import {OfferPoiType} from "./offer_poi_tags_enum";

export interface IOfferPoiEntry {
    type: OfferPoiType;
    name: string;
    distance: number;
}

/**
 * Hardcoded POI entries per offer id (nearest walkable POIs with route distance in meters).
 * Source: "2026_07 Tagi POI Inwestycje v3.csv" (2026-07). TEMPORARY — replace with BE data (US-616.1).
 */
export const OFFER_POI_TAGS: Record<number, IOfferPoiEntry[]> = {
    5362: [
        {type: OfferPoiType.BUS, name: "Jeziorna", distance: 121},
        {type: OfferPoiType.LAS, name: "Leśny zakątek", distance: 629},
        {type: OfferPoiType.LAS, name: "Małpia Wyspa", distance: 1287}
    ],
    7659: [{type: OfferPoiType.BUS, name: "Smolec - Chłopska/Śliwkowa", distance: 702}],
    8221: [
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Pasaż Handlowy", distance: 456},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Spokojna", distance: 683},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Stadion", distance: 692},
        {type: OfferPoiType.BUS, name: "Plac Neptuna", distance: 768},
        {type: OfferPoiType.BUS, name: "Niepodległości (Muzeum)", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 1050},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 1074},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 1231}
    ],
    8863: [
        {type: OfferPoiType.BUS, name: "Serbska (Centrum Kultury Agora)", distance: 91},
        {type: OfferPoiType.TRAM, name: "Serbska (Centrum Kultury Agora)", distance: 129},
        {type: OfferPoiType.BUS, name: "Łużycka", distance: 386},
        {type: OfferPoiType.BUS, name: "Most Osobowicki", distance: 578},
        {type: OfferPoiType.TRAM, name: "Osobowicka (Cmentarz II)", distance: 629},
        {type: OfferPoiType.BUS, name: "Osobowicka (Cmentarz II)", distance: 653},
        {type: OfferPoiType.TRAM, name: "Most Osobowicki", distance: 656},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1866},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 2279}
    ],
    9187: [
        {type: OfferPoiType.BUS, name: "Zegrze Osiedle 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Zegrze Osiedle 01", distance: 519}
    ],
    9458: [
        {type: OfferPoiType.BUS, name: "Wieliczka Dębowa", distance: 400},
        {type: OfferPoiType.BUS, name: "Wygoda 1 nż.", distance: 551},
        {type: OfferPoiType.BUS, name: "Czarnochowice Wygoda", distance: 733},
        {type: OfferPoiType.PARK, name: "Park osiedlowy", distance: 1721},
        {type: OfferPoiType.PARK, name: "Planty", distance: 2303},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 2354},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2385}
    ],
    9614: [
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Polna Rondo", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 1712},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 1716},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 1853}
    ],
    9681: [
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Pomnik", distance: 414},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Graniczna", distance: 455},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Biblioteka Śląska", distance: 597},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Sikorskiego", distance: 624},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 791},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 1058},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1413},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1714},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1748},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Eugeniusza Breitkopfa", distance: 1783},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1798}
    ],
    10103: [
        {type: OfferPoiType.BUS, name: "Nałęczowska 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Wojciechowska 05", distance: 379},
        {type: OfferPoiType.BUS, name: "Wojciechowska 03", distance: 427},
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Wojciechowska 01", distance: 438},
        {type: OfferPoiType.BUS, name: "Wojciechowska 02", distance: 442},
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 01", distance: 455},
        {type: OfferPoiType.BUS, name: "Nałęczowska 04", distance: 461},
        {type: OfferPoiType.BUS, name: "Nałęczowska 02", distance: 495},
        {type: OfferPoiType.BUS, name: "Cisowa 02", distance: 522}
    ],
    10198: [
        {type: OfferPoiType.PARK, name: "park Warszewo-Podbórz", distance: 225},
        {type: OfferPoiType.BUS, name: "Morenowa", distance: 232},
        {type: OfferPoiType.BUS, name: "Podbórzańska Ogrody", distance: 630},
        {type: OfferPoiType.BUS, name: "Podbórz", distance: 798},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Wodozbiór”", distance: 1943},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 2448},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 2495}
    ],
    10409: [
        {type: OfferPoiType.BUS, name: "Powstań Chłopskich", distance: 359},
        {type: OfferPoiType.BUS, name: "Ruchu Oporu", distance: 390},
        {type: OfferPoiType.BUS, name: "Redłowo SKM - Park Technologiczny", distance: 515},
        {type: OfferPoiType.BUS, name: "Instytut Med. Morskiej i Tropikalnej 01", distance: 519},
        {type: OfferPoiType.BUS, name: "Redłowo SKM - Park Technologiczny 02", distance: 523},
        {type: OfferPoiType.BUS, name: "Redłowo SKM - Park Technologiczny 01", distance: 539},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Redłowo", distance: 748},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kępa Redłowska", distance: 1446},
        {type: OfferPoiType.PARK, name: "Dziki Sad", distance: 1707}
    ],
    10692: [
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 485},
        {type: OfferPoiType.PARK, name: "Skwer Kapitana Zygmunta Pawlaczyka", distance: 1303},
        {type: OfferPoiType.PARK, name: "Park Polskich Wynalazców", distance: 1324},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1471},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1613},
        {type: OfferPoiType.PARK, name: "Skwer Sportów Miejskich", distance: 1763}
    ],
    10869: [
        {type: OfferPoiType.BUS, name: "Katowice Ceglana Szpital Kliniczny", distance: 116},
        {type: OfferPoiType.BUS, name: "Katowice Meteorologów", distance: 421},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Szpital", distance: 722},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Basen", distance: 780},
        {type: OfferPoiType.BUS, name: "Katowice Wita Stwosza", distance: 830},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1057},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1101},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Kaczmarskiego", distance: 1106},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Szymkowiaka", distance: 1121},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1345},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1498}
    ],
    11159: [
        {type: OfferPoiType.BUS, name: "Zamkowa 02", distance: 95},
        {type: OfferPoiType.BUS, name: "Zamkowa 01", distance: 118},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterów Szymankowa", distance: 421},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 02", distance: 482},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Okrzei 02", distance: 508},
        {type: OfferPoiType.BUS, name: "MOPS 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Okrzei 01", distance: 573},
        {type: OfferPoiType.BUS, name: "MOPS 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Nad Wisłą 01", distance: 719},
        {type: OfferPoiType.BUS, name: "Nad Wisłą 02", distance: 726},
        {type: OfferPoiType.PARK, name: "Park im. Mikołaja Kopernika", distance: 1065},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1163},
        {type: OfferPoiType.PARK, name: "Skwer Konstytucji 3 Maja", distance: 1324}
    ],
    11325: [
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Skromna", distance: 184},
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Szpital Wojskowy", distance: 261},
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Gdańska", distance: 504},
        {type: OfferPoiType.BUS, name: "Zaświat / Cmentarz", distance: 588},
        {type: OfferPoiType.TRAM, name: "Gdańska / Powst. Warszawy", distance: 634},
        {type: OfferPoiType.BUS, name: "Czerkaska / Gdańska", distance: 656},
        {type: OfferPoiType.BUS, name: "Gdańska / Czerkaska", distance: 658},
        {type: OfferPoiType.PARK, name: "Skwer Inwalidów Wojennych", distance: 693}
    ],
    11421: [
        {type: OfferPoiType.BUS, name: "Dziwnów - Wybreże Kościuszkowskie - Słoneczna", distance: 392},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1968}
    ],
    11485: [
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 323},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 336},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 361},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 480},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 507},
        {type: OfferPoiType.TRAM, name: "Nyska", distance: 545},
        {type: OfferPoiType.BUS, name: "Widna", distance: 561},
        {type: OfferPoiType.BUS, name: "Nyska", distance: 613},
        {type: OfferPoiType.TRAM, name: "Prudnicka", distance: 736},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1439},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1664},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1715},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1885}
    ],
    11820: [
        {type: OfferPoiType.BUS, name: "Marysin", distance: 421},
        {type: OfferPoiType.BUS, name: "Ustronie Morskie - pętla", distance: 442}
    ],
    12093: [
        {type: OfferPoiType.BUS, name: "Przystań Żeglarska", distance: 86},
        {type: OfferPoiType.BUS, name: "Lotnisko", distance: 503},
        {type: OfferPoiType.BUS, name: "Centrum Żeglarskie", distance: 774},
        {type: OfferPoiType.BUS, name: "Most Cłowy", distance: 825}
    ],
    12148: [
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 57},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 149},
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 253},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 527},
        {type: OfferPoiType.BUS, name: "Rondo Toruńskie", distance: 617},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 640},
        {type: OfferPoiType.TRAM, name: "Jagiellońska / Łużycka", distance: 656},
        {type: OfferPoiType.TRAM, name: "Jagiellońska - Łużycka", distance: 684},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 781},
        {type: OfferPoiType.PARK, name: "Bulwar im. Leona Janty-Połczyńskiego", distance: 888},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1063},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 1198}
    ],
    12642: [{type: OfferPoiType.LAS, name: "Drużyna Chrobrego", distance: 1463}],
    12872: [
        {type: OfferPoiType.BUS, name: "Sobieskiego - 3 Maja N/Ż 03", distance: 213},
        {type: OfferPoiType.BUS, name: "Sobieskiego - 3 Maja N/Ż 02", distance: 260},
        {type: OfferPoiType.BUS, name: "3 Maja - Emcek 02", distance: 412},
        {type: OfferPoiType.BUS, name: "3 Maja - Fabryczna 01", distance: 425},
        {type: OfferPoiType.BUS, name: "3 Maja - Emcek 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Sobieskiego - 3 Maja 01", distance: 501},
        {type: OfferPoiType.BUS, name: "3 Maja - Fabryczna 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Grunwaldzka N/Ż 02", distance: 572},
        {type: OfferPoiType.BUS, name: "3 Maja - Wazów N/Ż 02", distance: 611},
        {type: OfferPoiType.BUS, name: "3 Maja - Wazów N/Ż 01", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Ireny Sendlerowej", distance: 870},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1148},
        {type: OfferPoiType.PARK, name: "Plac Władysława Broniewskiego", distance: 1163},
        {type: OfferPoiType.PARK, name: 'Park kulturowy "Klasztorne stawy"', distance: 1200},
        {type: OfferPoiType.PARK, name: "Słupski Park Modelarski - RC GRYF Modele Zdalnie Sterowane", distance: 1323},
        {type: OfferPoiType.PARK, name: "Park im. Henryka Sienkiewicza", distance: 1605},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 1643},
        {type: OfferPoiType.PARK, name: "Park Pianistyki Polskiej", distance: 1738}
    ],
    12904: [
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 62},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 122},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Kopernika", distance: 171},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 178},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 221},
        {type: OfferPoiType.BUS, name: "Kopernika - Żeromskiego", distance: 230},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 257},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 271},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 326},
        {type: OfferPoiType.BUS, name: "Gdańska - Struga", distance: 341},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Żeromskiego", distance: 344},
        {type: OfferPoiType.PARK, name: "Skwer im. Lecha Kunki", distance: 416},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 463},
        {type: OfferPoiType.BUS, name: "Struga - Kościuszki", distance: 467},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Mickiewicza NŻ", distance: 473},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Zamenhofa", distance: 509},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 511},
        {type: OfferPoiType.TRAM, name: "Kopernika - Łąkowa", distance: 519},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Mickiewicza", distance: 540},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 569}
    ],
    12963: [
        {type: OfferPoiType.BUS, name: "Dorodna 02", distance: 478},
        {type: OfferPoiType.BUS, name: "Laurowa 02", distance: 617},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 654},
        {type: OfferPoiType.BUS, name: "Laurowa 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Portowa 02", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 1543}
    ],
    12968: [
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Stawowa", distance: 393},
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Błonia", distance: 772},
        {type: OfferPoiType.PARK, name: "Park Rybnik Paruszowiec przy Tężni", distance: 1053}
    ],
    12991: [
        {type: OfferPoiType.BUS, name: "Wołkowyska n/ż", distance: 274},
        {type: OfferPoiType.BUS, name: "Kopiec Wolności n/ż", distance: 509},
        {type: OfferPoiType.BUS, name: "Katowicka n/ż", distance: 650},
        {type: OfferPoiType.REZERWAT, name: "Traszki Ratajskie", distance: 1178},
        {type: OfferPoiType.PARK, name: "Park na os. Tysiąclecia", distance: 1220},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 2054},
        {type: OfferPoiType.PARK, name: "Park Forteczny", distance: 2330}
    ],
    13149: [
        {type: OfferPoiType.BUS, name: "Rybaki Górne 02", distance: 301},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 02", distance: 361},
        {type: OfferPoiType.PARK, name: 'Skwer "Stołówka"', distance: 400},
        {type: OfferPoiType.BUS, name: "Aksamitna 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 01", distance: 494},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 561},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 597},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 02", distance: 597},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 01", distance: 619},
        {type: OfferPoiType.BUS, name: "Łagiewniki 01", distance: 620},
        {type: OfferPoiType.BUS, name: "Plac Solidarności 04", distance: 661},
        {type: OfferPoiType.BUS, name: "Heweliusza 01", distance: 664},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 679},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 773},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 941},
        {type: OfferPoiType.PARK, name: "Skwer Heweliusza", distance: 989},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1480},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1542},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1769}
    ],
    13188: [
        {type: OfferPoiType.BUS, name: "Wynalazek 03", distance: 268},
        {type: OfferPoiType.BUS, name: "Wynalazek 04", distance: 291},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 360},
        {type: OfferPoiType.BUS, name: "Komputerowa 02", distance: 386},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 388},
        {type: OfferPoiType.BUS, name: "Komputerowa 01", distance: 433},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 489},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 514},
        {type: OfferPoiType.BUS, name: "Rondo Żabczyńskiego 04", distance: 516},
        {type: OfferPoiType.BUS, name: "PKP Służewiec 01", distance: 562},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 583},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Służewiec", distance: 591},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 11", distance: 647},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 15", distance: 647},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 12", distance: 670},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 14", distance: 673},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 13", distance: 676},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 746},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1132},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1833}
    ],
    13266: [
        {type: OfferPoiType.BUS, name: "Barzychowskiej 02", distance: 311},
        {type: OfferPoiType.BUS, name: "Barzychowskiej 01", distance: 349},
        {type: OfferPoiType.BUS, name: "Hokejowa 01", distance: 421},
        {type: OfferPoiType.BUS, name: "Olimpijska 02", distance: 519},
        {type: OfferPoiType.BUS, name: "Hokejowa 02", distance: 522},
        {type: OfferPoiType.BUS, name: "Olimpijska 01", distance: 535},
        {type: OfferPoiType.BUS, name: "Podleckiego 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Podleckiego 01", distance: 644}
    ],
    13308: [
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 507},
        {type: OfferPoiType.BUS, name: "Sielawy", distance: 607},
        {type: OfferPoiType.BUS, name: "Dworska", distance: 647},
        {type: OfferPoiType.BUS, name: "Naramowice Wschodnie", distance: 686},
        {type: OfferPoiType.BUS, name: "Rubież", distance: 692},
        {type: OfferPoiType.BUS, name: "Bielicowa", distance: 736},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1582},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2007},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2486}
    ],
    13487: [
        {type: OfferPoiType.BUS, name: "Kórnicka 01", distance: 777},
        {type: OfferPoiType.BUS, name: "Kórnicka 02", distance: 810},
        {type: OfferPoiType.PARK, name: "Park nad Jeziorem Zgorzała", distance: 1305}
    ],
    13504: [
        {type: OfferPoiType.BUS, name: "Politechniki - Skrzywana", distance: 137},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 147},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 270},
        {type: OfferPoiType.TRAM, name: "Politechniki - Obywatelska", distance: 430},
        {type: OfferPoiType.BUS, name: "Obywatelska - Politechniki", distance: 450},
        {type: OfferPoiType.BUS, name: "Politechniki - Obywatelska", distance: 478},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 501},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 632},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 660},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 707},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 715},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 716},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 858},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1027},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1345},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1379},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1394}
    ],
    13518: [
        {type: OfferPoiType.BUS, name: "Plac Neptuna", distance: 415},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Pasaż Handlowy", distance: 442},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Spokojna", distance: 474},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 500},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 504},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Stadion", distance: 597},
        {type: OfferPoiType.BUS, name: "Niepodległości (Muzeum)", distance: 598},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 641},
        {type: OfferPoiType.BUS, name: "Kolejowa 24", distance: 797}
    ],
    13568: [
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego żwirownia 08", distance: 79},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego żwirownia 05", distance: 149},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Podmiejska 10", distance: 532},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 06", distance: 622},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Koło 07", distance: 661},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 03", distance: 676},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 923},
        {type: OfferPoiType.PARK, name: "Bulwar WSK Rzeszów", distance: 2092},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 2304},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2464}
    ],
    13572: [
        {type: OfferPoiType.BUS, name: "Wywrockiego / Strzelnicza 02", distance: 29},
        {type: OfferPoiType.BUS, name: "Plenerowa 01", distance: 200},
        {type: OfferPoiType.BUS, name: "Plenerowa 02", distance: 208},
        {type: OfferPoiType.BUS, name: "Strzelnicza 02", distance: 247},
        {type: OfferPoiType.BUS, name: "Strzelnicza 01", distance: 333},
        {type: OfferPoiType.BUS, name: "Wywrockiego / Jagodowa 01", distance: 456},
        {type: OfferPoiType.BUS, name: "Wywrockiego / Jagodowa 04", distance: 493},
        {type: OfferPoiType.BUS, name: "Panoramiczna 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Wyspiańskiego / Strzelnicza 03", distance: 626},
        {type: OfferPoiType.BUS, name: "Panoramiczna 01", distance: 642},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 1135},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 1136},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1438},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 2360},
        {type: OfferPoiType.PARK, name: "Park Sybiraków", distance: 2422}
    ],
    13594: [{type: OfferPoiType.BUS, name: "Dębina", distance: 581}],
    13634: [
        {type: OfferPoiType.BUS, name: "23 Marca", distance: 126},
        {type: OfferPoiType.BUS, name: "Sopot Przylesie", distance: 326},
        {type: OfferPoiType.BUS, name: "Okrężna (n/ż)", distance: 604},
        {type: OfferPoiType.BUS, name: "Cmentarz", distance: 720},
        {type: OfferPoiType.LAS, name: "Park Wzgórze Augusty", distance: 1102},
        {type: OfferPoiType.REZERWAT, name: "Konwaliowe Wzgórze", distance: 1252},
        {type: OfferPoiType.PARK, name: "Park Sanitariuszki Inki", distance: 1312},
        {type: OfferPoiType.REZERWAT, name: "Daglezje imienia Jeana Georga Haffnera", distance: 1366},
        {type: OfferPoiType.REZERWAT, name: "Kokoryczowe Zbocze", distance: 1495},
        {type: OfferPoiType.PARK, name: "Park na Goyki", distance: 1605},
        {type: OfferPoiType.REZERWAT, name: "Wąwozy Grodowe", distance: 1766},
        {type: OfferPoiType.PARK, name: "Skwer Michała Urbanka", distance: 1935},
        {type: OfferPoiType.PARK, name: "Skwer Czesława Miłosza", distance: 1948},
        {type: OfferPoiType.PARK, name: "Skwer im. Księdza Władysława Szymańskiego", distance: 1970},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Przyrody Zajęcze Wzgórze", distance: 2216},
        {type: OfferPoiType.REZERWAT, name: "Cisowe Zbocze", distance: 2221}
    ],
    13652: [
        {type: OfferPoiType.BUS, name: "Suwalska - szkoła 01", distance: 421},
        {type: OfferPoiType.BUS, name: "Suwalska - szkoła 08", distance: 462},
        {type: OfferPoiType.BUS, name: "Suwalska - PUK 06", distance: 699},
        {type: OfferPoiType.PARK, name: "Park Odkrywców Kolei", distance: 790},
        {type: OfferPoiType.BUS, name: "Suwalska - PUK 03", distance: 833},
        {type: OfferPoiType.KOLEJ, name: "Ełk", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1631},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1676},
        {type: OfferPoiType.PARK, name: 'Skwer gen. Aleksandra Krzyżanowskiego "Wilka"', distance: 1841},
        {type: OfferPoiType.PARK, name: "Park Kopernika", distance: 1978},
        {type: OfferPoiType.PARK, name: "Skwer Rusałki", distance: 1995},
        {type: OfferPoiType.PARK, name: "Park sportowy", distance: 2132},
        {type: OfferPoiType.PARK, name: "Plaża Miejska", distance: 2191},
        {type: OfferPoiType.PARK, name: "Park Ireny Tamary Misztal", distance: 2257},
        {type: OfferPoiType.REZERWAT, name: "Wyspa lęgowa", distance: 2393}
    ],
    13655: [
        {type: OfferPoiType.BUS, name: "Teatr Polski", distance: 330},
        {type: OfferPoiType.BUS, name: "Parkowa", distance: 332},
        {type: OfferPoiType.TRAM, name: "Parkowa", distance: 332},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 333},
        {type: OfferPoiType.TRAM, name: "Teatr Polski", distance: 388},
        {type: OfferPoiType.BUS, name: "Dubois", distance: 408},
        {type: OfferPoiType.TRAM, name: "Dubois", distance: 419},
        {type: OfferPoiType.LAS, name: "Park imienia Stanisława Nadratowskiego", distance: 543},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Nadratowskiego", distance: 543},
        {type: OfferPoiType.BUS, name: "Emilii Plater", distance: 621},
        {type: OfferPoiType.BUS, name: "Admiralska nż", distance: 658},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 781},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 781},
        {type: OfferPoiType.TRAM, name: "Wały Chrobrego", distance: 798},
        {type: OfferPoiType.TRAM, name: "Matejki", distance: 831},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 1771},
        {type: OfferPoiType.PARK, name: "Skwer imienia Raoula Wallenberga", distance: 2204},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 2246},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 2327},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jacka Nieżychowskiego", distance: 2336}
    ],
    13695: [
        {type: OfferPoiType.BUS, name: "Lalki 03", distance: 299},
        {type: OfferPoiType.BUS, name: "PKP Ursus 02", distance: 325},
        {type: OfferPoiType.BUS, name: "Lalki 04", distance: 384},
        {type: OfferPoiType.BUS, name: "Lalki 01", distance: 438},
        {type: OfferPoiType.BUS, name: "PKP Ursus 01", distance: 439},
        {type: OfferPoiType.BUS, name: "Lalki 02", distance: 440},
        {type: OfferPoiType.BUS, name: "PKP Ursus 16", distance: 478},
        {type: OfferPoiType.BUS, name: "PKP Ursus 12", distance: 489},
        {type: OfferPoiType.BUS, name: "PKP Ursus 13", distance: 493},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 01", distance: 495},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 498},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ursus", distance: 583},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 690},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 888},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 893},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 967}
    ],
    13778: [
        {type: OfferPoiType.BUS, name: "Oś. Unieście ul.6 Marca - ul.Pogodna", distance: 282},
        {type: OfferPoiType.BUS, name: "6 Marca - Prądno", distance: 284},
        {type: OfferPoiType.BUS, name: "Mielno - ul. Chrobrego (Mickiewicza)", distance: 766},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Rawąskiego", distance: 878},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1914}
    ],
    13786: [
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej", distance: 269},
        {type: OfferPoiType.TRAM, name: "Unii Lubelskiej", distance: 343},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej Szpital", distance: 419},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej Szpital (Brama Główna)", distance: 486},
        {type: OfferPoiType.LAS, name: "park imienia Teresy Hulboj", distance: 521},
        {type: OfferPoiType.BUS, name: "Wincentego Pola", distance: 581},
        {type: OfferPoiType.PARK, name: "park Krystyny i Romana Łyczywków", distance: 616},
        {type: OfferPoiType.PARK, name: "skwer Zdrowia imienia Doktora Henryka Kompfa", distance: 655},
        {type: OfferPoiType.BUS, name: "Zawadzkiego Kościół", distance: 701},
        {type: OfferPoiType.PARK, name: "Skwer Majora Mieczysława Tarchalskiego", distance: 1295},
        {type: OfferPoiType.PARK, name: "Syrenie Stawy", distance: 1438},
        {type: OfferPoiType.PARK, name: "Psie Pole", distance: 1456},
        {type: OfferPoiType.PARK, name: "Skwer imienia Telesfora Badetko", distance: 1502},
        {type: OfferPoiType.PARK, name: "park Szachisty", distance: 1738},
        {type: OfferPoiType.PARK, name: "Park imienia Profesora Bolesława Briksa", distance: 1787}
    ],
    13823: [
        {type: OfferPoiType.BUS, name: "Domeyki 01", distance: 159},
        {type: OfferPoiType.BUS, name: "Domeyki 02", distance: 252},
        {type: OfferPoiType.BUS, name: "Energetyków 02", distance: 329},
        {type: OfferPoiType.BUS, name: "Elektromontaż 03", distance: 664},
        {type: OfferPoiType.BUS, name: "Elektromontaż 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Samsonowicza 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Elektromontaż 02", distance: 785},
        {type: OfferPoiType.BUS, name: "Samsonowicza 02", distance: 823}
    ],
    13875: [
        {type: OfferPoiType.BUS, name: "Łąkowa", distance: 66},
        {type: OfferPoiType.BUS, name: "Langiewicza", distance: 177},
        {type: OfferPoiType.BUS, name: "Dźwigowa", distance: 431},
        {type: OfferPoiType.BUS, name: "Klonowa", distance: 518},
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 582},
        {type: OfferPoiType.BUS, name: "Mińsk Maz. Siennicka", distance: 603},
        {type: OfferPoiType.BUS, name: "Rudzkiego", distance: 642},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 852},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1209},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 1637},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 1683},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 1709},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 1763}
    ],
    13902: [
        {type: OfferPoiType.BUS, name: "Konstantynowska - Krańcowa NŻ", distance: 195},
        {type: OfferPoiType.TRAM, name: "Konstantynowska - Krańcowa", distance: 253},
        {type: OfferPoiType.PARK, name: "Łódzkie Błonia", distance: 682},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 1470},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1601},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1715},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 1860},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 1944},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 2007},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 2191}
    ],
    13910: [
        {type: OfferPoiType.LAS, name: "Lasek Alfreda", distance: 394},
        {type: OfferPoiType.BUS, name: "Kolonia Agnieszki Promienna", distance: 414},
        {type: OfferPoiType.BUS, name: "Kolonia Agnieszki Bytomska", distance: 559},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 570},
        {type: OfferPoiType.BUS, name: "Wełnowiec Plac Alfreda", distance: 623},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Plac Alfreda", distance: 663},
        {type: OfferPoiType.BUS, name: "Józefowiec Szpital", distance: 733},
        {type: OfferPoiType.LAS, name: "Lasek Bytkowski", distance: 912},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1000},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1535},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Halora", distance: 1555},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1755},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 1833},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2310},
        {type: OfferPoiType.PARK, name: "Skwer księdza Franciszka Macherskiego", distance: 2395}
    ],
    13928: [
        {type: OfferPoiType.BUS, name: "Paprocka/Chełmońskiego", distance: 582},
        {type: OfferPoiType.PARK, name: "Park 100-lecia odzyskania niepodległości", distance: 592},
        {type: OfferPoiType.BUS, name: "Malczewskiego", distance: 659},
        {type: OfferPoiType.BUS, name: "Baczyńskiego", distance: 776},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 794},
        {type: OfferPoiType.BUS, name: "Paprocka/Boczna", distance: 818},
        {type: OfferPoiType.BUS, name: "Boczna", distance: 842},
        {type: OfferPoiType.PARK, name: "Park Miejski imienia Stefana Złotnickiego", distance: 1387},
        {type: OfferPoiType.PARK, name: "Skwer Zenona Anstadta", distance: 1654},
        {type: OfferPoiType.PARK, name: "Skwer Pawła Królikowskiego", distance: 1830},
        {type: OfferPoiType.PARK, name: "Skwer Jana Libsza", distance: 2235},
        {type: OfferPoiType.PARK, name: "Park Pogoń", distance: 2364}
    ],
    13932: [
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 258},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 260},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - rynek", distance: 489},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - Rynek 2 Nr 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Rzeczna", distance: 563},
        {type: OfferPoiType.BUS, name: "Frankowskiego Nr 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Łopuskiego - Szpital 1 Nr 01", distance: 618},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 639},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 676},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 682},
        {type: OfferPoiType.PARK, name: "Skwer Miast Partnerskich", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Pionierów Kołobrzegu", distance: 903},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 914},
        {type: OfferPoiType.PARK, name: "Skwer 750-lecia", distance: 935},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1464},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1965}
    ],
    13935: [
        {type: OfferPoiType.BUS, name: "Drwęcka 01", distance: 122},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 212},
        {type: OfferPoiType.BUS, name: "Drwęcka 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 225},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 236},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 296},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 01", distance: 438},
        {type: OfferPoiType.BUS, name: "Siennicka 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Siennicka 02", distance: 552},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Grochów", distance: 785},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1001},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1045},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1603},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1651},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1835},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1893},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 2223}
    ],
    13937: [
        {type: OfferPoiType.BUS, name: "Zjazdowa - Beskidzka NŻ", distance: 157},
        {type: OfferPoiType.BUS, name: "Marmurowa - Beskidzka NŻ", distance: 401},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Budy", distance: 445},
        {type: OfferPoiType.BUS, name: "Marmurowa - Brzezińska", distance: 570},
        {type: OfferPoiType.BUS, name: "Brzezińska - Marmurowa", distance: 742},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Opolska NŻ", distance: 799},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 1398}
    ],
    13946: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 179},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 190},
        {type: OfferPoiType.BUS, name: "Brylowska 01", distance: 332},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 371},
        {type: OfferPoiType.BUS, name: "Brylowska 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Dworzec Zachodni (Tunelowa) 01", distance: 671},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia", distance: 690},
        {type: OfferPoiType.BUS, name: "Szpital Wolski 06", distance: 714},
        {type: OfferPoiType.BUS, name: "Szpital Wolski 05", distance: 721},
        {type: OfferPoiType.BUS, name: "Prądzyńskiego 02", distance: 726},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia WKD", distance: 771},
        {type: OfferPoiType.TRAM, name: "Szpital Wolski 04", distance: 802},
        {type: OfferPoiType.TRAM, name: "Szpital Wolski 03", distance: 810},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1219},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1466},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 1676},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1824},
        {type: OfferPoiType.PARK, name: "Różany Skwer Pysznych Pączków", distance: 1865},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1898},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1989}
    ],
    13981: [
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 01", distance: 277},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 465},
        {type: OfferPoiType.BUS, name: "Przejezdna 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Przejezdna 01", distance: 682},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 738},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 810},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1233}
    ],
    14061: [
        {type: OfferPoiType.BUS, name: "Maratońska (wew.) - Plocka", distance: 385},
        {type: OfferPoiType.BUS, name: "Maratońska - Plocka", distance: 441},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego - blok 270", distance: 657},
        {type: OfferPoiType.BUS, name: "Armii Krajowej - Batalionów Chłopskich", distance: 751},
        {type: OfferPoiType.BUS, name: "Maratońska - Maratońska 91 NŻ", distance: 770},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1419},
        {type: OfferPoiType.PARK, name: "Park na Smulsku", distance: 2176},
        {type: OfferPoiType.PARK, name: "Łódzkie Błonia", distance: 2232}
    ],
    14108: [
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 06", distance: 137},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 02", distance: 218},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 05", distance: 266},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 01", distance: 272},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 04", distance: 282},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 08", distance: 283},
        {type: OfferPoiType.PARK, name: "Skwer Pilota Pirxa", distance: 322},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 03-91", distance: 407},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 03", distance: 433},
        {type: OfferPoiType.BUS, name: "Białucha 04", distance: 556},
        {type: OfferPoiType.BUS, name: "Meissnera 02", distance: 559},
        {type: OfferPoiType.TRAM, name: "Białucha 02", distance: 670},
        {type: OfferPoiType.TRAM, name: "Białucha 01", distance: 681},
        {type: OfferPoiType.BUS, name: "Meissnera 01", distance: 694},
        {type: OfferPoiType.BUS, name: "Białucha 03", distance: 720},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków 01", distance: 800},
        {type: OfferPoiType.TRAM, name: "Muzeum Lotnictwa Polskiego 02", distance: 820},
        {type: OfferPoiType.TRAM, name: "Muzeum Lotnictwa Polskiego 01", distance: 829},
        {type: OfferPoiType.PARK, name: "Park Lotników Polskich", distance: 1038},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy przy ul. Chałupnika", distance: 1097},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 1198},
        {type: OfferPoiType.PARK, name: "Ogród Fabryczny", distance: 1222},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 1809},
        {type: OfferPoiType.PARK, name: "Lotniczy Park Kulturowy", distance: 1935}
    ],
    14130: [
        {type: OfferPoiType.BUS, name: "Dw. Północny", distance: 262},
        {type: OfferPoiType.BUS, name: "Źródłowa - Wojska Polskiego NŻ", distance: 315},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 340},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 366},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Marynarska", distance: 482},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Marynarska", distance: 507},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 554},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 606},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 645},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Głowackiego", distance: 658},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Franciszkańska", distance: 739},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 815},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1051},
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 1173}
    ],
    14149: [
        {type: OfferPoiType.BUS, name: "Rondo ks. J. Popiełuszki 01", distance: 217},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Jastrzębia 02", distance: 345},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Działkowa 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Powstańców 03", distance: 424},
        {type: OfferPoiType.BUS, name: "Ołówkowa 04", distance: 466},
        {type: OfferPoiType.BUS, name: "Jastrzębia 01", distance: 508},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 1075},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 1488},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1576},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1891},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 2385}
    ],
    14152: [
        {type: OfferPoiType.PARK, name: "Park Kaszubski im.Jana Myślisza", distance: 229},
        {type: OfferPoiType.BUS, name: "Hel Śródmieście", distance: 344},
        {type: OfferPoiType.PARK, name: "Park Rzeźby Kaszubskiej", distance: 451},
        {type: OfferPoiType.BUS, name: "Hel, dworzec kolejowy", distance: 460},
        {type: OfferPoiType.BUS, name: "Hel, Dworzec Kolejowy", distance: 577},
        {type: OfferPoiType.KOLEJ, name: "Hel", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Wydmowy", distance: 611}
    ],
    14246: [
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 03", distance: 72},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 05", distance: 108},
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 04", distance: 121},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 02", distance: 124},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 01", distance: 135},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 06", distance: 156},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 309},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 419},
        {type: OfferPoiType.BUS, name: "Nowolipie 01", distance: 443},
        {type: OfferPoiType.BUS, name: "Okopowa 01", distance: 480},
        {type: OfferPoiType.BUS, name: "Okopowa 10", distance: 495},
        {type: OfferPoiType.TRAM, name: "Okopowa 03", distance: 496},
        {type: OfferPoiType.BUS, name: "Nowolipie 02", distance: 512},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 564},
        {type: OfferPoiType.TRAM, name: "Kino Femina 05", distance: 565},
        {type: OfferPoiType.TRAM, name: "Kino Femina 10", distance: 599},
        {type: OfferPoiType.TRAM, name: "Okopowa 07", distance: 620},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 628},
        {type: OfferPoiType.TRAM, name: "Kino Femina 09", distance: 632},
        {type: OfferPoiType.TRAM, name: "Kino Femina 06", distance: 641},
        {type: OfferPoiType.TRAM, name: "Okopowa 08", distance: 665},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 722},
        {type: OfferPoiType.TRAM, name: "Żytnia 02", distance: 798},
        {type: OfferPoiType.PARK, name: "Skwer Racheli Auerbach", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 878},
        {type: OfferPoiType.PARK, name: "Skwer gen. Jana Jura-Gorzechowskiego", distance: 941},
        {type: OfferPoiType.PARK, name: "Skwer Duśki Trafankowskiej", distance: 1065},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1089},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 2416}
    ],
    14252: [
        {type: OfferPoiType.BUS, name: "Boryszew 01", distance: 89},
        {type: OfferPoiType.BUS, name: "Boryszew 02", distance: 135},
        {type: OfferPoiType.BUS, name: "Stefanówka 01", distance: 673},
        {type: OfferPoiType.BUS, name: "Stefanówka 02", distance: 710},
        {type: OfferPoiType.PARK, name: "Skwer Generała Stefana Grota-Roweckiego", distance: 2228}
    ],
    14256: [
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa", distance: 228},
        {type: OfferPoiType.BUS, name: "Parkowa / Uzdrowiskowa", distance: 307},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Interferie", distance: 414},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Wiatrak", distance: 648},
        {type: OfferPoiType.BUS, name: "Fort Zachodni", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 993}
    ],
    14287: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 52},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 334},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 409},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 430},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 498},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Niepodległości", distance: 536},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Niepodległości", distance: 545},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 606},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 619},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 636},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 673},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 675},
        {type: OfferPoiType.TRAM, name: "Pl. Reymonta", distance: 692},
        {type: OfferPoiType.TRAM, name: "Pl. Niepodległości", distance: 702},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 954},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1001},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1024},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1037},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1086},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1200}
    ],
    14312: [
        {type: OfferPoiType.BUS, name: "1 Sierpnia 02", distance: 242},
        {type: OfferPoiType.TRAM, name: "Włochy-Ratusz 04", distance: 359},
        {type: OfferPoiType.BUS, name: "1 Sierpnia 01", distance: 386},
        {type: OfferPoiType.TRAM, name: "Włochy-Ratusz 03", distance: 416},
        {type: OfferPoiType.BUS, name: "Włochy-Ratusz 01", distance: 422},
        {type: OfferPoiType.BUS, name: "Włochy-Ratusz 02", distance: 434},
        {type: OfferPoiType.BUS, name: "1 Sierpnia 03", distance: 482},
        {type: OfferPoiType.TRAM, name: "PKP Rakowiec 04", distance: 496},
        {type: OfferPoiType.BUS, name: "PKP Rakowiec 05", distance: 504},
        {type: OfferPoiType.BUS, name: "PKP Rakowiec 06", distance: 518},
        {type: OfferPoiType.TRAM, name: "PKP Rakowiec 03", distance: 556},
        {type: OfferPoiType.BUS, name: "Jadwisin 02", distance: 631},
        {type: OfferPoiType.BUS, name: "PKP Rakowiec 01", distance: 637},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Rakowiec", distance: 667},
        {type: OfferPoiType.BUS, name: "Hynka 01", distance: 712},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 727},
        {type: OfferPoiType.TRAM, name: "Hynka 04", distance: 732},
        {type: OfferPoiType.TRAM, name: "Hynka 03", distance: 821},
        {type: OfferPoiType.PARK, name: "Fort Rakowiec", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Szczęśliwicki", distance: 1695},
        {type: OfferPoiType.PARK, name: "Park Zasława Malickiego", distance: 2095},
        {type: OfferPoiType.PARK, name: "Skwer Dobrego Maharadży", distance: 2215}
    ],
    14364: [
        {type: OfferPoiType.TRAM, name: "Norymberska 01", distance: 582},
        {type: OfferPoiType.TRAM, name: "Norymberska 02", distance: 588},
        {type: OfferPoiType.BUS, name: "Norymberska 04", distance: 620},
        {type: OfferPoiType.BUS, name: "Norymberska", distance: 636},
        {type: OfferPoiType.BUS, name: "Norymberska 03", distance: 647},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 01", distance: 700},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 02", distance: 718},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 04", distance: 726},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 03", distance: 752},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 05", distance: 753},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 04", distance: 780},
        {type: OfferPoiType.BUS, name: "Rostworowskiego", distance: 789},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 01", distance: 806},
        {type: OfferPoiType.BUS, name: "Rostworowskiego 01", distance: 835},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 02", distance: 838},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 863},
        {type: OfferPoiType.PARK, name: "Park Zakrzówek", distance: 921},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1458},
        {type: OfferPoiType.PARK, name: "Skałki Twardowskiego", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1736},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 1910}
    ],
    14404: [
        {type: OfferPoiType.BUS, name: "Mazowiecka 02", distance: 216},
        {type: OfferPoiType.BUS, name: "Mazowiecka 01", distance: 263},
        {type: OfferPoiType.BUS, name: "Urząd Marszałkowski 02", distance: 311},
        {type: OfferPoiType.BUS, name: "Urząd Marszałkowski 01", distance: 366},
        {type: OfferPoiType.BUS, name: "Wrocławska 01", distance: 604},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 02", distance: 656},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 01", distance: 660},
        {type: OfferPoiType.BUS, name: "Biprostal 04", distance: 660},
        {type: OfferPoiType.TRAM, name: "Urzędnicza 02", distance: 710},
        {type: OfferPoiType.TRAM, name: "Biprostal 01", distance: 716},
        {type: OfferPoiType.TRAM, name: "Urzędnicza 01", distance: 720},
        {type: OfferPoiType.BUS, name: "Wrocławska 02", distance: 747},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 03", distance: 752},
        {type: OfferPoiType.TRAM, name: "Biprostal 02", distance: 762},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 815},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 874},
        {type: OfferPoiType.PARK, name: "Gołębi Ogród Krakowian", distance: 881},
        {type: OfferPoiType.PARK, name: "Skwer imienia Więźniów Obozów Zagłady", distance: 983},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 1009},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1097},
        {type: OfferPoiType.PARK, name: "Ogrody Łobzów", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1194}
    ],
    14451: [
        {type: OfferPoiType.BUS, name: "Dąb Szkoła", distance: 402},
        {type: OfferPoiType.BUS, name: "Dąb Krzyżowa", distance: 404},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 490},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 495},
        {type: OfferPoiType.BUS, name: "Józefowiec Ściegiennego", distance: 505},
        {type: OfferPoiType.PARK, name: "Skwer księdza Franciszka Macherskiego", distance: 773},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 812},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1263},
        {type: OfferPoiType.PARK, name: "Ptaki", distance: 1439},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 1503},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Ryszki", distance: 1640},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 1687}
    ],
    14460: [
        {type: OfferPoiType.BUS, name: "Strumykowa", distance: 118},
        {type: OfferPoiType.BUS, name: "Wojnów", distance: 363},
        {type: OfferPoiType.BUS, name: "Smocza", distance: 472},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Wojnów", distance: 566},
        {type: OfferPoiType.BUS, name: "Wojnów (pętla)", distance: 619},
        {type: OfferPoiType.PARK, name: "Park Strachociński", distance: 1062}
    ],
    14462: [
        {type: OfferPoiType.BUS, name: "Zajezdnia Redutowa 01", distance: 262},
        {type: OfferPoiType.BUS, name: "Zajezdnia Redutowa 02", distance: 387},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 05", distance: 404},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 06", distance: 485},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 03", distance: 532},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Pustola 01", distance: 558},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 04", distance: 562},
        {type: OfferPoiType.BUS, name: "Pustola 02", distance: 688},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 01", distance: 691},
        {type: OfferPoiType.BUS, name: "Cm. Prawosławny 02", distance: 710},
        {type: OfferPoiType.PARK, name: "Park Powstańców Warszawy", distance: 721},
        {type: OfferPoiType.BUS, name: "Cm. Prawosławny 01", distance: 793},
        {type: OfferPoiType.TRAM, name: "Sowińskiego 02", distance: 841},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 889},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Klincewicza", distance: 921},
        {type: OfferPoiType.PARK, name: "Skwer Wiesława Michnikowskiego", distance: 1197},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 1228},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1316}
    ],
    14467: [
        {type: OfferPoiType.BUS, name: "Orfeusz 01", distance: 125},
        {type: OfferPoiType.BUS, name: "Orfeusz 04", distance: 219},
        {type: OfferPoiType.BUS, name: "Orfeusz 03", distance: 231},
        {type: OfferPoiType.BUS, name: "Orfeusz 02", distance: 276},
        {type: OfferPoiType.BUS, name: "Skrzypcowa 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 04", distance: 448},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Oratoryjna 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Oratoryjna 02", distance: 612},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1539}
    ],
    14480: [
        {type: OfferPoiType.BUS, name: "Mjr Słabego", distance: 291},
        {type: OfferPoiType.BUS, name: "Złota Karczma 02", distance: 568},
        {type: OfferPoiType.BUS, name: "Złota Karczma 01", distance: 587},
        {type: OfferPoiType.BUS, name: "Harfowa 01", distance: 789},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Wąwóz Huzarów", distance: 1631},
        {type: OfferPoiType.REZERWAT, name: "Źródliska Potoku Oliwskiego", distance: 1869},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Dolina Strzyży", distance: 2140},
        {type: OfferPoiType.LAS, name: "190-letnia Pierwotna bukowa dolina", distance: 2302}
    ],
    14542: [
        {type: OfferPoiType.BUS, name: "Przymorze Wielkie", distance: 368},
        {type: OfferPoiType.BUS, name: "Biały Dwór 02", distance: 423},
        {type: OfferPoiType.BUS, name: "Biały Dwór 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 03", distance: 616},
        {type: OfferPoiType.PARK, name: "Park imienia Ronalda Reagana", distance: 627},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 01", distance: 633},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 02", distance: 698},
        {type: OfferPoiType.BUS, name: "Olsztyńska 02", distance: 754},
        {type: OfferPoiType.BUS, name: "Olsztyńska 01", distance: 757},
        {type: OfferPoiType.BUS, name: "Obrońców Wybrzeża 02", distance: 767},
        {type: OfferPoiType.PARK, name: "Skwer Kwitnących Wiśni", distance: 1493},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1690},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1885}
    ],
    14545: [
        {type: OfferPoiType.BUS, name: "Więcka / Łowicka", distance: 156},
        {type: OfferPoiType.BUS, name: "Łowicka / Szkoła", distance: 186},
        {type: OfferPoiType.BUS, name: "Fordońska / Łowicka", distance: 526},
        {type: OfferPoiType.BUS, name: "Skandynawska / IKEA", distance: 535},
        {type: OfferPoiType.BUS, name: "Tor Regatowy", distance: 583},
        {type: OfferPoiType.BUS, name: "Tor Regatowy [końcowy]", distance: 629},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 1585}
    ],
    14564: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 393},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 427},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 428},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Natansona 01", distance: 524},
        {type: OfferPoiType.BUS, name: "Natansona 02", distance: 537},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 560},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 570},
        {type: OfferPoiType.BUS, name: "Siewna 03", distance: 605},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 639},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 711},
        {type: OfferPoiType.BUS, name: "Siewna 02", distance: 724},
        {type: OfferPoiType.BUS, name: "Siewna 01", distance: 744},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1420},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1463},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1519},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2146}
    ],
    14597: [
        {type: OfferPoiType.BUS, name: "Piłsudskiego 09", distance: 325},
        {type: OfferPoiType.BUS, name: "Piłsudskiego 01", distance: 330},
        {type: OfferPoiType.BUS, name: "Piłsudskiego 07", distance: 353},
        {type: OfferPoiType.BUS, name: "Piłsudskiego", distance: 378},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 02", distance: 456},
        {type: OfferPoiType.BUS, name: "I Aleja Najświętszej Maryi Panny", distance: 470},
        {type: OfferPoiType.BUS, name: "II Al. Najświętszej Maryi Panny 04", distance: 495},
        {type: OfferPoiType.BUS, name: "II Al. Najświętszej Maryi Panny 06", distance: 510},
        {type: OfferPoiType.TRAM, name: "II Al. Najświętszej Maryi Panny", distance: 602},
        {type: OfferPoiType.KOLEJ, name: "Częstochowa", distance: 667},
        {type: OfferPoiType.PARK, name: "Plac Katyński", distance: 1104},
        {type: OfferPoiType.PARK, name: "Skwer Solidarności", distance: 1209},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Gabriela Narutowicza", distance: 1336},
        {type: OfferPoiType.PARK, name: "Promenada Olgi Aleksandry Sipowicz - Kory", distance: 1548}
    ],
    14611: [
        {type: OfferPoiType.PARK, name: "Park 1000-lecia Królestwa Polskiego", distance: 251},
        {type: OfferPoiType.PARK, name: "Park przy CUS", distance: 437},
        {type: OfferPoiType.PARK, name: "Park im. Mieczysława Michalskiego w Lęborku", distance: 500},
        {type: OfferPoiType.BUS, name: "Stary Browar", distance: 743},
        {type: OfferPoiType.BUS, name: "Zwycięstwa - Kupiec", distance: 754},
        {type: OfferPoiType.PARK, name: "Skwer 7 Harcerskiej Drużyny Czerwonych Beretów", distance: 894},
        {type: OfferPoiType.PARK, name: "Park im. Lecha i Marii Kaczyńskich", distance: 946}
    ],
    14617: [{type: OfferPoiType.BUS, name: "Ustronie Morskie - szkoła", distance: 780}],
    14625: [
        {type: OfferPoiType.BUS, name: "Wiślinka Piaskowa", distance: 527},
        {type: OfferPoiType.BUS, name: "Wiślinka Most", distance: 792}
    ],
    14633: [
        {type: OfferPoiType.BUS, name: "Chodkiewicza / Paderewskiego", distance: 231},
        {type: OfferPoiType.TRAM, name: "Chodkiewicza / Paderewskiego", distance: 236},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 431},
        {type: OfferPoiType.BUS, name: "Gdańska / Chodkiewicza", distance: 433},
        {type: OfferPoiType.TRAM, name: "Gdańska / Chodkiewicza", distance: 433},
        {type: OfferPoiType.TRAM, name: "UKW", distance: 524},
        {type: OfferPoiType.BUS, name: "Mickiewicza / Teatr Polski", distance: 564},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 585},
        {type: OfferPoiType.BUS, name: "UKW", distance: 615},
        {type: OfferPoiType.PARK, name: "Skwer Edwarda Woyniłłowicza", distance: 680},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 728},
        {type: OfferPoiType.TRAM, name: "Gdańska / Artyleryjska", distance: 817},
        {type: OfferPoiType.PARK, name: "Skwer Mikołaja Kopernika", distance: 834},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 846},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 922},
        {type: OfferPoiType.PARK, name: "Skwer im. Mariana Turwida", distance: 980},
        {type: OfferPoiType.PARK, name: "Skwer im. ppor. Leszka Białego", distance: 992}
    ],
    14657: [
        {type: OfferPoiType.BUS, name: "Jarocińska", distance: 14},
        {type: OfferPoiType.BUS, name: "Lipska", distance: 335},
        {type: OfferPoiType.BUS, name: "Osobowice", distance: 622},
        {type: OfferPoiType.TRAM, name: "Osobowice", distance: 675},
        {type: OfferPoiType.BUS, name: "Witkowska", distance: 760},
        {type: OfferPoiType.BUS, name: "Las Osobowicki", distance: 783}
    ],
    14664: [
        {type: OfferPoiType.BUS, name: "Czerwieńskiego 02", distance: 324},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 355},
        {type: OfferPoiType.BUS, name: "Azory 01", distance: 483},
        {type: OfferPoiType.BUS, name: "Azory", distance: 540},
        {type: OfferPoiType.BUS, name: "Gnieźnieńska 02", distance: 552},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1360},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1538},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1565},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1571},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1597},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1914},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 2033}
    ],
    14669: [
        {type: OfferPoiType.BUS, name: "Powstańców Wielkopolskich / Wyszyńskiego", distance: 273},
        {type: OfferPoiType.BUS, name: "Głowackiego / Gajowa", distance: 389},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 418},
        {type: OfferPoiType.BUS, name: "Rondo Skrzetuskie", distance: 478},
        {type: OfferPoiType.BUS, name: "Kamienna / Gajowa", distance: 538},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego / Powstańców Wielkopolskich", distance: 549},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 828}
    ],
    14673: [
        {type: OfferPoiType.BUS, name: "Składowa", distance: 183},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Łasztownia", distance: 408},
        {type: OfferPoiType.BUS, name: "SKM Łasztownia", distance: 454},
        {type: OfferPoiType.TRAM, name: "Celna", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 1214},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1330},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1845},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1988},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 2267},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2267},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 2293},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 2473}
    ],
    14686: [
        {type: OfferPoiType.BUS, name: "Os. Lewandów II 02", distance: 121},
        {type: OfferPoiType.BUS, name: "Os. Lewandów II 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Internetowa 02", distance: 309},
        {type: OfferPoiType.BUS, name: "Oknicka 01", distance: 330},
        {type: OfferPoiType.BUS, name: "Internetowa 01", distance: 419},
        {type: OfferPoiType.BUS, name: "Chudoby 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Oknicka 02", distance: 539},
        {type: OfferPoiType.BUS, name: "Chudoby 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Nauczycielska 01", distance: 643},
        {type: OfferPoiType.BUS, name: "Grodzisk 02", distance: 648},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 2190},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2339},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 2413}
    ],
    14720: [
        {type: OfferPoiType.BUS, name: "Gorzykowska 01", distance: 222},
        {type: OfferPoiType.BUS, name: "Gorzykowska 04", distance: 230},
        {type: OfferPoiType.BUS, name: "Piotra Skargi 01", distance: 243},
        {type: OfferPoiType.BUS, name: "Myszkowska 02", distance: 285},
        {type: OfferPoiType.BUS, name: "Myszkowska 01", distance: 304},
        {type: OfferPoiType.BUS, name: "Piotra Skargi 02", distance: 348},
        {type: OfferPoiType.BUS, name: "Gorzykowska 02", distance: 363},
        {type: OfferPoiType.BUS, name: "Myszkowska 03", distance: 380},
        {type: OfferPoiType.METRO, name: "Targówek Mieszkaniowy", distance: 489},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 01", distance: 519},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 02", distance: 521},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 697},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1091},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 1593},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 1632},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 1704},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 1748}
    ],
    14738: [
        {type: OfferPoiType.BUS, name: "Starogardzka 04", distance: 321},
        {type: OfferPoiType.BUS, name: "Starogardzka 01", distance: 332},
        {type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 613},
        {type: OfferPoiType.BUS, name: "Jagiełły 02", distance: 682},
        {type: OfferPoiType.BUS, name: "Jagiełły 01", distance: 686},
        {type: OfferPoiType.BUS, name: "Przemian", distance: 737},
        {type: OfferPoiType.BUS, name: "Przemian 01", distance: 762}
    ],
    14783: [
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 223},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 246},
        {type: OfferPoiType.BUS, name: "Krakowska", distance: 538},
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 588},
        {type: OfferPoiType.TRAM, name: "Krakowska", distance: 604},
        {type: OfferPoiType.TRAM, name: "Armii Krajowej", distance: 798},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1201},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1461},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1844},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2284}
    ],
    14786: [
        {type: OfferPoiType.BUS, name: "Piłsudskiego - PUP", distance: 554},
        {type: OfferPoiType.BUS, name: "Zuzanny Morawskiej", distance: 713},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Marszałka Józefa Piłsudskiego", distance: 1741}
    ],
    14790: [
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 258},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 260},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - rynek", distance: 489},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - Rynek 2 Nr 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Rzeczna", distance: 563},
        {type: OfferPoiType.BUS, name: "Frankowskiego Nr 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Łopuskiego - Szpital 1 Nr 01", distance: 618},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 639},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 676},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 682},
        {type: OfferPoiType.PARK, name: "Skwer Miast Partnerskich", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Pionierów Kołobrzegu", distance: 903},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 914},
        {type: OfferPoiType.PARK, name: "Skwer 750-lecia", distance: 935},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1464},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1965}
    ],
    14796: [
        {type: OfferPoiType.BUS, name: "Zakroczym Urząd Miejski", distance: 327},
        {type: OfferPoiType.BUS, name: "Zakroczym O.H. Koźmińskiego-Bank", distance: 596},
        {type: OfferPoiType.BUS, name: "Zakroczym Warszawska-Osiedle", distance: 762}
    ],
    14861: [
        {type: OfferPoiType.BUS, name: "Piekarska Wyzwolenia", distance: 304},
        {type: OfferPoiType.BUS, name: "Piekarska PKP Wschód", distance: 394},
        {type: OfferPoiType.BUS, name: "Wyzwolenia Piekarska", distance: 489},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Wschód", distance: 559},
        {type: OfferPoiType.BUS, name: "Lwowska Wyzwolenia", distance: 764},
        {type: OfferPoiType.BUS, name: "Komorowicka PKP Wschód", distance: 771},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1335},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 2128},
        {type: OfferPoiType.PARK, name: "Park za Ratuszem", distance: 2149},
        {type: OfferPoiType.PARK, name: 'Plac zabaw "Szósty zmysł"', distance: 2423}
    ],
    14862: [
        {type: OfferPoiType.BUS, name: "Łagodna Złotych Kłosów", distance: 11},
        {type: OfferPoiType.BUS, name: "Urodzajna Osiedle Langiewicza", distance: 282},
        {type: OfferPoiType.BUS, name: "Łagodna Osiedle Langiewicza", distance: 330},
        {type: OfferPoiType.BUS, name: "Łagodna Szkoła", distance: 342},
        {type: OfferPoiType.BUS, name: "Górska Bulwary Młodości", distance: 546},
        {type: OfferPoiType.PARK, name: "Bulwary Straceńskie", distance: 706},
        {type: OfferPoiType.PARK, name: "Park Strzygowskiego", distance: 1947},
        {type: OfferPoiType.REZERWAT, name: "Żabiniec", distance: 2117}
    ],
    14863: [
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna Pętla", distance: 470},
        {type: OfferPoiType.TRAM, name: "Koszutka Jesionowa", distance: 471},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna", distance: 485},
        {type: OfferPoiType.BUS, name: "Koszutka Słoneczna", distance: 532},
        {type: OfferPoiType.BUS, name: "Koszutka Iłłakowiczówny", distance: 553},
        {type: OfferPoiType.BUS, name: "Wełnowiec Poczta", distance: 604},
        {type: OfferPoiType.BUS, name: "Koszutka GIG", distance: 698},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Kościół", distance: 746},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 767},
        {type: OfferPoiType.TRAM, name: "Koszutka Misjonarzy Oblatów", distance: 802},
        {type: OfferPoiType.LAS, name: "Park Wełnowiecki", distance: 959},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 959},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1212},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1294},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 1346},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1359},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 1481},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1494}
    ],
    14890: [
        {type: OfferPoiType.BUS, name: "Józefowiec Szpital", distance: 290},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 343},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Gnieźnieńska", distance: 474},
        {type: OfferPoiType.BUS, name: "Wełnowiec Gnieźnieńska", distance: 524},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 562},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 730},
        {type: OfferPoiType.BUS, name: "Józefowiec Liceum", distance: 807},
        {type: OfferPoiType.BUS, name: "Józefowiec Szczecińska nż", distance: 828},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 971},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1467},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 1739},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 1823},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 2045},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 2140},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Halora", distance: 2184}
    ],
    14906: [
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Janowska)", distance: 142},
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Mikołowska) [nż]", distance: 330},
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Partyzantów)", distance: 359},
        {type: OfferPoiType.BUS, name: "Janów Janowska", distance: 462},
        {type: OfferPoiType.BUS, name: "Mysłowice Mikołowska Markety", distance: 560},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 1451},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 2459}
    ],
    14910: [
        {type: OfferPoiType.BUS, name: "Karpacka Osiedle Karpackie", distance: 563},
        {type: OfferPoiType.BUS, name: "Osiedle Beskidzkie Kładka", distance: 575},
        {type: OfferPoiType.BUS, name: "Partyzantów Apena", distance: 617},
        {type: OfferPoiType.BUS, name: "Michałowicza Aleksandrowicka", distance: 713},
        {type: OfferPoiType.BUS, name: "Michałowicza Reja", distance: 837}
    ],
    14911: [
        {type: OfferPoiType.BUS, name: "Łódzka", distance: 228},
        {type: OfferPoiType.BUS, name: "Okulickiego", distance: 417},
        {type: OfferPoiType.BUS, name: "Market OBI 03", distance: 479},
        {type: OfferPoiType.BUS, name: "Parkitka - Osiedle", distance: 518},
        {type: OfferPoiType.BUS, name: "Market OBI 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Market OBI", distance: 632},
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 649},
        {type: OfferPoiType.BUS, name: "św.Krzysztofa", distance: 715},
        {type: OfferPoiType.PARK, name: "Park 3 Maja", distance: 1584},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 1841},
        {type: OfferPoiType.PARK, name: "Spacerniak", distance: 1850},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Staszica", distance: 1870},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny Jędrusik", distance: 1881},
        {type: OfferPoiType.PARK, name: "Skwer przy PCK", distance: 1910},
        {type: OfferPoiType.PARK, name: "Skwer osiedlowy przy ulicy Księżycowej", distance: 1990}
    ],
    14912: [
        {type: OfferPoiType.BUS, name: "Bończyk Gałczyńskiego", distance: 834},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 1475},
        {type: OfferPoiType.PARK, name: "Park Bolina", distance: 2186},
        {type: OfferPoiType.PARK, name: "Skwer Artystów Grupy Janowskiej", distance: 2305},
        {type: OfferPoiType.PARK, name: "Skwer Emila i Georga Zillmannów", distance: 2523}
    ],
    14923: [
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 197},
        {type: OfferPoiType.BUS, name: "Bałtycka przy Wylotowej", distance: 235},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wylotowej", distance: 286},
        {type: OfferPoiType.BUS, name: "Sobieskiego", distance: 473},
        {type: OfferPoiType.BUS, name: "Wiosenna", distance: 603},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 628},
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 638},
        {type: OfferPoiType.PARK, name: "Park Antoniego Szarmacha", distance: 783},
        {type: OfferPoiType.LAS, name: "Załęże", distance: 1589},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1592},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1704},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1704},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1847},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 2205}
    ],
    14937: [
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 230},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 310},
        {type: OfferPoiType.BUS, name: "Okólna 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 387},
        {type: OfferPoiType.BUS, name: "Okólna 03", distance: 435},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 577},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 02", distance: 630},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 01", distance: 668},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 711},
        {type: OfferPoiType.BUS, name: "Wspólna 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Strefa Przemysłowa 01", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1180},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1439}
    ],
    14952: [
        {type: OfferPoiType.BUS, name: "Spacerowa II", distance: 50},
        {type: OfferPoiType.BUS, name: "Spacerowa I", distance: 168},
        {type: OfferPoiType.PARK, name: "Park im. Ignacego Jana Paderewskiego", distance: 526},
        {type: OfferPoiType.BUS, name: "Bankowa", distance: 648},
        {type: OfferPoiType.PARK, name: "Park 750-lecia Goleniowa", distance: 1673},
        {type: OfferPoiType.PARK, name: "Skwer Świętego Jerzego", distance: 1706}
    ],
    14953: [
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 02", distance: 324},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 02", distance: 827},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 01", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Miłocin", distance: 1664},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 2112}
    ],
    14973: [
        {type: OfferPoiType.BUS, name: "Katowice Bonifraterska", distance: 262},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 297},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 299},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury", distance: 441},
        {type: OfferPoiType.BUS, name: "Bogucice Markiefki", distance: 487},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 533},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 539},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 645},
        {type: OfferPoiType.BUS, name: "Bogucice Wróblewskiego", distance: 730},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 745},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1182},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1182},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1229},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1280}
    ],
    14981: [
        {type: OfferPoiType.BUS, name: "ZAMKOWA LIDL", distance: 71},
        {type: OfferPoiType.BUS, name: "GRUDZIŃSKICH LIDL", distance: 117},
        {type: OfferPoiType.BUS, name: "STASZICA STADION", distance: 243},
        {type: OfferPoiType.BUS, name: "PIEKARY", distance: 400},
        {type: OfferPoiType.BUS, name: "Staszica SP-1", distance: 451},
        {type: OfferPoiType.BUS, name: "MARCINKOWSKIEGO SZPITAL", distance: 460},
        {type: OfferPoiType.BUS, name: "BUCZKOWSKA", distance: 491},
        {type: OfferPoiType.PARK, name: "Park im. Ks. Dr Janusza Ostrowskiego", distance: 688},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Partnerstwa z Nottuln", distance: 752},
        {type: OfferPoiType.PARK, name: 'Park "Odpoczywaj z kulturą"', distance: 764}
    ],
    14984: [
        {type: OfferPoiType.BUS, name: "Żyzna", distance: 274},
        {type: OfferPoiType.BUS, name: "Chrostowskiej", distance: 543},
        {type: OfferPoiType.BUS, name: "Roweckiego", distance: 599},
        {type: OfferPoiType.BUS, name: "Świtalskiej", distance: 725},
        {type: OfferPoiType.BUS, name: "Os. Żyzna", distance: 743},
        {type: OfferPoiType.PARK, name: "Park Północny", distance: 1495}
    ],
    15010: [
        {type: OfferPoiType.BUS, name: "Krokwi 02", distance: 159},
        {type: OfferPoiType.BUS, name: "Klasyków 04", distance: 212},
        {type: OfferPoiType.BUS, name: "Krokwi 01", distance: 249},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 265},
        {type: OfferPoiType.BUS, name: "Klasyków 02", distance: 320},
        {type: OfferPoiType.BUS, name: "Klasyków 01", distance: 366},
        {type: OfferPoiType.BUS, name: "Fletniowa 01", distance: 553},
        {type: OfferPoiType.BUS, name: "Fletniowa 02", distance: 611},
        {type: OfferPoiType.BUS, name: "Henryków 01", distance: 693},
        {type: OfferPoiType.BUS, name: "Drogowa 02", distance: 706},
        {type: OfferPoiType.BUS, name: "Henryków 04", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 1997},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 2044},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 2201}
    ],
    15024: [
        {type: OfferPoiType.BUS, name: "RATAJE ZSL-G", distance: 563},
        {type: OfferPoiType.BUS, name: "SŁONECZNA ZSL-G", distance: 785},
        {type: OfferPoiType.BUS, name: "SŁONECZNA OSM", distance: 814},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Partnerstwa z Nottuln", distance: 2385}
    ],
    15036: [
        {type: OfferPoiType.BUS, name: "Pyszczyn 03", distance: 584},
        {type: OfferPoiType.BUS, name: "Pyszczyn 04", distance: 590}
    ],
    15045: [
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 74},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 78},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 328},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 406},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 450},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 513},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 516},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 520},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 528},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 532},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Bratysławska 03", distance: 611},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 646},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 799},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 910},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1284}
    ],
    15066: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 160},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 254},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 263},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 308},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 322},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 369},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 562},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 565},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 565},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 756},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 772},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 801},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 908},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 967},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 968},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 1208},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1225}
    ],
    15068: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 152},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 255},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 262},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 316},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 330},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 361},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 554},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 557},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 557},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 748},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 764},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 798},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 900},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 959},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 960},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 1200},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1218}
    ],
    15090: [
        {type: OfferPoiType.BUS, name: "Krakowskie Przedmieście 02", distance: 187},
        {type: OfferPoiType.BUS, name: "Krakowskie Przedmieście 04", distance: 259},
        {type: OfferPoiType.BUS, name: "Ogród Saski 01", distance: 261},
        {type: OfferPoiType.BUS, name: "Ogród Saski 03", distance: 288},
        {type: OfferPoiType.BUS, name: "Czechowska 02", distance: 451},
        {type: OfferPoiType.BUS, name: "Czechowska 01", distance: 459},
        {type: OfferPoiType.BUS, name: "Plac Litewski 01", distance: 506},
        {type: OfferPoiType.PARK, name: "Skwer arcybiskupa Józefa Życińskiego", distance: 539},
        {type: OfferPoiType.BUS, name: "Plac Litewski 02", distance: 541},
        {type: OfferPoiType.PARK, name: "Plac Lecha Kaczyńskiego", distance: 561},
        {type: OfferPoiType.BUS, name: "Okopowa 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Okopowa 02", distance: 632},
        {type: OfferPoiType.PARK, name: "Ogród Saski", distance: 633}
    ],
    15093: [
        {type: OfferPoiType.BUS, name: "Orzechowa", distance: 182},
        {type: OfferPoiType.BUS, name: "ROD Bajki", distance: 213},
        {type: OfferPoiType.BUS, name: "Śliczna", distance: 549},
        {type: OfferPoiType.BUS, name: "Spiska (Ośrodek sportu)", distance: 575},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 660},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 769},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 832},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 947},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1018},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1201},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1637}
    ],
    15112: [
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 99},
        {type: OfferPoiType.BUS, name: "Kaloryczna 02", distance: 130},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 182},
        {type: OfferPoiType.BUS, name: "Antoniewska 02", distance: 393},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 398},
        {type: OfferPoiType.BUS, name: "Antoniewska 01", distance: 444},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 536},
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 748},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 765},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1661},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1684},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2142}
    ],
    15119: [
        {type: OfferPoiType.TRAM, name: "Grudziądzka", distance: 171},
        {type: OfferPoiType.BUS, name: "Grudziądzka 05", distance: 183},
        {type: OfferPoiType.BUS, name: "Grudziądzka 04", distance: 211},
        {type: OfferPoiType.BUS, name: "Grudziądzka 03", distance: 274},
        {type: OfferPoiType.TRAM, name: "Kolonia Uroda", distance: 571},
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 01", distance: 620},
        {type: OfferPoiType.BUS, name: "al. Płażyńskiego", distance: 679},
        {type: OfferPoiType.TRAM, name: "al. Płażyńskiego", distance: 763},
        {type: OfferPoiType.BUS, name: "Lwowska 01", distance: 833},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1114},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 1860},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1913}
    ],
    15156: [
        {type: OfferPoiType.BUS, name: "Reden Centrum Administracyjne", distance: 220},
        {type: OfferPoiType.BUS, name: "Dąbrowa Górnicza Zawidzkiej", distance: 547},
        {type: OfferPoiType.TRAM, name: "Reden Komenda Policji", distance: 643},
        {type: OfferPoiType.BUS, name: "Reden Komenda Policji", distance: 651},
        {type: OfferPoiType.BUS, name: "Gołonóg Morcinka", distance: 815},
        {type: OfferPoiType.PARK, name: "Planty im. Harcmistrza Stefana Piotrowskiego", distance: 1281},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Hallera", distance: 2017},
        {type: OfferPoiType.PARK, name: "Park Śródmiejski", distance: 2201},
        {type: OfferPoiType.PARK, name: "Park Podlesie", distance: 2433}
    ],
    15166: [
        {type: OfferPoiType.BUS, name: "Brodzka", distance: 104},
        {type: OfferPoiType.BUS, name: "Królewiecka (Staw)", distance: 280},
        {type: OfferPoiType.BUS, name: "Kozia", distance: 393},
        {type: OfferPoiType.BUS, name: "Suwalska", distance: 612},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 621},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1818},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 1844},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 1986},
        {type: OfferPoiType.PARK, name: "Park Leśny w Praczach Odrzańskich", distance: 2385}
    ],
    15170: [
        {type: OfferPoiType.BUS, name: "Krzyków – Osiedle", distance: 330},
        {type: OfferPoiType.BUS, name: "Nadolice Małe I", distance: 574},
        {type: OfferPoiType.BUS, name: "Nadolice Małe – Krzykowska", distance: 650},
        {type: OfferPoiType.BUS, name: "Nadolice Małe II – Wrocławska/Zielona", distance: 662}
    ],
    15173: [
        {type: OfferPoiType.BUS, name: "Katowice Bonifraterska", distance: 509},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 584},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 593},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury NOSPR", distance: 613},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 663},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 690},
        {type: OfferPoiType.BUS, name: "Koszutka Katowicka", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 774},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 792},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 832},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 841},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 872},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1042}
    ],
    15183: [{type: OfferPoiType.BUS, name: "Dobrzykowice – Szafirowa", distance: 380}],
    15189: [
        {type: OfferPoiType.BUS, name: "Struga - Kościuszki", distance: 124},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 142},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 149},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 164},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 177},
        {type: OfferPoiType.BUS, name: "Gdańska - Struga", distance: 180},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 255},
        {type: OfferPoiType.BUS, name: "Struga - Piotrkowska", distance: 336},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 371},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Struga", distance: 386},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 397},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 406},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 430},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Żeromskiego", distance: 458},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Zamenhofa", distance: 502},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 517},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 517},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 522},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 555},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 616},
        {type: OfferPoiType.PARK, name: "Skwer im. Lecha Kunki", distance: 635}
    ],
    15196: [
        {type: OfferPoiType.BUS, name: "Złotno - Stare Złotno NŻ", distance: 381},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1624},
        {type: OfferPoiType.PARK, name: "Metalowe namioty", distance: 1859},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 2036},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2353}
    ],
    15216: [
        {type: OfferPoiType.BUS, name: "Gołębia 04", distance: 265},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 306},
        {type: OfferPoiType.TRAM, name: "Gołębia 02", distance: 333},
        {type: OfferPoiType.TRAM, name: "Gołębia 01", distance: 341},
        {type: OfferPoiType.BUS, name: "Gołębia 03", distance: 377},
        {type: OfferPoiType.BUS, name: "Targowa 02", distance: 418},
        {type: OfferPoiType.BUS, name: "Targowa 01", distance: 487},
        {type: OfferPoiType.TRAM, name: "Targowa 04", distance: 626},
        {type: OfferPoiType.TRAM, name: "Targowa 03", distance: 646},
        {type: OfferPoiType.PARK, name: "Glazja", distance: 1484},
        {type: OfferPoiType.PARK, name: "Bastion Menniczy", distance: 1786},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 1959},
        {type: OfferPoiType.REZERWAT, name: "Miasto średniowieczne w Toruniu", distance: 2157}
    ],
    15229: [
        {type: OfferPoiType.BUS, name: "Chorzów Opolska", distance: 279},
        {type: OfferPoiType.BUS, name: "Chorzów Składowa", distance: 420},
        {type: OfferPoiType.BUS, name: "Chorzów Mariańska", distance: 826},
        {type: OfferPoiType.BUS, name: "Chorzów Łagiewnicka", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Amelung", distance: 1093},
        {type: OfferPoiType.PARK, name: "Park Łagiewnicki", distance: 1639},
        {type: OfferPoiType.PARK, name: "Park Chropaczowski imieniem Kopalni Śląsk", distance: 1656},
        {type: OfferPoiType.PARK, name: "Park Heiloo", distance: 1831},
        {type: OfferPoiType.REZERWAT, name: "Staw Foryśka", distance: 2434}
    ],
    15235: [
        {type: OfferPoiType.BUS, name: "Katowice Mickiewicza Biurowce", distance: 209},
        {type: OfferPoiType.BUS, name: "Katowice Plac Wolności", distance: 272},
        {type: OfferPoiType.BUS, name: "Katowice Sobieskiego", distance: 318},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 318},
        {type: OfferPoiType.BUS, name: "Katowice Sokolska", distance: 425},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 430},
        {type: OfferPoiType.BUS, name: "Katowice Dąbrówki", distance: 439},
        {type: OfferPoiType.BUS, name: "Katowice Piotra Skargi", distance: 451},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 473},
        {type: OfferPoiType.TRAM, name: "Katowice Dąbrówki", distance: 487},
        {type: OfferPoiType.TRAM, name: "Katowice Dworzec PKP", distance: 557},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna", distance: 558},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 678},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 752},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 810},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 1006},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1077},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1083},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 1086},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1116}
    ],
    15238: [
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska Sąd", distance: 316},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 349},
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska", distance: 363},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 466},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 630},
        {type: OfferPoiType.BUS, name: "Katowice Sądowa", distance: 670},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Miarki", distance: 688},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 699},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 707},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 814},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 964},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1178},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1220},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 1429}
    ],
    15245: [
        {type: OfferPoiType.BUS, name: "Kopisto Most Zamkowy 04", distance: 198},
        {type: OfferPoiType.BUS, name: "Podwisłocze U. Skarbowy 03", distance: 217},
        {type: OfferPoiType.BUS, name: "Kopisto U. Skarbowy 03", distance: 245},
        {type: OfferPoiType.BUS, name: "Kilara 02", distance: 436},
        {type: OfferPoiType.BUS, name: "Kilara 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Kopisto uniwersytet 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Podwisłocze / Seniora 04", distance: 634},
        {type: OfferPoiType.BUS, name: "Szopena filharmonia 02", distance: 646},
        {type: OfferPoiType.BUS, name: "Szopena filharmonia 01", distance: 663},
        {type: OfferPoiType.BUS, name: "Kopisto uniwersytet 02", distance: 731},
        {type: OfferPoiType.PARK, name: "Skwer im. Kazimierza Górskiego", distance: 1119},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 1122},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 1229},
        {type: OfferPoiType.PARK, name: "Biały Ogród", distance: 1338},
        {type: OfferPoiType.PARK, name: "Skwer im. ks. Józefa Hermana Osińskiego", distance: 1431},
        {type: OfferPoiType.PARK, name: "Park Jedności Polonii z Macierzą", distance: 1526}
    ],
    15258: [
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Interferie", distance: 237},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa", distance: 332},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Promenada 01", distance: 336},
        {type: OfferPoiType.BUS, name: "Słowackiego / Chrobrego 07", distance: 515},
        {type: OfferPoiType.BUS, name: "Świnoujście Express", distance: 675},
        {type: OfferPoiType.BUS, name: "Rusałka 02", distance: 737},
        {type: OfferPoiType.BUS, name: "Parkowa / Uzdrowiskowa", distance: 748},
        {type: OfferPoiType.BUS, name: "Rusałka 01", distance: 780},
        {type: OfferPoiType.BUS, name: "tymczasowy", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 815}
    ],
    15261: [
        {type: OfferPoiType.BUS, name: "Wschodnia - plaża", distance: 480},
        {type: OfferPoiType.LAS, name: "Park im. Aleksandra Fredry", distance: 489},
        {type: OfferPoiType.PARK, name: "Park im. Aleksandra Fredry", distance: 489},
        {type: OfferPoiType.BUS, name: "Wschodnia - WDW", distance: 642},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Amfiteatr", distance: 673},
        {type: OfferPoiType.BUS, name: "Fredry", distance: 775},
        {type: OfferPoiType.BUS, name: "Fredry 2 Nr 02", distance: 817},
        {type: OfferPoiType.BUS, name: "Chodkiewicza - osiedle", distance: 840},
        {type: OfferPoiType.PARK, name: "Park im. 3 Dywizji Piechoty", distance: 1527},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 2011}
    ],
    15269: [{type: OfferPoiType.LAS, name: "Stary cmentarz w Kobylnikach", distance: 990}],
    15288: [
        {type: OfferPoiType.BUS, name: "Hala Targowa 71", distance: 189},
        {type: OfferPoiType.BUS, name: "Starowiślna 08", distance: 201},
        {type: OfferPoiType.TRAM, name: "Starowiślna 04", distance: 233},
        {type: OfferPoiType.TRAM, name: "Starowiślna 03", distance: 256},
        {type: OfferPoiType.TRAM, name: "Hala Targowa 02", distance: 268},
        {type: OfferPoiType.BUS, name: "Hala Targowa 72", distance: 271},
        {type: OfferPoiType.TRAM, name: "Hala Targowa 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Poczta Główna 04", distance: 279},
        {type: OfferPoiType.TRAM, name: "Starowiślna 02", distance: 283},
        {type: OfferPoiType.TRAM, name: "Starowiślna 01", distance: 293},
        {type: OfferPoiType.TRAM, name: "Poczta Główna 02", distance: 307},
        {type: OfferPoiType.BUS, name: "Starowiślna 07", distance: 310},
        {type: OfferPoiType.KOLEJ, name: "Kraków Grzegórzki", distance: 333},
        {type: OfferPoiType.TRAM, name: "Poczta Główna 01", distance: 342},
        {type: OfferPoiType.TRAM, name: "Poczta Główna 03", distance: 367},
        {type: OfferPoiType.PARK, name: "Park Kolejowy", distance: 372},
        {type: OfferPoiType.BUS, name: "św. Gertrudy 02", distance: 483},
        {type: OfferPoiType.TRAM, name: "św. Gertrudy 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Plac Wszystkich Świętych 01", distance: 632},
        {type: OfferPoiType.PARK, name: "Skwer Kółeczko", distance: 667},
        {type: OfferPoiType.PARK, name: "Ogrody Zgromadzenia Księży Misjonarzy w Krakowie", distance: 671},
        {type: OfferPoiType.BUS, name: "Plac Wszystkich Świętych 02", distance: 704},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 709},
        {type: OfferPoiType.PARK, name: "Łąka na Wesołej", distance: 806},
        {type: OfferPoiType.BUS, name: "Stradom 06", distance: 822},
        {type: OfferPoiType.PARK, name: "Planty", distance: 1048}
    ],
    15294: [{type: OfferPoiType.BUS, name: "Jastrzębia Góra", distance: 809}],
    15303: [
        {type: OfferPoiType.BUS, name: "Olbrachta pętla 09", distance: 239},
        {type: OfferPoiType.BUS, name: "Olbrachta / Św. Kingi 07", distance: 736},
        {type: OfferPoiType.BUS, name: "Olbrachta / Św. Kingi 08", distance: 747},
        {type: OfferPoiType.BUS, name: "Słocińska pętla 11", distance: 800},
        {type: OfferPoiType.BUS, name: "Krasne Auchan", distance: 846}
    ],
    15316: [
        {type: OfferPoiType.BUS, name: "Podczele - Tarnopolska", distance: 86},
        {type: OfferPoiType.BUS, name: "Kresowa - Podczele Nr 01", distance: 401},
        {type: OfferPoiType.BUS, name: "Lwowska - Podczele Nr 01", distance: 413},
        {type: OfferPoiType.PARK, name: "skwer Pana Tadeusza", distance: 472},
        {type: OfferPoiType.BUS, name: "Nowogródzka - Podczele Nr 01", distance: 591}
    ],
    15317: [
        {type: OfferPoiType.BUS, name: "Wieczorynki n/ż", distance: 698},
        {type: OfferPoiType.BUS, name: "Os. Bajkowe", distance: 698},
        {type: OfferPoiType.LAS, name: "Lasek Marceliński", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Wille Bukowska", distance: 1682}
    ],
    15328: [
        {type: OfferPoiType.BUS, name: "ROD Zgoda", distance: 406},
        {type: OfferPoiType.BUS, name: "Lutosławskiego", distance: 466},
        {type: OfferPoiType.BUS, name: "Tunelowa", distance: 765},
        {type: OfferPoiType.BUS, name: "Konduktorska", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 1536},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1868},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 1883}
    ],
    15379: [
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 02", distance: 150},
        {type: OfferPoiType.BUS, name: "Kurpińskiego 02", distance: 172},
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 01", distance: 176},
        {type: OfferPoiType.BUS, name: "Kurpińskiego 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Schuberta 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Schuberta 01", distance: 529},
        {type: OfferPoiType.BUS, name: "Otwarta 02", distance: 612},
        {type: OfferPoiType.BUS, name: "Belgradzka 04", distance: 645},
        {type: OfferPoiType.BUS, name: "Piecewska", distance: 645},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 646},
        {type: OfferPoiType.BUS, name: "Otwarta 01", distance: 661},
        {type: OfferPoiType.TRAM, name: "Piekarnicza", distance: 700},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 743},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 743},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 760},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 866},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 1094},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 1964},
        {type: OfferPoiType.PARK, name: "Park w Królewskiej Dolinie", distance: 1989},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 2265}
    ],
    15408: [
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 108},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 242},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 323},
        {type: OfferPoiType.BUS, name: "Plac Neptuna", distance: 456},
        {type: OfferPoiType.BUS, name: "Niepodległości (Muzeum)", distance: 519},
        {type: OfferPoiType.BUS, name: "Kolejowa 24", distance: 626},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Pasaż Handlowy", distance: 691},
        {type: OfferPoiType.BUS, name: "Straż Pożarna", distance: 706}
    ],
    15413: [
        {type: OfferPoiType.BUS, name: "Tomaszew 01", distance: 148},
        {type: OfferPoiType.BUS, name: "Tomaszew 02", distance: 273},
        {type: OfferPoiType.BUS, name: "Wilkowiecka 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Nowiny 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Nowiny 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Wilkowiecka 02", distance: 696}
    ],
    15443: [
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 444},
        {type: OfferPoiType.BUS, name: "Skalskiego 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Felin Kalinówka 02", distance: 485},
        {type: OfferPoiType.BUS, name: "Skalskiego 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Felin Kalinówka 01", distance: 555},
        {type: OfferPoiType.BUS, name: "Felin 03", distance: 750},
        {type: OfferPoiType.BUS, name: "Felin 01", distance: 751},
        {type: OfferPoiType.BUS, name: "Felin 02", distance: 759},
        {type: OfferPoiType.BUS, name: "Instytut Agrofizyki 01", distance: 800}
    ],
    15445: [
        {type: OfferPoiType.BUS, name: "Park Bronowice 03", distance: 315},
        {type: OfferPoiType.BUS, name: "Park Bronowice 02", distance: 460},
        {type: OfferPoiType.BUS, name: "Park Bronowice 01", distance: 462},
        {type: OfferPoiType.BUS, name: "Park Bronowice 04", distance: 523},
        {type: OfferPoiType.BUS, name: "Lotnicza 02", distance: 530},
        {type: OfferPoiType.BUS, name: "Lotnicza 01", distance: 649},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 01", distance: 727},
        {type: OfferPoiType.PARK, name: "Park Bronowice", distance: 729},
        {type: OfferPoiType.PARK, name: "Skwer imienia Prymasa Tysiąclecia Kardynała Wyszyńskiego", distance: 734},
        {type: OfferPoiType.BUS, name: "Plac Bychawski 02", distance: 773},
        {type: OfferPoiType.BUS, name: "Plac Bychawski 03", distance: 775}
    ],
    15472: [
        {type: OfferPoiType.PARK, name: "Skwer Ofiar Zbrodni Karyńskiej", distance: 419},
        {type: OfferPoiType.PARK, name: "Skwer", distance: 444},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 460},
        {type: OfferPoiType.BUS, name: "Harcerska 02", distance: 466},
        {type: OfferPoiType.PARK, name: 'Skwer Zgrupowania AK "Szaracy"', distance: 488},
        {type: OfferPoiType.BUS, name: "Policja 02", distance: 543},
        {type: OfferPoiType.BUS, name: "Harcerska 01", distance: 557},
        {type: OfferPoiType.BUS, name: "Parkowa 01", distance: 590},
        {type: OfferPoiType.BUS, name: "Park 02", distance: 596},
        {type: OfferPoiType.BUS, name: "Parkowa 02", distance: 599},
        {type: OfferPoiType.PARK, name: "Skwer Tadeusza Bilicza", distance: 727},
        {type: OfferPoiType.PARK, name: "skwer Pracowników Zakładów Starachowickich", distance: 735},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny im. Bolesława Kazimierza Stanislawa Papi", distance: 2308}
    ],
    15485: [
        {type: OfferPoiType.TRAM, name: "Chełmińska/Włodka", distance: 499},
        {type: OfferPoiType.TRAM, name: "Aleja 23 Stycznia", distance: 564},
        {type: OfferPoiType.BUS, name: "Gdyńska", distance: 633},
        {type: OfferPoiType.TRAM, name: "Rynek Główny", distance: 769},
        {type: OfferPoiType.KOLEJ, name: "Grudziądz Śródmieście", distance: 796},
        {type: OfferPoiType.TRAM, name: "Hallera/Dworcowa", distance: 805},
        {type: OfferPoiType.PARK, name: "Skwer Teatralny im. Czesława Niemena", distance: 1092},
        {type: OfferPoiType.PARK, name: "Park na Górze Zamkowej", distance: 1197},
        {type: OfferPoiType.PARK, name: "Skwer Wolności imienia Władysława Bartoszewskiego", distance: 1462},
        {type: OfferPoiType.PARK, name: "Park Miejski imienia Piotra Janowskiego", distance: 1578},
        {type: OfferPoiType.PARK, name: "Park Miejski - część leśna", distance: 2479}
    ],
    15504: [
        {type: OfferPoiType.BUS, name: "Chełmińska/Bydgoska", distance: 537},
        {type: OfferPoiType.TRAM, name: "Chełmińska/Bydgoska", distance: 540},
        {type: OfferPoiType.PARK, name: "Park Miejski imienia Piotra Janowskiego", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Miejski - część leśna", distance: 2102},
        {type: OfferPoiType.PARK, name: "Skwer Teatralny im. Czesława Niemena", distance: 2103}
    ],
    15532: [
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 07", distance: 362},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 03", distance: 425},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 71", distance: 468},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 04", distance: 472},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 05", distance: 484},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 06", distance: 494},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 08", distance: 497},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Ostródzka 02", distance: 728},
        {type: OfferPoiType.BUS, name: "Łojewska 02", distance: 776},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 963},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1509},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1642},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1701},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 2237},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2290}
    ],
    15547: [
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/01", distance: 578},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 607},
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/02", distance: 679},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 967}
    ],
    15560: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 389},
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/01", distance: 449},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 554},
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/02", distance: 564}
    ],
    15584: [
        {type: OfferPoiType.BUS, name: "Stare Gliwice Łabędzka", distance: 349},
        {type: OfferPoiType.BUS, name: "Stare Gliwice Wiejska", distance: 489},
        {type: OfferPoiType.BUS, name: "Stare Gliwice Chemiczna", distance: 568},
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Pętla", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 1095},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Dąbrowa", distance: 2272}
    ],
    15585: [
        {type: OfferPoiType.BUS, name: "Malborska (EPBP)", distance: 173},
        {type: OfferPoiType.BUS, name: "Malborska - Fredry", distance: 358},
        {type: OfferPoiType.BUS, name: "Skrzydlata - LOK", distance: 464},
        {type: OfferPoiType.BUS, name: "Łódzka - pętla", distance: 573},
        {type: OfferPoiType.BUS, name: "Malborska - Zagonowa", distance: 646},
        {type: OfferPoiType.BUS, name: "Lotnicza - Fredry", distance: 662},
        {type: OfferPoiType.BUS, name: "Skrzydlata - pętla", distance: 734},
        {type: OfferPoiType.PARK, name: "Park Wojska Polskiego", distance: 1348},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Rebinina", distance: 1375},
        {type: OfferPoiType.PARK, name: "Park Planty", distance: 1608}
    ],
    15592: [{type: OfferPoiType.PARK, name: "Park Ireny Tamary Misztal", distance: 964}],
    15597: [
        {type: OfferPoiType.BUS, name: "Kajki ZS nr 6", distance: 253},
        {type: OfferPoiType.BUS, name: "11-go Listopada-szkoła 04", distance: 353},
        {type: OfferPoiType.BUS, name: "Północ II 01", distance: 355},
        {type: OfferPoiType.BUS, name: "Tuwima 02", distance: 442},
        {type: OfferPoiType.BUS, name: "Sikorskiego-rondo 01", distance: 462},
        {type: OfferPoiType.BUS, name: "Sikorskiego-Zespół Szkół nr 6 06", distance: 465},
        {type: OfferPoiType.BUS, name: "Północ II 02", distance: 469},
        {type: OfferPoiType.BUS, name: "Tuwima-Zespół Szkół nr 1 01", distance: 472},
        {type: OfferPoiType.BUS, name: "11-go Listopda-kościół", distance: 519},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Rondo 02", distance: 583},
        {type: OfferPoiType.REZERWAT, name: "Wyspa lęgowa", distance: 790}
    ],
    15600: [
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo Stare I 01", distance: 86},
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo Stare I 08", distance: 131},
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo II 02", distance: 310},
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo II 01", distance: 314}
    ],
    15613: [
        {type: OfferPoiType.BUS, name: "Gliwice Szpital Wielospecjalistyczny", distance: 266},
        {type: OfferPoiType.BUS, name: "Gliwice Sąd Okręgowy", distance: 308},
        {type: OfferPoiType.BUS, name: "Gliwice Teatr", distance: 326},
        {type: OfferPoiType.BUS, name: "Gliwice Słowackiego", distance: 453},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 528},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 693},
        {type: OfferPoiType.PARK, name: "Plac Mickiewicza", distance: 717}
    ],
    15622: [
        {type: OfferPoiType.BUS, name: "Telewizja Katowice", distance: 274},
        {type: OfferPoiType.BUS, name: "Wełnowiec Bytkowska Hotel", distance: 355},
        {type: OfferPoiType.BUS, name: "Bytków Osiedle Chemik", distance: 472},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 1209},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1490},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1799},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1888},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Halora", distance: 1917},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 2001},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 2085},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 2144},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2415}
    ],
    15646: [
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 28},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 118},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 341},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 405},
        {type: OfferPoiType.BUS, name: "Tuwima - Wysoka", distance: 424},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 448},
        {type: OfferPoiType.BUS, name: "Narutowicza - Tramwajowa", distance: 453},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 471},
        {type: OfferPoiType.BUS, name: "Tuwima - Przędzalniana", distance: 544},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 597},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 608},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 610},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 643},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 795},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 855},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 984},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 1077},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1184},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 1197},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 1295}
    ],
    15648: [
        {type: OfferPoiType.BUS, name: "Michalczyka", distance: 214},
        {type: OfferPoiType.TRAM, name: "Michalczyka", distance: 226},
        {type: OfferPoiType.PARK, name: "skwer Świętego Ojca Damiana de Veuster", distance: 509},
        {type: OfferPoiType.BUS, name: "Inowrocławska", distance: 594},
        {type: OfferPoiType.TRAM, name: "Wrocław Szczepin", distance: 612},
        {type: OfferPoiType.BUS, name: "Wrocław Szczepin", distance: 616},
        {type: OfferPoiType.BUS, name: "Litomska (ZUS)", distance: 672},
        {type: OfferPoiType.BUS, name: "Kępa Mieszczańska", distance: 736},
        {type: OfferPoiType.BUS, name: "Plac Solidarności", distance: 755},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Szczepin", distance: 792},
        {type: OfferPoiType.PARK, name: "skwer Kornela Morawieckiego", distance: 839},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2162}
    ],
    15651: [
        {type: OfferPoiType.BUS, name: "Reda Bosmańska 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Reda Bosmańska 01", distance: 358},
        {type: OfferPoiType.BUS, name: "Reda Obwodowa 01 n/ż", distance: 436},
        {type: OfferPoiType.BUS, name: "Reda Młyńska 02", distance: 458},
        {type: OfferPoiType.BUS, name: "Reda Młyńska 01", distance: 475},
        {type: OfferPoiType.BUS, name: "Reda Młyńska 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Reda Aquapark 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Rumia Dolna 01 n/ż", distance: 652},
        {type: OfferPoiType.BUS, name: "Reda Dworzec PKP 01", distance: 781},
        {type: OfferPoiType.PARK, name: "Miejski Park Rodzinny w Redzie", distance: 2233}
    ],
    15663: [
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 314},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 335},
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 356},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 577},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Bałtycka", distance: 592},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 605},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 646},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 649},
        {type: OfferPoiType.BUS, name: "Rondo Skrzetuskie", distance: 683},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 685},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 844}
    ],
    15681: [
        {type: OfferPoiType.BUS, name: "Wielka", distance: 65},
        {type: OfferPoiType.BUS, name: "Małe Garbary", distance: 196},
        {type: OfferPoiType.BUS, name: "Grobla", distance: 233},
        {type: OfferPoiType.TRAM, name: "Małe Garbary", distance: 254},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 369},
        {type: OfferPoiType.BUS, name: "Grochowe Łąki", distance: 471},
        {type: OfferPoiType.BUS, name: "Mostowa", distance: 489},
        {type: OfferPoiType.TRAM, name: "Pl. Bernardyński", distance: 537},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 546},
        {type: OfferPoiType.TRAM, name: "Pl. Wielkopolski", distance: 620},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 681},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 714},
        {type: OfferPoiType.TRAM, name: "Katedra", distance: 720},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 1061},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 1161},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1194},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1208},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 1219},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 1260},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1444},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 1520}
    ],
    15687: [
        {type: OfferPoiType.BUS, name: "Tuwima - Wysoka", distance: 125},
        {type: OfferPoiType.BUS, name: "Tuwima - Przędzalniana", distance: 265},
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 337},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 374},
        {type: OfferPoiType.BUS, name: "Tuwima - Rodz. Kindermannów NŻ", distance: 395},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 415},
        {type: OfferPoiType.BUS, name: "Przędzalniana - Nawrot", distance: 501},
        {type: OfferPoiType.BUS, name: "Nawrot - Wysoka", distance: 509},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Tuwima", distance: 550},
        {type: OfferPoiType.TRAM, name: "Kopcińskiego - Tuwima", distance: 552},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 599},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 612},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 672},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 814},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 1086},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1178},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 1191},
        {type: OfferPoiType.PARK, name: "Park im. 3 Maja", distance: 1238}
    ],
    15688: [
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Gałęźna Góra", distance: 2264},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Lewice", distance: 2492}
    ],
    15694: [
        {type: OfferPoiType.BUS, name: "Tychy Piłsudskiego", distance: 172},
        {type: OfferPoiType.PARK, name: "Oś Zielona", distance: 410},
        {type: OfferPoiType.BUS, name: "Tychy Hala Sportowa", distance: 457},
        {type: OfferPoiType.BUS, name: "Tychy Osiedle O", distance: 582},
        {type: OfferPoiType.PARK, name: "Park świętego Franciszka z Asyżu", distance: 618},
        {type: OfferPoiType.BUS, name: "Tychy Osiedle T", distance: 626},
        {type: OfferPoiType.BUS, name: "Tychy Paprocańska", distance: 669},
        {type: OfferPoiType.BUS, name: "Tychy Hale Targowe", distance: 722},
        {type: OfferPoiType.PARK, name: "Rodzinny Park Błogosławionej Karoliny", distance: 765},
        {type: OfferPoiType.PARK, name: "Skwer imienia Marii i Lecha Kaczyńskich", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Miejski Solidarności", distance: 1518},
        {type: OfferPoiType.REZERWAT, name: "Paprocany", distance: 1661}
    ],
    15726: [
        {type: OfferPoiType.BUS, name: "Bielicowa", distance: 241},
        {type: OfferPoiType.BUS, name: "Naramowice Wschodnie", distance: 394},
        {type: OfferPoiType.BUS, name: "Sielawy", distance: 406},
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 536},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1786},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2211}
    ],
    15737: [
        {type: OfferPoiType.BUS, name: "Aleja Jana Pawła II", distance: 91},
        {type: OfferPoiType.BUS, name: "Kościuszki - Starostwo", distance: 169},
        {type: OfferPoiType.BUS, name: "Kościuszki- Pelplińska", distance: 234},
        {type: OfferPoiType.BUS, name: "Rynek", distance: 288},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 344},
        {type: OfferPoiType.BUS, name: "SCK", distance: 413},
        {type: OfferPoiType.PARK, name: "Skwer Świętego Wojciecha", distance: 444},
        {type: OfferPoiType.PARK, name: "Park Nowe Oblicze", distance: 487},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 567}
    ],
    15757: [{type: OfferPoiType.BUS, name: "Skórzewo Os. Grafitowe n/ż", distance: 689}],
    15766: [
        {type: OfferPoiType.BUS, name: "Sypniewska 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Statkowskiego 04", distance: 516},
        {type: OfferPoiType.BUS, name: "Statkowskiego 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Statkowskiego 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Zawodzie 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Sypniewska 02", distance: 560},
        {type: OfferPoiType.BUS, name: "Zawodzie 02", distance: 565},
        {type: OfferPoiType.BUS, name: "Zawodzie 04", distance: 587},
        {type: OfferPoiType.BUS, name: "Prefabet 02", distance: 641},
        {type: OfferPoiType.BUS, name: "EC Siekierki 01", distance: 822},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 848},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1094},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1150},
        {type: OfferPoiType.PARK, name: "Park Czesława Szczubełka", distance: 1299},
        {type: OfferPoiType.PARK, name: "Skwer Ormiański", distance: 1303},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 2080}
    ],
    15788: [
        {type: OfferPoiType.BUS, name: "Ustronie Morskie - pętla", distance: 503},
        {type: OfferPoiType.BUS, name: "Marysin", distance: 535}
    ],
    15791: [
        {type: OfferPoiType.BUS, name: "Płużnicka 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Płużnicka 01", distance: 442},
        {type: OfferPoiType.TRAM, name: "Stare Świdry 03", distance: 576},
        {type: OfferPoiType.TRAM, name: "Stare Świdry 04", distance: 580},
        {type: OfferPoiType.BUS, name: "Stare Świdry 02", distance: 608},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 02", distance: 696},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 01", distance: 711},
        {type: OfferPoiType.BUS, name: "Obrazkowa 01", distance: 758},
        {type: OfferPoiType.BUS, name: "Obrazkowa 03", distance: 798},
        {type: OfferPoiType.BUS, name: "Porajów 01", distance: 820},
        {type: OfferPoiType.BUS, name: "Kasztanowa 02", distance: 833},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 1578}
    ],
    15798: [
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Nowokarsiborska 05", distance: 207},
        {type: OfferPoiType.BUS, name: "runwaldzka / Nowokarsiborska 06", distance: 243},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 07", distance: 389},
        {type: OfferPoiType.BUS, name: "Cmentarz - Brama nr II 04", distance: 404},
        {type: OfferPoiType.BUS, name: "Karsiborska / Steyera 06", distance: 423},
        {type: OfferPoiType.BUS, name: "Karsiborska / Steyera 05", distance: 431},
        {type: OfferPoiType.BUS, name: "Cmentarz - Brama nr II 03", distance: 436},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 08", distance: 491},
        {type: OfferPoiType.BUS, name: "Markiewicza - Poczta 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Osiedle Zachodnie 03", distance: 582},
        {type: OfferPoiType.LAS, name: "Świdne Bagna", distance: 1043},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 1915},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 2095}
    ],
    15816: [
        {type: OfferPoiType.BUS, name: "Zbożowa", distance: 355},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 467},
        {type: OfferPoiType.BUS, name: "Morska - Kcyńska", distance: 531},
        {type: OfferPoiType.BUS, name: "Owsiana", distance: 661}
    ],
    15820: [
        {type: OfferPoiType.BUS, name: "Czarnoleska / Wierzbicka", distance: 455},
        {type: OfferPoiType.BUS, name: "Czarnoleska / Urszuli", distance: 533},
        {type: OfferPoiType.BUS, name: "Sycyńska / Urszuli (NŻ) 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Sycyńska / Urszuli (NŻ) 01", distance: 607},
        {type: OfferPoiType.BUS, name: "Wierzbicka / Czarnoleska", distance: 625},
        {type: OfferPoiType.PARK, name: "Park Południe", distance: 808}
    ],
    15841: [
        {type: OfferPoiType.BUS, name: "Lodowa/Zamoyskiego", distance: 439},
        {type: OfferPoiType.BUS, name: "Karskiego/Oliwkowa (Z) NŻ", distance: 658},
        {type: OfferPoiType.BUS, name: "Karskiego/Oliwkowa NŻ", distance: 755},
        {type: OfferPoiType.BUS, name: "Lodowa/Chłodna", distance: 805},
        {type: OfferPoiType.LAS, name: "Las Wesołowski", distance: 1689},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Antoniuk", distance: 2082}
    ],
    15843: [
        {type: OfferPoiType.BUS, name: "Liceum Plastyczne", distance: 305},
        {type: OfferPoiType.BUS, name: "Batorego/Dworcowa", distance: 671},
        {type: OfferPoiType.LAS, name: "Dolina Gęśnika", distance: 1010},
        {type: OfferPoiType.PARK, name: "Plac Kolejarza", distance: 1434},
        {type: OfferPoiType.PARK, name: "Plac Makusynów", distance: 1470}
    ],
    15858: [
        {type: OfferPoiType.BUS, name: "Ligota Bronisławy", distance: 48},
        {type: OfferPoiType.BUS, name: "Ligota Akademiki", distance: 325},
        {type: OfferPoiType.PARK, name: "Skwer Tytusa Chałubińskiego", distance: 464},
        {type: OfferPoiType.BUS, name: "Ligota Szpital", distance: 469},
        {type: OfferPoiType.LAS, name: "Gierkówka", distance: 549},
        {type: OfferPoiType.BUS, name: "Ligota Wileńska", distance: 551},
        {type: OfferPoiType.PARK, name: "Park Zadole", distance: 654},
        {type: OfferPoiType.PARK, name: "plac profesora Kornela Gibińskiego", distance: 701},
        {type: OfferPoiType.BUS, name: "Ligota Medyków", distance: 712},
        {type: OfferPoiType.BUS, name: "Panewniki Bazylika", distance: 779},
        {type: OfferPoiType.PARK, name: "Skwer Nad Ślepiotką", distance: 788},
        {type: OfferPoiType.PARK, name: "skwer Bolesława Szabelskiego", distance: 1070},
        {type: OfferPoiType.PARK, name: "Skwer profesora Wilibalda Winklera", distance: 1096},
        {type: OfferPoiType.PARK, name: "plac ojca Justyna Widucha", distance: 1099},
        {type: OfferPoiType.PARK, name: "Plac Miast Partnerskich", distance: 1188}
    ],
    15863: [
        {type: OfferPoiType.BUS, name: "Bronowice Małe", distance: 105},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 03", distance: 157},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 05", distance: 255},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 09", distance: 319},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 334},
        {type: OfferPoiType.TRAM, name: "Bronowice Małe 01", distance: 409},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 06", distance: 422},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 08", distance: 508},
        {type: OfferPoiType.TRAM, name: "Bronowice Małe", distance: 510},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 07", distance: 558},
        {type: OfferPoiType.BUS, name: "Giełda Balicka 02", distance: 710},
        {type: OfferPoiType.BUS, name: "Giełda Balicka 01", distance: 743},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1560},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 1894},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1953},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 2124},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 2223}
    ],
    15866: [
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1223},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1903},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 2099},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2528}
    ],
    15885: [
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 192},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 240},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 253},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 317},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 401},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 480},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 505},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Sterlinga NŻ", distance: 513},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Rewolucji 1905 r.", distance: 527},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kilińskiego", distance: 541},
        {type: OfferPoiType.BUS, name: "Sterlinga - Rewolucji 1905r.", distance: 545},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 554},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 561},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 601},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 623},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 693},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 900},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1045},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1164}
    ],
    15887: [
        {type: OfferPoiType.BUS, name: "Świt", distance: 439},
        {type: OfferPoiType.BUS, name: "Ołtaszyn", distance: 534},
        {type: OfferPoiType.BUS, name: "Strachowskiego", distance: 748},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 1363},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1788},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 2221},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 2403},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 2433}
    ],
    15896: [
        {type: OfferPoiType.BUS, name: "Niepodległości / LIDL", distance: 162},
        {type: OfferPoiType.BUS, name: "Tysiąclecia / Spółdzielnia Mieszkaniowa", distance: 208},
        {type: OfferPoiType.BUS, name: "Słowackiego / Dom Nauczyciela", distance: 236},
        {type: OfferPoiType.PARK, name: "Skwer Braci Zygmuntowiczów", distance: 355},
        {type: OfferPoiType.BUS, name: "Okrzei / Poczta", distance: 363},
        {type: OfferPoiType.BUS, name: "Krasińskiego / Hermes", distance: 452},
        {type: OfferPoiType.PARK, name: "Skwer Kolejarzy", distance: 476},
        {type: OfferPoiType.BUS, name: "Sikorskiego / Urząd Miasta", distance: 593},
        {type: OfferPoiType.PARK, name: "Skwer imienia Franciszka Tatkowskiego", distance: 595},
        {type: OfferPoiType.BUS, name: "Piłsudskiego / Szkoła", distance: 613},
        {type: OfferPoiType.PARK, name: "Skwer Bziński", distance: 1120}
    ],
    15910: [
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 341},
        {type: OfferPoiType.BUS, name: "Marysińska - Szklana", distance: 396},
        {type: OfferPoiType.BUS, name: "Marysińska - Okopowa", distance: 436},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Park Szarych Szeregów", distance: 509},
        {type: OfferPoiType.BUS, name: "Marysin Stadion", distance: 515},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Okopowa", distance: 597},
        {type: OfferPoiType.BUS, name: "Obr. Westerplatte - Organizacji WiN", distance: 684},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Sucharskiego", distance: 688},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 879},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1245},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1319},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1363},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1464},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1532},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1594}
    ],
    15913: [
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 196},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 234},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 242},
        {type: OfferPoiType.BUS, name: "Włókniarzy - Legionów NŻ", distance: 302},
        {type: OfferPoiType.BUS, name: "Zielona - 1 Maja", distance: 422},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 492},
        {type: OfferPoiType.BUS, name: "Konstantynowska - Unii Lubelskiej (Fala)", distance: 510},
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 618},
        {type: OfferPoiType.TRAM, name: "Konstantynowska - Unii Lubelskiej (Fala)", distance: 628},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Konstantynowska (Fala)", distance: 657},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Srebrzyńska", distance: 710},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 888},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 988},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1214},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1313},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1400},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 1476},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 1509},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1810},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 1857}
    ],
    15914: [
        {type: OfferPoiType.BUS, name: "Jasielska II n/ż", distance: 95},
        {type: OfferPoiType.BUS, name: "Jasielska I n/ż", distance: 453},
        {type: OfferPoiType.BUS, name: "Druskienicka", distance: 483},
        {type: OfferPoiType.BUS, name: "Instytut Genetyki n/ż", distance: 655},
        {type: OfferPoiType.BUS, name: "Truskawiecka n/ż", distance: 774},
        {type: OfferPoiType.BUS, name: "Lubieńska n/ż", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 838},
        {type: OfferPoiType.PARK, name: "Park Edukacji Ekologicznej Strzeszyn", distance: 1105},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1208},
        {type: OfferPoiType.PARK, name: "Aleja Demokracji", distance: 1298},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 2377},
        {type: OfferPoiType.PARK, name: "Park Alberta Camusa", distance: 2520}
    ],
    15916: [
        {type: OfferPoiType.BUS, name: "Myśliwska 02", distance: 108},
        {type: OfferPoiType.BUS, name: "Myśliwska 01", distance: 128},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 473},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 02", distance: 490},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 496},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Lasówka 02", distance: 576},
        {type: OfferPoiType.BUS, name: "Lasówka 01", distance: 656},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 677},
        {type: OfferPoiType.PARK, name: "Ptasi Zagajnik", distance: 701},
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 773},
        {type: OfferPoiType.BUS, name: "Szczecińska 02", distance: 776},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R", distance: 811},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1376},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1876}
    ],
    15918: [
        {type: OfferPoiType.PARK, name: "Plac Władysława Broniewskiego", distance: 155},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 02", distance: 254},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy i Autobusowy 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy i Autobusowy 01", distance: 326},
        {type: OfferPoiType.BUS, name: "Kołłątaja - Kaufland 01/02", distance: 399},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy i Autobusowy 03", distance: 466},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 01", distance: 564},
        {type: OfferPoiType.BUS, name: "Plac Dąbrowskiego 02", distance: 600},
        {type: OfferPoiType.BUS, name: "Wolności 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Wolności 02", distance: 628},
        {type: OfferPoiType.BUS, name: "Sienkiewicza 01", distance: 647},
        {type: OfferPoiType.PARK, name: "Skwer im. Pierwszych Słupszczan", distance: 708},
        {type: OfferPoiType.PARK, name: "Park im. Henryka Sienkiewicza", distance: 729},
        {type: OfferPoiType.PARK, name: "Skwer Heinricha von Stephana", distance: 857},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 909},
        {type: OfferPoiType.PARK, name: "Park Pianistyki Polskiej", distance: 997},
        {type: OfferPoiType.PARK, name: "Park im. Jerzego Waldorffa", distance: 1095}
    ],
    15927: [
        {type: OfferPoiType.BUS, name: "Niemcz / Słowackiego", distance: 210},
        {type: OfferPoiType.BUS, name: "Niemcz / Kasprowicza", distance: 341},
        {type: OfferPoiType.BUS, name: "Niemcz / Mickiewicza", distance: 526},
        {type: OfferPoiType.BUS, name: "Jeździecka / Ogród Botaniczny", distance: 583},
        {type: OfferPoiType.BUS, name: "Jeździecka / Hipiczna", distance: 827}
    ],
    15937: [
        {type: OfferPoiType.BUS, name: "PIMOT 02", distance: 307},
        {type: OfferPoiType.TRAM, name: "PIMOT 04", distance: 408},
        {type: OfferPoiType.BUS, name: "PIMOT 01", distance: 409},
        {type: OfferPoiType.TRAM, name: "PIMOT 03", distance: 417},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 02", distance: 610},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 54", distance: 613},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 53", distance: 654},
        {type: OfferPoiType.TRAM, name: "Golędzinów 02", distance: 806},
        {type: OfferPoiType.BUS, name: "Golędzinów 04", distance: 826},
        {type: OfferPoiType.TRAM, name: "Golędzinów 01", distance: 837},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 2435}
    ],
    15943: [
        {type: OfferPoiType.BUS, name: "Galeria jurajska", distance: 689},
        {type: OfferPoiType.BUS, name: "Mała", distance: 736},
        {type: OfferPoiType.PARK, name: "Park Piastów", distance: 1248},
        {type: OfferPoiType.PARK, name: "Promenada Olgi Aleksandry Sipowicz - Kory", distance: 1385},
        {type: OfferPoiType.PARK, name: "Plac Katyński", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer Solidarności", distance: 1778}
    ],
    15946: [
        {type: OfferPoiType.BUS, name: "Zachodnia 01", distance: 167},
        {type: OfferPoiType.BUS, name: "Zachodnia 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Torfowa 02", distance: 431},
        {type: OfferPoiType.BUS, name: "Torfowa 01", distance: 584},
        {type: OfferPoiType.BUS, name: "Kampus UJ 03", distance: 734},
        {type: OfferPoiType.BUS, name: "Rostworowskiego 01", distance: 794},
        {type: OfferPoiType.TRAM, name: "Kampus UJ 02", distance: 799},
        {type: OfferPoiType.TRAM, name: "Kampus UJ 01", distance: 807},
        {type: OfferPoiType.BUS, name: "Rostworowskiego 05", distance: 817},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1058},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 1968},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2066}
    ],
    15978: [
        {type: OfferPoiType.BUS, name: "Granata 01", distance: 255},
        {type: OfferPoiType.BUS, name: "Granata 02", distance: 263},
        {type: OfferPoiType.BUS, name: "Osmolicka NŻ 02", distance: 734},
        {type: OfferPoiType.BUS, name: "Elektromontaż 01", distance: 816}
    ],
    15982: [
        {type: OfferPoiType.TRAM, name: "Kochanowskiego", distance: 391},
        {type: OfferPoiType.BUS, name: "Kochanowskiego", distance: 402},
        {type: OfferPoiType.TRAM, name: "Chopina", distance: 507},
        {type: OfferPoiType.BUS, name: "Szymanowskiego", distance: 632},
        {type: OfferPoiType.BUS, name: "Witelona", distance: 677},
        {type: OfferPoiType.BUS, name: "Moniuszki", distance: 777},
        {type: OfferPoiType.BUS, name: "Śniadeckich", distance: 838},
        {type: OfferPoiType.TRAM, name: "Karłowicza", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1033}
    ],
    16011: [
        {type: OfferPoiType.BUS, name: "Kozacka 01", distance: 152},
        {type: OfferPoiType.BUS, name: "Lotników 02", distance: 257},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 02", distance: 288},
        {type: OfferPoiType.BUS, name: "Lotników 01", distance: 350},
        {type: OfferPoiType.BUS, name: "Kozacka 02", distance: 350},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 03", distance: 357},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 01", distance: 424},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 04", distance: 438},
        {type: OfferPoiType.BUS, name: "Wielki Rów 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Wielki Rów 02", distance: 652},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1814},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 2080}
    ],
    16021: [
        {type: OfferPoiType.BUS, name: "Radzionków Targowisko", distance: 251},
        {type: OfferPoiType.BUS, name: "Radzionków Plac Letochów", distance: 452},
        {type: OfferPoiType.BUS, name: "Radzionków Unii Europejskiej", distance: 533},
        {type: OfferPoiType.BUS, name: "Rojca Centrum Przesiadkowe", distance: 579},
        {type: OfferPoiType.KOLEJ, name: "Radzionków Rojca", distance: 591},
        {type: OfferPoiType.PARK, name: "Planty Radzionków", distance: 1705},
        {type: OfferPoiType.PARK, name: "Park Marka", distance: 2001},
        {type: OfferPoiType.PARK, name: "Park Grota", distance: 2055},
        {type: OfferPoiType.REZERWAT, name: "Księża Góra", distance: 2297},
        {type: OfferPoiType.REZERWAT, name: "Suchogórski Labirynt Skalny", distance: 2431}
    ],
    16039: [
        {type: OfferPoiType.BUS, name: "Legionów - Farbiarska", distance: 217},
        {type: OfferPoiType.BUS, name: "Legionów - działki", distance: 253},
        {type: OfferPoiType.BUS, name: "Farbiarska - Legionów", distance: 269},
        {type: OfferPoiType.BUS, name: "Farbiarska - działki", distance: 289},
        {type: OfferPoiType.LAS, name: "Park Bulwary", distance: 391},
        {type: OfferPoiType.PARK, name: "Park Bulwary", distance: 391},
        {type: OfferPoiType.BUS, name: "gen. Bema - gen. Hallera", distance: 478},
        {type: OfferPoiType.BUS, name: "gen. Bema - Fabryczna", distance: 509},
        {type: OfferPoiType.BUS, name: "gen. Hallera 2", distance: 566},
        {type: OfferPoiType.BUS, name: "Legionów - szkoła", distance: 610},
        {type: OfferPoiType.BUS, name: "gen. Hallera 23", distance: 724},
        {type: OfferPoiType.PARK, name: "Park im. Stefanii i Juliana Tuwimów", distance: 783},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 1172},
        {type: OfferPoiType.PARK, name: "Pałac Ostrowskich", distance: 1190},
        {type: OfferPoiType.LAS, name: "Park Solidarności", distance: 1332},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1332},
        {type: OfferPoiType.LAS, name: "Skwer Powstań Narodowych", distance: 1473},
        {type: OfferPoiType.LAS, name: "Park imienia doktora medycyny Jana Rodego", distance: 1495}
    ],
    16043: [
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 120},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 02 TARGOWISKO", distance: 123},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 01 TARGOWISKO", distance: 158},
        {type: OfferPoiType.BUS, name: "Dąbrówki 01", distance: 230},
        {type: OfferPoiType.BUS, name: "Dąbrówki", distance: 252},
        {type: OfferPoiType.BUS, name: "Łubieńskiego 02", distance: 336},
        {type: OfferPoiType.BUS, name: "Sobieskiego 02 PARK MIEJSKI", distance: 363},
        {type: OfferPoiType.BUS, name: "Sobieskiego 01 PARK MIEJSKI", distance: 393},
        {type: OfferPoiType.BUS, name: "Roosevelta 02 C.K. ESTEDE", distance: 436},
        {type: OfferPoiType.BUS, name: "Roosevelta 01 C.K. ESTEDE", distance: 450},
        {type: OfferPoiType.PARK, name: "Park Miejski im. gen. Władysława Andersa", distance: 623},
        {type: OfferPoiType.PARK, name: "Park im. Prezydenta Ryszarda Kaczorowskiego", distance: 957},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 957},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisława Wyspiańskiego", distance: 1490},
        {type: OfferPoiType.PARK, name: "Konopnickiej/Wrzesińska Park Rozrywki", distance: 1772}
    ],
    16045: [
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 218},
        {type: OfferPoiType.BUS, name: "Świtezianki - Nastrojowa", distance: 277},
        {type: OfferPoiType.BUS, name: "Świtezianki - Zgierska", distance: 335},
        {type: OfferPoiType.BUS, name: "Radogoszcz Wschód", distance: 372},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 485},
        {type: OfferPoiType.TRAM, name: "Zgierska - Świtezianki", distance: 533},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pasieczna", distance: 660},
        {type: OfferPoiType.BUS, name: "Świtezianki - Dw. Łódź Radogoszcz Wschód NŻ", distance: 706},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 1322},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 1439},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy na Żabieńcu”", distance: 2322},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Sokołówki i Brzozy”", distance: 2449},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 2501}
    ],
    16062: [
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 669},
        {type: OfferPoiType.BUS, name: "Osiedle Sarni Stok", distance: 694},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1789},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1979}
    ],
    16069: [
        {type: OfferPoiType.BUS, name: "Św. Wawrzyńca", distance: 256},
        {type: OfferPoiType.BUS, name: "Jeżycka", distance: 272},
        {type: OfferPoiType.BUS, name: "Kościelna Tunel", distance: 326},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 590},
        {type: OfferPoiType.BUS, name: "Nad Wierzbakiem", distance: 645},
        {type: OfferPoiType.TRAM, name: "Nad Wierzbakiem", distance: 725},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 1127},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1164},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1353},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1402},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1475},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1657},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1746},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 1829}
    ],
    16079: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Brzozowa", distance: 412},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Brzozowa", distance: 413},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Senatorska", distance: 425},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Senatorska", distance: 445},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 609},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Kilińskiego", distance: 632},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Kilińskiego", distance: 632},
        {type: OfferPoiType.BUS, name: "Zarzewska - Praska NŻ", distance: 633},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Przybyszewskiego", distance: 661},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przybyszewskiego", distance: 661},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 703},
        {type: OfferPoiType.BUS, name: "Zarzewska - Kilińskiego", distance: 751},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 798},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1003},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1117},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1203},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1248},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 1476}
    ],
    16101: [
        {type: OfferPoiType.BUS, name: "Maczka - Pienista NŻ", distance: 219},
        {type: OfferPoiType.BUS, name: "Pienista - Komandorska", distance: 416},
        {type: OfferPoiType.BUS, name: "Sortownia", distance: 767},
        {type: OfferPoiType.BUS, name: "Maczka - Aeroklub NŻ", distance: 781},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1298}
    ],
    16108: [
        {type: OfferPoiType.BUS, name: "Wiślinka Piaskowa", distance: 532},
        {type: OfferPoiType.BUS, name: "Wiślinka Most", distance: 797}
    ],
    16113: [
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 03", distance: 263},
        {type: OfferPoiType.BUS, name: "Kościelna 01", distance: 271},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 01", distance: 277},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 302},
        {type: OfferPoiType.BUS, name: "Fabryczna 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Nadarzyńska 02", distance: 449},
        {type: OfferPoiType.BUS, name: "Szkolna 01", distance: 508},
        {type: OfferPoiType.BUS, name: "Urząd Miasta 02", distance: 545},
        {type: OfferPoiType.BUS, name: "Nadarzyńska 01", distance: 555},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Kisielewskiego", distance: 682},
        {type: OfferPoiType.PARK, name: "Skwer Hrabianki Ludwiki Małgorzaty Moriconi", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Książąt Mazowieckich", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 800}
    ],
    16147: [
        {type: OfferPoiType.TRAM, name: "Głowackiego 02", distance: 793},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 02", distance: 812},
        {type: OfferPoiType.TRAM, name: "Głowackiego 01", distance: 844},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 921},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1011},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1049},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1137},
        {type: OfferPoiType.PARK, name: "Ogrody Łobzów", distance: 1138},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1548},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1555},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 1594},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1643}
    ],
    16160: [
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Południowa", distance: 218},
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Słoneczników", distance: 265},
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Nadarzyńska", distance: 668},
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Graniczna", distance: 682},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat im. Bolesława Hryniewieckiego", distance: 2140}
    ],
    16164: [
        {type: OfferPoiType.BUS, name: "Baczyna - Słoneczna", distance: 143},
        {type: OfferPoiType.BUS, name: "Lipiańska", distance: 255}
    ],
    16180: [
        {type: OfferPoiType.BUS, name: "Paderewskiego 06", distance: 308},
        {type: OfferPoiType.BUS, name: "Stefczyka NŻ 01", distance: 316},
        {type: OfferPoiType.BUS, name: "Stefczyka NŻ 02", distance: 337},
        {type: OfferPoiType.BUS, name: "Zajezdnia Stefczyka", distance: 397},
        {type: OfferPoiType.BUS, name: "Paderewskiego 05", distance: 474},
        {type: OfferPoiType.BUS, name: "Paderewskiego 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Paderewskiego 04", distance: 504},
        {type: OfferPoiType.BUS, name: "Paderewskiego 03", distance: 536},
        {type: OfferPoiType.BUS, name: "Paderewskiego 02", distance: 552},
        {type: OfferPoiType.BUS, name: "Pienińska NŻ 02", distance: 653}
    ],
    16184: [
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Jarzynowa", distance: 161},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Cm. Mania", distance: 315},
        {type: OfferPoiType.BUS, name: "Solec - Cm. Mania", distance: 319},
        {type: OfferPoiType.BUS, name: "Solec - Borowa NŻ", distance: 383},
        {type: OfferPoiType.BUS, name: "Borowa - Siewna NŻ", distance: 656},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Unii Lubelskiej", distance: 700},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Praussa", distance: 720},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 899},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1010},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1137},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1554},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 2022},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2229},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 2324},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 2380},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2401}
    ],
    16185: [
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 830},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1987},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 2140},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Sarni Stok"', distance: 2343}
    ],
    16201: [
        {type: OfferPoiType.BUS, name: "Leźnieńska 01", distance: 673},
        {type: OfferPoiType.LAS, name: "Aleja Smęgorzyńska", distance: 1129},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko Smęgorzyńskie", distance: 2446}
    ],
    16207: [
        {type: OfferPoiType.BUS, name: "Gąsocińska 02", distance: 310},
        {type: OfferPoiType.BUS, name: "Gąsocińska 01", distance: 422},
        {type: OfferPoiType.BUS, name: "Siekierkowska 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Siekierkowska 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 03", distance: 553},
        {type: OfferPoiType.BUS, name: "Ananasowa 52", distance: 639},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 02", distance: 699},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 711},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 715},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 2392}
    ],
    16212: [
        {type: OfferPoiType.BUS, name: "Dobrzykowice – cmentarz", distance: 274},
        {type: OfferPoiType.BUS, name: "Krzyków – Osiedle", distance: 754}
    ],
    16214: [
        {type: OfferPoiType.BUS, name: "Puck, Wejherowska", distance: 99},
        {type: OfferPoiType.BUS, name: "Puck, Paderewskiego", distance: 426},
        {type: OfferPoiType.BUS, name: "Puck, Asnyka / Dziedzictwa Jana Pawła II", distance: 491},
        {type: OfferPoiType.BUS, name: "Puck, Topolowa", distance: 564},
        {type: OfferPoiType.BUS, name: "Puck, Żeromskiego [NŻ]", distance: 580},
        {type: OfferPoiType.BUS, name: "Puck, Sychty", distance: 702},
        {type: OfferPoiType.REZERWAT, name: "Nadmorski Park Krajobrazowy", distance: 1223},
        {type: OfferPoiType.PARK, name: "Park Dziejów Pucka", distance: 1279},
        {type: OfferPoiType.PARK, name: "Park Kaszubski", distance: 1728},
        {type: OfferPoiType.PARK, name: "Park pałacowy", distance: 1964},
        {type: OfferPoiType.PARK, name: "Park im. Feliksa Nowowiejskiego", distance: 2174}
    ],
    16215: [
        {type: OfferPoiType.BUS, name: "Zakopiańska - Mini Golf", distance: 629},
        {type: OfferPoiType.LAS, name: "Smolak", distance: 732},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1171},
        {type: OfferPoiType.PARK, name: "Park Orkiestr Wojska Polskiego", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Górny", distance: 1434},
        {type: OfferPoiType.PARK, name: "Park uzdrowiskowy Czerniawa-Zdrój", distance: 2290}
    ],
    16218: [
        {type: OfferPoiType.TRAM, name: "Wesele 02", distance: 144},
        {type: OfferPoiType.TRAM, name: "Wesele 01", distance: 220},
        {type: OfferPoiType.BUS, name: "Wesele 03", distance: 234},
        {type: OfferPoiType.BUS, name: "Wesele 04", distance: 244},
        {type: OfferPoiType.TRAM, name: "Bronowice 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Bronowice 05", distance: 490},
        {type: OfferPoiType.TRAM, name: "Bronowice 03", distance: 546},
        {type: OfferPoiType.TRAM, name: "Bronowice", distance: 560},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 06", distance: 586},
        {type: OfferPoiType.TRAM, name: "Bronowice 01", distance: 596},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 03", distance: 607},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 620},
        {type: OfferPoiType.BUS, name: "Bronowice 04", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 698},
        {type: OfferPoiType.TRAM, name: "Bronowice SKA 01", distance: 703},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 07", distance: 715},
        {type: OfferPoiType.TRAM, name: "Bronowice SKA 02", distance: 738},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 04", distance: 764},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 05", distance: 778},
        {type: OfferPoiType.BUS, name: "Zarzecze 02", distance: 808},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1051},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1216},
        {type: OfferPoiType.PARK, name: "Ogrody Łobzów", distance: 1305},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1538},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1624},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 1727}
    ],
    16220: [
        {type: OfferPoiType.BUS, name: "Dźwirzyno - WSS", distance: 443},
        {type: OfferPoiType.BUS, name: "Dźwirzyno - Osiedle", distance: 612},
        {type: OfferPoiType.LAS, name: "Drużyna Chrobrego", distance: 661}
    ],
    16228: [
        {type: OfferPoiType.BUS, name: "Kasztanowa n/ż", distance: 160},
        {type: OfferPoiType.BUS, name: "Kalinowa n/ż", distance: 168},
        {type: OfferPoiType.BUS, name: "Cedrowa", distance: 173},
        {type: OfferPoiType.BUS, name: "Dębiec Tunel PKM n/ż", distance: 301},
        {type: OfferPoiType.PARK, name: "Lasek Dębiec", distance: 358},
        {type: OfferPoiType.BUS, name: "Łozowa", distance: 422},
        {type: OfferPoiType.BUS, name: "Dębiec PKM", distance: 545},
        {type: OfferPoiType.KOLEJ, name: "Poznań Dębiec", distance: 595},
        {type: OfferPoiType.TRAM, name: "Dębiec PKM", distance: 709},
        {type: OfferPoiType.PARK, name: "Park Bambrów Poznańskich", distance: 785},
        {type: OfferPoiType.REZERWAT, name: "Strefa ochrony bezpośredniej ujęcia wody Dębina", distance: 1383},
        {type: OfferPoiType.REZERWAT, name: "Dębina II", distance: 1505},
        {type: OfferPoiType.REZERWAT, name: "Strefa ochrony pośredniej ujęcia wody Dębina", distance: 2084},
        {type: OfferPoiType.REZERWAT, name: "Dębina I", distance: 2218}
    ],
    16233: [
        {type: OfferPoiType.BUS, name: "Solna", distance: 310},
        {type: OfferPoiType.TRAM, name: "Pl. Ratajskiego", distance: 324},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 393},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 455},
        {type: OfferPoiType.BUS, name: "Libelta", distance: 472},
        {type: OfferPoiType.BUS, name: "Plac Wielkopolski n/ż", distance: 481},
        {type: OfferPoiType.BUS, name: "Plac Wielkopolski nż", distance: 486},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 501},
        {type: OfferPoiType.TRAM, name: "Pl. Wielkopolski", distance: 536},
        {type: OfferPoiType.BUS, name: "Nowowiejskiego", distance: 547},
        {type: OfferPoiType.BUS, name: "Urząd Wojewódzki", distance: 552},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 553},
        {type: OfferPoiType.TRAM, name: "Gwarna", distance: 573},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 576},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 633},
        {type: OfferPoiType.TRAM, name: "Fredry", distance: 649},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 663},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 697},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 739},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 759},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 827},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 942},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 953},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 1025},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1082},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1456}
    ],
    16235: [
        {type: OfferPoiType.BUS, name: "Grobla", distance: 49},
        {type: OfferPoiType.BUS, name: "Wielka", distance: 208},
        {type: OfferPoiType.BUS, name: "Mostowa", distance: 321},
        {type: OfferPoiType.TRAM, name: "Pl. Bernardyński", distance: 321},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 330},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 387},
        {type: OfferPoiType.BUS, name: "Małe Garbary", distance: 389},
        {type: OfferPoiType.TRAM, name: "Małe Garbary", distance: 441},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 489},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 522},
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 642},
        {type: OfferPoiType.BUS, name: "Most Św. Rocha", distance: 648},
        {type: OfferPoiType.TRAM, name: "Most Św. Rocha", distance: 648},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 978},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1051},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 1068},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 1249},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1287},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 1349},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 1407},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1486},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1528}
    ],
    16237: [
        {type: OfferPoiType.BUS, name: "Waniliowa", distance: 461},
        {type: OfferPoiType.BUS, name: "Kaparowa", distance: 643},
        {type: OfferPoiType.BUS, name: "Tymiankowa", distance: 673},
        {type: OfferPoiType.BUS, name: "Cynamonowa", distance: 743},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 1961}
    ],
    16240: [
        {type: OfferPoiType.BUS, name: "Bohaterów M. Cassino 02", distance: 90},
        {type: OfferPoiType.BUS, name: "Bohaterów M. Cassino 01", distance: 205},
        {type: OfferPoiType.BUS, name: "Wojciechowska - zespół szkół 02", distance: 244},
        {type: OfferPoiType.BUS, name: "Bohaterów M. Cassino 03", distance: 246},
        {type: OfferPoiType.BUS, name: "Wojciechowska - zespół szkół 01", distance: 371},
        {type: OfferPoiType.BUS, name: "Polfa 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Poczekajka 03", distance: 425},
        {type: OfferPoiType.BUS, name: "Polfa 01", distance: 516},
        {type: OfferPoiType.BUS, name: "Poczekajka 01", distance: 552},
        {type: OfferPoiType.BUS, name: "Poczekajka 04", distance: 594}
    ],
    16249: [{type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 2489}],
    16251: [
        {type: OfferPoiType.BUS, name: "Świtezianki - Sikorskiego", distance: 441},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Nastrojowa", distance: 448},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Dw. Łódź Arturówek", distance: 470},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 523},
        {type: OfferPoiType.BUS, name: "Łagiewnicka - Dw. Łódź Arturówek", distance: 603},
        {type: OfferPoiType.BUS, name: "Pl. Słoneczny", distance: 755},
        {type: OfferPoiType.BUS, name: "Świtezianki - Syrenki", distance: 789},
        {type: OfferPoiType.KOLEJ, name: "Łódź Arturówek", distance: 801},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 944},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 1145},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1541},
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 1609},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 2009}
    ],
    16254: [
        {type: OfferPoiType.BUS, name: "Goraszewska 04", distance: 77},
        {type: OfferPoiType.BUS, name: "Goraszewska 01", distance: 118},
        {type: OfferPoiType.BUS, name: "Goraszewska 03", distance: 124},
        {type: OfferPoiType.BUS, name: "Goraszewska 02", distance: 179},
        {type: OfferPoiType.BUS, name: "Klarysewska 01", distance: 306},
        {type: OfferPoiType.BUS, name: "Klarysewska 02", distance: 319},
        {type: OfferPoiType.BUS, name: "Limanowskiego 01", distance: 379},
        {type: OfferPoiType.PARK, name: "Skwer Ormiański", distance: 477},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 555},
        {type: OfferPoiType.PARK, name: "Park Czesława Szczubełka", distance: 565},
        {type: OfferPoiType.BUS, name: "Limanowskiego 02", distance: 579},
        {type: OfferPoiType.BUS, name: "Sadyba 02", distance: 611},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 619},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 662},
        {type: OfferPoiType.BUS, name: "Sadyba 01", distance: 691},
        {type: OfferPoiType.TRAM, name: "Św. Bonifacego 06", distance: 824},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1055}
    ],
    16261: [
        {type: OfferPoiType.BUS, name: "Zimna", distance: 199},
        {type: OfferPoiType.BUS, name: "Ugory eMOCja", distance: 375},
        {type: OfferPoiType.BUS, name: "Stogi 02", distance: 460},
        {type: OfferPoiType.BUS, name: "Stogi 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Tamka 01", distance: 606},
        {type: OfferPoiType.BUS, name: "Rozłogi 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Stogi 06", distance: 635},
        {type: OfferPoiType.BUS, name: "Kłosowa 01", distance: 683},
        {type: OfferPoiType.PARK, name: "Skwer Bajki", distance: 2025}
    ],
    16286: [
        {type: OfferPoiType.BUS, name: "Proletariacka - Sowia NŻ", distance: 501},
        {type: OfferPoiType.BUS, name: "Rembielińskiego - Inżynierska NŻ", distance: 588},
        {type: OfferPoiType.BUS, name: "Radwańska - Inżynierska NŻ", distance: 680},
        {type: OfferPoiType.BUS, name: "Proletariacka - Wróblewskiego NŻ", distance: 841},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1038},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1280},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1925},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1934},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1961}
    ],
    16288: [
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Pętla", distance: 471},
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Granitowa", distance: 823},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 2031},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Dąbrowa", distance: 2512}
    ],
    16289: [
        {type: OfferPoiType.BUS, name: "Mechanik", distance: 286},
        {type: OfferPoiType.BUS, name: "Widok", distance: 291},
        {type: OfferPoiType.BUS, name: "Szkoła Podstawowa nr 6", distance: 589},
        {type: OfferPoiType.BUS, name: "Piękna", distance: 688},
        {type: OfferPoiType.KOLEJ, name: "Mińsk Mazowiecki", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 1386},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 1787},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1941},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1953},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 2109},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 2328}
    ],
    16292: [
        {type: OfferPoiType.BUS, name: "Traugutta 04", distance: 67},
        {type: OfferPoiType.BUS, name: "Uniwersyteckie Centrum Kliniczne 01", distance: 129},
        {type: OfferPoiType.BUS, name: "Traugutta 03", distance: 185},
        {type: OfferPoiType.BUS, name: "Uniwersyteckie Centrum Kliniczne 02", distance: 224},
        {type: OfferPoiType.TRAM, name: "Traugutta", distance: 239},
        {type: OfferPoiType.PARK, name: "Park im. Daniela Gralatha", distance: 258},
        {type: OfferPoiType.BUS, name: "Uniwersytet Medyczny 04", distance: 286},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 01", distance: 305},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 02", distance: 382},
        {type: OfferPoiType.BUS, name: "Centrum Onkologii 04", distance: 401},
        {type: OfferPoiType.TRAM, name: "Uniwersytet Medyczny 01", distance: 467},
        {type: OfferPoiType.PARK, name: "Park XXV-lecia Polski Rzeczypospolitej Ludowej", distance: 469},
        {type: OfferPoiType.BUS, name: "Uniwersytet Medyczny 03", distance: 490},
        {type: OfferPoiType.TRAM, name: "Uniwersytet Medyczny 02", distance: 498},
        {type: OfferPoiType.BUS, name: "Centrum Medycyny Inwazyjnej 01", distance: 643},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 700},
        {type: OfferPoiType.PARK, name: "Park im. Steffensów", distance: 710},
        {type: OfferPoiType.TRAM, name: "Opera Bałtycka", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Nostalgiczny", distance: 919},
        {type: OfferPoiType.PARK, name: "Park na Wroniej Górce", distance: 1331},
        {type: OfferPoiType.PARK, name: "Skwer Janiny Rokickiej", distance: 1385},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1747},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1909},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1986}
    ],
    16294: [
        {type: OfferPoiType.BUS, name: "Marszałkowska", distance: 756},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego n/ż", distance: 816},
        {type: OfferPoiType.BUS, name: "Świerzawska", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1678},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1804},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2205},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 2444}
    ],
    16304: [
        {type: OfferPoiType.BUS, name: "Sołtysowicka", distance: 390},
        {type: OfferPoiType.BUS, name: "Poprzeczna", distance: 636},
        {type: OfferPoiType.BUS, name: "Koszarowa", distance: 685},
        {type: OfferPoiType.PARK, name: "park Porucznika Roberta Marczewskiego", distance: 1257},
        {type: OfferPoiType.PARK, name: "Park Sołtysowicki", distance: 1767},
        {type: OfferPoiType.PARK, name: "skwer Władysława Bełzy", distance: 1968}
    ],
    16321: [
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 285},
        {type: OfferPoiType.BUS, name: "Bukowińska 01", distance: 323},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 330},
        {type: OfferPoiType.BUS, name: "Bukowińska 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Królikarnia 01", distance: 408},
        {type: OfferPoiType.BUS, name: "Bukowińska 05", distance: 417},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 435},
        {type: OfferPoiType.BUS, name: "Os. Domaniewska 02", distance: 447},
        {type: OfferPoiType.BUS, name: "Ksawerów 02", distance: 450},
        {type: OfferPoiType.TRAM, name: "Królikarnia 05", distance: 475},
        {type: OfferPoiType.BUS, name: "Ksawerów 01", distance: 478},
        {type: OfferPoiType.TRAM, name: "Królikarnia 03", distance: 509},
        {type: OfferPoiType.BUS, name: "Królikarnia 08", distance: 511},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 71", distance: 516},
        {type: OfferPoiType.TRAM, name: "Królikarnia 06", distance: 527},
        {type: OfferPoiType.BUS, name: "Os. Domaniewska 04", distance: 533},
        {type: OfferPoiType.BUS, name: "Wielicka 02", distance: 546},
        {type: OfferPoiType.TRAM, name: "Królikarnia 04", distance: 559},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 72", distance: 583},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 04", distance: 716},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 03", distance: 734},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 748},
        {type: OfferPoiType.METRO, name: "Wierzbno", distance: 798},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 841},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 861},
        {type: OfferPoiType.PARK, name: "Arkadia", distance: 870},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1243},
        {type: OfferPoiType.PARK, name: "Park Dreszera", distance: 1494},
        {type: OfferPoiType.PARK, name: "Skwer Małkowskich", distance: 1539},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1585}
    ],
    16324: [
        {type: OfferPoiType.BUS, name: "Sielec Kąpielisko", distance: 303},
        {type: OfferPoiType.TRAM, name: "Sielec Osiedle Zamkowa", distance: 382},
        {type: OfferPoiType.TRAM, name: "Sielec Kąpielisko", distance: 387},
        {type: OfferPoiType.TRAM, name: "Konstantynów Centrum Handlowe", distance: 512},
        {type: OfferPoiType.BUS, name: "Sielec Osiedle Zamkowa", distance: 525},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 752},
        {type: OfferPoiType.BUS, name: "Sielec Park", distance: 814},
        {type: OfferPoiType.TRAM, name: "Konstantynów Fabryczna", distance: 821},
        {type: OfferPoiType.TRAM, name: "Sielec Park", distance: 830},
        {type: OfferPoiType.PARK, name: "Bulwary nad rzeką Przemszą", distance: 974},
        {type: OfferPoiType.PARK, name: 'Skwer Danuty Siedzikówny "Inki"', distance: 1006},
        {type: OfferPoiType.PARK, name: "Park Dietla", distance: 1169},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jana Antoniego Strzeleckiego", distance: 1591},
        {type: OfferPoiType.PARK, name: "Plac im. Braci Kożuchów", distance: 1781}
    ],
    16325: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 215},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 238},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 441},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 558},
        {type: OfferPoiType.BUS, name: "Terespolska 01", distance: 580},
        {type: OfferPoiType.BUS, name: "Terespolska 04", distance: 580},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 594},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1183},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1188},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1288},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1592},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1780},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1973},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1987},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 2113}
    ],
    16328: [
        {type: OfferPoiType.BUS, name: "Połczyńska 02", distance: 221},
        {type: OfferPoiType.BUS, name: "Połczyńska 01", distance: 286},
        {type: OfferPoiType.BUS, name: "Potęgowska 02", distance: 315},
        {type: OfferPoiType.BUS, name: "Potęgowska 01", distance: 316},
        {type: OfferPoiType.BUS, name: "Szadółki 04", distance: 693},
        {type: OfferPoiType.BUS, name: "Szadółki 03", distance: 757},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 996},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1556}
    ],
    16339: [
        {type: OfferPoiType.BUS, name: "Pienista - Obywatelska", distance: 375},
        {type: OfferPoiType.BUS, name: "Waltera-Janke - Nowe Sady", distance: 376},
        {type: OfferPoiType.BUS, name: "Elektronowa - Obywatelska NŻ", distance: 434},
        {type: OfferPoiType.BUS, name: "Obywatelska - Elektronowa NŻ", distance: 444},
        {type: OfferPoiType.BUS, name: "Nowe Sady - Waltera-Janke NŻ", distance: 544},
        {type: OfferPoiType.BUS, name: "Pienista - Rusałki NŻ", distance: 631},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 1693},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 2242},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2337}
    ],
    16340: [
        {type: OfferPoiType.BUS, name: "Podchorążych - Łucznicza NŻ", distance: 100},
        {type: OfferPoiType.BUS, name: "Podchorążych - Molla NŻ", distance: 317},
        {type: OfferPoiType.BUS, name: "Złotno - Legnicka NŻ", distance: 535},
        {type: OfferPoiType.BUS, name: "Podchorążych - Napoleońska", distance: 726},
        {type: OfferPoiType.BUS, name: "Złotno - Zaporowa", distance: 827},
        {type: OfferPoiType.BUS, name: "Rąbieńska - Rąbieńska 76 NŻ", distance: 834},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 1345},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 1422},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1721},
        {type: OfferPoiType.PARK, name: "Park Grabieński Las", distance: 2107},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 2109},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 2141},
        {type: OfferPoiType.PARK, name: "Skwer pocmentarny", distance: 2175},
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 2184}
    ],
    16342: [
        {type: OfferPoiType.BUS, name: "Wysoka – osiedle", distance: 424},
        {type: OfferPoiType.BUS, name: "Wysoka Osiedle", distance: 543},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 2510}
    ],
    16347: [
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Stawowa", distance: 285},
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Błonia", distance: 664},
        {type: OfferPoiType.PARK, name: "Park Rybnik Paruszowiec przy Tężni", distance: 945}
    ],
    16348: [
        {type: OfferPoiType.TRAM, name: "Stalowa", distance: 437},
        {type: OfferPoiType.BUS, name: "Stalowa", distance: 439},
        {type: OfferPoiType.TRAM, name: "Plac Srebrny", distance: 742},
        {type: OfferPoiType.BUS, name: "Plac Srebrny", distance: 751},
        {type: OfferPoiType.BUS, name: "Grochowa", distance: 797},
        {type: OfferPoiType.TRAM, name: "Pereca", distance: 817},
        {type: OfferPoiType.BUS, name: "Pereca", distance: 828}
    ],
    16350: [
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 392},
        {type: OfferPoiType.BUS, name: "Dworzec Fordon", distance: 409},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 532},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Fordon", distance: 547},
        {type: OfferPoiType.BUS, name: "Brzechwy / Szelburg-Zarembiny", distance: 791},
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 1249},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1445},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 1451},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 2006}
    ],
    16352: [
        {type: OfferPoiType.BUS, name: "Gałczyńskiego", distance: 456},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego", distance: 611},
        {type: OfferPoiType.BUS, name: "Oboźna", distance: 835},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1437},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 2146}
    ],
    16356: [
        {type: OfferPoiType.TRAM, name: "Nocznickiego 01", distance: 327},
        {type: OfferPoiType.TRAM, name: "Nocznickiego 02", distance: 328},
        {type: OfferPoiType.BUS, name: "Popiela 05", distance: 558},
        {type: OfferPoiType.BUS, name: "Tołstoja 01", distance: 619},
        {type: OfferPoiType.BUS, name: "Popiela 06", distance: 649},
        {type: OfferPoiType.TRAM, name: "Popiela 04", distance: 653},
        {type: OfferPoiType.BUS, name: "Metro Młociny 04", distance: 656},
        {type: OfferPoiType.TRAM, name: "Popiela 03", distance: 672},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 05", distance: 673},
        {type: OfferPoiType.METRO, name: "Młociny", distance: 688},
        {type: OfferPoiType.BUS, name: "Popiela 02", distance: 692},
        {type: OfferPoiType.BUS, name: "Metro Młociny 01", distance: 694},
        {type: OfferPoiType.BUS, name: "Metro Młociny 25", distance: 701},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 06", distance: 706},
        {type: OfferPoiType.BUS, name: "Metro Młociny 19", distance: 713},
        {type: OfferPoiType.BUS, name: "Metro Młociny 23", distance: 718},
        {type: OfferPoiType.BUS, name: "Metro Młociny 21", distance: 720},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 08", distance: 743},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 28", distance: 809},
        {type: OfferPoiType.PARK, name: "Skwer 30. Pułku Strzelców Kaniowskich", distance: 1019},
        {type: OfferPoiType.PARK, name: "Eco Skwerek", distance: 1397},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 1993},
        {type: OfferPoiType.PARK, name: "Jordanek", distance: 2299}
    ],
    16359: [
        {type: OfferPoiType.BUS, name: "Modzelewskiego 03", distance: 217},
        {type: OfferPoiType.BUS, name: "Langego 02", distance: 298},
        {type: OfferPoiType.BUS, name: "Modzelewskiego 01", distance: 314},
        {type: OfferPoiType.BUS, name: "Modzelewskiego 02", distance: 316},
        {type: OfferPoiType.BUS, name: "Langego 01", distance: 343},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 04", distance: 607},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 02", distance: 615},
        {type: OfferPoiType.BUS, name: "Os. Domaniewska 04", distance: 637},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Domaniewska 05", distance: 716},
        {type: OfferPoiType.TRAM, name: "Telewizja Polska 04", distance: 766},
        {type: OfferPoiType.TRAM, name: "Samochodowa 04", distance: 769},
        {type: OfferPoiType.TRAM, name: "Samochodowa 03", distance: 793},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 799},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 03", distance: 807},
        {type: OfferPoiType.TRAM, name: "Telewizja Polska 03", distance: 824},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1231},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1735},
        {type: OfferPoiType.PARK, name: "Arkadia", distance: 1764},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2126},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2468}
    ],
    16361: [
        {type: OfferPoiType.BUS, name: "Reduta 01", distance: 135},
        {type: OfferPoiType.BUS, name: "Reduta 02", distance: 189},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 04", distance: 294},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R", distance: 353},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 01", distance: 385},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 02", distance: 440},
        {type: OfferPoiType.BUS, name: "Strzelców 02", distance: 714},
        {type: OfferPoiType.BUS, name: "Powstańców Garaże 02", distance: 723},
        {type: OfferPoiType.BUS, name: "Powstańców Garaże 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Cmentarz Prądnik Czerwony 01", distance: 825},
        {type: OfferPoiType.LAS, name: "Park Krakowian - Węgrzecka", distance: 978},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 1286},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 1738}
    ],
    16375: [
        {type: OfferPoiType.TRAM, name: "Winnica 04", distance: 446},
        {type: OfferPoiType.TRAM, name: "Winnica 03", distance: 456},
        {type: OfferPoiType.BUS, name: "Winnica 73", distance: 457},
        {type: OfferPoiType.BUS, name: "Winnica 02", distance: 461},
        {type: OfferPoiType.BUS, name: "Winnica 03", distance: 469},
        {type: OfferPoiType.BUS, name: "Winnica 06", distance: 487},
        {type: OfferPoiType.BUS, name: "Winnica 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Winnica 11", distance: 526},
        {type: OfferPoiType.TRAM, name: "Winnica 05", distance: 549},
        {type: OfferPoiType.BUS, name: "Winnica 13", distance: 612},
        {type: OfferPoiType.TRAM, name: "Winnica 72", distance: 618},
        {type: OfferPoiType.BUS, name: "Grzymalitów 02", distance: 636},
        {type: OfferPoiType.TRAM, name: "Winnica 71", distance: 643},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 05", distance: 708},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 713},
        {type: OfferPoiType.BUS, name: "Poetów 01", distance: 722},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 06", distance: 743},
        {type: OfferPoiType.BUS, name: "Grzymalitów 01", distance: 786},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 870},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1893},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 1939}
    ],
    16388: [
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 326},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 02", distance: 426},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 01", distance: 434},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 483},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 04", distance: 502},
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 547},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 609},
        {type: OfferPoiType.BUS, name: "Chełmska 01", distance: 652},
        {type: OfferPoiType.BUS, name: "Chełmska 05", distance: 799},
        {type: OfferPoiType.BUS, name: "Chełmska 03", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 1412},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1477},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1746},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1754},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1974},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 2065},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 2216},
        {type: OfferPoiType.PARK, name: "Skwer Ormiański", distance: 2225},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2302}
    ],
    16394: [
        {type: OfferPoiType.TRAM, name: "Śliwice 03", distance: 124},
        {type: OfferPoiType.TRAM, name: "Śliwice 04", distance: 216},
        {type: OfferPoiType.BUS, name: "Śliwice 01", distance: 217},
        {type: OfferPoiType.BUS, name: "Śliwice 02", distance: 282},
        {type: OfferPoiType.TRAM, name: "Budzińskiej-Tylickiej 03", distance: 543},
        {type: OfferPoiType.BUS, name: "Budzińskiej-Tylickiej 01", distance: 566},
        {type: OfferPoiType.TRAM, name: "Budzińskiej-Tylickiej 04", distance: 577},
        {type: OfferPoiType.BUS, name: "Budzińskiej-Tylickiej 02", distance: 594},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 02", distance: 637},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 01", distance: 673},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 53", distance: 681},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 54", distance: 684}
    ],
    16399: [
        {type: OfferPoiType.TRAM, name: "Oś Królewska 05", distance: 662},
        {type: OfferPoiType.BUS, name: "Oś Królewska 01", distance: 669},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 06", distance: 672},
        {type: OfferPoiType.BUS, name: "Oś Królewska 02", distance: 723},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1084},
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 1274},
        {type: OfferPoiType.PARK, name: "Park Rozkosz", distance: 1624},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1648},
        {type: OfferPoiType.PARK, name: "Ogród Tarasowy", distance: 1687}
    ],
    16403: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 102},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 105},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 120},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 250},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 343},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 487},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Żupnicza 01", distance: 570},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 581},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 978},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1231},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1369},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1526},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1586},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1903},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2045},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2068},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2074}
    ],
    16407: [
        {type: OfferPoiType.BUS, name: "Poświęcka", distance: 420},
        {type: OfferPoiType.BUS, name: "Poświęcka (Ośrodek zdrowia)", distance: 584},
        {type: OfferPoiType.BUS, name: "Żmigrodzka (Obwodnica)", distance: 640},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 790},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1849}
    ],
    16409: [
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 108},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 131},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 145},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 232},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 262},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 275},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 281},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 330},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 331},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 374},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 603},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 638},
        {type: OfferPoiType.TRAM, name: "Hubego 03", distance: 724},
        {type: OfferPoiType.BUS, name: "Hubego 02", distance: 749},
        {type: OfferPoiType.BUS, name: "Katarzynka PKP nż. 01", distance: 756},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 757},
        {type: OfferPoiType.TRAM, name: "Hubego 04", distance: 781},
        {type: OfferPoiType.BUS, name: "Hubego 01", distance: 790},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1609},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1907}
    ],
    16411: [
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Woskowa NŻ", distance: 226},
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Wypoczynkowa NŻ", distance: 246},
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Warszawska", distance: 617},
        {type: OfferPoiType.LAS, name: "Park Stefana Rogowicza - Zielona Ostoja", distance: 656},
        {type: OfferPoiType.BUS, name: "Warszawska - Wycieczkowa", distance: 687},
        {type: OfferPoiType.BUS, name: "Marysin Warszawska", distance: 729},
        {type: OfferPoiType.BUS, name: "Marysin Tęczowa", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1837},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 2384}
    ],
    16421: [
        {type: OfferPoiType.TRAM, name: "Żwirki - Piotrkowska", distance: 253},
        {type: OfferPoiType.BUS, name: "Kościuszki - Radwańska", distance: 300},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Żwirki", distance: 323},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Żwirki", distance: 323},
        {type: OfferPoiType.BUS, name: "Radwańska - Wólczańska", distance: 404},
        {type: OfferPoiType.BUS, name: "Kościuszki - Mickiewicza", distance: 427},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Mickiewicza", distance: 483},
        {type: OfferPoiType.BUS, name: "Mickiewicza - Kościuszki", distance: 496},
        {type: OfferPoiType.BUS, name: "Wólczańska - Radwańska", distance: 508},
        {type: OfferPoiType.TRAM, name: "Piotrkowska Centrum", distance: 558},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Brzeźna", distance: 586},
        {type: OfferPoiType.PARK, name: "Skwer im. Lecha Kunki", distance: 892},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1012},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1045}
    ],
    16423: [
        {type: OfferPoiType.TRAM, name: "Oś Królewska 05", distance: 642},
        {type: OfferPoiType.BUS, name: "Oś Królewska 01", distance: 649},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 06", distance: 652},
        {type: OfferPoiType.BUS, name: "Oś Królewska 02", distance: 703},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1064},
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 1254},
        {type: OfferPoiType.PARK, name: "Park Rozkosz", distance: 1604},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1628},
        {type: OfferPoiType.PARK, name: "Ogród Tarasowy", distance: 1667}
    ],
    16435: [
        {type: OfferPoiType.BUS, name: "Piaski Nowe 03", distance: 522},
        {type: OfferPoiType.BUS, name: "Piaski Nowe", distance: 530},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 02", distance: 536},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 01", distance: 544},
        {type: OfferPoiType.BUS, name: "Bochenka 02", distance: 585},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 595},
        {type: OfferPoiType.BUS, name: "Bochenka 01", distance: 599},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 802},
        {type: OfferPoiType.BUS, name: "Nowosądecka 05", distance: 814},
        {type: OfferPoiType.BUS, name: "Łużycka 02", distance: 816},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1098},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 1473},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1794},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1814},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 2175}
    ],
    16445: [
        {type: OfferPoiType.BUS, name: "Tamka - Styrska NŻ", distance: 652},
        {type: OfferPoiType.TRAM, name: "Pomorska - Lumumby (kampus UŁ)", distance: 734},
        {type: OfferPoiType.BUS, name: "Pomorska - Konstytucyjna", distance: 768},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1531},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 1531},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1604},
        {type: OfferPoiType.PARK, name: "Park im. 3 Maja", distance: 1939},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1960},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 2052},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 2177},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 2356},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 2416}
    ],
    16447: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 389},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 425},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 457},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 519},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 525},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 642},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Ojca Aniceta 01", distance: 739},
        {type: OfferPoiType.BUS, name: "Danusi 01", distance: 778},
        {type: OfferPoiType.BUS, name: "Gryfitów 02", distance: 802},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1459},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2121},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2518}
    ],
    16449: [
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 01", distance: 543},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 02", distance: 561},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 04", distance: 569},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 03", distance: 595},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 05", distance: 596},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 04", distance: 623},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 01", distance: 658},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 03", distance: 700},
        {type: OfferPoiType.TRAM, name: "Lipińskiego 01", distance: 833},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 1469},
        {type: OfferPoiType.PARK, name: "Park Zakrzówek", distance: 1527},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1579},
        {type: OfferPoiType.PARK, name: "Park rzeczny Wilgi", distance: 1787},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 1951},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 1994}
    ],
    16454: [
        {type: OfferPoiType.BUS, name: "Bolszewo Graniczna 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Bolszewo Leśna - Szkoła 02", distance: 542},
        {type: OfferPoiType.BUS, name: "Bolszewo Leśna - Szkoła 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Bolszewo Graniczna 02", distance: 550},
        {type: OfferPoiType.BUS, name: "Bolszewo Harcerska 02 n/ż", distance: 673},
        {type: OfferPoiType.BUS, name: "Bolszewo Harcerska 01 n/ż", distance: 726},
        {type: OfferPoiType.PARK, name: "ArtPark w Bolszewie", distance: 1120}
    ],
    16455: [
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 700},
        {type: OfferPoiType.BUS, name: "3 Maja 02", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 1018},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1031},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1062}
    ],
    16459: [
        {type: OfferPoiType.BUS, name: "Dziwnów - Wybreże Kościuszkowskie - Słoneczna", distance: 599},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1968}
    ],
    16460: [{type: OfferPoiType.BUS, name: "Kościelisko Chotarz Polany", distance: 596}],
    16465: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 201},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 274},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 331},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 422},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 427},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 453},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 637},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 795},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 870},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 914}
    ],
    16467: [
        {type: OfferPoiType.BUS, name: "Dziedzicka", distance: 308},
        {type: OfferPoiType.BUS, name: "Żeglarska n/ż", distance: 459},
        {type: OfferPoiType.BUS, name: "Kotwicza n/ż", distance: 516},
        {type: OfferPoiType.BUS, name: "Starołęcka Wiadukt n/ż", distance: 662}
    ],
    16469: [
        {type: OfferPoiType.BUS, name: "Conrada 01", distance: 221},
        {type: OfferPoiType.BUS, name: "Conrada 02", distance: 388},
        {type: OfferPoiType.BUS, name: "Chełmońskiego 02", distance: 509},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 520},
        {type: OfferPoiType.BUS, name: "Różyckiego 04", distance: 640},
        {type: OfferPoiType.BUS, name: "Azory", distance: 683},
        {type: OfferPoiType.BUS, name: "Różyckiego 02", distance: 694},
        {type: OfferPoiType.BUS, name: "Fiszera 02", distance: 705},
        {type: OfferPoiType.BUS, name: "Azory 01", distance: 728},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1216},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1441},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1919},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1978},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 2156},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 2312}
    ],
    16470: [{type: OfferPoiType.PARK, name: "Plac Konstytucji 3 Maja", distance: 495}],
    16471: [
        {type: OfferPoiType.BUS, name: "Budziwojska / Herbowa 02", distance: 110},
        {type: OfferPoiType.BUS, name: "Tyczyn Orkana stawy 14", distance: 140},
        {type: OfferPoiType.BUS, name: "Tyczyn Orkana skrzyżowanie 16", distance: 462},
        {type: OfferPoiType.BUS, name: "Tyczyn Orkana skrzyżowanie 13", distance: 535},
        {type: OfferPoiType.BUS, name: "Budziwojska / Legionistów 04", distance: 633},
        {type: OfferPoiType.BUS, name: "Tyczyn Grunwaldzka park 02", distance: 751},
        {type: OfferPoiType.BUS, name: "Budziwojska / Legionistów 01", distance: 764},
        {type: OfferPoiType.BUS, name: "Tyczyn Grunwaldzka park 01", distance: 830},
        {type: OfferPoiType.BUS, name: "Tyczyn Armii Krajowej skrzyżowanie 25", distance: 841}
    ],
    16478: [
        {type: OfferPoiType.PARK, name: "Skwer leśny przy Odrzańskiej", distance: 122},
        {type: OfferPoiType.BUS, name: "Starogardzka - Odrzańska", distance: 379},
        {type: OfferPoiType.BUS, name: "Dubois - Hoffmanowej NŻ", distance: 526},
        {type: OfferPoiType.BUS, name: "Pabianicka - Rudzka", distance: 658},
        {type: OfferPoiType.BUS, name: "Rudzka - Pabianicka", distance: 733},
        {type: OfferPoiType.TRAM, name: "Pabianicka - Rudzka", distance: 747},
        {type: OfferPoiType.BUS, name: "Rudzka - Pabianicka NŻ", distance: 757},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy nad Nerem”", distance: 1876},
        {type: OfferPoiType.PARK, name: "Rudzka Góra", distance: 1965}
    ],
    16479: [
        {type: OfferPoiType.BUS, name: "Owińska/Parkowa", distance: 535},
        {type: OfferPoiType.BUS, name: "Owińska/Pałac", distance: 684},
        {type: OfferPoiType.PARK, name: "Park Orientacji Przestrzennej", distance: 895}
    ],
    16480: [
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 214},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 446},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 450},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 490},
        {type: OfferPoiType.BUS, name: "Niezłomnych", distance: 500},
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 514},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 524},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 590},
        {type: OfferPoiType.TRAM, name: "Aleje Marcinkowskiego", distance: 603},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 637},
        {type: OfferPoiType.BUS, name: "Uniwersytet Ekonomiczny", distance: 652},
        {type: OfferPoiType.TRAM, name: "Wierzbięcice", distance: 672},
        {type: OfferPoiType.BUS, name: "Poznań Główny", distance: 679},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 685},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 754},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 791},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 946},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 988},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1004},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1181},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1303},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1447}
    ],
    16482: [
        {type: OfferPoiType.BUS, name: "Termy Maltańskie", distance: 50},
        {type: OfferPoiType.KOLEJ, name: "Balbinka", distance: 152},
        {type: OfferPoiType.KOLEJ, name: "Ptyś", distance: 212},
        {type: OfferPoiType.BUS, name: "Czekalskie n/ż", distance: 559},
        {type: OfferPoiType.BUS, name: "Termalna n/ż", distance: 693},
        {type: OfferPoiType.TRAM, name: "Termalna", distance: 700},
        {type: OfferPoiType.TRAM, name: "Krańcowa", distance: 747},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 887},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 1887}
    ],
    16484: [
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej (szkoła)", distance: 128},
        {type: OfferPoiType.BUS, name: "Skwer Krasińskiego", distance: 191},
        {type: OfferPoiType.TRAM, name: "Komuny Paryskiej", distance: 220},
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej", distance: 238},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 377},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 424},
        {type: OfferPoiType.BUS, name: "Kościuszki", distance: 433},
        {type: OfferPoiType.BUS, name: "Plac Wróblewskiego", distance: 484},
        {type: OfferPoiType.BUS, name: "Bastion Sakwowy", distance: 505},
        {type: OfferPoiType.TRAM, name: "Plac Wróblewskiego", distance: 569},
        {type: OfferPoiType.TRAM, name: "Bastion Sakwowy", distance: 586},
        {type: OfferPoiType.TRAM, name: "Park Staromiejski", distance: 706},
        {type: OfferPoiType.TRAM, name: "Pułaskiego", distance: 710},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 864},
        {type: OfferPoiType.PARK, name: "Ogród Staromiejski", distance: 911},
        {type: OfferPoiType.PARK, name: "Park Juliusza Słowackiego", distance: 1128},
        {type: OfferPoiType.PARK, name: "skwer Wrocławianek", distance: 1155},
        {type: OfferPoiType.PARK, name: "skwer Czesława Niemena", distance: 1205},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1241},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1271}
    ],
    16485: [
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 235},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 287},
        {type: OfferPoiType.BUS, name: "Bokserska 01", distance: 439},
        {type: OfferPoiType.BUS, name: "Bokserska 05", distance: 468},
        {type: OfferPoiType.BUS, name: "Bokserska 04", distance: 532},
        {type: OfferPoiType.BUS, name: "Bokserska 03", distance: 563},
        {type: OfferPoiType.BUS, name: "Bokserska 02", distance: 588},
        {type: OfferPoiType.BUS, name: "Bokserska 71", distance: 604},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 670},
        {type: OfferPoiType.BUS, name: "Centrum Targowe 02", distance: 778},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1176},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 1834},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 2370}
    ],
    16487: [
        {type: OfferPoiType.BUS, name: "Ogród działkowy Im. Warneńczyka 02", distance: 55},
        {type: OfferPoiType.BUS, name: "Ogród działkowy Im. Warneńczyka 01", distance: 111},
        {type: OfferPoiType.BUS, name: "Okęcie Business Park 02", distance: 308},
        {type: OfferPoiType.BUS, name: "Krakowiaków 06", distance: 394},
        {type: OfferPoiType.BUS, name: "Okęcie Business Park 01", distance: 442},
        {type: OfferPoiType.BUS, name: "Krakowiaków 05", distance: 444},
        {type: OfferPoiType.BUS, name: "Radarowa 01", distance: 457},
        {type: OfferPoiType.TRAM, name: "Krakowiaków 04", distance: 478},
        {type: OfferPoiType.TRAM, name: "Krakowiaków 03", distance: 498},
        {type: OfferPoiType.BUS, name: "Radarowa 02", distance: 503},
        {type: OfferPoiType.TRAM, name: "Lipowczana 01", distance: 796},
        {type: OfferPoiType.TRAM, name: "Lipowczana 02", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 1647}
    ],
    16498: [
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 48},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 213},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 357},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 469},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 524},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1840}
    ],
    16500: [
        {type: OfferPoiType.BUS, name: "Dojazdowa", distance: 304},
        {type: OfferPoiType.BUS, name: "Zagórskiego", distance: 523},
        {type: OfferPoiType.BUS, name: "Kolonistów", distance: 660},
        {type: OfferPoiType.BUS, name: "Szosa Polska", distance: 779},
        {type: OfferPoiType.BUS, name: "Zagórskiego 10 nż", distance: 810},
        {type: OfferPoiType.REZERWAT, name: "Dolina strumienia Grzęziniec", distance: 2178},
        {type: OfferPoiType.PARK, name: "Park ks. Dąbrówki", distance: 2465}
    ],
    16503: [
        {type: OfferPoiType.BUS, name: "Prystora 01", distance: 239},
        {type: OfferPoiType.BUS, name: "Prystora 02", distance: 247},
        {type: OfferPoiType.BUS, name: "Prystora 03", distance: 258},
        {type: OfferPoiType.BUS, name: "Żywiecka 03", distance: 298},
        {type: OfferPoiType.BUS, name: "Żywiecka 02", distance: 341},
        {type: OfferPoiType.BUS, name: "Żywiecka 01", distance: 365},
        {type: OfferPoiType.BUS, name: "Żywiecka 04", distance: 386},
        {type: OfferPoiType.BUS, name: "Dzieci Warszawy 02", distance: 521},
        {type: OfferPoiType.BUS, name: "Salomea 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Składkowskiego 04", distance: 616},
        {type: OfferPoiType.KOLEJ, name: "Opacz", distance: 820},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 1453},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1541},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 2078},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 2152},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 2326},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2413}
    ],
    16504: [
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 585},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 939},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1434},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 2254},
        {type: OfferPoiType.PARK, name: "Górki Służewskie", distance: 2360},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 2380},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2385}
    ],
    16514: [
        {type: OfferPoiType.BUS, name: "Pogorzelica Wojska Polskiego", distance: 355},
        {type: OfferPoiType.LAS, name: "Enea", distance: 633},
        {type: OfferPoiType.REZERWAT, name: "Liwskie Ujście", distance: 1448}
    ],
    16518: [
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 02", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 962},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 1118},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1131}
    ],
    16520: [
        {type: OfferPoiType.BUS, name: "Piastowska 01", distance: 323},
        {type: OfferPoiType.BUS, name: "Piastowska 03", distance: 341},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Owcy-Orwicza 02", distance: 541},
        {type: OfferPoiType.BUS, name: "Piastowska 02", distance: 563},
        {type: OfferPoiType.BUS, name: "Tondosa 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 03", distance: 667},
        {type: OfferPoiType.TRAM, name: "Cichy Kącik 01", distance: 679},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 75", distance: 684},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 72", distance: 687},
        {type: OfferPoiType.BUS, name: "Tondosa 02", distance: 695},
        {type: OfferPoiType.PARK, name: "Skwer Papcia Chmiela", distance: 925},
        {type: OfferPoiType.PARK, name: "Park Fort 2 „Kościuszko” imienia Profesora Janusza Bogdanowskiego", distance: 1041},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1274},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1642},
        {type: OfferPoiType.PARK, name: "Skwer Olgi Jackowskiej „Kory”", distance: 1688},
        {type: OfferPoiType.PARK, name: "Skwer imienia Gustawa Holoubka", distance: 1758},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2512}
    ],
    16528: [
        {type: OfferPoiType.BUS, name: "Zakopiańska", distance: 228},
        {type: OfferPoiType.TRAM, name: "Skrajna", distance: 283},
        {type: OfferPoiType.TRAM, name: "Zakopiańska", distance: 307},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 371},
        {type: OfferPoiType.BUS, name: "Siedlce 06", distance: 674},
        {type: OfferPoiType.BUS, name: "Nad Jarem 01", distance: 676},
        {type: OfferPoiType.BUS, name: "Siedlce 05", distance: 699},
        {type: OfferPoiType.TRAM, name: "Siedlce 03", distance: 702},
        {type: OfferPoiType.TRAM, name: "Siedlce 01", distance: 702},
        {type: OfferPoiType.BUS, name: "Siedlce 04", distance: 709},
        {type: OfferPoiType.TRAM, name: "Siedlce 02", distance: 719},
        {type: OfferPoiType.TRAM, name: "Ciasna", distance: 727},
        {type: OfferPoiType.PARK, name: "Skwer im. Ignacego Wilczewskiego", distance: 1181},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Bema", distance: 1285},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1598},
        {type: OfferPoiType.PARK, name: "Kalwaria", distance: 1756},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1820},
        {type: OfferPoiType.PARK, name: "Park poforteczny „Grodzisko”", distance: 1995},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2299},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2402}
    ],
    16535: [
        {type: OfferPoiType.BUS, name: "Snopków - osiedle 02", distance: 464},
        {type: OfferPoiType.BUS, name: "Snopków II 01", distance: 849}
    ],
    16538: [
        {type: OfferPoiType.BUS, name: "Swarzędz Skansen", distance: 548},
        {type: OfferPoiType.BUS, name: "Swarzędz Węzeł Przesiadkowy", distance: 581},
        {type: OfferPoiType.BUS, name: "Swarzędz Dworzec PKP", distance: 733},
        {type: OfferPoiType.KOLEJ, name: "Swarzędz", distance: 829},
        {type: OfferPoiType.REZERWAT, name: "Dolina Cybiny w Poznaniu", distance: 2035}
    ],
    16539: [
        {type: OfferPoiType.BUS, name: "Kościelna Droga 01", distance: 163},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 02", distance: 305},
        {type: OfferPoiType.BUS, name: "Łużycka  02", distance: 473},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 507},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 01", distance: 653},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 02", distance: 763},
        {type: OfferPoiType.BUS, name: "Brzegowa 01", distance: 787}
    ],
    16540: [
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 02", distance: 284},
        {type: OfferPoiType.BUS, name: "Kosodrzewiny 01", distance: 294},
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 01", distance: 325},
        {type: OfferPoiType.BUS, name: "Falenica 02", distance: 464},
        {type: OfferPoiType.BUS, name: "Falenica 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Falenica 03", distance: 540},
        {type: OfferPoiType.BUS, name: "Falenica 04", distance: 550},
        {type: OfferPoiType.BUS, name: "Jachowicza 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Liliowa 02", distance: 732},
        {type: OfferPoiType.BUS, name: "Liliowa 04", distance: 792},
        {type: OfferPoiType.PARK, name: "Polanka", distance: 2032}
    ],
    16546: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 197},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 337},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 416},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 444},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 477},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 484},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 496},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 585},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 797},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 971}
    ],
    16548: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 106},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 139},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 432},
        {type: OfferPoiType.TRAM, name: "Serbska", distance: 492},
        {type: OfferPoiType.BUS, name: "Wilczy Młyn", distance: 555},
        {type: OfferPoiType.BUS, name: "Lechicka/Naramowicka", distance: 557},
        {type: OfferPoiType.TRAM, name: "Lechicka/Naramowicka", distance: 581},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 921},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1050},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1358},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1809},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1921},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 2200},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2233},
        {type: OfferPoiType.PARK, name: "Park Cytadela", distance: 2327}
    ],
    16549: [
        {type: OfferPoiType.BUS, name: "Dziwnów Wybrzeże Kościuszkowskie", distance: 407},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 543},
        {type: OfferPoiType.BUS, name: "Dzwinów - Słowackiego (Camping)", distance: 786}
    ],
    16553: [
        {type: OfferPoiType.BUS, name: "Krzeptów - Boisko", distance: 443},
        {type: OfferPoiType.BUS, name: "Krzeptów - pętla", distance: 470},
        {type: OfferPoiType.BUS, name: "Krzeptów - skrzy.", distance: 828}
    ],
    16558: [
        {type: OfferPoiType.BUS, name: "Gdańska - Zielona", distance: 216},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 222},
        {type: OfferPoiType.BUS, name: "Zielona - Gdańska", distance: 274},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 346},
        {type: OfferPoiType.BUS, name: "Gdańska - Struga", distance: 381},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 382},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 397},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 413},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 433},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 447},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 460},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 500},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 558},
        {type: OfferPoiType.TRAM, name: "Gdańska - 1 Maja", distance: 591},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 605},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 709},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 718},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 793},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 913}
    ],
    16562: [
        {type: OfferPoiType.BUS, name: "Ziębicka n/ż", distance: 139},
        {type: OfferPoiType.BUS, name: "Ziębicka Kościół n/ż", distance: 160},
        {type: OfferPoiType.BUS, name: "Wieruszowska n/ż", distance: 497},
        {type: OfferPoiType.BUS, name: "Grotkowska", distance: 526},
        {type: OfferPoiType.BUS, name: "Cmentarna", distance: 572},
        {type: OfferPoiType.TRAM, name: "Grotkowska", distance: 586},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 709},
        {type: OfferPoiType.TRAM, name: "Cmentarna", distance: 709},
        {type: OfferPoiType.BUS, name: "Cmentarna n/ż", distance: 726},
        {type: OfferPoiType.BUS, name: "Budziszyńska", distance: 828},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 1864},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 2068}
    ],
    16564: [
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 128},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 168},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 275},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 331},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 552},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 565},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 644},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 671},
        {type: OfferPoiType.BUS, name: "Powstańców Magazyny 01", distance: 766},
        {type: OfferPoiType.BUS, name: "Powstańców Magazyny 02", distance: 841},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1472},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1473}
    ],
    16568: [
        {type: OfferPoiType.BUS, name: "Jurowiecka/Ciepła", distance: 130},
        {type: OfferPoiType.BUS, name: "Jurowiecka/Sienkiewicza", distance: 158},
        {type: OfferPoiType.PARK, name: "Skwery Tamary Sołoniewicz", distance: 197},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego/Rzeka Biała", distance: 302},
        {type: OfferPoiType.BUS, name: "Sienkiewicza/Rzeka Biała", distance: 305},
        {type: OfferPoiType.BUS, name: "Sienkiewicza/Ogrodowa", distance: 377},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Stanisława Hałko", distance: 399},
        {type: OfferPoiType.BUS, name: "Jurowiecka/Sklep Łowiecki", distance: 459},
        {type: OfferPoiType.PARK, name: "Bulwary Ireny Sendlerowej", distance: 553},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Aleksandra Chodyki", distance: 597},
        {type: OfferPoiType.PARK, name: "Skwer Armii Krajowej", distance: 703},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 983},
        {type: OfferPoiType.PARK, name: "Park Stary im. Księcia Józefa Poniatowskiego", distance: 1027},
        {type: OfferPoiType.PARK, name: "Plac Błogosławionego Księdza Michała Sopoćki", distance: 1128},
        {type: OfferPoiType.PARK, name: "Plac Mordechaja Tenenbauma", distance: 1174}
    ],
    16569: [
        {type: OfferPoiType.BUS, name: "Wianki 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Wianki 01", distance: 218},
        {type: OfferPoiType.PARK, name: "Park Na Skarpie", distance: 470},
        {type: OfferPoiType.BUS, name: "Turystyczna nż. 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Turystyczna nż. 01", distance: 581},
        {type: OfferPoiType.TRAM, name: "Ślaskiego 01", distance: 716},
        {type: OfferPoiType.BUS, name: "Ślaskiego 04", distance: 719},
        {type: OfferPoiType.TRAM, name: "Ślaskiego 03", distance: 742},
        {type: OfferPoiType.BUS, name: "Ślaskiego 02", distance: 755},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego 01", distance: 815},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego 02", distance: 826},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 03", distance: 829},
        {type: OfferPoiType.BUS, name: "Wieżowa nż. 02", distance: 840},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 1719},
        {type: OfferPoiType.PARK, name: "Park na Bielawach", distance: 2080},
        {type: OfferPoiType.REZERWAT, name: "Dąbrowa w Kaszczorku", distance: 2104}
    ],
    16575: [
        {type: OfferPoiType.BUS, name: "Budapesztańska", distance: 210},
        {type: OfferPoiType.TRAM, name: "Budapesztańska", distance: 265},
        {type: OfferPoiType.BUS, name: "Migowo", distance: 540},
        {type: OfferPoiType.BUS, name: "Kolumba 04", distance: 569},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 569},
        {type: OfferPoiType.TRAM, name: "Warneńska 02", distance: 575},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Warneńska 04", distance: 606},
        {type: OfferPoiType.BUS, name: "Kolumba 03", distance: 610},
        {type: OfferPoiType.TRAM, name: "Migowo", distance: 621},
        {type: OfferPoiType.TRAM, name: "Warneńska 01", distance: 622},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 664},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 669},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 902},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 1045},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1067},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1399},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 1838},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 2300}
    ],
    16577: [
        {type: OfferPoiType.BUS, name: "Rechniewskiego 01", distance: 239},
        {type: OfferPoiType.BUS, name: "Rechniewskiego 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ostrobramska 03", distance: 641},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ostrobramska 02", distance: 693},
        {type: OfferPoiType.PARK, name: "Park/Ogród przy Kościele", distance: 709},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1723},
        {type: OfferPoiType.PARK, name: "Park Nad Balatonem", distance: 1739},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1760},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 1896},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 2028},
        {type: OfferPoiType.PARK, name: "Ogród na Meissnera", distance: 2156},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 2330}
    ],
    16585: [
        {type: OfferPoiType.BUS, name: "Północna - Kamińskiego", distance: 173},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 386},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 481},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 510},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 616},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 622},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 638},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 660},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 688},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 763},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 786},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1096},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1149},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1290},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 1319}
    ],
    16592: [
        {type: OfferPoiType.BUS, name: 'Polna "Krystynka"', distance: 336},
        {type: OfferPoiType.BUS, name: "Osiedle Związkowców", distance: 383},
        {type: OfferPoiType.BUS, name: "Ciechocinek Zdrojowa/Łąkowa", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Sosnowy", distance: 999},
        {type: OfferPoiType.PARK, name: "Partery Hellwiga", distance: 1132},
        {type: OfferPoiType.REZERWAT, name: "Otoczenie źródła solanki nr 11", distance: 1473}
    ],
    16596: [
        {type: OfferPoiType.BUS, name: "Maczka - Pienista NŻ", distance: 202},
        {type: OfferPoiType.BUS, name: "Pienista - Komandorska", distance: 315},
        {type: OfferPoiType.BUS, name: "Maczka - Aeroklub NŻ", distance: 713},
        {type: OfferPoiType.BUS, name: "Pienista - Rusałki NŻ", distance: 836},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1697}
    ],
    16605: [
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 01", distance: 127},
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 02", distance: 187},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 01", distance: 205},
        {type: OfferPoiType.BUS, name: "Startowa 03", distance: 274},
        {type: OfferPoiType.TRAM, name: "Startowa 01", distance: 369},
        {type: OfferPoiType.BUS, name: "Dywizjonu 303 01", distance: 374},
        {type: OfferPoiType.TRAM, name: "Startowa 02", distance: 416},
        {type: OfferPoiType.BUS, name: "Pilotów 01", distance: 472},
        {type: OfferPoiType.BUS, name: "Startowa 04", distance: 484},
        {type: OfferPoiType.BUS, name: "Żwirki i Wigury 03", distance: 503},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 01", distance: 519},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 556},
        {type: OfferPoiType.BUS, name: "Leszczyńskich 02", distance: 560},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 02", distance: 567},
        {type: OfferPoiType.TRAM, name: "Zaspa 04", distance: 621},
        {type: OfferPoiType.TRAM, name: "Zaspa 02", distance: 621},
        {type: OfferPoiType.TRAM, name: "Zaspa 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Leszczyńskich 03", distance: 679},
        {type: OfferPoiType.BUS, name: "Leszczyńskich 01", distance: 713},
        {type: OfferPoiType.TRAM, name: "Zaspa 03", distance: 724}
    ],
    16622: [
        {type: OfferPoiType.BUS, name: "Gliwice Cmentarz Centralny", distance: 546},
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Ordona", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 1248},
        {type: OfferPoiType.PARK, name: "Park Starokozielski", distance: 1535},
        {type: OfferPoiType.PARK, name: "Skwer Kežmarok", distance: 1591}
    ],
    16629: [
        {type: OfferPoiType.TRAM, name: "Wzgórze Wolności", distance: 151},
        {type: OfferPoiType.BUS, name: "Wzgórze Wolności", distance: 170},
        {type: OfferPoiType.BUS, name: "Rondo Kujawskie P+R", distance: 385},
        {type: OfferPoiType.BUS, name: "Trasa Uniwersytecka / Ujejskiego", distance: 432},
        {type: OfferPoiType.TRAM, name: "Rondo Kujawskie P+R", distance: 526},
        {type: OfferPoiType.TRAM, name: "Woj.Polskiego / Ujejskiego", distance: 628},
        {type: OfferPoiType.TRAM, name: "Rondo Kujawskie P+R (nieczynny)", distance: 638},
        {type: OfferPoiType.BUS, name: "Woj.Polskiego / Ujejskiego", distance: 640},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 756},
        {type: OfferPoiType.PARK, name: "Skwer im. Alojzego Bukolta", distance: 1264}
    ],
    16632: [
        {type: OfferPoiType.BUS, name: "Darwina 02", distance: 144},
        {type: OfferPoiType.BUS, name: "Szymanowskiego 01", distance: 249},
        {type: OfferPoiType.BUS, name: "Namysłowska 02", distance: 508},
        {type: OfferPoiType.TRAM, name: "Namysłowska 03", distance: 517},
        {type: OfferPoiType.TRAM, name: "Namysłowska 04", distance: 543},
        {type: OfferPoiType.BUS, name: "Namysłowska 01", distance: 553},
        {type: OfferPoiType.BUS, name: "Plac Hallera 07", distance: 589},
        {type: OfferPoiType.BUS, name: "Harnasie 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Plac Hallera 08", distance: 612},
        {type: OfferPoiType.BUS, name: "Strzelecka 02", distance: 652},
        {type: OfferPoiType.TRAM, name: "Bródnowska 01", distance: 661},
        {type: OfferPoiType.BUS, name: "Bródnowska 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Bródnowska 02", distance: 698},
        {type: OfferPoiType.TRAM, name: "Bródnowska 02", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 749},
        {type: OfferPoiType.TRAM, name: "Konopacka 01", distance: 803},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1703},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1818},
        {type: OfferPoiType.PARK, name: "Skwer Kępna-Jagiellońska", distance: 2266},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 2379},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 2421}
    ],
    16642: [
        {type: OfferPoiType.BUS, name: "CH Ursynów 03", distance: 182},
        {type: OfferPoiType.BUS, name: "Makolągwy 01", distance: 281},
        {type: OfferPoiType.BUS, name: "Makolągwy 02", distance: 302},
        {type: OfferPoiType.BUS, name: "CH Ursynów 02", distance: 352},
        {type: OfferPoiType.BUS, name: "CH Ursynów 01", distance: 353},
        {type: OfferPoiType.BUS, name: "Indiry Gandhi 03", distance: 468},
        {type: OfferPoiType.BUS, name: "Instytut Hematologii 02", distance: 513},
        {type: OfferPoiType.BUS, name: "CH Ursynów 04", distance: 515},
        {type: OfferPoiType.BUS, name: "Łukaszczyka 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Łukaszczyka 01", distance: 563},
        {type: OfferPoiType.REZERWAT, name: "Jeziorko Imielińskie - użytek 623", distance: 834},
        {type: OfferPoiType.PARK, name: "Słoneczny Jar", distance: 1205},
        {type: OfferPoiType.PARK, name: "Park im. Cichociemnych Spadochroniarzy AK", distance: 1687},
        {type: OfferPoiType.PARK, name: "Park linearny nad POW", distance: 1794},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1897},
        {type: OfferPoiType.PARK, name: "Skwer Sportów Miejskich", distance: 1938},
        {type: OfferPoiType.REZERWAT, name: "Aleja drzew", distance: 2134},
        {type: OfferPoiType.PARK, name: "Park Polskich Wynalazców", distance: 2217}
    ],
    16644: [
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 04", distance: 15},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 01", distance: 148},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 02", distance: 153},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 03", distance: 180},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 239},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Warszawska 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Czerwona Droga 02", distance: 436},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Habicha 01", distance: 556},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 01", distance: 559},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 834},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 1070},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1337}
    ],
    16660: [
        {type: OfferPoiType.BUS, name: "Dw. Północny", distance: 174},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 236},
        {type: OfferPoiType.BUS, name: "Źródłowa - Wojska Polskiego NŻ", distance: 392},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Marynarska", distance: 437},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 453},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Marynarska", distance: 462},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 476},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 497},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 558},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 562},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 620},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 621},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Franciszkańska", distance: 694},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 700},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 718},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 745},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Głowackiego", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 762},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 915}
    ],
    16667: [
        {type: OfferPoiType.BUS, name: "Reden Korczaka", distance: 492},
        {type: OfferPoiType.BUS, name: "Reden Aleja Majakowskiego", distance: 494},
        {type: OfferPoiType.BUS, name: "Reden", distance: 728},
        {type: OfferPoiType.TRAM, name: "Reden", distance: 794},
        {type: OfferPoiType.PARK, name: "Planty im. Harcmistrza Stefana Piotrowskiego", distance: 1003},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Hallera", distance: 1402},
        {type: OfferPoiType.PARK, name: "Park Podlesie", distance: 2149},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 2302},
        {type: OfferPoiType.PARK, name: "Skwer im. Antoniego Pilarza", distance: 2375},
        {type: OfferPoiType.PARK, name: "Park Śródmiejski", distance: 2445}
    ],
    16670: [
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 214},
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 306},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 358},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 371},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 421},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 440},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 475},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 528},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 574},
        {type: OfferPoiType.TRAM, name: "Piasta Kołodzieja 02", distance: 780},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 03", distance: 787},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 04", distance: 836},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1284},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1301},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 2277},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2415}
    ],
    16677: [
        {type: OfferPoiType.BUS, name: "Przyjaźni", distance: 524},
        {type: OfferPoiType.BUS, name: "Partynice – Tor Wyścigów Konnych", distance: 597},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Partynice", distance: 604},
        {type: OfferPoiType.TRAM, name: "Przyjaźni", distance: 624},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 885},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 1252},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 1669},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 1720},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1892},
        {type: OfferPoiType.PARK, name: "Park Migdałowy", distance: 2222}
    ],
    16679: [
        {type: OfferPoiType.BUS, name: "Rumia, Urząd Miasta Rumi", distance: 159},
        {type: OfferPoiType.BUS, name: "Górnicza 01 (NŻ)", distance: 403},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Górnicza 03 (NŻ)", distance: 422},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 610},
        {type: OfferPoiType.BUS, name: "Sobieskiego FUO - 01 (NŻ)", distance: 679},
        {type: OfferPoiType.KOLEJ, name: "Rumia", distance: 748},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1348},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1924},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 2076}
    ],
    16681: [
        {type: OfferPoiType.BUS, name: "Złotnicka", distance: 257},
        {type: OfferPoiType.TRAM, name: "Złotnicka", distance: 375},
        {type: OfferPoiType.BUS, name: "Wielkopolska", distance: 395},
        {type: OfferPoiType.PARK, name: "Park Literacki", distance: 622},
        {type: OfferPoiType.BUS, name: "Kamiennogórska (Ośrodek dla niewidomych)", distance: 761},
        {type: OfferPoiType.BUS, name: "Złotniki", distance: 771},
        {type: OfferPoiType.TRAM, name: "Kamiennogórska (Ośrodek dla niewidomych)", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Złotnicki", distance: 1346},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 1557},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Kobla", distance: 1973},
        {type: OfferPoiType.PARK, name: "Park Leśnicki", distance: 2254},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 2267}
    ],
    16682: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 262},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 544},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 619},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 640},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 708},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Niepodległości", distance: 746},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Niepodległości", distance: 755},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 816},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 829},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 846},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1164},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1211},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1234},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1247},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1296},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1410}
    ],
    16683: [
        {type: OfferPoiType.BUS, name: "Tymienieckiego - Sienkiewicza NŻ", distance: 248},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Tymienieckiego (Ericsson)NŻ", distance: 333},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 366},
        {type: OfferPoiType.BUS, name: "Tymienieckiego - Kilińskiego", distance: 481},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Katedralny", distance: 490},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 490},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tymienieckiego", distance: 604},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Tymienieckiego", distance: 617},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 671},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 671},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 738},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 778},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 936},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1081},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1124}
    ],
    16695: [
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 277},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 300},
        {type: OfferPoiType.BUS, name: "Krakowska", distance: 592},
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 642},
        {type: OfferPoiType.TRAM, name: "Krakowska", distance: 658},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1255},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1898},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2338}
    ],
    16696: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 68},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 155},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 174},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 285},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 366},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 378},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 428},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 456},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 485},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 509},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1013},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1146},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1251},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1562},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1936},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1938},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1950},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2143}
    ],
    16699: [
        {type: OfferPoiType.BUS, name: "Szymanów 01", distance: 7},
        {type: OfferPoiType.BUS, name: "Szymanów 03", distance: 96},
        {type: OfferPoiType.BUS, name: "Szymanów 02", distance: 96},
        {type: OfferPoiType.BUS, name: "Szymanów 04", distance: 113},
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 02", distance: 779},
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 01", distance: 796},
        {type: OfferPoiType.REZERWAT, name: "Łąki Soleckie", distance: 1915}
    ],
    16702: [
        {type: OfferPoiType.BUS, name: "Mazowiecka - Zakład Aktywności Zawodowej", distance: 75},
        {type: OfferPoiType.BUS, name: "Mazowiecka I", distance: 457},
        {type: OfferPoiType.BUS, name: "Mazowiecka przy Słonecznej", distance: 515},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wolności", distance: 688},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1598},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 1622},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 1757},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 2283}
    ],
    16704: [{type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 308}],
    16713: [
        {type: OfferPoiType.TRAM, name: "Cienista 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Cienista 03", distance: 251},
        {type: OfferPoiType.TRAM, name: "Cienista 02", distance: 264},
        {type: OfferPoiType.BUS, name: "Cienista 04", distance: 302},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 638},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 677},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 04", distance: 750},
        {type: OfferPoiType.BUS, name: "Os. Górali 02", distance: 755},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 03", distance: 768},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 02", distance: 789},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 1002},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1343},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 1445},
        {type: OfferPoiType.PARK, name: "Park Zalew Nowohucki", distance: 1641},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1667},
        {type: OfferPoiType.PARK, name: "Park wokół Dworku Jana Matejki", distance: 1694},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1714},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1825}
    ],
    16715: [
        {type: OfferPoiType.BUS, name: "Brynów Rzepakowa", distance: 306},
        {type: OfferPoiType.TRAM, name: "Brynów Centrum Przesiadkowe", distance: 721},
        {type: OfferPoiType.BUS, name: "Brynów Centrum Przesiadkowe", distance: 747},
        {type: OfferPoiType.BUS, name: "Ochojec Wapienna", distance: 829},
        {type: OfferPoiType.PARK, name: "Plac Tajnej Organizacji Nauczycielskiej", distance: 1119},
        {type: OfferPoiType.PARK, name: "Skwer księdza Waldemara Dekiela", distance: 1886},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Źródła Kłodnicy”", distance: 2194},
        {type: OfferPoiType.PARK, name: "Plac Miast Partnerskich", distance: 2406},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Szymkowiaka", distance: 2452},
        {type: OfferPoiType.PARK, name: "Plac Filipa Limańskiego", distance: 2457},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Kaczmarskiego", distance: 2462},
        {type: OfferPoiType.PARK, name: "skwer Bolesława Szabelskiego", distance: 2513}
    ],
    16717: [
        {type: OfferPoiType.BUS, name: "Mikulczyce Zwrotnicza", distance: 367},
        {type: OfferPoiType.TRAM, name: "Mikulczyce Pętla", distance: 410},
        {type: OfferPoiType.BUS, name: "Grzybowice Magazynowa", distance: 723}
    ],
    16728: [
        {type: OfferPoiType.BUS, name: "Stawowa 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Ojcowska Wągroda 01", distance: 472},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 504},
        {type: OfferPoiType.BUS, name: "Stawowa 04", distance: 517},
        {type: OfferPoiType.BUS, name: "Ojcowska Wągroda 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Ojcowska Dworek 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Ojcowska Dworek 02", distance: 729},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1553},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1960},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 2369}
    ],
    16731: [
        {type: OfferPoiType.BUS, name: "Mysłowice Staszica", distance: 57},
        {type: OfferPoiType.BUS, name: "Janów Osiedle Chopina Park", distance: 266},
        {type: OfferPoiType.BUS, name: "Mysłowice Wielka Skotnica", distance: 498},
        {type: OfferPoiType.BUS, name: "Bończyk Jastruna [nż]", distance: 528},
        {type: OfferPoiType.BUS, name: "Janów Łokietka", distance: 647},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 873},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 2050}
    ],
    16739: [
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 110},
        {type: OfferPoiType.BUS, name: "Prusa 03", distance: 132},
        {type: OfferPoiType.BUS, name: "Prusa 01", distance: 262},
        {type: OfferPoiType.BUS, name: "Czwartek 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Probostwo 02", distance: 494},
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Jaczewskiego 02", distance: 528},
        {type: OfferPoiType.BUS, name: "Jaczewskiego 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Szeligowskiego NŻ 01", distance: 563},
        {type: OfferPoiType.BUS, name: "Probostwo 01", distance: 570},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 847},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 881}
    ],
    16742: [
        {type: OfferPoiType.BUS, name: "Zagórze Technikum", distance: 606},
        {type: OfferPoiType.BUS, name: "Zagórze Centrum", distance: 649},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 744},
        {type: OfferPoiType.BUS, name: "Zagórze Dmowskiego", distance: 760},
        {type: OfferPoiType.LAS, name: "Kamionki", distance: 1174},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 1552},
        {type: OfferPoiType.PARK, name: "Plac im. Braci Kożuchów", distance: 2324},
        {type: OfferPoiType.PARK, name: "Park Środula", distance: 2367}
    ],
    16744: [
        {type: OfferPoiType.BUS, name: "Zagórze Technikum", distance: 611},
        {type: OfferPoiType.BUS, name: "Zagórze Centrum", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 749},
        {type: OfferPoiType.BUS, name: "Zagórze Dmowskiego", distance: 765},
        {type: OfferPoiType.LAS, name: "Kamionki", distance: 1179},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 1557},
        {type: OfferPoiType.PARK, name: "Plac im. Braci Kożuchów", distance: 2329},
        {type: OfferPoiType.PARK, name: "Park Środula", distance: 2372}
    ],
    16748: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 441},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 477},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 509},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 571},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 577},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 586},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 602},
        {type: OfferPoiType.BUS, name: "Ojca Aniceta 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Danusi 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1403},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2173}
    ],
    16749: [
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 305},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 309},
        {type: OfferPoiType.BUS, name: "Pl. Szoslanda - EC1 Centrum Nauki i Techniki", distance: 314},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 322},
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 409},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 489},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 495},
        {type: OfferPoiType.BUS, name: "Narutowicza - Pl. Dąbrowskiego", distance: 498},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 511},
        {type: OfferPoiType.BUS, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 519},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 641},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 663},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 824},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 843},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 915},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 1021},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 1086}
    ],
    16752: [
        {type: OfferPoiType.BUS, name: "Obywatelska - Cieszkowskiego NŻ", distance: 188},
        {type: OfferPoiType.BUS, name: "Obywatelska - Jana Pawła II", distance: 256},
        {type: OfferPoiType.BUS, name: "Obywatelska - Cieszkowskiego", distance: 288},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Obywatelska", distance: 373},
        {type: OfferPoiType.BUS, name: "Obywatelska - Politechniki", distance: 503},
        {type: OfferPoiType.BUS, name: "Politechniki - Obywatelska", distance: 520},
        {type: OfferPoiType.TRAM, name: "Politechniki - Obywatelska", distance: 556},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 649},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Rogozińskiego", distance: 681},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 781},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 942},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1285},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1574},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1728},
        {type: OfferPoiType.PARK, name: "Borek Józefa Lissnera", distance: 1837},
        {type: OfferPoiType.PARK, name: "Skwer im. Henryka Dubaniewicza", distance: 1883}
    ],
    16760: [
        {type: OfferPoiType.BUS, name: "Konwiktorska 03", distance: 64},
        {type: OfferPoiType.BUS, name: "Konwiktorska 04", distance: 78},
        {type: OfferPoiType.BUS, name: "Konwiktorska 02", distance: 92},
        {type: OfferPoiType.BUS, name: "Konwiktorska 01", distance: 185},
        {type: OfferPoiType.BUS, name: "Muranowska 06", distance: 319},
        {type: OfferPoiType.BUS, name: "Muranowska 05", distance: 368},
        {type: OfferPoiType.BUS, name: "Muranowska 04", distance: 385},
        {type: OfferPoiType.PARK, name: "Park Traugutta", distance: 450},
        {type: OfferPoiType.TRAM, name: "Muranowska 07", distance: 467},
        {type: OfferPoiType.TRAM, name: "Muranowska 08", distance: 474},
        {type: OfferPoiType.TRAM, name: "Muranowska 11", distance: 482},
        {type: OfferPoiType.BUS, name: "Muranowska 02", distance: 501},
        {type: OfferPoiType.TRAM, name: "KS Polonia 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Franciszkańska 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Park Traugutta 03", distance: 517},
        {type: OfferPoiType.TRAM, name: "KS Polonia 01", distance: 518},
        {type: OfferPoiType.TRAM, name: "Park Traugutta 05", distance: 550},
        {type: OfferPoiType.TRAM, name: "Park Traugutta 04", distance: 583},
        {type: OfferPoiType.TRAM, name: "Muranowska 71", distance: 661},
        {type: OfferPoiType.PARK, name: "Szkolny Park Sportowy imienia Janusza Kusocińskiego", distance: 733},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Pancernej WP", distance: 799},
        {type: OfferPoiType.TRAM, name: "Most Gdański 04", distance: 830},
        {type: OfferPoiType.PARK, name: 'Skwer Batalionu AK "Czata 49"', distance: 934},
        {type: OfferPoiType.PARK, name: "Ogród Krasińskich", distance: 1045},
        {type: OfferPoiType.PARK, name: "Skwer Więźniów Politycznych Stalinizmu", distance: 1049},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 1191}
    ],
    16766: [
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań", distance: 300},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 04", distance: 302},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 02", distance: 319},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła", distance: 694},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 01", distance: 735},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 02", distance: 737}
    ],
    16767: [
        {type: OfferPoiType.BUS, name: "Chrzanów Rospontowa II", distance: 304},
        {type: OfferPoiType.BUS, name: "Chrzanów Borowiec I", distance: 389}
    ],
    16784: [
        {type: OfferPoiType.TRAM, name: "Braterska", distance: 423},
        {type: OfferPoiType.BUS, name: "Braterska", distance: 437},
        {type: OfferPoiType.BUS, name: "Przyjaźni", distance: 615},
        {type: OfferPoiType.BUS, name: "Sąsiedzka", distance: 673},
        {type: OfferPoiType.TRAM, name: "Sąsiedzka", distance: 676},
        {type: OfferPoiType.BUS, name: "Partynice – Tor Wyścigów Konnych", distance: 688},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Partynice", distance: 695},
        {type: OfferPoiType.TRAM, name: "Przyjaźni", distance: 715},
        {type: OfferPoiType.BUS, name: "Osiedle Przyjaźni", distance: 726},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 976},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 1343},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1396},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 1482},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 1760}
    ],
    16789: [
        {type: OfferPoiType.BUS, name: "Wylotowa przy Plażowej", distance: 377},
        {type: OfferPoiType.PARK, name: "Park Antoniego Szarmacha", distance: 1438},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 1825},
        {type: OfferPoiType.LAS, name: "Załęże", distance: 2203}
    ],
    16793: [
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 391},
        {type: OfferPoiType.BUS, name: "Partynice – Tor Wyścigów Konnych", distance: 500},
        {type: OfferPoiType.BUS, name: "Klecina", distance: 549},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Partynice", distance: 571},
        {type: OfferPoiType.TRAM, name: "Klecina", distance: 599},
        {type: OfferPoiType.BUS, name: "Skarbowców", distance: 636},
        {type: OfferPoiType.TRAM, name: "Sąsiedzka", distance: 660},
        {type: OfferPoiType.BUS, name: "Sąsiedzka", distance: 661},
        {type: OfferPoiType.BUS, name: "Klecina (Stacja kolejowa)", distance: 775},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 791},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1272},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 1467},
        {type: OfferPoiType.PARK, name: "Park Migdałowy", distance: 1509},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 1791}
    ],
    16798: [
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 109},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 146},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 151},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 232},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 05", distance: 312},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 01", distance: 313},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 323},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 408},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 411},
        {type: OfferPoiType.BUS, name: "Cybernetyki 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 02", distance: 445},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 470},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 511},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 538},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 01", distance: 556},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 563},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 579},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 615},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 03", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1279},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1532},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 1631}
    ],
    16801: [
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska Sąd", distance: 401},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 434},
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska", distance: 448},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 551},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 715},
        {type: OfferPoiType.BUS, name: "Katowice Sądowa", distance: 755},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Miarki", distance: 773},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 784},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 792},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1049},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1263},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1305},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 1514}
    ],
    16809: [
        {type: OfferPoiType.BUS, name: "Park Wilsona", distance: 456},
        {type: OfferPoiType.TRAM, name: "Park Wilsona", distance: 463},
        {type: OfferPoiType.TRAM, name: "Dworzec Zachodni", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Thomasa Woodrowa Wilsona", distance: 622},
        {type: OfferPoiType.BUS, name: "Skwer Focha", distance: 630},
        {type: OfferPoiType.BUS, name: "Dworzec Zachodni", distance: 632},
        {type: OfferPoiType.KOLEJ, name: "Poznań Główny", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Hałasika", distance: 1212},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1440},
        {type: OfferPoiType.PARK, name: "Park Jana Kasprowicza", distance: 1448},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1777},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1853},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1881},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1886}
    ],
    16812: [
        {type: OfferPoiType.BUS, name: "Kilińskiego - Nawrot", distance: 10},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Nawrot", distance: 55},
        {type: OfferPoiType.BUS, name: "Nawrot - Kilińskiego", distance: 88},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Tuwima", distance: 231},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 236},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Piłsudskiego", distance: 322},
        {type: OfferPoiType.BUS, name: "Tuwima - Kilińskiego (EC1 Centr. Nauki)", distance: 388},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 391},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Kilińskiego", distance: 434},
        {type: OfferPoiType.BUS, name: "Nawrot - Sienkiewicza", distance: 440},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 454},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Kilińskiego", distance: 454},
        {type: OfferPoiType.BUS, name: "Nawrot - Targowa", distance: 467},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Roosevelta", distance: 544},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Park Sienkiewicza", distance: 544},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 646},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 690},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 696},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 705},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 802},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 855},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 897}
    ],
    16814: [
        {type: OfferPoiType.BUS, name: "ROD Storczyk", distance: 60},
        {type: OfferPoiType.BUS, name: "Lipowa", distance: 334},
        {type: OfferPoiType.BUS, name: "Wysoka", distance: 418},
        {type: OfferPoiType.BUS, name: "Kutrzeby", distance: 444},
        {type: OfferPoiType.BUS, name: "Lipowa-Parkowa", distance: 703},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 802}
    ],
    16817: [
        {type: OfferPoiType.BUS, name: "Żywiecka Leszczyny", distance: 246},
        {type: OfferPoiType.BUS, name: "Żywiecka Pawia", distance: 450},
        {type: OfferPoiType.BUS, name: "Łagodna Szkoła", distance: 532},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Leszczyny", distance: 634},
        {type: OfferPoiType.BUS, name: "Górska Bulwary Młodości", distance: 642},
        {type: OfferPoiType.BUS, name: "Osiedle Złote Łany", distance: 706},
        {type: OfferPoiType.PARK, name: "Bulwary Straceńskie", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Strzygowskiego", distance: 1104},
        {type: OfferPoiType.REZERWAT, name: "Żabiniec", distance: 1454},
        {type: OfferPoiType.REZERWAT, name: "Zbiornik Weldoro", distance: 1922}
    ],
    16824: [
        {type: OfferPoiType.BUS, name: "Katowice Ceglana Szpital Kliniczny", distance: 341},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Szpital", distance: 623},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Basen", distance: 638},
        {type: OfferPoiType.BUS, name: "Katowice Meteorologów", distance: 662},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 902},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Szymkowiaka", distance: 1087},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1120},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Kaczmarskiego", distance: 1324},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1376},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 1474},
        {type: OfferPoiType.PARK, name: "Skwer Porozumienia Katowickiego 1980 roku", distance: 1542}
    ],
    16826: [
        {type: OfferPoiType.BUS, name: "Cyryla i Metodego", distance: 357},
        {type: OfferPoiType.BUS, name: "1 Maja", distance: 452},
        {type: OfferPoiType.BUS, name: "Wilcza Wiadukt", distance: 495},
        {type: OfferPoiType.BUS, name: "Sczanieckiej", distance: 632},
        {type: OfferPoiType.BUS, name: "Fabryka Wody", distance: 724},
        {type: OfferPoiType.PARK, name: "Skwer imienia Pułkownika Ryszarda Kuklińskiego", distance: 1112},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jacka Nieżychowskiego", distance: 1155},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Nadratowskiego", distance: 1322},
        {type: OfferPoiType.PARK, name: "Skwer imienia Raoula Wallenberga", distance: 1377},
        {type: OfferPoiType.PARK, name: "park Orderu Uśmiechu", distance: 1593},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 1661},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 1778},
        {type: OfferPoiType.PARK, name: "Park Antoniego Kadziaka", distance: 1806},
        {type: OfferPoiType.PARK, name: "Park imienia Jacka Karpińskiego", distance: 2103}
    ],
    16840: [
        {type: OfferPoiType.BUS, name: "Sikorki 01", distance: 104},
        {type: OfferPoiType.BUS, name: "Sikorki 02", distance: 171},
        {type: OfferPoiType.BUS, name: "Na Załęczu 01", distance: 252},
        {type: OfferPoiType.BUS, name: "Na Załęczu 04", distance: 377},
        {type: OfferPoiType.BUS, name: "Na Załęczu 02", distance: 402},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 01", distance: 638},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 02", distance: 670},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 1144},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1543},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1872},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1944},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 2073},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2405},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2472},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 2479}
    ],
    16843: [
        {type: OfferPoiType.BUS, name: "Chłodnia 02", distance: 247},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Chłodnia 01", distance: 300},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 04", distance: 302},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 01", distance: 326},
        {type: OfferPoiType.BUS, name: "Daniszewska 02", distance: 637},
        {type: OfferPoiType.BUS, name: "Daniszewska 01", distance: 661},
        {type: OfferPoiType.BUS, name: "Odlewnicza 05", distance: 830},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1600},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 1619},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1875},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2000}
    ],
    16851: [
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 354},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 358},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 361},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 417},
        {type: OfferPoiType.TRAM, name: "Zabłocie 02", distance: 532},
        {type: OfferPoiType.TRAM, name: "Zabłocie 01", distance: 539},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 662},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 718},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 04", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 928},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1268},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1565},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1815}
    ],
    16852: [
        {type: OfferPoiType.BUS, name: "Mysłowice Cmentarz", distance: 159},
        {type: OfferPoiType.BUS, name: "Mysłowice Mikołowska Markety", distance: 492},
        {type: OfferPoiType.BUS, name: "Mysłowice Chopina", distance: 627},
        {type: OfferPoiType.BUS, name: "Mysłowice Katowicka", distance: 688},
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Partyzantów)", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1875},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 1940},
        {type: OfferPoiType.PARK, name: "Park Wygoda", distance: 2031},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Kłosowskiego", distance: 2493}
    ],
    16854: [
        {type: OfferPoiType.BUS, name: "Boya Żeleńskiego 01", distance: 125},
        {type: OfferPoiType.BUS, name: "Boya Żeleńskiego 02", distance: 195},
        {type: OfferPoiType.BUS, name: "Wita Stwosza / Langiewicza 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 04", distance: 296},
        {type: OfferPoiType.BUS, name: "Wita Stwosza pętla 01", distance: 310},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 05", distance: 368},
        {type: OfferPoiType.BUS, name: "Chmaja / Langiewicza 02", distance: 370},
        {type: OfferPoiType.BUS, name: "Chmaja / Langiewicza 01", distance: 425},
        {type: OfferPoiType.BUS, name: "Langiewicza park 02", distance: 465},
        {type: OfferPoiType.BUS, name: "Wita Stwosza kościół 03", distance: 495},
        {type: OfferPoiType.KOLEJ, name: "Rzeszów Politechnika", distance: 543},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 824},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 1095},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1181},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1413},
        {type: OfferPoiType.PARK, name: "Park Jedności Polonii z Macierzą", distance: 1669}
    ],
    16857: [
        {type: OfferPoiType.BUS, name: "Ornontowice Zespół Szkół", distance: 284},
        {type: OfferPoiType.BUS, name: "Ornontowice Szkoła", distance: 465},
        {type: OfferPoiType.BUS, name: "Ornontowice Działkowa", distance: 630},
        {type: OfferPoiType.BUS, name: "Ornontowice Ogródki Działkowe", distance: 728},
        {type: OfferPoiType.PARK, name: "Park pałacowy", distance: 950}
    ],
    16859: [
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 370},
        {type: OfferPoiType.BUS, name: "Bielicowa", distance: 457},
        {type: OfferPoiType.BUS, name: "Sielawy", distance: 504},
        {type: OfferPoiType.BUS, name: "Naramowice Wschodnie", distance: 566},
        {type: OfferPoiType.BUS, name: "Rubież", distance: 731},
        {type: OfferPoiType.BUS, name: "Dworska", distance: 732},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1620},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2045}
    ],
    16866: [{type: OfferPoiType.PARK, name: "Park Widawski", distance: 1677}],
    16877: [
        {type: OfferPoiType.TRAM, name: "Gwarna", distance: 66},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 241},
        {type: OfferPoiType.TRAM, name: "Zamek", distance: 258},
        {type: OfferPoiType.TRAM, name: "Fredry", distance: 270},
        {type: OfferPoiType.TRAM, name: "Pl. Ratajskiego", distance: 306},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 308},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 380},
        {type: OfferPoiType.BUS, name: "Zamek", distance: 425},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 456},
        {type: OfferPoiType.BUS, name: "Uniwersytet Ekonomiczny", distance: 489},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 508},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 518},
        {type: OfferPoiType.BUS, name: "Urząd Wojewódzki", distance: 529},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 640},
        {type: OfferPoiType.BUS, name: "Rondo Kaponiera", distance: 674},
        {type: OfferPoiType.BUS, name: "Libelta", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 693},
        {type: OfferPoiType.BUS, name: "Solna", distance: 700},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 711},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 718},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 958},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 978},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1058},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1107}
    ],
    16878: [
        {type: OfferPoiType.BUS, name: "Okrągła", distance: 352},
        {type: OfferPoiType.BUS, name: "Kłosowa", distance: 519},
        {type: OfferPoiType.PARK, name: "Skwer Wolnego Tybetu", distance: 2491}
    ],
    16879: [
        {type: OfferPoiType.BUS, name: "Przyszówka Osiedle Literatów", distance: 372},
        {type: OfferPoiType.BUS, name: "Przyszówka Kaplica", distance: 586},
        {type: OfferPoiType.BUS, name: "Przyszówka Ossolińskich", distance: 660},
        {type: OfferPoiType.BUS, name: "Przyszówka Zygmuntowska [nż]", distance: 703},
        {type: OfferPoiType.PARK, name: "Skwer Układu Słonecznego", distance: 2039},
        {type: OfferPoiType.PARK, name: "Łabędzki Park", distance: 2073}
    ],
    16889: [
        {type: OfferPoiType.BUS, name: "Pustki Cisowskie 02", distance: 78},
        {type: OfferPoiType.BUS, name: "Żurawia", distance: 279},
        {type: OfferPoiType.BUS, name: "Pustki Cisowskie 01", distance: 485},
        {type: OfferPoiType.BUS, name: "Wiklinowa", distance: 766},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1460}
    ],
    16896: [
        {type: OfferPoiType.BUS, name: "Wschodu Słońca 02", distance: 111},
        {type: OfferPoiType.BUS, name: "Popularna 03", distance: 180},
        {type: OfferPoiType.BUS, name: "Popularna 01", distance: 236},
        {type: OfferPoiType.BUS, name: "Wschodu Słońca 01", distance: 254},
        {type: OfferPoiType.BUS, name: "Popularna 04", distance: 334},
        {type: OfferPoiType.BUS, name: "Popularna 02", distance: 335},
        {type: OfferPoiType.BUS, name: "PKP WKD Al. Jerozolimskie 05", distance: 609},
        {type: OfferPoiType.BUS, name: "Szybka 02", distance: 681},
        {type: OfferPoiType.BUS, name: "PKP WKD Al. Jerozolimskie 06", distance: 709},
        {type: OfferPoiType.BUS, name: "Szybka 01", distance: 731},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Aleje Jerozolimskie WKD", distance: 742},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Aleje Jerozolimskie", distance: 839},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 1420},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1502},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 2019},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 2082},
        {type: OfferPoiType.PARK, name: "Park Szczęśliwicki", distance: 2227},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2358}
    ],
    16897: [
        {type: OfferPoiType.BUS, name: "Katowice Francuska WORD", distance: 790},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Trzy Stawy", distance: 835},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 1135},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1176},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 1782},
        {type: OfferPoiType.PARK, name: 'Skwer 304 Dywizjonu Bombowego "Ziemi Śląskiej"', distance: 1831},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 1865},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 2081},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 2094}
    ],
    16898: [
        {type: OfferPoiType.BUS, name: "Wełniana", distance: 334},
        {type: OfferPoiType.BUS, name: "Chwałkowska", distance: 349},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 776},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1371},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2073},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 2299}
    ],
    16901: [
        {type: OfferPoiType.BUS, name: "Sasanki 03", distance: 457},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 02", distance: 467},
        {type: OfferPoiType.BUS, name: "Sasanki 02", distance: 519},
        {type: OfferPoiType.BUS, name: "Sasanki 01", distance: 523},
        {type: OfferPoiType.BUS, name: "Sasanki 04", distance: 575},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 04", distance: 611},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 03", distance: 663},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 01", distance: 673},
        {type: OfferPoiType.BUS, name: "Astronautów 01", distance: 739},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1740}
    ],
    16903: [
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 03", distance: 470},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ursus Północny", distance: 483},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 02", distance: 494},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 04", distance: 508},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 01", distance: 527},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 08", distance: 588},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 638},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 07", distance: 686},
        {type: OfferPoiType.BUS, name: "Habicha 02", distance: 705},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 03", distance: 731},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ursus Płn. 01", distance: 744},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 06", distance: 780},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 880},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1203},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1462}
    ],
    16906: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 249},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 259},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 321},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 335},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 396},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 406},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 475},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 547},
        {type: OfferPoiType.BUS, name: "Natansona 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Natansona 02", distance: 642},
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 693},
        {type: OfferPoiType.BUS, name: "Siewna 03", distance: 710},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 741},
        {type: OfferPoiType.TRAM, name: "Bociana 02", distance: 835},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1624},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1656},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1699},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2251},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2345}
    ],
    16907: [
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 02 (NŻ)", distance: 157},
        {type: OfferPoiType.BUS, name: "Pogórze - Szkolna 01 (NŻ)", distance: 186},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 01 (NŻ)", distance: 274},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Gombrowicza 01", distance: 430},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Świetlica 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Świetlica 02", distance: 631},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Świetlica 04", distance: 638},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 02", distance: 648},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 01", distance: 726},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1543},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 2470}
    ],
    16909: [
        {type: OfferPoiType.BUS, name: "Pogórze - Szkolna 01 (NŻ)", distance: 464},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 02 (NŻ)", distance: 623},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 01 (NŻ)", distance: 629},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 02", distance: 656},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 01", distance: 734},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1551}
    ],
    16910: [
        {type: OfferPoiType.BUS, name: "Smolec - Chłopska/Śliwkowa", distance: 459},
        {type: OfferPoiType.BUS, name: "Smolec - Chłopska/Wrzosowa", distance: 527},
        {type: OfferPoiType.KOLEJ, name: "Mokronos Górny", distance: 646},
        {type: OfferPoiType.BUS, name: "Smolec - Wiśniowa", distance: 742}
    ],
    16924: [
        {type: OfferPoiType.BUS, name: "Wartka 02", distance: 294},
        {type: OfferPoiType.BUS, name: "Wartka 01", distance: 427},
        {type: OfferPoiType.BUS, name: "Cementownia 03", distance: 462},
        {type: OfferPoiType.BUS, name: "Cementownia 01", distance: 484},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 566},
        {type: OfferPoiType.BUS, name: "Konwaliowa 04", distance: 596},
        {type: OfferPoiType.BUS, name: "Konwaliowa 02", distance: 658},
        {type: OfferPoiType.BUS, name: "Płochocińska 04", distance: 688},
        {type: OfferPoiType.BUS, name: "Cementownia 02", distance: 689},
        {type: OfferPoiType.BUS, name: "Konwaliowa 03", distance: 718},
        {type: OfferPoiType.BUS, name: "Konwaliowa 01", distance: 765},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2372}
    ],
    16931: [
        {type: OfferPoiType.BUS, name: "Ligota Bronisławy", distance: 153},
        {type: OfferPoiType.PARK, name: "Skwer Tytusa Chałubińskiego", distance: 357},
        {type: OfferPoiType.BUS, name: "Ligota Szpital", distance: 360},
        {type: OfferPoiType.BUS, name: "Ligota Akademiki", distance: 528},
        {type: OfferPoiType.PARK, name: "plac profesora Kornela Gibińskiego", distance: 583},
        {type: OfferPoiType.BUS, name: "Ligota Medyków", distance: 594},
        {type: OfferPoiType.BUS, name: "Ligota Wileńska", distance: 731},
        {type: OfferPoiType.LAS, name: "Gierkówka", distance: 752},
        {type: OfferPoiType.PARK, name: "Park Zadole", distance: 857},
        {type: OfferPoiType.PARK, name: "Skwer Nad Ślepiotką", distance: 968},
        {type: OfferPoiType.PARK, name: "skwer Bolesława Szabelskiego", distance: 1250},
        {type: OfferPoiType.PARK, name: "Skwer profesora Wilibalda Winklera", distance: 1276},
        {type: OfferPoiType.PARK, name: "plac ojca Justyna Widucha", distance: 1279}
    ],
    16937: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 244},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 252},
        {type: OfferPoiType.BUS, name: "Lechicka/Naramowicka", distance: 260},
        {type: OfferPoiType.TRAM, name: "Lechicka/Naramowicka", distance: 281},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 602},
        {type: OfferPoiType.TRAM, name: "Serbska", distance: 662},
        {type: OfferPoiType.BUS, name: "Os. Wichrowe Wzgórze", distance: 765},
        {type: OfferPoiType.BUS, name: "Os. Kosmonautów", distance: 774},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 947},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 1091},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1135},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1528},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1894},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1915},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1941},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2370},
        {type: OfferPoiType.PARK, name: "Park Cytadela", distance: 2497},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2511}
    ],
    16944: [
        {type: OfferPoiType.BUS, name: "Rubież", distance: 121},
        {type: OfferPoiType.BUS, name: "Bronisza", distance: 228},
        {type: OfferPoiType.TRAM, name: "Jasna Rola", distance: 245},
        {type: OfferPoiType.BUS, name: "Sielawy n/ż", distance: 457},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 568},
        {type: OfferPoiType.TRAM, name: "Os. Łokietka", distance: 608},
        {type: OfferPoiType.TRAM, name: "Błażeja", distance: 620},
        {type: OfferPoiType.BUS, name: "Bogusława", distance: 655},
        {type: OfferPoiType.BUS, name: "Os. Łokietka", distance: 712},
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 760},
        {type: OfferPoiType.TRAM, name: "Naramowice", distance: 801},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 993},
        {type: OfferPoiType.PARK, name: "Demonstracyjny ogród klimatyczny", distance: 1976},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2080},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2355},
        {type: OfferPoiType.PARK, name: "Skwer Poznańskiego Towarzystwa Przyjaciół Nauk", distance: 2388},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 2409}
    ],
    16946: [
        {type: OfferPoiType.KOLEJ, name: "Michałowice", distance: 511},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 2031},
        {type: OfferPoiType.PARK, name: "Park im. Ludwika Trylskiego", distance: 2116},
        {type: OfferPoiType.PARK, name: "Park Niepodległości", distance: 2242},
        {type: OfferPoiType.PARK, name: "Park Bogny i Jerzego Sokorskich", distance: 2505},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 2510}
    ],
    16949: [
        {type: OfferPoiType.BUS, name: "Potęgowska 01", distance: 24},
        {type: OfferPoiType.BUS, name: "Potęgowska 02", distance: 28},
        {type: OfferPoiType.BUS, name: "Szadółki 04", distance: 355},
        {type: OfferPoiType.BUS, name: "Połczyńska 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Szadółki 03", distance: 413},
        {type: OfferPoiType.BUS, name: "Połczyńska 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Szadółki 02", distance: 510},
        {type: OfferPoiType.BUS, name: "Szadółki 01", distance: 554},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 660},
        {type: OfferPoiType.BUS, name: "Leszczynowa 02", distance: 818},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1817}
    ],
    16950: [
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 569},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 615},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 635},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 645},
        {type: OfferPoiType.BUS, name: "Popielidów 02", distance: 650},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 655},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 700},
        {type: OfferPoiType.BUS, name: "Popielidów 01", distance: 706},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 828},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 03", distance: 828},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1466},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 2471}
    ],
    16951: [
        {type: OfferPoiType.BUS, name: "Milanówek Łączna", distance: 407},
        {type: OfferPoiType.BUS, name: "Milanówek Nowowiejska", distance: 414},
        {type: OfferPoiType.BUS, name: "Milanówek Biedronka", distance: 504},
        {type: OfferPoiType.BUS, name: "Milanówek Królewska", distance: 605},
        {type: OfferPoiType.BUS, name: "Milanówek Jasna", distance: 772},
        {type: OfferPoiType.BUS, name: "Milanówek Targ", distance: 833},
        {type: OfferPoiType.PARK, name: 'Park "Zielony Dołek"', distance: 883},
        {type: OfferPoiType.PARK, name: "Skwer im. Bohaterów Polski Podziemnej 1939-1956", distance: 1187},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1344},
        {type: OfferPoiType.PARK, name: "Skwer im. Wacława Wdowiaka", distance: 1384},
        {type: OfferPoiType.PARK, name: "Skwer im. Ferdynanda Antoniego Ossendowskiego", distance: 1486},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1516},
        {type: OfferPoiType.PARK, name: "Skwer im. Adama Bienia", distance: 1604},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 1877},
        {type: OfferPoiType.PARK, name: "Starodęby", distance: 1991},
        {type: OfferPoiType.PARK, name: "Lasek Rososza", distance: 2123}
    ],
    16952: [
        {type: OfferPoiType.BUS, name: "Powstańców 01", distance: 253},
        {type: OfferPoiType.BUS, name: "Majora 01", distance: 306},
        {type: OfferPoiType.BUS, name: "Powstańców 02", distance: 334},
        {type: OfferPoiType.BUS, name: "Sudolska 02", distance: 347},
        {type: OfferPoiType.BUS, name: "Majora 03", distance: 403},
        {type: OfferPoiType.BUS, name: "Majora 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 03", distance: 520},
        {type: OfferPoiType.BUS, name: "Aleja 29 Listopada Wiadukt 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Promienistych 02", distance: 576},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 02", distance: 595},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 690},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 768},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1387}
    ],
    16963: [
        {type: OfferPoiType.BUS, name: "Olimp 01", distance: 58},
        {type: OfferPoiType.BUS, name: "Olimp 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Morzyckiej 01", distance: 340},
        {type: OfferPoiType.BUS, name: "Związkowa 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Związkowa 03", distance: 458},
        {type: OfferPoiType.BUS, name: "Związkowa 01", distance: 463},
        {type: OfferPoiType.BUS, name: "Szwedzka NŻ 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Związkowa 05", distance: 494},
        {type: OfferPoiType.BUS, name: "Szwedzka NŻ 02", distance: 646},
        {type: OfferPoiType.BUS, name: "WSPA 02", distance: 679},
        {type: OfferPoiType.PARK, name: "50-lecia", distance: 1637},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 1645},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1938}
    ],
    16972: [
        {type: OfferPoiType.BUS, name: "Niedźwiedzia", distance: 132},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia", distance: 173},
        {type: OfferPoiType.TRAM, name: "Małopanewska", distance: 384},
        {type: OfferPoiType.BUS, name: "Małopanewska", distance: 443},
        {type: OfferPoiType.BUS, name: "Kwiska", distance: 639},
        {type: OfferPoiType.TRAM, name: "Kwiska", distance: 731},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 807},
        {type: OfferPoiType.BUS, name: "Park Popowicki", distance: 812},
        {type: OfferPoiType.PARK, name: "park Aleksandry Natalli-Świat", distance: 901}
    ],
    16975: [{type: OfferPoiType.BUS, name: "Karwia, Kopernika", distance: 815}],
    16983: [
        {type: OfferPoiType.BUS, name: "Galicyjska 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Galicyjska 02", distance: 479},
        {type: OfferPoiType.BUS, name: "Galicyjska 03", distance: 560},
        {type: OfferPoiType.BUS, name: "Ciesielskiego 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 02", distance: 682},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Ciesielskiego 01", distance: 719},
        {type: OfferPoiType.BUS, name: "Siwka 01", distance: 760},
        {type: OfferPoiType.BUS, name: "Siwka 02", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 1720},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 2308},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 2406}
    ],
    16984: [
        {type: OfferPoiType.BUS, name: "Forsycji 02", distance: 266},
        {type: OfferPoiType.BUS, name: "Forsycji 01", distance: 285},
        {type: OfferPoiType.BUS, name: "Pole Namiotowe 02", distance: 431},
        {type: OfferPoiType.BUS, name: "Pole Namiotowe 01", distance: 456},
        {type: OfferPoiType.BUS, name: "Turystyczna 02", distance: 603},
        {type: OfferPoiType.BUS, name: "Turystyczna 01", distance: 695},
        {type: OfferPoiType.LAS, name: "Las Mierzei", distance: 1903}
    ],
    17010: [
        {type: OfferPoiType.BUS, name: "Zamojska 02", distance: 167},
        {type: OfferPoiType.BUS, name: "Zamojska 01", distance: 264},
        {type: OfferPoiType.LAS, name: "Skwer bł. ks. Antoniego Zawistowskiego", distance: 463},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 04", distance: 555},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 03", distance: 591},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 01", distance: 617},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 05", distance: 623},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 02", distance: 693},
        {type: OfferPoiType.BUS, name: "Brama Krakowska 04", distance: 752},
        {type: OfferPoiType.BUS, name: "turystyczny", distance: 758},
        {type: OfferPoiType.BUS, name: "Brama Krakowska 02", distance: 785},
        {type: OfferPoiType.PARK, name: "Park Bronowice", distance: 847},
        {type: OfferPoiType.PARK, name: "Skwer Pod Akacją", distance: 1084},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 1198},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1296}
    ],
    17021: [
        {type: OfferPoiType.BUS, name: "Jędrzejów Przem. Zachód", distance: 714},
        {type: OfferPoiType.BUS, name: "Bieszczadzka - Kolumny NŻ", distance: 818},
        {type: OfferPoiType.BUS, name: "Kolumny - Kolumny 118 NŻ", distance: 820},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 1584},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2135},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 2505}
    ],
    17026: [
        {type: OfferPoiType.BUS, name: "Piastun 02", distance: 106},
        {type: OfferPoiType.PARK, name: "Skwer im. Aleksandra Kamińskiego „Kamyka”", distance: 402},
        {type: OfferPoiType.BUS, name: "Dąbrowskiego 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Traugutta 02", distance: 485},
        {type: OfferPoiType.BUS, name: "Wysockiego 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 521},
        {type: OfferPoiType.BUS, name: "Skorupki 01", distance: 529},
        {type: OfferPoiType.BUS, name: "Dąbrowskiego 01", distance: 570},
        {type: OfferPoiType.BUS, name: "Traugutta 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Skłodowskiej 02", distance: 614},
        {type: OfferPoiType.PARK, name: "Park im. Marii Stypułkowskiej-Chojeckiej „Kamy”", distance: 685},
        {type: OfferPoiType.PARK, name: "Park im. Fryderyka Piotra Wilhelma Müllera", distance: 900},
        {type: OfferPoiType.PARK, name: "Park Bogny i Jerzego Sokorskich", distance: 1073},
        {type: OfferPoiType.PARK, name: "Park Niepodległości", distance: 1277},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 2092},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 2358}
    ],
    17027: [
        {type: OfferPoiType.BUS, name: "Gazowa", distance: 412},
        {type: OfferPoiType.BUS, name: "Tarnogaj", distance: 492},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 690},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 709},
        {type: OfferPoiType.TRAM, name: "Tarnogaj", distance: 771},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 814},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 814},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2028},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2322}
    ],
    17028: [
        {type: OfferPoiType.REZERWAT, name: "Staw Królówka", distance: 1944},
        {type: OfferPoiType.PARK, name: "Ogród krzewowy", distance: 2535}
    ],
    17056: [
        {type: OfferPoiType.BUS, name: "Warszewo Kościół", distance: 211},
        {type: OfferPoiType.BUS, name: "Wapienna", distance: 246},
        {type: OfferPoiType.BUS, name: "Łączna nż", distance: 383},
        {type: OfferPoiType.BUS, name: "Szwedzka", distance: 486},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 997},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 1051},
        {type: OfferPoiType.PARK, name: "park Warszewo-Podbórz", distance: 1630},
        {type: OfferPoiType.PARK, name: "Park imienia Fryderyka Chopina", distance: 2308},
        {type: OfferPoiType.PARK, name: "Park Antoniego Kadziaka", distance: 2440}
    ],
    17057: [
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 02", distance: 266},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 420},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 482},
        {type: OfferPoiType.BUS, name: "Przejezdna 02", distance: 622},
        {type: OfferPoiType.BUS, name: "Przejezdna 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 755},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 827},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1250}
    ],
    17065: [
        {type: OfferPoiType.BUS, name: "Marszałkowska", distance: 335},
        {type: OfferPoiType.BUS, name: "Świerzawska", distance: 541},
        {type: OfferPoiType.BUS, name: "Rycerska", distance: 596},
        {type: OfferPoiType.BUS, name: "Stadion Miejski", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1464},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1506},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2096},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 2238},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 2335},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 2506}
    ],
    17066: [
        {type: OfferPoiType.BUS, name: "Listopadowa", distance: 186},
        {type: OfferPoiType.BUS, name: "Asnyka", distance: 217},
        {type: OfferPoiType.BUS, name: "Nad Potokiem Listopadowa", distance: 306},
        {type: OfferPoiType.BUS, name: "Piastowska Lubertowicza", distance: 437},
        {type: OfferPoiType.BUS, name: "Piastowska Starostwo Powiatowe", distance: 439},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 480},
        {type: OfferPoiType.BUS, name: "Wyspiańskiego Starostwo Powiatowe", distance: 529},
        {type: OfferPoiType.BUS, name: "Filarowa Zespół Szkół", distance: 574},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 647},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 1384},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1695}
    ],
    17074: [
        {type: OfferPoiType.BUS, name: "Sikorki 02", distance: 126},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 02", distance: 180},
        {type: OfferPoiType.BUS, name: "Sikorki 01", distance: 189},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 01", distance: 219},
        {type: OfferPoiType.BUS, name: "Na Załęczu 01", distance: 431},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 504},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 01", distance: 531},
        {type: OfferPoiType.BUS, name: "Na Załęczu 04", distance: 548},
        {type: OfferPoiType.BUS, name: "Na Załęczu 02", distance: 569},
        {type: OfferPoiType.BUS, name: "Sołtysowska 02", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 849},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1506},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1763},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1778},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1835},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2362},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2368},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 2370},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 2378},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 2515}
    ],
    17078: [
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 130},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 590},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 643},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 703},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 774},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 832},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1414},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1737},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 1785},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1787},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 2053},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 2286},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2408},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2444},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 2454}
    ],
    17088: [
        {type: OfferPoiType.BUS, name: "Łobzów SKA 04", distance: 424},
        {type: OfferPoiType.BUS, name: "Stachiewicza 01", distance: 440},
        {type: OfferPoiType.BUS, name: "Różyckiego 01", distance: 460},
        {type: OfferPoiType.BUS, name: "Makowskiego 02", distance: 490},
        {type: OfferPoiType.BUS, name: "Radzikowskiego 02", distance: 507},
        {type: OfferPoiType.BUS, name: "Makowskiego 03", distance: 509},
        {type: OfferPoiType.BUS, name: "Radzikowskiego 01", distance: 520},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 03", distance: 521},
        {type: OfferPoiType.BUS, name: "Różyckiego 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Makowskiego 01", distance: 581},
        {type: OfferPoiType.KOLEJ, name: "Kraków Łobzów", distance: 669},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 850},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 956},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1423},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 1487},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 1609},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1651},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 1827}
    ],
    17092: [
        {type: OfferPoiType.BUS, name: "Parafialna 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Armatnia 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Parafialna 02", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 799},
        {type: OfferPoiType.BUS, name: "Armatnia 02", distance: 814},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1232},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1708},
        {type: OfferPoiType.PARK, name: "Park im. Edwarda Szymańskiego", distance: 1734},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 1810},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 1890}
    ],
    17102: [
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Pętla", distance: 490},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 2050}
    ],
    17103: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 59},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 341},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 416},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 437},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 505},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Niepodległości", distance: 543},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Niepodległości", distance: 552},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 613},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 626},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 643},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 680},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 682},
        {type: OfferPoiType.TRAM, name: "Pl. Reymonta", distance: 699},
        {type: OfferPoiType.TRAM, name: "Pl. Niepodległości", distance: 709},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 961},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1008},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1031},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1044},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1093},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1207}
    ],
    17105: [
        {type: OfferPoiType.BUS, name: "Chałubińskiego", distance: 90},
        {type: OfferPoiType.BUS, name: "PWSZ", distance: 126},
        {type: OfferPoiType.BUS, name: "Szpital", distance: 365},
        {type: OfferPoiType.BUS, name: "Ruszczyca", distance: 573},
        {type: OfferPoiType.BUS, name: "Traugutta", distance: 643},
        {type: OfferPoiType.BUS, name: "Zielona", distance: 694},
        {type: OfferPoiType.BUS, name: "Szpital (tymczasowy)", distance: 722},
        {type: OfferPoiType.PARK, name: "Park PCK", distance: 1381},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 2034},
        {type: OfferPoiType.REZERWAT, name: "Ujęcie Wody w Koszalinie", distance: 2130}
    ],
    17106: [
        {type: OfferPoiType.BUS, name: "Sosnowiec Kosów", distance: 147},
        {type: OfferPoiType.PARK, name: "Plac im. Jana Pawła II", distance: 2193},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 2317},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 2324},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 2346},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu drogowego", distance: 2365}
    ],
    17117: [
        {type: OfferPoiType.BUS, name: "Szkoła 02", distance: 540},
        {type: OfferPoiType.BUS, name: "Pętla 01", distance: 603},
        {type: OfferPoiType.BUS, name: "Szkoła 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Mostowa 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Mostowa 02", distance: 770},
        {type: OfferPoiType.BUS, name: "Elektrownia 01", distance: 776},
        {type: OfferPoiType.BUS, name: "Elektrownia 02", distance: 778},
        {type: OfferPoiType.BUS, name: "Łąkowa 01", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku Mazowsze", distance: 1521},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 1562},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1576},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 2060},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 2116}
    ],
    17123: [
        {type: OfferPoiType.BUS, name: "Uniwersytet Ekonomiczny", distance: 139},
        {type: OfferPoiType.BUS, name: "Petrusewicza", distance: 190},
        {type: OfferPoiType.TRAM, name: "Uniwersytet Ekonomiczny", distance: 210},
        {type: OfferPoiType.BUS, name: "Sanocka", distance: 239},
        {type: OfferPoiType.TRAM, name: "Sanocka", distance: 239},
        {type: OfferPoiType.BUS, name: "Komandorska", distance: 336},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 514},
        {type: OfferPoiType.TRAM, name: "Joannitów", distance: 657},
        {type: OfferPoiType.TRAM, name: "Wielka", distance: 716},
        {type: OfferPoiType.TRAM, name: "Dworzec Autobusowy", distance: 735},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2434}
    ],
    17128: [
        {type: OfferPoiType.BUS, name: "Jachtowa 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Jachtowa 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Drohobycka 02", distance: 664},
        {type: OfferPoiType.BUS, name: "Drohobycka 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Zagórzańska 02", distance: 677},
        {type: OfferPoiType.BUS, name: "Zagórzańska 01", distance: 820}
    ],
    17130: [{type: OfferPoiType.BUS, name: "Lutynia Osiedle", distance: 514}],
    17135: [
        {type: OfferPoiType.TRAM, name: "Plac Szyrockiego", distance: 44},
        {type: OfferPoiType.BUS, name: "Plac Szyrockiego", distance: 105},
        {type: OfferPoiType.TRAM, name: "Osiedle Polonia", distance: 362},
        {type: OfferPoiType.BUS, name: "Szwoleżerów", distance: 419},
        {type: OfferPoiType.TRAM, name: "Szwoleżerów", distance: 428},
        {type: OfferPoiType.BUS, name: "Mierosławskiego", distance: 493},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Dowbór-Muśnickiego", distance: 593},
        {type: OfferPoiType.BUS, name: "Starkiewicza", distance: 698},
        {type: OfferPoiType.TRAM, name: "Starkiewicza", distance: 698},
        {type: OfferPoiType.BUS, name: "Piekary", distance: 707},
        {type: OfferPoiType.TRAM, name: "Narutowicza", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer imienia Michała Doliwo-Dobrowolskiego", distance: 1060},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 1184},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 1199},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 1524},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1614},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 2003},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 2035}
    ],
    17136: [
        {type: OfferPoiType.BUS, name: "Marysin", distance: 413},
        {type: OfferPoiType.BUS, name: "Ustronie Morskie - pętla", distance: 434}
    ],
    17137: [
        {type: OfferPoiType.BUS, name: "Grudziądzka / Urząd Miasta P+R", distance: 273},
        {type: OfferPoiType.BUS, name: "Plac Poznański", distance: 276},
        {type: OfferPoiType.BUS, name: "Garbary", distance: 401},
        {type: OfferPoiType.TRAM, name: "Garbary", distance: 403},
        {type: OfferPoiType.BUS, name: "Nowy Rynek P+R", distance: 409},
        {type: OfferPoiType.PARK, name: "Park im. Jana Henryka Dąbrowskiego", distance: 500},
        {type: OfferPoiType.PARK, name: "Skwer 18 listopada 1956 r.", distance: 504},
        {type: OfferPoiType.BUS, name: "Rondo Grunwaldzkie", distance: 545},
        {type: OfferPoiType.TRAM, name: "Focha / Opera", distance: 546},
        {type: OfferPoiType.PARK, name: "Wyspa Młyńska", distance: 556},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 566},
        {type: OfferPoiType.BUS, name: "Focha / Opera", distance: 568},
        {type: OfferPoiType.TRAM, name: "Rondo Grunwaldzkie", distance: 683},
        {type: OfferPoiType.PARK, name: "Terasy", distance: 713},
        {type: OfferPoiType.TRAM, name: "Plac Teatralny", distance: 836}
    ],
    17138: [
        {type: OfferPoiType.PARK, name: "Plac im. Jana Pawła II", distance: 340},
        {type: OfferPoiType.BUS, name: "Zagórze Gwiezdna", distance: 380},
        {type: OfferPoiType.TRAM, name: "Zagórze Gwiezdna", distance: 409},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu drogowego", distance: 484},
        {type: OfferPoiType.BUS, name: "Zagórze Rondo Jana Pawła II", distance: 617},
        {type: OfferPoiType.TRAM, name: "Zagórze Rondo Jana Pawła II", distance: 635},
        {type: OfferPoiType.BUS, name: "Klimontów Fińskie Domki", distance: 702},
        {type: OfferPoiType.BUS, name: "Zagórze Droga do Klimontowa", distance: 755},
        {type: OfferPoiType.PARK, name: "Park imienia Wandy Malczewskiej", distance: 1539},
        {type: OfferPoiType.PARK, name: "Park Środula", distance: 2100},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 2179}
    ],
    17151: [
        {type: OfferPoiType.BUS, name: "Dworzec Fordon", distance: 362},
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 470},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Fordon", distance: 500},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 572},
        {type: OfferPoiType.BUS, name: "Brzechwy / Szelburg-Zarembiny", distance: 744},
        {type: OfferPoiType.BUS, name: "Fordońska / Wiadukt", distance: 841},
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1398},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 1414},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 1977}
    ],
    17153: [
        {type: OfferPoiType.BUS, name: "Jagiellończyka", distance: 266},
        {type: OfferPoiType.BUS, name: "Saperska", distance: 597},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa", distance: 665},
        {type: OfferPoiType.BUS, name: "Plaża Miejska", distance: 747},
        {type: OfferPoiType.PARK, name: "Skwer Wolnego Tybetu", distance: 1700},
        {type: OfferPoiType.PARK, name: "Park Zielony Raj", distance: 1730},
        {type: OfferPoiType.PARK, name: "Park Podzamcze", distance: 1942},
        {type: OfferPoiType.PARK, name: "Łynostrada", distance: 2043}
    ],
    17154: [
        {type: OfferPoiType.BUS, name: "Jednorożca", distance: 596},
        {type: OfferPoiType.BUS, name: "Galaktyczna 01", distance: 692},
        {type: OfferPoiType.PARK, name: "Zieleniec Orfeusza", distance: 738},
        {type: OfferPoiType.PARK, name: "Park Diany", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Chirona", distance: 1775},
        {type: OfferPoiType.PARK, name: "Zieleniec Parterowa", distance: 2290}
    ],
    17159: [
        {type: OfferPoiType.BUS, name: "Szadółki 04", distance: 310},
        {type: OfferPoiType.BUS, name: "Szadółki 03", distance: 359},
        {type: OfferPoiType.BUS, name: "Potęgowska 01", distance: 434},
        {type: OfferPoiType.BUS, name: "Potęgowska 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Szadółki 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Szadółki 01", distance: 500},
        {type: OfferPoiType.BUS, name: "Połczyńska 01", distance: 764},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 776},
        {type: OfferPoiType.BUS, name: "Połczyńska 02", distance: 790},
        {type: OfferPoiType.BUS, name: "Przywidzka 01", distance: 845},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 2227}
    ],
    17162: [
        {type: OfferPoiType.BUS, name: "Dziwnów - Wybreże Kościuszkowskie - Słoneczna", distance: 535},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1282}
    ],
    17163: [
        {type: OfferPoiType.BUS, name: "PKP Toruńska 02", distance: 621},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 04", distance: 624},
        {type: OfferPoiType.BUS, name: "Pelcowizna 01", distance: 727},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Toruńska", distance: 738},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 03", distance: 758},
        {type: OfferPoiType.BUS, name: "Pelcowizna 06", distance: 814},
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 838},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 1095},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1533},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1738},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 2057}
    ],
    17167: [
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 237},
        {type: OfferPoiType.TRAM, name: "Zabłocie 02", distance: 254},
        {type: OfferPoiType.TRAM, name: "Zabłocie 01", distance: 261},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 314},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 317},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 371},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 440},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 612},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 650},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 04", distance: 801},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1516},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1620},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 1750},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2485}
    ],
    17168: [
        {type: OfferPoiType.BUS, name: "Otyńska", distance: 270},
        {type: OfferPoiType.BUS, name: "Fabryczna", distance: 293},
        {type: OfferPoiType.BUS, name: "Babimojska", distance: 478},
        {type: OfferPoiType.TRAM, name: "Babimojska", distance: 478},
        {type: OfferPoiType.BUS, name: "Park Biznesu", distance: 555},
        {type: OfferPoiType.TRAM, name: "Park Biznesu", distance: 565},
        {type: OfferPoiType.BUS, name: "Strzegomska 148", distance: 741},
        {type: OfferPoiType.TRAM, name: "Strzegomska 148", distance: 741},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Muchobór", distance: 756},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Jochelsona", distance: 1699},
        {type: OfferPoiType.PARK, name: "park Aleksandry Natalli-Świat", distance: 1824},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 1885}
    ],
    17170: [
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 281},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 835},
        {type: OfferPoiType.BUS, name: "Aleja Architektów", distance: 840}
    ],
    17175: [
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 622},
        {type: OfferPoiType.BUS, name: "Królewiecka (Park)", distance: 656},
        {type: OfferPoiType.BUS, name: "Suwalska", distance: 665},
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 754},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1162},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 1351}
    ],
    17176: [
        {type: OfferPoiType.BUS, name: "Psie Pole", distance: 109},
        {type: OfferPoiType.BUS, name: "Psie Pole (Gorlicka)", distance: 165},
        {type: OfferPoiType.BUS, name: "Psie Pole (Rondo Lotników Polskich)", distance: 301},
        {type: OfferPoiType.BUS, name: "Zielna", distance: 380},
        {type: OfferPoiType.BUS, name: "Mulicka", distance: 421},
        {type: OfferPoiType.PARK, name: "Park Jedności", distance: 2187}
    ],
    17177: [
        {type: OfferPoiType.BUS, name: "Cesarzowice skrz.", distance: 212},
        {type: OfferPoiType.BUS, name: "Zybiszów", distance: 810},
        {type: OfferPoiType.PARK, name: "Park Mokronoski", distance: 1510}
    ],
    17181: [
        {type: OfferPoiType.BUS, name: "Osiedle Sarni Stok", distance: 295},
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 399},
        {type: OfferPoiType.BUS, name: "Filarowa Zespół Szkół", distance: 700},
        {type: OfferPoiType.BUS, name: "Nad Potokiem Listopadowa", distance: 800},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1427},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1580},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 2245}
    ],
    17186: [
        {type: OfferPoiType.BUS, name: "Ramiszów Stacja", distance: 427},
        {type: OfferPoiType.BUS, name: "Ramiszów", distance: 552},
        {type: OfferPoiType.KOLEJ, name: "Ramiszów", distance: 591},
        {type: OfferPoiType.LAS, name: "cmentarz ewangelicki", distance: 2171}
    ],
    17189: [
        {type: OfferPoiType.BUS, name: "Opatowicka nr 127", distance: 103},
        {type: OfferPoiType.BUS, name: "Zalewowa", distance: 325},
        {type: OfferPoiType.BUS, name: "Opatowice", distance: 484},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1829}
    ],
    17190: [
        {type: OfferPoiType.BUS, name: "Opatowicka nr 127", distance: 105},
        {type: OfferPoiType.BUS, name: "Zalewowa", distance: 327},
        {type: OfferPoiType.BUS, name: "Opatowice", distance: 486},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1831}
    ],
    17193: [
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 325},
        {type: OfferPoiType.BUS, name: "Arabska", distance: 473},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 506},
        {type: OfferPoiType.BUS, name: "Bieńkowice", distance: 606},
        {type: OfferPoiType.BUS, name: "Ziemniaczana", distance: 716},
        {type: OfferPoiType.BUS, name: "Iwiny – Brochowska/Polna", distance: 813},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 1674},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2003}
    ],
    17195: [
        {type: OfferPoiType.TRAM, name: "1 Maja - 3 Maja", distance: 266},
        {type: OfferPoiType.BUS, name: "3 Maja/1 Maja", distance: 305},
        {type: OfferPoiType.BUS, name: "3 Maja/Skłodowskiej-Curie", distance: 377},
        {type: OfferPoiType.BUS, name: "Łąkowa (TBS)", distance: 405},
        {type: OfferPoiType.BUS, name: "Wchodnia (MOSIR)", distance: 441},
        {type: OfferPoiType.BUS, name: "Plac Kilińskiego", distance: 538},
        {type: OfferPoiType.BUS, name: "Długa/Skłodowskiej-Curie", distance: 562},
        {type: OfferPoiType.TRAM, name: "Pl. Kilińskiego", distance: 601},
        {type: OfferPoiType.PARK, name: "Skwer Istvána Almásiego", distance: 788},
        {type: OfferPoiType.KOLEJ, name: "Zgierz", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Tadeusza Kościuszki", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer 35 lat Samorządności", distance: 1612},
        {type: OfferPoiType.PARK, name: "Las Chełmy", distance: 2142}
    ],
    17198: [
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 82},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 86},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 359},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 375},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 458},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 485},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 489},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 497},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 540},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 02", distance: 555},
        {type: OfferPoiType.BUS, name: "Bratysławska 03", distance: 580},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 654},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 918},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1253}
    ],
    17202: [
        {type: OfferPoiType.TRAM, name: "Port Popowice", distance: 139},
        {type: OfferPoiType.BUS, name: "Port Popowice", distance: 189},
        {type: OfferPoiType.BUS, name: "Wejherowska (Hala Orbita)", distance: 308},
        {type: OfferPoiType.TRAM, name: "Wejherowska (Hala Orbita)", distance: 346},
        {type: OfferPoiType.TRAM, name: "Białowieska", distance: 395},
        {type: OfferPoiType.BUS, name: "Milenijna (Hala Orbita)", distance: 465},
        {type: OfferPoiType.BUS, name: "Kwiska", distance: 603},
        {type: OfferPoiType.BUS, name: "Park Popowicki", distance: 741},
        {type: OfferPoiType.TRAM, name: "Kwiska", distance: 758},
        {type: OfferPoiType.TRAM, name: "Park Popowicki", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Popowicki", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 1028},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 1947}
    ],
    17204: [{type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1703}],
    17207: [
        {type: OfferPoiType.BUS, name: "Słona Woda 02", distance: 192},
        {type: OfferPoiType.BUS, name: "Słona Woda 01", distance: 200},
        {type: OfferPoiType.BUS, name: "Kosocicka 01", distance: 382},
        {type: OfferPoiType.BUS, name: "Kosocicka 02", distance: 443},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 655},
        {type: OfferPoiType.BUS, name: "Rżąka 02", distance: 695},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 700},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 02", distance: 740},
        {type: OfferPoiType.BUS, name: "Węzeł Wielicki 06", distance: 767},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 01", distance: 797},
        {type: OfferPoiType.BUS, name: "Czerwiakowskiego 02", distance: 810},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 1416},
        {type: OfferPoiType.REZERWAT, name: "Las Krzyszkowicki", distance: 1671},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 2245},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 2350},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 2434}
    ],
    17213: [
        {type: OfferPoiType.BUS, name: "Obwodnica - Kcyńska", distance: 180},
        {type: OfferPoiType.BUS, name: "Chylońka - Kcyńska", distance: 180},
        {type: OfferPoiType.BUS, name: "Morska - Kcyńska", distance: 727},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 911}
    ],
    17214: [
        {type: OfferPoiType.PARK, name: "Skwer Generała Józefa Hallera", distance: 101},
        {type: OfferPoiType.BUS, name: "Władysławowo, Brzozowa", distance: 140},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Abrahama", distance: 311},
        {type: OfferPoiType.BUS, name: "Władysławowo, Sportowa", distance: 334},
        {type: OfferPoiType.BUS, name: "Władysławowo, Morska", distance: 381},
        {type: OfferPoiType.BUS, name: "Władysławowo, Kościół", distance: 518},
        {type: OfferPoiType.BUS, name: "Władysławowo Cetniewo", distance: 799},
        {type: OfferPoiType.BUS, name: "Władysławowo, Cmentarz", distance: 823},
        {type: OfferPoiType.LAS, name: 'Park "Prądy Morskie"', distance: 1117},
        {type: OfferPoiType.PARK, name: 'Park "Prądy Morskie"', distance: 1117},
        {type: OfferPoiType.PARK, name: "Baza ATOL", distance: 1427},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Słone Łąki", distance: 2293}
    ],
    17215: [
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 279},
        {type: OfferPoiType.TRAM, name: "Śmigłego Rydza - Zbiorcza", distance: 513},
        {type: OfferPoiType.BUS, name: "Śmigłego Rydza - Zbiorcza", distance: 531},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 1376},
        {type: OfferPoiType.PARK, name: "Park Źródliska II", distance: 1547},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 1694},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 1826},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1864}
    ],
    17216: [
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 03", distance: 239},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego dom studenta 04", distance: 294},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 06", distance: 307},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego dom studenta 01", distance: 309},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Powst. Warszawy 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 08", distance: 615},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 09", distance: 701},
        {type: OfferPoiType.BUS, name: "Podwisłocze / Powst. Warszawy 02", distance: 708},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy / Podwisłocze 07", distance: 713},
        {type: OfferPoiType.BUS, name: "Strażacka / Graniczna 02", distance: 754},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 764},
        {type: OfferPoiType.PARK, name: "Bulwar WSK Rzeszów", distance: 1182},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 1394},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1887},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 1950},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 2060},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Lisia Góra", distance: 2365},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 2454}
    ],
    17218: [
        {type: OfferPoiType.BUS, name: "Dworzec Główny (MDK)", distance: 221},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (Stawowa)", distance: 223},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (MDK)", distance: 257},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny", distance: 293},
        {type: OfferPoiType.BUS, name: "Dworzec Główny (Stawowa)", distance: 313},
        {type: OfferPoiType.PARK, name: "skwer Czesława Niemena", distance: 333},
        {type: OfferPoiType.BUS, name: "Dworzec Główny", distance: 339},
        {type: OfferPoiType.BUS, name: "Bastion Sakwowy", distance: 418},
        {type: OfferPoiType.TRAM, name: "Bastion Sakwowy", distance: 489},
        {type: OfferPoiType.TRAM, name: "Arkady (Capitol)", distance: 495},
        {type: OfferPoiType.BUS, name: "Dworzec Główny (Dworcowa)", distance: 498},
        {type: OfferPoiType.TRAM, name: "Dworzec Autobusowy", distance: 544},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Główny", distance: 671},
        {type: OfferPoiType.PARK, name: "skwer Spółdzielców", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 766},
        {type: OfferPoiType.PARK, name: "Ogród Staromiejski", distance: 813},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 896},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 900},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1269}
    ],
    17225: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 304},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 503},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 638},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 751},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 751},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 772},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 798},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 807},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2277}
    ],
    17235: [
        {type: OfferPoiType.BUS, name: "Aroniowa 01", distance: 77},
        {type: OfferPoiType.BUS, name: "Aroniowa 02", distance: 113},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 02", distance: 655},
        {type: OfferPoiType.BUS, name: "Mochtyńska 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Mochtyńska 01", distance: 729},
        {type: OfferPoiType.BUS, name: "Mochtyńska 03", distance: 749},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 01", distance: 758},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1508}
    ],
    17236: [
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 415},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 419},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 422},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 478},
        {type: OfferPoiType.TRAM, name: "Zabłocie 02", distance: 593},
        {type: OfferPoiType.TRAM, name: "Zabłocie 01", distance: 600},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 717},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 989},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1544},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1626},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1876}
    ],
    17239: [
        {type: OfferPoiType.BUS, name: "Talarowa 01", distance: 295},
        {type: OfferPoiType.BUS, name: "Talarowa 02", distance: 310},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 440},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 02", distance: 494},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 01", distance: 605},
        {type: OfferPoiType.BUS, name: "Leśnej Polanki 02", distance: 762},
        {type: OfferPoiType.BUS, name: "Mehoffera 04", distance: 784},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 1566},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 2021},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 2422}
    ],
    17243: [
        {type: OfferPoiType.TRAM, name: "Chorzów Teatr Rozrywki", distance: 412},
        {type: OfferPoiType.BUS, name: "Chorzów Teatr Rozrywki", distance: 418},
        {type: OfferPoiType.BUS, name: "Chorzów Liceum Katolickie", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Góra Redena", distance: 627},
        {type: OfferPoiType.TRAM, name: "Chorzów AKS", distance: 668},
        {type: OfferPoiType.BUS, name: "Chorzów Stary Szyb Prezydent", distance: 669},
        {type: OfferPoiType.BUS, name: "Chorzów AKS", distance: 673},
        {type: OfferPoiType.TRAM, name: "Chorzów Rynek", distance: 768},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Józefa Kempińskiego", distance: 803},
        {type: OfferPoiType.PARK, name: "Plac Hutników", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 878},
        {type: OfferPoiType.PARK, name: "Park Pod Kasztanami", distance: 926},
        {type: OfferPoiType.PARK, name: "Skwer Mahatmy Gandhiego", distance: 1077},
        {type: OfferPoiType.PARK, name: "Ogrody Słowaka", distance: 1083},
        {type: OfferPoiType.PARK, name: "Park Róż", distance: 1216}
    ],
    17244: [
        {type: OfferPoiType.BUS, name: "Kleczkowska", distance: 334},
        {type: OfferPoiType.TRAM, name: "Kleczkowska", distance: 346},
        {type: OfferPoiType.TRAM, name: "Most Osobowicki", distance: 662},
        {type: OfferPoiType.BUS, name: "Most Osobowicki", distance: 668},
        {type: OfferPoiType.TRAM, name: "Trzebnicka", distance: 829},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 863},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 1276}
    ],
    17247: [
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej", distance: 34},
        {type: OfferPoiType.TRAM, name: "Unii Lubelskiej", distance: 34},
        {type: OfferPoiType.TRAM, name: "Tadeuszak", distance: 274},
        {type: OfferPoiType.BUS, name: "Tadeuszak", distance: 281},
        {type: OfferPoiType.BUS, name: "Falista", distance: 343},
        {type: OfferPoiType.BUS, name: "Warowna n/ż", distance: 611},
        {type: OfferPoiType.TRAM, name: "Rondo Żegrze", distance: 620},
        {type: OfferPoiType.PARK, name: "Park na os. Armii Krajowej", distance: 1069},
        {type: OfferPoiType.PARK, name: "Park na os. Orła Białego", distance: 1674},
        {type: OfferPoiType.PARK, name: "Park Rataje", distance: 2096}
    ],
    17254: [
        {type: OfferPoiType.BUS, name: "Kielanówka cegielnia 01", distance: 425},
        {type: OfferPoiType.BUS, name: "Kielanówka cegielnia 02", distance: 479},
        {type: OfferPoiType.BUS, name: "Staroniwska / Kresowa 16", distance: 525},
        {type: OfferPoiType.BUS, name: "Staroniwska / Kresowa 11", distance: 558},
        {type: OfferPoiType.BUS, name: "Kielanówka Kopiec 03", distance: 810}
    ],
    17266: [
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Skromna", distance: 464},
        {type: OfferPoiType.BUS, name: "Zaświat / Cmentarz", distance: 466},
        {type: OfferPoiType.PARK, name: "Skwer Inwalidów Wojennych", distance: 1330},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 1765}
    ],
    17268: [
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 03", distance: 676},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Powst. Warszawy 02", distance: 695},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 08", distance: 709},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 06", distance: 742},
        {type: OfferPoiType.BUS, name: "Podwisłocze / Powst. Warszawy 02", distance: 761},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 09", distance: 772},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy / Podwisłocze 07", distance: 777},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy stadion 06", distance: 827},
        {type: OfferPoiType.PARK, name: "Bulwar WSK Rzeszów", distance: 880},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 1183},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 1213},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1591},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 1764},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Lisia Góra", distance: 2063},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2167},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 2332}
    ],
    17269: [
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 267},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 283},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 288},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 318},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 437},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 456},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 531},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 550},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 599},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 722},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1026},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1436},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2176}
    ],
    17271: [
        {type: OfferPoiType.BUS, name: "Klepacka/Wenecka", distance: 158},
        {type: OfferPoiType.BUS, name: "Klepacka/Barszczańska", distance: 184},
        {type: OfferPoiType.BUS, name: "Klepacka/Kościół", distance: 358},
        {type: OfferPoiType.BUS, name: "Klepacka", distance: 400},
        {type: OfferPoiType.BUS, name: "Klepacka/Pętla", distance: 448},
        {type: OfferPoiType.BUS, name: "Meksykańska/Watykańska", distance: 534},
        {type: OfferPoiType.BUS, name: "Meksykańska/Rumuńska", distance: 592},
        {type: OfferPoiType.BUS, name: "Klepacka/Lawendowa NŻ", distance: 632},
        {type: OfferPoiType.BUS, name: "Klepacka/Lawendowa", distance: 696},
        {type: OfferPoiType.BUS, name: "Klepacka/Graniczna", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Janiny Kurkowskiej-Spychajowej", distance: 1405},
        {type: OfferPoiType.PARK, name: "Botaniczny Park Kieszonkowy", distance: 2403}
    ],
    17277: [
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Okopowa", distance: 420},
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 548},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Sucharskiego", distance: 553},
        {type: OfferPoiType.BUS, name: "Sporna - Bracka", distance: 585},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Park Szarych Szeregów", distance: 742},
        {type: OfferPoiType.BUS, name: "Marysińska - Szklana", distance: 791},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 804},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1139},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1183},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1284},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1303},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1590},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1767}
    ],
    17279: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Brylowska 01", distance: 658},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 697},
        {type: OfferPoiType.BUS, name: "Brylowska 02", distance: 753},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1320},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1545},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1615},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1792},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1976},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 2002},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 2002},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 2077}
    ],
    17285: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 104},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 491},
        {type: OfferPoiType.TRAM, name: "Żeromskiego", distance: 528},
        {type: OfferPoiType.BUS, name: "Żeromskiego n/ż", distance: 561},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 661},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 680},
        {type: OfferPoiType.BUS, name: "Rynek Jeżycki", distance: 685},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1581},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1618},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1677},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1751},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1757},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1827},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1850},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1982},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 1998},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 2021}
    ],
    17288: [
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 40},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 125},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 157},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 227},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 267},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego NŻ", distance: 290},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 341},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Rewolucji 1905 r.", distance: 343},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kilińskiego", distance: 368},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 372},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Rewolucji 1905 r.", distance: 420},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 522},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Wschodnia", distance: 526},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 566},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 568},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 573},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 591},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 599},
        {type: OfferPoiType.BUS, name: "Jaracza - Kilińskiego", distance: 605},
        {type: OfferPoiType.BUS, name: "Północna - Nowomiejska", distance: 621},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 818},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 986},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1037}
    ],
    17289: [
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 256},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 311},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 316},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 321},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 327},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 389},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 416},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 441},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 442},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 443},
        {type: OfferPoiType.TRAM, name: "Łagiewniki 02", distance: 670},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 701},
        {type: OfferPoiType.TRAM, name: "Łagiewniki 01", distance: 701},
        {type: OfferPoiType.TRAM, name: "Łagiewniki 03", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1197},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1217},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1506},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 1572},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1725},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1797},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1949},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2184},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2310},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2363}
    ],
    17295: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 238},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 261},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 546},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 589},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 792},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 815},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 836},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1448},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1574}
    ],
    17300: [
        {type: OfferPoiType.PARK, name: "Skwer Adolfa Marii Bocheńskiego", distance: 187},
        {type: OfferPoiType.TRAM, name: "Katedra", distance: 200},
        {type: OfferPoiType.TRAM, name: "Reja", distance: 207},
        {type: OfferPoiType.BUS, name: "Reja", distance: 214},
        {type: OfferPoiType.BUS, name: "Katedra", distance: 246},
        {type: OfferPoiType.BUS, name: "Górnickiego", distance: 354},
        {type: OfferPoiType.TRAM, name: "Górnickiego", distance: 357},
        {type: OfferPoiType.TRAM, name: "Plac Grunwaldzki", distance: 469},
        {type: OfferPoiType.BUS, name: "Plac Grunwaldzki", distance: 476},
        {type: OfferPoiType.PARK, name: "Skwer Obrońców Solidarności", distance: 819},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 897},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 939},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 968},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1709}
    ],
    17305: [
        {type: OfferPoiType.BUS, name: "Plac Szembeka 08", distance: 170},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 05", distance: 257},
        {type: OfferPoiType.BUS, name: "Chłopickiego 01", distance: 309},
        {type: OfferPoiType.BUS, name: "Chłopickiego 04", distance: 312},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 03", distance: 324},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 04", distance: 336},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 01", distance: 379},
        {type: OfferPoiType.BUS, name: "Chłopickiego 03", distance: 387},
        {type: OfferPoiType.BUS, name: "Chłopickiego 02", distance: 414},
        {type: OfferPoiType.TRAM, name: "Żółkiewskiego 03", distance: 444},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 02", distance: 450},
        {type: OfferPoiType.TRAM, name: "Żółkiewskiego 04", distance: 456},
        {type: OfferPoiType.BUS, name: "Hetmańska 02", distance: 486},
        {type: OfferPoiType.BUS, name: "Żółkiewskiego 01", distance: 493},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 674},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 03", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1361},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 1563},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 2044},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2046},
        {type: OfferPoiType.PARK, name: "Park Nad Balatonem", distance: 2284},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 2345}
    ],
    17306: [
        {type: OfferPoiType.BUS, name: "Mickiewicza", distance: 186},
        {type: OfferPoiType.BUS, name: "Chrobrego", distance: 435},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 599},
        {type: OfferPoiType.BUS, name: "Cmentarz Żydowski", distance: 615},
        {type: OfferPoiType.BUS, name: "Dąbrówki", distance: 631},
        {type: OfferPoiType.BUS, name: "Serbinów", distance: 657},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 1535},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1547},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1608},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 1884}
    ],
    17316: [
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego", distance: 382},
        {type: OfferPoiType.BUS, name: "Kurpiów", distance: 623},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego", distance: 826},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 1520},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1960}
    ],
    17317: [
        {type: OfferPoiType.BUS, name: "Figowa 02", distance: 475},
        {type: OfferPoiType.BUS, name: "Figowa 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Siekierkowska 01", distance: 590},
        {type: OfferPoiType.BUS, name: "Siekierkowska 02", distance: 620},
        {type: OfferPoiType.BUS, name: "Łososiowa 53", distance: 688},
        {type: OfferPoiType.BUS, name: "Łososiowa 01", distance: 710},
        {type: OfferPoiType.BUS, name: "Batalionu AK „Bałtyk” 02", distance: 745},
        {type: OfferPoiType.BUS, name: "Ku Wiśle 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Ku Wiśle 02", distance: 760},
        {type: OfferPoiType.BUS, name: "Batalionu AK „Bałtyk” 01", distance: 764},
        {type: OfferPoiType.PARK, name: "Park Akcji „Burza”", distance: 1631},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 2212},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 2467}
    ],
    17323: [
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 164},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 170},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 400},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 506},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 589},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2367}
    ],
    17325: [
        {type: OfferPoiType.BUS, name: "Biskupa Prandoty 01", distance: 311},
        {type: OfferPoiType.BUS, name: "Biskupa Prandoty 02", distance: 387},
        {type: OfferPoiType.BUS, name: "Cmentarz Rakowicki Zachód 03", distance: 581},
        {type: OfferPoiType.BUS, name: "Cmentarz Rakowicki Zachód 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Cmentarz Rakowicki Zachód 02", distance: 691},
        {type: OfferPoiType.BUS, name: "UR al. 29 Listopada 03", distance: 699},
        {type: OfferPoiType.BUS, name: "UR al. 29 Listopada 02", distance: 733},
        {type: OfferPoiType.BUS, name: "UR al. 29 Listopada 01", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 1067},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1231},
        {type: OfferPoiType.PARK, name: "Ogród Tadeusza Kościuszki", distance: 1326},
        {type: OfferPoiType.PARK, name: "Ogród Kasztanowy", distance: 1420},
        {type: OfferPoiType.PARK, name: "Ogród Krakowianek", distance: 1510},
        {type: OfferPoiType.PARK, name: "Park Kleparski", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Palczewskiego", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Jalu Kurka", distance: 1642}
    ],
    17331: [
        {type: OfferPoiType.BUS, name: "Kościuszki 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Lelewela 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Kościuszki 02", distance: 462},
        {type: OfferPoiType.BUS, name: "Lelewela 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Popiela 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Dekerta 01", distance: 603},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 01", distance: 632},
        {type: OfferPoiType.BUS, name: "Dekerta 02", distance: 665},
        {type: OfferPoiType.BUS, name: "Popiela 01", distance: 668},
        {type: OfferPoiType.TRAM, name: "Sąd Rejonowy 01", distance: 673},
        {type: OfferPoiType.TRAM, name: "Sąd Rejonowy 02", distance: 704},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 03", distance: 745},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 1244},
        {type: OfferPoiType.REZERWAT, name: "Miasto średniowieczne w Toruniu", distance: 1772}
    ],
    17334: [
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Konstytucyjna (Wi-Ma)", distance: 256},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - CH Tulipan", distance: 262},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Konstytucyjna (Wi-Ma)", distance: 275},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Niciarniana", distance: 428},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Niciarniana", distance: 428},
        {type: OfferPoiType.BUS, name: "Niciarniana - Piłsudskiego", distance: 512},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Sarnia", distance: 517},
        {type: OfferPoiType.BUS, name: "CH Tulipan", distance: 528},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Sarnia", distance: 633},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 640},
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 1010},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1273},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 1480},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 1835},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 1964},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1988},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 2046}
    ],
    17335: [
        {type: OfferPoiType.BUS, name: "Koszutka Katowicka", distance: 13},
        {type: OfferPoiType.TRAM, name: "Koszutka Misjonarzy Oblatów", distance: 154},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 187},
        {type: OfferPoiType.BUS, name: "Koszutka GIG", distance: 218},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna", distance: 430},
        {type: OfferPoiType.BUS, name: "Koszutka Kościół", distance: 458},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 517},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna Pętla", distance: 541},
        {type: OfferPoiType.TRAM, name: "Koszutka Jesionowa", distance: 555},
        {type: OfferPoiType.BUS, name: "Koszutka Słoneczna", distance: 556},
        {type: OfferPoiType.BUS, name: "Koszutka Morcinka", distance: 614},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 623},
        {type: OfferPoiType.BUS, name: "Koszutka Kino Kosmos", distance: 651},
        {type: OfferPoiType.BUS, name: "Katowice Chorzowska", distance: 748},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 756},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 862},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1105},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1105},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 1169}
    ],
    17336: [
        {type: OfferPoiType.BUS, name: "św. Antoniego 01", distance: 246},
        {type: OfferPoiType.BUS, name: "Lisia 03", distance: 266},
        {type: OfferPoiType.BUS, name: "Myśliwska nż. 01", distance: 295},
        {type: OfferPoiType.BUS, name: "Lisia 02", distance: 352},
        {type: OfferPoiType.BUS, name: "św. Antoniego 02", distance: 380},
        {type: OfferPoiType.BUS, name: "Lisia 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Lisia nż. 04", distance: 446},
        {type: OfferPoiType.BUS, name: "Liliowa nż. 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Krucza nż. 01", distance: 628},
        {type: OfferPoiType.BUS, name: "Jastrzębia nż. 01", distance: 705},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1144},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1633},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 2013},
        {type: OfferPoiType.PARK, name: "Park na Bielanach", distance: 2193}
    ],
    17349: [
        {type: OfferPoiType.BUS, name: "Legionów - Farbiarska", distance: 214},
        {type: OfferPoiType.BUS, name: "Legionów - działki", distance: 250},
        {type: OfferPoiType.BUS, name: "Farbiarska - Legionów", distance: 266},
        {type: OfferPoiType.BUS, name: "Farbiarska - działki", distance: 286},
        {type: OfferPoiType.LAS, name: "Park Bulwary", distance: 394},
        {type: OfferPoiType.PARK, name: "Park Bulwary", distance: 394},
        {type: OfferPoiType.BUS, name: "gen. Bema - gen. Hallera", distance: 475},
        {type: OfferPoiType.BUS, name: "gen. Bema - Fabryczna", distance: 506},
        {type: OfferPoiType.BUS, name: "gen. Hallera 2", distance: 563},
        {type: OfferPoiType.BUS, name: "Legionów - szkoła", distance: 607},
        {type: OfferPoiType.BUS, name: "gen. Hallera 23", distance: 721},
        {type: OfferPoiType.PARK, name: "Park im. Stefanii i Juliana Tuwimów", distance: 786},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 1175},
        {type: OfferPoiType.PARK, name: "Pałac Ostrowskich", distance: 1193},
        {type: OfferPoiType.LAS, name: "Park Solidarności", distance: 1335},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1335},
        {type: OfferPoiType.LAS, name: "Skwer Powstań Narodowych", distance: 1476},
        {type: OfferPoiType.LAS, name: "Park imienia doktora medycyny Jana Rodego", distance: 1498}
    ],
    17364: [
        {type: OfferPoiType.BUS, name: "Dworzec Główny (Dworcowa)", distance: 191},
        {type: OfferPoiType.BUS, name: "Dworzec Główny", distance: 200},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny", distance: 203},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (MDK)", distance: 268},
        {type: OfferPoiType.BUS, name: "Dworzec Główny (MDK)", distance: 270},
        {type: OfferPoiType.TRAM, name: "Bastion Sakwowy", distance: 378},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (Stawowa)", distance: 409},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Główny", distance: 482},
        {type: OfferPoiType.PARK, name: "skwer Czesława Niemena", distance: 495},
        {type: OfferPoiType.TRAM, name: "Park Staromiejski", distance: 538},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 609},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 696},
        {type: OfferPoiType.PARK, name: "Ogród Staromiejski", distance: 743},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 785},
        {type: OfferPoiType.PARK, name: "skwer Spółdzielców", distance: 888},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 955},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1196}
    ],
    17367: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Armii Krajowej 02", distance: 344},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 02", distance: 705},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 01", distance: 763},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1418},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1424},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1525},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1656},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1777},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1835},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1894},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1981}
    ],
    17368: [
        {type: OfferPoiType.BUS, name: "Rezedowa 02", distance: 206},
        {type: OfferPoiType.BUS, name: "Rezedowa 01", distance: 265},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 02", distance: 308},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Gocławek", distance: 322},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Okularowa 04", distance: 495},
        {type: OfferPoiType.BUS, name: "Okularowa 02", distance: 597},
        {type: OfferPoiType.BUS, name: "Okularowa 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Łysakowska 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Łysakowska 02", distance: 675},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 03", distance: 682},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 1201},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 1414},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 1801},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 1990},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 2085}
    ],
    17376: [
        {type: OfferPoiType.BUS, name: "Mennica 03", distance: 115},
        {type: OfferPoiType.BUS, name: "Mennica 52", distance: 163},
        {type: OfferPoiType.BUS, name: "Mennica 04", distance: 172},
        {type: OfferPoiType.BUS, name: "Norblin 06", distance: 189},
        {type: OfferPoiType.BUS, name: "Mennica 02", distance: 211},
        {type: OfferPoiType.BUS, name: "Mennica 01", distance: 253},
        {type: OfferPoiType.TRAM, name: "Norblin 04", distance: 258},
        {type: OfferPoiType.BUS, name: "Norblin 05", distance: 269},
        {type: OfferPoiType.BUS, name: "Norblin 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Norblin 02", distance: 303},
        {type: OfferPoiType.TRAM, name: "Norblin 03", distance: 306},
        {type: OfferPoiType.BUS, name: "Wronia 01", distance: 363},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 08", distance: 538},
        {type: OfferPoiType.METRO, name: "Rondo ONZ", distance: 594},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 596},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 609},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 04", distance: 621},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 661},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 03", distance: 702},
        {type: OfferPoiType.TRAM, name: "Muzeum Powstania Warszawskiego 06", distance: 740},
        {type: OfferPoiType.TRAM, name: "Muzeum Powstania Warszawskiego 05", distance: 753},
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 03", distance: 760},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 766},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 56", distance: 775},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 05", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Mirowski", distance: 984},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 998},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 1130},
        {type: OfferPoiType.PARK, name: "Park Świętokrzyski", distance: 1169}
    ],
    17383: [{type: OfferPoiType.BUS, name: "Mała Wieś Skrzyżowanie", distance: 581}],
    17384: [{type: OfferPoiType.BUS, name: "Mała Wieś Skrzyżowanie", distance: 685}],
    17387: [
        {type: OfferPoiType.BUS, name: "Brzezińska - Kerna NŻ", distance: 288},
        {type: OfferPoiType.BUS, name: "Brzezińska - Janosika", distance: 342},
        {type: OfferPoiType.BUS, name: "Kerna - Brzezińska", distance: 402},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 522},
        {type: OfferPoiType.BUS, name: "Brzezińska - CH M1", distance: 650},
        {type: OfferPoiType.BUS, name: "Janosika - Powstańców Śląskich", distance: 777},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 2361},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 2460}
    ],
    17397: [
        {type: OfferPoiType.BUS, name: "Miodowicza", distance: 140},
        {type: OfferPoiType.BUS, name: "Jana Pawła II", distance: 156},
        {type: OfferPoiType.BUS, name: "Krakowska / Jana Pawła II", distance: 186},
        {type: OfferPoiType.BUS, name: "Ściegiennego WDK", distance: 210},
        {type: OfferPoiType.BUS, name: "Wojska Pol./Langiewicza", distance: 326},
        {type: OfferPoiType.BUS, name: "Rogatka Krakowska", distance: 357},
        {type: OfferPoiType.BUS, name: "Krakowska UJK", distance: 399},
        {type: OfferPoiType.BUS, name: "Jana Pawła II / Ogrodowa", distance: 415},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego / Żeromskiego", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Żeromskiego", distance: 649},
        {type: OfferPoiType.PARK, name: "Skwer Harcerski im. Szarych Szeregów", distance: 726},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Ofiar Katynia", distance: 845},
        {type: OfferPoiType.PARK, name: "Park im. Stanisława Staszica", distance: 856},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Bularskiego", distance: 907},
        {type: OfferPoiType.PARK, name: "Skwer Wolontariuszy", distance: 957},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1035},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1143},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kadzielnia", distance: 1407},
        {type: OfferPoiType.REZERWAT, name: "Wietrznia", distance: 1698},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Wietrznia im. Z. Rubinowskiego", distance: 1890}
    ],
    17398: [
        {type: OfferPoiType.BUS, name: "Struga / Zbrowskiego 10", distance: 88},
        {type: OfferPoiType.BUS, name: "Struga / Zbrowskiego 07", distance: 94},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Olsztyńska 04", distance: 289},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Olsztyńska 05", distance: 316},
        {type: OfferPoiType.BUS, name: "Struga / 25 Czerwca 08", distance: 358},
        {type: OfferPoiType.BUS, name: "Struga / Szklana 09", distance: 372},
        {type: OfferPoiType.BUS, name: "Żwirki i Wigury / Struga 02", distance: 497},
        {type: OfferPoiType.BUS, name: "25 Czerwca / Struga 05", distance: 498},
        {type: OfferPoiType.BUS, name: "Struga / 25 Czerwca 05", distance: 513},
        {type: OfferPoiType.BUS, name: "Szklana / Struga", distance: 513}
    ],
    17400: [
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 08", distance: 219},
        {type: OfferPoiType.BUS, name: "Ustronie / Radomskiego", distance: 303},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 05", distance: 316},
        {type: OfferPoiType.BUS, name: "Biała / Indycza (Tymczasowy)", distance: 418},
        {type: OfferPoiType.BUS, name: "Wyścigowa / Radomskiego", distance: 466},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 06", distance: 526},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Słowackiego 07", distance: 555},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 03", distance: 674},
        {type: OfferPoiType.PARK, name: "Park Ustronie", distance: 1661},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Ruzika", distance: 1912},
        {type: OfferPoiType.PARK, name: "Sadek", distance: 2139},
        {type: OfferPoiType.PARK, name: "Plac Kazimierza Ołdakowskiego", distance: 2213}
    ],
    17401: [
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Orląt Lwowskich 08", distance: 484},
        {type: OfferPoiType.BUS, name: "Os. Gołębiów II / Paderewskiego 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Os. Gołębiów II / Paderewskiego 02", distance: 573},
        {type: OfferPoiType.BUS, name: "Os. Gołębiów II / Paderewskiego 04", distance: 599},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Gołębiowska (NŻ) 09", distance: 660},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Zientarskiego 07", distance: 665},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Zientarskiego 06", distance: 757},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Gołębiowska (NŻ) 10", distance: 769},
        {type: OfferPoiType.PARK, name: "Park Gołębiów", distance: 807}
    ],
    17409: [
        {type: OfferPoiType.BUS, name: "Bluszczowa 02", distance: 585},
        {type: OfferPoiType.BUS, name: "Bluszczowa 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Narcyzowa 02", distance: 733}
    ],
    17410: [
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 63},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 108},
        {type: OfferPoiType.BUS, name: "Starego Wiarusa 04", distance: 405},
        {type: OfferPoiType.BUS, name: "Starego Wiarusa 01", distance: 492},
        {type: OfferPoiType.BUS, name: "Zielonki Słoneczna", distance: 498},
        {type: OfferPoiType.BUS, name: "Starego Wiarusa 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 02", distance: 721},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 03", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1628},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 2108},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 2493},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2514}
    ],
    17413: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 653},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 822},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 1056},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 1087},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1650},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1909},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2294}
    ],
    17414: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 469},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 552},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 656},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 675},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 680},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 682},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1365},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1410},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1470},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1781},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1958},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2155},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2169},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 2335}
    ],
    17419: [
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 185},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 03", distance: 261},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 295},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 466},
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 612},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 696},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 706},
        {type: OfferPoiType.BUS, name: "Kamykowa 01", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1370}
    ],
    17420: [
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 01", distance: 47},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 03", distance: 50},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 02", distance: 95},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 126},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 187},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 234},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 291},
        {type: OfferPoiType.BUS, name: "Pucciniego 02", distance: 297},
        {type: OfferPoiType.BUS, name: "Pucciniego 01", distance: 360},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 521}
    ],
    17421: [
        {type: OfferPoiType.BUS, name: "Kłosowa 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Stogi 06", distance: 486},
        {type: OfferPoiType.BUS, name: "Stogi 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Sówki 01", distance: 665},
        {type: OfferPoiType.BUS, name: "Stogi 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Sówki 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Rozłogi 02", distance: 755}
    ],
    17422: [
        {type: OfferPoiType.BUS, name: "Gliwice Sobieskiego", distance: 739},
        {type: OfferPoiType.PARK, name: "Wilcze Doły", distance: 762},
        {type: OfferPoiType.BUS, name: "Gliwice Słowackiego", distance: 826},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1116}
    ],
    17429: [
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska", distance: 359},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 367},
        {type: OfferPoiType.BUS, name: "Katowice AWF", distance: 400},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Szpital", distance: 616},
        {type: OfferPoiType.TRAM, name: "Katowice Stadion AWF", distance: 623},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 716},
        {type: OfferPoiType.TRAM, name: "Katowice Jordana", distance: 747},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 954},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 973},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1019},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1166}
    ],
    17434: [
        {type: OfferPoiType.BUS, name: "Płowiecka 04", distance: 309},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 02", distance: 430},
        {type: OfferPoiType.BUS, name: "Świecka 01", distance: 451},
        {type: OfferPoiType.BUS, name: "Płowiecka 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Płowiecka 03", distance: 519},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Gocławek", distance: 539},
        {type: OfferPoiType.BUS, name: "Płowiecka 02", distance: 545},
        {type: OfferPoiType.BUS, name: "Płowiecka 06", distance: 548},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 01", distance: 621},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 03", distance: 712},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 04", distance: 715},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 1148},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 1434},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 1628},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1817},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 2063},
        {type: OfferPoiType.PARK, name: "Park/Ogród przy Kościele", distance: 2468}
    ],
    17435: [
        {type: OfferPoiType.BUS, name: 'Rumia C.H. "Port Rumia" 01', distance: 666},
        {type: OfferPoiType.BUS, name: "Rumia, CH Port Rumia - Grunwaldzka", distance: 706},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 2366}
    ],
    17437: [
        {type: OfferPoiType.LAS, name: "Jarugi", distance: 1456},
        {type: OfferPoiType.PARK, name: "Park Weglin", distance: 1922}
    ],
    17438: [
        {type: OfferPoiType.BUS, name: "Strachowicka", distance: 453},
        {type: OfferPoiType.PARK, name: "Park Żernicki", distance: 604},
        {type: OfferPoiType.PARK, name: "Żernicki Park Sportu i Rekreacji", distance: 630},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Żerniki", distance: 693},
        {type: OfferPoiType.BUS, name: "Żernicka", distance: 784},
        {type: OfferPoiType.PARK, name: "skwer Księdza Justyna Kostka", distance: 860},
        {type: OfferPoiType.PARK, name: "Park Strachowicki", distance: 2028}
    ],
    17443: [
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 137},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 219},
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 219},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 564},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 602},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 614},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 621},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 03", distance: 642},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 676},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1751}
    ],
    17444: [
        {type: OfferPoiType.BUS, name: "Dominów - Urząd Gminy 02", distance: 219},
        {type: OfferPoiType.BUS, name: "Dominów - Urząd Gminy 01", distance: 300},
        {type: OfferPoiType.BUS, name: "Dominów - skrzyżowanie 01", distance: 518},
        {type: OfferPoiType.BUS, name: "Kolonia Dominów NŻ 02", distance: 600},
        {type: OfferPoiType.BUS, name: "Dominów - skrzyżowanie 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Kolonia Dominów NŻ 01", distance: 660}
    ],
    17449: [
        {type: OfferPoiType.BUS, name: "Sudecka", distance: 427},
        {type: OfferPoiType.BUS, name: "Drukarska", distance: 596},
        {type: OfferPoiType.TRAM, name: "Sztabowa", distance: 617},
        {type: OfferPoiType.BUS, name: "Sztabowa", distance: 629},
        {type: OfferPoiType.BUS, name: "Wiśniowa", distance: 680},
        {type: OfferPoiType.TRAM, name: "Rondo", distance: 738},
        {type: OfferPoiType.BUS, name: "Hallera", distance: 745},
        {type: OfferPoiType.TRAM, name: "Wiśniowa", distance: 755},
        {type: OfferPoiType.TRAM, name: "Hallera", distance: 757},
        {type: OfferPoiType.PARK, name: "park Tadeusza Różewicza", distance: 816}
    ],
    17450: [
        {type: OfferPoiType.BUS, name: "Składowa", distance: 101},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Łasztownia", distance: 277},
        {type: OfferPoiType.BUS, name: "SKM Łasztownia", distance: 323},
        {type: OfferPoiType.BUS, name: "Celna", distance: 395},
        {type: OfferPoiType.TRAM, name: "Celna", distance: 550},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego", distance: 757},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 1083},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1199},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1714},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1857},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 2136},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2136},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 2162},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 2342},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 2483}
    ],
    17457: [
        {type: OfferPoiType.TRAM, name: "Zabrze Plac Teatralny", distance: 271},
        {type: OfferPoiType.BUS, name: "Zabrze Plac Teatralny", distance: 308},
        {type: OfferPoiType.TRAM, name: "Zabrze Prof. Religi", distance: 442},
        {type: OfferPoiType.TRAM, name: "Zabrze Karola Miarki", distance: 491},
        {type: OfferPoiType.PARK, name: "Skwer Dawców Drugiego Życia", distance: 547},
        {type: OfferPoiType.BUS, name: "Zabrze ŚCCS", distance: 554},
        {type: OfferPoiType.TRAM, name: "Zabrze Plac Wolności", distance: 557},
        {type: OfferPoiType.BUS, name: "Zabrze Szpitalna", distance: 674},
        {type: OfferPoiType.BUS, name: "Zabrze Chełmońskiego", distance: 692},
        {type: OfferPoiType.BUS, name: "Zabrze Gdańska", distance: 769},
        {type: OfferPoiType.BUS, name: "Zabrze Cieszyńska", distance: 779},
        {type: OfferPoiType.BUS, name: "Zabrze Curie-Skłodowskiej", distance: 798},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 896},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 960},
        {type: OfferPoiType.PARK, name: "Park imienia Jacka Kuronia", distance: 1196},
        {type: OfferPoiType.PARK, name: "Skwer Wielowiekowej Przyjaźni Polsko-Ormiańskiej", distance: 1275},
        {type: OfferPoiType.PARK, name: "Park Kościuszki", distance: 1581}
    ],
    17461: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 496},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 504},
        {type: OfferPoiType.BUS, name: "Wilczy Młyn", distance: 733},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 1199},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 1315},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1752},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2146},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 2258},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2427}
    ],
    17462: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 483},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 491},
        {type: OfferPoiType.BUS, name: "Wilczy Młyn", distance: 720},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 1186},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 1302},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1374},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1739},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2133},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 2245},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2414}
    ],
    17463: [
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 122},
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 132},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 184},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 200},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 258},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 314},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 322},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 383},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 386},
        {type: OfferPoiType.BUS, name: "Bratysławska 03", distance: 481},
        {type: OfferPoiType.BUS, name: "Krowodrza Górka P+R 05", distance: 546},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 560},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 02", distance: 677},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 03", distance: 707},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 712},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 01", distance: 732},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R", distance: 745},
        {type: OfferPoiType.TRAM, name: "Szpital Narutowicza 01", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 826},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 930},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1037},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1078}
    ],
    17464: [
        {type: OfferPoiType.BUS, name: "Krakowska galeria 05", distance: 251},
        {type: OfferPoiType.BUS, name: "Krakowska galeria 06", distance: 384},
        {type: OfferPoiType.BUS, name: "Ofiar Katynia galeria 06", distance: 401},
        {type: OfferPoiType.BUS, name: "Ofiar Katynia park 03", distance: 439},
        {type: OfferPoiType.BUS, name: "Krakowska / Wyzwolenia 08", distance: 448},
        {type: OfferPoiType.BUS, name: "Krakowska / Mielecka 07", distance: 455},
        {type: OfferPoiType.BUS, name: "Kotuli / Ustrzycka 02", distance: 470},
        {type: OfferPoiType.BUS, name: "Mikołajczyka pętla 03", distance: 478},
        {type: OfferPoiType.BUS, name: "Mikołajczyka pętla 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Kotuli / Zbyszewskiego 01", distance: 580},
        {type: OfferPoiType.PARK, name: "Park Sybiraków", distance: 725},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 1270},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 1275},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1675},
        {type: OfferPoiType.PARK, name: "Ogród Kieszonkowy", distance: 1742},
        {type: OfferPoiType.PARK, name: "Skwer prof. dr hab. n. med. Lesława Grzegorczyka", distance: 1903}
    ],
    17482: [
        {type: OfferPoiType.BUS, name: "Akademicka / Kaliskiego", distance: 348},
        {type: OfferPoiType.TRAM, name: "Akademicka / Kaliskiego", distance: 434},
        {type: OfferPoiType.BUS, name: "Kaliskiego / Politechnika", distance: 449},
        {type: OfferPoiType.BUS, name: "Kaliskiego / Akademicka", distance: 460},
        {type: OfferPoiType.TRAM, name: "Akademicka / Igrzyskowa", distance: 758},
        {type: OfferPoiType.BUS, name: "Akademicka / Igrzyskowa", distance: 779},
        {type: OfferPoiType.TRAM, name: "Przylesie P+R", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1342},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 1795},
        {type: OfferPoiType.PARK, name: "Dolina Śmierci", distance: 1935},
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 1965}
    ],
    17486: [
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 152},
        {type: OfferPoiType.BUS, name: "Centum Przesiadkowe Bałtycka", distance: 268},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Stadion", distance: 342},
        {type: OfferPoiType.BUS, name: "Bałtycka przy Wylotowej", distance: 499},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 619},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Żurawiej", distance: 621},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 929},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1088},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1200},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1200},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1361},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 1401},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1701}
    ],
    17487: [
        {type: OfferPoiType.BUS, name: "Trałowa Szkoła 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Boguckiego 02", distance: 511},
        {type: OfferPoiType.BUS, name: "Boguckiego 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Trałowa Szkoła 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Kempingowa 02", distance: 795},
        {type: OfferPoiType.LAS, name: "Las Mierzei", distance: 2285}
    ],
    17493: [
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 83},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 03", distance: 238},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Malborska Szkoła 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Malborska Szkoła 01", distance: 360},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 436},
        {type: OfferPoiType.BUS, name: "Pszenna 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 04", distance: 461},
        {type: OfferPoiType.BUS, name: "Pszenna 02", distance: 512},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 03", distance: 558},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 01", distance: 593},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1258},
        {type: OfferPoiType.PARK, name: "Baśniowy Ogród", distance: 1408},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1455},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2471}
    ],
    17498: [
        {type: OfferPoiType.BUS, name: "Półłanki 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Półłanki 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Szparagowa 01", distance: 580},
        {type: OfferPoiType.BUS, name: "Szparagowa 04", distance: 591},
        {type: OfferPoiType.BUS, name: "Półłanki 03", distance: 593},
        {type: OfferPoiType.BUS, name: "Półłanki 04", distance: 594},
        {type: OfferPoiType.BUS, name: "Szparagowa 06", distance: 692},
        {type: OfferPoiType.BUS, name: "Szparagowa 02", distance: 699},
        {type: OfferPoiType.REZERWAT, name: "Rybitwy", distance: 1167},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Cegielni", distance: 1879},
        {type: OfferPoiType.PARK, name: "Park Zielone Serce Podgórza", distance: 1955}
    ],
    17507: [
        {type: OfferPoiType.BUS, name: "Gęsia 02", distance: 780},
        {type: OfferPoiType.BUS, name: "Gęsia 01", distance: 799},
        {type: OfferPoiType.LAS, name: "Jarugi", distance: 1197},
        {type: OfferPoiType.PARK, name: "Park Weglin", distance: 1770}
    ],
    17510: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Dw. PKP", distance: 310},
        {type: OfferPoiType.KOLEJ, name: "Grodzisk Mazowiecki", distance: 319},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta", distance: 432},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Dw. PKP", distance: 471},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. DSI Malwa", distance: 585},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Przychodnia", distance: 690},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 752},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Piłsudskiego", distance: 1161},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1352},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1524},
        {type: OfferPoiType.PARK, name: "Park Marii Michalak", distance: 1848},
        {type: OfferPoiType.PARK, name: "Park nad Rokitnicą", distance: 1907},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 1926},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 2013}
    ],
    17514: [
        {type: OfferPoiType.BUS, name: "Dw. Północny", distance: 358},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 390},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 394},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego NŻ", distance: 415},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 430},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 430},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 452},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 550},
        {type: OfferPoiType.BUS, name: "Źródłowa - Wojska Polskiego NŻ", distance: 576},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 583},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Franciszkańska", distance: 605},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Marynarska", distance: 616},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 620},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Franciszkańska", distance: 630},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Marynarska", distance: 641},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 647},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 815},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 880},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 941}
    ],
    17525: [
        {type: OfferPoiType.BUS, name: "Tuszyńska - Paderewskiego NŻ", distance: 110},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Tuszyńska", distance: 222},
        {type: OfferPoiType.BUS, name: "Paderewskiego - Tuszyńska", distance: 237},
        {type: OfferPoiType.BUS, name: "Tuszyńska - Piaseczna NŻ", distance: 261},
        {type: OfferPoiType.PARK, name: "Skwer im. Henryka Dubaniewicza", distance: 340},
        {type: OfferPoiType.BUS, name: "Paderewskiego - Rzgowska", distance: 510},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Rzgowska", distance: 521},
        {type: OfferPoiType.BUS, name: "Rzgowska - Paderewskiego", distance: 566},
        {type: OfferPoiType.BUS, name: "Piastów Kurak", distance: 589},
        {type: OfferPoiType.BUS, name: "Paderewskiego - Karpacka", distance: 591},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Karpacka", distance: 610},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Zaolziańska", distance: 817},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 980},
        {type: OfferPoiType.PARK, name: "Park Miejski przy ul. Leczniczej", distance: 985},
        {type: OfferPoiType.PARK, name: "Borek Józefa Lissnera", distance: 1040},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1182},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1313},
        {type: OfferPoiType.PARK, name: "Park Zatorze", distance: 1339},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1487},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1558}
    ],
    17526: [
        {type: OfferPoiType.BUS, name: "Cystersów 03", distance: 323},
        {type: OfferPoiType.TRAM, name: "Cystersów 01", distance: 420},
        {type: OfferPoiType.TRAM, name: "Cystersów 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Fabryczna 06", distance: 493},
        {type: OfferPoiType.BUS, name: "Fabryczna 05", distance: 518},
        {type: OfferPoiType.TRAM, name: "Fabryczna 01", distance: 600},
        {type: OfferPoiType.TRAM, name: "Fabryczna 02", distance: 613},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 653},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 669},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Nullo 03", distance: 735},
        {type: OfferPoiType.PARK, name: "Ogród Fabryczny", distance: 738},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 789},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 07", distance: 810},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 818},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 852},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Polaków Poszkodowanych przez III Rzeszę", distance: 1027},
        {type: OfferPoiType.PARK, name: "Skwer Pilota Pirxa", distance: 1623},
        {type: OfferPoiType.PARK, name: "Ogród Kasztanowy", distance: 1723},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2232}
    ],
    17527: [
        {type: OfferPoiType.BUS, name: "Imbramowska 02", distance: 258},
        {type: OfferPoiType.BUS, name: "Imbramowska 01", distance: 307},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 04", distance: 406},
        {type: OfferPoiType.BUS, name: "Żmujdzka 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 03", distance: 591},
        {type: OfferPoiType.BUS, name: "Mackiewicza 01", distance: 608},
        {type: OfferPoiType.BUS, name: "Mackiewicza 02", distance: 623},
        {type: OfferPoiType.BUS, name: "Mackiewicza 03", distance: 627},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 02", distance: 642},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 919},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 930},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 971},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1154}
    ],
    17537: [
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 183},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 698},
        {type: OfferPoiType.BUS, name: "Aleja Architektów", distance: 703},
        {type: OfferPoiType.TRAM, name: "Aleja Architektów", distance: 712},
        {type: OfferPoiType.BUS, name: "Grabowa", distance: 736},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 2387}
    ],
    17539: [
        {type: OfferPoiType.BUS, name: "Władysława Hermana 02", distance: 214},
        {type: OfferPoiType.BUS, name: "Władysława Hermana 01", distance: 270},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 278},
        {type: OfferPoiType.BUS, name: "Henryka Brodatego 02", distance: 337},
        {type: OfferPoiType.BUS, name: "Henryka Brodatego 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Królowej Bony 01", distance: 482},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 502},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 508},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 617},
        {type: OfferPoiType.BUS, name: "Keniga 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Śmigielska 02", distance: 645},
        {type: OfferPoiType.BUS, name: "Ursus-Sanktuarium 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Ursus-Sanktuarium 02", distance: 673},
        {type: OfferPoiType.BUS, name: "Królowej Bony 02", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1059},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1105}
    ],
    17541: [
        {type: OfferPoiType.BUS, name: "Bonarka SKA 01", distance: 297},
        {type: OfferPoiType.KOLEJ, name: "Kraków Bonarka", distance: 581},
        {type: OfferPoiType.BUS, name: "Bonarka SKA 02", distance: 597},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 665},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 671},
        {type: OfferPoiType.BUS, name: "Kamieńskiego Wiadukt 02", distance: 685},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 745},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 756},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 764},
        {type: OfferPoiType.BUS, name: "Kamieńskiego Wiadukt 01", distance: 794},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 900},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 949},
        {type: OfferPoiType.PARK, name: "Park w Łagiewnikach", distance: 1209},
        {type: OfferPoiType.PARK, name: "Magnoliowy zakątek", distance: 1223},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1427},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1625},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1914},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2233}
    ],
    17548: [
        {type: OfferPoiType.BUS, name: "Górka Pychowicka 02", distance: 311},
        {type: OfferPoiType.BUS, name: "Fort Bodzów 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Fort Bodzów 02", distance: 639},
        {type: OfferPoiType.PARK, name: "Ogród krzewowy", distance: 1580},
        {type: OfferPoiType.REZERWAT, name: "Staw Królówka", distance: 1743}
    ],
    17554: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 488},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 623},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 736},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 736},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 783},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 792},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2262},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2465}
    ],
    17555: [
        {type: OfferPoiType.BUS, name: "Zielińskiego", distance: 283},
        {type: OfferPoiType.TRAM, name: "Wielka", distance: 412},
        {type: OfferPoiType.BUS, name: "Wielka", distance: 413},
        {type: OfferPoiType.TRAM, name: "Zaolziańska", distance: 433},
        {type: OfferPoiType.BUS, name: "Plac Hirszfelda", distance: 448},
        {type: OfferPoiType.BUS, name: "Zaolziańska", distance: 458},
        {type: OfferPoiType.BUS, name: "Zaporoska", distance: 478},
        {type: OfferPoiType.BUS, name: "Gwiaździsta", distance: 538},
        {type: OfferPoiType.PARK, name: "Skwer Ptasi Zagajnik", distance: 791},
        {type: OfferPoiType.TRAM, name: "Rondo", distance: 805},
        {type: OfferPoiType.TRAM, name: "Arkady (Capitol)", distance: 817},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2107}
    ],
    17561: [
        {type: OfferPoiType.BUS, name: "Gaj", distance: 87},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 200},
        {type: OfferPoiType.TRAM, name: "Świeradowska", distance: 230},
        {type: OfferPoiType.BUS, name: "Świeradowska", distance: 231},
        {type: OfferPoiType.BUS, name: "Gaj – pętla", distance: 494},
        {type: OfferPoiType.TRAM, name: "Morwowa", distance: 572},
        {type: OfferPoiType.BUS, name: "Morwowa", distance: 654},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1367},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1420},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 2051}
    ],
    17562: [
        {type: OfferPoiType.BUS, name: "Obrońców Tobruku 02", distance: 182},
        {type: OfferPoiType.BUS, name: "Obrońców Tobruku 03", distance: 215},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 01", distance: 249},
        {type: OfferPoiType.BUS, name: "Obrońców Tobruku 01", distance: 250},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 04", distance: 415},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 02", distance: 460},
        {type: OfferPoiType.BUS, name: "Niedzielskiego 01", distance: 540},
        {type: OfferPoiType.BUS, name: "Niedzielskiego 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Galla Anonima 01", distance: 617},
        {type: OfferPoiType.BUS, name: "Magiera 01", distance: 742},
        {type: OfferPoiType.TRAM, name: "Piaski 03", distance: 837},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1131},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1264},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1374},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1784},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 1901},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1932}
    ],
    17564: [
        {type: OfferPoiType.BUS, name: "Odrzykońska / Bł. Karoliny 02", distance: 248},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny przedszkole 06", distance: 400},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny pętla 09", distance: 402},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny przedszkole 07", distance: 503},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 584},
        {type: OfferPoiType.BUS, name: "Odrzykońska / Baligrodzka 04", distance: 621},
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 02", distance: 656},
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 01", distance: 670},
        {type: OfferPoiType.BUS, name: "Odrzykońska / Iwonicka 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny / Nowosądecka 05", distance: 790},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 1328},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 2000}
    ],
    17566: [
        {type: OfferPoiType.BUS, name: "Wolany - Polanica Górna", distance: 557},
        {type: OfferPoiType.BUS, name: "Zdrojowa/Leśna", distance: 593},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1216},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1228}
    ],
    17571: [
        {type: OfferPoiType.TRAM, name: "Długa (ogrody działkowe)", distance: 506},
        {type: OfferPoiType.BUS, name: "Długa (ogrody działkowe)", distance: 520},
        {type: OfferPoiType.BUS, name: "Wrocław Szczepin", distance: 553},
        {type: OfferPoiType.TRAM, name: "Wrocław Szczepin", distance: 553},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Szczepin", distance: 565},
        {type: OfferPoiType.PARK, name: "skwer Świętego Ojca Damiana de Veuster", distance: 1236}
    ],
    17578: [
        {type: OfferPoiType.BUS, name: "Przytycka / Malczewskiej (NŻ) 01", distance: 195},
        {type: OfferPoiType.BUS, name: "Przytycka / Malczewskiej (NŻ) 02", distance: 250},
        {type: OfferPoiType.BUS, name: "Malczewskiej / Langiewicza 02", distance: 527},
        {type: OfferPoiType.BUS, name: "Malczewskiej / Langiewicza 01", distance: 530},
        {type: OfferPoiType.BUS, name: "Listopadowa / al. Róż (NŻ) 01", distance: 644},
        {type: OfferPoiType.BUS, name: "Kielecka / Przytycka 02", distance: 660},
        {type: OfferPoiType.BUS, name: "Przytycka / Uniwersytecka 03", distance: 682},
        {type: OfferPoiType.BUS, name: "Kielecka / Przytycka 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Langiewicza / al. Róż (NŻ) 02", distance: 736},
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Przytycka 02", distance: 747},
        {type: OfferPoiType.PARK, name: "Bulwary nad Mleczną", distance: 1655},
        {type: OfferPoiType.PARK, name: "Park Stary Ogród", distance: 2141},
        {type: OfferPoiType.PARK, name: "Plac ks. Zdzisława Domagały (Zremb)", distance: 2229}
    ],
    17580: [
        {type: OfferPoiType.BUS, name: "Żerniki Wrocławskie", distance: 254},
        {type: OfferPoiType.BUS, name: "Żerniki Wr. – Orla", distance: 532},
        {type: OfferPoiType.BUS, name: "Żerniki Wr. – Kolejowa", distance: 772}
    ],
    17587: [
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 267},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 354},
        {type: OfferPoiType.BUS, name: "Tuwima - Kilińskiego (EC1 Centr. Nauki)", distance: 355},
        {type: OfferPoiType.BUS, name: "Pl. Szoslanda - EC1 Centrum Nauki i Techniki", distance: 386},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Nawrot", distance: 401},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Nawrot", distance: 405},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 408},
        {type: OfferPoiType.BUS, name: "Nawrot - Targowa", distance: 420},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 423},
        {type: OfferPoiType.BUS, name: "Nawrot - Kilińskiego", distance: 440},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Tuwima", distance: 498},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Kilińskiego", distance: 598},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 635},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Piłsudskiego", distance: 651},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 677},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 682},
        {type: OfferPoiType.BUS, name: "Nawrot - Wysoka", distance: 685},
        {type: OfferPoiType.BUS, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 699},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 699},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Targowa", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 741},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 790},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 855},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 874},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 902}
    ],
    17588: [
        {type: OfferPoiType.BUS, name: "Ogrody „Malwa” nż", distance: 109},
        {type: OfferPoiType.BUS, name: "Krakowska Uniwersytet", distance: 199},
        {type: OfferPoiType.BUS, name: "Bronowicka – Rezedowa nż", distance: 285},
        {type: OfferPoiType.BUS, name: "Zielona", distance: 400},
        {type: OfferPoiType.BUS, name: "Cukrowa Uniwersytet", distance: 665},
        {type: OfferPoiType.BUS, name: "Rondo Uniwersyteckie nż", distance: 721},
        {type: OfferPoiType.PARK, name: "park imienia Sprawiedliwych wśród Narodów Świata", distance: 990},
        {type: OfferPoiType.REZERWAT, name: "Stawek na Gumieńcach", distance: 1723},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 2194}
    ],
    17589: [
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Krasińskiego", distance: 74},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Sikorskiego", distance: 290},
        {type: OfferPoiType.TRAM, name: "Zawodzie Paderewskiego", distance: 489},
        {type: OfferPoiType.BUS, name: "Os. Paderewskiego Kościół", distance: 520},
        {type: OfferPoiType.TRAM, name: "Katowice Graniczna", distance: 645},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Biblioteka Śląska", distance: 808},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 869},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Eugeniusza Breitkopfa", distance: 938},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 966},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1000},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer Andrzeja Fonfary", distance: 1144},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 1476}
    ],
    17596: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 334},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 02", distance: 507},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 01", distance: 532},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 01", distance: 685},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 02", distance: 792}
    ],
    17599: [
        {type: OfferPoiType.BUS, name: "Dobczyce Wincentego Witosa", distance: 345},
        {type: OfferPoiType.BUS, name: "Dobczyce Witosa (pętla)", distance: 567},
        {type: OfferPoiType.BUS, name: "Dobczyce Kilińskiego", distance: 717},
        {type: OfferPoiType.PARK, name: "Dobek", distance: 1835},
        {type: OfferPoiType.PARK, name: "Dobczycki Park Miejski", distance: 1849}
    ],
    17601: [
        {type: OfferPoiType.BUS, name: "Sławka 01", distance: 214},
        {type: OfferPoiType.BUS, name: "Sławka 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 03", distance: 224},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 04", distance: 356},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka", distance: 365},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 03", distance: 545},
        {type: OfferPoiType.BUS, name: "Kamieńskiego 02", distance: 578},
        {type: OfferPoiType.BUS, name: "Kamieńskiego 01", distance: 594},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 667},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 718},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 957},
        {type: OfferPoiType.PARK, name: "Baśniowy Ogród", distance: 1183},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 1880},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1923}
    ],
    17602: [
        {type: OfferPoiType.BUS, name: "Smardzewice Zalew", distance: 379},
        {type: OfferPoiType.BUS, name: "Zalew pętla", distance: 547}
    ],
    17603: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 368},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 383},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 400},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 416},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 459},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 736},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 789},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 814},
        {type: OfferPoiType.BUS, name: "Kielecka 01", distance: 835},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1876},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 2133},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2439}
    ],
    17608: [
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 96},
        {type: OfferPoiType.BUS, name: "Kaloryczna 02", distance: 127},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 185},
        {type: OfferPoiType.BUS, name: "Antoniewska 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 395},
        {type: OfferPoiType.BUS, name: "Antoniewska 01", distance: 441},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 539},
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 624},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 745},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 762},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1658},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1681},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2139}
    ],
    17613: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 245},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 273},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 273},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 284},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 298},
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 615},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 687},
        {type: OfferPoiType.BUS, name: "Banacha 01", distance: 734},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 744},
        {type: OfferPoiType.BUS, name: "Banacha 03", distance: 747},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 754},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 808},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 823},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1442},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1485},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1940},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2506}
    ],
    17616: [
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 94},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 131},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 136},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 217},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 05", distance: 297},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 01", distance: 298},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 338},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Cybernetyki 02", distance: 423},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 423},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 02", distance: 430},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 485},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 526},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 01", distance: 541},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 553},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 578},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 594},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 630},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1264},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1547},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 1616}
    ],
    17617: [
        {type: OfferPoiType.TRAM, name: "Zgierska - Sikorskiego", distance: 173},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego", distance: 218},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Zgierska", distance: 295},
        {type: OfferPoiType.TRAM, name: "Zgierska - Przedwiośnie", distance: 295},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego NŻ", distance: 396},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 471},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pasieczna", distance: 545},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Herlinga-Grudzińskiego", distance: 559},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pl. Pamięci Narodowej", distance: 609},
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 1120},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 1281},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 1337},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 1372},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1639},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Sokołówki i Brzozy”", distance: 1823},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy na Żabieńcu”", distance: 1924},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 2122},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 2333}
    ],
    17619: [
        {type: OfferPoiType.BUS, name: "Szeligowskiego NŻ 01", distance: 115},
        {type: OfferPoiType.BUS, name: "Organowa 01", distance: 378},
        {type: OfferPoiType.BUS, name: "Prusa 03", distance: 390},
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 444},
        {type: OfferPoiType.BUS, name: "Organowa 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Paganiniego 01", distance: 490},
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Paganiniego 03", distance: 587},
        {type: OfferPoiType.BUS, name: "Paganiniego 04", distance: 638},
        {type: OfferPoiType.BUS, name: "Paganiniego 02", distance: 641},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 1151},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1265}
    ],
    17633: [
        {type: OfferPoiType.TRAM, name: "Dworcowa / Matejki", distance: 218},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Floriana Czakiego", distance: 333},
        {type: OfferPoiType.BUS, name: "Śniadeckich / Sienkiewicza", distance: 406},
        {type: OfferPoiType.BUS, name: "Królowej Jadwigi / Astoria", distance: 428},
        {type: OfferPoiType.BUS, name: "Focha / Opera", distance: 462},
        {type: OfferPoiType.BUS, name: "Plac Piastowski", distance: 469},
        {type: OfferPoiType.TRAM, name: "Focha / Opera", distance: 520},
        {type: OfferPoiType.BUS, name: "Fredry / Warszawska", distance: 567},
        {type: OfferPoiType.BUS, name: "Warszawska / Fredry", distance: 581},
        {type: OfferPoiType.TRAM, name: "Garbary", distance: 695},
        {type: OfferPoiType.BUS, name: "Garbary", distance: 721},
        {type: OfferPoiType.TRAM, name: "Plac Teatralny", distance: 748},
        {type: OfferPoiType.TRAM, name: "Plac Wolności", distance: 748},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 798},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 836},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 865},
        {type: OfferPoiType.PARK, name: "Wyspa Młyńska", distance: 941}
    ],
    17635: [
        {type: OfferPoiType.BUS, name: "Wólka Grodziska Zachodnia", distance: 285},
        {type: OfferPoiType.BUS, name: "Kozery Główna", distance: 438},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Zachodnia", distance: 842},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Szwedzka", distance: 843},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Piłsudskiego", distance: 1863},
        {type: OfferPoiType.PARK, name: "Park Marii Michalak", distance: 1891}
    ],
    17638: [
        {type: OfferPoiType.BUS, name: "Bużańska", distance: 210},
        {type: OfferPoiType.BUS, name: "Os. Lotnictwa Polskiego", distance: 467},
        {type: OfferPoiType.BUS, name: "Meissnera", distance: 741},
        {type: OfferPoiType.BUS, name: "Polska", distance: 768},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1382},
        {type: OfferPoiType.REZERWAT, name: "Bogdanka II", distance: 1816}
    ],
    17642: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 73},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 242},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 283},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Struga", distance: 430},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 447},
        {type: OfferPoiType.BUS, name: "Struga - Pogonowskiego NŻ", distance: 456},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 465},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 518},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 521},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 541},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 658},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 678},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 713},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 765},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 769},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 784}
    ],
    17645: [
        {type: OfferPoiType.BUS, name: "Podwale 02", distance: 255},
        {type: OfferPoiType.BUS, name: "Stanowisko 1", distance: 273},
        {type: OfferPoiType.BUS, name: "Stanowisko 2", distance: 281},
        {type: OfferPoiType.BUS, name: "Stanowisko 3", distance: 289},
        {type: OfferPoiType.BUS, name: "Stanowisko 4", distance: 297},
        {type: OfferPoiType.BUS, name: "Dworzec Autobusowy 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Stanowisko 5", distance: 303},
        {type: OfferPoiType.BUS, name: "Stanowisko 6", distance: 309},
        {type: OfferPoiType.BUS, name: "Podwale 01", distance: 312},
        {type: OfferPoiType.BUS, name: "Dworzec Autobusowy 01", distance: 325},
        {type: OfferPoiType.PARK, name: "Park im. J. Ziżki", distance: 1371},
        {type: OfferPoiType.PARK, name: "Wzgórze Kościuszki", distance: 1886}
    ],
    17655: [
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 368},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 453},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 464},
        {type: OfferPoiType.TRAM, name: "Prudnicka", distance: 487},
        {type: OfferPoiType.BUS, name: "Prudnicka", distance: 501},
        {type: OfferPoiType.BUS, name: "Widna", distance: 606},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 687},
        {type: OfferPoiType.BUS, name: "Wapienna", distance: 713},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 714},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1432},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1689},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1850}
    ],
    17659: [
        {type: OfferPoiType.BUS, name: "Waniliowa", distance: 463},
        {type: OfferPoiType.BUS, name: "Tymiankowa", distance: 525},
        {type: OfferPoiType.BUS, name: "Kaparowa", distance: 649},
        {type: OfferPoiType.BUS, name: "Cynamonowa", distance: 705},
        {type: OfferPoiType.BUS, name: "Lipa Piotrowska", distance: 730},
        {type: OfferPoiType.BUS, name: "Perzowa", distance: 749},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 1967}
    ],
    17661: [
        {type: OfferPoiType.BUS, name: "Klonowa Osiedle", distance: 214},
        {type: OfferPoiType.BUS, name: "Klonowa", distance: 491},
        {type: OfferPoiType.BUS, name: "Spacerowa", distance: 540},
        {type: OfferPoiType.BUS, name: "Ludowa", distance: 642},
        {type: OfferPoiType.BUS, name: "Langiewicza", distance: 740},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1224},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1581},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1994},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 2009},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 2039},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 2191},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 2343}
    ],
    17665: [
        {type: OfferPoiType.BUS, name: "Niwa 02", distance: 364},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 379},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 386},
        {type: OfferPoiType.BUS, name: "Niwa 01", distance: 418},
        {type: OfferPoiType.BUS, name: "Cm. Bródnowski 02", distance: 649},
        {type: OfferPoiType.BUS, name: "Cm. Bródnowski 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Samarytanka 02", distance: 786},
        {type: OfferPoiType.BUS, name: "Metro Trocka 11", distance: 790},
        {type: OfferPoiType.BUS, name: "Rolanda 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Metro Trocka 12", distance: 815},
        {type: OfferPoiType.BUS, name: "Metro Trocka 09", distance: 827},
        {type: OfferPoiType.PARK, name: "Skwer Ekologiczny", distance: 1163},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 1381},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1694},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 2023},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 2125}
    ],
    17667: [
        {type: OfferPoiType.KOLEJ, name: "Karpacz", distance: 613},
        {type: OfferPoiType.BUS, name: "Karpacz, Dworzec kolejowy PKP", distance: 648},
        {type: OfferPoiType.PARK, name: "Park Lipa Sądowa", distance: 1181},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1603},
        {type: OfferPoiType.PARK, name: "Park przy Wodospadzie", distance: 1683},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1697}
    ],
    17672: [
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego", distance: 117},
        {type: OfferPoiType.TRAM, name: "Wierzbięcice", distance: 231},
        {type: OfferPoiType.BUS, name: "Św. Czesława", distance: 281},
        {type: OfferPoiType.TRAM, name: "Św. Czesława", distance: 281},
        {type: OfferPoiType.BUS, name: "Poznań Główny", distance: 421},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 548},
        {type: OfferPoiType.BUS, name: "Bergera", distance: 574},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 610},
        {type: OfferPoiType.BUS, name: "Niezłomnych", distance: 628},
        {type: OfferPoiType.TRAM, name: "Półwiejska", distance: 650},
        {type: OfferPoiType.TRAM, name: "Różana", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 783},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 938},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 940},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1026},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1348},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1384},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1561},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1563}
    ],
    17675: [
        {type: OfferPoiType.BUS, name: "Warneńska 04", distance: 167},
        {type: OfferPoiType.TRAM, name: "Warneńska 01", distance: 228},
        {type: OfferPoiType.TRAM, name: "Warneńska 02", distance: 242},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Kolumba 03", distance: 317},
        {type: OfferPoiType.TRAM, name: "Budapesztańska", distance: 322},
        {type: OfferPoiType.BUS, name: "Budapesztańska", distance: 340},
        {type: OfferPoiType.BUS, name: "Kolumba 04", distance: 349},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 377},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 410},
        {type: OfferPoiType.BUS, name: "Piecewska", distance: 462},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 463},
        {type: OfferPoiType.BUS, name: "Belgradzka 03", distance: 563},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 675},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 681},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 687},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 687},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 687},
        {type: OfferPoiType.TRAM, name: "Migowo", distance: 786},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1426},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1564},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 1893},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2197}
    ],
    17678: [
        {type: OfferPoiType.BUS, name: "Portowa", distance: 350},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 350},
        {type: OfferPoiType.BUS, name: "I Urząd Skarbowy 01", distance: 371},
        {type: OfferPoiType.BUS, name: "I Urząd Skarbowy", distance: 371},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Jana z Kolna", distance: 475},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 476},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Jana z Kolna 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski", distance: 533},
        {type: OfferPoiType.BUS, name: "3 Maja - Hala", distance: 537},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski 03", distance: 538},
        {type: OfferPoiType.BUS, name: "3 Maja - Hala 01", distance: 541},
        {type: OfferPoiType.PARK, name: "Park Rady Europy", distance: 1255},
        {type: OfferPoiType.PARK, name: "Plac Wolnej Ukrainy", distance: 1408},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1440},
        {type: OfferPoiType.PARK, name: "Park Marii i Lecha Kaczyńskich", distance: 1539},
        {type: OfferPoiType.PARK, name: "Gdyński Park Kieszonkowy", distance: 1726},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 2004}
    ],
    17681: [
        {type: OfferPoiType.BUS, name: "Żwaków Sosnowe", distance: 23},
        {type: OfferPoiType.BUS, name: "Żwaków Rogatki", distance: 251},
        {type: OfferPoiType.BUS, name: "Żwaków Żorska", distance: 298},
        {type: OfferPoiType.BUS, name: "Żwaków św. Elżbiety", distance: 470},
        {type: OfferPoiType.BUS, name: "Żwaków Cmentarz", distance: 663},
        {type: OfferPoiType.BUS, name: "Żwaków Nowa", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Jaworek", distance: 2173},
        {type: OfferPoiType.PARK, name: "Rodzinny Park Błogosławionej Karoliny", distance: 2499}
    ],
    17682: [
        {type: OfferPoiType.BUS, name: "Kakaowa 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Bakaliowa 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Zamienie 01", distance: 705},
        {type: OfferPoiType.BUS, name: "Błędna 01", distance: 737}
    ],
    17684: [
        {type: OfferPoiType.BUS, name: "Kępa Zawadowska 01", distance: 350},
        {type: OfferPoiType.BUS, name: "Kępa Zawadowska 02", distance: 406},
        {type: OfferPoiType.BUS, name: "Gratyny 01", distance: 472},
        {type: OfferPoiType.BUS, name: "Gratyny 02", distance: 482},
        {type: OfferPoiType.BUS, name: "Bruzdowa - Kościół 02", distance: 615},
        {type: OfferPoiType.BUS, name: "Bruzdowa - Kościół 01", distance: 679}
    ],
    17690: [
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 01", distance: 278},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 02", distance: 319}
    ],
    17693: [
        {type: OfferPoiType.BUS, name: "Rokokowa 02", distance: 350},
        {type: OfferPoiType.BUS, name: "Rokokowa 01", distance: 422},
        {type: OfferPoiType.BUS, name: "Tytułowa 02", distance: 504},
        {type: OfferPoiType.BUS, name: "Tytułowa 01", distance: 538},
        {type: OfferPoiType.TRAM, name: "Nocznickiego 02", distance: 742},
        {type: OfferPoiType.BUS, name: "Wólczyńska-Bocznica 02", distance: 764},
        {type: OfferPoiType.TRAM, name: "Nocznickiego 01", distance: 766},
        {type: OfferPoiType.PARK, name: "Eco Skwerek", distance: 1375},
        {type: OfferPoiType.PARK, name: "Skwer 30. Pułku Strzelców Kaniowskich", distance: 1938},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 2174}
    ],
    17698: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 300},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 341},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 744},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 755},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 771},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1777}
    ],
    17699: [
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 386},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 800},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1731},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 2258},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 2318},
        {type: OfferPoiType.PARK, name: "Park Kielczan 2019", distance: 2329},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 2359},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2389}
    ],
    17700: [
        {type: OfferPoiType.BUS, name: "Taylora / Żniwna", distance: 600},
        {type: OfferPoiType.BUS, name: "Żniwna", distance: 606},
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 710},
        {type: OfferPoiType.BUS, name: "Uniwersytecka", distance: 724},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1124},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1692},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 2219},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 2279},
        {type: OfferPoiType.PARK, name: "Park Kielczan 2019", distance: 2290},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 2320},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2350}
    ],
    17702: [
        {type: OfferPoiType.BUS, name: "Kowale Szkoła Metropolitalna 01", distance: 132},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Cytrusowe", distance: 409},
        {type: OfferPoiType.BUS, name: "Kowale Plac Afrodyty 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Olimp 03", distance: 545},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Olimp 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Olimp 02", distance: 812},
        {type: OfferPoiType.BUS, name: "Kowale Starowiejska 01", distance: 823},
        {type: OfferPoiType.BUS, name: "Borkowo Stylowa 02", distance: 826}
    ],
    17703: [
        {type: OfferPoiType.BUS, name: "Gliwice Plac Piastów", distance: 50},
        {type: OfferPoiType.BUS, name: "Gliwice Piwna", distance: 256},
        {type: OfferPoiType.BUS, name: "Gliwice Dworzec", distance: 279},
        {type: OfferPoiType.BUS, name: "Gliwice Dworcowa", distance: 285},
        {type: OfferPoiType.BUS, name: "Gliwice Jagiellońska", distance: 422},
        {type: OfferPoiType.KOLEJ, name: "Gliwice", distance: 453},
        {type: OfferPoiType.PARK, name: "Skwer Europejski", distance: 474},
        {type: OfferPoiType.PARK, name: "Park Chopina", distance: 782},
        {type: OfferPoiType.PARK, name: "Skwer Valenciennes", distance: 905},
        {type: OfferPoiType.PARK, name: "Skwer Doncaster", distance: 907}
    ],
    17711: [
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 03", distance: 497},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R", distance: 590},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 05", distance: 609},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 02", distance: 625},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 01", distance: 662},
        {type: OfferPoiType.TRAM, name: "Rzebika 01", distance: 688},
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 702},
        {type: OfferPoiType.BUS, name: "Rzebika 04", distance: 714},
        {type: OfferPoiType.BUS, name: "Rzebika 03", distance: 719},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 725},
        {type: OfferPoiType.TRAM, name: "Rzebika 02", distance: 740},
        {type: OfferPoiType.BUS, name: "Rzebika 08", distance: 750},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1005},
        {type: OfferPoiType.PARK, name: "Ptasi Zagajnik", distance: 1397},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 1526},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1680},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1699}
    ],
    17714: [
        {type: OfferPoiType.BUS, name: "Powstańców 52", distance: 286},
        {type: OfferPoiType.BUS, name: "Powstańców 01", distance: 409},
        {type: OfferPoiType.BUS, name: "Powstańców 02", distance: 414},
        {type: OfferPoiType.BUS, name: "Powstańców 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Powstańców 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Cmentarz 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Cmentarz 02", distance: 681},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Kawęczyn 02", distance: 770},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 2175}
    ],
    17717: [
        {type: OfferPoiType.PARK, name: "Skwer 700-lecia Ligoty Zabrskiej", distance: 250},
        {type: OfferPoiType.BUS, name: "Ligota Zabrska Dolna", distance: 401},
        {type: OfferPoiType.BUS, name: "Gliwice Górna", distance: 437},
        {type: OfferPoiType.BUS, name: "Gliwice Jacka", distance: 684},
        {type: OfferPoiType.BUS, name: "Ligota Zabrska Panewnicka [nż]", distance: 752},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Kalide", distance: 1749},
        {type: OfferPoiType.PARK, name: "Park Bolesława Chrobrego", distance: 1846}
    ],
    17729: [
        {type: OfferPoiType.BUS, name: "Tuwima - Wysoka", distance: 281},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 301},
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 392},
        {type: OfferPoiType.BUS, name: "Tuwima - Przędzalniana", distance: 421},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 470},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 518},
        {type: OfferPoiType.BUS, name: "Nawrot - Wysoka", distance: 527},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 532},
        {type: OfferPoiType.BUS, name: "Tuwima - Rodz. Kindermannów NŻ", distance: 551},
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 592},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 693},
        {type: OfferPoiType.TRAM, name: "Kopcińskiego - Tuwima", distance: 708},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 736},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 752},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 759},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 760},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 784},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 797},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 885},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 971},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 1013},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1066},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 1118},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 1183}
    ],
    17730: [
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 323},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 393},
        {type: OfferPoiType.BUS, name: "Legionów - Żeligowskiego", distance: 561},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka", distance: 575},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Srebrzyńska", distance: 604},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 604},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 632},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka NŻ", distance: 686},
        {type: OfferPoiType.BUS, name: "Zielona - 1 Maja", distance: 727},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 754},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 791},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 926},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 932},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 1121},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 1262},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1274},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1591},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 2352},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2399}
    ],
    17738: [
        {type: OfferPoiType.BUS, name: "Jaracza - Wierzbowa", distance: 128},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rewolucji 1905 r.", distance: 192},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 335},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 397},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rondo Solidarności", distance: 403},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 418},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 447},
        {type: OfferPoiType.BUS, name: "Narutowicza - Tramwajowa", distance: 451},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 499},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 504},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Rondo Solidarności", distance: 509},
        {type: OfferPoiType.TRAM, name: "Pomorska - Rondo Solidarności", distance: 553},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 556},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Kopcińskiego", distance: 579},
        {type: OfferPoiType.TRAM, name: "Kopcińskiego - Narutowicza", distance: 629},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 670},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 797},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 867},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 1156},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1211},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 1303},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1320},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1382}
    ],
    17745: [
        {type: OfferPoiType.BUS, name: "Młynek", distance: 289},
        {type: OfferPoiType.BUS, name: "Kotoniarska - Szybowa NŻ", distance: 351},
        {type: OfferPoiType.PARK, name: "Park na Młynku", distance: 497},
        {type: OfferPoiType.BUS, name: "Śląska - Kowalszczyzna NŻ", distance: 540},
        {type: OfferPoiType.BUS, name: "Lodowa - Lodowa 97 NŻ", distance: 843}
    ],
    17748: [
        {type: OfferPoiType.BUS, name: "Gliwice Komag", distance: 219},
        {type: OfferPoiType.BUS, name: "Gliwice Kujawska", distance: 299},
        {type: OfferPoiType.BUS, name: "Trynek Lotników", distance: 538},
        {type: OfferPoiType.BUS, name: "Gliwice Łużycka", distance: 670},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 684},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Rydet", distance: 692},
        {type: OfferPoiType.BUS, name: "Gliwice Arena Widowiskowo-Sportowa", distance: 705},
        {type: OfferPoiType.BUS, name: "Gliwice Kopalniana", distance: 738},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Lewczyńskiego", distance: 774},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 845},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny", distance: 990}
    ],
    17750: [
        {type: OfferPoiType.TRAM, name: "Stocznia Północna 02", distance: 369},
        {type: OfferPoiType.BUS, name: "Stocznia Północna 03", distance: 385},
        {type: OfferPoiType.TRAM, name: "Stocznia Północna 01", distance: 393},
        {type: OfferPoiType.BUS, name: "Stocznia Północna 04", distance: 536},
        {type: OfferPoiType.TRAM, name: "Twarda", distance: 716},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 1438},
        {type: OfferPoiType.PARK, name: 'Skwer "Stołówka"', distance: 1612},
        {type: OfferPoiType.PARK, name: "Park XXV-lecia Polski Rzeczypospolitej Ludowej", distance: 1812},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1997},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2110},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 2159}
    ],
    17751: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 04", distance: 432},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 03", distance: 697},
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 766},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 821},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1969},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 2021}
    ],
    17752: [
        {type: OfferPoiType.BUS, name: "Świstackiego", distance: 220},
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej", distance: 516},
        {type: OfferPoiType.TRAM, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 553},
        {type: OfferPoiType.BUS, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 563},
        {type: OfferPoiType.TRAM, name: "Komuny Paryskiej", distance: 641},
        {type: OfferPoiType.BUS, name: "Na Niskich Łąkach", distance: 655},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 675},
        {type: OfferPoiType.TRAM, name: "Na Niskich Łąkach", distance: 734},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1039},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 1120},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 1615},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2030}
    ],
    17753: [
        {type: OfferPoiType.BUS, name: "Sosnowiec Teatralna", distance: 60},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Wspólna", distance: 231},
        {type: OfferPoiType.BUS, name: "Sosnowiec Wspólna", distance: 262},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dęblińska", distance: 381},
        {type: OfferPoiType.BUS, name: "Sosnowiec Mierosławskiego", distance: 389},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dęblińska", distance: 398},
        {type: OfferPoiType.BUS, name: "Sosnowiec Kościelna", distance: 509},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Południowy", distance: 533},
        {type: OfferPoiType.BUS, name: "Sosnowiec Sienkiewicza", distance: 536},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dworzec PKP", distance: 560},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dworzec PKP", distance: 615},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Małachowskiego", distance: 723},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Piłsudskiego/Sobieskiego", distance: 734},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Główny", distance: 738},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Aleja Zwycięstwa", distance: 768},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Ostrogórska", distance: 826},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 1180},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Harcerski", distance: 1439},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jana Antoniego Strzeleckiego", distance: 1729},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 1816},
        {type: OfferPoiType.PARK, name: "Park Dietla", distance: 1993},
        {type: OfferPoiType.REZERWAT, name: 'Zespół Przyrodniczo-Krajobrazowy "Szopienice-Borki"', distance: 1993},
        {type: OfferPoiType.REZERWAT, name: "Kruszczyk Szerokolistny w Lasku Stawiki", distance: 2381}
    ],
    17755: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 618},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 787},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 800},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 1052},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 1091},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1615},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1874},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2329}
    ],
    17760: [
        {type: OfferPoiType.BUS, name: "Dąb Widok", distance: 246},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 524},
        {type: OfferPoiType.BUS, name: "Koszutka Kościół", distance: 551},
        {type: OfferPoiType.BUS, name: "Józefowiec Jabłoniowa", distance: 614},
        {type: OfferPoiType.BUS, name: "Katowice Stęślickiego", distance: 621},
        {type: OfferPoiType.TRAM, name: "Dąb Huta Baildon", distance: 699},
        {type: OfferPoiType.TRAM, name: "Katowice Stęślickiego", distance: 701},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 718},
        {type: OfferPoiType.BUS, name: "Dąb Silesia City Center", distance: 736},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 772},
        {type: OfferPoiType.BUS, name: "Koszutka Kino Kosmos", distance: 781},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 939},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1051},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1220},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1314},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 1388}
    ],
    17762: [
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 01", distance: 383},
        {type: OfferPoiType.BUS, name: "Poligonowa - Osiedle 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Poligonowa - osiedle 02", distance: 685},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1120}
    ],
    17764: [
        {type: OfferPoiType.BUS, name: "Os. Marywilska 02", distance: 543},
        {type: OfferPoiType.BUS, name: "Os. Marywilska 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Os. Marywilska 04", distance: 635},
        {type: OfferPoiType.BUS, name: "Marcelin 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Marcelin 04", distance: 723},
        {type: OfferPoiType.BUS, name: "Marcelin 05", distance: 760},
        {type: OfferPoiType.BUS, name: "Marcelin 03", distance: 770},
        {type: OfferPoiType.BUS, name: "Marcelin 02", distance: 799},
        {type: OfferPoiType.BUS, name: "PKP Żerań 02", distance: 825},
        {type: OfferPoiType.BUS, name: "PKP Żerań 01", distance: 839},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 2069},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2139}
    ],
    17767: [{type: OfferPoiType.BUS, name: "Św. Katarzyna n.ż", distance: 606}],
    17769: [
        {type: OfferPoiType.BUS, name: "Północna - Kamińskiego", distance: 167},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 380},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 475},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 504},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 610},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 616},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 632},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 654},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 682},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 757},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 780},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1090},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1143},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 1313}
    ],
    17772: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    17775: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    17776: [
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 638},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 693},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 2121}
    ],
    17782: [
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 311},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 713},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1562},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1767},
        {type: OfferPoiType.PARK, name: "Górki Służewskie", distance: 1897},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1898},
        {type: OfferPoiType.PARK, name: "Arkadia", distance: 1927},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2286}
    ],
    17783: [
        {type: OfferPoiType.BUS, name: "Dzikiej Róży 02", distance: 771},
        {type: OfferPoiType.BUS, name: "Dzikiej Róży 01", distance: 783}
    ],
    17785: [
        {type: OfferPoiType.BUS, name: "3 Maja 02", distance: 763},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 764},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 954},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 967},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1126}
    ],
    17792: [{type: OfferPoiType.BUS, name: "Łady-Szkoła 02", distance: 819}],
    17793: [
        {type: OfferPoiType.BUS, name: "Trzebnicka", distance: 456},
        {type: OfferPoiType.TRAM, name: "Trzebnicka", distance: 465},
        {type: OfferPoiType.BUS, name: "Zakładowa", distance: 519},
        {type: OfferPoiType.TRAM, name: "Dworzec Nadodrze", distance: 539},
        {type: OfferPoiType.BUS, name: "Dworzec Nadodrze", distance: 548},
        {type: OfferPoiType.BUS, name: "Kręta", distance: 595},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 655},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Nadodrze", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 863},
        {type: OfferPoiType.PARK, name: "Park Świętego Macieja", distance: 1097},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 1363},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2467}
    ],
    17796: [
        {type: OfferPoiType.BUS, name: "Rotmanka Rondo", distance: 345},
        {type: OfferPoiType.BUS, name: "Rotmanka - Rondo 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Rotmanka Piłsudskiego", distance: 574},
        {type: OfferPoiType.BUS, name: "Rondo Bursztynowe 01", distance: 827},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 2368}
    ],
    17800: [
        {type: OfferPoiType.BUS, name: "Krokusów 02", distance: 612},
        {type: OfferPoiType.BUS, name: "Krokusów 01", distance: 655},
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 02", distance: 695},
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 01", distance: 705},
        {type: OfferPoiType.BUS, name: "Liliowa 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Liliowa 02", distance: 749},
        {type: OfferPoiType.BUS, name: "Liliowa 04", distance: 756},
        {type: OfferPoiType.BUS, name: "Kosodrzewiny 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Jachowicza 01", distance: 783},
        {type: OfferPoiType.BUS, name: "Bysławska 01", distance: 783}
    ],
    17812: [
        {type: OfferPoiType.BUS, name: "Bora-Komorowskiego 02", distance: 8},
        {type: OfferPoiType.BUS, name: "Bora-Komorowskiego 01", distance: 208},
        {type: OfferPoiType.BUS, name: "Cogiteon 02", distance: 426},
        {type: OfferPoiType.BUS, name: "Cogiteon 01", distance: 506},
        {type: OfferPoiType.BUS, name: "Olsza II 74", distance: 629},
        {type: OfferPoiType.BUS, name: "Akacjowa 01", distance: 638},
        {type: OfferPoiType.BUS, name: "Akacjowa 02", distance: 672},
        {type: OfferPoiType.BUS, name: "Spadochroniarzy 02", distance: 765},
        {type: OfferPoiType.BUS, name: "Rondo Barei 02", distance: 778},
        {type: OfferPoiType.BUS, name: "Os. Oświecenia 02", distance: 802},
        {type: OfferPoiType.PARK, name: "Lotniczy Park Kulturowy", distance: 1136},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 1224},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy przy ul. Chałupnika", distance: 1277},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1500},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 1724}
    ],
    17814: [
        {type: OfferPoiType.TRAM, name: "Winnica 04", distance: 478},
        {type: OfferPoiType.TRAM, name: "Winnica 03", distance: 488},
        {type: OfferPoiType.BUS, name: "Winnica 73", distance: 489},
        {type: OfferPoiType.BUS, name: "Winnica 02", distance: 493},
        {type: OfferPoiType.BUS, name: "Winnica 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Winnica 06", distance: 519},
        {type: OfferPoiType.BUS, name: "Winnica 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Winnica 11", distance: 558},
        {type: OfferPoiType.TRAM, name: "Winnica 05", distance: 581},
        {type: OfferPoiType.BUS, name: "Winnica 13", distance: 644},
        {type: OfferPoiType.TRAM, name: "Winnica 72", distance: 650},
        {type: OfferPoiType.BUS, name: "Grzymalitów 02", distance: 668},
        {type: OfferPoiType.TRAM, name: "Winnica 71", distance: 675},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 05", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 745},
        {type: OfferPoiType.BUS, name: "Poetów 01", distance: 754},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 06", distance: 775},
        {type: OfferPoiType.BUS, name: "Grzymalitów 01", distance: 818},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 902},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1924},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 1971}
    ],
    17816: [
        {type: OfferPoiType.BUS, name: "Szklarniowa 02", distance: 523},
        {type: OfferPoiType.BUS, name: "Szklarniowa 01", distance: 616},
        {type: OfferPoiType.PARK, name: "Park im. Mariana Jonkajtysa", distance: 2116},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci", distance: 2337},
        {type: OfferPoiType.PARK, name: "Skwer im. Żołnierzy Wyklętych", distance: 2484}
    ],
    17819: [
        {type: OfferPoiType.BUS, name: "Urząd Statystyczny 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Urząd Statystyczny 02", distance: 322},
        {type: OfferPoiType.BUS, name: "Novotel 04", distance: 349},
        {type: OfferPoiType.BUS, name: "Jadwisin 01", distance: 545},
        {type: OfferPoiType.BUS, name: "Novotel 01", distance: 605},
        {type: OfferPoiType.BUS, name: "Novotel 02", distance: 661},
        {type: OfferPoiType.BUS, name: "Jadwisin 02", distance: 748},
        {type: OfferPoiType.BUS, name: "PKP Żwirki i Wigury 01", distance: 796},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Żwirki i Wigury", distance: 817},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 884},
        {type: OfferPoiType.PARK, name: "Fort Rakowiec", distance: 1302},
        {type: OfferPoiType.PARK, name: "Park Zasława Malickiego", distance: 1552},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1776},
        {type: OfferPoiType.PARK, name: "Cmentarz Mauzoleum Żołnierzy Radzieckich", distance: 1884}
    ],
    17823: [
        {type: OfferPoiType.BUS, name: "Prądzyńskiego 02", distance: 52},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia peron 9", distance: 336},
        {type: OfferPoiType.BUS, name: "Parafialna 02", distance: 353},
        {type: OfferPoiType.TRAM, name: "PKP Wola (Kasprzaka) 03", distance: 474},
        {type: OfferPoiType.BUS, name: "PKP Wola (Kasprzaka) 01", distance: 501},
        {type: OfferPoiType.TRAM, name: "PKP Wola (Kasprzaka) 04", distance: 530},
        {type: OfferPoiType.BUS, name: "Parafialna 01", distance: 542},
        {type: OfferPoiType.BUS, name: "PKP Wola (Kasprzaka) 06", distance: 623},
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 629},
        {type: OfferPoiType.BUS, name: "PKP Wola (Kasprzaka) 05", distance: 639},
        {type: OfferPoiType.BUS, name: "Armatnia 02", distance: 660},
        {type: OfferPoiType.BUS, name: "Dworzec Zachodni (Tunelowa) 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 676},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Wola", distance: 745},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 755},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia", distance: 784},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1288},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1314},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1456},
        {type: OfferPoiType.PARK, name: "Park im. Edwarda Szymańskiego", distance: 1472},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1547},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 1720}
    ],
    17824: [
        {type: OfferPoiType.TRAM, name: "Sternicza", distance: 491},
        {type: OfferPoiType.TRAM, name: "Gdańska", distance: 551},
        {type: OfferPoiType.BUS, name: "PCK 01", distance: 560},
        {type: OfferPoiType.BUS, name: "PCK 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Krasickiego 04", distance: 772},
        {type: OfferPoiType.BUS, name: "Brzeźno Dom Zdrojowy 05", distance: 775},
        {type: OfferPoiType.TRAM, name: "Brzeźno Dom Zdrojowy 03", distance: 799},
        {type: OfferPoiType.TRAM, name: "Brzeźno Dom Zdrojowy 02", distance: 803},
        {type: OfferPoiType.TRAM, name: "Brzeźno Dom Zdrojowy 01", distance: 810},
        {type: OfferPoiType.BUS, name: "Brzeźno Dom Zdrojowy 04", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Brzeźnieński im. J. J. Haffnera", distance: 1073},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1885}
    ],
    17827: [
        {type: OfferPoiType.KOLEJ, name: "Niechorze", distance: 631},
        {type: OfferPoiType.BUS, name: "Niechorze", distance: 703},
        {type: OfferPoiType.REZERWAT, name: "Liwskie Ujście", distance: 1244}
    ],
    17828: [
        {type: OfferPoiType.BUS, name: "Maczka - Pienista NŻ", distance: 147},
        {type: OfferPoiType.BUS, name: "Pienista - Komandorska", distance: 392},
        {type: OfferPoiType.BUS, name: "Maczka - Aeroklub NŻ", distance: 688},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1448}
    ],
    17832: [{type: OfferPoiType.REZERWAT, name: "Rezerwat Zaborów im. W.Tyrakowskiego", distance: 2370}],
    17833: [
        {type: OfferPoiType.BUS, name: "Zagórze Hala Sportowa", distance: 70},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 413},
        {type: OfferPoiType.BUS, name: "Zagórze Piękna", distance: 671},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Hallera", distance: 1127},
        {type: OfferPoiType.PARK, name: "Skwer im. Antoniego Pilarza", distance: 1673},
        {type: OfferPoiType.PARK, name: "Planty im. Harcmistrza Stefana Piotrowskiego", distance: 1907},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 2083},
        {type: OfferPoiType.PARK, name: "Park Śródmiejski", distance: 2146}
    ],
    17834: [
        {type: OfferPoiType.BUS, name: "Ługowa", distance: 117},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 271},
        {type: OfferPoiType.BUS, name: "Starościńska", distance: 531},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 650},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1727}
    ],
    17836: [
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Dom Kultury", distance: 384},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Centrum", distance: 407},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Plac Świętego Herberta", distance: 539},
        {type: OfferPoiType.BUS, name: "Obroki Dulęby", distance: 543},
        {type: OfferPoiType.PARK, name: "Plac Świętego Herberta", distance: 714},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Sławka", distance: 796},
        {type: OfferPoiType.PARK, name: 'Skwer Danuty Siedzikówny "Inki"', distance: 889},
        {type: OfferPoiType.PARK, name: "Skwer rotmistrza Witolda Pileckiego", distance: 946},
        {type: OfferPoiType.PARK, name: "Park Załęski", distance: 1601},
        {type: OfferPoiType.PARK, name: "Skwer Męczenników Oświęcimskich", distance: 2362},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 2404},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Węglarczyka", distance: 2420}
    ],
    17837: [
        {type: OfferPoiType.BUS, name: "Załęska Hałda Kolońska [nż]", distance: 170},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Rataja", distance: 607},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Droga Kochłowicka", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer rotmistrza Witolda Pileckiego", distance: 655},
        {type: OfferPoiType.BUS, name: "Załęska Hałda Bocheńskiego Autostrada", distance: 660},
        {type: OfferPoiType.PARK, name: 'Skwer Danuty Siedzikówny "Inki"', distance: 902},
        {type: OfferPoiType.PARK, name: "Plac Świętego Herberta", distance: 1144},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Węglarczyka", distance: 1157},
        {type: OfferPoiType.PARK, name: "Park Załęski", distance: 1788},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 1978}
    ],
    17841: [
        {type: OfferPoiType.BUS, name: "Skalna - Juhasowa", distance: 246},
        {type: OfferPoiType.BUS, name: "Skalna - Kasprowy Wierch NŻ", distance: 705},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1267},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1314},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1497}
    ],
    17844: [
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 232},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 270},
        {type: OfferPoiType.BUS, name: "Fordon Rynek", distance: 279},
        {type: OfferPoiType.BUS, name: "Rondo Buxakowskiego", distance: 355},
        {type: OfferPoiType.BUS, name: "Fordońska / Wiadukt", distance: 443},
        {type: OfferPoiType.BUS, name: "Wyzwolenia / Styki", distance: 641},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 744},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 827},
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 1704},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1917}
    ],
    17845: [
        {type: OfferPoiType.BUS, name: "Termalna n/ż", distance: 420},
        {type: OfferPoiType.TRAM, name: "Termalna", distance: 547},
        {type: OfferPoiType.TRAM, name: "Św. Michała", distance: 716},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 1156},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 1528}
    ],
    17851: [
        {type: OfferPoiType.BUS, name: "Wrzosowa 07", distance: 78},
        {type: OfferPoiType.BUS, name: "Borówkowa 06", distance: 360},
        {type: OfferPoiType.BUS, name: "Borówkowa 05", distance: 366},
        {type: OfferPoiType.BUS, name: "Kalinowa 03", distance: 843}
    ],
    17852: [
        {type: OfferPoiType.BUS, name: "Poziomkowa 02", distance: 262},
        {type: OfferPoiType.BUS, name: "Poziomkowa 01", distance: 292},
        {type: OfferPoiType.BUS, name: "Nasturcjowa 02", distance: 492},
        {type: OfferPoiType.BUS, name: "Nasturcjowa 03", distance: 582},
        {type: OfferPoiType.BUS, name: "Węglarza 01", distance: 686},
        {type: OfferPoiType.BUS, name: "Węglarza 03", distance: 751},
        {type: OfferPoiType.BUS, name: "Węglarza 02", distance: 781},
        {type: OfferPoiType.BUS, name: "Węglarza 04", distance: 786},
        {type: OfferPoiType.PARK, name: "50-lecia", distance: 2362}
    ],
    17869: [
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 111},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 193},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 230},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 254},
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 334},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 419},
        {type: OfferPoiType.BUS, name: "Drwęcka 01", distance: 423},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 508},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1114},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1207},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1277},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1614},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1825},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1873},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1904},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 2202},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2373}
    ],
    17870: [
        {type: OfferPoiType.BUS, name: "Rybaki Górne 02", distance: 224},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 01", distance: 288},
        {type: OfferPoiType.BUS, name: "Aksamitna 01", distance: 369},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 02", distance: 436},
        {type: OfferPoiType.PARK, name: 'Skwer "Stołówka"', distance: 467},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 490},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 526},
        {type: OfferPoiType.BUS, name: "Łagiewniki 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Heweliusza 01", distance: 598},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 600},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 02", distance: 664},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 01", distance: 686},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 707},
        {type: OfferPoiType.BUS, name: "Plac Solidarności 04", distance: 728},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 875},
        {type: OfferPoiType.PARK, name: "Skwer Heweliusza", distance: 923},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1401},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1513},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1836}
    ],
    17872: [
        {type: OfferPoiType.BUS, name: "Zaściankowa 02", distance: 265},
        {type: OfferPoiType.BUS, name: "Syta 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Zaściankowa 01", distance: 399},
        {type: OfferPoiType.BUS, name: "Syta 02", distance: 470},
        {type: OfferPoiType.BUS, name: "Syta 03", distance: 514},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Wilanówka 01", distance: 683},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Wilanówka 02", distance: 713},
        {type: OfferPoiType.PARK, name: "Skwer nad Stawem Zawadowskim", distance: 1389},
        {type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 2306}
    ],
    17878: [
        {type: OfferPoiType.BUS, name: "Jordanowska 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Jordanowska 01", distance: 313},
        {type: OfferPoiType.BUS, name: "Skrajna 01", distance: 381},
        {type: OfferPoiType.BUS, name: "Skrajna 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Chabrowa 02", distance: 492},
        {type: OfferPoiType.BUS, name: "Chabrowa 01", distance: 591},
        {type: OfferPoiType.BUS, name: "Jordanowska 04", distance: 667},
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 670},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 715},
        {type: OfferPoiType.BUS, name: "Pełczyńskiego 01", distance: 776},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 904},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1384},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 1937},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 2059},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2258}
    ],
    17894: [
        {type: OfferPoiType.BUS, name: "Miła bloki 04", distance: 264},
        {type: OfferPoiType.BUS, name: "Miła bloki 03", distance: 311},
        {type: OfferPoiType.BUS, name: "Strażacka / Sympatyczna 05", distance: 612},
        {type: OfferPoiType.BUS, name: "Miła dom kultury 05", distance: 667},
        {type: OfferPoiType.BUS, name: "Strażacka / Sympatyczna 06", distance: 682},
        {type: OfferPoiType.BUS, name: "Strażacka / Sikorskiego 08", distance: 692},
        {type: OfferPoiType.BUS, name: "Miła szkoła 06", distance: 705},
        {type: OfferPoiType.BUS, name: "Miła / Strażacka 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Strażacka / Sikorskiego 07", distance: 783},
        {type: OfferPoiType.BUS, name: "Miła / Strażacka 01", distance: 836},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 1429},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2406}
    ],
    17897: [
        {type: OfferPoiType.BUS, name: "Sarmacka 01", distance: 281},
        {type: OfferPoiType.BUS, name: "Sarmacka 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Vogla 05", distance: 526},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 03", distance: 555},
        {type: OfferPoiType.BUS, name: "Vogla 04", distance: 641},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 10", distance: 683},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 05", distance: 685},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 04", distance: 691},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 02", distance: 691},
        {type: OfferPoiType.BUS, name: "Vogla 01", distance: 693},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 06", distance: 720},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 08", distance: 721},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 71", distance: 767},
        {type: OfferPoiType.BUS, name: "Vogla 02", distance: 772},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 72", distance: 772},
        {type: OfferPoiType.BUS, name: "Vogla 03", distance: 798},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 953},
        {type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 2448}
    ],
    17901: [
        {type: OfferPoiType.BUS, name: "Jana Kazimierza 02", distance: 220},
        {type: OfferPoiType.BUS, name: "Jana Kazimierza 01", distance: 223},
        {type: OfferPoiType.TRAM, name: "Sowińskiego 02", distance: 225},
        {type: OfferPoiType.TRAM, name: "Sowińskiego 01", distance: 233},
        {type: OfferPoiType.BUS, name: "Sowińskiego 03", distance: 239},
        {type: OfferPoiType.BUS, name: "Sowińskiego 04", distance: 262},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 277},
        {type: OfferPoiType.PARK, name: "Park Powstańców Warszawy", distance: 405},
        {type: OfferPoiType.BUS, name: "Goleszowska 02", distance: 468},
        {type: OfferPoiType.BUS, name: "Fort Wola 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Goleszowska 01", distance: 542},
        {type: OfferPoiType.BUS, name: "Hubalczyków 01", distance: 549},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 04", distance: 556},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 03", distance: 562},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 04", distance: 570},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 05", distance: 578},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Cm. Wolski 06", distance: 608},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 03", distance: 646},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Klincewicza", distance: 648},
        {type: OfferPoiType.TRAM, name: "Fort Wola 03", distance: 674},
        {type: OfferPoiType.TRAM, name: "Fort Wola 04", distance: 718},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer Wiesława Michnikowskiego", distance: 1322},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1362},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1600}
    ],
    17909: [
        {type: OfferPoiType.BUS, name: "Pl. Szoslanda - EC1 Centrum Nauki i Techniki", distance: 92},
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 131},
        {type: OfferPoiType.BUS, name: "Tuwima - Kilińskiego (EC1 Centr. Nauki)", distance: 368},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 381},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 415},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 419},
        {type: OfferPoiType.BUS, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 436},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 436},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 439},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 478},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 525},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 547},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 571},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 693},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 770},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 799},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 864},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 911},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 947}
    ],
    17910: [
        {type: OfferPoiType.BUS, name: "Okrąg 01", distance: 566},
        {type: OfferPoiType.PARK, name: "Staw Mysiadło", distance: 603},
        {type: OfferPoiType.BUS, name: "Iwiczna 01", distance: 623},
        {type: OfferPoiType.BUS, name: "Mysiadło 05", distance: 680},
        {type: OfferPoiType.BUS, name: "Mysiadło 04", distance: 689},
        {type: OfferPoiType.BUS, name: "Iwiczna 02", distance: 731},
        {type: OfferPoiType.BUS, name: "Graniczna 02", distance: 737},
        {type: OfferPoiType.BUS, name: "Mysiadło 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Mysiadło 02", distance: 793},
        {type: OfferPoiType.BUS, name: "Graniczna 01", distance: 837},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 2179},
        {type: OfferPoiType.PARK, name: "Skwer Hrabianki Ludwiki Małgorzaty Moriconi", distance: 2415}
    ],
    17915: [
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 02", distance: 126},
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 01", distance: 207},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 442},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 446},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 616},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 688},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 735},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 736},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 805}
    ],
    17916: [
        {type: OfferPoiType.BUS, name: "Szeligowskiego NŻ 01", distance: 247},
        {type: OfferPoiType.BUS, name: "Prusa 03", distance: 311},
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 376},
        {type: OfferPoiType.BUS, name: "Organowa 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Organowa 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Paganiniego 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Prusa 01", distance: 628},
        {type: OfferPoiType.BUS, name: "Paganiniego 03", distance: 708},
        {type: OfferPoiType.BUS, name: "Paganiniego 04", distance: 759},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 1084},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1198},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 1282}
    ],
    17918: [
        {type: OfferPoiType.BUS, name: "Flisacka / Grunwaldzka", distance: 146},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Flisacka", distance: 277},
        {type: OfferPoiType.BUS, name: "Rondo Maczka P+R", distance: 549},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Zachód", distance: 628},
        {type: OfferPoiType.BUS, name: "Dworzec Zachód", distance: 793},
        {type: OfferPoiType.PARK, name: "Park nad Kanałem Bydgoskim", distance: 1020},
        {type: OfferPoiType.PARK, name: "Park przy papierni", distance: 1075}
    ],
    17927: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 122},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 150},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 163},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 165},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 178},
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 492},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 564},
        {type: OfferPoiType.BUS, name: "Banacha 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Banacha 03", distance: 624},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 634},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 685},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 713},
        {type: OfferPoiType.BUS, name: "Górka Narodowa P+R 04", distance: 758},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R 01", distance: 782},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R", distance: 833},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1499},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1542},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1893},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2520}
    ],
    17931: [
        {type: OfferPoiType.BUS, name: "Muchowskiego 02", distance: 472},
        {type: OfferPoiType.BUS, name: "Muchowskiego", distance: 482},
        {type: OfferPoiType.BUS, name: "Oksywie Górne 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Muchowskiego 01", distance: 535},
        {type: OfferPoiType.BUS, name: "Pancerna", distance: 583},
        {type: OfferPoiType.BUS, name: "Oksywie Górne 02", distance: 654},
        {type: OfferPoiType.BUS, name: "Oksywie - Górne", distance: 659},
        {type: OfferPoiType.BUS, name: "Oksywie Górne 01", distance: 663},
        {type: OfferPoiType.PARK, name: "Park Admirała Floty Andrzeja Karwety", distance: 1273},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 2172}
    ],
    17937: [
        {type: OfferPoiType.BUS, name: "Proletariacka - Sowia NŻ", distance: 520},
        {type: OfferPoiType.BUS, name: "Rembielińskiego - Inżynierska NŻ", distance: 607},
        {type: OfferPoiType.BUS, name: "Radwańska - Inżynierska NŻ", distance: 699},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1299},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1904},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1931},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1944}
    ],
    17946: [
        {type: OfferPoiType.BUS, name: "Mysiadło 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Mysiadło 04", distance: 417},
        {type: OfferPoiType.BUS, name: "Mysiadło 05", distance: 426},
        {type: OfferPoiType.PARK, name: "Staw Mysiadło", distance: 488},
        {type: OfferPoiType.BUS, name: "Mysiadło 02", distance: 546},
        {type: OfferPoiType.BUS, name: "Mysiadło 03", distance: 677},
        {type: OfferPoiType.BUS, name: "Dąbrówka 01", distance: 696},
        {type: OfferPoiType.BUS, name: "Dąbrówka 03", distance: 732},
        {type: OfferPoiType.BUS, name: "Dąbrówka 02", distance: 736}
    ],
    17948: [
        {type: OfferPoiType.BUS, name: "Dachowa/Kręta n/ż", distance: 638},
        {type: OfferPoiType.BUS, name: "Dachowa/Tęczowa", distance: 773},
        {type: OfferPoiType.BUS, name: "Dachowa/Wiatrakowa n/ż", distance: 809},
        {type: OfferPoiType.PARK, name: "Park wiejski w Robakowie", distance: 1904}
    ],
    17957: [
        {type: OfferPoiType.BUS, name: "Biedrusko/Park", distance: 261},
        {type: OfferPoiType.BUS, name: "Biedrusko/Jednostka Wojskowa", distance: 638}
    ],
    17964: [
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Kozielska", distance: 281},
        {type: OfferPoiType.BUS, name: "Gliwice Cmentarz Centralny", distance: 290},
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Ordona", distance: 381},
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Czwartaków", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 1036},
        {type: OfferPoiType.PARK, name: "Park Starokozielski", distance: 1105}
    ],
    17966: [
        {type: OfferPoiType.BUS, name: "Sielanka 02", distance: 680},
        {type: OfferPoiType.BUS, name: "Sielanka 03", distance: 717},
        {type: OfferPoiType.BUS, name: "Park Decjusza 01", distance: 760},
        {type: OfferPoiType.BUS, name: "Sielanka 04", distance: 772},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 779},
        {type: OfferPoiType.BUS, name: "Sielanka 01", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 788},
        {type: OfferPoiType.BUS, name: "Park Decjusza 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1614},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1924},
        {type: OfferPoiType.PARK, name: "Park Fort 2 „Kościuszko” imienia Profesora Janusza Bogdanowskiego", distance: 2490}
    ],
    17970: [
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 282},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 01", distance: 420},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 03", distance: 449},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 02", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 481},
        {type: OfferPoiType.TRAM, name: "Wojnicka 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Wołomińska 02", distance: 608},
        {type: OfferPoiType.BUS, name: "Śnieżna 02", distance: 666},
        {type: OfferPoiType.TRAM, name: "Wojnicka 02", distance: 676},
        {type: OfferPoiType.BUS, name: "Śnieżna 01", distance: 683},
        {type: OfferPoiType.BUS, name: "Naczelnikowska 02", distance: 696},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 709},
        {type: OfferPoiType.BUS, name: "Naczelnikowska 01", distance: 712},
        {type: OfferPoiType.BUS, name: "Wołomińska 01", distance: 720},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Praga 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Młyn Michla 01", distance: 814},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Praga 02", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1525},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 1892},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 2176}
    ],
    17971: [
        {type: OfferPoiType.BUS, name: "Bieszczadzka 01 (ŃŻ)", distance: 721},
        {type: OfferPoiType.BUS, name: "Bieszczadzka", distance: 723},
        {type: OfferPoiType.BUS, name: "Bieszczadzka 02 (ŃŻ)", distance: 724},
        {type: OfferPoiType.PARK, name: "Zieleniec Parterowa", distance: 2514}
    ],
    17982: [
        {type: OfferPoiType.BUS, name: "Telefoniczna - Bystrzycka NŻ", distance: 89},
        {type: OfferPoiType.BUS, name: "Doły - Telefoniczna NŻ", distance: 206},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Tamka NŻ", distance: 325},
        {type: OfferPoiType.BUS, name: "Tamka - Telefoniczna NŻ", distance: 396},
        {type: OfferPoiType.BUS, name: "Doły - Smutna NŻ", distance: 682},
        {type: OfferPoiType.BUS, name: "Tamka - Styrska NŻ", distance: 719},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Telefoniczna 27 NŻ", distance: 810},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1453},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 1588},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1648},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1817},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1851},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1893},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1993},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 2003},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 2041}
    ],
    17983: [
        {type: OfferPoiType.BUS, name: "Bańgów Kościół", distance: 253},
        {type: OfferPoiType.PARK, name: "Skwer tajnej organizacji nauczycielskiej", distance: 449},
        {type: OfferPoiType.BUS, name: "Bańgów Zachodnia", distance: 814},
        {type: OfferPoiType.REZERWAT, name: 'Obszar chronionego krajobrazu "Przełajka"', distance: 1490},
        {type: OfferPoiType.PARK, name: 'Free Time Park "Brodzik"', distance: 2155},
        {type: OfferPoiType.REZERWAT, name: "Bażantarnia", distance: 2318}
    ],
    17986: [
        {type: OfferPoiType.BUS, name: "Mosty Warszawskie", distance: 80},
        {type: OfferPoiType.TRAM, name: "Mosty Warszawskie", distance: 86},
        {type: OfferPoiType.BUS, name: "Damrota", distance: 365},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 533},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 534},
        {type: OfferPoiType.BUS, name: "Kromera", distance: 659},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 730},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego", distance: 812},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 972},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1077},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1105},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1119},
        {type: OfferPoiType.PARK, name: "park Porucznika Roberta Marczewskiego", distance: 1396},
        {type: OfferPoiType.PARK, name: "skwer Skaczącej Gwiazdy", distance: 1475}
    ],
    17989: [
        {type: OfferPoiType.BUS, name: "Cmentarz Podgórski 04", distance: 529},
        {type: OfferPoiType.TRAM, name: "Cmentarz Podgórski 02", distance: 532},
        {type: OfferPoiType.TRAM, name: "Cmentarz Podgórski 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Cmentarz Podgórski 03", distance: 598},
        {type: OfferPoiType.BUS, name: "Dworcowa 05", distance: 641},
        {type: OfferPoiType.TRAM, name: "Dworcowa 01", distance: 641},
        {type: OfferPoiType.BUS, name: "Dworcowa 04", distance: 661},
        {type: OfferPoiType.TRAM, name: "Dworcowa 02", distance: 670},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 959},
        {type: OfferPoiType.PARK, name: "Baśniowy Ogród", distance: 991},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 1341},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 1645},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 1701}
    ],
    17990: [
        {type: OfferPoiType.BUS, name: "Telefoniczna - Bystrzycka NŻ", distance: 85},
        {type: OfferPoiType.BUS, name: "Doły - Telefoniczna NŻ", distance: 202},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Tamka NŻ", distance: 321},
        {type: OfferPoiType.BUS, name: "Tamka - Telefoniczna NŻ", distance: 392},
        {type: OfferPoiType.BUS, name: "Doły - Smutna NŻ", distance: 678},
        {type: OfferPoiType.BUS, name: "Tamka - Styrska NŻ", distance: 715},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Telefoniczna 27 NŻ", distance: 806},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1449},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 1584},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1644},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1813},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1847},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1889},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1989},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1999},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 2037}
    ],
    17994: [
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 153},
        {type: OfferPoiType.BUS, name: "Port", distance: 237},
        {type: OfferPoiType.BUS, name: "Centrum 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Plac Kościelny", distance: 305},
        {type: OfferPoiType.BUS, name: "Port 05", distance: 324},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 03", distance: 329},
        {type: OfferPoiType.BUS, name: "Centrum 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 04", distance: 340},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 384},
        {type: OfferPoiType.BUS, name: "Chrobrego 02", distance: 487},
        {type: OfferPoiType.LAS, name: "Parki Miejski im. Fryderyka Chopina", distance: 594},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 594}
    ],
    18002: [
        {type: OfferPoiType.BUS, name: "Tychy Bielska Wiadukt", distance: 283},
        {type: OfferPoiType.BUS, name: "Tychy Żwakowska", distance: 287},
        {type: OfferPoiType.KOLEJ, name: "Tychy Aleja Bielska", distance: 301},
        {type: OfferPoiType.BUS, name: "Tychy Bielska Szpital", distance: 488},
        {type: OfferPoiType.BUS, name: "Tychy Jana Pawła II", distance: 488},
        {type: OfferPoiType.KOLEJ, name: "Tychy Zachodnie", distance: 594},
        {type: OfferPoiType.BUS, name: "Tychy Osiedle M", distance: 608},
        {type: OfferPoiType.BUS, name: "Tychy Harcerska", distance: 642},
        {type: OfferPoiType.PARK, name: "Skwer przy ul. Czarnieckiego", distance: 740},
        {type: OfferPoiType.KOLEJ, name: "Tychy Grota Roweckiego", distance: 763},
        {type: OfferPoiType.PARK, name: "Park Jaworek", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer imienia Marii i Lecha Kaczyńskich", distance: 895},
        {type: OfferPoiType.PARK, name: "Skwer przy Bałuckiego", distance: 1031},
        {type: OfferPoiType.PARK, name: "Park Suble", distance: 1037},
        {type: OfferPoiType.PARK, name: "Park Niedźwiadków", distance: 1101}
    ],
    18008: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 650},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 684},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 728},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 732},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1076},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1639},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1721}
    ],
    18009: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 610},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 689},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 723},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 767},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 771},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1678},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1760}
    ],
    18016: [
        {type: OfferPoiType.BUS, name: "Moniuszki / Leclerc", distance: 129},
        {type: OfferPoiType.BUS, name: "11 Listopada / Biblioteka", distance: 143},
        {type: OfferPoiType.BUS, name: "Reja", distance: 218},
        {type: OfferPoiType.BUS, name: "3 Maja", distance: 354},
        {type: OfferPoiType.PARK, name: "Park Henryka Sienkiewicza", distance: 363},
        {type: OfferPoiType.BUS, name: "11 Listopada / Urząd Gminy", distance: 444},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy Oleśnica", distance: 469},
        {type: OfferPoiType.KOLEJ, name: "Oleśnica", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Kolejarzy Oleśnickich", distance: 888},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 890},
        {type: OfferPoiType.PARK, name: "Park Książąt Oleśnickich", distance: 1056},
        {type: OfferPoiType.PARK, name: "Skwer Kombatantów", distance: 1374},
        {type: OfferPoiType.PARK, name: "Park Nad Stawami", distance: 1783}
    ],
    18024: [
        {type: OfferPoiType.BUS, name: "Zjazdowa - Beskidzka NŻ", distance: 151},
        {type: OfferPoiType.BUS, name: "Marmurowa - Beskidzka NŻ", distance: 407},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Budy", distance: 439},
        {type: OfferPoiType.BUS, name: "Marmurowa - Brzezińska", distance: 576},
        {type: OfferPoiType.BUS, name: "Brzezińska - Marmurowa", distance: 748},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Opolska NŻ", distance: 793},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 1392}
    ],
    18025: [
        {type: OfferPoiType.BUS, name: "Katowice Bonifraterska", distance: 231},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 457},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 499},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 505},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 505},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 611},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 627},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury", distance: 631},
        {type: OfferPoiType.BUS, name: "Bogucice Markiefki", distance: 713},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury NOSPR", distance: 790},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 966},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1084},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1097},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1307}
    ],
    18028: [
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 51},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 558},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 570},
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 691},
        {type: OfferPoiType.BUS, name: "Olszynowa 02", distance: 826}
    ],
    18030: [
        {type: OfferPoiType.LAS, name: "Krynicki starodrzew", distance: 652},
        {type: OfferPoiType.REZERWAT, name: "Krynicki starodrzew", distance: 652},
        {type: OfferPoiType.REZERWAT, name: "Park Krajobrazowy Mierzeja Wiślana", distance: 1128}
    ],
    18031: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 188},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 333},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Hallera", distance: 349},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 423},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Pogonowskiego", distance: 431},
        {type: OfferPoiType.BUS, name: "Żeligowskiego - Pl. Hallera", distance: 477},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 492},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 542},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 584},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 594},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 661},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 678},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 789},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 846}
    ],
    18035: [
        {type: OfferPoiType.BUS, name: "Galeria Szperk 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Galeria Szperk", distance: 547},
        {type: OfferPoiType.BUS, name: "Maciejewicza 02", distance: 698},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 02", distance: 709},
        {type: OfferPoiType.BUS, name: "Maciejewicza", distance: 719},
        {type: OfferPoiType.BUS, name: "Maciejewicza 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Pogórze-Derdowskiego 02", distance: 756},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 01", distance: 763},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 02", distance: 781},
        {type: OfferPoiType.BUS, name: "Obłuże Maciejewicza", distance: 802},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1178},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1747},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 1939}
    ],
    18036: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 289},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 330},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 733},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 744},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 760},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1788}
    ],
    18037: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 288},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 371},
        {type: OfferPoiType.TRAM, name: "Żeromskiego", distance: 414},
        {type: OfferPoiType.BUS, name: "Żeromskiego n/ż", distance: 444},
        {type: OfferPoiType.BUS, name: "Niestachowska", distance: 554},
        {type: OfferPoiType.BUS, name: "Niestachowska n/ż", distance: 762},
        {type: OfferPoiType.BUS, name: "Św. Wawrzyńca", distance: 800},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1476},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1498},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 1634},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1865},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1939},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1945},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 1995},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 2038}
    ],
    18047: [
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 04", distance: 305},
        {type: OfferPoiType.TRAM, name: "Galeria Bałtycka 02", distance: 388},
        {type: OfferPoiType.TRAM, name: "Galeria Bałtycka 01", distance: 464},
        {type: OfferPoiType.PARK, name: "Park de Gaulle'a", distance: 489},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 06", distance: 510},
        {type: OfferPoiType.TRAM, name: "Klonowa", distance: 524},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 05", distance: 528},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 07", distance: 565},
        {type: OfferPoiType.PARK, name: 'Dawny cmentarz katolicki "Urania"', distance: 600},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 03", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterskiego Mariupola", distance: 706},
        {type: OfferPoiType.BUS, name: "Wrzeszcz PKP", distance: 710},
        {type: OfferPoiType.BUS, name: "Jaśkowa Dolina 03", distance: 758},
        {type: OfferPoiType.TRAM, name: "Jaśkowa Dolina 02", distance: 784},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Wrzeszcz", distance: 806},
        {type: OfferPoiType.TRAM, name: "Jaśkowa Dolina 01", distance: 822},
        {type: OfferPoiType.PARK, name: "Park Kuźniczki", distance: 948}
    ],
    18055: [
        {type: OfferPoiType.PARK, name: "Skwer przy PCK", distance: 1844},
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 1904},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 2094},
        {type: OfferPoiType.PARK, name: "Park im. Tysiąclecia", distance: 2382}
    ],
    18058: [
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 256},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 287},
        {type: OfferPoiType.BUS, name: "Kierbedzia 01", distance: 380},
        {type: OfferPoiType.BUS, name: "Hańczy 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 04", distance: 398},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 432},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 480},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 03", distance: 517},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 01", distance: 518},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 05", distance: 529},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 02", distance: 542},
        {type: OfferPoiType.BUS, name: "Tor Stegny 02", distance: 555},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 01", distance: 657},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 02", distance: 699},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 862},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1384},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1500},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1545},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1549},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1736},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1793},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1976},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 2008},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 2060},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2095},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2307}
    ],
    18059: [
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 223},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 03", distance: 441},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 01", distance: 497},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 530},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 02", distance: 545},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 624},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 637},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 940}
    ],
    18076: [
        {type: OfferPoiType.BUS, name: "Karolkowa 01", distance: 510},
        {type: OfferPoiType.TRAM, name: "Karolkowa 04", distance: 520},
        {type: OfferPoiType.TRAM, name: "Karolkowa 03", distance: 543},
        {type: OfferPoiType.BUS, name: "Karolkowa 02", distance: 548},
        {type: OfferPoiType.BUS, name: "Rondo Daszyńskiego 09", distance: 573},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Główna", distance: 662},
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 692},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 703},
        {type: OfferPoiType.BUS, name: "Spiska 02", distance: 729},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 14", distance: 790},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 11", distance: 795},
        {type: OfferPoiType.BUS, name: "Rondo Daszyńskiego 02", distance: 796},
        {type: OfferPoiType.METRO, name: "Rondo Daszyńskiego", distance: 801},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 08", distance: 804},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 884},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 928},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1262},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1585},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1611},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1732},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1811},
        {type: OfferPoiType.PARK, name: "Skwer Sue Ryder", distance: 1871}
    ],
    18094: [
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 248},
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 341},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 622},
        {type: OfferPoiType.BUS, name: "Klonowa (NŻ)", distance: 630},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 707},
        {type: OfferPoiType.BUS, name: "Dębogórze-Wybudowanie - Długa 01", distance: 783},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1221},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1922},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 2285}
    ],
    18103: [
        {type: OfferPoiType.BUS, name: "Sołtysowska 04", distance: 210},
        {type: OfferPoiType.BUS, name: "ZDMK 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Sołtysowska 02", distance: 303},
        {type: OfferPoiType.BUS, name: "Sołtysowska 01", distance: 310},
        {type: OfferPoiType.BUS, name: "ZDMK 02", distance: 346},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 564},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 01", distance: 607},
        {type: OfferPoiType.BUS, name: "Centralna 01", distance: 619},
        {type: OfferPoiType.BUS, name: "Ciesielskiego 01", distance: 631},
        {type: OfferPoiType.BUS, name: "Centralna 02", distance: 664},
        {type: OfferPoiType.TRAM, name: "Gałczyńskiego 01", distance: 754},
        {type: OfferPoiType.TRAM, name: "Gałczyńskiego 02", distance: 770},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1264},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 1694},
        {type: OfferPoiType.PARK, name: "Park Lotników Polskich", distance: 2003},
        {type: OfferPoiType.PARK, name: "Ogródek Wiewiórek", distance: 2211},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2244},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 2257},
        {type: OfferPoiType.PARK, name: "Avia Parkour Park", distance: 2304},
        {type: OfferPoiType.PARK, name: "Park Czyżyny", distance: 2373}
    ],
    18105: [
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 156},
        {type: OfferPoiType.BUS, name: "Os. Winiary", distance: 565},
        {type: OfferPoiType.BUS, name: "Witosa Wiadukt", distance: 617},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 689},
        {type: OfferPoiType.BUS, name: "Dojazd n/ż", distance: 717},
        {type: OfferPoiType.TRAM, name: "Os. Winiary", distance: 727},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1879},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1932},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 2025},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 2155},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 2224},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2301},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2412}
    ],
    18106: [
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 644},
        {type: OfferPoiType.BUS, name: "Osiedle Sarni Stok", distance: 669},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1814},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1954}
    ],
    18107: [
        {type: OfferPoiType.BUS, name: "Głęboka 91", distance: 352},
        {type: OfferPoiType.TRAM, name: "Głęboka 02", distance: 413},
        {type: OfferPoiType.BUS, name: "Głęboka 01", distance: 430},
        {type: OfferPoiType.TRAM, name: "Głęboka 01", distance: 445},
        {type: OfferPoiType.BUS, name: "Mostek 01", distance: 450},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 532},
        {type: OfferPoiType.BUS, name: "Mostek 02", distance: 558},
        {type: OfferPoiType.BUS, name: "Elbląska", distance: 626},
        {type: OfferPoiType.BUS, name: "Brama Żuławska 05", distance: 678},
        {type: OfferPoiType.TRAM, name: "Brama Żuławska", distance: 761},
        {type: OfferPoiType.BUS, name: "Miałki Szlak 01", distance: 790},
        {type: OfferPoiType.BUS, name: "Brama Żuławska 06", distance: 798},
        {type: OfferPoiType.BUS, name: "Brama Żuławska", distance: 826},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1077},
        {type: OfferPoiType.PARK, name: "Skwer Bajki", distance: 1242},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 1319},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1648}
    ],
    18111: [
        {type: OfferPoiType.BUS, name: "Suszki", distance: 204},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 546},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 576},
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 717},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 751},
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1285},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1397},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1594},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 1886},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2075},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2363},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2410},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2474}
    ],
    18115: [
        {type: OfferPoiType.BUS, name: "Willowa 02", distance: 344},
        {type: OfferPoiType.BUS, name: "Willowa 01", distance: 395},
        {type: OfferPoiType.BUS, name: "Olszynowa 02", distance: 613},
        {type: OfferPoiType.BUS, name: "Olszynowa 03", distance: 642}
    ],
    18117: [
        {type: OfferPoiType.BUS, name: "(N/Ż) Sandomierska / Nowy Folwark", distance: 183},
        {type: OfferPoiType.BUS, name: "(N/Ż) Sandomierska / Szczecińska", distance: 356},
        {type: OfferPoiType.BUS, name: "Sandomierska / Poleska", distance: 391},
        {type: OfferPoiType.BUS, name: "Szczecińska / Mazurska", distance: 570},
        {type: OfferPoiType.BUS, name: "Sandomierska / Morcinka", distance: 705},
        {type: OfferPoiType.BUS, name: "Sandomierska", distance: 744},
        {type: OfferPoiType.BUS, name: "Sandomierska / Śląska", distance: 748},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1312},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1447},
        {type: OfferPoiType.PARK, name: "Skwer im. Mikołaja Kopernika", distance: 1596},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1835},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1855},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2137},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Żeromskiego", distance: 2402}
    ],
    18123: [
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 322},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 354},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 422},
        {type: OfferPoiType.BUS, name: "Nadziei 01", distance: 453},
        {type: OfferPoiType.BUS, name: "Nadziei 02", distance: 559}
    ],
    18128: [
        {type: OfferPoiType.BUS, name: "Kopernika - Łąkowa", distance: 6},
        {type: OfferPoiType.TRAM, name: "Kopernika - Łąkowa", distance: 47},
        {type: OfferPoiType.BUS, name: "Łąkowa - Karolewska", distance: 216},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Pogonowskiego NŻ", distance: 293},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 298},
        {type: OfferPoiType.BUS, name: "Kopernika - Żeromskiego", distance: 321},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 391},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Kopernika", distance: 399},
        {type: OfferPoiType.TRAM, name: "Kopernika - Tobaco Park", distance: 401},
        {type: OfferPoiType.BUS, name: "Kopernika - Tobaco Park", distance: 407},
        {type: OfferPoiType.BUS, name: "Łąkowa - Struga", distance: 436},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Żeromskiego", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 534},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Mickiewicza", distance: 549},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 569},
        {type: OfferPoiType.TRAM, name: "Mickiewicza - Żeromskiego", distance: 570},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 577},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 790},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 845},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2096}
    ],
    18132: [{type: OfferPoiType.BUS, name: "Krzeptów - Boisko", distance: 804}],
    18133: [
        {type: OfferPoiType.BUS, name: "Przymorze Wielkie", distance: 438},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 03", distance: 469},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 01", distance: 486},
        {type: OfferPoiType.BUS, name: "Biały Dwór 02", distance: 493},
        {type: OfferPoiType.BUS, name: "Biały Dwór 01", distance: 519},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Olsztyńska 01", distance: 610},
        {type: OfferPoiType.BUS, name: "Olsztyńska 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Olsztyńska 04", distance: 685},
        {type: OfferPoiType.PARK, name: "Park imienia Ronalda Reagana", distance: 697},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1543},
        {type: OfferPoiType.PARK, name: "Skwer Kwitnących Wiśni", distance: 1563},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1738}
    ],
    18134: [
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 286},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 309},
        {type: OfferPoiType.BUS, name: "Krakowska", distance: 601},
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 651},
        {type: OfferPoiType.TRAM, name: "Krakowska", distance: 667},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1524},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1907},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2347}
    ],
    18137: [
        {type: OfferPoiType.BUS, name: "Dobra 01", distance: 81},
        {type: OfferPoiType.BUS, name: "Dobra 02", distance: 90},
        {type: OfferPoiType.BUS, name: "Wróbla 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Wróbla 01", distance: 310},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 581},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 01", distance: 649},
        {type: OfferPoiType.BUS, name: "Zagony", distance: 711},
        {type: OfferPoiType.BUS, name: "Chmielna 03", distance: 713},
        {type: OfferPoiType.TRAM, name: "Chmielna 01", distance: 716},
        {type: OfferPoiType.TRAM, name: "Chmielna 02", distance: 738},
        {type: OfferPoiType.TRAM, name: "Akademia Muzyczna", distance: 759},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 839},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 982},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1184},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1369},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2459}
    ],
    18138: [
        {type: OfferPoiType.BUS, name: "Katowice Piotra Skargi", distance: 77},
        {type: OfferPoiType.BUS, name: "Katowice Sokolska", distance: 173},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 178},
        {type: OfferPoiType.BUS, name: "Katowice Plac Synagogi", distance: 228},
        {type: OfferPoiType.BUS, name: "Katowice Mickiewicza", distance: 253},
        {type: OfferPoiType.TRAM, name: "Katowice Dworzec PKP", distance: 433},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 434},
        {type: OfferPoiType.TRAM, name: "Katowice Sokolska", distance: 465},
        {type: OfferPoiType.TRAM, name: "Katowice Rynek", distance: 472},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 551},
        {type: OfferPoiType.TRAM, name: "Katowice Rynek Teatr Śląski", distance: 622},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 714},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 736},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 854},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 895},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1000},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 1023},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 1128}
    ],
    18139: [
        {type: OfferPoiType.BUS, name: "Grochowe Łąki", distance: 130},
        {type: OfferPoiType.BUS, name: "Małe Garbary", distance: 253},
        {type: OfferPoiType.BUS, name: "Garbary PKM", distance: 376},
        {type: OfferPoiType.TRAM, name: "Małe Garbary", distance: 419},
        {type: OfferPoiType.KOLEJ, name: "Poznań Garbary", distance: 538},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 648},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 809},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 876},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 972},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 1054},
        {type: OfferPoiType.PARK, name: "Park Cytadela", distance: 1113},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1266},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1655},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1668},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1773}
    ],
    18141: [
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 119},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 145},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 02", distance: 653},
        {type: OfferPoiType.BUS, name: "Mochnaniec 02", distance: 654},
        {type: OfferPoiType.BUS, name: "Piltza 04", distance: 680},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 692},
        {type: OfferPoiType.BUS, name: "Mochnaniec 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Skotniki Szkoła 03", distance: 738},
        {type: OfferPoiType.TRAM, name: "Czerwone Maki P+R 01", distance: 764},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 06", distance: 765},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 03", distance: 769},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1013},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2223},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2284}
    ],
    18145: [
        {type: OfferPoiType.BUS, name: "Myśliwska / Kameliowa 05", distance: 475},
        {type: OfferPoiType.BUS, name: "Rudna Wielka Myśliwska / Oliwkowa 34", distance: 570},
        {type: OfferPoiType.BUS, name: "Rudna Wielka Myśliwska / Oliwkowa 33", distance: 649},
        {type: OfferPoiType.BUS, name: "Myśliwska / Kameliowa 06", distance: 771}
    ],
    18146: [
        {type: OfferPoiType.BUS, name: "Koło 03", distance: 161},
        {type: OfferPoiType.BUS, name: "Koło 04", distance: 247},
        {type: OfferPoiType.TRAM, name: "Koło 02", distance: 247},
        {type: OfferPoiType.TRAM, name: "Koło 01", distance: 266},
        {type: OfferPoiType.BUS, name: "Koło 05", distance: 267},
        {type: OfferPoiType.BUS, name: "Dalibora 04", distance: 271},
        {type: OfferPoiType.BUS, name: "Koło 06", distance: 281},
        {type: OfferPoiType.TRAM, name: "Koło 71", distance: 349},
        {type: OfferPoiType.BUS, name: "Dalibora 03", distance: 355},
        {type: OfferPoiType.TRAM, name: "Koło 07", distance: 364},
        {type: OfferPoiType.TRAM, name: "Koło 08", distance: 369},
        {type: OfferPoiType.BUS, name: "Dalibora 01", distance: 416},
        {type: OfferPoiType.TRAM, name: "Dalibora 05", distance: 419},
        {type: OfferPoiType.TRAM, name: "Dalibora 06", distance: 463},
        {type: OfferPoiType.BUS, name: "Dalibora 02", distance: 474},
        {type: OfferPoiType.BUS, name: "Brożka 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Brożka 02", distance: 526},
        {type: OfferPoiType.PARK, name: "Park im. Księcia Janusza", distance: 575},
        {type: OfferPoiType.TRAM, name: "Deotymy 05", distance: 693},
        {type: OfferPoiType.TRAM, name: "Deotymy 06", distance: 737},
        {type: OfferPoiType.METRO, name: "Księcia Janusza", distance: 752},
        {type: OfferPoiType.PARK, name: "Park Ulricha", distance: 1010},
        {type: OfferPoiType.LAS, name: "Lasek na Kole", distance: 1121},
        {type: OfferPoiType.PARK, name: "Park Moczydło", distance: 1254}
    ],
    18148: [
        {type: OfferPoiType.BUS, name: "Wełnowiec Poczta", distance: 369},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Kościół", distance: 510},
        {type: OfferPoiType.TRAM, name: "Koszutka Jesionowa", distance: 594},
        {type: OfferPoiType.BUS, name: "Koszutka Iłłakowiczówny", distance: 638},
        {type: OfferPoiType.BUS, name: "Koszutka Słoneczna", distance: 680},
        {type: OfferPoiType.TRAM, name: "Wełnowiec DL Tower", distance: 716},
        {type: OfferPoiType.LAS, name: "Park Wełnowiecki", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 722},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna Pętla", distance: 727},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna", distance: 806},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1126},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1135},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1256},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1407},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1504},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1505},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1692}
    ],
    18150: [
        {type: OfferPoiType.BUS, name: "Szobera 02", distance: 137},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 01", distance: 205},
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 233},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 03", distance: 315},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 04", distance: 343},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 02", distance: 395},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 407},
        {type: OfferPoiType.BUS, name: "Narwik 01", distance: 507},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 15", distance: 535},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 53", distance: 541},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 14", distance: 543},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 13", distance: 549},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 12", distance: 556},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 11", distance: 562},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 72", distance: 591},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 841}
    ],
    18151: [
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Usługowa", distance: 121},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Enea", distance: 173},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Polna Camping", distance: 248},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Polna Rondo", distance: 479},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 1842},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 1844},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 1848}
    ],
    18152: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 499},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 634},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 747},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 768},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 794},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 803},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2273},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2476}
    ],
    18158: [
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 318},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 416},
        {type: OfferPoiType.BUS, name: "Plac Litewski 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Plac Litewski 02", distance: 509},
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 748},
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 779},
        {type: OfferPoiType.BUS, name: "Plac Wolności 02", distance: 795},
        {type: OfferPoiType.BUS, name: "Lubomelska 02", distance: 808},
        {type: OfferPoiType.BUS, name: "Brama Krakowska 01", distance: 822},
        {type: OfferPoiType.PARK, name: "Plac Lecha Kaczyńskiego", distance: 1004}
    ],
    18159: [
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 03", distance: 44},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 05", distance: 80},
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 04", distance: 93},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 02", distance: 96},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 01", distance: 107},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 06", distance: 128},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 311},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 326},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Nowolipie 01", distance: 415},
        {type: OfferPoiType.BUS, name: "Okopowa 10", distance: 467},
        {type: OfferPoiType.TRAM, name: "Okopowa 03", distance: 468},
        {type: OfferPoiType.BUS, name: "Nowolipie 02", distance: 484},
        {type: OfferPoiType.BUS, name: "Okopowa 01", distance: 497},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 536},
        {type: OfferPoiType.TRAM, name: "Kino Femina 05", distance: 537},
        {type: OfferPoiType.TRAM, name: "Kino Femina 10", distance: 571},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 600},
        {type: OfferPoiType.TRAM, name: "Kino Femina 09", distance: 604},
        {type: OfferPoiType.TRAM, name: "Kino Femina 06", distance: 613},
        {type: OfferPoiType.TRAM, name: "Okopowa 08", distance: 637},
        {type: OfferPoiType.TRAM, name: "Okopowa 07", distance: 637},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 694},
        {type: OfferPoiType.TRAM, name: "Żytnia 02", distance: 770},
        {type: OfferPoiType.PARK, name: "Skwer Racheli Auerbach", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 850},
        {type: OfferPoiType.PARK, name: "Skwer gen. Jana Jura-Gorzechowskiego", distance: 913},
        {type: OfferPoiType.PARK, name: "Skwer Duśki Trafankowskiej", distance: 1037},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1106},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 2388}
    ],
    18160: [
        {type: OfferPoiType.BUS, name: "Zdrojowa/Leśna", distance: 497},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1119},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1131}
    ],
    18161: [
        {type: OfferPoiType.TRAM, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 239},
        {type: OfferPoiType.BUS, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 250},
        {type: OfferPoiType.BUS, name: "Świstackiego", distance: 425},
        {type: OfferPoiType.BUS, name: "Plac Wróblewskiego", distance: 473},
        {type: OfferPoiType.BUS, name: "Na Grobli (Hydropolis)", distance: 526},
        {type: OfferPoiType.TRAM, name: "Plac Wróblewskiego", distance: 539},
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej", distance: 552},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 676},
        {type: OfferPoiType.TRAM, name: "Komuny Paryskiej", distance: 677},
        {type: OfferPoiType.TRAM, name: "Na Niskich Łąkach", distance: 693},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 773},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 1049},
        {type: OfferPoiType.PARK, name: "Park Juliusza Słowackiego", distance: 1311},
        {type: OfferPoiType.PARK, name: "skwer Wrocławianek", distance: 1409},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1629}
    ],
    18162: [
        {type: OfferPoiType.BUS, name: "Plac Mickiewicza", distance: 374},
        {type: OfferPoiType.BUS, name: "Plac Żwirki i Wigury", distance: 380},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 560},
        {type: OfferPoiType.BUS, name: "Michałowicza Czarnieckiego", distance: 614},
        {type: OfferPoiType.BUS, name: "PCK PKP Lipnik", distance: 736},
        {type: OfferPoiType.BUS, name: "Sobieskiego Wyspiańskiego", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Włókniarzy", distance: 788}
    ],
    18179: [
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 559},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 578},
        {type: OfferPoiType.BUS, name: "Kamykowa 01", distance: 616},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1332}
    ],
    18183: [
        {type: OfferPoiType.BUS, name: "Rondo Kuronia 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Rondo Kuronia 02", distance: 232},
        {type: OfferPoiType.BUS, name: "Źródlana 01", distance: 481},
        {type: OfferPoiType.BUS, name: "Źródlana 02", distance: 508},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 686},
        {type: OfferPoiType.BUS, name: "Jasień Działki 01", distance: 710},
        {type: OfferPoiType.BUS, name: "Jasień Działki 02", distance: 792},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1327},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2303},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 2478}
    ],
    18184: [
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 63},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 178},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 192},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 285},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 341},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 487},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 500},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 579},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 606},
        {type: OfferPoiType.BUS, name: "Powstańców Magazyny 01", distance: 802},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1407},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1408}
    ],
    18221: [
        {type: OfferPoiType.BUS, name: "Piaśniki Skrzyżowanie", distance: 448},
        {type: OfferPoiType.BUS, name: "Piaśniki Szpital", distance: 465},
        {type: OfferPoiType.BUS, name: "Chropaczów Sudecka", distance: 480},
        {type: OfferPoiType.BUS, name: "Chropaczów Szkoła", distance: 544},
        {type: OfferPoiType.TRAM, name: "Chropaczów Szkoła", distance: 546},
        {type: OfferPoiType.TRAM, name: "Piaśniki Skrzyżowanie", distance: 551},
        {type: OfferPoiType.TRAM, name: "Chropaczów Osiedle Na Wzgórzu", distance: 582},
        {type: OfferPoiType.PARK, name: "Park Chropaczowski imieniem Kopalni Śląsk", distance: 590},
        {type: OfferPoiType.TRAM, name: "Piaśniki Szpital", distance: 672},
        {type: OfferPoiType.BUS, name: "Chropaczów Ratusz", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Heiloo", distance: 834},
        {type: OfferPoiType.LAS, name: "Zespół parkowo-leśny Piaśniki-Chropaczów", distance: 886},
        {type: OfferPoiType.REZERWAT, name: "Staw Foryśka", distance: 1054},
        {type: OfferPoiType.PARK, name: "Park Skałka", distance: 1503},
        {type: OfferPoiType.PARK, name: "Park Łagiewnicki", distance: 1595},
        {type: OfferPoiType.PARK, name: "Park Amelung", distance: 1638}
    ],
    18226: [
        {type: OfferPoiType.TRAM, name: "Plac Wolności", distance: 353},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Floriana Czakiego", distance: 368},
        {type: OfferPoiType.TRAM, name: "Plac Praw Kobiet", distance: 405},
        {type: OfferPoiType.TRAM, name: "Dworcowa / Matejki", distance: 436},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 439},
        {type: OfferPoiType.TRAM, name: "Plac Teatralny", distance: 445},
        {type: OfferPoiType.BUS, name: "Śniadeckich / Sienkiewicza", distance: 463},
        {type: OfferPoiType.TRAM, name: "Focha / Opera", distance: 478},
        {type: OfferPoiType.BUS, name: "Focha / Opera", distance: 487},
        {type: OfferPoiType.BUS, name: "Plac Teatralny", distance: 578},
        {type: OfferPoiType.BUS, name: "Śniadeckich / Gdańska", distance: 596},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 645},
        {type: OfferPoiType.BUS, name: "Królowej Jadwigi / Astoria", distance: 646},
        {type: OfferPoiType.BUS, name: "Plac Piastowski", distance: 687},
        {type: OfferPoiType.PARK, name: "Skwer Leona Barciszewskiego", distance: 712},
        {type: OfferPoiType.BUS, name: "Garbary", distance: 725},
        {type: OfferPoiType.BUS, name: "Rondo Jagiellonów", distance: 725},
        {type: OfferPoiType.TRAM, name: "Rondo Jagiellonów", distance: 775},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 787}
    ],
    18227: [
        {type: OfferPoiType.PARK, name: "Plac Generała Władysława Sikorskiego", distance: 168},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 205},
        {type: OfferPoiType.TRAM, name: "Muzeum Narodowe 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 03", distance: 248},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 05", distance: 286},
        {type: OfferPoiType.TRAM, name: "UJ / AST 01", distance: 321},
        {type: OfferPoiType.TRAM, name: "Muzeum Narodowe 02", distance: 340},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 04", distance: 384},
        {type: OfferPoiType.TRAM, name: "UJ / AST 02", distance: 399},
        {type: OfferPoiType.BUS, name: "AGH / UR 02", distance: 497},
        {type: OfferPoiType.BUS, name: "Filharmonia 04", distance: 529},
        {type: OfferPoiType.BUS, name: "Cracovia Błonia 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Cracovia Stadion 02", distance: 546},
        {type: OfferPoiType.BUS, name: "Cracovia Błonia 01", distance: 546},
        {type: OfferPoiType.TRAM, name: "Oleandry 01", distance: 568},
        {type: OfferPoiType.BUS, name: "AGH / UR 01", distance: 582},
        {type: OfferPoiType.BUS, name: "Jubilat 03", distance: 592},
        {type: OfferPoiType.TRAM, name: "Filharmonia 03", distance: 612},
        {type: OfferPoiType.TRAM, name: "Oleandry 02", distance: 613},
        {type: OfferPoiType.TRAM, name: "Jubilat 01", distance: 621},
        {type: OfferPoiType.PARK, name: "Ogród Profesorski", distance: 630},
        {type: OfferPoiType.TRAM, name: "Teatr Bagatela 01", distance: 637},
        {type: OfferPoiType.TRAM, name: "Filharmonia 02", distance: 664},
        {type: OfferPoiType.PARK, name: "Park im. Wisławy Szymborskiej", distance: 684},
        {type: OfferPoiType.PARK, name: "Ogród chiński", distance: 717},
        {type: OfferPoiType.PARK, name: "Skwer Konika Zwierzynieckiego", distance: 802},
        {type: OfferPoiType.PARK, name: "Skwer imienia Gustawa Holoubka", distance: 920},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 1580}
    ],
    18230: [
        {type: OfferPoiType.BUS, name: "Kantorowice 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Kantorowice 02", distance: 303},
        {type: OfferPoiType.BUS, name: "Kantorowice 04", distance: 386},
        {type: OfferPoiType.BUS, name: "Niebyła 01", distance: 630},
        {type: OfferPoiType.BUS, name: "Niebyła 02", distance: 646},
        {type: OfferPoiType.PARK, name: "Park Zielony Jar Wandy", distance: 1597},
        {type: OfferPoiType.PARK, name: "Park Zakole", distance: 1613}
    ],
    18231: [
        {type: OfferPoiType.BUS, name: "Ludwinów 02", distance: 436},
        {type: OfferPoiType.TRAM, name: "Smolki 01", distance: 492},
        {type: OfferPoiType.BUS, name: "Smolki 01", distance: 498},
        {type: OfferPoiType.TRAM, name: "Smolki 02", distance: 519},
        {type: OfferPoiType.BUS, name: "Smolki 02", distance: 524},
        {type: OfferPoiType.BUS, name: "Ludwinów 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 568},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 575},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 590},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 622},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 626},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 695},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 764},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 771},
        {type: OfferPoiType.BUS, name: "Os. Podwawelskie", distance: 817},
        {type: OfferPoiType.TRAM, name: "Korona 01", distance: 819},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1148},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1148},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1168},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1220},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1242},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2051},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2199},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2356},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2447}
    ],
    18240: [
        {type: OfferPoiType.BUS, name: "Stefanówka 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Stefanówka 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Boryszew 01", distance: 778},
        {type: OfferPoiType.PARK, name: "Skwer Generała Stefana Grota-Roweckiego", distance: 1832}
    ],
    18241: [
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 02", distance: 464},
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 497},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 561},
        {type: OfferPoiType.TRAM, name: "Czerwone Maki P+R 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 06", distance: 576},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 03", distance: 591},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 04", distance: 595},
        {type: OfferPoiType.TRAM, name: "Czerwone Maki P+R", distance: 658},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1399},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2095},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2437}
    ],
    18242: [
        {type: OfferPoiType.BUS, name: "Bronowice Małe", distance: 399},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 03", distance: 451},
        {type: OfferPoiType.BUS, name: "Lindego 03", distance: 492},
        {type: OfferPoiType.BUS, name: "Lindego 02", distance: 575},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Lindego 01", distance: 602},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 05", distance: 621},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 628},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 09", distance: 679},
        {type: OfferPoiType.TRAM, name: "Bronowice Małe 01", distance: 769},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 06", distance: 782},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1877},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1920},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2188},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 2313},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 2379}
    ],
    18245: [
        {type: OfferPoiType.BUS, name: "FAT", distance: 192},
        {type: OfferPoiType.TRAM, name: "FAT", distance: 284},
        {type: OfferPoiType.BUS, name: "Fiołkowa", distance: 307},
        {type: OfferPoiType.TRAM, name: "Fiołkowa", distance: 429},
        {type: OfferPoiType.BUS, name: "Grabiszyńska (Cmentarz)", distance: 600},
        {type: OfferPoiType.BUS, name: "Aleja Pracy", distance: 616},
        {type: OfferPoiType.TRAM, name: "Aleja Pracy", distance: 621},
        {type: OfferPoiType.TRAM, name: "Grabiszyńska (Cmentarz)", distance: 660},
        {type: OfferPoiType.PARK, name: "Park Grabiszyński", distance: 1108},
        {type: OfferPoiType.LAS, name: "Lasek Oporowski", distance: 1418}
    ],
    18252: [
        {type: OfferPoiType.TRAM, name: "Most Osobowicki", distance: 766},
        {type: OfferPoiType.BUS, name: "Most Osobowicki", distance: 772},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1373},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 1794}
    ],
    18254: [
        {type: OfferPoiType.BUS, name: "Karpińskiego 02", distance: 132},
        {type: OfferPoiType.BUS, name: "Nowosądecka 03", distance: 346},
        {type: OfferPoiType.BUS, name: "Nowosądecka 04", distance: 399},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 02", distance: 440},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Nowosądecka 05", distance: 487},
        {type: OfferPoiType.BUS, name: "Tuchowska 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Tuchowska 01", distance: 545},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 569},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 02", distance: 573},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 01", distance: 627},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 02", distance: 641},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 03", distance: 657},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 703},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1193},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1515},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1781}
    ],
    18257: [
        {type: OfferPoiType.BUS, name: "Gocław 10", distance: 444},
        {type: OfferPoiType.BUS, name: "Gocław 09", distance: 470},
        {type: OfferPoiType.BUS, name: "Stoczniowców 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Stoczniowców 01", distance: 485},
        {type: OfferPoiType.BUS, name: "Gocław 05", distance: 517},
        {type: OfferPoiType.BUS, name: "Gocław 01", distance: 530},
        {type: OfferPoiType.BUS, name: "Gocław 02", distance: 550},
        {type: OfferPoiType.BUS, name: "Gocław 03", distance: 553},
        {type: OfferPoiType.BUS, name: "Gocław 04", distance: 566},
        {type: OfferPoiType.BUS, name: "Most Siekierkowski 04", distance: 583},
        {type: OfferPoiType.PARK, name: "Park/Ogród przy Kościele", distance: 1183},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1335},
        {type: OfferPoiType.PARK, name: "Ogród na Meissnera", distance: 1559},
        {type: OfferPoiType.PARK, name: "Park Nad Balatonem", distance: 2073},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 2208},
        {type: OfferPoiType.PARK, name: "Dziki park angielski", distance: 2338}
    ],
    18258: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 473},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 509},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 516},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 541},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 603},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Ojca Aniceta 01", distance: 823},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1317},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2207}
    ],
    18259: [
        {type: OfferPoiType.BUS, name: "3 Maja 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 02", distance: 588},
        {type: OfferPoiType.BUS, name: "3 Maja 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 671},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 1282},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1295}
    ],
    18266: [
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 341},
        {type: OfferPoiType.BUS, name: "Baśniowa", distance: 600},
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 754},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1776}
    ],
    18267: [
        {type: OfferPoiType.BUS, name: "Zespół Szkół Morskich 01", distance: 206},
        {type: OfferPoiType.BUS, name: "Zespół Szkół Morskich 02", distance: 265},
        {type: OfferPoiType.TRAM, name: "Latarnia Morska", distance: 518},
        {type: OfferPoiType.BUS, name: "Krasickiego 04", distance: 570},
        {type: OfferPoiType.BUS, name: "Krasickiego 03", distance: 626},
        {type: OfferPoiType.TRAM, name: "Krasickiego 02", distance: 634},
        {type: OfferPoiType.PARK, name: "Park Brzeźnieński im. J. J. Haffnera", distance: 738},
        {type: OfferPoiType.TRAM, name: "Krasickiego 01", distance: 742},
        {type: OfferPoiType.BUS, name: "Wyzwolenia 01", distance: 750}
    ],
    18275: [
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Rzemieślnicza", distance: 227},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Studzienna", distance: 304},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Wysoki Stoczek", distance: 343},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Swobodna", distance: 401},
        {type: OfferPoiType.BUS, name: "Swobodna", distance: 574},
        {type: OfferPoiType.BUS, name: "Swobodna/Wysoki Stoczek", distance: 603},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Cmentarz Św. Rocha", distance: 614},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/al. Jana Pawła II", distance: 662},
        {type: OfferPoiType.BUS, name: "al. Jana Pawła II/Kościół", distance: 712},
        {type: OfferPoiType.BUS, name: "al. Jana Pawła II/Rzeka Biała", distance: 719},
        {type: OfferPoiType.PARK, name: "Park Antoniuk", distance: 763},
        {type: OfferPoiType.PARK, name: "Leśny Park Kieszonkowy", distance: 2150},
        {type: OfferPoiType.PARK, name: "Lawendowy park kieszonkowy", distance: 2195},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Piotra Karolskiego", distance: 2265},
        {type: OfferPoiType.REZERWAT, name: "Stawy Marczukowskie i Dolina Bażantarki", distance: 2317}
    ],
    18276: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 211},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 392},
        {type: OfferPoiType.TRAM, name: "Armii Krajowej", distance: 421},
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 435},
        {type: OfferPoiType.BUS, name: "Park Wschodni", distance: 600},
        {type: OfferPoiType.TRAM, name: "Park Wschodni", distance: 603},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 655},
        {type: OfferPoiType.LAS, name: "Las Rakowiecki", distance: 860},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1449},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1640},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1953}
    ],
    18282: [
        {type: OfferPoiType.BUS, name: "Góralska 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Góralska 01", distance: 236},
        {type: OfferPoiType.BUS, name: "Leśna Góra 01", distance: 335},
        {type: OfferPoiType.BUS, name: "Leśna Góra - Przychodnia 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Leśna Góra - Przychodnia 01", distance: 410},
        {type: OfferPoiType.BUS, name: "Podkarpacka", distance: 448},
        {type: OfferPoiType.BUS, name: "Potokowa 03", distance: 476},
        {type: OfferPoiType.BUS, name: "Potokowa 02", distance: 526},
        {type: OfferPoiType.BUS, name: "Potokowa 04", distance: 616},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Wąwóz Huzarów", distance: 1898},
        {type: OfferPoiType.PARK, name: "Skwer prof. Pawła Gałuszki", distance: 1959},
        {type: OfferPoiType.PARK, name: "Plac Generała Stanisława Maczka", distance: 2311}
    ],
    18286: [
        {type: OfferPoiType.BUS, name: "Żabiniec 02", distance: 331},
        {type: OfferPoiType.BUS, name: "Żmujdzka 02", distance: 536},
        {type: OfferPoiType.BUS, name: "Reja 01", distance: 555},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 682},
        {type: OfferPoiType.BUS, name: "Imbramowska 01", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1422},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 1474}
    ],
    18289: [
        {type: OfferPoiType.BUS, name: "Kiełpinek PKM 01", distance: 603},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Kiełpinek", distance: 698},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Dolina Strzyży", distance: 1784},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 2267},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2319}
    ],
    18293: [
        {type: OfferPoiType.BUS, name: "Akwarelowa", distance: 377},
        {type: OfferPoiType.BUS, name: "Fioletowa", distance: 651},
        {type: OfferPoiType.BUS, name: "Zdroje Szpital", distance: 667},
        {type: OfferPoiType.LAS, name: "Park Leśny Klęskowo", distance: 1250},
        {type: OfferPoiType.PARK, name: "Park Leśny Klęskowo", distance: 1250},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Bukowe Zdroje im. Profesora Tadeusza Dominika", distance: 2069},
        {type: OfferPoiType.PARK, name: "Park Leśny Zdroje", distance: 2248}
    ],
    18296: [
        {type: OfferPoiType.BUS, name: "Boenigka", distance: 619},
        {type: OfferPoiType.TRAM, name: "Boenigka", distance: 661},
        {type: OfferPoiType.TRAM, name: "Carrefour", distance: 800},
        {type: OfferPoiType.BUS, name: "Carrefour", distance: 827},
        {type: OfferPoiType.PARK, name: "Skwer generała Augusta Fieldorfa–Nila", distance: 1286},
        {type: OfferPoiType.PARK, name: "Plac Mazurski", distance: 1961},
        {type: OfferPoiType.PARK, name: "Park Nagórki-Jaroty", distance: 2035}
    ],
    18318: [
        {type: OfferPoiType.BUS, name: "Orężna 01", distance: 621},
        {type: OfferPoiType.BUS, name: "Orężna 02", distance: 703},
        {type: OfferPoiType.BUS, name: "Łoziska 01", distance: 772},
        {type: OfferPoiType.REZERWAT, name: "Redutowa", distance: 1430}
    ],
    18320: [
        {type: OfferPoiType.BUS, name: "Bolesława Krzywoustego 02", distance: 335},
        {type: OfferPoiType.BUS, name: "Zielonej Gęsi 01", distance: 543},
        {type: OfferPoiType.BUS, name: "Bolesława Śmiałego 02", distance: 662},
        {type: OfferPoiType.BUS, name: "Henryka Probusa 01", distance: 783},
        {type: OfferPoiType.BUS, name: "Przemysława II 02", distance: 802},
        {type: OfferPoiType.BUS, name: "Konotopska 01", distance: 810},
        {type: OfferPoiType.BUS, name: "PKP Gołąbki 01", distance: 831},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 871},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 997},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 1281},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1632},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1788},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1897}
    ],
    18329: [
        {type: OfferPoiType.BUS, name: "Nad Wisłą", distance: 599},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 637},
        {type: OfferPoiType.BUS, name: "Nad Wisłą [końcowy]", distance: 655},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 1195},
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 1380},
        {type: OfferPoiType.PARK, name: "Skwer świętej Rity", distance: 1703},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 2044},
        {type: OfferPoiType.PARK, name: "Skwer Matki Bożej Wspomożycielki Wiernych", distance: 2165}
    ],
    18333: [
        {type: OfferPoiType.TRAM, name: "Limanowskiego - Sierakowskiego", distance: 549},
        {type: OfferPoiType.BUS, name: "Limanowskiego - Sierakowskiego", distance: 596},
        {type: OfferPoiType.BUS, name: "Hipoteczna - Olsztyńska", distance: 620},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Struga", distance: 700},
        {type: OfferPoiType.BUS, name: "Klonowa - Limanowskiego", distance: 765},
        {type: OfferPoiType.BUS, name: "Hipoteczna - Limanowskiego", distance: 766},
        {type: OfferPoiType.BUS, name: "Pojezierska - Sierakowskiego", distance: 791},
        {type: OfferPoiType.PARK, name: "Park przy ul. Hipotecznej", distance: 894},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 1218},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 1224},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 1343},
        {type: OfferPoiType.PARK, name: "Plac Piastowski", distance: 1812},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 1855},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 2086}
    ],
    18340: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 625},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 794},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 807},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 1059},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 1085},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1622},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1881},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2307}
    ],
    18342: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 156},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 159},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 174},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 304},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 345},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 397},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 424},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 464},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 477},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 488},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1032},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1167},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1272},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1580},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1583},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1957},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1957},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1971},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2128}
    ],
    18345: [
        {type: OfferPoiType.BUS, name: "Mosty Warszawskie", distance: 170},
        {type: OfferPoiType.TRAM, name: "Mosty Warszawskie", distance: 176},
        {type: OfferPoiType.BUS, name: "Damrota", distance: 455},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 610},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 614},
        {type: OfferPoiType.BUS, name: "Kromera", distance: 739},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 820},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 1062},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1167},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1195},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1209},
        {type: OfferPoiType.PARK, name: "park Porucznika Roberta Marczewskiego", distance: 1476},
        {type: OfferPoiType.PARK, name: "skwer Skaczącej Gwiazdy", distance: 1560}
    ],
    18347: [
        {type: OfferPoiType.BUS, name: "Pryncypalna - Mieszkalna", distance: 47},
        {type: OfferPoiType.BUS, name: "Pryncypalna - Kosynierów Gdyńskich NŻ", distance: 239},
        {type: OfferPoiType.BUS, name: "Kongresowa - Pryncypalna NŻ", distance: 314},
        {type: OfferPoiType.PARK, name: "Park Zatorze", distance: 359},
        {type: OfferPoiType.BUS, name: "Kongresowa - Jutrzenki", distance: 630},
        {type: OfferPoiType.BUS, name: "Trybunalska - Kosynierów Gdyńskich", distance: 647},
        {type: OfferPoiType.BUS, name: "Kosynierów Gdyńskich - Trybunalska", distance: 684},
        {type: OfferPoiType.PARK, name: "Borek Józefa Lissnera", distance: 1163},
        {type: OfferPoiType.PARK, name: "Skwer im. Henryka Dubaniewicza", distance: 1392},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 1758},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1994},
        {type: OfferPoiType.PARK, name: "Park Miejski przy ul. Leczniczej", distance: 2035},
        {type: OfferPoiType.PARK, name: "Park Mirabelka", distance: 2068}
    ],
    18348: [
        {type: OfferPoiType.BUS, name: "Świeradowska", distance: 74},
        {type: OfferPoiType.TRAM, name: "Świeradowska", distance: 75},
        {type: OfferPoiType.BUS, name: "Gaj – pętla", distance: 235},
        {type: OfferPoiType.TRAM, name: "Morwowa", distance: 313},
        {type: OfferPoiType.BUS, name: "Gaj", distance: 364},
        {type: OfferPoiType.BUS, name: "Morwowa", distance: 379},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 518},
        {type: OfferPoiType.TRAM, name: "Krynicka", distance: 614},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1229},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1734},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 2195},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 2264}
    ],
    18352: [
        {type: OfferPoiType.BUS, name: "Bociana Czarnego 02", distance: 91},
        {type: OfferPoiType.BUS, name: "Bociana Czarnego 01", distance: 259},
        {type: OfferPoiType.BUS, name: "Zimorodka 01", distance: 260},
        {type: OfferPoiType.BUS, name: "Zimorodka 02", distance: 389},
        {type: OfferPoiType.BUS, name: "Jesiennych Liści 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Jesiennych Liści 02", distance: 787},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Chojnów", distance: 2141}
    ],
    18373: [
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 326},
        {type: OfferPoiType.BUS, name: "Mackiewicza 02", distance: 459},
        {type: OfferPoiType.BUS, name: "Pleszowska 03", distance: 470},
        {type: OfferPoiType.TRAM, name: "Białoprądnicka 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Pleszowska 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Szpital Jana Pawła II 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Białoprądnicka 04", distance: 495},
        {type: OfferPoiType.BUS, name: "Mackiewicza 03", distance: 500},
        {type: OfferPoiType.BUS, name: "Białoprądnicka 03", distance: 502},
        {type: OfferPoiType.BUS, name: "Pleszowska 02", distance: 516},
        {type: OfferPoiType.TRAM, name: "Białoprądnicka 01", distance: 527},
        {type: OfferPoiType.TRAM, name: "Górnickiego 01", distance: 531},
        {type: OfferPoiType.BUS, name: "Górnickiego 03", distance: 554},
        {type: OfferPoiType.TRAM, name: "Górnickiego 02", distance: 563},
        {type: OfferPoiType.BUS, name: "Górnickiego 04", distance: 578},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1094},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 1842}
    ],
    18383: [
        {type: OfferPoiType.BUS, name: "Ostródzka 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 07", distance: 562},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 03", distance: 629},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 71", distance: 668},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 04", distance: 676},
        {type: OfferPoiType.BUS, name: "Ostródzka 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 05", distance: 688},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 06", distance: 698},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 08", distance: 701},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 01", distance: 702},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 1360},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1686},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1901},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1906},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 2009},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2367}
    ],
    18384: [
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 147},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 222},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 312},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 08", distance: 466},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 471},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 05", distance: 473},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 536},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 02", distance: 576},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Mieszka I 05", distance: 593},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Powst. Listopad. 06", distance: 740},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 1937},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2273},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2407}
    ],
    18385: [
        {type: OfferPoiType.BUS, name: "Kuklińskiego 04", distance: 402},
        {type: OfferPoiType.TRAM, name: "Kuklińskiego 02", distance: 539},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 05", distance: 545},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 03", distance: 551},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 08", distance: 553},
        {type: OfferPoiType.TRAM, name: "Kuklińskiego 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 06", distance: 580},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 592},
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 599},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 603},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 606},
        {type: OfferPoiType.BUS, name: "Stoczniowców 02", distance: 828},
        {type: OfferPoiType.BUS, name: "Strycharska 01", distance: 832},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 858},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1131},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1163},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1265},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1413}
    ],
    18387: [
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja", distance: 46},
        {type: OfferPoiType.TRAM, name: "Konstytucji 3 Maja", distance: 111},
        {type: OfferPoiType.BUS, name: "Południowa", distance: 553},
        {type: OfferPoiType.BUS, name: "Rządz", distance: 580},
        {type: OfferPoiType.TRAM, name: "Pętla Rządz", distance: 602},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja / Sobieskiego", distance: 620},
        {type: OfferPoiType.TRAM, name: "Południowa", distance: 654},
        {type: OfferPoiType.LAS, name: "fort Strzemięcin", distance: 816},
        {type: OfferPoiType.LAS, name: "Nabrzeże generała Gustawa Orlicz-Dreszera", distance: 837}
    ],
    18389: [
        {type: OfferPoiType.BUS, name: "Sympatyczna 01", distance: 66},
        {type: OfferPoiType.BUS, name: "Sympatyczna 02", distance: 99},
        {type: OfferPoiType.BUS, name: "Sympatyczna 03", distance: 182},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 257},
        {type: OfferPoiType.BUS, name: "Sympatyczna 04", distance: 340},
        {type: OfferPoiType.BUS, name: "Płużańska 02", distance: 379},
        {type: OfferPoiType.BUS, name: "Gniewkowska 52", distance: 432},
        {type: OfferPoiType.BUS, name: "PKP Włochy 03", distance: 448},
        {type: OfferPoiType.BUS, name: "Gniewkowska 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Wałowicka 03", distance: 505},
        {type: OfferPoiType.BUS, name: "Płużańska 01", distance: 515},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Włochy", distance: 661},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 703},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 855},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 1193},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1347},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1970}
    ],
    18405: [
        {type: OfferPoiType.BUS, name: "Bieszczadzka - Kolumny NŻ", distance: 749},
        {type: OfferPoiType.BUS, name: "Kolumny - Kolumny 118 NŻ", distance: 751},
        {type: OfferPoiType.BUS, name: "Jędrzejów Przem. Zachód", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2066}
    ],
    18411: [{type: OfferPoiType.BUS, name: "Nowa Wola 52", distance: 815}],
    18436: [
        {type: OfferPoiType.BUS, name: "Komorniki", distance: 349},
        {type: OfferPoiType.BUS, name: "Kurczaki - Cm. Kurczaki", distance: 834},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 1617},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 2390},
        {type: OfferPoiType.PARK, name: "Skwer im. Świętego Maksymiliana Marii Kolbego", distance: 2397}
    ],
    18438: [
        {type: OfferPoiType.BUS, name: "Gliwice Kochanowskiego", distance: 328},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 460},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Lewczyńskiego", distance: 474},
        {type: OfferPoiType.BUS, name: "Trynek Cichociemnych", distance: 485},
        {type: OfferPoiType.BUS, name: "Gliwice Komag", distance: 551},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Rydet", distance: 562},
        {type: OfferPoiType.BUS, name: "Gliwice Rybnicka", distance: 629},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 667},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Rybnickiej", distance: 709},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny", distance: 833}
    ],
    18443: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 352},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 376},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód/ Polna II", distance: 550},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód (Białogardzka)", distance: 573},
        {type: OfferPoiType.BUS, name: "Karlińska/ Os. Generalskie II", distance: 578},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 602},
        {type: OfferPoiType.BUS, name: "Os.Zachód/ Polna I", distance: 625},
        {type: OfferPoiType.BUS, name: "Karlińska/ Os. Generalskie I", distance: 671},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 679},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 680},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 1659},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1757}
    ],
    18445: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 321},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 404},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 496},
        {type: OfferPoiType.BUS, name: "Polna/ Krakowska", distance: 531},
        {type: OfferPoiType.BUS, name: "Polna/ SP7", distance: 547},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 573},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 574},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód/ Polna II", distance: 624},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód (Białogardzka)", distance: 667},
        {type: OfferPoiType.BUS, name: "Polna/ Gazownia", distance: 681},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1643},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 1830}
    ],
    18447: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 366},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 449},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 547},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 624},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 625},
        {type: OfferPoiType.BUS, name: "Polna/ Krakowska", distance: 773},
        {type: OfferPoiType.BUS, name: "Polna/ SP7", distance: 789},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1693},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 2072}
    ],
    18448: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 188},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 271},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 347},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 424},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 425},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Szpital I", distance: 794},
        {type: OfferPoiType.BUS, name: "Polna/ Krakowska", distance: 807},
        {type: OfferPoiType.BUS, name: "Polna/ Gazownia", distance: 815},
        {type: OfferPoiType.BUS, name: "Polna/ SP7", distance: 823},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1493},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 1996}
    ],
    18459: [
        {type: OfferPoiType.BUS, name: "Zagórze Droga do Klimontowa", distance: 502},
        {type: OfferPoiType.BUS, name: "Sosnowiec Kosów", distance: 672},
        {type: OfferPoiType.PARK, name: "Plac im. Jana Pawła II", distance: 1503},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu drogowego", distance: 1658},
        {type: OfferPoiType.PARK, name: "Park imienia Wandy Malczewskiej", distance: 2274}
    ],
    18464: [
        {type: OfferPoiType.BUS, name: "Siechnice – Kwiatkowskiego", distance: 357},
        {type: OfferPoiType.BUS, name: "Siechnice Kwiatkowskiego", distance: 376},
        {type: OfferPoiType.BUS, name: "Siechnice Staszica", distance: 580},
        {type: OfferPoiType.BUS, name: "Siechnice - Staszica", distance: 741}
    ],
    18471: [
        {type: OfferPoiType.BUS, name: "Kościelna Droga 02", distance: 177},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 01", distance: 202},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 307},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 01", distance: 394},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 02", distance: 501},
        {type: OfferPoiType.BUS, name: "Łużycka  02", distance: 577},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Szymanowskiego 01", distance: 721},
        {type: OfferPoiType.BUS, name: "Szymanowskiego 02", distance: 771}
    ],
    18472: [
        {type: OfferPoiType.TRAM, name: "Czynszowa 01", distance: 157},
        {type: OfferPoiType.BUS, name: "Szwedzka 04", distance: 235},
        {type: OfferPoiType.BUS, name: "Szwedzka 05", distance: 236},
        {type: OfferPoiType.BUS, name: "Metro Szwedzka 01", distance: 238},
        {type: OfferPoiType.TRAM, name: "Konopacka 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Szwedzka 07", distance: 295},
        {type: OfferPoiType.BUS, name: "Konopacka 02", distance: 303},
        {type: OfferPoiType.BUS, name: "Konopacka 01", distance: 308},
        {type: OfferPoiType.TRAM, name: "Środkowa 01", distance: 319},
        {type: OfferPoiType.TRAM, name: "Konopacka 01", distance: 330},
        {type: OfferPoiType.BUS, name: "Metro Szwedzka 02", distance: 356},
        {type: OfferPoiType.BUS, name: "Zajezdnia Stalowa 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Szwedzka 01", distance: 455},
        {type: OfferPoiType.METRO, name: "Szwedzka", distance: 463},
        {type: OfferPoiType.BUS, name: "Zajezdnia Stalowa 02", distance: 464},
        {type: OfferPoiType.TRAM, name: "Bródnowska 01", distance: 660},
        {type: OfferPoiType.TRAM, name: "Bródnowska 02", distance: 699},
        {type: OfferPoiType.TRAM, name: "Inżynierska 04", distance: 699},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 745},
        {type: OfferPoiType.TRAM, name: "Inżynierska 03", distance: 762},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Targówek", distance: 794},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1366},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1372},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1587},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 1639},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 1746},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 1877}
    ],
    18473: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Królewska / Teligi", distance: 362},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Sienna", distance: 400},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Teligi", distance: 415},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Bairda", distance: 493},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Na Laski", distance: 494},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 598},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Braci Okuniów", distance: 631},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 869},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 1217},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1514},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1577},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1747},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1854},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 1992},
        {type: OfferPoiType.PARK, name: "Skwer przy ulicy Górnej", distance: 2058}
    ],
    18474: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 217},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 614},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 636},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 714}
    ],
    18475: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 371},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 768},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 790}
    ],
    18476: [
        {type: OfferPoiType.TRAM, name: "Korona 01", distance: 139},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 185},
        {type: OfferPoiType.TRAM, name: "Korona 03", distance: 219},
        {type: OfferPoiType.TRAM, name: "Smolki 02", distance: 225},
        {type: OfferPoiType.TRAM, name: "Korona 02", distance: 229},
        {type: OfferPoiType.BUS, name: "Smolki 02", distance: 238},
        {type: OfferPoiType.BUS, name: "Smolki 01", distance: 251},
        {type: OfferPoiType.TRAM, name: "Smolki 01", distance: 252},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 468},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 01", distance: 682},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 02", distance: 700},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 747},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 754},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 790},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 801},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 809},
        {type: OfferPoiType.TRAM, name: "Limanowskiego 01", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 1113},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 1713},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2140},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2405},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2514}
    ],
    18477: [
        {type: OfferPoiType.BUS, name: "Świergotki", distance: 150},
        {type: OfferPoiType.BUS, name: "Przepiórki", distance: 411},
        {type: OfferPoiType.BUS, name: "Pelikana", distance: 544},
        {type: OfferPoiType.BUS, name: "Królewskiego nż", distance: 788},
        {type: OfferPoiType.REZERWAT, name: "Dolina strumienia Grzęziniec", distance: 1575},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 2108},
        {type: OfferPoiType.PARK, name: "park Brodowski", distance: 2166},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 2378}
    ],
    18480: [
        {type: OfferPoiType.TRAM, name: "Port Popowice", distance: 144},
        {type: OfferPoiType.BUS, name: "Port Popowice", distance: 194},
        {type: OfferPoiType.BUS, name: "Wejherowska (Hala Orbita)", distance: 313},
        {type: OfferPoiType.TRAM, name: "Wejherowska (Hala Orbita)", distance: 351},
        {type: OfferPoiType.TRAM, name: "Białowieska", distance: 400},
        {type: OfferPoiType.BUS, name: "Milenijna (Hala Orbita)", distance: 470},
        {type: OfferPoiType.BUS, name: "Kwiska", distance: 608},
        {type: OfferPoiType.BUS, name: "Park Popowicki", distance: 746},
        {type: OfferPoiType.TRAM, name: "Kwiska", distance: 763},
        {type: OfferPoiType.TRAM, name: "Park Popowicki", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Popowicki", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 1033},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 1952}
    ],
    18492: [
        {type: OfferPoiType.BUS, name: "Skośna 01", distance: 130},
        {type: OfferPoiType.BUS, name: "Skośna 02", distance: 188},
        {type: OfferPoiType.BUS, name: "Lubostroń 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Lubostroń 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Lubostroń 04", distance: 398},
        {type: OfferPoiType.BUS, name: "Lubostroń 03", distance: 424},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 01", distance: 474},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Torfowa 01", distance: 713},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 741},
        {type: OfferPoiType.BUS, name: "Piltza 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 865},
        {type: OfferPoiType.PARK, name: "Park Maćka i Doroty", distance: 1746},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 1926},
        {type: OfferPoiType.REZERWAT, name: "Łąki na Klinach", distance: 2439}
    ],
    18494: [
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Cm. Mania", distance: 49},
        {type: OfferPoiType.BUS, name: "Solec - Cm. Mania", distance: 166},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Jarzynowa", distance: 181},
        {type: OfferPoiType.BUS, name: "Solec - Borowa NŻ", distance: 488},
        {type: OfferPoiType.BUS, name: "Biegunowa - Krakowska", distance: 641},
        {type: OfferPoiType.BUS, name: "Krakowska - Biegunowa", distance: 660},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Unii Lubelskiej", distance: 712},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 911},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1022},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1149},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1353},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 2142},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 2180},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2187},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2413},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 2437},
        {type: OfferPoiType.PARK, name: "Park im. generała Władysława Andersa", distance: 2447}
    ],
    18496: [
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 324},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 376},
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 406},
        {type: OfferPoiType.BUS, name: "Babińskiego 02", distance: 452},
        {type: OfferPoiType.BUS, name: "Babińskiego 01", distance: 457},
        {type: OfferPoiType.BUS, name: "Skotniki Kościół 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Brücknera 02", distance: 683},
        {type: OfferPoiType.BUS, name: "Brücknera 01", distance: 703},
        {type: OfferPoiType.BUS, name: "Skotniki 04", distance: 730},
        {type: OfferPoiType.BUS, name: "Skotniki 01", distance: 794},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1271},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2491}
    ],
    18497: [
        {type: OfferPoiType.TRAM, name: "Półwiejska", distance: 451},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 457},
        {type: OfferPoiType.TRAM, name: "Różana", distance: 613},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 691},
        {type: OfferPoiType.TRAM, name: "AWF", distance: 725},
        {type: OfferPoiType.BUS, name: "Bielniki n/ż", distance: 757},
        {type: OfferPoiType.BUS, name: "AWF", distance: 770},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 843},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 994},
        {type: OfferPoiType.LAS, name: "Miejski las kieszonkowy", distance: 995},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1102},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1278},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1466},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1510},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1514},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1745},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1820}
    ],
    18498: [
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 01", distance: 510},
        {type: OfferPoiType.BUS, name: "Targowa 02", distance: 543},
        {type: OfferPoiType.BUS, name: "Targowa 01", distance: 622},
        {type: OfferPoiType.TRAM, name: "Targowa 03", distance: 666},
        {type: OfferPoiType.TRAM, name: "Targowa 04", distance: 681},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 06", distance: 706},
        {type: OfferPoiType.BUS, name: "Galeria Copernicus 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 02", distance: 707},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 05", distance: 742},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 04", distance: 753},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 08", distance: 766},
        {type: OfferPoiType.BUS, name: "Olbrachta nż. 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 03", distance: 798},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 923},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 2025},
        {type: OfferPoiType.PARK, name: "Glazja", distance: 2113},
        {type: OfferPoiType.PARK, name: "Bastion Menniczy", distance: 2403}
    ],
    18508: [
        {type: OfferPoiType.BUS, name: "Habicha 01", distance: 238},
        {type: OfferPoiType.BUS, name: "Habicha 02", distance: 398},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 04", distance: 570},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 03", distance: 598},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ursus Płn. 01", distance: 609},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 691},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ursus Płn. 02", distance: 728},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 766},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 02", distance: 789},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1286},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 1323}
    ],
    18510: [
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 793},
        {type: OfferPoiType.TRAM, name: "Głęboka 02", distance: 813},
        {type: OfferPoiType.BUS, name: "Głęboka 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 943},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1077},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1122},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1459}
    ],
    18514: [
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 477},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 479},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 515},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 533},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 680},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1341}
    ],
    18518: [
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Żurawiej", distance: 118},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Stadion", distance: 259},
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 333},
        {type: OfferPoiType.BUS, name: "Centum Przesiadkowe Bałtycka", distance: 370},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 473},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wolności", distance: 540},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1036},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 1187},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1262},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1647}
    ],
    18519: [
        {type: OfferPoiType.BUS, name: "Grabówki IV", distance: 143},
        {type: OfferPoiType.BUS, name: "Grabówki V", distance: 241},
        {type: OfferPoiType.BUS, name: "Sygneczów Sklep", distance: 254},
        {type: OfferPoiType.BUS, name: "Grabówki VI", distance: 566},
        {type: OfferPoiType.BUS, name: "Sygneczów Kościół", distance: 733},
        {type: OfferPoiType.REZERWAT, name: "Las i stawy na Grabówkach", distance: 2214}
    ],
    18525: [
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 01", distance: 615},
        {type: OfferPoiType.BUS, name: "Słoneczny Stok / Pańska 02", distance: 671},
        {type: OfferPoiType.BUS, name: "Słoneczny Stok / Pańska 01", distance: 700},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny pętla 09", distance: 766},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 1323},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 2081}
    ],
    18530: [
        {type: OfferPoiType.BUS, name: "Gdańska / Chodkiewicza", distance: 238},
        {type: OfferPoiType.TRAM, name: "Gdańska / Chodkiewicza", distance: 238},
        {type: OfferPoiType.BUS, name: "Chodkiewicza / Paderewskiego", distance: 302},
        {type: OfferPoiType.TRAM, name: "Chodkiewicza / Paderewskiego", distance: 304},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 502},
        {type: OfferPoiType.BUS, name: "Mickiewicza / Teatr Polski", distance: 527},
        {type: OfferPoiType.TRAM, name: "UKW", distance: 592},
        {type: OfferPoiType.TRAM, name: "Gdańska / Artyleryjska", distance: 622},
        {type: OfferPoiType.BUS, name: "Kamienna / Gdańska", distance: 624},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 639},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 714},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 727},
        {type: OfferPoiType.PARK, name: "Skwer Edwarda Woyniłłowicza", distance: 748},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 791},
        {type: OfferPoiType.PARK, name: "Skwer Mikołaja Kopernika", distance: 869},
        {type: OfferPoiType.PARK, name: "Skwer im. ppor. Leszka Białego", distance: 1026},
        {type: OfferPoiType.PARK, name: "Skwer im. Mariana Turwida", distance: 1050}
    ],
    18535: [
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1924},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1936},
        {type: OfferPoiType.PARK, name: 'Park edukacyjny "Żabie Doły"', distance: 2226}
    ],
    18550: [
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 02", distance: 663},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Galeria Szperk", distance: 732},
        {type: OfferPoiType.BUS, name: "Galeria Szperk 02", distance: 732},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 02", distance: 735},
        {type: OfferPoiType.BUS, name: "Staniewicza", distance: 765},
        {type: OfferPoiType.BUS, name: "Staniewicza 01", distance: 765},
        {type: OfferPoiType.BUS, name: "Staniewicza 02", distance: 810},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1477},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1705},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 1893}
    ],
    18563: [
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 45},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 250},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 418},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 446},
        {type: OfferPoiType.BUS, name: "Zielona - 1 Maja", distance: 454},
        {type: OfferPoiType.BUS, name: "Legionów - Żeligowskiego", distance: 523},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 568},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka", distance: 644},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Srebrzyńska", distance: 672},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 754},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 888},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 897},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 920},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 1227},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1236},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1432},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 2166},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2213}
    ],
    18568: [{type: OfferPoiType.PARK, name: "Park Panoptikum", distance: 2439}],
    18572: [{type: OfferPoiType.PARK, name: "Park Miejski", distance: 2506}],
    18591: [
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 193},
        {type: OfferPoiType.BUS, name: "Os. Paderewskiego Kościół", distance: 247},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 347},
        {type: OfferPoiType.BUS, name: "Katowice Francuska", distance: 524},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Krasińskiego", distance: 559},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Biblioteka Śląska", distance: 563},
        {type: OfferPoiType.TRAM, name: "Katowice Graniczna", distance: 591},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Sikorskiego", distance: 597},
        {type: OfferPoiType.BUS, name: "Katowice Mariacka", distance: 639},
        {type: OfferPoiType.BUS, name: "Katowice Francuska Sąd", distance: 775},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 819},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 860},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1043},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1260},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1344}
    ],
    18616: [
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Młynowa", distance: 105},
        {type: OfferPoiType.BUS, name: "Sosnowskiego/Wyszyńskiego", distance: 218},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Sosnowskiego", distance: 236},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Bema NŻ", distance: 242},
        {type: OfferPoiType.BUS, name: "Sosnowskiego/Grunwaldzka", distance: 365},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 422},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Kaczorowskiego", distance: 424},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Cieszyńska", distance: 456},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Stołeczna", distance: 474},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Opera Podlaska", distance: 539},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 823},
        {type: OfferPoiType.PARK, name: "Park im. Jadwigi Dziekońskiej", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park Branickich", distance: 1527},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1536},
        {type: OfferPoiType.PARK, name: "Skwer Zenona Andrzeja Młyńczyka", distance: 1550},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Zwierzyniecki", distance: 2269}
    ],
    18617: [
        {type: OfferPoiType.BUS, name: "Pucka", distance: 126},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 01", distance: 260},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP", distance: 336},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 03", distance: 340},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 04", distance: 362},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 06", distance: 381},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Chylonia", distance: 389},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 02", distance: 397},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1262},
        {type: OfferPoiType.PARK, name: "Park Zielone Leszczynki", distance: 1997},
        {type: OfferPoiType.PARK, name: "Kieszonka na fali", distance: 2414}
    ],
    18621: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 491},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Brylowska 01", distance: 644},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 683},
        {type: OfferPoiType.BUS, name: "Brylowska 02", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1306},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1531},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1601},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1778},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1962},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 1988},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1988},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 2063}
    ],
    18623: [{type: OfferPoiType.BUS, name: "Śmiłowice Osiedle", distance: 232}],
    18624: [
        {type: OfferPoiType.BUS, name: "Kolonia Wysockiego Woźniaków", distance: 749},
        {type: OfferPoiType.PARK, name: "Skwer Rybka", distance: 1485},
        {type: OfferPoiType.PARK, name: "Skwer Emila i Georga Zillmannów", distance: 1948},
        {type: OfferPoiType.PARK, name: "Skwer Artystów Grupy Janowskiej", distance: 2015},
        {type: OfferPoiType.PARK, name: "Park Giszowiecki", distance: 2021},
        {type: OfferPoiType.PARK, name: "Skwer Ewalda Gawlika", distance: 2334}
    ],
    18625: [
        {type: OfferPoiType.BUS, name: "Półłanki 01", distance: 335},
        {type: OfferPoiType.BUS, name: "Półłanki 02", distance: 352},
        {type: OfferPoiType.BUS, name: "Półłanki 03", distance: 388},
        {type: OfferPoiType.BUS, name: "Półłanki 04", distance: 392},
        {type: OfferPoiType.BUS, name: "Szparagowa 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Szparagowa 04", distance: 479},
        {type: OfferPoiType.BUS, name: "Szparagowa 06", distance: 580},
        {type: OfferPoiType.BUS, name: "Szparagowa 02", distance: 587},
        {type: OfferPoiType.BUS, name: "Bazarowa 01", distance: 790},
        {type: OfferPoiType.BUS, name: "Rybitwy Rozjazd 02", distance: 798},
        {type: OfferPoiType.REZERWAT, name: "Rybitwy", distance: 955},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Cegielni", distance: 1667},
        {type: OfferPoiType.PARK, name: "Park Zielone Serce Podgórza", distance: 1843}
    ],
    18631: [
        {type: OfferPoiType.BUS, name: "Srebrniki 02", distance: 169},
        {type: OfferPoiType.BUS, name: "Srebrniki 01", distance: 188},
        {type: OfferPoiType.BUS, name: "Niedźwiednik PKM 03", distance: 212},
        {type: OfferPoiType.BUS, name: "Cmentarz Srebrzysko 02", distance: 268},
        {type: OfferPoiType.BUS, name: "Cmentarz Srebrzysko 01", distance: 352},
        {type: OfferPoiType.BUS, name: "Niedźwiednik PKM 02", distance: 365},
        {type: OfferPoiType.BUS, name: "Niedźwiednik PKM 01", distance: 369},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Niedźwiednik", distance: 564},
        {type: OfferPoiType.BUS, name: "Chrzanowskiego 01", distance: 585},
        {type: OfferPoiType.BUS, name: "Chrzanowskiego 02", distance: 631},
        {type: OfferPoiType.BUS, name: "Zabytkowa 02", distance: 696},
        {type: OfferPoiType.PARK, name: "Skwer prof. Pawła Gałuszki", distance: 755},
        {type: OfferPoiType.PARK, name: "Plac Generała Stanisława Maczka", distance: 1228},
        {type: OfferPoiType.PARK, name: "Skwer im. Krzysztofa Kolbergera", distance: 1370},
        {type: OfferPoiType.PARK, name: "Skwer Marszałka Józefa Piłsudskiego", distance: 1382},
        {type: OfferPoiType.PARK, name: 'Dawny cmentarz katolicki "Urania"', distance: 1514},
        {type: OfferPoiType.PARK, name: "Park de Gaulle'a", distance: 1737},
        {type: OfferPoiType.PARK, name: "Park Okazała Strzyża", distance: 1762},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterskiego Mariupola", distance: 1809}
    ],
    18639: [
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 368},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 453},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 464},
        {type: OfferPoiType.TRAM, name: "Prudnicka", distance: 487},
        {type: OfferPoiType.BUS, name: "Prudnicka", distance: 501},
        {type: OfferPoiType.BUS, name: "Widna", distance: 606},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 687},
        {type: OfferPoiType.BUS, name: "Wapienna", distance: 713},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 714},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1432},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1689},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1850}
    ],
    18645: [
        {type: OfferPoiType.BUS, name: "Oknicka 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Chudoby 01", distance: 578},
        {type: OfferPoiType.BUS, name: "Chudoby 02", distance: 683},
        {type: OfferPoiType.BUS, name: "Nauczycielska 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Os. Lewandów II 02", distance: 739},
        {type: OfferPoiType.BUS, name: "Nauczycielska 02", distance: 741},
        {type: OfferPoiType.BUS, name: "Oknicka 02", distance: 781},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 2174},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2259},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 2267},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 2352}
    ],
    18648: [
        {type: OfferPoiType.BUS, name: "Kościelna 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 194},
        {type: OfferPoiType.BUS, name: "Bolesława Prusa 02", distance: 205},
        {type: OfferPoiType.BUS, name: "Kościuszki 03", distance: 247},
        {type: OfferPoiType.BUS, name: "Bolesława Prusa 01", distance: 329},
        {type: OfferPoiType.BUS, name: "USC 01", distance: 335},
        {type: OfferPoiType.BUS, name: "USC 05", distance: 343},
        {type: OfferPoiType.BUS, name: "USC 04", distance: 370},
        {type: OfferPoiType.BUS, name: "Kubusia Puchatka 01", distance: 409},
        {type: OfferPoiType.BUS, name: "Urząd Miasta 01", distance: 410},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 655},
        {type: OfferPoiType.KOLEJ, name: "Pruszków WKD", distance: 706},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 737},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 781},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 1643},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1728}
    ],
    18651: [
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 732},
        {type: OfferPoiType.BUS, name: "Rojna - Kaczeńcowa", distance: 741},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 858},
        {type: OfferPoiType.PARK, name: "Park im. Stefana Żeromskiego", distance: 858},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 1001},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 1072},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1334},
        {type: OfferPoiType.PARK, name: "Skwer pocmentarny", distance: 1400},
        {type: OfferPoiType.PARK, name: "Park im. generała Władysława Andersa", distance: 1620}
    ],
    18652: [
        {type: OfferPoiType.BUS, name: "Glincz Szkola", distance: 327},
        {type: OfferPoiType.PARK, name: "Nad Stawem", distance: 552},
        {type: OfferPoiType.BUS, name: "Glincz Brzozowa 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Glincz Brzozowa 02", distance: 627}
    ],
    18653: [
        {type: OfferPoiType.BUS, name: "Świętopełka", distance: 124},
        {type: OfferPoiType.BUS, name: "Stara Rumia Cmentarz 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Stara Rumia Cmentarz 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Rondo Jana Pawła II", distance: 558},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 05", distance: 602},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 04", distance: 635},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 06", distance: 644},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 02", distance: 668},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1186},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 1200},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 2492}
    ],
    18661: [
        {type: OfferPoiType.BUS, name: "Św. Leonarda", distance: 178},
        {type: OfferPoiType.TRAM, name: "Św. Leonarda", distance: 265},
        {type: OfferPoiType.BUS, name: "Koronna", distance: 306},
        {type: OfferPoiType.BUS, name: "Os. Powstańców Warszawy", distance: 399},
        {type: OfferPoiType.TRAM, name: "Os. Winiary", distance: 457},
        {type: OfferPoiType.BUS, name: "Trójpole", distance: 487},
        {type: OfferPoiType.BUS, name: "Wyłom", distance: 489},
        {type: OfferPoiType.BUS, name: "Os. Winiary", distance: 494},
        {type: OfferPoiType.BUS, name: "Aleje Solidarności", distance: 547},
        {type: OfferPoiType.TRAM, name: "Aleje Solidarności", distance: 574},
        {type: OfferPoiType.TRAM, name: "Bonin", distance: 643},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 967},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1315},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1735},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 1823},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 1896},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 2283},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 2301},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 2357}
    ],
    18670: [
        {type: OfferPoiType.BUS, name: "Życzliwa 02", distance: 102},
        {type: OfferPoiType.BUS, name: "Życzliwa 01", distance: 213},
        {type: OfferPoiType.BUS, name: "Węzeł Karczemki 02", distance: 459},
        {type: OfferPoiType.BUS, name: "Węzeł Karczemki 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Jasień Działki 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Jasień Działki 02", distance: 622},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1687}
    ],
    18671: [
        {type: OfferPoiType.BUS, name: "Klasztor Cystersów 01", distance: 388},
        {type: OfferPoiType.BUS, name: "Stare Wiślisko 02", distance: 478},
        {type: OfferPoiType.BUS, name: "Klasztor Cystersów 02", distance: 493},
        {type: OfferPoiType.BUS, name: "Stare Wiślisko 01", distance: 509},
        {type: OfferPoiType.BUS, name: "Sieroszewskiego 02", distance: 632},
        {type: OfferPoiType.BUS, name: "Sieroszewskiego 01", distance: 644},
        {type: OfferPoiType.PARK, name: "Park Rogozińskich", distance: 679},
        {type: OfferPoiType.BUS, name: "Szpital Żeromskiego 01", distance: 761},
        {type: OfferPoiType.BUS, name: "Szpital Żeromskiego 02", distance: 764},
        {type: OfferPoiType.BUS, name: "Klasztorna 06", distance: 794},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 816},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1254},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1928},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2075},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 2226},
        {type: OfferPoiType.PARK, name: "Park Zalew Nowohucki", distance: 2318},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 2487}
    ],
    18677: [
        {type: OfferPoiType.BUS, name: "Warszawska - Park 01", distance: 139},
        {type: OfferPoiType.PARK, name: "Skwer im. abp. Dobrogosta", distance: 142},
        {type: OfferPoiType.BUS, name: "Warszawska - Park 02", distance: 162},
        {type: OfferPoiType.BUS, name: "Legionów", distance: 201},
        {type: OfferPoiType.BUS, name: "Modlińska, ZUS", distance: 224},
        {type: OfferPoiType.PARK, name: "Skwer im. ks. Stanisława Poniatowskiego", distance: 239},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Józefa Wybickiego", distance: 265},
        {type: OfferPoiType.BUS, name: "Warszawska - Urząd Miejski 02", distance: 272},
        {type: OfferPoiType.PARK, name: "Plac Solny", distance: 273},
        {type: OfferPoiType.BUS, name: "Urząd Miasta 01", distance: 286},
        {type: OfferPoiType.BUS, name: "Warszawska - Urząd Miejski 01", distance: 290},
        {type: OfferPoiType.BUS, name: "Sawy, przedszkole", distance: 323},
        {type: OfferPoiType.BUS, name: "Modlińska, Kościół", distance: 355},
        {type: OfferPoiType.PARK, name: "Nadrzeczna Park", distance: 1131},
        {type: OfferPoiType.PARK, name: "Dębowy Park", distance: 2097}
    ],
    18678: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 381},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 388},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 476},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 487},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 491},
        {type: OfferPoiType.BUS, name: "Rondo Skrzetuskie", distance: 573},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Bałtycka", distance: 717},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 761},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 772},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 959}
    ],
    18681: [
        {type: OfferPoiType.BUS, name: "Piekary", distance: 67},
        {type: OfferPoiType.BUS, name: "Mierosławskiego", distance: 152},
        {type: OfferPoiType.BUS, name: "Potulicka", distance: 295},
        {type: OfferPoiType.TRAM, name: "Potulicka", distance: 371},
        {type: OfferPoiType.TRAM, name: "Zapadła", distance: 475},
        {type: OfferPoiType.BUS, name: "Plac Szyrockiego", distance: 533},
        {type: OfferPoiType.TRAM, name: "Tama Pomorzańska", distance: 647},
        {type: OfferPoiType.TRAM, name: "Osiedle Polonia", distance: 665},
        {type: OfferPoiType.BUS, name: "Sowińskiego", distance: 731},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Dowbór-Muśnickiego", distance: 896},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 1204},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1592},
        {type: OfferPoiType.PARK, name: "Skwer imienia Michała Doliwo-Dobrowolskiego", distance: 1609},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1669},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 1705},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1865},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 2143}
    ],
    18696: [
        {type: OfferPoiType.BUS, name: "Rokietnica/Noblistów n/ż", distance: 268},
        {type: OfferPoiType.BUS, name: "Rokietnica Trakt Napoleoński", distance: 281},
        {type: OfferPoiType.BUS, name: "Rokietnica/Szkoła", distance: 633},
        {type: OfferPoiType.BUS, name: "Mrowino Leszka n/ż", distance: 697},
        {type: OfferPoiType.PARK, name: "Jeżogród", distance: 1348}
    ],
    18705: [
        {type: OfferPoiType.BUS, name: "Myśliwska 01", distance: 290},
        {type: OfferPoiType.BUS, name: "Lasówka 02", distance: 350},
        {type: OfferPoiType.BUS, name: "Myśliwska 02", distance: 373},
        {type: OfferPoiType.BUS, name: "Lasówka 01", distance: 428},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 632},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 02", distance: 751},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 836},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 839},
        {type: OfferPoiType.PARK, name: "Ptasi Zagajnik", distance: 860},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 1034},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 2137}
    ],
    18706: [
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 200},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 721},
        {type: OfferPoiType.BUS, name: "Babińskiego 01", distance: 807},
        {type: OfferPoiType.BUS, name: "Babińskiego 02", distance: 822},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1041},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2251},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2474}
    ],
    18709: [
        {type: OfferPoiType.BUS, name: "Asfaltowa (Szkoła)", distance: 190},
        {type: OfferPoiType.BUS, name: "Klasztorna", distance: 198},
        {type: OfferPoiType.BUS, name: "Parafialna", distance: 632},
        {type: OfferPoiType.BUS, name: "Maszkowskiego", distance: 633},
        {type: OfferPoiType.BUS, name: "Wojszyce", distance: 665},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 836}
    ],
    18710: [
        {type: OfferPoiType.BUS, name: "Proletariacka - Sowia NŻ", distance: 505},
        {type: OfferPoiType.BUS, name: "Rembielińskiego - Inżynierska NŻ", distance: 592},
        {type: OfferPoiType.BUS, name: "Radwańska - Inżynierska NŻ", distance: 684},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1042},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1929},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1938},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1965}
    ],
    18718: [
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1297},
        {type: OfferPoiType.REZERWAT, name: "Łąki na Klinach", distance: 1515},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2218},
        {type: OfferPoiType.PARK, name: "Park Maćka i Doroty", distance: 2384}
    ],
    18721: [
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 628},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 671},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1515},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 2186}
    ],
    18722: [
        {type: OfferPoiType.BUS, name: "Szybka 02", distance: 542},
        {type: OfferPoiType.BUS, name: "Szybka 01", distance: 565},
        {type: OfferPoiType.BUS, name: "Instalatorów 03", distance: 745},
        {type: OfferPoiType.BUS, name: "Instalatorów 01", distance: 793},
        {type: OfferPoiType.BUS, name: "Instalatorów 02", distance: 798},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 1896},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2206}
    ],
    18723: [
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 224},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 267},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 309},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 367},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 378},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 390},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 423},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 436},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 451},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 05", distance: 470},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 01", distance: 471},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 476},
        {type: OfferPoiType.BUS, name: "Domaniewska 06", distance: 486},
        {type: OfferPoiType.BUS, name: "Domaniewska 05", distance: 511},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 539},
        {type: OfferPoiType.BUS, name: "Park Postępu 01", distance: 554},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 607},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 643},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 03", distance: 753},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 04", distance: 790},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1437},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1535}
    ],
    18724: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 348},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 371},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 420},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 463},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 666},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 689},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 710},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 827},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1322},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1684},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2462}
    ],
    18737: [
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 01", distance: 108},
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 02", distance: 180},
        {type: OfferPoiType.BUS, name: "Przyjazna 01", distance: 354},
        {type: OfferPoiType.BUS, name: "Przyjazna 02", distance: 399},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 405},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 01", distance: 436},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 02", distance: 513},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 522},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 04", distance: 657},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2473}
    ],
    18738: [
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 01", distance: 108},
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 02", distance: 180},
        {type: OfferPoiType.BUS, name: "Przyjazna 01", distance: 354},
        {type: OfferPoiType.BUS, name: "Przyjazna 02", distance: 399},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 405},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 01", distance: 436},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 02", distance: 513},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 522},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 04", distance: 657},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2473}
    ],
    18741: [
        {type: OfferPoiType.PARK, name: "Park Świętej Barbary", distance: 651},
        {type: OfferPoiType.BUS, name: "Wieliczka Os. Kościuszki", distance: 733},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1466},
        {type: OfferPoiType.PARK, name: "Park Świętej Kingi", distance: 2124}
    ],
    18742: [
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 295},
        {type: OfferPoiType.BUS, name: "Cmentarz Prokocim 02", distance: 477},
        {type: OfferPoiType.TRAM, name: "Nowy Prokocim 02", distance: 517},
        {type: OfferPoiType.BUS, name: "Cmentarz Prokocim 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Bieżanów Trafo 02", distance: 541},
        {type: OfferPoiType.TRAM, name: "Nowy Prokocim 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Bieżanów Trafo 01", distance: 551},
        {type: OfferPoiType.BUS, name: "Nowy Prokocim 03", distance: 582},
        {type: OfferPoiType.BUS, name: "Nowy Prokocim 04", distance: 597},
        {type: OfferPoiType.TRAM, name: "Teligi 02", distance: 665},
        {type: OfferPoiType.TRAM, name: "Teligi 01", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 955},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1024},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1259},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1332},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1690}
    ],
    18744: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 224},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 354},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 445},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 450},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 476},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 660},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 820},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 893},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 937}
    ],
    18745: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 272},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 344},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 402},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 424},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 429},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 455},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 640},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 917},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 941}
    ],
    18746: [
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1271},
        {type: OfferPoiType.PARK, name: "Skwer im. Konstantego Leona Wolickiego", distance: 1390},
        {type: OfferPoiType.PARK, name: "Park Sosnowy", distance: 1404},
        {type: OfferPoiType.PARK, name: "Partery Hellwiga", distance: 1419},
        {type: OfferPoiType.REZERWAT, name: "Otoczenie źródła solanki nr 11", distance: 1570}
    ],
    18747: [
        {type: OfferPoiType.BUS, name: "Aluzyjna 02", distance: 152},
        {type: OfferPoiType.BUS, name: "Aluzyjna 03", distance: 243},
        {type: OfferPoiType.BUS, name: "Aluzyjna 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 02", distance: 522},
        {type: OfferPoiType.BUS, name: "Chlubna 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Chlubna 02", distance: 674},
        {type: OfferPoiType.BUS, name: "Osiedle 02", distance: 695},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 2334},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 2338}
    ],
    18750: [
        {type: OfferPoiType.BUS, name: "Sternicza 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Sternicza 02", distance: 447},
        {type: OfferPoiType.BUS, name: "Siemiatycka 01", distance: 681},
        {type: OfferPoiType.BUS, name: "Siemiatycka 02", distance: 805},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2096},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 2292},
        {type: OfferPoiType.PARK, name: "Polanka", distance: 2373}
    ],
    18756: [
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 598},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 623},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 713},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 768},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1215},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1262}
    ],
    18757: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Królewska / Teligi", distance: 318},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Sienna", distance: 356},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Na Laski", distance: 450},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Teligi", distance: 459},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Bairda", distance: 490},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 554},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Braci Okuniów", distance: 587},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 913},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 1261},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1470},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1595},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1703},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1810},
        {type: OfferPoiType.PARK, name: "Skwer przy ulicy Górnej", distance: 2014},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 2036}
    ],
    18759: [
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 01", distance: 605},
        {type: OfferPoiType.BUS, name: "Melcera 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Suchy Las 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Piastowska 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 02", distance: 661},
        {type: OfferPoiType.BUS, name: "Melcera 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Piastowska 01", distance: 730},
        {type: OfferPoiType.BUS, name: "Jesionowa 02", distance: 739},
        {type: OfferPoiType.BUS, name: "Suchy Las 02", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 1361},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1658},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 1822},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1892},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1916},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 2228}
    ],
    18766: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Teklin", distance: 328},
        {type: OfferPoiType.BUS, name: "Łódzka - Teklin", distance: 457},
        {type: OfferPoiType.BUS, name: "Dąbrowa", distance: 566},
        {type: OfferPoiType.TRAM, name: "Dąbrowa", distance: 578},
        {type: OfferPoiType.BUS, name: "Wschodnia 119", distance: 752},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 1188}
    ],
    18771: [
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 388},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 558},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Dębogórze-Wybudowanie - Długa 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1325},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1372},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2263}
    ],
    18778: [
        {type: OfferPoiType.BUS, name: "Węzeł Żołnierzy Wyklętych", distance: 213},
        {type: OfferPoiType.BUS, name: "Ściegiennego", distance: 293},
        {type: OfferPoiType.BUS, name: "Zamenhofa", distance: 499},
        {type: OfferPoiType.BUS, name: "Morska - Estakada", distance: 513},
        {type: OfferPoiType.PARK, name: "Park Zielone Leszczynki", distance: 775},
        {type: OfferPoiType.PARK, name: "Kieszonka na fali", distance: 886},
        {type: OfferPoiType.PARK, name: "Kieszonka na kocyk", distance: 2167}
    ],
    18787: [
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 468},
        {type: OfferPoiType.BUS, name: "św.Krzysztofa", distance: 604},
        {type: OfferPoiType.BUS, name: "Łódzka", distance: 667},
        {type: OfferPoiType.BUS, name: "Okulickiego", distance: 679},
        {type: OfferPoiType.BUS, name: "Rynek Wieluński", distance: 738},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 793},
        {type: OfferPoiType.PARK, name: "Park 3 Maja", distance: 1308},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Staszica", distance: 1594},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Zbigniewa Religi", distance: 1877},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 2199},
        {type: OfferPoiType.PARK, name: "Spacerniak", distance: 2208},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny Jędrusik", distance: 2239}
    ],
    18789: [
        {type: OfferPoiType.BUS, name: "Obywatelska - Jana Pawła II", distance: 630},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Wróblewskiego", distance: 676},
        {type: OfferPoiType.BUS, name: "Proletariacka - Wróblewskiego NŻ", distance: 703},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Obywatelska", distance: 757},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1131},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1645},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1832},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1867},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1920},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1941}
    ],
    18793: [
        {type: OfferPoiType.BUS, name: "Międzylesie", distance: 360},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 646},
        {type: OfferPoiType.BUS, name: "Paderewskiego NŻ", distance: 767},
        {type: OfferPoiType.LAS, name: "Hałdy Single Track", distance: 972},
        {type: OfferPoiType.PARK, name: "Skwer Przyjaciół Dzieci", distance: 2316}
    ],
    18794: [
        {type: OfferPoiType.BUS, name: "Międzylesie", distance: 326},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 612},
        {type: OfferPoiType.BUS, name: "Paderewskiego NŻ", distance: 733},
        {type: OfferPoiType.BUS, name: "Moniuszki NŻ", distance: 819},
        {type: OfferPoiType.BUS, name: "Kleczewska", distance: 835},
        {type: OfferPoiType.LAS, name: "Hałdy Single Track", distance: 938},
        {type: OfferPoiType.PARK, name: "Skwer Przyjaciół Dzieci", distance: 2282}
    ],
    18796: [
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 340},
        {type: OfferPoiType.BUS, name: "Mazowiecka 02", distance: 431},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 460},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 02", distance: 481},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Dokerów", distance: 522},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 03", distance: 530},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 577},
        {type: OfferPoiType.BUS, name: "Ormińskiego 02", distance: 687},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2335}
    ],
    18797: [
        {type: OfferPoiType.BUS, name: "Port", distance: 54},
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 124},
        {type: OfferPoiType.BUS, name: "Port 05", distance: 151},
        {type: OfferPoiType.BUS, name: "Plac Kościelny", distance: 240},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 327},
        {type: OfferPoiType.BUS, name: "Centrum 01", distance: 338},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 03", distance: 373},
        {type: OfferPoiType.BUS, name: "Centrum 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 04", distance: 384},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Steyera 02", distance: 472},
        {type: OfferPoiType.LAS, name: "Parki Miejski im. Fryderyka Chopina", distance: 638},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 638}
    ],
    18820: [
        {type: OfferPoiType.BUS, name: "Stabłowicka (Ośrodek zdrowia)", distance: 311},
        {type: OfferPoiType.BUS, name: "Stabłowicka", distance: 367},
        {type: OfferPoiType.BUS, name: "Pracze Odrzańskie (Stacja kolejowa)", distance: 503},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Pracze", distance: 551},
        {type: OfferPoiType.BUS, name: "Główna", distance: 755},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1381},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 1508},
        {type: OfferPoiType.PARK, name: "Park Leśny w Praczach Odrzańskich", distance: 1865},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2310},
        {type: OfferPoiType.REZERWAT, name: "Las Pracki", distance: 2489}
    ],
    18823: [
        {type: OfferPoiType.BUS, name: "Białołęka-Ratusz 03", distance: 146},
        {type: OfferPoiType.BUS, name: "Milenijna 01", distance: 151},
        {type: OfferPoiType.BUS, name: "Ceramiczna 01", distance: 151},
        {type: OfferPoiType.BUS, name: "Białołęka-Ratusz 01", distance: 170},
        {type: OfferPoiType.BUS, name: "Ceramiczna 02", distance: 238},
        {type: OfferPoiType.BUS, name: "Białołęka-Ratusz 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Milenijna 02", distance: 293},
        {type: OfferPoiType.BUS, name: "Kaflowa 01", distance: 466},
        {type: OfferPoiType.BUS, name: "Braci Zawadzkich 01", distance: 517},
        {type: OfferPoiType.LAS, name: "Park Wiśniewo", distance: 531},
        {type: OfferPoiType.BUS, name: "Kaflowa 02", distance: 565},
        {type: OfferPoiType.TRAM, name: "Myśliborska 06", distance: 743},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 01", distance: 757},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 02", distance: 762},
        {type: OfferPoiType.TRAM, name: "Myśliborska 05", distance: 774},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1442},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 1622},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 2074}
    ],
    18824: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 452},
        {type: OfferPoiType.BUS, name: "Niestachowska", distance: 633},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 789},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1555},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 1713},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1854},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1916},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1950},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2024},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 2030},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 2074},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 2123}
    ],
    18826: [
        {type: OfferPoiType.BUS, name: "Jawornicka", distance: 236},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 355},
        {type: OfferPoiType.BUS, name: "Rondo Skubiszewskiego", distance: 384},
        {type: OfferPoiType.TRAM, name: "Rondo Skubiszewskiego", distance: 474},
        {type: OfferPoiType.BUS, name: "Jugosłowiańska", distance: 634},
        {type: OfferPoiType.TRAM, name: "Węgorka", distance: 698},
        {type: OfferPoiType.TRAM, name: "Budziszyńska", distance: 743},
        {type: OfferPoiType.BUS, name: "Budziszyńska n/ż", distance: 744},
        {type: OfferPoiType.BUS, name: "Budziszyńska", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 1203},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1544},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Górczyński", distance: 1903}
    ],
    18828: [
        {type: OfferPoiType.BUS, name: "Nowy Bytom Osiedle Otylia", distance: 252},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Pokoju", distance: 707},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Chorzowska", distance: 722},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Centrum", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Dworski", distance: 1038},
        {type: OfferPoiType.PARK, name: "Zrewitalizowana Hałda Pocynkowa", distance: 1292},
        {type: OfferPoiType.PARK, name: "Ogród Ślaskiego Teatru Impresaryjnego", distance: 1449},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Hallera", distance: 2155},
        {type: OfferPoiType.PARK, name: "Góra Antonia", distance: 2190},
        {type: OfferPoiType.PARK, name: "Strefa Aktywności Rodzinnej Bykowina", distance: 2276},
        {type: OfferPoiType.PARK, name: "Park im. Juliana Tuwima", distance: 2427}
    ],
    18831: [
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 164},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 174},
        {type: OfferPoiType.BUS, name: "Natansona 02", distance: 226},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 247},
        {type: OfferPoiType.BUS, name: "Natansona 01", distance: 279},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 331},
        {type: OfferPoiType.BUS, name: "Siewna 03", distance: 517},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 546},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 548},
        {type: OfferPoiType.BUS, name: "Bociana 04", distance: 562},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 586},
        {type: OfferPoiType.BUS, name: "ks. Meiera 04", distance: 600},
        {type: OfferPoiType.TRAM, name: "Bociana 02", distance: 603},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 610},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 624},
        {type: OfferPoiType.TRAM, name: "Bociana 01", distance: 648},
        {type: OfferPoiType.TRAM, name: "Siewna Wiadukt 02", distance: 831},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1431},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1838},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1881},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2070},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2121},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 2186}
    ],
    18832: [
        {type: OfferPoiType.BUS, name: "Os. Na Stoku", distance: 130},
        {type: OfferPoiType.BUS, name: "Orląt Lwowskich", distance: 267},
        {type: OfferPoiType.BUS, name: "Orląt Lwowskich / Żłobek", distance: 481},
        {type: OfferPoiType.BUS, name: "Sikorskiego", distance: 492},
        {type: OfferPoiType.BUS, name: "Nowaka-Jeziorańskiego / os. Na Stoku", distance: 532},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 2430}
    ],
    18833: [
        {type: OfferPoiType.BUS, name: "Wiatraczna", distance: 192},
        {type: OfferPoiType.BUS, name: "Brneńska n/ż", distance: 308},
        {type: OfferPoiType.LAS, name: "Las kieszonkowy", distance: 443},
        {type: OfferPoiType.TRAM, name: "Łacina", distance: 443},
        {type: OfferPoiType.BUS, name: "Os. Tysiąclecia", distance: 532},
        {type: OfferPoiType.TRAM, name: "Os. Tysiąclecia", distance: 538},
        {type: OfferPoiType.BUS, name: "Os. Lecha II", distance: 667},
        {type: OfferPoiType.BUS, name: "Os. Jagiellońskie n/ż", distance: 714},
        {type: OfferPoiType.REZERWAT, name: "Traszki Ratajskie", distance: 745},
        {type: OfferPoiType.BUS, name: "Os. Lecha I n/ż", distance: 755},
        {type: OfferPoiType.TRAM, name: "Polanka", distance: 770},
        {type: OfferPoiType.PARK, name: "Park na os. Tysiąclecia", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Rataje", distance: 1241},
        {type: OfferPoiType.PARK, name: "Park na os. Orła Białego", distance: 1707},
        {type: OfferPoiType.PARK, name: "Park Forteczny", distance: 1800},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1888},
        {type: OfferPoiType.PARK, name: "Park na os. Armii Krajowej", distance: 2003},
        {type: OfferPoiType.PARK, name: "Park Nad Wartą", distance: 2065},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 2142},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 2488}
    ],
    18836: [
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 01", distance: 94},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 02", distance: 236},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy", distance: 345},
        {type: OfferPoiType.BUS, name: "ZUS 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Rondo ks. J. Popiełuszki 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Jastrzębia 02", distance: 603},
        {type: OfferPoiType.BUS, name: "Powstańców 03", distance: 632},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 641},
        {type: OfferPoiType.BUS, name: "Działkowa 01", distance: 694},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 898},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 1311},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1707},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1868},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 2201}
    ],
    18841: [
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1266},
        {type: OfferPoiType.PARK, name: "Małpi Gaj", distance: 1947}
    ],
    18842: [
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1266},
        {type: OfferPoiType.PARK, name: "Małpi Gaj", distance: 1947}
    ],
    18843: [
        {type: OfferPoiType.BUS, name: "Obornicka (Wołowska)", distance: 274},
        {type: OfferPoiType.BUS, name: "Wołowska", distance: 412},
        {type: OfferPoiType.TRAM, name: "Wołowska", distance: 417},
        {type: OfferPoiType.BUS, name: "Bezpieczna", distance: 458},
        {type: OfferPoiType.TRAM, name: "Poświętne", distance: 670},
        {type: OfferPoiType.BUS, name: "Paprotna", distance: 690},
        {type: OfferPoiType.BUS, name: "Poświętne", distance: 722},
        {type: OfferPoiType.BUS, name: "Kępińska", distance: 765},
        {type: OfferPoiType.TRAM, name: "Kępińska", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 2263}
    ],
    18850: [
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 399},
        {type: OfferPoiType.BUS, name: "Markowska 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Markowska 02", distance: 500},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Wileńska", distance: 522},
        {type: OfferPoiType.BUS, name: "Korsaka 02", distance: 618},
        {type: OfferPoiType.BUS, name: "Ząbkowska 06", distance: 646},
        {type: OfferPoiType.BUS, name: "Dworzec Wileński 04", distance: 657},
        {type: OfferPoiType.BUS, name: "Rzeszotarskiej 02", distance: 662},
        {type: OfferPoiType.METRO, name: "Dworzec Wileński", distance: 665},
        {type: OfferPoiType.BUS, name: "Rzeszotarskiej 01", distance: 682},
        {type: OfferPoiType.TRAM, name: "Dworzec Wileński 07", distance: 682},
        {type: OfferPoiType.BUS, name: "Dworzec Wileński 06", distance: 688},
        {type: OfferPoiType.BUS, name: "Dworzec Wileński 01", distance: 760},
        {type: OfferPoiType.BUS, name: "Korsaka 01", distance: 781},
        {type: OfferPoiType.TRAM, name: "Ząbkowska 04", distance: 821},
        {type: OfferPoiType.TRAM, name: "Dworzec Wileński 08", distance: 825},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 1285},
        {type: OfferPoiType.PARK, name: "Skwer Kępna-Jagiellońska", distance: 1370},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1372},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 1493}
    ],
    18854: [
        {type: OfferPoiType.BUS, name: "Tarnogajska", distance: 132},
        {type: OfferPoiType.TRAM, name: "Tarnogajska", distance: 177},
        {type: OfferPoiType.TRAM, name: "Nyska", distance: 495},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 536},
        {type: OfferPoiType.BUS, name: "Nyska", distance: 563},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 623},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 633},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 750},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 763},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 784},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 788},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 793},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1994},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 2188},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 2210}
    ],
    18855: [
        {type: OfferPoiType.TRAM, name: "Aleja Reymonta 03", distance: 68},
        {type: OfferPoiType.BUS, name: "Aleja Reymonta 05", distance: 84},
        {type: OfferPoiType.TRAM, name: "Aleja Reymonta 08", distance: 118},
        {type: OfferPoiType.TRAM, name: "Aleja Reymonta 04", distance: 154},
        {type: OfferPoiType.BUS, name: "Aleja Reymonta 06", distance: 178},
        {type: OfferPoiType.BUS, name: "Aleja Reymonta 01", distance: 211},
        {type: OfferPoiType.BUS, name: "Andersena 03", distance: 298},
        {type: OfferPoiType.BUS, name: "Andersena 02", distance: 415},
        {type: OfferPoiType.BUS, name: "Andersena 01", distance: 429},
        {type: OfferPoiType.BUS, name: "Andersena 04", distance: 447},
        {type: OfferPoiType.TRAM, name: "Aspekt 03", distance: 485},
        {type: OfferPoiType.TRAM, name: "Aspekt 04", distance: 495},
        {type: OfferPoiType.BUS, name: "Aspekt 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Aspekt 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Conrada 02", distance: 546},
        {type: OfferPoiType.TRAM, name: "Conrada 05", distance: 621},
        {type: OfferPoiType.TRAM, name: "Conrada 06", distance: 663},
        {type: OfferPoiType.TRAM, name: "Piaski 04", distance: 772},
        {type: OfferPoiType.TRAM, name: "Piaski 03", distance: 799},
        {type: OfferPoiType.TRAM, name: "Piaski 05", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 886},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1206},
        {type: OfferPoiType.PARK, name: "Eco Skwerek", distance: 1496},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1568},
        {type: OfferPoiType.PARK, name: "Jordanek", distance: 1780},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1806},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1947}
    ],
    18863: [
        {type: OfferPoiType.BUS, name: "Żółkiewskiego / Sobieskiego", distance: 384},
        {type: OfferPoiType.BUS, name: "Chrobrego / Rapackiego 10", distance: 541},
        {type: OfferPoiType.BUS, name: "Mieszka I / Żółkiewskiego 02", distance: 557},
        {type: OfferPoiType.BUS, name: "Chrobrego / Rapackiego 09", distance: 620},
        {type: OfferPoiType.BUS, name: "Rapackiego / Chrobrego 02", distance: 694},
        {type: OfferPoiType.BUS, name: "Mieszka I / Królowej Jadwigi 01", distance: 775},
        {type: OfferPoiType.PARK, name: "Park Michałów", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Gołębiów", distance: 1794}
    ],
    18877: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 498},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 633},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 746},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 767},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 793},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 802},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2272},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2475}
    ],
    18882: [
        {type: OfferPoiType.BUS, name: "Zesławice 01", distance: 278},
        {type: OfferPoiType.BUS, name: "Zesławice 02", distance: 290},
        {type: OfferPoiType.BUS, name: "Zesławice Ogródki Działkowe 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Zesławice Ogródki Działkowe 01", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Zakole", distance: 1276},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 2066}
    ],
    18888: [
        {type: OfferPoiType.BUS, name: "Jasielska I n/ż", distance: 152},
        {type: OfferPoiType.BUS, name: "Instytut Genetyki n/ż", distance: 353},
        {type: OfferPoiType.BUS, name: "Jasielska II n/ż", distance: 449},
        {type: OfferPoiType.BUS, name: "Strzeszyńska II", distance: 573},
        {type: OfferPoiType.BUS, name: "Strzeszyńska n/ż", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 1052},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1173},
        {type: OfferPoiType.PARK, name: "Park Edukacji Ekologicznej Strzeszyn", distance: 1446},
        {type: OfferPoiType.PARK, name: "Aleja Demokracji", distance: 1639},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 2432}
    ],
    18895: [
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 248},
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 293},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 716},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 743},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 743},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1873}
    ],
    18902: [
        {type: OfferPoiType.BUS, name: "Tartaczna/Straż Graniczna (122)", distance: 247},
        {type: OfferPoiType.BUS, name: "Tartaczna/Bloki (123)", distance: 328},
        {type: OfferPoiType.BUS, name: "Tartaczna/Pętla (113)", distance: 356},
        {type: OfferPoiType.BUS, name: "Turystyczna/Augustowianka (n/ż) (44)", distance: 359},
        {type: OfferPoiType.BUS, name: "Turystyczna/Rozlewnia Augustowianki (n/ż) (3)", distance: 371},
        {type: OfferPoiType.BUS, name: "Turystyczna/Wypoczynkowa (n/ż) (2)", distance: 429},
        {type: OfferPoiType.BUS, name: "Turystyczna/Jednostka Wojskowa (124) (n/ż)", distance: 479},
        {type: OfferPoiType.BUS, name: "Tartaczna/Os. Lipowiec (73)", distance: 481},
        {type: OfferPoiType.BUS, name: "Tartaczna/Szkoła nr 6 (42)", distance: 603},
        {type: OfferPoiType.PARK, name: "Park Herberta", distance: 796},
        {type: OfferPoiType.LAS, name: "7", distance: 894}
    ],
    18905: [
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 01", distance: 375},
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 02", distance: 402},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 503},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 573},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 578},
        {type: OfferPoiType.BUS, name: "Małych Dębów 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 779},
        {type: OfferPoiType.BUS, name: "Małych Dębów 02", distance: 784}
    ],
    18906: [
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 06", distance: 90},
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 05", distance: 116},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 02", distance: 138},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 01", distance: 230},
        {type: OfferPoiType.PARK, name: "Dolinka Marymoncka", distance: 275},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 03", distance: 294},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 04", distance: 310},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 342},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 07", distance: 370},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 04", distance: 392},
        {type: OfferPoiType.METRO, name: "Słodowiec", distance: 411},
        {type: OfferPoiType.BUS, name: "Park Kaskada 02", distance: 445},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 03", distance: 475},
        {type: OfferPoiType.PARK, name: "Stawy Kellera", distance: 483},
        {type: OfferPoiType.BUS, name: "Park Kaskada 06", distance: 494},
        {type: OfferPoiType.BUS, name: "Park Kaskada 05", distance: 505},
        {type: OfferPoiType.BUS, name: "Park Kaskada 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Hłaski 02", distance: 603},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 03", distance: 614},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 08", distance: 635},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 04", distance: 643},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 09", distance: 733},
        {type: OfferPoiType.PARK, name: "Park Kaskada", distance: 742},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 04", distance: 810},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 71", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 925},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1016},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1196},
        {type: OfferPoiType.PARK, name: "Park Harcerskiej Poczty Polowej Powstania Warszawskiego", distance: 1332},
        {type: OfferPoiType.PARK, name: "Skwer Igora Newerlego", distance: 1384},
        {type: OfferPoiType.PARK, name: 'Park Żołnierzy "Żywiciela"', distance: 1470}
    ],
    18907: [
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 06", distance: 76},
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 05", distance: 102},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 02", distance: 124},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 01", distance: 216},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 03", distance: 280},
        {type: OfferPoiType.PARK, name: "Dolinka Marymoncka", distance: 289},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 04", distance: 296},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 328},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 04", distance: 378},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 07", distance: 384},
        {type: OfferPoiType.METRO, name: "Słodowiec", distance: 397},
        {type: OfferPoiType.BUS, name: "Park Kaskada 02", distance: 431},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 03", distance: 461},
        {type: OfferPoiType.PARK, name: "Stawy Kellera", distance: 469},
        {type: OfferPoiType.BUS, name: "Park Kaskada 06", distance: 480},
        {type: OfferPoiType.BUS, name: "Park Kaskada 05", distance: 491},
        {type: OfferPoiType.BUS, name: "Park Kaskada 01", distance: 497},
        {type: OfferPoiType.BUS, name: "Hłaski 02", distance: 589},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 08", distance: 621},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 03", distance: 628},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 04", distance: 657},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 09", distance: 719},
        {type: OfferPoiType.PARK, name: "Park Kaskada", distance: 728},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 04", distance: 796},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 71", distance: 816},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 911},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1002},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1182},
        {type: OfferPoiType.PARK, name: "Park Harcerskiej Poczty Polowej Powstania Warszawskiego", distance: 1318},
        {type: OfferPoiType.PARK, name: "Skwer Igora Newerlego", distance: 1370},
        {type: OfferPoiType.PARK, name: 'Park Żołnierzy "Żywiciela"', distance: 1456}
    ],
    18913: [
        {type: OfferPoiType.LAS, name: "Park rzeczny Wilgi", distance: 301},
        {type: OfferPoiType.PARK, name: "Park rzeczny Wilgi", distance: 301},
        {type: OfferPoiType.BUS, name: "Lipińskiego 03", distance: 445},
        {type: OfferPoiType.BUS, name: "Lipińskiego 04", distance: 453},
        {type: OfferPoiType.TRAM, name: "Lipińskiego 02", distance: 469},
        {type: OfferPoiType.TRAM, name: "Lipińskiego 01", distance: 489},
        {type: OfferPoiType.BUS, name: "Borsucza 04", distance: 568},
        {type: OfferPoiType.TRAM, name: "Borsucza 01", distance: 585},
        {type: OfferPoiType.TRAM, name: "Borsucza 02", distance: 595},
        {type: OfferPoiType.BUS, name: "Borsucza 03", distance: 618},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 05", distance: 721},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 02", distance: 761},
        {type: OfferPoiType.TRAM, name: "Brożka 02", distance: 781},
        {type: OfferPoiType.TRAM, name: "Brożka 01", distance: 785},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 03", distance: 795},
        {type: OfferPoiType.BUS, name: "Krokusowa 02", distance: 820},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 01", distance: 827},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 04", distance: 832},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 04", distance: 834},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 938},
        {type: OfferPoiType.PARK, name: "Park Solvay", distance: 1827},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1855},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2076},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2255}
    ],
    18915: [
        {type: OfferPoiType.BUS, name: "Przestrzenna - Tabelowa NŻ", distance: 770},
        {type: OfferPoiType.LAS, name: "Las Popioły", distance: 973},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Ruda Willowa”", distance: 1543},
        {type: OfferPoiType.PARK, name: "Rudzka Góra", distance: 2085},
        {type: OfferPoiType.PARK, name: "Park Mirabelka", distance: 2086},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2198}
    ],
    18927: [
        {type: OfferPoiType.TRAM, name: "Hetmańska - Zagłoby", distance: 520},
        {type: OfferPoiType.BUS, name: "Hetmańska - Zagłoby", distance: 561},
        {type: OfferPoiType.TRAM, name: "Hetmańska - Dąbrówki", distance: 650},
        {type: OfferPoiType.BUS, name: "Hetmańska - Dąbrówki", distance: 683},
        {type: OfferPoiType.BUS, name: "Hetmańska - Juranda ze Spychowa", distance: 797},
        {type: OfferPoiType.PARK, name: "Park na Janowie", distance: 1185},
        {type: OfferPoiType.PARK, name: "Park Źródła Olechówki", distance: 1709}
    ],
    18929: [
        {type: OfferPoiType.BUS, name: "Barlickiego - poczta", distance: 54},
        {type: OfferPoiType.BUS, name: "Fińska", distance: 292},
        {type: OfferPoiType.BUS, name: "Barlickiego / Ludzi Morza", distance: 302},
        {type: OfferPoiType.BUS, name: "Barlickiego - Dworzec", distance: 365},
        {type: OfferPoiType.BUS, name: "Duńska 01", distance: 423},
        {type: OfferPoiType.BUS, name: "Skandynawska n/ż", distance: 446},
        {type: OfferPoiType.BUS, name: "Ludzi Morza / Łąkowa", distance: 460},
        {type: OfferPoiType.KOLEJ, name: "Świnoujście", distance: 655},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 1522}
    ],
    18933: [
        {type: OfferPoiType.PARK, name: "Skwer Pomorskiego Okręgu Wojskowego", distance: 509},
        {type: OfferPoiType.BUS, name: "Sułkowskiego / Kamienna", distance: 513},
        {type: OfferPoiType.BUS, name: "Kamienna / Sułkowskiego", distance: 556},
        {type: OfferPoiType.BUS, name: "Gdańska / Powst. Warszawy", distance: 614},
        {type: OfferPoiType.BUS, name: "Kamienna / Gdańska", distance: 622},
        {type: OfferPoiType.BUS, name: "Czerkaska / Sułkowskiego", distance: 632},
        {type: OfferPoiType.BUS, name: "Gdańska / Artyleryjska", distance: 648},
        {type: OfferPoiType.TRAM, name: "Gdańska / Artyleryjska", distance: 651},
        {type: OfferPoiType.TRAM, name: "Gdańska / Powst. Warszawy", distance: 669},
        {type: OfferPoiType.PARK, name: "Skwer Inwalidów Wojennych", distance: 734},
        {type: OfferPoiType.PARK, name: "Skwer im. Teresy Ciepły", distance: 827}
    ],
    18945: [
        {type: OfferPoiType.BUS, name: "Dąbrowska 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Leśna 02", distance: 618},
        {type: OfferPoiType.BUS, name: "Dąbrowska 01", distance: 624},
        {type: OfferPoiType.BUS, name: "Wyścigowa 03", distance: 660},
        {type: OfferPoiType.BUS, name: "Dunikowskiego - osiedle 01", distance: 679},
        {type: OfferPoiType.PARK, name: "Perłowy Zakątek", distance: 682},
        {type: OfferPoiType.BUS, name: "Wyścigowa 02", distance: 715},
        {type: OfferPoiType.BUS, name: "Wyścigowa - szkoła 02", distance: 737},
        {type: OfferPoiType.BUS, name: "Pawia 01", distance: 788},
        {type: OfferPoiType.BUS, name: "Wyścigowa - szkoła 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Nowy Świat 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Skwer Borowiczan", distance: 1440}
    ],
    18947: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Okęcie", distance: 609},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 04", distance: 681},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 749},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1843}
    ],
    18949: [
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Łużycka  02", distance: 529},
        {type: OfferPoiType.BUS, name: "Brzegowa 01", distance: 718},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1058}
    ],
    18950: [
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 14", distance: 187},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 10", distance: 208},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 11", distance: 244},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 13", distance: 269},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ochota WKD", distance: 409},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 433},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 08", distance: 441},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 06", distance: 444},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ochota", distance: 479},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 04", distance: 493},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 05", distance: 494},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 02", distance: 500},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Główna", distance: 524},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 03", distance: 526},
        {type: OfferPoiType.BUS, name: "Plac Starynkiewicza 02", distance: 527},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 15", distance: 549},
        {type: OfferPoiType.BUS, name: "Plac Starynkiewicza 06", distance: 550},
        {type: OfferPoiType.BUS, name: "Sienna 01", distance: 554},
        {type: OfferPoiType.BUS, name: "Rondo Daszyńskiego 03", distance: 554},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 06", distance: 573},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 07", distance: 654},
        {type: OfferPoiType.TRAM, name: "Ochota-Ratusz 02", distance: 677},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 56", distance: 690},
        {type: OfferPoiType.TRAM, name: "Plac Starynkiewicza 03", distance: 695},
        {type: OfferPoiType.METRO, name: "Rondo Daszyńskiego", distance: 734},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 932},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1113},
        {type: OfferPoiType.PARK, name: "Skwer Sue Ryder", distance: 1356},
        {type: OfferPoiType.PARK, name: "Park Wielkopolski", distance: 1524},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1529},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 1592},
        {type: OfferPoiType.PARK, name: "Park Świętokrzyski", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 1607}
    ],
    18951: [
        {type: OfferPoiType.BUS, name: "Maczka 01", distance: 210},
        {type: OfferPoiType.BUS, name: "Dzika 01", distance: 249},
        {type: OfferPoiType.BUS, name: "Dzika 02", distance: 275},
        {type: OfferPoiType.BUS, name: "Maczka 04", distance: 294},
        {type: OfferPoiType.BUS, name: "Maczka 02", distance: 308},
        {type: OfferPoiType.BUS, name: "Maczka 03", distance: 317},
        {type: OfferPoiType.BUS, name: "Zieleniecka 02", distance: 671},
        {type: OfferPoiType.BUS, name: "Powstańców 04", distance: 740},
        {type: OfferPoiType.BUS, name: "Kosynierów 03", distance: 777},
        {type: OfferPoiType.BUS, name: "Zieleniecka 01", distance: 784},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 2358}
    ],
    18953: [
        {type: OfferPoiType.BUS, name: "Piekarnicza 04", distance: 162},
        {type: OfferPoiType.TRAM, name: "Piekarnicza", distance: 226},
        {type: OfferPoiType.BUS, name: "Piekarnicza 03", distance: 287},
        {type: OfferPoiType.BUS, name: "Nowolipie 01", distance: 588},
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 02", distance: 751},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 755},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 767},
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 01", distance: 768},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 772},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 772},
        {type: OfferPoiType.BUS, name: "Belgradzka 04", distance: 792},
        {type: OfferPoiType.BUS, name: "Belgradzka 03", distance: 818},
        {type: OfferPoiType.LAS, name: "Lasek Buloński", distance: 904},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 904},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 1338},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 1992},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 2032}
    ],
    18956: [
        {type: OfferPoiType.BUS, name: "Nowodworska", distance: 268},
        {type: OfferPoiType.TRAM, name: "Nowodworska", distance: 268},
        {type: OfferPoiType.BUS, name: "Strzegomska (krzyżówka)", distance: 576},
        {type: OfferPoiType.TRAM, name: "Strzegomska (krzyżówka)", distance: 593},
        {type: OfferPoiType.BUS, name: "Chociebuska (Centrum Kultury Nowy Pafawag)", distance: 603},
        {type: OfferPoiType.BUS, name: "Muchobór Mały (stacja kolejowa)", distance: 721},
        {type: OfferPoiType.BUS, name: "Strzegomska 148", distance: 799},
        {type: OfferPoiType.TRAM, name: "Strzegomska 148", distance: 799},
        {type: OfferPoiType.PARK, name: "Park Leonarda", distance: 1921},
        {type: OfferPoiType.PARK, name: "skwer Księdza Szczepana Zielińskiego", distance: 1937},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 2350}
    ],
    18957: [
        {type: OfferPoiType.TRAM, name: "Teatr Variété 01", distance: 363},
        {type: OfferPoiType.TRAM, name: "Teatr Variété 02", distance: 393},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 408},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 476},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 07", distance: 492},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 04", distance: 493},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 05", distance: 502},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 01", distance: 521},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 06", distance: 573},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 02", distance: 588},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 03", distance: 607},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 08", distance: 612},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 615},
        {type: OfferPoiType.BUS, name: "Nullo 03", distance: 623},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 633},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 641},
        {type: OfferPoiType.TRAM, name: "Fabryczna 01", distance: 809},
        {type: OfferPoiType.TRAM, name: "Fabryczna 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Grzegórzecki", distance: 854},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 930},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Polaków Poszkodowanych przez III Rzeszę", distance: 1271},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1307},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2044},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2335}
    ],
    18958: [
        {type: OfferPoiType.BUS, name: "Zagłębiowska", distance: 150},
        {type: OfferPoiType.BUS, name: "Księże Małe", distance: 287},
        {type: OfferPoiType.BUS, name: "Księska", distance: 327},
        {type: OfferPoiType.TRAM, name: "Księże Małe", distance: 345},
        {type: OfferPoiType.BUS, name: "Blizanowicka", distance: 549},
        {type: OfferPoiType.BUS, name: "Sosnowiecka", distance: 599},
        {type: OfferPoiType.TRAM, name: "Głubczycka", distance: 752},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2075},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2099},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2312},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 2527}
    ],
    18962: [
        {type: OfferPoiType.BUS, name: "Poniatowskiego 01", distance: 420},
        {type: OfferPoiType.BUS, name: "Poniatowskiego 02", distance: 436}
    ],
    18970: [
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 176},
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 419},
        {type: OfferPoiType.BUS, name: "Rędzińska (Cmentarz)", distance: 607},
        {type: OfferPoiType.BUS, name: "Maślicka (Staw)", distance: 645},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 719},
        {type: OfferPoiType.BUS, name: "Maślicka (Osiedle)", distance: 825},
        {type: OfferPoiType.BUS, name: "Północna", distance: 826},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1246}
    ],
    18977: [
        {type: OfferPoiType.BUS, name: "Minakowskiego", distance: 588},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 1228},
        {type: OfferPoiType.PARK, name: "Park Nagórki-Jaroty", distance: 1396},
        {type: OfferPoiType.PARK, name: "Skwer generała Augusta Fieldorfa–Nila", distance: 1796},
        {type: OfferPoiType.PARK, name: "Park podworski Pozorty", distance: 2263},
        {type: OfferPoiType.PARK, name: "Park podworski Nagórki", distance: 2518}
    ],
    18978: [
        {type: OfferPoiType.BUS, name: "Iwiny – pętla", distance: 731},
        {type: OfferPoiType.BUS, name: "Iwiny – Słoneczna", distance: 765},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1534},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1901}
    ],
    18994: [
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 01", distance: 259},
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 02", distance: 326},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 02", distance: 829},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 01", distance: 843},
        {type: OfferPoiType.PARK, name: "Park Miłocin", distance: 1666},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 2114}
    ],
    19002: [
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 598},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 653},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 731},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 1569},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1727},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1752},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1755},
        {type: OfferPoiType.PARK, name: "skwer Skaczącej Gwiazdy", distance: 1808}
    ],
    19005: [
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 627},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 635},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 661},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 662},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 727},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 768},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 912},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 955},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1395},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1611},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1909},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 1974},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1977},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1981},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 2043},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2153},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2420}
    ],
    19007: [
        {type: OfferPoiType.BUS, name: "Kudowa Zdrój,Nad Potokiem", distance: 528},
        {type: OfferPoiType.BUS, name: "Kudowa Zdrój, ul.Nad Potokiem 24", distance: 528},
        {type: OfferPoiType.BUS, name: "Kudowa Zdrój 1", distance: 603},
        {type: OfferPoiType.BUS, name: "KUDOWA ZDRÓJ ul.Zdrojowa", distance: 679},
        {type: OfferPoiType.BUS, name: "ul. Norwida (szkoła)", distance: 829},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 989}
    ],
    19009: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 132},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 135},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 150},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 280},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 369},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 373},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 448},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 488},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 512},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1008},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1191},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1296},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1556},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1616},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1933},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1981},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1995},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2104}
    ],
    19010: [
        {type: OfferPoiType.TRAM, name: "Mogileńska", distance: 482},
        {type: OfferPoiType.BUS, name: "Mogileńska", distance: 508},
        {type: OfferPoiType.BUS, name: "Pusta n/ż", distance: 626},
        {type: OfferPoiType.BUS, name: "Łomżyńska", distance: 778},
        {type: OfferPoiType.BUS, name: "Miłostowo", distance: 804},
        {type: OfferPoiType.TRAM, name: "Łomżyńska", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2213}
    ],
    19011: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Mały Skręt", distance: 620},
        {type: OfferPoiType.BUS, name: "Łódzka - Mały Skręt", distance: 731},
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 823},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2189},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2456}
    ],
    19015: [
        {type: OfferPoiType.BUS, name: "Podchorążych 2", distance: 208},
        {type: OfferPoiType.BUS, name: "Kopernika Pętla", distance: 220},
        {type: OfferPoiType.BUS, name: "Podchorążych 1", distance: 265},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 2 / Kopernika", distance: 529},
        {type: OfferPoiType.BUS, name: "Wileńska 1", distance: 576},
        {type: OfferPoiType.BUS, name: "Wileńska / Jednostka Wojskowa", distance: 597},
        {type: OfferPoiType.PARK, name: "Skwer Kombatantów", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Nad Stawami", distance: 1192},
        {type: OfferPoiType.PARK, name: "Park Kolejarzy Oleśnickich", distance: 1351},
        {type: OfferPoiType.PARK, name: "Park Henryka Sienkiewicza", distance: 1871},
        {type: OfferPoiType.REZERWAT, name: "Olsy Spalickie", distance: 2126}
    ],
    19020: [
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 01", distance: 193},
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 02", distance: 281},
        {type: OfferPoiType.BUS, name: "Drzewieckiego 02", distance: 366},
        {type: OfferPoiType.BUS, name: "Drzewieckiego 01", distance: 378},
        {type: OfferPoiType.BUS, name: "Kopalniana", distance: 725},
        {type: OfferPoiType.BUS, name: "Grudziądzka 04", distance: 747},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 748},
        {type: OfferPoiType.TRAM, name: "Grudziądzka", distance: 767},
        {type: OfferPoiType.BUS, name: "Grudziądzka 05", distance: 779},
        {type: OfferPoiType.BUS, name: "Korczaka 02", distance: 803},
        {type: OfferPoiType.TRAM, name: "Kolonia Uroda", distance: 805},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1340}
    ],
    19021: [
        {type: OfferPoiType.BUS, name: "Jasielska II n/ż", distance: 182},
        {type: OfferPoiType.BUS, name: "Jasielska I n/ż", distance: 372},
        {type: OfferPoiType.BUS, name: "Druskienicka", distance: 568},
        {type: OfferPoiType.BUS, name: "Instytut Genetyki n/ż", distance: 574},
        {type: OfferPoiType.BUS, name: "Strzeszyńska II", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 923},
        {type: OfferPoiType.PARK, name: "Park Edukacji Ekologicznej Strzeszyn", distance: 1190},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1293},
        {type: OfferPoiType.PARK, name: "Aleja Demokracji", distance: 1383},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 2462}
    ],
    19022: [
        {type: OfferPoiType.BUS, name: "Żelechów Topolowa", distance: 173},
        {type: OfferPoiType.BUS, name: "Żelechów Jastrzębska", distance: 186},
        {type: OfferPoiType.BUS, name: "Żelechów Krakowiańska", distance: 498},
        {type: OfferPoiType.BUS, name: "Żelechów Jana Matejki", distance: 718},
        {type: OfferPoiType.BUS, name: "Żelechów Kościół", distance: 730},
        {type: OfferPoiType.BUS, name: "Żelechów Polna", distance: 777},
        {type: OfferPoiType.PARK, name: "Zespół pałacowo-parkowy w Ojrzanowie", distance: 1668}
    ],
    19027: [
        {type: OfferPoiType.BUS, name: "Iwiny - Kolejowa", distance: 344},
        {type: OfferPoiType.BUS, name: "Iwiny – Kościuszki", distance: 359},
        {type: OfferPoiType.BUS, name: "Iwiny – Słoneczna", distance: 534},
        {type: OfferPoiType.BUS, name: "Iwiny – pętla", distance: 578},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1850}
    ],
    19029: [
        {type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 440},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 675},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 784}
    ],
    19030: [
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 311},
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 317},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 563},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 681},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 792},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 796},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2318},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2378}
    ],
    19032: [
        {type: OfferPoiType.BUS, name: "Zakładowa", distance: 376},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 474},
        {type: OfferPoiType.BUS, name: "Trzebnicka", distance: 627},
        {type: OfferPoiType.TRAM, name: "Trzebnicka", distance: 636},
        {type: OfferPoiType.TRAM, name: "Dworzec Nadodrze", distance: 710},
        {type: OfferPoiType.BUS, name: "Dworzec Nadodrze", distance: 719},
        {type: OfferPoiType.BUS, name: "Kręta", distance: 766},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 775},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1034},
        {type: OfferPoiType.PARK, name: "Park Świętego Macieja", distance: 1268}
    ],
    19035: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 493},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 574},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 587},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 790},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 811},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 825},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1079},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1087},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1770},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1889},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1966},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2113},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2223}
    ],
    19036: [
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Służewiec 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Służewiec 01", distance: 339},
        {type: OfferPoiType.BUS, name: "Kłobucka 04", distance: 377},
        {type: OfferPoiType.BUS, name: "Kłobucka 03", distance: 484},
        {type: OfferPoiType.BUS, name: "Kłobucka 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 715},
        {type: OfferPoiType.BUS, name: "Jurajska 01", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 1471},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 2224}
    ],
    19038: [
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 97},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 215},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 223},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 286},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 581},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 604},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 693},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2064}
    ],
    19043: [
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 104},
        {type: OfferPoiType.BUS, name: "Kaloryczna 02", distance: 135},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 360},
        {type: OfferPoiType.BUS, name: "Antoniewska 02", distance: 398},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Antoniewska 01", distance: 451},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 753},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 771},
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 799},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1666},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1689},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2147}
    ],
    19044: [
        {type: OfferPoiType.BUS, name: "Smolecka", distance: 675},
        {type: OfferPoiType.TRAM, name: "Smolecka", distance: 675},
        {type: OfferPoiType.BUS, name: "Śrubowa", distance: 737},
        {type: OfferPoiType.TRAM, name: "Śrubowa", distance: 737},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Jochelsona", distance: 867},
        {type: OfferPoiType.PARK, name: "park Aleksandry Natalli-Świat", distance: 1427},
        {type: OfferPoiType.LAS, name: "Lasek Dolmelowski", distance: 1608},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 2120}
    ],
    19045: [
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 04", distance: 119},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 03", distance: 279},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 04", distance: 415},
        {type: OfferPoiType.BUS, name: "Jabłonna 01", distance: 477},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 03", distance: 487},
        {type: OfferPoiType.BUS, name: "Jabłonna 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 02", distance: 553},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Wschód 02", distance: 565},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 815},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 867},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 921},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1217},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1316}
    ],
    19047: [
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 04", distance: 74},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 02", distance: 200},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 03", distance: 242},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 01", distance: 336},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 04", distance: 351},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 03", distance: 423},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Jabłonna 01", distance: 521},
        {type: OfferPoiType.BUS, name: "Jabłonna 02", distance: 532},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Wschód 02", distance: 609},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 803},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 884},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1180},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1360}
    ],
    19048: [
        {type: OfferPoiType.BUS, name: "Błonie-Rokitno PKP", distance: 349},
        {type: OfferPoiType.KOLEJ, name: "Błonie Rokitno", distance: 386},
        {type: OfferPoiType.BUS, name: "Rokitno I", distance: 596},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 1586},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 2003},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 2149}
    ],
    19055: [{type: OfferPoiType.BUS, name: "BRZEZINA - pętla", distance: 590}],
    19058: [
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 186},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 231},
        {type: OfferPoiType.TRAM, name: "Aleje Marcinkowskiego", distance: 233},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 432},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 445},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 451},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 520},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 554},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 565},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 580},
        {type: OfferPoiType.TRAM, name: "Łąkowa", distance: 580},
        {type: OfferPoiType.TRAM, name: "Pl. Bernardyński", distance: 583},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 615},
        {type: OfferPoiType.BUS, name: "Grobla", distance: 782},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 906},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1003},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1012},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1116},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1117},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1133},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1226},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1270},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1270}
    ],
    19061: [{type: OfferPoiType.PARK, name: "Park Felicjana Sypniewskiego", distance: 2073}],
    19064: [
        {type: OfferPoiType.BUS, name: "Śmigłego Rydza - Grota-Roweckiego", distance: 237},
        {type: OfferPoiType.TRAM, name: "Śmigłego Rydza - Grota-Roweckiego", distance: 250},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Łęczycka", distance: 436},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Łęczycka", distance: 436},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Śmigłego-Rydza", distance: 527},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Śmigłego-Rydza", distance: 530},
        {type: OfferPoiType.TRAM, name: "Śmigłego Rydza - Przybyszewskiego", distance: 560},
        {type: OfferPoiType.BUS, name: "Śmigłego Rydza - Przybyszewskiego", distance: 585},
        {type: OfferPoiType.BUS, name: "Tatrzańska - Grota-Roweckiego", distance: 644},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Poznańska", distance: 713},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 887},
        {type: OfferPoiType.PARK, name: "Skwer im. Świętego Maksymiliana Marii Kolbego", distance: 1519},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1729},
        {type: OfferPoiType.PARK, name: "Park Miejski przy ul. Leczniczej", distance: 1771},
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 1846},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1858},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1985}
    ],
    19066: [
        {type: OfferPoiType.BUS, name: "Zbyszewska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Zbyszewska 02", distance: 381},
        {type: OfferPoiType.BUS, name: "Grójec Piłsudskiego PKP", distance: 485},
        {type: OfferPoiType.BUS, name: "Grójec ul. Piłsudskiego", distance: 724},
        {type: OfferPoiType.BUS, name: 'Jana Pawła II "PSP 1" 02', distance: 760},
        {type: OfferPoiType.BUS, name: 'Jana Pawła II "PSP 1" 01', distance: 811}
    ],
    19069: [
        {type: OfferPoiType.BUS, name: "Grochowa", distance: 205},
        {type: OfferPoiType.BUS, name: "Krucza", distance: 504},
        {type: OfferPoiType.BUS, name: "Stalowa", distance: 526},
        {type: OfferPoiType.BUS, name: "Pereca", distance: 547},
        {type: OfferPoiType.TRAM, name: "Pereca", distance: 557},
        {type: OfferPoiType.TRAM, name: "Stalowa", distance: 622},
        {type: OfferPoiType.BUS, name: "Krucza (Mielecka)", distance: 670}
    ],
    19073: [
        {type: OfferPoiType.PARK, name: "park imienia Sprawiedliwych wśród Narodów Świata", distance: 1212},
        {type: OfferPoiType.REZERWAT, name: "Stawek na Gumieńcach", distance: 1545},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 2462}
    ],
    19079: [
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 228},
        {type: OfferPoiType.TRAM, name: "Zgierska - Przedwiośnie", distance: 281},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego", distance: 310},
        {type: OfferPoiType.TRAM, name: "Zgierska - Sikorskiego", distance: 380},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Zgierska", distance: 409},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego NŻ", distance: 536},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pl. Pamięci Narodowej", distance: 599},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Herlinga-Grudzińskiego", distance: 673},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pasieczna", distance: 780},
        {type: OfferPoiType.BUS, name: "Zgierska - Cm. Radogoszcz", distance: 816},
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 1260},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 1277},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 1316},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 1448},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1591},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Sokołówki i Brzozy”", distance: 2067},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 2086},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy na Żabieńcu”", distance: 2168},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 2332}
    ],
    19081: [
        {type: OfferPoiType.BUS, name: "Przasnyska 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Przasnyska 04", distance: 260},
        {type: OfferPoiType.BUS, name: "Przasnyska 02", distance: 332},
        {type: OfferPoiType.BUS, name: "Anny German 02", distance: 429},
        {type: OfferPoiType.BUS, name: "Sady Żoliborskie 06", distance: 438},
        {type: OfferPoiType.BUS, name: "Rydygiera 01", distance: 467},
        {type: OfferPoiType.BUS, name: "Anny German 01", distance: 484},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 495},
        {type: OfferPoiType.TRAM, name: "Sady Żoliborskie 03", distance: 514},
        {type: OfferPoiType.TRAM, name: "Sady Żoliborskie 04", distance: 521},
        {type: OfferPoiType.BUS, name: "Rydygiera 04", distance: 554},
        {type: OfferPoiType.BUS, name: "Rydygiera 03", distance: 561},
        {type: OfferPoiType.BUS, name: "Sady Żoliborskie 05", distance: 569},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 719},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 947},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1004},
        {type: OfferPoiType.PARK, name: 'Park Żołnierzy "Żywiciela"', distance: 1273},
        {type: OfferPoiType.PARK, name: "Skwer Barbary i Stanisława Brukalskich", distance: 1602},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1605},
        {type: OfferPoiType.PARK, name: "Skwer Igora Newerlego", distance: 1614}
    ],
    19083: [
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rewolucji 1905 r.", distance: 179},
        {type: OfferPoiType.BUS, name: "Jaracza - Wierzbowa", distance: 203},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 384},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rondo Solidarności", distance: 390},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 410},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 486},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 493},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Rondo Solidarności", distance: 496},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 522},
        {type: OfferPoiType.BUS, name: "Narutowicza - Tramwajowa", distance: 526},
        {type: OfferPoiType.TRAM, name: "Pomorska - Rondo Solidarności", distance: 540},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 543},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 579},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Kopcińskiego", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 745},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 872},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 942},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 1231},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1286},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 1290},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1439}
    ],
    19087: [
        {type: OfferPoiType.BUS, name: "Czarnochowice Osiedle", distance: 97},
        {type: OfferPoiType.BUS, name: "Czarnochowice Wygoda", distance: 563},
        {type: OfferPoiType.BUS, name: "Czarnochowice IX", distance: 660},
        {type: OfferPoiType.BUS, name: "Czarnochowice Dom Ludowy", distance: 703},
        {type: OfferPoiType.BUS, name: "Wygoda 1 nż.", distance: 807},
        {type: OfferPoiType.PARK, name: "Park osiedlowy", distance: 2322}
    ],
    19089: [
        {type: OfferPoiType.BUS, name: "Gliwice Puszkina", distance: 249},
        {type: OfferPoiType.BUS, name: "Gliwice Sowińskiego", distance: 437},
        {type: OfferPoiType.BUS, name: "Gliwice Styczyńskiego", distance: 543},
        {type: OfferPoiType.PARK, name: "Skwer Kežmarok", distance: 582},
        {type: OfferPoiType.BUS, name: "Gliwice Kościuszki", distance: 658},
        {type: OfferPoiType.BUS, name: "Gliwice Aleja Majowa", distance: 714},
        {type: OfferPoiType.PARK, name: "Park Starokozielski", distance: 1061}
    ],
    19090: [
        {type: OfferPoiType.BUS, name: "Wioślarska", distance: 156},
        {type: OfferPoiType.BUS, name: "Likusy", distance: 261},
        {type: OfferPoiType.BUS, name: "Żbicza", distance: 613},
        {type: OfferPoiType.KOLEJ, name: "Olsztyn Redykajny", distance: 614},
        {type: OfferPoiType.BUS, name: "Letniskowa", distance: 652}
    ],
    19093: [
        {type: OfferPoiType.BUS, name: "Niemcz / Kasprowicza", distance: 226},
        {type: OfferPoiType.BUS, name: "Niemcz / Mickiewicza", distance: 299},
        {type: OfferPoiType.BUS, name: "Niemcz / Słowackiego", distance: 393},
        {type: OfferPoiType.BUS, name: "Niemcz / Urocza", distance: 689},
        {type: OfferPoiType.BUS, name: "Niemcz / Pod Wierzbami", distance: 712},
        {type: OfferPoiType.BUS, name: "Jeździecka / Ogród Botaniczny", distance: 780},
        {type: OfferPoiType.BUS, name: "Jeździecka / Hipiczna", distance: 820}
    ],
    19095: [
        {type: OfferPoiType.BUS, name: "Maczka 03", distance: 267},
        {type: OfferPoiType.BUS, name: "Maczka 04", distance: 310},
        {type: OfferPoiType.BUS, name: "Maczka 01", distance: 331},
        {type: OfferPoiType.BUS, name: "Maczka 02", distance: 393},
        {type: OfferPoiType.BUS, name: "Kosynierów 04", distance: 400},
        {type: OfferPoiType.BUS, name: "Kosynierów 03", distance: 411},
        {type: OfferPoiType.BUS, name: "Kosynierów 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Zieleniecka 02", distance: 546},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 586},
        {type: OfferPoiType.BUS, name: "Pułaskiego 01", distance: 644},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 2237}
    ],
    19099: [
        {type: OfferPoiType.BUS, name: "Bytom Kruszcowa", distance: 705},
        {type: OfferPoiType.PARK, name: "Plac Akademicki", distance: 1516}
    ],
    19101: [
        {type: OfferPoiType.BUS, name: "Korczaka 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Korczaka 02", distance: 779},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski w Radzyminie", distance: 1243},
        {type: OfferPoiType.PARK, name: "Park Pułkownika Mieczysława Chojnackiego „Młodzika”", distance: 1300},
        {type: OfferPoiType.PARK, name: "Park Księżnej Eleonory Czartoryskiej", distance: 1445},
        {type: OfferPoiType.PARK, name: "Park na dawnym cmentarzu ewangelickim", distance: 2514}
    ],
    19105: [
        {type: OfferPoiType.BUS, name: "Lechowskiego nż", distance: 74},
        {type: OfferPoiType.BUS, name: "Szajnowicza nż", distance: 299},
        {type: OfferPoiType.BUS, name: "Golęcińska nż", distance: 443},
        {type: OfferPoiType.BUS, name: "Kolonistów", distance: 790},
        {type: OfferPoiType.BUS, name: "Stołczyn Kościół", distance: 842},
        {type: OfferPoiType.PARK, name: "Park ks. Dąbrówki", distance: 1740}
    ],
    19106: [
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 386},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 427},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 441},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 451},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 457},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 519},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 546},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 571},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 572},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 573},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 831},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1327},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1347},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1636},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 1702},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1855},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1927},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2079},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2241},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2420},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2440}
    ],
    19107: [
        {type: OfferPoiType.BUS, name: "Biegasa", distance: 257},
        {type: OfferPoiType.BUS, name: "Chełmońskiego", distance: 521},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 594},
        {type: OfferPoiType.BUS, name: "Tramwajowa", distance: 698},
        {type: OfferPoiType.TRAM, name: "Chełmońskiego", distance: 723},
        {type: OfferPoiType.TRAM, name: "Tramwajowa", distance: 735},
        {type: OfferPoiType.BUS, name: "Dembowskiego (Kosiby)", distance: 830},
        {type: OfferPoiType.LAS, name: "Park Dąbski", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park Dąbski", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1610},
        {type: OfferPoiType.PARK, name: "skwer Zbyszka Cybulskiego", distance: 1618},
        {type: OfferPoiType.PARK, name: "skwer Hanny Hirszfeldowej", distance: 1795},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1992}
    ],
    19110: [
        {type: OfferPoiType.BUS, name: "Gniewskie Młyny", distance: 226},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1360},
        {type: OfferPoiType.REZERWAT, name: "Strzelnica w Gniewie", distance: 2060}
    ],
    19111: [
        {type: OfferPoiType.BUS, name: "Katowice Mickiewicza Biurowce", distance: 178},
        {type: OfferPoiType.BUS, name: "Katowice Plac Wolności", distance: 386},
        {type: OfferPoiType.BUS, name: "Katowice Dąbrówki", distance: 395},
        {type: OfferPoiType.BUS, name: "Katowice Sobieskiego", distance: 415},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 415},
        {type: OfferPoiType.TRAM, name: "Katowice Dąbrówki", distance: 436},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna", distance: 506},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 562},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 582},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 628},
        {type: OfferPoiType.TRAM, name: "Katowice Dworzec PKP", distance: 688},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 708},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1025},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 1138},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1192},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 1218},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1235}
    ],
    19117: [{type: OfferPoiType.BUS, name: "Lutynia Osiedle", distance: 663}],
    19118: [
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 779},
        {type: OfferPoiType.TRAM, name: "Głęboka 02", distance: 799},
        {type: OfferPoiType.BUS, name: "Głęboka 01", distance: 816},
        {type: OfferPoiType.TRAM, name: "Głęboka 01", distance: 831},
        {type: OfferPoiType.BUS, name: "Głęboka 91", distance: 839},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 929},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1063},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1108},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1445}
    ],
    19128: [
        {type: OfferPoiType.BUS, name: "Siemianice 02", distance: 204},
        {type: OfferPoiType.BUS, name: "Siemianice 01", distance: 210},
        {type: OfferPoiType.BUS, name: "Siemianice - Słupska N/Ż 01", distance: 304},
        {type: OfferPoiType.BUS, name: "Siemianice - Słupska N/Ż 02", distance: 353},
        {type: OfferPoiType.BUS, name: "Siemianice - Miejska 02", distance: 396},
        {type: OfferPoiType.BUS, name: "Siemianice - Miejska 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Siemianice - Spacerowa 02", distance: 602},
        {type: OfferPoiType.KOLEJ, name: "Siemianice", distance: 650},
        {type: OfferPoiType.BUS, name: "Siemianice - Agrestowa 01", distance: 799},
        {type: OfferPoiType.BUS, name: "Siemianice - Agrestowa 02", distance: 805},
        {type: OfferPoiType.PARK, name: "Park pod brzozami", distance: 1123}
    ],
    19133: [
        {type: OfferPoiType.BUS, name: "Bursztynowa-Szpital 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Bursztynowa-Szpital 01", distance: 515},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 02", distance: 649},
        {type: OfferPoiType.BUS, name: "Bielszowicka 02", distance: 681},
        {type: OfferPoiType.BUS, name: "Bielszowicka 01", distance: 706},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 01", distance: 720},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 04", distance: 751},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 03", distance: 782},
        {type: OfferPoiType.BUS, name: "Wawer-Ratusz 02", distance: 825}
    ],
    19136: [
        {type: OfferPoiType.BUS, name: "Załęże Pośpiecha", distance: 369},
        {type: OfferPoiType.TRAM, name: "Załęże Pośpiecha", distance: 370},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 417},
        {type: OfferPoiType.BUS, name: "Dąb Huta Baildon", distance: 463},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 582},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna", distance: 583},
        {type: OfferPoiType.TRAM, name: "Załęże Kościół", distance: 602},
        {type: OfferPoiType.BUS, name: "Załęże Kościół", distance: 604},
        {type: OfferPoiType.TRAM, name: "Dąb Huta Baildon", distance: 672},
        {type: OfferPoiType.BUS, name: "Katowice Dąbrówki", distance: 694},
        {type: OfferPoiType.BUS, name: "Katowice Stęślickiego", distance: 801},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1032},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 1419},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1420},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1467},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1619}
    ],
    19139: [
        {type: OfferPoiType.BUS, name: "Gęsia 02", distance: 772},
        {type: OfferPoiType.BUS, name: "Gęsia 01", distance: 791},
        {type: OfferPoiType.LAS, name: "Jarugi", distance: 1205},
        {type: OfferPoiType.PARK, name: "Park Weglin", distance: 1762}
    ],
    19143: [
        {type: OfferPoiType.BUS, name: "Piecewska", distance: 120},
        {type: OfferPoiType.TRAM, name: "Warneńska 01", distance: 162},
        {type: OfferPoiType.BUS, name: "Warneńska 04", distance: 173},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 191},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 191},
        {type: OfferPoiType.TRAM, name: "Warneńska 02", distance: 209},
        {type: OfferPoiType.BUS, name: "Belgradzka 03", distance: 237},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 347},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 361},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 361},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 366},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 368},
        {type: OfferPoiType.BUS, name: "Belgradzka 04", distance: 368},
        {type: OfferPoiType.BUS, name: "Dobrowolskiego 02", distance: 431},
        {type: OfferPoiType.BUS, name: "Dobrowolskiego 01", distance: 464},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 528},
        {type: OfferPoiType.TRAM, name: "Budapesztańska", distance: 562},
        {type: OfferPoiType.BUS, name: "Budapesztańska", distance: 576},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 707},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 740},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 1706},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1708},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1846},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2479}
    ],
    19145: [
        {type: OfferPoiType.BUS, name: "Gniewkowska 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Sympatyczna 03", distance: 346},
        {type: OfferPoiType.BUS, name: "Sympatyczna 02", distance: 430},
        {type: OfferPoiType.BUS, name: "Gniewkowska 52", distance: 449},
        {type: OfferPoiType.BUS, name: "Sympatyczna 01", distance: 462},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 705},
        {type: OfferPoiType.BUS, name: "Sympatyczna 04", distance: 711},
        {type: OfferPoiType.BUS, name: "Wałowicka 03", distance: 767},
        {type: OfferPoiType.BUS, name: "Płużańska 02", distance: 826},
        {type: OfferPoiType.BUS, name: "PKP Włochy 03", distance: 833},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 1026},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 1101},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 1530},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1808},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 2368}
    ],
    19156: [
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 729},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 990},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1126},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1214},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 1407},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1490},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2219},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2331}
    ],
    19157: [
        {type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 472},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 643},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 752}
    ],
    19161: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 302},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 343},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 746},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 757},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 773},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1775}
    ],
    19172: [
        {type: OfferPoiType.BUS, name: "Chłodnia 01", distance: 279},
        {type: OfferPoiType.BUS, name: "Chłodnia 02", distance: 446},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Toruńska", distance: 584},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 03", distance: 650},
        {type: OfferPoiType.BUS, name: "Pelcowizna 01", distance: 666},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 04", distance: 682},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 02", distance: 719},
        {type: OfferPoiType.BUS, name: "Pelcowizna 02", distance: 737},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 01", distance: 740},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 04", distance: 779},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 02", distance: 788},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 1217},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1774},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1802},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2089}
    ],
    19173: [
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 311},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 481},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Dębogórze-Wybudowanie - Długa 01", distance: 753},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 788},
        {type: OfferPoiType.BUS, name: "Dębogórze - Wybudowanie - Długa 04", distance: 824},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1290},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1337},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2186}
    ],
    19175: [
        {type: OfferPoiType.BUS, name: "Drwęcka 01", distance: 341},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 582},
        {type: OfferPoiType.BUS, name: "Świtezianki 02", distance: 591},
        {type: OfferPoiType.BUS, name: "Odrzańska 04", distance: 675},
        {type: OfferPoiType.BUS, name: "Chałubińskiego", distance: 676},
        {type: OfferPoiType.TRAM, name: "Odrzańska", distance: 704},
        {type: OfferPoiType.TRAM, name: "Ciasna", distance: 737},
        {type: OfferPoiType.BUS, name: "Odrzańska", distance: 740},
        {type: OfferPoiType.TRAM, name: "Zakopiańska", distance: 759},
        {type: OfferPoiType.BUS, name: "Zakopiańska", distance: 764},
        {type: OfferPoiType.BUS, name: "Domeyki 01", distance: 776},
        {type: OfferPoiType.TRAM, name: "Chałubińskiego", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1204},
        {type: OfferPoiType.PARK, name: "Skwer im. Ignacego Wilczewskiego", distance: 1242},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Bema", distance: 1468},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1847},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1963},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2415}
    ],
    19179: [
        {type: OfferPoiType.BUS, name: "Kopernika/Bema", distance: 286},
        {type: OfferPoiType.BUS, name: "Kopernika/Osiedle Bema", distance: 303},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Bema NŻ", distance: 360},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Kaczorowskiego", distance: 381},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Młynowa", distance: 421},
        {type: OfferPoiType.BUS, name: "Kopernika/Kaczorowskiego", distance: 426},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Wyszyńskiego", distance: 465},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Waszyngtona", distance: 520},
        {type: OfferPoiType.BUS, name: "Wiejska/Kopernika", distance: 569},
        {type: OfferPoiType.BUS, name: "Kopernika/Depowa NŻ", distance: 574},
        {type: OfferPoiType.PARK, name: "Skwer Zenona Andrzeja Młyńczyka", distance: 1134},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1236},
        {type: OfferPoiType.PARK, name: "Park im. Jadwigi Dziekońskiej", distance: 1755},
        {type: OfferPoiType.PARK, name: "Skwer Lecha i Marii Kaczyńskich - Prezydenta Rzeczypospolitej Polskiej z Małżonką", distance: 1793},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1811},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Zwierzyniecki", distance: 2200}
    ],
    19180: [
        {type: OfferPoiType.BUS, name: "Suszki", distance: 211},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 553},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 583},
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 724},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 758},
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1292},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1404},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1601},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 1893},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2082},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2370},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2417},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2481}
    ],
    19182: [
        {type: OfferPoiType.BUS, name: "Osiedle Kopernika", distance: 306},
        {type: OfferPoiType.BUS, name: "Cieszyńska Hulanka", distance: 592},
        {type: OfferPoiType.BUS, name: "Stawowa", distance: 761},
        {type: OfferPoiType.PARK, name: "Skwer Marzeń", distance: 963}
    ],
    19183: [
        {type: OfferPoiType.BUS, name: "Błonie Nowakowskiego", distance: 300},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 418},
        {type: OfferPoiType.BUS, name: "Błonie Narutowicza", distance: 482},
        {type: OfferPoiType.BUS, name: "Błonie Piłsudskiego Przedszkole", distance: 526},
        {type: OfferPoiType.BUS, name: "Błonie Okrzei", distance: 551},
        {type: OfferPoiType.BUS, name: "Błonie Polna", distance: 625},
        {type: OfferPoiType.BUS, name: "Błonie Sochaczewska", distance: 679},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 867},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 991}
    ],
    19184: [
        {type: OfferPoiType.BUS, name: "Wiatraczna 16", distance: 290},
        {type: OfferPoiType.BUS, name: "Wiatraczna 14", distance: 292},
        {type: OfferPoiType.BUS, name: "Wiatraczna 02", distance: 351},
        {type: OfferPoiType.BUS, name: "Wiatraczna 17", distance: 360},
        {type: OfferPoiType.BUS, name: "Wiatraczna 15", distance: 363},
        {type: OfferPoiType.BUS, name: "Wiatraczna 23", distance: 367},
        {type: OfferPoiType.BUS, name: "Wiatraczna 22", distance: 395},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 13", distance: 427},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 12", distance: 434},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 06", distance: 435},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 11", distance: 435},
        {type: OfferPoiType.BUS, name: "Wiatraczna 10", distance: 436},
        {type: OfferPoiType.TRAM, name: "Czapelska 01", distance: 447},
        {type: OfferPoiType.TRAM, name: "Czapelska 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Wiatraczna 09", distance: 509},
        {type: OfferPoiType.BUS, name: "Wiatraczna 03", distance: 527},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 07", distance: 537},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 04", distance: 559},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 05", distance: 608},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 04", distance: 609},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 870},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 908},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1171},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1366}
    ],
    19186: [
        {type: OfferPoiType.BUS, name: "Kiełpino, Cyprysowa", distance: 280},
        {type: OfferPoiType.BUS, name: "Kiełpino, Podlaska", distance: 453},
        {type: OfferPoiType.BUS, name: "Kiełpino, Piaskowa", distance: 750}
    ],
    19187: [
        {type: OfferPoiType.BUS, name: "Orlinki 02", distance: 429},
        {type: OfferPoiType.BUS, name: "Kwiatowa 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Kwiatowa 02", distance: 459},
        {type: OfferPoiType.BUS, name: "Orlinki 01", distance: 464},
        {type: OfferPoiType.LAS, name: "Las Mierzei", distance: 1053}
    ],
    19189: [
        {type: OfferPoiType.KOLEJ, name: "Iwiny", distance: 566},
        {type: OfferPoiType.BUS, name: "Jagodno (P+R)", distance: 616},
        {type: OfferPoiType.BUS, name: "Kopycińskiego", distance: 727},
        {type: OfferPoiType.BUS, name: "Jagodzińska", distance: 808},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 1791},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2138},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 2256}
    ],
    19190: [{type: OfferPoiType.BUS, name: "Siechnice – Kalinowa", distance: 344}],
    19191: [
        {type: OfferPoiType.BUS, name: "Iwiny – pętla", distance: 735},
        {type: OfferPoiType.BUS, name: "Iwiny – Słoneczna", distance: 769},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1538},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1905}
    ],
    19201: [
        {type: OfferPoiType.BUS, name: "Słonimska/Urząd Miejski", distance: 370},
        {type: OfferPoiType.BUS, name: "Piasta/Skorupska", distance: 484},
        {type: OfferPoiType.BUS, name: "Piasta", distance: 494},
        {type: OfferPoiType.BUS, name: "Towarowa/Pętla", distance: 679},
        {type: OfferPoiType.BUS, name: "Towarowa/Dworzec Fabryczny", distance: 717},
        {type: OfferPoiType.BUS, name: "Pałacowa/Hotel", distance: 745},
        {type: OfferPoiType.BUS, name: "Towarowa/Daleka", distance: 748},
        {type: OfferPoiType.BUS, name: "Mieszka I/Szkoła", distance: 774},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Aleksandra Chodyki", distance: 957},
        {type: OfferPoiType.PARK, name: "Skwer Armii Krajowej", distance: 980},
        {type: OfferPoiType.PARK, name: "Park Stary im. Księcia Józefa Poniatowskiego", distance: 1051},
        {type: OfferPoiType.PARK, name: "Bulwary Ireny Sendlerowej", distance: 1084},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Stanisława Hałko", distance: 1141},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1202},
        {type: OfferPoiType.PARK, name: "Skwer im. doc. Włodzimierza Zankiewicza", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Branickich", distance: 1377},
        {type: OfferPoiType.PARK, name: "Park Planty", distance: 1540},
        {type: OfferPoiType.PARK, name: "Skwer Wygoda", distance: 1543}
    ],
    19212: [
        {type: OfferPoiType.BUS, name: "Osiedle Limba 01", distance: 749},
        {type: OfferPoiType.BUS, name: "Osiedle Limba 02", distance: 813},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Stawy Raszyńskie", distance: 2313}
    ],
    19213: [
        {type: OfferPoiType.BUS, name: "Rząska Autostrada", distance: 703},
        {type: OfferPoiType.BUS, name: "Rząska Szkoła", distance: 746},
        {type: OfferPoiType.PARK, name: "Park Topólki", distance: 2507},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko w Rząsce", distance: 2515}
    ],
    19219: [
        {type: OfferPoiType.BUS, name: "Gliwice Komag", distance: 236},
        {type: OfferPoiType.BUS, name: "Gliwice Kujawska", distance: 486},
        {type: OfferPoiType.BUS, name: "Trynek Lotników", distance: 715},
        {type: OfferPoiType.BUS, name: "Gliwice Łużycka", distance: 736},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 750},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Rydet", distance: 758},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Lewczyńskiego", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 911},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny", distance: 1056}
    ],
    19221: [
        {type: OfferPoiType.BUS, name: "Augustówek 01", distance: 734},
        {type: OfferPoiType.BUS, name: "Augustówek 02", distance: 735},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1744}
    ],
    19223: [
        {type: OfferPoiType.BUS, name: "Potockiego / Grafitowa 05", distance: 189},
        {type: OfferPoiType.BUS, name: "Potockiego / Grafitowa 08", distance: 239},
        {type: OfferPoiType.BUS, name: "Potockiego / Ametystowa 06", distance: 346},
        {type: OfferPoiType.BUS, name: "Potockiego / Ametystowa 03", distance: 385},
        {type: OfferPoiType.LAS, name: "Las Dębina", distance: 513},
        {type: OfferPoiType.BUS, name: "Potockiego pętla 10", distance: 778},
        {type: OfferPoiType.BUS, name: "Potockiego / Nefrytowa 01", distance: 835}
    ],
    19226: [{type: OfferPoiType.PARK, name: "Active Park w Zalasewie", distance: 1944}],
    19227: [
        {type: OfferPoiType.BUS, name: "Gen. Maczka 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 04", distance: 573},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 03", distance: 606},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 04", distance: 610},
        {type: OfferPoiType.BUS, name: "Park Olszyna 06", distance: 613},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 01", distance: 648},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 03", distance: 701},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 02", distance: 735},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 04", distance: 757},
        {type: OfferPoiType.BUS, name: "Park Olszyna 02", distance: 760},
        {type: OfferPoiType.BUS, name: "Włościańska 01", distance: 802},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 970},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1360},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1455},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1456},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 1803},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1840},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1896},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 1941}
    ],
    19233: [
        {type: OfferPoiType.BUS, name: "Dobra 02", distance: 7},
        {type: OfferPoiType.BUS, name: "Dobra 01", distance: 65},
        {type: OfferPoiType.BUS, name: "Wróbla 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Wróbla 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 620},
        {type: OfferPoiType.BUS, name: "Zagony", distance: 628},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 628},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 01", distance: 647},
        {type: OfferPoiType.TRAM, name: "Chmielna 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Brama Nizinna", distance: 729},
        {type: OfferPoiType.TRAM, name: "Chmielna 02", distance: 736},
        {type: OfferPoiType.TRAM, name: "Akademia Muzyczna", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 837},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 980},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1267},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1367},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2457}
    ],
    19234: [
        {type: OfferPoiType.BUS, name: "Maratońska - Dw. Łódź Retkinia", distance: 161},
        {type: OfferPoiType.BUS, name: "Retkińska - Dw. Łódź Retkinia", distance: 200},
        {type: OfferPoiType.BUS, name: "Armii Krajowej - Batalionów Chłopskich", distance: 259},
        {type: OfferPoiType.KOLEJ, name: "Łódź Retkinia", distance: 368},
        {type: OfferPoiType.BUS, name: "Retkińska - Zagrodniki", distance: 477},
        {type: OfferPoiType.BUS, name: "Maratońska (wew.) - Plocka", distance: 563},
        {type: OfferPoiType.BUS, name: "Maratońska - Obywatelska", distance: 588},
        {type: OfferPoiType.BUS, name: "Maratońska - Plocka", distance: 591},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego - Armii Krajowej", distance: 780},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1713},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 1844},
        {type: OfferPoiType.PARK, name: "Łódzkie Błonia", distance: 2063},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2332}
    ],
    19238: [
        {type: OfferPoiType.BUS, name: "Cukrowa", distance: 87},
        {type: OfferPoiType.BUS, name: "Radomska", distance: 406},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego", distance: 524},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Gumieńce", distance: 603},
        {type: OfferPoiType.BUS, name: "Południowa", distance: 682},
        {type: OfferPoiType.BUS, name: "Cukrowa Uniwersytet", distance: 720},
        {type: OfferPoiType.PARK, name: "park imienia Sprawiedliwych wśród Narodów Świata", distance: 2080}
    ],
    19239: [
        {type: OfferPoiType.BUS, name: "Mulicka", distance: 366},
        {type: OfferPoiType.BUS, name: "Gorlicka", distance: 427},
        {type: OfferPoiType.BUS, name: "Psie Pole (Rondo Lotników Polskich)", distance: 520},
        {type: OfferPoiType.BUS, name: "Psie Pole (Gorlicka)", distance: 572},
        {type: OfferPoiType.BUS, name: "Psie Pole", distance: 611},
        {type: OfferPoiType.BUS, name: "Zielna", distance: 624},
        {type: OfferPoiType.PARK, name: "Park Jedności", distance: 2494}
    ],
    19240: [
        {type: OfferPoiType.BUS, name: "Szatonia #", distance: 343},
        {type: OfferPoiType.PARK, name: "korty tenisowe bratoszewskiego", distance: 1323},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2327}
    ],
    19247: [
        {type: OfferPoiType.BUS, name: "Złocień 03", distance: 372},
        {type: OfferPoiType.BUS, name: "Złocień 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Agatowa 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Złocień 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Agatowa 01", distance: 485},
        {type: OfferPoiType.KOLEJ, name: "Kraków Złocień", distance: 744},
        {type: OfferPoiType.PARK, name: "Park Złocień", distance: 806}
    ],
    19249: [
        {type: OfferPoiType.BUS, name: "Kwidzyn Łużycka", distance: 155},
        {type: OfferPoiType.BUS, name: "Kwidzyn Łużycka Połomskiego", distance: 363},
        {type: OfferPoiType.BUS, name: "Kwidzyn Południowa", distance: 364},
        {type: OfferPoiType.BUS, name: "Kwidzyn Toruńska", distance: 498},
        {type: OfferPoiType.BUS, name: "Kwidzyn Hallera Szpital", distance: 584},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Kosacza", distance: 821},
        {type: OfferPoiType.PARK, name: "Plac Plebiscytowy", distance: 1510},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Płażyńskiego", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer Kombatantów", distance: 2076}
    ],
    19253: [
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 257},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 288},
        {type: OfferPoiType.BUS, name: "Kierbedzia 01", distance: 381},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 04", distance: 397},
        {type: OfferPoiType.BUS, name: "Hańczy 01", distance: 397},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 433},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 481},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 03", distance: 516},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 05", distance: 528},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 02", distance: 541},
        {type: OfferPoiType.BUS, name: "Tor Stegny 02", distance: 554},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 01", distance: 658},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 02", distance: 700},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 863},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1385},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1499},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1546},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1550},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1737},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1794},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1977},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 2007},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 2061},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2094},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2308}
    ],
    19254: [
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 18", distance: 202},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 17", distance: 227},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 16", distance: 231},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 12", distance: 240},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 02", distance: 255},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 15", distance: 257},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 14", distance: 272},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 13", distance: 281},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 11", distance: 284},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 10", distance: 289},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 05", distance: 295},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 307},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 06", distance: 315},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 72", distance: 372},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 71", distance: 373},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 04", distance: 712},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 712},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 03", distance: 758},
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 920},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1160},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1304},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1455},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1856},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2198}
    ],
    19256: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 201},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 768}
    ],
    19257: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 222},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 591},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 669}
    ],
    19258: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 202},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 649}
    ],
    19262: [
        {type: OfferPoiType.BUS, name: "Bora Komorowskiego 01", distance: 139},
        {type: OfferPoiType.BUS, name: "Konieczki-pętla 02", distance: 294},
        {type: OfferPoiType.PARK, name: "Park Ireny Tamary Misztal", distance: 342},
        {type: OfferPoiType.BUS, name: "Piwnika Ponurego 02", distance: 343},
        {type: OfferPoiType.BUS, name: "Kolonia - Nowe Miasto 02", distance: 461},
        {type: OfferPoiType.BUS, name: "Kolonia - Park 03", distance: 471},
        {type: OfferPoiType.BUS, name: "Piwnika Ponurego 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Kolonia - szkoła 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Kolonia - szkoła 01", distance: 596},
        {type: OfferPoiType.BUS, name: "Dobrzańskiego 02", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Odkrywców Kolei", distance: 2061},
        {type: OfferPoiType.REZERWAT, name: "Wyspa lęgowa", distance: 2212},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 2452}
    ],
    19263: [
        {type: OfferPoiType.BUS, name: "Litworowy Staw ul. Środkowa 63", distance: 251},
        {type: OfferPoiType.BUS, name: 'Sklep "Gama"', distance: 369},
        {type: OfferPoiType.BUS, name: "Białka Tatrzańska Korkoszówka", distance: 459},
        {type: OfferPoiType.BUS, name: "u Rafała i Joanny", distance: 495},
        {type: OfferPoiType.BUS, name: "Białka Tatrzańska Środkowa", distance: 572},
        {type: OfferPoiType.BUS, name: "u Chramca", distance: 821}
    ],
    19269: [
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 291},
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 407},
        {type: OfferPoiType.BUS, name: "Czermińskiego 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Przywidzka 03", distance: 795},
        {type: OfferPoiType.BUS, name: "Przywidzka 01", distance: 834},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1447}
    ],
    19271: [
        {type: OfferPoiType.BUS, name: "Chorzów Wodociągi", distance: 7},
        {type: OfferPoiType.TRAM, name: "Chorzów Wodociągi", distance: 69},
        {type: OfferPoiType.BUS, name: "Chorzów Styczyńskiego", distance: 273},
        {type: OfferPoiType.PARK, name: "Park Amelung", distance: 304},
        {type: OfferPoiType.TRAM, name: "Chorzów Styczyńskiego", distance: 381},
        {type: OfferPoiType.TRAM, name: "Chorzów Szarlociniec", distance: 397},
        {type: OfferPoiType.BUS, name: "Chorzów Składowa", distance: 478},
        {type: OfferPoiType.BUS, name: "Chorzów Amelung", distance: 586},
        {type: OfferPoiType.BUS, name: "Chorzów Miarki", distance: 677},
        {type: OfferPoiType.TRAM, name: "Chorzów Pokoju", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Heiloo", distance: 1368},
        {type: OfferPoiType.PARK, name: "Park Skałka", distance: 1713},
        {type: OfferPoiType.REZERWAT, name: "Staw Foryśka", distance: 1971},
        {type: OfferPoiType.PARK, name: "Park Chropaczowski imieniem Kopalni Śląsk", distance: 2062}
    ],
    19277: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1671},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Rawąskiego", distance: 2348}
    ],
    19280: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 151},
        {type: OfferPoiType.BUS, name: "Żeligowskiego - Pl. Hallera", distance: 195},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 241},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Hallera", distance: 338},
        {type: OfferPoiType.BUS, name: "Żeligowskiego - Struga", distance: 379},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Żeligowskiego", distance: 471},
        {type: OfferPoiType.BUS, name: "Struga - Żeligowskiego", distance: 480},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 503},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 565},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 565},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 756},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 824},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 892},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 1030}
    ],
    19284: [
        {type: OfferPoiType.BUS, name: "Wilkasy ul. Olsztyńska Niegocin", distance: 519},
        {type: OfferPoiType.KOLEJ, name: "Wilkasy Niegocin", distance: 637},
        {type: OfferPoiType.BUS, name: "Łuczanka", distance: 716},
        {type: OfferPoiType.REZERWAT, name: "Wilkasy", distance: 1531}
    ],
    19288: [
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 182},
        {type: OfferPoiType.BUS, name: "Bolesława Śmiałego 02", distance: 376},
        {type: OfferPoiType.BUS, name: "Bolesława Krzywoustego 02", distance: 423},
        {type: OfferPoiType.BUS, name: "Przemysława II 02", distance: 510},
        {type: OfferPoiType.BUS, name: "Królowej Bony 01", distance: 544},
        {type: OfferPoiType.BUS, name: "Królowej Bony 02", distance: 560},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 567},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 592},
        {type: OfferPoiType.BUS, name: "Czerwona Droga 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Henryka Probusa 01", distance: 706},
        {type: OfferPoiType.BUS, name: "Śmigielska 02", distance: 722},
        {type: OfferPoiType.BUS, name: "Czerwona Droga 02", distance: 801},
        {type: OfferPoiType.BUS, name: "Władysława Hermana 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1086},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1113},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1208}
    ],
    19300: [
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 383},
        {type: OfferPoiType.BUS, name: "Mazowiecka 02", distance: 388},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 503},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 02", distance: 524},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 534},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Dokerów", distance: 565},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 03", distance: 573},
        {type: OfferPoiType.BUS, name: "Ormińskiego 02", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2378}
    ],
    19304: [
        {type: OfferPoiType.BUS, name: "Jastrzębia Góra", distance: 409},
        {type: OfferPoiType.BUS, name: "Jastrzębia Góra, centrum", distance: 472},
        {type: OfferPoiType.BUS, name: "Tupadły, Wiejska", distance: 751}
    ],
    19305: [
        {type: OfferPoiType.BUS, name: "Dolnobrzeska", distance: 289},
        {type: OfferPoiType.BUS, name: "Owczarska", distance: 589},
        {type: OfferPoiType.BUS, name: "Grzybowa", distance: 696},
        {type: OfferPoiType.BUS, name: "Krępicka – szkoła", distance: 837},
        {type: OfferPoiType.PARK, name: "Park Leśnicki", distance: 1669},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Kobla", distance: 1674}
    ],
    19308: [
        {type: OfferPoiType.BUS, name: "Solidarności / Tysiąclecia PP", distance: 274},
        {type: OfferPoiType.BUS, name: "Tysiąclecia PP / Wiejska", distance: 463},
        {type: OfferPoiType.BUS, name: "Galeria Echo", distance: 535},
        {type: OfferPoiType.BUS, name: "Tysiąclecia Państwa Polskiego", distance: 624},
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 700},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 750},
        {type: OfferPoiType.BUS, name: "Górna", distance: 827},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1094},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1515},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1564},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1575},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1616},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 1646},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 1688},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1689}
    ],
    19309: [
        {type: OfferPoiType.BUS, name: "Solidarności / Tysiąclecia PP", distance: 283},
        {type: OfferPoiType.BUS, name: "Tysiąclecia PP / Wiejska", distance: 472},
        {type: OfferPoiType.BUS, name: "Galeria Echo", distance: 544},
        {type: OfferPoiType.BUS, name: "Tysiąclecia Państwa Polskiego", distance: 633},
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 709},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 759},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1524},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1584},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1625},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 1655},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 1697},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1698}
    ],
    19310: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 179},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 376},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 393},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 452},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Ujeścisko 04", distance: 658},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 01", distance: 667},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 03", distance: 685},
        {type: OfferPoiType.BUS, name: "Ujeścisko 05", distance: 693},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 02", distance: 693},
        {type: OfferPoiType.BUS, name: "Ujeścisko 06", distance: 696},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Nowosądecka 01", distance: 777},
        {type: OfferPoiType.BUS, name: "Nowosądecka 02", distance: 785},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1869},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1944},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2432}
    ],
    19325: [
        {type: OfferPoiType.BUS, name: "Talarowa 01", distance: 357},
        {type: OfferPoiType.BUS, name: "Talarowa 02", distance: 372},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 502},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 02", distance: 556},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 01", distance: 667},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 1618},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 1628},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 2083}
    ],
    19328: [
        {type: OfferPoiType.BUS, name: "Gazowa", distance: 505},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 548},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 567},
        {type: OfferPoiType.BUS, name: "Tarnogaj", distance: 582},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 672},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 672},
        {type: OfferPoiType.TRAM, name: "Tarnogaj", distance: 781},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 822},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1886},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2180}
    ],
    19338: [
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 08", distance: 401},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 07", distance: 499},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 03", distance: 500},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 06", distance: 593},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 05", distance: 622},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 02", distance: 679},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 686},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 03", distance: 727},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ursus Północny", distance: 756},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 04", distance: 765},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 02", distance: 775},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1137},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 1249},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1510},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1587}
    ],
    19339: [
        {type: OfferPoiType.BUS, name: "Gąsocińska 02", distance: 359},
        {type: OfferPoiType.BUS, name: "Siekierkowska 02", distance: 363},
        {type: OfferPoiType.BUS, name: "Siekierkowska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 03", distance: 401},
        {type: OfferPoiType.BUS, name: "Gąsocińska 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 01", distance: 515},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Ananasowa 52", distance: 688},
        {type: OfferPoiType.BUS, name: "Łososiowa 02", distance: 752},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 760},
        {type: OfferPoiType.PARK, name: "Park Akcji „Burza”", distance: 2398},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 2441}
    ],
    19343: [
        {type: OfferPoiType.BUS, name: "Filtrowa / Grunwaldzka", distance: 334},
        {type: OfferPoiType.BUS, name: "Czyżkówko", distance: 354},
        {type: OfferPoiType.BUS, name: "Wiejska / Krajeńska", distance: 360},
        {type: OfferPoiType.BUS, name: "Krajeńska / Wiejska", distance: 366},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Filtrowa", distance: 431},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Chojnicka", distance: 475},
        {type: OfferPoiType.BUS, name: "Czyżkówko [końcowy]", distance: 502},
        {type: OfferPoiType.BUS, name: "Orlicza / Nad Torem", distance: 747},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Zachód", distance: 772},
        {type: OfferPoiType.PARK, name: "Park przy papierni", distance: 1207},
        {type: OfferPoiType.PARK, name: "Park nad Kanałem Bydgoskim", distance: 1443},
        {type: OfferPoiType.REZERWAT, name: "Stacja uzdatniania wody “Czyżkówko”", distance: 2359}
    ],
    19344: [
        {type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 360},
        {type: OfferPoiType.BUS, name: "Starogardzka 04", distance: 600},
        {type: OfferPoiType.BUS, name: "Starogardzka 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 02", distance: 673}
    ],
    19345: [
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 171},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 177},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 405},
        {type: OfferPoiType.BUS, name: "EC Siekierki 03", distance: 414},
        {type: OfferPoiType.BUS, name: "EC Siekierki 04", distance: 418},
        {type: OfferPoiType.BUS, name: "EC Siekierki 05", distance: 423},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 437},
        {type: OfferPoiType.BUS, name: "EC Siekierki 01", distance: 489},
        {type: OfferPoiType.BUS, name: "EC Siekierki 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 720},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1973},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1996},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2130}
    ],
    19346: [
        {type: OfferPoiType.BUS, name: "Krzeptów - Boisko", distance: 461},
        {type: OfferPoiType.BUS, name: "Krzeptów - pętla", distance: 488},
        {type: OfferPoiType.BUS, name: "Krzeptów - skrzy.", distance: 846}
    ],
    19352: [
        {type: OfferPoiType.PARK, name: "Park Mirabelka", distance: 56},
        {type: OfferPoiType.BUS, name: "Ustronna - Świecka NŻ", distance: 172},
        {type: OfferPoiType.BUS, name: "Ustronna - Przednia NŻ", distance: 378},
        {type: OfferPoiType.PARK, name: "Park im. Zofii Garlickiej", distance: 391},
        {type: OfferPoiType.BUS, name: "Matek Polskich - Przednia", distance: 436},
        {type: OfferPoiType.BUS, name: "Instytut CZMP", distance: 572},
        {type: OfferPoiType.BUS, name: "Siostrzana - Bartoszewskiego", distance: 578},
        {type: OfferPoiType.BUS, name: "Matek Polskich - Sczanieckiej", distance: 592},
        {type: OfferPoiType.BUS, name: "Ustronna - Zagadkowa NŻ", distance: 606},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 1440},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 2246},
        {type: OfferPoiType.PARK, name: "Park Zatorze", distance: 2339},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2508}
    ],
    19353: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 117},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 220},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 297},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 326},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 351},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 365},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 519},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 522},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 522},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 713},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 729},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 865},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 924},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 925},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 1165},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1183}
    ],
    19354: [
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 403},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka", distance: 585},
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 586},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Srebrzyńska", distance: 614},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 614},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 642},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka NŻ", distance: 696},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 764},
        {type: OfferPoiType.BUS, name: "Legionów - Żeligowskiego", distance: 824},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1054},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 1189},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 1195},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 1273},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 1525},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1537},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1785},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 2362},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2409}
    ],
    19357: [{type: OfferPoiType.LAS, name: "Jankowski las", distance: 1076}],
    19361: [
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 01", distance: 58},
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 02", distance: 192},
        {type: OfferPoiType.BUS, name: "Wojciechowska 05", distance: 249},
        {type: OfferPoiType.BUS, name: "Wojciechowska 03", distance: 338},
        {type: OfferPoiType.BUS, name: "Wojciechowska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Wojciechowska 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Cisowa 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Wojciechowska - zespół szkół 01", distance: 461},
        {type: OfferPoiType.BUS, name: "Cisowa 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Nałęczowska 01", distance: 596}
    ],
    19373: [
        {type: OfferPoiType.BUS, name: "Struga - Piotrkowska", distance: 113},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 190},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 321},
        {type: OfferPoiType.BUS, name: "Tuwima - Sienkiewicza", distance: 322},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 322},
        {type: OfferPoiType.BUS, name: "Struga - Kościuszki", distance: 324},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 329},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 359},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Tuwima", distance: 379},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 433},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Park Sienkiewicza", distance: 525},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 533},
        {type: OfferPoiType.BUS, name: "Zamenhofa - Piotrkowska", distance: 535},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 543},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 557},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Zamenhofa", distance: 578},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 582},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 647},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 674},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 787},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 868}
    ],
    19380: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 407},
        {type: OfferPoiType.TRAM, name: "Armii Krajowej", distance: 457},
        {type: OfferPoiType.BUS, name: "Park Wschodni", distance: 538},
        {type: OfferPoiType.TRAM, name: "Park Wschodni", distance: 587},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 588},
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 631},
        {type: OfferPoiType.LAS, name: "Las Rakowiecki", distance: 716},
        {type: OfferPoiType.BUS, name: "Międzyrzecka", distance: 770},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 789},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1275},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1827},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 2134}
    ],
    19384: [
        {type: OfferPoiType.BUS, name: "Wola Duchacka 03", distance: 327},
        {type: OfferPoiType.BUS, name: "Karpińskiego 02", distance: 330},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 380},
        {type: OfferPoiType.BUS, name: "Pszenna 01", distance: 518},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 04", distance: 547},
        {type: OfferPoiType.BUS, name: "Pszenna 02", distance: 581},
        {type: OfferPoiType.BUS, name: "Malborska Szkoła 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Nowosądecka 03", distance: 615},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 03", distance: 647},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 02", distance: 693},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 01", distance: 729},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 733},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1341},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1435}
    ],
    19385: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Wschód 02", distance: 250},
        {type: OfferPoiType.BUS, name: "Jabłonna 02", distance: 277},
        {type: OfferPoiType.BUS, name: "Jabłonna 01", distance: 284},
        {type: OfferPoiType.BUS, name: "Bociana 04", distance: 421},
        {type: OfferPoiType.TRAM, name: "Bociana 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Zawodzie 02", distance: 486},
        {type: OfferPoiType.BUS, name: "Bociana 03", distance: 496},
        {type: OfferPoiType.TRAM, name: "Bociana 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Aleja 29 Listopada Wiadukt 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Zawodzie 01", distance: 578},
        {type: OfferPoiType.BUS, name: "Zawodzie 04", distance: 624},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 664},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 692},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 04", distance: 760},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1485},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 1520},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1526},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 1537},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1665}
    ],
    19391: [
        {type: OfferPoiType.BUS, name: "Osiedle Bukowy Dworek 02", distance: 188},
        {type: OfferPoiType.BUS, name: "Osiedle Bukowy Dworek 01", distance: 259},
        {type: OfferPoiType.BUS, name: "Milenijna 52", distance: 624},
        {type: OfferPoiType.BUS, name: "Dworkowa 02", distance: 697}
    ],
    19393: [{type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 827}],
    19394: [
        {type: OfferPoiType.BUS, name: "Mańkowska 01", distance: 274},
        {type: OfferPoiType.BUS, name: "Mańkowska 02", distance: 336},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 343},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 532},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 598},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 604},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 633},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 673},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Tymotki 02", distance: 762}
    ],
    19395: [{type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 399}],
    19397: [
        {type: OfferPoiType.BUS, name: "Sokola 01", distance: 683},
        {type: OfferPoiType.BUS, name: "Partyzantów-Szkoła 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Partyzantów-Szkoła 52", distance: 804},
        {type: OfferPoiType.BUS, name: "Partyzantów-Szkoła 02", distance: 820},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Grabicz", distance: 1009},
        {type: OfferPoiType.PARK, name: "Park im. Bohdana Wodiczki", distance: 2025},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 2129},
        {type: OfferPoiType.PARK, name: "Park Wiktoryn", distance: 2162},
        {type: OfferPoiType.PARK, name: "Skwer Pawła Seweryna Rozbickiego", distance: 2387}
    ],
    19400: [
        {type: OfferPoiType.BUS, name: "Moniuszki 01", distance: 102},
        {type: OfferPoiType.BUS, name: "Al. Wojska Polskiego 06", distance: 294},
        {type: OfferPoiType.BUS, name: "Al. Wojska Polskiego 05", distance: 389},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 400},
        {type: OfferPoiType.BUS, name: "Al. Wojska Polskiego 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Powstańców", distance: 490},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 535},
        {type: OfferPoiType.BUS, name: "Ołówkowa 03", distance: 541},
        {type: OfferPoiType.BUS, name: "Ceramiczna 01", distance: 583},
        {type: OfferPoiType.BUS, name: "Kubusia Puchatka 01", distance: 607},
        {type: OfferPoiType.BUS, name: "Ołówkowa 04", distance: 610},
        {type: OfferPoiType.BUS, name: "Pałacyk Sokoła 01", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1282},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1350},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 1573},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 2282}
    ],
    19405: [
        {type: OfferPoiType.BUS, name: "Obrońców Poczty Gdańskiej", distance: 201},
        {type: OfferPoiType.BUS, name: "Kołakowskiego", distance: 255},
        {type: OfferPoiType.BUS, name: "Wawrzynowicza", distance: 548},
        {type: OfferPoiType.BUS, name: "Tysiąclecie - Szpital 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Tysiąclecie - Szpital 02", distance: 685},
        {type: OfferPoiType.BUS, name: "Obrońców Westerplatte", distance: 734},
        {type: OfferPoiType.PARK, name: "Skwer przy PCK", distance: 883},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 1202},
        {type: OfferPoiType.PARK, name: "Park im. Tysiąclecia", distance: 1287},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny Jędrusik", distance: 1660},
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 1823},
        {type: OfferPoiType.PARK, name: "Spacerniak", distance: 1885},
        {type: OfferPoiType.PARK, name: "Skwer osiedlowy przy ulicy Księżycowej", distance: 1928}
    ],
    19421: [
        {type: OfferPoiType.TRAM, name: "Nowosądecka 02", distance: 327},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 01", distance: 363},
        {type: OfferPoiType.BUS, name: "Nowosądecka 04", distance: 374},
        {type: OfferPoiType.BUS, name: "Nowosądecka 03", distance: 426},
        {type: OfferPoiType.BUS, name: "Tuchowska 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Nowosądecka 05", distance: 437},
        {type: OfferPoiType.BUS, name: "Tuchowska 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Bojki 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Bojki 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Karpińskiego 02", distance: 663},
        {type: OfferPoiType.BUS, name: "Piaski Nowe", distance: 721},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 763},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 842},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 1403},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1749},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2321}
    ],
    19426: [
        {type: OfferPoiType.BUS, name: "Bronisin - Paprociowa NŻ", distance: 523},
        {type: OfferPoiType.BUS, name: "600-lecia miasta Łodzi - Bronisin", distance: 642},
        {type: OfferPoiType.BUS, name: "Brójecka - Paprociowa NŻ", distance: 645},
        {type: OfferPoiType.BUS, name: "Bronisin - 600-lecia miasta Łodzi NŻ", distance: 828},
        {type: OfferPoiType.PARK, name: "Park Jana Gibusa", distance: 2259},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2514}
    ],
    19428: [
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 302},
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 465},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 576},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 596},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 770},
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 808},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1416}
    ],
    19432: [
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 789},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 884},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1421},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1680},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2390}
    ],
    19433: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 437},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 464},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 498},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 784},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1132},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1656},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1777}
    ],
    19435: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 340},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 401},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 687},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 691},
        {type: OfferPoiType.BUS, name: "Bazyliańska 04", distance: 831},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1035},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1559},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1680}
    ],
    19437: [
        {type: OfferPoiType.BUS, name: "Rozłogi 02", distance: 145},
        {type: OfferPoiType.BUS, name: "Stogi 01", distance: 282},
        {type: OfferPoiType.BUS, name: "Kłosowa 01", distance: 393},
        {type: OfferPoiType.BUS, name: "Stogi 02", distance: 397},
        {type: OfferPoiType.BUS, name: "Stogi 06", distance: 408},
        {type: OfferPoiType.BUS, name: "Zimna", distance: 671}
    ],
    19439: [
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Szobera 02", distance: 239},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 345},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 03", distance: 560},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 04", distance: 606},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 637},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 15", distance: 637},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 02", distance: 640},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 14", distance: 645},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 13", distance: 651},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 12", distance: 658},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 11", distance: 664},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 779}
    ],
    19440: [
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 182},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 186},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 240},
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 302},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 01", distance: 384},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 02", distance: 391},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 660},
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 706},
        {type: OfferPoiType.BUS, name: "Człuchowska 02", distance: 769},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 796},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 890}
    ],
    19441: [
        {type: OfferPoiType.BUS, name: "Pirenejska 02", distance: 250},
        {type: OfferPoiType.BUS, name: "Radiowa 02", distance: 310},
        {type: OfferPoiType.BUS, name: "Pirenejska 01", distance: 329},
        {type: OfferPoiType.TRAM, name: "Radiowa 06", distance: 355},
        {type: OfferPoiType.TRAM, name: "Radiowa 07", distance: 365},
        {type: OfferPoiType.BUS, name: "Radiowa 03", distance: 387},
        {type: OfferPoiType.BUS, name: "Radiowa 04", distance: 404},
        {type: OfferPoiType.TRAM, name: "Radiowa 05", distance: 415},
        {type: OfferPoiType.BUS, name: "Wrocławska 04", distance: 432},
        {type: OfferPoiType.BUS, name: "Radiowa 01", distance: 434},
        {type: OfferPoiType.TRAM, name: "Wrocławska 06", distance: 437},
        {type: OfferPoiType.BUS, name: "Wrocławska 02", distance: 459},
        {type: OfferPoiType.TRAM, name: "Wrocławska 05", distance: 509},
        {type: OfferPoiType.BUS, name: "Wrocławska 03", distance: 550},
        {type: OfferPoiType.BUS, name: "Wrocławska 01", distance: 571},
        {type: OfferPoiType.TRAM, name: "Orlich Gniazd 05", distance: 830},
        {type: OfferPoiType.PARK, name: "Park im. Księcia Janusza", distance: 2371},
        {type: OfferPoiType.PARK, name: "Park Ulricha", distance: 2494}
    ],
    19442: [
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 576},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 610},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 617},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 627},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 699},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2070}
    ],
    19443: [
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 02", distance: 161},
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 01", distance: 242},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 528},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 633},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 723},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 771},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 817},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 840}
    ],
    19445: [
        {type: OfferPoiType.BUS, name: "Skłodowskiej", distance: 511},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (Szpital)", distance: 709},
        {type: OfferPoiType.PARK, name: "Skwer Lecha Kaczyńskiego Prezydenta Rzeczypospolitej Polskiej", distance: 730},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (DPS)", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Klenczona", distance: 1369},
        {type: OfferPoiType.REZERWAT, name: 'Użytek Ekologiczny "Mała Biel"', distance: 1391},
        {type: OfferPoiType.REZERWAT, name: "Mała Biel", distance: 1413}
    ],
    19447: [
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 559},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 1334},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 1378},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 1431},
        {type: OfferPoiType.PARK, name: "Skwer Edwarda Woyniłłowicza", distance: 1568},
        {type: OfferPoiType.PARK, name: "Skwer Mikołaja Kopernika", distance: 1586},
        {type: OfferPoiType.PARK, name: "Skwer im. ppor. Leszka Białego", distance: 1743},
        {type: OfferPoiType.PARK, name: "Skwer im. Mariana Turwida", distance: 1745},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 1747}
    ],
    19451: [{type: OfferPoiType.BUS, name: "Ustronie Morskie - szkoła", distance: 484}],
    19452: [
        {type: OfferPoiType.BUS, name: "Rewal", distance: 153},
        {type: OfferPoiType.KOLEJ, name: "Rewal", distance: 819}
    ],
    19453: [
        {type: OfferPoiType.BUS, name: "Kostuchna Skrzyżowanie", distance: 252},
        {type: OfferPoiType.BUS, name: "Kostuchna Fińskie Domki", distance: 295},
        {type: OfferPoiType.PARK, name: "Skwer Michała Banasika", distance: 301},
        {type: OfferPoiType.BUS, name: "Piotrowice Cmentarz", distance: 762},
        {type: OfferPoiType.BUS, name: "Kostuchna Szarych Szeregów", distance: 781},
        {type: OfferPoiType.PARK, name: "Skwer 2 Pułku Pszczyńskiego", distance: 856},
        {type: OfferPoiType.PARK, name: "Park Malownik", distance: 1876},
        {type: OfferPoiType.PARK, name: "Plac Filipa Limańskiego", distance: 2020},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat przyrody "Ochojec"', distance: 2345}
    ],
    19459: [
        {type: OfferPoiType.BUS, name: "Bożeny n/ż", distance: 179},
        {type: OfferPoiType.PARK, name: "Park Rodziny Stablewskich", distance: 1084}
    ],
    19460: [
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Mochnaniec 02", distance: 758},
        {type: OfferPoiType.BUS, name: "Piltza 04", distance: 784},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 796},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1117},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2327},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2388}
    ],
    19461: [
        {type: OfferPoiType.BUS, name: "Sikorki 01", distance: 66},
        {type: OfferPoiType.BUS, name: "Sikorki 02", distance: 103},
        {type: OfferPoiType.BUS, name: "Na Załęczu 01", distance: 266},
        {type: OfferPoiType.BUS, name: "Na Załęczu 04", distance: 315},
        {type: OfferPoiType.BUS, name: "Na Załęczu 02", distance: 355},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 02", distance: 399},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 01", distance: 576},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 02", distance: 608},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 1076},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1519},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1825},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1897},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 2005},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2381},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2424},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 2432}
    ],
    19462: [
        {type: OfferPoiType.BUS, name: "Nowy Bieżanów P+R 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Nowy Bieżanów P+R 03", distance: 212},
        {type: OfferPoiType.BUS, name: "Nowy Bieżanów P+R 04", distance: 220},
        {type: OfferPoiType.BUS, name: "przystanek tymczasowy", distance: 236},
        {type: OfferPoiType.TRAM, name: "Nowy Bieżanów P+R 01", distance: 248},
        {type: OfferPoiType.TRAM, name: "Nowy Bieżanów P+R", distance: 256},
        {type: OfferPoiType.BUS, name: "Bieżanów Szkoła 04", distance: 353},
        {type: OfferPoiType.BUS, name: "Korepty 02", distance: 397},
        {type: OfferPoiType.BUS, name: "Madejówka 02", distance: 422},
        {type: OfferPoiType.TRAM, name: "Ćwiklińskiej 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Ćwiklińskiej 04", distance: 443},
        {type: OfferPoiType.BUS, name: "Korepty 01", distance: 453},
        {type: OfferPoiType.BUS, name: "Bieżanów Szkoła 02", distance: 467},
        {type: OfferPoiType.TRAM, name: "Ćwiklińskiej 01", distance: 517},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1270},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 1302},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1888},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1890},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1948},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 2357}
    ],
    19463: [
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego", distance: 83},
        {type: OfferPoiType.TRAM, name: "Wierzbięcice", distance: 265},
        {type: OfferPoiType.BUS, name: "Św. Czesława", distance: 291},
        {type: OfferPoiType.TRAM, name: "Św. Czesława", distance: 291},
        {type: OfferPoiType.BUS, name: "Poznań Główny", distance: 409},
        {type: OfferPoiType.BUS, name: "Bergera", distance: 540},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 582},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 644},
        {type: OfferPoiType.TRAM, name: "Półwiejska", distance: 661},
        {type: OfferPoiType.TRAM, name: "Różana", distance: 678},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 817},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 961},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 974},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1060},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1382},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1418},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1529},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1564}
    ],
    19473: [
        {type: OfferPoiType.BUS, name: "Sarmacka 01", distance: 311},
        {type: OfferPoiType.BUS, name: "Sarmacka 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Vogla 05", distance: 556},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 03", distance: 585},
        {type: OfferPoiType.BUS, name: "Vogla 04", distance: 671},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 10", distance: 713},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 05", distance: 715},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 04", distance: 721},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 02", distance: 721},
        {type: OfferPoiType.BUS, name: "Vogla 01", distance: 723},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 06", distance: 750},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 08", distance: 751},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 71", distance: 797},
        {type: OfferPoiType.BUS, name: "Vogla 02", distance: 802},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 72", distance: 802},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 983},
        {type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 2478}
    ],
    19474: [
        {type: OfferPoiType.PARK, name: "Wilcze Doły", distance: 1127},
        {type: OfferPoiType.PARK, name: "Skwer Kežmarok", distance: 1684},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1736}
    ],
    19475: [
        {type: OfferPoiType.BUS, name: "Wrony 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Wrony 01", distance: 509},
        {type: OfferPoiType.BUS, name: "Wrony 03", distance: 546},
        {type: OfferPoiType.REZERWAT, name: "Dąbrowa", distance: 2360}
    ],
    19478: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 02", distance: 380},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 04", distance: 437},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 03", distance: 510},
        {type: OfferPoiType.BUS, name: "Glogera 71", distance: 712},
        {type: OfferPoiType.BUS, name: "Glogera 72", distance: 730},
        {type: OfferPoiType.BUS, name: "Zielonki Słoneczna", distance: 783},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2162},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 2214},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2515}
    ],
    19483: [
        {type: OfferPoiType.BUS, name: "Poznańska", distance: 194},
        {type: OfferPoiType.BUS, name: "Witomińska", distance: 253},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 10", distance: 277},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 04", distance: 313},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 06", distance: 324},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej", distance: 373},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 02", distance: 402},
        {type: OfferPoiType.PARK, name: "Gdyński Park Kieszonkowy", distance: 504},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Wzgórze Świętego Maksymiliana", distance: 515},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 579},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 900},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 905},
        {type: OfferPoiType.PARK, name: "Park Marii i Lecha Kaczyńskich", distance: 1376}
    ],
    19484: [
        {type: OfferPoiType.BUS, name: "Szklarniowa 02", distance: 527},
        {type: OfferPoiType.BUS, name: "Szklarniowa 01", distance: 620},
        {type: OfferPoiType.PARK, name: "Park im. Mariana Jonkajtysa", distance: 2120},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci", distance: 2341},
        {type: OfferPoiType.PARK, name: "Skwer im. Żołnierzy Wyklętych", distance: 2488}
    ],
    19495: [
        {type: OfferPoiType.BUS, name: "Skalskiego 01", distance: 338},
        {type: OfferPoiType.BUS, name: "Skalskiego 02", distance: 396},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 673},
        {type: OfferPoiType.BUS, name: "Instytut Agrofizyki 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Instytut Agrofizyki 02", distance: 699},
        {type: OfferPoiType.BUS, name: "Felin 03", distance: 792},
        {type: OfferPoiType.BUS, name: "Felin 01", distance: 793}
    ],
    19496: [
        {type: OfferPoiType.BUS, name: "Zelwerowicza 03", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 2517}
    ],
    19497: [
        {type: OfferPoiType.BUS, name: "Walendów Ogrody", distance: 76},
        {type: OfferPoiType.BUS, name: "Kajetany Brzozowa", distance: 590},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 01", distance: 779},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 02", distance: 835}
    ],
    19499: [
        {type: OfferPoiType.BUS, name: "Poświęcka", distance: 255},
        {type: OfferPoiType.BUS, name: "Poświęcka (Ośrodek zdrowia)", distance: 419},
        {type: OfferPoiType.BUS, name: "Żmigrodzka (Obwodnica)", distance: 693},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 765},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 783},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1860}
    ],
    19501: [
        {type: OfferPoiType.BUS, name: "Kakaowa 01", distance: 329},
        {type: OfferPoiType.BUS, name: "Błędna 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Zamienie 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Bakaliowa 01", distance: 652}
    ],
    19514: [
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – PKP", distance: 102},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – skrzyżowanie", distance: 161},
        {type: OfferPoiType.BUS, name: "Bielany Stacja Kolejowa", distance: 243},
        {type: OfferPoiType.KOLEJ, name: "Bielany Wrocławskie", distance: 386},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – Kościół", distance: 475},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – Boczna", distance: 562},
        {type: OfferPoiType.BUS, name: "Ślęza – skrzyżowanie", distance: 832}
    ],
    19519: [
        {type: OfferPoiType.BUS, name: "Warszawska / os. Słoneczne Wzgórze", distance: 189},
        {type: OfferPoiType.BUS, name: "Warszawska / os. Szydłówek", distance: 230},
        {type: OfferPoiType.BUS, name: "Warszawska / os. Uroczysko", distance: 276},
        {type: OfferPoiType.BUS, name: "Warszawska / os. Bocianek", distance: 541},
        {type: OfferPoiType.BUS, name: "Warszawska / Jaworskiego", distance: 599},
        {type: OfferPoiType.BUS, name: "Klonowa / Turystyczna", distance: 676},
        {type: OfferPoiType.BUS, name: "Orkana / os. Związkowiec", distance: 718},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 905},
        {type: OfferPoiType.PARK, name: "Park Kielczan 2019", distance: 915},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1028},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 1886},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2182}
    ],
    19524: [
        {type: OfferPoiType.BUS, name: "Szybka 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Szybka 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Instalatorów 03", distance: 721},
        {type: OfferPoiType.BUS, name: "Instalatorów 01", distance: 769},
        {type: OfferPoiType.BUS, name: "Instalatorów 02", distance: 774},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 1872},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2182}
    ],
    19525: [
        {type: OfferPoiType.BUS, name: "Sportowa / Bloki (03)", distance: 253},
        {type: OfferPoiType.BUS, name: "Walerego Romana / PNT (01)", distance: 329},
        {type: OfferPoiType.BUS, name: "Sportowa (02)", distance: 342},
        {type: OfferPoiType.BUS, name: "Walerego Romana (02)", distance: 433},
        {type: OfferPoiType.PARK, name: "Park Konstytucji 3 Maja", distance: 2317}
    ],
    19532: [
        {type: OfferPoiType.TRAM, name: "Dajwór 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Dajwór 01", distance: 224},
        {type: OfferPoiType.TRAM, name: "Muzeum Inżynierii Miejskiej", distance: 288},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 01", distance: 302},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 02", distance: 347},
        {type: OfferPoiType.TRAM, name: "Miodowa 02", distance: 370},
        {type: OfferPoiType.TRAM, name: "Miodowa 01", distance: 433},
        {type: OfferPoiType.PARK, name: "Skwer Kółeczko", distance: 491},
        {type: OfferPoiType.TRAM, name: "Stradom 04", distance: 574},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 02", distance: 597},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 01", distance: 615},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 626},
        {type: OfferPoiType.BUS, name: "Stradom 05", distance: 673},
        {type: OfferPoiType.TRAM, name: "Stradom 01", distance: 704},
        {type: OfferPoiType.BUS, name: "Stradom 06", distance: 714},
        {type: OfferPoiType.BUS, name: "Stradom 02", distance: 745},
        {type: OfferPoiType.BUS, name: "Stradom 08", distance: 758},
        {type: OfferPoiType.BUS, name: "Starowiślna 07", distance: 795},
        {type: OfferPoiType.BUS, name: "Plac Bohaterów Getta", distance: 834},
        {type: OfferPoiType.PARK, name: "Ogrody Zgromadzenia Księży Misjonarzy w Krakowie", distance: 884},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 927},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1103}
    ],
    19534: [{type: OfferPoiType.BUS, name: "Ogonki", distance: 115}],
    19535: [
        {type: OfferPoiType.BUS, name: "Radiowa 02", distance: 1},
        {type: OfferPoiType.TRAM, name: "Radiowa 06", distance: 115},
        {type: OfferPoiType.TRAM, name: "Radiowa 07", distance: 141},
        {type: OfferPoiType.BUS, name: "Radiowa 03", distance: 163},
        {type: OfferPoiType.BUS, name: "Radiowa 04", distance: 164},
        {type: OfferPoiType.TRAM, name: "Radiowa 05", distance: 177},
        {type: OfferPoiType.BUS, name: "Radiowa 01", distance: 193},
        {type: OfferPoiType.BUS, name: "Pirenejska 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Dywizjonu 303 02", distance: 568},
        {type: OfferPoiType.BUS, name: "Orlich Gniazd 02", distance: 583},
        {type: OfferPoiType.BUS, name: "Pirenejska 01", distance: 592},
        {type: OfferPoiType.TRAM, name: "Orlich Gniazd 05", distance: 674},
        {type: OfferPoiType.TRAM, name: "Dywizjonu 303 04", distance: 678},
        {type: OfferPoiType.BUS, name: "Radiowa-WAT 02", distance: 704},
        {type: OfferPoiType.TRAM, name: "Orlich Gniazd 06", distance: 707},
        {type: OfferPoiType.BUS, name: "Wrocławska 02", distance: 722},
        {type: OfferPoiType.TRAM, name: "Dywizjonu 303 03", distance: 730},
        {type: OfferPoiType.TRAM, name: "Wrocławska 06", distance: 750},
        {type: OfferPoiType.TRAM, name: "Siodlarska 02", distance: 794},
        {type: OfferPoiType.TRAM, name: "Dywizjonu 303 05", distance: 798},
        {type: OfferPoiType.PARK, name: "Park im. Księcia Janusza", distance: 2314},
        {type: OfferPoiType.PARK, name: "Park Ulricha", distance: 2338}
    ],
    19537: [
        {type: OfferPoiType.BUS, name: "Objazdowa", distance: 477},
        {type: OfferPoiType.BUS, name: "Łąkoszyńska/bloki", distance: 557},
        {type: OfferPoiType.BUS, name: "Łąkoszyńska/pętla", distance: 621},
        {type: OfferPoiType.BUS, name: "Łąkoszyńska/Łódzka", distance: 652},
        {type: OfferPoiType.PARK, name: "Teren kościoła św. Stanisława Biskupa i Męczennika", distance: 1367},
        {type: OfferPoiType.PARK, name: "Park nad Ochnią", distance: 2222},
        {type: OfferPoiType.PARK, name: "Skwer Druhny Harcmistrzyni Pelagii Ładykowskiej-Zys", distance: 2364}
    ],
    19538: [
        {type: OfferPoiType.BUS, name: "Szamotuły, ul. Dworcowa", distance: 406},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 497},
        {type: OfferPoiType.BUS, name: "Szamotuły ul. Wojska Polskiego", distance: 539},
        {type: OfferPoiType.BUS, name: "Szamotuły Poczta", distance: 759},
        {type: OfferPoiType.PARK, name: "Skwer im. Maksymiliana Ciężkiego", distance: 796},
        {type: OfferPoiType.PARK, name: "Park Jana III Sobieskiego", distance: 1145},
        {type: OfferPoiType.PARK, name: "Ogródek Jordanowski", distance: 1467},
        {type: OfferPoiType.PARK, name: "Park Henryka Sienkiewicza", distance: 1575},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park im. Zofii i Michała Mycielskich", distance: 1906}
    ],
    19539: [
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 527},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 565}
    ],
    19540: [
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 02", distance: 292},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 316},
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 01", distance: 335},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 02", distance: 432},
        {type: OfferPoiType.BUS, name: "Czerwiakowskiego 02", distance: 523},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 04", distance: 553},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 01", distance: 562},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 01", distance: 623},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 639},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 06", distance: 646},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 02", distance: 658},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1276},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1371},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 1389},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1575}
    ],
    19541: [
        {type: OfferPoiType.BUS, name: "Laurowa 01", distance: 326},
        {type: OfferPoiType.BUS, name: "Laurowa 02", distance: 364},
        {type: OfferPoiType.BUS, name: "Kasztanowa 01", distance: 418},
        {type: OfferPoiType.BUS, name: "Kasztanowa 02", distance: 479},
        {type: OfferPoiType.BUS, name: "Dorodna 02", distance: 599},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 750},
        {type: OfferPoiType.BUS, name: "Portowa 02", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 1787},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 2008}
    ],
    19542: [
        {type: OfferPoiType.BUS, name: "Osiedle Limba 02", distance: 191},
        {type: OfferPoiType.BUS, name: "Osiedle Limba 01", distance: 258},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Stawy Raszyńskie", distance: 2444}
    ],
    19544: [
        {type: OfferPoiType.BUS, name: "Biegasa", distance: 260},
        {type: OfferPoiType.BUS, name: "Chełmońskiego", distance: 524},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 597},
        {type: OfferPoiType.BUS, name: "Tramwajowa", distance: 701},
        {type: OfferPoiType.TRAM, name: "Chełmońskiego", distance: 726},
        {type: OfferPoiType.TRAM, name: "Tramwajowa", distance: 738},
        {type: OfferPoiType.BUS, name: "Dembowskiego (Kosiby)", distance: 833},
        {type: OfferPoiType.LAS, name: "Park Dąbski", distance: 1060},
        {type: OfferPoiType.PARK, name: "Park Dąbski", distance: 1060},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1613},
        {type: OfferPoiType.PARK, name: "skwer Zbyszka Cybulskiego", distance: 1621},
        {type: OfferPoiType.PARK, name: "skwer Hanny Hirszfeldowej", distance: 1798},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1995}
    ],
    19548: [
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 01", distance: 633},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 02", distance: 675},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 795},
        {type: OfferPoiType.BUS, name: "Targ Rybny 01", distance: 829},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 876},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 911},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 1104},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1219},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1916},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2028},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 2386}
    ],
    19549: [
        {type: OfferPoiType.BUS, name: "ks. Meiera 01", distance: 635},
        {type: OfferPoiType.BUS, name: "ks. Meiera 04", distance: 657},
        {type: OfferPoiType.BUS, name: "ks. Meiera 02", distance: 662},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2020},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 2178}
    ],
    19561: [
        {type: OfferPoiType.BUS, name: "Krzepicka", distance: 635},
        {type: OfferPoiType.BUS, name: "Rudnicze", distance: 798},
        {type: OfferPoiType.TRAM, name: "Junikowo", distance: 817},
        {type: OfferPoiType.BUS, name: "Junikowo", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 1703}
    ],
    19564: [
        {type: OfferPoiType.BUS, name: "Niepodległości 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Niepodległości 02", distance: 581},
        {type: OfferPoiType.BUS, name: "Kossaka 01", distance: 602},
        {type: OfferPoiType.BUS, name: "Kossaka 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Robotnicza 02", distance: 666},
        {type: OfferPoiType.BUS, name: "Robotnicza 01", distance: 740},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1672}
    ],
    19567: [
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 318},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 408},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 497},
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 539},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 795},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 917},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 957},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2171}
    ],
    19568: [
        {type: OfferPoiType.BUS, name: "Cmentarz Poprzeczna", distance: 244},
        {type: OfferPoiType.BUS, name: "Cicha", distance: 260},
        {type: OfferPoiType.BUS, name: "Wrocławska", distance: 515},
        {type: OfferPoiType.BUS, name: "Reymonta", distance: 586},
        {type: OfferPoiType.BUS, name: "Poprzeczna", distance: 606},
        {type: OfferPoiType.BUS, name: "Szewczenki", distance: 698},
        {type: OfferPoiType.PARK, name: "Górka Jasia", distance: 722},
        {type: OfferPoiType.KOLEJ, name: "Olsztyn Główny", distance: 741},
        {type: OfferPoiType.PARK, name: "Za Torami Pod Lipami", distance: 882},
        {type: OfferPoiType.PARK, name: "Park przy Rataja", distance: 1438},
        {type: OfferPoiType.PARK, name: "Park Jakubowo", distance: 1804}
    ],
    19569: [
        {type: OfferPoiType.BUS, name: "Kresowa", distance: 360},
        {type: OfferPoiType.BUS, name: "Widłakowa n/ż", distance: 439},
        {type: OfferPoiType.BUS, name: "UAM Os. Różany Potok", distance: 586},
        {type: OfferPoiType.BUS, name: "Rumiankowa n/ż", distance: 697},
        {type: OfferPoiType.BUS, name: "UAM Wydział Geografii", distance: 701},
        {type: OfferPoiType.PARK, name: "Demonstracyjny ogród klimatyczny", distance: 901},
        {type: OfferPoiType.PARK, name: "Skwer Poznańskiego Towarzystwa Przyjaciół Nauk", distance: 1388},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2483}
    ],
    19572: [
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 01 n/ż", distance: 455},
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 02 n/ż", distance: 473},
        {type: OfferPoiType.BUS, name: 'C.H. "Port Rumia" - Kosynierów 02', distance: 681},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 2337}
    ],
    19573: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer Jana Pawła II", distance: 1968},
        {type: OfferPoiType.PARK, name: "Planty Zamkowe", distance: 1991},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu", distance: 2236},
        {type: OfferPoiType.PARK, name: "Skwer imienia księcia Henryka I Brodatego", distance: 2242}
    ],
    19577: [
        {type: OfferPoiType.BUS, name: "Gazowa", distance: 440},
        {type: OfferPoiType.BUS, name: "Tarnogaj", distance: 520},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 793},
        {type: OfferPoiType.TRAM, name: "Tarnogaj", distance: 799},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 812},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 917},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 917},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2131},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2425}
    ],
    19579: [
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 376},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 406},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 428},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 458},
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 469},
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 704},
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 705},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1296},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1509},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1822},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1974},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2070},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2075},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2181},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2309}
    ],
    19580: [
        {type: OfferPoiType.BUS, name: "Saska 02", distance: 384},
        {type: OfferPoiType.BUS, name: "Saska 03", distance: 476},
        {type: OfferPoiType.BUS, name: "Saska 05", distance: 483},
        {type: OfferPoiType.BUS, name: "Saska 07", distance: 507},
        {type: OfferPoiType.BUS, name: "Saska 04", distance: 511},
        {type: OfferPoiType.BUS, name: "Saska 01", distance: 544},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 553},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 596},
        {type: OfferPoiType.BUS, name: "Stoczniowców 01", distance: 598},
        {type: OfferPoiType.BUS, name: "Koszykarska 03", distance: 623},
        {type: OfferPoiType.BUS, name: "Stoczniowców 03", distance: 660},
        {type: OfferPoiType.BUS, name: "Koszykarska 01", distance: 727},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1462},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1655},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 1834},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 1863},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1884}
    ],
    19586: [
        {type: OfferPoiType.BUS, name: "Wieliczka Modrzewiowa", distance: 362},
        {type: OfferPoiType.BUS, name: "Krzyszkowice Kasztanowa II", distance: 543},
        {type: OfferPoiType.REZERWAT, name: "Las Krzyszkowicki", distance: 1437},
        {type: OfferPoiType.PARK, name: "Park Świętej Barbary", distance: 1960},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2255}
    ],
    19588: [
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 113},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 118},
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Chyliczki 01", distance: 716},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 735},
        {type: OfferPoiType.BUS, name: "Chyliczki 02", distance: 813}
    ],
    19590: [
        {type: OfferPoiType.BUS, name: "Rondo Toruńskie", distance: 159},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 218},
        {type: OfferPoiType.BUS, name: "Toruńska / Hala", distance: 294},
        {type: OfferPoiType.TRAM, name: "Toruńska / Hala", distance: 335},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 557},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 591},
        {type: OfferPoiType.BUS, name: "Toruńska / Żupy", distance: 603},
        {type: OfferPoiType.TRAM, name: "Toruńska / Żupy", distance: 719},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 1000},
        {type: OfferPoiType.PARK, name: "Bulwar im. Leona Janty-Połczyńskiego", distance: 1066},
        {type: OfferPoiType.PARK, name: "Park Kotwicy", distance: 1162},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1226}
    ],
    19595: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 515},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 541},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 814},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2223},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2507}
    ],
    19596: [
        {type: OfferPoiType.BUS, name: "Krakowska / Ceramiczna 12", distance: 795},
        {type: OfferPoiType.BUS, name: "Krakowska / Ustrzycka 11", distance: 838},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 2424},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 2450}
    ],
    19597: [
        {type: OfferPoiType.BUS, name: "Aleja Jana Pawła II 01", distance: 129},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 04", distance: 307},
        {type: OfferPoiType.BUS, name: "Aleja Jana Pawła II 02", distance: 323},
        {type: OfferPoiType.BUS, name: "Rondo ONZ 02", distance: 340},
        {type: OfferPoiType.BUS, name: "Hala Mirowska 02", distance: 386},
        {type: OfferPoiType.PARK, name: "Park Mirowski", distance: 410},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 03", distance: 435},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 01", distance: 450},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 04", distance: 458},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 477},
        {type: OfferPoiType.BUS, name: "Mennica 01", distance: 497},
        {type: OfferPoiType.METRO, name: "Rondo ONZ", distance: 497},
        {type: OfferPoiType.TRAM, name: "Hala Mirowska 04", distance: 532},
        {type: OfferPoiType.BUS, name: "Hala Mirowska 01", distance: 539},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 08", distance: 550},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 03", distance: 579},
        {type: OfferPoiType.TRAM, name: "Hala Mirowska 03", distance: 592},
        {type: OfferPoiType.TRAM, name: "Królewska 05", distance: 666},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 675},
        {type: OfferPoiType.TRAM, name: "Królewska 06", distance: 716},
        {type: OfferPoiType.TRAM, name: "Norblin 03", distance: 796},
        {type: OfferPoiType.TRAM, name: "Norblin 04", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Świętokrzyski", distance: 847},
        {type: OfferPoiType.PARK, name: "Ogród Saski", distance: 993},
        {type: OfferPoiType.PARK, name: "Skwer Duśki Trafankowskiej", distance: 1015},
        {type: OfferPoiType.PARK, name: "Ogród Zamoyskich", distance: 1110},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 2155}
    ],
    19602: [
        {type: OfferPoiType.BUS, name: "Łukowska 01", distance: 374},
        {type: OfferPoiType.BUS, name: "Gdecka 01", distance: 399},
        {type: OfferPoiType.BUS, name: "Wspólna Droga 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Gdecka 02", distance: 429},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Łukowska 04", distance: 457},
        {type: OfferPoiType.BUS, name: "Łukowska 02", distance: 467},
        {type: OfferPoiType.BUS, name: "Łukowska 03", distance: 490},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 491},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 03", distance: 510},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 04", distance: 538},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 04", distance: 574},
        {type: OfferPoiType.BUS, name: "Wspólna Droga 01", distance: 578},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 01", distance: 617},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 03", distance: 630},
        {type: OfferPoiType.TRAM, name: "Czapelska 01", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1338},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1346},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1502},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1905}
    ],
    19603: [
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 90},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 313},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 331},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 08", distance: 333},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 05", distance: 338},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 02", distance: 467},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 01", distance: 566},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 580},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 645},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Mieszka I 05", distance: 702},
        {type: OfferPoiType.BUS, name: "Św. Rocha szkoła 01", distance: 797},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 2046},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2382}
    ],
    19604: [
        {type: OfferPoiType.BUS, name: "Domaszowska / Poleska", distance: 352},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 375},
        {type: OfferPoiType.BUS, name: "Domaszowska / Żniwna", distance: 410},
        {type: OfferPoiType.BUS, name: "Poleska", distance: 451},
        {type: OfferPoiType.BUS, name: "Sandomierska / Śląska", distance: 466},
        {type: OfferPoiType.BUS, name: "Sandomierska", distance: 495},
        {type: OfferPoiType.BUS, name: "Żniwna / Domaszowska", distance: 572},
        {type: OfferPoiType.BUS, name: "Tysiąclecia PP / Wiejska", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1164},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1297},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1555},
        {type: OfferPoiType.PARK, name: "Skwer im. Mikołaja Kopernika", distance: 1586},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1656},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 1686},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1913},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Żeromskiego", distance: 1973}
    ],
    19605: [
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego", distance: 59},
        {type: OfferPoiType.BUS, name: "Leśny Dwór Pętla", distance: 270},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (DPS)", distance: 401},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (Szpital)", distance: 457},
        {type: OfferPoiType.PARK, name: "Skwer Lecha Kaczyńskiego Prezydenta Rzeczypospolitej Polskiej", distance: 1172},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Klenczona", distance: 1807},
        {type: OfferPoiType.REZERWAT, name: 'Użytek Ekologiczny "Mała Biel"', distance: 1830},
        {type: OfferPoiType.REZERWAT, name: "Mała Biel", distance: 1852}
    ],
    19607: [
        {type: OfferPoiType.BUS, name: "Widłakowa n/ż", distance: 438},
        {type: OfferPoiType.BUS, name: "Kresowa", distance: 626},
        {type: OfferPoiType.BUS, name: "UAM Os. Różany Potok", distance: 647},
        {type: OfferPoiType.BUS, name: "Rumiankowa n/ż", distance: 653},
        {type: OfferPoiType.BUS, name: "UAM Wydział Geografii", distance: 765},
        {type: OfferPoiType.PARK, name: "Demonstracyjny ogród klimatyczny", distance: 965},
        {type: OfferPoiType.PARK, name: "Skwer Poznańskiego Towarzystwa Przyjaciół Nauk", distance: 1316}
    ],
    19609: [
        {type: OfferPoiType.BUS, name: "Chełm - Więckowskiego 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Małomiejska", distance: 654},
        {type: OfferPoiType.BUS, name: "Chełm Witosa 01", distance: 680},
        {type: OfferPoiType.TRAM, name: "Chełm Witosa 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Chełm Witosa 02", distance: 718},
        {type: OfferPoiType.BUS, name: "Kopeckiego 02", distance: 730},
        {type: OfferPoiType.TRAM, name: "Chełm Witosa 02", distance: 752},
        {type: OfferPoiType.BUS, name: "Ptasia 02", distance: 803},
        {type: OfferPoiType.BUS, name: "Ptasia", distance: 807},
        {type: OfferPoiType.BUS, name: "Kopeckiego 01", distance: 811},
        {type: OfferPoiType.BUS, name: "Sikorskiego 04", distance: 819},
        {type: OfferPoiType.TRAM, name: "Sikorskiego", distance: 820},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1102},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1222},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Dolina Potoku Oruńskiego"', distance: 1721},
        {type: OfferPoiType.PARK, name: 'Skwer im. Danuty Siedzikówny "Inki"', distance: 1777},
        {type: OfferPoiType.PARK, name: "Park Schopenhauera", distance: 1844},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 1975},
        {type: OfferPoiType.PARK, name: "Park Oruński im. Emilii Hoene", distance: 2048}
    ],
    19613: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Augustów NŻ", distance: 244},
        {type: OfferPoiType.BUS, name: "Augustów - Bacewicz NŻ", distance: 448},
        {type: OfferPoiType.BUS, name: "Książąt Polskich - Zakładowa", distance: 663},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Czajkowskiego", distance: 734},
        {type: OfferPoiType.BUS, name: "Widzew Czajkowskiego", distance: 767},
        {type: OfferPoiType.BUS, name: "Zakładowa - Książąt Polskich", distance: 784},
        {type: OfferPoiType.BUS, name: "Augustów - Wujaka NŻ", distance: 817},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 852},
        {type: OfferPoiType.PARK, name: "Park na Janowie", distance: 1690},
        {type: OfferPoiType.PARK, name: "Park Źródła Olechówki", distance: 2030},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 2071},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 2272}
    ],
    19614: [
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 573},
        {type: OfferPoiType.BUS, name: "Kamykowa 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 643},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 768},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1327}
    ],
    19615: [
        {type: OfferPoiType.BUS, name: "Przebieg 01", distance: 131},
        {type: OfferPoiType.BUS, name: "Przebieg 02", distance: 267},
        {type: OfferPoiType.BUS, name: "Przebieg 52", distance: 270},
        {type: OfferPoiType.BUS, name: "Buławy 01", distance: 384},
        {type: OfferPoiType.BUS, name: "Gawędziarzy 51", distance: 423},
        {type: OfferPoiType.BUS, name: "Buławy 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Fiszera 52", distance: 501},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 08", distance: 543},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 06", distance: 637},
        {type: OfferPoiType.BUS, name: "Rembertów-Ratusz 02", distance: 671},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 2101}
    ],
    19616: [
        {type: OfferPoiType.BUS, name: "Podolszyn 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Nowy Podolszyn 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Nowy Podolszyn 02", distance: 792}
    ],
    19618: [
        {type: OfferPoiType.BUS, name: "Buków 04", distance: 261},
        {type: OfferPoiType.BUS, name: "Buków 02", distance: 351},
        {type: OfferPoiType.BUS, name: "Buków 01", distance: 412},
        {type: OfferPoiType.BUS, name: "Buków 03", distance: 426},
        {type: OfferPoiType.BUS, name: "Dębowa 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Główna 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Dębowa 02", distance: 769}
    ],
    19621: [
        {type: OfferPoiType.BUS, name: "Agatowa 02", distance: 220},
        {type: OfferPoiType.BUS, name: "Agatowa 01", distance: 255},
        {type: OfferPoiType.BUS, name: "Złocień 03", distance: 318},
        {type: OfferPoiType.BUS, name: "Złocień 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Złocień 02", distance: 433},
        {type: OfferPoiType.PARK, name: "Park Złocień", distance: 643},
        {type: OfferPoiType.BUS, name: "Magazynowa 01", distance: 806}
    ],
    19622: [
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 452},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 454},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 490},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 655},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 666},
        {type: OfferPoiType.BUS, name: "Człuchowska 04", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1316}
    ],
    19626: [
        {type: OfferPoiType.BUS, name: "Jeziorna", distance: 244},
        {type: OfferPoiType.LAS, name: "Leśny zakątek", distance: 478},
        {type: OfferPoiType.LAS, name: "Małpia Wyspa", distance: 1136}
    ],
    19627: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 82},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 108},
        {type: OfferPoiType.BUS, name: "Danusi 01", distance: 428},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Danusi 02", distance: 522},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 584},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 589},
        {type: OfferPoiType.BUS, name: "Przydrożna 01", distance: 670},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 699},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 715},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1516},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2185}
    ],
    19629: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 179},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 376},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 393},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 452},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Ujeścisko 04", distance: 658},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 01", distance: 667},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 03", distance: 685},
        {type: OfferPoiType.BUS, name: "Ujeścisko 05", distance: 693},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 02", distance: 693},
        {type: OfferPoiType.BUS, name: "Ujeścisko 06", distance: 696},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Nowosądecka 01", distance: 777},
        {type: OfferPoiType.BUS, name: "Nowosądecka 02", distance: 785},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1869},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1944},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2432}
    ],
    19633: [
        {type: OfferPoiType.BUS, name: "Łady 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Łady 02", distance: 413},
        {type: OfferPoiType.BUS, name: "Figowa 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Jutrzenki 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Jutrzenki 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Łady-Szkoła 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Nowy Podolszyn 02", distance: 829}
    ],
    19634: [
        {type: OfferPoiType.BUS, name: "Ludwinów 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Ludwinów 02", distance: 254},
        {type: OfferPoiType.BUS, name: "Os. Podwawelskie", distance: 420},
        {type: OfferPoiType.BUS, name: "Os. Podwawelskie 01", distance: 471},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 747},
        {type: OfferPoiType.BUS, name: "Rondo Grunwaldzkie 03", distance: 779},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 838},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 938},
        {type: OfferPoiType.PARK, name: "skwer Zdrowia", distance: 1086},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Magiczny", distance: 1172},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1511},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1514},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1532},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 1650},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2109},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2268}
    ],
    19636: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej 01", distance: 327},
        {type: OfferPoiType.BUS, name: "Armii Krajowej 02", distance: 374},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 02", distance: 735},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 01", distance: 793},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1448},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1454},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1555},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1686},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1807},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1865},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1924},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2011}
    ],
    19638: [
        {type: OfferPoiType.BUS, name: "Dębowa Góra Tabelna", distance: 118},
        {type: OfferPoiType.TRAM, name: "Dębowa Góra Tabelna", distance: 119},
        {type: OfferPoiType.TRAM, name: "Dańdówka Cmentarz", distance: 277},
        {type: OfferPoiType.BUS, name: "Dębowa Góra Zakopiańska", distance: 409},
        {type: OfferPoiType.BUS, name: "Dańdówka Cmentarz", distance: 420},
        {type: OfferPoiType.BUS, name: "Dębowa Góra Lipowa", distance: 564},
        {type: OfferPoiType.BUS, name: "Dańdówka Wiadukt", distance: 588},
        {type: OfferPoiType.TRAM, name: "Dębowa Góra Zakopiańska", distance: 618},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 1985},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 2085},
        {type: OfferPoiType.PARK, name: "Park Harcerski", distance: 2384}
    ],
    19643: [{type: OfferPoiType.BUS, name: "Łukaszew Zjazdowa", distance: 645}],
    19644: [
        {type: OfferPoiType.KOLEJ, name: "Iwiny", distance: 592},
        {type: OfferPoiType.BUS, name: "Vivaldiego", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2125},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2472}
    ],
    19645: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 489},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 529},
        {type: OfferPoiType.BUS, name: "Łopuszańska 03", distance: 550},
        {type: OfferPoiType.BUS, name: "WKD Raków 02", distance: 562},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 735},
        {type: OfferPoiType.BUS, name: "Łopuszańska 01", distance: 750},
        {type: OfferPoiType.BUS, name: "Łopuszańska 02", distance: 760},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 768},
        {type: OfferPoiType.BUS, name: "Łopuszańska 04", distance: 818},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1605}
    ],
    19646: [
        {type: OfferPoiType.BUS, name: "Szczeblewskiego 01", distance: 167},
        {type: OfferPoiType.BUS, name: "Zespół Szkół Budowlanych", distance: 209},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół", distance: 213},
        {type: OfferPoiType.BUS, name: "Szczeblewskiego 02", distance: 221},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół 01", distance: 234},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół 02", distance: 260},
        {type: OfferPoiType.BUS, name: "Cylkowskiego 02", distance: 410},
        {type: OfferPoiType.BUS, name: "Cylkowskiego", distance: 457},
        {type: OfferPoiType.BUS, name: "Cylkowskiego 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Korczaka 02", distance: 689},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kępa Redłowska", distance: 1221},
        {type: OfferPoiType.PARK, name: "Skwer Arki Gdynia", distance: 1344},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1510},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 1585}
    ],
    19652: [
        {type: OfferPoiType.BUS, name: "Kantorowice 01", distance: 423},
        {type: OfferPoiType.BUS, name: "Kantorowice 02", distance: 424},
        {type: OfferPoiType.BUS, name: "Kantorowice 04", distance: 507},
        {type: OfferPoiType.BUS, name: "Niebyła 01", distance: 751},
        {type: OfferPoiType.BUS, name: "Niebyła 02", distance: 767},
        {type: OfferPoiType.PARK, name: "Park Zielony Jar Wandy", distance: 1718},
        {type: OfferPoiType.PARK, name: "Park Zakole", distance: 1734}
    ],
    19653: [
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 01", distance: 131},
        {type: OfferPoiType.BUS, name: "Tarczyn Lidl/Biedronka 01", distance: 253},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 01", distance: 469},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 02", distance: 523},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1663}
    ],
    19654: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Okęcie", distance: 453},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 04", distance: 525},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 639},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1687},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 2345},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 2468}
    ],
    19656: [
        {type: OfferPoiType.BUS, name: "Górna", distance: 316},
        {type: OfferPoiType.BUS, name: "Taylora / Żniwna", distance: 353},
        {type: OfferPoiType.BUS, name: "Żniwna", distance: 382},
        {type: OfferPoiType.BUS, name: "Domaszowska / Poleska", distance: 481},
        {type: OfferPoiType.BUS, name: "Domaszowska / Żniwna", distance: 511},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 601},
        {type: OfferPoiType.BUS, name: "Żniwna / Domaszowska", distance: 673},
        {type: OfferPoiType.BUS, name: "Poleska", distance: 722},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1372},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1814},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1843},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1947},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 2091},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 2126},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 2192},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2222}
    ],
    19658: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 362},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 397},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 405},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 448},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 516},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 522},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 537},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 541},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 590},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 591},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 734},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1017},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1271},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2132}
    ],
    19659: [
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 105},
        {type: OfferPoiType.TRAM, name: "Rzebika 01", distance: 177},
        {type: OfferPoiType.BUS, name: "Szczecińska 02", distance: 178},
        {type: OfferPoiType.BUS, name: "Rzebika 04", distance: 203},
        {type: OfferPoiType.BUS, name: "Rzebika 03", distance: 208},
        {type: OfferPoiType.TRAM, name: "Rzebika 02", distance: 229},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 230},
        {type: OfferPoiType.BUS, name: "Rzebika 08", distance: 239},
        {type: OfferPoiType.BUS, name: "Szczecińska 01", distance: 276},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Węglarska 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 03", distance: 544},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R", distance: 637},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R 01", distance: 706},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 772},
        {type: OfferPoiType.TRAM, name: "Lipska 01", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 946},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1052},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1110},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1169},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1356}
    ],
    19660: [
        {type: OfferPoiType.BUS, name: "Aluzyjna 02", distance: 137},
        {type: OfferPoiType.BUS, name: "Aluzyjna 03", distance: 228},
        {type: OfferPoiType.BUS, name: "Aluzyjna 01", distance: 279},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 02", distance: 476},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 02", distance: 507},
        {type: OfferPoiType.BUS, name: "Buków 04", distance: 617},
        {type: OfferPoiType.BUS, name: "Buków 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 01", distance: 653},
        {type: OfferPoiType.BUS, name: "Buków 01", distance: 680},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 2319},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 2323}
    ],
    19661: [
        {type: OfferPoiType.BUS, name: "Świerzawska", distance: 672},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego n/ż", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1825},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1951},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2352}
    ],
    19662: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Mały Skręt", distance: 622},
        {type: OfferPoiType.BUS, name: "Łódzka - Mały Skręt", distance: 733},
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 821},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2191},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2454}
    ],
    19664: [
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – PKP", distance: 422},
        {type: OfferPoiType.BUS, name: "Bielany Stacja Kolejowa", distance: 458},
        {type: OfferPoiType.KOLEJ, name: "Bielany Wrocławskie", distance: 601},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – skrzyżowanie", distance: 687}
    ],
    19665: [
        {type: OfferPoiType.BUS, name: "Pustynna - Nowe Sady", distance: 543},
        {type: OfferPoiType.BUS, name: "Czahary", distance: 576},
        {type: OfferPoiType.BUS, name: "Nowe Sady - Pustynna", distance: 663},
        {type: OfferPoiType.BUS, name: "Obywatelska - Elektronowa NŻ", distance: 844},
        {type: OfferPoiType.PARK, name: "Skwer leśny przy Odrzańskiej", distance: 2204},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 2297},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 2428}
    ],
    19670: [
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 02", distance: 79},
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 01", distance: 237},
        {type: OfferPoiType.TRAM, name: "Uczniowska", distance: 739},
        {type: OfferPoiType.BUS, name: "Uczniowska 02", distance: 744},
        {type: OfferPoiType.PARK, name: "Park księdza kanonika Kazimierza Orkusza", distance: 1171},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1728},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 1870}
    ],
    19671: [
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 223},
        {type: OfferPoiType.BUS, name: "Topazowa", distance: 310},
        {type: OfferPoiType.BUS, name: "Ametystowa NŻ", distance: 344},
        {type: OfferPoiType.PARK, name: "Zielone korytarze miejske - Os. Diamentowe", distance: 413},
        {type: OfferPoiType.BUS, name: "Szpital", distance: 420},
        {type: OfferPoiType.BUS, name: "Piłsudskiego", distance: 554},
        {type: OfferPoiType.BUS, name: "Dom Seniora", distance: 576},
        {type: OfferPoiType.PARK, name: "Sad Miejski", distance: 887},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Jasiukowicza", distance: 2455}
    ],
    19672: [
        {type: OfferPoiType.BUS, name: "Runowska 02", distance: 163},
        {type: OfferPoiType.BUS, name: "Runowska 01", distance: 189},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Hilarego Rostworowskiego", distance: 216},
        {type: OfferPoiType.BUS, name: "Fogga 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Fogga 02", distance: 239},
        {type: OfferPoiType.BUS, name: "Złotokłos 02", distance: 323},
        {type: OfferPoiType.BUS, name: "Wojewódzka 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Wojewódzka 01", distance: 553},
        {type: OfferPoiType.BUS, name: "Szczaki 01", distance: 771},
        {type: OfferPoiType.PARK, name: "Skwer", distance: 803},
        {type: OfferPoiType.BUS, name: "Szczaki 02", distance: 803},
        {type: OfferPoiType.PARK, name: "Park Nad stawem", distance: 1089},
        {type: OfferPoiType.PARK, name: "Park Przy kolejce", distance: 1292}
    ],
    19674: [
        {type: OfferPoiType.BUS, name: "Psary – Parkowa", distance: 109},
        {type: OfferPoiType.BUS, name: "Psary – Wiadukt", distance: 407},
        {type: OfferPoiType.BUS, name: "Psary – Szkoła", distance: 658},
        {type: OfferPoiType.BUS, name: "Psary – Wolności", distance: 842},
        {type: OfferPoiType.PARK, name: "Park w Szymanowie", distance: 2060},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 2143}
    ],
    19678: [
        {type: OfferPoiType.BUS, name: "Rembertów-Akademia 01", distance: 122},
        {type: OfferPoiType.BUS, name: "Rembertów-Akademia 02", distance: 170},
        {type: OfferPoiType.BUS, name: "Rembertów-Akademia 04", distance: 204},
        {type: OfferPoiType.BUS, name: "Jerzego 01", distance: 341},
        {type: OfferPoiType.BUS, name: "Jerzego 02", distance: 451},
        {type: OfferPoiType.BUS, name: "Emilii Gierczak 01", distance: 542},
        {type: OfferPoiType.BUS, name: "Topograficzna 02", distance: 552},
        {type: OfferPoiType.BUS, name: "Emilii Gierczak 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Topograficzna 01", distance: 654},
        {type: OfferPoiType.BUS, name: "Eskulapów 01", distance: 713},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 2381}
    ],
    19679: [
        {type: OfferPoiType.TRAM, name: "Stare Zoo", distance: 154},
        {type: OfferPoiType.TRAM, name: "Kraszewskiego", distance: 234},
        {type: OfferPoiType.BUS, name: "Kraszewskiego", distance: 304},
        {type: OfferPoiType.BUS, name: "Rondo Kaponiera", distance: 314},
        {type: OfferPoiType.BUS, name: "Szylinga", distance: 516},
        {type: OfferPoiType.TRAM, name: "Rondo Kaponiera", distance: 525},
        {type: OfferPoiType.BUS, name: "Rynek Jeżycki", distance: 535},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 535},
        {type: OfferPoiType.TRAM, name: "Bałtyk", distance: 538},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 954},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 961},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 996},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1037},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1092},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1280},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1380},
        {type: OfferPoiType.PARK, name: "Park Thomasa Woodrowa Wilsona", distance: 1400},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1605},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 1766},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 2108}
    ],
    19681: [
        {type: OfferPoiType.BUS, name: "Brętowo PKM 04", distance: 248},
        {type: OfferPoiType.BUS, name: "Kolumba 04", distance: 356},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 356},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Kolumba 03", distance: 397},
        {type: OfferPoiType.BUS, name: "Brętowo PKM 03", distance: 422},
        {type: OfferPoiType.TRAM, name: "Brętowo PKM 01", distance: 583},
        {type: OfferPoiType.BUS, name: "Dolne Młyny 01", distance: 610},
        {type: OfferPoiType.TRAM, name: "Brętowo PKM 05", distance: 653},
        {type: OfferPoiType.BUS, name: "Dolne Młyny 02", distance: 675},
        {type: OfferPoiType.TRAM, name: "Brętowo PKM 02", distance: 724},
        {type: OfferPoiType.BUS, name: "Ogrodowa 02", distance: 796},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 950},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 1234},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 1361},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1927},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 2117},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 2125}
    ],
    19684: [
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 676},
        {type: OfferPoiType.BUS, name: "Węzłowiec Pętla", distance: 714},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1768},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 1887},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 2037}
    ],
    19685: [
        {type: OfferPoiType.BUS, name: "Dobrzykowice – przejazd", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Kamieniecki", distance: 1297}
    ],
    19686: [
        {type: OfferPoiType.BUS, name: "Błonie Olymp", distance: 456},
        {type: OfferPoiType.BUS, name: "Błonie Polna", distance: 641},
        {type: OfferPoiType.BUS, name: "Błonie Batalionów Chłopskich", distance: 653},
        {type: OfferPoiType.BUS, name: "Błonie Sochaczewska", distance: 794},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 1337},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 1682}
    ],
    19688: [
        {type: OfferPoiType.BUS, name: "Lebiodowa 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Lebiodowa 02", distance: 669},
        {type: OfferPoiType.BUS, name: "Kombajnistów 01", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Aktywności Rodzinnej", distance: 1448}
    ],
    19689: [
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Bursztynowa Góra", distance: 1412},
        {type: OfferPoiType.LAS, name: "Jankowski las", distance: 1916}
    ],
    19690: [
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 372},
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 572},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 593},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2287}
    ],
    19693: [
        {type: OfferPoiType.BUS, name: "Biedrusko/Park", distance: 222},
        {type: OfferPoiType.BUS, name: "Biedrusko/Jednostka Wojskowa", distance: 486}
    ],
    19704: [
        {type: OfferPoiType.BUS, name: "Złotno - Stare Złotno NŻ", distance: 511},
        {type: OfferPoiType.PARK, name: "Metalowe namioty", distance: 1855},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 2166},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2383}
    ],
    19705: [
        {type: OfferPoiType.BUS, name: "Cmentarz 01", distance: 548},
        {type: OfferPoiType.BUS, name: "Cmentarz 02", distance: 550},
        {type: OfferPoiType.BUS, name: "Zycha", distance: 586},
        {type: OfferPoiType.BUS, name: "Szwoleżerów 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Szwoleżerów 02", distance: 758},
        {type: OfferPoiType.BUS, name: "Warszawska 01", distance: 782},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 816},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 1808}
    ],
    19712: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 373},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 452},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 486},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 540},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 544},
        {type: OfferPoiType.BUS, name: "Bazyliańska 04", distance: 684},
        {type: OfferPoiType.BUS, name: "Bazyliańska 03", distance: 695},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 886},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1449},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1531}
    ],
    19713: [
        {type: OfferPoiType.TRAM, name: "Stolema", distance: 423},
        {type: OfferPoiType.BUS, name: "Lipowa", distance: 431},
        {type: OfferPoiType.BUS, name: "Stolema", distance: 434},
        {type: OfferPoiType.BUS, name: "Myśliwska", distance: 537},
        {type: OfferPoiType.BUS, name: "Migdałowa 02", distance: 704},
        {type: OfferPoiType.BUS, name: "Migdałowa 01", distance: 721},
        {type: OfferPoiType.BUS, name: "Zabornia 05", distance: 729},
        {type: OfferPoiType.TRAM, name: "Zabornia 02", distance: 824},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1586},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1947},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 1955},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 2243}
    ],
    19714: [
        {type: OfferPoiType.BUS, name: "Gaj", distance: 310},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 323},
        {type: OfferPoiType.BUS, name: "Działkowa", distance: 563},
        {type: OfferPoiType.BUS, name: "Orzechowa", distance: 652},
        {type: OfferPoiType.TRAM, name: "Świeradowska", distance: 686},
        {type: OfferPoiType.BUS, name: "Świeradowska", distance: 709},
        {type: OfferPoiType.BUS, name: "ROD Bajki", distance: 786},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1180},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1420},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1696}
    ],
    19716: [
        {type: OfferPoiType.BUS, name: "Lodowisko 02", distance: 233},
        {type: OfferPoiType.BUS, name: "Lodowisko 01", distance: 254},
        {type: OfferPoiType.BUS, name: "Podwale 01", distance: 374},
        {type: OfferPoiType.BUS, name: "Osiedle Robotnicze 02", distance: 448},
        {type: OfferPoiType.BUS, name: "Podwale 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Bankowa 02", distance: 506},
        {type: OfferPoiType.BUS, name: "Osiedle Robotnicze 01", distance: 550},
        {type: OfferPoiType.BUS, name: "Bankowa 01", distance: 558},
        {type: OfferPoiType.BUS, name: "Stanowisko 1", distance: 625},
        {type: OfferPoiType.BUS, name: "Stanowisko 2", distance: 633},
        {type: OfferPoiType.PARK, name: "Wzgórze Kościuszki", distance: 1750},
        {type: OfferPoiType.PARK, name: "Park im. J. Ziżki", distance: 1853}
    ],
    19717: [
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Wschodnia", distance: 312},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 407},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 419},
        {type: OfferPoiType.BUS, name: "Północna - Nowomiejska", distance: 421},
        {type: OfferPoiType.BUS, name: "Próchnika - Piotrkowska", distance: 436},
        {type: OfferPoiType.TRAM, name: "Północna - Nowomiejska", distance: 462},
        {type: OfferPoiType.TRAM, name: "Zachodnia - Legionów", distance: 469},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 475},
        {type: OfferPoiType.BUS, name: "Ogrodowa - Nowomiejska", distance: 480},
        {type: OfferPoiType.TRAM, name: "Ogrodowa - Nowomiejska", distance: 480},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 485},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 511},
        {type: OfferPoiType.BUS, name: "Zachodnia - Legionów", distance: 518},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego NŻ", distance: 522},
        {type: OfferPoiType.BUS, name: "Nowomiejska - Północna", distance: 526},
        {type: OfferPoiType.TRAM, name: "Legionów - Zachodnia", distance: 528},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 545},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 551},
        {type: OfferPoiType.BUS, name: "Łódzka Inf. Turystyczna", distance: 556},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kilińskiego", distance: 573},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 792},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 904},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1177},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1188}
    ],
    19718: [
        {type: OfferPoiType.BUS, name: "Rudzka - Farna", distance: 135},
        {type: OfferPoiType.BUS, name: "Farna - Plażowa NŻ", distance: 178},
        {type: OfferPoiType.BUS, name: "Rudzka - Przestrzenna", distance: 250},
        {type: OfferPoiType.BUS, name: "Rudzka - Popioły", distance: 267},
        {type: OfferPoiType.BUS, name: "Przestrzenna - Rudzka", distance: 303},
        {type: OfferPoiType.BUS, name: "Przestrzenna - Sławna NŻ", distance: 572},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 798},
        {type: OfferPoiType.PARK, name: "Rudzka Góra", distance: 1211},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Ruda Willowa”", distance: 1335},
        {type: OfferPoiType.LAS, name: "Las Popioły", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer leśny przy Odrzańskiej", distance: 2169}
    ],
    19722: [{type: OfferPoiType.PARK, name: "Staw Mysiadło", distance: 1154}],
    19724: [
        {type: OfferPoiType.BUS, name: "Instytut Lotnictwa 02", distance: 254},
        {type: OfferPoiType.TRAM, name: "Instytut Lotnictwa 04", distance: 329},
        {type: OfferPoiType.TRAM, name: "Instytut Lotnictwa 03", distance: 369},
        {type: OfferPoiType.BUS, name: "Instytut Lotnictwa 01", distance: 431},
        {type: OfferPoiType.TRAM, name: "Lipowczana 01", distance: 618},
        {type: OfferPoiType.TRAM, name: "Lipowczana 02", distance: 620},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 04", distance: 732},
        {type: OfferPoiType.BUS, name: "P+R Aleja Krakowska 06", distance: 737},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 01", distance: 771},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 02", distance: 780},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 03", distance: 787}
    ],
    19726: [
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 316},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 347},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 362},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 385},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 390},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 432},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 435},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 460},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 461},
        {type: OfferPoiType.BUS, name: "Domaniewska 06", distance: 470},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Domaniewska 05", distance: 495},
        {type: OfferPoiType.BUS, name: "Park Postępu 01", distance: 520},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 546},
        {type: OfferPoiType.BUS, name: "Domaniewska 02", distance: 548},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 556},
        {type: OfferPoiType.BUS, name: "Wynalazek 03", distance: 588},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 592},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 03", distance: 738},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 04", distance: 775},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1509},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1560}
    ],
    19728: [
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Białołęka 01", distance: 339},
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Białołęka 02", distance: 348},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 01", distance: 464},
        {type: OfferPoiType.BUS, name: "Białołęka Dworska 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Białołęka Dworska 02", distance: 817}
    ],
    19733: [
        {type: OfferPoiType.BUS, name: "Mańkowska 01", distance: 288},
        {type: OfferPoiType.BUS, name: "Mańkowska 02", distance: 334},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 357},
        {type: OfferPoiType.BUS, name: "Tymotki 02", distance: 386},
        {type: OfferPoiType.BUS, name: "Tymotki 01", distance: 532},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 596},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 687},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 01", distance: 808},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 03", distance: 811},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 02", distance: 834}
    ],
    19737: [
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła", distance: 609},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań", distance: 621},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 04", distance: 623},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 02", distance: 640},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Mosty - Wiązowa 01 (NŻ)", distance: 649},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 02", distance: 652},
        {type: OfferPoiType.BUS, name: "Mosty - Wiązowa 02 (NŻ)", distance: 699},
        {type: OfferPoiType.BUS, name: "Mosty - Ogrodowa", distance: 765},
        {type: OfferPoiType.BUS, name: "Mosty - Ogrodowa 03", distance: 773}
    ],
    19739: [
        {type: OfferPoiType.BUS, name: "Śniechowskiego (rondo)", distance: 176},
        {type: OfferPoiType.BUS, name: "Konstantynowska (rondo)", distance: 205},
        {type: OfferPoiType.BUS, name: "Śniechowskiego/Łódzka", distance: 332},
        {type: OfferPoiType.BUS, name: "Konstantynowska/Sokołowska", distance: 447},
        {type: OfferPoiType.BUS, name: "Ks. Popiełuszki/Łódzka", distance: 534},
        {type: OfferPoiType.BUS, name: "Barona/Konstantynowska", distance: 623},
        {type: OfferPoiType.PARK, name: "Skwer Istvána Almásiego", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Tadeusza Kościuszki", distance: 1177},
        {type: OfferPoiType.PARK, name: "Skwer 35 lat Samorządności", distance: 1345},
        {type: OfferPoiType.PARK, name: "Oko Tuwima", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer im. Adama Mickiewicza", distance: 1933}
    ],
    19744: [
        {type: OfferPoiType.BUS, name: "Szczecińska 02", distance: 98},
        {type: OfferPoiType.BUS, name: "Szczecińska 01", distance: 124},
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 224},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 301},
        {type: OfferPoiType.BUS, name: "Rzebika 03", distance: 318},
        {type: OfferPoiType.TRAM, name: "Rzebika 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 384},
        {type: OfferPoiType.TRAM, name: "Rzebika 01", distance: 385},
        {type: OfferPoiType.BUS, name: "Rzebika 04", distance: 411},
        {type: OfferPoiType.BUS, name: "Rzebika 08", distance: 417},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 01", distance: 429},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 02", distance: 437},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 789},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 841},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 1042},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1246},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1332},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1371}
    ],
    19754: [
        {type: OfferPoiType.BUS, name: "Szczyrk Centrum", distance: 407},
        {type: OfferPoiType.BUS, name: "Szczyrk Nowy Kościół", distance: 551},
        {type: OfferPoiType.BUS, name: "Szczyrk Beskidek", distance: 819},
        {type: OfferPoiType.BUS, name: "Szczyrk Skocznia", distance: 827}
    ],
    19755: [
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 138},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 221},
        {type: OfferPoiType.BUS, name: "Banacha 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Banacha 03", distance: 281},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 326},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 348},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 356},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 392},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 406},
        {type: OfferPoiType.BUS, name: "Os. Gotyk 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Górka Narodowa P+R 02", distance: 540},
        {type: OfferPoiType.BUS, name: "ks. Meiera 01", distance: 637},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R 01", distance: 771},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R", distance: 822},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1757},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1800},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2121},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2150}
    ],
    19760: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Park 03", distance: 170},
        {type: OfferPoiType.BUS, name: "Lubelska/Urząd Miasta 01", distance: 237},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Ogrodowa 04", distance: 299},
        {type: OfferPoiType.BUS, name: "Lubelska/Park 02", distance: 341},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 368},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Wiadukt 06", distance: 395},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Wiadukt 05", distance: 412},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Ogrodowa 01", distance: 435},
        {type: OfferPoiType.PARK, name: "Skwer Mickiewicza", distance: 463},
        {type: OfferPoiType.BUS, name: "Plac Gdański 01", distance: 471},
        {type: OfferPoiType.BUS, name: "10", distance: 582},
        {type: OfferPoiType.BUS, name: "09", distance: 582},
        {type: OfferPoiType.PARK, name: "Plac Kościuszki", distance: 611},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1204},
        {type: OfferPoiType.PARK, name: "Park XXX-lecia", distance: 1499}
    ],
    19765: [
        {type: OfferPoiType.BUS, name: "Marsa", distance: 138},
        {type: OfferPoiType.PARK, name: "Park Diany", distance: 293},
        {type: OfferPoiType.BUS, name: "Jednorożca", distance: 366},
        {type: OfferPoiType.PARK, name: "Zieleniec Orfeusza", distance: 571},
        {type: OfferPoiType.BUS, name: "Koziorożca", distance: 656},
        {type: OfferPoiType.BUS, name: "Wodnika 02", distance: 715},
        {type: OfferPoiType.BUS, name: "Wodnika 01", distance: 754},
        {type: OfferPoiType.BUS, name: "Owczarnia 03", distance: 811},
        {type: OfferPoiType.BUS, name: "Sołdka 01", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Chirona", distance: 1528},
        {type: OfferPoiType.PARK, name: "Zieleniec Parterowa", distance: 2097}
    ],
    19767: [
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Struga", distance: 315},
        {type: OfferPoiType.TRAM, name: "Limanowskiego - Piwna", distance: 480},
        {type: OfferPoiType.TRAM, name: "Zgierska - Adwokacka", distance: 545},
        {type: OfferPoiType.BUS, name: "Zgierska - Dolna", distance: 614},
        {type: OfferPoiType.TRAM, name: "Zgierska - Dolna", distance: 615},
        {type: OfferPoiType.BUS, name: "Zgierska - Sędziowska", distance: 623},
        {type: OfferPoiType.BUS, name: "Limanowskiego - Sierakowskiego", distance: 677},
        {type: OfferPoiType.TRAM, name: "Limanowskiego - Sierakowskiego", distance: 693},
        {type: OfferPoiType.BUS, name: "Zgierska - Julianowska", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 1002},
        {type: OfferPoiType.PARK, name: "Plac Piastowski", distance: 1166},
        {type: OfferPoiType.PARK, name: "Park przy ul. Hipotecznej", distance: 1310},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 1341},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 1609},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1901}
    ],
    19769: [
        {type: OfferPoiType.BUS, name: "Platynowa 03", distance: 310},
        {type: OfferPoiType.BUS, name: "Krzemowa 01", distance: 332},
        {type: OfferPoiType.BUS, name: "Orunia Górna 01", distance: 389},
        {type: OfferPoiType.BUS, name: "Platynowa 01", distance: 410},
        {type: OfferPoiType.BUS, name: "Platynowa 04", distance: 475},
        {type: OfferPoiType.BUS, name: "Platynowa 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Uranowa 01", distance: 613},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Dolina Potoku Oruńskiego"', distance: 672},
        {type: OfferPoiType.BUS, name: "Małomiejska", distance: 757},
        {type: OfferPoiType.BUS, name: "Świętokrzyska 01", distance: 766},
        {type: OfferPoiType.BUS, name: "Wawelska 02", distance: 779},
        {type: OfferPoiType.TRAM, name: "Łostowice Świętokrzyska 02", distance: 831},
        {type: OfferPoiType.PARK, name: "Park Oruński im. Emilii Hoene", distance: 1136},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1525},
        {type: OfferPoiType.PARK, name: 'Skwer im. Danuty Siedzikówny "Inki"', distance: 1746},
        {type: OfferPoiType.PARK, name: "Park Schopenhauera", distance: 1777}
    ],
    19770: [
        {type: OfferPoiType.BUS, name: "Cmentarz Bronowice 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Cmentarz Bronowice 02", distance: 441},
        {type: OfferPoiType.BUS, name: "Pasternik 03", distance: 567},
        {type: OfferPoiType.BUS, name: "Pasternik 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Pasternik 02", distance: 739},
        {type: OfferPoiType.BUS, name: "Park Tetmajera 01", distance: 752},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1455},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1862},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko Podgołogórze", distance: 1987},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko w Rząsce", distance: 2419}
    ],
    19774: [
        {type: OfferPoiType.BUS, name: "Prokocim UJ 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Prokocim UJ 02", distance: 335},
        {type: OfferPoiType.BUS, name: "Wydział Farmaceutyczny UJ 01", distance: 492},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 1040},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1712},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1719},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1723},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1879},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1968},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1985},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 2300},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 2479}
    ],
    19777: [
        {type: OfferPoiType.BUS, name: "Zaułek Dworcowy nż. 02", distance: 167},
        {type: OfferPoiType.BUS, name: "Zaułek Dworcowy nż. 01", distance: 309},
        {type: OfferPoiType.BUS, name: "Urząd Celny nż. 02", distance: 445},
        {type: OfferPoiType.TRAM, name: "Szpital Miejski 01", distance: 472},
        {type: OfferPoiType.TRAM, name: "Szpital Miejski 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Urząd Celny nż. 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Fabryczna nż. 02", distance: 607},
        {type: OfferPoiType.BUS, name: "Świętopełka 02", distance: 655},
        {type: OfferPoiType.BUS, name: "Młyn Wiedzy nż. 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Młyn Wiedzy nż. 02", distance: 669},
        {type: OfferPoiType.BUS, name: "Fabryczna nż. 01", distance: 731},
        {type: OfferPoiType.TRAM, name: "Świętopełka 04", distance: 735},
        {type: OfferPoiType.TRAM, name: "Świętopełka 03", distance: 745},
        {type: OfferPoiType.BUS, name: "Świętopełka 01", distance: 752},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 1581},
        {type: OfferPoiType.PARK, name: "Glazja", distance: 2202},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 2277}
    ],
    19778: [
        {type: OfferPoiType.TRAM, name: "Wschodnia 01", distance: 101},
        {type: OfferPoiType.TRAM, name: "Wschodnia 02", distance: 157},
        {type: OfferPoiType.BUS, name: "Wschodnia 04", distance: 263},
        {type: OfferPoiType.BUS, name: "Wschodnia 03", distance: 263},
        {type: OfferPoiType.TRAM, name: "Wschodnia (pętla) 01", distance: 284},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 06", distance: 628},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 03", distance: 685},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 05", distance: 796},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 04", distance: 807},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 02", distance: 810},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 08", distance: 820},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 1726},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 2016}
    ],
    19779: [
        {type: OfferPoiType.TRAM, name: "Paska", distance: 142},
        {type: OfferPoiType.TRAM, name: "Ciasna", distance: 321},
        {type: OfferPoiType.PARK, name: "Skwer im. Ignacego Wilczewskiego", distance: 324},
        {type: OfferPoiType.BUS, name: "Tarasy (Bema)", distance: 332},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Bema", distance: 550},
        {type: OfferPoiType.TRAM, name: "Pohulanka", distance: 587},
        {type: OfferPoiType.TRAM, name: "Powstańców Warszawskich", distance: 600},
        {type: OfferPoiType.BUS, name: "Pohulanka 04", distance: 683},
        {type: OfferPoiType.TRAM, name: "Zakopiańska", distance: 697},
        {type: OfferPoiType.BUS, name: "Pohulanka", distance: 704},
        {type: OfferPoiType.BUS, name: "Hevelianum 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Zakopiańska", distance: 741},
        {type: OfferPoiType.BUS, name: "Urząd Miejski 02", distance: 778},
        {type: OfferPoiType.BUS, name: "Hevelianum 02", distance: 800},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 885},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1046},
        {type: OfferPoiType.PARK, name: "Park poforteczny „Grodzisko”", distance: 1193},
        {type: OfferPoiType.PARK, name: "Skwer im. Polskich Harcerzy w byłym Wolnym Mieście Gdańsku", distance: 1199},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1210},
        {type: OfferPoiType.PARK, name: "Skwer Czesława Niemena", distance: 1214},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1497},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1629}
    ],
    19781: [
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego", distance: 818},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 1695},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 2322}
    ],
    19782: [
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 524},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 562}
    ],
    19783: [
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 01", distance: 152},
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 02", distance: 216},
        {type: OfferPoiType.BUS, name: "Królika 02", distance: 727},
        {type: OfferPoiType.BUS, name: "Starochylicka 01", distance: 765},
        {type: OfferPoiType.BUS, name: "Królika 01", distance: 793}
    ],
    19784: [
        {type: OfferPoiType.BUS, name: "Granata 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Granata 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Elektromontaż 01", distance: 460},
        {type: OfferPoiType.BUS, name: "Elektromontaż 03", distance: 579},
        {type: OfferPoiType.BUS, name: "Elektromontaż 02", distance: 599},
        {type: OfferPoiType.BUS, name: "Domeyki 01", distance: 718}
    ],
    19785: [
        {type: OfferPoiType.PARK, name: "Skwer Wacława Żebrowskiego", distance: 366},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Śliza", distance: 712},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 1082},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Domańskiej", distance: 1228},
        {type: OfferPoiType.PARK, name: "Skwer Anny Krzywańskiej", distance: 1240},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Dunajewskiego", distance: 1782}
    ],
    19786: [
        {type: OfferPoiType.BUS, name: "ul. Brzozowa", distance: 766},
        {type: OfferPoiType.LAS, name: "Park Staromiejski", distance: 1026},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1026},
        {type: OfferPoiType.PARK, name: "Skwer doktor Teresy Bielesz-Gniedziejko", distance: 1939}
    ],
    19787: [
        {type: OfferPoiType.BUS, name: "ul. Brzozowa", distance: 820},
        {type: OfferPoiType.LAS, name: "Park Staromiejski", distance: 1080},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer doktor Teresy Bielesz-Gniedziejko", distance: 1993}
    ],
    19791: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 107},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 110},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 125},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 255},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 348},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 492},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 513},
        {type: OfferPoiType.BUS, name: "Żupnicza 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 586},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 983},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1236},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1374},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1531},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1591},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1908},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2050},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2073},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2079}
    ],
    19792: [
        {type: OfferPoiType.BUS, name: "Cylkowskiego 01", distance: 320},
        {type: OfferPoiType.BUS, name: "Cylkowskiego", distance: 347},
        {type: OfferPoiType.BUS, name: "Cylkowskiego 02", distance: 394},
        {type: OfferPoiType.BUS, name: "Płyta Redłowska", distance: 478},
        {type: OfferPoiType.BUS, name: "Płyta Redłowska 04", distance: 492},
        {type: OfferPoiType.BUS, name: "Płyta Redłowska 02", distance: 494},
        {type: OfferPoiType.BUS, name: "Korczaka 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Korczaka", distance: 549},
        {type: OfferPoiType.BUS, name: "Ruchu Oporu", distance: 555},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół 01", distance: 569},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kępa Redłowska", distance: 1111},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 2080}
    ],
    19800: [
        {type: OfferPoiType.BUS, name: "Bronowice Wielkie 01", distance: 750},
        {type: OfferPoiType.BUS, name: "Bronowice Wielkie 02", distance: 768},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1728},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko w Rząsce", distance: 2233},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko Podgołogórze", distance: 2488}
    ],
    19801: [
        {type: OfferPoiType.BUS, name: "Urząd Wojewódzki / Marszałkowski", distance: 205},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Brama Nizinna", distance: 395},
        {type: OfferPoiType.BUS, name: "Toruńska 02", distance: 468},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 489},
        {type: OfferPoiType.BUS, name: "Toruńska 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Zaroślak 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Zaroślak 02", distance: 564},
        {type: OfferPoiType.TRAM, name: "Żabi Kruk", distance: 633},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Śródmieście", distance: 735},
        {type: OfferPoiType.TRAM, name: "Okopowa", distance: 752},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1044},
        {type: OfferPoiType.PARK, name: "Skwer im. Polskich Harcerzy w byłym Wolnym Mieście Gdańsku", distance: 1202},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1249},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2115},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2227},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 2260}
    ],
    19802: [
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 187},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 198},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 288},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 394},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 477},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 772},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2255}
    ],
    19803: [
        {type: OfferPoiType.BUS, name: "Rogowska 01", distance: 324},
        {type: OfferPoiType.BUS, name: "Rogowska 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 02", distance: 398},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 01", distance: 421},
        {type: OfferPoiType.TRAM, name: "Rondo Żaba 03", distance: 534},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 06", distance: 553},
        {type: OfferPoiType.TRAM, name: "Rondo Żaba 04", distance: 555},
        {type: OfferPoiType.TRAM, name: "Rondo Żaba 07", distance: 574},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 05", distance: 618},
        {type: OfferPoiType.BUS, name: "Kołowa 01", distance: 622},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 02", distance: 653},
        {type: OfferPoiType.BUS, name: "11 Listopada 02", distance: 664},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 01", distance: 670},
        {type: OfferPoiType.METRO, name: "Targówek Mieszkaniowy", distance: 685},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Targówek", distance: 802},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 856},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 1601},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1651},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 1669},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 1828},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 2153},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 2192}
    ],
    19804: [
        {type: OfferPoiType.BUS, name: "Jesiotrowa 01", distance: 264},
        {type: OfferPoiType.BUS, name: "Wierna 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Wierna 04", distance: 446},
        {type: OfferPoiType.BUS, name: "Lniana 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Wierna 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Plac Ostrej Bramy 01", distance: 516},
        {type: OfferPoiType.BUS, name: "Plac Ostrej Bramy 02", distance: 537},
        {type: OfferPoiType.BUS, name: "Lniana 02", distance: 559},
        {type: OfferPoiType.BUS, name: "Krzewna 01", distance: 594},
        {type: OfferPoiType.BUS, name: "Krzewna 02", distance: 605},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zacisze-Wilno", distance: 843}
    ],
    19809: [
        {type: OfferPoiType.BUS, name: "Bochenka 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Bochenka 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 03", distance: 636},
        {type: OfferPoiType.BUS, name: "Piaski Nowe", distance: 644},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 02", distance: 650},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 674},
        {type: OfferPoiType.BUS, name: "Łużycka 02", distance: 688},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 709},
        {type: OfferPoiType.BUS, name: "Tuchowska 01", distance: 807},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1132},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 1587},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1834},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1848},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 2209}
    ],
    19811: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 94},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 273},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 332},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 402},
        {type: OfferPoiType.BUS, name: "Struga - Pogonowskiego NŻ", distance: 403},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 420},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Struga", distance: 441},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 540},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 552},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 590},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 694},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 697},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 712},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 725},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 731},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 745},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 811}
    ],
    19816: [
        {type: OfferPoiType.BUS, name: "Chwałkowska", distance: 492},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 649},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1915},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 2220}
    ],
    19817: [
        {type: OfferPoiType.BUS, name: "Wilkowyje Obywatelska", distance: 285},
        {type: OfferPoiType.BUS, name: "Wilkowyje Działki nż", distance: 487},
        {type: OfferPoiType.PARK, name: "Skwer Wilczy Kąt", distance: 1596},
        {type: OfferPoiType.PARK, name: "Park Górniczy", distance: 1719}
    ],
    19818: [
        {type: OfferPoiType.BUS, name: "Oś Królewska 01", distance: 23},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 06", distance: 116},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 05", distance: 145},
        {type: OfferPoiType.BUS, name: "Oś Królewska 02", distance: 206},
        {type: OfferPoiType.BUS, name: "Świątynia Opatrzności Bożej 02", distance: 395},
        {type: OfferPoiType.TRAM, name: "Świątynia Opatrzności Bożej 04", distance: 509},
        {type: OfferPoiType.TRAM, name: "Świątynia Opatrzności Bożej 03", distance: 542},
        {type: OfferPoiType.BUS, name: "Świątynia Opatrzności Bożej 01", distance: 545},
        {type: OfferPoiType.BUS, name: "Sobieskiego 03", distance: 604},
        {type: OfferPoiType.BUS, name: "Sobieskiego 01", distance: 719},
        {type: OfferPoiType.BUS, name: "Sobieskiego 04", distance: 755},
        {type: OfferPoiType.BUS, name: "Sobieskiego 02", distance: 793},
        {type: OfferPoiType.BUS, name: "Sobieskiego 06", distance: 795},
        {type: OfferPoiType.TRAM, name: "Sobieskiego 06", distance: 795},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 71", distance: 806},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 72", distance: 807},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1092},
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 1451},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1578}
    ],
    19822: [
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 360},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pl. Dąbrowskiego", distance: 395},
        {type: OfferPoiType.BUS, name: "Sterlinga - Rewolucji 1905r.", distance: 420},
        {type: OfferPoiType.BUS, name: "Jaracza - P.O.W.", distance: 454},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 503},
        {type: OfferPoiType.BUS, name: "Jaracza - Wierzbowa", distance: 521},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 527},
        {type: OfferPoiType.BUS, name: "Narutowicza - Pl. Dąbrowskiego", distance: 530},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 602},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 647},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 737},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 763},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 775},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 898},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 944},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 995},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1091},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1159},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1231}
    ],
    19827: [
        {type: OfferPoiType.BUS, name: "Pienista - Obywatelska", distance: 152},
        {type: OfferPoiType.BUS, name: "Waltera-Janke - Nowe Sady", distance: 400},
        {type: OfferPoiType.BUS, name: "Pienista - Rusałki NŻ", distance: 406},
        {type: OfferPoiType.BUS, name: "Maratońska - Obywatelska", distance: 416},
        {type: OfferPoiType.BUS, name: "Nowe Sady - Waltera-Janke NŻ", distance: 507},
        {type: OfferPoiType.KOLEJ, name: "Łódź Retkinia", distance: 827},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 1605},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2249},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 2490}
    ],
    19828: [
        {type: OfferPoiType.TRAM, name: "Aleje Marcinkowskiego", distance: 277},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 296},
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 341},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 352},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 358},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 369},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 446},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 543},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 570},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 591},
        {type: OfferPoiType.TRAM, name: "Gwarna", distance: 648},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 662},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 724},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 808},
        {type: OfferPoiType.BUS, name: "Niezłomnych", distance: 818},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 910},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 941},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1024},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1040},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1137},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1178},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1254},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1300}
    ],
    19834: [
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 02", distance: 425},
        {type: OfferPoiType.BUS, name: "Ryżowa 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Ryżowa 03", distance: 613},
        {type: OfferPoiType.BUS, name: "Zapustna 04", distance: 636},
        {type: OfferPoiType.BUS, name: "Ryżowa 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 01", distance: 682},
        {type: OfferPoiType.BUS, name: "Zapustna 01", distance: 689},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 02", distance: 708},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 04", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1455},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 1545},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 1680},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1769},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1817},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 1959},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 2031}
    ],
    19838: [
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 522},
        {type: OfferPoiType.PARK, name: "Małpi Gaj", distance: 552}
    ],
    19840: [
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 194},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 245},
        {type: OfferPoiType.BUS, name: "Hańczy 01", distance: 267},
        {type: OfferPoiType.BUS, name: "Kierbedzia 01", distance: 318},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 442},
        {type: OfferPoiType.BUS, name: "Kostrzewskiego 04", distance: 486},
        {type: OfferPoiType.BUS, name: "Kierbedzia 02", distance: 515},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 04", distance: 527},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 01", distance: 541},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 02", distance: 570},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 01", distance: 647},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 02", distance: 671},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 759},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1322},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1446},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1556},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1607},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1664},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1934},
        {type: OfferPoiType.PARK, name: "Skwer Małkowskich", distance: 1996},
        {type: OfferPoiType.PARK, name: "Park Szustrów", distance: 2007},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2178},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2224}
    ],
    19841: [
        {type: OfferPoiType.BUS, name: "Sanocka n/ż", distance: 283},
        {type: OfferPoiType.BUS, name: "Urszulanek n/ż", distance: 765},
        {type: OfferPoiType.BUS, name: "Strzyżowska n/ż", distance: 780}
    ],
    19845: [
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 367},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 422},
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 477},
        {type: OfferPoiType.BUS, name: "Maślicka (Staw)", distance: 516},
        {type: OfferPoiType.BUS, name: "Turoszowska", distance: 664},
        {type: OfferPoiType.BUS, name: "Rędzińska", distance: 679},
        {type: OfferPoiType.BUS, name: "Północna", distance: 697},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1547}
    ],
    19846: [
        {type: OfferPoiType.BUS, name: "Bańgów Kościół", distance: 378},
        {type: OfferPoiType.PARK, name: "Skwer tajnej organizacji nauczycielskiej", distance: 751},
        {type: OfferPoiType.REZERWAT, name: 'Obszar chronionego krajobrazu "Przełajka"', distance: 1498},
        {type: OfferPoiType.PARK, name: 'Free Time Park "Brodzik"', distance: 2163},
        {type: OfferPoiType.REZERWAT, name: "Bażantarnia", distance: 2474}
    ],
    19848: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    19850: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    19851: [
        {type: OfferPoiType.BUS, name: "Generała Grota-Roweckiego 04", distance: 277},
        {type: OfferPoiType.BUS, name: "Generała Grota-Roweckiego 05", distance: 321},
        {type: OfferPoiType.BUS, name: "Zakole 02", distance: 389},
        {type: OfferPoiType.BUS, name: "Zakole 01", distance: 483},
        {type: OfferPoiType.BUS, name: "Stawki 01", distance: 632},
        {type: OfferPoiType.BUS, name: "Stawki 02", distance: 633},
        {type: OfferPoiType.BUS, name: "Telimeny 01", distance: 757},
        {type: OfferPoiType.BUS, name: "Stawki Południowe nż. 02", distance: 811},
        {type: OfferPoiType.PARK, name: "Zacisze Holandii", distance: 1360},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2321}
    ],
    19853: [
        {type: OfferPoiType.BUS, name: "Muzeum Kinematografii", distance: 129},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Targowa", distance: 212},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 270},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Kilińskiego", distance: 290},
        {type: OfferPoiType.PARK, name: "Park Źródliska II", distance: 374},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Piłsudskiego", distance: 378},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Kilińskiego", distance: 400},
        {type: OfferPoiType.BUS, name: "Fabryczna - Targowa NŻ", distance: 489},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 528},
        {type: OfferPoiType.BUS, name: "Fabryczna - Kilińskiego NŻ", distance: 578},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 608},
        {type: OfferPoiType.BUS, name: "Wigury - Kilińskiego NŻ", distance: 623},
        {type: OfferPoiType.BUS, name: "Nawrot - Targowa", distance: 632},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Fabryczna", distance: 657},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Fabryczna", distance: 657},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Nawrot", distance: 662},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Przędzalniana", distance: 664},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 725},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 999},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1012}
    ],
    19854: [
        {type: OfferPoiType.BUS, name: "Ustronie Morskie", distance: 201},
        {type: OfferPoiType.BUS, name: "Ustronie Morskie Chrobrego", distance: 219}
    ],
    19855: [
        {type: OfferPoiType.BUS, name: "Bat. Chłopskich / Staroniwska 05", distance: 82},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 05", distance: 201},
        {type: OfferPoiType.BUS, name: "Bat. Chłopskich / Langiewicza 04", distance: 222},
        {type: OfferPoiType.BUS, name: "Witosa / Langiewicza 02", distance: 252},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 04", distance: 282},
        {type: OfferPoiType.BUS, name: "Przemysłowa / Bat. Chłopskich 02", distance: 335},
        {type: OfferPoiType.BUS, name: "Staroniwska / Rzemieślnicza 01", distance: 352},
        {type: OfferPoiType.BUS, name: "Staroniwska / Rzemieślnicza 02", distance: 386},
        {type: OfferPoiType.BUS, name: "Witosa / Panoramiczna 01", distance: 408},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1179},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 1381},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 1386},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 1484}
    ],
    19857: [{type: OfferPoiType.BUS, name: "Ogrody Działkowe Kawęczyn 02", distance: 687}],
    19858: [
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja", distance: 411},
        {type: OfferPoiType.TRAM, name: "Konstytucji 3 Maja", distance: 416},
        {type: OfferPoiType.BUS, name: "Rządz", distance: 546},
        {type: OfferPoiType.TRAM, name: "Pętla Rządz", distance: 568},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja / Sobieskiego", distance: 571},
        {type: OfferPoiType.LAS, name: "Nabrzeże generała Gustawa Orlicz-Dreszera", distance: 645},
        {type: OfferPoiType.BUS, name: "Dębowe Wzgórze", distance: 813},
        {type: OfferPoiType.LAS, name: "fort Strzemięcin", distance: 1022}
    ],
    19859: [
        {type: OfferPoiType.BUS, name: "Grażyńskiego Okrzei", distance: 127},
        {type: OfferPoiType.BUS, name: "Podwale Dworzec", distance: 261},
        {type: OfferPoiType.BUS, name: "Stefana Okrzei", distance: 311},
        {type: OfferPoiType.BUS, name: "Gazownicza", distance: 373},
        {type: OfferPoiType.BUS, name: "Komorowicka Towarzystwa Szkoły Ludowej", distance: 445},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Główna", distance: 541},
        {type: OfferPoiType.BUS, name: "Wałowa CH", distance: 599},
        {type: OfferPoiType.BUS, name: "Bielsko-Biała D.A.", distance: 627},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 783},
        {type: OfferPoiType.PARK, name: "Park za Ratuszem", distance: 1177},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1340},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1418}
    ],
    19863: [
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 332},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 443},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 576},
        {type: OfferPoiType.BUS, name: "Zakładowa", distance: 772},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 1396},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1551},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1579},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1579}
    ],
    19866: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Kilińskiego", distance: 274},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Kilińskiego", distance: 274},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Senatorska", distance: 333},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Przybyszewskiego", distance: 334},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przybyszewskiego", distance: 334},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Senatorska", distance: 345},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Brzozowa", distance: 374},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Brzozowa", distance: 375},
        {type: OfferPoiType.BUS, name: "Zarzewska - Kilińskiego", distance: 416},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Poznańska", distance: 644},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 786},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 876},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 911},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1190},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1197},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 1379}
    ],
    19868: [
        {type: OfferPoiType.BUS, name: "Turoszowska", distance: 374},
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 424},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 472},
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 584},
        {type: OfferPoiType.BUS, name: "Rędzińska (Cmentarz)", distance: 688},
        {type: OfferPoiType.BUS, name: "Rędzińska", distance: 729},
        {type: OfferPoiType.BUS, name: "Maślicka (Staw)", distance: 806},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1494}
    ],
    19878: [
        {type: OfferPoiType.BUS, name: "Koszykarska 02", distance: 298},
        {type: OfferPoiType.BUS, name: "Koszykarska 01", distance: 393},
        {type: OfferPoiType.BUS, name: "Koszykarska 03", distance: 445},
        {type: OfferPoiType.BUS, name: "Stoczniowców 05", distance: 514},
        {type: OfferPoiType.BUS, name: "Stoczniowców 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Stoczniowców 03", distance: 592},
        {type: OfferPoiType.BUS, name: "Stoczniowców 01", distance: 607},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 764},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 1034},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 1795},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1884},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1908},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 2086}
    ],
    19886: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 309},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 332},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 381},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 424},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 627},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 671},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 788},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 807},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1283},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1645},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2423}
    ],
    19888: [
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 610},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 651},
        {type: OfferPoiType.BUS, name: "Krakowiaków 02", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2335}
    ],
    19890: [
        {type: OfferPoiType.BUS, name: "Niemcz / Słowackiego", distance: 67},
        {type: OfferPoiType.BUS, name: "Niemcz / Kasprowicza", distance: 261},
        {type: OfferPoiType.BUS, name: "Jeździecka / Ogród Botaniczny", distance: 333},
        {type: OfferPoiType.BUS, name: "Niemcz / Mickiewicza", distance: 518},
        {type: OfferPoiType.BUS, name: "Jeździecka / Hipiczna", distance: 557},
        {type: OfferPoiType.PARK, name: "Drzewa Młodej Bydgoszczy", distance: 2376}
    ],
    19898: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Zapadła", distance: 536},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Zapadła", distance: 536},
        {type: OfferPoiType.LAS, name: "osadnik", distance: 566},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Nurta-Kaszyńskiego", distance: 681},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Nurta-Kaszyńskiego", distance: 681},
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2150},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 2236},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 2282},
        {type: OfferPoiType.PARK, name: "Skwer im. Świętego Maksymiliana Marii Kolbego", distance: 2375},
        {type: OfferPoiType.PARK, name: "Park Źródliska II", distance: 2453}
    ],
    19902: [
        {type: OfferPoiType.BUS, name: "Halicka", distance: 83},
        {type: OfferPoiType.BUS, name: "Małopolska (Ośrodek dla niewidomych)", distance: 245},
        {type: OfferPoiType.BUS, name: "Częstochowska", distance: 357},
        {type: OfferPoiType.BUS, name: "Złotniki", distance: 675},
        {type: OfferPoiType.BUS, name: "Kosmonautów (Szpital)", distance: 725},
        {type: OfferPoiType.TRAM, name: "Kosmonautów (Szpital)", distance: 746},
        {type: OfferPoiType.PARK, name: "Park Literacki", distance: 1361},
        {type: OfferPoiType.PARK, name: "Park Złotnicki", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park Żernicki", distance: 2066},
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 2349},
        {type: OfferPoiType.PARK, name: "skwer Księdza Justyna Kostka", distance: 2396},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2464},
        {type: OfferPoiType.PARK, name: "Żernicki Park Sportu i Rekreacji", distance: 2485}
    ],
    19904: [
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 355},
        {type: OfferPoiType.BUS, name: "Bogucice Skrzyżowanie", distance: 429},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury", distance: 515},
        {type: OfferPoiType.TRAM, name: "Zawodzie Paderewskiego", distance: 569},
        {type: OfferPoiType.TRAM, name: "Zawodzie Uniwersytet Ekonomiczny", distance: 580},
        {type: OfferPoiType.BUS, name: "Bogucice Markiefki", distance: 598},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Eugeniusza Breitkopfa", distance: 608},
        {type: OfferPoiType.BUS, name: "Zawodzie Waleriana", distance: 727},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 773},
        {type: OfferPoiType.TRAM, name: "Katowice Graniczna", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 793},
        {type: OfferPoiType.PARK, name: "Skwer Andrzeja Fonfary", distance: 814},
        {type: OfferPoiType.BUS, name: "Bogucice Wróblewskiego", distance: 822},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1180},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 1224},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 1240},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 1333},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1456},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 1546}
    ],
    19906: [
        {type: OfferPoiType.BUS, name: "Os. Ślichowice", distance: 166},
        {type: OfferPoiType.KOLEJ, name: "Kielce Ślichowice", distance: 406},
        {type: OfferPoiType.BUS, name: "Massalskiego", distance: 461},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skalny Ślichowice im. Jana Czarnockiego", distance: 544},
        {type: OfferPoiType.BUS, name: "Pasaż Świętokrzyski", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Czarnów", distance: 2536}
    ],
    19907: [
        {type: OfferPoiType.BUS, name: "Osielsko / Dzikiej Gęsi", distance: 399},
        {type: OfferPoiType.BUS, name: "Osielsko / Młyn", distance: 509}
    ],
    19908: [
        {type: OfferPoiType.BUS, name: "Trzebinia Osiedle Widokowe Kiosk", distance: 353},
        {type: OfferPoiType.BUS, name: "Trzebinia Osiedle Widokowe Szkoła", distance: 593},
        {type: OfferPoiType.BUS, name: "Trzebinia Osiedle Widokowe Schody", distance: 791},
        {type: OfferPoiType.PARK, name: "Zespół pałacowo – parkowy Florkiewiczów w Młoszowej", distance: 1708}
    ],
    19910: [
        {type: OfferPoiType.BUS, name: "Kredytowa", distance: 528},
        {type: OfferPoiType.BUS, name: "Skarpa", distance: 555},
        {type: OfferPoiType.BUS, name: "Skłodowskiej", distance: 774},
        {type: OfferPoiType.BUS, name: "Słowackiego", distance: 830},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego", distance: 834},
        {type: OfferPoiType.PARK, name: "Park przy Łukasiewicza", distance: 1244},
        {type: OfferPoiType.PARK, name: "Park na Wzgórzu Tumskim", distance: 2035},
        {type: OfferPoiType.PARK, name: "Skwer imienia Romana Lutyńskiego", distance: 2244},
        {type: OfferPoiType.PARK, name: "Plac Obrońców Warszawy", distance: 2252}
    ],
    19919: [
        {type: OfferPoiType.BUS, name: "Edwardowo n/ż", distance: 143},
        {type: OfferPoiType.BUS, name: "Brzechwy n/ż", distance: 320},
        {type: OfferPoiType.BUS, name: "Leśnych Skrzatów", distance: 475},
        {type: OfferPoiType.BUS, name: "Wieczorynki n/ż", distance: 617},
        {type: OfferPoiType.LAS, name: "Lasek Marceliński", distance: 1465}
    ],
    19920: [
        {type: OfferPoiType.TRAM, name: "Pomorska - Matejki", distance: 183},
        {type: OfferPoiType.BUS, name: "Pomorska - Matejki", distance: 192},
        {type: OfferPoiType.BUS, name: "Pomorska - Rondo Solidarności", distance: 322},
        {type: OfferPoiType.TRAM, name: "Pomorska - Rondo Solidarności", distance: 331},
        {type: OfferPoiType.BUS, name: "Pomorska - Tamka NŻ", distance: 415},
        {type: OfferPoiType.BUS, name: "Palki - Źródłowa", distance: 426},
        {type: OfferPoiType.TRAM, name: "Pomorska - Tamka", distance: 433},
        {type: OfferPoiType.BUS, name: "Pomorska - Tamka", distance: 441},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Rondo Solidarności", distance: 519},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 694},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 756},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 759},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1219},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1258},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1429},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1590},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1725},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1725}
    ],
    19922: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 04", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1574},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1878},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 2054},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 2439}
    ],
    19923: [
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 04", distance: 93},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 02", distance: 199},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 01", distance: 213},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 06", distance: 215},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 03", distance: 244},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 09", distance: 265},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 05", distance: 285},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 07", distance: 298},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 11", distance: 323},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 71", distance: 347},
        {type: OfferPoiType.TRAM, name: "Lubelska 03", distance: 357},
        {type: OfferPoiType.TRAM, name: "Lubelska 04", distance: 370},
        {type: OfferPoiType.BUS, name: "Kijowska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Lubelska 06", distance: 385},
        {type: OfferPoiType.BUS, name: "Lubelska 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Lubelska 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Metro Stadion Narodowy 71", distance: 459},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 554},
        {type: OfferPoiType.METRO, name: "Stadion Narodowy", distance: 559},
        {type: OfferPoiType.TRAM, name: "Kijowska 03", distance: 564},
        {type: OfferPoiType.TRAM, name: "Kijowska 06", distance: 638},
        {type: OfferPoiType.TRAM, name: "Kijowska 04", distance: 641},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Stadion", distance: 676},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 829},
        {type: OfferPoiType.PARK, name: "Skwer Kępna-Jagiellońska", distance: 968},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1008},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1259},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1671},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1834},
        {type: OfferPoiType.PARK, name: "Park Odkrywców", distance: 1859},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1890}
    ],
    19925: [
        {type: OfferPoiType.BUS, name: "Podbipięty 02", distance: 184},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 16", distance: 187},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 17", distance: 198},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 15", distance: 213},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 14", distance: 228},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 18", distance: 229},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 13", distance: 237},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 10", distance: 245},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 11", distance: 258},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 09", distance: 260},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 05", distance: 339},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 351},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 06", distance: 359},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 72", distance: 416},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 71", distance: 417},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 04", distance: 692},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 03", distance: 738},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 778},
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 986},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1226},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1370},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1521},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1922},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2264}
    ],
    19930: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Mechaniczna (CRO) NŻ", distance: 278},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego NŻ", distance: 474},
        {type: OfferPoiType.TRAM, name: "Lodowa - Przybyszewskiego", distance: 475},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego", distance: 482},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Lodowa", distance: 494},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Lodowa", distance: 498},
        {type: OfferPoiType.BUS, name: "Maciejewskiego - Dw. Łódź Zarzew", distance: 524},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 575},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 575},
        {type: OfferPoiType.KOLEJ, name: "Łódź Zarzew", distance: 665},
        {type: OfferPoiType.TRAM, name: "Cm. Zarzew", distance: 693},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 1067},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 1144},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 2241},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2366},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2458},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 2492}
    ],
    19933: [
        {type: OfferPoiType.BUS, name: "Mazowieckiego 02", distance: 562},
        {type: OfferPoiType.BUS, name: "Mazowieckiego 01", distance: 665}
    ],
    19934: [{type: OfferPoiType.REZERWAT, name: "Redutowa", distance: 1467}],
    19943: [
        {type: OfferPoiType.BUS, name: "PKP Gocławek 04", distance: 234},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 03", distance: 241},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 02", distance: 356},
        {type: OfferPoiType.BUS, name: "Płowiecka 01", distance: 550},
        {type: OfferPoiType.BUS, name: "Cukrownicza 02", distance: 580},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Gocławek", distance: 612},
        {type: OfferPoiType.BUS, name: "Okularowa 01", distance: 626},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 652},
        {type: OfferPoiType.BUS, name: "Cukrownicza 01", distance: 661},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 01", distance: 694},
        {type: OfferPoiType.BUS, name: "Płowiecka 04", distance: 743},
        {type: OfferPoiType.BUS, name: "Okularowa 04", distance: 779},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 1419},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1536},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 1753},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 1944}
    ],
    19953: [
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 227},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 247},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 320},
        {type: OfferPoiType.BUS, name: "Terespolska 01", distance: 339},
        {type: OfferPoiType.BUS, name: "Terespolska 04", distance: 388},
        {type: OfferPoiType.BUS, name: "Praga Południe-Ratusz 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 485},
        {type: OfferPoiType.TRAM, name: "Praga Południe-Ratusz 04", distance: 501},
        {type: OfferPoiType.TRAM, name: "Praga Południe-Ratusz 03", distance: 514},
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 537},
        {type: OfferPoiType.BUS, name: "Praga Południe-Ratusz 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 552},
        {type: OfferPoiType.TRAM, name: "Gocławska 03", distance: 718},
        {type: OfferPoiType.TRAM, name: "Gocławska 04", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 781},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 973},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1100},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1136},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1540},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1595},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1799},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1807}
    ],
    19963: [
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 515},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 784},
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 817}
    ],
    19964: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 519},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 536},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 540},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 547},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 561},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1502},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1545},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2000}
    ],
    19969: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Teligi", distance: 294},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Czeremchowa", distance: 392},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Bairda", distance: 525},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Królewska / Teligi", distance: 567},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Na Laski", distance: 641},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Świerkowa", distance: 646},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 846},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 1042},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1444},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 1625},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1803},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1814},
        {type: OfferPoiType.PARK, name: "Skwer przy ulicy Górnej", distance: 2181}
    ],
    19970: [
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 606},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 620},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 699},
        {type: OfferPoiType.BUS, name: "Osiedle Kukuczki Sandomierska", distance: 711},
        {type: OfferPoiType.BUS, name: "Bogucice Wróblewskiego", distance: 729},
        {type: OfferPoiType.BUS, name: "Bogucice Cmentarz", distance: 808},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 1229},
        {type: OfferPoiType.PARK, name: "Park przy ul. Leopolda", distance: 1243},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1549},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 1584},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park Zielony Zakątek", distance: 1724},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1737}
    ],
    19971: [
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Traugutta", distance: 459},
        {type: OfferPoiType.BUS, name: "Traugutta - Sienkiewicza", distance: 465},
        {type: OfferPoiType.BUS, name: "Łódzka Inf. Turystyczna", distance: 507},
        {type: OfferPoiType.BUS, name: "Jaracza - Piotrkowska", distance: 510},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Narutowicza", distance: 521},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Narutowicza", distance: 528},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 641},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 644},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 662},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 671},
        {type: OfferPoiType.BUS, name: "Jaracza - Kilińskiego", distance: 672},
        {type: OfferPoiType.TRAM, name: "Zachodnia - Więckowskiego", distance: 688},
        {type: OfferPoiType.BUS, name: "Narutowicza - P.O.W. NŻ", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 695},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 706},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 719},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Zachodnia", distance: 723},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 743},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 765},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 841},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 906},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 910},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 930}
    ],
    19972: [
        {type: OfferPoiType.BUS, name: "Mickiewicza 05", distance: 236},
        {type: OfferPoiType.BUS, name: "Ostroroga 01", distance: 325},
        {type: OfferPoiType.TRAM, name: "Mickiewicza 03", distance: 362},
        {type: OfferPoiType.BUS, name: "Kościuszki 04", distance: 408},
        {type: OfferPoiType.BUS, name: "Mickiewicza 04", distance: 408},
        {type: OfferPoiType.BUS, name: "Mickiewicza 06", distance: 414},
        {type: OfferPoiType.TRAM, name: "Mickiewicza 02", distance: 424},
        {type: OfferPoiType.TRAM, name: "Mickiewicza 01", distance: 426},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 435},
        {type: OfferPoiType.BUS, name: "Kościuszki 05", distance: 443},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 479},
        {type: OfferPoiType.BUS, name: "Kościuszki 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Klonowicza 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Klonowicza 01", distance: 542},
        {type: OfferPoiType.BUS, name: "Lwowska 01", distance: 630},
        {type: OfferPoiType.PARK, name: "Park nad Strzyżą", distance: 868},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Wybickiego", distance: 1002}
    ],
    19973: [
        {type: OfferPoiType.BUS, name: "Grabowa", distance: 331},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 340},
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 414},
        {type: OfferPoiType.BUS, name: "Aleja Architektów", distance: 711},
        {type: OfferPoiType.TRAM, name: "Aleja Architektów", distance: 720},
        {type: OfferPoiType.TRAM, name: "Kosmonautów", distance: 811},
        {type: OfferPoiType.BUS, name: "Kosmonautów (pętla)", distance: 830},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 2477}
    ],
    19974: [
        {type: OfferPoiType.BUS, name: "Obornicka (Wołowska)", distance: 306},
        {type: OfferPoiType.BUS, name: "Wołowska", distance: 444},
        {type: OfferPoiType.TRAM, name: "Wołowska", distance: 449},
        {type: OfferPoiType.BUS, name: "Bezpieczna", distance: 490},
        {type: OfferPoiType.TRAM, name: "Poświętne", distance: 702},
        {type: OfferPoiType.BUS, name: "Paprotna", distance: 722},
        {type: OfferPoiType.BUS, name: "Poświętne", distance: 754},
        {type: OfferPoiType.BUS, name: "Kępińska", distance: 797},
        {type: OfferPoiType.TRAM, name: "Kępińska", distance: 798},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 2295}
    ],
    19975: [
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 537},
        {type: OfferPoiType.BUS, name: "Grabowa", distance: 651},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 660}
    ],
    19976: [
        {type: OfferPoiType.BUS, name: "Fabryczna 02", distance: 71},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 01", distance: 204},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 03", distance: 228},
        {type: OfferPoiType.BUS, name: "Kościelna 01", distance: 296},
        {type: OfferPoiType.BUS, name: "Szkolna 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 355},
        {type: OfferPoiType.BUS, name: "Szkolna 03", distance: 409},
        {type: OfferPoiType.BUS, name: "Nadarzyńska 02", distance: 428},
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy 02", distance: 504},
        {type: OfferPoiType.PARK, name: "Skwer Hrabianki Ludwiki Małgorzaty Moriconi", distance: 558},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 560},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Kisielewskiego", distance: 735},
        {type: OfferPoiType.PARK, name: "Park Książąt Mazowieckich", distance: 837}
    ],
    19978: [
        {type: OfferPoiType.PARK, name: "Park im. Mariana Jonkajtysa", distance: 2012},
        {type: OfferPoiType.PARK, name: "Skwer im. Żołnierzy Wyklętych", distance: 2380}
    ],
    19981: [
        {type: OfferPoiType.BUS, name: "Błonie PEKAES", distance: 251},
        {type: OfferPoiType.BUS, name: "Błonie Batalionów Chłopskich", distance: 365},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 2079},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 2109},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 2426}
    ],
    19986: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Przychodnia", distance: 84},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta", distance: 260},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Dw. PKP", distance: 333},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. DSI Malwa", distance: 377},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Dw. PKP", distance: 555},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Poniatowskiego", distance: 576},
        {type: OfferPoiType.KOLEJ, name: "Grodzisk Mazowiecki", distance: 615},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 1048},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Piłsudskiego", distance: 1201},
        {type: OfferPoiType.PARK, name: "Park Marii Michalak", distance: 1290},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1600},
        {type: OfferPoiType.PARK, name: "Park nad Rokitnicą", distance: 1797},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1820},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 2172},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 2259}
    ],
    19989: [
        {type: OfferPoiType.BUS, name: "Kolonistów", distance: 513},
        {type: OfferPoiType.BUS, name: "Górna", distance: 543},
        {type: OfferPoiType.BUS, name: "Nehringa", distance: 753},
        {type: OfferPoiType.BUS, name: "Dojazdowa", distance: 804},
        {type: OfferPoiType.LAS, name: "Uroczysko Kupały", distance: 1362},
        {type: OfferPoiType.REZERWAT, name: "Dolina strumienia Grzęziniec", distance: 2130}
    ],
    20000: [
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 176},
        {type: OfferPoiType.BUS, name: "Marycjusza 01", distance: 189},
        {type: OfferPoiType.BUS, name: "Marycjusza 02", distance: 233},
        {type: OfferPoiType.BUS, name: "Popielidów 02", distance: 358},
        {type: OfferPoiType.BUS, name: "Kruszwicka 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Kruszwicka 01", distance: 486},
        {type: OfferPoiType.BUS, name: "Popielidów 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Os. Mistrzejowice Nowe 02", distance: 783},
        {type: OfferPoiType.BUS, name: "Kupały 02", distance: 792},
        {type: OfferPoiType.BUS, name: "Os. Mistrzejowice Nowe 01", distance: 811},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1585},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 1885},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1904},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 1993},
        {type: OfferPoiType.PARK, name: "Park Generała pilota Stanisława Skalskiego", distance: 2460},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2469}
    ],
    20003: [
        {type: OfferPoiType.BUS, name: "Sikorskiego-Wilczyńskiego", distance: 84},
        {type: OfferPoiType.TRAM, name: "Sikorskiego-Wilczyńskiego", distance: 221},
        {type: OfferPoiType.BUS, name: "Andersa", distance: 227},
        {type: OfferPoiType.BUS, name: "Sikorskiego-Wilczyńskiego 02", distance: 233},
        {type: OfferPoiType.TRAM, name: "Andersa", distance: 261},
        {type: OfferPoiType.BUS, name: "Bartąska", distance: 305},
        {type: OfferPoiType.BUS, name: "Jarocka", distance: 361},
        {type: OfferPoiType.BUS, name: "Kutrzeby 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Osiedle Generałów", distance: 576},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 626},
        {type: OfferPoiType.PARK, name: "Skwer generała Augusta Fieldorfa–Nila", distance: 1449},
        {type: OfferPoiType.PARK, name: "Park Nagórki-Jaroty", distance: 1541},
        {type: OfferPoiType.PARK, name: "Park podworski Pozorty", distance: 2402}
    ],
    20004: [{type: OfferPoiType.PARK, name: "Park Miejski im. Lecha Jana Nitkowskiego", distance: 1734}],
    20011: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 724}
    ],
    20012: [
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1144},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1154},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1648}
    ],
    20013: [{type: OfferPoiType.PARK, name: "Zespół pałacowo-parkowy w Gałowie", distance: 1226}],
    20015: [
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 751},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 1012},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1148},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1236},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 1429},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1512},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2241},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2353}
    ],
    20017: [
        {type: OfferPoiType.BUS, name: "Wiślinka Piaskowa", distance: 363},
        {type: OfferPoiType.BUS, name: "Wiślinka Most", distance: 615}
    ],
    20018: [
        {type: OfferPoiType.BUS, name: "Szczodre-Trzebnicka (na wys. 3a)", distance: 702},
        {type: OfferPoiType.PARK, name: "Park Szczodre", distance: 1936}
    ],
    20026: [
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 221},
        {type: OfferPoiType.BUS, name: "Słona Woda 02", distance: 722},
        {type: OfferPoiType.BUS, name: "Prokocim UJ 02", distance: 746},
        {type: OfferPoiType.BUS, name: "Słona Woda 01", distance: 773},
        {type: OfferPoiType.BUS, name: "Hallera 03", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1094},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1753},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 1914},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 2211},
        {type: OfferPoiType.REZERWAT, name: "Las Krzyszkowicki", distance: 2287},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 2336}
    ],
    20029: [
        {type: OfferPoiType.BUS, name: "Likusy", distance: 211},
        {type: OfferPoiType.BUS, name: "Wioślarska", distance: 459},
        {type: OfferPoiType.BUS, name: "Żbicza", distance: 563},
        {type: OfferPoiType.KOLEJ, name: "Olsztyn Redykajny", distance: 564},
        {type: OfferPoiType.BUS, name: "Letniskowa", distance: 602},
        {type: OfferPoiType.PARK, name: "Skwer Wolnego Tybetu", distance: 2541}
    ],
    20030: [
        {type: OfferPoiType.BUS, name: "Plac Mickiewicza", distance: 417},
        {type: OfferPoiType.BUS, name: "Plac Żwirki i Wigury", distance: 423},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 603},
        {type: OfferPoiType.BUS, name: "Michałowicza Czarnieckiego", distance: 657},
        {type: OfferPoiType.BUS, name: "PCK PKP Lipnik", distance: 779},
        {type: OfferPoiType.BUS, name: "Sobieskiego Wyspiańskiego", distance: 822},
        {type: OfferPoiType.PARK, name: "Park Włókniarzy", distance: 831}
    ],
    20031: [
        {type: OfferPoiType.BUS, name: "Plac Mickiewicza", distance: 227},
        {type: OfferPoiType.BUS, name: "Michałowicza Czarnieckiego", distance: 372},
        {type: OfferPoiType.BUS, name: "Plac Żwirki i Wigury", distance: 448},
        {type: OfferPoiType.BUS, name: "PCK PKP Lipnik", distance: 513},
        {type: OfferPoiType.PARK, name: "Park Włókniarzy", distance: 538},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 625},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Lipnik", distance: 762}
    ],
    20032: [
        {type: OfferPoiType.BUS, name: "Wróbla 01", distance: 133},
        {type: OfferPoiType.BUS, name: "Wróbla 02", distance: 144},
        {type: OfferPoiType.BUS, name: "Dobra 02", distance: 215},
        {type: OfferPoiType.BUS, name: "Dobra 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Zagony", distance: 427},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 588},
        {type: OfferPoiType.BUS, name: "Miedza n/ż 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Miedza n/ż 02", distance: 693},
        {type: OfferPoiType.TRAM, name: "Akademia Muzyczna", distance: 780},
        {type: OfferPoiType.BUS, name: "Brama Nizinna", distance: 792},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1034},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 1188},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 1577}
    ],
    20033: [
        {type: OfferPoiType.BUS, name: "Pogórze-Derdowskiego 02", distance: 615},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 01", distance: 835},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1553},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 2223},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 2384}
    ],
    20036: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Mechaniczna (CRO) NŻ", distance: 257},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego NŻ", distance: 453},
        {type: OfferPoiType.TRAM, name: "Lodowa - Przybyszewskiego", distance: 454},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego", distance: 461},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Lodowa", distance: 473},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Lodowa", distance: 477},
        {type: OfferPoiType.BUS, name: "Maciejewskiego - Dw. Łódź Zarzew", distance: 503},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 554},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 554},
        {type: OfferPoiType.KOLEJ, name: "Łódź Zarzew", distance: 644},
        {type: OfferPoiType.TRAM, name: "Cm. Zarzew", distance: 672},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 861},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 1088},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 1165},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 2220},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2387},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 2471},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2479}
    ],
    20037: [
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 01", distance: 248},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Warmińska 02", distance: 834}
    ],
    20043: [
        {type: OfferPoiType.BUS, name: "Walendów Ogrody", distance: 111},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Kajetany Brzozowa", distance: 625},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 02", distance: 675}
    ],
    20044: [
        {type: OfferPoiType.BUS, name: "Walendów Ogrody", distance: 115},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 01", distance: 614},
        {type: OfferPoiType.BUS, name: "Kajetany Brzozowa", distance: 629},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 02", distance: 671}
    ],
    20051: [
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1793},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 2253},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 2273},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 2401}
    ],
    20054: [
        {type: OfferPoiType.BUS, name: "Plac Bohaterów Getta", distance: 187},
        {type: OfferPoiType.TRAM, name: "Plac Bohaterów Getta 02", distance: 205},
        {type: OfferPoiType.TRAM, name: "Plac Bohaterów Getta 01", distance: 228},
        {type: OfferPoiType.KOLEJ, name: "Kraków Zabłocie", distance: 352},
        {type: OfferPoiType.TRAM, name: "Limanowskiego 02", distance: 367},
        {type: OfferPoiType.TRAM, name: "Limanowskiego 01", distance: 382},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 01", distance: 662},
        {type: OfferPoiType.TRAM, name: "Podgórze SKA 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Dajwór 01", distance: 697},
        {type: OfferPoiType.TRAM, name: "Dajwór 01", distance: 698},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 02", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 748},
        {type: OfferPoiType.TRAM, name: "Podgórze SKA 02", distance: 768},
        {type: OfferPoiType.BUS, name: "Podgórze SKA 03", distance: 792},
        {type: OfferPoiType.BUS, name: "Podgórze SKA 05", distance: 812},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 921},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 950},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1008},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1163},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 1724},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2015}
    ],
    20057: [
        {type: OfferPoiType.BUS, name: "Regulska 01", distance: 778},
        {type: OfferPoiType.BUS, name: "Regulska 02", distance: 786},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 1095},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1532},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 1894},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 2018},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 2040},
        {type: OfferPoiType.PARK, name: "Park Niepodległości", distance: 2124},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 2186},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 2273},
        {type: OfferPoiType.PARK, name: "Park Bogny i Jerzego Sokorskich", distance: 2291},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 2391}
    ],
    20058: [
        {type: OfferPoiType.BUS, name: "Janowska 02", distance: 191},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa 02", distance: 251},
        {type: OfferPoiType.BUS, name: "Janowska 01", distance: 271},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa 03", distance: 292},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa", distance: 318},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa 01", distance: 348},
        {type: OfferPoiType.BUS, name: "Rzepakowa 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Owsiana", distance: 669},
        {type: OfferPoiType.BUS, name: "Rzepakowa 02", distance: 689},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1342}
    ],
    20072: [{type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 781}],
    20073: [
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 01", distance: 134},
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 02", distance: 198},
        {type: OfferPoiType.BUS, name: "Królika 02", distance: 709},
        {type: OfferPoiType.BUS, name: "Starochylicka 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Królika 01", distance: 775}
    ],
    20077: [
        {type: OfferPoiType.BUS, name: "Niwka Tuwima", distance: 95},
        {type: OfferPoiType.BUS, name: "Niwka Szybowa", distance: 439},
        {type: OfferPoiType.BUS, name: "Osiedle Bór Bloki", distance: 536},
        {type: OfferPoiType.BUS, name: "Niwka Fabryka", distance: 555},
        {type: OfferPoiType.TRAM, name: "Niwka Fabryka", distance: 571},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Kłosowskiego", distance: 582},
        {type: OfferPoiType.TRAM, name: "Niwka Kościół", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Wygoda", distance: 1360}
    ],
    20078: [
        {type: OfferPoiType.BUS, name: "Marchewkowa", distance: 299},
        {type: OfferPoiType.BUS, name: "Wałbrzyska", distance: 381},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 501},
        {type: OfferPoiType.LAS, name: "skwer Katyński", distance: 567},
        {type: OfferPoiType.BUS, name: "Zabrodzka", distance: 594},
        {type: OfferPoiType.BUS, name: "Marcepanowa", distance: 602},
        {type: OfferPoiType.TRAM, name: "Klecina", distance: 715},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 1019},
        {type: OfferPoiType.PARK, name: "Park Migdałowy", distance: 1034},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1398},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 1901},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 2043}
    ],
    20080: [
        {type: OfferPoiType.BUS, name: "Bilitewskiego", distance: 679},
        {type: OfferPoiType.BUS, name: "Rubinowa", distance: 807},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 1752}
    ],
    20082: [
        {type: OfferPoiType.BUS, name: "Poświęcka", distance: 282},
        {type: OfferPoiType.BUS, name: "Poświęcka (Ośrodek zdrowia)", distance: 446},
        {type: OfferPoiType.BUS, name: "Żmigrodzka (Obwodnica)", distance: 641},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 713},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 731},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1808}
    ],
    20086: [
        {type: OfferPoiType.BUS, name: "Zacharzyce", distance: 165},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1597},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1955}
    ],
    20087: [
        {type: OfferPoiType.BUS, name: "Stocznia", distance: 103},
        {type: OfferPoiType.BUS, name: "Portowa", distance: 407},
        {type: OfferPoiType.PARK, name: "Plac Majora Janusza Mościckiego", distance: 1606}
    ],
    20088: [
        {type: OfferPoiType.BUS, name: "Wysockiego 02", distance: 144},
        {type: OfferPoiType.BUS, name: "Wysockiego 01", distance: 158},
        {type: OfferPoiType.BUS, name: "Broniewskiego 02", distance: 232},
        {type: OfferPoiType.BUS, name: "Broniewskiego 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Kopernika/Kasprowicza 62", distance: 551},
        {type: OfferPoiType.BUS, name: "Osiedle Wschód 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Osiedle Wschód 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Kopernika/Kasprowicza 17", distance: 609},
        {type: OfferPoiType.BUS, name: "Osiedle Kasprowicza 02", distance: 716},
        {type: OfferPoiType.BUS, name: "Kopernika/Azaliowa 58", distance: 725},
        {type: OfferPoiType.PARK, name: "Park Krainy Polodowcowej", distance: 954}
    ],
    20092: [
        {type: OfferPoiType.BUS, name: "Hubalczyków 02", distance: 227},
        {type: OfferPoiType.BUS, name: "Hubalczyków 01", distance: 299},
        {type: OfferPoiType.BUS, name: "Fort Wola 05", distance: 330},
        {type: OfferPoiType.TRAM, name: "Fort Wola 03", distance: 427},
        {type: OfferPoiType.BUS, name: "Fort Wola 01", distance: 438},
        {type: OfferPoiType.TRAM, name: "Fort Wola 04", distance: 475},
        {type: OfferPoiType.BUS, name: "Fort Wola 06", distance: 489},
        {type: OfferPoiType.BUS, name: "Fort Wola 02", distance: 496},
        {type: OfferPoiType.BUS, name: "P+R Połczyńska 01", distance: 568},
        {type: OfferPoiType.BUS, name: "Jana Kazimierza 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Cm. Wolski 07", distance: 607},
        {type: OfferPoiType.BUS, name: "Cm. Wolski 09", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 620},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 05", distance: 654},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 04", distance: 660},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 03", distance: 666},
        {type: OfferPoiType.TRAM, name: "P+R Połczyńska 03", distance: 687},
        {type: OfferPoiType.TRAM, name: "P+R Połczyńska 04", distance: 689},
        {type: OfferPoiType.PARK, name: "Park Powstańców Warszawy", distance: 1095},
        {type: OfferPoiType.PARK, name: "Polanka", distance: 1234},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Klincewicza", distance: 1325},
        {type: OfferPoiType.PARK, name: "Skwer Wiesława Michnikowskiego", distance: 1398},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1793}
    ],
    20093: [
        {type: OfferPoiType.BUS, name: "Góra Kalwaria Marianki III", distance: 703},
        {type: OfferPoiType.BUS, name: "Kalwaryjska 02", distance: 794},
        {type: OfferPoiType.PARK, name: "Skwer Dominikański", distance: 1275},
        {type: OfferPoiType.PARK, name: "Skwer Marszałka Józefa Piłsudskiego", distance: 1519},
        {type: OfferPoiType.PARK, name: "Skwer Adama i Ewy", distance: 1609},
        {type: OfferPoiType.PARK, name: "Ogród Miejski", distance: 1673},
        {type: OfferPoiType.PARK, name: "Park Witolda Pyrkosza", distance: 1951},
        {type: OfferPoiType.PARK, name: "Ogród Klasztorny", distance: 2040}
    ],
    20094: [
        {type: OfferPoiType.BUS, name: "Techników 01", distance: 19},
        {type: OfferPoiType.BUS, name: "Techników 02", distance: 72},
        {type: OfferPoiType.BUS, name: "Stawy 01", distance: 206},
        {type: OfferPoiType.BUS, name: "Stawy 02", distance: 258},
        {type: OfferPoiType.BUS, name: "Mikołajska 03", distance: 264},
        {type: OfferPoiType.BUS, name: "Płużańska 01", distance: 318},
        {type: OfferPoiType.BUS, name: "Mikołajska 02", distance: 439},
        {type: OfferPoiType.BUS, name: "Płużańska 02", distance: 449},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 557},
        {type: OfferPoiType.BUS, name: "PKP Włochy 02", distance: 574},
        {type: OfferPoiType.BUS, name: "PKP Włochy 01", distance: 607},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Włochy", distance: 772},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 940},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 1266},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 1426},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 2203},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 2362}
    ],
    20098: [
        {type: OfferPoiType.BUS, name: "Młodej Polski 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 02", distance: 370},
        {type: OfferPoiType.BUS, name: "Młodej Polski 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 04", distance: 436},
        {type: OfferPoiType.BUS, name: "Wydział Farmaceutyczny 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Akademia W. Pola 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Orfeusz 03", distance: 681},
        {type: OfferPoiType.BUS, name: "Szpital dziecięcy 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Akademia W. Pola 01", distance: 702},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1974},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 2136}
    ],
    20099: [
        {type: OfferPoiType.BUS, name: "Klasztorna 01", distance: 291},
        {type: OfferPoiType.BUS, name: "Klasztorna 02", distance: 389},
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego 02", distance: 443},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Rembertów", distance: 480},
        {type: OfferPoiType.BUS, name: "Grawerska 01", distance: 481},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 71", distance: 486},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 03", distance: 521},
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego 01", distance: 584},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 04", distance: 590},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 02", distance: 599},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 05", distance: 615},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 1474}
    ],
    20100: [
        {type: OfferPoiType.BUS, name: "Twardzickiego / Łochowskiego", distance: 205},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Kleina", distance: 299},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Bołtucia", distance: 633},
        {type: OfferPoiType.BUS, name: "Korfantego / Prejsa", distance: 768},
        {type: OfferPoiType.BUS, name: "Pod Skarpą / Frydrychowicza", distance: 775},
        {type: OfferPoiType.PARK, name: "Dolina Śmierci", distance: 1138},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1885},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 2241}
    ],
    20101: [
        {type: OfferPoiType.BUS, name: "Anielewicza 03", distance: 142},
        {type: OfferPoiType.TRAM, name: "Anielewicza 06", distance: 143},
        {type: OfferPoiType.BUS, name: "Anielewicza 04", distance: 193},
        {type: OfferPoiType.BUS, name: "Anielewicza 01", distance: 196},
        {type: OfferPoiType.TRAM, name: "Anielewicza 05", distance: 199},
        {type: OfferPoiType.BUS, name: "Anielewicza 02", distance: 201},
        {type: OfferPoiType.BUS, name: "Nalewki-Muzeum 01", distance: 312},
        {type: OfferPoiType.BUS, name: "Nalewki-Muzeum 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Smocza 03", distance: 373},
        {type: OfferPoiType.BUS, name: "Smocza 04", distance: 408},
        {type: OfferPoiType.PARK, name: "Skwer gen. Jana Jura-Gorzechowskiego", distance: 417},
        {type: OfferPoiType.BUS, name: "Nowolipki 03", distance: 426},
        {type: OfferPoiType.TRAM, name: "Nowolipki 06", distance: 454},
        {type: OfferPoiType.BUS, name: "Nowolipki 02", distance: 461},
        {type: OfferPoiType.TRAM, name: "Nowolipki 05", distance: 496},
        {type: OfferPoiType.TRAM, name: "Stawki 06", distance: 569},
        {type: OfferPoiType.PARK, name: "Skwer Więźniów Politycznych Stalinizmu", distance: 618},
        {type: OfferPoiType.PARK, name: "Skwer Racheli Auerbach", distance: 625},
        {type: OfferPoiType.TRAM, name: "Muranów 06", distance: 644},
        {type: OfferPoiType.TRAM, name: "Muranów 05", distance: 651},
        {type: OfferPoiType.TRAM, name: "Stawki 05", distance: 652},
        {type: OfferPoiType.TRAM, name: "Kino Femina 06", distance: 764},
        {type: OfferPoiType.TRAM, name: "Dzika 03", distance: 765},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 768},
        {type: OfferPoiType.PARK, name: "Ogród Krasińskich", distance: 946},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 1866}
    ],
    20103: [
        {type: OfferPoiType.BUS, name: "Żywiecka 02", distance: 584},
        {type: OfferPoiType.BUS, name: "Żywiecka 01", distance: 732},
        {type: OfferPoiType.BUS, name: "Kępna 01", distance: 742},
        {type: OfferPoiType.BUS, name: "Rynek Fałęcki 01", distance: 787},
        {type: OfferPoiType.BUS, name: "Rynek Fałęcki 02", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Solvay", distance: 914},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 1271},
        {type: OfferPoiType.PARK, name: "Park rzeczny Wilgi", distance: 1625},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1850}
    ],
    20105: [
        {type: OfferPoiType.BUS, name: "Cystersów 03", distance: 170},
        {type: OfferPoiType.TRAM, name: "Cystersów 02", distance: 261},
        {type: OfferPoiType.TRAM, name: "Cystersów 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 07", distance: 405},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 06", distance: 507},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 04", distance: 521},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 03", distance: 549},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 02", distance: 552},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 01", distance: 554},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 09", distance: 592},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 05", distance: 600},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 08", distance: 613},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Polaków Poszkodowanych przez III Rzeszę", distance: 622},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 631},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie Opera 02", distance: 672},
        {type: OfferPoiType.BUS, name: "Brodowicza 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Brodowicza 02", distance: 742},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 780},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 796},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 804},
        {type: OfferPoiType.BUS, name: "Białucha 03", distance: 844},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 945},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 979},
        {type: OfferPoiType.PARK, name: "Ogród Fabryczny", distance: 1029},
        {type: OfferPoiType.PARK, name: "Ogród Kasztanowy", distance: 1318},
        {type: OfferPoiType.PARK, name: "Park Strzelecki", distance: 1332},
        {type: OfferPoiType.PARK, name: "Łąka na Wesołej", distance: 1398},
        {type: OfferPoiType.PARK, name: "Skwer Pilota Pirxa", distance: 1562},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2246},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2475}
    ],
    20115: [
        {type: OfferPoiType.BUS, name: "Kacze Buki Puszczyka 01", distance: 235},
        {type: OfferPoiType.BUS, name: "Bieszczadzka 02 (ŃŻ)", distance: 308},
        {type: OfferPoiType.BUS, name: "Bieszczadzka", distance: 309},
        {type: OfferPoiType.BUS, name: "Bieszczadzka 01 (ŃŻ)", distance: 311}
    ],
    20116: [
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 01", distance: 219},
        {type: OfferPoiType.BUS, name: "Młodej Polski 01", distance: 390},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 02", distance: 407},
        {type: OfferPoiType.BUS, name: "Wydział Farmaceutyczny 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 04", distance: 473},
        {type: OfferPoiType.BUS, name: "Młodej Polski 02", distance: 535},
        {type: OfferPoiType.BUS, name: "Chodźki - szpital 01", distance: 713},
        {type: OfferPoiType.BUS, name: "Orfeusz 03", distance: 718},
        {type: OfferPoiType.BUS, name: "Szpital dziecięcy 02", distance: 727},
        {type: OfferPoiType.BUS, name: "Chodźki - szpital 03", distance: 758},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 2114},
        {type: OfferPoiType.PARK, name: "50-lecia", distance: 2120},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 2132}
    ],
    20117: [
        {type: OfferPoiType.BUS, name: "Bojano 61", distance: 672},
        {type: OfferPoiType.BUS, name: "Bojano", distance: 673},
        {type: OfferPoiType.BUS, name: "Bojano 18", distance: 674}
    ],
    20118: [{type: OfferPoiType.BUS, name: "Bartąg Fiołkowa P", distance: 819}],
    20119: [
        {type: OfferPoiType.BUS, name: "Tartaczna/Straż Graniczna (122)", distance: 258},
        {type: OfferPoiType.BUS, name: "Tartaczna/Bloki (123)", distance: 339},
        {type: OfferPoiType.BUS, name: "Tartaczna/Pętla (113)", distance: 367},
        {type: OfferPoiType.BUS, name: "Turystyczna/Augustowianka (n/ż) (44)", distance: 370},
        {type: OfferPoiType.BUS, name: "Turystyczna/Rozlewnia Augustowianki (n/ż) (3)", distance: 382},
        {type: OfferPoiType.BUS, name: "Turystyczna/Wypoczynkowa (n/ż) (2)", distance: 440},
        {type: OfferPoiType.BUS, name: "Turystyczna/Jednostka Wojskowa (124) (n/ż)", distance: 490},
        {type: OfferPoiType.BUS, name: "Tartaczna/Os. Lipowiec (73)", distance: 492},
        {type: OfferPoiType.BUS, name: "Tartaczna/Szkoła nr 6 (42)", distance: 614},
        {type: OfferPoiType.PARK, name: "Park Herberta", distance: 807},
        {type: OfferPoiType.LAS, name: "7", distance: 905}
    ],
    20121: [
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 08", distance: 173},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 03", distance: 265},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 04", distance: 304},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 02", distance: 318},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 03", distance: 327},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 04", distance: 333},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 05", distance: 344},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 06", distance: 355},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 01", distance: 364},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 06", distance: 372},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 01", distance: 381},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 07", distance: 432},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 05", distance: 437},
        {type: OfferPoiType.BUS, name: "Arka Pana 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Os. Zgody 04", distance: 473},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 01", distance: 522},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 02", distance: 539},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 660},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 697},
        {type: OfferPoiType.TRAM, name: "Cienista 02", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 956},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1177},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 1194},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 1233},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1555},
        {type: OfferPoiType.PARK, name: "Ogródek Wiewiórek", distance: 1623},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1891}
    ],
    20123: [
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 08", distance: 173},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 03", distance: 265},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 04", distance: 304},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 02", distance: 318},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 03", distance: 327},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 04", distance: 333},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 05", distance: 344},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 06", distance: 355},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 01", distance: 364},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 06", distance: 372},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 01", distance: 381},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 07", distance: 432},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 05", distance: 437},
        {type: OfferPoiType.BUS, name: "Arka Pana 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Os. Zgody 04", distance: 473},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 01", distance: 522},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 02", distance: 539},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 660},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 697},
        {type: OfferPoiType.TRAM, name: "Cienista 02", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 956},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1177},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 1194},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 1233},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1555},
        {type: OfferPoiType.PARK, name: "Ogródek Wiewiórek", distance: 1623},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1891}
    ],
    20125: [
        {type: OfferPoiType.BUS, name: "Pylna 02", distance: 410},
        {type: OfferPoiType.BUS, name: "Pylna 01", distance: 416},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 1659},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1906},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 2052},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2173}
    ],
    20126: [
        {type: OfferPoiType.BUS, name: "Grabowa 01", distance: 164},
        {type: OfferPoiType.BUS, name: "Grabowa 02", distance: 267},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 02", distance: 484},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 01", distance: 709},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 02", distance: 719},
        {type: OfferPoiType.BUS, name: "Zielony Dół 01", distance: 739},
        {type: OfferPoiType.BUS, name: "Zielony Dół 02", distance: 782},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1084},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 1357}
    ],
    20127: [
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1838},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1984},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2105},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 2441}
    ],
    20128: [
        {type: OfferPoiType.BUS, name: "Pylna 02", distance: 161},
        {type: OfferPoiType.BUS, name: "Pylna 01", distance: 167},
        {type: OfferPoiType.BUS, name: "Kraków Zakliki", distance: 685},
        {type: OfferPoiType.KOLEJ, name: "Kraków Zakliki", distance: 755},
        {type: OfferPoiType.BUS, name: "Zakliki SKA 02", distance: 798},
        {type: OfferPoiType.BUS, name: "Zakliki SKA 01", distance: 801},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 1410},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2258},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 2404},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2525}
    ],
    20129: [
        {type: OfferPoiType.BUS, name: "Grabowa 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Grabowa 01", distance: 277},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 01", distance: 525},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 02", distance: 535},
        {type: OfferPoiType.BUS, name: "Zielony Dół 01", distance: 594},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 02", distance: 613},
        {type: OfferPoiType.BUS, name: "Zielony Dół 02", distance: 637},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 01", distance: 689},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1222},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1368},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 1489}
    ],
    20130: [
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1886},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 2032},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2153},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 2489}
    ],
    20133: [
        {type: OfferPoiType.BUS, name: "Miłosza Szkoła", distance: 786},
        {type: OfferPoiType.PARK, name: "park Warszewo-Podbórz", distance: 1880},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 2175},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 2208}
    ],
    20134: [
        {type: OfferPoiType.BUS, name: "Okrągła 01", distance: 222},
        {type: OfferPoiType.BUS, name: "Sieczna 02", distance: 286},
        {type: OfferPoiType.BUS, name: "Okrągła 02", distance: 332},
        {type: OfferPoiType.BUS, name: "Sieczna 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Os. Derby 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Os. Derby 01", distance: 494},
        {type: OfferPoiType.BUS, name: "Os. Derby 04", distance: 515},
        {type: OfferPoiType.BUS, name: "Podwójna 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 01", distance: 590},
        {type: OfferPoiType.BUS, name: "Podwójna 02", distance: 607},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 782}
    ],
    20136: [
        {type: OfferPoiType.BUS, name: "Gen. Maczka 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 04", distance: 456},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 03", distance: 489},
        {type: OfferPoiType.BUS, name: "Park Olszyna 06", distance: 496},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 01", distance: 531},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 03", distance: 584},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 04", distance: 640},
        {type: OfferPoiType.BUS, name: "Park Olszyna 02", distance: 643},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 04", distance: 652},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 01", distance: 671},
        {type: OfferPoiType.BUS, name: "Włościańska 01", distance: 685},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 02", distance: 693},
        {type: OfferPoiType.TRAM, name: "Romaszewskiego 03", distance: 824},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 853},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1338},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1339},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1402},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 1686},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1723},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1779},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 1824}
    ],
    20138: [
        {type: OfferPoiType.BUS, name: "Gen. Maczka 02", distance: 148},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 04", distance: 221},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 03", distance: 254},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 01", distance: 296},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 02", distance: 458},
        {type: OfferPoiType.BUS, name: "Park Olszyna 06", distance: 506},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 01", distance: 576},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 03", distance: 594},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 04", distance: 650},
        {type: OfferPoiType.BUS, name: "Park Olszyna 02", distance: 653},
        {type: OfferPoiType.BUS, name: "Włościańska 01", distance: 695},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 04", distance: 743},
        {type: OfferPoiType.TRAM, name: "Romaszewskiego 03", distance: 834},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 863},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1103},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1349},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1544},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1589},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 1696},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1733},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 1834}
    ],
    20145: [
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 421},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Powst. Listopad. 06", distance: 499},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 537},
        {type: OfferPoiType.BUS, name: "Krzyżanowskiego / Armii Krajowej 04", distance: 656},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 660},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 694},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Krzyżanowskiego 03", distance: 702},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 1912},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 2141}
    ],
    20146: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Powst. Listopad. 06", distance: 367},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 412},
        {type: OfferPoiType.BUS, name: "Krzyżanowskiego / Armii Krajowej 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 528},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Krzyżanowskiego 03", distance: 570},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 639},
        {type: OfferPoiType.BUS, name: "Krzyżanowskiego / Paderewskiego 03", distance: 668},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 685},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 731},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Mieszka I 05", distance: 762},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 1780},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 2132}
    ],
    20147: [
        {type: OfferPoiType.BUS, name: "Warmińska 02", distance: 332},
        {type: OfferPoiType.BUS, name: "Warmińska 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Bruszewska 01", distance: 746}
    ],
    20151: [
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 564},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 600},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 722},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 731},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 733},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 755},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 757},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 759},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 760},
        {type: OfferPoiType.BUS, name: "Ludwinów 01", distance: 768},
        {type: OfferPoiType.BUS, name: "Ludwinów 02", distance: 812},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 819},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1053},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1133},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1433},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1493},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1505},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1682},
        {type: OfferPoiType.PARK, name: "skwer Zdrowia", distance: 1772},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1858},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2147},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2326},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2383}
    ],
    20153: [
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 379},
        {type: OfferPoiType.BUS, name: "Marysińska - Szklana", distance: 434},
        {type: OfferPoiType.BUS, name: "Marysińska - Okopowa", distance: 482},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Park Szarych Szeregów", distance: 547},
        {type: OfferPoiType.BUS, name: "Marysin Stadion", distance: 553},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Okopowa", distance: 589},
        {type: OfferPoiType.BUS, name: "Obr. Westerplatte - Organizacji WiN", distance: 722},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Sucharskiego", distance: 726},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 917},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1283},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1357},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1401},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1502},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1632}
    ],
    20159: [
        {type: OfferPoiType.PARK, name: "Małe Wilczyce", distance: 238},
        {type: OfferPoiType.BUS, name: "Kiełczowska (Cmentarz)", distance: 324}
    ],
    20161: [
        {type: OfferPoiType.BUS, name: "Krynoliny 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Krynoliny 02", distance: 188},
        {type: OfferPoiType.PARK, name: "Park linearny nad Kanałem Zaciszańskim", distance: 488},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 04", distance: 555},
        {type: OfferPoiType.BUS, name: "Bystra 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Bystra 01", distance: 588},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Codzienna 02", distance: 682},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 01", distance: 696},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 03", distance: 731},
        {type: OfferPoiType.BUS, name: "Codzienna 01", distance: 782},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1856},
        {type: OfferPoiType.PARK, name: "Skwer Ekologiczny", distance: 1926},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 2260}
    ],
    20163: [
        {type: OfferPoiType.BUS, name: "Karolin 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Karolin 01", distance: 649}
    ],
    20164: [
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Traugutta", distance: 457},
        {type: OfferPoiType.BUS, name: "Traugutta - Sienkiewicza", distance: 463},
        {type: OfferPoiType.BUS, name: "Łódzka Inf. Turystyczna", distance: 505},
        {type: OfferPoiType.BUS, name: "Jaracza - Piotrkowska", distance: 508},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Narutowicza", distance: 519},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Narutowicza", distance: 526},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 639},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 642},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 660},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 669},
        {type: OfferPoiType.BUS, name: "Jaracza - Kilińskiego", distance: 670},
        {type: OfferPoiType.TRAM, name: "Zachodnia - Więckowskiego", distance: 686},
        {type: OfferPoiType.BUS, name: "Narutowicza - P.O.W. NŻ", distance: 689},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 693},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 704},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 717},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Zachodnia", distance: 721},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 741},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 839},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 904},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 908},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 928}
    ],
    20165: [
        {type: OfferPoiType.BUS, name: "Widzewska - Wiejska", distance: 195},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Widzew Stadion", distance: 554},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Widzew Stadion", distance: 554},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 879},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 880},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 1157},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 1907},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2054},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 2497}
    ],
    20168: [
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 08", distance: 171},
        {type: OfferPoiType.BUS, name: "Galeria Copernicus 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego II 07", distance: 358},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 05", distance: 370},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 04", distance: 427},
        {type: OfferPoiType.TRAM, name: "Plac Daszyńskiego 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 06", distance: 508},
        {type: OfferPoiType.TRAM, name: "Plac Daszyńskiego 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 03", distance: 595},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 02", distance: 639},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 01", distance: 703},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 06", distance: 819},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 1433},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 1860}
    ],
    20177: [
        {type: OfferPoiType.BUS, name: "Małomiejska", distance: 155},
        {type: OfferPoiType.BUS, name: "Platynowa 01", distance: 534},
        {type: OfferPoiType.BUS, name: "Platynowa 04", distance: 621},
        {type: OfferPoiType.BUS, name: "Ptasia", distance: 648},
        {type: OfferPoiType.BUS, name: "Platynowa 02", distance: 686},
        {type: OfferPoiType.BUS, name: "Platynowa 03", distance: 692},
        {type: OfferPoiType.BUS, name: "Orunia Górna 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Ptasia 02", distance: 738},
        {type: OfferPoiType.BUS, name: "Chełm - Więckowskiego 01", distance: 740},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1154},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Dolina Potoku Oruńskiego"', distance: 1222},
        {type: OfferPoiType.PARK, name: "Park Oruński im. Emilii Hoene", distance: 1549},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1661},
        {type: OfferPoiType.PARK, name: 'Skwer im. Danuty Siedzikówny "Inki"', distance: 1703},
        {type: OfferPoiType.PARK, name: "Park Schopenhauera", distance: 1770}
    ],
    20178: [
        {type: OfferPoiType.BUS, name: "Torfowa 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Torfowa 01", distance: 325},
        {type: OfferPoiType.BUS, name: "Zachodnia 01", distance: 376},
        {type: OfferPoiType.BUS, name: "Zachodnia 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Lubostroń 01", distance: 665},
        {type: OfferPoiType.BUS, name: "Lubostroń 03", distance: 672},
        {type: OfferPoiType.BUS, name: "Lubostroń 04", distance: 698},
        {type: OfferPoiType.BUS, name: "Lubostroń 02", distance: 807},
        {type: OfferPoiType.BUS, name: "Kampus UP JP II 03", distance: 814},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1194},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 2033},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2285}
    ],
    20179: [
        {type: OfferPoiType.BUS, name: "Wrocław Szczepin", distance: 204},
        {type: OfferPoiType.TRAM, name: "Wrocław Szczepin", distance: 204},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Szczepin", distance: 225},
        {type: OfferPoiType.TRAM, name: "Długa (ogrody działkowe)", distance: 407},
        {type: OfferPoiType.BUS, name: "Długa (ogrody działkowe)", distance: 421},
        {type: OfferPoiType.BUS, name: "Litomska (ZUS)", distance: 534},
        {type: OfferPoiType.BUS, name: "Michalczyka", distance: 582},
        {type: OfferPoiType.TRAM, name: "Michalczyka", distance: 596},
        {type: OfferPoiType.PARK, name: "skwer Świętego Ojca Damiana de Veuster", distance: 897},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 2401}
    ],
    20180: [
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 08", distance: 219},
        {type: OfferPoiType.BUS, name: "Ustronie / Radomskiego", distance: 303},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 05", distance: 316},
        {type: OfferPoiType.BUS, name: "Biała / Indycza (Tymczasowy)", distance: 418},
        {type: OfferPoiType.BUS, name: "Wyścigowa / Radomskiego", distance: 466},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 06", distance: 526},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Słowackiego 07", distance: 555},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 03", distance: 674},
        {type: OfferPoiType.PARK, name: "Park Ustronie", distance: 1661},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Ruzika", distance: 1912},
        {type: OfferPoiType.PARK, name: "Sadek", distance: 2139},
        {type: OfferPoiType.PARK, name: "Plac Kazimierza Ołdakowskiego", distance: 2213}
    ],
    20181: [
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 02", distance: 356},
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 01", distance: 511},
        {type: OfferPoiType.PARK, name: "Park księdza kanonika Kazimierza Orkusza", distance: 1206},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 1930},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 2005}
    ],
    20183: [
        {type: OfferPoiType.BUS, name: "Reduta 02", distance: 336},
        {type: OfferPoiType.BUS, name: "Reduta 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 04", distance: 654},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R", distance: 714},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 01", distance: 721},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 02", distance: 791},
        {type: OfferPoiType.LAS, name: "Park Krakowian - Węgrzecka", distance: 838},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1594},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 1634},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 2071}
    ],
    20185: [{type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1896}],
    20186: [
        {type: OfferPoiType.BUS, name: "Okrągła 01", distance: 384},
        {type: OfferPoiType.BUS, name: "Okrągła 02", distance: 414},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Sieczna 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 02", distance: 722},
        {type: OfferPoiType.BUS, name: "Os. Derby III 02", distance: 761},
        {type: OfferPoiType.BUS, name: "Sieczna 01", distance: 763},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1381}
    ],
    20192: [
        {type: OfferPoiType.BUS, name: "Jutrosińska", distance: 112},
        {type: OfferPoiType.BUS, name: "Gąsiorowskiego", distance: 216},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 325},
        {type: OfferPoiType.BUS, name: "Kamieńskiego (Szpital)", distance: 374},
        {type: OfferPoiType.BUS, name: "Mochnackiego", distance: 595},
        {type: OfferPoiType.BUS, name: "Kamieńskiego (pętla)", distance: 660},
        {type: OfferPoiType.BUS, name: "Kamieńskiego (Pętla)", distance: 662},
        {type: OfferPoiType.PARK, name: "skwer Władysława Bełzy", distance: 1290},
        {type: OfferPoiType.PARK, name: "Park Jana Kasprowicza", distance: 1511}
    ],
    20195: [
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 126},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 143},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 348},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 392},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 394},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 405},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 474},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 497},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 03", distance: 808},
        {type: OfferPoiType.TRAM, name: "Piasta Kołodzieja 02", distance: 814},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1312},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1335},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 2437},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2443}
    ],
    20199: [
        {type: OfferPoiType.BUS, name: "11 Listopada I", distance: 239},
        {type: OfferPoiType.BUS, name: "Sitarska-Kępy I", distance: 338},
        {type: OfferPoiType.BUS, name: "Sitarska-Kępy II", distance: 353},
        {type: OfferPoiType.BUS, name: "11 Listopada II", distance: 418},
        {type: OfferPoiType.BUS, name: "Ogrody", distance: 571},
        {type: OfferPoiType.BUS, name: "Księdza Popiełuszki", distance: 587},
        {type: OfferPoiType.BUS, name: "Budowlanka", distance: 629},
        {type: OfferPoiType.BUS, name: "Skwer Saski", distance: 839},
        {type: OfferPoiType.BUS, name: "Długa", distance: 842},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 962},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 985},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1125}
    ],
    20200: [
        {type: OfferPoiType.TRAM, name: "Rycerska [końcowy]", distance: 153},
        {type: OfferPoiType.BUS, name: "Rycerska [końcowy]", distance: 174},
        {type: OfferPoiType.BUS, name: "Rycerska", distance: 174},
        {type: OfferPoiType.TRAM, name: "Rycerska", distance: 210},
        {type: OfferPoiType.BUS, name: "Zaświat / Artyleryjska", distance: 362},
        {type: OfferPoiType.BUS, name: "Artyleryjska / Zaświat", distance: 392},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny", distance: 645},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 687},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 1466},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Floriana Czakiego", distance: 1522},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 1602},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 1649},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 1724},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 1728}
    ],
    20201: [
        {type: OfferPoiType.BUS, name: "Prosta 01", distance: 321},
        {type: OfferPoiType.BUS, name: "Prosta 02", distance: 365},
        {type: OfferPoiType.BUS, name: "Prokocim Rynek 01", distance: 377},
        {type: OfferPoiType.BUS, name: "Prokocim Rynek 02", distance: 472},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 476},
        {type: OfferPoiType.TRAM, name: "Wlotowa 02", distance: 701},
        {type: OfferPoiType.TRAM, name: "Wlotowa 01", distance: 731},
        {type: OfferPoiType.KOLEJ, name: "Kraków Prokocim", distance: 738},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 763},
        {type: OfferPoiType.BUS, name: "Wlotowa 03", distance: 765},
        {type: OfferPoiType.BUS, name: "Wlotowa 04", distance: 766},
        {type: OfferPoiType.BUS, name: "Młodzieży 02", distance: 780},
        {type: OfferPoiType.BUS, name: "Młodzieży 01", distance: 820},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 956},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1689},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1900},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 2183}
    ],
    20202: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Mały Skręt", distance: 653},
        {type: OfferPoiType.BUS, name: "Łódzka - Mały Skręt", distance: 764},
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 790},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2222},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2423}
    ],
    20204: [
        {type: OfferPoiType.BUS, name: "Jordanowska 02", distance: 136},
        {type: OfferPoiType.BUS, name: "Jordanowska 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Skrajna 01", distance: 429},
        {type: OfferPoiType.BUS, name: "Chabrowa 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Skrajna 02", distance: 521},
        {type: OfferPoiType.BUS, name: "Jordanowska 04", distance: 539},
        {type: OfferPoiType.BUS, name: "Chabrowa 01", distance: 606},
        {type: OfferPoiType.BUS, name: "Pełczyńskiego 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Pełczyńskiego 02", distance: 666},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 942},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1422},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1807},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 1975},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 2097},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2348}
    ],
    20205: [
        {type: OfferPoiType.BUS, name: "Zielonki 02", distance: 797},
        {type: OfferPoiType.BUS, name: "Zielonki 01", distance: 836}
    ],
    20207: [
        {type: OfferPoiType.BUS, name: "Tarczyński Arena (Królewiecka)", distance: 3},
        {type: OfferPoiType.BUS, name: "Królewiecka", distance: 278},
        {type: OfferPoiType.BUS, name: "Maślicka (Osiedle)", distance: 317},
        {type: OfferPoiType.TRAM, name: "Tarczyński Arena (Królewiecka)", distance: 319},
        {type: OfferPoiType.TRAM, name: "Dworska", distance: 491},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1380},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 1437},
        {type: OfferPoiType.REZERWAT, name: "Las Pilczycki", distance: 2097}
    ],
    20209: [
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 285},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 306},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 370},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 374},
        {type: OfferPoiType.BUS, name: "Nadziei 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Nadziei 02", distance: 607}
    ],
    20211: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 765},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 776},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 957},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1416},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1711},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1805},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 2052},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 2072},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 2098},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 2173},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 2262}
    ],
    20216: [
        {type: OfferPoiType.BUS, name: "Młyn Michla 01", distance: 98},
        {type: OfferPoiType.BUS, name: "Młyn Michla 02", distance: 148},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 02", distance: 300},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 03", distance: 303},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 01", distance: 310},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 343},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 370},
        {type: OfferPoiType.TRAM, name: "Wojnicka 01", distance: 531},
        {type: OfferPoiType.BUS, name: "Siarczana 03", distance: 620},
        {type: OfferPoiType.TRAM, name: "Wojnicka 02", distance: 632},
        {type: OfferPoiType.BUS, name: "Dw. Wschodni (Kijowska) 16", distance: 642},
        {type: OfferPoiType.TRAM, name: "Dw. Wschodni (Kijowska) 71", distance: 664},
        {type: OfferPoiType.BUS, name: "Siarczana 01", distance: 727},
        {type: OfferPoiType.BUS, name: "Siarczana 02", distance: 764},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Praga 01", distance: 769},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 780},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1534},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1797},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1899}
    ],
    20217: [{type: OfferPoiType.BUS, name: "Leźnieńska 01", distance: 254}],
    20218: [
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Świętojańska 01", distance: 276},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Świętojańska", distance: 277},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Świętojańska 02", distance: 297},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski 51", distance: 346},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski 01", distance: 390},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski", distance: 398},
        {type: OfferPoiType.BUS, name: "10 Lutego - Skwer Kościuszki 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Skwer Kościuszki - InfoBox 04", distance: 443},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Jana z Kolna", distance: 451},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 539},
        {type: OfferPoiType.PARK, name: "Park Rady Europy", distance: 554},
        {type: OfferPoiType.PARK, name: "Plac Wolnej Ukrainy", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Marii i Lecha Kaczyńskich", distance: 1043},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1132},
        {type: OfferPoiType.PARK, name: "Gdyński Park Kieszonkowy", distance: 1557},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 1652}
    ],
    20220: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 122},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 509},
        {type: OfferPoiType.TRAM, name: "Żeromskiego", distance: 546},
        {type: OfferPoiType.BUS, name: "Żeromskiego n/ż", distance: 579},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 679},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 698},
        {type: OfferPoiType.BUS, name: "Rynek Jeżycki", distance: 703},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1599},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1636},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1695},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1775},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1845},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1868},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 2000},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 2016},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 2039}
    ],
    20222: [
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 01", distance: 239},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 02", distance: 257},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 371},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 02", distance: 378},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 01", distance: 389},
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 02", distance: 409},
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 01", distance: 521},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 04", distance: 608},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 01", distance: 662},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 06", distance: 685},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 02", distance: 697},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 05", distance: 698},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 989},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 1214},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1331},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1362},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1426},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1630}
    ],
    20223: [
        {type: OfferPoiType.BUS, name: "Chopina/Pileckiego (03)", distance: 323},
        {type: OfferPoiType.BUS, name: "Pileckiego / Rondo(03)", distance: 441},
        {type: OfferPoiType.BUS, name: "Chopina / Os. Chopina Park (02) na żądanie", distance: 581},
        {type: OfferPoiType.BUS, name: "Pileckiego / K. O. Faka (02) na żądanie", distance: 592},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego / Pileckiego (01) na żądanie", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Północny", distance: 1436}
    ],
    20224: [
        {type: OfferPoiType.PARK, name: "Skwer Powstańców Warszawy", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci", distance: 1814},
        {type: OfferPoiType.PARK, name: "Park Glinianki", distance: 2365}
    ],
    20225: [
        {type: OfferPoiType.BUS, name: "Świętego Floriana", distance: 77},
        {type: OfferPoiType.TRAM, name: "Celna", distance: 251},
        {type: OfferPoiType.BUS, name: "Celna", distance: 261},
        {type: OfferPoiType.BUS, name: "SKM Łasztownia", distance: 426},
        {type: OfferPoiType.BUS, name: "Zbożowa", distance: 470},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 597},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego", distance: 620},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Łasztownia", distance: 624},
        {type: OfferPoiType.TRAM, name: "SKM Port Centralny", distance: 813},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 946},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1071},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1577},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1720},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 1999},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 1999},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 2025},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 2205},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 2346},
        {type: OfferPoiType.LAS, name: "Park imienia Stanisława Nadratowskiego", distance: 2445},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Nadratowskiego", distance: 2445}
    ],
    20226: [
        {type: OfferPoiType.BUS, name: "Bohaterów Getta/Bank", distance: 230},
        {type: OfferPoiType.BUS, name: "Poleska/Czysta", distance: 314},
        {type: OfferPoiType.BUS, name: "Bohaterów Getta/Poleska", distance: 320},
        {type: OfferPoiType.BUS, name: "Poleska/Sitarska", distance: 373},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego/Waryńskiego", distance: 377},
        {type: OfferPoiType.BUS, name: "Częstochowska/Piłsudskiego", distance: 388},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego/Częstochowska", distance: 402},
        {type: OfferPoiType.PARK, name: "Plac Mordechaja Tenenbauma", distance: 419},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego / Domus (Komunikacja regionalna)", distance: 447},
        {type: OfferPoiType.BUS, name: "Sitarska/Kozłowa", distance: 508},
        {type: OfferPoiType.BUS, name: "Poleska/Jurowiecka", distance: 530},
        {type: OfferPoiType.PARK, name: "Skwery Tamary Sołoniewicz", distance: 708},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1072},
        {type: OfferPoiType.PARK, name: "Bulwary Ireny Sendlerowej", distance: 1084},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Stanisława Hałko", distance: 1094},
        {type: OfferPoiType.PARK, name: "Park im. Jadwigi Dziekońskiej", distance: 1108},
        {type: OfferPoiType.PARK, name: "Plac Błogosławionego Księdza Michała Sopoćki", distance: 1119},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Aleksandra Chodyki", distance: 1201},
        {type: OfferPoiType.PARK, name: "Skwer Armii Krajowej", distance: 1258},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1285}
    ],
    20227: [
        {type: OfferPoiType.BUS, name: "Gutkowo-Przyjazna", distance: 657},
        {type: OfferPoiType.BUS, name: "Żółkiewskiego", distance: 759}
    ],
    20231: [{type: OfferPoiType.PARK, name: "Park Pułkownika Mieczysława Chojnackiego „Młodzika”", distance: 2178}],
    20232: [
        {type: OfferPoiType.TRAM, name: "Teatr Variété 01", distance: 533},
        {type: OfferPoiType.TRAM, name: "Teatr Variété 02", distance: 563},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 579},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 07", distance: 618},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 04", distance: 619},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 05", distance: 628},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 647},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 01", distance: 647},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 06", distance: 699},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 02", distance: 714},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 03", distance: 733},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 08", distance: 738},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 786},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 794},
        {type: OfferPoiType.BUS, name: "Nullo 03", distance: 794},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 804},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Grzegórzecki", distance: 848},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 1100},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1185},
        {type: OfferPoiType.PARK, name: "Łąka na Wesołej", distance: 1432},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2170},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2506}
    ],
    20237: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 493},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 574},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 587},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 790},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 811},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 825},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1079},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1087},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1770},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1889},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1966},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2113},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2223}
    ],
    20245: [
        {type: OfferPoiType.BUS, name: "Złota 02", distance: 210},
        {type: OfferPoiType.BUS, name: "Złota 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Baza na Pogórzu Dolnym 01", distance: 398},
        {type: OfferPoiType.BUS, name: "Kadmowa 02", distance: 485},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Kadmowa", distance: 493},
        {type: OfferPoiType.BUS, name: "Kadmowa 01", distance: 494},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne", distance: 519},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne 03", distance: 520},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne 02", distance: 539},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1364},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 2356}
    ],
    20247: [
        {type: OfferPoiType.PARK, name: "Park Sowińskiego", distance: 269},
        {type: OfferPoiType.BUS, name: "Planetarium", distance: 338},
        {type: OfferPoiType.BUS, name: "Sienkiewicza", distance: 453},
        {type: OfferPoiType.BUS, name: "Stare Miasto (PLAC POCZTOWY)", distance: 479},
        {type: OfferPoiType.BUS, name: "Długa", distance: 525},
        {type: OfferPoiType.BUS, name: "Drzewna (NŻ)", distance: 633},
        {type: OfferPoiType.BUS, name: "Ogrodowa", distance: 662},
        {type: OfferPoiType.PARK, name: "Park Kolei Szprotawskiej", distance: 666},
        {type: OfferPoiType.PARK, name: "Park Winny", distance: 831},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 950}
    ],
    20253: [
        {type: OfferPoiType.PARK, name: "Park Sowińskiego", distance: 268},
        {type: OfferPoiType.BUS, name: "Planetarium", distance: 337},
        {type: OfferPoiType.BUS, name: "Sienkiewicza", distance: 452},
        {type: OfferPoiType.BUS, name: "Stare Miasto (PLAC POCZTOWY)", distance: 478},
        {type: OfferPoiType.BUS, name: "Długa", distance: 526},
        {type: OfferPoiType.BUS, name: "Drzewna (NŻ)", distance: 632},
        {type: OfferPoiType.BUS, name: "Ogrodowa", distance: 663},
        {type: OfferPoiType.PARK, name: "Park Kolei Szprotawskiej", distance: 667},
        {type: OfferPoiType.PARK, name: "Park Winny", distance: 830},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 949}
    ],
    20255: [
        {type: OfferPoiType.BUS, name: "Nowy Bytom Osiedle Otylia", distance: 269},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Centrum", distance: 605},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Pokoju", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Dworski", distance: 830},
        {type: OfferPoiType.PARK, name: "Zrewitalizowana Hałda Pocynkowa", distance: 1091},
        {type: OfferPoiType.PARK, name: "Ogród Ślaskiego Teatru Impresaryjnego", distance: 1245},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Hallera", distance: 1951},
        {type: OfferPoiType.PARK, name: "Góra Antonia", distance: 1989},
        {type: OfferPoiType.PARK, name: "Park im. Juliana Tuwima", distance: 2365}
    ],
    20256: [
        {type: OfferPoiType.BUS, name: "Gwarna 01", distance: 492},
        {type: OfferPoiType.BUS, name: "Gwarna 02", distance: 638},
        {type: OfferPoiType.BUS, name: "Rataja 02", distance: 837}
    ],
    20258: [
        {type: OfferPoiType.BUS, name: "Przepiórki 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Przepiórki 01", distance: 388},
        {type: OfferPoiType.BUS, name: "Kolibra 01", distance: 715},
        {type: OfferPoiType.BUS, name: "Kolibra 02", distance: 780}
    ],
    20259: [
        {type: OfferPoiType.BUS, name: "Chłodnia 01", distance: 340},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Toruńska", distance: 356},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 03", distance: 422},
        {type: OfferPoiType.BUS, name: "Pelcowizna 01", distance: 438},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 04", distance: 454},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Chłodnia 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Pelcowizna 02", distance: 509},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Pelcowizna 06", distance: 580},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 989},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1546},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1574},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2150},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 2401}
    ],
    20260: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 343},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 757},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 1047},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1390},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1819},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2111},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2145},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2404}
    ],
    20261: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 347},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 487},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 681},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 1038},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1214},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1727},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1908},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2115},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2158},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2394},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2406}
    ],
    20262: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 272},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 562},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 686},
        {type: OfferPoiType.BUS, name: "Michałkowice Kościół", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 963},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1139},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1652},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1983},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2040},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2083},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2469},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2481}
    ],
    20264: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 308},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 526},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 642},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 722},
        {type: OfferPoiType.BUS, name: "Michałkowice Kościół", distance: 815},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 999},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1175},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1688},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1947},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2076},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2119},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2433},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2445}
    ],
    20265: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 242},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 576},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 592},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 656},
        {type: OfferPoiType.BUS, name: "Michałkowice Kościół", distance: 749},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 933},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1109},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1622},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2010},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2013},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2053},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2499},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2500}
    ],
    20268: [
        {type: OfferPoiType.BUS, name: "Pomorska - Gryfa Pomorskiego NŻ", distance: 290},
        {type: OfferPoiType.BUS, name: "Pomorska - Śródziemnomorska NŻ", distance: 529},
        {type: OfferPoiType.BUS, name: "Pomorska - Wendy NŻ", distance: 739}
    ],
    20269: [
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola 02", distance: 183},
        {type: OfferPoiType.BUS, name: "Okopowa 02", distance: 258},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 268},
        {type: OfferPoiType.BUS, name: "Leszno 01", distance: 270},
        {type: OfferPoiType.BUS, name: "Leszno 02", distance: 272},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Wola 06", distance: 333},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Wola 04", distance: 333},
        {type: OfferPoiType.BUS, name: "Młynarska 01", distance: 370},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Wola 03", distance: 370},
        {type: OfferPoiType.BUS, name: "Okopowa 05", distance: 371},
        {type: OfferPoiType.BUS, name: "Młynarska 02", distance: 372},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Okopowa 06", distance: 398},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 399},
        {type: OfferPoiType.TRAM, name: "Okopowa 08", distance: 400},
        {type: OfferPoiType.TRAM, name: "Okopowa 07", distance: 416},
        {type: OfferPoiType.BUS, name: "Młynarska 04", distance: 435},
        {type: OfferPoiType.TRAM, name: "Okopowa 03", distance: 440},
        {type: OfferPoiType.TRAM, name: "Młynarska 04", distance: 449},
        {type: OfferPoiType.TRAM, name: "Żytnia 02", distance: 513},
        {type: OfferPoiType.TRAM, name: "Żytnia 01", distance: 531},
        {type: OfferPoiType.TRAM, name: "Młynarska 03", distance: 534},
        {type: OfferPoiType.PARK, name: "Plac Opolski", distance: 761},
        {type: OfferPoiType.PARK, name: "Różany Skwer Pysznych Pączków", distance: 767},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 801},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 899},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 942},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1004},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 1361}
    ],
    20271: [
        {type: OfferPoiType.BUS, name: "Rąbieńska - Traktorowa", distance: 334},
        {type: OfferPoiType.BUS, name: "Rąbieńska - Podjazdowa NŻ", distance: 354},
        {type: OfferPoiType.BUS, name: "Podchorążych - Napoleońska", distance: 415},
        {type: OfferPoiType.BUS, name: "Traktorowa - Rąbieńska", distance: 539},
        {type: OfferPoiType.BUS, name: "Złotno - Podchorążych", distance: 544},
        {type: OfferPoiType.BUS, name: "Fizylierów - Złotno", distance: 577},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 755},
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 1281},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 1417},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1691},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1746},
        {type: OfferPoiType.PARK, name: "Park im. Stefana Żeromskiego", distance: 1827},
        {type: OfferPoiType.PARK, name: "Park im. generała Władysława Andersa", distance: 1832},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 2153},
        {type: OfferPoiType.PARK, name: "Park Grabieński Las", distance: 2220}
    ],
    20278: [
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 454},
        {type: OfferPoiType.BUS, name: "Czermińskiego 01", distance: 509},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1353}
    ],
    20280: [
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 215},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 362},
        {type: OfferPoiType.BUS, name: "Okólna 02", distance: 511},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 539},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Okólna 03", distance: 598},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 01", distance: 630},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 673},
        {type: OfferPoiType.BUS, name: "Wspólna 01", distance: 734},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1142},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1401}
    ],
    20287: [{type: OfferPoiType.BUS, name: "Nowosiedlice", distance: 836}],
    20290: [
        {type: OfferPoiType.BUS, name: "Twardzickiego / Łochowskiego", distance: 230},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Kleina", distance: 244},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Bołtucia", distance: 578},
        {type: OfferPoiType.BUS, name: "Korfantego / Prejsa", distance: 793},
        {type: OfferPoiType.BUS, name: "Pod Skarpą / Frydrychowicza", distance: 800},
        {type: OfferPoiType.PARK, name: "Dolina Śmierci", distance: 1046},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1830},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 2266}
    ],
    20291: [
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 481},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 485},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 502},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 504},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 513},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 514},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 523},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 558},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 645},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 666},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 806},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 959},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1382},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2039}
    ],
    20292: [
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 418},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 437},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 446},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 526},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 547},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 582},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 669},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 690},
        {type: OfferPoiType.TRAM, name: "Hubego 03", distance: 821},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 892},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1406},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1972}
    ],
    20293: [
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 114},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 119},
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 651},
        {type: OfferPoiType.BUS, name: "Chyliczki 01", distance: 715},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 736},
        {type: OfferPoiType.BUS, name: "Chyliczki 02", distance: 812}
    ],
    20301: [
        {type: OfferPoiType.BUS, name: "Skrzydlata - Dojazdowa", distance: 191},
        {type: OfferPoiType.BUS, name: "Skrzydlata - Kasztelańska NŻ", distance: 278},
        {type: OfferPoiType.BUS, name: "Warszawska - Słowicza NŻ", distance: 446},
        {type: OfferPoiType.BUS, name: "Warszawska - Dw. Łódź Warszawska NŻ", distance: 452},
        {type: OfferPoiType.KOLEJ, name: "Łódź Warszawska", distance: 575},
        {type: OfferPoiType.BUS, name: "Warszawska - Centralna NŻ", distance: 656},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 2310},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 2495}
    ],
    20303: [
        {type: OfferPoiType.BUS, name: "Stadion Olimpijski", distance: 345},
        {type: OfferPoiType.TRAM, name: "Stadion Olimpijski", distance: 395},
        {type: OfferPoiType.TRAM, name: "Karłowicza", distance: 630},
        {type: OfferPoiType.BUS, name: "8 Maja", distance: 766},
        {type: OfferPoiType.BUS, name: "Szymanowskiego", distance: 773},
        {type: OfferPoiType.PARK, name: "skwer Ludwiga Guttmanna", distance: 779},
        {type: OfferPoiType.TRAM, name: "8 Maja", distance: 795},
        {type: OfferPoiType.BUS, name: "Moniuszki", distance: 798},
        {type: OfferPoiType.PARK, name: "Park Wroni", distance: 1107},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1280},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 1958}
    ],
    20304: [
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Bursztynowa Góra", distance: 1483},
        {type: OfferPoiType.LAS, name: "Jankowski las", distance: 1845}
    ],
    20305: [{type: OfferPoiType.KOLEJ, name: "Stegna PKS", distance: 782}],
    20306: [
        {type: OfferPoiType.BUS, name: "Warszawska", distance: 826},
        {type: OfferPoiType.REZERWAT, name: "Śmieszka w Bojanie", distance: 843},
        {type: OfferPoiType.REZERWAT, name: "Trójmiejski Park Krajobrazowy", distance: 1056}
    ],
    20307: [
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 01", distance: 169},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Tarczyn Lidl/Biedronka 01", distance: 353},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 02", distance: 561},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1763}
    ],
    20308: [
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 184},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 409},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 688},
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 701},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 718},
        {type: OfferPoiType.BUS, name: "Lutycka Szpital", distance: 747},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 774},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1537},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1641},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1853},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2021},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2132},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2294},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2319}
    ],
    20309: [
        {type: OfferPoiType.KOLEJ, name: "Iwiny", distance: 596},
        {type: OfferPoiType.BUS, name: "Vivaldiego", distance: 811},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2129},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2476}
    ],
    20310: [
        {type: OfferPoiType.BUS, name: "Kościelisko Rysulówka 2", distance: 337},
        {type: OfferPoiType.BUS, name: "Kościelisko Rysulówka 1", distance: 367}
    ],
    20311: [
        {type: OfferPoiType.BUS, name: "Leszczynki SKM", distance: 116},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Leszczynki", distance: 247},
        {type: OfferPoiType.BUS, name: "Wiejska", distance: 406},
        {type: OfferPoiType.BUS, name: "Zamenhofa", distance: 484},
        {type: OfferPoiType.PARK, name: "Park Zielone Leszczynki", distance: 1311},
        {type: OfferPoiType.PARK, name: "Kieszonka na fali", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1938}
    ],
    20315: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 180},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 183},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 198},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 328},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 421},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 565},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 580},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 586},
        {type: OfferPoiType.BUS, name: "Żupnicza 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 659},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1056},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1309},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1447},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1604},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1664},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1981},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2123},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2146},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2152}
    ],
    20316: [
        {type: OfferPoiType.BUS, name: "Sosnowiec Teatralna", distance: 63},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Wspólna", distance: 228},
        {type: OfferPoiType.BUS, name: "Sosnowiec Wspólna", distance: 259},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dęblińska", distance: 384},
        {type: OfferPoiType.BUS, name: "Sosnowiec Mierosławskiego", distance: 392},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dęblińska", distance: 395},
        {type: OfferPoiType.BUS, name: "Sosnowiec Kościelna", distance: 512},
        {type: OfferPoiType.BUS, name: "Sosnowiec Sienkiewicza", distance: 533},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Południowy", distance: 536},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dworzec PKP", distance: 557},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dworzec PKP", distance: 612},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Małachowskiego", distance: 720},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Główny", distance: 735},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Piłsudskiego/Sobieskiego", distance: 737},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Aleja Zwycięstwa", distance: 765},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Ostrogórska", distance: 823},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 1177},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 1258},
        {type: OfferPoiType.PARK, name: "Park Harcerski", distance: 1436},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jana Antoniego Strzeleckiego", distance: 1726},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 1813},
        {type: OfferPoiType.PARK, name: "Park Dietla", distance: 1990},
        {type: OfferPoiType.REZERWAT, name: 'Zespół Przyrodniczo-Krajobrazowy "Szopienice-Borki"', distance: 1996},
        {type: OfferPoiType.REZERWAT, name: "Kruszczyk Szerokolistny w Lasku Stawiki", distance: 2384}
    ],
    20317: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 447},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 528},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 541},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 744},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 765},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 779},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1033},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1041},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1724},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1843},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1920},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2067},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2177}
    ],
    20318: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 483},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 564},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 577},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 780},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 801},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 815},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1069},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1077},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1760},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1879},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1956},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2103},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2213}
    ],
    20321: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej 01", distance: 425},
        {type: OfferPoiType.BUS, name: "Armii Krajowej 02", distance: 472},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 02", distance: 535},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 01", distance: 568},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1236},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1245},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1470},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1582},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1715},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1728},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2203}
    ],
    20322: [
        {type: OfferPoiType.BUS, name: "Stawowa 01", distance: 486},
        {type: OfferPoiType.BUS, name: "Stawowa 04", distance: 585},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1054},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1305},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 2028},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 2464}
    ],
    20326: [
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 227},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 452},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 731},
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 744},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 761},
        {type: OfferPoiType.BUS, name: "Lutycka Szpital", distance: 790},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 817},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1580},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1684},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1896},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2064},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2175},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2337},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2362}
    ],
    20327: [
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 303},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 02", distance: 382},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 01", distance: 444},
        {type: OfferPoiType.BUS, name: "Rumia, Urząd Miasta Rumi", distance: 622},
        {type: OfferPoiType.BUS, name: "Porazińskiej", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1816},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 2461}
    ],
    20328: [
        {type: OfferPoiType.BUS, name: "Łąkowa 01", distance: 483},
        {type: OfferPoiType.BUS, name: "Łąkowa 02", distance: 588},
        {type: OfferPoiType.BUS, name: "Wierzbowa 02", distance: 744}
    ],
    20331: [
        {type: OfferPoiType.BUS, name: "Pilotów 01", distance: 161},
        {type: OfferPoiType.BUS, name: "Dywizjonu 303 01", distance: 163},
        {type: OfferPoiType.BUS, name: "Zaspa SKM 01", distance: 417},
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 01", distance: 422},
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Zaspa SKM 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 01", distance: 581},
        {type: OfferPoiType.BUS, name: "Startowa 04", distance: 582},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 02", distance: 606},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 01", distance: 610},
        {type: OfferPoiType.BUS, name: "Żwirki i Wigury 03", distance: 622},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Zaspa", distance: 629},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 02", distance: 638},
        {type: OfferPoiType.TRAM, name: "Startowa 01", distance: 684},
        {type: OfferPoiType.TRAM, name: "Startowa 02", distance: 709},
        {type: OfferPoiType.BUS, name: 'SDO "Złota Jesień" 01', distance: 734},
        {type: OfferPoiType.BUS, name: "Startowa 03", distance: 753},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 975},
        {type: OfferPoiType.PARK, name: "Skwer Marszałka Józefa Piłsudskiego", distance: 1035}
    ],
    20332: [
        {type: OfferPoiType.BUS, name: "Mateckiego", distance: 130},
        {type: OfferPoiType.BUS, name: "Wiedeńska", distance: 611},
        {type: OfferPoiType.BUS, name: "Os. Marysieńki", distance: 675},
        {type: OfferPoiType.BUS, name: "Wietrzna n/ż", distance: 718},
        {type: OfferPoiType.BUS, name: "Łęgowskiego n/ż", distance: 724},
        {type: OfferPoiType.BUS, name: "Os. Sobieskiego Szkoła n/ż", distance: 778},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1485},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1530},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 1633},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 1799},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1965},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2438}
    ],
    20336: [
        {type: OfferPoiType.BUS, name: "Inflancka - Zagajnikowa", distance: 387},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Inflancka", distance: 437},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Radlińskiej NŻ", distance: 466},
        {type: OfferPoiType.KOLEJ, name: "Łódź Marysin", distance: 605},
        {type: OfferPoiType.TRAM, name: "Doły", distance: 669},
        {type: OfferPoiType.BUS, name: "Inflancka - Gibalskiego", distance: 673},
        {type: OfferPoiType.BUS, name: "Strykowska - Inflancka", distance: 705},
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Strykowska", distance: 719},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1243},
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 1642},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1832},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 1846},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 2345}
    ],
    20337: [{type: OfferPoiType.BUS, name: "Gąski, Nadbrzeżna / Wczasowa", distance: 121}],
    20339: [
        {type: OfferPoiType.BUS, name: "Gowarzewo/Jesionowa n/ż", distance: 385},
        {type: OfferPoiType.BUS, name: "Gowarzewo/Jesienna n/ż", distance: 693},
        {type: OfferPoiType.PARK, name: "Park Dworski w Gowarzewie", distance: 1731}
    ],
    20341: [
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 542},
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 668},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 701},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 714},
        {type: OfferPoiType.BUS, name: "Byszewska - Pomarańczowa", distance: 744},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 770},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2407}
    ],
    20342: [
        {type: OfferPoiType.BUS, name: "Starogardzka 04", distance: 453},
        {type: OfferPoiType.BUS, name: "Starogardzka 01", distance: 464},
        {type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 01", distance: 794},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 02", distance: 801},
        {type: OfferPoiType.BUS, name: "Jagiełły 02", distance: 814},
        {type: OfferPoiType.BUS, name: "Jagiełły 01", distance: 818}
    ],
    20343: [
        {type: OfferPoiType.BUS, name: "Zamienie 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Błędna 01", distance: 630},
        {type: OfferPoiType.BUS, name: "Kakaowa 01", distance: 731},
        {type: OfferPoiType.BUS, name: "Bakaliowa 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Dawidowska 01", distance: 824}
    ],
    20345: [
        {type: OfferPoiType.BUS, name: "Osiedle Limba 02", distance: 232},
        {type: OfferPoiType.BUS, name: "Osiedle Limba 01", distance: 299},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Stawy Raszyńskie", distance: 2485}
    ],
    20346: [
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 12", distance: 1},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 18", distance: 35},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 11", distance: 45},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 10", distance: 59},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 09", distance: 68},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 17", distance: 79},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 16", distance: 90},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 15", distance: 115},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 14", distance: 120},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 13", distance: 132},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 72", distance: 175},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 71", distance: 176},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 05", distance: 203},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 06", distance: 223},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 235},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 04", distance: 497},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 03", distance: 543},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 755},
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 799},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 1084},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1203},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1345},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1496},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1897},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2239}
    ],
    20347: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Okęcie", distance: 401},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 04", distance: 473},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 587},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 725},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 2293},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 2416}
    ],
    20348: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 555},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 754}
    ],
    20349: [
        {type: OfferPoiType.BUS, name: "Krzesiwa 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Krzesiwa 02", distance: 532},
        {type: OfferPoiType.BUS, name: "Koszalińska 01", distance: 638},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zacisze-Wilno", distance: 638},
        {type: OfferPoiType.BUS, name: "PKP Zacisze-Wilno 02", distance: 718},
        {type: OfferPoiType.BUS, name: "PKP Zacisze-Wilno 01", distance: 725},
        {type: OfferPoiType.BUS, name: "PKP Zacisze-Wilno 04", distance: 730},
        {type: OfferPoiType.BUS, name: "Diamentowa 01", distance: 738},
        {type: OfferPoiType.PARK, name: "Skwer Ekologiczny", distance: 1841},
        {type: OfferPoiType.PARK, name: "Park linearny nad Kanałem Zaciszańskim", distance: 2247},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 2290},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 2315}
    ],
    20350: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 157},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 625},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 628},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 800},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Swojczycki", distance: 1924}
    ],
    20351: [
        {type: OfferPoiType.BUS, name: 'C.H. "Port Rumia" - Kosynierów 02', distance: 370},
        {type: OfferPoiType.BUS, name: "Zapolskiej 01", distance: 563},
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 02 n/ż", distance: 566},
        {type: OfferPoiType.BUS, name: "Zapolskiej 02", distance: 588},
        {type: OfferPoiType.BUS, name: 'Rumia C.H. "Port Rumia" 01', distance: 594},
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 01 n/ż", distance: 725},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 1762},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2467}
    ],
    20352: [
        {type: OfferPoiType.BUS, name: "Ustka, Grunwaldzka", distance: 282},
        {type: OfferPoiType.BUS, name: "Ustka, Wróblewskiego", distance: 404},
        {type: OfferPoiType.BUS, name: "Ustka / Dunina", distance: 534},
        {type: OfferPoiType.BUS, name: "Ustka, Dunina", distance: 535},
        {type: OfferPoiType.BUS, name: "Ustka, Plac Dąbrowskiego", distance: 559},
        {type: OfferPoiType.BUS, name: "Ustka, Słupska - Stadion", distance: 742},
        {type: OfferPoiType.KOLEJ, name: "Ustka", distance: 804},
        {type: OfferPoiType.PARK, name: "Skwer Pożarniaków", distance: 947},
        {type: OfferPoiType.PARK, name: "Park Usteckich Stoczniowców", distance: 1040},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1056},
        {type: OfferPoiType.PARK, name: 'Park linowy "Na Wydmie"', distance: 1246},
        {type: OfferPoiType.PARK, name: "Park Chopina", distance: 1297},
        {type: OfferPoiType.PARK, name: "Park Uzdrowiskowy", distance: 1369}
    ],
    20353: [
        {type: OfferPoiType.BUS, name: "Targówka I", distance: 509},
        {type: OfferPoiType.BUS, name: "Targówka II", distance: 800},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 1981}
    ],
    20354: [
        {type: OfferPoiType.BUS, name: "Karolina", distance: 464},
        {type: OfferPoiType.BUS, name: "Wólka Mińska", distance: 535}
    ],
    20355: [
        {type: OfferPoiType.BUS, name: "Łucznicza 01", distance: 336},
        {type: OfferPoiType.BUS, name: "Łucznicza 02", distance: 359},
        {type: OfferPoiType.BUS, name: "Pastelowa 02", distance: 606},
        {type: OfferPoiType.BUS, name: "Podleckiego 01", distance: 626},
        {type: OfferPoiType.BUS, name: "Pastelowa 01", distance: 635},
        {type: OfferPoiType.BUS, name: "Chychły 01", distance: 707},
        {type: OfferPoiType.BUS, name: "Topazowa 02", distance: 720},
        {type: OfferPoiType.BUS, name: "Topazowa 01", distance: 731},
        {type: OfferPoiType.BUS, name: "Podleckiego 02", distance: 732},
        {type: OfferPoiType.BUS, name: "Przemian 01", distance: 737}
    ],
    20356: [
        {type: OfferPoiType.BUS, name: "Gliwice Michałowskiego", distance: 434},
        {type: OfferPoiType.BUS, name: "Gliwice Grottgera", distance: 484},
        {type: OfferPoiType.BUS, name: "Gliwice Cmentarz Lipowy", distance: 629},
        {type: OfferPoiType.BUS, name: "Gliwice Targowisko", distance: 657},
        {type: OfferPoiType.PARK, name: "Skwer Franza Honioka", distance: 903},
        {type: OfferPoiType.PARK, name: "Skwer Nacka", distance: 1807},
        {type: OfferPoiType.PARK, name: "plac gier", distance: 1842},
        {type: OfferPoiType.PARK, name: "Westerplatte", distance: 1864},
        {type: OfferPoiType.PARK, name: "Skwer Europejski", distance: 1973}
    ],
    20357: [
        {type: OfferPoiType.BUS, name: "Chwałkowska", distance: 405},
        {type: OfferPoiType.BUS, name: "Wełniana", distance: 520},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 686},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1557},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 2257},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2259}
    ],
    20358: [{type: OfferPoiType.BUS, name: "Komarowo 01", distance: 378}],
    20359: [{type: OfferPoiType.REZERWAT, name: "Lasy Grędzińskie", distance: 1967}],
    20360: [
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 298},
        {type: OfferPoiType.BUS, name: "Pałacyk Sokoła 01", distance: 413},
        {type: OfferPoiType.BUS, name: "Kościuszki 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Kościuszki 02", distance: 421},
        {type: OfferPoiType.BUS, name: "USC 01", distance: 485},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 502},
        {type: OfferPoiType.BUS, name: "USC 05", distance: 548},
        {type: OfferPoiType.BUS, name: "USC 04", distance: 551},
        {type: OfferPoiType.BUS, name: "Kościuszki 03", distance: 589},
        {type: OfferPoiType.BUS, name: "PKP Pruszków", distance: 622},
        {type: OfferPoiType.KOLEJ, name: "Pruszków", distance: 671},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 783},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 830},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 898},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 1298}
    ],
    20363: [
        {type: OfferPoiType.BUS, name: "Sieczna 02", distance: 134},
        {type: OfferPoiType.BUS, name: "Okrągła 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Sieczna 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Okrągła 02", distance: 319},
        {type: OfferPoiType.BUS, name: "Podwójna 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Podwójna 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 01", distance: 598},
        {type: OfferPoiType.BUS, name: "Os. Derby 02", distance: 604},
        {type: OfferPoiType.BUS, name: "Os. Lewandów I 01", distance: 640},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 02", distance: 688},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 995}
    ],
    20365: [
        {type: OfferPoiType.BUS, name: "Wyścigowa [końcowy]", distance: 298},
        {type: OfferPoiType.TRAM, name: "Wyścigowa", distance: 305},
        {type: OfferPoiType.BUS, name: "Wyścigowa", distance: 313},
        {type: OfferPoiType.TRAM, name: "Wyścigowa [końcowy]", distance: 313},
        {type: OfferPoiType.BUS, name: "Fordońska / Wyścigowa", distance: 318},
        {type: OfferPoiType.TRAM, name: "Fordońska / Wyścigowa", distance: 335},
        {type: OfferPoiType.BUS, name: "Fordońska / Fabryczna", distance: 556},
        {type: OfferPoiType.TRAM, name: "Fordońska / Fabryczna", distance: 659},
        {type: OfferPoiType.BUS, name: "Dworzec Wschód", distance: 706},
        {type: OfferPoiType.PARK, name: "Park przyfolwarczny", distance: 1109},
        {type: OfferPoiType.PARK, name: "Skwer przy Gdyńskiej", distance: 1980},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 1999}
    ],
    20370: [
        {type: OfferPoiType.PARK, name: "Skwer Prażaby Czatkowickiej", distance: 753},
        {type: OfferPoiType.PARK, name: "Dzikie Planty", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy imienia Adama Bogackiego", distance: 1658},
        {type: OfferPoiType.PARK, name: "Skwer Olgi Drahonowskiej-Małkowskiej", distance: 1686},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Adama Bogackiego (Park Potockich)", distance: 2204}
    ],
    20371: [
        {type: OfferPoiType.BUS, name: "Port", distance: 60},
        {type: OfferPoiType.BUS, name: "Port 05", distance: 108},
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 194},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 252},
        {type: OfferPoiType.BUS, name: "Plac Kościelny", distance: 333},
        {type: OfferPoiType.BUS, name: "Centrum 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 03", distance: 422},
        {type: OfferPoiType.BUS, name: "Centrum 02", distance: 432},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 04", distance: 433},
        {type: OfferPoiType.BUS, name: "Prom", distance: 459},
        {type: OfferPoiType.LAS, name: "Parki Miejski im. Fryderyka Chopina", distance: 687},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 687}
    ],
    20373: [
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 331},
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 447},
        {type: OfferPoiType.BUS, name: "Czermińskiego 01", distance: 502},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1346}
    ],
    20374: [
        {type: OfferPoiType.BUS, name: "Waniliowa", distance: 189},
        {type: OfferPoiType.BUS, name: "Kaparowa", distance: 371},
        {type: OfferPoiType.BUS, name: "Cynamonowa", distance: 474},
        {type: OfferPoiType.BUS, name: "Cynamonowa (Szkoła)", distance: 641},
        {type: OfferPoiType.BUS, name: "Kminkowa", distance: 691},
        {type: OfferPoiType.BUS, name: "Tymiankowa", distance: 802},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 1689}
    ],
    20375: [
        {type: OfferPoiType.TRAM, name: "Sielska", distance: 368},
        {type: OfferPoiType.BUS, name: "Sielska", distance: 379},
        {type: OfferPoiType.BUS, name: "Częstochowska n/ż", distance: 386},
        {type: OfferPoiType.BUS, name: "Górczyn PKM", distance: 425},
        {type: OfferPoiType.KOLEJ, name: "Poznań Górczyn", distance: 434},
        {type: OfferPoiType.TRAM, name: "Górczyn PKM", distance: 508},
        {type: OfferPoiType.TRAM, name: "Krauthofera", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Górczyński", distance: 800},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Hałasika", distance: 1762},
        {type: OfferPoiType.PARK, name: "Park Jana Kasprowicza", distance: 2053},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 2148},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 2179},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2355}
    ],
    20377: [
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 462},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 485},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 519},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 542},
        {type: OfferPoiType.BUS, name: "Pomorska - Nowosolna", distance: 542},
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 595},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2014}
    ],
    20378: [
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 440},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 463},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 497},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Pomorska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 573},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2036}
    ],
    20379: [
        {type: OfferPoiType.BUS, name: "Długa 01", distance: 632},
        {type: OfferPoiType.BUS, name: "Długa 02", distance: 644}
    ],
    20380: [
        {type: OfferPoiType.BUS, name: "Zaborze Pyki", distance: 432},
        {type: OfferPoiType.TRAM, name: "Ruda Klary", distance: 589},
        {type: OfferPoiType.BUS, name: "Ruda Klary", distance: 597},
        {type: OfferPoiType.BUS, name: "Zaborze Struzika", distance: 628},
        {type: OfferPoiType.PARK, name: "Park Gorgol", distance: 969},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1685},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Augusta Kozioła", distance: 1945}
    ],
    20381: [
        {type: OfferPoiType.BUS, name: "Krzeszowice Zielona", distance: 640},
        {type: OfferPoiType.PARK, name: "Skwer Olgi Drahonowskiej-Małkowskiej", distance: 1338},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy imienia Adama Bogackiego", distance: 1339},
        {type: OfferPoiType.REZERWAT, name: "Las Buczyna", distance: 1575},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Adama Bogackiego (Park Potockich)", distance: 1730},
        {type: OfferPoiType.PARK, name: "Dzikie Planty", distance: 2316}
    ],
    20382: [{type: OfferPoiType.BUS, name: "Rabowice Bukowa", distance: 793}],
    20383: [
        {type: OfferPoiType.BUS, name: "Zaborze Pyki", distance: 573},
        {type: OfferPoiType.BUS, name: "Zaborze Struzika", distance: 769},
        {type: OfferPoiType.LAS, name: "Dolina Rowu Rudzkiego II", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Gorgol", distance: 1189},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1664},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Augusta Kozioła", distance: 1924}
    ],
    20384: [
        {type: OfferPoiType.BUS, name: "Niwka Tuwima", distance: 130},
        {type: OfferPoiType.BUS, name: "Niwka Szybowa", distance: 404},
        {type: OfferPoiType.BUS, name: "Osiedle Bór Bloki", distance: 501},
        {type: OfferPoiType.BUS, name: "Niwka Fabryka", distance: 590},
        {type: OfferPoiType.TRAM, name: "Niwka Fabryka", distance: 606},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Kłosowskiego", distance: 617},
        {type: OfferPoiType.PARK, name: "Park Wygoda", distance: 1395}
    ],
    20385: [
        {type: OfferPoiType.BUS, name: "Narutowicza - Bandrowskiego", distance: 200},
        {type: OfferPoiType.BUS, name: "Krakowska 01 - Pl. Kościuszki", distance: 211},
        {type: OfferPoiType.BUS, name: "Sikorskiego 01 - Świt", distance: 217},
        {type: OfferPoiType.BUS, name: "Krakowska 03 - Pl. Popiełuszki", distance: 282},
        {type: OfferPoiType.BUS, name: "Krakowska 02 - Planty", distance: 302},
        {type: OfferPoiType.BUS, name: "Tarnów Sikorskiego", distance: 346},
        {type: OfferPoiType.BUS, name: "Bema 04 - Szkoła", distance: 348},
        {type: OfferPoiType.PARK, name: "Planty im. Józefa Jakubowskiego", distance: 384},
        {type: OfferPoiType.BUS, name: "Skwer Petöfiego 01", distance: 399},
        {type: OfferPoiType.BUS, name: "Mościckiego 01 - Szkotnik", distance: 559},
        {type: OfferPoiType.BUS, name: "Narutowicza - Wodna", distance: 563},
        {type: OfferPoiType.PARK, name: "Skwer Obrońców Grodna 1939", distance: 685},
        {type: OfferPoiType.KOLEJ, name: "Tarnów", distance: 757},
        {type: OfferPoiType.PARK, name: "Skwer Alicji i Jana Preiss", distance: 813},
        {type: OfferPoiType.PARK, name: "Skwer Wójta Kiliana Bałkowicza", distance: 886},
        {type: OfferPoiType.PARK, name: "Skwer Ojca Olgierda Kokocińskiego", distance: 1180},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterów Zadwórza 1920", distance: 1239},
        {type: OfferPoiType.PARK, name: "Plac Henryka Sienkiewicza", distance: 1340},
        {type: OfferPoiType.PARK, name: "plac Podpułkownika Stanisława Sowiźrała-Sobolewicza", distance: 1561}
    ],
    20386: [
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 07", distance: 371},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 08", distance: 375},
        {type: OfferPoiType.BUS, name: "Wielkopolska 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Osiedle Zachodnie 03", distance: 519},
        {type: OfferPoiType.BUS, name: "Osiedle Krzywa", distance: 636},
        {type: OfferPoiType.BUS, name: "Wielkopolska / Mazurska 02", distance: 678},
        {type: OfferPoiType.BUS, name: "Markiewicza - Poczta 02", distance: 712},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Nowokarsiborska 05", distance: 759},
        {type: OfferPoiType.BUS, name: "runwaldzka / Nowokarsiborska 06", distance: 790},
        {type: OfferPoiType.LAS, name: "Świdne Bagna", distance: 850},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 2465}
    ],
    20389: [
        {type: OfferPoiType.BUS, name: "Solec - Borowa NŻ", distance: 226},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Praussa", distance: 277},
        {type: OfferPoiType.BUS, name: "Borowa - Siewna NŻ", distance: 375},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Jarzynowa", distance: 627},
        {type: OfferPoiType.BUS, name: "Solec - Cm. Mania", distance: 639},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Srebrzyńska", distance: 675},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Cm. Mania", distance: 678},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Długosza", distance: 714},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 1262},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1428},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1450},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 1580},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 1850},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1875}
    ],
    20393: [
        {type: OfferPoiType.BUS, name: "Żeromskiego 01", distance: 281},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy", distance: 289},
        {type: OfferPoiType.BUS, name: "Żeromskiego 02", distance: 310},
        {type: OfferPoiType.PARK, name: "Skwer Kolejarzy", distance: 314},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy 01", distance: 385},
        {type: OfferPoiType.KOLEJ, name: "Ostrołęka", distance: 429},
        {type: OfferPoiType.BUS, name: "Starowiejska 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Starowiejska 01", distance: 474},
        {type: OfferPoiType.BUS, name: "Moniuszki 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Kaczyńska 02", distance: 661},
        {type: OfferPoiType.BUS, name: "Wyspiańskiego 01", distance: 767},
        {type: OfferPoiType.BUS, name: "Kaczyńska 01", distance: 790}
    ],
    20394: [
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 440},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 463},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 497},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Pomorska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 573},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2036}
    ],
    20397: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skorupki", distance: 131},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 198},
        {type: OfferPoiType.BUS, name: "Wólczańska - Radwańska", distance: 355},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 378},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Katedralny", distance: 391},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 391},
        {type: OfferPoiType.BUS, name: "Politechniki - Park im. Klepacza NŻ", distance: 400},
        {type: OfferPoiType.BUS, name: "Radwańska - Wólczańska", distance: 427},
        {type: OfferPoiType.TRAM, name: "Politechniki - Targi Łódzkie", distance: 505},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 543},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Brzeźna", distance: 651},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 681},
        {type: OfferPoiType.TRAM, name: "Politechniki - Radwańska (kampus PŁ)", distance: 723},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Radwańska (kampus PŁ)", distance: 743},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1053},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1190},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 1264}
    ],
    20399: [
        {type: OfferPoiType.BUS, name: "Katowice Kopernika Dworzec", distance: 152},
        {type: OfferPoiType.BUS, name: "Katowice Skłodowskiej Dworzec", distance: 183},
        {type: OfferPoiType.BUS, name: "Katowice Plac Miarki", distance: 244},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Miarki", distance: 246},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 278},
        {type: OfferPoiType.BUS, name: "Katowice Andrzeja Dworzec", distance: 330},
        {type: OfferPoiType.TRAM, name: "Katowice Jordana", distance: 360},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 461},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 496},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 500},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 547},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 640},
        {type: OfferPoiType.TRAM, name: "Katowice Stadion AWF", distance: 722},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 815},
        {type: OfferPoiType.TRAM, name: "Katowice Św. Jana", distance: 828}
    ],
    20401: [
        {type: OfferPoiType.KOLEJ, name: "Wieliczka Bogucice", distance: 399},
        {type: OfferPoiType.BUS, name: "Wieliczka Winnicka", distance: 584},
        {type: OfferPoiType.PARK, name: "Park Świętej Barbary", distance: 1876},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2192},
        {type: OfferPoiType.PARK, name: "Planty", distance: 2388}
    ],
    20403: [
        {type: OfferPoiType.BUS, name: "Rondo Bitwy Warszawskiej 1920 r.", distance: 196},
        {type: OfferPoiType.BUS, name: "Okrzei", distance: 358},
        {type: OfferPoiType.BUS, name: "Kazikowskiego", distance: 421},
        {type: OfferPoiType.BUS, name: "Mińsk Mazowiecki Dworzec Autobusowy", distance: 422},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 475},
        {type: OfferPoiType.KOLEJ, name: "Mińsk Mazowiecki", distance: 529},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 751},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 995},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1084},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1161},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 1380},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 2084}
    ],
    20406: [
        {type: OfferPoiType.PARK, name: 'Skwer im. Majora Henryka Dobrzańskiego "Hubala"', distance: 156},
        {type: OfferPoiType.PARK, name: "Park im. Włodzimierza Skarbek-Borowskiego", distance: 372},
        {type: OfferPoiType.BUS, name: "Osiedle Metalowiec", distance: 457},
        {type: OfferPoiType.BUS, name: "Osiedle Chemik", distance: 504},
        {type: OfferPoiType.BUS, name: "T.C. Dębica 1-Maja", distance: 513},
        {type: OfferPoiType.BUS, name: "Staszica Starostwo", distance: 598},
        {type: OfferPoiType.BUS, name: "Osiedle Matejki", distance: 733},
        {type: OfferPoiType.BUS, name: "Krakowska Klasztor", distance: 734},
        {type: OfferPoiType.PARK, name: "Plac Kazimierza Wielkiego", distance: 1212},
        {type: OfferPoiType.PARK, name: "Skwer im. Rodziny Mikołajków", distance: 1226},
        {type: OfferPoiType.PARK, name: "Plac im. Krzysztofa Pendereckiego", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1293},
        {type: OfferPoiType.PARK, name: "Plac Solidarności", distance: 1338},
        {type: OfferPoiType.PARK, name: "Plac Gryfitów", distance: 1364}
    ],
    20407: [
        {type: OfferPoiType.BUS, name: "Wiejska / Chojnicka", distance: 319},
        {type: OfferPoiType.BUS, name: "Nad Torem / Karolewska", distance: 414},
        {type: OfferPoiType.BUS, name: "Wiejska / Krajeńska", distance: 494},
        {type: OfferPoiType.BUS, name: "Krajeńska / Wiejska", distance: 564},
        {type: OfferPoiType.BUS, name: "Wiejska / Deszczowa", distance: 714},
        {type: OfferPoiType.BUS, name: "Deszczowa / Wiejska", distance: 777},
        {type: OfferPoiType.BUS, name: "Nad Torem / Chmurna", distance: 788},
        {type: OfferPoiType.BUS, name: "Czyżkówko", distance: 798},
        {type: OfferPoiType.PARK, name: "Park przy papierni", distance: 1299},
        {type: OfferPoiType.PARK, name: "Park nad Kanałem Bydgoskim", distance: 2213},
        {type: OfferPoiType.PARK, name: "Skwer Poległych i Pomordowanych Mieszkańców Jachcic w latach 1939-1945", distance: 2282},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Prałata Zdzisława Peszkowskiego", distance: 2393}
    ],
    20411: [
        {type: OfferPoiType.BUS, name: "Bilitewskiego", distance: 604},
        {type: OfferPoiType.BUS, name: "Rubinowa", distance: 732},
        {type: OfferPoiType.BUS, name: "Popiełuszki", distance: 795},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 1656}
    ],
    20413: [
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 03", distance: 317},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 351},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 441},
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 572},
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 668},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 752},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 762},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1426}
    ],
    20417: [
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 116},
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 343},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 390},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 392},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 409},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Skarbka z Gór 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 690},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1875}
    ],
    20418: [
        {type: OfferPoiType.BUS, name: "Pustecka", distance: 680},
        {type: OfferPoiType.BUS, name: "Trzmielowicka", distance: 727},
        {type: OfferPoiType.BUS, name: "Miodowa (Osiedle)", distance: 824},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Kobla", distance: 1797},
        {type: OfferPoiType.PARK, name: "Park Leśnicki", distance: 2401}
    ],
    20420: [
        {type: OfferPoiType.BUS, name: "Brzezińska - Kerna NŻ", distance: 365},
        {type: OfferPoiType.BUS, name: "Brzezińska - Janosika", distance: 419},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 445},
        {type: OfferPoiType.BUS, name: "Kerna - Brzezińska", distance: 479},
        {type: OfferPoiType.BUS, name: "Janosika - Powstańców Śląskich", distance: 700},
        {type: OfferPoiType.BUS, name: "Brzezińska - CH M1", distance: 727},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 2284},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 2383}
    ],
    20421: [
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 109},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 235},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 252},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 330},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 444},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 452},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 513},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 516},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Krowodrza Górka P+R 06", distance: 596},
        {type: OfferPoiType.BUS, name: "Krowodrza Górka P+R 05", distance: 599},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 689},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 02", distance: 713},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 03", distance: 716},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R", distance: 754},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 01", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 803},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 907},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1014},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1208}
    ],
    20425: [
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 02", distance: 285},
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Szymanów 02", distance: 748},
        {type: OfferPoiType.BUS, name: "Szymanów 01", distance: 795},
        {type: OfferPoiType.BUS, name: "Szymanów 03", distance: 820},
        {type: OfferPoiType.BUS, name: "Szymanów 04", distance: 821},
        {type: OfferPoiType.REZERWAT, name: "Łąki Soleckie", distance: 1370}
    ],
    20427: [{type: OfferPoiType.BUS, name: "Sławoszewo", distance: 486}],
    20430: [
        {type: OfferPoiType.BUS, name: "Popiełuszki/Ubocze", distance: 152},
        {type: OfferPoiType.BUS, name: "Popiełuszki/al. Niepodległości", distance: 230},
        {type: OfferPoiType.BUS, name: "Popiełuszki/Batalionów Chłopskich", distance: 278},
        {type: OfferPoiType.BUS, name: "Popiełuszki/Sikorskiego", distance: 285},
        {type: OfferPoiType.BUS, name: "Wrocławska/Galeria Zielone Wzgórze", distance: 338},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Batalionów Chłopskich", distance: 351},
        {type: OfferPoiType.BUS, name: "al. Niepodległości/Popiełuszki", distance: 418},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Powstańców", distance: 436},
        {type: OfferPoiType.BUS, name: "Popiełuszki/Boboli", distance: 461},
        {type: OfferPoiType.PARK, name: "Leśny Park Kieszonkowy", distance: 967},
        {type: OfferPoiType.PARK, name: "Park Janiny Kurkowskiej-Spychajowej", distance: 1238},
        {type: OfferPoiType.REZERWAT, name: "Stawy Marczukowskie i Dolina Bażantarki", distance: 1792},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Piotra Karolskiego", distance: 1804}
    ],
    20431: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 100},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 269},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 282},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 534},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Wspólna 01", distance: 561},
        {type: OfferPoiType.BUS, name: "Wspólna 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 01", distance: 625},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 628},
        {type: OfferPoiType.BUS, name: "Okólna 02", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1097},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1356}
    ],
    20432: [
        {type: OfferPoiType.BUS, name: "Kórnicka", distance: 127},
        {type: OfferPoiType.TRAM, name: "Kórnicka", distance: 172},
        {type: OfferPoiType.BUS, name: "Rondo Rataje", distance: 343},
        {type: OfferPoiType.TRAM, name: "Rondo Rataje", distance: 405},
        {type: OfferPoiType.TRAM, name: "Politechnika", distance: 489},
        {type: OfferPoiType.BUS, name: "Politechnika", distance: 518},
        {type: OfferPoiType.BUS, name: "Os. Jagiellońskie n/ż", distance: 520},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 661},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 975},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1274},
        {type: OfferPoiType.PARK, name: "Park Rataje", distance: 1478},
        {type: OfferPoiType.PARK, name: "Park Nad Wartą", distance: 1544},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1555},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1673},
        {type: OfferPoiType.REZERWAT, name: "Traszki Ratajskie", distance: 1853},
        {type: OfferPoiType.PARK, name: "Park na os. Tysiąclecia", distance: 1921},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2036},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 2104}
    ],
    20434: [
        {type: OfferPoiType.PARK, name: "Plac rekreacyjny", distance: 265},
        {type: OfferPoiType.BUS, name: "Teresin Szkoła", distance: 335},
        {type: OfferPoiType.BUS, name: "Teresin-Niepokalanów PKP", distance: 778},
        {type: OfferPoiType.PARK, name: "Park rekreacyjny", distance: 1669}
    ],
    20435: [
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 01", distance: 383},
        {type: OfferPoiType.BUS, name: "Poligonowa - Osiedle 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Poligonowa - osiedle 02", distance: 685},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1120}
    ],
    20436: [{type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 781}],
    20438: [
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Szpital 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Szpital 04", distance: 627},
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Przytycka 02", distance: 674},
        {type: OfferPoiType.BUS, name: "Przytycka / Uniwersytecka 03", distance: 754},
        {type: OfferPoiType.BUS, name: "Przytycka / Uniwersytecka 04", distance: 828},
        {type: OfferPoiType.BUS, name: "Wacyn / Szpital 03", distance: 840}
    ],
    20440: [
        {type: OfferPoiType.BUS, name: "Ćwiklińskiej 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Ćwiklińskiej 02", distance: 445},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 466},
        {type: OfferPoiType.BUS, name: "Leśnej Polanki 01", distance: 613},
        {type: OfferPoiType.BUS, name: "Strumykowa 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Chęcińska 01", distance: 648},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 659},
        {type: OfferPoiType.BUS, name: "Chęcińska 02", distance: 710},
        {type: OfferPoiType.BUS, name: "Leśnej Polanki 02", distance: 719},
        {type: OfferPoiType.BUS, name: "Strumykowa 01", distance: 771},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 1251},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1664}
    ],
    20441: [
        {type: OfferPoiType.BUS, name: "Borkowo Szkoła 02", distance: 788},
        {type: OfferPoiType.BUS, name: "Borkowo Szkoła 01", distance: 793},
        {type: OfferPoiType.BUS, name: "Borkowo, Głębokie", distance: 809},
        {type: OfferPoiType.BUS, name: "Borkowo Kasztanowa 02", distance: 819}
    ],
    20442: [
        {type: OfferPoiType.BUS, name: "Wieliczka Solne Miasto II", distance: 120},
        {type: OfferPoiType.BUS, name: "Wieliczka Solne Miasto I", distance: 186},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 426},
        {type: OfferPoiType.BUS, name: "Wieliczka Park II", distance: 649},
        {type: OfferPoiType.BUS, name: "Wieliczka Park I", distance: 662},
        {type: OfferPoiType.BUS, name: "Wieliczka Sąd", distance: 666},
        {type: OfferPoiType.PARK, name: "Park Świętej Kingi", distance: 677},
        {type: OfferPoiType.BUS, name: "Wieliczka Jedynaka", distance: 786},
        {type: OfferPoiType.PARK, name: "Planty", distance: 1404}
    ],
    20444: [
        {type: OfferPoiType.BUS, name: "Podchorążych - Łucznicza NŻ", distance: 301},
        {type: OfferPoiType.BUS, name: "Podchorążych - Molla NŻ", distance: 522},
        {type: OfferPoiType.BUS, name: "Złotno - Legnicka NŻ", distance: 728},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 1550},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 1605},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1934},
        {type: OfferPoiType.PARK, name: "Park Grabieński Las", distance: 2312},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 2322},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 2342},
        {type: OfferPoiType.PARK, name: "Skwer pocmentarny", distance: 2388},
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 2397}
    ],
    20446: [
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 400},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Chyliczki 01", distance: 763}
    ],
    20447: [
        {type: OfferPoiType.BUS, name: "Hołubcowa 02", distance: 224},
        {type: OfferPoiType.BUS, name: "Hołubcowa 01", distance: 267},
        {type: OfferPoiType.BUS, name: "Łączyny 02", distance: 307},
        {type: OfferPoiType.BUS, name: "Osmańska 01", distance: 421},
        {type: OfferPoiType.BUS, name: "Wyczółki 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Wyczółki 02", distance: 447},
        {type: OfferPoiType.BUS, name: "Kłobucka 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Kłobucka 04", distance: 497},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 595},
        {type: OfferPoiType.REZERWAT, name: "Jeziorko Imielińskie - użytek 623", distance: 2512}
    ],
    20448: [
        {type: OfferPoiType.BUS, name: "Dorodna 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Laurowa 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Laurowa 01", distance: 652},
        {type: OfferPoiType.BUS, name: "Portowa 02", distance: 714},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 1531}
    ],
    20449: [
        {type: OfferPoiType.BUS, name: "Jeziorna", distance: 357},
        {type: OfferPoiType.LAS, name: "Leśny zakątek", distance: 514},
        {type: OfferPoiType.LAS, name: "Małpia Wyspa", distance: 1023}
    ],
    20451: [
        {type: OfferPoiType.BUS, name: "Pożaryskiego 04", distance: 650},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 03", distance: 653},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 01", distance: 772},
        {type: OfferPoiType.BUS, name: "Czatów 02", distance: 774},
        {type: OfferPoiType.BUS, name: "Czatów 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 02", distance: 796}
    ],
    20452: [
        {type: OfferPoiType.BUS, name: "Skośna 02", distance: 215},
        {type: OfferPoiType.BUS, name: "Skośna 01", distance: 254},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 01", distance: 535},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 546},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 02", distance: 584},
        {type: OfferPoiType.BUS, name: "Lubostroń 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Piltza 02", distance: 676},
        {type: OfferPoiType.BUS, name: "Piltza 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Lubostroń 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Lubostroń 04", distance: 784},
        {type: OfferPoiType.BUS, name: "Kobierzyn 02", distance: 798},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Maćka i Doroty", distance: 1957},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2046},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 2145},
        {type: OfferPoiType.REZERWAT, name: "Łąki na Klinach", distance: 2390}
    ],
    20453: [
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Żurawiej", distance: 118},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Stadion", distance: 259},
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 333},
        {type: OfferPoiType.BUS, name: "Centum Przesiadkowe Bałtycka", distance: 370},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 473},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wolności", distance: 540},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1036},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 1187},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1262},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1647}
    ],
    20454: [
        {type: OfferPoiType.BUS, name: "Meksykańska 01", distance: 129},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP - os. Meksyk 03", distance: 134},
        {type: OfferPoiType.BUS, name: "Meksykańska 02", distance: 196},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP - os. Meksyk 01", distance: 201},
        {type: OfferPoiType.BUS, name: "Wiśniowa 90", distance: 246},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Chylonia", distance: 282},
        {type: OfferPoiType.BUS, name: "Pucka - Hutnicza", distance: 312},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 04", distance: 329},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 06", distance: 348},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 01", distance: 443},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP", distance: 448},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1246}
    ],
    20455: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 204},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 252},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 326},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 343},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 402},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 650},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 679},
        {type: OfferPoiType.BUS, name: "Ujeścisko 04", distance: 683},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 01", distance: 692},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 03", distance: 710},
        {type: OfferPoiType.BUS, name: "Ujeścisko 05", distance: 718},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 02", distance: 718},
        {type: OfferPoiType.BUS, name: "Ujeścisko 06", distance: 721},
        {type: OfferPoiType.BUS, name: "Kielecka 01", distance: 778},
        {type: OfferPoiType.BUS, name: "Nowosądecka 01", distance: 802},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1819},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1969},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2382}
    ],
    20456: [
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 02", distance: 161},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 01", distance: 191},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 02", distance: 414},
        {type: OfferPoiType.BUS, name: "Pogórze - Dąbrowskiego 02", distance: 639},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 01", distance: 647},
        {type: OfferPoiType.BUS, name: "Pogórze - Pułaskiego", distance: 657},
        {type: OfferPoiType.BUS, name: "Pogórze - Pułaskiego 02", distance: 687},
        {type: OfferPoiType.BUS, name: "Pogórze - Pułaskiego 01", distance: 708},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1370},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 1619},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1995}
    ],
    20457: [
        {type: OfferPoiType.BUS, name: "Os. Ślichowice", distance: 183},
        {type: OfferPoiType.BUS, name: "Massalskiego", distance: 498},
        {type: OfferPoiType.KOLEJ, name: "Kielce Ślichowice", distance: 665},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skalny Ślichowice im. Jana Czarnockiego", distance: 690}
    ],
    20458: [
        {type: OfferPoiType.BUS, name: "Błonie Nowakowskiego", distance: 142},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 353},
        {type: OfferPoiType.BUS, name: "Błonie Piłsudskiego Przedszkole", distance: 409},
        {type: OfferPoiType.BUS, name: "Błonie Okrzei", distance: 462},
        {type: OfferPoiType.BUS, name: "Błonie Stadion", distance: 528},
        {type: OfferPoiType.BUS, name: "Błonie Wyszyńskiego", distance: 745},
        {type: OfferPoiType.BUS, name: "Błonie Narutowicza", distance: 772},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 926}
    ],
    20459: [
        {type: OfferPoiType.BUS, name: "Rumia, Urząd Miasta Rumi", distance: 162},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 01", distance: 407},
        {type: OfferPoiType.BUS, name: "Górnicza 01 (NŻ)", distance: 426},
        {type: OfferPoiType.BUS, name: "Górnicza 03 (NŻ)", distance: 445},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 02", distance: 457},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 613},
        {type: OfferPoiType.BUS, name: "Dąbrowskiego - Most", distance: 646},
        {type: OfferPoiType.KOLEJ, name: "Rumia", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1282},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1858},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 2010}
    ],
    20460: [
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1896},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 2270}
    ],
    20463: [
        {type: OfferPoiType.BUS, name: "Malborska (EPBP)", distance: 317},
        {type: OfferPoiType.BUS, name: "Malborska - Fredry", distance: 367},
        {type: OfferPoiType.BUS, name: "Skrzydlata - LOK", distance: 461},
        {type: OfferPoiType.BUS, name: "Lotnicza - Fredry", distance: 648},
        {type: OfferPoiType.BUS, name: "Malborska - Zagonowa", distance: 672},
        {type: OfferPoiType.BUS, name: "Lotnicza - wiadukt", distance: 704},
        {type: OfferPoiType.BUS, name: "Lotnicza - Skrzydlata", distance: 710},
        {type: OfferPoiType.PARK, name: "Park Wojska Polskiego", distance: 1357},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Rebinina", distance: 1401},
        {type: OfferPoiType.PARK, name: "Park Planty", distance: 1634},
        {type: OfferPoiType.PARK, name: "Park im. Generała Bolesława Nieczuja-Ostrowskiego", distance: 1689}
    ],
    20464: [
        {type: OfferPoiType.BUS, name: "Fabryczna 02", distance: 625},
        {type: OfferPoiType.BUS, name: "Fabryczna 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Nizinna 01", distance: 704},
        {type: OfferPoiType.BUS, name: "Nizinna 02", distance: 756}
    ],
    20465: [
        {type: OfferPoiType.BUS, name: "Chałubińskiego", distance: 471},
        {type: OfferPoiType.BUS, name: "PWSZ", distance: 481},
        {type: OfferPoiType.BUS, name: "Ruszczyca", distance: 597},
        {type: OfferPoiType.BUS, name: "Szpital", distance: 746},
        {type: OfferPoiType.BUS, name: "Zielona", distance: 794},
        {type: OfferPoiType.PARK, name: "Park PCK", distance: 1763},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 2416}
    ],
    20466: [
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 240},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 256},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 725},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 789},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1057}
    ],
    20467: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 122},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 512},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 544},
        {type: OfferPoiType.BUS, name: "6 Dyw. Piechoty - Zieleń Miejska", distance: 680},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 1 Nr 04", distance: 685}
    ],
    20468: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 121},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 429},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 568},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 1 Nr 04", distance: 570},
        {type: OfferPoiType.BUS, name: "6 Dyw. Piechoty - Zieleń Miejska", distance: 696}
    ],
    20469: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 383},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 671},
        {type: OfferPoiType.BUS, name: "Starynowska I - piekarnia", distance: 783},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 813}
    ],
    20470: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 390},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 678},
        {type: OfferPoiType.BUS, name: "Starynowska I - piekarnia", distance: 790},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 820}
    ],
    20471: [
        {type: OfferPoiType.BUS, name: "Watra", distance: 288},
        {type: OfferPoiType.BUS, name: "Krupówki Pomnik hr. Władysława Zamoyskiego", distance: 315},
        {type: OfferPoiType.BUS, name: "Parcele Urzędnicze", distance: 620},
        {type: OfferPoiType.PARK, name: "Górna Rówień Krupowa", distance: 624},
        {type: OfferPoiType.BUS, name: "Piłsudskiego Start", distance: 629},
        {type: OfferPoiType.LAS, name: "Las Chałubińskich", distance: 740},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Ornak", distance: 751},
        {type: OfferPoiType.BUS, name: "Grunwaldzka Ornak", distance: 767},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Józefa Piłsudskiego", distance: 791},
        {type: OfferPoiType.PARK, name: "Dolna Rówień Krupowa", distance: 1096},
        {type: OfferPoiType.PARK, name: "Park Lecha Kaczyńskiego - Prezydenta Rzeczypospolitej Polskiej", distance: 1229},
        {type: OfferPoiType.PARK, name: "Skwer Josepha Conrada Korzeniowskiego", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer księdza Mirosława Drozdka", distance: 1334},
        {type: OfferPoiType.PARK, name: "Skwer Ryszarda Kaczorowskiego Prezydenta Rzeczypospolitej Polskiej", distance: 1494}
    ],
    20472: [
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 01", distance: 178},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 04", distance: 209},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 02", distance: 268},
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Walerego Sławka 01", distance: 351},
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Walerego Sławka 02", distance: 443},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 05", distance: 555},
        {type: OfferPoiType.BUS, name: "Szancera 02", distance: 597},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 610},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 01", distance: 646},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1090},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 1105},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1355},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 1776},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 1793}
    ],
    20473: [
        {type: OfferPoiType.BUS, name: "Gołuski/Wspólna", distance: 560},
        {type: OfferPoiType.BUS, name: "Palędzie/Żelazka", distance: 648}
    ],
    20474: [{type: OfferPoiType.BUS, name: "Palędzie Leśna n/ż", distance: 509}],
    20476: [
        {type: OfferPoiType.BUS, name: "Metro Imielin 01", distance: 12},
        {type: OfferPoiType.BUS, name: "Polinezyjska 05", distance: 144},
        {type: OfferPoiType.METRO, name: "Imielin", distance: 162},
        {type: OfferPoiType.BUS, name: "Metro Imielin 04", distance: 163},
        {type: OfferPoiType.BUS, name: "Polinezyjska 04", distance: 171},
        {type: OfferPoiType.BUS, name: "Metro Imielin 03", distance: 179},
        {type: OfferPoiType.BUS, name: "Polinezyjska 03", distance: 201},
        {type: OfferPoiType.BUS, name: "Metro Imielin 02", distance: 202},
        {type: OfferPoiType.BUS, name: "Polinezyjska 02", distance: 220},
        {type: OfferPoiType.PARK, name: "Skwer Sportów Miejskich", distance: 273},
        {type: OfferPoiType.BUS, name: "Miklaszewskiego 03", distance: 348},
        {type: OfferPoiType.BUS, name: "Szolc-Rogozińskiego 02", distance: 432},
        {type: OfferPoiType.PARK, name: "Park Polskich Wynalazców", distance: 555},
        {type: OfferPoiType.PARK, name: "Park linearny nad POW", distance: 828},
        {type: OfferPoiType.PARK, name: "Skwer Kapitana Zygmunta Pawlaczyka", distance: 1208},
        {type: OfferPoiType.PARK, name: "Słoneczny Jar", distance: 1292},
        {type: OfferPoiType.PARK, name: "Lasek Brzozowy", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1722},
        {type: OfferPoiType.PARK, name: "Plac Wielkiej Przygody", distance: 1764},
        {type: OfferPoiType.PARK, name: "Sadek Natoliński", distance: 1797},
        {type: OfferPoiType.REZERWAT, name: "Aleja drzew", distance: 1989},
        {type: OfferPoiType.REZERWAT, name: "Jeziorko Imielińskie - użytek 623", distance: 2017},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 2120}
    ],
    20478: [
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 588},
        {type: OfferPoiType.BUS, name: "Pabianicka - Długa NŻ", distance: 646},
        {type: OfferPoiType.BUS, name: "Chocianowice IKEA", distance: 687},
        {type: OfferPoiType.BUS, name: "Pabianicka - Długa", distance: 731},
        {type: OfferPoiType.TRAM, name: "Chocianowice IKEA", distance: 740},
        {type: OfferPoiType.TRAM, name: "Pabianicka - Długa", distance: 750},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2221},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2424}
    ],
    20482: [
        {type: OfferPoiType.BUS, name: "Klepacka/Kościół", distance: 278},
        {type: OfferPoiType.BUS, name: "Klepacka", distance: 369},
        {type: OfferPoiType.BUS, name: "Klepacka/Pętla", distance: 389},
        {type: OfferPoiType.BUS, name: "Klepacka/Barszczańska", distance: 399},
        {type: OfferPoiType.BUS, name: "Klepacka/Wenecka", distance: 498},
        {type: OfferPoiType.BUS, name: "Klepacka/Graniczna", distance: 688},
        {type: OfferPoiType.BUS, name: "Niewodnicka/Pętla", distance: 733},
        {type: OfferPoiType.BUS, name: "Meksykańska/Rumuńska", distance: 818},
        {type: OfferPoiType.PARK, name: "Park Janiny Kurkowskiej-Spychajowej", distance: 1811}
    ]
};
import {OfferPoiType} from "./offer_poi_tags_enum";

export interface IOfferPoiEntry {
    type: OfferPoiType;
    name: string;
    distance: number;
}

/**
 * Hardcoded POI entries per offer id (nearest walkable POIs with route distance in meters).
 * Source: "2026_07 Tagi POI Inwestycje v3.csv" (2026-07). TEMPORARY — replace with BE data (US-616.1).
 */
export const OFFER_POI_TAGS: Record<number, IOfferPoiEntry[]> = {
    5362: [
        {type: OfferPoiType.BUS, name: "Jeziorna", distance: 121},
        {type: OfferPoiType.LAS, name: "Leśny zakątek", distance: 629},
        {type: OfferPoiType.LAS, name: "Małpia Wyspa", distance: 1287}
    ],
    7659: [{type: OfferPoiType.BUS, name: "Smolec - Chłopska/Śliwkowa", distance: 702}],
    8221: [
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Pasaż Handlowy", distance: 456},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Spokojna", distance: 683},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Stadion", distance: 692},
        {type: OfferPoiType.BUS, name: "Plac Neptuna", distance: 768},
        {type: OfferPoiType.BUS, name: "Niepodległości (Muzeum)", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 1050},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 1074},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 1231}
    ],
    8863: [
        {type: OfferPoiType.BUS, name: "Serbska (Centrum Kultury Agora)", distance: 91},
        {type: OfferPoiType.TRAM, name: "Serbska (Centrum Kultury Agora)", distance: 129},
        {type: OfferPoiType.BUS, name: "Łużycka", distance: 386},
        {type: OfferPoiType.BUS, name: "Most Osobowicki", distance: 578},
        {type: OfferPoiType.TRAM, name: "Osobowicka (Cmentarz II)", distance: 629},
        {type: OfferPoiType.BUS, name: "Osobowicka (Cmentarz II)", distance: 653},
        {type: OfferPoiType.TRAM, name: "Most Osobowicki", distance: 656},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1866},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 2279}
    ],
    9187: [
        {type: OfferPoiType.BUS, name: "Zegrze Osiedle 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Zegrze Osiedle 01", distance: 519}
    ],
    9458: [
        {type: OfferPoiType.BUS, name: "Wieliczka Dębowa", distance: 400},
        {type: OfferPoiType.BUS, name: "Wygoda 1 nż.", distance: 551},
        {type: OfferPoiType.BUS, name: "Czarnochowice Wygoda", distance: 733},
        {type: OfferPoiType.PARK, name: "Park osiedlowy", distance: 1721},
        {type: OfferPoiType.PARK, name: "Planty", distance: 2303},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 2354},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2385}
    ],
    9614: [
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Polna Rondo", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 1712},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 1716},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 1853}
    ],
    9681: [
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Pomnik", distance: 414},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Graniczna", distance: 455},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Biblioteka Śląska", distance: 597},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Sikorskiego", distance: 624},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 791},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 1058},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1413},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1714},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1748},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Eugeniusza Breitkopfa", distance: 1783},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1798}
    ],
    10103: [
        {type: OfferPoiType.BUS, name: "Nałęczowska 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Wojciechowska 05", distance: 379},
        {type: OfferPoiType.BUS, name: "Wojciechowska 03", distance: 427},
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Wojciechowska 01", distance: 438},
        {type: OfferPoiType.BUS, name: "Wojciechowska 02", distance: 442},
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 01", distance: 455},
        {type: OfferPoiType.BUS, name: "Nałęczowska 04", distance: 461},
        {type: OfferPoiType.BUS, name: "Nałęczowska 02", distance: 495},
        {type: OfferPoiType.BUS, name: "Cisowa 02", distance: 522}
    ],
    10198: [
        {type: OfferPoiType.PARK, name: "park Warszewo-Podbórz", distance: 225},
        {type: OfferPoiType.BUS, name: "Morenowa", distance: 232},
        {type: OfferPoiType.BUS, name: "Podbórzańska Ogrody", distance: 630},
        {type: OfferPoiType.BUS, name: "Podbórz", distance: 798},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Wodozbiór”", distance: 1943},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 2448},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 2495}
    ],
    10409: [
        {type: OfferPoiType.BUS, name: "Powstań Chłopskich", distance: 359},
        {type: OfferPoiType.BUS, name: "Ruchu Oporu", distance: 390},
        {type: OfferPoiType.BUS, name: "Redłowo SKM - Park Technologiczny", distance: 515},
        {type: OfferPoiType.BUS, name: "Instytut Med. Morskiej i Tropikalnej 01", distance: 519},
        {type: OfferPoiType.BUS, name: "Redłowo SKM - Park Technologiczny 02", distance: 523},
        {type: OfferPoiType.BUS, name: "Redłowo SKM - Park Technologiczny 01", distance: 539},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Redłowo", distance: 748},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kępa Redłowska", distance: 1446},
        {type: OfferPoiType.PARK, name: "Dziki Sad", distance: 1707}
    ],
    10692: [
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 485},
        {type: OfferPoiType.PARK, name: "Skwer Kapitana Zygmunta Pawlaczyka", distance: 1303},
        {type: OfferPoiType.PARK, name: "Park Polskich Wynalazców", distance: 1324},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1471},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1613},
        {type: OfferPoiType.PARK, name: "Skwer Sportów Miejskich", distance: 1763}
    ],
    10869: [
        {type: OfferPoiType.BUS, name: "Katowice Ceglana Szpital Kliniczny", distance: 116},
        {type: OfferPoiType.BUS, name: "Katowice Meteorologów", distance: 421},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Szpital", distance: 722},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Basen", distance: 780},
        {type: OfferPoiType.BUS, name: "Katowice Wita Stwosza", distance: 830},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1057},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1101},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Kaczmarskiego", distance: 1106},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Szymkowiaka", distance: 1121},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1345},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1498}
    ],
    11159: [
        {type: OfferPoiType.BUS, name: "Zamkowa 02", distance: 95},
        {type: OfferPoiType.BUS, name: "Zamkowa 01", distance: 118},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterów Szymankowa", distance: 421},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 02", distance: 482},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Okrzei 02", distance: 508},
        {type: OfferPoiType.BUS, name: "MOPS 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Okrzei 01", distance: 573},
        {type: OfferPoiType.BUS, name: "MOPS 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Nad Wisłą 01", distance: 719},
        {type: OfferPoiType.BUS, name: "Nad Wisłą 02", distance: 726},
        {type: OfferPoiType.PARK, name: "Park im. Mikołaja Kopernika", distance: 1065},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1163},
        {type: OfferPoiType.PARK, name: "Skwer Konstytucji 3 Maja", distance: 1324}
    ],
    11325: [
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Skromna", distance: 184},
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Szpital Wojskowy", distance: 261},
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Gdańska", distance: 504},
        {type: OfferPoiType.BUS, name: "Zaświat / Cmentarz", distance: 588},
        {type: OfferPoiType.TRAM, name: "Gdańska / Powst. Warszawy", distance: 634},
        {type: OfferPoiType.BUS, name: "Czerkaska / Gdańska", distance: 656},
        {type: OfferPoiType.BUS, name: "Gdańska / Czerkaska", distance: 658},
        {type: OfferPoiType.PARK, name: "Skwer Inwalidów Wojennych", distance: 693}
    ],
    11421: [
        {type: OfferPoiType.BUS, name: "Dziwnów - Wybreże Kościuszkowskie - Słoneczna", distance: 392},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1968}
    ],
    11485: [
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 323},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 336},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 361},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 480},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 507},
        {type: OfferPoiType.TRAM, name: "Nyska", distance: 545},
        {type: OfferPoiType.BUS, name: "Widna", distance: 561},
        {type: OfferPoiType.BUS, name: "Nyska", distance: 613},
        {type: OfferPoiType.TRAM, name: "Prudnicka", distance: 736},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1439},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1664},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1715},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1885}
    ],
    11820: [
        {type: OfferPoiType.BUS, name: "Marysin", distance: 421},
        {type: OfferPoiType.BUS, name: "Ustronie Morskie - pętla", distance: 442}
    ],
    12093: [
        {type: OfferPoiType.BUS, name: "Przystań Żeglarska", distance: 86},
        {type: OfferPoiType.BUS, name: "Lotnisko", distance: 503},
        {type: OfferPoiType.BUS, name: "Centrum Żeglarskie", distance: 774},
        {type: OfferPoiType.BUS, name: "Most Cłowy", distance: 825}
    ],
    12148: [
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 57},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 149},
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 253},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 527},
        {type: OfferPoiType.BUS, name: "Rondo Toruńskie", distance: 617},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 640},
        {type: OfferPoiType.TRAM, name: "Jagiellońska / Łużycka", distance: 656},
        {type: OfferPoiType.TRAM, name: "Jagiellońska - Łużycka", distance: 684},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 781},
        {type: OfferPoiType.PARK, name: "Bulwar im. Leona Janty-Połczyńskiego", distance: 888},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1063},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 1198}
    ],
    12642: [{type: OfferPoiType.LAS, name: "Drużyna Chrobrego", distance: 1463}],
    12872: [
        {type: OfferPoiType.BUS, name: "Sobieskiego - 3 Maja N/Ż 03", distance: 213},
        {type: OfferPoiType.BUS, name: "Sobieskiego - 3 Maja N/Ż 02", distance: 260},
        {type: OfferPoiType.BUS, name: "3 Maja - Emcek 02", distance: 412},
        {type: OfferPoiType.BUS, name: "3 Maja - Fabryczna 01", distance: 425},
        {type: OfferPoiType.BUS, name: "3 Maja - Emcek 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Sobieskiego - 3 Maja 01", distance: 501},
        {type: OfferPoiType.BUS, name: "3 Maja - Fabryczna 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Grunwaldzka N/Ż 02", distance: 572},
        {type: OfferPoiType.BUS, name: "3 Maja - Wazów N/Ż 02", distance: 611},
        {type: OfferPoiType.BUS, name: "3 Maja - Wazów N/Ż 01", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Ireny Sendlerowej", distance: 870},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1148},
        {type: OfferPoiType.PARK, name: "Plac Władysława Broniewskiego", distance: 1163},
        {type: OfferPoiType.PARK, name: 'Park kulturowy "Klasztorne stawy"', distance: 1200},
        {type: OfferPoiType.PARK, name: "Słupski Park Modelarski - RC GRYF Modele Zdalnie Sterowane", distance: 1323},
        {type: OfferPoiType.PARK, name: "Park im. Henryka Sienkiewicza", distance: 1605},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 1643},
        {type: OfferPoiType.PARK, name: "Park Pianistyki Polskiej", distance: 1738}
    ],
    12904: [
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 62},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 122},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Kopernika", distance: 171},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 178},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 221},
        {type: OfferPoiType.BUS, name: "Kopernika - Żeromskiego", distance: 230},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 257},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 271},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 326},
        {type: OfferPoiType.BUS, name: "Gdańska - Struga", distance: 341},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Żeromskiego", distance: 344},
        {type: OfferPoiType.PARK, name: "Skwer im. Lecha Kunki", distance: 416},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 463},
        {type: OfferPoiType.BUS, name: "Struga - Kościuszki", distance: 467},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Mickiewicza NŻ", distance: 473},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Zamenhofa", distance: 509},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 511},
        {type: OfferPoiType.TRAM, name: "Kopernika - Łąkowa", distance: 519},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Mickiewicza", distance: 540},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 569}
    ],
    12963: [
        {type: OfferPoiType.BUS, name: "Dorodna 02", distance: 478},
        {type: OfferPoiType.BUS, name: "Laurowa 02", distance: 617},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 654},
        {type: OfferPoiType.BUS, name: "Laurowa 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Portowa 02", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 1543}
    ],
    12968: [
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Stawowa", distance: 393},
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Błonia", distance: 772},
        {type: OfferPoiType.PARK, name: "Park Rybnik Paruszowiec przy Tężni", distance: 1053}
    ],
    12991: [
        {type: OfferPoiType.BUS, name: "Wołkowyska n/ż", distance: 274},
        {type: OfferPoiType.BUS, name: "Kopiec Wolności n/ż", distance: 509},
        {type: OfferPoiType.BUS, name: "Katowicka n/ż", distance: 650},
        {type: OfferPoiType.REZERWAT, name: "Traszki Ratajskie", distance: 1178},
        {type: OfferPoiType.PARK, name: "Park na os. Tysiąclecia", distance: 1220},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 2054},
        {type: OfferPoiType.PARK, name: "Park Forteczny", distance: 2330}
    ],
    13149: [
        {type: OfferPoiType.BUS, name: "Rybaki Górne 02", distance: 301},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 02", distance: 361},
        {type: OfferPoiType.PARK, name: 'Skwer "Stołówka"', distance: 400},
        {type: OfferPoiType.BUS, name: "Aksamitna 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 01", distance: 494},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 561},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 597},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 02", distance: 597},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 01", distance: 619},
        {type: OfferPoiType.BUS, name: "Łagiewniki 01", distance: 620},
        {type: OfferPoiType.BUS, name: "Plac Solidarności 04", distance: 661},
        {type: OfferPoiType.BUS, name: "Heweliusza 01", distance: 664},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 679},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 773},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 941},
        {type: OfferPoiType.PARK, name: "Skwer Heweliusza", distance: 989},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1480},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1542},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1769}
    ],
    13188: [
        {type: OfferPoiType.BUS, name: "Wynalazek 03", distance: 268},
        {type: OfferPoiType.BUS, name: "Wynalazek 04", distance: 291},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 360},
        {type: OfferPoiType.BUS, name: "Komputerowa 02", distance: 386},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 388},
        {type: OfferPoiType.BUS, name: "Komputerowa 01", distance: 433},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 489},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 514},
        {type: OfferPoiType.BUS, name: "Rondo Żabczyńskiego 04", distance: 516},
        {type: OfferPoiType.BUS, name: "PKP Służewiec 01", distance: 562},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 583},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Służewiec", distance: 591},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 11", distance: 647},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 15", distance: 647},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 12", distance: 670},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 14", distance: 673},
        {type: OfferPoiType.TRAM, name: "PKP Służewiec 13", distance: 676},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 746},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1132},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1833}
    ],
    13266: [
        {type: OfferPoiType.BUS, name: "Barzychowskiej 02", distance: 311},
        {type: OfferPoiType.BUS, name: "Barzychowskiej 01", distance: 349},
        {type: OfferPoiType.BUS, name: "Hokejowa 01", distance: 421},
        {type: OfferPoiType.BUS, name: "Olimpijska 02", distance: 519},
        {type: OfferPoiType.BUS, name: "Hokejowa 02", distance: 522},
        {type: OfferPoiType.BUS, name: "Olimpijska 01", distance: 535},
        {type: OfferPoiType.BUS, name: "Podleckiego 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Podleckiego 01", distance: 644}
    ],
    13308: [
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 507},
        {type: OfferPoiType.BUS, name: "Sielawy", distance: 607},
        {type: OfferPoiType.BUS, name: "Dworska", distance: 647},
        {type: OfferPoiType.BUS, name: "Naramowice Wschodnie", distance: 686},
        {type: OfferPoiType.BUS, name: "Rubież", distance: 692},
        {type: OfferPoiType.BUS, name: "Bielicowa", distance: 736},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1582},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2007},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2486}
    ],
    13487: [
        {type: OfferPoiType.BUS, name: "Kórnicka 01", distance: 777},
        {type: OfferPoiType.BUS, name: "Kórnicka 02", distance: 810},
        {type: OfferPoiType.PARK, name: "Park nad Jeziorem Zgorzała", distance: 1305}
    ],
    13504: [
        {type: OfferPoiType.BUS, name: "Politechniki - Skrzywana", distance: 137},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 147},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 270},
        {type: OfferPoiType.TRAM, name: "Politechniki - Obywatelska", distance: 430},
        {type: OfferPoiType.BUS, name: "Obywatelska - Politechniki", distance: 450},
        {type: OfferPoiType.BUS, name: "Politechniki - Obywatelska", distance: 478},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 501},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 632},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 660},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 707},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 715},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 716},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 858},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1027},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1345},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1379},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1394}
    ],
    13518: [
        {type: OfferPoiType.BUS, name: "Plac Neptuna", distance: 415},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Pasaż Handlowy", distance: 442},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Spokojna", distance: 474},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 500},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 504},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Stadion", distance: 597},
        {type: OfferPoiType.BUS, name: "Niepodległości (Muzeum)", distance: 598},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 641},
        {type: OfferPoiType.BUS, name: "Kolejowa 24", distance: 797}
    ],
    13568: [
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego żwirownia 08", distance: 79},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego żwirownia 05", distance: 149},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Podmiejska 10", distance: 532},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 06", distance: 622},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Koło 07", distance: 661},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 03", distance: 676},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 923},
        {type: OfferPoiType.PARK, name: "Bulwar WSK Rzeszów", distance: 2092},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 2304},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2464}
    ],
    13572: [
        {type: OfferPoiType.BUS, name: "Wywrockiego / Strzelnicza 02", distance: 29},
        {type: OfferPoiType.BUS, name: "Plenerowa 01", distance: 200},
        {type: OfferPoiType.BUS, name: "Plenerowa 02", distance: 208},
        {type: OfferPoiType.BUS, name: "Strzelnicza 02", distance: 247},
        {type: OfferPoiType.BUS, name: "Strzelnicza 01", distance: 333},
        {type: OfferPoiType.BUS, name: "Wywrockiego / Jagodowa 01", distance: 456},
        {type: OfferPoiType.BUS, name: "Wywrockiego / Jagodowa 04", distance: 493},
        {type: OfferPoiType.BUS, name: "Panoramiczna 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Wyspiańskiego / Strzelnicza 03", distance: 626},
        {type: OfferPoiType.BUS, name: "Panoramiczna 01", distance: 642},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 1135},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 1136},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1438},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 2360},
        {type: OfferPoiType.PARK, name: "Park Sybiraków", distance: 2422}
    ],
    13594: [{type: OfferPoiType.BUS, name: "Dębina", distance: 581}],
    13634: [
        {type: OfferPoiType.BUS, name: "23 Marca", distance: 126},
        {type: OfferPoiType.BUS, name: "Sopot Przylesie", distance: 326},
        {type: OfferPoiType.BUS, name: "Okrężna (n/ż)", distance: 604},
        {type: OfferPoiType.BUS, name: "Cmentarz", distance: 720},
        {type: OfferPoiType.LAS, name: "Park Wzgórze Augusty", distance: 1102},
        {type: OfferPoiType.REZERWAT, name: "Konwaliowe Wzgórze", distance: 1252},
        {type: OfferPoiType.PARK, name: "Park Sanitariuszki Inki", distance: 1312},
        {type: OfferPoiType.REZERWAT, name: "Daglezje imienia Jeana Georga Haffnera", distance: 1366},
        {type: OfferPoiType.REZERWAT, name: "Kokoryczowe Zbocze", distance: 1495},
        {type: OfferPoiType.PARK, name: "Park na Goyki", distance: 1605},
        {type: OfferPoiType.REZERWAT, name: "Wąwozy Grodowe", distance: 1766},
        {type: OfferPoiType.PARK, name: "Skwer Michała Urbanka", distance: 1935},
        {type: OfferPoiType.PARK, name: "Skwer Czesława Miłosza", distance: 1948},
        {type: OfferPoiType.PARK, name: "Skwer im. Księdza Władysława Szymańskiego", distance: 1970},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Przyrody Zajęcze Wzgórze", distance: 2216},
        {type: OfferPoiType.REZERWAT, name: "Cisowe Zbocze", distance: 2221}
    ],
    13652: [
        {type: OfferPoiType.BUS, name: "Suwalska - szkoła 01", distance: 421},
        {type: OfferPoiType.BUS, name: "Suwalska - szkoła 08", distance: 462},
        {type: OfferPoiType.BUS, name: "Suwalska - PUK 06", distance: 699},
        {type: OfferPoiType.PARK, name: "Park Odkrywców Kolei", distance: 790},
        {type: OfferPoiType.BUS, name: "Suwalska - PUK 03", distance: 833},
        {type: OfferPoiType.KOLEJ, name: "Ełk", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1631},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1676},
        {type: OfferPoiType.PARK, name: 'Skwer gen. Aleksandra Krzyżanowskiego "Wilka"', distance: 1841},
        {type: OfferPoiType.PARK, name: "Park Kopernika", distance: 1978},
        {type: OfferPoiType.PARK, name: "Skwer Rusałki", distance: 1995},
        {type: OfferPoiType.PARK, name: "Park sportowy", distance: 2132},
        {type: OfferPoiType.PARK, name: "Plaża Miejska", distance: 2191},
        {type: OfferPoiType.PARK, name: "Park Ireny Tamary Misztal", distance: 2257},
        {type: OfferPoiType.REZERWAT, name: "Wyspa lęgowa", distance: 2393}
    ],
    13655: [
        {type: OfferPoiType.BUS, name: "Teatr Polski", distance: 330},
        {type: OfferPoiType.BUS, name: "Parkowa", distance: 332},
        {type: OfferPoiType.TRAM, name: "Parkowa", distance: 332},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 333},
        {type: OfferPoiType.TRAM, name: "Teatr Polski", distance: 388},
        {type: OfferPoiType.BUS, name: "Dubois", distance: 408},
        {type: OfferPoiType.TRAM, name: "Dubois", distance: 419},
        {type: OfferPoiType.LAS, name: "Park imienia Stanisława Nadratowskiego", distance: 543},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Nadratowskiego", distance: 543},
        {type: OfferPoiType.BUS, name: "Emilii Plater", distance: 621},
        {type: OfferPoiType.BUS, name: "Admiralska nż", distance: 658},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 781},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 781},
        {type: OfferPoiType.TRAM, name: "Wały Chrobrego", distance: 798},
        {type: OfferPoiType.TRAM, name: "Matejki", distance: 831},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 1771},
        {type: OfferPoiType.PARK, name: "Skwer imienia Raoula Wallenberga", distance: 2204},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 2246},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 2327},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jacka Nieżychowskiego", distance: 2336}
    ],
    13695: [
        {type: OfferPoiType.BUS, name: "Lalki 03", distance: 299},
        {type: OfferPoiType.BUS, name: "PKP Ursus 02", distance: 325},
        {type: OfferPoiType.BUS, name: "Lalki 04", distance: 384},
        {type: OfferPoiType.BUS, name: "Lalki 01", distance: 438},
        {type: OfferPoiType.BUS, name: "PKP Ursus 01", distance: 439},
        {type: OfferPoiType.BUS, name: "Lalki 02", distance: 440},
        {type: OfferPoiType.BUS, name: "PKP Ursus 16", distance: 478},
        {type: OfferPoiType.BUS, name: "PKP Ursus 12", distance: 489},
        {type: OfferPoiType.BUS, name: "PKP Ursus 13", distance: 493},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 01", distance: 495},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 498},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ursus", distance: 583},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 690},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 888},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 893},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 967}
    ],
    13778: [
        {type: OfferPoiType.BUS, name: "Oś. Unieście ul.6 Marca - ul.Pogodna", distance: 282},
        {type: OfferPoiType.BUS, name: "6 Marca - Prądno", distance: 284},
        {type: OfferPoiType.BUS, name: "Mielno - ul. Chrobrego (Mickiewicza)", distance: 766},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Rawąskiego", distance: 878},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1914}
    ],
    13786: [
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej", distance: 269},
        {type: OfferPoiType.TRAM, name: "Unii Lubelskiej", distance: 343},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej Szpital", distance: 419},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej Szpital (Brama Główna)", distance: 486},
        {type: OfferPoiType.LAS, name: "park imienia Teresy Hulboj", distance: 521},
        {type: OfferPoiType.BUS, name: "Wincentego Pola", distance: 581},
        {type: OfferPoiType.PARK, name: "park Krystyny i Romana Łyczywków", distance: 616},
        {type: OfferPoiType.PARK, name: "skwer Zdrowia imienia Doktora Henryka Kompfa", distance: 655},
        {type: OfferPoiType.BUS, name: "Zawadzkiego Kościół", distance: 701},
        {type: OfferPoiType.PARK, name: "Skwer Majora Mieczysława Tarchalskiego", distance: 1295},
        {type: OfferPoiType.PARK, name: "Syrenie Stawy", distance: 1438},
        {type: OfferPoiType.PARK, name: "Psie Pole", distance: 1456},
        {type: OfferPoiType.PARK, name: "Skwer imienia Telesfora Badetko", distance: 1502},
        {type: OfferPoiType.PARK, name: "park Szachisty", distance: 1738},
        {type: OfferPoiType.PARK, name: "Park imienia Profesora Bolesława Briksa", distance: 1787}
    ],
    13823: [
        {type: OfferPoiType.BUS, name: "Domeyki 01", distance: 159},
        {type: OfferPoiType.BUS, name: "Domeyki 02", distance: 252},
        {type: OfferPoiType.BUS, name: "Energetyków 02", distance: 329},
        {type: OfferPoiType.BUS, name: "Elektromontaż 03", distance: 664},
        {type: OfferPoiType.BUS, name: "Elektromontaż 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Samsonowicza 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Elektromontaż 02", distance: 785},
        {type: OfferPoiType.BUS, name: "Samsonowicza 02", distance: 823}
    ],
    13875: [
        {type: OfferPoiType.BUS, name: "Łąkowa", distance: 66},
        {type: OfferPoiType.BUS, name: "Langiewicza", distance: 177},
        {type: OfferPoiType.BUS, name: "Dźwigowa", distance: 431},
        {type: OfferPoiType.BUS, name: "Klonowa", distance: 518},
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 582},
        {type: OfferPoiType.BUS, name: "Mińsk Maz. Siennicka", distance: 603},
        {type: OfferPoiType.BUS, name: "Rudzkiego", distance: 642},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 852},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1209},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 1637},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 1683},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 1709},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 1763}
    ],
    13902: [
        {type: OfferPoiType.BUS, name: "Konstantynowska - Krańcowa NŻ", distance: 195},
        {type: OfferPoiType.TRAM, name: "Konstantynowska - Krańcowa", distance: 253},
        {type: OfferPoiType.PARK, name: "Łódzkie Błonia", distance: 682},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 1470},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1601},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1715},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 1860},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 1944},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 2007},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 2191}
    ],
    13910: [
        {type: OfferPoiType.LAS, name: "Lasek Alfreda", distance: 394},
        {type: OfferPoiType.BUS, name: "Kolonia Agnieszki Promienna", distance: 414},
        {type: OfferPoiType.BUS, name: "Kolonia Agnieszki Bytomska", distance: 559},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 570},
        {type: OfferPoiType.BUS, name: "Wełnowiec Plac Alfreda", distance: 623},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Plac Alfreda", distance: 663},
        {type: OfferPoiType.BUS, name: "Józefowiec Szpital", distance: 733},
        {type: OfferPoiType.LAS, name: "Lasek Bytkowski", distance: 912},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1000},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1535},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Halora", distance: 1555},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1755},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 1833},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2310},
        {type: OfferPoiType.PARK, name: "Skwer księdza Franciszka Macherskiego", distance: 2395}
    ],
    13928: [
        {type: OfferPoiType.BUS, name: "Paprocka/Chełmońskiego", distance: 582},
        {type: OfferPoiType.PARK, name: "Park 100-lecia odzyskania niepodległości", distance: 592},
        {type: OfferPoiType.BUS, name: "Malczewskiego", distance: 659},
        {type: OfferPoiType.BUS, name: "Baczyńskiego", distance: 776},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 794},
        {type: OfferPoiType.BUS, name: "Paprocka/Boczna", distance: 818},
        {type: OfferPoiType.BUS, name: "Boczna", distance: 842},
        {type: OfferPoiType.PARK, name: "Park Miejski imienia Stefana Złotnickiego", distance: 1387},
        {type: OfferPoiType.PARK, name: "Skwer Zenona Anstadta", distance: 1654},
        {type: OfferPoiType.PARK, name: "Skwer Pawła Królikowskiego", distance: 1830},
        {type: OfferPoiType.PARK, name: "Skwer Jana Libsza", distance: 2235},
        {type: OfferPoiType.PARK, name: "Park Pogoń", distance: 2364}
    ],
    13932: [
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 258},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 260},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - rynek", distance: 489},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - Rynek 2 Nr 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Rzeczna", distance: 563},
        {type: OfferPoiType.BUS, name: "Frankowskiego Nr 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Łopuskiego - Szpital 1 Nr 01", distance: 618},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 639},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 676},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 682},
        {type: OfferPoiType.PARK, name: "Skwer Miast Partnerskich", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Pionierów Kołobrzegu", distance: 903},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 914},
        {type: OfferPoiType.PARK, name: "Skwer 750-lecia", distance: 935},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1464},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1965}
    ],
    13935: [
        {type: OfferPoiType.BUS, name: "Drwęcka 01", distance: 122},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 212},
        {type: OfferPoiType.BUS, name: "Drwęcka 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 225},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 236},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 296},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 01", distance: 438},
        {type: OfferPoiType.BUS, name: "Siennicka 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Siennicka 02", distance: 552},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Grochów", distance: 785},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1001},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1045},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1603},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1651},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1835},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1893},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 2223}
    ],
    13937: [
        {type: OfferPoiType.BUS, name: "Zjazdowa - Beskidzka NŻ", distance: 157},
        {type: OfferPoiType.BUS, name: "Marmurowa - Beskidzka NŻ", distance: 401},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Budy", distance: 445},
        {type: OfferPoiType.BUS, name: "Marmurowa - Brzezińska", distance: 570},
        {type: OfferPoiType.BUS, name: "Brzezińska - Marmurowa", distance: 742},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Opolska NŻ", distance: 799},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 1398}
    ],
    13946: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 179},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 190},
        {type: OfferPoiType.BUS, name: "Brylowska 01", distance: 332},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 371},
        {type: OfferPoiType.BUS, name: "Brylowska 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Dworzec Zachodni (Tunelowa) 01", distance: 671},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia", distance: 690},
        {type: OfferPoiType.BUS, name: "Szpital Wolski 06", distance: 714},
        {type: OfferPoiType.BUS, name: "Szpital Wolski 05", distance: 721},
        {type: OfferPoiType.BUS, name: "Prądzyńskiego 02", distance: 726},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia WKD", distance: 771},
        {type: OfferPoiType.TRAM, name: "Szpital Wolski 04", distance: 802},
        {type: OfferPoiType.TRAM, name: "Szpital Wolski 03", distance: 810},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1219},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1466},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 1676},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1824},
        {type: OfferPoiType.PARK, name: "Różany Skwer Pysznych Pączków", distance: 1865},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1898},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1989}
    ],
    13981: [
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 01", distance: 277},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 465},
        {type: OfferPoiType.BUS, name: "Przejezdna 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Przejezdna 01", distance: 682},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 738},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 810},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1233}
    ],
    14061: [
        {type: OfferPoiType.BUS, name: "Maratońska (wew.) - Plocka", distance: 385},
        {type: OfferPoiType.BUS, name: "Maratońska - Plocka", distance: 441},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego - blok 270", distance: 657},
        {type: OfferPoiType.BUS, name: "Armii Krajowej - Batalionów Chłopskich", distance: 751},
        {type: OfferPoiType.BUS, name: "Maratońska - Maratońska 91 NŻ", distance: 770},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1419},
        {type: OfferPoiType.PARK, name: "Park na Smulsku", distance: 2176},
        {type: OfferPoiType.PARK, name: "Łódzkie Błonia", distance: 2232}
    ],
    14108: [
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 06", distance: 137},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 02", distance: 218},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 05", distance: 266},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 01", distance: 272},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 04", distance: 282},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków Wieczysta 08", distance: 283},
        {type: OfferPoiType.PARK, name: "Skwer Pilota Pirxa", distance: 322},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 03-91", distance: 407},
        {type: OfferPoiType.TRAM, name: "TAURON Arena Kraków Wieczysta 03", distance: 433},
        {type: OfferPoiType.BUS, name: "Białucha 04", distance: 556},
        {type: OfferPoiType.BUS, name: "Meissnera 02", distance: 559},
        {type: OfferPoiType.TRAM, name: "Białucha 02", distance: 670},
        {type: OfferPoiType.TRAM, name: "Białucha 01", distance: 681},
        {type: OfferPoiType.BUS, name: "Meissnera 01", distance: 694},
        {type: OfferPoiType.BUS, name: "Białucha 03", distance: 720},
        {type: OfferPoiType.BUS, name: "TAURON Arena Kraków 01", distance: 800},
        {type: OfferPoiType.TRAM, name: "Muzeum Lotnictwa Polskiego 02", distance: 820},
        {type: OfferPoiType.TRAM, name: "Muzeum Lotnictwa Polskiego 01", distance: 829},
        {type: OfferPoiType.PARK, name: "Park Lotników Polskich", distance: 1038},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy przy ul. Chałupnika", distance: 1097},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 1198},
        {type: OfferPoiType.PARK, name: "Ogród Fabryczny", distance: 1222},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 1809},
        {type: OfferPoiType.PARK, name: "Lotniczy Park Kulturowy", distance: 1935}
    ],
    14130: [
        {type: OfferPoiType.BUS, name: "Dw. Północny", distance: 262},
        {type: OfferPoiType.BUS, name: "Źródłowa - Wojska Polskiego NŻ", distance: 315},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 340},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 366},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Marynarska", distance: 482},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Marynarska", distance: 507},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 554},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 606},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 645},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Głowackiego", distance: 658},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Franciszkańska", distance: 739},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 815},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1051},
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 1173}
    ],
    14149: [
        {type: OfferPoiType.BUS, name: "Rondo ks. J. Popiełuszki 01", distance: 217},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Jastrzębia 02", distance: 345},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Działkowa 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Powstańców 03", distance: 424},
        {type: OfferPoiType.BUS, name: "Ołówkowa 04", distance: 466},
        {type: OfferPoiType.BUS, name: "Jastrzębia 01", distance: 508},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 1075},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 1488},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1576},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1891},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 2385}
    ],
    14152: [
        {type: OfferPoiType.PARK, name: "Park Kaszubski im.Jana Myślisza", distance: 229},
        {type: OfferPoiType.BUS, name: "Hel Śródmieście", distance: 344},
        {type: OfferPoiType.PARK, name: "Park Rzeźby Kaszubskiej", distance: 451},
        {type: OfferPoiType.BUS, name: "Hel, dworzec kolejowy", distance: 460},
        {type: OfferPoiType.BUS, name: "Hel, Dworzec Kolejowy", distance: 577},
        {type: OfferPoiType.KOLEJ, name: "Hel", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Wydmowy", distance: 611}
    ],
    14246: [
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 03", distance: 72},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 05", distance: 108},
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 04", distance: 121},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 02", distance: 124},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 01", distance: 135},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 06", distance: 156},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 309},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 419},
        {type: OfferPoiType.BUS, name: "Nowolipie 01", distance: 443},
        {type: OfferPoiType.BUS, name: "Okopowa 01", distance: 480},
        {type: OfferPoiType.BUS, name: "Okopowa 10", distance: 495},
        {type: OfferPoiType.TRAM, name: "Okopowa 03", distance: 496},
        {type: OfferPoiType.BUS, name: "Nowolipie 02", distance: 512},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 564},
        {type: OfferPoiType.TRAM, name: "Kino Femina 05", distance: 565},
        {type: OfferPoiType.TRAM, name: "Kino Femina 10", distance: 599},
        {type: OfferPoiType.TRAM, name: "Okopowa 07", distance: 620},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 628},
        {type: OfferPoiType.TRAM, name: "Kino Femina 09", distance: 632},
        {type: OfferPoiType.TRAM, name: "Kino Femina 06", distance: 641},
        {type: OfferPoiType.TRAM, name: "Okopowa 08", distance: 665},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 722},
        {type: OfferPoiType.TRAM, name: "Żytnia 02", distance: 798},
        {type: OfferPoiType.PARK, name: "Skwer Racheli Auerbach", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 878},
        {type: OfferPoiType.PARK, name: "Skwer gen. Jana Jura-Gorzechowskiego", distance: 941},
        {type: OfferPoiType.PARK, name: "Skwer Duśki Trafankowskiej", distance: 1065},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1089},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 2416}
    ],
    14252: [
        {type: OfferPoiType.BUS, name: "Boryszew 01", distance: 89},
        {type: OfferPoiType.BUS, name: "Boryszew 02", distance: 135},
        {type: OfferPoiType.BUS, name: "Stefanówka 01", distance: 673},
        {type: OfferPoiType.BUS, name: "Stefanówka 02", distance: 710},
        {type: OfferPoiType.PARK, name: "Skwer Generała Stefana Grota-Roweckiego", distance: 2228}
    ],
    14256: [
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa", distance: 228},
        {type: OfferPoiType.BUS, name: "Parkowa / Uzdrowiskowa", distance: 307},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Interferie", distance: 414},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Wiatrak", distance: 648},
        {type: OfferPoiType.BUS, name: "Fort Zachodni", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 993}
    ],
    14287: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 52},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 334},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 409},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 430},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 498},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Niepodległości", distance: 536},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Niepodległości", distance: 545},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 606},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 619},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 636},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 673},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 675},
        {type: OfferPoiType.TRAM, name: "Pl. Reymonta", distance: 692},
        {type: OfferPoiType.TRAM, name: "Pl. Niepodległości", distance: 702},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 954},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1001},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1024},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1037},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1086},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1200}
    ],
    14312: [
        {type: OfferPoiType.BUS, name: "1 Sierpnia 02", distance: 242},
        {type: OfferPoiType.TRAM, name: "Włochy-Ratusz 04", distance: 359},
        {type: OfferPoiType.BUS, name: "1 Sierpnia 01", distance: 386},
        {type: OfferPoiType.TRAM, name: "Włochy-Ratusz 03", distance: 416},
        {type: OfferPoiType.BUS, name: "Włochy-Ratusz 01", distance: 422},
        {type: OfferPoiType.BUS, name: "Włochy-Ratusz 02", distance: 434},
        {type: OfferPoiType.BUS, name: "1 Sierpnia 03", distance: 482},
        {type: OfferPoiType.TRAM, name: "PKP Rakowiec 04", distance: 496},
        {type: OfferPoiType.BUS, name: "PKP Rakowiec 05", distance: 504},
        {type: OfferPoiType.BUS, name: "PKP Rakowiec 06", distance: 518},
        {type: OfferPoiType.TRAM, name: "PKP Rakowiec 03", distance: 556},
        {type: OfferPoiType.BUS, name: "Jadwisin 02", distance: 631},
        {type: OfferPoiType.BUS, name: "PKP Rakowiec 01", distance: 637},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Rakowiec", distance: 667},
        {type: OfferPoiType.BUS, name: "Hynka 01", distance: 712},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 727},
        {type: OfferPoiType.TRAM, name: "Hynka 04", distance: 732},
        {type: OfferPoiType.TRAM, name: "Hynka 03", distance: 821},
        {type: OfferPoiType.PARK, name: "Fort Rakowiec", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Szczęśliwicki", distance: 1695},
        {type: OfferPoiType.PARK, name: "Park Zasława Malickiego", distance: 2095},
        {type: OfferPoiType.PARK, name: "Skwer Dobrego Maharadży", distance: 2215}
    ],
    14364: [
        {type: OfferPoiType.TRAM, name: "Norymberska 01", distance: 582},
        {type: OfferPoiType.TRAM, name: "Norymberska 02", distance: 588},
        {type: OfferPoiType.BUS, name: "Norymberska 04", distance: 620},
        {type: OfferPoiType.BUS, name: "Norymberska", distance: 636},
        {type: OfferPoiType.BUS, name: "Norymberska 03", distance: 647},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 01", distance: 700},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 02", distance: 718},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 04", distance: 726},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 03", distance: 752},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 05", distance: 753},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 04", distance: 780},
        {type: OfferPoiType.BUS, name: "Rostworowskiego", distance: 789},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 01", distance: 806},
        {type: OfferPoiType.BUS, name: "Rostworowskiego 01", distance: 835},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 02", distance: 838},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 863},
        {type: OfferPoiType.PARK, name: "Park Zakrzówek", distance: 921},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1458},
        {type: OfferPoiType.PARK, name: "Skałki Twardowskiego", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1736},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 1910}
    ],
    14404: [
        {type: OfferPoiType.BUS, name: "Mazowiecka 02", distance: 216},
        {type: OfferPoiType.BUS, name: "Mazowiecka 01", distance: 263},
        {type: OfferPoiType.BUS, name: "Urząd Marszałkowski 02", distance: 311},
        {type: OfferPoiType.BUS, name: "Urząd Marszałkowski 01", distance: 366},
        {type: OfferPoiType.BUS, name: "Wrocławska 01", distance: 604},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 02", distance: 656},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 01", distance: 660},
        {type: OfferPoiType.BUS, name: "Biprostal 04", distance: 660},
        {type: OfferPoiType.TRAM, name: "Urzędnicza 02", distance: 710},
        {type: OfferPoiType.TRAM, name: "Biprostal 01", distance: 716},
        {type: OfferPoiType.TRAM, name: "Urzędnicza 01", distance: 720},
        {type: OfferPoiType.BUS, name: "Wrocławska 02", distance: 747},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 03", distance: 752},
        {type: OfferPoiType.TRAM, name: "Biprostal 02", distance: 762},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 815},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 874},
        {type: OfferPoiType.PARK, name: "Gołębi Ogród Krakowian", distance: 881},
        {type: OfferPoiType.PARK, name: "Skwer imienia Więźniów Obozów Zagłady", distance: 983},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 1009},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1097},
        {type: OfferPoiType.PARK, name: "Ogrody Łobzów", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1194}
    ],
    14451: [
        {type: OfferPoiType.BUS, name: "Dąb Szkoła", distance: 402},
        {type: OfferPoiType.BUS, name: "Dąb Krzyżowa", distance: 404},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 490},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 495},
        {type: OfferPoiType.BUS, name: "Józefowiec Ściegiennego", distance: 505},
        {type: OfferPoiType.PARK, name: "Skwer księdza Franciszka Macherskiego", distance: 773},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 812},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1263},
        {type: OfferPoiType.PARK, name: "Ptaki", distance: 1439},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 1503},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Ryszki", distance: 1640},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 1687}
    ],
    14460: [
        {type: OfferPoiType.BUS, name: "Strumykowa", distance: 118},
        {type: OfferPoiType.BUS, name: "Wojnów", distance: 363},
        {type: OfferPoiType.BUS, name: "Smocza", distance: 472},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Wojnów", distance: 566},
        {type: OfferPoiType.BUS, name: "Wojnów (pętla)", distance: 619},
        {type: OfferPoiType.PARK, name: "Park Strachociński", distance: 1062}
    ],
    14462: [
        {type: OfferPoiType.BUS, name: "Zajezdnia Redutowa 01", distance: 262},
        {type: OfferPoiType.BUS, name: "Zajezdnia Redutowa 02", distance: 387},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 05", distance: 404},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 06", distance: 485},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 03", distance: 532},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Pustola 01", distance: 558},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 04", distance: 562},
        {type: OfferPoiType.BUS, name: "Pustola 02", distance: 688},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 01", distance: 691},
        {type: OfferPoiType.BUS, name: "Cm. Prawosławny 02", distance: 710},
        {type: OfferPoiType.PARK, name: "Park Powstańców Warszawy", distance: 721},
        {type: OfferPoiType.BUS, name: "Cm. Prawosławny 01", distance: 793},
        {type: OfferPoiType.TRAM, name: "Sowińskiego 02", distance: 841},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 889},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Klincewicza", distance: 921},
        {type: OfferPoiType.PARK, name: "Skwer Wiesława Michnikowskiego", distance: 1197},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 1228},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1316}
    ],
    14467: [
        {type: OfferPoiType.BUS, name: "Orfeusz 01", distance: 125},
        {type: OfferPoiType.BUS, name: "Orfeusz 04", distance: 219},
        {type: OfferPoiType.BUS, name: "Orfeusz 03", distance: 231},
        {type: OfferPoiType.BUS, name: "Orfeusz 02", distance: 276},
        {type: OfferPoiType.BUS, name: "Skrzypcowa 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 04", distance: 448},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Oratoryjna 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Oratoryjna 02", distance: 612},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1539}
    ],
    14480: [
        {type: OfferPoiType.BUS, name: "Mjr Słabego", distance: 291},
        {type: OfferPoiType.BUS, name: "Złota Karczma 02", distance: 568},
        {type: OfferPoiType.BUS, name: "Złota Karczma 01", distance: 587},
        {type: OfferPoiType.BUS, name: "Harfowa 01", distance: 789},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Wąwóz Huzarów", distance: 1631},
        {type: OfferPoiType.REZERWAT, name: "Źródliska Potoku Oliwskiego", distance: 1869},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Dolina Strzyży", distance: 2140},
        {type: OfferPoiType.LAS, name: "190-letnia Pierwotna bukowa dolina", distance: 2302}
    ],
    14542: [
        {type: OfferPoiType.BUS, name: "Przymorze Wielkie", distance: 368},
        {type: OfferPoiType.BUS, name: "Biały Dwór 02", distance: 423},
        {type: OfferPoiType.BUS, name: "Biały Dwór 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 03", distance: 616},
        {type: OfferPoiType.PARK, name: "Park imienia Ronalda Reagana", distance: 627},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 01", distance: 633},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 02", distance: 698},
        {type: OfferPoiType.BUS, name: "Olsztyńska 02", distance: 754},
        {type: OfferPoiType.BUS, name: "Olsztyńska 01", distance: 757},
        {type: OfferPoiType.BUS, name: "Obrońców Wybrzeża 02", distance: 767},
        {type: OfferPoiType.PARK, name: "Skwer Kwitnących Wiśni", distance: 1493},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1690},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1885}
    ],
    14545: [
        {type: OfferPoiType.BUS, name: "Więcka / Łowicka", distance: 156},
        {type: OfferPoiType.BUS, name: "Łowicka / Szkoła", distance: 186},
        {type: OfferPoiType.BUS, name: "Fordońska / Łowicka", distance: 526},
        {type: OfferPoiType.BUS, name: "Skandynawska / IKEA", distance: 535},
        {type: OfferPoiType.BUS, name: "Tor Regatowy", distance: 583},
        {type: OfferPoiType.BUS, name: "Tor Regatowy [końcowy]", distance: 629},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 1585}
    ],
    14564: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 393},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 427},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 428},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Natansona 01", distance: 524},
        {type: OfferPoiType.BUS, name: "Natansona 02", distance: 537},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 560},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 570},
        {type: OfferPoiType.BUS, name: "Siewna 03", distance: 605},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 639},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 711},
        {type: OfferPoiType.BUS, name: "Siewna 02", distance: 724},
        {type: OfferPoiType.BUS, name: "Siewna 01", distance: 744},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1420},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1463},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1519},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2146}
    ],
    14597: [
        {type: OfferPoiType.BUS, name: "Piłsudskiego 09", distance: 325},
        {type: OfferPoiType.BUS, name: "Piłsudskiego 01", distance: 330},
        {type: OfferPoiType.BUS, name: "Piłsudskiego 07", distance: 353},
        {type: OfferPoiType.BUS, name: "Piłsudskiego", distance: 378},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 02", distance: 456},
        {type: OfferPoiType.BUS, name: "I Aleja Najświętszej Maryi Panny", distance: 470},
        {type: OfferPoiType.BUS, name: "II Al. Najświętszej Maryi Panny 04", distance: 495},
        {type: OfferPoiType.BUS, name: "II Al. Najświętszej Maryi Panny 06", distance: 510},
        {type: OfferPoiType.TRAM, name: "II Al. Najświętszej Maryi Panny", distance: 602},
        {type: OfferPoiType.KOLEJ, name: "Częstochowa", distance: 667},
        {type: OfferPoiType.PARK, name: "Plac Katyński", distance: 1104},
        {type: OfferPoiType.PARK, name: "Skwer Solidarności", distance: 1209},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Gabriela Narutowicza", distance: 1336},
        {type: OfferPoiType.PARK, name: "Promenada Olgi Aleksandry Sipowicz - Kory", distance: 1548}
    ],
    14611: [
        {type: OfferPoiType.PARK, name: "Park 1000-lecia Królestwa Polskiego", distance: 251},
        {type: OfferPoiType.PARK, name: "Park przy CUS", distance: 437},
        {type: OfferPoiType.PARK, name: "Park im. Mieczysława Michalskiego w Lęborku", distance: 500},
        {type: OfferPoiType.BUS, name: "Stary Browar", distance: 743},
        {type: OfferPoiType.BUS, name: "Zwycięstwa - Kupiec", distance: 754},
        {type: OfferPoiType.PARK, name: "Skwer 7 Harcerskiej Drużyny Czerwonych Beretów", distance: 894},
        {type: OfferPoiType.PARK, name: "Park im. Lecha i Marii Kaczyńskich", distance: 946}
    ],
    14617: [{type: OfferPoiType.BUS, name: "Ustronie Morskie - szkoła", distance: 780}],
    14625: [
        {type: OfferPoiType.BUS, name: "Wiślinka Piaskowa", distance: 527},
        {type: OfferPoiType.BUS, name: "Wiślinka Most", distance: 792}
    ],
    14633: [
        {type: OfferPoiType.BUS, name: "Chodkiewicza / Paderewskiego", distance: 231},
        {type: OfferPoiType.TRAM, name: "Chodkiewicza / Paderewskiego", distance: 236},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 431},
        {type: OfferPoiType.BUS, name: "Gdańska / Chodkiewicza", distance: 433},
        {type: OfferPoiType.TRAM, name: "Gdańska / Chodkiewicza", distance: 433},
        {type: OfferPoiType.TRAM, name: "UKW", distance: 524},
        {type: OfferPoiType.BUS, name: "Mickiewicza / Teatr Polski", distance: 564},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 585},
        {type: OfferPoiType.BUS, name: "UKW", distance: 615},
        {type: OfferPoiType.PARK, name: "Skwer Edwarda Woyniłłowicza", distance: 680},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 728},
        {type: OfferPoiType.TRAM, name: "Gdańska / Artyleryjska", distance: 817},
        {type: OfferPoiType.PARK, name: "Skwer Mikołaja Kopernika", distance: 834},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 846},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 922},
        {type: OfferPoiType.PARK, name: "Skwer im. Mariana Turwida", distance: 980},
        {type: OfferPoiType.PARK, name: "Skwer im. ppor. Leszka Białego", distance: 992}
    ],
    14657: [
        {type: OfferPoiType.BUS, name: "Jarocińska", distance: 14},
        {type: OfferPoiType.BUS, name: "Lipska", distance: 335},
        {type: OfferPoiType.BUS, name: "Osobowice", distance: 622},
        {type: OfferPoiType.TRAM, name: "Osobowice", distance: 675},
        {type: OfferPoiType.BUS, name: "Witkowska", distance: 760},
        {type: OfferPoiType.BUS, name: "Las Osobowicki", distance: 783}
    ],
    14664: [
        {type: OfferPoiType.BUS, name: "Czerwieńskiego 02", distance: 324},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 355},
        {type: OfferPoiType.BUS, name: "Azory 01", distance: 483},
        {type: OfferPoiType.BUS, name: "Azory", distance: 540},
        {type: OfferPoiType.BUS, name: "Gnieźnieńska 02", distance: 552},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1360},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1538},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1565},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1571},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1597},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1914},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 2033}
    ],
    14669: [
        {type: OfferPoiType.BUS, name: "Powstańców Wielkopolskich / Wyszyńskiego", distance: 273},
        {type: OfferPoiType.BUS, name: "Głowackiego / Gajowa", distance: 389},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 418},
        {type: OfferPoiType.BUS, name: "Rondo Skrzetuskie", distance: 478},
        {type: OfferPoiType.BUS, name: "Kamienna / Gajowa", distance: 538},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego / Powstańców Wielkopolskich", distance: 549},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 828}
    ],
    14673: [
        {type: OfferPoiType.BUS, name: "Składowa", distance: 183},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Łasztownia", distance: 408},
        {type: OfferPoiType.BUS, name: "SKM Łasztownia", distance: 454},
        {type: OfferPoiType.TRAM, name: "Celna", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 1214},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1330},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1845},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1988},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 2267},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2267},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 2293},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 2473}
    ],
    14686: [
        {type: OfferPoiType.BUS, name: "Os. Lewandów II 02", distance: 121},
        {type: OfferPoiType.BUS, name: "Os. Lewandów II 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Internetowa 02", distance: 309},
        {type: OfferPoiType.BUS, name: "Oknicka 01", distance: 330},
        {type: OfferPoiType.BUS, name: "Internetowa 01", distance: 419},
        {type: OfferPoiType.BUS, name: "Chudoby 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Oknicka 02", distance: 539},
        {type: OfferPoiType.BUS, name: "Chudoby 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Nauczycielska 01", distance: 643},
        {type: OfferPoiType.BUS, name: "Grodzisk 02", distance: 648},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 2190},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2339},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 2413}
    ],
    14720: [
        {type: OfferPoiType.BUS, name: "Gorzykowska 01", distance: 222},
        {type: OfferPoiType.BUS, name: "Gorzykowska 04", distance: 230},
        {type: OfferPoiType.BUS, name: "Piotra Skargi 01", distance: 243},
        {type: OfferPoiType.BUS, name: "Myszkowska 02", distance: 285},
        {type: OfferPoiType.BUS, name: "Myszkowska 01", distance: 304},
        {type: OfferPoiType.BUS, name: "Piotra Skargi 02", distance: 348},
        {type: OfferPoiType.BUS, name: "Gorzykowska 02", distance: 363},
        {type: OfferPoiType.BUS, name: "Myszkowska 03", distance: 380},
        {type: OfferPoiType.METRO, name: "Targówek Mieszkaniowy", distance: 489},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 01", distance: 519},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 02", distance: 521},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 697},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1091},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 1593},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 1632},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 1704},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 1748}
    ],
    14738: [
        {type: OfferPoiType.BUS, name: "Starogardzka 04", distance: 321},
        {type: OfferPoiType.BUS, name: "Starogardzka 01", distance: 332},
        {type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 613},
        {type: OfferPoiType.BUS, name: "Jagiełły 02", distance: 682},
        {type: OfferPoiType.BUS, name: "Jagiełły 01", distance: 686},
        {type: OfferPoiType.BUS, name: "Przemian", distance: 737},
        {type: OfferPoiType.BUS, name: "Przemian 01", distance: 762}
    ],
    14783: [
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 223},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 246},
        {type: OfferPoiType.BUS, name: "Krakowska", distance: 538},
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 588},
        {type: OfferPoiType.TRAM, name: "Krakowska", distance: 604},
        {type: OfferPoiType.TRAM, name: "Armii Krajowej", distance: 798},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1201},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1461},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1844},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2284}
    ],
    14786: [
        {type: OfferPoiType.BUS, name: "Piłsudskiego - PUP", distance: 554},
        {type: OfferPoiType.BUS, name: "Zuzanny Morawskiej", distance: 713},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Marszałka Józefa Piłsudskiego", distance: 1741}
    ],
    14790: [
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 258},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 260},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - rynek", distance: 489},
        {type: OfferPoiType.BUS, name: "Trzebiatowska - Rynek 2 Nr 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Rzeczna", distance: 563},
        {type: OfferPoiType.BUS, name: "Frankowskiego Nr 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Łopuskiego - Szpital 1 Nr 01", distance: 618},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 639},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 676},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 682},
        {type: OfferPoiType.PARK, name: "Skwer Miast Partnerskich", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Pionierów Kołobrzegu", distance: 903},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 914},
        {type: OfferPoiType.PARK, name: "Skwer 750-lecia", distance: 935},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1464},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1965}
    ],
    14796: [
        {type: OfferPoiType.BUS, name: "Zakroczym Urząd Miejski", distance: 327},
        {type: OfferPoiType.BUS, name: "Zakroczym O.H. Koźmińskiego-Bank", distance: 596},
        {type: OfferPoiType.BUS, name: "Zakroczym Warszawska-Osiedle", distance: 762}
    ],
    14861: [
        {type: OfferPoiType.BUS, name: "Piekarska Wyzwolenia", distance: 304},
        {type: OfferPoiType.BUS, name: "Piekarska PKP Wschód", distance: 394},
        {type: OfferPoiType.BUS, name: "Wyzwolenia Piekarska", distance: 489},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Wschód", distance: 559},
        {type: OfferPoiType.BUS, name: "Lwowska Wyzwolenia", distance: 764},
        {type: OfferPoiType.BUS, name: "Komorowicka PKP Wschód", distance: 771},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1335},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 2128},
        {type: OfferPoiType.PARK, name: "Park za Ratuszem", distance: 2149},
        {type: OfferPoiType.PARK, name: 'Plac zabaw "Szósty zmysł"', distance: 2423}
    ],
    14862: [
        {type: OfferPoiType.BUS, name: "Łagodna Złotych Kłosów", distance: 11},
        {type: OfferPoiType.BUS, name: "Urodzajna Osiedle Langiewicza", distance: 282},
        {type: OfferPoiType.BUS, name: "Łagodna Osiedle Langiewicza", distance: 330},
        {type: OfferPoiType.BUS, name: "Łagodna Szkoła", distance: 342},
        {type: OfferPoiType.BUS, name: "Górska Bulwary Młodości", distance: 546},
        {type: OfferPoiType.PARK, name: "Bulwary Straceńskie", distance: 706},
        {type: OfferPoiType.PARK, name: "Park Strzygowskiego", distance: 1947},
        {type: OfferPoiType.REZERWAT, name: "Żabiniec", distance: 2117}
    ],
    14863: [
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna Pętla", distance: 470},
        {type: OfferPoiType.TRAM, name: "Koszutka Jesionowa", distance: 471},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna", distance: 485},
        {type: OfferPoiType.BUS, name: "Koszutka Słoneczna", distance: 532},
        {type: OfferPoiType.BUS, name: "Koszutka Iłłakowiczówny", distance: 553},
        {type: OfferPoiType.BUS, name: "Wełnowiec Poczta", distance: 604},
        {type: OfferPoiType.BUS, name: "Koszutka GIG", distance: 698},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Kościół", distance: 746},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 767},
        {type: OfferPoiType.TRAM, name: "Koszutka Misjonarzy Oblatów", distance: 802},
        {type: OfferPoiType.LAS, name: "Park Wełnowiecki", distance: 959},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 959},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1212},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1294},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 1346},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1359},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 1481},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1494}
    ],
    14890: [
        {type: OfferPoiType.BUS, name: "Józefowiec Szpital", distance: 290},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 343},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Gnieźnieńska", distance: 474},
        {type: OfferPoiType.BUS, name: "Wełnowiec Gnieźnieńska", distance: 524},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 562},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 730},
        {type: OfferPoiType.BUS, name: "Józefowiec Liceum", distance: 807},
        {type: OfferPoiType.BUS, name: "Józefowiec Szczecińska nż", distance: 828},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 971},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1467},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 1739},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 1823},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 2045},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 2140},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Halora", distance: 2184}
    ],
    14906: [
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Janowska)", distance: 142},
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Mikołowska) [nż]", distance: 330},
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Partyzantów)", distance: 359},
        {type: OfferPoiType.BUS, name: "Janów Janowska", distance: 462},
        {type: OfferPoiType.BUS, name: "Mysłowice Mikołowska Markety", distance: 560},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 1451},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 2459}
    ],
    14910: [
        {type: OfferPoiType.BUS, name: "Karpacka Osiedle Karpackie", distance: 563},
        {type: OfferPoiType.BUS, name: "Osiedle Beskidzkie Kładka", distance: 575},
        {type: OfferPoiType.BUS, name: "Partyzantów Apena", distance: 617},
        {type: OfferPoiType.BUS, name: "Michałowicza Aleksandrowicka", distance: 713},
        {type: OfferPoiType.BUS, name: "Michałowicza Reja", distance: 837}
    ],
    14911: [
        {type: OfferPoiType.BUS, name: "Łódzka", distance: 228},
        {type: OfferPoiType.BUS, name: "Okulickiego", distance: 417},
        {type: OfferPoiType.BUS, name: "Market OBI 03", distance: 479},
        {type: OfferPoiType.BUS, name: "Parkitka - Osiedle", distance: 518},
        {type: OfferPoiType.BUS, name: "Market OBI 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Market OBI", distance: 632},
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 649},
        {type: OfferPoiType.BUS, name: "św.Krzysztofa", distance: 715},
        {type: OfferPoiType.PARK, name: "Park 3 Maja", distance: 1584},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 1841},
        {type: OfferPoiType.PARK, name: "Spacerniak", distance: 1850},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Staszica", distance: 1870},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny Jędrusik", distance: 1881},
        {type: OfferPoiType.PARK, name: "Skwer przy PCK", distance: 1910},
        {type: OfferPoiType.PARK, name: "Skwer osiedlowy przy ulicy Księżycowej", distance: 1990}
    ],
    14912: [
        {type: OfferPoiType.BUS, name: "Bończyk Gałczyńskiego", distance: 834},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 1475},
        {type: OfferPoiType.PARK, name: "Park Bolina", distance: 2186},
        {type: OfferPoiType.PARK, name: "Skwer Artystów Grupy Janowskiej", distance: 2305},
        {type: OfferPoiType.PARK, name: "Skwer Emila i Georga Zillmannów", distance: 2523}
    ],
    14923: [
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 197},
        {type: OfferPoiType.BUS, name: "Bałtycka przy Wylotowej", distance: 235},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wylotowej", distance: 286},
        {type: OfferPoiType.BUS, name: "Sobieskiego", distance: 473},
        {type: OfferPoiType.BUS, name: "Wiosenna", distance: 603},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 628},
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 638},
        {type: OfferPoiType.PARK, name: "Park Antoniego Szarmacha", distance: 783},
        {type: OfferPoiType.LAS, name: "Załęże", distance: 1589},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1592},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1704},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1704},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1847},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 2205}
    ],
    14937: [
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 230},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 310},
        {type: OfferPoiType.BUS, name: "Okólna 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 387},
        {type: OfferPoiType.BUS, name: "Okólna 03", distance: 435},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 577},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 02", distance: 630},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 01", distance: 668},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 711},
        {type: OfferPoiType.BUS, name: "Wspólna 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Strefa Przemysłowa 01", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1180},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1439}
    ],
    14952: [
        {type: OfferPoiType.BUS, name: "Spacerowa II", distance: 50},
        {type: OfferPoiType.BUS, name: "Spacerowa I", distance: 168},
        {type: OfferPoiType.PARK, name: "Park im. Ignacego Jana Paderewskiego", distance: 526},
        {type: OfferPoiType.BUS, name: "Bankowa", distance: 648},
        {type: OfferPoiType.PARK, name: "Park 750-lecia Goleniowa", distance: 1673},
        {type: OfferPoiType.PARK, name: "Skwer Świętego Jerzego", distance: 1706}
    ],
    14953: [
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 02", distance: 324},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 02", distance: 827},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 01", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Miłocin", distance: 1664},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 2112}
    ],
    14973: [
        {type: OfferPoiType.BUS, name: "Katowice Bonifraterska", distance: 262},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 297},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 299},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury", distance: 441},
        {type: OfferPoiType.BUS, name: "Bogucice Markiefki", distance: 487},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 533},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 539},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 645},
        {type: OfferPoiType.BUS, name: "Bogucice Wróblewskiego", distance: 730},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 745},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1182},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1182},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1229},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1280}
    ],
    14981: [
        {type: OfferPoiType.BUS, name: "ZAMKOWA LIDL", distance: 71},
        {type: OfferPoiType.BUS, name: "GRUDZIŃSKICH LIDL", distance: 117},
        {type: OfferPoiType.BUS, name: "STASZICA STADION", distance: 243},
        {type: OfferPoiType.BUS, name: "PIEKARY", distance: 400},
        {type: OfferPoiType.BUS, name: "Staszica SP-1", distance: 451},
        {type: OfferPoiType.BUS, name: "MARCINKOWSKIEGO SZPITAL", distance: 460},
        {type: OfferPoiType.BUS, name: "BUCZKOWSKA", distance: 491},
        {type: OfferPoiType.PARK, name: "Park im. Ks. Dr Janusza Ostrowskiego", distance: 688},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Partnerstwa z Nottuln", distance: 752},
        {type: OfferPoiType.PARK, name: 'Park "Odpoczywaj z kulturą"', distance: 764}
    ],
    14984: [
        {type: OfferPoiType.BUS, name: "Żyzna", distance: 274},
        {type: OfferPoiType.BUS, name: "Chrostowskiej", distance: 543},
        {type: OfferPoiType.BUS, name: "Roweckiego", distance: 599},
        {type: OfferPoiType.BUS, name: "Świtalskiej", distance: 725},
        {type: OfferPoiType.BUS, name: "Os. Żyzna", distance: 743},
        {type: OfferPoiType.PARK, name: "Park Północny", distance: 1495}
    ],
    15010: [
        {type: OfferPoiType.BUS, name: "Krokwi 02", distance: 159},
        {type: OfferPoiType.BUS, name: "Klasyków 04", distance: 212},
        {type: OfferPoiType.BUS, name: "Krokwi 01", distance: 249},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 265},
        {type: OfferPoiType.BUS, name: "Klasyków 02", distance: 320},
        {type: OfferPoiType.BUS, name: "Klasyków 01", distance: 366},
        {type: OfferPoiType.BUS, name: "Fletniowa 01", distance: 553},
        {type: OfferPoiType.BUS, name: "Fletniowa 02", distance: 611},
        {type: OfferPoiType.BUS, name: "Henryków 01", distance: 693},
        {type: OfferPoiType.BUS, name: "Drogowa 02", distance: 706},
        {type: OfferPoiType.BUS, name: "Henryków 04", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 1997},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 2044},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 2201}
    ],
    15024: [
        {type: OfferPoiType.BUS, name: "RATAJE ZSL-G", distance: 563},
        {type: OfferPoiType.BUS, name: "SŁONECZNA ZSL-G", distance: 785},
        {type: OfferPoiType.BUS, name: "SŁONECZNA OSM", distance: 814},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Partnerstwa z Nottuln", distance: 2385}
    ],
    15036: [
        {type: OfferPoiType.BUS, name: "Pyszczyn 03", distance: 584},
        {type: OfferPoiType.BUS, name: "Pyszczyn 04", distance: 590}
    ],
    15045: [
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 74},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 78},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 328},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 406},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 450},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 513},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 516},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 520},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 528},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 532},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Bratysławska 03", distance: 611},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 646},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 799},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 910},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1284}
    ],
    15066: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 160},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 254},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 263},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 308},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 322},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 369},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 562},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 565},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 565},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 756},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 772},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 801},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 908},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 967},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 968},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 1208},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1225}
    ],
    15068: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 152},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 255},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 262},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 316},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 330},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 361},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 554},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 557},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 557},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 748},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 764},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 798},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 900},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 959},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 960},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 1200},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1218}
    ],
    15090: [
        {type: OfferPoiType.BUS, name: "Krakowskie Przedmieście 02", distance: 187},
        {type: OfferPoiType.BUS, name: "Krakowskie Przedmieście 04", distance: 259},
        {type: OfferPoiType.BUS, name: "Ogród Saski 01", distance: 261},
        {type: OfferPoiType.BUS, name: "Ogród Saski 03", distance: 288},
        {type: OfferPoiType.BUS, name: "Czechowska 02", distance: 451},
        {type: OfferPoiType.BUS, name: "Czechowska 01", distance: 459},
        {type: OfferPoiType.BUS, name: "Plac Litewski 01", distance: 506},
        {type: OfferPoiType.PARK, name: "Skwer arcybiskupa Józefa Życińskiego", distance: 539},
        {type: OfferPoiType.BUS, name: "Plac Litewski 02", distance: 541},
        {type: OfferPoiType.PARK, name: "Plac Lecha Kaczyńskiego", distance: 561},
        {type: OfferPoiType.BUS, name: "Okopowa 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Okopowa 02", distance: 632},
        {type: OfferPoiType.PARK, name: "Ogród Saski", distance: 633}
    ],
    15093: [
        {type: OfferPoiType.BUS, name: "Orzechowa", distance: 182},
        {type: OfferPoiType.BUS, name: "ROD Bajki", distance: 213},
        {type: OfferPoiType.BUS, name: "Śliczna", distance: 549},
        {type: OfferPoiType.BUS, name: "Spiska (Ośrodek sportu)", distance: 575},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 660},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 769},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 832},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 947},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1018},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1201},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1637}
    ],
    15112: [
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 99},
        {type: OfferPoiType.BUS, name: "Kaloryczna 02", distance: 130},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 182},
        {type: OfferPoiType.BUS, name: "Antoniewska 02", distance: 393},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 398},
        {type: OfferPoiType.BUS, name: "Antoniewska 01", distance: 444},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 536},
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 748},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 765},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1661},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1684},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2142}
    ],
    15119: [
        {type: OfferPoiType.TRAM, name: "Grudziądzka", distance: 171},
        {type: OfferPoiType.BUS, name: "Grudziądzka 05", distance: 183},
        {type: OfferPoiType.BUS, name: "Grudziądzka 04", distance: 211},
        {type: OfferPoiType.BUS, name: "Grudziądzka 03", distance: 274},
        {type: OfferPoiType.TRAM, name: "Kolonia Uroda", distance: 571},
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 01", distance: 620},
        {type: OfferPoiType.BUS, name: "al. Płażyńskiego", distance: 679},
        {type: OfferPoiType.TRAM, name: "al. Płażyńskiego", distance: 763},
        {type: OfferPoiType.BUS, name: "Lwowska 01", distance: 833},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1114},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 1860},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1913}
    ],
    15156: [
        {type: OfferPoiType.BUS, name: "Reden Centrum Administracyjne", distance: 220},
        {type: OfferPoiType.BUS, name: "Dąbrowa Górnicza Zawidzkiej", distance: 547},
        {type: OfferPoiType.TRAM, name: "Reden Komenda Policji", distance: 643},
        {type: OfferPoiType.BUS, name: "Reden Komenda Policji", distance: 651},
        {type: OfferPoiType.BUS, name: "Gołonóg Morcinka", distance: 815},
        {type: OfferPoiType.PARK, name: "Planty im. Harcmistrza Stefana Piotrowskiego", distance: 1281},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Hallera", distance: 2017},
        {type: OfferPoiType.PARK, name: "Park Śródmiejski", distance: 2201},
        {type: OfferPoiType.PARK, name: "Park Podlesie", distance: 2433}
    ],
    15166: [
        {type: OfferPoiType.BUS, name: "Brodzka", distance: 104},
        {type: OfferPoiType.BUS, name: "Królewiecka (Staw)", distance: 280},
        {type: OfferPoiType.BUS, name: "Kozia", distance: 393},
        {type: OfferPoiType.BUS, name: "Suwalska", distance: 612},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 621},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1818},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 1844},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 1986},
        {type: OfferPoiType.PARK, name: "Park Leśny w Praczach Odrzańskich", distance: 2385}
    ],
    15170: [
        {type: OfferPoiType.BUS, name: "Krzyków – Osiedle", distance: 330},
        {type: OfferPoiType.BUS, name: "Nadolice Małe I", distance: 574},
        {type: OfferPoiType.BUS, name: "Nadolice Małe – Krzykowska", distance: 650},
        {type: OfferPoiType.BUS, name: "Nadolice Małe II – Wrocławska/Zielona", distance: 662}
    ],
    15173: [
        {type: OfferPoiType.BUS, name: "Katowice Bonifraterska", distance: 509},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 584},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 593},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury NOSPR", distance: 613},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 663},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 690},
        {type: OfferPoiType.BUS, name: "Koszutka Katowicka", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 774},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 792},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 832},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 841},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 872},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1042}
    ],
    15183: [{type: OfferPoiType.BUS, name: "Dobrzykowice – Szafirowa", distance: 380}],
    15189: [
        {type: OfferPoiType.BUS, name: "Struga - Kościuszki", distance: 124},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 142},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 149},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 164},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 177},
        {type: OfferPoiType.BUS, name: "Gdańska - Struga", distance: 180},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 255},
        {type: OfferPoiType.BUS, name: "Struga - Piotrkowska", distance: 336},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 371},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Struga", distance: 386},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 397},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 406},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 430},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Żeromskiego", distance: 458},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Zamenhofa", distance: 502},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 517},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 517},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 522},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 555},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 616},
        {type: OfferPoiType.PARK, name: "Skwer im. Lecha Kunki", distance: 635}
    ],
    15196: [
        {type: OfferPoiType.BUS, name: "Złotno - Stare Złotno NŻ", distance: 381},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1624},
        {type: OfferPoiType.PARK, name: "Metalowe namioty", distance: 1859},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 2036},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2353}
    ],
    15216: [
        {type: OfferPoiType.BUS, name: "Gołębia 04", distance: 265},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 306},
        {type: OfferPoiType.TRAM, name: "Gołębia 02", distance: 333},
        {type: OfferPoiType.TRAM, name: "Gołębia 01", distance: 341},
        {type: OfferPoiType.BUS, name: "Gołębia 03", distance: 377},
        {type: OfferPoiType.BUS, name: "Targowa 02", distance: 418},
        {type: OfferPoiType.BUS, name: "Targowa 01", distance: 487},
        {type: OfferPoiType.TRAM, name: "Targowa 04", distance: 626},
        {type: OfferPoiType.TRAM, name: "Targowa 03", distance: 646},
        {type: OfferPoiType.PARK, name: "Glazja", distance: 1484},
        {type: OfferPoiType.PARK, name: "Bastion Menniczy", distance: 1786},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 1959},
        {type: OfferPoiType.REZERWAT, name: "Miasto średniowieczne w Toruniu", distance: 2157}
    ],
    15229: [
        {type: OfferPoiType.BUS, name: "Chorzów Opolska", distance: 279},
        {type: OfferPoiType.BUS, name: "Chorzów Składowa", distance: 420},
        {type: OfferPoiType.BUS, name: "Chorzów Mariańska", distance: 826},
        {type: OfferPoiType.BUS, name: "Chorzów Łagiewnicka", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Amelung", distance: 1093},
        {type: OfferPoiType.PARK, name: "Park Łagiewnicki", distance: 1639},
        {type: OfferPoiType.PARK, name: "Park Chropaczowski imieniem Kopalni Śląsk", distance: 1656},
        {type: OfferPoiType.PARK, name: "Park Heiloo", distance: 1831},
        {type: OfferPoiType.REZERWAT, name: "Staw Foryśka", distance: 2434}
    ],
    15235: [
        {type: OfferPoiType.BUS, name: "Katowice Mickiewicza Biurowce", distance: 209},
        {type: OfferPoiType.BUS, name: "Katowice Plac Wolności", distance: 272},
        {type: OfferPoiType.BUS, name: "Katowice Sobieskiego", distance: 318},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 318},
        {type: OfferPoiType.BUS, name: "Katowice Sokolska", distance: 425},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 430},
        {type: OfferPoiType.BUS, name: "Katowice Dąbrówki", distance: 439},
        {type: OfferPoiType.BUS, name: "Katowice Piotra Skargi", distance: 451},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 473},
        {type: OfferPoiType.TRAM, name: "Katowice Dąbrówki", distance: 487},
        {type: OfferPoiType.TRAM, name: "Katowice Dworzec PKP", distance: 557},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna", distance: 558},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 678},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 752},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 810},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 1006},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1077},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1083},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 1086},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1116}
    ],
    15238: [
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska Sąd", distance: 316},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 349},
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska", distance: 363},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 466},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 630},
        {type: OfferPoiType.BUS, name: "Katowice Sądowa", distance: 670},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Miarki", distance: 688},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 699},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 707},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 814},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 964},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1178},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1220},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 1429}
    ],
    15245: [
        {type: OfferPoiType.BUS, name: "Kopisto Most Zamkowy 04", distance: 198},
        {type: OfferPoiType.BUS, name: "Podwisłocze U. Skarbowy 03", distance: 217},
        {type: OfferPoiType.BUS, name: "Kopisto U. Skarbowy 03", distance: 245},
        {type: OfferPoiType.BUS, name: "Kilara 02", distance: 436},
        {type: OfferPoiType.BUS, name: "Kilara 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Kopisto uniwersytet 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Podwisłocze / Seniora 04", distance: 634},
        {type: OfferPoiType.BUS, name: "Szopena filharmonia 02", distance: 646},
        {type: OfferPoiType.BUS, name: "Szopena filharmonia 01", distance: 663},
        {type: OfferPoiType.BUS, name: "Kopisto uniwersytet 02", distance: 731},
        {type: OfferPoiType.PARK, name: "Skwer im. Kazimierza Górskiego", distance: 1119},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 1122},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 1229},
        {type: OfferPoiType.PARK, name: "Biały Ogród", distance: 1338},
        {type: OfferPoiType.PARK, name: "Skwer im. ks. Józefa Hermana Osińskiego", distance: 1431},
        {type: OfferPoiType.PARK, name: "Park Jedności Polonii z Macierzą", distance: 1526}
    ],
    15258: [
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Interferie", distance: 237},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa", distance: 332},
        {type: OfferPoiType.BUS, name: "Uzdrowiskowa - Promenada 01", distance: 336},
        {type: OfferPoiType.BUS, name: "Słowackiego / Chrobrego 07", distance: 515},
        {type: OfferPoiType.BUS, name: "Świnoujście Express", distance: 675},
        {type: OfferPoiType.BUS, name: "Rusałka 02", distance: 737},
        {type: OfferPoiType.BUS, name: "Parkowa / Uzdrowiskowa", distance: 748},
        {type: OfferPoiType.BUS, name: "Rusałka 01", distance: 780},
        {type: OfferPoiType.BUS, name: "tymczasowy", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 815}
    ],
    15261: [
        {type: OfferPoiType.BUS, name: "Wschodnia - plaża", distance: 480},
        {type: OfferPoiType.LAS, name: "Park im. Aleksandra Fredry", distance: 489},
        {type: OfferPoiType.PARK, name: "Park im. Aleksandra Fredry", distance: 489},
        {type: OfferPoiType.BUS, name: "Wschodnia - WDW", distance: 642},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Amfiteatr", distance: 673},
        {type: OfferPoiType.BUS, name: "Fredry", distance: 775},
        {type: OfferPoiType.BUS, name: "Fredry 2 Nr 02", distance: 817},
        {type: OfferPoiType.BUS, name: "Chodkiewicza - osiedle", distance: 840},
        {type: OfferPoiType.PARK, name: "Park im. 3 Dywizji Piechoty", distance: 1527},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 2011}
    ],
    15269: [{type: OfferPoiType.LAS, name: "Stary cmentarz w Kobylnikach", distance: 990}],
    15288: [
        {type: OfferPoiType.BUS, name: "Hala Targowa 71", distance: 189},
        {type: OfferPoiType.BUS, name: "Starowiślna 08", distance: 201},
        {type: OfferPoiType.TRAM, name: "Starowiślna 04", distance: 233},
        {type: OfferPoiType.TRAM, name: "Starowiślna 03", distance: 256},
        {type: OfferPoiType.TRAM, name: "Hala Targowa 02", distance: 268},
        {type: OfferPoiType.BUS, name: "Hala Targowa 72", distance: 271},
        {type: OfferPoiType.TRAM, name: "Hala Targowa 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Poczta Główna 04", distance: 279},
        {type: OfferPoiType.TRAM, name: "Starowiślna 02", distance: 283},
        {type: OfferPoiType.TRAM, name: "Starowiślna 01", distance: 293},
        {type: OfferPoiType.TRAM, name: "Poczta Główna 02", distance: 307},
        {type: OfferPoiType.BUS, name: "Starowiślna 07", distance: 310},
        {type: OfferPoiType.KOLEJ, name: "Kraków Grzegórzki", distance: 333},
        {type: OfferPoiType.TRAM, name: "Poczta Główna 01", distance: 342},
        {type: OfferPoiType.TRAM, name: "Poczta Główna 03", distance: 367},
        {type: OfferPoiType.PARK, name: "Park Kolejowy", distance: 372},
        {type: OfferPoiType.BUS, name: "św. Gertrudy 02", distance: 483},
        {type: OfferPoiType.TRAM, name: "św. Gertrudy 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Plac Wszystkich Świętych 01", distance: 632},
        {type: OfferPoiType.PARK, name: "Skwer Kółeczko", distance: 667},
        {type: OfferPoiType.PARK, name: "Ogrody Zgromadzenia Księży Misjonarzy w Krakowie", distance: 671},
        {type: OfferPoiType.BUS, name: "Plac Wszystkich Świętych 02", distance: 704},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 709},
        {type: OfferPoiType.PARK, name: "Łąka na Wesołej", distance: 806},
        {type: OfferPoiType.BUS, name: "Stradom 06", distance: 822},
        {type: OfferPoiType.PARK, name: "Planty", distance: 1048}
    ],
    15294: [{type: OfferPoiType.BUS, name: "Jastrzębia Góra", distance: 809}],
    15303: [
        {type: OfferPoiType.BUS, name: "Olbrachta pętla 09", distance: 239},
        {type: OfferPoiType.BUS, name: "Olbrachta / Św. Kingi 07", distance: 736},
        {type: OfferPoiType.BUS, name: "Olbrachta / Św. Kingi 08", distance: 747},
        {type: OfferPoiType.BUS, name: "Słocińska pętla 11", distance: 800},
        {type: OfferPoiType.BUS, name: "Krasne Auchan", distance: 846}
    ],
    15316: [
        {type: OfferPoiType.BUS, name: "Podczele - Tarnopolska", distance: 86},
        {type: OfferPoiType.BUS, name: "Kresowa - Podczele Nr 01", distance: 401},
        {type: OfferPoiType.BUS, name: "Lwowska - Podczele Nr 01", distance: 413},
        {type: OfferPoiType.PARK, name: "skwer Pana Tadeusza", distance: 472},
        {type: OfferPoiType.BUS, name: "Nowogródzka - Podczele Nr 01", distance: 591}
    ],
    15317: [
        {type: OfferPoiType.BUS, name: "Wieczorynki n/ż", distance: 698},
        {type: OfferPoiType.BUS, name: "Os. Bajkowe", distance: 698},
        {type: OfferPoiType.LAS, name: "Lasek Marceliński", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Wille Bukowska", distance: 1682}
    ],
    15328: [
        {type: OfferPoiType.BUS, name: "ROD Zgoda", distance: 406},
        {type: OfferPoiType.BUS, name: "Lutosławskiego", distance: 466},
        {type: OfferPoiType.BUS, name: "Tunelowa", distance: 765},
        {type: OfferPoiType.BUS, name: "Konduktorska", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 1536},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1868},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 1883}
    ],
    15379: [
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 02", distance: 150},
        {type: OfferPoiType.BUS, name: "Kurpińskiego 02", distance: 172},
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 01", distance: 176},
        {type: OfferPoiType.BUS, name: "Kurpińskiego 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Schuberta 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Schuberta 01", distance: 529},
        {type: OfferPoiType.BUS, name: "Otwarta 02", distance: 612},
        {type: OfferPoiType.BUS, name: "Belgradzka 04", distance: 645},
        {type: OfferPoiType.BUS, name: "Piecewska", distance: 645},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 646},
        {type: OfferPoiType.BUS, name: "Otwarta 01", distance: 661},
        {type: OfferPoiType.TRAM, name: "Piekarnicza", distance: 700},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 743},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 743},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 760},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 866},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 1094},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 1964},
        {type: OfferPoiType.PARK, name: "Park w Królewskiej Dolinie", distance: 1989},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 2265}
    ],
    15408: [
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 108},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 242},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 323},
        {type: OfferPoiType.BUS, name: "Plac Neptuna", distance: 456},
        {type: OfferPoiType.BUS, name: "Niepodległości (Muzeum)", distance: 519},
        {type: OfferPoiType.BUS, name: "Kolejowa 24", distance: 626},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Pasaż Handlowy", distance: 691},
        {type: OfferPoiType.BUS, name: "Straż Pożarna", distance: 706}
    ],
    15413: [
        {type: OfferPoiType.BUS, name: "Tomaszew 01", distance: 148},
        {type: OfferPoiType.BUS, name: "Tomaszew 02", distance: 273},
        {type: OfferPoiType.BUS, name: "Wilkowiecka 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Nowiny 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Nowiny 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Wilkowiecka 02", distance: 696}
    ],
    15443: [
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 444},
        {type: OfferPoiType.BUS, name: "Skalskiego 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Felin Kalinówka 02", distance: 485},
        {type: OfferPoiType.BUS, name: "Skalskiego 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Felin Kalinówka 01", distance: 555},
        {type: OfferPoiType.BUS, name: "Felin 03", distance: 750},
        {type: OfferPoiType.BUS, name: "Felin 01", distance: 751},
        {type: OfferPoiType.BUS, name: "Felin 02", distance: 759},
        {type: OfferPoiType.BUS, name: "Instytut Agrofizyki 01", distance: 800}
    ],
    15445: [
        {type: OfferPoiType.BUS, name: "Park Bronowice 03", distance: 315},
        {type: OfferPoiType.BUS, name: "Park Bronowice 02", distance: 460},
        {type: OfferPoiType.BUS, name: "Park Bronowice 01", distance: 462},
        {type: OfferPoiType.BUS, name: "Park Bronowice 04", distance: 523},
        {type: OfferPoiType.BUS, name: "Lotnicza 02", distance: 530},
        {type: OfferPoiType.BUS, name: "Lotnicza 01", distance: 649},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 01", distance: 727},
        {type: OfferPoiType.PARK, name: "Park Bronowice", distance: 729},
        {type: OfferPoiType.PARK, name: "Skwer imienia Prymasa Tysiąclecia Kardynała Wyszyńskiego", distance: 734},
        {type: OfferPoiType.BUS, name: "Plac Bychawski 02", distance: 773},
        {type: OfferPoiType.BUS, name: "Plac Bychawski 03", distance: 775}
    ],
    15472: [
        {type: OfferPoiType.PARK, name: "Skwer Ofiar Zbrodni Karyńskiej", distance: 419},
        {type: OfferPoiType.PARK, name: "Skwer", distance: 444},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 460},
        {type: OfferPoiType.BUS, name: "Harcerska 02", distance: 466},
        {type: OfferPoiType.PARK, name: 'Skwer Zgrupowania AK "Szaracy"', distance: 488},
        {type: OfferPoiType.BUS, name: "Policja 02", distance: 543},
        {type: OfferPoiType.BUS, name: "Harcerska 01", distance: 557},
        {type: OfferPoiType.BUS, name: "Parkowa 01", distance: 590},
        {type: OfferPoiType.BUS, name: "Park 02", distance: 596},
        {type: OfferPoiType.BUS, name: "Parkowa 02", distance: 599},
        {type: OfferPoiType.PARK, name: "Skwer Tadeusza Bilicza", distance: 727},
        {type: OfferPoiType.PARK, name: "skwer Pracowników Zakładów Starachowickich", distance: 735},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny im. Bolesława Kazimierza Stanislawa Papi", distance: 2308}
    ],
    15485: [
        {type: OfferPoiType.TRAM, name: "Chełmińska/Włodka", distance: 499},
        {type: OfferPoiType.TRAM, name: "Aleja 23 Stycznia", distance: 564},
        {type: OfferPoiType.BUS, name: "Gdyńska", distance: 633},
        {type: OfferPoiType.TRAM, name: "Rynek Główny", distance: 769},
        {type: OfferPoiType.KOLEJ, name: "Grudziądz Śródmieście", distance: 796},
        {type: OfferPoiType.TRAM, name: "Hallera/Dworcowa", distance: 805},
        {type: OfferPoiType.PARK, name: "Skwer Teatralny im. Czesława Niemena", distance: 1092},
        {type: OfferPoiType.PARK, name: "Park na Górze Zamkowej", distance: 1197},
        {type: OfferPoiType.PARK, name: "Skwer Wolności imienia Władysława Bartoszewskiego", distance: 1462},
        {type: OfferPoiType.PARK, name: "Park Miejski imienia Piotra Janowskiego", distance: 1578},
        {type: OfferPoiType.PARK, name: "Park Miejski - część leśna", distance: 2479}
    ],
    15504: [
        {type: OfferPoiType.BUS, name: "Chełmińska/Bydgoska", distance: 537},
        {type: OfferPoiType.TRAM, name: "Chełmińska/Bydgoska", distance: 540},
        {type: OfferPoiType.PARK, name: "Park Miejski imienia Piotra Janowskiego", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Miejski - część leśna", distance: 2102},
        {type: OfferPoiType.PARK, name: "Skwer Teatralny im. Czesława Niemena", distance: 2103}
    ],
    15532: [
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 07", distance: 362},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 03", distance: 425},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 71", distance: 468},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 04", distance: 472},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 05", distance: 484},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 06", distance: 494},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 08", distance: 497},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Ostródzka 02", distance: 728},
        {type: OfferPoiType.BUS, name: "Łojewska 02", distance: 776},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 963},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1509},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1642},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1701},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 2237},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2290}
    ],
    15547: [
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/01", distance: 578},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 607},
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/02", distance: 679},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 967}
    ],
    15560: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 389},
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/01", distance: 449},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 554},
        {type: OfferPoiType.BUS, name: "Wysokie Mazowieckie - ul. Ludowa 2072B/02", distance: 564}
    ],
    15584: [
        {type: OfferPoiType.BUS, name: "Stare Gliwice Łabędzka", distance: 349},
        {type: OfferPoiType.BUS, name: "Stare Gliwice Wiejska", distance: 489},
        {type: OfferPoiType.BUS, name: "Stare Gliwice Chemiczna", distance: 568},
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Pętla", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 1095},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Dąbrowa", distance: 2272}
    ],
    15585: [
        {type: OfferPoiType.BUS, name: "Malborska (EPBP)", distance: 173},
        {type: OfferPoiType.BUS, name: "Malborska - Fredry", distance: 358},
        {type: OfferPoiType.BUS, name: "Skrzydlata - LOK", distance: 464},
        {type: OfferPoiType.BUS, name: "Łódzka - pętla", distance: 573},
        {type: OfferPoiType.BUS, name: "Malborska - Zagonowa", distance: 646},
        {type: OfferPoiType.BUS, name: "Lotnicza - Fredry", distance: 662},
        {type: OfferPoiType.BUS, name: "Skrzydlata - pętla", distance: 734},
        {type: OfferPoiType.PARK, name: "Park Wojska Polskiego", distance: 1348},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Rebinina", distance: 1375},
        {type: OfferPoiType.PARK, name: "Park Planty", distance: 1608}
    ],
    15592: [{type: OfferPoiType.PARK, name: "Park Ireny Tamary Misztal", distance: 964}],
    15597: [
        {type: OfferPoiType.BUS, name: "Kajki ZS nr 6", distance: 253},
        {type: OfferPoiType.BUS, name: "11-go Listopada-szkoła 04", distance: 353},
        {type: OfferPoiType.BUS, name: "Północ II 01", distance: 355},
        {type: OfferPoiType.BUS, name: "Tuwima 02", distance: 442},
        {type: OfferPoiType.BUS, name: "Sikorskiego-rondo 01", distance: 462},
        {type: OfferPoiType.BUS, name: "Sikorskiego-Zespół Szkół nr 6 06", distance: 465},
        {type: OfferPoiType.BUS, name: "Północ II 02", distance: 469},
        {type: OfferPoiType.BUS, name: "Tuwima-Zespół Szkół nr 1 01", distance: 472},
        {type: OfferPoiType.BUS, name: "11-go Listopda-kościół", distance: 519},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Rondo 02", distance: 583},
        {type: OfferPoiType.REZERWAT, name: "Wyspa lęgowa", distance: 790}
    ],
    15600: [
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo Stare I 01", distance: 86},
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo Stare I 08", distance: 131},
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo II 02", distance: 310},
        {type: OfferPoiType.BUS, name: "Osiedle Nikutowo II 01", distance: 314}
    ],
    15613: [
        {type: OfferPoiType.BUS, name: "Gliwice Szpital Wielospecjalistyczny", distance: 266},
        {type: OfferPoiType.BUS, name: "Gliwice Sąd Okręgowy", distance: 308},
        {type: OfferPoiType.BUS, name: "Gliwice Teatr", distance: 326},
        {type: OfferPoiType.BUS, name: "Gliwice Słowackiego", distance: 453},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 528},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 693},
        {type: OfferPoiType.PARK, name: "Plac Mickiewicza", distance: 717}
    ],
    15622: [
        {type: OfferPoiType.BUS, name: "Telewizja Katowice", distance: 274},
        {type: OfferPoiType.BUS, name: "Wełnowiec Bytkowska Hotel", distance: 355},
        {type: OfferPoiType.BUS, name: "Bytków Osiedle Chemik", distance: 472},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Bolesława Kałuży", distance: 1209},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1490},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1799},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1888},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Halora", distance: 1917},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 2001},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 2085},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 2144},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2415}
    ],
    15646: [
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 28},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 118},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 341},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 405},
        {type: OfferPoiType.BUS, name: "Tuwima - Wysoka", distance: 424},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 448},
        {type: OfferPoiType.BUS, name: "Narutowicza - Tramwajowa", distance: 453},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 471},
        {type: OfferPoiType.BUS, name: "Tuwima - Przędzalniana", distance: 544},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 597},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 608},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 610},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 643},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 795},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 855},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 984},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 1077},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1184},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 1197},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 1295}
    ],
    15648: [
        {type: OfferPoiType.BUS, name: "Michalczyka", distance: 214},
        {type: OfferPoiType.TRAM, name: "Michalczyka", distance: 226},
        {type: OfferPoiType.PARK, name: "skwer Świętego Ojca Damiana de Veuster", distance: 509},
        {type: OfferPoiType.BUS, name: "Inowrocławska", distance: 594},
        {type: OfferPoiType.TRAM, name: "Wrocław Szczepin", distance: 612},
        {type: OfferPoiType.BUS, name: "Wrocław Szczepin", distance: 616},
        {type: OfferPoiType.BUS, name: "Litomska (ZUS)", distance: 672},
        {type: OfferPoiType.BUS, name: "Kępa Mieszczańska", distance: 736},
        {type: OfferPoiType.BUS, name: "Plac Solidarności", distance: 755},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Szczepin", distance: 792},
        {type: OfferPoiType.PARK, name: "skwer Kornela Morawieckiego", distance: 839},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2162}
    ],
    15651: [
        {type: OfferPoiType.BUS, name: "Reda Bosmańska 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Reda Bosmańska 01", distance: 358},
        {type: OfferPoiType.BUS, name: "Reda Obwodowa 01 n/ż", distance: 436},
        {type: OfferPoiType.BUS, name: "Reda Młyńska 02", distance: 458},
        {type: OfferPoiType.BUS, name: "Reda Młyńska 01", distance: 475},
        {type: OfferPoiType.BUS, name: "Reda Młyńska 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Reda Aquapark 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Rumia Dolna 01 n/ż", distance: 652},
        {type: OfferPoiType.BUS, name: "Reda Dworzec PKP 01", distance: 781},
        {type: OfferPoiType.PARK, name: "Miejski Park Rodzinny w Redzie", distance: 2233}
    ],
    15663: [
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 314},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 335},
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 356},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 577},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Bałtycka", distance: 592},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 605},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 646},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 649},
        {type: OfferPoiType.BUS, name: "Rondo Skrzetuskie", distance: 683},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 685},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 844}
    ],
    15681: [
        {type: OfferPoiType.BUS, name: "Wielka", distance: 65},
        {type: OfferPoiType.BUS, name: "Małe Garbary", distance: 196},
        {type: OfferPoiType.BUS, name: "Grobla", distance: 233},
        {type: OfferPoiType.TRAM, name: "Małe Garbary", distance: 254},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 369},
        {type: OfferPoiType.BUS, name: "Grochowe Łąki", distance: 471},
        {type: OfferPoiType.BUS, name: "Mostowa", distance: 489},
        {type: OfferPoiType.TRAM, name: "Pl. Bernardyński", distance: 537},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 546},
        {type: OfferPoiType.TRAM, name: "Pl. Wielkopolski", distance: 620},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 681},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 714},
        {type: OfferPoiType.TRAM, name: "Katedra", distance: 720},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 1061},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 1161},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1194},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1208},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 1219},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 1260},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1444},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 1520}
    ],
    15687: [
        {type: OfferPoiType.BUS, name: "Tuwima - Wysoka", distance: 125},
        {type: OfferPoiType.BUS, name: "Tuwima - Przędzalniana", distance: 265},
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 337},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 374},
        {type: OfferPoiType.BUS, name: "Tuwima - Rodz. Kindermannów NŻ", distance: 395},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 415},
        {type: OfferPoiType.BUS, name: "Przędzalniana - Nawrot", distance: 501},
        {type: OfferPoiType.BUS, name: "Nawrot - Wysoka", distance: 509},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Tuwima", distance: 550},
        {type: OfferPoiType.TRAM, name: "Kopcińskiego - Tuwima", distance: 552},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 599},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 612},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 672},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 814},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 1086},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1178},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 1191},
        {type: OfferPoiType.PARK, name: "Park im. 3 Maja", distance: 1238}
    ],
    15688: [
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Gałęźna Góra", distance: 2264},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Lewice", distance: 2492}
    ],
    15694: [
        {type: OfferPoiType.BUS, name: "Tychy Piłsudskiego", distance: 172},
        {type: OfferPoiType.PARK, name: "Oś Zielona", distance: 410},
        {type: OfferPoiType.BUS, name: "Tychy Hala Sportowa", distance: 457},
        {type: OfferPoiType.BUS, name: "Tychy Osiedle O", distance: 582},
        {type: OfferPoiType.PARK, name: "Park świętego Franciszka z Asyżu", distance: 618},
        {type: OfferPoiType.BUS, name: "Tychy Osiedle T", distance: 626},
        {type: OfferPoiType.BUS, name: "Tychy Paprocańska", distance: 669},
        {type: OfferPoiType.BUS, name: "Tychy Hale Targowe", distance: 722},
        {type: OfferPoiType.PARK, name: "Rodzinny Park Błogosławionej Karoliny", distance: 765},
        {type: OfferPoiType.PARK, name: "Skwer imienia Marii i Lecha Kaczyńskich", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Miejski Solidarności", distance: 1518},
        {type: OfferPoiType.REZERWAT, name: "Paprocany", distance: 1661}
    ],
    15726: [
        {type: OfferPoiType.BUS, name: "Bielicowa", distance: 241},
        {type: OfferPoiType.BUS, name: "Naramowice Wschodnie", distance: 394},
        {type: OfferPoiType.BUS, name: "Sielawy", distance: 406},
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 536},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1786},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2211}
    ],
    15737: [
        {type: OfferPoiType.BUS, name: "Aleja Jana Pawła II", distance: 91},
        {type: OfferPoiType.BUS, name: "Kościuszki - Starostwo", distance: 169},
        {type: OfferPoiType.BUS, name: "Kościuszki- Pelplińska", distance: 234},
        {type: OfferPoiType.BUS, name: "Rynek", distance: 288},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 344},
        {type: OfferPoiType.BUS, name: "SCK", distance: 413},
        {type: OfferPoiType.PARK, name: "Skwer Świętego Wojciecha", distance: 444},
        {type: OfferPoiType.PARK, name: "Park Nowe Oblicze", distance: 487},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 567}
    ],
    15757: [{type: OfferPoiType.BUS, name: "Skórzewo Os. Grafitowe n/ż", distance: 689}],
    15766: [
        {type: OfferPoiType.BUS, name: "Sypniewska 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Statkowskiego 04", distance: 516},
        {type: OfferPoiType.BUS, name: "Statkowskiego 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Statkowskiego 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Zawodzie 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Sypniewska 02", distance: 560},
        {type: OfferPoiType.BUS, name: "Zawodzie 02", distance: 565},
        {type: OfferPoiType.BUS, name: "Zawodzie 04", distance: 587},
        {type: OfferPoiType.BUS, name: "Prefabet 02", distance: 641},
        {type: OfferPoiType.BUS, name: "EC Siekierki 01", distance: 822},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 848},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1094},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1150},
        {type: OfferPoiType.PARK, name: "Park Czesława Szczubełka", distance: 1299},
        {type: OfferPoiType.PARK, name: "Skwer Ormiański", distance: 1303},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 2080}
    ],
    15788: [
        {type: OfferPoiType.BUS, name: "Ustronie Morskie - pętla", distance: 503},
        {type: OfferPoiType.BUS, name: "Marysin", distance: 535}
    ],
    15791: [
        {type: OfferPoiType.BUS, name: "Płużnicka 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Płużnicka 01", distance: 442},
        {type: OfferPoiType.TRAM, name: "Stare Świdry 03", distance: 576},
        {type: OfferPoiType.TRAM, name: "Stare Świdry 04", distance: 580},
        {type: OfferPoiType.BUS, name: "Stare Świdry 02", distance: 608},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 02", distance: 696},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 01", distance: 711},
        {type: OfferPoiType.BUS, name: "Obrazkowa 01", distance: 758},
        {type: OfferPoiType.BUS, name: "Obrazkowa 03", distance: 798},
        {type: OfferPoiType.BUS, name: "Porajów 01", distance: 820},
        {type: OfferPoiType.BUS, name: "Kasztanowa 02", distance: 833},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 1578}
    ],
    15798: [
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Nowokarsiborska 05", distance: 207},
        {type: OfferPoiType.BUS, name: "runwaldzka / Nowokarsiborska 06", distance: 243},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 07", distance: 389},
        {type: OfferPoiType.BUS, name: "Cmentarz - Brama nr II 04", distance: 404},
        {type: OfferPoiType.BUS, name: "Karsiborska / Steyera 06", distance: 423},
        {type: OfferPoiType.BUS, name: "Karsiborska / Steyera 05", distance: 431},
        {type: OfferPoiType.BUS, name: "Cmentarz - Brama nr II 03", distance: 436},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 08", distance: 491},
        {type: OfferPoiType.BUS, name: "Markiewicza - Poczta 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Osiedle Zachodnie 03", distance: 582},
        {type: OfferPoiType.LAS, name: "Świdne Bagna", distance: 1043},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 1915},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 2095}
    ],
    15816: [
        {type: OfferPoiType.BUS, name: "Zbożowa", distance: 355},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 467},
        {type: OfferPoiType.BUS, name: "Morska - Kcyńska", distance: 531},
        {type: OfferPoiType.BUS, name: "Owsiana", distance: 661}
    ],
    15820: [
        {type: OfferPoiType.BUS, name: "Czarnoleska / Wierzbicka", distance: 455},
        {type: OfferPoiType.BUS, name: "Czarnoleska / Urszuli", distance: 533},
        {type: OfferPoiType.BUS, name: "Sycyńska / Urszuli (NŻ) 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Sycyńska / Urszuli (NŻ) 01", distance: 607},
        {type: OfferPoiType.BUS, name: "Wierzbicka / Czarnoleska", distance: 625},
        {type: OfferPoiType.PARK, name: "Park Południe", distance: 808}
    ],
    15841: [
        {type: OfferPoiType.BUS, name: "Lodowa/Zamoyskiego", distance: 439},
        {type: OfferPoiType.BUS, name: "Karskiego/Oliwkowa (Z) NŻ", distance: 658},
        {type: OfferPoiType.BUS, name: "Karskiego/Oliwkowa NŻ", distance: 755},
        {type: OfferPoiType.BUS, name: "Lodowa/Chłodna", distance: 805},
        {type: OfferPoiType.LAS, name: "Las Wesołowski", distance: 1689},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Antoniuk", distance: 2082}
    ],
    15843: [
        {type: OfferPoiType.BUS, name: "Liceum Plastyczne", distance: 305},
        {type: OfferPoiType.BUS, name: "Batorego/Dworcowa", distance: 671},
        {type: OfferPoiType.LAS, name: "Dolina Gęśnika", distance: 1010},
        {type: OfferPoiType.PARK, name: "Plac Kolejarza", distance: 1434},
        {type: OfferPoiType.PARK, name: "Plac Makusynów", distance: 1470}
    ],
    15858: [
        {type: OfferPoiType.BUS, name: "Ligota Bronisławy", distance: 48},
        {type: OfferPoiType.BUS, name: "Ligota Akademiki", distance: 325},
        {type: OfferPoiType.PARK, name: "Skwer Tytusa Chałubińskiego", distance: 464},
        {type: OfferPoiType.BUS, name: "Ligota Szpital", distance: 469},
        {type: OfferPoiType.LAS, name: "Gierkówka", distance: 549},
        {type: OfferPoiType.BUS, name: "Ligota Wileńska", distance: 551},
        {type: OfferPoiType.PARK, name: "Park Zadole", distance: 654},
        {type: OfferPoiType.PARK, name: "plac profesora Kornela Gibińskiego", distance: 701},
        {type: OfferPoiType.BUS, name: "Ligota Medyków", distance: 712},
        {type: OfferPoiType.BUS, name: "Panewniki Bazylika", distance: 779},
        {type: OfferPoiType.PARK, name: "Skwer Nad Ślepiotką", distance: 788},
        {type: OfferPoiType.PARK, name: "skwer Bolesława Szabelskiego", distance: 1070},
        {type: OfferPoiType.PARK, name: "Skwer profesora Wilibalda Winklera", distance: 1096},
        {type: OfferPoiType.PARK, name: "plac ojca Justyna Widucha", distance: 1099},
        {type: OfferPoiType.PARK, name: "Plac Miast Partnerskich", distance: 1188}
    ],
    15863: [
        {type: OfferPoiType.BUS, name: "Bronowice Małe", distance: 105},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 03", distance: 157},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 05", distance: 255},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 09", distance: 319},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 334},
        {type: OfferPoiType.TRAM, name: "Bronowice Małe 01", distance: 409},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 06", distance: 422},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 08", distance: 508},
        {type: OfferPoiType.TRAM, name: "Bronowice Małe", distance: 510},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 07", distance: 558},
        {type: OfferPoiType.BUS, name: "Giełda Balicka 02", distance: 710},
        {type: OfferPoiType.BUS, name: "Giełda Balicka 01", distance: 743},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1560},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 1894},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1953},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 2124},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 2223}
    ],
    15866: [
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1223},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1903},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 2099},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2528}
    ],
    15885: [
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 192},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 240},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 253},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 317},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 401},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 480},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 505},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Sterlinga NŻ", distance: 513},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Rewolucji 1905 r.", distance: 527},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kilińskiego", distance: 541},
        {type: OfferPoiType.BUS, name: "Sterlinga - Rewolucji 1905r.", distance: 545},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 554},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 561},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 601},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 623},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 693},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 900},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1045},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1164}
    ],
    15887: [
        {type: OfferPoiType.BUS, name: "Świt", distance: 439},
        {type: OfferPoiType.BUS, name: "Ołtaszyn", distance: 534},
        {type: OfferPoiType.BUS, name: "Strachowskiego", distance: 748},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 1363},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1788},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 2221},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 2403},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 2433}
    ],
    15896: [
        {type: OfferPoiType.BUS, name: "Niepodległości / LIDL", distance: 162},
        {type: OfferPoiType.BUS, name: "Tysiąclecia / Spółdzielnia Mieszkaniowa", distance: 208},
        {type: OfferPoiType.BUS, name: "Słowackiego / Dom Nauczyciela", distance: 236},
        {type: OfferPoiType.PARK, name: "Skwer Braci Zygmuntowiczów", distance: 355},
        {type: OfferPoiType.BUS, name: "Okrzei / Poczta", distance: 363},
        {type: OfferPoiType.BUS, name: "Krasińskiego / Hermes", distance: 452},
        {type: OfferPoiType.PARK, name: "Skwer Kolejarzy", distance: 476},
        {type: OfferPoiType.BUS, name: "Sikorskiego / Urząd Miasta", distance: 593},
        {type: OfferPoiType.PARK, name: "Skwer imienia Franciszka Tatkowskiego", distance: 595},
        {type: OfferPoiType.BUS, name: "Piłsudskiego / Szkoła", distance: 613},
        {type: OfferPoiType.PARK, name: "Skwer Bziński", distance: 1120}
    ],
    15910: [
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 341},
        {type: OfferPoiType.BUS, name: "Marysińska - Szklana", distance: 396},
        {type: OfferPoiType.BUS, name: "Marysińska - Okopowa", distance: 436},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Park Szarych Szeregów", distance: 509},
        {type: OfferPoiType.BUS, name: "Marysin Stadion", distance: 515},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Okopowa", distance: 597},
        {type: OfferPoiType.BUS, name: "Obr. Westerplatte - Organizacji WiN", distance: 684},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Sucharskiego", distance: 688},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 879},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1245},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1319},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1363},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1464},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1532},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1594}
    ],
    15913: [
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 196},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 234},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 242},
        {type: OfferPoiType.BUS, name: "Włókniarzy - Legionów NŻ", distance: 302},
        {type: OfferPoiType.BUS, name: "Zielona - 1 Maja", distance: 422},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 492},
        {type: OfferPoiType.BUS, name: "Konstantynowska - Unii Lubelskiej (Fala)", distance: 510},
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 618},
        {type: OfferPoiType.TRAM, name: "Konstantynowska - Unii Lubelskiej (Fala)", distance: 628},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Konstantynowska (Fala)", distance: 657},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Srebrzyńska", distance: 710},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 888},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 988},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1214},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1313},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1400},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 1476},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 1509},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1810},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 1857}
    ],
    15914: [
        {type: OfferPoiType.BUS, name: "Jasielska II n/ż", distance: 95},
        {type: OfferPoiType.BUS, name: "Jasielska I n/ż", distance: 453},
        {type: OfferPoiType.BUS, name: "Druskienicka", distance: 483},
        {type: OfferPoiType.BUS, name: "Instytut Genetyki n/ż", distance: 655},
        {type: OfferPoiType.BUS, name: "Truskawiecka n/ż", distance: 774},
        {type: OfferPoiType.BUS, name: "Lubieńska n/ż", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 838},
        {type: OfferPoiType.PARK, name: "Park Edukacji Ekologicznej Strzeszyn", distance: 1105},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1208},
        {type: OfferPoiType.PARK, name: "Aleja Demokracji", distance: 1298},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 2377},
        {type: OfferPoiType.PARK, name: "Park Alberta Camusa", distance: 2520}
    ],
    15916: [
        {type: OfferPoiType.BUS, name: "Myśliwska 02", distance: 108},
        {type: OfferPoiType.BUS, name: "Myśliwska 01", distance: 128},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 473},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 02", distance: 490},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 496},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Lasówka 02", distance: 576},
        {type: OfferPoiType.BUS, name: "Lasówka 01", distance: 656},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 677},
        {type: OfferPoiType.PARK, name: "Ptasi Zagajnik", distance: 701},
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 773},
        {type: OfferPoiType.BUS, name: "Szczecińska 02", distance: 776},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R", distance: 811},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1376},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1876}
    ],
    15918: [
        {type: OfferPoiType.PARK, name: "Plac Władysława Broniewskiego", distance: 155},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 02", distance: 254},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy i Autobusowy 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy i Autobusowy 01", distance: 326},
        {type: OfferPoiType.BUS, name: "Kołłątaja - Kaufland 01/02", distance: 399},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy i Autobusowy 03", distance: 466},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 01", distance: 564},
        {type: OfferPoiType.BUS, name: "Plac Dąbrowskiego 02", distance: 600},
        {type: OfferPoiType.BUS, name: "Wolności 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Wolności 02", distance: 628},
        {type: OfferPoiType.BUS, name: "Sienkiewicza 01", distance: 647},
        {type: OfferPoiType.PARK, name: "Skwer im. Pierwszych Słupszczan", distance: 708},
        {type: OfferPoiType.PARK, name: "Park im. Henryka Sienkiewicza", distance: 729},
        {type: OfferPoiType.PARK, name: "Skwer Heinricha von Stephana", distance: 857},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 909},
        {type: OfferPoiType.PARK, name: "Park Pianistyki Polskiej", distance: 997},
        {type: OfferPoiType.PARK, name: "Park im. Jerzego Waldorffa", distance: 1095}
    ],
    15927: [
        {type: OfferPoiType.BUS, name: "Niemcz / Słowackiego", distance: 210},
        {type: OfferPoiType.BUS, name: "Niemcz / Kasprowicza", distance: 341},
        {type: OfferPoiType.BUS, name: "Niemcz / Mickiewicza", distance: 526},
        {type: OfferPoiType.BUS, name: "Jeździecka / Ogród Botaniczny", distance: 583},
        {type: OfferPoiType.BUS, name: "Jeździecka / Hipiczna", distance: 827}
    ],
    15937: [
        {type: OfferPoiType.BUS, name: "PIMOT 02", distance: 307},
        {type: OfferPoiType.TRAM, name: "PIMOT 04", distance: 408},
        {type: OfferPoiType.BUS, name: "PIMOT 01", distance: 409},
        {type: OfferPoiType.TRAM, name: "PIMOT 03", distance: 417},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 02", distance: 610},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 54", distance: 613},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 53", distance: 654},
        {type: OfferPoiType.TRAM, name: "Golędzinów 02", distance: 806},
        {type: OfferPoiType.BUS, name: "Golędzinów 04", distance: 826},
        {type: OfferPoiType.TRAM, name: "Golędzinów 01", distance: 837},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 2435}
    ],
    15943: [
        {type: OfferPoiType.BUS, name: "Galeria jurajska", distance: 689},
        {type: OfferPoiType.BUS, name: "Mała", distance: 736},
        {type: OfferPoiType.PARK, name: "Park Piastów", distance: 1248},
        {type: OfferPoiType.PARK, name: "Promenada Olgi Aleksandry Sipowicz - Kory", distance: 1385},
        {type: OfferPoiType.PARK, name: "Plac Katyński", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer Solidarności", distance: 1778}
    ],
    15946: [
        {type: OfferPoiType.BUS, name: "Zachodnia 01", distance: 167},
        {type: OfferPoiType.BUS, name: "Zachodnia 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Torfowa 02", distance: 431},
        {type: OfferPoiType.BUS, name: "Torfowa 01", distance: 584},
        {type: OfferPoiType.BUS, name: "Kampus UJ 03", distance: 734},
        {type: OfferPoiType.BUS, name: "Rostworowskiego 01", distance: 794},
        {type: OfferPoiType.TRAM, name: "Kampus UJ 02", distance: 799},
        {type: OfferPoiType.TRAM, name: "Kampus UJ 01", distance: 807},
        {type: OfferPoiType.BUS, name: "Rostworowskiego 05", distance: 817},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1058},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 1968},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2066}
    ],
    15978: [
        {type: OfferPoiType.BUS, name: "Granata 01", distance: 255},
        {type: OfferPoiType.BUS, name: "Granata 02", distance: 263},
        {type: OfferPoiType.BUS, name: "Osmolicka NŻ 02", distance: 734},
        {type: OfferPoiType.BUS, name: "Elektromontaż 01", distance: 816}
    ],
    15982: [
        {type: OfferPoiType.TRAM, name: "Kochanowskiego", distance: 391},
        {type: OfferPoiType.BUS, name: "Kochanowskiego", distance: 402},
        {type: OfferPoiType.TRAM, name: "Chopina", distance: 507},
        {type: OfferPoiType.BUS, name: "Szymanowskiego", distance: 632},
        {type: OfferPoiType.BUS, name: "Witelona", distance: 677},
        {type: OfferPoiType.BUS, name: "Moniuszki", distance: 777},
        {type: OfferPoiType.BUS, name: "Śniadeckich", distance: 838},
        {type: OfferPoiType.TRAM, name: "Karłowicza", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1033}
    ],
    16011: [
        {type: OfferPoiType.BUS, name: "Kozacka 01", distance: 152},
        {type: OfferPoiType.BUS, name: "Lotników 02", distance: 257},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 02", distance: 288},
        {type: OfferPoiType.BUS, name: "Lotników 01", distance: 350},
        {type: OfferPoiType.BUS, name: "Kozacka 02", distance: 350},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 03", distance: 357},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 01", distance: 424},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 04", distance: 438},
        {type: OfferPoiType.BUS, name: "Wielki Rów 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Wielki Rów 02", distance: 652},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1814},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 2080}
    ],
    16021: [
        {type: OfferPoiType.BUS, name: "Radzionków Targowisko", distance: 251},
        {type: OfferPoiType.BUS, name: "Radzionków Plac Letochów", distance: 452},
        {type: OfferPoiType.BUS, name: "Radzionków Unii Europejskiej", distance: 533},
        {type: OfferPoiType.BUS, name: "Rojca Centrum Przesiadkowe", distance: 579},
        {type: OfferPoiType.KOLEJ, name: "Radzionków Rojca", distance: 591},
        {type: OfferPoiType.PARK, name: "Planty Radzionków", distance: 1705},
        {type: OfferPoiType.PARK, name: "Park Marka", distance: 2001},
        {type: OfferPoiType.PARK, name: "Park Grota", distance: 2055},
        {type: OfferPoiType.REZERWAT, name: "Księża Góra", distance: 2297},
        {type: OfferPoiType.REZERWAT, name: "Suchogórski Labirynt Skalny", distance: 2431}
    ],
    16039: [
        {type: OfferPoiType.BUS, name: "Legionów - Farbiarska", distance: 217},
        {type: OfferPoiType.BUS, name: "Legionów - działki", distance: 253},
        {type: OfferPoiType.BUS, name: "Farbiarska - Legionów", distance: 269},
        {type: OfferPoiType.BUS, name: "Farbiarska - działki", distance: 289},
        {type: OfferPoiType.LAS, name: "Park Bulwary", distance: 391},
        {type: OfferPoiType.PARK, name: "Park Bulwary", distance: 391},
        {type: OfferPoiType.BUS, name: "gen. Bema - gen. Hallera", distance: 478},
        {type: OfferPoiType.BUS, name: "gen. Bema - Fabryczna", distance: 509},
        {type: OfferPoiType.BUS, name: "gen. Hallera 2", distance: 566},
        {type: OfferPoiType.BUS, name: "Legionów - szkoła", distance: 610},
        {type: OfferPoiType.BUS, name: "gen. Hallera 23", distance: 724},
        {type: OfferPoiType.PARK, name: "Park im. Stefanii i Juliana Tuwimów", distance: 783},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 1172},
        {type: OfferPoiType.PARK, name: "Pałac Ostrowskich", distance: 1190},
        {type: OfferPoiType.LAS, name: "Park Solidarności", distance: 1332},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1332},
        {type: OfferPoiType.LAS, name: "Skwer Powstań Narodowych", distance: 1473},
        {type: OfferPoiType.LAS, name: "Park imienia doktora medycyny Jana Rodego", distance: 1495}
    ],
    16043: [
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 120},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 02 TARGOWISKO", distance: 123},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 01 TARGOWISKO", distance: 158},
        {type: OfferPoiType.BUS, name: "Dąbrówki 01", distance: 230},
        {type: OfferPoiType.BUS, name: "Dąbrówki", distance: 252},
        {type: OfferPoiType.BUS, name: "Łubieńskiego 02", distance: 336},
        {type: OfferPoiType.BUS, name: "Sobieskiego 02 PARK MIEJSKI", distance: 363},
        {type: OfferPoiType.BUS, name: "Sobieskiego 01 PARK MIEJSKI", distance: 393},
        {type: OfferPoiType.BUS, name: "Roosevelta 02 C.K. ESTEDE", distance: 436},
        {type: OfferPoiType.BUS, name: "Roosevelta 01 C.K. ESTEDE", distance: 450},
        {type: OfferPoiType.PARK, name: "Park Miejski im. gen. Władysława Andersa", distance: 623},
        {type: OfferPoiType.PARK, name: "Park im. Prezydenta Ryszarda Kaczorowskiego", distance: 957},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 957},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisława Wyspiańskiego", distance: 1490},
        {type: OfferPoiType.PARK, name: "Konopnickiej/Wrzesińska Park Rozrywki", distance: 1772}
    ],
    16045: [
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 218},
        {type: OfferPoiType.BUS, name: "Świtezianki - Nastrojowa", distance: 277},
        {type: OfferPoiType.BUS, name: "Świtezianki - Zgierska", distance: 335},
        {type: OfferPoiType.BUS, name: "Radogoszcz Wschód", distance: 372},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 485},
        {type: OfferPoiType.TRAM, name: "Zgierska - Świtezianki", distance: 533},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pasieczna", distance: 660},
        {type: OfferPoiType.BUS, name: "Świtezianki - Dw. Łódź Radogoszcz Wschód NŻ", distance: 706},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 1322},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 1439},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy na Żabieńcu”", distance: 2322},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Sokołówki i Brzozy”", distance: 2449},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 2501}
    ],
    16062: [
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 669},
        {type: OfferPoiType.BUS, name: "Osiedle Sarni Stok", distance: 694},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1789},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1979}
    ],
    16069: [
        {type: OfferPoiType.BUS, name: "Św. Wawrzyńca", distance: 256},
        {type: OfferPoiType.BUS, name: "Jeżycka", distance: 272},
        {type: OfferPoiType.BUS, name: "Kościelna Tunel", distance: 326},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 590},
        {type: OfferPoiType.BUS, name: "Nad Wierzbakiem", distance: 645},
        {type: OfferPoiType.TRAM, name: "Nad Wierzbakiem", distance: 725},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 1127},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1164},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1353},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1402},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1475},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1657},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1746},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 1829}
    ],
    16079: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Brzozowa", distance: 412},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Brzozowa", distance: 413},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Senatorska", distance: 425},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Senatorska", distance: 445},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 609},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Kilińskiego", distance: 632},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Kilińskiego", distance: 632},
        {type: OfferPoiType.BUS, name: "Zarzewska - Praska NŻ", distance: 633},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Przybyszewskiego", distance: 661},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przybyszewskiego", distance: 661},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 703},
        {type: OfferPoiType.BUS, name: "Zarzewska - Kilińskiego", distance: 751},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 798},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1003},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1117},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1203},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1248},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 1476}
    ],
    16101: [
        {type: OfferPoiType.BUS, name: "Maczka - Pienista NŻ", distance: 219},
        {type: OfferPoiType.BUS, name: "Pienista - Komandorska", distance: 416},
        {type: OfferPoiType.BUS, name: "Sortownia", distance: 767},
        {type: OfferPoiType.BUS, name: "Maczka - Aeroklub NŻ", distance: 781},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1298}
    ],
    16108: [
        {type: OfferPoiType.BUS, name: "Wiślinka Piaskowa", distance: 532},
        {type: OfferPoiType.BUS, name: "Wiślinka Most", distance: 797}
    ],
    16113: [
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 03", distance: 263},
        {type: OfferPoiType.BUS, name: "Kościelna 01", distance: 271},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 01", distance: 277},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 302},
        {type: OfferPoiType.BUS, name: "Fabryczna 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Nadarzyńska 02", distance: 449},
        {type: OfferPoiType.BUS, name: "Szkolna 01", distance: 508},
        {type: OfferPoiType.BUS, name: "Urząd Miasta 02", distance: 545},
        {type: OfferPoiType.BUS, name: "Nadarzyńska 01", distance: 555},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Kisielewskiego", distance: 682},
        {type: OfferPoiType.PARK, name: "Skwer Hrabianki Ludwiki Małgorzaty Moriconi", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Książąt Mazowieckich", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 800}
    ],
    16147: [
        {type: OfferPoiType.TRAM, name: "Głowackiego 02", distance: 793},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 02", distance: 812},
        {type: OfferPoiType.TRAM, name: "Głowackiego 01", distance: 844},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 921},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1011},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1049},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1137},
        {type: OfferPoiType.PARK, name: "Ogrody Łobzów", distance: 1138},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1548},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1555},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 1594},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1643}
    ],
    16160: [
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Południowa", distance: 218},
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Słoneczników", distance: 265},
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Nadarzyńska", distance: 668},
        {type: OfferPoiType.BUS, name: "Żółwin Słoneczna / Graniczna", distance: 682},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat im. Bolesława Hryniewieckiego", distance: 2140}
    ],
    16164: [
        {type: OfferPoiType.BUS, name: "Baczyna - Słoneczna", distance: 143},
        {type: OfferPoiType.BUS, name: "Lipiańska", distance: 255}
    ],
    16180: [
        {type: OfferPoiType.BUS, name: "Paderewskiego 06", distance: 308},
        {type: OfferPoiType.BUS, name: "Stefczyka NŻ 01", distance: 316},
        {type: OfferPoiType.BUS, name: "Stefczyka NŻ 02", distance: 337},
        {type: OfferPoiType.BUS, name: "Zajezdnia Stefczyka", distance: 397},
        {type: OfferPoiType.BUS, name: "Paderewskiego 05", distance: 474},
        {type: OfferPoiType.BUS, name: "Paderewskiego 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Paderewskiego 04", distance: 504},
        {type: OfferPoiType.BUS, name: "Paderewskiego 03", distance: 536},
        {type: OfferPoiType.BUS, name: "Paderewskiego 02", distance: 552},
        {type: OfferPoiType.BUS, name: "Pienińska NŻ 02", distance: 653}
    ],
    16184: [
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Jarzynowa", distance: 161},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Cm. Mania", distance: 315},
        {type: OfferPoiType.BUS, name: "Solec - Cm. Mania", distance: 319},
        {type: OfferPoiType.BUS, name: "Solec - Borowa NŻ", distance: 383},
        {type: OfferPoiType.BUS, name: "Borowa - Siewna NŻ", distance: 656},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Unii Lubelskiej", distance: 700},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Praussa", distance: 720},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 899},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1010},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1137},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1554},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 2022},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2229},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 2324},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 2380},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2401}
    ],
    16185: [
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 830},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1987},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 2140},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Sarni Stok"', distance: 2343}
    ],
    16201: [
        {type: OfferPoiType.BUS, name: "Leźnieńska 01", distance: 673},
        {type: OfferPoiType.LAS, name: "Aleja Smęgorzyńska", distance: 1129},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko Smęgorzyńskie", distance: 2446}
    ],
    16207: [
        {type: OfferPoiType.BUS, name: "Gąsocińska 02", distance: 310},
        {type: OfferPoiType.BUS, name: "Gąsocińska 01", distance: 422},
        {type: OfferPoiType.BUS, name: "Siekierkowska 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Siekierkowska 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 03", distance: 553},
        {type: OfferPoiType.BUS, name: "Ananasowa 52", distance: 639},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 02", distance: 699},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 711},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 715},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 2392}
    ],
    16212: [
        {type: OfferPoiType.BUS, name: "Dobrzykowice – cmentarz", distance: 274},
        {type: OfferPoiType.BUS, name: "Krzyków – Osiedle", distance: 754}
    ],
    16214: [
        {type: OfferPoiType.BUS, name: "Puck, Wejherowska", distance: 99},
        {type: OfferPoiType.BUS, name: "Puck, Paderewskiego", distance: 426},
        {type: OfferPoiType.BUS, name: "Puck, Asnyka / Dziedzictwa Jana Pawła II", distance: 491},
        {type: OfferPoiType.BUS, name: "Puck, Topolowa", distance: 564},
        {type: OfferPoiType.BUS, name: "Puck, Żeromskiego [NŻ]", distance: 580},
        {type: OfferPoiType.BUS, name: "Puck, Sychty", distance: 702},
        {type: OfferPoiType.REZERWAT, name: "Nadmorski Park Krajobrazowy", distance: 1223},
        {type: OfferPoiType.PARK, name: "Park Dziejów Pucka", distance: 1279},
        {type: OfferPoiType.PARK, name: "Park Kaszubski", distance: 1728},
        {type: OfferPoiType.PARK, name: "Park pałacowy", distance: 1964},
        {type: OfferPoiType.PARK, name: "Park im. Feliksa Nowowiejskiego", distance: 2174}
    ],
    16215: [
        {type: OfferPoiType.BUS, name: "Zakopiańska - Mini Golf", distance: 629},
        {type: OfferPoiType.LAS, name: "Smolak", distance: 732},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1171},
        {type: OfferPoiType.PARK, name: "Park Orkiestr Wojska Polskiego", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Górny", distance: 1434},
        {type: OfferPoiType.PARK, name: "Park uzdrowiskowy Czerniawa-Zdrój", distance: 2290}
    ],
    16218: [
        {type: OfferPoiType.TRAM, name: "Wesele 02", distance: 144},
        {type: OfferPoiType.TRAM, name: "Wesele 01", distance: 220},
        {type: OfferPoiType.BUS, name: "Wesele 03", distance: 234},
        {type: OfferPoiType.BUS, name: "Wesele 04", distance: 244},
        {type: OfferPoiType.TRAM, name: "Bronowice 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Bronowice 05", distance: 490},
        {type: OfferPoiType.TRAM, name: "Bronowice 03", distance: 546},
        {type: OfferPoiType.TRAM, name: "Bronowice", distance: 560},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 06", distance: 586},
        {type: OfferPoiType.TRAM, name: "Bronowice 01", distance: 596},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 03", distance: 607},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 620},
        {type: OfferPoiType.BUS, name: "Bronowice 04", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 698},
        {type: OfferPoiType.TRAM, name: "Bronowice SKA 01", distance: 703},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 07", distance: 715},
        {type: OfferPoiType.TRAM, name: "Bronowice SKA 02", distance: 738},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 04", distance: 764},
        {type: OfferPoiType.BUS, name: "Bronowice SKA 05", distance: 778},
        {type: OfferPoiType.BUS, name: "Zarzecze 02", distance: 808},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1051},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1216},
        {type: OfferPoiType.PARK, name: "Ogrody Łobzów", distance: 1305},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1538},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1624},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 1727}
    ],
    16220: [
        {type: OfferPoiType.BUS, name: "Dźwirzyno - WSS", distance: 443},
        {type: OfferPoiType.BUS, name: "Dźwirzyno - Osiedle", distance: 612},
        {type: OfferPoiType.LAS, name: "Drużyna Chrobrego", distance: 661}
    ],
    16228: [
        {type: OfferPoiType.BUS, name: "Kasztanowa n/ż", distance: 160},
        {type: OfferPoiType.BUS, name: "Kalinowa n/ż", distance: 168},
        {type: OfferPoiType.BUS, name: "Cedrowa", distance: 173},
        {type: OfferPoiType.BUS, name: "Dębiec Tunel PKM n/ż", distance: 301},
        {type: OfferPoiType.PARK, name: "Lasek Dębiec", distance: 358},
        {type: OfferPoiType.BUS, name: "Łozowa", distance: 422},
        {type: OfferPoiType.BUS, name: "Dębiec PKM", distance: 545},
        {type: OfferPoiType.KOLEJ, name: "Poznań Dębiec", distance: 595},
        {type: OfferPoiType.TRAM, name: "Dębiec PKM", distance: 709},
        {type: OfferPoiType.PARK, name: "Park Bambrów Poznańskich", distance: 785},
        {type: OfferPoiType.REZERWAT, name: "Strefa ochrony bezpośredniej ujęcia wody Dębina", distance: 1383},
        {type: OfferPoiType.REZERWAT, name: "Dębina II", distance: 1505},
        {type: OfferPoiType.REZERWAT, name: "Strefa ochrony pośredniej ujęcia wody Dębina", distance: 2084},
        {type: OfferPoiType.REZERWAT, name: "Dębina I", distance: 2218}
    ],
    16233: [
        {type: OfferPoiType.BUS, name: "Solna", distance: 310},
        {type: OfferPoiType.TRAM, name: "Pl. Ratajskiego", distance: 324},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 393},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 455},
        {type: OfferPoiType.BUS, name: "Libelta", distance: 472},
        {type: OfferPoiType.BUS, name: "Plac Wielkopolski n/ż", distance: 481},
        {type: OfferPoiType.BUS, name: "Plac Wielkopolski nż", distance: 486},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 501},
        {type: OfferPoiType.TRAM, name: "Pl. Wielkopolski", distance: 536},
        {type: OfferPoiType.BUS, name: "Nowowiejskiego", distance: 547},
        {type: OfferPoiType.BUS, name: "Urząd Wojewódzki", distance: 552},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 553},
        {type: OfferPoiType.TRAM, name: "Gwarna", distance: 573},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 576},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 633},
        {type: OfferPoiType.TRAM, name: "Fredry", distance: 649},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 663},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 697},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 739},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 759},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 827},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 942},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 953},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 1025},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1082},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1456}
    ],
    16235: [
        {type: OfferPoiType.BUS, name: "Grobla", distance: 49},
        {type: OfferPoiType.BUS, name: "Wielka", distance: 208},
        {type: OfferPoiType.BUS, name: "Mostowa", distance: 321},
        {type: OfferPoiType.TRAM, name: "Pl. Bernardyński", distance: 321},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 330},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 387},
        {type: OfferPoiType.BUS, name: "Małe Garbary", distance: 389},
        {type: OfferPoiType.TRAM, name: "Małe Garbary", distance: 441},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 489},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 522},
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 642},
        {type: OfferPoiType.BUS, name: "Most Św. Rocha", distance: 648},
        {type: OfferPoiType.TRAM, name: "Most Św. Rocha", distance: 648},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 978},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1051},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 1068},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 1249},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1287},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 1349},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 1407},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1486},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1528}
    ],
    16237: [
        {type: OfferPoiType.BUS, name: "Waniliowa", distance: 461},
        {type: OfferPoiType.BUS, name: "Kaparowa", distance: 643},
        {type: OfferPoiType.BUS, name: "Tymiankowa", distance: 673},
        {type: OfferPoiType.BUS, name: "Cynamonowa", distance: 743},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 1961}
    ],
    16240: [
        {type: OfferPoiType.BUS, name: "Bohaterów M. Cassino 02", distance: 90},
        {type: OfferPoiType.BUS, name: "Bohaterów M. Cassino 01", distance: 205},
        {type: OfferPoiType.BUS, name: "Wojciechowska - zespół szkół 02", distance: 244},
        {type: OfferPoiType.BUS, name: "Bohaterów M. Cassino 03", distance: 246},
        {type: OfferPoiType.BUS, name: "Wojciechowska - zespół szkół 01", distance: 371},
        {type: OfferPoiType.BUS, name: "Polfa 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Poczekajka 03", distance: 425},
        {type: OfferPoiType.BUS, name: "Polfa 01", distance: 516},
        {type: OfferPoiType.BUS, name: "Poczekajka 01", distance: 552},
        {type: OfferPoiType.BUS, name: "Poczekajka 04", distance: 594}
    ],
    16249: [{type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 2489}],
    16251: [
        {type: OfferPoiType.BUS, name: "Świtezianki - Sikorskiego", distance: 441},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Nastrojowa", distance: 448},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Dw. Łódź Arturówek", distance: 470},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 523},
        {type: OfferPoiType.BUS, name: "Łagiewnicka - Dw. Łódź Arturówek", distance: 603},
        {type: OfferPoiType.BUS, name: "Pl. Słoneczny", distance: 755},
        {type: OfferPoiType.BUS, name: "Świtezianki - Syrenki", distance: 789},
        {type: OfferPoiType.KOLEJ, name: "Łódź Arturówek", distance: 801},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 944},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 1145},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1541},
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 1609},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 2009}
    ],
    16254: [
        {type: OfferPoiType.BUS, name: "Goraszewska 04", distance: 77},
        {type: OfferPoiType.BUS, name: "Goraszewska 01", distance: 118},
        {type: OfferPoiType.BUS, name: "Goraszewska 03", distance: 124},
        {type: OfferPoiType.BUS, name: "Goraszewska 02", distance: 179},
        {type: OfferPoiType.BUS, name: "Klarysewska 01", distance: 306},
        {type: OfferPoiType.BUS, name: "Klarysewska 02", distance: 319},
        {type: OfferPoiType.BUS, name: "Limanowskiego 01", distance: 379},
        {type: OfferPoiType.PARK, name: "Skwer Ormiański", distance: 477},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 555},
        {type: OfferPoiType.PARK, name: "Park Czesława Szczubełka", distance: 565},
        {type: OfferPoiType.BUS, name: "Limanowskiego 02", distance: 579},
        {type: OfferPoiType.BUS, name: "Sadyba 02", distance: 611},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 619},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 662},
        {type: OfferPoiType.BUS, name: "Sadyba 01", distance: 691},
        {type: OfferPoiType.TRAM, name: "Św. Bonifacego 06", distance: 824},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1055}
    ],
    16261: [
        {type: OfferPoiType.BUS, name: "Zimna", distance: 199},
        {type: OfferPoiType.BUS, name: "Ugory eMOCja", distance: 375},
        {type: OfferPoiType.BUS, name: "Stogi 02", distance: 460},
        {type: OfferPoiType.BUS, name: "Stogi 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Tamka 01", distance: 606},
        {type: OfferPoiType.BUS, name: "Rozłogi 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Stogi 06", distance: 635},
        {type: OfferPoiType.BUS, name: "Kłosowa 01", distance: 683},
        {type: OfferPoiType.PARK, name: "Skwer Bajki", distance: 2025}
    ],
    16286: [
        {type: OfferPoiType.BUS, name: "Proletariacka - Sowia NŻ", distance: 501},
        {type: OfferPoiType.BUS, name: "Rembielińskiego - Inżynierska NŻ", distance: 588},
        {type: OfferPoiType.BUS, name: "Radwańska - Inżynierska NŻ", distance: 680},
        {type: OfferPoiType.BUS, name: "Proletariacka - Wróblewskiego NŻ", distance: 841},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1038},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1280},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1925},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1934},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1961}
    ],
    16288: [
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Pętla", distance: 471},
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Granitowa", distance: 823},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 2031},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Dąbrowa", distance: 2512}
    ],
    16289: [
        {type: OfferPoiType.BUS, name: "Mechanik", distance: 286},
        {type: OfferPoiType.BUS, name: "Widok", distance: 291},
        {type: OfferPoiType.BUS, name: "Szkoła Podstawowa nr 6", distance: 589},
        {type: OfferPoiType.BUS, name: "Piękna", distance: 688},
        {type: OfferPoiType.KOLEJ, name: "Mińsk Mazowiecki", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 1386},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 1787},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1941},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1953},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 2109},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 2328}
    ],
    16292: [
        {type: OfferPoiType.BUS, name: "Traugutta 04", distance: 67},
        {type: OfferPoiType.BUS, name: "Uniwersyteckie Centrum Kliniczne 01", distance: 129},
        {type: OfferPoiType.BUS, name: "Traugutta 03", distance: 185},
        {type: OfferPoiType.BUS, name: "Uniwersyteckie Centrum Kliniczne 02", distance: 224},
        {type: OfferPoiType.TRAM, name: "Traugutta", distance: 239},
        {type: OfferPoiType.PARK, name: "Park im. Daniela Gralatha", distance: 258},
        {type: OfferPoiType.BUS, name: "Uniwersytet Medyczny 04", distance: 286},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 01", distance: 305},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 02", distance: 382},
        {type: OfferPoiType.BUS, name: "Centrum Onkologii 04", distance: 401},
        {type: OfferPoiType.TRAM, name: "Uniwersytet Medyczny 01", distance: 467},
        {type: OfferPoiType.PARK, name: "Park XXV-lecia Polski Rzeczypospolitej Ludowej", distance: 469},
        {type: OfferPoiType.BUS, name: "Uniwersytet Medyczny 03", distance: 490},
        {type: OfferPoiType.TRAM, name: "Uniwersytet Medyczny 02", distance: 498},
        {type: OfferPoiType.BUS, name: "Centrum Medycyny Inwazyjnej 01", distance: 643},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 700},
        {type: OfferPoiType.PARK, name: "Park im. Steffensów", distance: 710},
        {type: OfferPoiType.TRAM, name: "Opera Bałtycka", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Nostalgiczny", distance: 919},
        {type: OfferPoiType.PARK, name: "Park na Wroniej Górce", distance: 1331},
        {type: OfferPoiType.PARK, name: "Skwer Janiny Rokickiej", distance: 1385},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1747},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1909},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1986}
    ],
    16294: [
        {type: OfferPoiType.BUS, name: "Marszałkowska", distance: 756},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego n/ż", distance: 816},
        {type: OfferPoiType.BUS, name: "Świerzawska", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1678},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1804},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2205},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 2444}
    ],
    16304: [
        {type: OfferPoiType.BUS, name: "Sołtysowicka", distance: 390},
        {type: OfferPoiType.BUS, name: "Poprzeczna", distance: 636},
        {type: OfferPoiType.BUS, name: "Koszarowa", distance: 685},
        {type: OfferPoiType.PARK, name: "park Porucznika Roberta Marczewskiego", distance: 1257},
        {type: OfferPoiType.PARK, name: "Park Sołtysowicki", distance: 1767},
        {type: OfferPoiType.PARK, name: "skwer Władysława Bełzy", distance: 1968}
    ],
    16321: [
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 285},
        {type: OfferPoiType.BUS, name: "Bukowińska 01", distance: 323},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 330},
        {type: OfferPoiType.BUS, name: "Bukowińska 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Królikarnia 01", distance: 408},
        {type: OfferPoiType.BUS, name: "Bukowińska 05", distance: 417},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 435},
        {type: OfferPoiType.BUS, name: "Os. Domaniewska 02", distance: 447},
        {type: OfferPoiType.BUS, name: "Ksawerów 02", distance: 450},
        {type: OfferPoiType.TRAM, name: "Królikarnia 05", distance: 475},
        {type: OfferPoiType.BUS, name: "Ksawerów 01", distance: 478},
        {type: OfferPoiType.TRAM, name: "Królikarnia 03", distance: 509},
        {type: OfferPoiType.BUS, name: "Królikarnia 08", distance: 511},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 71", distance: 516},
        {type: OfferPoiType.TRAM, name: "Królikarnia 06", distance: 527},
        {type: OfferPoiType.BUS, name: "Os. Domaniewska 04", distance: 533},
        {type: OfferPoiType.BUS, name: "Wielicka 02", distance: 546},
        {type: OfferPoiType.TRAM, name: "Królikarnia 04", distance: 559},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 72", distance: 583},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 04", distance: 716},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 03", distance: 734},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 748},
        {type: OfferPoiType.METRO, name: "Wierzbno", distance: 798},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 841},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 861},
        {type: OfferPoiType.PARK, name: "Arkadia", distance: 870},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1243},
        {type: OfferPoiType.PARK, name: "Park Dreszera", distance: 1494},
        {type: OfferPoiType.PARK, name: "Skwer Małkowskich", distance: 1539},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1585}
    ],
    16324: [
        {type: OfferPoiType.BUS, name: "Sielec Kąpielisko", distance: 303},
        {type: OfferPoiType.TRAM, name: "Sielec Osiedle Zamkowa", distance: 382},
        {type: OfferPoiType.TRAM, name: "Sielec Kąpielisko", distance: 387},
        {type: OfferPoiType.TRAM, name: "Konstantynów Centrum Handlowe", distance: 512},
        {type: OfferPoiType.BUS, name: "Sielec Osiedle Zamkowa", distance: 525},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 752},
        {type: OfferPoiType.BUS, name: "Sielec Park", distance: 814},
        {type: OfferPoiType.TRAM, name: "Konstantynów Fabryczna", distance: 821},
        {type: OfferPoiType.TRAM, name: "Sielec Park", distance: 830},
        {type: OfferPoiType.PARK, name: "Bulwary nad rzeką Przemszą", distance: 974},
        {type: OfferPoiType.PARK, name: 'Skwer Danuty Siedzikówny "Inki"', distance: 1006},
        {type: OfferPoiType.PARK, name: "Park Dietla", distance: 1169},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jana Antoniego Strzeleckiego", distance: 1591},
        {type: OfferPoiType.PARK, name: "Plac im. Braci Kożuchów", distance: 1781}
    ],
    16325: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 215},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 238},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 441},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 558},
        {type: OfferPoiType.BUS, name: "Terespolska 01", distance: 580},
        {type: OfferPoiType.BUS, name: "Terespolska 04", distance: 580},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 594},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1183},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1188},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1288},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1592},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1780},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1973},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1987},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 2113}
    ],
    16328: [
        {type: OfferPoiType.BUS, name: "Połczyńska 02", distance: 221},
        {type: OfferPoiType.BUS, name: "Połczyńska 01", distance: 286},
        {type: OfferPoiType.BUS, name: "Potęgowska 02", distance: 315},
        {type: OfferPoiType.BUS, name: "Potęgowska 01", distance: 316},
        {type: OfferPoiType.BUS, name: "Szadółki 04", distance: 693},
        {type: OfferPoiType.BUS, name: "Szadółki 03", distance: 757},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 996},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1556}
    ],
    16339: [
        {type: OfferPoiType.BUS, name: "Pienista - Obywatelska", distance: 375},
        {type: OfferPoiType.BUS, name: "Waltera-Janke - Nowe Sady", distance: 376},
        {type: OfferPoiType.BUS, name: "Elektronowa - Obywatelska NŻ", distance: 434},
        {type: OfferPoiType.BUS, name: "Obywatelska - Elektronowa NŻ", distance: 444},
        {type: OfferPoiType.BUS, name: "Nowe Sady - Waltera-Janke NŻ", distance: 544},
        {type: OfferPoiType.BUS, name: "Pienista - Rusałki NŻ", distance: 631},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 1693},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 2242},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2337}
    ],
    16340: [
        {type: OfferPoiType.BUS, name: "Podchorążych - Łucznicza NŻ", distance: 100},
        {type: OfferPoiType.BUS, name: "Podchorążych - Molla NŻ", distance: 317},
        {type: OfferPoiType.BUS, name: "Złotno - Legnicka NŻ", distance: 535},
        {type: OfferPoiType.BUS, name: "Podchorążych - Napoleońska", distance: 726},
        {type: OfferPoiType.BUS, name: "Złotno - Zaporowa", distance: 827},
        {type: OfferPoiType.BUS, name: "Rąbieńska - Rąbieńska 76 NŻ", distance: 834},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 1345},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 1422},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1721},
        {type: OfferPoiType.PARK, name: "Park Grabieński Las", distance: 2107},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 2109},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 2141},
        {type: OfferPoiType.PARK, name: "Skwer pocmentarny", distance: 2175},
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 2184}
    ],
    16342: [
        {type: OfferPoiType.BUS, name: "Wysoka – osiedle", distance: 424},
        {type: OfferPoiType.BUS, name: "Wysoka Osiedle", distance: 543},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 2510}
    ],
    16347: [
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Stawowa", distance: 285},
        {type: OfferPoiType.BUS, name: "Rybnik Paruszowiec-Piaski Błonia", distance: 664},
        {type: OfferPoiType.PARK, name: "Park Rybnik Paruszowiec przy Tężni", distance: 945}
    ],
    16348: [
        {type: OfferPoiType.TRAM, name: "Stalowa", distance: 437},
        {type: OfferPoiType.BUS, name: "Stalowa", distance: 439},
        {type: OfferPoiType.TRAM, name: "Plac Srebrny", distance: 742},
        {type: OfferPoiType.BUS, name: "Plac Srebrny", distance: 751},
        {type: OfferPoiType.BUS, name: "Grochowa", distance: 797},
        {type: OfferPoiType.TRAM, name: "Pereca", distance: 817},
        {type: OfferPoiType.BUS, name: "Pereca", distance: 828}
    ],
    16350: [
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 392},
        {type: OfferPoiType.BUS, name: "Dworzec Fordon", distance: 409},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 532},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Fordon", distance: 547},
        {type: OfferPoiType.BUS, name: "Brzechwy / Szelburg-Zarembiny", distance: 791},
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 1249},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1445},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 1451},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 2006}
    ],
    16352: [
        {type: OfferPoiType.BUS, name: "Gałczyńskiego", distance: 456},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego", distance: 611},
        {type: OfferPoiType.BUS, name: "Oboźna", distance: 835},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1437},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 2146}
    ],
    16356: [
        {type: OfferPoiType.TRAM, name: "Nocznickiego 01", distance: 327},
        {type: OfferPoiType.TRAM, name: "Nocznickiego 02", distance: 328},
        {type: OfferPoiType.BUS, name: "Popiela 05", distance: 558},
        {type: OfferPoiType.BUS, name: "Tołstoja 01", distance: 619},
        {type: OfferPoiType.BUS, name: "Popiela 06", distance: 649},
        {type: OfferPoiType.TRAM, name: "Popiela 04", distance: 653},
        {type: OfferPoiType.BUS, name: "Metro Młociny 04", distance: 656},
        {type: OfferPoiType.TRAM, name: "Popiela 03", distance: 672},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 05", distance: 673},
        {type: OfferPoiType.METRO, name: "Młociny", distance: 688},
        {type: OfferPoiType.BUS, name: "Popiela 02", distance: 692},
        {type: OfferPoiType.BUS, name: "Metro Młociny 01", distance: 694},
        {type: OfferPoiType.BUS, name: "Metro Młociny 25", distance: 701},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 06", distance: 706},
        {type: OfferPoiType.BUS, name: "Metro Młociny 19", distance: 713},
        {type: OfferPoiType.BUS, name: "Metro Młociny 23", distance: 718},
        {type: OfferPoiType.BUS, name: "Metro Młociny 21", distance: 720},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 08", distance: 743},
        {type: OfferPoiType.TRAM, name: "Metro Młociny 28", distance: 809},
        {type: OfferPoiType.PARK, name: "Skwer 30. Pułku Strzelców Kaniowskich", distance: 1019},
        {type: OfferPoiType.PARK, name: "Eco Skwerek", distance: 1397},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 1993},
        {type: OfferPoiType.PARK, name: "Jordanek", distance: 2299}
    ],
    16359: [
        {type: OfferPoiType.BUS, name: "Modzelewskiego 03", distance: 217},
        {type: OfferPoiType.BUS, name: "Langego 02", distance: 298},
        {type: OfferPoiType.BUS, name: "Modzelewskiego 01", distance: 314},
        {type: OfferPoiType.BUS, name: "Modzelewskiego 02", distance: 316},
        {type: OfferPoiType.BUS, name: "Langego 01", distance: 343},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 04", distance: 607},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 02", distance: 615},
        {type: OfferPoiType.BUS, name: "Os. Domaniewska 04", distance: 637},
        {type: OfferPoiType.BUS, name: "Smoluchowskiego 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Domaniewska 05", distance: 716},
        {type: OfferPoiType.TRAM, name: "Telewizja Polska 04", distance: 766},
        {type: OfferPoiType.TRAM, name: "Samochodowa 04", distance: 769},
        {type: OfferPoiType.TRAM, name: "Samochodowa 03", distance: 793},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 799},
        {type: OfferPoiType.TRAM, name: "Metro Wierzbno 03", distance: 807},
        {type: OfferPoiType.TRAM, name: "Telewizja Polska 03", distance: 824},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1231},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1735},
        {type: OfferPoiType.PARK, name: "Arkadia", distance: 1764},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2126},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2468}
    ],
    16361: [
        {type: OfferPoiType.BUS, name: "Reduta 01", distance: 135},
        {type: OfferPoiType.BUS, name: "Reduta 02", distance: 189},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 04", distance: 294},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R", distance: 353},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 01", distance: 385},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 02", distance: 440},
        {type: OfferPoiType.BUS, name: "Strzelców 02", distance: 714},
        {type: OfferPoiType.BUS, name: "Powstańców Garaże 02", distance: 723},
        {type: OfferPoiType.BUS, name: "Powstańców Garaże 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Cmentarz Prądnik Czerwony 01", distance: 825},
        {type: OfferPoiType.LAS, name: "Park Krakowian - Węgrzecka", distance: 978},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 1286},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 1738}
    ],
    16375: [
        {type: OfferPoiType.TRAM, name: "Winnica 04", distance: 446},
        {type: OfferPoiType.TRAM, name: "Winnica 03", distance: 456},
        {type: OfferPoiType.BUS, name: "Winnica 73", distance: 457},
        {type: OfferPoiType.BUS, name: "Winnica 02", distance: 461},
        {type: OfferPoiType.BUS, name: "Winnica 03", distance: 469},
        {type: OfferPoiType.BUS, name: "Winnica 06", distance: 487},
        {type: OfferPoiType.BUS, name: "Winnica 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Winnica 11", distance: 526},
        {type: OfferPoiType.TRAM, name: "Winnica 05", distance: 549},
        {type: OfferPoiType.BUS, name: "Winnica 13", distance: 612},
        {type: OfferPoiType.TRAM, name: "Winnica 72", distance: 618},
        {type: OfferPoiType.BUS, name: "Grzymalitów 02", distance: 636},
        {type: OfferPoiType.TRAM, name: "Winnica 71", distance: 643},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 05", distance: 708},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 713},
        {type: OfferPoiType.BUS, name: "Poetów 01", distance: 722},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 06", distance: 743},
        {type: OfferPoiType.BUS, name: "Grzymalitów 01", distance: 786},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 870},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1893},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 1939}
    ],
    16388: [
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 326},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 02", distance: 426},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 01", distance: 434},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 483},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 04", distance: 502},
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 547},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 609},
        {type: OfferPoiType.BUS, name: "Chełmska 01", distance: 652},
        {type: OfferPoiType.BUS, name: "Chełmska 05", distance: 799},
        {type: OfferPoiType.BUS, name: "Chełmska 03", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 1412},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1477},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1746},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1754},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1974},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 2065},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 2216},
        {type: OfferPoiType.PARK, name: "Skwer Ormiański", distance: 2225},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2302}
    ],
    16394: [
        {type: OfferPoiType.TRAM, name: "Śliwice 03", distance: 124},
        {type: OfferPoiType.TRAM, name: "Śliwice 04", distance: 216},
        {type: OfferPoiType.BUS, name: "Śliwice 01", distance: 217},
        {type: OfferPoiType.BUS, name: "Śliwice 02", distance: 282},
        {type: OfferPoiType.TRAM, name: "Budzińskiej-Tylickiej 03", distance: 543},
        {type: OfferPoiType.BUS, name: "Budzińskiej-Tylickiej 01", distance: 566},
        {type: OfferPoiType.TRAM, name: "Budzińskiej-Tylickiej 04", distance: 577},
        {type: OfferPoiType.BUS, name: "Budzińskiej-Tylickiej 02", distance: 594},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 02", distance: 637},
        {type: OfferPoiType.TRAM, name: "Batalionu Platerówek 01", distance: 673},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 53", distance: 681},
        {type: OfferPoiType.BUS, name: "Batalionu Platerówek 54", distance: 684}
    ],
    16399: [
        {type: OfferPoiType.TRAM, name: "Oś Królewska 05", distance: 662},
        {type: OfferPoiType.BUS, name: "Oś Królewska 01", distance: 669},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 06", distance: 672},
        {type: OfferPoiType.BUS, name: "Oś Królewska 02", distance: 723},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1084},
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 1274},
        {type: OfferPoiType.PARK, name: "Park Rozkosz", distance: 1624},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1648},
        {type: OfferPoiType.PARK, name: "Ogród Tarasowy", distance: 1687}
    ],
    16403: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 102},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 105},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 120},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 250},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 343},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 487},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Żupnicza 01", distance: 570},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 581},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 978},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1231},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1369},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1526},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1586},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1903},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2045},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2068},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2074}
    ],
    16407: [
        {type: OfferPoiType.BUS, name: "Poświęcka", distance: 420},
        {type: OfferPoiType.BUS, name: "Poświęcka (Ośrodek zdrowia)", distance: 584},
        {type: OfferPoiType.BUS, name: "Żmigrodzka (Obwodnica)", distance: 640},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 790},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1849}
    ],
    16409: [
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 108},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 131},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 145},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 232},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 262},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 275},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 281},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 330},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 331},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 374},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 603},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 638},
        {type: OfferPoiType.TRAM, name: "Hubego 03", distance: 724},
        {type: OfferPoiType.BUS, name: "Hubego 02", distance: 749},
        {type: OfferPoiType.BUS, name: "Katarzynka PKP nż. 01", distance: 756},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 757},
        {type: OfferPoiType.TRAM, name: "Hubego 04", distance: 781},
        {type: OfferPoiType.BUS, name: "Hubego 01", distance: 790},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1609},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1907}
    ],
    16411: [
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Woskowa NŻ", distance: 226},
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Wypoczynkowa NŻ", distance: 246},
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Warszawska", distance: 617},
        {type: OfferPoiType.LAS, name: "Park Stefana Rogowicza - Zielona Ostoja", distance: 656},
        {type: OfferPoiType.BUS, name: "Warszawska - Wycieczkowa", distance: 687},
        {type: OfferPoiType.BUS, name: "Marysin Warszawska", distance: 729},
        {type: OfferPoiType.BUS, name: "Marysin Tęczowa", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1837},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 2384}
    ],
    16421: [
        {type: OfferPoiType.TRAM, name: "Żwirki - Piotrkowska", distance: 253},
        {type: OfferPoiType.BUS, name: "Kościuszki - Radwańska", distance: 300},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Żwirki", distance: 323},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Żwirki", distance: 323},
        {type: OfferPoiType.BUS, name: "Radwańska - Wólczańska", distance: 404},
        {type: OfferPoiType.BUS, name: "Kościuszki - Mickiewicza", distance: 427},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Mickiewicza", distance: 483},
        {type: OfferPoiType.BUS, name: "Mickiewicza - Kościuszki", distance: 496},
        {type: OfferPoiType.BUS, name: "Wólczańska - Radwańska", distance: 508},
        {type: OfferPoiType.TRAM, name: "Piotrkowska Centrum", distance: 558},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Brzeźna", distance: 586},
        {type: OfferPoiType.PARK, name: "Skwer im. Lecha Kunki", distance: 892},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1012},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1045}
    ],
    16423: [
        {type: OfferPoiType.TRAM, name: "Oś Królewska 05", distance: 642},
        {type: OfferPoiType.BUS, name: "Oś Królewska 01", distance: 649},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 06", distance: 652},
        {type: OfferPoiType.BUS, name: "Oś Królewska 02", distance: 703},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1064},
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 1254},
        {type: OfferPoiType.PARK, name: "Park Rozkosz", distance: 1604},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1628},
        {type: OfferPoiType.PARK, name: "Ogród Tarasowy", distance: 1667}
    ],
    16435: [
        {type: OfferPoiType.BUS, name: "Piaski Nowe 03", distance: 522},
        {type: OfferPoiType.BUS, name: "Piaski Nowe", distance: 530},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 02", distance: 536},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 01", distance: 544},
        {type: OfferPoiType.BUS, name: "Bochenka 02", distance: 585},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 595},
        {type: OfferPoiType.BUS, name: "Bochenka 01", distance: 599},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 802},
        {type: OfferPoiType.BUS, name: "Nowosądecka 05", distance: 814},
        {type: OfferPoiType.BUS, name: "Łużycka 02", distance: 816},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1098},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 1473},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1794},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1814},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 2175}
    ],
    16445: [
        {type: OfferPoiType.BUS, name: "Tamka - Styrska NŻ", distance: 652},
        {type: OfferPoiType.TRAM, name: "Pomorska - Lumumby (kampus UŁ)", distance: 734},
        {type: OfferPoiType.BUS, name: "Pomorska - Konstytucyjna", distance: 768},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1531},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 1531},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1604},
        {type: OfferPoiType.PARK, name: "Park im. 3 Maja", distance: 1939},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1960},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 2052},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 2177},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 2356},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 2416}
    ],
    16447: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 389},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 425},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 457},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 519},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 525},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 642},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Ojca Aniceta 01", distance: 739},
        {type: OfferPoiType.BUS, name: "Danusi 01", distance: 778},
        {type: OfferPoiType.BUS, name: "Gryfitów 02", distance: 802},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1459},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2121},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2518}
    ],
    16449: [
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 01", distance: 543},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 02", distance: 561},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 04", distance: 569},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 03", distance: 595},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 05", distance: 596},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 04", distance: 623},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 01", distance: 658},
        {type: OfferPoiType.TRAM, name: "Kobierzyńska 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 03", distance: 700},
        {type: OfferPoiType.TRAM, name: "Lipińskiego 01", distance: 833},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 1469},
        {type: OfferPoiType.PARK, name: "Park Zakrzówek", distance: 1527},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1579},
        {type: OfferPoiType.PARK, name: "Park rzeczny Wilgi", distance: 1787},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 1951},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 1994}
    ],
    16454: [
        {type: OfferPoiType.BUS, name: "Bolszewo Graniczna 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Bolszewo Leśna - Szkoła 02", distance: 542},
        {type: OfferPoiType.BUS, name: "Bolszewo Leśna - Szkoła 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Bolszewo Graniczna 02", distance: 550},
        {type: OfferPoiType.BUS, name: "Bolszewo Harcerska 02 n/ż", distance: 673},
        {type: OfferPoiType.BUS, name: "Bolszewo Harcerska 01 n/ż", distance: 726},
        {type: OfferPoiType.PARK, name: "ArtPark w Bolszewie", distance: 1120}
    ],
    16455: [
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 700},
        {type: OfferPoiType.BUS, name: "3 Maja 02", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 1018},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1031},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1062}
    ],
    16459: [
        {type: OfferPoiType.BUS, name: "Dziwnów - Wybreże Kościuszkowskie - Słoneczna", distance: 599},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1968}
    ],
    16460: [{type: OfferPoiType.BUS, name: "Kościelisko Chotarz Polany", distance: 596}],
    16465: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 201},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 274},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 331},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 422},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 427},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 453},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 637},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 795},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 870},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 914}
    ],
    16467: [
        {type: OfferPoiType.BUS, name: "Dziedzicka", distance: 308},
        {type: OfferPoiType.BUS, name: "Żeglarska n/ż", distance: 459},
        {type: OfferPoiType.BUS, name: "Kotwicza n/ż", distance: 516},
        {type: OfferPoiType.BUS, name: "Starołęcka Wiadukt n/ż", distance: 662}
    ],
    16469: [
        {type: OfferPoiType.BUS, name: "Conrada 01", distance: 221},
        {type: OfferPoiType.BUS, name: "Conrada 02", distance: 388},
        {type: OfferPoiType.BUS, name: "Chełmońskiego 02", distance: 509},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 520},
        {type: OfferPoiType.BUS, name: "Różyckiego 04", distance: 640},
        {type: OfferPoiType.BUS, name: "Azory", distance: 683},
        {type: OfferPoiType.BUS, name: "Różyckiego 02", distance: 694},
        {type: OfferPoiType.BUS, name: "Fiszera 02", distance: 705},
        {type: OfferPoiType.BUS, name: "Azory 01", distance: 728},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1216},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1441},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1919},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1978},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 2156},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 2312}
    ],
    16470: [{type: OfferPoiType.PARK, name: "Plac Konstytucji 3 Maja", distance: 495}],
    16471: [
        {type: OfferPoiType.BUS, name: "Budziwojska / Herbowa 02", distance: 110},
        {type: OfferPoiType.BUS, name: "Tyczyn Orkana stawy 14", distance: 140},
        {type: OfferPoiType.BUS, name: "Tyczyn Orkana skrzyżowanie 16", distance: 462},
        {type: OfferPoiType.BUS, name: "Tyczyn Orkana skrzyżowanie 13", distance: 535},
        {type: OfferPoiType.BUS, name: "Budziwojska / Legionistów 04", distance: 633},
        {type: OfferPoiType.BUS, name: "Tyczyn Grunwaldzka park 02", distance: 751},
        {type: OfferPoiType.BUS, name: "Budziwojska / Legionistów 01", distance: 764},
        {type: OfferPoiType.BUS, name: "Tyczyn Grunwaldzka park 01", distance: 830},
        {type: OfferPoiType.BUS, name: "Tyczyn Armii Krajowej skrzyżowanie 25", distance: 841}
    ],
    16478: [
        {type: OfferPoiType.PARK, name: "Skwer leśny przy Odrzańskiej", distance: 122},
        {type: OfferPoiType.BUS, name: "Starogardzka - Odrzańska", distance: 379},
        {type: OfferPoiType.BUS, name: "Dubois - Hoffmanowej NŻ", distance: 526},
        {type: OfferPoiType.BUS, name: "Pabianicka - Rudzka", distance: 658},
        {type: OfferPoiType.BUS, name: "Rudzka - Pabianicka", distance: 733},
        {type: OfferPoiType.TRAM, name: "Pabianicka - Rudzka", distance: 747},
        {type: OfferPoiType.BUS, name: "Rudzka - Pabianicka NŻ", distance: 757},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy nad Nerem”", distance: 1876},
        {type: OfferPoiType.PARK, name: "Rudzka Góra", distance: 1965}
    ],
    16479: [
        {type: OfferPoiType.BUS, name: "Owińska/Parkowa", distance: 535},
        {type: OfferPoiType.BUS, name: "Owińska/Pałac", distance: 684},
        {type: OfferPoiType.PARK, name: "Park Orientacji Przestrzennej", distance: 895}
    ],
    16480: [
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 214},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 446},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 450},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 490},
        {type: OfferPoiType.BUS, name: "Niezłomnych", distance: 500},
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 514},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 524},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 590},
        {type: OfferPoiType.TRAM, name: "Aleje Marcinkowskiego", distance: 603},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 637},
        {type: OfferPoiType.BUS, name: "Uniwersytet Ekonomiczny", distance: 652},
        {type: OfferPoiType.TRAM, name: "Wierzbięcice", distance: 672},
        {type: OfferPoiType.BUS, name: "Poznań Główny", distance: 679},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 685},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 754},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 791},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 946},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 988},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1004},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1181},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1303},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1447}
    ],
    16482: [
        {type: OfferPoiType.BUS, name: "Termy Maltańskie", distance: 50},
        {type: OfferPoiType.KOLEJ, name: "Balbinka", distance: 152},
        {type: OfferPoiType.KOLEJ, name: "Ptyś", distance: 212},
        {type: OfferPoiType.BUS, name: "Czekalskie n/ż", distance: 559},
        {type: OfferPoiType.BUS, name: "Termalna n/ż", distance: 693},
        {type: OfferPoiType.TRAM, name: "Termalna", distance: 700},
        {type: OfferPoiType.TRAM, name: "Krańcowa", distance: 747},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 887},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 1887}
    ],
    16484: [
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej (szkoła)", distance: 128},
        {type: OfferPoiType.BUS, name: "Skwer Krasińskiego", distance: 191},
        {type: OfferPoiType.TRAM, name: "Komuny Paryskiej", distance: 220},
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej", distance: 238},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 377},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 424},
        {type: OfferPoiType.BUS, name: "Kościuszki", distance: 433},
        {type: OfferPoiType.BUS, name: "Plac Wróblewskiego", distance: 484},
        {type: OfferPoiType.BUS, name: "Bastion Sakwowy", distance: 505},
        {type: OfferPoiType.TRAM, name: "Plac Wróblewskiego", distance: 569},
        {type: OfferPoiType.TRAM, name: "Bastion Sakwowy", distance: 586},
        {type: OfferPoiType.TRAM, name: "Park Staromiejski", distance: 706},
        {type: OfferPoiType.TRAM, name: "Pułaskiego", distance: 710},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 864},
        {type: OfferPoiType.PARK, name: "Ogród Staromiejski", distance: 911},
        {type: OfferPoiType.PARK, name: "Park Juliusza Słowackiego", distance: 1128},
        {type: OfferPoiType.PARK, name: "skwer Wrocławianek", distance: 1155},
        {type: OfferPoiType.PARK, name: "skwer Czesława Niemena", distance: 1205},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1241},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1271}
    ],
    16485: [
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 235},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 287},
        {type: OfferPoiType.BUS, name: "Bokserska 01", distance: 439},
        {type: OfferPoiType.BUS, name: "Bokserska 05", distance: 468},
        {type: OfferPoiType.BUS, name: "Bokserska 04", distance: 532},
        {type: OfferPoiType.BUS, name: "Bokserska 03", distance: 563},
        {type: OfferPoiType.BUS, name: "Bokserska 02", distance: 588},
        {type: OfferPoiType.BUS, name: "Bokserska 71", distance: 604},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 670},
        {type: OfferPoiType.BUS, name: "Centrum Targowe 02", distance: 778},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1176},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 1834},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 2370}
    ],
    16487: [
        {type: OfferPoiType.BUS, name: "Ogród działkowy Im. Warneńczyka 02", distance: 55},
        {type: OfferPoiType.BUS, name: "Ogród działkowy Im. Warneńczyka 01", distance: 111},
        {type: OfferPoiType.BUS, name: "Okęcie Business Park 02", distance: 308},
        {type: OfferPoiType.BUS, name: "Krakowiaków 06", distance: 394},
        {type: OfferPoiType.BUS, name: "Okęcie Business Park 01", distance: 442},
        {type: OfferPoiType.BUS, name: "Krakowiaków 05", distance: 444},
        {type: OfferPoiType.BUS, name: "Radarowa 01", distance: 457},
        {type: OfferPoiType.TRAM, name: "Krakowiaków 04", distance: 478},
        {type: OfferPoiType.TRAM, name: "Krakowiaków 03", distance: 498},
        {type: OfferPoiType.BUS, name: "Radarowa 02", distance: 503},
        {type: OfferPoiType.TRAM, name: "Lipowczana 01", distance: 796},
        {type: OfferPoiType.TRAM, name: "Lipowczana 02", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 1647}
    ],
    16498: [
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 48},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 213},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 357},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 469},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 524},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1840}
    ],
    16500: [
        {type: OfferPoiType.BUS, name: "Dojazdowa", distance: 304},
        {type: OfferPoiType.BUS, name: "Zagórskiego", distance: 523},
        {type: OfferPoiType.BUS, name: "Kolonistów", distance: 660},
        {type: OfferPoiType.BUS, name: "Szosa Polska", distance: 779},
        {type: OfferPoiType.BUS, name: "Zagórskiego 10 nż", distance: 810},
        {type: OfferPoiType.REZERWAT, name: "Dolina strumienia Grzęziniec", distance: 2178},
        {type: OfferPoiType.PARK, name: "Park ks. Dąbrówki", distance: 2465}
    ],
    16503: [
        {type: OfferPoiType.BUS, name: "Prystora 01", distance: 239},
        {type: OfferPoiType.BUS, name: "Prystora 02", distance: 247},
        {type: OfferPoiType.BUS, name: "Prystora 03", distance: 258},
        {type: OfferPoiType.BUS, name: "Żywiecka 03", distance: 298},
        {type: OfferPoiType.BUS, name: "Żywiecka 02", distance: 341},
        {type: OfferPoiType.BUS, name: "Żywiecka 01", distance: 365},
        {type: OfferPoiType.BUS, name: "Żywiecka 04", distance: 386},
        {type: OfferPoiType.BUS, name: "Dzieci Warszawy 02", distance: 521},
        {type: OfferPoiType.BUS, name: "Salomea 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Składkowskiego 04", distance: 616},
        {type: OfferPoiType.KOLEJ, name: "Opacz", distance: 820},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 1453},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1541},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 2078},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 2152},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 2326},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2413}
    ],
    16504: [
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 585},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 939},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1434},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 2254},
        {type: OfferPoiType.PARK, name: "Górki Służewskie", distance: 2360},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 2380},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2385}
    ],
    16514: [
        {type: OfferPoiType.BUS, name: "Pogorzelica Wojska Polskiego", distance: 355},
        {type: OfferPoiType.LAS, name: "Enea", distance: 633},
        {type: OfferPoiType.REZERWAT, name: "Liwskie Ujście", distance: 1448}
    ],
    16518: [
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 02", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 962},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 1118},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1131}
    ],
    16520: [
        {type: OfferPoiType.BUS, name: "Piastowska 01", distance: 323},
        {type: OfferPoiType.BUS, name: "Piastowska 03", distance: 341},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Owcy-Orwicza 02", distance: 541},
        {type: OfferPoiType.BUS, name: "Piastowska 02", distance: 563},
        {type: OfferPoiType.BUS, name: "Tondosa 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 03", distance: 667},
        {type: OfferPoiType.TRAM, name: "Cichy Kącik 01", distance: 679},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 75", distance: 684},
        {type: OfferPoiType.BUS, name: "Cichy Kącik 72", distance: 687},
        {type: OfferPoiType.BUS, name: "Tondosa 02", distance: 695},
        {type: OfferPoiType.PARK, name: "Skwer Papcia Chmiela", distance: 925},
        {type: OfferPoiType.PARK, name: "Park Fort 2 „Kościuszko” imienia Profesora Janusza Bogdanowskiego", distance: 1041},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1274},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1642},
        {type: OfferPoiType.PARK, name: "Skwer Olgi Jackowskiej „Kory”", distance: 1688},
        {type: OfferPoiType.PARK, name: "Skwer imienia Gustawa Holoubka", distance: 1758},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2512}
    ],
    16528: [
        {type: OfferPoiType.BUS, name: "Zakopiańska", distance: 228},
        {type: OfferPoiType.TRAM, name: "Skrajna", distance: 283},
        {type: OfferPoiType.TRAM, name: "Zakopiańska", distance: 307},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 371},
        {type: OfferPoiType.BUS, name: "Siedlce 06", distance: 674},
        {type: OfferPoiType.BUS, name: "Nad Jarem 01", distance: 676},
        {type: OfferPoiType.BUS, name: "Siedlce 05", distance: 699},
        {type: OfferPoiType.TRAM, name: "Siedlce 03", distance: 702},
        {type: OfferPoiType.TRAM, name: "Siedlce 01", distance: 702},
        {type: OfferPoiType.BUS, name: "Siedlce 04", distance: 709},
        {type: OfferPoiType.TRAM, name: "Siedlce 02", distance: 719},
        {type: OfferPoiType.TRAM, name: "Ciasna", distance: 727},
        {type: OfferPoiType.PARK, name: "Skwer im. Ignacego Wilczewskiego", distance: 1181},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Bema", distance: 1285},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1598},
        {type: OfferPoiType.PARK, name: "Kalwaria", distance: 1756},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1820},
        {type: OfferPoiType.PARK, name: "Park poforteczny „Grodzisko”", distance: 1995},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2299},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2402}
    ],
    16535: [
        {type: OfferPoiType.BUS, name: "Snopków - osiedle 02", distance: 464},
        {type: OfferPoiType.BUS, name: "Snopków II 01", distance: 849}
    ],
    16538: [
        {type: OfferPoiType.BUS, name: "Swarzędz Skansen", distance: 548},
        {type: OfferPoiType.BUS, name: "Swarzędz Węzeł Przesiadkowy", distance: 581},
        {type: OfferPoiType.BUS, name: "Swarzędz Dworzec PKP", distance: 733},
        {type: OfferPoiType.KOLEJ, name: "Swarzędz", distance: 829},
        {type: OfferPoiType.REZERWAT, name: "Dolina Cybiny w Poznaniu", distance: 2035}
    ],
    16539: [
        {type: OfferPoiType.BUS, name: "Kościelna Droga 01", distance: 163},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 02", distance: 305},
        {type: OfferPoiType.BUS, name: "Łużycka  02", distance: 473},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 507},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 01", distance: 653},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 02", distance: 763},
        {type: OfferPoiType.BUS, name: "Brzegowa 01", distance: 787}
    ],
    16540: [
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 02", distance: 284},
        {type: OfferPoiType.BUS, name: "Kosodrzewiny 01", distance: 294},
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 01", distance: 325},
        {type: OfferPoiType.BUS, name: "Falenica 02", distance: 464},
        {type: OfferPoiType.BUS, name: "Falenica 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Falenica 03", distance: 540},
        {type: OfferPoiType.BUS, name: "Falenica 04", distance: 550},
        {type: OfferPoiType.BUS, name: "Jachowicza 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Liliowa 02", distance: 732},
        {type: OfferPoiType.BUS, name: "Liliowa 04", distance: 792},
        {type: OfferPoiType.PARK, name: "Polanka", distance: 2032}
    ],
    16546: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 197},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 337},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 416},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 444},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 477},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 484},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 496},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 585},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 797},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 971}
    ],
    16548: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 106},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 139},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 432},
        {type: OfferPoiType.TRAM, name: "Serbska", distance: 492},
        {type: OfferPoiType.BUS, name: "Wilczy Młyn", distance: 555},
        {type: OfferPoiType.BUS, name: "Lechicka/Naramowicka", distance: 557},
        {type: OfferPoiType.TRAM, name: "Lechicka/Naramowicka", distance: 581},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 921},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1050},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1358},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1809},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1921},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 2200},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2233},
        {type: OfferPoiType.PARK, name: "Park Cytadela", distance: 2327}
    ],
    16549: [
        {type: OfferPoiType.BUS, name: "Dziwnów Wybrzeże Kościuszkowskie", distance: 407},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 543},
        {type: OfferPoiType.BUS, name: "Dzwinów - Słowackiego (Camping)", distance: 786}
    ],
    16553: [
        {type: OfferPoiType.BUS, name: "Krzeptów - Boisko", distance: 443},
        {type: OfferPoiType.BUS, name: "Krzeptów - pętla", distance: 470},
        {type: OfferPoiType.BUS, name: "Krzeptów - skrzy.", distance: 828}
    ],
    16558: [
        {type: OfferPoiType.BUS, name: "Gdańska - Zielona", distance: 216},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 222},
        {type: OfferPoiType.BUS, name: "Zielona - Gdańska", distance: 274},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 346},
        {type: OfferPoiType.BUS, name: "Gdańska - Struga", distance: 381},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 382},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 397},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 413},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 433},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 447},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 460},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 500},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 558},
        {type: OfferPoiType.TRAM, name: "Gdańska - 1 Maja", distance: 591},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 605},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 709},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 718},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 793},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 913}
    ],
    16562: [
        {type: OfferPoiType.BUS, name: "Ziębicka n/ż", distance: 139},
        {type: OfferPoiType.BUS, name: "Ziębicka Kościół n/ż", distance: 160},
        {type: OfferPoiType.BUS, name: "Wieruszowska n/ż", distance: 497},
        {type: OfferPoiType.BUS, name: "Grotkowska", distance: 526},
        {type: OfferPoiType.BUS, name: "Cmentarna", distance: 572},
        {type: OfferPoiType.TRAM, name: "Grotkowska", distance: 586},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 709},
        {type: OfferPoiType.TRAM, name: "Cmentarna", distance: 709},
        {type: OfferPoiType.BUS, name: "Cmentarna n/ż", distance: 726},
        {type: OfferPoiType.BUS, name: "Budziszyńska", distance: 828},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 1864},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 2068}
    ],
    16564: [
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 128},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 168},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 275},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 331},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 552},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 565},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 644},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 671},
        {type: OfferPoiType.BUS, name: "Powstańców Magazyny 01", distance: 766},
        {type: OfferPoiType.BUS, name: "Powstańców Magazyny 02", distance: 841},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1472},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1473}
    ],
    16568: [
        {type: OfferPoiType.BUS, name: "Jurowiecka/Ciepła", distance: 130},
        {type: OfferPoiType.BUS, name: "Jurowiecka/Sienkiewicza", distance: 158},
        {type: OfferPoiType.PARK, name: "Skwery Tamary Sołoniewicz", distance: 197},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego/Rzeka Biała", distance: 302},
        {type: OfferPoiType.BUS, name: "Sienkiewicza/Rzeka Biała", distance: 305},
        {type: OfferPoiType.BUS, name: "Sienkiewicza/Ogrodowa", distance: 377},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Stanisława Hałko", distance: 399},
        {type: OfferPoiType.BUS, name: "Jurowiecka/Sklep Łowiecki", distance: 459},
        {type: OfferPoiType.PARK, name: "Bulwary Ireny Sendlerowej", distance: 553},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Aleksandra Chodyki", distance: 597},
        {type: OfferPoiType.PARK, name: "Skwer Armii Krajowej", distance: 703},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 983},
        {type: OfferPoiType.PARK, name: "Park Stary im. Księcia Józefa Poniatowskiego", distance: 1027},
        {type: OfferPoiType.PARK, name: "Plac Błogosławionego Księdza Michała Sopoćki", distance: 1128},
        {type: OfferPoiType.PARK, name: "Plac Mordechaja Tenenbauma", distance: 1174}
    ],
    16569: [
        {type: OfferPoiType.BUS, name: "Wianki 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Wianki 01", distance: 218},
        {type: OfferPoiType.PARK, name: "Park Na Skarpie", distance: 470},
        {type: OfferPoiType.BUS, name: "Turystyczna nż. 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Turystyczna nż. 01", distance: 581},
        {type: OfferPoiType.TRAM, name: "Ślaskiego 01", distance: 716},
        {type: OfferPoiType.BUS, name: "Ślaskiego 04", distance: 719},
        {type: OfferPoiType.TRAM, name: "Ślaskiego 03", distance: 742},
        {type: OfferPoiType.BUS, name: "Ślaskiego 02", distance: 755},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego 01", distance: 815},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego 02", distance: 826},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego 03", distance: 829},
        {type: OfferPoiType.BUS, name: "Wieżowa nż. 02", distance: 840},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 1719},
        {type: OfferPoiType.PARK, name: "Park na Bielawach", distance: 2080},
        {type: OfferPoiType.REZERWAT, name: "Dąbrowa w Kaszczorku", distance: 2104}
    ],
    16575: [
        {type: OfferPoiType.BUS, name: "Budapesztańska", distance: 210},
        {type: OfferPoiType.TRAM, name: "Budapesztańska", distance: 265},
        {type: OfferPoiType.BUS, name: "Migowo", distance: 540},
        {type: OfferPoiType.BUS, name: "Kolumba 04", distance: 569},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 569},
        {type: OfferPoiType.TRAM, name: "Warneńska 02", distance: 575},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 586},
        {type: OfferPoiType.BUS, name: "Warneńska 04", distance: 606},
        {type: OfferPoiType.BUS, name: "Kolumba 03", distance: 610},
        {type: OfferPoiType.TRAM, name: "Migowo", distance: 621},
        {type: OfferPoiType.TRAM, name: "Warneńska 01", distance: 622},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 664},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 669},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 902},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 1045},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1067},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1399},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 1838},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 2300}
    ],
    16577: [
        {type: OfferPoiType.BUS, name: "Rechniewskiego 01", distance: 239},
        {type: OfferPoiType.BUS, name: "Rechniewskiego 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ostrobramska 03", distance: 641},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ostrobramska 02", distance: 693},
        {type: OfferPoiType.PARK, name: "Park/Ogród przy Kościele", distance: 709},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1723},
        {type: OfferPoiType.PARK, name: "Park Nad Balatonem", distance: 1739},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1760},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 1896},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 2028},
        {type: OfferPoiType.PARK, name: "Ogród na Meissnera", distance: 2156},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 2330}
    ],
    16585: [
        {type: OfferPoiType.BUS, name: "Północna - Kamińskiego", distance: 173},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 386},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 481},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 510},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 616},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 622},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 638},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 660},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 688},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 763},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 786},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1096},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1149},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1290},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 1319}
    ],
    16592: [
        {type: OfferPoiType.BUS, name: 'Polna "Krystynka"', distance: 336},
        {type: OfferPoiType.BUS, name: "Osiedle Związkowców", distance: 383},
        {type: OfferPoiType.BUS, name: "Ciechocinek Zdrojowa/Łąkowa", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Sosnowy", distance: 999},
        {type: OfferPoiType.PARK, name: "Partery Hellwiga", distance: 1132},
        {type: OfferPoiType.REZERWAT, name: "Otoczenie źródła solanki nr 11", distance: 1473}
    ],
    16596: [
        {type: OfferPoiType.BUS, name: "Maczka - Pienista NŻ", distance: 202},
        {type: OfferPoiType.BUS, name: "Pienista - Komandorska", distance: 315},
        {type: OfferPoiType.BUS, name: "Maczka - Aeroklub NŻ", distance: 713},
        {type: OfferPoiType.BUS, name: "Pienista - Rusałki NŻ", distance: 836},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1697}
    ],
    16605: [
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 01", distance: 127},
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 02", distance: 187},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 01", distance: 205},
        {type: OfferPoiType.BUS, name: "Startowa 03", distance: 274},
        {type: OfferPoiType.TRAM, name: "Startowa 01", distance: 369},
        {type: OfferPoiType.BUS, name: "Dywizjonu 303 01", distance: 374},
        {type: OfferPoiType.TRAM, name: "Startowa 02", distance: 416},
        {type: OfferPoiType.BUS, name: "Pilotów 01", distance: 472},
        {type: OfferPoiType.BUS, name: "Startowa 04", distance: 484},
        {type: OfferPoiType.BUS, name: "Żwirki i Wigury 03", distance: 503},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 01", distance: 519},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 556},
        {type: OfferPoiType.BUS, name: "Leszczyńskich 02", distance: 560},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 02", distance: 567},
        {type: OfferPoiType.TRAM, name: "Zaspa 04", distance: 621},
        {type: OfferPoiType.TRAM, name: "Zaspa 02", distance: 621},
        {type: OfferPoiType.TRAM, name: "Zaspa 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Leszczyńskich 03", distance: 679},
        {type: OfferPoiType.BUS, name: "Leszczyńskich 01", distance: 713},
        {type: OfferPoiType.TRAM, name: "Zaspa 03", distance: 724}
    ],
    16622: [
        {type: OfferPoiType.BUS, name: "Gliwice Cmentarz Centralny", distance: 546},
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Ordona", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 1248},
        {type: OfferPoiType.PARK, name: "Park Starokozielski", distance: 1535},
        {type: OfferPoiType.PARK, name: "Skwer Kežmarok", distance: 1591}
    ],
    16629: [
        {type: OfferPoiType.TRAM, name: "Wzgórze Wolności", distance: 151},
        {type: OfferPoiType.BUS, name: "Wzgórze Wolności", distance: 170},
        {type: OfferPoiType.BUS, name: "Rondo Kujawskie P+R", distance: 385},
        {type: OfferPoiType.BUS, name: "Trasa Uniwersytecka / Ujejskiego", distance: 432},
        {type: OfferPoiType.TRAM, name: "Rondo Kujawskie P+R", distance: 526},
        {type: OfferPoiType.TRAM, name: "Woj.Polskiego / Ujejskiego", distance: 628},
        {type: OfferPoiType.TRAM, name: "Rondo Kujawskie P+R (nieczynny)", distance: 638},
        {type: OfferPoiType.BUS, name: "Woj.Polskiego / Ujejskiego", distance: 640},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 756},
        {type: OfferPoiType.PARK, name: "Skwer im. Alojzego Bukolta", distance: 1264}
    ],
    16632: [
        {type: OfferPoiType.BUS, name: "Darwina 02", distance: 144},
        {type: OfferPoiType.BUS, name: "Szymanowskiego 01", distance: 249},
        {type: OfferPoiType.BUS, name: "Namysłowska 02", distance: 508},
        {type: OfferPoiType.TRAM, name: "Namysłowska 03", distance: 517},
        {type: OfferPoiType.TRAM, name: "Namysłowska 04", distance: 543},
        {type: OfferPoiType.BUS, name: "Namysłowska 01", distance: 553},
        {type: OfferPoiType.BUS, name: "Plac Hallera 07", distance: 589},
        {type: OfferPoiType.BUS, name: "Harnasie 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Plac Hallera 08", distance: 612},
        {type: OfferPoiType.BUS, name: "Strzelecka 02", distance: 652},
        {type: OfferPoiType.TRAM, name: "Bródnowska 01", distance: 661},
        {type: OfferPoiType.BUS, name: "Bródnowska 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Bródnowska 02", distance: 698},
        {type: OfferPoiType.TRAM, name: "Bródnowska 02", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 749},
        {type: OfferPoiType.TRAM, name: "Konopacka 01", distance: 803},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1703},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1818},
        {type: OfferPoiType.PARK, name: "Skwer Kępna-Jagiellońska", distance: 2266},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 2379},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 2421}
    ],
    16642: [
        {type: OfferPoiType.BUS, name: "CH Ursynów 03", distance: 182},
        {type: OfferPoiType.BUS, name: "Makolągwy 01", distance: 281},
        {type: OfferPoiType.BUS, name: "Makolągwy 02", distance: 302},
        {type: OfferPoiType.BUS, name: "CH Ursynów 02", distance: 352},
        {type: OfferPoiType.BUS, name: "CH Ursynów 01", distance: 353},
        {type: OfferPoiType.BUS, name: "Indiry Gandhi 03", distance: 468},
        {type: OfferPoiType.BUS, name: "Instytut Hematologii 02", distance: 513},
        {type: OfferPoiType.BUS, name: "CH Ursynów 04", distance: 515},
        {type: OfferPoiType.BUS, name: "Łukaszczyka 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Łukaszczyka 01", distance: 563},
        {type: OfferPoiType.REZERWAT, name: "Jeziorko Imielińskie - użytek 623", distance: 834},
        {type: OfferPoiType.PARK, name: "Słoneczny Jar", distance: 1205},
        {type: OfferPoiType.PARK, name: "Park im. Cichociemnych Spadochroniarzy AK", distance: 1687},
        {type: OfferPoiType.PARK, name: "Park linearny nad POW", distance: 1794},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1897},
        {type: OfferPoiType.PARK, name: "Skwer Sportów Miejskich", distance: 1938},
        {type: OfferPoiType.REZERWAT, name: "Aleja drzew", distance: 2134},
        {type: OfferPoiType.PARK, name: "Park Polskich Wynalazców", distance: 2217}
    ],
    16644: [
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 04", distance: 15},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 01", distance: 148},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 02", distance: 153},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 03", distance: 180},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 239},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Warszawska 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Czerwona Droga 02", distance: 436},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Habicha 01", distance: 556},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 01", distance: 559},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 834},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 1070},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1337}
    ],
    16660: [
        {type: OfferPoiType.BUS, name: "Dw. Północny", distance: 174},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 236},
        {type: OfferPoiType.BUS, name: "Źródłowa - Wojska Polskiego NŻ", distance: 392},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Marynarska", distance: 437},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 453},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Marynarska", distance: 462},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 476},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 497},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 558},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 562},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 620},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 621},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Franciszkańska", distance: 694},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 700},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 718},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 745},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Głowackiego", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 762},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 915}
    ],
    16667: [
        {type: OfferPoiType.BUS, name: "Reden Korczaka", distance: 492},
        {type: OfferPoiType.BUS, name: "Reden Aleja Majakowskiego", distance: 494},
        {type: OfferPoiType.BUS, name: "Reden", distance: 728},
        {type: OfferPoiType.TRAM, name: "Reden", distance: 794},
        {type: OfferPoiType.PARK, name: "Planty im. Harcmistrza Stefana Piotrowskiego", distance: 1003},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Hallera", distance: 1402},
        {type: OfferPoiType.PARK, name: "Park Podlesie", distance: 2149},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 2302},
        {type: OfferPoiType.PARK, name: "Skwer im. Antoniego Pilarza", distance: 2375},
        {type: OfferPoiType.PARK, name: "Park Śródmiejski", distance: 2445}
    ],
    16670: [
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 214},
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 306},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 358},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 371},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 421},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 440},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 475},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 528},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 574},
        {type: OfferPoiType.TRAM, name: "Piasta Kołodzieja 02", distance: 780},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 03", distance: 787},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 04", distance: 836},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1284},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1301},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 2277},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2415}
    ],
    16677: [
        {type: OfferPoiType.BUS, name: "Przyjaźni", distance: 524},
        {type: OfferPoiType.BUS, name: "Partynice – Tor Wyścigów Konnych", distance: 597},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Partynice", distance: 604},
        {type: OfferPoiType.TRAM, name: "Przyjaźni", distance: 624},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 885},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 1252},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 1669},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 1720},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1892},
        {type: OfferPoiType.PARK, name: "Park Migdałowy", distance: 2222}
    ],
    16679: [
        {type: OfferPoiType.BUS, name: "Rumia, Urząd Miasta Rumi", distance: 159},
        {type: OfferPoiType.BUS, name: "Górnicza 01 (NŻ)", distance: 403},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Górnicza 03 (NŻ)", distance: 422},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 610},
        {type: OfferPoiType.BUS, name: "Sobieskiego FUO - 01 (NŻ)", distance: 679},
        {type: OfferPoiType.KOLEJ, name: "Rumia", distance: 748},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1348},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1924},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 2076}
    ],
    16681: [
        {type: OfferPoiType.BUS, name: "Złotnicka", distance: 257},
        {type: OfferPoiType.TRAM, name: "Złotnicka", distance: 375},
        {type: OfferPoiType.BUS, name: "Wielkopolska", distance: 395},
        {type: OfferPoiType.PARK, name: "Park Literacki", distance: 622},
        {type: OfferPoiType.BUS, name: "Kamiennogórska (Ośrodek dla niewidomych)", distance: 761},
        {type: OfferPoiType.BUS, name: "Złotniki", distance: 771},
        {type: OfferPoiType.TRAM, name: "Kamiennogórska (Ośrodek dla niewidomych)", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Złotnicki", distance: 1346},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 1557},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Kobla", distance: 1973},
        {type: OfferPoiType.PARK, name: "Park Leśnicki", distance: 2254},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 2267}
    ],
    16682: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 262},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 544},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 619},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 640},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 708},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Niepodległości", distance: 746},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Niepodległości", distance: 755},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 816},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 829},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 846},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1164},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1211},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1234},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1247},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1296},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1410}
    ],
    16683: [
        {type: OfferPoiType.BUS, name: "Tymienieckiego - Sienkiewicza NŻ", distance: 248},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Tymienieckiego (Ericsson)NŻ", distance: 333},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 366},
        {type: OfferPoiType.BUS, name: "Tymienieckiego - Kilińskiego", distance: 481},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Katedralny", distance: 490},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 490},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tymienieckiego", distance: 604},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Tymienieckiego", distance: 617},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 671},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 671},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 738},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 778},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 936},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1081},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1124}
    ],
    16695: [
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 277},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 300},
        {type: OfferPoiType.BUS, name: "Krakowska", distance: 592},
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 642},
        {type: OfferPoiType.TRAM, name: "Krakowska", distance: 658},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1255},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1898},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2338}
    ],
    16696: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 68},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 155},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 174},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 285},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 366},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 378},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 428},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 456},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 485},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 509},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1013},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1146},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1251},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1562},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1936},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1938},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1950},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2143}
    ],
    16699: [
        {type: OfferPoiType.BUS, name: "Szymanów 01", distance: 7},
        {type: OfferPoiType.BUS, name: "Szymanów 03", distance: 96},
        {type: OfferPoiType.BUS, name: "Szymanów 02", distance: 96},
        {type: OfferPoiType.BUS, name: "Szymanów 04", distance: 113},
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 02", distance: 779},
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 01", distance: 796},
        {type: OfferPoiType.REZERWAT, name: "Łąki Soleckie", distance: 1915}
    ],
    16702: [
        {type: OfferPoiType.BUS, name: "Mazowiecka - Zakład Aktywności Zawodowej", distance: 75},
        {type: OfferPoiType.BUS, name: "Mazowiecka I", distance: 457},
        {type: OfferPoiType.BUS, name: "Mazowiecka przy Słonecznej", distance: 515},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wolności", distance: 688},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1598},
        {type: OfferPoiType.PARK, name: "Park Generała Jana Henryka Dąbrowskiego", distance: 1622},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 1757},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 2283}
    ],
    16704: [{type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 308}],
    16713: [
        {type: OfferPoiType.TRAM, name: "Cienista 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Cienista 03", distance: 251},
        {type: OfferPoiType.TRAM, name: "Cienista 02", distance: 264},
        {type: OfferPoiType.BUS, name: "Cienista 04", distance: 302},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 638},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 677},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 04", distance: 750},
        {type: OfferPoiType.BUS, name: "Os. Górali 02", distance: 755},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 03", distance: 768},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 02", distance: 789},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 1002},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1343},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 1445},
        {type: OfferPoiType.PARK, name: "Park Zalew Nowohucki", distance: 1641},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1667},
        {type: OfferPoiType.PARK, name: "Park wokół Dworku Jana Matejki", distance: 1694},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1714},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1825}
    ],
    16715: [
        {type: OfferPoiType.BUS, name: "Brynów Rzepakowa", distance: 306},
        {type: OfferPoiType.TRAM, name: "Brynów Centrum Przesiadkowe", distance: 721},
        {type: OfferPoiType.BUS, name: "Brynów Centrum Przesiadkowe", distance: 747},
        {type: OfferPoiType.BUS, name: "Ochojec Wapienna", distance: 829},
        {type: OfferPoiType.PARK, name: "Plac Tajnej Organizacji Nauczycielskiej", distance: 1119},
        {type: OfferPoiType.PARK, name: "Skwer księdza Waldemara Dekiela", distance: 1886},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Źródła Kłodnicy”", distance: 2194},
        {type: OfferPoiType.PARK, name: "Plac Miast Partnerskich", distance: 2406},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Szymkowiaka", distance: 2452},
        {type: OfferPoiType.PARK, name: "Plac Filipa Limańskiego", distance: 2457},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Kaczmarskiego", distance: 2462},
        {type: OfferPoiType.PARK, name: "skwer Bolesława Szabelskiego", distance: 2513}
    ],
    16717: [
        {type: OfferPoiType.BUS, name: "Mikulczyce Zwrotnicza", distance: 367},
        {type: OfferPoiType.TRAM, name: "Mikulczyce Pętla", distance: 410},
        {type: OfferPoiType.BUS, name: "Grzybowice Magazynowa", distance: 723}
    ],
    16728: [
        {type: OfferPoiType.BUS, name: "Stawowa 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Ojcowska Wągroda 01", distance: 472},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 504},
        {type: OfferPoiType.BUS, name: "Stawowa 04", distance: 517},
        {type: OfferPoiType.BUS, name: "Ojcowska Wągroda 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Ojcowska Dworek 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Ojcowska Dworek 02", distance: 729},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1553},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1960},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 2369}
    ],
    16731: [
        {type: OfferPoiType.BUS, name: "Mysłowice Staszica", distance: 57},
        {type: OfferPoiType.BUS, name: "Janów Osiedle Chopina Park", distance: 266},
        {type: OfferPoiType.BUS, name: "Mysłowice Wielka Skotnica", distance: 498},
        {type: OfferPoiType.BUS, name: "Bończyk Jastruna [nż]", distance: 528},
        {type: OfferPoiType.BUS, name: "Janów Łokietka", distance: 647},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 873},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 2050}
    ],
    16739: [
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 110},
        {type: OfferPoiType.BUS, name: "Prusa 03", distance: 132},
        {type: OfferPoiType.BUS, name: "Prusa 01", distance: 262},
        {type: OfferPoiType.BUS, name: "Czwartek 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Probostwo 02", distance: 494},
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Jaczewskiego 02", distance: 528},
        {type: OfferPoiType.BUS, name: "Jaczewskiego 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Szeligowskiego NŻ 01", distance: 563},
        {type: OfferPoiType.BUS, name: "Probostwo 01", distance: 570},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 847},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 881}
    ],
    16742: [
        {type: OfferPoiType.BUS, name: "Zagórze Technikum", distance: 606},
        {type: OfferPoiType.BUS, name: "Zagórze Centrum", distance: 649},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 744},
        {type: OfferPoiType.BUS, name: "Zagórze Dmowskiego", distance: 760},
        {type: OfferPoiType.LAS, name: "Kamionki", distance: 1174},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 1552},
        {type: OfferPoiType.PARK, name: "Plac im. Braci Kożuchów", distance: 2324},
        {type: OfferPoiType.PARK, name: "Park Środula", distance: 2367}
    ],
    16744: [
        {type: OfferPoiType.BUS, name: "Zagórze Technikum", distance: 611},
        {type: OfferPoiType.BUS, name: "Zagórze Centrum", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 749},
        {type: OfferPoiType.BUS, name: "Zagórze Dmowskiego", distance: 765},
        {type: OfferPoiType.LAS, name: "Kamionki", distance: 1179},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 1557},
        {type: OfferPoiType.PARK, name: "Plac im. Braci Kożuchów", distance: 2329},
        {type: OfferPoiType.PARK, name: "Park Środula", distance: 2372}
    ],
    16748: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 441},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 477},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 509},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 571},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 577},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 586},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 602},
        {type: OfferPoiType.BUS, name: "Ojca Aniceta 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Danusi 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1403},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2173}
    ],
    16749: [
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 305},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 309},
        {type: OfferPoiType.BUS, name: "Pl. Szoslanda - EC1 Centrum Nauki i Techniki", distance: 314},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 322},
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 409},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 489},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 495},
        {type: OfferPoiType.BUS, name: "Narutowicza - Pl. Dąbrowskiego", distance: 498},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 511},
        {type: OfferPoiType.BUS, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 519},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 641},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 663},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 824},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 843},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 915},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 1021},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 1086}
    ],
    16752: [
        {type: OfferPoiType.BUS, name: "Obywatelska - Cieszkowskiego NŻ", distance: 188},
        {type: OfferPoiType.BUS, name: "Obywatelska - Jana Pawła II", distance: 256},
        {type: OfferPoiType.BUS, name: "Obywatelska - Cieszkowskiego", distance: 288},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Obywatelska", distance: 373},
        {type: OfferPoiType.BUS, name: "Obywatelska - Politechniki", distance: 503},
        {type: OfferPoiType.BUS, name: "Politechniki - Obywatelska", distance: 520},
        {type: OfferPoiType.TRAM, name: "Politechniki - Obywatelska", distance: 556},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 649},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Rogozińskiego", distance: 681},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 781},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 942},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1285},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1574},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1728},
        {type: OfferPoiType.PARK, name: "Borek Józefa Lissnera", distance: 1837},
        {type: OfferPoiType.PARK, name: "Skwer im. Henryka Dubaniewicza", distance: 1883}
    ],
    16760: [
        {type: OfferPoiType.BUS, name: "Konwiktorska 03", distance: 64},
        {type: OfferPoiType.BUS, name: "Konwiktorska 04", distance: 78},
        {type: OfferPoiType.BUS, name: "Konwiktorska 02", distance: 92},
        {type: OfferPoiType.BUS, name: "Konwiktorska 01", distance: 185},
        {type: OfferPoiType.BUS, name: "Muranowska 06", distance: 319},
        {type: OfferPoiType.BUS, name: "Muranowska 05", distance: 368},
        {type: OfferPoiType.BUS, name: "Muranowska 04", distance: 385},
        {type: OfferPoiType.PARK, name: "Park Traugutta", distance: 450},
        {type: OfferPoiType.TRAM, name: "Muranowska 07", distance: 467},
        {type: OfferPoiType.TRAM, name: "Muranowska 08", distance: 474},
        {type: OfferPoiType.TRAM, name: "Muranowska 11", distance: 482},
        {type: OfferPoiType.BUS, name: "Muranowska 02", distance: 501},
        {type: OfferPoiType.TRAM, name: "KS Polonia 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Franciszkańska 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Park Traugutta 03", distance: 517},
        {type: OfferPoiType.TRAM, name: "KS Polonia 01", distance: 518},
        {type: OfferPoiType.TRAM, name: "Park Traugutta 05", distance: 550},
        {type: OfferPoiType.TRAM, name: "Park Traugutta 04", distance: 583},
        {type: OfferPoiType.TRAM, name: "Muranowska 71", distance: 661},
        {type: OfferPoiType.PARK, name: "Szkolny Park Sportowy imienia Janusza Kusocińskiego", distance: 733},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Pancernej WP", distance: 799},
        {type: OfferPoiType.TRAM, name: "Most Gdański 04", distance: 830},
        {type: OfferPoiType.PARK, name: 'Skwer Batalionu AK "Czata 49"', distance: 934},
        {type: OfferPoiType.PARK, name: "Ogród Krasińskich", distance: 1045},
        {type: OfferPoiType.PARK, name: "Skwer Więźniów Politycznych Stalinizmu", distance: 1049},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 1191}
    ],
    16766: [
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań", distance: 300},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 04", distance: 302},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 02", distance: 319},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła", distance: 694},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 01", distance: 735},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 02", distance: 737}
    ],
    16767: [
        {type: OfferPoiType.BUS, name: "Chrzanów Rospontowa II", distance: 304},
        {type: OfferPoiType.BUS, name: "Chrzanów Borowiec I", distance: 389}
    ],
    16784: [
        {type: OfferPoiType.TRAM, name: "Braterska", distance: 423},
        {type: OfferPoiType.BUS, name: "Braterska", distance: 437},
        {type: OfferPoiType.BUS, name: "Przyjaźni", distance: 615},
        {type: OfferPoiType.BUS, name: "Sąsiedzka", distance: 673},
        {type: OfferPoiType.TRAM, name: "Sąsiedzka", distance: 676},
        {type: OfferPoiType.BUS, name: "Partynice – Tor Wyścigów Konnych", distance: 688},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Partynice", distance: 695},
        {type: OfferPoiType.TRAM, name: "Przyjaźni", distance: 715},
        {type: OfferPoiType.BUS, name: "Osiedle Przyjaźni", distance: 726},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 976},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 1343},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1396},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 1482},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 1760}
    ],
    16789: [
        {type: OfferPoiType.BUS, name: "Wylotowa przy Plażowej", distance: 377},
        {type: OfferPoiType.PARK, name: "Park Antoniego Szarmacha", distance: 1438},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 1825},
        {type: OfferPoiType.LAS, name: "Załęże", distance: 2203}
    ],
    16793: [
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 391},
        {type: OfferPoiType.BUS, name: "Partynice – Tor Wyścigów Konnych", distance: 500},
        {type: OfferPoiType.BUS, name: "Klecina", distance: 549},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Partynice", distance: 571},
        {type: OfferPoiType.TRAM, name: "Klecina", distance: 599},
        {type: OfferPoiType.BUS, name: "Skarbowców", distance: 636},
        {type: OfferPoiType.TRAM, name: "Sąsiedzka", distance: 660},
        {type: OfferPoiType.BUS, name: "Sąsiedzka", distance: 661},
        {type: OfferPoiType.BUS, name: "Klecina (Stacja kolejowa)", distance: 775},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 791},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1272},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 1467},
        {type: OfferPoiType.PARK, name: "Park Migdałowy", distance: 1509},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 1791}
    ],
    16798: [
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 109},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 146},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 151},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 232},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 05", distance: 312},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 01", distance: 313},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 323},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 408},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 411},
        {type: OfferPoiType.BUS, name: "Cybernetyki 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 02", distance: 445},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 470},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 511},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 538},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 01", distance: 556},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 563},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 579},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 615},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 03", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1279},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1532},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 1631}
    ],
    16801: [
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska Sąd", distance: 401},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 434},
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska", distance: 448},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 551},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 715},
        {type: OfferPoiType.BUS, name: "Katowice Sądowa", distance: 755},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Miarki", distance: 773},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 784},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 792},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1049},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1263},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1305},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 1514}
    ],
    16809: [
        {type: OfferPoiType.BUS, name: "Park Wilsona", distance: 456},
        {type: OfferPoiType.TRAM, name: "Park Wilsona", distance: 463},
        {type: OfferPoiType.TRAM, name: "Dworzec Zachodni", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Thomasa Woodrowa Wilsona", distance: 622},
        {type: OfferPoiType.BUS, name: "Skwer Focha", distance: 630},
        {type: OfferPoiType.BUS, name: "Dworzec Zachodni", distance: 632},
        {type: OfferPoiType.KOLEJ, name: "Poznań Główny", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Hałasika", distance: 1212},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1440},
        {type: OfferPoiType.PARK, name: "Park Jana Kasprowicza", distance: 1448},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1777},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1853},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1881},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1886}
    ],
    16812: [
        {type: OfferPoiType.BUS, name: "Kilińskiego - Nawrot", distance: 10},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Nawrot", distance: 55},
        {type: OfferPoiType.BUS, name: "Nawrot - Kilińskiego", distance: 88},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Tuwima", distance: 231},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 236},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Piłsudskiego", distance: 322},
        {type: OfferPoiType.BUS, name: "Tuwima - Kilińskiego (EC1 Centr. Nauki)", distance: 388},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 391},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Kilińskiego", distance: 434},
        {type: OfferPoiType.BUS, name: "Nawrot - Sienkiewicza", distance: 440},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 454},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Kilińskiego", distance: 454},
        {type: OfferPoiType.BUS, name: "Nawrot - Targowa", distance: 467},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Roosevelta", distance: 544},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Park Sienkiewicza", distance: 544},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 646},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 690},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 696},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 705},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 802},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 855},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 897}
    ],
    16814: [
        {type: OfferPoiType.BUS, name: "ROD Storczyk", distance: 60},
        {type: OfferPoiType.BUS, name: "Lipowa", distance: 334},
        {type: OfferPoiType.BUS, name: "Wysoka", distance: 418},
        {type: OfferPoiType.BUS, name: "Kutrzeby", distance: 444},
        {type: OfferPoiType.BUS, name: "Lipowa-Parkowa", distance: 703},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 802}
    ],
    16817: [
        {type: OfferPoiType.BUS, name: "Żywiecka Leszczyny", distance: 246},
        {type: OfferPoiType.BUS, name: "Żywiecka Pawia", distance: 450},
        {type: OfferPoiType.BUS, name: "Łagodna Szkoła", distance: 532},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Leszczyny", distance: 634},
        {type: OfferPoiType.BUS, name: "Górska Bulwary Młodości", distance: 642},
        {type: OfferPoiType.BUS, name: "Osiedle Złote Łany", distance: 706},
        {type: OfferPoiType.PARK, name: "Bulwary Straceńskie", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Strzygowskiego", distance: 1104},
        {type: OfferPoiType.REZERWAT, name: "Żabiniec", distance: 1454},
        {type: OfferPoiType.REZERWAT, name: "Zbiornik Weldoro", distance: 1922}
    ],
    16824: [
        {type: OfferPoiType.BUS, name: "Katowice Ceglana Szpital Kliniczny", distance: 341},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Szpital", distance: 623},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Basen", distance: 638},
        {type: OfferPoiType.BUS, name: "Katowice Meteorologów", distance: 662},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 902},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Szymkowiaka", distance: 1087},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1120},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Kaczmarskiego", distance: 1324},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1376},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 1474},
        {type: OfferPoiType.PARK, name: "Skwer Porozumienia Katowickiego 1980 roku", distance: 1542}
    ],
    16826: [
        {type: OfferPoiType.BUS, name: "Cyryla i Metodego", distance: 357},
        {type: OfferPoiType.BUS, name: "1 Maja", distance: 452},
        {type: OfferPoiType.BUS, name: "Wilcza Wiadukt", distance: 495},
        {type: OfferPoiType.BUS, name: "Sczanieckiej", distance: 632},
        {type: OfferPoiType.BUS, name: "Fabryka Wody", distance: 724},
        {type: OfferPoiType.PARK, name: "Skwer imienia Pułkownika Ryszarda Kuklińskiego", distance: 1112},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jacka Nieżychowskiego", distance: 1155},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Nadratowskiego", distance: 1322},
        {type: OfferPoiType.PARK, name: "Skwer imienia Raoula Wallenberga", distance: 1377},
        {type: OfferPoiType.PARK, name: "park Orderu Uśmiechu", distance: 1593},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 1661},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 1778},
        {type: OfferPoiType.PARK, name: "Park Antoniego Kadziaka", distance: 1806},
        {type: OfferPoiType.PARK, name: "Park imienia Jacka Karpińskiego", distance: 2103}
    ],
    16840: [
        {type: OfferPoiType.BUS, name: "Sikorki 01", distance: 104},
        {type: OfferPoiType.BUS, name: "Sikorki 02", distance: 171},
        {type: OfferPoiType.BUS, name: "Na Załęczu 01", distance: 252},
        {type: OfferPoiType.BUS, name: "Na Załęczu 04", distance: 377},
        {type: OfferPoiType.BUS, name: "Na Załęczu 02", distance: 402},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 01", distance: 638},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 02", distance: 670},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 1144},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1543},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1872},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1944},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 2073},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2405},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2472},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 2479}
    ],
    16843: [
        {type: OfferPoiType.BUS, name: "Chłodnia 02", distance: 247},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Chłodnia 01", distance: 300},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 04", distance: 302},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 01", distance: 326},
        {type: OfferPoiType.BUS, name: "Daniszewska 02", distance: 637},
        {type: OfferPoiType.BUS, name: "Daniszewska 01", distance: 661},
        {type: OfferPoiType.BUS, name: "Odlewnicza 05", distance: 830},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1600},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 1619},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1875},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2000}
    ],
    16851: [
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 354},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 358},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 361},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 417},
        {type: OfferPoiType.TRAM, name: "Zabłocie 02", distance: 532},
        {type: OfferPoiType.TRAM, name: "Zabłocie 01", distance: 539},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 662},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 718},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 04", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 928},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1268},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1565},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1815}
    ],
    16852: [
        {type: OfferPoiType.BUS, name: "Mysłowice Cmentarz", distance: 159},
        {type: OfferPoiType.BUS, name: "Mysłowice Mikołowska Markety", distance: 492},
        {type: OfferPoiType.BUS, name: "Mysłowice Chopina", distance: 627},
        {type: OfferPoiType.BUS, name: "Mysłowice Katowicka", distance: 688},
        {type: OfferPoiType.BUS, name: "Ćmok Rondo (Partyzantów)", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1875},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Pawła II", distance: 1940},
        {type: OfferPoiType.PARK, name: "Park Wygoda", distance: 2031},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Kłosowskiego", distance: 2493}
    ],
    16854: [
        {type: OfferPoiType.BUS, name: "Boya Żeleńskiego 01", distance: 125},
        {type: OfferPoiType.BUS, name: "Boya Żeleńskiego 02", distance: 195},
        {type: OfferPoiType.BUS, name: "Wita Stwosza / Langiewicza 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 04", distance: 296},
        {type: OfferPoiType.BUS, name: "Wita Stwosza pętla 01", distance: 310},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 05", distance: 368},
        {type: OfferPoiType.BUS, name: "Chmaja / Langiewicza 02", distance: 370},
        {type: OfferPoiType.BUS, name: "Chmaja / Langiewicza 01", distance: 425},
        {type: OfferPoiType.BUS, name: "Langiewicza park 02", distance: 465},
        {type: OfferPoiType.BUS, name: "Wita Stwosza kościół 03", distance: 495},
        {type: OfferPoiType.KOLEJ, name: "Rzeszów Politechnika", distance: 543},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 824},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 1095},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1181},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1413},
        {type: OfferPoiType.PARK, name: "Park Jedności Polonii z Macierzą", distance: 1669}
    ],
    16857: [
        {type: OfferPoiType.BUS, name: "Ornontowice Zespół Szkół", distance: 284},
        {type: OfferPoiType.BUS, name: "Ornontowice Szkoła", distance: 465},
        {type: OfferPoiType.BUS, name: "Ornontowice Działkowa", distance: 630},
        {type: OfferPoiType.BUS, name: "Ornontowice Ogródki Działkowe", distance: 728},
        {type: OfferPoiType.PARK, name: "Park pałacowy", distance: 950}
    ],
    16859: [
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 370},
        {type: OfferPoiType.BUS, name: "Bielicowa", distance: 457},
        {type: OfferPoiType.BUS, name: "Sielawy", distance: 504},
        {type: OfferPoiType.BUS, name: "Naramowice Wschodnie", distance: 566},
        {type: OfferPoiType.BUS, name: "Rubież", distance: 731},
        {type: OfferPoiType.BUS, name: "Dworska", distance: 732},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1620},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2045}
    ],
    16866: [{type: OfferPoiType.PARK, name: "Park Widawski", distance: 1677}],
    16877: [
        {type: OfferPoiType.TRAM, name: "Gwarna", distance: 66},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 241},
        {type: OfferPoiType.TRAM, name: "Zamek", distance: 258},
        {type: OfferPoiType.TRAM, name: "Fredry", distance: 270},
        {type: OfferPoiType.TRAM, name: "Pl. Ratajskiego", distance: 306},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 308},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 380},
        {type: OfferPoiType.BUS, name: "Zamek", distance: 425},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 456},
        {type: OfferPoiType.BUS, name: "Uniwersytet Ekonomiczny", distance: 489},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 508},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 518},
        {type: OfferPoiType.BUS, name: "Urząd Wojewódzki", distance: 529},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 640},
        {type: OfferPoiType.BUS, name: "Rondo Kaponiera", distance: 674},
        {type: OfferPoiType.BUS, name: "Libelta", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 693},
        {type: OfferPoiType.BUS, name: "Solna", distance: 700},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 711},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 718},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 958},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 978},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1058},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1107}
    ],
    16878: [
        {type: OfferPoiType.BUS, name: "Okrągła", distance: 352},
        {type: OfferPoiType.BUS, name: "Kłosowa", distance: 519},
        {type: OfferPoiType.PARK, name: "Skwer Wolnego Tybetu", distance: 2491}
    ],
    16879: [
        {type: OfferPoiType.BUS, name: "Przyszówka Osiedle Literatów", distance: 372},
        {type: OfferPoiType.BUS, name: "Przyszówka Kaplica", distance: 586},
        {type: OfferPoiType.BUS, name: "Przyszówka Ossolińskich", distance: 660},
        {type: OfferPoiType.BUS, name: "Przyszówka Zygmuntowska [nż]", distance: 703},
        {type: OfferPoiType.PARK, name: "Skwer Układu Słonecznego", distance: 2039},
        {type: OfferPoiType.PARK, name: "Łabędzki Park", distance: 2073}
    ],
    16889: [
        {type: OfferPoiType.BUS, name: "Pustki Cisowskie 02", distance: 78},
        {type: OfferPoiType.BUS, name: "Żurawia", distance: 279},
        {type: OfferPoiType.BUS, name: "Pustki Cisowskie 01", distance: 485},
        {type: OfferPoiType.BUS, name: "Wiklinowa", distance: 766},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1460}
    ],
    16896: [
        {type: OfferPoiType.BUS, name: "Wschodu Słońca 02", distance: 111},
        {type: OfferPoiType.BUS, name: "Popularna 03", distance: 180},
        {type: OfferPoiType.BUS, name: "Popularna 01", distance: 236},
        {type: OfferPoiType.BUS, name: "Wschodu Słońca 01", distance: 254},
        {type: OfferPoiType.BUS, name: "Popularna 04", distance: 334},
        {type: OfferPoiType.BUS, name: "Popularna 02", distance: 335},
        {type: OfferPoiType.BUS, name: "PKP WKD Al. Jerozolimskie 05", distance: 609},
        {type: OfferPoiType.BUS, name: "Szybka 02", distance: 681},
        {type: OfferPoiType.BUS, name: "PKP WKD Al. Jerozolimskie 06", distance: 709},
        {type: OfferPoiType.BUS, name: "Szybka 01", distance: 731},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Aleje Jerozolimskie WKD", distance: 742},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Aleje Jerozolimskie", distance: 839},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 1420},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1502},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 2019},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 2082},
        {type: OfferPoiType.PARK, name: "Park Szczęśliwicki", distance: 2227},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2358}
    ],
    16897: [
        {type: OfferPoiType.BUS, name: "Katowice Francuska WORD", distance: 790},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Trzy Stawy", distance: 835},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 1135},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1176},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 1782},
        {type: OfferPoiType.PARK, name: 'Skwer 304 Dywizjonu Bombowego "Ziemi Śląskiej"', distance: 1831},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 1865},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 2081},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 2094}
    ],
    16898: [
        {type: OfferPoiType.BUS, name: "Wełniana", distance: 334},
        {type: OfferPoiType.BUS, name: "Chwałkowska", distance: 349},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 776},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1371},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2073},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 2299}
    ],
    16901: [
        {type: OfferPoiType.BUS, name: "Sasanki 03", distance: 457},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 02", distance: 467},
        {type: OfferPoiType.BUS, name: "Sasanki 02", distance: 519},
        {type: OfferPoiType.BUS, name: "Sasanki 01", distance: 523},
        {type: OfferPoiType.BUS, name: "Sasanki 04", distance: 575},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 04", distance: 611},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 03", distance: 663},
        {type: OfferPoiType.BUS, name: "Komitetu Obrony Robotników 01", distance: 673},
        {type: OfferPoiType.BUS, name: "Astronautów 01", distance: 739},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1740}
    ],
    16903: [
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 03", distance: 470},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ursus Północny", distance: 483},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 02", distance: 494},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 04", distance: 508},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 01", distance: 527},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 08", distance: 588},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 638},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 07", distance: 686},
        {type: OfferPoiType.BUS, name: "Habicha 02", distance: 705},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 03", distance: 731},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ursus Płn. 01", distance: 744},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 06", distance: 780},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 880},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1203},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1462}
    ],
    16906: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 249},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 259},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 321},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 335},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 396},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 406},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 475},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 547},
        {type: OfferPoiType.BUS, name: "Natansona 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Natansona 02", distance: 642},
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 693},
        {type: OfferPoiType.BUS, name: "Siewna 03", distance: 710},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 741},
        {type: OfferPoiType.TRAM, name: "Bociana 02", distance: 835},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1624},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1656},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1699},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2251},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2345}
    ],
    16907: [
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 02 (NŻ)", distance: 157},
        {type: OfferPoiType.BUS, name: "Pogórze - Szkolna 01 (NŻ)", distance: 186},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 01 (NŻ)", distance: 274},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Gombrowicza 01", distance: 430},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Świetlica 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Świetlica 02", distance: 631},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Świetlica 04", distance: 638},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 02", distance: 648},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 01", distance: 726},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1543},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 2470}
    ],
    16909: [
        {type: OfferPoiType.BUS, name: "Pogórze - Szkolna 01 (NŻ)", distance: 464},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 02 (NŻ)", distance: 623},
        {type: OfferPoiType.BUS, name: "Suchy Dwór - Szkolna 01 (NŻ)", distance: 629},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 02", distance: 656},
        {type: OfferPoiType.BUS, name: "Pogórze - Majakowskiego 01", distance: 734},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1551}
    ],
    16910: [
        {type: OfferPoiType.BUS, name: "Smolec - Chłopska/Śliwkowa", distance: 459},
        {type: OfferPoiType.BUS, name: "Smolec - Chłopska/Wrzosowa", distance: 527},
        {type: OfferPoiType.KOLEJ, name: "Mokronos Górny", distance: 646},
        {type: OfferPoiType.BUS, name: "Smolec - Wiśniowa", distance: 742}
    ],
    16924: [
        {type: OfferPoiType.BUS, name: "Wartka 02", distance: 294},
        {type: OfferPoiType.BUS, name: "Wartka 01", distance: 427},
        {type: OfferPoiType.BUS, name: "Cementownia 03", distance: 462},
        {type: OfferPoiType.BUS, name: "Cementownia 01", distance: 484},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 566},
        {type: OfferPoiType.BUS, name: "Konwaliowa 04", distance: 596},
        {type: OfferPoiType.BUS, name: "Konwaliowa 02", distance: 658},
        {type: OfferPoiType.BUS, name: "Płochocińska 04", distance: 688},
        {type: OfferPoiType.BUS, name: "Cementownia 02", distance: 689},
        {type: OfferPoiType.BUS, name: "Konwaliowa 03", distance: 718},
        {type: OfferPoiType.BUS, name: "Konwaliowa 01", distance: 765},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2372}
    ],
    16931: [
        {type: OfferPoiType.BUS, name: "Ligota Bronisławy", distance: 153},
        {type: OfferPoiType.PARK, name: "Skwer Tytusa Chałubińskiego", distance: 357},
        {type: OfferPoiType.BUS, name: "Ligota Szpital", distance: 360},
        {type: OfferPoiType.BUS, name: "Ligota Akademiki", distance: 528},
        {type: OfferPoiType.PARK, name: "plac profesora Kornela Gibińskiego", distance: 583},
        {type: OfferPoiType.BUS, name: "Ligota Medyków", distance: 594},
        {type: OfferPoiType.BUS, name: "Ligota Wileńska", distance: 731},
        {type: OfferPoiType.LAS, name: "Gierkówka", distance: 752},
        {type: OfferPoiType.PARK, name: "Park Zadole", distance: 857},
        {type: OfferPoiType.PARK, name: "Skwer Nad Ślepiotką", distance: 968},
        {type: OfferPoiType.PARK, name: "skwer Bolesława Szabelskiego", distance: 1250},
        {type: OfferPoiType.PARK, name: "Skwer profesora Wilibalda Winklera", distance: 1276},
        {type: OfferPoiType.PARK, name: "plac ojca Justyna Widucha", distance: 1279}
    ],
    16937: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 244},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 252},
        {type: OfferPoiType.BUS, name: "Lechicka/Naramowicka", distance: 260},
        {type: OfferPoiType.TRAM, name: "Lechicka/Naramowicka", distance: 281},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 602},
        {type: OfferPoiType.TRAM, name: "Serbska", distance: 662},
        {type: OfferPoiType.BUS, name: "Os. Wichrowe Wzgórze", distance: 765},
        {type: OfferPoiType.BUS, name: "Os. Kosmonautów", distance: 774},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 947},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 1091},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1135},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1528},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1894},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 1915},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1941},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2370},
        {type: OfferPoiType.PARK, name: "Park Cytadela", distance: 2497},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2511}
    ],
    16944: [
        {type: OfferPoiType.BUS, name: "Rubież", distance: 121},
        {type: OfferPoiType.BUS, name: "Bronisza", distance: 228},
        {type: OfferPoiType.TRAM, name: "Jasna Rola", distance: 245},
        {type: OfferPoiType.BUS, name: "Sielawy n/ż", distance: 457},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 568},
        {type: OfferPoiType.TRAM, name: "Os. Łokietka", distance: 608},
        {type: OfferPoiType.TRAM, name: "Błażeja", distance: 620},
        {type: OfferPoiType.BUS, name: "Bogusława", distance: 655},
        {type: OfferPoiType.BUS, name: "Os. Łokietka", distance: 712},
        {type: OfferPoiType.BUS, name: "Czarnucha", distance: 760},
        {type: OfferPoiType.TRAM, name: "Naramowice", distance: 801},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 993},
        {type: OfferPoiType.PARK, name: "Demonstracyjny ogród klimatyczny", distance: 1976},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2080},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2355},
        {type: OfferPoiType.PARK, name: "Skwer Poznańskiego Towarzystwa Przyjaciół Nauk", distance: 2388},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 2409}
    ],
    16946: [
        {type: OfferPoiType.KOLEJ, name: "Michałowice", distance: 511},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 2031},
        {type: OfferPoiType.PARK, name: "Park im. Ludwika Trylskiego", distance: 2116},
        {type: OfferPoiType.PARK, name: "Park Niepodległości", distance: 2242},
        {type: OfferPoiType.PARK, name: "Park Bogny i Jerzego Sokorskich", distance: 2505},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 2510}
    ],
    16949: [
        {type: OfferPoiType.BUS, name: "Potęgowska 01", distance: 24},
        {type: OfferPoiType.BUS, name: "Potęgowska 02", distance: 28},
        {type: OfferPoiType.BUS, name: "Szadółki 04", distance: 355},
        {type: OfferPoiType.BUS, name: "Połczyńska 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Szadółki 03", distance: 413},
        {type: OfferPoiType.BUS, name: "Połczyńska 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Szadółki 02", distance: 510},
        {type: OfferPoiType.BUS, name: "Szadółki 01", distance: 554},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 660},
        {type: OfferPoiType.BUS, name: "Leszczynowa 02", distance: 818},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1817}
    ],
    16950: [
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 569},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 615},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 635},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 645},
        {type: OfferPoiType.BUS, name: "Popielidów 02", distance: 650},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 655},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 700},
        {type: OfferPoiType.BUS, name: "Popielidów 01", distance: 706},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 828},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 03", distance: 828},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1466},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 2471}
    ],
    16951: [
        {type: OfferPoiType.BUS, name: "Milanówek Łączna", distance: 407},
        {type: OfferPoiType.BUS, name: "Milanówek Nowowiejska", distance: 414},
        {type: OfferPoiType.BUS, name: "Milanówek Biedronka", distance: 504},
        {type: OfferPoiType.BUS, name: "Milanówek Królewska", distance: 605},
        {type: OfferPoiType.BUS, name: "Milanówek Jasna", distance: 772},
        {type: OfferPoiType.BUS, name: "Milanówek Targ", distance: 833},
        {type: OfferPoiType.PARK, name: 'Park "Zielony Dołek"', distance: 883},
        {type: OfferPoiType.PARK, name: "Skwer im. Bohaterów Polski Podziemnej 1939-1956", distance: 1187},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1344},
        {type: OfferPoiType.PARK, name: "Skwer im. Wacława Wdowiaka", distance: 1384},
        {type: OfferPoiType.PARK, name: "Skwer im. Ferdynanda Antoniego Ossendowskiego", distance: 1486},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1516},
        {type: OfferPoiType.PARK, name: "Skwer im. Adama Bienia", distance: 1604},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 1877},
        {type: OfferPoiType.PARK, name: "Starodęby", distance: 1991},
        {type: OfferPoiType.PARK, name: "Lasek Rososza", distance: 2123}
    ],
    16952: [
        {type: OfferPoiType.BUS, name: "Powstańców 01", distance: 253},
        {type: OfferPoiType.BUS, name: "Majora 01", distance: 306},
        {type: OfferPoiType.BUS, name: "Powstańców 02", distance: 334},
        {type: OfferPoiType.BUS, name: "Sudolska 02", distance: 347},
        {type: OfferPoiType.BUS, name: "Majora 03", distance: 403},
        {type: OfferPoiType.BUS, name: "Majora 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 03", distance: 520},
        {type: OfferPoiType.BUS, name: "Aleja 29 Listopada Wiadukt 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Promienistych 02", distance: 576},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 02", distance: 595},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 690},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 768},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1387}
    ],
    16963: [
        {type: OfferPoiType.BUS, name: "Olimp 01", distance: 58},
        {type: OfferPoiType.BUS, name: "Olimp 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Morzyckiej 01", distance: 340},
        {type: OfferPoiType.BUS, name: "Związkowa 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Związkowa 03", distance: 458},
        {type: OfferPoiType.BUS, name: "Związkowa 01", distance: 463},
        {type: OfferPoiType.BUS, name: "Szwedzka NŻ 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Związkowa 05", distance: 494},
        {type: OfferPoiType.BUS, name: "Szwedzka NŻ 02", distance: 646},
        {type: OfferPoiType.BUS, name: "WSPA 02", distance: 679},
        {type: OfferPoiType.PARK, name: "50-lecia", distance: 1637},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 1645},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1938}
    ],
    16972: [
        {type: OfferPoiType.BUS, name: "Niedźwiedzia", distance: 132},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia", distance: 173},
        {type: OfferPoiType.TRAM, name: "Małopanewska", distance: 384},
        {type: OfferPoiType.BUS, name: "Małopanewska", distance: 443},
        {type: OfferPoiType.BUS, name: "Kwiska", distance: 639},
        {type: OfferPoiType.TRAM, name: "Kwiska", distance: 731},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 807},
        {type: OfferPoiType.BUS, name: "Park Popowicki", distance: 812},
        {type: OfferPoiType.PARK, name: "park Aleksandry Natalli-Świat", distance: 901}
    ],
    16975: [{type: OfferPoiType.BUS, name: "Karwia, Kopernika", distance: 815}],
    16983: [
        {type: OfferPoiType.BUS, name: "Galicyjska 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Galicyjska 02", distance: 479},
        {type: OfferPoiType.BUS, name: "Galicyjska 03", distance: 560},
        {type: OfferPoiType.BUS, name: "Ciesielskiego 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 02", distance: 682},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Ciesielskiego 01", distance: 719},
        {type: OfferPoiType.BUS, name: "Siwka 01", distance: 760},
        {type: OfferPoiType.BUS, name: "Siwka 02", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 1720},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 2308},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 2406}
    ],
    16984: [
        {type: OfferPoiType.BUS, name: "Forsycji 02", distance: 266},
        {type: OfferPoiType.BUS, name: "Forsycji 01", distance: 285},
        {type: OfferPoiType.BUS, name: "Pole Namiotowe 02", distance: 431},
        {type: OfferPoiType.BUS, name: "Pole Namiotowe 01", distance: 456},
        {type: OfferPoiType.BUS, name: "Turystyczna 02", distance: 603},
        {type: OfferPoiType.BUS, name: "Turystyczna 01", distance: 695},
        {type: OfferPoiType.LAS, name: "Las Mierzei", distance: 1903}
    ],
    17010: [
        {type: OfferPoiType.BUS, name: "Zamojska 02", distance: 167},
        {type: OfferPoiType.BUS, name: "Zamojska 01", distance: 264},
        {type: OfferPoiType.LAS, name: "Skwer bł. ks. Antoniego Zawistowskiego", distance: 463},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 04", distance: 555},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 03", distance: 591},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 01", distance: 617},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 05", distance: 623},
        {type: OfferPoiType.BUS, name: "Rondo Lubelskiego Lipca 02", distance: 693},
        {type: OfferPoiType.BUS, name: "Brama Krakowska 04", distance: 752},
        {type: OfferPoiType.BUS, name: "turystyczny", distance: 758},
        {type: OfferPoiType.BUS, name: "Brama Krakowska 02", distance: 785},
        {type: OfferPoiType.PARK, name: "Park Bronowice", distance: 847},
        {type: OfferPoiType.PARK, name: "Skwer Pod Akacją", distance: 1084},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 1198},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1296}
    ],
    17021: [
        {type: OfferPoiType.BUS, name: "Jędrzejów Przem. Zachód", distance: 714},
        {type: OfferPoiType.BUS, name: "Bieszczadzka - Kolumny NŻ", distance: 818},
        {type: OfferPoiType.BUS, name: "Kolumny - Kolumny 118 NŻ", distance: 820},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 1584},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2135},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 2505}
    ],
    17026: [
        {type: OfferPoiType.BUS, name: "Piastun 02", distance: 106},
        {type: OfferPoiType.PARK, name: "Skwer im. Aleksandra Kamińskiego „Kamyka”", distance: 402},
        {type: OfferPoiType.BUS, name: "Dąbrowskiego 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Traugutta 02", distance: 485},
        {type: OfferPoiType.BUS, name: "Wysockiego 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 521},
        {type: OfferPoiType.BUS, name: "Skorupki 01", distance: 529},
        {type: OfferPoiType.BUS, name: "Dąbrowskiego 01", distance: 570},
        {type: OfferPoiType.BUS, name: "Traugutta 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Skłodowskiej 02", distance: 614},
        {type: OfferPoiType.PARK, name: "Park im. Marii Stypułkowskiej-Chojeckiej „Kamy”", distance: 685},
        {type: OfferPoiType.PARK, name: "Park im. Fryderyka Piotra Wilhelma Müllera", distance: 900},
        {type: OfferPoiType.PARK, name: "Park Bogny i Jerzego Sokorskich", distance: 1073},
        {type: OfferPoiType.PARK, name: "Park Niepodległości", distance: 1277},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 2092},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 2358}
    ],
    17027: [
        {type: OfferPoiType.BUS, name: "Gazowa", distance: 412},
        {type: OfferPoiType.BUS, name: "Tarnogaj", distance: 492},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 690},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 709},
        {type: OfferPoiType.TRAM, name: "Tarnogaj", distance: 771},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 814},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 814},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2028},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2322}
    ],
    17028: [
        {type: OfferPoiType.REZERWAT, name: "Staw Królówka", distance: 1944},
        {type: OfferPoiType.PARK, name: "Ogród krzewowy", distance: 2535}
    ],
    17056: [
        {type: OfferPoiType.BUS, name: "Warszewo Kościół", distance: 211},
        {type: OfferPoiType.BUS, name: "Wapienna", distance: 246},
        {type: OfferPoiType.BUS, name: "Łączna nż", distance: 383},
        {type: OfferPoiType.BUS, name: "Szwedzka", distance: 486},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 997},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 1051},
        {type: OfferPoiType.PARK, name: "park Warszewo-Podbórz", distance: 1630},
        {type: OfferPoiType.PARK, name: "Park imienia Fryderyka Chopina", distance: 2308},
        {type: OfferPoiType.PARK, name: "Park Antoniego Kadziaka", distance: 2440}
    ],
    17057: [
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 02", distance: 266},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 420},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 482},
        {type: OfferPoiType.BUS, name: "Przejezdna 02", distance: 622},
        {type: OfferPoiType.BUS, name: "Przejezdna 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 755},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 827},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1250}
    ],
    17065: [
        {type: OfferPoiType.BUS, name: "Marszałkowska", distance: 335},
        {type: OfferPoiType.BUS, name: "Świerzawska", distance: 541},
        {type: OfferPoiType.BUS, name: "Rycerska", distance: 596},
        {type: OfferPoiType.BUS, name: "Stadion Miejski", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1464},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1506},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2096},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 2238},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 2335},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 2506}
    ],
    17066: [
        {type: OfferPoiType.BUS, name: "Listopadowa", distance: 186},
        {type: OfferPoiType.BUS, name: "Asnyka", distance: 217},
        {type: OfferPoiType.BUS, name: "Nad Potokiem Listopadowa", distance: 306},
        {type: OfferPoiType.BUS, name: "Piastowska Lubertowicza", distance: 437},
        {type: OfferPoiType.BUS, name: "Piastowska Starostwo Powiatowe", distance: 439},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 480},
        {type: OfferPoiType.BUS, name: "Wyspiańskiego Starostwo Powiatowe", distance: 529},
        {type: OfferPoiType.BUS, name: "Filarowa Zespół Szkół", distance: 574},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 647},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 1384},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1695}
    ],
    17074: [
        {type: OfferPoiType.BUS, name: "Sikorki 02", distance: 126},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 02", distance: 180},
        {type: OfferPoiType.BUS, name: "Sikorki 01", distance: 189},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 01", distance: 219},
        {type: OfferPoiType.BUS, name: "Na Załęczu 01", distance: 431},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 504},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 01", distance: 531},
        {type: OfferPoiType.BUS, name: "Na Załęczu 04", distance: 548},
        {type: OfferPoiType.BUS, name: "Na Załęczu 02", distance: 569},
        {type: OfferPoiType.BUS, name: "Sołtysowska 02", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 849},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1506},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1763},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1778},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1835},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2362},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2368},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 2370},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 2378},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 2515}
    ],
    17078: [
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 130},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 590},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 643},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 703},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 774},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 832},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1414},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1737},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 1785},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1787},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 2053},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 2286},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2408},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2444},
        {type: OfferPoiType.PARK, name: 'Park rekreacyjno-sportowy "Przy Żurawińcu"', distance: 2454}
    ],
    17088: [
        {type: OfferPoiType.BUS, name: "Łobzów SKA 04", distance: 424},
        {type: OfferPoiType.BUS, name: "Stachiewicza 01", distance: 440},
        {type: OfferPoiType.BUS, name: "Różyckiego 01", distance: 460},
        {type: OfferPoiType.BUS, name: "Makowskiego 02", distance: 490},
        {type: OfferPoiType.BUS, name: "Radzikowskiego 02", distance: 507},
        {type: OfferPoiType.BUS, name: "Makowskiego 03", distance: 509},
        {type: OfferPoiType.BUS, name: "Radzikowskiego 01", distance: 520},
        {type: OfferPoiType.BUS, name: "Łobzów SKA 03", distance: 521},
        {type: OfferPoiType.BUS, name: "Różyckiego 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Makowskiego 01", distance: 581},
        {type: OfferPoiType.KOLEJ, name: "Kraków Łobzów", distance: 669},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 850},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 956},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1423},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 1487},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 1609},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1651},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Literacki", distance: 1827}
    ],
    17092: [
        {type: OfferPoiType.BUS, name: "Parafialna 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Armatnia 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Parafialna 02", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 799},
        {type: OfferPoiType.BUS, name: "Armatnia 02", distance: 814},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1232},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1708},
        {type: OfferPoiType.PARK, name: "Park im. Edwarda Szymańskiego", distance: 1734},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 1810},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 1890}
    ],
    17102: [
        {type: OfferPoiType.BUS, name: "Osiedle Waryńskiego Pętla", distance: 490},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 2050}
    ],
    17103: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 59},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 341},
        {type: OfferPoiType.BUS, name: "Wólczańska - Skargi", distance: 416},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 437},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 505},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Niepodległości", distance: 543},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Niepodległości", distance: 552},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 613},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 626},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 643},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 680},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 682},
        {type: OfferPoiType.TRAM, name: "Pl. Reymonta", distance: 699},
        {type: OfferPoiType.TRAM, name: "Pl. Niepodległości", distance: 709},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 961},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1008},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1031},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1044},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 1093},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1207}
    ],
    17105: [
        {type: OfferPoiType.BUS, name: "Chałubińskiego", distance: 90},
        {type: OfferPoiType.BUS, name: "PWSZ", distance: 126},
        {type: OfferPoiType.BUS, name: "Szpital", distance: 365},
        {type: OfferPoiType.BUS, name: "Ruszczyca", distance: 573},
        {type: OfferPoiType.BUS, name: "Traugutta", distance: 643},
        {type: OfferPoiType.BUS, name: "Zielona", distance: 694},
        {type: OfferPoiType.BUS, name: "Szpital (tymczasowy)", distance: 722},
        {type: OfferPoiType.PARK, name: "Park PCK", distance: 1381},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 2034},
        {type: OfferPoiType.REZERWAT, name: "Ujęcie Wody w Koszalinie", distance: 2130}
    ],
    17106: [
        {type: OfferPoiType.BUS, name: "Sosnowiec Kosów", distance: 147},
        {type: OfferPoiType.PARK, name: "Plac im. Jana Pawła II", distance: 2193},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 2317},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 2324},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 2346},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu drogowego", distance: 2365}
    ],
    17117: [
        {type: OfferPoiType.BUS, name: "Szkoła 02", distance: 540},
        {type: OfferPoiType.BUS, name: "Pętla 01", distance: 603},
        {type: OfferPoiType.BUS, name: "Szkoła 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Mostowa 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Mostowa 02", distance: 770},
        {type: OfferPoiType.BUS, name: "Elektrownia 01", distance: 776},
        {type: OfferPoiType.BUS, name: "Elektrownia 02", distance: 778},
        {type: OfferPoiType.BUS, name: "Łąkowa 01", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku Mazowsze", distance: 1521},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 1562},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1576},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 2060},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 2116}
    ],
    17123: [
        {type: OfferPoiType.BUS, name: "Uniwersytet Ekonomiczny", distance: 139},
        {type: OfferPoiType.BUS, name: "Petrusewicza", distance: 190},
        {type: OfferPoiType.TRAM, name: "Uniwersytet Ekonomiczny", distance: 210},
        {type: OfferPoiType.BUS, name: "Sanocka", distance: 239},
        {type: OfferPoiType.TRAM, name: "Sanocka", distance: 239},
        {type: OfferPoiType.BUS, name: "Komandorska", distance: 336},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 514},
        {type: OfferPoiType.TRAM, name: "Joannitów", distance: 657},
        {type: OfferPoiType.TRAM, name: "Wielka", distance: 716},
        {type: OfferPoiType.TRAM, name: "Dworzec Autobusowy", distance: 735},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2434}
    ],
    17128: [
        {type: OfferPoiType.BUS, name: "Jachtowa 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Jachtowa 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Drohobycka 02", distance: 664},
        {type: OfferPoiType.BUS, name: "Drohobycka 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Zagórzańska 02", distance: 677},
        {type: OfferPoiType.BUS, name: "Zagórzańska 01", distance: 820}
    ],
    17130: [{type: OfferPoiType.BUS, name: "Lutynia Osiedle", distance: 514}],
    17135: [
        {type: OfferPoiType.TRAM, name: "Plac Szyrockiego", distance: 44},
        {type: OfferPoiType.BUS, name: "Plac Szyrockiego", distance: 105},
        {type: OfferPoiType.TRAM, name: "Osiedle Polonia", distance: 362},
        {type: OfferPoiType.BUS, name: "Szwoleżerów", distance: 419},
        {type: OfferPoiType.TRAM, name: "Szwoleżerów", distance: 428},
        {type: OfferPoiType.BUS, name: "Mierosławskiego", distance: 493},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Dowbór-Muśnickiego", distance: 593},
        {type: OfferPoiType.BUS, name: "Starkiewicza", distance: 698},
        {type: OfferPoiType.TRAM, name: "Starkiewicza", distance: 698},
        {type: OfferPoiType.BUS, name: "Piekary", distance: 707},
        {type: OfferPoiType.TRAM, name: "Narutowicza", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer imienia Michała Doliwo-Dobrowolskiego", distance: 1060},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 1184},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 1199},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 1524},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1614},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 2003},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 2035}
    ],
    17136: [
        {type: OfferPoiType.BUS, name: "Marysin", distance: 413},
        {type: OfferPoiType.BUS, name: "Ustronie Morskie - pętla", distance: 434}
    ],
    17137: [
        {type: OfferPoiType.BUS, name: "Grudziądzka / Urząd Miasta P+R", distance: 273},
        {type: OfferPoiType.BUS, name: "Plac Poznański", distance: 276},
        {type: OfferPoiType.BUS, name: "Garbary", distance: 401},
        {type: OfferPoiType.TRAM, name: "Garbary", distance: 403},
        {type: OfferPoiType.BUS, name: "Nowy Rynek P+R", distance: 409},
        {type: OfferPoiType.PARK, name: "Park im. Jana Henryka Dąbrowskiego", distance: 500},
        {type: OfferPoiType.PARK, name: "Skwer 18 listopada 1956 r.", distance: 504},
        {type: OfferPoiType.BUS, name: "Rondo Grunwaldzkie", distance: 545},
        {type: OfferPoiType.TRAM, name: "Focha / Opera", distance: 546},
        {type: OfferPoiType.PARK, name: "Wyspa Młyńska", distance: 556},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 566},
        {type: OfferPoiType.BUS, name: "Focha / Opera", distance: 568},
        {type: OfferPoiType.TRAM, name: "Rondo Grunwaldzkie", distance: 683},
        {type: OfferPoiType.PARK, name: "Terasy", distance: 713},
        {type: OfferPoiType.TRAM, name: "Plac Teatralny", distance: 836}
    ],
    17138: [
        {type: OfferPoiType.PARK, name: "Plac im. Jana Pawła II", distance: 340},
        {type: OfferPoiType.BUS, name: "Zagórze Gwiezdna", distance: 380},
        {type: OfferPoiType.TRAM, name: "Zagórze Gwiezdna", distance: 409},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu drogowego", distance: 484},
        {type: OfferPoiType.BUS, name: "Zagórze Rondo Jana Pawła II", distance: 617},
        {type: OfferPoiType.TRAM, name: "Zagórze Rondo Jana Pawła II", distance: 635},
        {type: OfferPoiType.BUS, name: "Klimontów Fińskie Domki", distance: 702},
        {type: OfferPoiType.BUS, name: "Zagórze Droga do Klimontowa", distance: 755},
        {type: OfferPoiType.PARK, name: "Park imienia Wandy Malczewskiej", distance: 1539},
        {type: OfferPoiType.PARK, name: "Park Środula", distance: 2100},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 2179}
    ],
    17151: [
        {type: OfferPoiType.BUS, name: "Dworzec Fordon", distance: 362},
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 470},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Fordon", distance: 500},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 572},
        {type: OfferPoiType.BUS, name: "Brzechwy / Szelburg-Zarembiny", distance: 744},
        {type: OfferPoiType.BUS, name: "Fordońska / Wiadukt", distance: 841},
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1398},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 1414},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 1977}
    ],
    17153: [
        {type: OfferPoiType.BUS, name: "Jagiellończyka", distance: 266},
        {type: OfferPoiType.BUS, name: "Saperska", distance: 597},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa", distance: 665},
        {type: OfferPoiType.BUS, name: "Plaża Miejska", distance: 747},
        {type: OfferPoiType.PARK, name: "Skwer Wolnego Tybetu", distance: 1700},
        {type: OfferPoiType.PARK, name: "Park Zielony Raj", distance: 1730},
        {type: OfferPoiType.PARK, name: "Park Podzamcze", distance: 1942},
        {type: OfferPoiType.PARK, name: "Łynostrada", distance: 2043}
    ],
    17154: [
        {type: OfferPoiType.BUS, name: "Jednorożca", distance: 596},
        {type: OfferPoiType.BUS, name: "Galaktyczna 01", distance: 692},
        {type: OfferPoiType.PARK, name: "Zieleniec Orfeusza", distance: 738},
        {type: OfferPoiType.PARK, name: "Park Diany", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Chirona", distance: 1775},
        {type: OfferPoiType.PARK, name: "Zieleniec Parterowa", distance: 2290}
    ],
    17159: [
        {type: OfferPoiType.BUS, name: "Szadółki 04", distance: 310},
        {type: OfferPoiType.BUS, name: "Szadółki 03", distance: 359},
        {type: OfferPoiType.BUS, name: "Potęgowska 01", distance: 434},
        {type: OfferPoiType.BUS, name: "Potęgowska 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Szadółki 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Szadółki 01", distance: 500},
        {type: OfferPoiType.BUS, name: "Połczyńska 01", distance: 764},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 776},
        {type: OfferPoiType.BUS, name: "Połczyńska 02", distance: 790},
        {type: OfferPoiType.BUS, name: "Przywidzka 01", distance: 845},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 2227}
    ],
    17162: [
        {type: OfferPoiType.BUS, name: "Dziwnów - Wybreże Kościuszkowskie - Słoneczna", distance: 535},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1282}
    ],
    17163: [
        {type: OfferPoiType.BUS, name: "PKP Toruńska 02", distance: 621},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 04", distance: 624},
        {type: OfferPoiType.BUS, name: "Pelcowizna 01", distance: 727},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Toruńska", distance: 738},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 03", distance: 758},
        {type: OfferPoiType.BUS, name: "Pelcowizna 06", distance: 814},
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 838},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 1095},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1533},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1738},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 2057}
    ],
    17167: [
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 237},
        {type: OfferPoiType.TRAM, name: "Zabłocie 02", distance: 254},
        {type: OfferPoiType.TRAM, name: "Zabłocie 01", distance: 261},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 314},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 317},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 371},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 440},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 612},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 650},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 04", distance: 801},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1516},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1620},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 1750},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2485}
    ],
    17168: [
        {type: OfferPoiType.BUS, name: "Otyńska", distance: 270},
        {type: OfferPoiType.BUS, name: "Fabryczna", distance: 293},
        {type: OfferPoiType.BUS, name: "Babimojska", distance: 478},
        {type: OfferPoiType.TRAM, name: "Babimojska", distance: 478},
        {type: OfferPoiType.BUS, name: "Park Biznesu", distance: 555},
        {type: OfferPoiType.TRAM, name: "Park Biznesu", distance: 565},
        {type: OfferPoiType.BUS, name: "Strzegomska 148", distance: 741},
        {type: OfferPoiType.TRAM, name: "Strzegomska 148", distance: 741},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Muchobór", distance: 756},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Jochelsona", distance: 1699},
        {type: OfferPoiType.PARK, name: "park Aleksandry Natalli-Świat", distance: 1824},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 1885}
    ],
    17170: [
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 281},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 835},
        {type: OfferPoiType.BUS, name: "Aleja Architektów", distance: 840}
    ],
    17175: [
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 622},
        {type: OfferPoiType.BUS, name: "Królewiecka (Park)", distance: 656},
        {type: OfferPoiType.BUS, name: "Suwalska", distance: 665},
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 754},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1162},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 1351}
    ],
    17176: [
        {type: OfferPoiType.BUS, name: "Psie Pole", distance: 109},
        {type: OfferPoiType.BUS, name: "Psie Pole (Gorlicka)", distance: 165},
        {type: OfferPoiType.BUS, name: "Psie Pole (Rondo Lotników Polskich)", distance: 301},
        {type: OfferPoiType.BUS, name: "Zielna", distance: 380},
        {type: OfferPoiType.BUS, name: "Mulicka", distance: 421},
        {type: OfferPoiType.PARK, name: "Park Jedności", distance: 2187}
    ],
    17177: [
        {type: OfferPoiType.BUS, name: "Cesarzowice skrz.", distance: 212},
        {type: OfferPoiType.BUS, name: "Zybiszów", distance: 810},
        {type: OfferPoiType.PARK, name: "Park Mokronoski", distance: 1510}
    ],
    17181: [
        {type: OfferPoiType.BUS, name: "Osiedle Sarni Stok", distance: 295},
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 399},
        {type: OfferPoiType.BUS, name: "Filarowa Zespół Szkół", distance: 700},
        {type: OfferPoiType.BUS, name: "Nad Potokiem Listopadowa", distance: 800},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1427},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1580},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 2245}
    ],
    17186: [
        {type: OfferPoiType.BUS, name: "Ramiszów Stacja", distance: 427},
        {type: OfferPoiType.BUS, name: "Ramiszów", distance: 552},
        {type: OfferPoiType.KOLEJ, name: "Ramiszów", distance: 591},
        {type: OfferPoiType.LAS, name: "cmentarz ewangelicki", distance: 2171}
    ],
    17189: [
        {type: OfferPoiType.BUS, name: "Opatowicka nr 127", distance: 103},
        {type: OfferPoiType.BUS, name: "Zalewowa", distance: 325},
        {type: OfferPoiType.BUS, name: "Opatowice", distance: 484},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1829}
    ],
    17190: [
        {type: OfferPoiType.BUS, name: "Opatowicka nr 127", distance: 105},
        {type: OfferPoiType.BUS, name: "Zalewowa", distance: 327},
        {type: OfferPoiType.BUS, name: "Opatowice", distance: 486},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1831}
    ],
    17193: [
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 325},
        {type: OfferPoiType.BUS, name: "Arabska", distance: 473},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 506},
        {type: OfferPoiType.BUS, name: "Bieńkowice", distance: 606},
        {type: OfferPoiType.BUS, name: "Ziemniaczana", distance: 716},
        {type: OfferPoiType.BUS, name: "Iwiny – Brochowska/Polna", distance: 813},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 1674},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2003}
    ],
    17195: [
        {type: OfferPoiType.TRAM, name: "1 Maja - 3 Maja", distance: 266},
        {type: OfferPoiType.BUS, name: "3 Maja/1 Maja", distance: 305},
        {type: OfferPoiType.BUS, name: "3 Maja/Skłodowskiej-Curie", distance: 377},
        {type: OfferPoiType.BUS, name: "Łąkowa (TBS)", distance: 405},
        {type: OfferPoiType.BUS, name: "Wchodnia (MOSIR)", distance: 441},
        {type: OfferPoiType.BUS, name: "Plac Kilińskiego", distance: 538},
        {type: OfferPoiType.BUS, name: "Długa/Skłodowskiej-Curie", distance: 562},
        {type: OfferPoiType.TRAM, name: "Pl. Kilińskiego", distance: 601},
        {type: OfferPoiType.PARK, name: "Skwer Istvána Almásiego", distance: 788},
        {type: OfferPoiType.KOLEJ, name: "Zgierz", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Tadeusza Kościuszki", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer 35 lat Samorządności", distance: 1612},
        {type: OfferPoiType.PARK, name: "Las Chełmy", distance: 2142}
    ],
    17198: [
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 82},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 86},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 359},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 375},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 458},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 485},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 489},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 497},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 540},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 02", distance: 555},
        {type: OfferPoiType.BUS, name: "Bratysławska 03", distance: 580},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 654},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 918},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1253}
    ],
    17202: [
        {type: OfferPoiType.TRAM, name: "Port Popowice", distance: 139},
        {type: OfferPoiType.BUS, name: "Port Popowice", distance: 189},
        {type: OfferPoiType.BUS, name: "Wejherowska (Hala Orbita)", distance: 308},
        {type: OfferPoiType.TRAM, name: "Wejherowska (Hala Orbita)", distance: 346},
        {type: OfferPoiType.TRAM, name: "Białowieska", distance: 395},
        {type: OfferPoiType.BUS, name: "Milenijna (Hala Orbita)", distance: 465},
        {type: OfferPoiType.BUS, name: "Kwiska", distance: 603},
        {type: OfferPoiType.BUS, name: "Park Popowicki", distance: 741},
        {type: OfferPoiType.TRAM, name: "Kwiska", distance: 758},
        {type: OfferPoiType.TRAM, name: "Park Popowicki", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Popowicki", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 1028},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 1947}
    ],
    17204: [{type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1703}],
    17207: [
        {type: OfferPoiType.BUS, name: "Słona Woda 02", distance: 192},
        {type: OfferPoiType.BUS, name: "Słona Woda 01", distance: 200},
        {type: OfferPoiType.BUS, name: "Kosocicka 01", distance: 382},
        {type: OfferPoiType.BUS, name: "Kosocicka 02", distance: 443},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 655},
        {type: OfferPoiType.BUS, name: "Rżąka 02", distance: 695},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 700},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 02", distance: 740},
        {type: OfferPoiType.BUS, name: "Węzeł Wielicki 06", distance: 767},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 01", distance: 797},
        {type: OfferPoiType.BUS, name: "Czerwiakowskiego 02", distance: 810},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 1416},
        {type: OfferPoiType.REZERWAT, name: "Las Krzyszkowicki", distance: 1671},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 2245},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 2350},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 2434}
    ],
    17213: [
        {type: OfferPoiType.BUS, name: "Obwodnica - Kcyńska", distance: 180},
        {type: OfferPoiType.BUS, name: "Chylońka - Kcyńska", distance: 180},
        {type: OfferPoiType.BUS, name: "Morska - Kcyńska", distance: 727},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 911}
    ],
    17214: [
        {type: OfferPoiType.PARK, name: "Skwer Generała Józefa Hallera", distance: 101},
        {type: OfferPoiType.BUS, name: "Władysławowo, Brzozowa", distance: 140},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Abrahama", distance: 311},
        {type: OfferPoiType.BUS, name: "Władysławowo, Sportowa", distance: 334},
        {type: OfferPoiType.BUS, name: "Władysławowo, Morska", distance: 381},
        {type: OfferPoiType.BUS, name: "Władysławowo, Kościół", distance: 518},
        {type: OfferPoiType.BUS, name: "Władysławowo Cetniewo", distance: 799},
        {type: OfferPoiType.BUS, name: "Władysławowo, Cmentarz", distance: 823},
        {type: OfferPoiType.LAS, name: 'Park "Prądy Morskie"', distance: 1117},
        {type: OfferPoiType.PARK, name: 'Park "Prądy Morskie"', distance: 1117},
        {type: OfferPoiType.PARK, name: "Baza ATOL", distance: 1427},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Słone Łąki", distance: 2293}
    ],
    17215: [
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 279},
        {type: OfferPoiType.TRAM, name: "Śmigłego Rydza - Zbiorcza", distance: 513},
        {type: OfferPoiType.BUS, name: "Śmigłego Rydza - Zbiorcza", distance: 531},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 1376},
        {type: OfferPoiType.PARK, name: "Park Źródliska II", distance: 1547},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 1694},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 1826},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1864}
    ],
    17216: [
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 03", distance: 239},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego dom studenta 04", distance: 294},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 06", distance: 307},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego dom studenta 01", distance: 309},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Powst. Warszawy 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 08", distance: 615},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 09", distance: 701},
        {type: OfferPoiType.BUS, name: "Podwisłocze / Powst. Warszawy 02", distance: 708},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy / Podwisłocze 07", distance: 713},
        {type: OfferPoiType.BUS, name: "Strażacka / Graniczna 02", distance: 754},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 764},
        {type: OfferPoiType.PARK, name: "Bulwar WSK Rzeszów", distance: 1182},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 1394},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1887},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 1950},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 2060},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Lisia Góra", distance: 2365},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 2454}
    ],
    17218: [
        {type: OfferPoiType.BUS, name: "Dworzec Główny (MDK)", distance: 221},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (Stawowa)", distance: 223},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (MDK)", distance: 257},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny", distance: 293},
        {type: OfferPoiType.BUS, name: "Dworzec Główny (Stawowa)", distance: 313},
        {type: OfferPoiType.PARK, name: "skwer Czesława Niemena", distance: 333},
        {type: OfferPoiType.BUS, name: "Dworzec Główny", distance: 339},
        {type: OfferPoiType.BUS, name: "Bastion Sakwowy", distance: 418},
        {type: OfferPoiType.TRAM, name: "Bastion Sakwowy", distance: 489},
        {type: OfferPoiType.TRAM, name: "Arkady (Capitol)", distance: 495},
        {type: OfferPoiType.BUS, name: "Dworzec Główny (Dworcowa)", distance: 498},
        {type: OfferPoiType.TRAM, name: "Dworzec Autobusowy", distance: 544},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Główny", distance: 671},
        {type: OfferPoiType.PARK, name: "skwer Spółdzielców", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 766},
        {type: OfferPoiType.PARK, name: "Ogród Staromiejski", distance: 813},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 896},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 900},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1269}
    ],
    17225: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 304},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 503},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 638},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 751},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 751},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 772},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 798},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 807},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2277}
    ],
    17235: [
        {type: OfferPoiType.BUS, name: "Aroniowa 01", distance: 77},
        {type: OfferPoiType.BUS, name: "Aroniowa 02", distance: 113},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 02", distance: 655},
        {type: OfferPoiType.BUS, name: "Mochtyńska 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Mochtyńska 01", distance: 729},
        {type: OfferPoiType.BUS, name: "Mochtyńska 03", distance: 749},
        {type: OfferPoiType.BUS, name: "Mochtyńska-Kanał 01", distance: 758},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1508}
    ],
    17236: [
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 415},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 419},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 422},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 478},
        {type: OfferPoiType.TRAM, name: "Zabłocie 02", distance: 593},
        {type: OfferPoiType.TRAM, name: "Zabłocie 01", distance: 600},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 717},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 989},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1544},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1626},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1876}
    ],
    17239: [
        {type: OfferPoiType.BUS, name: "Talarowa 01", distance: 295},
        {type: OfferPoiType.BUS, name: "Talarowa 02", distance: 310},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 440},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 02", distance: 494},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 01", distance: 605},
        {type: OfferPoiType.BUS, name: "Leśnej Polanki 02", distance: 762},
        {type: OfferPoiType.BUS, name: "Mehoffera 04", distance: 784},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 1566},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 2021},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 2422}
    ],
    17243: [
        {type: OfferPoiType.TRAM, name: "Chorzów Teatr Rozrywki", distance: 412},
        {type: OfferPoiType.BUS, name: "Chorzów Teatr Rozrywki", distance: 418},
        {type: OfferPoiType.BUS, name: "Chorzów Liceum Katolickie", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Góra Redena", distance: 627},
        {type: OfferPoiType.TRAM, name: "Chorzów AKS", distance: 668},
        {type: OfferPoiType.BUS, name: "Chorzów Stary Szyb Prezydent", distance: 669},
        {type: OfferPoiType.BUS, name: "Chorzów AKS", distance: 673},
        {type: OfferPoiType.TRAM, name: "Chorzów Rynek", distance: 768},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Józefa Kempińskiego", distance: 803},
        {type: OfferPoiType.PARK, name: "Plac Hutników", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 878},
        {type: OfferPoiType.PARK, name: "Park Pod Kasztanami", distance: 926},
        {type: OfferPoiType.PARK, name: "Skwer Mahatmy Gandhiego", distance: 1077},
        {type: OfferPoiType.PARK, name: "Ogrody Słowaka", distance: 1083},
        {type: OfferPoiType.PARK, name: "Park Róż", distance: 1216}
    ],
    17244: [
        {type: OfferPoiType.BUS, name: "Kleczkowska", distance: 334},
        {type: OfferPoiType.TRAM, name: "Kleczkowska", distance: 346},
        {type: OfferPoiType.TRAM, name: "Most Osobowicki", distance: 662},
        {type: OfferPoiType.BUS, name: "Most Osobowicki", distance: 668},
        {type: OfferPoiType.TRAM, name: "Trzebnicka", distance: 829},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 863},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 1276}
    ],
    17247: [
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej", distance: 34},
        {type: OfferPoiType.TRAM, name: "Unii Lubelskiej", distance: 34},
        {type: OfferPoiType.TRAM, name: "Tadeuszak", distance: 274},
        {type: OfferPoiType.BUS, name: "Tadeuszak", distance: 281},
        {type: OfferPoiType.BUS, name: "Falista", distance: 343},
        {type: OfferPoiType.BUS, name: "Warowna n/ż", distance: 611},
        {type: OfferPoiType.TRAM, name: "Rondo Żegrze", distance: 620},
        {type: OfferPoiType.PARK, name: "Park na os. Armii Krajowej", distance: 1069},
        {type: OfferPoiType.PARK, name: "Park na os. Orła Białego", distance: 1674},
        {type: OfferPoiType.PARK, name: "Park Rataje", distance: 2096}
    ],
    17254: [
        {type: OfferPoiType.BUS, name: "Kielanówka cegielnia 01", distance: 425},
        {type: OfferPoiType.BUS, name: "Kielanówka cegielnia 02", distance: 479},
        {type: OfferPoiType.BUS, name: "Staroniwska / Kresowa 16", distance: 525},
        {type: OfferPoiType.BUS, name: "Staroniwska / Kresowa 11", distance: 558},
        {type: OfferPoiType.BUS, name: "Kielanówka Kopiec 03", distance: 810}
    ],
    17266: [
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy / Skromna", distance: 464},
        {type: OfferPoiType.BUS, name: "Zaświat / Cmentarz", distance: 466},
        {type: OfferPoiType.PARK, name: "Skwer Inwalidów Wojennych", distance: 1330},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 1765}
    ],
    17268: [
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 03", distance: 676},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Powst. Warszawy 02", distance: 695},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 08", distance: 709},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego / Strażacka 06", distance: 742},
        {type: OfferPoiType.BUS, name: "Podwisłocze / Powst. Warszawy 02", distance: 761},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy dom studenta 09", distance: 772},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy / Podwisłocze 07", distance: 777},
        {type: OfferPoiType.BUS, name: "Powst. Warszawy stadion 06", distance: 827},
        {type: OfferPoiType.PARK, name: "Bulwar WSK Rzeszów", distance: 880},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 1183},
        {type: OfferPoiType.PARK, name: "Park Kultury i Wypoczynku", distance: 1213},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1591},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 1764},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Lisia Góra", distance: 2063},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2167},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 2332}
    ],
    17269: [
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 267},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 283},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 288},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 318},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 437},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 456},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 531},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 550},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 599},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 722},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1026},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1436},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2176}
    ],
    17271: [
        {type: OfferPoiType.BUS, name: "Klepacka/Wenecka", distance: 158},
        {type: OfferPoiType.BUS, name: "Klepacka/Barszczańska", distance: 184},
        {type: OfferPoiType.BUS, name: "Klepacka/Kościół", distance: 358},
        {type: OfferPoiType.BUS, name: "Klepacka", distance: 400},
        {type: OfferPoiType.BUS, name: "Klepacka/Pętla", distance: 448},
        {type: OfferPoiType.BUS, name: "Meksykańska/Watykańska", distance: 534},
        {type: OfferPoiType.BUS, name: "Meksykańska/Rumuńska", distance: 592},
        {type: OfferPoiType.BUS, name: "Klepacka/Lawendowa NŻ", distance: 632},
        {type: OfferPoiType.BUS, name: "Klepacka/Lawendowa", distance: 696},
        {type: OfferPoiType.BUS, name: "Klepacka/Graniczna", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Janiny Kurkowskiej-Spychajowej", distance: 1405},
        {type: OfferPoiType.PARK, name: "Botaniczny Park Kieszonkowy", distance: 2403}
    ],
    17277: [
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Okopowa", distance: 420},
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 548},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Sucharskiego", distance: 553},
        {type: OfferPoiType.BUS, name: "Sporna - Bracka", distance: 585},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Park Szarych Szeregów", distance: 742},
        {type: OfferPoiType.BUS, name: "Marysińska - Szklana", distance: 791},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 804},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1139},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1183},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1284},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1303},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1590},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1767}
    ],
    17279: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Brylowska 01", distance: 658},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 697},
        {type: OfferPoiType.BUS, name: "Brylowska 02", distance: 753},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1320},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1545},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1615},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1792},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1976},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 2002},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 2002},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 2077}
    ],
    17285: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 104},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 491},
        {type: OfferPoiType.TRAM, name: "Żeromskiego", distance: 528},
        {type: OfferPoiType.BUS, name: "Żeromskiego n/ż", distance: 561},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 661},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 680},
        {type: OfferPoiType.BUS, name: "Rynek Jeżycki", distance: 685},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1581},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1618},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1677},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1751},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1757},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1827},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1850},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1982},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 1998},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 2021}
    ],
    17288: [
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 40},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 125},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 157},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 227},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 267},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego NŻ", distance: 290},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 341},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Rewolucji 1905 r.", distance: 343},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kilińskiego", distance: 368},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 372},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Rewolucji 1905 r.", distance: 420},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 522},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Wschodnia", distance: 526},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 566},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 568},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 573},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 591},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 599},
        {type: OfferPoiType.BUS, name: "Jaracza - Kilińskiego", distance: 605},
        {type: OfferPoiType.BUS, name: "Północna - Nowomiejska", distance: 621},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 818},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 986},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1037}
    ],
    17289: [
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 256},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 311},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 316},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 321},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 327},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 389},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 416},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 441},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 442},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 443},
        {type: OfferPoiType.TRAM, name: "Łagiewniki 02", distance: 670},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 701},
        {type: OfferPoiType.TRAM, name: "Łagiewniki 01", distance: 701},
        {type: OfferPoiType.TRAM, name: "Łagiewniki 03", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1197},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1217},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1506},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 1572},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1725},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1797},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1949},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2184},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2310},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2363}
    ],
    17295: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 238},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 261},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 546},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 589},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 792},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 815},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 836},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1448},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1574}
    ],
    17300: [
        {type: OfferPoiType.PARK, name: "Skwer Adolfa Marii Bocheńskiego", distance: 187},
        {type: OfferPoiType.TRAM, name: "Katedra", distance: 200},
        {type: OfferPoiType.TRAM, name: "Reja", distance: 207},
        {type: OfferPoiType.BUS, name: "Reja", distance: 214},
        {type: OfferPoiType.BUS, name: "Katedra", distance: 246},
        {type: OfferPoiType.BUS, name: "Górnickiego", distance: 354},
        {type: OfferPoiType.TRAM, name: "Górnickiego", distance: 357},
        {type: OfferPoiType.TRAM, name: "Plac Grunwaldzki", distance: 469},
        {type: OfferPoiType.BUS, name: "Plac Grunwaldzki", distance: 476},
        {type: OfferPoiType.PARK, name: "Skwer Obrońców Solidarności", distance: 819},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 897},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 939},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 968},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1709}
    ],
    17305: [
        {type: OfferPoiType.BUS, name: "Plac Szembeka 08", distance: 170},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 05", distance: 257},
        {type: OfferPoiType.BUS, name: "Chłopickiego 01", distance: 309},
        {type: OfferPoiType.BUS, name: "Chłopickiego 04", distance: 312},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 03", distance: 324},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 04", distance: 336},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 01", distance: 379},
        {type: OfferPoiType.BUS, name: "Chłopickiego 03", distance: 387},
        {type: OfferPoiType.BUS, name: "Chłopickiego 02", distance: 414},
        {type: OfferPoiType.TRAM, name: "Żółkiewskiego 03", distance: 444},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 02", distance: 450},
        {type: OfferPoiType.TRAM, name: "Żółkiewskiego 04", distance: 456},
        {type: OfferPoiType.BUS, name: "Hetmańska 02", distance: 486},
        {type: OfferPoiType.BUS, name: "Żółkiewskiego 01", distance: 493},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 674},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 03", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1361},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 1563},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 2044},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2046},
        {type: OfferPoiType.PARK, name: "Park Nad Balatonem", distance: 2284},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 2345}
    ],
    17306: [
        {type: OfferPoiType.BUS, name: "Mickiewicza", distance: 186},
        {type: OfferPoiType.BUS, name: "Chrobrego", distance: 435},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 599},
        {type: OfferPoiType.BUS, name: "Cmentarz Żydowski", distance: 615},
        {type: OfferPoiType.BUS, name: "Dąbrówki", distance: 631},
        {type: OfferPoiType.BUS, name: "Serbinów", distance: 657},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 1535},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1547},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1608},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 1884}
    ],
    17316: [
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego", distance: 382},
        {type: OfferPoiType.BUS, name: "Kurpiów", distance: 623},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego", distance: 826},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 1520},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 1960}
    ],
    17317: [
        {type: OfferPoiType.BUS, name: "Figowa 02", distance: 475},
        {type: OfferPoiType.BUS, name: "Figowa 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Siekierkowska 01", distance: 590},
        {type: OfferPoiType.BUS, name: "Siekierkowska 02", distance: 620},
        {type: OfferPoiType.BUS, name: "Łososiowa 53", distance: 688},
        {type: OfferPoiType.BUS, name: "Łososiowa 01", distance: 710},
        {type: OfferPoiType.BUS, name: "Batalionu AK „Bałtyk” 02", distance: 745},
        {type: OfferPoiType.BUS, name: "Ku Wiśle 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Ku Wiśle 02", distance: 760},
        {type: OfferPoiType.BUS, name: "Batalionu AK „Bałtyk” 01", distance: 764},
        {type: OfferPoiType.PARK, name: "Park Akcji „Burza”", distance: 1631},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 2212},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 2467}
    ],
    17323: [
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 164},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 170},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 400},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 506},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 589},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2367}
    ],
    17325: [
        {type: OfferPoiType.BUS, name: "Biskupa Prandoty 01", distance: 311},
        {type: OfferPoiType.BUS, name: "Biskupa Prandoty 02", distance: 387},
        {type: OfferPoiType.BUS, name: "Cmentarz Rakowicki Zachód 03", distance: 581},
        {type: OfferPoiType.BUS, name: "Cmentarz Rakowicki Zachód 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Cmentarz Rakowicki Zachód 02", distance: 691},
        {type: OfferPoiType.BUS, name: "UR al. 29 Listopada 03", distance: 699},
        {type: OfferPoiType.BUS, name: "UR al. 29 Listopada 02", distance: 733},
        {type: OfferPoiType.BUS, name: "UR al. 29 Listopada 01", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 1067},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1231},
        {type: OfferPoiType.PARK, name: "Ogród Tadeusza Kościuszki", distance: 1326},
        {type: OfferPoiType.PARK, name: "Ogród Kasztanowy", distance: 1420},
        {type: OfferPoiType.PARK, name: "Ogród Krakowianek", distance: 1510},
        {type: OfferPoiType.PARK, name: "Park Kleparski", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Palczewskiego", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Jalu Kurka", distance: 1642}
    ],
    17331: [
        {type: OfferPoiType.BUS, name: "Kościuszki 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Lelewela 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Kościuszki 02", distance: 462},
        {type: OfferPoiType.BUS, name: "Lelewela 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Popiela 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Dekerta 01", distance: 603},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 01", distance: 632},
        {type: OfferPoiType.BUS, name: "Dekerta 02", distance: 665},
        {type: OfferPoiType.BUS, name: "Popiela 01", distance: 668},
        {type: OfferPoiType.TRAM, name: "Sąd Rejonowy 01", distance: 673},
        {type: OfferPoiType.TRAM, name: "Sąd Rejonowy 02", distance: 704},
        {type: OfferPoiType.BUS, name: "Sczanieckiego 03", distance: 745},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 1244},
        {type: OfferPoiType.REZERWAT, name: "Miasto średniowieczne w Toruniu", distance: 1772}
    ],
    17334: [
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Konstytucyjna (Wi-Ma)", distance: 256},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - CH Tulipan", distance: 262},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Konstytucyjna (Wi-Ma)", distance: 275},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Niciarniana", distance: 428},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Niciarniana", distance: 428},
        {type: OfferPoiType.BUS, name: "Niciarniana - Piłsudskiego", distance: 512},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Sarnia", distance: 517},
        {type: OfferPoiType.BUS, name: "CH Tulipan", distance: 528},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Sarnia", distance: 633},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 640},
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 1010},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1273},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 1480},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 1835},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 1964},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1988},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 2046}
    ],
    17335: [
        {type: OfferPoiType.BUS, name: "Koszutka Katowicka", distance: 13},
        {type: OfferPoiType.TRAM, name: "Koszutka Misjonarzy Oblatów", distance: 154},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 187},
        {type: OfferPoiType.BUS, name: "Koszutka GIG", distance: 218},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna", distance: 430},
        {type: OfferPoiType.BUS, name: "Koszutka Kościół", distance: 458},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 517},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna Pętla", distance: 541},
        {type: OfferPoiType.TRAM, name: "Koszutka Jesionowa", distance: 555},
        {type: OfferPoiType.BUS, name: "Koszutka Słoneczna", distance: 556},
        {type: OfferPoiType.BUS, name: "Koszutka Morcinka", distance: 614},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 623},
        {type: OfferPoiType.BUS, name: "Koszutka Kino Kosmos", distance: 651},
        {type: OfferPoiType.BUS, name: "Katowice Chorzowska", distance: 748},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 756},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 862},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1105},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1105},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 1169}
    ],
    17336: [
        {type: OfferPoiType.BUS, name: "św. Antoniego 01", distance: 246},
        {type: OfferPoiType.BUS, name: "Lisia 03", distance: 266},
        {type: OfferPoiType.BUS, name: "Myśliwska nż. 01", distance: 295},
        {type: OfferPoiType.BUS, name: "Lisia 02", distance: 352},
        {type: OfferPoiType.BUS, name: "św. Antoniego 02", distance: 380},
        {type: OfferPoiType.BUS, name: "Lisia 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Lisia nż. 04", distance: 446},
        {type: OfferPoiType.BUS, name: "Liliowa nż. 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Krucza nż. 01", distance: 628},
        {type: OfferPoiType.BUS, name: "Jastrzębia nż. 01", distance: 705},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1144},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1633},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 2013},
        {type: OfferPoiType.PARK, name: "Park na Bielanach", distance: 2193}
    ],
    17349: [
        {type: OfferPoiType.BUS, name: "Legionów - Farbiarska", distance: 214},
        {type: OfferPoiType.BUS, name: "Legionów - działki", distance: 250},
        {type: OfferPoiType.BUS, name: "Farbiarska - Legionów", distance: 266},
        {type: OfferPoiType.BUS, name: "Farbiarska - działki", distance: 286},
        {type: OfferPoiType.LAS, name: "Park Bulwary", distance: 394},
        {type: OfferPoiType.PARK, name: "Park Bulwary", distance: 394},
        {type: OfferPoiType.BUS, name: "gen. Bema - gen. Hallera", distance: 475},
        {type: OfferPoiType.BUS, name: "gen. Bema - Fabryczna", distance: 506},
        {type: OfferPoiType.BUS, name: "gen. Hallera 2", distance: 563},
        {type: OfferPoiType.BUS, name: "Legionów - szkoła", distance: 607},
        {type: OfferPoiType.BUS, name: "gen. Hallera 23", distance: 721},
        {type: OfferPoiType.PARK, name: "Park im. Stefanii i Juliana Tuwimów", distance: 786},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 1175},
        {type: OfferPoiType.PARK, name: "Pałac Ostrowskich", distance: 1193},
        {type: OfferPoiType.LAS, name: "Park Solidarności", distance: 1335},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1335},
        {type: OfferPoiType.LAS, name: "Skwer Powstań Narodowych", distance: 1476},
        {type: OfferPoiType.LAS, name: "Park imienia doktora medycyny Jana Rodego", distance: 1498}
    ],
    17364: [
        {type: OfferPoiType.BUS, name: "Dworzec Główny (Dworcowa)", distance: 191},
        {type: OfferPoiType.BUS, name: "Dworzec Główny", distance: 200},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny", distance: 203},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (MDK)", distance: 268},
        {type: OfferPoiType.BUS, name: "Dworzec Główny (MDK)", distance: 270},
        {type: OfferPoiType.TRAM, name: "Bastion Sakwowy", distance: 378},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny (Stawowa)", distance: 409},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Główny", distance: 482},
        {type: OfferPoiType.PARK, name: "skwer Czesława Niemena", distance: 495},
        {type: OfferPoiType.TRAM, name: "Park Staromiejski", distance: 538},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 609},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 696},
        {type: OfferPoiType.PARK, name: "Ogród Staromiejski", distance: 743},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 785},
        {type: OfferPoiType.PARK, name: "skwer Spółdzielców", distance: 888},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 955},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1196}
    ],
    17367: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Armii Krajowej 02", distance: 344},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 02", distance: 705},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 01", distance: 763},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1418},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1424},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1525},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1656},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1777},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1835},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1894},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1981}
    ],
    17368: [
        {type: OfferPoiType.BUS, name: "Rezedowa 02", distance: 206},
        {type: OfferPoiType.BUS, name: "Rezedowa 01", distance: 265},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 02", distance: 308},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Gocławek", distance: 322},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Okularowa 04", distance: 495},
        {type: OfferPoiType.BUS, name: "Okularowa 02", distance: 597},
        {type: OfferPoiType.BUS, name: "Okularowa 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Łysakowska 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Łysakowska 02", distance: 675},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 03", distance: 682},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 1201},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 1414},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 1801},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 1990},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 2085}
    ],
    17376: [
        {type: OfferPoiType.BUS, name: "Mennica 03", distance: 115},
        {type: OfferPoiType.BUS, name: "Mennica 52", distance: 163},
        {type: OfferPoiType.BUS, name: "Mennica 04", distance: 172},
        {type: OfferPoiType.BUS, name: "Norblin 06", distance: 189},
        {type: OfferPoiType.BUS, name: "Mennica 02", distance: 211},
        {type: OfferPoiType.BUS, name: "Mennica 01", distance: 253},
        {type: OfferPoiType.TRAM, name: "Norblin 04", distance: 258},
        {type: OfferPoiType.BUS, name: "Norblin 05", distance: 269},
        {type: OfferPoiType.BUS, name: "Norblin 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Norblin 02", distance: 303},
        {type: OfferPoiType.TRAM, name: "Norblin 03", distance: 306},
        {type: OfferPoiType.BUS, name: "Wronia 01", distance: 363},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 08", distance: 538},
        {type: OfferPoiType.METRO, name: "Rondo ONZ", distance: 594},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 596},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 609},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 04", distance: 621},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 661},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 03", distance: 702},
        {type: OfferPoiType.TRAM, name: "Muzeum Powstania Warszawskiego 06", distance: 740},
        {type: OfferPoiType.TRAM, name: "Muzeum Powstania Warszawskiego 05", distance: 753},
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 03", distance: 760},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 766},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 56", distance: 775},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 05", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Mirowski", distance: 984},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 998},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 1130},
        {type: OfferPoiType.PARK, name: "Park Świętokrzyski", distance: 1169}
    ],
    17383: [{type: OfferPoiType.BUS, name: "Mała Wieś Skrzyżowanie", distance: 581}],
    17384: [{type: OfferPoiType.BUS, name: "Mała Wieś Skrzyżowanie", distance: 685}],
    17387: [
        {type: OfferPoiType.BUS, name: "Brzezińska - Kerna NŻ", distance: 288},
        {type: OfferPoiType.BUS, name: "Brzezińska - Janosika", distance: 342},
        {type: OfferPoiType.BUS, name: "Kerna - Brzezińska", distance: 402},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 522},
        {type: OfferPoiType.BUS, name: "Brzezińska - CH M1", distance: 650},
        {type: OfferPoiType.BUS, name: "Janosika - Powstańców Śląskich", distance: 777},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 2361},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 2460}
    ],
    17397: [
        {type: OfferPoiType.BUS, name: "Miodowicza", distance: 140},
        {type: OfferPoiType.BUS, name: "Jana Pawła II", distance: 156},
        {type: OfferPoiType.BUS, name: "Krakowska / Jana Pawła II", distance: 186},
        {type: OfferPoiType.BUS, name: "Ściegiennego WDK", distance: 210},
        {type: OfferPoiType.BUS, name: "Wojska Pol./Langiewicza", distance: 326},
        {type: OfferPoiType.BUS, name: "Rogatka Krakowska", distance: 357},
        {type: OfferPoiType.BUS, name: "Krakowska UJK", distance: 399},
        {type: OfferPoiType.BUS, name: "Jana Pawła II / Ogrodowa", distance: 415},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego / Żeromskiego", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Żeromskiego", distance: 649},
        {type: OfferPoiType.PARK, name: "Skwer Harcerski im. Szarych Szeregów", distance: 726},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Ofiar Katynia", distance: 845},
        {type: OfferPoiType.PARK, name: "Park im. Stanisława Staszica", distance: 856},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Bularskiego", distance: 907},
        {type: OfferPoiType.PARK, name: "Skwer Wolontariuszy", distance: 957},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1035},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1143},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kadzielnia", distance: 1407},
        {type: OfferPoiType.REZERWAT, name: "Wietrznia", distance: 1698},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Wietrznia im. Z. Rubinowskiego", distance: 1890}
    ],
    17398: [
        {type: OfferPoiType.BUS, name: "Struga / Zbrowskiego 10", distance: 88},
        {type: OfferPoiType.BUS, name: "Struga / Zbrowskiego 07", distance: 94},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Olsztyńska 04", distance: 289},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Olsztyńska 05", distance: 316},
        {type: OfferPoiType.BUS, name: "Struga / 25 Czerwca 08", distance: 358},
        {type: OfferPoiType.BUS, name: "Struga / Szklana 09", distance: 372},
        {type: OfferPoiType.BUS, name: "Żwirki i Wigury / Struga 02", distance: 497},
        {type: OfferPoiType.BUS, name: "25 Czerwca / Struga 05", distance: 498},
        {type: OfferPoiType.BUS, name: "Struga / 25 Czerwca 05", distance: 513},
        {type: OfferPoiType.BUS, name: "Szklana / Struga", distance: 513}
    ],
    17400: [
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 08", distance: 219},
        {type: OfferPoiType.BUS, name: "Ustronie / Radomskiego", distance: 303},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 05", distance: 316},
        {type: OfferPoiType.BUS, name: "Biała / Indycza (Tymczasowy)", distance: 418},
        {type: OfferPoiType.BUS, name: "Wyścigowa / Radomskiego", distance: 466},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 06", distance: 526},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Słowackiego 07", distance: 555},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 03", distance: 674},
        {type: OfferPoiType.PARK, name: "Park Ustronie", distance: 1661},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Ruzika", distance: 1912},
        {type: OfferPoiType.PARK, name: "Sadek", distance: 2139},
        {type: OfferPoiType.PARK, name: "Plac Kazimierza Ołdakowskiego", distance: 2213}
    ],
    17401: [
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Orląt Lwowskich 08", distance: 484},
        {type: OfferPoiType.BUS, name: "Os. Gołębiów II / Paderewskiego 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Os. Gołębiów II / Paderewskiego 02", distance: 573},
        {type: OfferPoiType.BUS, name: "Os. Gołębiów II / Paderewskiego 04", distance: 599},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Gołębiowska (NŻ) 09", distance: 660},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Zientarskiego 07", distance: 665},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Zientarskiego 06", distance: 757},
        {type: OfferPoiType.BUS, name: "Zbrowskiego / Gołębiowska (NŻ) 10", distance: 769},
        {type: OfferPoiType.PARK, name: "Park Gołębiów", distance: 807}
    ],
    17409: [
        {type: OfferPoiType.BUS, name: "Bluszczowa 02", distance: 585},
        {type: OfferPoiType.BUS, name: "Bluszczowa 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Narcyzowa 02", distance: 733}
    ],
    17410: [
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 63},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 108},
        {type: OfferPoiType.BUS, name: "Starego Wiarusa 04", distance: 405},
        {type: OfferPoiType.BUS, name: "Starego Wiarusa 01", distance: 492},
        {type: OfferPoiType.BUS, name: "Zielonki Słoneczna", distance: 498},
        {type: OfferPoiType.BUS, name: "Starego Wiarusa 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 02", distance: 721},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 03", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1628},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 2108},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 2493},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2514}
    ],
    17413: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 653},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 822},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 1056},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 1087},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1650},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1909},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2294}
    ],
    17414: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 469},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 552},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 656},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 675},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 680},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 682},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1365},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1410},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1470},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1781},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1958},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2155},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2169},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 2335}
    ],
    17419: [
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 185},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 03", distance: 261},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 295},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 466},
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 612},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 696},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 706},
        {type: OfferPoiType.BUS, name: "Kamykowa 01", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1370}
    ],
    17420: [
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 01", distance: 47},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 03", distance: 50},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 02", distance: 95},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 126},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 187},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 234},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 291},
        {type: OfferPoiType.BUS, name: "Pucciniego 02", distance: 297},
        {type: OfferPoiType.BUS, name: "Pucciniego 01", distance: 360},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 521}
    ],
    17421: [
        {type: OfferPoiType.BUS, name: "Kłosowa 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Stogi 06", distance: 486},
        {type: OfferPoiType.BUS, name: "Stogi 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Sówki 01", distance: 665},
        {type: OfferPoiType.BUS, name: "Stogi 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Sówki 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Rozłogi 02", distance: 755}
    ],
    17422: [
        {type: OfferPoiType.BUS, name: "Gliwice Sobieskiego", distance: 739},
        {type: OfferPoiType.PARK, name: "Wilcze Doły", distance: 762},
        {type: OfferPoiType.BUS, name: "Gliwice Słowackiego", distance: 826},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1116}
    ],
    17429: [
        {type: OfferPoiType.BUS, name: "Katowice Mikołowska", distance: 359},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 367},
        {type: OfferPoiType.BUS, name: "Katowice AWF", distance: 400},
        {type: OfferPoiType.TRAM, name: "Katowice Kościuszki Szpital", distance: 616},
        {type: OfferPoiType.TRAM, name: "Katowice Stadion AWF", distance: 623},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 716},
        {type: OfferPoiType.TRAM, name: "Katowice Jordana", distance: 747},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 954},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 973},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 1019},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1166}
    ],
    17434: [
        {type: OfferPoiType.BUS, name: "Płowiecka 04", distance: 309},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 02", distance: 430},
        {type: OfferPoiType.BUS, name: "Świecka 01", distance: 451},
        {type: OfferPoiType.BUS, name: "Płowiecka 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Płowiecka 03", distance: 519},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Gocławek", distance: 539},
        {type: OfferPoiType.BUS, name: "Płowiecka 02", distance: 545},
        {type: OfferPoiType.BUS, name: "Płowiecka 06", distance: 548},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 01", distance: 621},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 03", distance: 712},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 04", distance: 715},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 1148},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 1434},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 1628},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1817},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 2063},
        {type: OfferPoiType.PARK, name: "Park/Ogród przy Kościele", distance: 2468}
    ],
    17435: [
        {type: OfferPoiType.BUS, name: 'Rumia C.H. "Port Rumia" 01', distance: 666},
        {type: OfferPoiType.BUS, name: "Rumia, CH Port Rumia - Grunwaldzka", distance: 706},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 2366}
    ],
    17437: [
        {type: OfferPoiType.LAS, name: "Jarugi", distance: 1456},
        {type: OfferPoiType.PARK, name: "Park Weglin", distance: 1922}
    ],
    17438: [
        {type: OfferPoiType.BUS, name: "Strachowicka", distance: 453},
        {type: OfferPoiType.PARK, name: "Park Żernicki", distance: 604},
        {type: OfferPoiType.PARK, name: "Żernicki Park Sportu i Rekreacji", distance: 630},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Żerniki", distance: 693},
        {type: OfferPoiType.BUS, name: "Żernicka", distance: 784},
        {type: OfferPoiType.PARK, name: "skwer Księdza Justyna Kostka", distance: 860},
        {type: OfferPoiType.PARK, name: "Park Strachowicki", distance: 2028}
    ],
    17443: [
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 137},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 219},
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 219},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 564},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 602},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 614},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 621},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 03", distance: 642},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 676},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1751}
    ],
    17444: [
        {type: OfferPoiType.BUS, name: "Dominów - Urząd Gminy 02", distance: 219},
        {type: OfferPoiType.BUS, name: "Dominów - Urząd Gminy 01", distance: 300},
        {type: OfferPoiType.BUS, name: "Dominów - skrzyżowanie 01", distance: 518},
        {type: OfferPoiType.BUS, name: "Kolonia Dominów NŻ 02", distance: 600},
        {type: OfferPoiType.BUS, name: "Dominów - skrzyżowanie 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Kolonia Dominów NŻ 01", distance: 660}
    ],
    17449: [
        {type: OfferPoiType.BUS, name: "Sudecka", distance: 427},
        {type: OfferPoiType.BUS, name: "Drukarska", distance: 596},
        {type: OfferPoiType.TRAM, name: "Sztabowa", distance: 617},
        {type: OfferPoiType.BUS, name: "Sztabowa", distance: 629},
        {type: OfferPoiType.BUS, name: "Wiśniowa", distance: 680},
        {type: OfferPoiType.TRAM, name: "Rondo", distance: 738},
        {type: OfferPoiType.BUS, name: "Hallera", distance: 745},
        {type: OfferPoiType.TRAM, name: "Wiśniowa", distance: 755},
        {type: OfferPoiType.TRAM, name: "Hallera", distance: 757},
        {type: OfferPoiType.PARK, name: "park Tadeusza Różewicza", distance: 816}
    ],
    17450: [
        {type: OfferPoiType.BUS, name: "Składowa", distance: 101},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Łasztownia", distance: 277},
        {type: OfferPoiType.BUS, name: "SKM Łasztownia", distance: 323},
        {type: OfferPoiType.BUS, name: "Celna", distance: 395},
        {type: OfferPoiType.TRAM, name: "Celna", distance: 550},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego", distance: 757},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 1083},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1199},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1714},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1857},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 2136},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2136},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 2162},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 2342},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 2483}
    ],
    17457: [
        {type: OfferPoiType.TRAM, name: "Zabrze Plac Teatralny", distance: 271},
        {type: OfferPoiType.BUS, name: "Zabrze Plac Teatralny", distance: 308},
        {type: OfferPoiType.TRAM, name: "Zabrze Prof. Religi", distance: 442},
        {type: OfferPoiType.TRAM, name: "Zabrze Karola Miarki", distance: 491},
        {type: OfferPoiType.PARK, name: "Skwer Dawców Drugiego Życia", distance: 547},
        {type: OfferPoiType.BUS, name: "Zabrze ŚCCS", distance: 554},
        {type: OfferPoiType.TRAM, name: "Zabrze Plac Wolności", distance: 557},
        {type: OfferPoiType.BUS, name: "Zabrze Szpitalna", distance: 674},
        {type: OfferPoiType.BUS, name: "Zabrze Chełmońskiego", distance: 692},
        {type: OfferPoiType.BUS, name: "Zabrze Gdańska", distance: 769},
        {type: OfferPoiType.BUS, name: "Zabrze Cieszyńska", distance: 779},
        {type: OfferPoiType.BUS, name: "Zabrze Curie-Skłodowskiej", distance: 798},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 896},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 960},
        {type: OfferPoiType.PARK, name: "Park imienia Jacka Kuronia", distance: 1196},
        {type: OfferPoiType.PARK, name: "Skwer Wielowiekowej Przyjaźni Polsko-Ormiańskiej", distance: 1275},
        {type: OfferPoiType.PARK, name: "Park Kościuszki", distance: 1581}
    ],
    17461: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 496},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 504},
        {type: OfferPoiType.BUS, name: "Wilczy Młyn", distance: 733},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 1199},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 1315},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1752},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2146},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 2258},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2427}
    ],
    17462: [
        {type: OfferPoiType.BUS, name: "Włodarska", distance: 483},
        {type: OfferPoiType.TRAM, name: "Włodarska", distance: 491},
        {type: OfferPoiType.BUS, name: "Wilczy Młyn", distance: 720},
        {type: OfferPoiType.BUS, name: "Serbska", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 1186},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 1302},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1374},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1739},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2133},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 2245},
        {type: OfferPoiType.PARK, name: "Park Księdza Tadeusza Kirschke", distance: 2414}
    ],
    17463: [
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 122},
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 132},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 184},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 200},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 258},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 314},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 322},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 383},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 386},
        {type: OfferPoiType.BUS, name: "Bratysławska 03", distance: 481},
        {type: OfferPoiType.BUS, name: "Krowodrza Górka P+R 05", distance: 546},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 560},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 02", distance: 677},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 03", distance: 707},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 712},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 01", distance: 732},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R", distance: 745},
        {type: OfferPoiType.TRAM, name: "Szpital Narutowicza 01", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 826},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 930},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1037},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1078}
    ],
    17464: [
        {type: OfferPoiType.BUS, name: "Krakowska galeria 05", distance: 251},
        {type: OfferPoiType.BUS, name: "Krakowska galeria 06", distance: 384},
        {type: OfferPoiType.BUS, name: "Ofiar Katynia galeria 06", distance: 401},
        {type: OfferPoiType.BUS, name: "Ofiar Katynia park 03", distance: 439},
        {type: OfferPoiType.BUS, name: "Krakowska / Wyzwolenia 08", distance: 448},
        {type: OfferPoiType.BUS, name: "Krakowska / Mielecka 07", distance: 455},
        {type: OfferPoiType.BUS, name: "Kotuli / Ustrzycka 02", distance: 470},
        {type: OfferPoiType.BUS, name: "Mikołajczyka pętla 03", distance: 478},
        {type: OfferPoiType.BUS, name: "Mikołajczyka pętla 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Kotuli / Zbyszewskiego 01", distance: 580},
        {type: OfferPoiType.PARK, name: "Park Sybiraków", distance: 725},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 1270},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 1275},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1675},
        {type: OfferPoiType.PARK, name: "Ogród Kieszonkowy", distance: 1742},
        {type: OfferPoiType.PARK, name: "Skwer prof. dr hab. n. med. Lesława Grzegorczyka", distance: 1903}
    ],
    17482: [
        {type: OfferPoiType.BUS, name: "Akademicka / Kaliskiego", distance: 348},
        {type: OfferPoiType.TRAM, name: "Akademicka / Kaliskiego", distance: 434},
        {type: OfferPoiType.BUS, name: "Kaliskiego / Politechnika", distance: 449},
        {type: OfferPoiType.BUS, name: "Kaliskiego / Akademicka", distance: 460},
        {type: OfferPoiType.TRAM, name: "Akademicka / Igrzyskowa", distance: 758},
        {type: OfferPoiType.BUS, name: "Akademicka / Igrzyskowa", distance: 779},
        {type: OfferPoiType.TRAM, name: "Przylesie P+R", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1342},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 1795},
        {type: OfferPoiType.PARK, name: "Dolina Śmierci", distance: 1935},
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 1965}
    ],
    17486: [
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 152},
        {type: OfferPoiType.BUS, name: "Centum Przesiadkowe Bałtycka", distance: 268},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Stadion", distance: 342},
        {type: OfferPoiType.BUS, name: "Bałtycka przy Wylotowej", distance: 499},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 619},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Żurawiej", distance: 621},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 929},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1088},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1200},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1200},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1361},
        {type: OfferPoiType.PARK, name: "Park 18 Marca", distance: 1401},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1701}
    ],
    17487: [
        {type: OfferPoiType.BUS, name: "Trałowa Szkoła 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Boguckiego 02", distance: 511},
        {type: OfferPoiType.BUS, name: "Boguckiego 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Trałowa Szkoła 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Kempingowa 02", distance: 795},
        {type: OfferPoiType.LAS, name: "Las Mierzei", distance: 2285}
    ],
    17493: [
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 83},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 03", distance: 238},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Malborska Szkoła 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Malborska Szkoła 01", distance: 360},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 436},
        {type: OfferPoiType.BUS, name: "Pszenna 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 04", distance: 461},
        {type: OfferPoiType.BUS, name: "Pszenna 02", distance: 512},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 03", distance: 558},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 01", distance: 593},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1258},
        {type: OfferPoiType.PARK, name: "Baśniowy Ogród", distance: 1408},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1455},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2471}
    ],
    17498: [
        {type: OfferPoiType.BUS, name: "Półłanki 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Półłanki 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Szparagowa 01", distance: 580},
        {type: OfferPoiType.BUS, name: "Szparagowa 04", distance: 591},
        {type: OfferPoiType.BUS, name: "Półłanki 03", distance: 593},
        {type: OfferPoiType.BUS, name: "Półłanki 04", distance: 594},
        {type: OfferPoiType.BUS, name: "Szparagowa 06", distance: 692},
        {type: OfferPoiType.BUS, name: "Szparagowa 02", distance: 699},
        {type: OfferPoiType.REZERWAT, name: "Rybitwy", distance: 1167},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Cegielni", distance: 1879},
        {type: OfferPoiType.PARK, name: "Park Zielone Serce Podgórza", distance: 1955}
    ],
    17507: [
        {type: OfferPoiType.BUS, name: "Gęsia 02", distance: 780},
        {type: OfferPoiType.BUS, name: "Gęsia 01", distance: 799},
        {type: OfferPoiType.LAS, name: "Jarugi", distance: 1197},
        {type: OfferPoiType.PARK, name: "Park Weglin", distance: 1770}
    ],
    17510: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Dw. PKP", distance: 310},
        {type: OfferPoiType.KOLEJ, name: "Grodzisk Mazowiecki", distance: 319},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta", distance: 432},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Dw. PKP", distance: 471},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. DSI Malwa", distance: 585},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Przychodnia", distance: 690},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 752},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Piłsudskiego", distance: 1161},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1352},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1524},
        {type: OfferPoiType.PARK, name: "Park Marii Michalak", distance: 1848},
        {type: OfferPoiType.PARK, name: "Park nad Rokitnicą", distance: 1907},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 1926},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 2013}
    ],
    17514: [
        {type: OfferPoiType.BUS, name: "Dw. Północny", distance: 358},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 390},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Północna", distance: 394},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego NŻ", distance: 415},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 430},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 430},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 452},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 550},
        {type: OfferPoiType.BUS, name: "Źródłowa - Wojska Polskiego NŻ", distance: 576},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 583},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Franciszkańska", distance: 605},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Marynarska", distance: 616},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 620},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego - Franciszkańska", distance: 630},
        {type: OfferPoiType.TRAM, name: "Wojska Polskiego - Marynarska", distance: 641},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 647},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 815},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 880},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 941}
    ],
    17525: [
        {type: OfferPoiType.BUS, name: "Tuszyńska - Paderewskiego NŻ", distance: 110},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Tuszyńska", distance: 222},
        {type: OfferPoiType.BUS, name: "Paderewskiego - Tuszyńska", distance: 237},
        {type: OfferPoiType.BUS, name: "Tuszyńska - Piaseczna NŻ", distance: 261},
        {type: OfferPoiType.PARK, name: "Skwer im. Henryka Dubaniewicza", distance: 340},
        {type: OfferPoiType.BUS, name: "Paderewskiego - Rzgowska", distance: 510},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Rzgowska", distance: 521},
        {type: OfferPoiType.BUS, name: "Rzgowska - Paderewskiego", distance: 566},
        {type: OfferPoiType.BUS, name: "Piastów Kurak", distance: 589},
        {type: OfferPoiType.BUS, name: "Paderewskiego - Karpacka", distance: 591},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Karpacka", distance: 610},
        {type: OfferPoiType.TRAM, name: "Paderewskiego - Zaolziańska", distance: 817},
        {type: OfferPoiType.PARK, name: "Park im. Legionów", distance: 980},
        {type: OfferPoiType.PARK, name: "Park Miejski przy ul. Leczniczej", distance: 985},
        {type: OfferPoiType.PARK, name: "Borek Józefa Lissnera", distance: 1040},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1182},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1313},
        {type: OfferPoiType.PARK, name: "Park Zatorze", distance: 1339},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1487},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1558}
    ],
    17526: [
        {type: OfferPoiType.BUS, name: "Cystersów 03", distance: 323},
        {type: OfferPoiType.TRAM, name: "Cystersów 01", distance: 420},
        {type: OfferPoiType.TRAM, name: "Cystersów 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Fabryczna 06", distance: 493},
        {type: OfferPoiType.BUS, name: "Fabryczna 05", distance: 518},
        {type: OfferPoiType.TRAM, name: "Fabryczna 01", distance: 600},
        {type: OfferPoiType.TRAM, name: "Fabryczna 02", distance: 613},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 653},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 669},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Nullo 03", distance: 735},
        {type: OfferPoiType.PARK, name: "Ogród Fabryczny", distance: 738},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 789},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 07", distance: 810},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 818},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 852},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Polaków Poszkodowanych przez III Rzeszę", distance: 1027},
        {type: OfferPoiType.PARK, name: "Skwer Pilota Pirxa", distance: 1623},
        {type: OfferPoiType.PARK, name: "Ogród Kasztanowy", distance: 1723},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2232}
    ],
    17527: [
        {type: OfferPoiType.BUS, name: "Imbramowska 02", distance: 258},
        {type: OfferPoiType.BUS, name: "Imbramowska 01", distance: 307},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 04", distance: 406},
        {type: OfferPoiType.BUS, name: "Żmujdzka 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 03", distance: 591},
        {type: OfferPoiType.BUS, name: "Mackiewicza 01", distance: 608},
        {type: OfferPoiType.BUS, name: "Mackiewicza 02", distance: 623},
        {type: OfferPoiType.BUS, name: "Mackiewicza 03", distance: 627},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 02", distance: 642},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 919},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 930},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 971},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1154}
    ],
    17537: [
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 183},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 698},
        {type: OfferPoiType.BUS, name: "Aleja Architektów", distance: 703},
        {type: OfferPoiType.TRAM, name: "Aleja Architektów", distance: 712},
        {type: OfferPoiType.BUS, name: "Grabowa", distance: 736},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 2387}
    ],
    17539: [
        {type: OfferPoiType.BUS, name: "Władysława Hermana 02", distance: 214},
        {type: OfferPoiType.BUS, name: "Władysława Hermana 01", distance: 270},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 278},
        {type: OfferPoiType.BUS, name: "Henryka Brodatego 02", distance: 337},
        {type: OfferPoiType.BUS, name: "Henryka Brodatego 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Królowej Bony 01", distance: 482},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 502},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 508},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 617},
        {type: OfferPoiType.BUS, name: "Keniga 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Śmigielska 02", distance: 645},
        {type: OfferPoiType.BUS, name: "Ursus-Sanktuarium 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Ursus-Sanktuarium 02", distance: 673},
        {type: OfferPoiType.BUS, name: "Królowej Bony 02", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1059},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1105}
    ],
    17541: [
        {type: OfferPoiType.BUS, name: "Bonarka SKA 01", distance: 297},
        {type: OfferPoiType.KOLEJ, name: "Kraków Bonarka", distance: 581},
        {type: OfferPoiType.BUS, name: "Bonarka SKA 02", distance: 597},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 665},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 671},
        {type: OfferPoiType.BUS, name: "Kamieńskiego Wiadukt 02", distance: 685},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 745},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 756},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 764},
        {type: OfferPoiType.BUS, name: "Kamieńskiego Wiadukt 01", distance: 794},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 900},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 949},
        {type: OfferPoiType.PARK, name: "Park w Łagiewnikach", distance: 1209},
        {type: OfferPoiType.PARK, name: "Magnoliowy zakątek", distance: 1223},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1427},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1625},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1914},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2233}
    ],
    17548: [
        {type: OfferPoiType.BUS, name: "Górka Pychowicka 02", distance: 311},
        {type: OfferPoiType.BUS, name: "Fort Bodzów 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Fort Bodzów 02", distance: 639},
        {type: OfferPoiType.PARK, name: "Ogród krzewowy", distance: 1580},
        {type: OfferPoiType.REZERWAT, name: "Staw Królówka", distance: 1743}
    ],
    17554: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 488},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 623},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 736},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 736},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 783},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 792},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2262},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2465}
    ],
    17555: [
        {type: OfferPoiType.BUS, name: "Zielińskiego", distance: 283},
        {type: OfferPoiType.TRAM, name: "Wielka", distance: 412},
        {type: OfferPoiType.BUS, name: "Wielka", distance: 413},
        {type: OfferPoiType.TRAM, name: "Zaolziańska", distance: 433},
        {type: OfferPoiType.BUS, name: "Plac Hirszfelda", distance: 448},
        {type: OfferPoiType.BUS, name: "Zaolziańska", distance: 458},
        {type: OfferPoiType.BUS, name: "Zaporoska", distance: 478},
        {type: OfferPoiType.BUS, name: "Gwiaździsta", distance: 538},
        {type: OfferPoiType.PARK, name: "Skwer Ptasi Zagajnik", distance: 791},
        {type: OfferPoiType.TRAM, name: "Rondo", distance: 805},
        {type: OfferPoiType.TRAM, name: "Arkady (Capitol)", distance: 817},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2107}
    ],
    17561: [
        {type: OfferPoiType.BUS, name: "Gaj", distance: 87},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 200},
        {type: OfferPoiType.TRAM, name: "Świeradowska", distance: 230},
        {type: OfferPoiType.BUS, name: "Świeradowska", distance: 231},
        {type: OfferPoiType.BUS, name: "Gaj – pętla", distance: 494},
        {type: OfferPoiType.TRAM, name: "Morwowa", distance: 572},
        {type: OfferPoiType.BUS, name: "Morwowa", distance: 654},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1367},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1420},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 2051}
    ],
    17562: [
        {type: OfferPoiType.BUS, name: "Obrońców Tobruku 02", distance: 182},
        {type: OfferPoiType.BUS, name: "Obrońców Tobruku 03", distance: 215},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 01", distance: 249},
        {type: OfferPoiType.BUS, name: "Obrońców Tobruku 01", distance: 250},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 04", distance: 415},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 02", distance: 460},
        {type: OfferPoiType.BUS, name: "Niedzielskiego 01", distance: 540},
        {type: OfferPoiType.BUS, name: "Niedzielskiego 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Galla Anonima 01", distance: 617},
        {type: OfferPoiType.BUS, name: "Magiera 01", distance: 742},
        {type: OfferPoiType.TRAM, name: "Piaski 03", distance: 837},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1131},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1264},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1374},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1784},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 1901},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1932}
    ],
    17564: [
        {type: OfferPoiType.BUS, name: "Odrzykońska / Bł. Karoliny 02", distance: 248},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny przedszkole 06", distance: 400},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny pętla 09", distance: 402},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny przedszkole 07", distance: 503},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 584},
        {type: OfferPoiType.BUS, name: "Odrzykońska / Baligrodzka 04", distance: 621},
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 02", distance: 656},
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 01", distance: 670},
        {type: OfferPoiType.BUS, name: "Odrzykońska / Iwonicka 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny / Nowosądecka 05", distance: 790},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 1328},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 2000}
    ],
    17566: [
        {type: OfferPoiType.BUS, name: "Wolany - Polanica Górna", distance: 557},
        {type: OfferPoiType.BUS, name: "Zdrojowa/Leśna", distance: 593},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1216},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1228}
    ],
    17571: [
        {type: OfferPoiType.TRAM, name: "Długa (ogrody działkowe)", distance: 506},
        {type: OfferPoiType.BUS, name: "Długa (ogrody działkowe)", distance: 520},
        {type: OfferPoiType.BUS, name: "Wrocław Szczepin", distance: 553},
        {type: OfferPoiType.TRAM, name: "Wrocław Szczepin", distance: 553},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Szczepin", distance: 565},
        {type: OfferPoiType.PARK, name: "skwer Świętego Ojca Damiana de Veuster", distance: 1236}
    ],
    17578: [
        {type: OfferPoiType.BUS, name: "Przytycka / Malczewskiej (NŻ) 01", distance: 195},
        {type: OfferPoiType.BUS, name: "Przytycka / Malczewskiej (NŻ) 02", distance: 250},
        {type: OfferPoiType.BUS, name: "Malczewskiej / Langiewicza 02", distance: 527},
        {type: OfferPoiType.BUS, name: "Malczewskiej / Langiewicza 01", distance: 530},
        {type: OfferPoiType.BUS, name: "Listopadowa / al. Róż (NŻ) 01", distance: 644},
        {type: OfferPoiType.BUS, name: "Kielecka / Przytycka 02", distance: 660},
        {type: OfferPoiType.BUS, name: "Przytycka / Uniwersytecka 03", distance: 682},
        {type: OfferPoiType.BUS, name: "Kielecka / Przytycka 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Langiewicza / al. Róż (NŻ) 02", distance: 736},
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Przytycka 02", distance: 747},
        {type: OfferPoiType.PARK, name: "Bulwary nad Mleczną", distance: 1655},
        {type: OfferPoiType.PARK, name: "Park Stary Ogród", distance: 2141},
        {type: OfferPoiType.PARK, name: "Plac ks. Zdzisława Domagały (Zremb)", distance: 2229}
    ],
    17580: [
        {type: OfferPoiType.BUS, name: "Żerniki Wrocławskie", distance: 254},
        {type: OfferPoiType.BUS, name: "Żerniki Wr. – Orla", distance: 532},
        {type: OfferPoiType.BUS, name: "Żerniki Wr. – Kolejowa", distance: 772}
    ],
    17587: [
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 267},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 354},
        {type: OfferPoiType.BUS, name: "Tuwima - Kilińskiego (EC1 Centr. Nauki)", distance: 355},
        {type: OfferPoiType.BUS, name: "Pl. Szoslanda - EC1 Centrum Nauki i Techniki", distance: 386},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Nawrot", distance: 401},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Nawrot", distance: 405},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 408},
        {type: OfferPoiType.BUS, name: "Nawrot - Targowa", distance: 420},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 423},
        {type: OfferPoiType.BUS, name: "Nawrot - Kilińskiego", distance: 440},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Tuwima", distance: 498},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Kilińskiego", distance: 598},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 635},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Piłsudskiego", distance: 651},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 677},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 682},
        {type: OfferPoiType.BUS, name: "Nawrot - Wysoka", distance: 685},
        {type: OfferPoiType.BUS, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 699},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 699},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Targowa", distance: 700},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 741},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 790},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 855},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 874},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 902}
    ],
    17588: [
        {type: OfferPoiType.BUS, name: "Ogrody „Malwa” nż", distance: 109},
        {type: OfferPoiType.BUS, name: "Krakowska Uniwersytet", distance: 199},
        {type: OfferPoiType.BUS, name: "Bronowicka – Rezedowa nż", distance: 285},
        {type: OfferPoiType.BUS, name: "Zielona", distance: 400},
        {type: OfferPoiType.BUS, name: "Cukrowa Uniwersytet", distance: 665},
        {type: OfferPoiType.BUS, name: "Rondo Uniwersyteckie nż", distance: 721},
        {type: OfferPoiType.PARK, name: "park imienia Sprawiedliwych wśród Narodów Świata", distance: 990},
        {type: OfferPoiType.REZERWAT, name: "Stawek na Gumieńcach", distance: 1723},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 2194}
    ],
    17589: [
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Krasińskiego", distance: 74},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Sikorskiego", distance: 290},
        {type: OfferPoiType.TRAM, name: "Zawodzie Paderewskiego", distance: 489},
        {type: OfferPoiType.BUS, name: "Os. Paderewskiego Kościół", distance: 520},
        {type: OfferPoiType.TRAM, name: "Katowice Graniczna", distance: 645},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Biblioteka Śląska", distance: 808},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 869},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Eugeniusza Breitkopfa", distance: 938},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 966},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1000},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer Andrzeja Fonfary", distance: 1144},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 1476}
    ],
    17596: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 334},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 02", distance: 507},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 01", distance: 532},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 01", distance: 685},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 02", distance: 792}
    ],
    17599: [
        {type: OfferPoiType.BUS, name: "Dobczyce Wincentego Witosa", distance: 345},
        {type: OfferPoiType.BUS, name: "Dobczyce Witosa (pętla)", distance: 567},
        {type: OfferPoiType.BUS, name: "Dobczyce Kilińskiego", distance: 717},
        {type: OfferPoiType.PARK, name: "Dobek", distance: 1835},
        {type: OfferPoiType.PARK, name: "Dobczycki Park Miejski", distance: 1849}
    ],
    17601: [
        {type: OfferPoiType.BUS, name: "Sławka 01", distance: 214},
        {type: OfferPoiType.BUS, name: "Sławka 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 03", distance: 224},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 04", distance: 356},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka", distance: 365},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 03", distance: 545},
        {type: OfferPoiType.BUS, name: "Kamieńskiego 02", distance: 578},
        {type: OfferPoiType.BUS, name: "Kamieńskiego 01", distance: 594},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 667},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 718},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 957},
        {type: OfferPoiType.PARK, name: "Baśniowy Ogród", distance: 1183},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 1880},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1923}
    ],
    17602: [
        {type: OfferPoiType.BUS, name: "Smardzewice Zalew", distance: 379},
        {type: OfferPoiType.BUS, name: "Zalew pętla", distance: 547}
    ],
    17603: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 368},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 383},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 400},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 416},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 459},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 736},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 789},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 814},
        {type: OfferPoiType.BUS, name: "Kielecka 01", distance: 835},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1876},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 2133},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2439}
    ],
    17608: [
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 96},
        {type: OfferPoiType.BUS, name: "Kaloryczna 02", distance: 127},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 185},
        {type: OfferPoiType.BUS, name: "Antoniewska 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 395},
        {type: OfferPoiType.BUS, name: "Antoniewska 01", distance: 441},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 539},
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 624},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 745},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 762},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1658},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1681},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2139}
    ],
    17613: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 245},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 273},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 273},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 284},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 298},
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 615},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 687},
        {type: OfferPoiType.BUS, name: "Banacha 01", distance: 734},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 744},
        {type: OfferPoiType.BUS, name: "Banacha 03", distance: 747},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 754},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 808},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 823},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1442},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1485},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1940},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2506}
    ],
    17616: [
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 94},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 131},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 136},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 217},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 05", distance: 297},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 01", distance: 298},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 338},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Cybernetyki 02", distance: 423},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 423},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 02", distance: 430},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 485},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 526},
        {type: OfferPoiType.BUS, name: "Instytut Fizyki 01", distance: 541},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 553},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 578},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 594},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 630},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1264},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1547},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 1616}
    ],
    17617: [
        {type: OfferPoiType.TRAM, name: "Zgierska - Sikorskiego", distance: 173},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego", distance: 218},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Zgierska", distance: 295},
        {type: OfferPoiType.TRAM, name: "Zgierska - Przedwiośnie", distance: 295},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego NŻ", distance: 396},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 471},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pasieczna", distance: 545},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Herlinga-Grudzińskiego", distance: 559},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pl. Pamięci Narodowej", distance: 609},
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 1120},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 1281},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 1337},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 1372},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1639},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Sokołówki i Brzozy”", distance: 1823},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy na Żabieńcu”", distance: 1924},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 2122},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 2333}
    ],
    17619: [
        {type: OfferPoiType.BUS, name: "Szeligowskiego NŻ 01", distance: 115},
        {type: OfferPoiType.BUS, name: "Organowa 01", distance: 378},
        {type: OfferPoiType.BUS, name: "Prusa 03", distance: 390},
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 444},
        {type: OfferPoiType.BUS, name: "Organowa 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Paganiniego 01", distance: 490},
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Paganiniego 03", distance: 587},
        {type: OfferPoiType.BUS, name: "Paganiniego 04", distance: 638},
        {type: OfferPoiType.BUS, name: "Paganiniego 02", distance: 641},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 1151},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1265}
    ],
    17633: [
        {type: OfferPoiType.TRAM, name: "Dworcowa / Matejki", distance: 218},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Floriana Czakiego", distance: 333},
        {type: OfferPoiType.BUS, name: "Śniadeckich / Sienkiewicza", distance: 406},
        {type: OfferPoiType.BUS, name: "Królowej Jadwigi / Astoria", distance: 428},
        {type: OfferPoiType.BUS, name: "Focha / Opera", distance: 462},
        {type: OfferPoiType.BUS, name: "Plac Piastowski", distance: 469},
        {type: OfferPoiType.TRAM, name: "Focha / Opera", distance: 520},
        {type: OfferPoiType.BUS, name: "Fredry / Warszawska", distance: 567},
        {type: OfferPoiType.BUS, name: "Warszawska / Fredry", distance: 581},
        {type: OfferPoiType.TRAM, name: "Garbary", distance: 695},
        {type: OfferPoiType.BUS, name: "Garbary", distance: 721},
        {type: OfferPoiType.TRAM, name: "Plac Teatralny", distance: 748},
        {type: OfferPoiType.TRAM, name: "Plac Wolności", distance: 748},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 798},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 836},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 865},
        {type: OfferPoiType.PARK, name: "Wyspa Młyńska", distance: 941}
    ],
    17635: [
        {type: OfferPoiType.BUS, name: "Wólka Grodziska Zachodnia", distance: 285},
        {type: OfferPoiType.BUS, name: "Kozery Główna", distance: 438},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Zachodnia", distance: 842},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Szwedzka", distance: 843},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Piłsudskiego", distance: 1863},
        {type: OfferPoiType.PARK, name: "Park Marii Michalak", distance: 1891}
    ],
    17638: [
        {type: OfferPoiType.BUS, name: "Bużańska", distance: 210},
        {type: OfferPoiType.BUS, name: "Os. Lotnictwa Polskiego", distance: 467},
        {type: OfferPoiType.BUS, name: "Meissnera", distance: 741},
        {type: OfferPoiType.BUS, name: "Polska", distance: 768},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1382},
        {type: OfferPoiType.REZERWAT, name: "Bogdanka II", distance: 1816}
    ],
    17642: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 73},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 242},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 283},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Struga", distance: 430},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 447},
        {type: OfferPoiType.BUS, name: "Struga - Pogonowskiego NŻ", distance: 456},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 465},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 518},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 521},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 541},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 658},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 678},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 713},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 765},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 769},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 784}
    ],
    17645: [
        {type: OfferPoiType.BUS, name: "Podwale 02", distance: 255},
        {type: OfferPoiType.BUS, name: "Stanowisko 1", distance: 273},
        {type: OfferPoiType.BUS, name: "Stanowisko 2", distance: 281},
        {type: OfferPoiType.BUS, name: "Stanowisko 3", distance: 289},
        {type: OfferPoiType.BUS, name: "Stanowisko 4", distance: 297},
        {type: OfferPoiType.BUS, name: "Dworzec Autobusowy 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Stanowisko 5", distance: 303},
        {type: OfferPoiType.BUS, name: "Stanowisko 6", distance: 309},
        {type: OfferPoiType.BUS, name: "Podwale 01", distance: 312},
        {type: OfferPoiType.BUS, name: "Dworzec Autobusowy 01", distance: 325},
        {type: OfferPoiType.PARK, name: "Park im. J. Ziżki", distance: 1371},
        {type: OfferPoiType.PARK, name: "Wzgórze Kościuszki", distance: 1886}
    ],
    17655: [
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 368},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 453},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 464},
        {type: OfferPoiType.TRAM, name: "Prudnicka", distance: 487},
        {type: OfferPoiType.BUS, name: "Prudnicka", distance: 501},
        {type: OfferPoiType.BUS, name: "Widna", distance: 606},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 687},
        {type: OfferPoiType.BUS, name: "Wapienna", distance: 713},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 714},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1432},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1689},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1850}
    ],
    17659: [
        {type: OfferPoiType.BUS, name: "Waniliowa", distance: 463},
        {type: OfferPoiType.BUS, name: "Tymiankowa", distance: 525},
        {type: OfferPoiType.BUS, name: "Kaparowa", distance: 649},
        {type: OfferPoiType.BUS, name: "Cynamonowa", distance: 705},
        {type: OfferPoiType.BUS, name: "Lipa Piotrowska", distance: 730},
        {type: OfferPoiType.BUS, name: "Perzowa", distance: 749},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 1967}
    ],
    17661: [
        {type: OfferPoiType.BUS, name: "Klonowa Osiedle", distance: 214},
        {type: OfferPoiType.BUS, name: "Klonowa", distance: 491},
        {type: OfferPoiType.BUS, name: "Spacerowa", distance: 540},
        {type: OfferPoiType.BUS, name: "Ludowa", distance: 642},
        {type: OfferPoiType.BUS, name: "Langiewicza", distance: 740},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1224},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1581},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 1994},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 2009},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 2039},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 2191},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 2343}
    ],
    17665: [
        {type: OfferPoiType.BUS, name: "Niwa 02", distance: 364},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 379},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 386},
        {type: OfferPoiType.BUS, name: "Niwa 01", distance: 418},
        {type: OfferPoiType.BUS, name: "Cm. Bródnowski 02", distance: 649},
        {type: OfferPoiType.BUS, name: "Cm. Bródnowski 01", distance: 667},
        {type: OfferPoiType.BUS, name: "Samarytanka 02", distance: 786},
        {type: OfferPoiType.BUS, name: "Metro Trocka 11", distance: 790},
        {type: OfferPoiType.BUS, name: "Rolanda 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Metro Trocka 12", distance: 815},
        {type: OfferPoiType.BUS, name: "Metro Trocka 09", distance: 827},
        {type: OfferPoiType.PARK, name: "Skwer Ekologiczny", distance: 1163},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 1381},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1694},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 2023},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 2125}
    ],
    17667: [
        {type: OfferPoiType.KOLEJ, name: "Karpacz", distance: 613},
        {type: OfferPoiType.BUS, name: "Karpacz, Dworzec kolejowy PKP", distance: 648},
        {type: OfferPoiType.PARK, name: "Park Lipa Sądowa", distance: 1181},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1603},
        {type: OfferPoiType.PARK, name: "Park przy Wodospadzie", distance: 1683},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1697}
    ],
    17672: [
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego", distance: 117},
        {type: OfferPoiType.TRAM, name: "Wierzbięcice", distance: 231},
        {type: OfferPoiType.BUS, name: "Św. Czesława", distance: 281},
        {type: OfferPoiType.TRAM, name: "Św. Czesława", distance: 281},
        {type: OfferPoiType.BUS, name: "Poznań Główny", distance: 421},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 548},
        {type: OfferPoiType.BUS, name: "Bergera", distance: 574},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 610},
        {type: OfferPoiType.BUS, name: "Niezłomnych", distance: 628},
        {type: OfferPoiType.TRAM, name: "Półwiejska", distance: 650},
        {type: OfferPoiType.TRAM, name: "Różana", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 783},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 938},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 940},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1026},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1348},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1384},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1561},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1563}
    ],
    17675: [
        {type: OfferPoiType.BUS, name: "Warneńska 04", distance: 167},
        {type: OfferPoiType.TRAM, name: "Warneńska 01", distance: 228},
        {type: OfferPoiType.TRAM, name: "Warneńska 02", distance: 242},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Kolumba 03", distance: 317},
        {type: OfferPoiType.TRAM, name: "Budapesztańska", distance: 322},
        {type: OfferPoiType.BUS, name: "Budapesztańska", distance: 340},
        {type: OfferPoiType.BUS, name: "Kolumba 04", distance: 349},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 377},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 410},
        {type: OfferPoiType.BUS, name: "Piecewska", distance: 462},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 463},
        {type: OfferPoiType.BUS, name: "Belgradzka 03", distance: 563},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 675},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 681},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 687},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 687},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 687},
        {type: OfferPoiType.TRAM, name: "Migowo", distance: 786},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1426},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1564},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 1893},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2197}
    ],
    17678: [
        {type: OfferPoiType.BUS, name: "Portowa", distance: 350},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 350},
        {type: OfferPoiType.BUS, name: "I Urząd Skarbowy 01", distance: 371},
        {type: OfferPoiType.BUS, name: "I Urząd Skarbowy", distance: 371},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Jana z Kolna", distance: 475},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 476},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Jana z Kolna 02", distance: 487},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski", distance: 533},
        {type: OfferPoiType.BUS, name: "3 Maja - Hala", distance: 537},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski 03", distance: 538},
        {type: OfferPoiType.BUS, name: "3 Maja - Hala 01", distance: 541},
        {type: OfferPoiType.PARK, name: "Park Rady Europy", distance: 1255},
        {type: OfferPoiType.PARK, name: "Plac Wolnej Ukrainy", distance: 1408},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1440},
        {type: OfferPoiType.PARK, name: "Park Marii i Lecha Kaczyńskich", distance: 1539},
        {type: OfferPoiType.PARK, name: "Gdyński Park Kieszonkowy", distance: 1726},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 2004}
    ],
    17681: [
        {type: OfferPoiType.BUS, name: "Żwaków Sosnowe", distance: 23},
        {type: OfferPoiType.BUS, name: "Żwaków Rogatki", distance: 251},
        {type: OfferPoiType.BUS, name: "Żwaków Żorska", distance: 298},
        {type: OfferPoiType.BUS, name: "Żwaków św. Elżbiety", distance: 470},
        {type: OfferPoiType.BUS, name: "Żwaków Cmentarz", distance: 663},
        {type: OfferPoiType.BUS, name: "Żwaków Nowa", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Jaworek", distance: 2173},
        {type: OfferPoiType.PARK, name: "Rodzinny Park Błogosławionej Karoliny", distance: 2499}
    ],
    17682: [
        {type: OfferPoiType.BUS, name: "Kakaowa 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Bakaliowa 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Zamienie 01", distance: 705},
        {type: OfferPoiType.BUS, name: "Błędna 01", distance: 737}
    ],
    17684: [
        {type: OfferPoiType.BUS, name: "Kępa Zawadowska 01", distance: 350},
        {type: OfferPoiType.BUS, name: "Kępa Zawadowska 02", distance: 406},
        {type: OfferPoiType.BUS, name: "Gratyny 01", distance: 472},
        {type: OfferPoiType.BUS, name: "Gratyny 02", distance: 482},
        {type: OfferPoiType.BUS, name: "Bruzdowa - Kościół 02", distance: 615},
        {type: OfferPoiType.BUS, name: "Bruzdowa - Kościół 01", distance: 679}
    ],
    17690: [
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 01", distance: 278},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 02", distance: 319}
    ],
    17693: [
        {type: OfferPoiType.BUS, name: "Rokokowa 02", distance: 350},
        {type: OfferPoiType.BUS, name: "Rokokowa 01", distance: 422},
        {type: OfferPoiType.BUS, name: "Tytułowa 02", distance: 504},
        {type: OfferPoiType.BUS, name: "Tytułowa 01", distance: 538},
        {type: OfferPoiType.TRAM, name: "Nocznickiego 02", distance: 742},
        {type: OfferPoiType.BUS, name: "Wólczyńska-Bocznica 02", distance: 764},
        {type: OfferPoiType.TRAM, name: "Nocznickiego 01", distance: 766},
        {type: OfferPoiType.PARK, name: "Eco Skwerek", distance: 1375},
        {type: OfferPoiType.PARK, name: "Skwer 30. Pułku Strzelców Kaniowskich", distance: 1938},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 2174}
    ],
    17698: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 300},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 341},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 744},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 755},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 771},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1777}
    ],
    17699: [
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 386},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 800},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1731},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 2258},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 2318},
        {type: OfferPoiType.PARK, name: "Park Kielczan 2019", distance: 2329},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 2359},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2389}
    ],
    17700: [
        {type: OfferPoiType.BUS, name: "Taylora / Żniwna", distance: 600},
        {type: OfferPoiType.BUS, name: "Żniwna", distance: 606},
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 710},
        {type: OfferPoiType.BUS, name: "Uniwersytecka", distance: 724},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1124},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1692},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 2219},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 2279},
        {type: OfferPoiType.PARK, name: "Park Kielczan 2019", distance: 2290},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 2320},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2350}
    ],
    17702: [
        {type: OfferPoiType.BUS, name: "Kowale Szkoła Metropolitalna 01", distance: 132},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Cytrusowe", distance: 409},
        {type: OfferPoiType.BUS, name: "Kowale Plac Afrodyty 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Olimp 03", distance: 545},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Olimp 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Kowale Osiedle Olimp 02", distance: 812},
        {type: OfferPoiType.BUS, name: "Kowale Starowiejska 01", distance: 823},
        {type: OfferPoiType.BUS, name: "Borkowo Stylowa 02", distance: 826}
    ],
    17703: [
        {type: OfferPoiType.BUS, name: "Gliwice Plac Piastów", distance: 50},
        {type: OfferPoiType.BUS, name: "Gliwice Piwna", distance: 256},
        {type: OfferPoiType.BUS, name: "Gliwice Dworzec", distance: 279},
        {type: OfferPoiType.BUS, name: "Gliwice Dworcowa", distance: 285},
        {type: OfferPoiType.BUS, name: "Gliwice Jagiellońska", distance: 422},
        {type: OfferPoiType.KOLEJ, name: "Gliwice", distance: 453},
        {type: OfferPoiType.PARK, name: "Skwer Europejski", distance: 474},
        {type: OfferPoiType.PARK, name: "Park Chopina", distance: 782},
        {type: OfferPoiType.PARK, name: "Skwer Valenciennes", distance: 905},
        {type: OfferPoiType.PARK, name: "Skwer Doncaster", distance: 907}
    ],
    17711: [
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 03", distance: 497},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R", distance: 590},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 05", distance: 609},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 02", distance: 625},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 01", distance: 662},
        {type: OfferPoiType.TRAM, name: "Rzebika 01", distance: 688},
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 702},
        {type: OfferPoiType.BUS, name: "Rzebika 04", distance: 714},
        {type: OfferPoiType.BUS, name: "Rzebika 03", distance: 719},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 725},
        {type: OfferPoiType.TRAM, name: "Rzebika 02", distance: 740},
        {type: OfferPoiType.BUS, name: "Rzebika 08", distance: 750},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1005},
        {type: OfferPoiType.PARK, name: "Ptasi Zagajnik", distance: 1397},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 1526},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1680},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1699}
    ],
    17714: [
        {type: OfferPoiType.BUS, name: "Powstańców 52", distance: 286},
        {type: OfferPoiType.BUS, name: "Powstańców 01", distance: 409},
        {type: OfferPoiType.BUS, name: "Powstańców 02", distance: 414},
        {type: OfferPoiType.BUS, name: "Powstańców 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Powstańców 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Cmentarz 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Cmentarz 02", distance: 681},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Kawęczyn 02", distance: 770},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 2175}
    ],
    17717: [
        {type: OfferPoiType.PARK, name: "Skwer 700-lecia Ligoty Zabrskiej", distance: 250},
        {type: OfferPoiType.BUS, name: "Ligota Zabrska Dolna", distance: 401},
        {type: OfferPoiType.BUS, name: "Gliwice Górna", distance: 437},
        {type: OfferPoiType.BUS, name: "Gliwice Jacka", distance: 684},
        {type: OfferPoiType.BUS, name: "Ligota Zabrska Panewnicka [nż]", distance: 752},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Kalide", distance: 1749},
        {type: OfferPoiType.PARK, name: "Park Bolesława Chrobrego", distance: 1846}
    ],
    17729: [
        {type: OfferPoiType.BUS, name: "Tuwima - Wysoka", distance: 281},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 301},
        {type: OfferPoiType.TRAM, name: "Węglowa - Tramwajowa", distance: 392},
        {type: OfferPoiType.BUS, name: "Tuwima - Przędzalniana", distance: 421},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 470},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 518},
        {type: OfferPoiType.BUS, name: "Nawrot - Wysoka", distance: 527},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 532},
        {type: OfferPoiType.BUS, name: "Tuwima - Rodz. Kindermannów NŻ", distance: 551},
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 592},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 693},
        {type: OfferPoiType.TRAM, name: "Kopcińskiego - Tuwima", distance: 708},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 736},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 752},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 759},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 760},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 784},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 797},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 885},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 971},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 1013},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1066},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 1118},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 1183}
    ],
    17730: [
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 323},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 393},
        {type: OfferPoiType.BUS, name: "Legionów - Żeligowskiego", distance: 561},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka", distance: 575},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Srebrzyńska", distance: 604},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 604},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 632},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka NŻ", distance: 686},
        {type: OfferPoiType.BUS, name: "Zielona - 1 Maja", distance: 727},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 754},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 791},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 926},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 932},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 1121},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 1262},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1274},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1591},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 2352},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2399}
    ],
    17738: [
        {type: OfferPoiType.BUS, name: "Jaracza - Wierzbowa", distance: 128},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rewolucji 1905 r.", distance: 192},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 335},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 397},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rondo Solidarności", distance: 403},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 418},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 447},
        {type: OfferPoiType.BUS, name: "Narutowicza - Tramwajowa", distance: 451},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 499},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 504},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Rondo Solidarności", distance: 509},
        {type: OfferPoiType.TRAM, name: "Pomorska - Rondo Solidarności", distance: 553},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 556},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Kopcińskiego", distance: 579},
        {type: OfferPoiType.TRAM, name: "Kopcińskiego - Narutowicza", distance: 629},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 670},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 797},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 867},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 1156},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1211},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 1303},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1320},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1382}
    ],
    17745: [
        {type: OfferPoiType.BUS, name: "Młynek", distance: 289},
        {type: OfferPoiType.BUS, name: "Kotoniarska - Szybowa NŻ", distance: 351},
        {type: OfferPoiType.PARK, name: "Park na Młynku", distance: 497},
        {type: OfferPoiType.BUS, name: "Śląska - Kowalszczyzna NŻ", distance: 540},
        {type: OfferPoiType.BUS, name: "Lodowa - Lodowa 97 NŻ", distance: 843}
    ],
    17748: [
        {type: OfferPoiType.BUS, name: "Gliwice Komag", distance: 219},
        {type: OfferPoiType.BUS, name: "Gliwice Kujawska", distance: 299},
        {type: OfferPoiType.BUS, name: "Trynek Lotników", distance: 538},
        {type: OfferPoiType.BUS, name: "Gliwice Łużycka", distance: 670},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 684},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Rydet", distance: 692},
        {type: OfferPoiType.BUS, name: "Gliwice Arena Widowiskowo-Sportowa", distance: 705},
        {type: OfferPoiType.BUS, name: "Gliwice Kopalniana", distance: 738},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Lewczyńskiego", distance: 774},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 845},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny", distance: 990}
    ],
    17750: [
        {type: OfferPoiType.TRAM, name: "Stocznia Północna 02", distance: 369},
        {type: OfferPoiType.BUS, name: "Stocznia Północna 03", distance: 385},
        {type: OfferPoiType.TRAM, name: "Stocznia Północna 01", distance: 393},
        {type: OfferPoiType.BUS, name: "Stocznia Północna 04", distance: 536},
        {type: OfferPoiType.TRAM, name: "Twarda", distance: 716},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 1438},
        {type: OfferPoiType.PARK, name: 'Skwer "Stołówka"', distance: 1612},
        {type: OfferPoiType.PARK, name: "Park XXV-lecia Polski Rzeczypospolitej Ludowej", distance: 1812},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1997},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2110},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 2159}
    ],
    17751: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 04", distance: 432},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 03", distance: 697},
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 766},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 821},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1969},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 2021}
    ],
    17752: [
        {type: OfferPoiType.BUS, name: "Świstackiego", distance: 220},
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej", distance: 516},
        {type: OfferPoiType.TRAM, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 553},
        {type: OfferPoiType.BUS, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 563},
        {type: OfferPoiType.TRAM, name: "Komuny Paryskiej", distance: 641},
        {type: OfferPoiType.BUS, name: "Na Niskich Łąkach", distance: 655},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 675},
        {type: OfferPoiType.TRAM, name: "Na Niskich Łąkach", distance: 734},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1039},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 1120},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Mikołaja Kopernika", distance: 1615},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2030}
    ],
    17753: [
        {type: OfferPoiType.BUS, name: "Sosnowiec Teatralna", distance: 60},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Wspólna", distance: 231},
        {type: OfferPoiType.BUS, name: "Sosnowiec Wspólna", distance: 262},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dęblińska", distance: 381},
        {type: OfferPoiType.BUS, name: "Sosnowiec Mierosławskiego", distance: 389},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dęblińska", distance: 398},
        {type: OfferPoiType.BUS, name: "Sosnowiec Kościelna", distance: 509},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Południowy", distance: 533},
        {type: OfferPoiType.BUS, name: "Sosnowiec Sienkiewicza", distance: 536},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dworzec PKP", distance: 560},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dworzec PKP", distance: 615},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Małachowskiego", distance: 723},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Piłsudskiego/Sobieskiego", distance: 734},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Główny", distance: 738},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Aleja Zwycięstwa", distance: 768},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Ostrogórska", distance: 826},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 1180},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Harcerski", distance: 1439},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jana Antoniego Strzeleckiego", distance: 1729},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 1816},
        {type: OfferPoiType.PARK, name: "Park Dietla", distance: 1993},
        {type: OfferPoiType.REZERWAT, name: 'Zespół Przyrodniczo-Krajobrazowy "Szopienice-Borki"', distance: 1993},
        {type: OfferPoiType.REZERWAT, name: "Kruszczyk Szerokolistny w Lasku Stawiki", distance: 2381}
    ],
    17755: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 618},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 787},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 800},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 1052},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 1091},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1615},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1874},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2329}
    ],
    17760: [
        {type: OfferPoiType.BUS, name: "Dąb Widok", distance: 246},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 524},
        {type: OfferPoiType.BUS, name: "Koszutka Kościół", distance: 551},
        {type: OfferPoiType.BUS, name: "Józefowiec Jabłoniowa", distance: 614},
        {type: OfferPoiType.BUS, name: "Katowice Stęślickiego", distance: 621},
        {type: OfferPoiType.TRAM, name: "Dąb Huta Baildon", distance: 699},
        {type: OfferPoiType.TRAM, name: "Katowice Stęślickiego", distance: 701},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 718},
        {type: OfferPoiType.BUS, name: "Dąb Silesia City Center", distance: 736},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 772},
        {type: OfferPoiType.BUS, name: "Koszutka Kino Kosmos", distance: 781},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 939},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1051},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1220},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1314},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Pająka", distance: 1388}
    ],
    17762: [
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 01", distance: 383},
        {type: OfferPoiType.BUS, name: "Poligonowa - Osiedle 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Poligonowa - osiedle 02", distance: 685},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1120}
    ],
    17764: [
        {type: OfferPoiType.BUS, name: "Os. Marywilska 02", distance: 543},
        {type: OfferPoiType.BUS, name: "Os. Marywilska 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Os. Marywilska 04", distance: 635},
        {type: OfferPoiType.BUS, name: "Marcelin 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Marcelin 04", distance: 723},
        {type: OfferPoiType.BUS, name: "Marcelin 05", distance: 760},
        {type: OfferPoiType.BUS, name: "Marcelin 03", distance: 770},
        {type: OfferPoiType.BUS, name: "Marcelin 02", distance: 799},
        {type: OfferPoiType.BUS, name: "PKP Żerań 02", distance: 825},
        {type: OfferPoiType.BUS, name: "PKP Żerań 01", distance: 839},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 2069},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2139}
    ],
    17767: [{type: OfferPoiType.BUS, name: "Św. Katarzyna n.ż", distance: 606}],
    17769: [
        {type: OfferPoiType.BUS, name: "Północna - Kamińskiego", distance: 167},
        {type: OfferPoiType.BUS, name: "Północna - Sterlinga", distance: 380},
        {type: OfferPoiType.BUS, name: "Sterlinga - Północna", distance: 475},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 504},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pomorska", distance: 610},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 616},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 632},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 654},
        {type: OfferPoiType.BUS, name: "Źródłowa - Bulwary Nad Łódką NŻ", distance: 682},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 757},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 780},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1090},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1143},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 1313}
    ],
    17772: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    17775: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    17776: [
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 638},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 693},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 2121}
    ],
    17782: [
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 311},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 713},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1562},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1767},
        {type: OfferPoiType.PARK, name: "Górki Służewskie", distance: 1897},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1898},
        {type: OfferPoiType.PARK, name: "Arkadia", distance: 1927},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2286}
    ],
    17783: [
        {type: OfferPoiType.BUS, name: "Dzikiej Róży 02", distance: 771},
        {type: OfferPoiType.BUS, name: "Dzikiej Róży 01", distance: 783}
    ],
    17785: [
        {type: OfferPoiType.BUS, name: "3 Maja 02", distance: 763},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 764},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 954},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 967},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1126}
    ],
    17792: [{type: OfferPoiType.BUS, name: "Łady-Szkoła 02", distance: 819}],
    17793: [
        {type: OfferPoiType.BUS, name: "Trzebnicka", distance: 456},
        {type: OfferPoiType.TRAM, name: "Trzebnicka", distance: 465},
        {type: OfferPoiType.BUS, name: "Zakładowa", distance: 519},
        {type: OfferPoiType.TRAM, name: "Dworzec Nadodrze", distance: 539},
        {type: OfferPoiType.BUS, name: "Dworzec Nadodrze", distance: 548},
        {type: OfferPoiType.BUS, name: "Kręta", distance: 595},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 655},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Nadodrze", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 863},
        {type: OfferPoiType.PARK, name: "Park Świętego Macieja", distance: 1097},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 1363},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 2467}
    ],
    17796: [
        {type: OfferPoiType.BUS, name: "Rotmanka Rondo", distance: 345},
        {type: OfferPoiType.BUS, name: "Rotmanka - Rondo 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Rotmanka Piłsudskiego", distance: 574},
        {type: OfferPoiType.BUS, name: "Rondo Bursztynowe 01", distance: 827},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 2368}
    ],
    17800: [
        {type: OfferPoiType.BUS, name: "Krokusów 02", distance: 612},
        {type: OfferPoiType.BUS, name: "Krokusów 01", distance: 655},
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 02", distance: 695},
        {type: OfferPoiType.BUS, name: "MERA-PNEFAL 01", distance: 705},
        {type: OfferPoiType.BUS, name: "Liliowa 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Liliowa 02", distance: 749},
        {type: OfferPoiType.BUS, name: "Liliowa 04", distance: 756},
        {type: OfferPoiType.BUS, name: "Kosodrzewiny 01", distance: 780},
        {type: OfferPoiType.BUS, name: "Jachowicza 01", distance: 783},
        {type: OfferPoiType.BUS, name: "Bysławska 01", distance: 783}
    ],
    17812: [
        {type: OfferPoiType.BUS, name: "Bora-Komorowskiego 02", distance: 8},
        {type: OfferPoiType.BUS, name: "Bora-Komorowskiego 01", distance: 208},
        {type: OfferPoiType.BUS, name: "Cogiteon 02", distance: 426},
        {type: OfferPoiType.BUS, name: "Cogiteon 01", distance: 506},
        {type: OfferPoiType.BUS, name: "Olsza II 74", distance: 629},
        {type: OfferPoiType.BUS, name: "Akacjowa 01", distance: 638},
        {type: OfferPoiType.BUS, name: "Akacjowa 02", distance: 672},
        {type: OfferPoiType.BUS, name: "Spadochroniarzy 02", distance: 765},
        {type: OfferPoiType.BUS, name: "Rondo Barei 02", distance: 778},
        {type: OfferPoiType.BUS, name: "Os. Oświecenia 02", distance: 802},
        {type: OfferPoiType.PARK, name: "Lotniczy Park Kulturowy", distance: 1136},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 1224},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy przy ul. Chałupnika", distance: 1277},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1500},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 1724}
    ],
    17814: [
        {type: OfferPoiType.TRAM, name: "Winnica 04", distance: 478},
        {type: OfferPoiType.TRAM, name: "Winnica 03", distance: 488},
        {type: OfferPoiType.BUS, name: "Winnica 73", distance: 489},
        {type: OfferPoiType.BUS, name: "Winnica 02", distance: 493},
        {type: OfferPoiType.BUS, name: "Winnica 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Winnica 06", distance: 519},
        {type: OfferPoiType.BUS, name: "Winnica 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Winnica 11", distance: 558},
        {type: OfferPoiType.TRAM, name: "Winnica 05", distance: 581},
        {type: OfferPoiType.BUS, name: "Winnica 13", distance: 644},
        {type: OfferPoiType.TRAM, name: "Winnica 72", distance: 650},
        {type: OfferPoiType.BUS, name: "Grzymalitów 02", distance: 668},
        {type: OfferPoiType.TRAM, name: "Winnica 71", distance: 675},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 05", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 745},
        {type: OfferPoiType.BUS, name: "Poetów 01", distance: 754},
        {type: OfferPoiType.TRAM, name: "Grzymalitów 06", distance: 775},
        {type: OfferPoiType.BUS, name: "Grzymalitów 01", distance: 818},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 902},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1924},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 1971}
    ],
    17816: [
        {type: OfferPoiType.BUS, name: "Szklarniowa 02", distance: 523},
        {type: OfferPoiType.BUS, name: "Szklarniowa 01", distance: 616},
        {type: OfferPoiType.PARK, name: "Park im. Mariana Jonkajtysa", distance: 2116},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci", distance: 2337},
        {type: OfferPoiType.PARK, name: "Skwer im. Żołnierzy Wyklętych", distance: 2484}
    ],
    17819: [
        {type: OfferPoiType.BUS, name: "Urząd Statystyczny 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Urząd Statystyczny 02", distance: 322},
        {type: OfferPoiType.BUS, name: "Novotel 04", distance: 349},
        {type: OfferPoiType.BUS, name: "Jadwisin 01", distance: 545},
        {type: OfferPoiType.BUS, name: "Novotel 01", distance: 605},
        {type: OfferPoiType.BUS, name: "Novotel 02", distance: 661},
        {type: OfferPoiType.BUS, name: "Jadwisin 02", distance: 748},
        {type: OfferPoiType.BUS, name: "PKP Żwirki i Wigury 01", distance: 796},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Żwirki i Wigury", distance: 817},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 884},
        {type: OfferPoiType.PARK, name: "Fort Rakowiec", distance: 1302},
        {type: OfferPoiType.PARK, name: "Park Zasława Malickiego", distance: 1552},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1776},
        {type: OfferPoiType.PARK, name: "Cmentarz Mauzoleum Żołnierzy Radzieckich", distance: 1884}
    ],
    17823: [
        {type: OfferPoiType.BUS, name: "Prądzyńskiego 02", distance: 52},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia peron 9", distance: 336},
        {type: OfferPoiType.BUS, name: "Parafialna 02", distance: 353},
        {type: OfferPoiType.TRAM, name: "PKP Wola (Kasprzaka) 03", distance: 474},
        {type: OfferPoiType.BUS, name: "PKP Wola (Kasprzaka) 01", distance: 501},
        {type: OfferPoiType.TRAM, name: "PKP Wola (Kasprzaka) 04", distance: 530},
        {type: OfferPoiType.BUS, name: "Parafialna 01", distance: 542},
        {type: OfferPoiType.BUS, name: "PKP Wola (Kasprzaka) 06", distance: 623},
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 629},
        {type: OfferPoiType.BUS, name: "PKP Wola (Kasprzaka) 05", distance: 639},
        {type: OfferPoiType.BUS, name: "Armatnia 02", distance: 660},
        {type: OfferPoiType.BUS, name: "Dworzec Zachodni (Tunelowa) 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 676},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Wola", distance: 745},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 755},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zachodnia", distance: 784},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1288},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1314},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1456},
        {type: OfferPoiType.PARK, name: "Park im. Edwarda Szymańskiego", distance: 1472},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1547},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 1720}
    ],
    17824: [
        {type: OfferPoiType.TRAM, name: "Sternicza", distance: 491},
        {type: OfferPoiType.TRAM, name: "Gdańska", distance: 551},
        {type: OfferPoiType.BUS, name: "PCK 01", distance: 560},
        {type: OfferPoiType.BUS, name: "PCK 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Krasickiego 04", distance: 772},
        {type: OfferPoiType.BUS, name: "Brzeźno Dom Zdrojowy 05", distance: 775},
        {type: OfferPoiType.TRAM, name: "Brzeźno Dom Zdrojowy 03", distance: 799},
        {type: OfferPoiType.TRAM, name: "Brzeźno Dom Zdrojowy 02", distance: 803},
        {type: OfferPoiType.TRAM, name: "Brzeźno Dom Zdrojowy 01", distance: 810},
        {type: OfferPoiType.BUS, name: "Brzeźno Dom Zdrojowy 04", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Brzeźnieński im. J. J. Haffnera", distance: 1073},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1885}
    ],
    17827: [
        {type: OfferPoiType.KOLEJ, name: "Niechorze", distance: 631},
        {type: OfferPoiType.BUS, name: "Niechorze", distance: 703},
        {type: OfferPoiType.REZERWAT, name: "Liwskie Ujście", distance: 1244}
    ],
    17828: [
        {type: OfferPoiType.BUS, name: "Maczka - Pienista NŻ", distance: 147},
        {type: OfferPoiType.BUS, name: "Pienista - Komandorska", distance: 392},
        {type: OfferPoiType.BUS, name: "Maczka - Aeroklub NŻ", distance: 688},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1448}
    ],
    17832: [{type: OfferPoiType.REZERWAT, name: "Rezerwat Zaborów im. W.Tyrakowskiego", distance: 2370}],
    17833: [
        {type: OfferPoiType.BUS, name: "Zagórze Hala Sportowa", distance: 70},
        {type: OfferPoiType.PARK, name: "Park Kępa", distance: 413},
        {type: OfferPoiType.BUS, name: "Zagórze Piękna", distance: 671},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Hallera", distance: 1127},
        {type: OfferPoiType.PARK, name: "Skwer im. Antoniego Pilarza", distance: 1673},
        {type: OfferPoiType.PARK, name: "Planty im. Harcmistrza Stefana Piotrowskiego", distance: 1907},
        {type: OfferPoiType.PARK, name: "Park Mieroszewskich", distance: 2083},
        {type: OfferPoiType.PARK, name: "Park Śródmiejski", distance: 2146}
    ],
    17834: [
        {type: OfferPoiType.BUS, name: "Ługowa", distance: 117},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 271},
        {type: OfferPoiType.BUS, name: "Starościńska", distance: 531},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 650},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1727}
    ],
    17836: [
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Dom Kultury", distance: 384},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Centrum", distance: 407},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Plac Świętego Herberta", distance: 539},
        {type: OfferPoiType.BUS, name: "Obroki Dulęby", distance: 543},
        {type: OfferPoiType.PARK, name: "Plac Świętego Herberta", distance: 714},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Sławka", distance: 796},
        {type: OfferPoiType.PARK, name: 'Skwer Danuty Siedzikówny "Inki"', distance: 889},
        {type: OfferPoiType.PARK, name: "Skwer rotmistrza Witolda Pileckiego", distance: 946},
        {type: OfferPoiType.PARK, name: "Park Załęski", distance: 1601},
        {type: OfferPoiType.PARK, name: "Skwer Męczenników Oświęcimskich", distance: 2362},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 2404},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Węglarczyka", distance: 2420}
    ],
    17837: [
        {type: OfferPoiType.BUS, name: "Załęska Hałda Kolońska [nż]", distance: 170},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Rataja", distance: 607},
        {type: OfferPoiType.BUS, name: "Osiedle Witosa Droga Kochłowicka", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer rotmistrza Witolda Pileckiego", distance: 655},
        {type: OfferPoiType.BUS, name: "Załęska Hałda Bocheńskiego Autostrada", distance: 660},
        {type: OfferPoiType.PARK, name: 'Skwer Danuty Siedzikówny "Inki"', distance: 902},
        {type: OfferPoiType.PARK, name: "Plac Świętego Herberta", distance: 1144},
        {type: OfferPoiType.PARK, name: "Skwer Antoniego Węglarczyka", distance: 1157},
        {type: OfferPoiType.PARK, name: "Park Załęski", distance: 1788},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 1978}
    ],
    17841: [
        {type: OfferPoiType.BUS, name: "Skalna - Juhasowa", distance: 246},
        {type: OfferPoiType.BUS, name: "Skalna - Kasprowy Wierch NŻ", distance: 705},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1267},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1314},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1497}
    ],
    17844: [
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 232},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 270},
        {type: OfferPoiType.BUS, name: "Fordon Rynek", distance: 279},
        {type: OfferPoiType.BUS, name: "Rondo Buxakowskiego", distance: 355},
        {type: OfferPoiType.BUS, name: "Fordońska / Wiadukt", distance: 443},
        {type: OfferPoiType.BUS, name: "Wyzwolenia / Styki", distance: 641},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 744},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 827},
        {type: OfferPoiType.PARK, name: "Teren zielony w okolicy Wyszogrodu", distance: 1704},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1917}
    ],
    17845: [
        {type: OfferPoiType.BUS, name: "Termalna n/ż", distance: 420},
        {type: OfferPoiType.TRAM, name: "Termalna", distance: 547},
        {type: OfferPoiType.TRAM, name: "Św. Michała", distance: 716},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 1156},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 1528}
    ],
    17851: [
        {type: OfferPoiType.BUS, name: "Wrzosowa 07", distance: 78},
        {type: OfferPoiType.BUS, name: "Borówkowa 06", distance: 360},
        {type: OfferPoiType.BUS, name: "Borówkowa 05", distance: 366},
        {type: OfferPoiType.BUS, name: "Kalinowa 03", distance: 843}
    ],
    17852: [
        {type: OfferPoiType.BUS, name: "Poziomkowa 02", distance: 262},
        {type: OfferPoiType.BUS, name: "Poziomkowa 01", distance: 292},
        {type: OfferPoiType.BUS, name: "Nasturcjowa 02", distance: 492},
        {type: OfferPoiType.BUS, name: "Nasturcjowa 03", distance: 582},
        {type: OfferPoiType.BUS, name: "Węglarza 01", distance: 686},
        {type: OfferPoiType.BUS, name: "Węglarza 03", distance: 751},
        {type: OfferPoiType.BUS, name: "Węglarza 02", distance: 781},
        {type: OfferPoiType.BUS, name: "Węglarza 04", distance: 786},
        {type: OfferPoiType.PARK, name: "50-lecia", distance: 2362}
    ],
    17869: [
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 111},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 193},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 230},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 254},
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 334},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 419},
        {type: OfferPoiType.BUS, name: "Drwęcka 01", distance: 423},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 508},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1114},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1207},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1277},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1614},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1825},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1873},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1904},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 2202},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2373}
    ],
    17870: [
        {type: OfferPoiType.BUS, name: "Rybaki Górne 02", distance: 224},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 01", distance: 288},
        {type: OfferPoiType.BUS, name: "Aksamitna 01", distance: 369},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 02", distance: 436},
        {type: OfferPoiType.PARK, name: 'Skwer "Stołówka"', distance: 467},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 490},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 526},
        {type: OfferPoiType.BUS, name: "Łagiewniki 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Europejskie Centrum Solidarności 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Heweliusza 01", distance: 598},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 600},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 02", distance: 664},
        {type: OfferPoiType.TRAM, name: "Plac Solidarności 01", distance: 686},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 707},
        {type: OfferPoiType.BUS, name: "Plac Solidarności 04", distance: 728},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 875},
        {type: OfferPoiType.PARK, name: "Skwer Heweliusza", distance: 923},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1401},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1513},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1836}
    ],
    17872: [
        {type: OfferPoiType.BUS, name: "Zaściankowa 02", distance: 265},
        {type: OfferPoiType.BUS, name: "Syta 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Zaściankowa 01", distance: 399},
        {type: OfferPoiType.BUS, name: "Syta 02", distance: 470},
        {type: OfferPoiType.BUS, name: "Syta 03", distance: 514},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Wilanówka 01", distance: 683},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Wilanówka 02", distance: 713},
        {type: OfferPoiType.PARK, name: "Skwer nad Stawem Zawadowskim", distance: 1389},
        {type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 2306}
    ],
    17878: [
        {type: OfferPoiType.BUS, name: "Jordanowska 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Jordanowska 01", distance: 313},
        {type: OfferPoiType.BUS, name: "Skrajna 01", distance: 381},
        {type: OfferPoiType.BUS, name: "Skrajna 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Chabrowa 02", distance: 492},
        {type: OfferPoiType.BUS, name: "Chabrowa 01", distance: 591},
        {type: OfferPoiType.BUS, name: "Jordanowska 04", distance: 667},
        {type: OfferPoiType.BUS, name: "Pękowicka 03", distance: 670},
        {type: OfferPoiType.BUS, name: "Pękowicka 01", distance: 715},
        {type: OfferPoiType.BUS, name: "Pełczyńskiego 01", distance: 776},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 904},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1384},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 1937},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 2059},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2258}
    ],
    17894: [
        {type: OfferPoiType.BUS, name: "Miła bloki 04", distance: 264},
        {type: OfferPoiType.BUS, name: "Miła bloki 03", distance: 311},
        {type: OfferPoiType.BUS, name: "Strażacka / Sympatyczna 05", distance: 612},
        {type: OfferPoiType.BUS, name: "Miła dom kultury 05", distance: 667},
        {type: OfferPoiType.BUS, name: "Strażacka / Sympatyczna 06", distance: 682},
        {type: OfferPoiType.BUS, name: "Strażacka / Sikorskiego 08", distance: 692},
        {type: OfferPoiType.BUS, name: "Miła szkoła 06", distance: 705},
        {type: OfferPoiType.BUS, name: "Miła / Strażacka 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Strażacka / Sikorskiego 07", distance: 783},
        {type: OfferPoiType.BUS, name: "Miła / Strażacka 01", distance: 836},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Infułata Stanisława Maca", distance: 1429},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2406}
    ],
    17897: [
        {type: OfferPoiType.BUS, name: "Sarmacka 01", distance: 281},
        {type: OfferPoiType.BUS, name: "Sarmacka 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Vogla 05", distance: 526},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 03", distance: 555},
        {type: OfferPoiType.BUS, name: "Vogla 04", distance: 641},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 10", distance: 683},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 05", distance: 685},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 04", distance: 691},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 02", distance: 691},
        {type: OfferPoiType.BUS, name: "Vogla 01", distance: 693},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 06", distance: 720},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 08", distance: 721},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 71", distance: 767},
        {type: OfferPoiType.BUS, name: "Vogla 02", distance: 772},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 72", distance: 772},
        {type: OfferPoiType.BUS, name: "Vogla 03", distance: 798},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 953},
        {type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 2448}
    ],
    17901: [
        {type: OfferPoiType.BUS, name: "Jana Kazimierza 02", distance: 220},
        {type: OfferPoiType.BUS, name: "Jana Kazimierza 01", distance: 223},
        {type: OfferPoiType.TRAM, name: "Sowińskiego 02", distance: 225},
        {type: OfferPoiType.TRAM, name: "Sowińskiego 01", distance: 233},
        {type: OfferPoiType.BUS, name: "Sowińskiego 03", distance: 239},
        {type: OfferPoiType.BUS, name: "Sowińskiego 04", distance: 262},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 277},
        {type: OfferPoiType.PARK, name: "Park Powstańców Warszawy", distance: 405},
        {type: OfferPoiType.BUS, name: "Goleszowska 02", distance: 468},
        {type: OfferPoiType.BUS, name: "Fort Wola 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Goleszowska 01", distance: 542},
        {type: OfferPoiType.BUS, name: "Hubalczyków 01", distance: 549},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 04", distance: 556},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 03", distance: 562},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 04", distance: 570},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 05", distance: 578},
        {type: OfferPoiType.BUS, name: "Reduta Wolska 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Cm. Wolski 06", distance: 608},
        {type: OfferPoiType.TRAM, name: "Reduta Wolska 03", distance: 646},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Klincewicza", distance: 648},
        {type: OfferPoiType.TRAM, name: "Fort Wola 03", distance: 674},
        {type: OfferPoiType.TRAM, name: "Fort Wola 04", distance: 718},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer Wiesława Michnikowskiego", distance: 1322},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 1362},
        {type: OfferPoiType.PARK, name: "Park Józefa Sowińskiego", distance: 1600}
    ],
    17909: [
        {type: OfferPoiType.BUS, name: "Pl. Szoslanda - EC1 Centrum Nauki i Techniki", distance: 92},
        {type: OfferPoiType.BUS, name: "Wajdy - EC1 Centrum Komiksu", distance: 131},
        {type: OfferPoiType.BUS, name: "Tuwima - Kilińskiego (EC1 Centr. Nauki)", distance: 368},
        {type: OfferPoiType.BUS, name: "Dw. Łódź Fabryczna", distance: 381},
        {type: OfferPoiType.BUS, name: "Tuwima - Targowa (Planetarium)", distance: 415},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 419},
        {type: OfferPoiType.BUS, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 436},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 436},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 439},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 478},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 525},
        {type: OfferPoiType.KOLEJ, name: "Łódź Fabryczna", distance: 547},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 571},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 693},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 770},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 799},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 864},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 911},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 947}
    ],
    17910: [
        {type: OfferPoiType.BUS, name: "Okrąg 01", distance: 566},
        {type: OfferPoiType.PARK, name: "Staw Mysiadło", distance: 603},
        {type: OfferPoiType.BUS, name: "Iwiczna 01", distance: 623},
        {type: OfferPoiType.BUS, name: "Mysiadło 05", distance: 680},
        {type: OfferPoiType.BUS, name: "Mysiadło 04", distance: 689},
        {type: OfferPoiType.BUS, name: "Iwiczna 02", distance: 731},
        {type: OfferPoiType.BUS, name: "Graniczna 02", distance: 737},
        {type: OfferPoiType.BUS, name: "Mysiadło 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Mysiadło 02", distance: 793},
        {type: OfferPoiType.BUS, name: "Graniczna 01", distance: 837},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 2179},
        {type: OfferPoiType.PARK, name: "Skwer Hrabianki Ludwiki Małgorzaty Moriconi", distance: 2415}
    ],
    17915: [
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 02", distance: 126},
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 01", distance: 207},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 442},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 446},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 616},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 688},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 735},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 736},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 805}
    ],
    17916: [
        {type: OfferPoiType.BUS, name: "Szeligowskiego NŻ 01", distance: 247},
        {type: OfferPoiType.BUS, name: "Prusa 03", distance: 311},
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 376},
        {type: OfferPoiType.BUS, name: "Organowa 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Organowa 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Paganiniego 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Prusa 01", distance: 628},
        {type: OfferPoiType.BUS, name: "Paganiniego 03", distance: 708},
        {type: OfferPoiType.BUS, name: "Paganiniego 04", distance: 759},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 1084},
        {type: OfferPoiType.PARK, name: "Skwer Jurka Bitschana", distance: 1198},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 1282}
    ],
    17918: [
        {type: OfferPoiType.BUS, name: "Flisacka / Grunwaldzka", distance: 146},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Flisacka", distance: 277},
        {type: OfferPoiType.BUS, name: "Rondo Maczka P+R", distance: 549},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Zachód", distance: 628},
        {type: OfferPoiType.BUS, name: "Dworzec Zachód", distance: 793},
        {type: OfferPoiType.PARK, name: "Park nad Kanałem Bydgoskim", distance: 1020},
        {type: OfferPoiType.PARK, name: "Park przy papierni", distance: 1075}
    ],
    17927: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 122},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 150},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 163},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 165},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 178},
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 492},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 564},
        {type: OfferPoiType.BUS, name: "Banacha 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Banacha 03", distance: 624},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 634},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 685},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 713},
        {type: OfferPoiType.BUS, name: "Górka Narodowa P+R 04", distance: 758},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R 01", distance: 782},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R", distance: 833},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1499},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1542},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1893},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2520}
    ],
    17931: [
        {type: OfferPoiType.BUS, name: "Muchowskiego 02", distance: 472},
        {type: OfferPoiType.BUS, name: "Muchowskiego", distance: 482},
        {type: OfferPoiType.BUS, name: "Oksywie Górne 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Muchowskiego 01", distance: 535},
        {type: OfferPoiType.BUS, name: "Pancerna", distance: 583},
        {type: OfferPoiType.BUS, name: "Oksywie Górne 02", distance: 654},
        {type: OfferPoiType.BUS, name: "Oksywie - Górne", distance: 659},
        {type: OfferPoiType.BUS, name: "Oksywie Górne 01", distance: 663},
        {type: OfferPoiType.PARK, name: "Park Admirała Floty Andrzeja Karwety", distance: 1273},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 2172}
    ],
    17937: [
        {type: OfferPoiType.BUS, name: "Proletariacka - Sowia NŻ", distance: 520},
        {type: OfferPoiType.BUS, name: "Rembielińskiego - Inżynierska NŻ", distance: 607},
        {type: OfferPoiType.BUS, name: "Radwańska - Inżynierska NŻ", distance: 699},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1299},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1904},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1931},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1944}
    ],
    17946: [
        {type: OfferPoiType.BUS, name: "Mysiadło 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Mysiadło 04", distance: 417},
        {type: OfferPoiType.BUS, name: "Mysiadło 05", distance: 426},
        {type: OfferPoiType.PARK, name: "Staw Mysiadło", distance: 488},
        {type: OfferPoiType.BUS, name: "Mysiadło 02", distance: 546},
        {type: OfferPoiType.BUS, name: "Mysiadło 03", distance: 677},
        {type: OfferPoiType.BUS, name: "Dąbrówka 01", distance: 696},
        {type: OfferPoiType.BUS, name: "Dąbrówka 03", distance: 732},
        {type: OfferPoiType.BUS, name: "Dąbrówka 02", distance: 736}
    ],
    17948: [
        {type: OfferPoiType.BUS, name: "Dachowa/Kręta n/ż", distance: 638},
        {type: OfferPoiType.BUS, name: "Dachowa/Tęczowa", distance: 773},
        {type: OfferPoiType.BUS, name: "Dachowa/Wiatrakowa n/ż", distance: 809},
        {type: OfferPoiType.PARK, name: "Park wiejski w Robakowie", distance: 1904}
    ],
    17957: [
        {type: OfferPoiType.BUS, name: "Biedrusko/Park", distance: 261},
        {type: OfferPoiType.BUS, name: "Biedrusko/Jednostka Wojskowa", distance: 638}
    ],
    17964: [
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Kozielska", distance: 281},
        {type: OfferPoiType.BUS, name: "Gliwice Cmentarz Centralny", distance: 290},
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Ordona", distance: 381},
        {type: OfferPoiType.BUS, name: "Osiedle Wojska Polskiego Czwartaków", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Szwajcaria", distance: 1036},
        {type: OfferPoiType.PARK, name: "Park Starokozielski", distance: 1105}
    ],
    17966: [
        {type: OfferPoiType.BUS, name: "Sielanka 02", distance: 680},
        {type: OfferPoiType.BUS, name: "Sielanka 03", distance: 717},
        {type: OfferPoiType.BUS, name: "Park Decjusza 01", distance: 760},
        {type: OfferPoiType.BUS, name: "Sielanka 04", distance: 772},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 779},
        {type: OfferPoiType.BUS, name: "Sielanka 01", distance: 784},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 788},
        {type: OfferPoiType.BUS, name: "Park Decjusza 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1614},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1924},
        {type: OfferPoiType.PARK, name: "Park Fort 2 „Kościuszko” imienia Profesora Janusza Bogdanowskiego", distance: 2490}
    ],
    17970: [
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 282},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 01", distance: 420},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 03", distance: 449},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 02", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 481},
        {type: OfferPoiType.TRAM, name: "Wojnicka 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Wołomińska 02", distance: 608},
        {type: OfferPoiType.BUS, name: "Śnieżna 02", distance: 666},
        {type: OfferPoiType.TRAM, name: "Wojnicka 02", distance: 676},
        {type: OfferPoiType.BUS, name: "Śnieżna 01", distance: 683},
        {type: OfferPoiType.BUS, name: "Naczelnikowska 02", distance: 696},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 709},
        {type: OfferPoiType.BUS, name: "Naczelnikowska 01", distance: 712},
        {type: OfferPoiType.BUS, name: "Wołomińska 01", distance: 720},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Praga 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Młyn Michla 01", distance: 814},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Praga 02", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1525},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 1892},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 2176}
    ],
    17971: [
        {type: OfferPoiType.BUS, name: "Bieszczadzka 01 (ŃŻ)", distance: 721},
        {type: OfferPoiType.BUS, name: "Bieszczadzka", distance: 723},
        {type: OfferPoiType.BUS, name: "Bieszczadzka 02 (ŃŻ)", distance: 724},
        {type: OfferPoiType.PARK, name: "Zieleniec Parterowa", distance: 2514}
    ],
    17982: [
        {type: OfferPoiType.BUS, name: "Telefoniczna - Bystrzycka NŻ", distance: 89},
        {type: OfferPoiType.BUS, name: "Doły - Telefoniczna NŻ", distance: 206},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Tamka NŻ", distance: 325},
        {type: OfferPoiType.BUS, name: "Tamka - Telefoniczna NŻ", distance: 396},
        {type: OfferPoiType.BUS, name: "Doły - Smutna NŻ", distance: 682},
        {type: OfferPoiType.BUS, name: "Tamka - Styrska NŻ", distance: 719},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Telefoniczna 27 NŻ", distance: 810},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1453},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 1588},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1648},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1817},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1851},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1893},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1993},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 2003},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 2041}
    ],
    17983: [
        {type: OfferPoiType.BUS, name: "Bańgów Kościół", distance: 253},
        {type: OfferPoiType.PARK, name: "Skwer tajnej organizacji nauczycielskiej", distance: 449},
        {type: OfferPoiType.BUS, name: "Bańgów Zachodnia", distance: 814},
        {type: OfferPoiType.REZERWAT, name: 'Obszar chronionego krajobrazu "Przełajka"', distance: 1490},
        {type: OfferPoiType.PARK, name: 'Free Time Park "Brodzik"', distance: 2155},
        {type: OfferPoiType.REZERWAT, name: "Bażantarnia", distance: 2318}
    ],
    17986: [
        {type: OfferPoiType.BUS, name: "Mosty Warszawskie", distance: 80},
        {type: OfferPoiType.TRAM, name: "Mosty Warszawskie", distance: 86},
        {type: OfferPoiType.BUS, name: "Damrota", distance: 365},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 533},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 534},
        {type: OfferPoiType.BUS, name: "Kromera", distance: 659},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 730},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego", distance: 812},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 972},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1077},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1105},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1119},
        {type: OfferPoiType.PARK, name: "park Porucznika Roberta Marczewskiego", distance: 1396},
        {type: OfferPoiType.PARK, name: "skwer Skaczącej Gwiazdy", distance: 1475}
    ],
    17989: [
        {type: OfferPoiType.BUS, name: "Cmentarz Podgórski 04", distance: 529},
        {type: OfferPoiType.TRAM, name: "Cmentarz Podgórski 02", distance: 532},
        {type: OfferPoiType.TRAM, name: "Cmentarz Podgórski 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Cmentarz Podgórski 03", distance: 598},
        {type: OfferPoiType.BUS, name: "Dworcowa 05", distance: 641},
        {type: OfferPoiType.TRAM, name: "Dworcowa 01", distance: 641},
        {type: OfferPoiType.BUS, name: "Dworcowa 04", distance: 661},
        {type: OfferPoiType.TRAM, name: "Dworcowa 02", distance: 670},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 959},
        {type: OfferPoiType.PARK, name: "Baśniowy Ogród", distance: 991},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 1341},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 1645},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 1701}
    ],
    17990: [
        {type: OfferPoiType.BUS, name: "Telefoniczna - Bystrzycka NŻ", distance: 85},
        {type: OfferPoiType.BUS, name: "Doły - Telefoniczna NŻ", distance: 202},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Tamka NŻ", distance: 321},
        {type: OfferPoiType.BUS, name: "Tamka - Telefoniczna NŻ", distance: 392},
        {type: OfferPoiType.BUS, name: "Doły - Smutna NŻ", distance: 678},
        {type: OfferPoiType.BUS, name: "Tamka - Styrska NŻ", distance: 715},
        {type: OfferPoiType.BUS, name: "Telefoniczna - Telefoniczna 27 NŻ", distance: 806},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1449},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 1584},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1644},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1813},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1847},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1889},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1989},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1999},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 2037}
    ],
    17994: [
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 153},
        {type: OfferPoiType.BUS, name: "Port", distance: 237},
        {type: OfferPoiType.BUS, name: "Centrum 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Plac Kościelny", distance: 305},
        {type: OfferPoiType.BUS, name: "Port 05", distance: 324},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 03", distance: 329},
        {type: OfferPoiType.BUS, name: "Centrum 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 04", distance: 340},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 384},
        {type: OfferPoiType.BUS, name: "Chrobrego 02", distance: 487},
        {type: OfferPoiType.LAS, name: "Parki Miejski im. Fryderyka Chopina", distance: 594},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 594}
    ],
    18002: [
        {type: OfferPoiType.BUS, name: "Tychy Bielska Wiadukt", distance: 283},
        {type: OfferPoiType.BUS, name: "Tychy Żwakowska", distance: 287},
        {type: OfferPoiType.KOLEJ, name: "Tychy Aleja Bielska", distance: 301},
        {type: OfferPoiType.BUS, name: "Tychy Bielska Szpital", distance: 488},
        {type: OfferPoiType.BUS, name: "Tychy Jana Pawła II", distance: 488},
        {type: OfferPoiType.KOLEJ, name: "Tychy Zachodnie", distance: 594},
        {type: OfferPoiType.BUS, name: "Tychy Osiedle M", distance: 608},
        {type: OfferPoiType.BUS, name: "Tychy Harcerska", distance: 642},
        {type: OfferPoiType.PARK, name: "Skwer przy ul. Czarnieckiego", distance: 740},
        {type: OfferPoiType.KOLEJ, name: "Tychy Grota Roweckiego", distance: 763},
        {type: OfferPoiType.PARK, name: "Park Jaworek", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer imienia Marii i Lecha Kaczyńskich", distance: 895},
        {type: OfferPoiType.PARK, name: "Skwer przy Bałuckiego", distance: 1031},
        {type: OfferPoiType.PARK, name: "Park Suble", distance: 1037},
        {type: OfferPoiType.PARK, name: "Park Niedźwiadków", distance: 1101}
    ],
    18008: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 650},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 684},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 728},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 732},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1076},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1639},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1721}
    ],
    18009: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 610},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 689},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 723},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 767},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 771},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1678},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1760}
    ],
    18016: [
        {type: OfferPoiType.BUS, name: "Moniuszki / Leclerc", distance: 129},
        {type: OfferPoiType.BUS, name: "11 Listopada / Biblioteka", distance: 143},
        {type: OfferPoiType.BUS, name: "Reja", distance: 218},
        {type: OfferPoiType.BUS, name: "3 Maja", distance: 354},
        {type: OfferPoiType.PARK, name: "Park Henryka Sienkiewicza", distance: 363},
        {type: OfferPoiType.BUS, name: "11 Listopada / Urząd Gminy", distance: 444},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy Oleśnica", distance: 469},
        {type: OfferPoiType.KOLEJ, name: "Oleśnica", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Kolejarzy Oleśnickich", distance: 888},
        {type: OfferPoiType.PARK, name: "Park Południowy", distance: 890},
        {type: OfferPoiType.PARK, name: "Park Książąt Oleśnickich", distance: 1056},
        {type: OfferPoiType.PARK, name: "Skwer Kombatantów", distance: 1374},
        {type: OfferPoiType.PARK, name: "Park Nad Stawami", distance: 1783}
    ],
    18024: [
        {type: OfferPoiType.BUS, name: "Zjazdowa - Beskidzka NŻ", distance: 151},
        {type: OfferPoiType.BUS, name: "Marmurowa - Beskidzka NŻ", distance: 407},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Budy", distance: 439},
        {type: OfferPoiType.BUS, name: "Marmurowa - Brzezińska", distance: 576},
        {type: OfferPoiType.BUS, name: "Brzezińska - Marmurowa", distance: 748},
        {type: OfferPoiType.BUS, name: "Zjazdowa - Opolska NŻ", distance: 793},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 1392}
    ],
    18025: [
        {type: OfferPoiType.BUS, name: "Katowice Bonifraterska", distance: 231},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 457},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 499},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 505},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 505},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 611},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 627},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury", distance: 631},
        {type: OfferPoiType.BUS, name: "Bogucice Markiefki", distance: 713},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury NOSPR", distance: 790},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 966},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1084},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1097},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1307}
    ],
    18028: [
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 51},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 558},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 570},
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 691},
        {type: OfferPoiType.BUS, name: "Olszynowa 02", distance: 826}
    ],
    18030: [
        {type: OfferPoiType.LAS, name: "Krynicki starodrzew", distance: 652},
        {type: OfferPoiType.REZERWAT, name: "Krynicki starodrzew", distance: 652},
        {type: OfferPoiType.REZERWAT, name: "Park Krajobrazowy Mierzeja Wiślana", distance: 1128}
    ],
    18031: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 188},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 333},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Hallera", distance: 349},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 423},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Pogonowskiego", distance: 431},
        {type: OfferPoiType.BUS, name: "Żeligowskiego - Pl. Hallera", distance: 477},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 492},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 542},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 584},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 594},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 661},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 678},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 789},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 846}
    ],
    18035: [
        {type: OfferPoiType.BUS, name: "Galeria Szperk 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Galeria Szperk", distance: 547},
        {type: OfferPoiType.BUS, name: "Maciejewicza 02", distance: 698},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 02", distance: 709},
        {type: OfferPoiType.BUS, name: "Maciejewicza", distance: 719},
        {type: OfferPoiType.BUS, name: "Maciejewicza 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Pogórze-Derdowskiego 02", distance: 756},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 01", distance: 763},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 02", distance: 781},
        {type: OfferPoiType.BUS, name: "Obłuże Maciejewicza", distance: 802},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1178},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1747},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 1939}
    ],
    18036: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 289},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 330},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 733},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 744},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 760},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1788}
    ],
    18037: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 288},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 371},
        {type: OfferPoiType.TRAM, name: "Żeromskiego", distance: 414},
        {type: OfferPoiType.BUS, name: "Żeromskiego n/ż", distance: 444},
        {type: OfferPoiType.BUS, name: "Niestachowska", distance: 554},
        {type: OfferPoiType.BUS, name: "Niestachowska n/ż", distance: 762},
        {type: OfferPoiType.BUS, name: "Św. Wawrzyńca", distance: 800},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1476},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1498},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 1634},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1865},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1939},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1945},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 1995},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 2038}
    ],
    18047: [
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 04", distance: 305},
        {type: OfferPoiType.TRAM, name: "Galeria Bałtycka 02", distance: 388},
        {type: OfferPoiType.TRAM, name: "Galeria Bałtycka 01", distance: 464},
        {type: OfferPoiType.PARK, name: "Park de Gaulle'a", distance: 489},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 06", distance: 510},
        {type: OfferPoiType.TRAM, name: "Klonowa", distance: 524},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 05", distance: 528},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 07", distance: 565},
        {type: OfferPoiType.PARK, name: 'Dawny cmentarz katolicki "Urania"', distance: 600},
        {type: OfferPoiType.BUS, name: "Galeria Bałtycka 03", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterskiego Mariupola", distance: 706},
        {type: OfferPoiType.BUS, name: "Wrzeszcz PKP", distance: 710},
        {type: OfferPoiType.BUS, name: "Jaśkowa Dolina 03", distance: 758},
        {type: OfferPoiType.TRAM, name: "Jaśkowa Dolina 02", distance: 784},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Wrzeszcz", distance: 806},
        {type: OfferPoiType.TRAM, name: "Jaśkowa Dolina 01", distance: 822},
        {type: OfferPoiType.PARK, name: "Park Kuźniczki", distance: 948}
    ],
    18055: [
        {type: OfferPoiType.PARK, name: "Skwer przy PCK", distance: 1844},
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 1904},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 2094},
        {type: OfferPoiType.PARK, name: "Park im. Tysiąclecia", distance: 2382}
    ],
    18058: [
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 256},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 287},
        {type: OfferPoiType.BUS, name: "Kierbedzia 01", distance: 380},
        {type: OfferPoiType.BUS, name: "Hańczy 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 04", distance: 398},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 432},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 480},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 03", distance: 517},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 01", distance: 518},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 05", distance: 529},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 02", distance: 542},
        {type: OfferPoiType.BUS, name: "Tor Stegny 02", distance: 555},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 01", distance: 657},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 02", distance: 699},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 862},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1384},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1500},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1545},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1549},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1736},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1793},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1976},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 2008},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 2060},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2095},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2307}
    ],
    18059: [
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 223},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 03", distance: 441},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 01", distance: 497},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 530},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 02", distance: 545},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 624},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 637},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 940}
    ],
    18076: [
        {type: OfferPoiType.BUS, name: "Karolkowa 01", distance: 510},
        {type: OfferPoiType.TRAM, name: "Karolkowa 04", distance: 520},
        {type: OfferPoiType.TRAM, name: "Karolkowa 03", distance: 543},
        {type: OfferPoiType.BUS, name: "Karolkowa 02", distance: 548},
        {type: OfferPoiType.BUS, name: "Rondo Daszyńskiego 09", distance: 573},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Główna", distance: 662},
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 692},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 703},
        {type: OfferPoiType.BUS, name: "Spiska 02", distance: 729},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 14", distance: 790},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 11", distance: 795},
        {type: OfferPoiType.BUS, name: "Rondo Daszyńskiego 02", distance: 796},
        {type: OfferPoiType.METRO, name: "Rondo Daszyńskiego", distance: 801},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 08", distance: 804},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 884},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 928},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1262},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1585},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1611},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1732},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1811},
        {type: OfferPoiType.PARK, name: "Skwer Sue Ryder", distance: 1871}
    ],
    18094: [
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 248},
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 341},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 622},
        {type: OfferPoiType.BUS, name: "Klonowa (NŻ)", distance: 630},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 707},
        {type: OfferPoiType.BUS, name: "Dębogórze-Wybudowanie - Długa 01", distance: 783},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1221},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1261},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1922},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 2285}
    ],
    18103: [
        {type: OfferPoiType.BUS, name: "Sołtysowska 04", distance: 210},
        {type: OfferPoiType.BUS, name: "ZDMK 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Sołtysowska 02", distance: 303},
        {type: OfferPoiType.BUS, name: "Sołtysowska 01", distance: 310},
        {type: OfferPoiType.BUS, name: "ZDMK 02", distance: 346},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 564},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 01", distance: 607},
        {type: OfferPoiType.BUS, name: "Centralna 01", distance: 619},
        {type: OfferPoiType.BUS, name: "Ciesielskiego 01", distance: 631},
        {type: OfferPoiType.BUS, name: "Centralna 02", distance: 664},
        {type: OfferPoiType.TRAM, name: "Gałczyńskiego 01", distance: 754},
        {type: OfferPoiType.TRAM, name: "Gałczyńskiego 02", distance: 770},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1264},
        {type: OfferPoiType.PARK, name: "Ogród Doświadczeń im. Stanisława Lema", distance: 1694},
        {type: OfferPoiType.PARK, name: "Park Lotników Polskich", distance: 2003},
        {type: OfferPoiType.PARK, name: "Ogródek Wiewiórek", distance: 2211},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2244},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 2257},
        {type: OfferPoiType.PARK, name: "Avia Parkour Park", distance: 2304},
        {type: OfferPoiType.PARK, name: "Park Czyżyny", distance: 2373}
    ],
    18105: [
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 156},
        {type: OfferPoiType.BUS, name: "Os. Winiary", distance: 565},
        {type: OfferPoiType.BUS, name: "Witosa Wiadukt", distance: 617},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 689},
        {type: OfferPoiType.BUS, name: "Dojazd n/ż", distance: 717},
        {type: OfferPoiType.TRAM, name: "Os. Winiary", distance: 727},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1879},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1932},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 2025},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 2155},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 2224},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2301},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2412}
    ],
    18106: [
        {type: OfferPoiType.BUS, name: "Sarni Potok", distance: 644},
        {type: OfferPoiType.BUS, name: "Osiedle Sarni Stok", distance: 669},
        {type: OfferPoiType.PARK, name: "Skwer Bohdana Smolenia", distance: 1814},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1954}
    ],
    18107: [
        {type: OfferPoiType.BUS, name: "Głęboka 91", distance: 352},
        {type: OfferPoiType.TRAM, name: "Głęboka 02", distance: 413},
        {type: OfferPoiType.BUS, name: "Głęboka 01", distance: 430},
        {type: OfferPoiType.TRAM, name: "Głęboka 01", distance: 445},
        {type: OfferPoiType.BUS, name: "Mostek 01", distance: 450},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 532},
        {type: OfferPoiType.BUS, name: "Mostek 02", distance: 558},
        {type: OfferPoiType.BUS, name: "Elbląska", distance: 626},
        {type: OfferPoiType.BUS, name: "Brama Żuławska 05", distance: 678},
        {type: OfferPoiType.TRAM, name: "Brama Żuławska", distance: 761},
        {type: OfferPoiType.BUS, name: "Miałki Szlak 01", distance: 790},
        {type: OfferPoiType.BUS, name: "Brama Żuławska 06", distance: 798},
        {type: OfferPoiType.BUS, name: "Brama Żuławska", distance: 826},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1077},
        {type: OfferPoiType.PARK, name: "Skwer Bajki", distance: 1242},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 1319},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1648}
    ],
    18111: [
        {type: OfferPoiType.BUS, name: "Suszki", distance: 204},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 546},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 576},
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 717},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 751},
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1285},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1397},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1594},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 1886},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2075},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2363},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2410},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2474}
    ],
    18115: [
        {type: OfferPoiType.BUS, name: "Willowa 02", distance: 344},
        {type: OfferPoiType.BUS, name: "Willowa 01", distance: 395},
        {type: OfferPoiType.BUS, name: "Olszynowa 02", distance: 613},
        {type: OfferPoiType.BUS, name: "Olszynowa 03", distance: 642}
    ],
    18117: [
        {type: OfferPoiType.BUS, name: "(N/Ż) Sandomierska / Nowy Folwark", distance: 183},
        {type: OfferPoiType.BUS, name: "(N/Ż) Sandomierska / Szczecińska", distance: 356},
        {type: OfferPoiType.BUS, name: "Sandomierska / Poleska", distance: 391},
        {type: OfferPoiType.BUS, name: "Szczecińska / Mazurska", distance: 570},
        {type: OfferPoiType.BUS, name: "Sandomierska / Morcinka", distance: 705},
        {type: OfferPoiType.BUS, name: "Sandomierska", distance: 744},
        {type: OfferPoiType.BUS, name: "Sandomierska / Śląska", distance: 748},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1312},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1447},
        {type: OfferPoiType.PARK, name: "Skwer im. Mikołaja Kopernika", distance: 1596},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1835},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1855},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2137},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Żeromskiego", distance: 2402}
    ],
    18123: [
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 322},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 354},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 422},
        {type: OfferPoiType.BUS, name: "Nadziei 01", distance: 453},
        {type: OfferPoiType.BUS, name: "Nadziei 02", distance: 559}
    ],
    18128: [
        {type: OfferPoiType.BUS, name: "Kopernika - Łąkowa", distance: 6},
        {type: OfferPoiType.TRAM, name: "Kopernika - Łąkowa", distance: 47},
        {type: OfferPoiType.BUS, name: "Łąkowa - Karolewska", distance: 216},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Pogonowskiego NŻ", distance: 293},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 298},
        {type: OfferPoiType.BUS, name: "Kopernika - Żeromskiego", distance: 321},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 391},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Kopernika", distance: 399},
        {type: OfferPoiType.TRAM, name: "Kopernika - Tobaco Park", distance: 401},
        {type: OfferPoiType.BUS, name: "Kopernika - Tobaco Park", distance: 407},
        {type: OfferPoiType.BUS, name: "Łąkowa - Struga", distance: 436},
        {type: OfferPoiType.BUS, name: "Skłodowskiej Curie - Żeromskiego", distance: 471},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 534},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Mickiewicza", distance: 549},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 569},
        {type: OfferPoiType.TRAM, name: "Mickiewicza - Żeromskiego", distance: 570},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 577},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 790},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 845},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2096}
    ],
    18132: [{type: OfferPoiType.BUS, name: "Krzeptów - Boisko", distance: 804}],
    18133: [
        {type: OfferPoiType.BUS, name: "Przymorze Wielkie", distance: 438},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 03", distance: 469},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 01", distance: 486},
        {type: OfferPoiType.BUS, name: "Biały Dwór 02", distance: 493},
        {type: OfferPoiType.BUS, name: "Biały Dwór 01", distance: 519},
        {type: OfferPoiType.BUS, name: "Czarny Dwór 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Olsztyńska 01", distance: 610},
        {type: OfferPoiType.BUS, name: "Olsztyńska 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Olsztyńska 04", distance: 685},
        {type: OfferPoiType.PARK, name: "Park imienia Ronalda Reagana", distance: 697},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1543},
        {type: OfferPoiType.PARK, name: "Skwer Kwitnących Wiśni", distance: 1563},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1738}
    ],
    18134: [
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 286},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 309},
        {type: OfferPoiType.BUS, name: "Krakowska", distance: 601},
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 651},
        {type: OfferPoiType.TRAM, name: "Krakowska", distance: 667},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1524},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1907},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2347}
    ],
    18137: [
        {type: OfferPoiType.BUS, name: "Dobra 01", distance: 81},
        {type: OfferPoiType.BUS, name: "Dobra 02", distance: 90},
        {type: OfferPoiType.BUS, name: "Wróbla 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Wróbla 01", distance: 310},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 581},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 01", distance: 649},
        {type: OfferPoiType.BUS, name: "Zagony", distance: 711},
        {type: OfferPoiType.BUS, name: "Chmielna 03", distance: 713},
        {type: OfferPoiType.TRAM, name: "Chmielna 01", distance: 716},
        {type: OfferPoiType.TRAM, name: "Chmielna 02", distance: 738},
        {type: OfferPoiType.TRAM, name: "Akademia Muzyczna", distance: 759},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 839},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 982},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1184},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1369},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2459}
    ],
    18138: [
        {type: OfferPoiType.BUS, name: "Katowice Piotra Skargi", distance: 77},
        {type: OfferPoiType.BUS, name: "Katowice Sokolska", distance: 173},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 178},
        {type: OfferPoiType.BUS, name: "Katowice Plac Synagogi", distance: 228},
        {type: OfferPoiType.BUS, name: "Katowice Mickiewicza", distance: 253},
        {type: OfferPoiType.TRAM, name: "Katowice Dworzec PKP", distance: 433},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 434},
        {type: OfferPoiType.TRAM, name: "Katowice Sokolska", distance: 465},
        {type: OfferPoiType.TRAM, name: "Katowice Rynek", distance: 472},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 551},
        {type: OfferPoiType.TRAM, name: "Katowice Rynek Teatr Śląski", distance: 622},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 714},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 736},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 854},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 895},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1000},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 1023},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 1128}
    ],
    18139: [
        {type: OfferPoiType.BUS, name: "Grochowe Łąki", distance: 130},
        {type: OfferPoiType.BUS, name: "Małe Garbary", distance: 253},
        {type: OfferPoiType.BUS, name: "Garbary PKM", distance: 376},
        {type: OfferPoiType.TRAM, name: "Małe Garbary", distance: 419},
        {type: OfferPoiType.KOLEJ, name: "Poznań Garbary", distance: 538},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 648},
        {type: OfferPoiType.PARK, name: "Skwer Marii i Lecha Kaczyńskich", distance: 809},
        {type: OfferPoiType.PARK, name: "Cmentarz Zasłużonych Wielkopolan", distance: 876},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 972},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 1054},
        {type: OfferPoiType.PARK, name: "Park Cytadela", distance: 1113},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1266},
        {type: OfferPoiType.PARK, name: "Park Szelągowski", distance: 1655},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1668},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 1773}
    ],
    18141: [
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 119},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 145},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 02", distance: 653},
        {type: OfferPoiType.BUS, name: "Mochnaniec 02", distance: 654},
        {type: OfferPoiType.BUS, name: "Piltza 04", distance: 680},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 692},
        {type: OfferPoiType.BUS, name: "Mochnaniec 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Skotniki Szkoła 03", distance: 738},
        {type: OfferPoiType.TRAM, name: "Czerwone Maki P+R 01", distance: 764},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 06", distance: 765},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 03", distance: 769},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1013},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2223},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2284}
    ],
    18145: [
        {type: OfferPoiType.BUS, name: "Myśliwska / Kameliowa 05", distance: 475},
        {type: OfferPoiType.BUS, name: "Rudna Wielka Myśliwska / Oliwkowa 34", distance: 570},
        {type: OfferPoiType.BUS, name: "Rudna Wielka Myśliwska / Oliwkowa 33", distance: 649},
        {type: OfferPoiType.BUS, name: "Myśliwska / Kameliowa 06", distance: 771}
    ],
    18146: [
        {type: OfferPoiType.BUS, name: "Koło 03", distance: 161},
        {type: OfferPoiType.BUS, name: "Koło 04", distance: 247},
        {type: OfferPoiType.TRAM, name: "Koło 02", distance: 247},
        {type: OfferPoiType.TRAM, name: "Koło 01", distance: 266},
        {type: OfferPoiType.BUS, name: "Koło 05", distance: 267},
        {type: OfferPoiType.BUS, name: "Dalibora 04", distance: 271},
        {type: OfferPoiType.BUS, name: "Koło 06", distance: 281},
        {type: OfferPoiType.TRAM, name: "Koło 71", distance: 349},
        {type: OfferPoiType.BUS, name: "Dalibora 03", distance: 355},
        {type: OfferPoiType.TRAM, name: "Koło 07", distance: 364},
        {type: OfferPoiType.TRAM, name: "Koło 08", distance: 369},
        {type: OfferPoiType.BUS, name: "Dalibora 01", distance: 416},
        {type: OfferPoiType.TRAM, name: "Dalibora 05", distance: 419},
        {type: OfferPoiType.TRAM, name: "Dalibora 06", distance: 463},
        {type: OfferPoiType.BUS, name: "Dalibora 02", distance: 474},
        {type: OfferPoiType.BUS, name: "Brożka 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Brożka 02", distance: 526},
        {type: OfferPoiType.PARK, name: "Park im. Księcia Janusza", distance: 575},
        {type: OfferPoiType.TRAM, name: "Deotymy 05", distance: 693},
        {type: OfferPoiType.TRAM, name: "Deotymy 06", distance: 737},
        {type: OfferPoiType.METRO, name: "Księcia Janusza", distance: 752},
        {type: OfferPoiType.PARK, name: "Park Ulricha", distance: 1010},
        {type: OfferPoiType.LAS, name: "Lasek na Kole", distance: 1121},
        {type: OfferPoiType.PARK, name: "Park Moczydło", distance: 1254}
    ],
    18148: [
        {type: OfferPoiType.BUS, name: "Wełnowiec Poczta", distance: 369},
        {type: OfferPoiType.TRAM, name: "Wełnowiec Kościół", distance: 510},
        {type: OfferPoiType.TRAM, name: "Koszutka Jesionowa", distance: 594},
        {type: OfferPoiType.BUS, name: "Koszutka Iłłakowiczówny", distance: 638},
        {type: OfferPoiType.BUS, name: "Koszutka Słoneczna", distance: 680},
        {type: OfferPoiType.TRAM, name: "Wełnowiec DL Tower", distance: 716},
        {type: OfferPoiType.LAS, name: "Park Wełnowiecki", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 722},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna Pętla", distance: 727},
        {type: OfferPoiType.TRAM, name: "Koszutka Słoneczna", distance: 806},
        {type: OfferPoiType.PARK, name: "Plac Świętego Józefa Robotnika", distance: 1126},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1135},
        {type: OfferPoiType.PARK, name: "Skwer Walentego Fojkisa", distance: 1256},
        {type: OfferPoiType.PARK, name: "Skwer Janusza Kalinowskiego", distance: 1407},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1504},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1505},
        {type: OfferPoiType.PARK, name: "Skwer Aspiranta Jana Górskiego", distance: 1692}
    ],
    18150: [
        {type: OfferPoiType.BUS, name: "Szobera 02", distance: 137},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 01", distance: 205},
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 233},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 03", distance: 315},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 04", distance: 343},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 02", distance: 395},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 407},
        {type: OfferPoiType.BUS, name: "Narwik 01", distance: 507},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 15", distance: 535},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 53", distance: 541},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 14", distance: 543},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 13", distance: 549},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 12", distance: 556},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 11", distance: 562},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 72", distance: 591},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 841}
    ],
    18151: [
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Usługowa", distance: 121},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Enea", distance: 173},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Polna Camping", distance: 248},
        {type: OfferPoiType.BUS, name: "Międzyzdroje - Polna Rondo", distance: 479},
        {type: OfferPoiType.PARK, name: "Park Rzeźb", distance: 1842},
        {type: OfferPoiType.PARK, name: "Park Międzyzdroje", distance: 1844},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy im. Fryderyka Chopina", distance: 1848}
    ],
    18152: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 499},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 634},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 747},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 768},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 794},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 803},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2273},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2476}
    ],
    18158: [
        {type: OfferPoiType.BUS, name: "Dolna 3 Maja 01", distance: 318},
        {type: OfferPoiType.PARK, name: "Plac Mieczysława Alberta Krąpca", distance: 416},
        {type: OfferPoiType.BUS, name: "Plac Litewski 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Plac Litewski 02", distance: 509},
        {type: OfferPoiType.BUS, name: "Prusa 02", distance: 748},
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 779},
        {type: OfferPoiType.BUS, name: "Plac Wolności 02", distance: 795},
        {type: OfferPoiType.BUS, name: "Lubomelska 02", distance: 808},
        {type: OfferPoiType.BUS, name: "Brama Krakowska 01", distance: 822},
        {type: OfferPoiType.PARK, name: "Plac Lecha Kaczyńskiego", distance: 1004}
    ],
    18159: [
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 03", distance: 44},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 05", distance: 80},
        {type: OfferPoiType.TRAM, name: "Wola-Ratusz 04", distance: 93},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 02", distance: 96},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 01", distance: 107},
        {type: OfferPoiType.BUS, name: "Wola-Ratusz 06", distance: 128},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 311},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 326},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Nowolipie 01", distance: 415},
        {type: OfferPoiType.BUS, name: "Okopowa 10", distance: 467},
        {type: OfferPoiType.TRAM, name: "Okopowa 03", distance: 468},
        {type: OfferPoiType.BUS, name: "Nowolipie 02", distance: 484},
        {type: OfferPoiType.BUS, name: "Okopowa 01", distance: 497},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 536},
        {type: OfferPoiType.TRAM, name: "Kino Femina 05", distance: 537},
        {type: OfferPoiType.TRAM, name: "Kino Femina 10", distance: 571},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 600},
        {type: OfferPoiType.TRAM, name: "Kino Femina 09", distance: 604},
        {type: OfferPoiType.TRAM, name: "Kino Femina 06", distance: 613},
        {type: OfferPoiType.TRAM, name: "Okopowa 08", distance: 637},
        {type: OfferPoiType.TRAM, name: "Okopowa 07", distance: 637},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 694},
        {type: OfferPoiType.TRAM, name: "Żytnia 02", distance: 770},
        {type: OfferPoiType.PARK, name: "Skwer Racheli Auerbach", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 850},
        {type: OfferPoiType.PARK, name: "Skwer gen. Jana Jura-Gorzechowskiego", distance: 913},
        {type: OfferPoiType.PARK, name: "Skwer Duśki Trafankowskiej", distance: 1037},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1106},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 2388}
    ],
    18160: [
        {type: OfferPoiType.BUS, name: "Zdrojowa/Leśna", distance: 497},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1119},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1131}
    ],
    18161: [
        {type: OfferPoiType.TRAM, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 239},
        {type: OfferPoiType.BUS, name: "Plac Zgody (Muzeum Etnograficzne)", distance: 250},
        {type: OfferPoiType.BUS, name: "Świstackiego", distance: 425},
        {type: OfferPoiType.BUS, name: "Plac Wróblewskiego", distance: 473},
        {type: OfferPoiType.BUS, name: "Na Grobli (Hydropolis)", distance: 526},
        {type: OfferPoiType.TRAM, name: "Plac Wróblewskiego", distance: 539},
        {type: OfferPoiType.BUS, name: "Komuny Paryskiej", distance: 552},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 676},
        {type: OfferPoiType.TRAM, name: "Komuny Paryskiej", distance: 677},
        {type: OfferPoiType.TRAM, name: "Na Niskich Łąkach", distance: 693},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 773},
        {type: OfferPoiType.PARK, name: "Skwer Zygmunta Krasińskiego", distance: 1049},
        {type: OfferPoiType.PARK, name: "Park Juliusza Słowackiego", distance: 1311},
        {type: OfferPoiType.PARK, name: "skwer Wrocławianek", distance: 1409},
        {type: OfferPoiType.REZERWAT, name: "Park Kulturowy „Stare Miasto”", distance: 1629}
    ],
    18162: [
        {type: OfferPoiType.BUS, name: "Plac Mickiewicza", distance: 374},
        {type: OfferPoiType.BUS, name: "Plac Żwirki i Wigury", distance: 380},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 560},
        {type: OfferPoiType.BUS, name: "Michałowicza Czarnieckiego", distance: 614},
        {type: OfferPoiType.BUS, name: "PCK PKP Lipnik", distance: 736},
        {type: OfferPoiType.BUS, name: "Sobieskiego Wyspiańskiego", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Włókniarzy", distance: 788}
    ],
    18179: [
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 559},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 578},
        {type: OfferPoiType.BUS, name: "Kamykowa 01", distance: 616},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1332}
    ],
    18183: [
        {type: OfferPoiType.BUS, name: "Rondo Kuronia 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Rondo Kuronia 02", distance: 232},
        {type: OfferPoiType.BUS, name: "Źródlana 01", distance: 481},
        {type: OfferPoiType.BUS, name: "Źródlana 02", distance: 508},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 686},
        {type: OfferPoiType.BUS, name: "Jasień Działki 01", distance: 710},
        {type: OfferPoiType.BUS, name: "Jasień Działki 02", distance: 792},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1327},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2303},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 2478}
    ],
    18184: [
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 63},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 178},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 192},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 285},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 341},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 487},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 500},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 579},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 606},
        {type: OfferPoiType.BUS, name: "Powstańców Magazyny 01", distance: 802},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1407},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1408}
    ],
    18221: [
        {type: OfferPoiType.BUS, name: "Piaśniki Skrzyżowanie", distance: 448},
        {type: OfferPoiType.BUS, name: "Piaśniki Szpital", distance: 465},
        {type: OfferPoiType.BUS, name: "Chropaczów Sudecka", distance: 480},
        {type: OfferPoiType.BUS, name: "Chropaczów Szkoła", distance: 544},
        {type: OfferPoiType.TRAM, name: "Chropaczów Szkoła", distance: 546},
        {type: OfferPoiType.TRAM, name: "Piaśniki Skrzyżowanie", distance: 551},
        {type: OfferPoiType.TRAM, name: "Chropaczów Osiedle Na Wzgórzu", distance: 582},
        {type: OfferPoiType.PARK, name: "Park Chropaczowski imieniem Kopalni Śląsk", distance: 590},
        {type: OfferPoiType.TRAM, name: "Piaśniki Szpital", distance: 672},
        {type: OfferPoiType.BUS, name: "Chropaczów Ratusz", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Heiloo", distance: 834},
        {type: OfferPoiType.LAS, name: "Zespół parkowo-leśny Piaśniki-Chropaczów", distance: 886},
        {type: OfferPoiType.REZERWAT, name: "Staw Foryśka", distance: 1054},
        {type: OfferPoiType.PARK, name: "Park Skałka", distance: 1503},
        {type: OfferPoiType.PARK, name: "Park Łagiewnicki", distance: 1595},
        {type: OfferPoiType.PARK, name: "Park Amelung", distance: 1638}
    ],
    18226: [
        {type: OfferPoiType.TRAM, name: "Plac Wolności", distance: 353},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Floriana Czakiego", distance: 368},
        {type: OfferPoiType.TRAM, name: "Plac Praw Kobiet", distance: 405},
        {type: OfferPoiType.TRAM, name: "Dworcowa / Matejki", distance: 436},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 439},
        {type: OfferPoiType.TRAM, name: "Plac Teatralny", distance: 445},
        {type: OfferPoiType.BUS, name: "Śniadeckich / Sienkiewicza", distance: 463},
        {type: OfferPoiType.TRAM, name: "Focha / Opera", distance: 478},
        {type: OfferPoiType.BUS, name: "Focha / Opera", distance: 487},
        {type: OfferPoiType.BUS, name: "Plac Teatralny", distance: 578},
        {type: OfferPoiType.BUS, name: "Śniadeckich / Gdańska", distance: 596},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 645},
        {type: OfferPoiType.BUS, name: "Królowej Jadwigi / Astoria", distance: 646},
        {type: OfferPoiType.BUS, name: "Plac Piastowski", distance: 687},
        {type: OfferPoiType.PARK, name: "Skwer Leona Barciszewskiego", distance: 712},
        {type: OfferPoiType.BUS, name: "Garbary", distance: 725},
        {type: OfferPoiType.BUS, name: "Rondo Jagiellonów", distance: 725},
        {type: OfferPoiType.TRAM, name: "Rondo Jagiellonów", distance: 775},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 787}
    ],
    18227: [
        {type: OfferPoiType.PARK, name: "Plac Generała Władysława Sikorskiego", distance: 168},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 205},
        {type: OfferPoiType.TRAM, name: "Muzeum Narodowe 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 03", distance: 248},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 05", distance: 286},
        {type: OfferPoiType.TRAM, name: "UJ / AST 01", distance: 321},
        {type: OfferPoiType.TRAM, name: "Muzeum Narodowe 02", distance: 340},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 04", distance: 384},
        {type: OfferPoiType.TRAM, name: "UJ / AST 02", distance: 399},
        {type: OfferPoiType.BUS, name: "AGH / UR 02", distance: 497},
        {type: OfferPoiType.BUS, name: "Filharmonia 04", distance: 529},
        {type: OfferPoiType.BUS, name: "Cracovia Błonia 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Cracovia Stadion 02", distance: 546},
        {type: OfferPoiType.BUS, name: "Cracovia Błonia 01", distance: 546},
        {type: OfferPoiType.TRAM, name: "Oleandry 01", distance: 568},
        {type: OfferPoiType.BUS, name: "AGH / UR 01", distance: 582},
        {type: OfferPoiType.BUS, name: "Jubilat 03", distance: 592},
        {type: OfferPoiType.TRAM, name: "Filharmonia 03", distance: 612},
        {type: OfferPoiType.TRAM, name: "Oleandry 02", distance: 613},
        {type: OfferPoiType.TRAM, name: "Jubilat 01", distance: 621},
        {type: OfferPoiType.PARK, name: "Ogród Profesorski", distance: 630},
        {type: OfferPoiType.TRAM, name: "Teatr Bagatela 01", distance: 637},
        {type: OfferPoiType.TRAM, name: "Filharmonia 02", distance: 664},
        {type: OfferPoiType.PARK, name: "Park im. Wisławy Szymborskiej", distance: 684},
        {type: OfferPoiType.PARK, name: "Ogród chiński", distance: 717},
        {type: OfferPoiType.PARK, name: "Skwer Konika Zwierzynieckiego", distance: 802},
        {type: OfferPoiType.PARK, name: "Skwer imienia Gustawa Holoubka", distance: 920},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 1580}
    ],
    18230: [
        {type: OfferPoiType.BUS, name: "Kantorowice 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Kantorowice 02", distance: 303},
        {type: OfferPoiType.BUS, name: "Kantorowice 04", distance: 386},
        {type: OfferPoiType.BUS, name: "Niebyła 01", distance: 630},
        {type: OfferPoiType.BUS, name: "Niebyła 02", distance: 646},
        {type: OfferPoiType.PARK, name: "Park Zielony Jar Wandy", distance: 1597},
        {type: OfferPoiType.PARK, name: "Park Zakole", distance: 1613}
    ],
    18231: [
        {type: OfferPoiType.BUS, name: "Ludwinów 02", distance: 436},
        {type: OfferPoiType.TRAM, name: "Smolki 01", distance: 492},
        {type: OfferPoiType.BUS, name: "Smolki 01", distance: 498},
        {type: OfferPoiType.TRAM, name: "Smolki 02", distance: 519},
        {type: OfferPoiType.BUS, name: "Smolki 02", distance: 524},
        {type: OfferPoiType.BUS, name: "Ludwinów 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 568},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 575},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 590},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 622},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 626},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 695},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 764},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 771},
        {type: OfferPoiType.BUS, name: "Os. Podwawelskie", distance: 817},
        {type: OfferPoiType.TRAM, name: "Korona 01", distance: 819},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1148},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1148},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1168},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1220},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1242},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2051},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2199},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2356},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2447}
    ],
    18240: [
        {type: OfferPoiType.BUS, name: "Stefanówka 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Stefanówka 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Boryszew 01", distance: 778},
        {type: OfferPoiType.PARK, name: "Skwer Generała Stefana Grota-Roweckiego", distance: 1832}
    ],
    18241: [
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 02", distance: 464},
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 497},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 561},
        {type: OfferPoiType.TRAM, name: "Czerwone Maki P+R 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 06", distance: 576},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 03", distance: 591},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 04", distance: 595},
        {type: OfferPoiType.TRAM, name: "Czerwone Maki P+R", distance: 658},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1399},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2095},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2437}
    ],
    18242: [
        {type: OfferPoiType.BUS, name: "Bronowice Małe", distance: 399},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 03", distance: 451},
        {type: OfferPoiType.BUS, name: "Lindego 03", distance: 492},
        {type: OfferPoiType.BUS, name: "Lindego 02", distance: 575},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Lindego 01", distance: 602},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 05", distance: 621},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 628},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 09", distance: 679},
        {type: OfferPoiType.TRAM, name: "Bronowice Małe 01", distance: 769},
        {type: OfferPoiType.BUS, name: "Bronowice Małe 06", distance: 782},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1877},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1920},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2188},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 2313},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 2379}
    ],
    18245: [
        {type: OfferPoiType.BUS, name: "FAT", distance: 192},
        {type: OfferPoiType.TRAM, name: "FAT", distance: 284},
        {type: OfferPoiType.BUS, name: "Fiołkowa", distance: 307},
        {type: OfferPoiType.TRAM, name: "Fiołkowa", distance: 429},
        {type: OfferPoiType.BUS, name: "Grabiszyńska (Cmentarz)", distance: 600},
        {type: OfferPoiType.BUS, name: "Aleja Pracy", distance: 616},
        {type: OfferPoiType.TRAM, name: "Aleja Pracy", distance: 621},
        {type: OfferPoiType.TRAM, name: "Grabiszyńska (Cmentarz)", distance: 660},
        {type: OfferPoiType.PARK, name: "Park Grabiszyński", distance: 1108},
        {type: OfferPoiType.LAS, name: "Lasek Oporowski", distance: 1418}
    ],
    18252: [
        {type: OfferPoiType.TRAM, name: "Most Osobowicki", distance: 766},
        {type: OfferPoiType.BUS, name: "Most Osobowicki", distance: 772},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1373},
        {type: OfferPoiType.PARK, name: "skwer Pawła Adamowicza", distance: 1794}
    ],
    18254: [
        {type: OfferPoiType.BUS, name: "Karpińskiego 02", distance: 132},
        {type: OfferPoiType.BUS, name: "Nowosądecka 03", distance: 346},
        {type: OfferPoiType.BUS, name: "Nowosądecka 04", distance: 399},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 02", distance: 440},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Nowosądecka 05", distance: 487},
        {type: OfferPoiType.BUS, name: "Tuchowska 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Tuchowska 01", distance: 545},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 569},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 02", distance: 573},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 01", distance: 627},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 02", distance: 641},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 03", distance: 657},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 703},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1193},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1515},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1781}
    ],
    18257: [
        {type: OfferPoiType.BUS, name: "Gocław 10", distance: 444},
        {type: OfferPoiType.BUS, name: "Gocław 09", distance: 470},
        {type: OfferPoiType.BUS, name: "Stoczniowców 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Stoczniowców 01", distance: 485},
        {type: OfferPoiType.BUS, name: "Gocław 05", distance: 517},
        {type: OfferPoiType.BUS, name: "Gocław 01", distance: 530},
        {type: OfferPoiType.BUS, name: "Gocław 02", distance: 550},
        {type: OfferPoiType.BUS, name: "Gocław 03", distance: 553},
        {type: OfferPoiType.BUS, name: "Gocław 04", distance: 566},
        {type: OfferPoiType.BUS, name: "Most Siekierkowski 04", distance: 583},
        {type: OfferPoiType.PARK, name: "Park/Ogród przy Kościele", distance: 1183},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1335},
        {type: OfferPoiType.PARK, name: "Ogród na Meissnera", distance: 1559},
        {type: OfferPoiType.PARK, name: "Park Nad Balatonem", distance: 2073},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 2208},
        {type: OfferPoiType.PARK, name: "Dziki park angielski", distance: 2338}
    ],
    18258: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 473},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 509},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 516},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 541},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 603},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Ojca Aniceta 01", distance: 823},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1317},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2207}
    ],
    18259: [
        {type: OfferPoiType.BUS, name: "3 Maja 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 02", distance: 588},
        {type: OfferPoiType.BUS, name: "3 Maja 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Obrońców Warszawy 01", distance: 671},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 787},
        {type: OfferPoiType.PARK, name: "Park Ołtarzewski", distance: 1282},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1295}
    ],
    18266: [
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 341},
        {type: OfferPoiType.BUS, name: "Baśniowa", distance: 600},
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 754},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1776}
    ],
    18267: [
        {type: OfferPoiType.BUS, name: "Zespół Szkół Morskich 01", distance: 206},
        {type: OfferPoiType.BUS, name: "Zespół Szkół Morskich 02", distance: 265},
        {type: OfferPoiType.TRAM, name: "Latarnia Morska", distance: 518},
        {type: OfferPoiType.BUS, name: "Krasickiego 04", distance: 570},
        {type: OfferPoiType.BUS, name: "Krasickiego 03", distance: 626},
        {type: OfferPoiType.TRAM, name: "Krasickiego 02", distance: 634},
        {type: OfferPoiType.PARK, name: "Park Brzeźnieński im. J. J. Haffnera", distance: 738},
        {type: OfferPoiType.TRAM, name: "Krasickiego 01", distance: 742},
        {type: OfferPoiType.BUS, name: "Wyzwolenia 01", distance: 750}
    ],
    18275: [
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Rzemieślnicza", distance: 227},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Studzienna", distance: 304},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Wysoki Stoczek", distance: 343},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Swobodna", distance: 401},
        {type: OfferPoiType.BUS, name: "Swobodna", distance: 574},
        {type: OfferPoiType.BUS, name: "Swobodna/Wysoki Stoczek", distance: 603},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/Cmentarz Św. Rocha", distance: 614},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja/al. Jana Pawła II", distance: 662},
        {type: OfferPoiType.BUS, name: "al. Jana Pawła II/Kościół", distance: 712},
        {type: OfferPoiType.BUS, name: "al. Jana Pawła II/Rzeka Biała", distance: 719},
        {type: OfferPoiType.PARK, name: "Park Antoniuk", distance: 763},
        {type: OfferPoiType.PARK, name: "Leśny Park Kieszonkowy", distance: 2150},
        {type: OfferPoiType.PARK, name: "Lawendowy park kieszonkowy", distance: 2195},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Piotra Karolskiego", distance: 2265},
        {type: OfferPoiType.REZERWAT, name: "Stawy Marczukowskie i Dolina Bażantarki", distance: 2317}
    ],
    18276: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 211},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 392},
        {type: OfferPoiType.TRAM, name: "Armii Krajowej", distance: 421},
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 435},
        {type: OfferPoiType.BUS, name: "Park Wschodni", distance: 600},
        {type: OfferPoiType.TRAM, name: "Park Wschodni", distance: 603},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 655},
        {type: OfferPoiType.LAS, name: "Las Rakowiecki", distance: 860},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1449},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1640},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1953}
    ],
    18282: [
        {type: OfferPoiType.BUS, name: "Góralska 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Góralska 01", distance: 236},
        {type: OfferPoiType.BUS, name: "Leśna Góra 01", distance: 335},
        {type: OfferPoiType.BUS, name: "Leśna Góra - Przychodnia 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Leśna Góra - Przychodnia 01", distance: 410},
        {type: OfferPoiType.BUS, name: "Podkarpacka", distance: 448},
        {type: OfferPoiType.BUS, name: "Potokowa 03", distance: 476},
        {type: OfferPoiType.BUS, name: "Potokowa 02", distance: 526},
        {type: OfferPoiType.BUS, name: "Potokowa 04", distance: 616},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Wąwóz Huzarów", distance: 1898},
        {type: OfferPoiType.PARK, name: "Skwer prof. Pawła Gałuszki", distance: 1959},
        {type: OfferPoiType.PARK, name: "Plac Generała Stanisława Maczka", distance: 2311}
    ],
    18286: [
        {type: OfferPoiType.BUS, name: "Żabiniec 02", distance: 331},
        {type: OfferPoiType.BUS, name: "Żmujdzka 02", distance: 536},
        {type: OfferPoiType.BUS, name: "Reja 01", distance: 555},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 682},
        {type: OfferPoiType.BUS, name: "Imbramowska 01", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1422},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 1474}
    ],
    18289: [
        {type: OfferPoiType.BUS, name: "Kiełpinek PKM 01", distance: 603},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Kiełpinek", distance: 698},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Dolina Strzyży", distance: 1784},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 2267},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2319}
    ],
    18293: [
        {type: OfferPoiType.BUS, name: "Akwarelowa", distance: 377},
        {type: OfferPoiType.BUS, name: "Fioletowa", distance: 651},
        {type: OfferPoiType.BUS, name: "Zdroje Szpital", distance: 667},
        {type: OfferPoiType.LAS, name: "Park Leśny Klęskowo", distance: 1250},
        {type: OfferPoiType.PARK, name: "Park Leśny Klęskowo", distance: 1250},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Bukowe Zdroje im. Profesora Tadeusza Dominika", distance: 2069},
        {type: OfferPoiType.PARK, name: "Park Leśny Zdroje", distance: 2248}
    ],
    18296: [
        {type: OfferPoiType.BUS, name: "Boenigka", distance: 619},
        {type: OfferPoiType.TRAM, name: "Boenigka", distance: 661},
        {type: OfferPoiType.TRAM, name: "Carrefour", distance: 800},
        {type: OfferPoiType.BUS, name: "Carrefour", distance: 827},
        {type: OfferPoiType.PARK, name: "Skwer generała Augusta Fieldorfa–Nila", distance: 1286},
        {type: OfferPoiType.PARK, name: "Plac Mazurski", distance: 1961},
        {type: OfferPoiType.PARK, name: "Park Nagórki-Jaroty", distance: 2035}
    ],
    18318: [
        {type: OfferPoiType.BUS, name: "Orężna 01", distance: 621},
        {type: OfferPoiType.BUS, name: "Orężna 02", distance: 703},
        {type: OfferPoiType.BUS, name: "Łoziska 01", distance: 772},
        {type: OfferPoiType.REZERWAT, name: "Redutowa", distance: 1430}
    ],
    18320: [
        {type: OfferPoiType.BUS, name: "Bolesława Krzywoustego 02", distance: 335},
        {type: OfferPoiType.BUS, name: "Zielonej Gęsi 01", distance: 543},
        {type: OfferPoiType.BUS, name: "Bolesława Śmiałego 02", distance: 662},
        {type: OfferPoiType.BUS, name: "Henryka Probusa 01", distance: 783},
        {type: OfferPoiType.BUS, name: "Przemysława II 02", distance: 802},
        {type: OfferPoiType.BUS, name: "Konotopska 01", distance: 810},
        {type: OfferPoiType.BUS, name: "PKP Gołąbki 01", distance: 831},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 871},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 997},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 1281},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1632},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1788},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1897}
    ],
    18329: [
        {type: OfferPoiType.BUS, name: "Nad Wisłą", distance: 599},
        {type: OfferPoiType.PARK, name: "Skwer im. gen. Augusta Emila Fieldorfa-Nila", distance: 637},
        {type: OfferPoiType.BUS, name: "Nad Wisłą [końcowy]", distance: 655},
        {type: OfferPoiType.PARK, name: "Kozi Rynek w Fordonie", distance: 1195},
        {type: OfferPoiType.PARK, name: "Polana Nadwiślańska", distance: 1380},
        {type: OfferPoiType.PARK, name: "Skwer świętej Rity", distance: 1703},
        {type: OfferPoiType.PARK, name: "Park Milenijny", distance: 2044},
        {type: OfferPoiType.PARK, name: "Skwer Matki Bożej Wspomożycielki Wiernych", distance: 2165}
    ],
    18333: [
        {type: OfferPoiType.TRAM, name: "Limanowskiego - Sierakowskiego", distance: 549},
        {type: OfferPoiType.BUS, name: "Limanowskiego - Sierakowskiego", distance: 596},
        {type: OfferPoiType.BUS, name: "Hipoteczna - Olsztyńska", distance: 620},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Struga", distance: 700},
        {type: OfferPoiType.BUS, name: "Klonowa - Limanowskiego", distance: 765},
        {type: OfferPoiType.BUS, name: "Hipoteczna - Limanowskiego", distance: 766},
        {type: OfferPoiType.BUS, name: "Pojezierska - Sierakowskiego", distance: 791},
        {type: OfferPoiType.PARK, name: "Park przy ul. Hipotecznej", distance: 894},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 1218},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 1224},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 1343},
        {type: OfferPoiType.PARK, name: "Plac Piastowski", distance: 1812},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 1855},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 2086}
    ],
    18340: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 625},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 794},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 807},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 1059},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 1085},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1622},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1881},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2307}
    ],
    18342: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 156},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 159},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 174},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 304},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 345},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 397},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 424},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 464},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 477},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 488},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1032},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1167},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1272},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1580},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1583},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1957},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1957},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1971},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2128}
    ],
    18345: [
        {type: OfferPoiType.BUS, name: "Mosty Warszawskie", distance: 170},
        {type: OfferPoiType.TRAM, name: "Mosty Warszawskie", distance: 176},
        {type: OfferPoiType.BUS, name: "Damrota", distance: 455},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 610},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 614},
        {type: OfferPoiType.BUS, name: "Kromera", distance: 739},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 820},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 1062},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1167},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1195},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1209},
        {type: OfferPoiType.PARK, name: "park Porucznika Roberta Marczewskiego", distance: 1476},
        {type: OfferPoiType.PARK, name: "skwer Skaczącej Gwiazdy", distance: 1560}
    ],
    18347: [
        {type: OfferPoiType.BUS, name: "Pryncypalna - Mieszkalna", distance: 47},
        {type: OfferPoiType.BUS, name: "Pryncypalna - Kosynierów Gdyńskich NŻ", distance: 239},
        {type: OfferPoiType.BUS, name: "Kongresowa - Pryncypalna NŻ", distance: 314},
        {type: OfferPoiType.PARK, name: "Park Zatorze", distance: 359},
        {type: OfferPoiType.BUS, name: "Kongresowa - Jutrzenki", distance: 630},
        {type: OfferPoiType.BUS, name: "Trybunalska - Kosynierów Gdyńskich", distance: 647},
        {type: OfferPoiType.BUS, name: "Kosynierów Gdyńskich - Trybunalska", distance: 684},
        {type: OfferPoiType.PARK, name: "Borek Józefa Lissnera", distance: 1163},
        {type: OfferPoiType.PARK, name: "Skwer im. Henryka Dubaniewicza", distance: 1392},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 1758},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1994},
        {type: OfferPoiType.PARK, name: "Park Miejski przy ul. Leczniczej", distance: 2035},
        {type: OfferPoiType.PARK, name: "Park Mirabelka", distance: 2068}
    ],
    18348: [
        {type: OfferPoiType.BUS, name: "Świeradowska", distance: 74},
        {type: OfferPoiType.TRAM, name: "Świeradowska", distance: 75},
        {type: OfferPoiType.BUS, name: "Gaj – pętla", distance: 235},
        {type: OfferPoiType.TRAM, name: "Morwowa", distance: 313},
        {type: OfferPoiType.BUS, name: "Gaj", distance: 364},
        {type: OfferPoiType.BUS, name: "Morwowa", distance: 379},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 518},
        {type: OfferPoiType.TRAM, name: "Krynicka", distance: 614},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1229},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1734},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 2195},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 2264}
    ],
    18352: [
        {type: OfferPoiType.BUS, name: "Bociana Czarnego 02", distance: 91},
        {type: OfferPoiType.BUS, name: "Bociana Czarnego 01", distance: 259},
        {type: OfferPoiType.BUS, name: "Zimorodka 01", distance: 260},
        {type: OfferPoiType.BUS, name: "Zimorodka 02", distance: 389},
        {type: OfferPoiType.BUS, name: "Jesiennych Liści 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Jesiennych Liści 02", distance: 787},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Chojnów", distance: 2141}
    ],
    18373: [
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 326},
        {type: OfferPoiType.BUS, name: "Mackiewicza 02", distance: 459},
        {type: OfferPoiType.BUS, name: "Pleszowska 03", distance: 470},
        {type: OfferPoiType.TRAM, name: "Białoprądnicka 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Pleszowska 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Szpital Jana Pawła II 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Białoprądnicka 04", distance: 495},
        {type: OfferPoiType.BUS, name: "Mackiewicza 03", distance: 500},
        {type: OfferPoiType.BUS, name: "Białoprądnicka 03", distance: 502},
        {type: OfferPoiType.BUS, name: "Pleszowska 02", distance: 516},
        {type: OfferPoiType.TRAM, name: "Białoprądnicka 01", distance: 527},
        {type: OfferPoiType.TRAM, name: "Górnickiego 01", distance: 531},
        {type: OfferPoiType.BUS, name: "Górnickiego 03", distance: 554},
        {type: OfferPoiType.TRAM, name: "Górnickiego 02", distance: 563},
        {type: OfferPoiType.BUS, name: "Górnickiego 04", distance: 578},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1094},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 1842}
    ],
    18383: [
        {type: OfferPoiType.BUS, name: "Ostródzka 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 07", distance: 562},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 03", distance: 629},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 71", distance: 668},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 04", distance: 676},
        {type: OfferPoiType.BUS, name: "Ostródzka 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 05", distance: 688},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 06", distance: 698},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 08", distance: 701},
        {type: OfferPoiType.BUS, name: "Bródno-Podgrodzie 01", distance: 702},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 1360},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1686},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1901},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1906},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 2009},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 2367}
    ],
    18384: [
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 147},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 222},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 312},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 08", distance: 466},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 471},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 05", distance: 473},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 536},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 02", distance: 576},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Mieszka I 05", distance: 593},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Powst. Listopad. 06", distance: 740},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 1937},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2273},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2407}
    ],
    18385: [
        {type: OfferPoiType.BUS, name: "Kuklińskiego 04", distance: 402},
        {type: OfferPoiType.TRAM, name: "Kuklińskiego 02", distance: 539},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 05", distance: 545},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 03", distance: 551},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 08", distance: 553},
        {type: OfferPoiType.TRAM, name: "Kuklińskiego 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Kuklińskiego 06", distance: 580},
        {type: OfferPoiType.BUS, name: "Klimeckiego 03", distance: 592},
        {type: OfferPoiType.BUS, name: "Klimeckiego 05", distance: 599},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 01", distance: 603},
        {type: OfferPoiType.TRAM, name: "Klimeckiego 02", distance: 606},
        {type: OfferPoiType.BUS, name: "Stoczniowców 02", distance: 828},
        {type: OfferPoiType.BUS, name: "Strycharska 01", distance: 832},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 858},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1131},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1163},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1265},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1413}
    ],
    18387: [
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja", distance: 46},
        {type: OfferPoiType.TRAM, name: "Konstytucji 3 Maja", distance: 111},
        {type: OfferPoiType.BUS, name: "Południowa", distance: 553},
        {type: OfferPoiType.BUS, name: "Rządz", distance: 580},
        {type: OfferPoiType.TRAM, name: "Pętla Rządz", distance: 602},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja / Sobieskiego", distance: 620},
        {type: OfferPoiType.TRAM, name: "Południowa", distance: 654},
        {type: OfferPoiType.LAS, name: "fort Strzemięcin", distance: 816},
        {type: OfferPoiType.LAS, name: "Nabrzeże generała Gustawa Orlicz-Dreszera", distance: 837}
    ],
    18389: [
        {type: OfferPoiType.BUS, name: "Sympatyczna 01", distance: 66},
        {type: OfferPoiType.BUS, name: "Sympatyczna 02", distance: 99},
        {type: OfferPoiType.BUS, name: "Sympatyczna 03", distance: 182},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 257},
        {type: OfferPoiType.BUS, name: "Sympatyczna 04", distance: 340},
        {type: OfferPoiType.BUS, name: "Płużańska 02", distance: 379},
        {type: OfferPoiType.BUS, name: "Gniewkowska 52", distance: 432},
        {type: OfferPoiType.BUS, name: "PKP Włochy 03", distance: 448},
        {type: OfferPoiType.BUS, name: "Gniewkowska 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Wałowicka 03", distance: 505},
        {type: OfferPoiType.BUS, name: "Płużańska 01", distance: 515},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Włochy", distance: 661},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 703},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 855},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 1193},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1347},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1970}
    ],
    18405: [
        {type: OfferPoiType.BUS, name: "Bieszczadzka - Kolumny NŻ", distance: 749},
        {type: OfferPoiType.BUS, name: "Kolumny - Kolumny 118 NŻ", distance: 751},
        {type: OfferPoiType.BUS, name: "Jędrzejów Przem. Zachód", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2066}
    ],
    18411: [{type: OfferPoiType.BUS, name: "Nowa Wola 52", distance: 815}],
    18436: [
        {type: OfferPoiType.BUS, name: "Komorniki", distance: 349},
        {type: OfferPoiType.BUS, name: "Kurczaki - Cm. Kurczaki", distance: 834},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 1617},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 2390},
        {type: OfferPoiType.PARK, name: "Skwer im. Świętego Maksymiliana Marii Kolbego", distance: 2397}
    ],
    18438: [
        {type: OfferPoiType.BUS, name: "Gliwice Kochanowskiego", distance: 328},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 460},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Lewczyńskiego", distance: 474},
        {type: OfferPoiType.BUS, name: "Trynek Cichociemnych", distance: 485},
        {type: OfferPoiType.BUS, name: "Gliwice Komag", distance: 551},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Rydet", distance: 562},
        {type: OfferPoiType.BUS, name: "Gliwice Rybnicka", distance: 629},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 667},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Rybnickiej", distance: 709},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny", distance: 833}
    ],
    18443: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 352},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 376},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód/ Polna II", distance: 550},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód (Białogardzka)", distance: 573},
        {type: OfferPoiType.BUS, name: "Karlińska/ Os. Generalskie II", distance: 578},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 602},
        {type: OfferPoiType.BUS, name: "Os.Zachód/ Polna I", distance: 625},
        {type: OfferPoiType.BUS, name: "Karlińska/ Os. Generalskie I", distance: 671},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 679},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 680},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 1659},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1757}
    ],
    18445: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 321},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 404},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 496},
        {type: OfferPoiType.BUS, name: "Polna/ Krakowska", distance: 531},
        {type: OfferPoiType.BUS, name: "Polna/ SP7", distance: 547},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 573},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 574},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód/ Polna II", distance: 624},
        {type: OfferPoiType.BUS, name: "Osiedle Zachód (Białogardzka)", distance: 667},
        {type: OfferPoiType.BUS, name: "Polna/ Gazownia", distance: 681},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1643},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 1830}
    ],
    18447: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 366},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 449},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 547},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 624},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 625},
        {type: OfferPoiType.BUS, name: "Polna/ Krakowska", distance: 773},
        {type: OfferPoiType.BUS, name: "Polna/ SP7", distance: 789},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1693},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 2072}
    ],
    18448: [
        {type: OfferPoiType.BUS, name: "Kościuszki/ Pułaskiego - N.Ż.", distance: 188},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Plaża kołki - N.Ż.", distance: 271},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego I - N.Ż.", distance: 347},
        {type: OfferPoiType.BUS, name: "Kosińskiego/ Kościuszki", distance: 424},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Kosińskiego II - N.Ż.", distance: 425},
        {type: OfferPoiType.BUS, name: "Kościuszki/ Szpital I", distance: 794},
        {type: OfferPoiType.BUS, name: "Polna/ Krakowska", distance: 807},
        {type: OfferPoiType.BUS, name: "Polna/ Gazownia", distance: 815},
        {type: OfferPoiType.BUS, name: "Polna/ SP7", distance: 823},
        {type: OfferPoiType.PARK, name: "Wyspa Łabędzia", distance: 1493},
        {type: OfferPoiType.REZERWAT, name: "Torfowisko w Lasku Zachodnim", distance: 1996}
    ],
    18459: [
        {type: OfferPoiType.BUS, name: "Zagórze Droga do Klimontowa", distance: 502},
        {type: OfferPoiType.BUS, name: "Sosnowiec Kosów", distance: 672},
        {type: OfferPoiType.PARK, name: "Plac im. Jana Pawła II", distance: 1503},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu drogowego", distance: 1658},
        {type: OfferPoiType.PARK, name: "Park imienia Wandy Malczewskiej", distance: 2274}
    ],
    18464: [
        {type: OfferPoiType.BUS, name: "Siechnice – Kwiatkowskiego", distance: 357},
        {type: OfferPoiType.BUS, name: "Siechnice Kwiatkowskiego", distance: 376},
        {type: OfferPoiType.BUS, name: "Siechnice Staszica", distance: 580},
        {type: OfferPoiType.BUS, name: "Siechnice - Staszica", distance: 741}
    ],
    18471: [
        {type: OfferPoiType.BUS, name: "Kościelna Droga 02", distance: 177},
        {type: OfferPoiType.BUS, name: "Kościelna Droga 01", distance: 202},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 307},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 01", distance: 394},
        {type: OfferPoiType.BUS, name: "Aleja Chopina 02", distance: 501},
        {type: OfferPoiType.BUS, name: "Łużycka  02", distance: 577},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Szymanowskiego 01", distance: 721},
        {type: OfferPoiType.BUS, name: "Szymanowskiego 02", distance: 771}
    ],
    18472: [
        {type: OfferPoiType.TRAM, name: "Czynszowa 01", distance: 157},
        {type: OfferPoiType.BUS, name: "Szwedzka 04", distance: 235},
        {type: OfferPoiType.BUS, name: "Szwedzka 05", distance: 236},
        {type: OfferPoiType.BUS, name: "Metro Szwedzka 01", distance: 238},
        {type: OfferPoiType.TRAM, name: "Konopacka 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Szwedzka 07", distance: 295},
        {type: OfferPoiType.BUS, name: "Konopacka 02", distance: 303},
        {type: OfferPoiType.BUS, name: "Konopacka 01", distance: 308},
        {type: OfferPoiType.TRAM, name: "Środkowa 01", distance: 319},
        {type: OfferPoiType.TRAM, name: "Konopacka 01", distance: 330},
        {type: OfferPoiType.BUS, name: "Metro Szwedzka 02", distance: 356},
        {type: OfferPoiType.BUS, name: "Zajezdnia Stalowa 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Szwedzka 01", distance: 455},
        {type: OfferPoiType.METRO, name: "Szwedzka", distance: 463},
        {type: OfferPoiType.BUS, name: "Zajezdnia Stalowa 02", distance: 464},
        {type: OfferPoiType.TRAM, name: "Bródnowska 01", distance: 660},
        {type: OfferPoiType.TRAM, name: "Bródnowska 02", distance: 699},
        {type: OfferPoiType.TRAM, name: "Inżynierska 04", distance: 699},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 745},
        {type: OfferPoiType.TRAM, name: "Inżynierska 03", distance: 762},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Targówek", distance: 794},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1366},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1372},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1587},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 1639},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 1746},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 1877}
    ],
    18473: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Królewska / Teligi", distance: 362},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Sienna", distance: 400},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Teligi", distance: 415},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Bairda", distance: 493},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Na Laski", distance: 494},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 598},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Braci Okuniów", distance: 631},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 869},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 1217},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1514},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1577},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1747},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1854},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 1992},
        {type: OfferPoiType.PARK, name: "Skwer przy ulicy Górnej", distance: 2058}
    ],
    18474: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 217},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 614},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 636},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 714}
    ],
    18475: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 371},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 768},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 790}
    ],
    18476: [
        {type: OfferPoiType.TRAM, name: "Korona 01", distance: 139},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 185},
        {type: OfferPoiType.TRAM, name: "Korona 03", distance: 219},
        {type: OfferPoiType.TRAM, name: "Smolki 02", distance: 225},
        {type: OfferPoiType.TRAM, name: "Korona 02", distance: 229},
        {type: OfferPoiType.BUS, name: "Smolki 02", distance: 238},
        {type: OfferPoiType.BUS, name: "Smolki 01", distance: 251},
        {type: OfferPoiType.TRAM, name: "Smolki 01", distance: 252},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 468},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 01", distance: 682},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 02", distance: 700},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 747},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 754},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 790},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 801},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 809},
        {type: OfferPoiType.TRAM, name: "Limanowskiego 01", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 1113},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 1713},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2140},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2405},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2514}
    ],
    18477: [
        {type: OfferPoiType.BUS, name: "Świergotki", distance: 150},
        {type: OfferPoiType.BUS, name: "Przepiórki", distance: 411},
        {type: OfferPoiType.BUS, name: "Pelikana", distance: 544},
        {type: OfferPoiType.BUS, name: "Królewskiego nż", distance: 788},
        {type: OfferPoiType.REZERWAT, name: "Dolina strumienia Grzęziniec", distance: 1575},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 2108},
        {type: OfferPoiType.PARK, name: "park Brodowski", distance: 2166},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 2378}
    ],
    18480: [
        {type: OfferPoiType.TRAM, name: "Port Popowice", distance: 144},
        {type: OfferPoiType.BUS, name: "Port Popowice", distance: 194},
        {type: OfferPoiType.BUS, name: "Wejherowska (Hala Orbita)", distance: 313},
        {type: OfferPoiType.TRAM, name: "Wejherowska (Hala Orbita)", distance: 351},
        {type: OfferPoiType.TRAM, name: "Białowieska", distance: 400},
        {type: OfferPoiType.BUS, name: "Milenijna (Hala Orbita)", distance: 470},
        {type: OfferPoiType.BUS, name: "Kwiska", distance: 608},
        {type: OfferPoiType.BUS, name: "Park Popowicki", distance: 746},
        {type: OfferPoiType.TRAM, name: "Kwiska", distance: 763},
        {type: OfferPoiType.TRAM, name: "Park Popowicki", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Popowicki", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 1033},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 1952}
    ],
    18492: [
        {type: OfferPoiType.BUS, name: "Skośna 01", distance: 130},
        {type: OfferPoiType.BUS, name: "Skośna 02", distance: 188},
        {type: OfferPoiType.BUS, name: "Lubostroń 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Lubostroń 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Lubostroń 04", distance: 398},
        {type: OfferPoiType.BUS, name: "Lubostroń 03", distance: 424},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 01", distance: 474},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Torfowa 01", distance: 713},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 741},
        {type: OfferPoiType.BUS, name: "Piltza 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 865},
        {type: OfferPoiType.PARK, name: "Park Maćka i Doroty", distance: 1746},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 1926},
        {type: OfferPoiType.REZERWAT, name: "Łąki na Klinach", distance: 2439}
    ],
    18494: [
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Cm. Mania", distance: 49},
        {type: OfferPoiType.BUS, name: "Solec - Cm. Mania", distance: 166},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Jarzynowa", distance: 181},
        {type: OfferPoiType.BUS, name: "Solec - Borowa NŻ", distance: 488},
        {type: OfferPoiType.BUS, name: "Biegunowa - Krakowska", distance: 641},
        {type: OfferPoiType.BUS, name: "Krakowska - Biegunowa", distance: 660},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Unii Lubelskiej", distance: 712},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 911},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1022},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1149},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1353},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 2142},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 2180},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2187},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2413},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 2437},
        {type: OfferPoiType.PARK, name: "Park im. generała Władysława Andersa", distance: 2447}
    ],
    18496: [
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 324},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 376},
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 406},
        {type: OfferPoiType.BUS, name: "Babińskiego 02", distance: 452},
        {type: OfferPoiType.BUS, name: "Babińskiego 01", distance: 457},
        {type: OfferPoiType.BUS, name: "Skotniki Kościół 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Brücknera 02", distance: 683},
        {type: OfferPoiType.BUS, name: "Brücknera 01", distance: 703},
        {type: OfferPoiType.BUS, name: "Skotniki 04", distance: 730},
        {type: OfferPoiType.BUS, name: "Skotniki 01", distance: 794},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1271},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2491}
    ],
    18497: [
        {type: OfferPoiType.TRAM, name: "Półwiejska", distance: 451},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 457},
        {type: OfferPoiType.TRAM, name: "Różana", distance: 613},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 691},
        {type: OfferPoiType.TRAM, name: "AWF", distance: 725},
        {type: OfferPoiType.BUS, name: "Bielniki n/ż", distance: 757},
        {type: OfferPoiType.BUS, name: "AWF", distance: 770},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 843},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 994},
        {type: OfferPoiType.LAS, name: "Miejski las kieszonkowy", distance: 995},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1102},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1278},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1466},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1510},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1514},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1745},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1820}
    ],
    18498: [
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 01", distance: 510},
        {type: OfferPoiType.BUS, name: "Targowa 02", distance: 543},
        {type: OfferPoiType.BUS, name: "Targowa 01", distance: 622},
        {type: OfferPoiType.TRAM, name: "Targowa 03", distance: 666},
        {type: OfferPoiType.TRAM, name: "Targowa 04", distance: 681},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 06", distance: 706},
        {type: OfferPoiType.BUS, name: "Galeria Copernicus 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 02", distance: 707},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 05", distance: 742},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 04", distance: 753},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 08", distance: 766},
        {type: OfferPoiType.BUS, name: "Olbrachta nż. 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 03", distance: 798},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 923},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 2025},
        {type: OfferPoiType.PARK, name: "Glazja", distance: 2113},
        {type: OfferPoiType.PARK, name: "Bastion Menniczy", distance: 2403}
    ],
    18508: [
        {type: OfferPoiType.BUS, name: "Habicha 01", distance: 238},
        {type: OfferPoiType.BUS, name: "Habicha 02", distance: 398},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 04", distance: 570},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 03", distance: 598},
        {type: OfferPoiType.BUS, name: "Posag 7 Panien 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ursus Płn. 01", distance: 609},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 691},
        {type: OfferPoiType.BUS, name: "Zajezdnia Ursus Płn. 02", distance: 728},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 766},
        {type: OfferPoiType.BUS, name: "Gierdziejewskiego 02", distance: 789},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1286},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 1323}
    ],
    18510: [
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 793},
        {type: OfferPoiType.TRAM, name: "Głęboka 02", distance: 813},
        {type: OfferPoiType.BUS, name: "Głęboka 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 943},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1077},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1122},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1459}
    ],
    18514: [
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 477},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 479},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 515},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 533},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 547},
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 680},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1341}
    ],
    18518: [
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Żurawiej", distance: 118},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Stadion", distance: 259},
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 333},
        {type: OfferPoiType.BUS, name: "Centum Przesiadkowe Bałtycka", distance: 370},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 473},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wolności", distance: 540},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1036},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 1187},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1262},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1647}
    ],
    18519: [
        {type: OfferPoiType.BUS, name: "Grabówki IV", distance: 143},
        {type: OfferPoiType.BUS, name: "Grabówki V", distance: 241},
        {type: OfferPoiType.BUS, name: "Sygneczów Sklep", distance: 254},
        {type: OfferPoiType.BUS, name: "Grabówki VI", distance: 566},
        {type: OfferPoiType.BUS, name: "Sygneczów Kościół", distance: 733},
        {type: OfferPoiType.REZERWAT, name: "Las i stawy na Grabówkach", distance: 2214}
    ],
    18525: [
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 02", distance: 601},
        {type: OfferPoiType.BUS, name: "Pańska Kopalnia 01", distance: 615},
        {type: OfferPoiType.BUS, name: "Słoneczny Stok / Pańska 02", distance: 671},
        {type: OfferPoiType.BUS, name: "Słoneczny Stok / Pańska 01", distance: 700},
        {type: OfferPoiType.BUS, name: "Bł. Karoliny pętla 09", distance: 766},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 1323},
        {type: OfferPoiType.PARK, name: "Park Błogosławionej Karoliny Kózki", distance: 2081}
    ],
    18530: [
        {type: OfferPoiType.BUS, name: "Gdańska / Chodkiewicza", distance: 238},
        {type: OfferPoiType.TRAM, name: "Gdańska / Chodkiewicza", distance: 238},
        {type: OfferPoiType.BUS, name: "Chodkiewicza / Paderewskiego", distance: 302},
        {type: OfferPoiType.TRAM, name: "Chodkiewicza / Paderewskiego", distance: 304},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 502},
        {type: OfferPoiType.BUS, name: "Mickiewicza / Teatr Polski", distance: 527},
        {type: OfferPoiType.TRAM, name: "UKW", distance: 592},
        {type: OfferPoiType.TRAM, name: "Gdańska / Artyleryjska", distance: 622},
        {type: OfferPoiType.BUS, name: "Kamienna / Gdańska", distance: 624},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 639},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 714},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 727},
        {type: OfferPoiType.PARK, name: "Skwer Edwarda Woyniłłowicza", distance: 748},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 791},
        {type: OfferPoiType.PARK, name: "Skwer Mikołaja Kopernika", distance: 869},
        {type: OfferPoiType.PARK, name: "Skwer im. ppor. Leszka Białego", distance: 1026},
        {type: OfferPoiType.PARK, name: "Skwer im. Mariana Turwida", distance: 1050}
    ],
    18535: [
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1924},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1936},
        {type: OfferPoiType.PARK, name: 'Park edukacyjny "Żabie Doły"', distance: 2226}
    ],
    18550: [
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 02", distance: 663},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Galeria Szperk", distance: 732},
        {type: OfferPoiType.BUS, name: "Galeria Szperk 02", distance: 732},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 02", distance: 735},
        {type: OfferPoiType.BUS, name: "Staniewicza", distance: 765},
        {type: OfferPoiType.BUS, name: "Staniewicza 01", distance: 765},
        {type: OfferPoiType.BUS, name: "Staniewicza 02", distance: 810},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1477},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1705},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 1893}
    ],
    18563: [
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 45},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 250},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 418},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 446},
        {type: OfferPoiType.BUS, name: "Zielona - 1 Maja", distance: 454},
        {type: OfferPoiType.BUS, name: "Legionów - Żeligowskiego", distance: 523},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 568},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka", distance: 644},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Srebrzyńska", distance: 672},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 754},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 888},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 897},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 920},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 1227},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1236},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1432},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 2166},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2213}
    ],
    18568: [{type: OfferPoiType.PARK, name: "Park Panoptikum", distance: 2439}],
    18572: [{type: OfferPoiType.PARK, name: "Park Miejski", distance: 2506}],
    18591: [
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 193},
        {type: OfferPoiType.BUS, name: "Os. Paderewskiego Kościół", distance: 247},
        {type: OfferPoiType.PARK, name: "Plac Rady Europy", distance: 347},
        {type: OfferPoiType.BUS, name: "Katowice Francuska", distance: 524},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Krasińskiego", distance: 559},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Biblioteka Śląska", distance: 563},
        {type: OfferPoiType.TRAM, name: "Katowice Graniczna", distance: 591},
        {type: OfferPoiType.BUS, name: "Osiedle Paderewskiego Sikorskiego", distance: 597},
        {type: OfferPoiType.BUS, name: "Katowice Mariacka", distance: 639},
        {type: OfferPoiType.BUS, name: "Katowice Francuska Sąd", distance: 775},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Klimondy", distance: 819},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 860},
        {type: OfferPoiType.PARK, name: "Skwer Raoula Wallenberga", distance: 1043},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1260},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 1344}
    ],
    18616: [
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Młynowa", distance: 105},
        {type: OfferPoiType.BUS, name: "Sosnowskiego/Wyszyńskiego", distance: 218},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Sosnowskiego", distance: 236},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Bema NŻ", distance: 242},
        {type: OfferPoiType.BUS, name: "Sosnowskiego/Grunwaldzka", distance: 365},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 422},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Kaczorowskiego", distance: 424},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Cieszyńska", distance: 456},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Stołeczna", distance: 474},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Opera Podlaska", distance: 539},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 823},
        {type: OfferPoiType.PARK, name: "Park im. Jadwigi Dziekońskiej", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park Branickich", distance: 1527},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1536},
        {type: OfferPoiType.PARK, name: "Skwer Zenona Andrzeja Młyńczyka", distance: 1550},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Zwierzyniecki", distance: 2269}
    ],
    18617: [
        {type: OfferPoiType.BUS, name: "Pucka", distance: 126},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 01", distance: 260},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP", distance: 336},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 03", distance: 340},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 04", distance: 362},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 06", distance: 381},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Chylonia", distance: 389},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 02", distance: 397},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1262},
        {type: OfferPoiType.PARK, name: "Park Zielone Leszczynki", distance: 1997},
        {type: OfferPoiType.PARK, name: "Kieszonka na fali", distance: 2414}
    ],
    18621: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 491},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Brylowska 01", distance: 644},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 683},
        {type: OfferPoiType.BUS, name: "Brylowska 02", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1306},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1531},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1601},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 1778},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1962},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 1988},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 1988},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 2063}
    ],
    18623: [{type: OfferPoiType.BUS, name: "Śmiłowice Osiedle", distance: 232}],
    18624: [
        {type: OfferPoiType.BUS, name: "Kolonia Wysockiego Woźniaków", distance: 749},
        {type: OfferPoiType.PARK, name: "Skwer Rybka", distance: 1485},
        {type: OfferPoiType.PARK, name: "Skwer Emila i Georga Zillmannów", distance: 1948},
        {type: OfferPoiType.PARK, name: "Skwer Artystów Grupy Janowskiej", distance: 2015},
        {type: OfferPoiType.PARK, name: "Park Giszowiecki", distance: 2021},
        {type: OfferPoiType.PARK, name: "Skwer Ewalda Gawlika", distance: 2334}
    ],
    18625: [
        {type: OfferPoiType.BUS, name: "Półłanki 01", distance: 335},
        {type: OfferPoiType.BUS, name: "Półłanki 02", distance: 352},
        {type: OfferPoiType.BUS, name: "Półłanki 03", distance: 388},
        {type: OfferPoiType.BUS, name: "Półłanki 04", distance: 392},
        {type: OfferPoiType.BUS, name: "Szparagowa 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Szparagowa 04", distance: 479},
        {type: OfferPoiType.BUS, name: "Szparagowa 06", distance: 580},
        {type: OfferPoiType.BUS, name: "Szparagowa 02", distance: 587},
        {type: OfferPoiType.BUS, name: "Bazarowa 01", distance: 790},
        {type: OfferPoiType.BUS, name: "Rybitwy Rozjazd 02", distance: 798},
        {type: OfferPoiType.REZERWAT, name: "Rybitwy", distance: 955},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Cegielni", distance: 1667},
        {type: OfferPoiType.PARK, name: "Park Zielone Serce Podgórza", distance: 1843}
    ],
    18631: [
        {type: OfferPoiType.BUS, name: "Srebrniki 02", distance: 169},
        {type: OfferPoiType.BUS, name: "Srebrniki 01", distance: 188},
        {type: OfferPoiType.BUS, name: "Niedźwiednik PKM 03", distance: 212},
        {type: OfferPoiType.BUS, name: "Cmentarz Srebrzysko 02", distance: 268},
        {type: OfferPoiType.BUS, name: "Cmentarz Srebrzysko 01", distance: 352},
        {type: OfferPoiType.BUS, name: "Niedźwiednik PKM 02", distance: 365},
        {type: OfferPoiType.BUS, name: "Niedźwiednik PKM 01", distance: 369},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Niedźwiednik", distance: 564},
        {type: OfferPoiType.BUS, name: "Chrzanowskiego 01", distance: 585},
        {type: OfferPoiType.BUS, name: "Chrzanowskiego 02", distance: 631},
        {type: OfferPoiType.BUS, name: "Zabytkowa 02", distance: 696},
        {type: OfferPoiType.PARK, name: "Skwer prof. Pawła Gałuszki", distance: 755},
        {type: OfferPoiType.PARK, name: "Plac Generała Stanisława Maczka", distance: 1228},
        {type: OfferPoiType.PARK, name: "Skwer im. Krzysztofa Kolbergera", distance: 1370},
        {type: OfferPoiType.PARK, name: "Skwer Marszałka Józefa Piłsudskiego", distance: 1382},
        {type: OfferPoiType.PARK, name: 'Dawny cmentarz katolicki "Urania"', distance: 1514},
        {type: OfferPoiType.PARK, name: "Park de Gaulle'a", distance: 1737},
        {type: OfferPoiType.PARK, name: "Park Okazała Strzyża", distance: 1762},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterskiego Mariupola", distance: 1809}
    ],
    18639: [
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 368},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 453},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 464},
        {type: OfferPoiType.TRAM, name: "Prudnicka", distance: 487},
        {type: OfferPoiType.BUS, name: "Prudnicka", distance: 501},
        {type: OfferPoiType.BUS, name: "Widna", distance: 606},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 687},
        {type: OfferPoiType.BUS, name: "Wapienna", distance: 713},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 714},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 1432},
        {type: OfferPoiType.PARK, name: "skwer Podpułkownika Ludwika Marszałka", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1689},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1850}
    ],
    18645: [
        {type: OfferPoiType.BUS, name: "Oknicka 01", distance: 562},
        {type: OfferPoiType.BUS, name: "Chudoby 01", distance: 578},
        {type: OfferPoiType.BUS, name: "Chudoby 02", distance: 683},
        {type: OfferPoiType.BUS, name: "Nauczycielska 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Os. Lewandów II 02", distance: 739},
        {type: OfferPoiType.BUS, name: "Nauczycielska 02", distance: 741},
        {type: OfferPoiType.BUS, name: "Oknicka 02", distance: 781},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 2174},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2259},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 2267},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 2352}
    ],
    18648: [
        {type: OfferPoiType.BUS, name: "Kościelna 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 194},
        {type: OfferPoiType.BUS, name: "Bolesława Prusa 02", distance: 205},
        {type: OfferPoiType.BUS, name: "Kościuszki 03", distance: 247},
        {type: OfferPoiType.BUS, name: "Bolesława Prusa 01", distance: 329},
        {type: OfferPoiType.BUS, name: "USC 01", distance: 335},
        {type: OfferPoiType.BUS, name: "USC 05", distance: 343},
        {type: OfferPoiType.BUS, name: "USC 04", distance: 370},
        {type: OfferPoiType.BUS, name: "Kubusia Puchatka 01", distance: 409},
        {type: OfferPoiType.BUS, name: "Urząd Miasta 01", distance: 410},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 655},
        {type: OfferPoiType.KOLEJ, name: "Pruszków WKD", distance: 706},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 737},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 781},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 1643},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1728}
    ],
    18651: [
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 732},
        {type: OfferPoiType.BUS, name: "Rojna - Kaczeńcowa", distance: 741},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 858},
        {type: OfferPoiType.PARK, name: "Park im. Stefana Żeromskiego", distance: 858},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 1001},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 1072},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1334},
        {type: OfferPoiType.PARK, name: "Skwer pocmentarny", distance: 1400},
        {type: OfferPoiType.PARK, name: "Park im. generała Władysława Andersa", distance: 1620}
    ],
    18652: [
        {type: OfferPoiType.BUS, name: "Glincz Szkola", distance: 327},
        {type: OfferPoiType.PARK, name: "Nad Stawem", distance: 552},
        {type: OfferPoiType.BUS, name: "Glincz Brzozowa 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Glincz Brzozowa 02", distance: 627}
    ],
    18653: [
        {type: OfferPoiType.BUS, name: "Świętopełka", distance: 124},
        {type: OfferPoiType.BUS, name: "Stara Rumia Cmentarz 01", distance: 404},
        {type: OfferPoiType.BUS, name: "Stara Rumia Cmentarz 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Rondo Jana Pawła II", distance: 558},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 05", distance: 602},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 04", distance: 635},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 06", distance: 644},
        {type: OfferPoiType.BUS, name: "Rumia Partyzantów 02", distance: 668},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1186},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 1200},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 2492}
    ],
    18661: [
        {type: OfferPoiType.BUS, name: "Św. Leonarda", distance: 178},
        {type: OfferPoiType.TRAM, name: "Św. Leonarda", distance: 265},
        {type: OfferPoiType.BUS, name: "Koronna", distance: 306},
        {type: OfferPoiType.BUS, name: "Os. Powstańców Warszawy", distance: 399},
        {type: OfferPoiType.TRAM, name: "Os. Winiary", distance: 457},
        {type: OfferPoiType.BUS, name: "Trójpole", distance: 487},
        {type: OfferPoiType.BUS, name: "Wyłom", distance: 489},
        {type: OfferPoiType.BUS, name: "Os. Winiary", distance: 494},
        {type: OfferPoiType.BUS, name: "Aleje Solidarności", distance: 547},
        {type: OfferPoiType.TRAM, name: "Aleje Solidarności", distance: 574},
        {type: OfferPoiType.TRAM, name: "Bonin", distance: 643},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 967},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1315},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1735},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 1823},
        {type: OfferPoiType.PARK, name: "Park Jurija Gagarina", distance: 1896},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 2283},
        {type: OfferPoiType.PARK, name: "Park Kosynierów", distance: 2301},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 2357}
    ],
    18670: [
        {type: OfferPoiType.BUS, name: "Życzliwa 02", distance: 102},
        {type: OfferPoiType.BUS, name: "Życzliwa 01", distance: 213},
        {type: OfferPoiType.BUS, name: "Węzeł Karczemki 02", distance: 459},
        {type: OfferPoiType.BUS, name: "Węzeł Karczemki 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Jasień Działki 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Jasień Działki 02", distance: 622},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1687}
    ],
    18671: [
        {type: OfferPoiType.BUS, name: "Klasztor Cystersów 01", distance: 388},
        {type: OfferPoiType.BUS, name: "Stare Wiślisko 02", distance: 478},
        {type: OfferPoiType.BUS, name: "Klasztor Cystersów 02", distance: 493},
        {type: OfferPoiType.BUS, name: "Stare Wiślisko 01", distance: 509},
        {type: OfferPoiType.BUS, name: "Sieroszewskiego 02", distance: 632},
        {type: OfferPoiType.BUS, name: "Sieroszewskiego 01", distance: 644},
        {type: OfferPoiType.PARK, name: "Park Rogozińskich", distance: 679},
        {type: OfferPoiType.BUS, name: "Szpital Żeromskiego 01", distance: 761},
        {type: OfferPoiType.BUS, name: "Szpital Żeromskiego 02", distance: 764},
        {type: OfferPoiType.BUS, name: "Klasztorna 06", distance: 794},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 816},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1254},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1928},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2075},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 2226},
        {type: OfferPoiType.PARK, name: "Park Zalew Nowohucki", distance: 2318},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 2487}
    ],
    18677: [
        {type: OfferPoiType.BUS, name: "Warszawska - Park 01", distance: 139},
        {type: OfferPoiType.PARK, name: "Skwer im. abp. Dobrogosta", distance: 142},
        {type: OfferPoiType.BUS, name: "Warszawska - Park 02", distance: 162},
        {type: OfferPoiType.BUS, name: "Legionów", distance: 201},
        {type: OfferPoiType.BUS, name: "Modlińska, ZUS", distance: 224},
        {type: OfferPoiType.PARK, name: "Skwer im. ks. Stanisława Poniatowskiego", distance: 239},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Józefa Wybickiego", distance: 265},
        {type: OfferPoiType.BUS, name: "Warszawska - Urząd Miejski 02", distance: 272},
        {type: OfferPoiType.PARK, name: "Plac Solny", distance: 273},
        {type: OfferPoiType.BUS, name: "Urząd Miasta 01", distance: 286},
        {type: OfferPoiType.BUS, name: "Warszawska - Urząd Miejski 01", distance: 290},
        {type: OfferPoiType.BUS, name: "Sawy, przedszkole", distance: 323},
        {type: OfferPoiType.BUS, name: "Modlińska, Kościół", distance: 355},
        {type: OfferPoiType.PARK, name: "Nadrzeczna Park", distance: 1131},
        {type: OfferPoiType.PARK, name: "Dębowy Park", distance: 2097}
    ],
    18678: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 381},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Gajowa", distance: 388},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 476},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 487},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 491},
        {type: OfferPoiType.BUS, name: "Rondo Skrzetuskie", distance: 573},
        {type: OfferPoiType.BUS, name: "Skłodowskiej-Curie / Bałtycka", distance: 717},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 761},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 772},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 959}
    ],
    18681: [
        {type: OfferPoiType.BUS, name: "Piekary", distance: 67},
        {type: OfferPoiType.BUS, name: "Mierosławskiego", distance: 152},
        {type: OfferPoiType.BUS, name: "Potulicka", distance: 295},
        {type: OfferPoiType.TRAM, name: "Potulicka", distance: 371},
        {type: OfferPoiType.TRAM, name: "Zapadła", distance: 475},
        {type: OfferPoiType.BUS, name: "Plac Szyrockiego", distance: 533},
        {type: OfferPoiType.TRAM, name: "Tama Pomorzańska", distance: 647},
        {type: OfferPoiType.TRAM, name: "Osiedle Polonia", distance: 665},
        {type: OfferPoiType.BUS, name: "Sowińskiego", distance: 731},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Dowbór-Muśnickiego", distance: 896},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 1204},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1592},
        {type: OfferPoiType.PARK, name: "Skwer imienia Michała Doliwo-Dobrowolskiego", distance: 1609},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1669},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 1705},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1865},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 2143}
    ],
    18696: [
        {type: OfferPoiType.BUS, name: "Rokietnica/Noblistów n/ż", distance: 268},
        {type: OfferPoiType.BUS, name: "Rokietnica Trakt Napoleoński", distance: 281},
        {type: OfferPoiType.BUS, name: "Rokietnica/Szkoła", distance: 633},
        {type: OfferPoiType.BUS, name: "Mrowino Leszka n/ż", distance: 697},
        {type: OfferPoiType.PARK, name: "Jeżogród", distance: 1348}
    ],
    18705: [
        {type: OfferPoiType.BUS, name: "Myśliwska 01", distance: 290},
        {type: OfferPoiType.BUS, name: "Lasówka 02", distance: 350},
        {type: OfferPoiType.BUS, name: "Myśliwska 02", distance: 373},
        {type: OfferPoiType.BUS, name: "Lasówka 01", distance: 428},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 632},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 02", distance: 751},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 836},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 839},
        {type: OfferPoiType.PARK, name: "Ptasi Zagajnik", distance: 860},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 1034},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1637},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 2137}
    ],
    18706: [
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 200},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 721},
        {type: OfferPoiType.BUS, name: "Babińskiego 01", distance: 807},
        {type: OfferPoiType.BUS, name: "Babińskiego 02", distance: 822},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1041},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2251},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2474}
    ],
    18709: [
        {type: OfferPoiType.BUS, name: "Asfaltowa (Szkoła)", distance: 190},
        {type: OfferPoiType.BUS, name: "Klasztorna", distance: 198},
        {type: OfferPoiType.BUS, name: "Parafialna", distance: 632},
        {type: OfferPoiType.BUS, name: "Maszkowskiego", distance: 633},
        {type: OfferPoiType.BUS, name: "Wojszyce", distance: 665},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 836}
    ],
    18710: [
        {type: OfferPoiType.BUS, name: "Proletariacka - Sowia NŻ", distance: 505},
        {type: OfferPoiType.BUS, name: "Rembielińskiego - Inżynierska NŻ", distance: 592},
        {type: OfferPoiType.BUS, name: "Radwańska - Inżynierska NŻ", distance: 684},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1042},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1929},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1938},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1965}
    ],
    18718: [
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1297},
        {type: OfferPoiType.REZERWAT, name: "Łąki na Klinach", distance: 1515},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2218},
        {type: OfferPoiType.PARK, name: "Park Maćka i Doroty", distance: 2384}
    ],
    18721: [
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 628},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 671},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1515},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 2186}
    ],
    18722: [
        {type: OfferPoiType.BUS, name: "Szybka 02", distance: 542},
        {type: OfferPoiType.BUS, name: "Szybka 01", distance: 565},
        {type: OfferPoiType.BUS, name: "Instalatorów 03", distance: 745},
        {type: OfferPoiType.BUS, name: "Instalatorów 01", distance: 793},
        {type: OfferPoiType.BUS, name: "Instalatorów 02", distance: 798},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 1896},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2206}
    ],
    18723: [
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 224},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 267},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 309},
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 367},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 378},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 390},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 423},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 436},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 451},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 05", distance: 470},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 01", distance: 471},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 476},
        {type: OfferPoiType.BUS, name: "Domaniewska 06", distance: 486},
        {type: OfferPoiType.BUS, name: "Domaniewska 05", distance: 511},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 539},
        {type: OfferPoiType.BUS, name: "Park Postępu 01", distance: 554},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 607},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 643},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 03", distance: 753},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 04", distance: 790},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1437},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1535}
    ],
    18724: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 348},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 371},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 420},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 463},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 666},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 689},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 710},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 827},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1322},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1684},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2462}
    ],
    18737: [
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 01", distance: 108},
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 02", distance: 180},
        {type: OfferPoiType.BUS, name: "Przyjazna 01", distance: 354},
        {type: OfferPoiType.BUS, name: "Przyjazna 02", distance: 399},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 405},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 01", distance: 436},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 02", distance: 513},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 522},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 04", distance: 657},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2473}
    ],
    18738: [
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 01", distance: 108},
        {type: OfferPoiType.BUS, name: "Dobka z Oleśnicy 02", distance: 180},
        {type: OfferPoiType.BUS, name: "Przyjazna 01", distance: 354},
        {type: OfferPoiType.BUS, name: "Przyjazna 02", distance: 399},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 405},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 01", distance: 436},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 02", distance: 513},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 522},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 531},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa - Szkoła 04", distance: 657},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2473}
    ],
    18741: [
        {type: OfferPoiType.PARK, name: "Park Świętej Barbary", distance: 651},
        {type: OfferPoiType.BUS, name: "Wieliczka Os. Kościuszki", distance: 733},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1466},
        {type: OfferPoiType.PARK, name: "Park Świętej Kingi", distance: 2124}
    ],
    18742: [
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 295},
        {type: OfferPoiType.BUS, name: "Cmentarz Prokocim 02", distance: 477},
        {type: OfferPoiType.TRAM, name: "Nowy Prokocim 02", distance: 517},
        {type: OfferPoiType.BUS, name: "Cmentarz Prokocim 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Bieżanów Trafo 02", distance: 541},
        {type: OfferPoiType.TRAM, name: "Nowy Prokocim 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Bieżanów Trafo 01", distance: 551},
        {type: OfferPoiType.BUS, name: "Nowy Prokocim 03", distance: 582},
        {type: OfferPoiType.BUS, name: "Nowy Prokocim 04", distance: 597},
        {type: OfferPoiType.TRAM, name: "Teligi 02", distance: 665},
        {type: OfferPoiType.TRAM, name: "Teligi 01", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 955},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1024},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1259},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1332},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1690}
    ],
    18744: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 224},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 354},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 445},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 450},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 476},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 660},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 820},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 893},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 937}
    ],
    18745: [
        {type: OfferPoiType.BUS, name: "Fordońska / Gajowa", distance: 272},
        {type: OfferPoiType.BUS, name: "Rondo Fordońskie", distance: 344},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 402},
        {type: OfferPoiType.BUS, name: "Fordońska / Bałtycka", distance: 424},
        {type: OfferPoiType.TRAM, name: "Fordońska / Bałtycka", distance: 429},
        {type: OfferPoiType.TRAM, name: "Bałtycka", distance: 455},
        {type: OfferPoiType.PARK, name: "Park nad Balatonem", distance: 640},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 917},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 941}
    ],
    18746: [
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1271},
        {type: OfferPoiType.PARK, name: "Skwer im. Konstantego Leona Wolickiego", distance: 1390},
        {type: OfferPoiType.PARK, name: "Park Sosnowy", distance: 1404},
        {type: OfferPoiType.PARK, name: "Partery Hellwiga", distance: 1419},
        {type: OfferPoiType.REZERWAT, name: "Otoczenie źródła solanki nr 11", distance: 1570}
    ],
    18747: [
        {type: OfferPoiType.BUS, name: "Aluzyjna 02", distance: 152},
        {type: OfferPoiType.BUS, name: "Aluzyjna 03", distance: 243},
        {type: OfferPoiType.BUS, name: "Aluzyjna 01", distance: 294},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 02", distance: 522},
        {type: OfferPoiType.BUS, name: "Chlubna 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Chlubna 02", distance: 674},
        {type: OfferPoiType.BUS, name: "Osiedle 02", distance: 695},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 2334},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 2338}
    ],
    18750: [
        {type: OfferPoiType.BUS, name: "Sternicza 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Sternicza 02", distance: 447},
        {type: OfferPoiType.BUS, name: "Siemiatycka 01", distance: 681},
        {type: OfferPoiType.BUS, name: "Siemiatycka 02", distance: 805},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2096},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 2292},
        {type: OfferPoiType.PARK, name: "Polanka", distance: 2373}
    ],
    18756: [
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 598},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 623},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 713},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 768},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1215},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1262}
    ],
    18757: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Królewska / Teligi", distance: 318},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Sienna", distance: 356},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Na Laski", distance: 450},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Teligi", distance: 459},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Bairda", distance: 490},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 554},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Braci Okuniów", distance: 587},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 913},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 1261},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1470},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1595},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1703},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1810},
        {type: OfferPoiType.PARK, name: "Skwer przy ulicy Górnej", distance: 2014},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 2036}
    ],
    18759: [
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 01", distance: 605},
        {type: OfferPoiType.BUS, name: "Melcera 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Suchy Las 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Piastowska 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 02", distance: 661},
        {type: OfferPoiType.BUS, name: "Melcera 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Piastowska 01", distance: 730},
        {type: OfferPoiType.BUS, name: "Jesionowa 02", distance: 739},
        {type: OfferPoiType.BUS, name: "Suchy Las 02", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 1361},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1658},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 1822},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1892},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1916},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 2228}
    ],
    18766: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Teklin", distance: 328},
        {type: OfferPoiType.BUS, name: "Łódzka - Teklin", distance: 457},
        {type: OfferPoiType.BUS, name: "Dąbrowa", distance: 566},
        {type: OfferPoiType.TRAM, name: "Dąbrowa", distance: 578},
        {type: OfferPoiType.BUS, name: "Wschodnia 119", distance: 752},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 1188}
    ],
    18771: [
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 388},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 558},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Dębogórze-Wybudowanie - Długa 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1325},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1372},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2263}
    ],
    18778: [
        {type: OfferPoiType.BUS, name: "Węzeł Żołnierzy Wyklętych", distance: 213},
        {type: OfferPoiType.BUS, name: "Ściegiennego", distance: 293},
        {type: OfferPoiType.BUS, name: "Zamenhofa", distance: 499},
        {type: OfferPoiType.BUS, name: "Morska - Estakada", distance: 513},
        {type: OfferPoiType.PARK, name: "Park Zielone Leszczynki", distance: 775},
        {type: OfferPoiType.PARK, name: "Kieszonka na fali", distance: 886},
        {type: OfferPoiType.PARK, name: "Kieszonka na kocyk", distance: 2167}
    ],
    18787: [
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 468},
        {type: OfferPoiType.BUS, name: "św.Krzysztofa", distance: 604},
        {type: OfferPoiType.BUS, name: "Łódzka", distance: 667},
        {type: OfferPoiType.BUS, name: "Okulickiego", distance: 679},
        {type: OfferPoiType.BUS, name: "Rynek Wieluński", distance: 738},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 793},
        {type: OfferPoiType.PARK, name: "Park 3 Maja", distance: 1308},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Staszica", distance: 1594},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Zbigniewa Religi", distance: 1877},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 2199},
        {type: OfferPoiType.PARK, name: "Spacerniak", distance: 2208},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny Jędrusik", distance: 2239}
    ],
    18789: [
        {type: OfferPoiType.BUS, name: "Obywatelska - Jana Pawła II", distance: 630},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Wróblewskiego", distance: 676},
        {type: OfferPoiType.BUS, name: "Proletariacka - Wróblewskiego NŻ", distance: 703},
        {type: OfferPoiType.BUS, name: "Jana Pawła II - Obywatelska", distance: 757},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1131},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1645},
        {type: OfferPoiType.PARK, name: "Park Wenecja im. Juliusza Słowackiego", distance: 1832},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 1867},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 1920},
        {type: OfferPoiType.PARK, name: "Park im. ksIęcia Józefa Poniatowskiego", distance: 1941}
    ],
    18793: [
        {type: OfferPoiType.BUS, name: "Międzylesie", distance: 360},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 646},
        {type: OfferPoiType.BUS, name: "Paderewskiego NŻ", distance: 767},
        {type: OfferPoiType.LAS, name: "Hałdy Single Track", distance: 972},
        {type: OfferPoiType.PARK, name: "Skwer Przyjaciół Dzieci", distance: 2316}
    ],
    18794: [
        {type: OfferPoiType.BUS, name: "Międzylesie", distance: 326},
        {type: OfferPoiType.BUS, name: "Paderewskiego", distance: 612},
        {type: OfferPoiType.BUS, name: "Paderewskiego NŻ", distance: 733},
        {type: OfferPoiType.BUS, name: "Moniuszki NŻ", distance: 819},
        {type: OfferPoiType.BUS, name: "Kleczewska", distance: 835},
        {type: OfferPoiType.LAS, name: "Hałdy Single Track", distance: 938},
        {type: OfferPoiType.PARK, name: "Skwer Przyjaciół Dzieci", distance: 2282}
    ],
    18796: [
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 340},
        {type: OfferPoiType.BUS, name: "Mazowiecka 02", distance: 431},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 460},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 02", distance: 481},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Dokerów", distance: 522},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 03", distance: 530},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 577},
        {type: OfferPoiType.BUS, name: "Ormińskiego 02", distance: 687},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2335}
    ],
    18797: [
        {type: OfferPoiType.BUS, name: "Port", distance: 54},
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 124},
        {type: OfferPoiType.BUS, name: "Port 05", distance: 151},
        {type: OfferPoiType.BUS, name: "Plac Kościelny", distance: 240},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 327},
        {type: OfferPoiType.BUS, name: "Centrum 01", distance: 338},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 03", distance: 373},
        {type: OfferPoiType.BUS, name: "Centrum 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 04", distance: 384},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Steyera 02", distance: 472},
        {type: OfferPoiType.LAS, name: "Parki Miejski im. Fryderyka Chopina", distance: 638},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 638}
    ],
    18820: [
        {type: OfferPoiType.BUS, name: "Stabłowicka (Ośrodek zdrowia)", distance: 311},
        {type: OfferPoiType.BUS, name: "Stabłowicka", distance: 367},
        {type: OfferPoiType.BUS, name: "Pracze Odrzańskie (Stacja kolejowa)", distance: 503},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Pracze", distance: 551},
        {type: OfferPoiType.BUS, name: "Główna", distance: 755},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1381},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 1508},
        {type: OfferPoiType.PARK, name: "Park Leśny w Praczach Odrzańskich", distance: 1865},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2310},
        {type: OfferPoiType.REZERWAT, name: "Las Pracki", distance: 2489}
    ],
    18823: [
        {type: OfferPoiType.BUS, name: "Białołęka-Ratusz 03", distance: 146},
        {type: OfferPoiType.BUS, name: "Milenijna 01", distance: 151},
        {type: OfferPoiType.BUS, name: "Ceramiczna 01", distance: 151},
        {type: OfferPoiType.BUS, name: "Białołęka-Ratusz 01", distance: 170},
        {type: OfferPoiType.BUS, name: "Ceramiczna 02", distance: 238},
        {type: OfferPoiType.BUS, name: "Białołęka-Ratusz 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Milenijna 02", distance: 293},
        {type: OfferPoiType.BUS, name: "Kaflowa 01", distance: 466},
        {type: OfferPoiType.BUS, name: "Braci Zawadzkich 01", distance: 517},
        {type: OfferPoiType.LAS, name: "Park Wiśniewo", distance: 531},
        {type: OfferPoiType.BUS, name: "Kaflowa 02", distance: 565},
        {type: OfferPoiType.TRAM, name: "Myśliborska 06", distance: 743},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 01", distance: 757},
        {type: OfferPoiType.TRAM, name: "Śreniawitów 02", distance: 762},
        {type: OfferPoiType.TRAM, name: "Myśliborska 05", distance: 774},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1442},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 1622},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 2074}
    ],
    18824: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 452},
        {type: OfferPoiType.BUS, name: "Niestachowska", distance: 633},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 789},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1555},
        {type: OfferPoiType.PARK, name: "Ogród Dendrologiczny UPP", distance: 1713},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1854},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1916},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1950},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2024},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 2030},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 2074},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 2123}
    ],
    18826: [
        {type: OfferPoiType.BUS, name: "Jawornicka", distance: 236},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 355},
        {type: OfferPoiType.BUS, name: "Rondo Skubiszewskiego", distance: 384},
        {type: OfferPoiType.TRAM, name: "Rondo Skubiszewskiego", distance: 474},
        {type: OfferPoiType.BUS, name: "Jugosłowiańska", distance: 634},
        {type: OfferPoiType.TRAM, name: "Węgorka", distance: 698},
        {type: OfferPoiType.TRAM, name: "Budziszyńska", distance: 743},
        {type: OfferPoiType.BUS, name: "Budziszyńska n/ż", distance: 744},
        {type: OfferPoiType.BUS, name: "Budziszyńska", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 1139},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 1203},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1544},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Górczyński", distance: 1903}
    ],
    18828: [
        {type: OfferPoiType.BUS, name: "Nowy Bytom Osiedle Otylia", distance: 252},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Pokoju", distance: 707},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Chorzowska", distance: 722},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Centrum", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Dworski", distance: 1038},
        {type: OfferPoiType.PARK, name: "Zrewitalizowana Hałda Pocynkowa", distance: 1292},
        {type: OfferPoiType.PARK, name: "Ogród Ślaskiego Teatru Impresaryjnego", distance: 1449},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Hallera", distance: 2155},
        {type: OfferPoiType.PARK, name: "Góra Antonia", distance: 2190},
        {type: OfferPoiType.PARK, name: "Strefa Aktywności Rodzinnej Bykowina", distance: 2276},
        {type: OfferPoiType.PARK, name: "Park im. Juliana Tuwima", distance: 2427}
    ],
    18831: [
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 164},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 174},
        {type: OfferPoiType.BUS, name: "Natansona 02", distance: 226},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 03", distance: 247},
        {type: OfferPoiType.BUS, name: "Natansona 01", distance: 279},
        {type: OfferPoiType.BUS, name: "Kuźnicy Kołłątajowskiej 04", distance: 331},
        {type: OfferPoiType.BUS, name: "Siewna 03", distance: 517},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 546},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 548},
        {type: OfferPoiType.BUS, name: "Bociana 04", distance: 562},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 586},
        {type: OfferPoiType.BUS, name: "ks. Meiera 04", distance: 600},
        {type: OfferPoiType.TRAM, name: "Bociana 02", distance: 603},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 610},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 624},
        {type: OfferPoiType.TRAM, name: "Bociana 01", distance: 648},
        {type: OfferPoiType.TRAM, name: "Siewna Wiadukt 02", distance: 831},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1431},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1838},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1881},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2070},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2121},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 2186}
    ],
    18832: [
        {type: OfferPoiType.BUS, name: "Os. Na Stoku", distance: 130},
        {type: OfferPoiType.BUS, name: "Orląt Lwowskich", distance: 267},
        {type: OfferPoiType.BUS, name: "Orląt Lwowskich / Żłobek", distance: 481},
        {type: OfferPoiType.BUS, name: "Sikorskiego", distance: 492},
        {type: OfferPoiType.BUS, name: "Nowaka-Jeziorańskiego / os. Na Stoku", distance: 532},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 2430}
    ],
    18833: [
        {type: OfferPoiType.BUS, name: "Wiatraczna", distance: 192},
        {type: OfferPoiType.BUS, name: "Brneńska n/ż", distance: 308},
        {type: OfferPoiType.LAS, name: "Las kieszonkowy", distance: 443},
        {type: OfferPoiType.TRAM, name: "Łacina", distance: 443},
        {type: OfferPoiType.BUS, name: "Os. Tysiąclecia", distance: 532},
        {type: OfferPoiType.TRAM, name: "Os. Tysiąclecia", distance: 538},
        {type: OfferPoiType.BUS, name: "Os. Lecha II", distance: 667},
        {type: OfferPoiType.BUS, name: "Os. Jagiellońskie n/ż", distance: 714},
        {type: OfferPoiType.REZERWAT, name: "Traszki Ratajskie", distance: 745},
        {type: OfferPoiType.BUS, name: "Os. Lecha I n/ż", distance: 755},
        {type: OfferPoiType.TRAM, name: "Polanka", distance: 770},
        {type: OfferPoiType.PARK, name: "Park na os. Tysiąclecia", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Rataje", distance: 1241},
        {type: OfferPoiType.PARK, name: "Park na os. Orła Białego", distance: 1707},
        {type: OfferPoiType.PARK, name: "Park Forteczny", distance: 1800},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 1888},
        {type: OfferPoiType.PARK, name: "Park na os. Armii Krajowej", distance: 2003},
        {type: OfferPoiType.PARK, name: "Park Nad Wartą", distance: 2065},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 2142},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 2488}
    ],
    18836: [
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 01", distance: 94},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy 02", distance: 236},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy", distance: 345},
        {type: OfferPoiType.BUS, name: "ZUS 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Rondo ks. J. Popiełuszki 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Jastrzębia 02", distance: 603},
        {type: OfferPoiType.BUS, name: "Powstańców 03", distance: 632},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 641},
        {type: OfferPoiType.BUS, name: "Działkowa 01", distance: 694},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 898},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 1311},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1707},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1868},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 2201}
    ],
    18841: [
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1266},
        {type: OfferPoiType.PARK, name: "Małpi Gaj", distance: 1947}
    ],
    18842: [
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1266},
        {type: OfferPoiType.PARK, name: "Małpi Gaj", distance: 1947}
    ],
    18843: [
        {type: OfferPoiType.BUS, name: "Obornicka (Wołowska)", distance: 274},
        {type: OfferPoiType.BUS, name: "Wołowska", distance: 412},
        {type: OfferPoiType.TRAM, name: "Wołowska", distance: 417},
        {type: OfferPoiType.BUS, name: "Bezpieczna", distance: 458},
        {type: OfferPoiType.TRAM, name: "Poświętne", distance: 670},
        {type: OfferPoiType.BUS, name: "Paprotna", distance: 690},
        {type: OfferPoiType.BUS, name: "Poświętne", distance: 722},
        {type: OfferPoiType.BUS, name: "Kępińska", distance: 765},
        {type: OfferPoiType.TRAM, name: "Kępińska", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 2263}
    ],
    18850: [
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 399},
        {type: OfferPoiType.BUS, name: "Markowska 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Markowska 02", distance: 500},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Wileńska", distance: 522},
        {type: OfferPoiType.BUS, name: "Korsaka 02", distance: 618},
        {type: OfferPoiType.BUS, name: "Ząbkowska 06", distance: 646},
        {type: OfferPoiType.BUS, name: "Dworzec Wileński 04", distance: 657},
        {type: OfferPoiType.BUS, name: "Rzeszotarskiej 02", distance: 662},
        {type: OfferPoiType.METRO, name: "Dworzec Wileński", distance: 665},
        {type: OfferPoiType.BUS, name: "Rzeszotarskiej 01", distance: 682},
        {type: OfferPoiType.TRAM, name: "Dworzec Wileński 07", distance: 682},
        {type: OfferPoiType.BUS, name: "Dworzec Wileński 06", distance: 688},
        {type: OfferPoiType.BUS, name: "Dworzec Wileński 01", distance: 760},
        {type: OfferPoiType.BUS, name: "Korsaka 01", distance: 781},
        {type: OfferPoiType.TRAM, name: "Ząbkowska 04", distance: 821},
        {type: OfferPoiType.TRAM, name: "Dworzec Wileński 08", distance: 825},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 1285},
        {type: OfferPoiType.PARK, name: "Skwer Kępna-Jagiellońska", distance: 1370},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1372},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 1493}
    ],
    18854: [
        {type: OfferPoiType.BUS, name: "Tarnogajska", distance: 132},
        {type: OfferPoiType.TRAM, name: "Tarnogajska", distance: 177},
        {type: OfferPoiType.TRAM, name: "Nyska", distance: 495},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 536},
        {type: OfferPoiType.BUS, name: "Nyska", distance: 563},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 623},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 633},
        {type: OfferPoiType.TRAM, name: "Bardzka", distance: 750},
        {type: OfferPoiType.BUS, name: "Bardzka", distance: 763},
        {type: OfferPoiType.TRAM, name: "Kamienna", distance: 784},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 788},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 793},
        {type: OfferPoiType.BUS, name: "Kamienna", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1994},
        {type: OfferPoiType.PARK, name: "Skwer Komisji Edukacji Narodowej", distance: 2188},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 2210}
    ],
    18855: [
        {type: OfferPoiType.TRAM, name: "Aleja Reymonta 03", distance: 68},
        {type: OfferPoiType.BUS, name: "Aleja Reymonta 05", distance: 84},
        {type: OfferPoiType.TRAM, name: "Aleja Reymonta 08", distance: 118},
        {type: OfferPoiType.TRAM, name: "Aleja Reymonta 04", distance: 154},
        {type: OfferPoiType.BUS, name: "Aleja Reymonta 06", distance: 178},
        {type: OfferPoiType.BUS, name: "Aleja Reymonta 01", distance: 211},
        {type: OfferPoiType.BUS, name: "Andersena 03", distance: 298},
        {type: OfferPoiType.BUS, name: "Andersena 02", distance: 415},
        {type: OfferPoiType.BUS, name: "Andersena 01", distance: 429},
        {type: OfferPoiType.BUS, name: "Andersena 04", distance: 447},
        {type: OfferPoiType.TRAM, name: "Aspekt 03", distance: 485},
        {type: OfferPoiType.TRAM, name: "Aspekt 04", distance: 495},
        {type: OfferPoiType.BUS, name: "Aspekt 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Aspekt 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Conrada 02", distance: 546},
        {type: OfferPoiType.TRAM, name: "Conrada 05", distance: 621},
        {type: OfferPoiType.TRAM, name: "Conrada 06", distance: 663},
        {type: OfferPoiType.TRAM, name: "Piaski 04", distance: 772},
        {type: OfferPoiType.TRAM, name: "Piaski 03", distance: 799},
        {type: OfferPoiType.TRAM, name: "Piaski 05", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Chomicza", distance: 886},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1206},
        {type: OfferPoiType.PARK, name: "Eco Skwerek", distance: 1496},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1568},
        {type: OfferPoiType.PARK, name: "Jordanek", distance: 1780},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1806},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1947}
    ],
    18863: [
        {type: OfferPoiType.BUS, name: "Żółkiewskiego / Sobieskiego", distance: 384},
        {type: OfferPoiType.BUS, name: "Chrobrego / Rapackiego 10", distance: 541},
        {type: OfferPoiType.BUS, name: "Mieszka I / Żółkiewskiego 02", distance: 557},
        {type: OfferPoiType.BUS, name: "Chrobrego / Rapackiego 09", distance: 620},
        {type: OfferPoiType.BUS, name: "Rapackiego / Chrobrego 02", distance: 694},
        {type: OfferPoiType.BUS, name: "Mieszka I / Królowej Jadwigi 01", distance: 775},
        {type: OfferPoiType.PARK, name: "Park Michałów", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Gołębiów", distance: 1794}
    ],
    18877: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 498},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 633},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 746},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 767},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 793},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 802},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2272},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2475}
    ],
    18882: [
        {type: OfferPoiType.BUS, name: "Zesławice 01", distance: 278},
        {type: OfferPoiType.BUS, name: "Zesławice 02", distance: 290},
        {type: OfferPoiType.BUS, name: "Zesławice Ogródki Działkowe 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Zesławice Ogródki Działkowe 01", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Zakole", distance: 1276},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 2066}
    ],
    18888: [
        {type: OfferPoiType.BUS, name: "Jasielska I n/ż", distance: 152},
        {type: OfferPoiType.BUS, name: "Instytut Genetyki n/ż", distance: 353},
        {type: OfferPoiType.BUS, name: "Jasielska II n/ż", distance: 449},
        {type: OfferPoiType.BUS, name: "Strzeszyńska II", distance: 573},
        {type: OfferPoiType.BUS, name: "Strzeszyńska n/ż", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 1052},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1173},
        {type: OfferPoiType.PARK, name: "Park Edukacji Ekologicznej Strzeszyn", distance: 1446},
        {type: OfferPoiType.PARK, name: "Aleja Demokracji", distance: 1639},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 2432}
    ],
    18895: [
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 248},
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 293},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 716},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 743},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 743},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1873}
    ],
    18902: [
        {type: OfferPoiType.BUS, name: "Tartaczna/Straż Graniczna (122)", distance: 247},
        {type: OfferPoiType.BUS, name: "Tartaczna/Bloki (123)", distance: 328},
        {type: OfferPoiType.BUS, name: "Tartaczna/Pętla (113)", distance: 356},
        {type: OfferPoiType.BUS, name: "Turystyczna/Augustowianka (n/ż) (44)", distance: 359},
        {type: OfferPoiType.BUS, name: "Turystyczna/Rozlewnia Augustowianki (n/ż) (3)", distance: 371},
        {type: OfferPoiType.BUS, name: "Turystyczna/Wypoczynkowa (n/ż) (2)", distance: 429},
        {type: OfferPoiType.BUS, name: "Turystyczna/Jednostka Wojskowa (124) (n/ż)", distance: 479},
        {type: OfferPoiType.BUS, name: "Tartaczna/Os. Lipowiec (73)", distance: 481},
        {type: OfferPoiType.BUS, name: "Tartaczna/Szkoła nr 6 (42)", distance: 603},
        {type: OfferPoiType.PARK, name: "Park Herberta", distance: 796},
        {type: OfferPoiType.LAS, name: "7", distance: 894}
    ],
    18905: [
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 01", distance: 375},
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 02", distance: 402},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 503},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 573},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 578},
        {type: OfferPoiType.BUS, name: "Małych Dębów 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 779},
        {type: OfferPoiType.BUS, name: "Małych Dębów 02", distance: 784}
    ],
    18906: [
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 06", distance: 90},
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 05", distance: 116},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 02", distance: 138},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 01", distance: 230},
        {type: OfferPoiType.PARK, name: "Dolinka Marymoncka", distance: 275},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 03", distance: 294},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 04", distance: 310},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 342},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 07", distance: 370},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 04", distance: 392},
        {type: OfferPoiType.METRO, name: "Słodowiec", distance: 411},
        {type: OfferPoiType.BUS, name: "Park Kaskada 02", distance: 445},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 03", distance: 475},
        {type: OfferPoiType.PARK, name: "Stawy Kellera", distance: 483},
        {type: OfferPoiType.BUS, name: "Park Kaskada 06", distance: 494},
        {type: OfferPoiType.BUS, name: "Park Kaskada 05", distance: 505},
        {type: OfferPoiType.BUS, name: "Park Kaskada 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Hłaski 02", distance: 603},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 03", distance: 614},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 08", distance: 635},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 04", distance: 643},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 09", distance: 733},
        {type: OfferPoiType.PARK, name: "Park Kaskada", distance: 742},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 04", distance: 810},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 71", distance: 830},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 925},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1016},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1196},
        {type: OfferPoiType.PARK, name: "Park Harcerskiej Poczty Polowej Powstania Warszawskiego", distance: 1332},
        {type: OfferPoiType.PARK, name: "Skwer Igora Newerlego", distance: 1384},
        {type: OfferPoiType.PARK, name: 'Park Żołnierzy "Żywiciela"', distance: 1470}
    ],
    18907: [
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 06", distance: 76},
        {type: OfferPoiType.TRAM, name: "Metro Słodowiec 05", distance: 102},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 02", distance: 124},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 01", distance: 216},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 03", distance: 280},
        {type: OfferPoiType.PARK, name: "Dolinka Marymoncka", distance: 289},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 04", distance: 296},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 328},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 04", distance: 378},
        {type: OfferPoiType.BUS, name: "Metro Słodowiec 07", distance: 384},
        {type: OfferPoiType.METRO, name: "Słodowiec", distance: 397},
        {type: OfferPoiType.BUS, name: "Park Kaskada 02", distance: 431},
        {type: OfferPoiType.TRAM, name: "Park Kaskada 03", distance: 461},
        {type: OfferPoiType.PARK, name: "Stawy Kellera", distance: 469},
        {type: OfferPoiType.BUS, name: "Park Kaskada 06", distance: 480},
        {type: OfferPoiType.BUS, name: "Park Kaskada 05", distance: 491},
        {type: OfferPoiType.BUS, name: "Park Kaskada 01", distance: 497},
        {type: OfferPoiType.BUS, name: "Hłaski 02", distance: 589},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 08", distance: 621},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 03", distance: 628},
        {type: OfferPoiType.TRAM, name: "Podleśna IMGW 04", distance: 657},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 09", distance: 719},
        {type: OfferPoiType.PARK, name: "Park Kaskada", distance: 728},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 04", distance: 796},
        {type: OfferPoiType.TRAM, name: "Metro Marymont 71", distance: 816},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 911},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1002},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1182},
        {type: OfferPoiType.PARK, name: "Park Harcerskiej Poczty Polowej Powstania Warszawskiego", distance: 1318},
        {type: OfferPoiType.PARK, name: "Skwer Igora Newerlego", distance: 1370},
        {type: OfferPoiType.PARK, name: 'Park Żołnierzy "Żywiciela"', distance: 1456}
    ],
    18913: [
        {type: OfferPoiType.LAS, name: "Park rzeczny Wilgi", distance: 301},
        {type: OfferPoiType.PARK, name: "Park rzeczny Wilgi", distance: 301},
        {type: OfferPoiType.BUS, name: "Lipińskiego 03", distance: 445},
        {type: OfferPoiType.BUS, name: "Lipińskiego 04", distance: 453},
        {type: OfferPoiType.TRAM, name: "Lipińskiego 02", distance: 469},
        {type: OfferPoiType.TRAM, name: "Lipińskiego 01", distance: 489},
        {type: OfferPoiType.BUS, name: "Borsucza 04", distance: 568},
        {type: OfferPoiType.TRAM, name: "Borsucza 01", distance: 585},
        {type: OfferPoiType.TRAM, name: "Borsucza 02", distance: 595},
        {type: OfferPoiType.BUS, name: "Borsucza 03", distance: 618},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 05", distance: 721},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 02", distance: 761},
        {type: OfferPoiType.TRAM, name: "Brożka 02", distance: 781},
        {type: OfferPoiType.TRAM, name: "Brożka 01", distance: 785},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 03", distance: 795},
        {type: OfferPoiType.BUS, name: "Krokusowa 02", distance: 820},
        {type: OfferPoiType.TRAM, name: "Grota-Roweckiego 01", distance: 827},
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego 04", distance: 832},
        {type: OfferPoiType.BUS, name: "Kobierzyńska 04", distance: 834},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 938},
        {type: OfferPoiType.PARK, name: "Park Solvay", distance: 1827},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1855},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2076},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2255}
    ],
    18915: [
        {type: OfferPoiType.BUS, name: "Przestrzenna - Tabelowa NŻ", distance: 770},
        {type: OfferPoiType.LAS, name: "Las Popioły", distance: 973},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Ruda Willowa”", distance: 1543},
        {type: OfferPoiType.PARK, name: "Rudzka Góra", distance: 2085},
        {type: OfferPoiType.PARK, name: "Park Mirabelka", distance: 2086},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2198}
    ],
    18927: [
        {type: OfferPoiType.TRAM, name: "Hetmańska - Zagłoby", distance: 520},
        {type: OfferPoiType.BUS, name: "Hetmańska - Zagłoby", distance: 561},
        {type: OfferPoiType.TRAM, name: "Hetmańska - Dąbrówki", distance: 650},
        {type: OfferPoiType.BUS, name: "Hetmańska - Dąbrówki", distance: 683},
        {type: OfferPoiType.BUS, name: "Hetmańska - Juranda ze Spychowa", distance: 797},
        {type: OfferPoiType.PARK, name: "Park na Janowie", distance: 1185},
        {type: OfferPoiType.PARK, name: "Park Źródła Olechówki", distance: 1709}
    ],
    18929: [
        {type: OfferPoiType.BUS, name: "Barlickiego - poczta", distance: 54},
        {type: OfferPoiType.BUS, name: "Fińska", distance: 292},
        {type: OfferPoiType.BUS, name: "Barlickiego / Ludzi Morza", distance: 302},
        {type: OfferPoiType.BUS, name: "Barlickiego - Dworzec", distance: 365},
        {type: OfferPoiType.BUS, name: "Duńska 01", distance: 423},
        {type: OfferPoiType.BUS, name: "Skandynawska n/ż", distance: 446},
        {type: OfferPoiType.BUS, name: "Ludzi Morza / Łąkowa", distance: 460},
        {type: OfferPoiType.KOLEJ, name: "Świnoujście", distance: 655},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 1522}
    ],
    18933: [
        {type: OfferPoiType.PARK, name: "Skwer Pomorskiego Okręgu Wojskowego", distance: 509},
        {type: OfferPoiType.BUS, name: "Sułkowskiego / Kamienna", distance: 513},
        {type: OfferPoiType.BUS, name: "Kamienna / Sułkowskiego", distance: 556},
        {type: OfferPoiType.BUS, name: "Gdańska / Powst. Warszawy", distance: 614},
        {type: OfferPoiType.BUS, name: "Kamienna / Gdańska", distance: 622},
        {type: OfferPoiType.BUS, name: "Czerkaska / Sułkowskiego", distance: 632},
        {type: OfferPoiType.BUS, name: "Gdańska / Artyleryjska", distance: 648},
        {type: OfferPoiType.TRAM, name: "Gdańska / Artyleryjska", distance: 651},
        {type: OfferPoiType.TRAM, name: "Gdańska / Powst. Warszawy", distance: 669},
        {type: OfferPoiType.PARK, name: "Skwer Inwalidów Wojennych", distance: 734},
        {type: OfferPoiType.PARK, name: "Skwer im. Teresy Ciepły", distance: 827}
    ],
    18945: [
        {type: OfferPoiType.BUS, name: "Dąbrowska 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Leśna 02", distance: 618},
        {type: OfferPoiType.BUS, name: "Dąbrowska 01", distance: 624},
        {type: OfferPoiType.BUS, name: "Wyścigowa 03", distance: 660},
        {type: OfferPoiType.BUS, name: "Dunikowskiego - osiedle 01", distance: 679},
        {type: OfferPoiType.PARK, name: "Perłowy Zakątek", distance: 682},
        {type: OfferPoiType.BUS, name: "Wyścigowa 02", distance: 715},
        {type: OfferPoiType.BUS, name: "Wyścigowa - szkoła 02", distance: 737},
        {type: OfferPoiType.BUS, name: "Pawia 01", distance: 788},
        {type: OfferPoiType.BUS, name: "Wyścigowa - szkoła 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Nowy Świat 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Skwer Borowiczan", distance: 1440}
    ],
    18947: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Okęcie", distance: 609},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 04", distance: 681},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 749},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1843}
    ],
    18949: [
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Łużycka  02", distance: 529},
        {type: OfferPoiType.BUS, name: "Brzegowa 01", distance: 718},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1058}
    ],
    18950: [
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 14", distance: 187},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 10", distance: 208},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 11", distance: 244},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 13", distance: 269},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ochota WKD", distance: 409},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 433},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 08", distance: 441},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 06", distance: 444},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ochota", distance: 479},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 04", distance: 493},
        {type: OfferPoiType.TRAM, name: "Plac Zawiszy 05", distance: 494},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 02", distance: 500},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Główna", distance: 524},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 03", distance: 526},
        {type: OfferPoiType.BUS, name: "Plac Starynkiewicza 02", distance: 527},
        {type: OfferPoiType.BUS, name: "Plac Zawiszy 15", distance: 549},
        {type: OfferPoiType.BUS, name: "Plac Starynkiewicza 06", distance: 550},
        {type: OfferPoiType.BUS, name: "Sienna 01", distance: 554},
        {type: OfferPoiType.BUS, name: "Rondo Daszyńskiego 03", distance: 554},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 06", distance: 573},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 07", distance: 654},
        {type: OfferPoiType.TRAM, name: "Ochota-Ratusz 02", distance: 677},
        {type: OfferPoiType.TRAM, name: "Rondo Daszyńskiego 56", distance: 690},
        {type: OfferPoiType.TRAM, name: "Plac Starynkiewicza 03", distance: 695},
        {type: OfferPoiType.METRO, name: "Rondo Daszyńskiego", distance: 734},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 932},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1113},
        {type: OfferPoiType.PARK, name: "Skwer Sue Ryder", distance: 1356},
        {type: OfferPoiType.PARK, name: "Park Wielkopolski", distance: 1524},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 1529},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 1592},
        {type: OfferPoiType.PARK, name: "Park Świętokrzyski", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 1607}
    ],
    18951: [
        {type: OfferPoiType.BUS, name: "Maczka 01", distance: 210},
        {type: OfferPoiType.BUS, name: "Dzika 01", distance: 249},
        {type: OfferPoiType.BUS, name: "Dzika 02", distance: 275},
        {type: OfferPoiType.BUS, name: "Maczka 04", distance: 294},
        {type: OfferPoiType.BUS, name: "Maczka 02", distance: 308},
        {type: OfferPoiType.BUS, name: "Maczka 03", distance: 317},
        {type: OfferPoiType.BUS, name: "Zieleniecka 02", distance: 671},
        {type: OfferPoiType.BUS, name: "Powstańców 04", distance: 740},
        {type: OfferPoiType.BUS, name: "Kosynierów 03", distance: 777},
        {type: OfferPoiType.BUS, name: "Zieleniecka 01", distance: 784},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 2358}
    ],
    18953: [
        {type: OfferPoiType.BUS, name: "Piekarnicza 04", distance: 162},
        {type: OfferPoiType.TRAM, name: "Piekarnicza", distance: 226},
        {type: OfferPoiType.BUS, name: "Piekarnicza 03", distance: 287},
        {type: OfferPoiType.BUS, name: "Nowolipie 01", distance: 588},
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 02", distance: 751},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 755},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 767},
        {type: OfferPoiType.BUS, name: "Park Naukowo - Technologiczny 01", distance: 768},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 772},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 772},
        {type: OfferPoiType.BUS, name: "Belgradzka 04", distance: 792},
        {type: OfferPoiType.BUS, name: "Belgradzka 03", distance: 818},
        {type: OfferPoiType.LAS, name: "Lasek Buloński", distance: 904},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 904},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 1338},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 1992},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 2032}
    ],
    18956: [
        {type: OfferPoiType.BUS, name: "Nowodworska", distance: 268},
        {type: OfferPoiType.TRAM, name: "Nowodworska", distance: 268},
        {type: OfferPoiType.BUS, name: "Strzegomska (krzyżówka)", distance: 576},
        {type: OfferPoiType.TRAM, name: "Strzegomska (krzyżówka)", distance: 593},
        {type: OfferPoiType.BUS, name: "Chociebuska (Centrum Kultury Nowy Pafawag)", distance: 603},
        {type: OfferPoiType.BUS, name: "Muchobór Mały (stacja kolejowa)", distance: 721},
        {type: OfferPoiType.BUS, name: "Strzegomska 148", distance: 799},
        {type: OfferPoiType.TRAM, name: "Strzegomska 148", distance: 799},
        {type: OfferPoiType.PARK, name: "Park Leonarda", distance: 1921},
        {type: OfferPoiType.PARK, name: "skwer Księdza Szczepana Zielińskiego", distance: 1937},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 2350}
    ],
    18957: [
        {type: OfferPoiType.TRAM, name: "Teatr Variété 01", distance: 363},
        {type: OfferPoiType.TRAM, name: "Teatr Variété 02", distance: 393},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 408},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 476},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 07", distance: 492},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 04", distance: 493},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 05", distance: 502},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 01", distance: 521},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 06", distance: 573},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 02", distance: 588},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 03", distance: 607},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 08", distance: 612},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 615},
        {type: OfferPoiType.BUS, name: "Nullo 03", distance: 623},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 633},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 641},
        {type: OfferPoiType.TRAM, name: "Fabryczna 01", distance: 809},
        {type: OfferPoiType.TRAM, name: "Fabryczna 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Grzegórzecki", distance: 854},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 930},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Polaków Poszkodowanych przez III Rzeszę", distance: 1271},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1307},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2044},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2335}
    ],
    18958: [
        {type: OfferPoiType.BUS, name: "Zagłębiowska", distance: 150},
        {type: OfferPoiType.BUS, name: "Księże Małe", distance: 287},
        {type: OfferPoiType.BUS, name: "Księska", distance: 327},
        {type: OfferPoiType.TRAM, name: "Księże Małe", distance: 345},
        {type: OfferPoiType.BUS, name: "Blizanowicka", distance: 549},
        {type: OfferPoiType.BUS, name: "Sosnowiecka", distance: 599},
        {type: OfferPoiType.TRAM, name: "Głubczycka", distance: 752},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2075},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2099},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2312},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 2527}
    ],
    18962: [
        {type: OfferPoiType.BUS, name: "Poniatowskiego 01", distance: 420},
        {type: OfferPoiType.BUS, name: "Poniatowskiego 02", distance: 436}
    ],
    18970: [
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 176},
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 419},
        {type: OfferPoiType.BUS, name: "Rędzińska (Cmentarz)", distance: 607},
        {type: OfferPoiType.BUS, name: "Maślicka (Staw)", distance: 645},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 719},
        {type: OfferPoiType.BUS, name: "Maślicka (Osiedle)", distance: 825},
        {type: OfferPoiType.BUS, name: "Północna", distance: 826},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1246}
    ],
    18977: [
        {type: OfferPoiType.BUS, name: "Minakowskiego", distance: 588},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 1228},
        {type: OfferPoiType.PARK, name: "Park Nagórki-Jaroty", distance: 1396},
        {type: OfferPoiType.PARK, name: "Skwer generała Augusta Fieldorfa–Nila", distance: 1796},
        {type: OfferPoiType.PARK, name: "Park podworski Pozorty", distance: 2263},
        {type: OfferPoiType.PARK, name: "Park podworski Nagórki", distance: 2518}
    ],
    18978: [
        {type: OfferPoiType.BUS, name: "Iwiny – pętla", distance: 731},
        {type: OfferPoiType.BUS, name: "Iwiny – Słoneczna", distance: 765},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1534},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1901}
    ],
    18994: [
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 01", distance: 259},
        {type: OfferPoiType.BUS, name: "Technologiczna / Kapitałowa 02", distance: 326},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 02", distance: 829},
        {type: OfferPoiType.BUS, name: "Biznesowa / Kapitałowa 01", distance: 843},
        {type: OfferPoiType.PARK, name: "Park Miłocin", distance: 1666},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 2114}
    ],
    19002: [
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 598},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 653},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 731},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 1569},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1727},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1752},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1755},
        {type: OfferPoiType.PARK, name: "skwer Skaczącej Gwiazdy", distance: 1808}
    ],
    19005: [
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 627},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 635},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 661},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 662},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 727},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 768},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 912},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 955},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1395},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1611},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1909},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 1974},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1977},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1981},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 2043},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2153},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2420}
    ],
    19007: [
        {type: OfferPoiType.BUS, name: "Kudowa Zdrój,Nad Potokiem", distance: 528},
        {type: OfferPoiType.BUS, name: "Kudowa Zdrój, ul.Nad Potokiem 24", distance: 528},
        {type: OfferPoiType.BUS, name: "Kudowa Zdrój 1", distance: 603},
        {type: OfferPoiType.BUS, name: "KUDOWA ZDRÓJ ul.Zdrojowa", distance: 679},
        {type: OfferPoiType.BUS, name: "ul. Norwida (szkoła)", distance: 829},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 989}
    ],
    19009: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 132},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 135},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 150},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 280},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 369},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 373},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 448},
        {type: OfferPoiType.BUS, name: "Kamionek 04", distance: 488},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Kamionek 03", distance: 512},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1008},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1191},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1296},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1556},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1616},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1933},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1981},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1995},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2104}
    ],
    19010: [
        {type: OfferPoiType.TRAM, name: "Mogileńska", distance: 482},
        {type: OfferPoiType.BUS, name: "Mogileńska", distance: 508},
        {type: OfferPoiType.BUS, name: "Pusta n/ż", distance: 626},
        {type: OfferPoiType.BUS, name: "Łomżyńska", distance: 778},
        {type: OfferPoiType.BUS, name: "Miłostowo", distance: 804},
        {type: OfferPoiType.TRAM, name: "Łomżyńska", distance: 809},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2213}
    ],
    19011: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Mały Skręt", distance: 620},
        {type: OfferPoiType.BUS, name: "Łódzka - Mały Skręt", distance: 731},
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 823},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2189},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2456}
    ],
    19015: [
        {type: OfferPoiType.BUS, name: "Podchorążych 2", distance: 208},
        {type: OfferPoiType.BUS, name: "Kopernika Pętla", distance: 220},
        {type: OfferPoiType.BUS, name: "Podchorążych 1", distance: 265},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 2 / Kopernika", distance: 529},
        {type: OfferPoiType.BUS, name: "Wileńska 1", distance: 576},
        {type: OfferPoiType.BUS, name: "Wileńska / Jednostka Wojskowa", distance: 597},
        {type: OfferPoiType.PARK, name: "Skwer Kombatantów", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Nad Stawami", distance: 1192},
        {type: OfferPoiType.PARK, name: "Park Kolejarzy Oleśnickich", distance: 1351},
        {type: OfferPoiType.PARK, name: "Park Henryka Sienkiewicza", distance: 1871},
        {type: OfferPoiType.REZERWAT, name: "Olsy Spalickie", distance: 2126}
    ],
    19020: [
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 01", distance: 193},
        {type: OfferPoiType.BUS, name: "Ciołkowskiego 02", distance: 281},
        {type: OfferPoiType.BUS, name: "Drzewieckiego 02", distance: 366},
        {type: OfferPoiType.BUS, name: "Drzewieckiego 01", distance: 378},
        {type: OfferPoiType.BUS, name: "Kopalniana", distance: 725},
        {type: OfferPoiType.BUS, name: "Grudziądzka 04", distance: 747},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 748},
        {type: OfferPoiType.TRAM, name: "Grudziądzka", distance: 767},
        {type: OfferPoiType.BUS, name: "Grudziądzka 05", distance: 779},
        {type: OfferPoiType.BUS, name: "Korczaka 02", distance: 803},
        {type: OfferPoiType.TRAM, name: "Kolonia Uroda", distance: 805},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 1340}
    ],
    19021: [
        {type: OfferPoiType.BUS, name: "Jasielska II n/ż", distance: 182},
        {type: OfferPoiType.BUS, name: "Jasielska I n/ż", distance: 372},
        {type: OfferPoiType.BUS, name: "Druskienicka", distance: 568},
        {type: OfferPoiType.BUS, name: "Instytut Genetyki n/ż", distance: 574},
        {type: OfferPoiType.BUS, name: "Strzeszyńska II", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 923},
        {type: OfferPoiType.PARK, name: "Park Edukacji Ekologicznej Strzeszyn", distance: 1190},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1293},
        {type: OfferPoiType.PARK, name: "Aleja Demokracji", distance: 1383},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 2462}
    ],
    19022: [
        {type: OfferPoiType.BUS, name: "Żelechów Topolowa", distance: 173},
        {type: OfferPoiType.BUS, name: "Żelechów Jastrzębska", distance: 186},
        {type: OfferPoiType.BUS, name: "Żelechów Krakowiańska", distance: 498},
        {type: OfferPoiType.BUS, name: "Żelechów Jana Matejki", distance: 718},
        {type: OfferPoiType.BUS, name: "Żelechów Kościół", distance: 730},
        {type: OfferPoiType.BUS, name: "Żelechów Polna", distance: 777},
        {type: OfferPoiType.PARK, name: "Zespół pałacowo-parkowy w Ojrzanowie", distance: 1668}
    ],
    19027: [
        {type: OfferPoiType.BUS, name: "Iwiny - Kolejowa", distance: 344},
        {type: OfferPoiType.BUS, name: "Iwiny – Kościuszki", distance: 359},
        {type: OfferPoiType.BUS, name: "Iwiny – Słoneczna", distance: 534},
        {type: OfferPoiType.BUS, name: "Iwiny – pętla", distance: 578},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1850}
    ],
    19029: [
        {type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 440},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 675},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 784}
    ],
    19030: [
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 311},
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 317},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 563},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 681},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 792},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 796},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2318},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2378}
    ],
    19032: [
        {type: OfferPoiType.BUS, name: "Zakładowa", distance: 376},
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 474},
        {type: OfferPoiType.BUS, name: "Trzebnicka", distance: 627},
        {type: OfferPoiType.TRAM, name: "Trzebnicka", distance: 636},
        {type: OfferPoiType.TRAM, name: "Dworzec Nadodrze", distance: 710},
        {type: OfferPoiType.BUS, name: "Dworzec Nadodrze", distance: 719},
        {type: OfferPoiType.BUS, name: "Kręta", distance: 766},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 775},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1034},
        {type: OfferPoiType.PARK, name: "Park Świętego Macieja", distance: 1268}
    ],
    19035: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 493},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 574},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 587},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 790},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 811},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 825},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1079},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1087},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1770},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1889},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1966},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2113},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2223}
    ],
    19036: [
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Służewiec 02", distance: 280},
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Służewiec 01", distance: 339},
        {type: OfferPoiType.BUS, name: "Kłobucka 04", distance: 377},
        {type: OfferPoiType.BUS, name: "Kłobucka 03", distance: 484},
        {type: OfferPoiType.BUS, name: "Kłobucka 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 715},
        {type: OfferPoiType.BUS, name: "Jurajska 01", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 1471},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 2224}
    ],
    19038: [
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 97},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 215},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 223},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 286},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 581},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 604},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 693},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2064}
    ],
    19043: [
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 104},
        {type: OfferPoiType.BUS, name: "Kaloryczna 02", distance: 135},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 360},
        {type: OfferPoiType.BUS, name: "Antoniewska 02", distance: 398},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Antoniewska 01", distance: 451},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Ananasowa 02", distance: 753},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 771},
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 799},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1666},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1689},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2147}
    ],
    19044: [
        {type: OfferPoiType.BUS, name: "Smolecka", distance: 675},
        {type: OfferPoiType.TRAM, name: "Smolecka", distance: 675},
        {type: OfferPoiType.BUS, name: "Śrubowa", distance: 737},
        {type: OfferPoiType.TRAM, name: "Śrubowa", distance: 737},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Jochelsona", distance: 867},
        {type: OfferPoiType.PARK, name: "park Aleksandry Natalli-Świat", distance: 1427},
        {type: OfferPoiType.LAS, name: "Lasek Dolmelowski", distance: 1608},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 2120}
    ],
    19045: [
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 04", distance: 119},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 02", distance: 237},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 03", distance: 279},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 04", distance: 415},
        {type: OfferPoiType.BUS, name: "Jabłonna 01", distance: 477},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 03", distance: 487},
        {type: OfferPoiType.BUS, name: "Jabłonna 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 02", distance: 553},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Wschód 02", distance: 565},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 815},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 867},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 921},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1217},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1316}
    ],
    19047: [
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 04", distance: 74},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 02", distance: 200},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 03", distance: 242},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 01", distance: 336},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 04", distance: 351},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 03", distance: 423},
        {type: OfferPoiType.BUS, name: "Opolska Estakada 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Jabłonna 01", distance: 521},
        {type: OfferPoiType.BUS, name: "Jabłonna 02", distance: 532},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Wschód 02", distance: 609},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 803},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 884},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1180},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1360}
    ],
    19048: [
        {type: OfferPoiType.BUS, name: "Błonie-Rokitno PKP", distance: 349},
        {type: OfferPoiType.KOLEJ, name: "Błonie Rokitno", distance: 386},
        {type: OfferPoiType.BUS, name: "Rokitno I", distance: 596},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 1586},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 2003},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 2149}
    ],
    19055: [{type: OfferPoiType.BUS, name: "BRZEZINA - pętla", distance: 590}],
    19058: [
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 186},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 231},
        {type: OfferPoiType.TRAM, name: "Aleje Marcinkowskiego", distance: 233},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 432},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 445},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 451},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 520},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 554},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 565},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 580},
        {type: OfferPoiType.TRAM, name: "Łąkowa", distance: 580},
        {type: OfferPoiType.TRAM, name: "Pl. Bernardyński", distance: 583},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 615},
        {type: OfferPoiType.BUS, name: "Grobla", distance: 782},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 906},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1003},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1012},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1116},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1117},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1133},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1226},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1270},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1270}
    ],
    19061: [{type: OfferPoiType.PARK, name: "Park Felicjana Sypniewskiego", distance: 2073}],
    19064: [
        {type: OfferPoiType.BUS, name: "Śmigłego Rydza - Grota-Roweckiego", distance: 237},
        {type: OfferPoiType.TRAM, name: "Śmigłego Rydza - Grota-Roweckiego", distance: 250},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Łęczycka", distance: 436},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Łęczycka", distance: 436},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Śmigłego-Rydza", distance: 527},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Śmigłego-Rydza", distance: 530},
        {type: OfferPoiType.TRAM, name: "Śmigłego Rydza - Przybyszewskiego", distance: 560},
        {type: OfferPoiType.BUS, name: "Śmigłego Rydza - Przybyszewskiego", distance: 585},
        {type: OfferPoiType.BUS, name: "Tatrzańska - Grota-Roweckiego", distance: 644},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Poznańska", distance: 713},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 887},
        {type: OfferPoiType.PARK, name: "Skwer im. Świętego Maksymiliana Marii Kolbego", distance: 1519},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1729},
        {type: OfferPoiType.PARK, name: "Park Miejski przy ul. Leczniczej", distance: 1771},
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 1846},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1858},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1985}
    ],
    19066: [
        {type: OfferPoiType.BUS, name: "Zbyszewska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Zbyszewska 02", distance: 381},
        {type: OfferPoiType.BUS, name: "Grójec Piłsudskiego PKP", distance: 485},
        {type: OfferPoiType.BUS, name: "Grójec ul. Piłsudskiego", distance: 724},
        {type: OfferPoiType.BUS, name: 'Jana Pawła II "PSP 1" 02', distance: 760},
        {type: OfferPoiType.BUS, name: 'Jana Pawła II "PSP 1" 01', distance: 811}
    ],
    19069: [
        {type: OfferPoiType.BUS, name: "Grochowa", distance: 205},
        {type: OfferPoiType.BUS, name: "Krucza", distance: 504},
        {type: OfferPoiType.BUS, name: "Stalowa", distance: 526},
        {type: OfferPoiType.BUS, name: "Pereca", distance: 547},
        {type: OfferPoiType.TRAM, name: "Pereca", distance: 557},
        {type: OfferPoiType.TRAM, name: "Stalowa", distance: 622},
        {type: OfferPoiType.BUS, name: "Krucza (Mielecka)", distance: 670}
    ],
    19073: [
        {type: OfferPoiType.PARK, name: "park imienia Sprawiedliwych wśród Narodów Świata", distance: 1212},
        {type: OfferPoiType.REZERWAT, name: "Stawek na Gumieńcach", distance: 1545},
        {type: OfferPoiType.PARK, name: "Cmentarz Centralny", distance: 2462}
    ],
    19079: [
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła Brzozy”", distance: 228},
        {type: OfferPoiType.TRAM, name: "Zgierska - Przedwiośnie", distance: 281},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego", distance: 310},
        {type: OfferPoiType.TRAM, name: "Zgierska - Sikorskiego", distance: 380},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Zgierska", distance: 409},
        {type: OfferPoiType.BUS, name: "Zgierska - Sikorskiego NŻ", distance: 536},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pl. Pamięci Narodowej", distance: 599},
        {type: OfferPoiType.BUS, name: "Sikorskiego - Herlinga-Grudzińskiego", distance: 673},
        {type: OfferPoiType.TRAM, name: "Zgierska - Pasieczna", distance: 780},
        {type: OfferPoiType.BUS, name: "Zgierska - Cm. Radogoszcz", distance: 816},
        {type: OfferPoiType.PARK, name: "Park leśny Włodzimierza Puchalskiego", distance: 1260},
        {type: OfferPoiType.PARK, name: "Park nad Sokołówką", distance: 1277},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 1316},
        {type: OfferPoiType.PARK, name: "Park im. Łódzkich Harcerek", distance: 1448},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1591},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Sokołówki i Brzozy”", distance: 2067},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 2086},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Olsy na Żabieńcu”", distance: 2168},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 2332}
    ],
    19081: [
        {type: OfferPoiType.BUS, name: "Przasnyska 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Przasnyska 04", distance: 260},
        {type: OfferPoiType.BUS, name: "Przasnyska 02", distance: 332},
        {type: OfferPoiType.BUS, name: "Anny German 02", distance: 429},
        {type: OfferPoiType.BUS, name: "Sady Żoliborskie 06", distance: 438},
        {type: OfferPoiType.BUS, name: "Rydygiera 01", distance: 467},
        {type: OfferPoiType.BUS, name: "Anny German 01", distance: 484},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 495},
        {type: OfferPoiType.TRAM, name: "Sady Żoliborskie 03", distance: 514},
        {type: OfferPoiType.TRAM, name: "Sady Żoliborskie 04", distance: 521},
        {type: OfferPoiType.BUS, name: "Rydygiera 04", distance: 554},
        {type: OfferPoiType.BUS, name: "Rydygiera 03", distance: 561},
        {type: OfferPoiType.BUS, name: "Sady Żoliborskie 05", distance: 569},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 719},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 947},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1004},
        {type: OfferPoiType.PARK, name: 'Park Żołnierzy "Żywiciela"', distance: 1273},
        {type: OfferPoiType.PARK, name: "Skwer Barbary i Stanisława Brukalskich", distance: 1602},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 1605},
        {type: OfferPoiType.PARK, name: "Skwer Igora Newerlego", distance: 1614}
    ],
    19083: [
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rewolucji 1905 r.", distance: 179},
        {type: OfferPoiType.BUS, name: "Jaracza - Wierzbowa", distance: 203},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kamińskiego", distance: 384},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Rondo Solidarności", distance: 390},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 410},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 486},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 493},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Rondo Solidarności", distance: 496},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 522},
        {type: OfferPoiType.BUS, name: "Narutowicza - Tramwajowa", distance: 526},
        {type: OfferPoiType.TRAM, name: "Pomorska - Rondo Solidarności", distance: 540},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kamińskiego", distance: 543},
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 579},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Kopcińskiego", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 745},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 872},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 942},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 1231},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1286},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 1290},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1439}
    ],
    19087: [
        {type: OfferPoiType.BUS, name: "Czarnochowice Osiedle", distance: 97},
        {type: OfferPoiType.BUS, name: "Czarnochowice Wygoda", distance: 563},
        {type: OfferPoiType.BUS, name: "Czarnochowice IX", distance: 660},
        {type: OfferPoiType.BUS, name: "Czarnochowice Dom Ludowy", distance: 703},
        {type: OfferPoiType.BUS, name: "Wygoda 1 nż.", distance: 807},
        {type: OfferPoiType.PARK, name: "Park osiedlowy", distance: 2322}
    ],
    19089: [
        {type: OfferPoiType.BUS, name: "Gliwice Puszkina", distance: 249},
        {type: OfferPoiType.BUS, name: "Gliwice Sowińskiego", distance: 437},
        {type: OfferPoiType.BUS, name: "Gliwice Styczyńskiego", distance: 543},
        {type: OfferPoiType.PARK, name: "Skwer Kežmarok", distance: 582},
        {type: OfferPoiType.BUS, name: "Gliwice Kościuszki", distance: 658},
        {type: OfferPoiType.BUS, name: "Gliwice Aleja Majowa", distance: 714},
        {type: OfferPoiType.PARK, name: "Park Starokozielski", distance: 1061}
    ],
    19090: [
        {type: OfferPoiType.BUS, name: "Wioślarska", distance: 156},
        {type: OfferPoiType.BUS, name: "Likusy", distance: 261},
        {type: OfferPoiType.BUS, name: "Żbicza", distance: 613},
        {type: OfferPoiType.KOLEJ, name: "Olsztyn Redykajny", distance: 614},
        {type: OfferPoiType.BUS, name: "Letniskowa", distance: 652}
    ],
    19093: [
        {type: OfferPoiType.BUS, name: "Niemcz / Kasprowicza", distance: 226},
        {type: OfferPoiType.BUS, name: "Niemcz / Mickiewicza", distance: 299},
        {type: OfferPoiType.BUS, name: "Niemcz / Słowackiego", distance: 393},
        {type: OfferPoiType.BUS, name: "Niemcz / Urocza", distance: 689},
        {type: OfferPoiType.BUS, name: "Niemcz / Pod Wierzbami", distance: 712},
        {type: OfferPoiType.BUS, name: "Jeździecka / Ogród Botaniczny", distance: 780},
        {type: OfferPoiType.BUS, name: "Jeździecka / Hipiczna", distance: 820}
    ],
    19095: [
        {type: OfferPoiType.BUS, name: "Maczka 03", distance: 267},
        {type: OfferPoiType.BUS, name: "Maczka 04", distance: 310},
        {type: OfferPoiType.BUS, name: "Maczka 01", distance: 331},
        {type: OfferPoiType.BUS, name: "Maczka 02", distance: 393},
        {type: OfferPoiType.BUS, name: "Kosynierów 04", distance: 400},
        {type: OfferPoiType.BUS, name: "Kosynierów 03", distance: 411},
        {type: OfferPoiType.BUS, name: "Kosynierów 01", distance: 511},
        {type: OfferPoiType.BUS, name: "Zieleniecka 02", distance: 546},
        {type: OfferPoiType.BUS, name: "Pułaskiego 02", distance: 586},
        {type: OfferPoiType.BUS, name: "Pułaskiego 01", distance: 644},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 2237}
    ],
    19099: [
        {type: OfferPoiType.BUS, name: "Bytom Kruszcowa", distance: 705},
        {type: OfferPoiType.PARK, name: "Plac Akademicki", distance: 1516}
    ],
    19101: [
        {type: OfferPoiType.BUS, name: "Korczaka 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Korczaka 02", distance: 779},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski w Radzyminie", distance: 1243},
        {type: OfferPoiType.PARK, name: "Park Pułkownika Mieczysława Chojnackiego „Młodzika”", distance: 1300},
        {type: OfferPoiType.PARK, name: "Park Księżnej Eleonory Czartoryskiej", distance: 1445},
        {type: OfferPoiType.PARK, name: "Park na dawnym cmentarzu ewangelickim", distance: 2514}
    ],
    19105: [
        {type: OfferPoiType.BUS, name: "Lechowskiego nż", distance: 74},
        {type: OfferPoiType.BUS, name: "Szajnowicza nż", distance: 299},
        {type: OfferPoiType.BUS, name: "Golęcińska nż", distance: 443},
        {type: OfferPoiType.BUS, name: "Kolonistów", distance: 790},
        {type: OfferPoiType.BUS, name: "Stołczyn Kościół", distance: 842},
        {type: OfferPoiType.PARK, name: "Park ks. Dąbrówki", distance: 1740}
    ],
    19106: [
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 386},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 427},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 441},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 451},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 457},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 519},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 546},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 571},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 572},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 573},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 831},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1327},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1347},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1636},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 1702},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1855},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1927},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2079},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2241},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2420},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2440}
    ],
    19107: [
        {type: OfferPoiType.BUS, name: "Biegasa", distance: 257},
        {type: OfferPoiType.BUS, name: "Chełmońskiego", distance: 521},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 594},
        {type: OfferPoiType.BUS, name: "Tramwajowa", distance: 698},
        {type: OfferPoiType.TRAM, name: "Chełmońskiego", distance: 723},
        {type: OfferPoiType.TRAM, name: "Tramwajowa", distance: 735},
        {type: OfferPoiType.BUS, name: "Dembowskiego (Kosiby)", distance: 830},
        {type: OfferPoiType.LAS, name: "Park Dąbski", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park Dąbski", distance: 1057},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1610},
        {type: OfferPoiType.PARK, name: "skwer Zbyszka Cybulskiego", distance: 1618},
        {type: OfferPoiType.PARK, name: "skwer Hanny Hirszfeldowej", distance: 1795},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1992}
    ],
    19110: [
        {type: OfferPoiType.BUS, name: "Gniewskie Młyny", distance: 226},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1360},
        {type: OfferPoiType.REZERWAT, name: "Strzelnica w Gniewie", distance: 2060}
    ],
    19111: [
        {type: OfferPoiType.BUS, name: "Katowice Mickiewicza Biurowce", distance: 178},
        {type: OfferPoiType.BUS, name: "Katowice Plac Wolności", distance: 386},
        {type: OfferPoiType.BUS, name: "Katowice Dąbrówki", distance: 395},
        {type: OfferPoiType.BUS, name: "Katowice Sobieskiego", distance: 415},
        {type: OfferPoiType.TRAM, name: "Katowice Sobieskiego", distance: 415},
        {type: OfferPoiType.TRAM, name: "Katowice Dąbrówki", distance: 436},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna", distance: 506},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 562},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 582},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 628},
        {type: OfferPoiType.TRAM, name: "Katowice Dworzec PKP", distance: 688},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 708},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1025},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 1138},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1192},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 1218},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1235}
    ],
    19117: [{type: OfferPoiType.BUS, name: "Lutynia Osiedle", distance: 663}],
    19118: [
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 779},
        {type: OfferPoiType.TRAM, name: "Głęboka 02", distance: 799},
        {type: OfferPoiType.BUS, name: "Głęboka 01", distance: 816},
        {type: OfferPoiType.TRAM, name: "Głęboka 01", distance: 831},
        {type: OfferPoiType.BUS, name: "Głęboka 91", distance: 839},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 929},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1063},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1108},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1445}
    ],
    19128: [
        {type: OfferPoiType.BUS, name: "Siemianice 02", distance: 204},
        {type: OfferPoiType.BUS, name: "Siemianice 01", distance: 210},
        {type: OfferPoiType.BUS, name: "Siemianice - Słupska N/Ż 01", distance: 304},
        {type: OfferPoiType.BUS, name: "Siemianice - Słupska N/Ż 02", distance: 353},
        {type: OfferPoiType.BUS, name: "Siemianice - Miejska 02", distance: 396},
        {type: OfferPoiType.BUS, name: "Siemianice - Miejska 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Siemianice - Spacerowa 02", distance: 602},
        {type: OfferPoiType.KOLEJ, name: "Siemianice", distance: 650},
        {type: OfferPoiType.BUS, name: "Siemianice - Agrestowa 01", distance: 799},
        {type: OfferPoiType.BUS, name: "Siemianice - Agrestowa 02", distance: 805},
        {type: OfferPoiType.PARK, name: "Park pod brzozami", distance: 1123}
    ],
    19133: [
        {type: OfferPoiType.BUS, name: "Bursztynowa-Szpital 02", distance: 489},
        {type: OfferPoiType.BUS, name: "Bursztynowa-Szpital 01", distance: 515},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 02", distance: 649},
        {type: OfferPoiType.BUS, name: "Bielszowicka 02", distance: 681},
        {type: OfferPoiType.BUS, name: "Bielszowicka 01", distance: 706},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 01", distance: 720},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 04", distance: 751},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 03", distance: 782},
        {type: OfferPoiType.BUS, name: "Wawer-Ratusz 02", distance: 825}
    ],
    19136: [
        {type: OfferPoiType.BUS, name: "Załęże Pośpiecha", distance: 369},
        {type: OfferPoiType.TRAM, name: "Załęże Pośpiecha", distance: 370},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Barei", distance: 417},
        {type: OfferPoiType.BUS, name: "Dąb Huta Baildon", distance: 463},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna Office Park", distance: 582},
        {type: OfferPoiType.TRAM, name: "Katowice Grundmanna", distance: 583},
        {type: OfferPoiType.TRAM, name: "Załęże Kościół", distance: 602},
        {type: OfferPoiType.BUS, name: "Załęże Kościół", distance: 604},
        {type: OfferPoiType.TRAM, name: "Dąb Huta Baildon", distance: 672},
        {type: OfferPoiType.BUS, name: "Katowice Dąbrówki", distance: 694},
        {type: OfferPoiType.BUS, name: "Katowice Stęślickiego", distance: 801},
        {type: OfferPoiType.PARK, name: "Park Alojzego Budnioka", distance: 1032},
        {type: OfferPoiType.PARK, name: "Plac Józefa Londzina", distance: 1419},
        {type: OfferPoiType.PARK, name: "Skwer Gustawa Holoubka", distance: 1420},
        {type: OfferPoiType.PARK, name: "Plac Przyjaciół z Miszkolca", distance: 1467},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1619}
    ],
    19139: [
        {type: OfferPoiType.BUS, name: "Gęsia 02", distance: 772},
        {type: OfferPoiType.BUS, name: "Gęsia 01", distance: 791},
        {type: OfferPoiType.LAS, name: "Jarugi", distance: 1205},
        {type: OfferPoiType.PARK, name: "Park Weglin", distance: 1762}
    ],
    19143: [
        {type: OfferPoiType.BUS, name: "Piecewska", distance: 120},
        {type: OfferPoiType.TRAM, name: "Warneńska 01", distance: 162},
        {type: OfferPoiType.BUS, name: "Warneńska 04", distance: 173},
        {type: OfferPoiType.BUS, name: "Warneńska 02", distance: 191},
        {type: OfferPoiType.BUS, name: "Warneńska 01", distance: 191},
        {type: OfferPoiType.TRAM, name: "Warneńska 02", distance: 209},
        {type: OfferPoiType.BUS, name: "Belgradzka 03", distance: 237},
        {type: OfferPoiType.TRAM, name: "Belgradzka 02", distance: 347},
        {type: OfferPoiType.LAS, name: 'Lasek "Belgradzka"', distance: 361},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 361},
        {type: OfferPoiType.TRAM, name: "Belgradzka 01", distance: 366},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 368},
        {type: OfferPoiType.BUS, name: "Belgradzka 04", distance: 368},
        {type: OfferPoiType.BUS, name: "Dobrowolskiego 02", distance: 431},
        {type: OfferPoiType.BUS, name: "Dobrowolskiego 01", distance: 464},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 528},
        {type: OfferPoiType.TRAM, name: "Budapesztańska", distance: 562},
        {type: OfferPoiType.BUS, name: "Budapesztańska", distance: 576},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 707},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 740},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 1706},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1708},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1846},
        {type: OfferPoiType.REZERWAT, name: "Migowska Bielawa", distance: 2479}
    ],
    19145: [
        {type: OfferPoiType.BUS, name: "Gniewkowska 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Sympatyczna 03", distance: 346},
        {type: OfferPoiType.BUS, name: "Sympatyczna 02", distance: 430},
        {type: OfferPoiType.BUS, name: "Gniewkowska 52", distance: 449},
        {type: OfferPoiType.BUS, name: "Sympatyczna 01", distance: 462},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 705},
        {type: OfferPoiType.BUS, name: "Sympatyczna 04", distance: 711},
        {type: OfferPoiType.BUS, name: "Wałowicka 03", distance: 767},
        {type: OfferPoiType.BUS, name: "Płużańska 02", distance: 826},
        {type: OfferPoiType.BUS, name: "PKP Włochy 03", distance: 833},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 1026},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 1101},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 1530},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1808},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 2368}
    ],
    19156: [
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 707},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 729},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 990},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1126},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1214},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 1407},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1490},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2219},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2331}
    ],
    19157: [
        {type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 472},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 643},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 752}
    ],
    19161: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 302},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 343},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 746},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 757},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 773},
        {type: OfferPoiType.PARK, name: "park Kolumba", distance: 1775}
    ],
    19172: [
        {type: OfferPoiType.BUS, name: "Chłodnia 01", distance: 279},
        {type: OfferPoiType.BUS, name: "Chłodnia 02", distance: 446},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Toruńska", distance: 584},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 03", distance: 650},
        {type: OfferPoiType.BUS, name: "Pelcowizna 01", distance: 666},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 04", distance: 682},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 02", distance: 719},
        {type: OfferPoiType.BUS, name: "Pelcowizna 02", distance: 737},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 01", distance: 740},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 04", distance: 779},
        {type: OfferPoiType.BUS, name: "Fabryka Pomp 02", distance: 788},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 1217},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1774},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1802},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2089}
    ],
    19173: [
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 311},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 481},
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Dębogórze-Wybudowanie - Długa 01", distance: 753},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 788},
        {type: OfferPoiType.BUS, name: "Dębogórze - Wybudowanie - Długa 04", distance: 824},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 1290},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1337},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2186}
    ],
    19175: [
        {type: OfferPoiType.BUS, name: "Drwęcka 01", distance: 341},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 582},
        {type: OfferPoiType.BUS, name: "Świtezianki 02", distance: 591},
        {type: OfferPoiType.BUS, name: "Odrzańska 04", distance: 675},
        {type: OfferPoiType.BUS, name: "Chałubińskiego", distance: 676},
        {type: OfferPoiType.TRAM, name: "Odrzańska", distance: 704},
        {type: OfferPoiType.TRAM, name: "Ciasna", distance: 737},
        {type: OfferPoiType.BUS, name: "Odrzańska", distance: 740},
        {type: OfferPoiType.TRAM, name: "Zakopiańska", distance: 759},
        {type: OfferPoiType.BUS, name: "Zakopiańska", distance: 764},
        {type: OfferPoiType.BUS, name: "Domeyki 01", distance: 776},
        {type: OfferPoiType.TRAM, name: "Chałubińskiego", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1204},
        {type: OfferPoiType.PARK, name: "Skwer im. Ignacego Wilczewskiego", distance: 1242},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Bema", distance: 1468},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1847},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1963},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2415}
    ],
    19179: [
        {type: OfferPoiType.BUS, name: "Kopernika/Bema", distance: 286},
        {type: OfferPoiType.BUS, name: "Kopernika/Osiedle Bema", distance: 303},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Bema NŻ", distance: 360},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Kaczorowskiego", distance: 381},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego/Młynowa", distance: 421},
        {type: OfferPoiType.BUS, name: "Kopernika/Kaczorowskiego", distance: 426},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Wyszyńskiego", distance: 465},
        {type: OfferPoiType.BUS, name: "Kaczorowskiego/Waszyngtona", distance: 520},
        {type: OfferPoiType.BUS, name: "Wiejska/Kopernika", distance: 569},
        {type: OfferPoiType.BUS, name: "Kopernika/Depowa NŻ", distance: 574},
        {type: OfferPoiType.PARK, name: "Skwer Zenona Andrzeja Młyńczyka", distance: 1134},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1236},
        {type: OfferPoiType.PARK, name: "Park im. Jadwigi Dziekońskiej", distance: 1755},
        {type: OfferPoiType.PARK, name: "Skwer Lecha i Marii Kaczyńskich - Prezydenta Rzeczypospolitej Polskiej z Małżonką", distance: 1793},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1811},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Las Zwierzyniecki", distance: 2200}
    ],
    19180: [
        {type: OfferPoiType.BUS, name: "Suszki", distance: 211},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 553},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 583},
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 724},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 758},
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1292},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1404},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1601},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 1893},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2082},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2370},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2417},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2481}
    ],
    19182: [
        {type: OfferPoiType.BUS, name: "Osiedle Kopernika", distance: 306},
        {type: OfferPoiType.BUS, name: "Cieszyńska Hulanka", distance: 592},
        {type: OfferPoiType.BUS, name: "Stawowa", distance: 761},
        {type: OfferPoiType.PARK, name: "Skwer Marzeń", distance: 963}
    ],
    19183: [
        {type: OfferPoiType.BUS, name: "Błonie Nowakowskiego", distance: 300},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 418},
        {type: OfferPoiType.BUS, name: "Błonie Narutowicza", distance: 482},
        {type: OfferPoiType.BUS, name: "Błonie Piłsudskiego Przedszkole", distance: 526},
        {type: OfferPoiType.BUS, name: "Błonie Okrzei", distance: 551},
        {type: OfferPoiType.BUS, name: "Błonie Polna", distance: 625},
        {type: OfferPoiType.BUS, name: "Błonie Sochaczewska", distance: 679},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 867},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 991}
    ],
    19184: [
        {type: OfferPoiType.BUS, name: "Wiatraczna 16", distance: 290},
        {type: OfferPoiType.BUS, name: "Wiatraczna 14", distance: 292},
        {type: OfferPoiType.BUS, name: "Wiatraczna 02", distance: 351},
        {type: OfferPoiType.BUS, name: "Wiatraczna 17", distance: 360},
        {type: OfferPoiType.BUS, name: "Wiatraczna 15", distance: 363},
        {type: OfferPoiType.BUS, name: "Wiatraczna 23", distance: 367},
        {type: OfferPoiType.BUS, name: "Wiatraczna 22", distance: 395},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 13", distance: 427},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 12", distance: 434},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 06", distance: 435},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 11", distance: 435},
        {type: OfferPoiType.BUS, name: "Wiatraczna 10", distance: 436},
        {type: OfferPoiType.TRAM, name: "Czapelska 01", distance: 447},
        {type: OfferPoiType.TRAM, name: "Czapelska 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Wiatraczna 09", distance: 509},
        {type: OfferPoiType.BUS, name: "Wiatraczna 03", distance: 527},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 07", distance: 537},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 04", distance: 559},
        {type: OfferPoiType.TRAM, name: "Wiatraczna 05", distance: 608},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 04", distance: 609},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 870},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 908},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1171},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1366}
    ],
    19186: [
        {type: OfferPoiType.BUS, name: "Kiełpino, Cyprysowa", distance: 280},
        {type: OfferPoiType.BUS, name: "Kiełpino, Podlaska", distance: 453},
        {type: OfferPoiType.BUS, name: "Kiełpino, Piaskowa", distance: 750}
    ],
    19187: [
        {type: OfferPoiType.BUS, name: "Orlinki 02", distance: 429},
        {type: OfferPoiType.BUS, name: "Kwiatowa 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Kwiatowa 02", distance: 459},
        {type: OfferPoiType.BUS, name: "Orlinki 01", distance: 464},
        {type: OfferPoiType.LAS, name: "Las Mierzei", distance: 1053}
    ],
    19189: [
        {type: OfferPoiType.KOLEJ, name: "Iwiny", distance: 566},
        {type: OfferPoiType.BUS, name: "Jagodno (P+R)", distance: 616},
        {type: OfferPoiType.BUS, name: "Kopycińskiego", distance: 727},
        {type: OfferPoiType.BUS, name: "Jagodzińska", distance: 808},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 1791},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2138},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 2256}
    ],
    19190: [{type: OfferPoiType.BUS, name: "Siechnice – Kalinowa", distance: 344}],
    19191: [
        {type: OfferPoiType.BUS, name: "Iwiny – pętla", distance: 735},
        {type: OfferPoiType.BUS, name: "Iwiny – Słoneczna", distance: 769},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1538},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1905}
    ],
    19201: [
        {type: OfferPoiType.BUS, name: "Słonimska/Urząd Miejski", distance: 370},
        {type: OfferPoiType.BUS, name: "Piasta/Skorupska", distance: 484},
        {type: OfferPoiType.BUS, name: "Piasta", distance: 494},
        {type: OfferPoiType.BUS, name: "Towarowa/Pętla", distance: 679},
        {type: OfferPoiType.BUS, name: "Towarowa/Dworzec Fabryczny", distance: 717},
        {type: OfferPoiType.BUS, name: "Pałacowa/Hotel", distance: 745},
        {type: OfferPoiType.BUS, name: "Towarowa/Daleka", distance: 748},
        {type: OfferPoiType.BUS, name: "Mieszka I/Szkoła", distance: 774},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Aleksandra Chodyki", distance: 957},
        {type: OfferPoiType.PARK, name: "Skwer Armii Krajowej", distance: 980},
        {type: OfferPoiType.PARK, name: "Park Stary im. Księcia Józefa Poniatowskiego", distance: 1051},
        {type: OfferPoiType.PARK, name: "Bulwary Ireny Sendlerowej", distance: 1084},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Stanisława Hałko", distance: 1141},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1202},
        {type: OfferPoiType.PARK, name: "Skwer im. doc. Włodzimierza Zankiewicza", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Branickich", distance: 1377},
        {type: OfferPoiType.PARK, name: "Park Planty", distance: 1540},
        {type: OfferPoiType.PARK, name: "Skwer Wygoda", distance: 1543}
    ],
    19212: [
        {type: OfferPoiType.BUS, name: "Osiedle Limba 01", distance: 749},
        {type: OfferPoiType.BUS, name: "Osiedle Limba 02", distance: 813},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Stawy Raszyńskie", distance: 2313}
    ],
    19213: [
        {type: OfferPoiType.BUS, name: "Rząska Autostrada", distance: 703},
        {type: OfferPoiType.BUS, name: "Rząska Szkoła", distance: 746},
        {type: OfferPoiType.PARK, name: "Park Topólki", distance: 2507},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko w Rząsce", distance: 2515}
    ],
    19219: [
        {type: OfferPoiType.BUS, name: "Gliwice Komag", distance: 236},
        {type: OfferPoiType.BUS, name: "Gliwice Kujawska", distance: 486},
        {type: OfferPoiType.BUS, name: "Trynek Lotników", distance: 715},
        {type: OfferPoiType.BUS, name: "Gliwice Łużycka", distance: 736},
        {type: OfferPoiType.BUS, name: "Gliwice Nowy Świat", distance: 750},
        {type: OfferPoiType.PARK, name: "Skwer Zofii Rydet", distance: 758},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Lewczyńskiego", distance: 840},
        {type: OfferPoiType.PARK, name: "Skwer Dessau", distance: 911},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny", distance: 1056}
    ],
    19221: [
        {type: OfferPoiType.BUS, name: "Augustówek 01", distance: 734},
        {type: OfferPoiType.BUS, name: "Augustówek 02", distance: 735},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 1744}
    ],
    19223: [
        {type: OfferPoiType.BUS, name: "Potockiego / Grafitowa 05", distance: 189},
        {type: OfferPoiType.BUS, name: "Potockiego / Grafitowa 08", distance: 239},
        {type: OfferPoiType.BUS, name: "Potockiego / Ametystowa 06", distance: 346},
        {type: OfferPoiType.BUS, name: "Potockiego / Ametystowa 03", distance: 385},
        {type: OfferPoiType.LAS, name: "Las Dębina", distance: 513},
        {type: OfferPoiType.BUS, name: "Potockiego pętla 10", distance: 778},
        {type: OfferPoiType.BUS, name: "Potockiego / Nefrytowa 01", distance: 835}
    ],
    19226: [{type: OfferPoiType.PARK, name: "Active Park w Zalasewie", distance: 1944}],
    19227: [
        {type: OfferPoiType.BUS, name: "Gen. Maczka 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 04", distance: 573},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 03", distance: 606},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 04", distance: 610},
        {type: OfferPoiType.BUS, name: "Park Olszyna 06", distance: 613},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 01", distance: 629},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 01", distance: 648},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 03", distance: 701},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 02", distance: 735},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 04", distance: 757},
        {type: OfferPoiType.BUS, name: "Park Olszyna 02", distance: 760},
        {type: OfferPoiType.BUS, name: "Włościańska 01", distance: 802},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 970},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1360},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1455},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1456},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 1803},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1840},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1896},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 1941}
    ],
    19233: [
        {type: OfferPoiType.BUS, name: "Dobra 02", distance: 7},
        {type: OfferPoiType.BUS, name: "Dobra 01", distance: 65},
        {type: OfferPoiType.BUS, name: "Wróbla 02", distance: 217},
        {type: OfferPoiType.BUS, name: "Wróbla 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 620},
        {type: OfferPoiType.BUS, name: "Zagony", distance: 628},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 628},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 01", distance: 647},
        {type: OfferPoiType.TRAM, name: "Chmielna 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Brama Nizinna", distance: 729},
        {type: OfferPoiType.TRAM, name: "Chmielna 02", distance: 736},
        {type: OfferPoiType.TRAM, name: "Akademia Muzyczna", distance: 812},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 837},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 980},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1267},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1367},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2457}
    ],
    19234: [
        {type: OfferPoiType.BUS, name: "Maratońska - Dw. Łódź Retkinia", distance: 161},
        {type: OfferPoiType.BUS, name: "Retkińska - Dw. Łódź Retkinia", distance: 200},
        {type: OfferPoiType.BUS, name: "Armii Krajowej - Batalionów Chłopskich", distance: 259},
        {type: OfferPoiType.KOLEJ, name: "Łódź Retkinia", distance: 368},
        {type: OfferPoiType.BUS, name: "Retkińska - Zagrodniki", distance: 477},
        {type: OfferPoiType.BUS, name: "Maratońska (wew.) - Plocka", distance: 563},
        {type: OfferPoiType.BUS, name: "Maratońska - Obywatelska", distance: 588},
        {type: OfferPoiType.BUS, name: "Maratońska - Plocka", distance: 591},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego - Armii Krajowej", distance: 780},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 1713},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 1844},
        {type: OfferPoiType.PARK, name: "Łódzkie Błonia", distance: 2063},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2332}
    ],
    19238: [
        {type: OfferPoiType.BUS, name: "Cukrowa", distance: 87},
        {type: OfferPoiType.BUS, name: "Radomska", distance: 406},
        {type: OfferPoiType.BUS, name: "Kwiatkowskiego", distance: 524},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Gumieńce", distance: 603},
        {type: OfferPoiType.BUS, name: "Południowa", distance: 682},
        {type: OfferPoiType.BUS, name: "Cukrowa Uniwersytet", distance: 720},
        {type: OfferPoiType.PARK, name: "park imienia Sprawiedliwych wśród Narodów Świata", distance: 2080}
    ],
    19239: [
        {type: OfferPoiType.BUS, name: "Mulicka", distance: 366},
        {type: OfferPoiType.BUS, name: "Gorlicka", distance: 427},
        {type: OfferPoiType.BUS, name: "Psie Pole (Rondo Lotników Polskich)", distance: 520},
        {type: OfferPoiType.BUS, name: "Psie Pole (Gorlicka)", distance: 572},
        {type: OfferPoiType.BUS, name: "Psie Pole", distance: 611},
        {type: OfferPoiType.BUS, name: "Zielna", distance: 624},
        {type: OfferPoiType.PARK, name: "Park Jedności", distance: 2494}
    ],
    19240: [
        {type: OfferPoiType.BUS, name: "Szatonia #", distance: 343},
        {type: OfferPoiType.PARK, name: "korty tenisowe bratoszewskiego", distance: 1323},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2327}
    ],
    19247: [
        {type: OfferPoiType.BUS, name: "Złocień 03", distance: 372},
        {type: OfferPoiType.BUS, name: "Złocień 01", distance: 449},
        {type: OfferPoiType.BUS, name: "Agatowa 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Złocień 02", distance: 481},
        {type: OfferPoiType.BUS, name: "Agatowa 01", distance: 485},
        {type: OfferPoiType.KOLEJ, name: "Kraków Złocień", distance: 744},
        {type: OfferPoiType.PARK, name: "Park Złocień", distance: 806}
    ],
    19249: [
        {type: OfferPoiType.BUS, name: "Kwidzyn Łużycka", distance: 155},
        {type: OfferPoiType.BUS, name: "Kwidzyn Łużycka Połomskiego", distance: 363},
        {type: OfferPoiType.BUS, name: "Kwidzyn Południowa", distance: 364},
        {type: OfferPoiType.BUS, name: "Kwidzyn Toruńska", distance: 498},
        {type: OfferPoiType.BUS, name: "Kwidzyn Hallera Szpital", distance: 584},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Kosacza", distance: 821},
        {type: OfferPoiType.PARK, name: "Plac Plebiscytowy", distance: 1510},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Płażyńskiego", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer Kombatantów", distance: 2076}
    ],
    19253: [
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 257},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 288},
        {type: OfferPoiType.BUS, name: "Kierbedzia 01", distance: 381},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 04", distance: 397},
        {type: OfferPoiType.BUS, name: "Hańczy 01", distance: 397},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 433},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 481},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 03", distance: 516},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 01", distance: 517},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 05", distance: 528},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 02", distance: 541},
        {type: OfferPoiType.BUS, name: "Tor Stegny 02", distance: 554},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 01", distance: 658},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 02", distance: 700},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 863},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1385},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1499},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1546},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1550},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1737},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1794},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1977},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 2007},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 2061},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2094},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2308}
    ],
    19254: [
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 18", distance: 202},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 17", distance: 227},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 16", distance: 231},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 12", distance: 240},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 02", distance: 255},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 15", distance: 257},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 14", distance: 272},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 13", distance: 281},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 11", distance: 284},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 10", distance: 289},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 05", distance: 295},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 307},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 06", distance: 315},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 72", distance: 372},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 71", distance: 373},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 04", distance: 712},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 712},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 03", distance: 758},
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 920},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1160},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1304},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1455},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1856},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2198}
    ],
    19256: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 201},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 768}
    ],
    19257: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 222},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 569},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 591},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 669}
    ],
    19258: [
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 202},
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 649}
    ],
    19262: [
        {type: OfferPoiType.BUS, name: "Bora Komorowskiego 01", distance: 139},
        {type: OfferPoiType.BUS, name: "Konieczki-pętla 02", distance: 294},
        {type: OfferPoiType.PARK, name: "Park Ireny Tamary Misztal", distance: 342},
        {type: OfferPoiType.BUS, name: "Piwnika Ponurego 02", distance: 343},
        {type: OfferPoiType.BUS, name: "Kolonia - Nowe Miasto 02", distance: 461},
        {type: OfferPoiType.BUS, name: "Kolonia - Park 03", distance: 471},
        {type: OfferPoiType.BUS, name: "Piwnika Ponurego 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Kolonia - szkoła 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Kolonia - szkoła 01", distance: 596},
        {type: OfferPoiType.BUS, name: "Dobrzańskiego 02", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Odkrywców Kolei", distance: 2061},
        {type: OfferPoiType.REZERWAT, name: "Wyspa lęgowa", distance: 2212},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 2452}
    ],
    19263: [
        {type: OfferPoiType.BUS, name: "Litworowy Staw ul. Środkowa 63", distance: 251},
        {type: OfferPoiType.BUS, name: 'Sklep "Gama"', distance: 369},
        {type: OfferPoiType.BUS, name: "Białka Tatrzańska Korkoszówka", distance: 459},
        {type: OfferPoiType.BUS, name: "u Rafała i Joanny", distance: 495},
        {type: OfferPoiType.BUS, name: "Białka Tatrzańska Środkowa", distance: 572},
        {type: OfferPoiType.BUS, name: "u Chramca", distance: 821}
    ],
    19269: [
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 291},
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 407},
        {type: OfferPoiType.BUS, name: "Czermińskiego 01", distance: 433},
        {type: OfferPoiType.BUS, name: "Przywidzka 03", distance: 795},
        {type: OfferPoiType.BUS, name: "Przywidzka 01", distance: 834},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1447}
    ],
    19271: [
        {type: OfferPoiType.BUS, name: "Chorzów Wodociągi", distance: 7},
        {type: OfferPoiType.TRAM, name: "Chorzów Wodociągi", distance: 69},
        {type: OfferPoiType.BUS, name: "Chorzów Styczyńskiego", distance: 273},
        {type: OfferPoiType.PARK, name: "Park Amelung", distance: 304},
        {type: OfferPoiType.TRAM, name: "Chorzów Styczyńskiego", distance: 381},
        {type: OfferPoiType.TRAM, name: "Chorzów Szarlociniec", distance: 397},
        {type: OfferPoiType.BUS, name: "Chorzów Składowa", distance: 478},
        {type: OfferPoiType.BUS, name: "Chorzów Amelung", distance: 586},
        {type: OfferPoiType.BUS, name: "Chorzów Miarki", distance: 677},
        {type: OfferPoiType.TRAM, name: "Chorzów Pokoju", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Heiloo", distance: 1368},
        {type: OfferPoiType.PARK, name: "Park Skałka", distance: 1713},
        {type: OfferPoiType.REZERWAT, name: "Staw Foryśka", distance: 1971},
        {type: OfferPoiType.PARK, name: "Park Chropaczowski imieniem Kopalni Śląsk", distance: 2062}
    ],
    19277: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1671},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Rawąskiego", distance: 2348}
    ],
    19280: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 151},
        {type: OfferPoiType.BUS, name: "Żeligowskiego - Pl. Hallera", distance: 195},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 241},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Hallera", distance: 338},
        {type: OfferPoiType.BUS, name: "Żeligowskiego - Struga", distance: 379},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Żeligowskiego", distance: 471},
        {type: OfferPoiType.BUS, name: "Struga - Żeligowskiego", distance: 480},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 503},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 565},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 565},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 756},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 824},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 892},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 1030}
    ],
    19284: [
        {type: OfferPoiType.BUS, name: "Wilkasy ul. Olsztyńska Niegocin", distance: 519},
        {type: OfferPoiType.KOLEJ, name: "Wilkasy Niegocin", distance: 637},
        {type: OfferPoiType.BUS, name: "Łuczanka", distance: 716},
        {type: OfferPoiType.REZERWAT, name: "Wilkasy", distance: 1531}
    ],
    19288: [
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 182},
        {type: OfferPoiType.BUS, name: "Bolesława Śmiałego 02", distance: 376},
        {type: OfferPoiType.BUS, name: "Bolesława Krzywoustego 02", distance: 423},
        {type: OfferPoiType.BUS, name: "Przemysława II 02", distance: 510},
        {type: OfferPoiType.BUS, name: "Królowej Bony 01", distance: 544},
        {type: OfferPoiType.BUS, name: "Królowej Bony 02", distance: 560},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 567},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 592},
        {type: OfferPoiType.BUS, name: "Czerwona Droga 01", distance: 668},
        {type: OfferPoiType.BUS, name: "Henryka Probusa 01", distance: 706},
        {type: OfferPoiType.BUS, name: "Śmigielska 02", distance: 722},
        {type: OfferPoiType.BUS, name: "Czerwona Droga 02", distance: 801},
        {type: OfferPoiType.BUS, name: "Władysława Hermana 02", distance: 819},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1086},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1113},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 1208}
    ],
    19300: [
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 383},
        {type: OfferPoiType.BUS, name: "Mazowiecka 02", distance: 388},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 503},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 02", distance: 524},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 534},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Dokerów", distance: 565},
        {type: OfferPoiType.BUS, name: "25-lecia Solidarności 03", distance: 573},
        {type: OfferPoiType.BUS, name: "Ormińskiego 02", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2378}
    ],
    19304: [
        {type: OfferPoiType.BUS, name: "Jastrzębia Góra", distance: 409},
        {type: OfferPoiType.BUS, name: "Jastrzębia Góra, centrum", distance: 472},
        {type: OfferPoiType.BUS, name: "Tupadły, Wiejska", distance: 751}
    ],
    19305: [
        {type: OfferPoiType.BUS, name: "Dolnobrzeska", distance: 289},
        {type: OfferPoiType.BUS, name: "Owczarska", distance: 589},
        {type: OfferPoiType.BUS, name: "Grzybowa", distance: 696},
        {type: OfferPoiType.BUS, name: "Krępicka – szkoła", distance: 837},
        {type: OfferPoiType.PARK, name: "Park Leśnicki", distance: 1669},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Kobla", distance: 1674}
    ],
    19308: [
        {type: OfferPoiType.BUS, name: "Solidarności / Tysiąclecia PP", distance: 274},
        {type: OfferPoiType.BUS, name: "Tysiąclecia PP / Wiejska", distance: 463},
        {type: OfferPoiType.BUS, name: "Galeria Echo", distance: 535},
        {type: OfferPoiType.BUS, name: "Tysiąclecia Państwa Polskiego", distance: 624},
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 700},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 750},
        {type: OfferPoiType.BUS, name: "Górna", distance: 827},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1094},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1515},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1564},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1575},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1616},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 1646},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 1688},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1689}
    ],
    19309: [
        {type: OfferPoiType.BUS, name: "Solidarności / Tysiąclecia PP", distance: 283},
        {type: OfferPoiType.BUS, name: "Tysiąclecia PP / Wiejska", distance: 472},
        {type: OfferPoiType.BUS, name: "Galeria Echo", distance: 544},
        {type: OfferPoiType.BUS, name: "Tysiąclecia Państwa Polskiego", distance: 633},
        {type: OfferPoiType.BUS, name: "Solidarności / os. Bocianek", distance: 709},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 759},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1103},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1524},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1584},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1625},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 1655},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 1697},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1698}
    ],
    19310: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 179},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 376},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 393},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 452},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Ujeścisko 04", distance: 658},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 01", distance: 667},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 03", distance: 685},
        {type: OfferPoiType.BUS, name: "Ujeścisko 05", distance: 693},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 02", distance: 693},
        {type: OfferPoiType.BUS, name: "Ujeścisko 06", distance: 696},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Nowosądecka 01", distance: 777},
        {type: OfferPoiType.BUS, name: "Nowosądecka 02", distance: 785},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1869},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1944},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2432}
    ],
    19325: [
        {type: OfferPoiType.BUS, name: "Talarowa 01", distance: 357},
        {type: OfferPoiType.BUS, name: "Talarowa 02", distance: 372},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 502},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 02", distance: 556},
        {type: OfferPoiType.BUS, name: "Erazma z Zakroczymia 01", distance: 667},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 1618},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 1628},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 2083}
    ],
    19328: [
        {type: OfferPoiType.BUS, name: "Gazowa", distance: 505},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 548},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 567},
        {type: OfferPoiType.BUS, name: "Tarnogaj", distance: 582},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 672},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 672},
        {type: OfferPoiType.TRAM, name: "Tarnogaj", distance: 781},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 822},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1886},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2180}
    ],
    19338: [
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 08", distance: 401},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 07", distance: 499},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 03", distance: 500},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 06", distance: 593},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 05", distance: 622},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 02", distance: 679},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 686},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 03", distance: 727},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Ursus Północny", distance: 756},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 04", distance: 765},
        {type: OfferPoiType.BUS, name: "PKP Ursus Płn. 02", distance: 775},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1137},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 1249},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1510},
        {type: OfferPoiType.PARK, name: "Eko Park Ursus", distance: 1587}
    ],
    19339: [
        {type: OfferPoiType.BUS, name: "Gąsocińska 02", distance: 359},
        {type: OfferPoiType.BUS, name: "Siekierkowska 02", distance: 363},
        {type: OfferPoiType.BUS, name: "Siekierkowska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 03", distance: 401},
        {type: OfferPoiType.BUS, name: "Gąsocińska 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 01", distance: 515},
        {type: OfferPoiType.BUS, name: "Siekierki-Sanktuarium 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Ananasowa 52", distance: 688},
        {type: OfferPoiType.BUS, name: "Łososiowa 02", distance: 752},
        {type: OfferPoiType.BUS, name: "Ananasowa 51", distance: 760},
        {type: OfferPoiType.PARK, name: "Park Akcji „Burza”", distance: 2398},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 2441}
    ],
    19343: [
        {type: OfferPoiType.BUS, name: "Filtrowa / Grunwaldzka", distance: 334},
        {type: OfferPoiType.BUS, name: "Czyżkówko", distance: 354},
        {type: OfferPoiType.BUS, name: "Wiejska / Krajeńska", distance: 360},
        {type: OfferPoiType.BUS, name: "Krajeńska / Wiejska", distance: 366},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Filtrowa", distance: 431},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Chojnicka", distance: 475},
        {type: OfferPoiType.BUS, name: "Czyżkówko [końcowy]", distance: 502},
        {type: OfferPoiType.BUS, name: "Orlicza / Nad Torem", distance: 747},
        {type: OfferPoiType.KOLEJ, name: "Bydgoszcz Zachód", distance: 772},
        {type: OfferPoiType.PARK, name: "Park przy papierni", distance: 1207},
        {type: OfferPoiType.PARK, name: "Park nad Kanałem Bydgoskim", distance: 1443},
        {type: OfferPoiType.REZERWAT, name: "Stacja uzdatniania wody “Czyżkówko”", distance: 2359}
    ],
    19344: [
        {type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 360},
        {type: OfferPoiType.BUS, name: "Starogardzka 04", distance: 600},
        {type: OfferPoiType.BUS, name: "Starogardzka 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 01", distance: 666},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 02", distance: 673}
    ],
    19345: [
        {type: OfferPoiType.BUS, name: "Augustówka 02", distance: 171},
        {type: OfferPoiType.BUS, name: "Augustówka 01", distance: 177},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 01", distance: 405},
        {type: OfferPoiType.BUS, name: "EC Siekierki 03", distance: 414},
        {type: OfferPoiType.BUS, name: "EC Siekierki 04", distance: 418},
        {type: OfferPoiType.BUS, name: "EC Siekierki 05", distance: 423},
        {type: OfferPoiType.BUS, name: "Ogrody Działkowe Budowlani II 02", distance: 437},
        {type: OfferPoiType.BUS, name: "EC Siekierki 01", distance: 489},
        {type: OfferPoiType.BUS, name: "EC Siekierki 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Kaloryczna 01", distance: 720},
        {type: OfferPoiType.PARK, name: 'Skwer "Starszych Panów"', distance: 1973},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1996},
        {type: OfferPoiType.PARK, name: "Plac Aleksandra Rembowskiego", distance: 2130}
    ],
    19346: [
        {type: OfferPoiType.BUS, name: "Krzeptów - Boisko", distance: 461},
        {type: OfferPoiType.BUS, name: "Krzeptów - pętla", distance: 488},
        {type: OfferPoiType.BUS, name: "Krzeptów - skrzy.", distance: 846}
    ],
    19352: [
        {type: OfferPoiType.PARK, name: "Park Mirabelka", distance: 56},
        {type: OfferPoiType.BUS, name: "Ustronna - Świecka NŻ", distance: 172},
        {type: OfferPoiType.BUS, name: "Ustronna - Przednia NŻ", distance: 378},
        {type: OfferPoiType.PARK, name: "Park im. Zofii Garlickiej", distance: 391},
        {type: OfferPoiType.BUS, name: "Matek Polskich - Przednia", distance: 436},
        {type: OfferPoiType.BUS, name: "Instytut CZMP", distance: 572},
        {type: OfferPoiType.BUS, name: "Siostrzana - Bartoszewskiego", distance: 578},
        {type: OfferPoiType.BUS, name: "Matek Polskich - Sczanieckiej", distance: 592},
        {type: OfferPoiType.BUS, name: "Ustronna - Zagadkowa NŻ", distance: 606},
        {type: OfferPoiType.PARK, name: "Stawy Jana", distance: 1440},
        {type: OfferPoiType.PARK, name: "Park Chojeński", distance: 2246},
        {type: OfferPoiType.PARK, name: "Park Zatorze", distance: 2339},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2508}
    ],
    19353: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skrzywana", distance: 117},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 220},
        {type: OfferPoiType.BUS, name: "Wróblewskiego - Politechniki (kampus PŁ)", distance: 297},
        {type: OfferPoiType.BUS, name: "Czerwona - Piotrkowska NŻ", distance: 326},
        {type: OfferPoiType.TRAM, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 351},
        {type: OfferPoiType.BUS, name: "Politechniki - Wróblewskiego (kampus PŁ)", distance: 365},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 519},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Czerwona", distance: 522},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 522},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 713},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 729},
        {type: OfferPoiType.TRAM, name: "Politechniki - Skrzywana", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 865},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 924},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 925},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 1165},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 1183}
    ],
    19354: [
        {type: OfferPoiType.BUS, name: "Kasprzaka - Legionów", distance: 403},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka", distance: 585},
        {type: OfferPoiType.BUS, name: "Legionów - Artyleryjska NŻ", distance: 586},
        {type: OfferPoiType.BUS, name: "Kasprzaka - Srebrzyńska", distance: 614},
        {type: OfferPoiType.BUS, name: "Legionów - Włókniarzy", distance: 614},
        {type: OfferPoiType.TRAM, name: "Legionów - Włókniarzy", distance: 642},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Kasprzaka NŻ", distance: 696},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Legionów", distance: 764},
        {type: OfferPoiType.BUS, name: "Legionów - Żeligowskiego", distance: 824},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1054},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 1189},
        {type: OfferPoiType.PARK, name: "Skwer Komitetu Obrony Robotników", distance: 1195},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 1273},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 1525},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 1537},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 1785},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 2362},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2409}
    ],
    19357: [{type: OfferPoiType.LAS, name: "Jankowski las", distance: 1076}],
    19361: [
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 01", distance: 58},
        {type: OfferPoiType.BUS, name: "Morwowa - Helenów NŻ 02", distance: 192},
        {type: OfferPoiType.BUS, name: "Wojciechowska 05", distance: 249},
        {type: OfferPoiType.BUS, name: "Wojciechowska 03", distance: 338},
        {type: OfferPoiType.BUS, name: "Wojciechowska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Wojciechowska 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Cisowa 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Wojciechowska - zespół szkół 01", distance: 461},
        {type: OfferPoiType.BUS, name: "Cisowa 01", distance: 479},
        {type: OfferPoiType.BUS, name: "Nałęczowska 01", distance: 596}
    ],
    19373: [
        {type: OfferPoiType.BUS, name: "Struga - Piotrkowska", distance: 113},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 190},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 321},
        {type: OfferPoiType.BUS, name: "Tuwima - Sienkiewicza", distance: 322},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Struga", distance: 322},
        {type: OfferPoiType.BUS, name: "Struga - Kościuszki", distance: 324},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 329},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 359},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Tuwima", distance: 379},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 433},
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Park Sienkiewicza", distance: 525},
        {type: OfferPoiType.BUS, name: "Struga - Gdańska", distance: 533},
        {type: OfferPoiType.BUS, name: "Zamenhofa - Piotrkowska", distance: 535},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 543},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 557},
        {type: OfferPoiType.TRAM, name: "Kościuszki - Zamenhofa", distance: 578},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 582},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 627},
        {type: OfferPoiType.PARK, name: "Park Sienkiewicza", distance: 647},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Tuwima", distance: 674},
        {type: OfferPoiType.PARK, name: "Skwer Hanny Ożogowskiej", distance: 787},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 868}
    ],
    19380: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej", distance: 407},
        {type: OfferPoiType.TRAM, name: "Armii Krajowej", distance: 457},
        {type: OfferPoiType.BUS, name: "Park Wschodni", distance: 538},
        {type: OfferPoiType.TRAM, name: "Park Wschodni", distance: 587},
        {type: OfferPoiType.BUS, name: "Krakowska (Centrum handlowe)", distance: 588},
        {type: OfferPoiType.TRAM, name: "Krakowska (Centrum handlowe)", distance: 631},
        {type: OfferPoiType.LAS, name: "Las Rakowiecki", distance: 716},
        {type: OfferPoiType.BUS, name: "Międzyrzecka", distance: 770},
        {type: OfferPoiType.BUS, name: "Armii Krajowej (Bogedaina)", distance: 789},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 1275},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 1387},
        {type: OfferPoiType.PARK, name: "Park na Niskich Łąkach", distance: 1827},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 2134}
    ],
    19384: [
        {type: OfferPoiType.BUS, name: "Wola Duchacka 03", distance: 327},
        {type: OfferPoiType.BUS, name: "Karpińskiego 02", distance: 330},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Wola Duchacka 01", distance: 380},
        {type: OfferPoiType.BUS, name: "Pszenna 01", distance: 518},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 04", distance: 547},
        {type: OfferPoiType.BUS, name: "Pszenna 02", distance: 581},
        {type: OfferPoiType.BUS, name: "Malborska Szkoła 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Nowosądecka 03", distance: 615},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola Duchacka 03", distance: 647},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 02", distance: 693},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 01", distance: 729},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 733},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 1341},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1435}
    ],
    19385: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Wschód 02", distance: 250},
        {type: OfferPoiType.BUS, name: "Jabłonna 02", distance: 277},
        {type: OfferPoiType.BUS, name: "Jabłonna 01", distance: 284},
        {type: OfferPoiType.BUS, name: "Bociana 04", distance: 421},
        {type: OfferPoiType.TRAM, name: "Bociana 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Zawodzie 02", distance: 486},
        {type: OfferPoiType.BUS, name: "Bociana 03", distance: 496},
        {type: OfferPoiType.TRAM, name: "Bociana 01", distance: 499},
        {type: OfferPoiType.BUS, name: "Aleja 29 Listopada Wiadukt 02", distance: 516},
        {type: OfferPoiType.BUS, name: "Zawodzie 01", distance: 578},
        {type: OfferPoiType.BUS, name: "Zawodzie 04", distance: 624},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 02", distance: 664},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 692},
        {type: OfferPoiType.BUS, name: "Dobrego Pasterza 04", distance: 760},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Białucha", distance: 1485},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 1520},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1526},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Dębowy", distance: 1537},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1665}
    ],
    19391: [
        {type: OfferPoiType.BUS, name: "Osiedle Bukowy Dworek 02", distance: 188},
        {type: OfferPoiType.BUS, name: "Osiedle Bukowy Dworek 01", distance: 259},
        {type: OfferPoiType.BUS, name: "Milenijna 52", distance: 624},
        {type: OfferPoiType.BUS, name: "Dworkowa 02", distance: 697}
    ],
    19393: [{type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 827}],
    19394: [
        {type: OfferPoiType.BUS, name: "Mańkowska 01", distance: 274},
        {type: OfferPoiType.BUS, name: "Mańkowska 02", distance: 336},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 343},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 02", distance: 532},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 598},
        {type: OfferPoiType.BUS, name: "Os. Olchowy Park 01", distance: 604},
        {type: OfferPoiType.BUS, name: "Fajna 01", distance: 633},
        {type: OfferPoiType.BUS, name: "Fajna 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 673},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Tymotki 02", distance: 762}
    ],
    19395: [{type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 399}],
    19397: [
        {type: OfferPoiType.BUS, name: "Sokola 01", distance: 683},
        {type: OfferPoiType.BUS, name: "Partyzantów-Szkoła 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Partyzantów-Szkoła 52", distance: 804},
        {type: OfferPoiType.BUS, name: "Partyzantów-Szkoła 02", distance: 820},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Grabicz", distance: 1009},
        {type: OfferPoiType.PARK, name: "Park im. Bohdana Wodiczki", distance: 2025},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 2129},
        {type: OfferPoiType.PARK, name: "Park Wiktoryn", distance: 2162},
        {type: OfferPoiType.PARK, name: "Skwer Pawła Seweryna Rozbickiego", distance: 2387}
    ],
    19400: [
        {type: OfferPoiType.BUS, name: "Moniuszki 01", distance: 102},
        {type: OfferPoiType.BUS, name: "Al. Wojska Polskiego 06", distance: 294},
        {type: OfferPoiType.BUS, name: "Al. Wojska Polskiego 05", distance: 389},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 400},
        {type: OfferPoiType.BUS, name: "Al. Wojska Polskiego 01", distance: 487},
        {type: OfferPoiType.BUS, name: "Powstańców", distance: 490},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 535},
        {type: OfferPoiType.BUS, name: "Ołówkowa 03", distance: 541},
        {type: OfferPoiType.BUS, name: "Ceramiczna 01", distance: 583},
        {type: OfferPoiType.BUS, name: "Kubusia Puchatka 01", distance: 607},
        {type: OfferPoiType.BUS, name: "Ołówkowa 04", distance: 610},
        {type: OfferPoiType.BUS, name: "Pałacyk Sokoła 01", distance: 654},
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 1282},
        {type: OfferPoiType.PARK, name: "Park Żwirowisko", distance: 1350},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 1573},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 2282}
    ],
    19405: [
        {type: OfferPoiType.BUS, name: "Obrońców Poczty Gdańskiej", distance: 201},
        {type: OfferPoiType.BUS, name: "Kołakowskiego", distance: 255},
        {type: OfferPoiType.BUS, name: "Wawrzynowicza", distance: 548},
        {type: OfferPoiType.BUS, name: "Tysiąclecie - Szpital 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Tysiąclecie - Szpital 02", distance: 685},
        {type: OfferPoiType.BUS, name: "Obrońców Westerplatte", distance: 734},
        {type: OfferPoiType.PARK, name: "Skwer przy PCK", distance: 883},
        {type: OfferPoiType.PARK, name: "Skwer im. Janusza Gniatkowskiego", distance: 1202},
        {type: OfferPoiType.PARK, name: "Park im. Tysiąclecia", distance: 1287},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny Jędrusik", distance: 1660},
        {type: OfferPoiType.PARK, name: "Park Parkitka", distance: 1823},
        {type: OfferPoiType.PARK, name: "Spacerniak", distance: 1885},
        {type: OfferPoiType.PARK, name: "Skwer osiedlowy przy ulicy Księżycowej", distance: 1928}
    ],
    19421: [
        {type: OfferPoiType.TRAM, name: "Nowosądecka 02", distance: 327},
        {type: OfferPoiType.TRAM, name: "Nowosądecka 01", distance: 363},
        {type: OfferPoiType.BUS, name: "Nowosądecka 04", distance: 374},
        {type: OfferPoiType.BUS, name: "Nowosądecka 03", distance: 426},
        {type: OfferPoiType.BUS, name: "Tuchowska 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Nowosądecka 05", distance: 437},
        {type: OfferPoiType.BUS, name: "Tuchowska 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Bojki 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Bojki 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Karpińskiego 02", distance: 663},
        {type: OfferPoiType.BUS, name: "Piaski Nowe", distance: 721},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 763},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 842},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 1403},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1749},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2321}
    ],
    19426: [
        {type: OfferPoiType.BUS, name: "Bronisin - Paprociowa NŻ", distance: 523},
        {type: OfferPoiType.BUS, name: "600-lecia miasta Łodzi - Bronisin", distance: 642},
        {type: OfferPoiType.BUS, name: "Brójecka - Paprociowa NŻ", distance: 645},
        {type: OfferPoiType.BUS, name: "Bronisin - 600-lecia miasta Łodzi NŻ", distance: 828},
        {type: OfferPoiType.PARK, name: "Park Jana Gibusa", distance: 2259},
        {type: OfferPoiType.PARK, name: "Park Leśny „Nowe Górki”", distance: 2514}
    ],
    19428: [
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 302},
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 465},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 576},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 596},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 770},
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 808},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1416}
    ],
    19432: [
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 789},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 884},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1421},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1680},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Horowe Bagno", distance: 2390}
    ],
    19433: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 437},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 464},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 498},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 784},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 788},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1132},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1656},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1777}
    ],
    19435: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 340},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 401},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 687},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 691},
        {type: OfferPoiType.BUS, name: "Bazyliańska 04", distance: 831},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1035},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1559},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1680}
    ],
    19437: [
        {type: OfferPoiType.BUS, name: "Rozłogi 02", distance: 145},
        {type: OfferPoiType.BUS, name: "Stogi 01", distance: 282},
        {type: OfferPoiType.BUS, name: "Kłosowa 01", distance: 393},
        {type: OfferPoiType.BUS, name: "Stogi 02", distance: 397},
        {type: OfferPoiType.BUS, name: "Stogi 06", distance: 408},
        {type: OfferPoiType.BUS, name: "Zimna", distance: 671}
    ],
    19439: [
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Szobera 02", distance: 239},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 345},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 03", distance: 560},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 04", distance: 606},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 637},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 15", distance: 637},
        {type: OfferPoiType.BUS, name: "Os. Górczewska 02", distance: 640},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 14", distance: 645},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 13", distance: 651},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 12", distance: 658},
        {type: OfferPoiType.TRAM, name: "Os. Górczewska 11", distance: 664},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 779}
    ],
    19440: [
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 182},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 186},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 240},
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 302},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 01", distance: 384},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 02", distance: 391},
        {type: OfferPoiType.BUS, name: "Coopera 02", distance: 660},
        {type: OfferPoiType.BUS, name: "Szobera 01", distance: 706},
        {type: OfferPoiType.BUS, name: "Człuchowska 02", distance: 769},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 796},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 890}
    ],
    19441: [
        {type: OfferPoiType.BUS, name: "Pirenejska 02", distance: 250},
        {type: OfferPoiType.BUS, name: "Radiowa 02", distance: 310},
        {type: OfferPoiType.BUS, name: "Pirenejska 01", distance: 329},
        {type: OfferPoiType.TRAM, name: "Radiowa 06", distance: 355},
        {type: OfferPoiType.TRAM, name: "Radiowa 07", distance: 365},
        {type: OfferPoiType.BUS, name: "Radiowa 03", distance: 387},
        {type: OfferPoiType.BUS, name: "Radiowa 04", distance: 404},
        {type: OfferPoiType.TRAM, name: "Radiowa 05", distance: 415},
        {type: OfferPoiType.BUS, name: "Wrocławska 04", distance: 432},
        {type: OfferPoiType.BUS, name: "Radiowa 01", distance: 434},
        {type: OfferPoiType.TRAM, name: "Wrocławska 06", distance: 437},
        {type: OfferPoiType.BUS, name: "Wrocławska 02", distance: 459},
        {type: OfferPoiType.TRAM, name: "Wrocławska 05", distance: 509},
        {type: OfferPoiType.BUS, name: "Wrocławska 03", distance: 550},
        {type: OfferPoiType.BUS, name: "Wrocławska 01", distance: 571},
        {type: OfferPoiType.TRAM, name: "Orlich Gniazd 05", distance: 830},
        {type: OfferPoiType.PARK, name: "Park im. Księcia Janusza", distance: 2371},
        {type: OfferPoiType.PARK, name: "Park Ulricha", distance: 2494}
    ],
    19442: [
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 576},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 610},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 617},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 627},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 699},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2070}
    ],
    19443: [
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 02", distance: 161},
        {type: OfferPoiType.BUS, name: "Warzelnicza-Szkoła 01", distance: 242},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 528},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 633},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 04", distance: 723},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 02", distance: 771},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 817},
        {type: OfferPoiType.BUS, name: "Białołęka-Kanał 01", distance: 840}
    ],
    19445: [
        {type: OfferPoiType.BUS, name: "Skłodowskiej", distance: 511},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (Szpital)", distance: 709},
        {type: OfferPoiType.PARK, name: "Skwer Lecha Kaczyńskiego Prezydenta Rzeczypospolitej Polskiej", distance: 730},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (DPS)", distance: 764},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Klenczona", distance: 1369},
        {type: OfferPoiType.REZERWAT, name: 'Użytek Ekologiczny "Mała Biel"', distance: 1391},
        {type: OfferPoiType.REZERWAT, name: "Mała Biel", distance: 1413}
    ],
    19447: [
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 559},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 1334},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 1378},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 1431},
        {type: OfferPoiType.PARK, name: "Skwer Edwarda Woyniłłowicza", distance: 1568},
        {type: OfferPoiType.PARK, name: "Skwer Mikołaja Kopernika", distance: 1586},
        {type: OfferPoiType.PARK, name: "Skwer im. ppor. Leszka Białego", distance: 1743},
        {type: OfferPoiType.PARK, name: "Skwer im. Mariana Turwida", distance: 1745},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 1747}
    ],
    19451: [{type: OfferPoiType.BUS, name: "Ustronie Morskie - szkoła", distance: 484}],
    19452: [
        {type: OfferPoiType.BUS, name: "Rewal", distance: 153},
        {type: OfferPoiType.KOLEJ, name: "Rewal", distance: 819}
    ],
    19453: [
        {type: OfferPoiType.BUS, name: "Kostuchna Skrzyżowanie", distance: 252},
        {type: OfferPoiType.BUS, name: "Kostuchna Fińskie Domki", distance: 295},
        {type: OfferPoiType.PARK, name: "Skwer Michała Banasika", distance: 301},
        {type: OfferPoiType.BUS, name: "Piotrowice Cmentarz", distance: 762},
        {type: OfferPoiType.BUS, name: "Kostuchna Szarych Szeregów", distance: 781},
        {type: OfferPoiType.PARK, name: "Skwer 2 Pułku Pszczyńskiego", distance: 856},
        {type: OfferPoiType.PARK, name: "Park Malownik", distance: 1876},
        {type: OfferPoiType.PARK, name: "Plac Filipa Limańskiego", distance: 2020},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat przyrody "Ochojec"', distance: 2345}
    ],
    19459: [
        {type: OfferPoiType.BUS, name: "Bożeny n/ż", distance: 179},
        {type: OfferPoiType.PARK, name: "Park Rodziny Stablewskich", distance: 1084}
    ],
    19460: [
        {type: OfferPoiType.BUS, name: "Bunscha 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Bunscha 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Czerwone Maki P+R 02", distance: 757},
        {type: OfferPoiType.BUS, name: "Mochnaniec 02", distance: 758},
        {type: OfferPoiType.BUS, name: "Piltza 04", distance: 784},
        {type: OfferPoiType.BUS, name: "Babińskiego 03", distance: 796},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 1117},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 2327},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2388}
    ],
    19461: [
        {type: OfferPoiType.BUS, name: "Sikorki 01", distance: 66},
        {type: OfferPoiType.BUS, name: "Sikorki 02", distance: 103},
        {type: OfferPoiType.BUS, name: "Na Załęczu 01", distance: 266},
        {type: OfferPoiType.BUS, name: "Na Załęczu 04", distance: 315},
        {type: OfferPoiType.BUS, name: "Na Załęczu 02", distance: 355},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 02", distance: 399},
        {type: OfferPoiType.BUS, name: "Sołtysowska Osiedle 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 01", distance: 576},
        {type: OfferPoiType.BUS, name: "Ogłęczyzna 02", distance: 608},
        {type: OfferPoiType.BUS, name: "Sołtysowska Zakłady 02", distance: 723},
        {type: OfferPoiType.PARK, name: "Park Woźniców", distance: 1076},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1519},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 1825},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 1897},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 2005},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 2381},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 2424},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 2432}
    ],
    19462: [
        {type: OfferPoiType.BUS, name: "Nowy Bieżanów P+R 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Nowy Bieżanów P+R 03", distance: 212},
        {type: OfferPoiType.BUS, name: "Nowy Bieżanów P+R 04", distance: 220},
        {type: OfferPoiType.BUS, name: "przystanek tymczasowy", distance: 236},
        {type: OfferPoiType.TRAM, name: "Nowy Bieżanów P+R 01", distance: 248},
        {type: OfferPoiType.TRAM, name: "Nowy Bieżanów P+R", distance: 256},
        {type: OfferPoiType.BUS, name: "Bieżanów Szkoła 04", distance: 353},
        {type: OfferPoiType.BUS, name: "Korepty 02", distance: 397},
        {type: OfferPoiType.BUS, name: "Madejówka 02", distance: 422},
        {type: OfferPoiType.TRAM, name: "Ćwiklińskiej 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Ćwiklińskiej 04", distance: 443},
        {type: OfferPoiType.BUS, name: "Korepty 01", distance: 453},
        {type: OfferPoiType.BUS, name: "Bieżanów Szkoła 02", distance: 467},
        {type: OfferPoiType.TRAM, name: "Ćwiklińskiej 01", distance: 517},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1270},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 1302},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1888},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1890},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1948},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 2357}
    ],
    19463: [
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego", distance: 83},
        {type: OfferPoiType.TRAM, name: "Wierzbięcice", distance: 265},
        {type: OfferPoiType.BUS, name: "Św. Czesława", distance: 291},
        {type: OfferPoiType.TRAM, name: "Św. Czesława", distance: 291},
        {type: OfferPoiType.BUS, name: "Poznań Główny", distance: 409},
        {type: OfferPoiType.BUS, name: "Bergera", distance: 540},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 582},
        {type: OfferPoiType.BUS, name: "Półwiejska", distance: 644},
        {type: OfferPoiType.TRAM, name: "Półwiejska", distance: 661},
        {type: OfferPoiType.TRAM, name: "Różana", distance: 678},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 817},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 961},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 974},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 1060},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1382},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1418},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1529},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1564}
    ],
    19473: [
        {type: OfferPoiType.BUS, name: "Sarmacka 01", distance: 311},
        {type: OfferPoiType.BUS, name: "Sarmacka 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Vogla 05", distance: 556},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 03", distance: 585},
        {type: OfferPoiType.BUS, name: "Vogla 04", distance: 671},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 10", distance: 713},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 05", distance: 715},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 04", distance: 721},
        {type: OfferPoiType.BUS, name: "Miasteczko Wilanów 02", distance: 721},
        {type: OfferPoiType.BUS, name: "Vogla 01", distance: 723},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 06", distance: 750},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 08", distance: 751},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 71", distance: 797},
        {type: OfferPoiType.BUS, name: "Vogla 02", distance: 802},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 72", distance: 802},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 983},
        {type: OfferPoiType.REZERWAT, name: "Powsinek - użytek 622", distance: 2478}
    ],
    19474: [
        {type: OfferPoiType.PARK, name: "Wilcze Doły", distance: 1127},
        {type: OfferPoiType.PARK, name: "Skwer Kežmarok", distance: 1684},
        {type: OfferPoiType.PARK, name: "Plac Grunwaldzki", distance: 1736}
    ],
    19475: [
        {type: OfferPoiType.BUS, name: "Wrony 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Wrony 01", distance: 509},
        {type: OfferPoiType.BUS, name: "Wrony 03", distance: 546},
        {type: OfferPoiType.REZERWAT, name: "Dąbrowa", distance: 2360}
    ],
    19478: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 02", distance: 380},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 04", distance: 437},
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 03", distance: 510},
        {type: OfferPoiType.BUS, name: "Glogera 71", distance: 712},
        {type: OfferPoiType.BUS, name: "Glogera 72", distance: 730},
        {type: OfferPoiType.BUS, name: "Zielonki Słoneczna", distance: 783},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2162},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 2214},
        {type: OfferPoiType.REZERWAT, name: "Dolina Prądnika", distance: 2515}
    ],
    19483: [
        {type: OfferPoiType.BUS, name: "Poznańska", distance: 194},
        {type: OfferPoiType.BUS, name: "Witomińska", distance: 253},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 10", distance: 277},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 04", distance: 313},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 06", distance: 324},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej", distance: 373},
        {type: OfferPoiType.BUS, name: "Węzeł Franciszki Cegielskiej 02", distance: 402},
        {type: OfferPoiType.PARK, name: "Gdyński Park Kieszonkowy", distance: 504},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Wzgórze Świętego Maksymiliana", distance: 515},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 579},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 900},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 905},
        {type: OfferPoiType.PARK, name: "Park Marii i Lecha Kaczyńskich", distance: 1376}
    ],
    19484: [
        {type: OfferPoiType.BUS, name: "Szklarniowa 02", distance: 527},
        {type: OfferPoiType.BUS, name: "Szklarniowa 01", distance: 620},
        {type: OfferPoiType.PARK, name: "Park im. Mariana Jonkajtysa", distance: 2120},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci", distance: 2341},
        {type: OfferPoiType.PARK, name: "Skwer im. Żołnierzy Wyklętych", distance: 2488}
    ],
    19495: [
        {type: OfferPoiType.BUS, name: "Skalskiego 01", distance: 338},
        {type: OfferPoiType.BUS, name: "Skalskiego 02", distance: 396},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 673},
        {type: OfferPoiType.BUS, name: "Instytut Agrofizyki 01", distance: 678},
        {type: OfferPoiType.BUS, name: "Instytut Agrofizyki 02", distance: 699},
        {type: OfferPoiType.BUS, name: "Felin 03", distance: 792},
        {type: OfferPoiType.BUS, name: "Felin 01", distance: 793}
    ],
    19496: [
        {type: OfferPoiType.BUS, name: "Zelwerowicza 03", distance: 782},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 2517}
    ],
    19497: [
        {type: OfferPoiType.BUS, name: "Walendów Ogrody", distance: 76},
        {type: OfferPoiType.BUS, name: "Kajetany Brzozowa", distance: 590},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 01", distance: 779},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 02", distance: 835}
    ],
    19499: [
        {type: OfferPoiType.BUS, name: "Poświęcka", distance: 255},
        {type: OfferPoiType.BUS, name: "Poświęcka (Ośrodek zdrowia)", distance: 419},
        {type: OfferPoiType.BUS, name: "Żmigrodzka (Obwodnica)", distance: 693},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 765},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 783},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1860}
    ],
    19501: [
        {type: OfferPoiType.BUS, name: "Kakaowa 01", distance: 329},
        {type: OfferPoiType.BUS, name: "Błędna 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Zamienie 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Bakaliowa 01", distance: 652}
    ],
    19514: [
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – PKP", distance: 102},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – skrzyżowanie", distance: 161},
        {type: OfferPoiType.BUS, name: "Bielany Stacja Kolejowa", distance: 243},
        {type: OfferPoiType.KOLEJ, name: "Bielany Wrocławskie", distance: 386},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – Kościół", distance: 475},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – Boczna", distance: 562},
        {type: OfferPoiType.BUS, name: "Ślęza – skrzyżowanie", distance: 832}
    ],
    19519: [
        {type: OfferPoiType.BUS, name: "Warszawska / os. Słoneczne Wzgórze", distance: 189},
        {type: OfferPoiType.BUS, name: "Warszawska / os. Szydłówek", distance: 230},
        {type: OfferPoiType.BUS, name: "Warszawska / os. Uroczysko", distance: 276},
        {type: OfferPoiType.BUS, name: "Warszawska / os. Bocianek", distance: 541},
        {type: OfferPoiType.BUS, name: "Warszawska / Jaworskiego", distance: 599},
        {type: OfferPoiType.BUS, name: "Klonowa / Turystyczna", distance: 676},
        {type: OfferPoiType.BUS, name: "Orkana / os. Związkowiec", distance: 718},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 905},
        {type: OfferPoiType.PARK, name: "Park Kielczan 2019", distance: 915},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1028},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 1886},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2182}
    ],
    19524: [
        {type: OfferPoiType.BUS, name: "Szybka 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Szybka 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Instalatorów 03", distance: 721},
        {type: OfferPoiType.BUS, name: "Instalatorów 01", distance: 769},
        {type: OfferPoiType.BUS, name: "Instalatorów 02", distance: 774},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 1872},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2182}
    ],
    19525: [
        {type: OfferPoiType.BUS, name: "Sportowa / Bloki (03)", distance: 253},
        {type: OfferPoiType.BUS, name: "Walerego Romana / PNT (01)", distance: 329},
        {type: OfferPoiType.BUS, name: "Sportowa (02)", distance: 342},
        {type: OfferPoiType.BUS, name: "Walerego Romana (02)", distance: 433},
        {type: OfferPoiType.PARK, name: "Park Konstytucji 3 Maja", distance: 2317}
    ],
    19532: [
        {type: OfferPoiType.TRAM, name: "Dajwór 01", distance: 223},
        {type: OfferPoiType.BUS, name: "Dajwór 01", distance: 224},
        {type: OfferPoiType.TRAM, name: "Muzeum Inżynierii Miejskiej", distance: 288},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 01", distance: 302},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 02", distance: 347},
        {type: OfferPoiType.TRAM, name: "Miodowa 02", distance: 370},
        {type: OfferPoiType.TRAM, name: "Miodowa 01", distance: 433},
        {type: OfferPoiType.PARK, name: "Skwer Kółeczko", distance: 491},
        {type: OfferPoiType.TRAM, name: "Stradom 04", distance: 574},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 02", distance: 597},
        {type: OfferPoiType.TRAM, name: "Plac Wolnica 01", distance: 615},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 626},
        {type: OfferPoiType.BUS, name: "Stradom 05", distance: 673},
        {type: OfferPoiType.TRAM, name: "Stradom 01", distance: 704},
        {type: OfferPoiType.BUS, name: "Stradom 06", distance: 714},
        {type: OfferPoiType.BUS, name: "Stradom 02", distance: 745},
        {type: OfferPoiType.BUS, name: "Stradom 08", distance: 758},
        {type: OfferPoiType.BUS, name: "Starowiślna 07", distance: 795},
        {type: OfferPoiType.BUS, name: "Plac Bohaterów Getta", distance: 834},
        {type: OfferPoiType.PARK, name: "Ogrody Zgromadzenia Księży Misjonarzy w Krakowie", distance: 884},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 927},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1103}
    ],
    19534: [{type: OfferPoiType.BUS, name: "Ogonki", distance: 115}],
    19535: [
        {type: OfferPoiType.BUS, name: "Radiowa 02", distance: 1},
        {type: OfferPoiType.TRAM, name: "Radiowa 06", distance: 115},
        {type: OfferPoiType.TRAM, name: "Radiowa 07", distance: 141},
        {type: OfferPoiType.BUS, name: "Radiowa 03", distance: 163},
        {type: OfferPoiType.BUS, name: "Radiowa 04", distance: 164},
        {type: OfferPoiType.TRAM, name: "Radiowa 05", distance: 177},
        {type: OfferPoiType.BUS, name: "Radiowa 01", distance: 193},
        {type: OfferPoiType.BUS, name: "Pirenejska 02", distance: 500},
        {type: OfferPoiType.BUS, name: "Dywizjonu 303 02", distance: 568},
        {type: OfferPoiType.BUS, name: "Orlich Gniazd 02", distance: 583},
        {type: OfferPoiType.BUS, name: "Pirenejska 01", distance: 592},
        {type: OfferPoiType.TRAM, name: "Orlich Gniazd 05", distance: 674},
        {type: OfferPoiType.TRAM, name: "Dywizjonu 303 04", distance: 678},
        {type: OfferPoiType.BUS, name: "Radiowa-WAT 02", distance: 704},
        {type: OfferPoiType.TRAM, name: "Orlich Gniazd 06", distance: 707},
        {type: OfferPoiType.BUS, name: "Wrocławska 02", distance: 722},
        {type: OfferPoiType.TRAM, name: "Dywizjonu 303 03", distance: 730},
        {type: OfferPoiType.TRAM, name: "Wrocławska 06", distance: 750},
        {type: OfferPoiType.TRAM, name: "Siodlarska 02", distance: 794},
        {type: OfferPoiType.TRAM, name: "Dywizjonu 303 05", distance: 798},
        {type: OfferPoiType.PARK, name: "Park im. Księcia Janusza", distance: 2314},
        {type: OfferPoiType.PARK, name: "Park Ulricha", distance: 2338}
    ],
    19537: [
        {type: OfferPoiType.BUS, name: "Objazdowa", distance: 477},
        {type: OfferPoiType.BUS, name: "Łąkoszyńska/bloki", distance: 557},
        {type: OfferPoiType.BUS, name: "Łąkoszyńska/pętla", distance: 621},
        {type: OfferPoiType.BUS, name: "Łąkoszyńska/Łódzka", distance: 652},
        {type: OfferPoiType.PARK, name: "Teren kościoła św. Stanisława Biskupa i Męczennika", distance: 1367},
        {type: OfferPoiType.PARK, name: "Park nad Ochnią", distance: 2222},
        {type: OfferPoiType.PARK, name: "Skwer Druhny Harcmistrzyni Pelagii Ładykowskiej-Zys", distance: 2364}
    ],
    19538: [
        {type: OfferPoiType.BUS, name: "Szamotuły, ul. Dworcowa", distance: 406},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 497},
        {type: OfferPoiType.BUS, name: "Szamotuły ul. Wojska Polskiego", distance: 539},
        {type: OfferPoiType.BUS, name: "Szamotuły Poczta", distance: 759},
        {type: OfferPoiType.PARK, name: "Skwer im. Maksymiliana Ciężkiego", distance: 796},
        {type: OfferPoiType.PARK, name: "Park Jana III Sobieskiego", distance: 1145},
        {type: OfferPoiType.PARK, name: "Ogródek Jordanowski", distance: 1467},
        {type: OfferPoiType.PARK, name: "Park Henryka Sienkiewicza", distance: 1575},
        {type: OfferPoiType.PARK, name: "Park Zamkowy", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park im. Zofii i Michała Mycielskich", distance: 1906}
    ],
    19539: [
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 527},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 565}
    ],
    19540: [
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 02", distance: 292},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 316},
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 01", distance: 335},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 02", distance: 432},
        {type: OfferPoiType.BUS, name: "Czerwiakowskiego 02", distance: 523},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 02", distance: 551},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 04", distance: 553},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 01", distance: 562},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 01", distance: 623},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 639},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 06", distance: 646},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 02", distance: 658},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1276},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1307},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1371},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 1389},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1575}
    ],
    19541: [
        {type: OfferPoiType.BUS, name: "Laurowa 01", distance: 326},
        {type: OfferPoiType.BUS, name: "Laurowa 02", distance: 364},
        {type: OfferPoiType.BUS, name: "Kasztanowa 01", distance: 418},
        {type: OfferPoiType.BUS, name: "Kasztanowa 02", distance: 479},
        {type: OfferPoiType.BUS, name: "Dorodna 02", distance: 599},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 750},
        {type: OfferPoiType.BUS, name: "Portowa 02", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 1787},
        {type: OfferPoiType.PARK, name: "Park Picassa", distance: 2008}
    ],
    19542: [
        {type: OfferPoiType.BUS, name: "Osiedle Limba 02", distance: 191},
        {type: OfferPoiType.BUS, name: "Osiedle Limba 01", distance: 258},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Stawy Raszyńskie", distance: 2444}
    ],
    19544: [
        {type: OfferPoiType.BUS, name: "Biegasa", distance: 260},
        {type: OfferPoiType.BUS, name: "Chełmońskiego", distance: 524},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 597},
        {type: OfferPoiType.BUS, name: "Tramwajowa", distance: 701},
        {type: OfferPoiType.TRAM, name: "Chełmońskiego", distance: 726},
        {type: OfferPoiType.TRAM, name: "Tramwajowa", distance: 738},
        {type: OfferPoiType.BUS, name: "Dembowskiego (Kosiby)", distance: 833},
        {type: OfferPoiType.LAS, name: "Park Dąbski", distance: 1060},
        {type: OfferPoiType.PARK, name: "Park Dąbski", distance: 1060},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 1613},
        {type: OfferPoiType.PARK, name: "skwer Zbyszka Cybulskiego", distance: 1621},
        {type: OfferPoiType.PARK, name: "skwer Hanny Hirszfeldowej", distance: 1798},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1995}
    ],
    19548: [
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 426},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 01", distance: 633},
        {type: OfferPoiType.BUS, name: "Rybaki Górne 02", distance: 675},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 795},
        {type: OfferPoiType.BUS, name: "Targ Rybny 01", distance: 829},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 876},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 911},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 1104},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1219},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1916},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2028},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 2386}
    ],
    19549: [
        {type: OfferPoiType.BUS, name: "ks. Meiera 01", distance: 635},
        {type: OfferPoiType.BUS, name: "ks. Meiera 04", distance: 657},
        {type: OfferPoiType.BUS, name: "ks. Meiera 02", distance: 662},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2020},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 2178}
    ],
    19561: [
        {type: OfferPoiType.BUS, name: "Krzepicka", distance: 635},
        {type: OfferPoiType.BUS, name: "Rudnicze", distance: 798},
        {type: OfferPoiType.TRAM, name: "Junikowo", distance: 817},
        {type: OfferPoiType.BUS, name: "Junikowo", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Księdza Feliksa Michalskiego", distance: 1703}
    ],
    19564: [
        {type: OfferPoiType.BUS, name: "Niepodległości 01", distance: 533},
        {type: OfferPoiType.BUS, name: "Niepodległości 02", distance: 581},
        {type: OfferPoiType.BUS, name: "Kossaka 01", distance: 602},
        {type: OfferPoiType.BUS, name: "Kossaka 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Robotnicza 02", distance: 666},
        {type: OfferPoiType.BUS, name: "Robotnicza 01", distance: 740},
        {type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1672}
    ],
    19567: [
        {type: OfferPoiType.BUS, name: "Pomorska - Gdańska 01", distance: 318},
        {type: OfferPoiType.BUS, name: "Kujawska", distance: 408},
        {type: OfferPoiType.BUS, name: "Osiedle Królewskie", distance: 497},
        {type: OfferPoiType.BUS, name: "Wierzbowa", distance: 539},
        {type: OfferPoiType.BUS, name: "Pomorska", distance: 795},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 917},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 957},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2171}
    ],
    19568: [
        {type: OfferPoiType.BUS, name: "Cmentarz Poprzeczna", distance: 244},
        {type: OfferPoiType.BUS, name: "Cicha", distance: 260},
        {type: OfferPoiType.BUS, name: "Wrocławska", distance: 515},
        {type: OfferPoiType.BUS, name: "Reymonta", distance: 586},
        {type: OfferPoiType.BUS, name: "Poprzeczna", distance: 606},
        {type: OfferPoiType.BUS, name: "Szewczenki", distance: 698},
        {type: OfferPoiType.PARK, name: "Górka Jasia", distance: 722},
        {type: OfferPoiType.KOLEJ, name: "Olsztyn Główny", distance: 741},
        {type: OfferPoiType.PARK, name: "Za Torami Pod Lipami", distance: 882},
        {type: OfferPoiType.PARK, name: "Park przy Rataja", distance: 1438},
        {type: OfferPoiType.PARK, name: "Park Jakubowo", distance: 1804}
    ],
    19569: [
        {type: OfferPoiType.BUS, name: "Kresowa", distance: 360},
        {type: OfferPoiType.BUS, name: "Widłakowa n/ż", distance: 439},
        {type: OfferPoiType.BUS, name: "UAM Os. Różany Potok", distance: 586},
        {type: OfferPoiType.BUS, name: "Rumiankowa n/ż", distance: 697},
        {type: OfferPoiType.BUS, name: "UAM Wydział Geografii", distance: 701},
        {type: OfferPoiType.PARK, name: "Demonstracyjny ogród klimatyczny", distance: 901},
        {type: OfferPoiType.PARK, name: "Skwer Poznańskiego Towarzystwa Przyjaciół Nauk", distance: 1388},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Żurawiniec", distance: 2483}
    ],
    19572: [
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 01 n/ż", distance: 455},
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 02 n/ż", distance: 473},
        {type: OfferPoiType.BUS, name: 'C.H. "Port Rumia" - Kosynierów 02', distance: 681},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 2337}
    ],
    19573: [
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer Jana Pawła II", distance: 1968},
        {type: OfferPoiType.PARK, name: "Planty Zamkowe", distance: 1991},
        {type: OfferPoiType.PARK, name: "Miasteczko ruchu", distance: 2236},
        {type: OfferPoiType.PARK, name: "Skwer imienia księcia Henryka I Brodatego", distance: 2242}
    ],
    19577: [
        {type: OfferPoiType.BUS, name: "Gazowa", distance: 440},
        {type: OfferPoiType.BUS, name: "Tarnogaj", distance: 520},
        {type: OfferPoiType.TRAM, name: "Klimasa", distance: 793},
        {type: OfferPoiType.TRAM, name: "Tarnogaj", distance: 799},
        {type: OfferPoiType.BUS, name: "Klimasa", distance: 812},
        {type: OfferPoiType.LAS, name: "Park Tarnogajski", distance: 917},
        {type: OfferPoiType.PARK, name: "Park Tarnogajski", distance: 917},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 2131},
        {type: OfferPoiType.PARK, name: "Park Wschodni", distance: 2425}
    ],
    19579: [
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 376},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 406},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 428},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 458},
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 469},
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 704},
        {type: OfferPoiType.TRAM, name: "Lechicka/Poznań Plaza", distance: 705},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1296},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1509},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1822},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 1974},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2070},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2075},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2181},
        {type: OfferPoiType.PARK, name: "Park na os. Wichrowe Wzgórze", distance: 2309}
    ],
    19580: [
        {type: OfferPoiType.BUS, name: "Saska 02", distance: 384},
        {type: OfferPoiType.BUS, name: "Saska 03", distance: 476},
        {type: OfferPoiType.BUS, name: "Saska 05", distance: 483},
        {type: OfferPoiType.BUS, name: "Saska 07", distance: 507},
        {type: OfferPoiType.BUS, name: "Saska 04", distance: 511},
        {type: OfferPoiType.BUS, name: "Saska 01", distance: 544},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 553},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 596},
        {type: OfferPoiType.BUS, name: "Stoczniowców 01", distance: 598},
        {type: OfferPoiType.BUS, name: "Koszykarska 03", distance: 623},
        {type: OfferPoiType.BUS, name: "Stoczniowców 03", distance: 660},
        {type: OfferPoiType.BUS, name: "Koszykarska 01", distance: 727},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1462},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1655},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 1834},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 1863},
        {type: OfferPoiType.PARK, name: "Park Płaszów", distance: 1884}
    ],
    19586: [
        {type: OfferPoiType.BUS, name: "Wieliczka Modrzewiowa", distance: 362},
        {type: OfferPoiType.BUS, name: "Krzyszkowice Kasztanowa II", distance: 543},
        {type: OfferPoiType.REZERWAT, name: "Las Krzyszkowicki", distance: 1437},
        {type: OfferPoiType.PARK, name: "Park Świętej Barbary", distance: 1960},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2255}
    ],
    19588: [
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 113},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 118},
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Chyliczki 01", distance: 716},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 735},
        {type: OfferPoiType.BUS, name: "Chyliczki 02", distance: 813}
    ],
    19590: [
        {type: OfferPoiType.BUS, name: "Rondo Toruńskie", distance: 159},
        {type: OfferPoiType.TRAM, name: "Rondo Toruńskie", distance: 218},
        {type: OfferPoiType.BUS, name: "Toruńska / Hala", distance: 294},
        {type: OfferPoiType.TRAM, name: "Toruńska / Hala", distance: 335},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 557},
        {type: OfferPoiType.TRAM, name: "Rondo Fordońskie", distance: 591},
        {type: OfferPoiType.BUS, name: "Toruńska / Żupy", distance: 603},
        {type: OfferPoiType.TRAM, name: "Toruńska / Żupy", distance: 719},
        {type: OfferPoiType.PARK, name: "Skwer Ludwika Zamenhofa", distance: 1000},
        {type: OfferPoiType.PARK, name: "Bulwar im. Leona Janty-Połczyńskiego", distance: 1066},
        {type: OfferPoiType.PARK, name: "Park Kotwicy", distance: 1162},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1226}
    ],
    19595: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 515},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 541},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 814},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2223},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 2507}
    ],
    19596: [
        {type: OfferPoiType.BUS, name: "Krakowska / Ceramiczna 12", distance: 795},
        {type: OfferPoiType.BUS, name: "Krakowska / Ustrzycka 11", distance: 838},
        {type: OfferPoiType.PARK, name: "Park im. Adama Węgrzyna", distance: 2424},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Nyíregyháza", distance: 2450}
    ],
    19597: [
        {type: OfferPoiType.BUS, name: "Aleja Jana Pawła II 01", distance: 129},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 04", distance: 307},
        {type: OfferPoiType.BUS, name: "Aleja Jana Pawła II 02", distance: 323},
        {type: OfferPoiType.BUS, name: "Rondo ONZ 02", distance: 340},
        {type: OfferPoiType.BUS, name: "Hala Mirowska 02", distance: 386},
        {type: OfferPoiType.PARK, name: "Park Mirowski", distance: 410},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 03", distance: 435},
        {type: OfferPoiType.BUS, name: "Pl. Grzybowski 01", distance: 450},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 04", distance: 458},
        {type: OfferPoiType.PARK, name: "Skwer Isaaca Bashevisa Singera", distance: 477},
        {type: OfferPoiType.BUS, name: "Mennica 01", distance: 497},
        {type: OfferPoiType.METRO, name: "Rondo ONZ", distance: 497},
        {type: OfferPoiType.TRAM, name: "Hala Mirowska 04", distance: 532},
        {type: OfferPoiType.BUS, name: "Hala Mirowska 01", distance: 539},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 08", distance: 550},
        {type: OfferPoiType.TRAM, name: "Rondo ONZ 03", distance: 579},
        {type: OfferPoiType.TRAM, name: "Hala Mirowska 03", distance: 592},
        {type: OfferPoiType.TRAM, name: "Królewska 05", distance: 666},
        {type: OfferPoiType.PARK, name: "Skwer Sybiraków", distance: 675},
        {type: OfferPoiType.TRAM, name: "Królewska 06", distance: 716},
        {type: OfferPoiType.TRAM, name: "Norblin 03", distance: 796},
        {type: OfferPoiType.TRAM, name: "Norblin 04", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Świętokrzyski", distance: 847},
        {type: OfferPoiType.PARK, name: "Ogród Saski", distance: 993},
        {type: OfferPoiType.PARK, name: "Skwer Duśki Trafankowskiej", distance: 1015},
        {type: OfferPoiType.PARK, name: "Ogród Zamoyskich", distance: 1110},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 2155}
    ],
    19602: [
        {type: OfferPoiType.BUS, name: "Łukowska 01", distance: 374},
        {type: OfferPoiType.BUS, name: "Gdecka 01", distance: 399},
        {type: OfferPoiType.BUS, name: "Wspólna Droga 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Gdecka 02", distance: 429},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 02", distance: 454},
        {type: OfferPoiType.BUS, name: "Łukowska 04", distance: 457},
        {type: OfferPoiType.BUS, name: "Łukowska 02", distance: 467},
        {type: OfferPoiType.BUS, name: "Łukowska 03", distance: 490},
        {type: OfferPoiType.PARK, name: "Park Znicza", distance: 491},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 03", distance: 510},
        {type: OfferPoiType.TRAM, name: "Wspólna Droga 04", distance: 538},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 04", distance: 574},
        {type: OfferPoiType.BUS, name: "Wspólna Droga 01", distance: 578},
        {type: OfferPoiType.BUS, name: "Plac Szembeka 01", distance: 617},
        {type: OfferPoiType.TRAM, name: "Plac Szembeka 03", distance: 630},
        {type: OfferPoiType.TRAM, name: "Czapelska 01", distance: 813},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1338},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1346},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1502},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1905}
    ],
    19603: [
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 90},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 313},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 331},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 08", distance: 333},
        {type: OfferPoiType.BUS, name: "Paderewskiego kościół 05", distance: 338},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 02", distance: 467},
        {type: OfferPoiType.BUS, name: "Witolda seminarium 01", distance: 566},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 580},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 645},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Mieszka I 05", distance: 702},
        {type: OfferPoiType.BUS, name: "Św. Rocha szkoła 01", distance: 797},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 2046},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 2382}
    ],
    19604: [
        {type: OfferPoiType.BUS, name: "Domaszowska / Poleska", distance: 352},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 375},
        {type: OfferPoiType.BUS, name: "Domaszowska / Żniwna", distance: 410},
        {type: OfferPoiType.BUS, name: "Poleska", distance: 451},
        {type: OfferPoiType.BUS, name: "Sandomierska / Śląska", distance: 466},
        {type: OfferPoiType.BUS, name: "Sandomierska", distance: 495},
        {type: OfferPoiType.BUS, name: "Żniwna / Domaszowska", distance: 572},
        {type: OfferPoiType.BUS, name: "Tysiąclecia PP / Wiejska", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1164},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1297},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 1555},
        {type: OfferPoiType.PARK, name: "Skwer im. Mikołaja Kopernika", distance: 1586},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 1656},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 1686},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1913},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Żeromskiego", distance: 1973}
    ],
    19605: [
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego", distance: 59},
        {type: OfferPoiType.BUS, name: "Leśny Dwór Pętla", distance: 270},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (DPS)", distance: 401},
        {type: OfferPoiType.BUS, name: "Sobieszczańskiego (Szpital)", distance: 457},
        {type: OfferPoiType.PARK, name: "Skwer Lecha Kaczyńskiego Prezydenta Rzeczypospolitej Polskiej", distance: 1172},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Klenczona", distance: 1807},
        {type: OfferPoiType.REZERWAT, name: 'Użytek Ekologiczny "Mała Biel"', distance: 1830},
        {type: OfferPoiType.REZERWAT, name: "Mała Biel", distance: 1852}
    ],
    19607: [
        {type: OfferPoiType.BUS, name: "Widłakowa n/ż", distance: 438},
        {type: OfferPoiType.BUS, name: "Kresowa", distance: 626},
        {type: OfferPoiType.BUS, name: "UAM Os. Różany Potok", distance: 647},
        {type: OfferPoiType.BUS, name: "Rumiankowa n/ż", distance: 653},
        {type: OfferPoiType.BUS, name: "UAM Wydział Geografii", distance: 765},
        {type: OfferPoiType.PARK, name: "Demonstracyjny ogród klimatyczny", distance: 965},
        {type: OfferPoiType.PARK, name: "Skwer Poznańskiego Towarzystwa Przyjaciół Nauk", distance: 1316}
    ],
    19609: [
        {type: OfferPoiType.BUS, name: "Chełm - Więckowskiego 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Małomiejska", distance: 654},
        {type: OfferPoiType.BUS, name: "Chełm Witosa 01", distance: 680},
        {type: OfferPoiType.TRAM, name: "Chełm Witosa 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Chełm Witosa 02", distance: 718},
        {type: OfferPoiType.BUS, name: "Kopeckiego 02", distance: 730},
        {type: OfferPoiType.TRAM, name: "Chełm Witosa 02", distance: 752},
        {type: OfferPoiType.BUS, name: "Ptasia 02", distance: 803},
        {type: OfferPoiType.BUS, name: "Ptasia", distance: 807},
        {type: OfferPoiType.BUS, name: "Kopeckiego 01", distance: 811},
        {type: OfferPoiType.BUS, name: "Sikorskiego 04", distance: 819},
        {type: OfferPoiType.TRAM, name: "Sikorskiego", distance: 820},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1102},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1222},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Dolina Potoku Oruńskiego"', distance: 1721},
        {type: OfferPoiType.PARK, name: 'Skwer im. Danuty Siedzikówny "Inki"', distance: 1777},
        {type: OfferPoiType.PARK, name: "Park Schopenhauera", distance: 1844},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 1975},
        {type: OfferPoiType.PARK, name: "Park Oruński im. Emilii Hoene", distance: 2048}
    ],
    19613: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Augustów NŻ", distance: 244},
        {type: OfferPoiType.BUS, name: "Augustów - Bacewicz NŻ", distance: 448},
        {type: OfferPoiType.BUS, name: "Książąt Polskich - Zakładowa", distance: 663},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Czajkowskiego", distance: 734},
        {type: OfferPoiType.BUS, name: "Widzew Czajkowskiego", distance: 767},
        {type: OfferPoiType.BUS, name: "Zakładowa - Książąt Polskich", distance: 784},
        {type: OfferPoiType.BUS, name: "Augustów - Wujaka NŻ", distance: 817},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 852},
        {type: OfferPoiType.PARK, name: "Park na Janowie", distance: 1690},
        {type: OfferPoiType.PARK, name: "Park Źródła Olechówki", distance: 2030},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 2071},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 2272}
    ],
    19614: [
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 554},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 573},
        {type: OfferPoiType.BUS, name: "Kamykowa 01", distance: 611},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 643},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 768},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1327}
    ],
    19615: [
        {type: OfferPoiType.BUS, name: "Przebieg 01", distance: 131},
        {type: OfferPoiType.BUS, name: "Przebieg 02", distance: 267},
        {type: OfferPoiType.BUS, name: "Przebieg 52", distance: 270},
        {type: OfferPoiType.BUS, name: "Buławy 01", distance: 384},
        {type: OfferPoiType.BUS, name: "Gawędziarzy 51", distance: 423},
        {type: OfferPoiType.BUS, name: "Buławy 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Fiszera 52", distance: 501},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 08", distance: 543},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 06", distance: 637},
        {type: OfferPoiType.BUS, name: "Rembertów-Ratusz 02", distance: 671},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 2101}
    ],
    19616: [
        {type: OfferPoiType.BUS, name: "Podolszyn 01", distance: 396},
        {type: OfferPoiType.BUS, name: "Nowy Podolszyn 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Nowy Podolszyn 02", distance: 792}
    ],
    19618: [
        {type: OfferPoiType.BUS, name: "Buków 04", distance: 261},
        {type: OfferPoiType.BUS, name: "Buków 02", distance: 351},
        {type: OfferPoiType.BUS, name: "Buków 01", distance: 412},
        {type: OfferPoiType.BUS, name: "Buków 03", distance: 426},
        {type: OfferPoiType.BUS, name: "Dębowa 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Główna 01", distance: 733},
        {type: OfferPoiType.BUS, name: "Dębowa 02", distance: 769}
    ],
    19621: [
        {type: OfferPoiType.BUS, name: "Agatowa 02", distance: 220},
        {type: OfferPoiType.BUS, name: "Agatowa 01", distance: 255},
        {type: OfferPoiType.BUS, name: "Złocień 03", distance: 318},
        {type: OfferPoiType.BUS, name: "Złocień 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Złocień 02", distance: 433},
        {type: OfferPoiType.PARK, name: "Park Złocień", distance: 643},
        {type: OfferPoiType.BUS, name: "Magazynowa 01", distance: 806}
    ],
    19622: [
        {type: OfferPoiType.BUS, name: "Coopera 52", distance: 452},
        {type: OfferPoiType.BUS, name: "Coopera 51", distance: 454},
        {type: OfferPoiType.BUS, name: "Chrzanów 04", distance: 490},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 508},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Coopera-Przychodnia 51", distance: 655},
        {type: OfferPoiType.BUS, name: "Batalionów Chłopskich 53", distance: 666},
        {type: OfferPoiType.BUS, name: "Człuchowska 04", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 1316}
    ],
    19626: [
        {type: OfferPoiType.BUS, name: "Jeziorna", distance: 244},
        {type: OfferPoiType.LAS, name: "Leśny zakątek", distance: 478},
        {type: OfferPoiType.LAS, name: "Małpia Wyspa", distance: 1136}
    ],
    19627: [
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 82},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 108},
        {type: OfferPoiType.BUS, name: "Danusi 01", distance: 428},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Danusi 02", distance: 522},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 04", distance: 584},
        {type: OfferPoiType.BUS, name: "Wielkiego Dębu 01", distance: 589},
        {type: OfferPoiType.BUS, name: "Przydrożna 01", distance: 670},
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 699},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 715},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1516},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 2185}
    ],
    19629: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 179},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 376},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 393},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 452},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 498},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 619},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Ujeścisko 04", distance: 658},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 01", distance: 667},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 03", distance: 685},
        {type: OfferPoiType.BUS, name: "Ujeścisko 05", distance: 693},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 02", distance: 693},
        {type: OfferPoiType.BUS, name: "Ujeścisko 06", distance: 696},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Nowosądecka 01", distance: 777},
        {type: OfferPoiType.BUS, name: "Nowosądecka 02", distance: 785},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1869},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1944},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2432}
    ],
    19633: [
        {type: OfferPoiType.BUS, name: "Łady 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Łady 02", distance: 413},
        {type: OfferPoiType.BUS, name: "Figowa 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Jutrzenki 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Jutrzenki 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Łady-Szkoła 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Nowy Podolszyn 02", distance: 829}
    ],
    19634: [
        {type: OfferPoiType.BUS, name: "Ludwinów 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Ludwinów 02", distance: 254},
        {type: OfferPoiType.BUS, name: "Os. Podwawelskie", distance: 420},
        {type: OfferPoiType.BUS, name: "Os. Podwawelskie 01", distance: 471},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 747},
        {type: OfferPoiType.BUS, name: "Rondo Grunwaldzkie 03", distance: 779},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 838},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 938},
        {type: OfferPoiType.PARK, name: "skwer Zdrowia", distance: 1086},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Magiczny", distance: 1172},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1511},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1514},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1532},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 1650},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2109},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2268}
    ],
    19636: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej 01", distance: 327},
        {type: OfferPoiType.BUS, name: "Armii Krajowej 02", distance: 374},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 02", distance: 735},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 01", distance: 793},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1448},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1454},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1555},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1686},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1807},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1865},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1924},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2011}
    ],
    19638: [
        {type: OfferPoiType.BUS, name: "Dębowa Góra Tabelna", distance: 118},
        {type: OfferPoiType.TRAM, name: "Dębowa Góra Tabelna", distance: 119},
        {type: OfferPoiType.TRAM, name: "Dańdówka Cmentarz", distance: 277},
        {type: OfferPoiType.BUS, name: "Dębowa Góra Zakopiańska", distance: 409},
        {type: OfferPoiType.BUS, name: "Dańdówka Cmentarz", distance: 420},
        {type: OfferPoiType.BUS, name: "Dębowa Góra Lipowa", distance: 564},
        {type: OfferPoiType.BUS, name: "Dańdówka Wiadukt", distance: 588},
        {type: OfferPoiType.TRAM, name: "Dębowa Góra Zakopiańska", distance: 618},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 1985},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 2085},
        {type: OfferPoiType.PARK, name: "Park Harcerski", distance: 2384}
    ],
    19643: [{type: OfferPoiType.BUS, name: "Łukaszew Zjazdowa", distance: 645}],
    19644: [
        {type: OfferPoiType.KOLEJ, name: "Iwiny", distance: 592},
        {type: OfferPoiType.BUS, name: "Vivaldiego", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2125},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2472}
    ],
    19645: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Raków", distance: 489},
        {type: OfferPoiType.BUS, name: "WKD Raków 01", distance: 529},
        {type: OfferPoiType.BUS, name: "Łopuszańska 03", distance: 550},
        {type: OfferPoiType.BUS, name: "WKD Raków 02", distance: 562},
        {type: OfferPoiType.BUS, name: "WKD Raków 03", distance: 735},
        {type: OfferPoiType.BUS, name: "Łopuszańska 01", distance: 750},
        {type: OfferPoiType.BUS, name: "Łopuszańska 02", distance: 760},
        {type: OfferPoiType.BUS, name: "WKD Raków 04", distance: 768},
        {type: OfferPoiType.BUS, name: "Łopuszańska 04", distance: 818},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1605}
    ],
    19646: [
        {type: OfferPoiType.BUS, name: "Szczeblewskiego 01", distance: 167},
        {type: OfferPoiType.BUS, name: "Zespół Szkół Budowlanych", distance: 209},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół", distance: 213},
        {type: OfferPoiType.BUS, name: "Szczeblewskiego 02", distance: 221},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół 01", distance: 234},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół 02", distance: 260},
        {type: OfferPoiType.BUS, name: "Cylkowskiego 02", distance: 410},
        {type: OfferPoiType.BUS, name: "Cylkowskiego", distance: 457},
        {type: OfferPoiType.BUS, name: "Cylkowskiego 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Korczaka 02", distance: 689},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kępa Redłowska", distance: 1221},
        {type: OfferPoiType.PARK, name: "Skwer Arki Gdynia", distance: 1344},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1510},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 1585}
    ],
    19652: [
        {type: OfferPoiType.BUS, name: "Kantorowice 01", distance: 423},
        {type: OfferPoiType.BUS, name: "Kantorowice 02", distance: 424},
        {type: OfferPoiType.BUS, name: "Kantorowice 04", distance: 507},
        {type: OfferPoiType.BUS, name: "Niebyła 01", distance: 751},
        {type: OfferPoiType.BUS, name: "Niebyła 02", distance: 767},
        {type: OfferPoiType.PARK, name: "Park Zielony Jar Wandy", distance: 1718},
        {type: OfferPoiType.PARK, name: "Park Zakole", distance: 1734}
    ],
    19653: [
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 01", distance: 131},
        {type: OfferPoiType.BUS, name: "Tarczyn Lidl/Biedronka 01", distance: 253},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 01", distance: 469},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 02", distance: 523},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1663}
    ],
    19654: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Okęcie", distance: 453},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 04", distance: 525},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 593},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 639},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 777},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1687},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 2345},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 2468}
    ],
    19656: [
        {type: OfferPoiType.BUS, name: "Górna", distance: 316},
        {type: OfferPoiType.BUS, name: "Taylora / Żniwna", distance: 353},
        {type: OfferPoiType.BUS, name: "Żniwna", distance: 382},
        {type: OfferPoiType.BUS, name: "Domaszowska / Poleska", distance: 481},
        {type: OfferPoiType.BUS, name: "Domaszowska / Żniwna", distance: 511},
        {type: OfferPoiType.BUS, name: "Domaszowska / Górna", distance: 601},
        {type: OfferPoiType.BUS, name: "Żniwna / Domaszowska", distance: 673},
        {type: OfferPoiType.BUS, name: "Poleska", distance: 722},
        {type: OfferPoiType.PARK, name: "Park imienia Adolfa Dygasińskiego", distance: 1372},
        {type: OfferPoiType.PARK, name: "Skwer 50-lecia KSMu", distance: 1814},
        {type: OfferPoiType.PARK, name: "Sąsiedzki Skwer", distance: 1843},
        {type: OfferPoiType.PARK, name: "Skwer Adwokata Jerzego Zięby", distance: 1947},
        {type: OfferPoiType.PARK, name: "Skwer adwokata Świętosława Krawczyńskiego", distance: 2091},
        {type: OfferPoiType.PARK, name: "Dolina Silnicy", distance: 2126},
        {type: OfferPoiType.PARK, name: "Skwer Pszczoły", distance: 2192},
        {type: OfferPoiType.PARK, name: "Ogród Wolności", distance: 2222}
    ],
    19658: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 362},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 397},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 405},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 448},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 516},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 522},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 537},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 541},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 590},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 591},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 734},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1017},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1271},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2132}
    ],
    19659: [
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 105},
        {type: OfferPoiType.TRAM, name: "Rzebika 01", distance: 177},
        {type: OfferPoiType.BUS, name: "Szczecińska 02", distance: 178},
        {type: OfferPoiType.BUS, name: "Rzebika 04", distance: 203},
        {type: OfferPoiType.BUS, name: "Rzebika 03", distance: 208},
        {type: OfferPoiType.TRAM, name: "Rzebika 02", distance: 229},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 230},
        {type: OfferPoiType.BUS, name: "Rzebika 08", distance: 239},
        {type: OfferPoiType.BUS, name: "Szczecińska 01", distance: 276},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 299},
        {type: OfferPoiType.BUS, name: "Węglarska 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Mały Płaszów P+R 03", distance: 544},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R", distance: 637},
        {type: OfferPoiType.TRAM, name: "Mały Płaszów P+R 01", distance: 706},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 772},
        {type: OfferPoiType.TRAM, name: "Lipska 01", distance: 806},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 946},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1052},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1110},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1169},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1356}
    ],
    19660: [
        {type: OfferPoiType.BUS, name: "Aluzyjna 02", distance: 137},
        {type: OfferPoiType.BUS, name: "Aluzyjna 03", distance: 228},
        {type: OfferPoiType.BUS, name: "Aluzyjna 01", distance: 279},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 02", distance: 476},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 01", distance: 502},
        {type: OfferPoiType.BUS, name: "Dąbrówka Wiślana 02", distance: 507},
        {type: OfferPoiType.BUS, name: "Buków 04", distance: 617},
        {type: OfferPoiType.BUS, name: "Buków 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Dąbrówka Szlachecka 01", distance: 653},
        {type: OfferPoiType.BUS, name: "Buków 01", distance: 680},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 2319},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 2323}
    ],
    19661: [
        {type: OfferPoiType.BUS, name: "Świerzawska", distance: 672},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego n/ż", distance: 722},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 1825},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 1951},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2352}
    ],
    19662: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Mały Skręt", distance: 622},
        {type: OfferPoiType.BUS, name: "Łódzka - Mały Skręt", distance: 733},
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 821},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2191},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2454}
    ],
    19664: [
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – PKP", distance: 422},
        {type: OfferPoiType.BUS, name: "Bielany Stacja Kolejowa", distance: 458},
        {type: OfferPoiType.KOLEJ, name: "Bielany Wrocławskie", distance: 601},
        {type: OfferPoiType.BUS, name: "Bielany Wrocławskie – skrzyżowanie", distance: 687}
    ],
    19665: [
        {type: OfferPoiType.BUS, name: "Pustynna - Nowe Sady", distance: 543},
        {type: OfferPoiType.BUS, name: "Czahary", distance: 576},
        {type: OfferPoiType.BUS, name: "Nowe Sady - Pustynna", distance: 663},
        {type: OfferPoiType.BUS, name: "Obywatelska - Elektronowa NŻ", distance: 844},
        {type: OfferPoiType.PARK, name: "Skwer leśny przy Odrzańskiej", distance: 2204},
        {type: OfferPoiType.PARK, name: "Park Sielanka", distance: 2297},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Rejtana", distance: 2428}
    ],
    19670: [
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 02", distance: 79},
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 01", distance: 237},
        {type: OfferPoiType.TRAM, name: "Uczniowska", distance: 739},
        {type: OfferPoiType.BUS, name: "Uczniowska 02", distance: 744},
        {type: OfferPoiType.PARK, name: "Park księdza kanonika Kazimierza Orkusza", distance: 1171},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 1728},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 1870}
    ],
    19671: [
        {type: OfferPoiType.BUS, name: "Szpitalna", distance: 223},
        {type: OfferPoiType.BUS, name: "Topazowa", distance: 310},
        {type: OfferPoiType.BUS, name: "Ametystowa NŻ", distance: 344},
        {type: OfferPoiType.PARK, name: "Zielone korytarze miejske - Os. Diamentowe", distance: 413},
        {type: OfferPoiType.BUS, name: "Szpital", distance: 420},
        {type: OfferPoiType.BUS, name: "Piłsudskiego", distance: 554},
        {type: OfferPoiType.BUS, name: "Dom Seniora", distance: 576},
        {type: OfferPoiType.PARK, name: "Sad Miejski", distance: 887},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Jasiukowicza", distance: 2455}
    ],
    19672: [
        {type: OfferPoiType.BUS, name: "Runowska 02", distance: 163},
        {type: OfferPoiType.BUS, name: "Runowska 01", distance: 189},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Hilarego Rostworowskiego", distance: 216},
        {type: OfferPoiType.BUS, name: "Fogga 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Fogga 02", distance: 239},
        {type: OfferPoiType.BUS, name: "Złotokłos 02", distance: 323},
        {type: OfferPoiType.BUS, name: "Wojewódzka 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Wojewódzka 01", distance: 553},
        {type: OfferPoiType.BUS, name: "Szczaki 01", distance: 771},
        {type: OfferPoiType.PARK, name: "Skwer", distance: 803},
        {type: OfferPoiType.BUS, name: "Szczaki 02", distance: 803},
        {type: OfferPoiType.PARK, name: "Park Nad stawem", distance: 1089},
        {type: OfferPoiType.PARK, name: "Park Przy kolejce", distance: 1292}
    ],
    19674: [
        {type: OfferPoiType.BUS, name: "Psary – Parkowa", distance: 109},
        {type: OfferPoiType.BUS, name: "Psary – Wiadukt", distance: 407},
        {type: OfferPoiType.BUS, name: "Psary – Szkoła", distance: 658},
        {type: OfferPoiType.BUS, name: "Psary – Wolności", distance: 842},
        {type: OfferPoiType.PARK, name: "Park w Szymanowie", distance: 2060},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 2143}
    ],
    19678: [
        {type: OfferPoiType.BUS, name: "Rembertów-Akademia 01", distance: 122},
        {type: OfferPoiType.BUS, name: "Rembertów-Akademia 02", distance: 170},
        {type: OfferPoiType.BUS, name: "Rembertów-Akademia 04", distance: 204},
        {type: OfferPoiType.BUS, name: "Jerzego 01", distance: 341},
        {type: OfferPoiType.BUS, name: "Jerzego 02", distance: 451},
        {type: OfferPoiType.BUS, name: "Emilii Gierczak 01", distance: 542},
        {type: OfferPoiType.BUS, name: "Topograficzna 02", distance: 552},
        {type: OfferPoiType.BUS, name: "Emilii Gierczak 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Topograficzna 01", distance: 654},
        {type: OfferPoiType.BUS, name: "Eskulapów 01", distance: 713},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 2381}
    ],
    19679: [
        {type: OfferPoiType.TRAM, name: "Stare Zoo", distance: 154},
        {type: OfferPoiType.TRAM, name: "Kraszewskiego", distance: 234},
        {type: OfferPoiType.BUS, name: "Kraszewskiego", distance: 304},
        {type: OfferPoiType.BUS, name: "Rondo Kaponiera", distance: 314},
        {type: OfferPoiType.BUS, name: "Szylinga", distance: 516},
        {type: OfferPoiType.TRAM, name: "Rondo Kaponiera", distance: 525},
        {type: OfferPoiType.BUS, name: "Rynek Jeżycki", distance: 535},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 535},
        {type: OfferPoiType.TRAM, name: "Bałtyk", distance: 538},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 954},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 961},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 996},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1037},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1092},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 1280},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1380},
        {type: OfferPoiType.PARK, name: "Park Thomasa Woodrowa Wilsona", distance: 1400},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1605},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 1766},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 2108}
    ],
    19681: [
        {type: OfferPoiType.BUS, name: "Brętowo PKM 04", distance: 248},
        {type: OfferPoiType.BUS, name: "Kolumba 04", distance: 356},
        {type: OfferPoiType.TRAM, name: "Kolumba 02", distance: 356},
        {type: OfferPoiType.TRAM, name: "Kolumba 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Kolumba 03", distance: 397},
        {type: OfferPoiType.BUS, name: "Brętowo PKM 03", distance: 422},
        {type: OfferPoiType.TRAM, name: "Brętowo PKM 01", distance: 583},
        {type: OfferPoiType.BUS, name: "Dolne Młyny 01", distance: 610},
        {type: OfferPoiType.TRAM, name: "Brętowo PKM 05", distance: 653},
        {type: OfferPoiType.BUS, name: "Dolne Młyny 02", distance: 675},
        {type: OfferPoiType.TRAM, name: "Brętowo PKM 02", distance: 724},
        {type: OfferPoiType.BUS, name: "Ogrodowa 02", distance: 796},
        {type: OfferPoiType.PARK, name: "Skwer Joachima Gudela", distance: 950},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 1234},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 1361},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1927},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 2117},
        {type: OfferPoiType.PARK, name: "Jaśkowy Zakątek", distance: 2125}
    ],
    19684: [
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 676},
        {type: OfferPoiType.BUS, name: "Węzłowiec Pętla", distance: 714},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1768},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 1887},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 2037}
    ],
    19685: [
        {type: OfferPoiType.BUS, name: "Dobrzykowice – przejazd", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Kamieniecki", distance: 1297}
    ],
    19686: [
        {type: OfferPoiType.BUS, name: "Błonie Olymp", distance: 456},
        {type: OfferPoiType.BUS, name: "Błonie Polna", distance: 641},
        {type: OfferPoiType.BUS, name: "Błonie Batalionów Chłopskich", distance: 653},
        {type: OfferPoiType.BUS, name: "Błonie Sochaczewska", distance: 794},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 1337},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 1556},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 1682}
    ],
    19688: [
        {type: OfferPoiType.BUS, name: "Lebiodowa 01", distance: 625},
        {type: OfferPoiType.BUS, name: "Lebiodowa 02", distance: 669},
        {type: OfferPoiType.BUS, name: "Kombajnistów 01", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Aktywności Rodzinnej", distance: 1448}
    ],
    19689: [
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Bursztynowa Góra", distance: 1412},
        {type: OfferPoiType.LAS, name: "Jankowski las", distance: 1916}
    ],
    19690: [
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 372},
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 571},
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 572},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 593},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2287}
    ],
    19693: [
        {type: OfferPoiType.BUS, name: "Biedrusko/Park", distance: 222},
        {type: OfferPoiType.BUS, name: "Biedrusko/Jednostka Wojskowa", distance: 486}
    ],
    19704: [
        {type: OfferPoiType.BUS, name: "Złotno - Stare Złotno NŻ", distance: 511},
        {type: OfferPoiType.PARK, name: "Metalowe namioty", distance: 1855},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 2166},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Pole”", distance: 2383}
    ],
    19705: [
        {type: OfferPoiType.BUS, name: "Cmentarz 01", distance: 548},
        {type: OfferPoiType.BUS, name: "Cmentarz 02", distance: 550},
        {type: OfferPoiType.BUS, name: "Zycha", distance: 586},
        {type: OfferPoiType.BUS, name: "Szwoleżerów 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Szwoleżerów 02", distance: 758},
        {type: OfferPoiType.BUS, name: "Warszawska 01", distance: 782},
        {type: OfferPoiType.BUS, name: "Warszawska 02", distance: 816},
        {type: OfferPoiType.PARK, name: "Park imienia Michała Szuberta", distance: 1808}
    ],
    19712: [
        {type: OfferPoiType.BUS, name: "Bartnicza 02", distance: 373},
        {type: OfferPoiType.BUS, name: "Bartnicza 01", distance: 452},
        {type: OfferPoiType.BUS, name: "Bartnicza 04", distance: 486},
        {type: OfferPoiType.BUS, name: "Bazyliańska 01", distance: 540},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 544},
        {type: OfferPoiType.BUS, name: "Bazyliańska 04", distance: 684},
        {type: OfferPoiType.BUS, name: "Bazyliańska 03", distance: 695},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 886},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 1449},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1531}
    ],
    19713: [
        {type: OfferPoiType.TRAM, name: "Stolema", distance: 423},
        {type: OfferPoiType.BUS, name: "Lipowa", distance: 431},
        {type: OfferPoiType.BUS, name: "Stolema", distance: 434},
        {type: OfferPoiType.BUS, name: "Myśliwska", distance: 537},
        {type: OfferPoiType.BUS, name: "Migdałowa 02", distance: 704},
        {type: OfferPoiType.BUS, name: "Migdałowa 01", distance: 721},
        {type: OfferPoiType.BUS, name: "Zabornia 05", distance: 729},
        {type: OfferPoiType.TRAM, name: "Zabornia 02", distance: 824},
        {type: OfferPoiType.PARK, name: "Multipark Morena", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park im. ks. Bronisława Kabata", distance: 1586},
        {type: OfferPoiType.REZERWAT, name: 'Przepompownia Wody "Migowo"', distance: 1947},
        {type: OfferPoiType.PARK, name: "Lasek Buloński", distance: 1955},
        {type: OfferPoiType.PARK, name: 'Lasek "Belgradzka"', distance: 2243}
    ],
    19714: [
        {type: OfferPoiType.BUS, name: "Gaj", distance: 310},
        {type: OfferPoiType.TRAM, name: "Gaj", distance: 323},
        {type: OfferPoiType.BUS, name: "Działkowa", distance: 563},
        {type: OfferPoiType.BUS, name: "Orzechowa", distance: 652},
        {type: OfferPoiType.TRAM, name: "Świeradowska", distance: 686},
        {type: OfferPoiType.BUS, name: "Świeradowska", distance: 709},
        {type: OfferPoiType.BUS, name: "ROD Bajki", distance: 786},
        {type: OfferPoiType.PARK, name: "Park Skowroni", distance: 1180},
        {type: OfferPoiType.PARK, name: "skwer Władysława Stasiaka", distance: 1420},
        {type: OfferPoiType.PARK, name: "Park Generała Władysława Andersa", distance: 1696}
    ],
    19716: [
        {type: OfferPoiType.BUS, name: "Lodowisko 02", distance: 233},
        {type: OfferPoiType.BUS, name: "Lodowisko 01", distance: 254},
        {type: OfferPoiType.BUS, name: "Podwale 01", distance: 374},
        {type: OfferPoiType.BUS, name: "Osiedle Robotnicze 02", distance: 448},
        {type: OfferPoiType.BUS, name: "Podwale 02", distance: 502},
        {type: OfferPoiType.BUS, name: "Bankowa 02", distance: 506},
        {type: OfferPoiType.BUS, name: "Osiedle Robotnicze 01", distance: 550},
        {type: OfferPoiType.BUS, name: "Bankowa 01", distance: 558},
        {type: OfferPoiType.BUS, name: "Stanowisko 1", distance: 625},
        {type: OfferPoiType.BUS, name: "Stanowisko 2", distance: 633},
        {type: OfferPoiType.PARK, name: "Wzgórze Kościuszki", distance: 1750},
        {type: OfferPoiType.PARK, name: "Park im. J. Ziżki", distance: 1853}
    ],
    19717: [
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Wschodnia", distance: 312},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Pomorska", distance: 407},
        {type: OfferPoiType.TRAM, name: "Pomorska - Kilińskiego", distance: 419},
        {type: OfferPoiType.BUS, name: "Północna - Nowomiejska", distance: 421},
        {type: OfferPoiType.BUS, name: "Próchnika - Piotrkowska", distance: 436},
        {type: OfferPoiType.TRAM, name: "Północna - Nowomiejska", distance: 462},
        {type: OfferPoiType.TRAM, name: "Zachodnia - Legionów", distance: 469},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 475},
        {type: OfferPoiType.BUS, name: "Ogrodowa - Nowomiejska", distance: 480},
        {type: OfferPoiType.TRAM, name: "Ogrodowa - Nowomiejska", distance: 480},
        {type: OfferPoiType.TRAM, name: "Północna", distance: 485},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego", distance: 511},
        {type: OfferPoiType.BUS, name: "Zachodnia - Legionów", distance: 518},
        {type: OfferPoiType.BUS, name: "Północna - Kilińskiego NŻ", distance: 522},
        {type: OfferPoiType.BUS, name: "Nowomiejska - Północna", distance: 526},
        {type: OfferPoiType.TRAM, name: "Legionów - Zachodnia", distance: 528},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 545},
        {type: OfferPoiType.TRAM, name: "Północna - Kilińskiego", distance: 551},
        {type: OfferPoiType.BUS, name: "Łódzka Inf. Turystyczna", distance: 556},
        {type: OfferPoiType.BUS, name: "Rewolucji 1905r. - Kilińskiego", distance: 573},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 792},
        {type: OfferPoiType.PARK, name: "Skwer Romana Kłosowskiego", distance: 904},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 1177},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1188}
    ],
    19718: [
        {type: OfferPoiType.BUS, name: "Rudzka - Farna", distance: 135},
        {type: OfferPoiType.BUS, name: "Farna - Plażowa NŻ", distance: 178},
        {type: OfferPoiType.BUS, name: "Rudzka - Przestrzenna", distance: 250},
        {type: OfferPoiType.BUS, name: "Rudzka - Popioły", distance: 267},
        {type: OfferPoiType.BUS, name: "Przestrzenna - Rudzka", distance: 303},
        {type: OfferPoiType.BUS, name: "Przestrzenna - Sławna NŻ", distance: 572},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 798},
        {type: OfferPoiType.PARK, name: "Rudzka Góra", distance: 1211},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy „Ruda Willowa”", distance: 1335},
        {type: OfferPoiType.LAS, name: "Las Popioły", distance: 1350},
        {type: OfferPoiType.PARK, name: "Skwer leśny przy Odrzańskiej", distance: 2169}
    ],
    19722: [{type: OfferPoiType.PARK, name: "Staw Mysiadło", distance: 1154}],
    19724: [
        {type: OfferPoiType.BUS, name: "Instytut Lotnictwa 02", distance: 254},
        {type: OfferPoiType.TRAM, name: "Instytut Lotnictwa 04", distance: 329},
        {type: OfferPoiType.TRAM, name: "Instytut Lotnictwa 03", distance: 369},
        {type: OfferPoiType.BUS, name: "Instytut Lotnictwa 01", distance: 431},
        {type: OfferPoiType.TRAM, name: "Lipowczana 01", distance: 618},
        {type: OfferPoiType.TRAM, name: "Lipowczana 02", distance: 620},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 04", distance: 732},
        {type: OfferPoiType.BUS, name: "P+R Aleja Krakowska 06", distance: 737},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 01", distance: 771},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 02", distance: 780},
        {type: OfferPoiType.TRAM, name: "P+R Aleja Krakowska 03", distance: 787}
    ],
    19726: [
        {type: OfferPoiType.TRAM, name: "Postępu 04", distance: 316},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 04", distance: 347},
        {type: OfferPoiType.BUS, name: "Domaniewska 01", distance: 362},
        {type: OfferPoiType.TRAM, name: "Postępu 03", distance: 385},
        {type: OfferPoiType.TRAM, name: "Rondo Unii Europejskiej 03", distance: 390},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 02", distance: 432},
        {type: OfferPoiType.TRAM, name: "Domaniewska 04", distance: 435},
        {type: OfferPoiType.TRAM, name: "Domaniewska 03", distance: 460},
        {type: OfferPoiType.BUS, name: "Rondo Unii Europejskiej 06", distance: 461},
        {type: OfferPoiType.BUS, name: "Domaniewska 06", distance: 470},
        {type: OfferPoiType.BUS, name: "Postępu 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Domaniewska 05", distance: 495},
        {type: OfferPoiType.BUS, name: "Park Postępu 01", distance: 520},
        {type: OfferPoiType.BUS, name: "Postępu 01", distance: 546},
        {type: OfferPoiType.BUS, name: "Domaniewska 02", distance: 548},
        {type: OfferPoiType.TRAM, name: "Wynalazek 01", distance: 556},
        {type: OfferPoiType.BUS, name: "Wynalazek 03", distance: 588},
        {type: OfferPoiType.TRAM, name: "Wynalazek 02", distance: 592},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 03", distance: 738},
        {type: OfferPoiType.TRAM, name: "Konstruktorska 04", distance: 775},
        {type: OfferPoiType.PARK, name: 'Park linearny "Suwak"', distance: 1509},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1560}
    ],
    19728: [
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Białołęka 01", distance: 339},
        {type: OfferPoiType.BUS, name: "Areszt Śledczy Białołęka 02", distance: 348},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 02", distance: 450},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 01", distance: 464},
        {type: OfferPoiType.BUS, name: "Białołęka Dworska 01", distance: 677},
        {type: OfferPoiType.BUS, name: "Białołęka Dworska 02", distance: 817}
    ],
    19733: [
        {type: OfferPoiType.BUS, name: "Mańkowska 01", distance: 288},
        {type: OfferPoiType.BUS, name: "Mańkowska 02", distance: 334},
        {type: OfferPoiType.PARK, name: "Plac Bociani Zakątek", distance: 357},
        {type: OfferPoiType.BUS, name: "Tymotki 02", distance: 386},
        {type: OfferPoiType.BUS, name: "Tymotki 01", distance: 532},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 02", distance: 596},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 03", distance: 687},
        {type: OfferPoiType.BUS, name: "Jarzębinowa 01", distance: 698},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 01", distance: 808},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 03", distance: 811},
        {type: OfferPoiType.BUS, name: "Os. Zielona Dolina 02", distance: 834}
    ],
    19737: [
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła", distance: 609},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań", distance: 621},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 04", distance: 623},
        {type: OfferPoiType.BUS, name: "Mechelinki - Przystań 02", distance: 640},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 01", distance: 646},
        {type: OfferPoiType.BUS, name: "Mosty - Wiązowa 01 (NŻ)", distance: 649},
        {type: OfferPoiType.BUS, name: "Mosty - Szkoła 02", distance: 652},
        {type: OfferPoiType.BUS, name: "Mosty - Wiązowa 02 (NŻ)", distance: 699},
        {type: OfferPoiType.BUS, name: "Mosty - Ogrodowa", distance: 765},
        {type: OfferPoiType.BUS, name: "Mosty - Ogrodowa 03", distance: 773}
    ],
    19739: [
        {type: OfferPoiType.BUS, name: "Śniechowskiego (rondo)", distance: 176},
        {type: OfferPoiType.BUS, name: "Konstantynowska (rondo)", distance: 205},
        {type: OfferPoiType.BUS, name: "Śniechowskiego/Łódzka", distance: 332},
        {type: OfferPoiType.BUS, name: "Konstantynowska/Sokołowska", distance: 447},
        {type: OfferPoiType.BUS, name: "Ks. Popiełuszki/Łódzka", distance: 534},
        {type: OfferPoiType.BUS, name: "Barona/Konstantynowska", distance: 623},
        {type: OfferPoiType.PARK, name: "Skwer Istvána Almásiego", distance: 1115},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Tadeusza Kościuszki", distance: 1177},
        {type: OfferPoiType.PARK, name: "Skwer 35 lat Samorządności", distance: 1345},
        {type: OfferPoiType.PARK, name: "Oko Tuwima", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer im. Adama Mickiewicza", distance: 1933}
    ],
    19744: [
        {type: OfferPoiType.BUS, name: "Szczecińska 02", distance: 98},
        {type: OfferPoiType.BUS, name: "Szczecińska 01", distance: 124},
        {type: OfferPoiType.BUS, name: "Rzebika 06", distance: 224},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 01", distance: 301},
        {type: OfferPoiType.BUS, name: "Rzebika 03", distance: 318},
        {type: OfferPoiType.TRAM, name: "Rzebika 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Os. Przewóz 02", distance: 384},
        {type: OfferPoiType.TRAM, name: "Rzebika 01", distance: 385},
        {type: OfferPoiType.BUS, name: "Rzebika 04", distance: 411},
        {type: OfferPoiType.BUS, name: "Rzebika 08", distance: 417},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 01", distance: 429},
        {type: OfferPoiType.BUS, name: "Myśliwska Szkoła 02", distance: 437},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 789},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 841},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 1042},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1246},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 1332},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1371}
    ],
    19754: [
        {type: OfferPoiType.BUS, name: "Szczyrk Centrum", distance: 407},
        {type: OfferPoiType.BUS, name: "Szczyrk Nowy Kościół", distance: 551},
        {type: OfferPoiType.BUS, name: "Szczyrk Beskidek", distance: 819},
        {type: OfferPoiType.BUS, name: "Szczyrk Skocznia", distance: 827}
    ],
    19755: [
        {type: OfferPoiType.BUS, name: "Banacha 04", distance: 138},
        {type: OfferPoiType.BUS, name: "Banacha 02", distance: 221},
        {type: OfferPoiType.BUS, name: "Banacha 01", distance: 257},
        {type: OfferPoiType.BUS, name: "Banacha 03", distance: 281},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 326},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 348},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 356},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 392},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 406},
        {type: OfferPoiType.BUS, name: "Os. Gotyk 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Górka Narodowa P+R 02", distance: 540},
        {type: OfferPoiType.BUS, name: "ks. Meiera 01", distance: 637},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R 01", distance: 771},
        {type: OfferPoiType.TRAM, name: "Górka Narodowa P+R", distance: 822},
        {type: OfferPoiType.TRAM, name: "Kuźnicy Kołłątajowskiej 01", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1757},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1800},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2121},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 2150}
    ],
    19760: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Park 03", distance: 170},
        {type: OfferPoiType.BUS, name: "Lubelska/Urząd Miasta 01", distance: 237},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Ogrodowa 04", distance: 299},
        {type: OfferPoiType.BUS, name: "Lubelska/Park 02", distance: 341},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 368},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Wiadukt 06", distance: 395},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Wiadukt 05", distance: 412},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Ogrodowa 01", distance: 435},
        {type: OfferPoiType.PARK, name: "Skwer Mickiewicza", distance: 463},
        {type: OfferPoiType.BUS, name: "Plac Gdański 01", distance: 471},
        {type: OfferPoiType.BUS, name: "10", distance: 582},
        {type: OfferPoiType.BUS, name: "09", distance: 582},
        {type: OfferPoiType.PARK, name: "Plac Kościuszki", distance: 611},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1204},
        {type: OfferPoiType.PARK, name: "Park XXX-lecia", distance: 1499}
    ],
    19765: [
        {type: OfferPoiType.BUS, name: "Marsa", distance: 138},
        {type: OfferPoiType.PARK, name: "Park Diany", distance: 293},
        {type: OfferPoiType.BUS, name: "Jednorożca", distance: 366},
        {type: OfferPoiType.PARK, name: "Zieleniec Orfeusza", distance: 571},
        {type: OfferPoiType.BUS, name: "Koziorożca", distance: 656},
        {type: OfferPoiType.BUS, name: "Wodnika 02", distance: 715},
        {type: OfferPoiType.BUS, name: "Wodnika 01", distance: 754},
        {type: OfferPoiType.BUS, name: "Owczarnia 03", distance: 811},
        {type: OfferPoiType.BUS, name: "Sołdka 01", distance: 821},
        {type: OfferPoiType.PARK, name: "Park Chirona", distance: 1528},
        {type: OfferPoiType.PARK, name: "Zieleniec Parterowa", distance: 2097}
    ],
    19767: [
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Struga", distance: 315},
        {type: OfferPoiType.TRAM, name: "Limanowskiego - Piwna", distance: 480},
        {type: OfferPoiType.TRAM, name: "Zgierska - Adwokacka", distance: 545},
        {type: OfferPoiType.BUS, name: "Zgierska - Dolna", distance: 614},
        {type: OfferPoiType.TRAM, name: "Zgierska - Dolna", distance: 615},
        {type: OfferPoiType.BUS, name: "Zgierska - Sędziowska", distance: 623},
        {type: OfferPoiType.BUS, name: "Limanowskiego - Sierakowskiego", distance: 677},
        {type: OfferPoiType.TRAM, name: "Limanowskiego - Sierakowskiego", distance: 693},
        {type: OfferPoiType.BUS, name: "Zgierska - Julianowska", distance: 788},
        {type: OfferPoiType.PARK, name: "Skwer Króla Władysława Jagiełły", distance: 1002},
        {type: OfferPoiType.PARK, name: "Plac Piastowski", distance: 1166},
        {type: OfferPoiType.PARK, name: "Park przy ul. Hipotecznej", distance: 1310},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 1341},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Kalinowej", distance: 1609},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 1901}
    ],
    19769: [
        {type: OfferPoiType.BUS, name: "Platynowa 03", distance: 310},
        {type: OfferPoiType.BUS, name: "Krzemowa 01", distance: 332},
        {type: OfferPoiType.BUS, name: "Orunia Górna 01", distance: 389},
        {type: OfferPoiType.BUS, name: "Platynowa 01", distance: 410},
        {type: OfferPoiType.BUS, name: "Platynowa 04", distance: 475},
        {type: OfferPoiType.BUS, name: "Platynowa 02", distance: 480},
        {type: OfferPoiType.BUS, name: "Uranowa 01", distance: 613},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Dolina Potoku Oruńskiego"', distance: 672},
        {type: OfferPoiType.BUS, name: "Małomiejska", distance: 757},
        {type: OfferPoiType.BUS, name: "Świętokrzyska 01", distance: 766},
        {type: OfferPoiType.BUS, name: "Wawelska 02", distance: 779},
        {type: OfferPoiType.TRAM, name: "Łostowice Świętokrzyska 02", distance: 831},
        {type: OfferPoiType.PARK, name: "Park Oruński im. Emilii Hoene", distance: 1136},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1525},
        {type: OfferPoiType.PARK, name: 'Skwer im. Danuty Siedzikówny "Inki"', distance: 1746},
        {type: OfferPoiType.PARK, name: "Park Schopenhauera", distance: 1777}
    ],
    19770: [
        {type: OfferPoiType.BUS, name: "Cmentarz Bronowice 01", distance: 403},
        {type: OfferPoiType.BUS, name: "Cmentarz Bronowice 02", distance: 441},
        {type: OfferPoiType.BUS, name: "Pasternik 03", distance: 567},
        {type: OfferPoiType.BUS, name: "Pasternik 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Pasternik 02", distance: 739},
        {type: OfferPoiType.BUS, name: "Park Tetmajera 01", distance: 752},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1455},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1862},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko Podgołogórze", distance: 1987},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko w Rząsce", distance: 2419}
    ],
    19774: [
        {type: OfferPoiType.BUS, name: "Prokocim UJ 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Prokocim UJ 02", distance: 335},
        {type: OfferPoiType.BUS, name: "Wydział Farmaceutyczny UJ 01", distance: 492},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 1040},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1712},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1719},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1723},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1879},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1968},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1985},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 2300},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 2479}
    ],
    19777: [
        {type: OfferPoiType.BUS, name: "Zaułek Dworcowy nż. 02", distance: 167},
        {type: OfferPoiType.BUS, name: "Zaułek Dworcowy nż. 01", distance: 309},
        {type: OfferPoiType.BUS, name: "Urząd Celny nż. 02", distance: 445},
        {type: OfferPoiType.TRAM, name: "Szpital Miejski 01", distance: 472},
        {type: OfferPoiType.TRAM, name: "Szpital Miejski 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Urząd Celny nż. 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Fabryczna nż. 02", distance: 607},
        {type: OfferPoiType.BUS, name: "Świętopełka 02", distance: 655},
        {type: OfferPoiType.BUS, name: "Młyn Wiedzy nż. 01", distance: 659},
        {type: OfferPoiType.BUS, name: "Młyn Wiedzy nż. 02", distance: 669},
        {type: OfferPoiType.BUS, name: "Fabryczna nż. 01", distance: 731},
        {type: OfferPoiType.TRAM, name: "Świętopełka 04", distance: 735},
        {type: OfferPoiType.TRAM, name: "Świętopełka 03", distance: 745},
        {type: OfferPoiType.BUS, name: "Świętopełka 01", distance: 752},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 1581},
        {type: OfferPoiType.PARK, name: "Glazja", distance: 2202},
        {type: OfferPoiType.PARK, name: "Park Pamięci", distance: 2277}
    ],
    19778: [
        {type: OfferPoiType.TRAM, name: "Wschodnia 01", distance: 101},
        {type: OfferPoiType.TRAM, name: "Wschodnia 02", distance: 157},
        {type: OfferPoiType.BUS, name: "Wschodnia 04", distance: 263},
        {type: OfferPoiType.BUS, name: "Wschodnia 03", distance: 263},
        {type: OfferPoiType.TRAM, name: "Wschodnia (pętla) 01", distance: 284},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 06", distance: 628},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 03", distance: 685},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 05", distance: 796},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 04", distance: 807},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 02", distance: 810},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 08", distance: 820},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 1726},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 2016}
    ],
    19779: [
        {type: OfferPoiType.TRAM, name: "Paska", distance: 142},
        {type: OfferPoiType.TRAM, name: "Ciasna", distance: 321},
        {type: OfferPoiType.PARK, name: "Skwer im. Ignacego Wilczewskiego", distance: 324},
        {type: OfferPoiType.BUS, name: "Tarasy (Bema)", distance: 332},
        {type: OfferPoiType.PARK, name: "Park Generała Józefa Bema", distance: 550},
        {type: OfferPoiType.TRAM, name: "Pohulanka", distance: 587},
        {type: OfferPoiType.TRAM, name: "Powstańców Warszawskich", distance: 600},
        {type: OfferPoiType.BUS, name: "Pohulanka 04", distance: 683},
        {type: OfferPoiType.TRAM, name: "Zakopiańska", distance: 697},
        {type: OfferPoiType.BUS, name: "Pohulanka", distance: 704},
        {type: OfferPoiType.BUS, name: "Hevelianum 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Zakopiańska", distance: 741},
        {type: OfferPoiType.BUS, name: "Urząd Miejski 02", distance: 778},
        {type: OfferPoiType.BUS, name: "Hevelianum 02", distance: 800},
        {type: OfferPoiType.PARK, name: "Placyk rekreacyjny im. Jacka Malczewskiego", distance: 885},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 1046},
        {type: OfferPoiType.PARK, name: "Park poforteczny „Grodzisko”", distance: 1193},
        {type: OfferPoiType.PARK, name: "Skwer im. Polskich Harcerzy w byłym Wolnym Mieście Gdańsku", distance: 1199},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1210},
        {type: OfferPoiType.PARK, name: "Skwer Czesława Niemena", distance: 1214},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 1497},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 1629}
    ],
    19781: [
        {type: OfferPoiType.BUS, name: "Grota-Roweckiego", distance: 818},
        {type: OfferPoiType.PARK, name: "park Generała Tadeusza Rozwadowskiego", distance: 1695},
        {type: OfferPoiType.PARK, name: "park Wojszyce", distance: 2322}
    ],
    19782: [
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 01", distance: 524},
        {type: OfferPoiType.BUS, name: "Baniocha - Marki 02", distance: 562}
    ],
    19783: [
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 01", distance: 152},
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 02", distance: 216},
        {type: OfferPoiType.BUS, name: "Królika 02", distance: 727},
        {type: OfferPoiType.BUS, name: "Starochylicka 01", distance: 765},
        {type: OfferPoiType.BUS, name: "Królika 01", distance: 793}
    ],
    19784: [
        {type: OfferPoiType.BUS, name: "Granata 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Granata 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Elektromontaż 01", distance: 460},
        {type: OfferPoiType.BUS, name: "Elektromontaż 03", distance: 579},
        {type: OfferPoiType.BUS, name: "Elektromontaż 02", distance: 599},
        {type: OfferPoiType.BUS, name: "Domeyki 01", distance: 718}
    ],
    19785: [
        {type: OfferPoiType.PARK, name: "Skwer Wacława Żebrowskiego", distance: 366},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Śliza", distance: 712},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 1082},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Domańskiej", distance: 1228},
        {type: OfferPoiType.PARK, name: "Skwer Anny Krzywańskiej", distance: 1240},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Dunajewskiego", distance: 1782}
    ],
    19786: [
        {type: OfferPoiType.BUS, name: "ul. Brzozowa", distance: 766},
        {type: OfferPoiType.LAS, name: "Park Staromiejski", distance: 1026},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1026},
        {type: OfferPoiType.PARK, name: "Skwer doktor Teresy Bielesz-Gniedziejko", distance: 1939}
    ],
    19787: [
        {type: OfferPoiType.BUS, name: "ul. Brzozowa", distance: 820},
        {type: OfferPoiType.LAS, name: "Park Staromiejski", distance: 1080},
        {type: OfferPoiType.PARK, name: "Park Staromiejski", distance: 1080},
        {type: OfferPoiType.PARK, name: "Skwer doktor Teresy Bielesz-Gniedziejko", distance: 1993}
    ],
    19791: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 107},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 110},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 125},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 255},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 348},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 492},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 513},
        {type: OfferPoiType.BUS, name: "Żupnicza 01", distance: 575},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 586},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 983},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1236},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1374},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1531},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1591},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1908},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2050},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2073},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2079}
    ],
    19792: [
        {type: OfferPoiType.BUS, name: "Cylkowskiego 01", distance: 320},
        {type: OfferPoiType.BUS, name: "Cylkowskiego", distance: 347},
        {type: OfferPoiType.BUS, name: "Cylkowskiego 02", distance: 394},
        {type: OfferPoiType.BUS, name: "Płyta Redłowska", distance: 478},
        {type: OfferPoiType.BUS, name: "Płyta Redłowska 04", distance: 492},
        {type: OfferPoiType.BUS, name: "Płyta Redłowska 02", distance: 494},
        {type: OfferPoiType.BUS, name: "Korczaka 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Korczaka", distance: 549},
        {type: OfferPoiType.BUS, name: "Ruchu Oporu", distance: 555},
        {type: OfferPoiType.BUS, name: "Kopernika - Kościół 01", distance: 569},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kępa Redłowska", distance: 1111},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 2080}
    ],
    19800: [
        {type: OfferPoiType.BUS, name: "Bronowice Wielkie 01", distance: 750},
        {type: OfferPoiType.BUS, name: "Bronowice Wielkie 02", distance: 768},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1728},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko w Rząsce", distance: 2233},
        {type: OfferPoiType.REZERWAT, name: "Uroczysko Podgołogórze", distance: 2488}
    ],
    19801: [
        {type: OfferPoiType.BUS, name: "Urząd Wojewódzki / Marszałkowski", distance: 205},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 02", distance: 349},
        {type: OfferPoiType.BUS, name: "Muzeum Narodowe 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Brama Nizinna", distance: 395},
        {type: OfferPoiType.BUS, name: "Toruńska 02", distance: 468},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 489},
        {type: OfferPoiType.BUS, name: "Toruńska 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Zaroślak 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Zaroślak 02", distance: 564},
        {type: OfferPoiType.TRAM, name: "Żabi Kruk", distance: 633},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Śródmieście", distance: 735},
        {type: OfferPoiType.TRAM, name: "Okopowa", distance: 752},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Salwator", distance: 1044},
        {type: OfferPoiType.PARK, name: "Skwer im. Polskich Harcerzy w byłym Wolnym Mieście Gdańsku", distance: 1202},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1249},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2115},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2227},
        {type: OfferPoiType.REZERWAT, name: "Luneta z Pasikonikiem", distance: 2260}
    ],
    19802: [
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 01", distance: 187},
        {type: OfferPoiType.BUS, name: "Jana Heweliusza 02", distance: 198},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 03", distance: 288},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 02", distance: 394},
        {type: OfferPoiType.BUS, name: "Szeligowska-Szkoła 01", distance: 477},
        {type: OfferPoiType.BUS, name: "Chrzanów 01", distance: 772},
        {type: OfferPoiType.BUS, name: "Chrzanów 02", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Górczewska", distance: 2255}
    ],
    19803: [
        {type: OfferPoiType.BUS, name: "Rogowska 01", distance: 324},
        {type: OfferPoiType.BUS, name: "Rogowska 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 02", distance: 398},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 01", distance: 421},
        {type: OfferPoiType.TRAM, name: "Rondo Żaba 03", distance: 534},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 06", distance: 553},
        {type: OfferPoiType.TRAM, name: "Rondo Żaba 04", distance: 555},
        {type: OfferPoiType.TRAM, name: "Rondo Żaba 07", distance: 574},
        {type: OfferPoiType.BUS, name: "Rondo Żaba 05", distance: 618},
        {type: OfferPoiType.BUS, name: "Kołowa 01", distance: 622},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 02", distance: 653},
        {type: OfferPoiType.BUS, name: "11 Listopada 02", distance: 664},
        {type: OfferPoiType.BUS, name: "Metro Targówek Mieszkaniowy 01", distance: 670},
        {type: OfferPoiType.METRO, name: "Targówek Mieszkaniowy", distance: 685},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Targówek", distance: 802},
        {type: OfferPoiType.PARK, name: "Park Stefana Wiecheckiego „Wiecha”", distance: 856},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Antoniego Władysława Żurowskiego", distance: 1601},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 1651},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 1669},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 1828},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 2153},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 2192}
    ],
    19804: [
        {type: OfferPoiType.BUS, name: "Jesiotrowa 01", distance: 264},
        {type: OfferPoiType.BUS, name: "Wierna 02", distance: 427},
        {type: OfferPoiType.BUS, name: "Wierna 04", distance: 446},
        {type: OfferPoiType.BUS, name: "Lniana 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Wierna 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Plac Ostrej Bramy 01", distance: 516},
        {type: OfferPoiType.BUS, name: "Plac Ostrej Bramy 02", distance: 537},
        {type: OfferPoiType.BUS, name: "Lniana 02", distance: 559},
        {type: OfferPoiType.BUS, name: "Krzewna 01", distance: 594},
        {type: OfferPoiType.BUS, name: "Krzewna 02", distance: 605},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zacisze-Wilno", distance: 843}
    ],
    19809: [
        {type: OfferPoiType.BUS, name: "Bochenka 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Bochenka 01", distance: 471},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 03", distance: 636},
        {type: OfferPoiType.BUS, name: "Piaski Nowe", distance: 644},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 02", distance: 650},
        {type: OfferPoiType.TRAM, name: "Piaski Nowe 01", distance: 658},
        {type: OfferPoiType.BUS, name: "Łużycka 01", distance: 674},
        {type: OfferPoiType.BUS, name: "Łużycka 02", distance: 688},
        {type: OfferPoiType.BUS, name: "Piaski Nowe 04", distance: 709},
        {type: OfferPoiType.BUS, name: "Tuchowska 01", distance: 807},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1132},
        {type: OfferPoiType.PARK, name: "Park Duchacki", distance: 1587},
        {type: OfferPoiType.PARK, name: "Park Kurdwanów", distance: 1834},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1848},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 2209}
    ],
    19811: [
        {type: OfferPoiType.BUS, name: "6 Sierpnia - Pogonowskiego NŻ", distance: 94},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Pl. Barlickiego", distance: 273},
        {type: OfferPoiType.BUS, name: "Zielona - Pl. Barlickiego", distance: 332},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Tuwim", distance: 402},
        {type: OfferPoiType.BUS, name: "Struga - Pogonowskiego NŻ", distance: 403},
        {type: OfferPoiType.BUS, name: "Struga - Żeromskiego", distance: 420},
        {type: OfferPoiType.BUS, name: "Żeromskiego - Struga", distance: 441},
        {type: OfferPoiType.TRAM, name: "Gdańska - Zielona", distance: 540},
        {type: OfferPoiType.PARK, name: "Plac Generała Józefa Hallera", distance: 552},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Linkego", distance: 590},
        {type: OfferPoiType.TRAM, name: "Gdańska - Struga", distance: 681},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Presi", distance: 694},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 697},
        {type: OfferPoiType.PARK, name: "Skwer Praw Kobiet", distance: 712},
        {type: OfferPoiType.TRAM, name: "Kopernika - Żeromskiego", distance: 725},
        {type: OfferPoiType.PARK, name: "Skwer im. Tadeusza Mazowieckiego", distance: 731},
        {type: OfferPoiType.PARK, name: "Skwer Latających Babć z Plusem", distance: 745},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Kopernika", distance: 811}
    ],
    19816: [
        {type: OfferPoiType.BUS, name: "Chwałkowska", distance: 492},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 649},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1915},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 2220}
    ],
    19817: [
        {type: OfferPoiType.BUS, name: "Wilkowyje Obywatelska", distance: 285},
        {type: OfferPoiType.BUS, name: "Wilkowyje Działki nż", distance: 487},
        {type: OfferPoiType.PARK, name: "Skwer Wilczy Kąt", distance: 1596},
        {type: OfferPoiType.PARK, name: "Park Górniczy", distance: 1719}
    ],
    19818: [
        {type: OfferPoiType.BUS, name: "Oś Królewska 01", distance: 23},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 06", distance: 116},
        {type: OfferPoiType.TRAM, name: "Oś Królewska 05", distance: 145},
        {type: OfferPoiType.BUS, name: "Oś Królewska 02", distance: 206},
        {type: OfferPoiType.BUS, name: "Świątynia Opatrzności Bożej 02", distance: 395},
        {type: OfferPoiType.TRAM, name: "Świątynia Opatrzności Bożej 04", distance: 509},
        {type: OfferPoiType.TRAM, name: "Świątynia Opatrzności Bożej 03", distance: 542},
        {type: OfferPoiType.BUS, name: "Świątynia Opatrzności Bożej 01", distance: 545},
        {type: OfferPoiType.BUS, name: "Sobieskiego 03", distance: 604},
        {type: OfferPoiType.BUS, name: "Sobieskiego 01", distance: 719},
        {type: OfferPoiType.BUS, name: "Sobieskiego 04", distance: 755},
        {type: OfferPoiType.BUS, name: "Sobieskiego 02", distance: 793},
        {type: OfferPoiType.BUS, name: "Sobieskiego 06", distance: 795},
        {type: OfferPoiType.TRAM, name: "Sobieskiego 06", distance: 795},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 71", distance: 806},
        {type: OfferPoiType.TRAM, name: "Miasteczko Wilanów 72", distance: 807},
        {type: OfferPoiType.PARK, name: "Plac Miejski", distance: 1092},
        {type: OfferPoiType.PARK, name: "Wege Park", distance: 1451},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 1578}
    ],
    19822: [
        {type: OfferPoiType.BUS, name: "Uniwersytecka - Narutowicza", distance: 360},
        {type: OfferPoiType.BUS, name: "Sterlinga - Pl. Dąbrowskiego", distance: 395},
        {type: OfferPoiType.BUS, name: "Sterlinga - Rewolucji 1905r.", distance: 420},
        {type: OfferPoiType.BUS, name: "Jaracza - P.O.W.", distance: 454},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 503},
        {type: OfferPoiType.BUS, name: "Jaracza - Wierzbowa", distance: 521},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Pl. Dąbrowskiego", distance: 527},
        {type: OfferPoiType.BUS, name: "Narutowicza - Pl. Dąbrowskiego", distance: 530},
        {type: OfferPoiType.TRAM, name: "Narutowicza - Tramwajowa", distance: 602},
        {type: OfferPoiType.TRAM, name: "Tramwajowa - Narutowicza", distance: 647},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 737},
        {type: OfferPoiType.TRAM, name: "Pomorska - Sterlinga", distance: 763},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 775},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 898},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 944},
        {type: OfferPoiType.PARK, name: "Skwer Studentów 1981 roku", distance: 995},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 1091},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 1159},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1231}
    ],
    19827: [
        {type: OfferPoiType.BUS, name: "Pienista - Obywatelska", distance: 152},
        {type: OfferPoiType.BUS, name: "Waltera-Janke - Nowe Sady", distance: 400},
        {type: OfferPoiType.BUS, name: "Pienista - Rusałki NŻ", distance: 406},
        {type: OfferPoiType.BUS, name: "Maratońska - Obywatelska", distance: 416},
        {type: OfferPoiType.BUS, name: "Nowe Sady - Waltera-Janke NŻ", distance: 507},
        {type: OfferPoiType.KOLEJ, name: "Łódź Retkinia", distance: 827},
        {type: OfferPoiType.PARK, name: "Obiekt rekreacyjno-sportowy „Karolek”", distance: 1605},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Polesie Konstantynowskie", distance: 2249},
        {type: OfferPoiType.PARK, name: "Uroczysko Lublinek", distance: 2490}
    ],
    19828: [
        {type: OfferPoiType.TRAM, name: "Aleje Marcinkowskiego", distance: 277},
        {type: OfferPoiType.PARK, name: "Park Jana Henryka Dąbrowskiego", distance: 296},
        {type: OfferPoiType.TRAM, name: "Pl. Wiosny Ludów", distance: 341},
        {type: OfferPoiType.TRAM, name: "Biblioteka Uniwersytecka", distance: 352},
        {type: OfferPoiType.TRAM, name: "Święty Marcin", distance: 358},
        {type: OfferPoiType.TRAM, name: "Wrocławska", distance: 369},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 446},
        {type: OfferPoiType.TRAM, name: "27 Grudnia – Teatr Polski", distance: 543},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 570},
        {type: OfferPoiType.BUS, name: "Marcinkowskiego", distance: 591},
        {type: OfferPoiType.TRAM, name: "Gwarna", distance: 648},
        {type: OfferPoiType.BUS, name: "Pl. Wielkopolski", distance: 662},
        {type: OfferPoiType.BUS, name: "Pl. Bernardyński", distance: 724},
        {type: OfferPoiType.PARK, name: "Park Karola Marcinkowskiego", distance: 808},
        {type: OfferPoiType.BUS, name: "Niezłomnych", distance: 818},
        {type: OfferPoiType.PARK, name: "Park Romana Maciejewskiego", distance: 910},
        {type: OfferPoiType.LAS, name: "Skwer Leona Wyczółkowskiego", distance: 941},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1024},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1040},
        {type: OfferPoiType.PARK, name: "Park Izabeli i Jarogniewa Drwęskich", distance: 1137},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1178},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1254},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1300}
    ],
    19834: [
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 02", distance: 425},
        {type: OfferPoiType.BUS, name: "Ryżowa 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 01", distance: 503},
        {type: OfferPoiType.BUS, name: "Ryżowa 03", distance: 613},
        {type: OfferPoiType.BUS, name: "Zapustna 04", distance: 636},
        {type: OfferPoiType.BUS, name: "Ryżowa 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 01", distance: 682},
        {type: OfferPoiType.BUS, name: "Zapustna 01", distance: 689},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 02", distance: 708},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 04", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 1455},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 1545},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 1680},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1769},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1817},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 1959},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 2031}
    ],
    19838: [
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 522},
        {type: OfferPoiType.PARK, name: "Małpi Gaj", distance: 552}
    ],
    19840: [
        {type: OfferPoiType.BUS, name: "Beethovena 04", distance: 194},
        {type: OfferPoiType.BUS, name: "Beethovena 01", distance: 245},
        {type: OfferPoiType.BUS, name: "Hańczy 01", distance: 267},
        {type: OfferPoiType.BUS, name: "Kierbedzia 01", distance: 318},
        {type: OfferPoiType.BUS, name: "Beethovena 02", distance: 390},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 03", distance: 442},
        {type: OfferPoiType.BUS, name: "Kostrzewskiego 04", distance: 486},
        {type: OfferPoiType.BUS, name: "Kierbedzia 02", distance: 515},
        {type: OfferPoiType.BUS, name: "Idzikowskiego 04", distance: 527},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 01", distance: 528},
        {type: OfferPoiType.BUS, name: "Aleja Witosa 01", distance: 541},
        {type: OfferPoiType.TRAM, name: "Kostrzewskiego 02", distance: 570},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 01", distance: 647},
        {type: OfferPoiType.TRAM, name: "Idzikowskiego 02", distance: 671},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 759},
        {type: OfferPoiType.PARK, name: "Folwark Sielce", distance: 1322},
        {type: OfferPoiType.PARK, name: "Skwer Chorwacki", distance: 1446},
        {type: OfferPoiType.PARK, name: "Skwer Jolanty Brzeskiej", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Stanisława Dygata", distance: 1556},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 1607},
        {type: OfferPoiType.PARK, name: "Park Promenada", distance: 1664},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Jeziorko Czerniakowskie", distance: 1934},
        {type: OfferPoiType.PARK, name: "Skwer Małkowskich", distance: 1996},
        {type: OfferPoiType.PARK, name: "Park Szustrów", distance: 2007},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 2178},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 2224}
    ],
    19841: [
        {type: OfferPoiType.BUS, name: "Sanocka n/ż", distance: 283},
        {type: OfferPoiType.BUS, name: "Urszulanek n/ż", distance: 765},
        {type: OfferPoiType.BUS, name: "Strzyżowska n/ż", distance: 780}
    ],
    19845: [
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 367},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 422},
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 477},
        {type: OfferPoiType.BUS, name: "Maślicka (Staw)", distance: 516},
        {type: OfferPoiType.BUS, name: "Turoszowska", distance: 664},
        {type: OfferPoiType.BUS, name: "Rędzińska", distance: 679},
        {type: OfferPoiType.BUS, name: "Północna", distance: 697},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1547}
    ],
    19846: [
        {type: OfferPoiType.BUS, name: "Bańgów Kościół", distance: 378},
        {type: OfferPoiType.PARK, name: "Skwer tajnej organizacji nauczycielskiej", distance: 751},
        {type: OfferPoiType.REZERWAT, name: 'Obszar chronionego krajobrazu "Przełajka"', distance: 1498},
        {type: OfferPoiType.PARK, name: 'Free Time Park "Brodzik"', distance: 2163},
        {type: OfferPoiType.REZERWAT, name: "Bażantarnia", distance: 2474}
    ],
    19848: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    19850: [
        {type: OfferPoiType.BUS, name: "Warszawska/Dworcowa", distance: 333},
        {type: OfferPoiType.KOLEJ, name: "Polanica-Zdrój", distance: 447},
        {type: OfferPoiType.BUS, name: "Polanica Zdrój, al. Wojska polskiego 25/58", distance: 562},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy", distance: 1388},
        {type: OfferPoiType.PARK, name: "Park Leśny", distance: 1804}
    ],
    19851: [
        {type: OfferPoiType.BUS, name: "Generała Grota-Roweckiego 04", distance: 277},
        {type: OfferPoiType.BUS, name: "Generała Grota-Roweckiego 05", distance: 321},
        {type: OfferPoiType.BUS, name: "Zakole 02", distance: 389},
        {type: OfferPoiType.BUS, name: "Zakole 01", distance: 483},
        {type: OfferPoiType.BUS, name: "Stawki 01", distance: 632},
        {type: OfferPoiType.BUS, name: "Stawki 02", distance: 633},
        {type: OfferPoiType.BUS, name: "Telimeny 01", distance: 757},
        {type: OfferPoiType.BUS, name: "Stawki Południowe nż. 02", distance: 811},
        {type: OfferPoiType.PARK, name: "Zacisze Holandii", distance: 1360},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2321}
    ],
    19853: [
        {type: OfferPoiType.BUS, name: "Muzeum Kinematografii", distance: 129},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Targowa", distance: 212},
        {type: OfferPoiType.PARK, name: "Skwer im. Leona Niemczyka", distance: 270},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Kilińskiego", distance: 290},
        {type: OfferPoiType.PARK, name: "Park Źródliska II", distance: 374},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Piłsudskiego", distance: 378},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Kilińskiego", distance: 400},
        {type: OfferPoiType.BUS, name: "Fabryczna - Targowa NŻ", distance: 489},
        {type: OfferPoiType.PARK, name: "Skwer Bogumiły Wander", distance: 528},
        {type: OfferPoiType.BUS, name: "Fabryczna - Kilińskiego NŻ", distance: 578},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 608},
        {type: OfferPoiType.BUS, name: "Wigury - Kilińskiego NŻ", distance: 623},
        {type: OfferPoiType.BUS, name: "Nawrot - Targowa", distance: 632},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Fabryczna", distance: 657},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Fabryczna", distance: 657},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Nawrot", distance: 662},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Przędzalniana", distance: 664},
        {type: OfferPoiType.PARK, name: "Zieleniec Wodny Rynek", distance: 725},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 999},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 1012}
    ],
    19854: [
        {type: OfferPoiType.BUS, name: "Ustronie Morskie", distance: 201},
        {type: OfferPoiType.BUS, name: "Ustronie Morskie Chrobrego", distance: 219}
    ],
    19855: [
        {type: OfferPoiType.BUS, name: "Bat. Chłopskich / Staroniwska 05", distance: 82},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 05", distance: 201},
        {type: OfferPoiType.BUS, name: "Bat. Chłopskich / Langiewicza 04", distance: 222},
        {type: OfferPoiType.BUS, name: "Witosa / Langiewicza 02", distance: 252},
        {type: OfferPoiType.BUS, name: "Langiewicza / Wita Stwosza 04", distance: 282},
        {type: OfferPoiType.BUS, name: "Przemysłowa / Bat. Chłopskich 02", distance: 335},
        {type: OfferPoiType.BUS, name: "Staroniwska / Rzemieślnicza 01", distance: 352},
        {type: OfferPoiType.BUS, name: "Staroniwska / Rzemieślnicza 02", distance: 386},
        {type: OfferPoiType.BUS, name: "Witosa / Panoramiczna 01", distance: 408},
        {type: OfferPoiType.PARK, name: "Park Zdrowia", distance: 1179},
        {type: OfferPoiType.PARK, name: "Ogród Miejski im. Solidarności", distance: 1381},
        {type: OfferPoiType.PARK, name: "ogródek jordanowski", distance: 1386},
        {type: OfferPoiType.PARK, name: "Park im. Inwalidów Wojennych", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Niezapominajki", distance: 1484}
    ],
    19857: [{type: OfferPoiType.BUS, name: "Ogrody Działkowe Kawęczyn 02", distance: 687}],
    19858: [
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja", distance: 411},
        {type: OfferPoiType.TRAM, name: "Konstytucji 3 Maja", distance: 416},
        {type: OfferPoiType.BUS, name: "Rządz", distance: 546},
        {type: OfferPoiType.TRAM, name: "Pętla Rządz", distance: 568},
        {type: OfferPoiType.BUS, name: "Konstytucji 3 Maja / Sobieskiego", distance: 571},
        {type: OfferPoiType.LAS, name: "Nabrzeże generała Gustawa Orlicz-Dreszera", distance: 645},
        {type: OfferPoiType.BUS, name: "Dębowe Wzgórze", distance: 813},
        {type: OfferPoiType.LAS, name: "fort Strzemięcin", distance: 1022}
    ],
    19859: [
        {type: OfferPoiType.BUS, name: "Grażyńskiego Okrzei", distance: 127},
        {type: OfferPoiType.BUS, name: "Podwale Dworzec", distance: 261},
        {type: OfferPoiType.BUS, name: "Stefana Okrzei", distance: 311},
        {type: OfferPoiType.BUS, name: "Gazownicza", distance: 373},
        {type: OfferPoiType.BUS, name: "Komorowicka Towarzystwa Szkoły Ludowej", distance: 445},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Główna", distance: 541},
        {type: OfferPoiType.BUS, name: "Wałowa CH", distance: 599},
        {type: OfferPoiType.BUS, name: "Bielsko-Biała D.A.", distance: 627},
        {type: OfferPoiType.PARK, name: "Plac Esperanto", distance: 783},
        {type: OfferPoiType.PARK, name: "Park za Ratuszem", distance: 1177},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1340},
        {type: OfferPoiType.PARK, name: "Park im. Juliusza Słowackiego", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1418}
    ],
    19863: [
        {type: OfferPoiType.BUS, name: "Słonimskiego", distance: 332},
        {type: OfferPoiType.BUS, name: "Daszyńskiego", distance: 443},
        {type: OfferPoiType.TRAM, name: "Daszyńskiego", distance: 576},
        {type: OfferPoiType.BUS, name: "Zakładowa", distance: 772},
        {type: OfferPoiType.PARK, name: "park Świętej Edyty Stein", distance: 1396},
        {type: OfferPoiType.PARK, name: "Park Stanisława Tołpy", distance: 1551},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Roberta Spiske", distance: 1579},
        {type: OfferPoiType.PARK, name: "skwer Ludzi ze znakiem „P”", distance: 1579}
    ],
    19866: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Kilińskiego", distance: 274},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Kilińskiego", distance: 274},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Senatorska", distance: 333},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Przybyszewskiego", distance: 334},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przybyszewskiego", distance: 334},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Senatorska", distance: 345},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Brzozowa", distance: 374},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Brzozowa", distance: 375},
        {type: OfferPoiType.BUS, name: "Zarzewska - Kilińskiego", distance: 416},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Poznańska", distance: 644},
        {type: OfferPoiType.PARK, name: "Ogrody Anny", distance: 786},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 876},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 911},
        {type: OfferPoiType.PARK, name: "Park im. gen. Jarosława Dąbrowskiego", distance: 1190},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1197},
        {type: OfferPoiType.PARK, name: "Skwer Świętej Siostry Faustyny Kowalskiej", distance: 1289},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 1379}
    ],
    19868: [
        {type: OfferPoiType.BUS, name: "Turoszowska", distance: 374},
        {type: OfferPoiType.BUS, name: "Maślice Małe (Brodnicka)", distance: 424},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 472},
        {type: OfferPoiType.BUS, name: "Śliwowa", distance: 584},
        {type: OfferPoiType.BUS, name: "Rędzińska (Cmentarz)", distance: 688},
        {type: OfferPoiType.BUS, name: "Rędzińska", distance: 729},
        {type: OfferPoiType.BUS, name: "Maślicka (Staw)", distance: 806},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1494}
    ],
    19878: [
        {type: OfferPoiType.BUS, name: "Koszykarska 02", distance: 298},
        {type: OfferPoiType.BUS, name: "Koszykarska 01", distance: 393},
        {type: OfferPoiType.BUS, name: "Koszykarska 03", distance: 445},
        {type: OfferPoiType.BUS, name: "Stoczniowców 05", distance: 514},
        {type: OfferPoiType.BUS, name: "Stoczniowców 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Stoczniowców 03", distance: 592},
        {type: OfferPoiType.BUS, name: "Stoczniowców 01", distance: 607},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 764},
        {type: OfferPoiType.PARK, name: "Park Rzeczny Ogród Płaszów", distance: 1034},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 1795},
        {type: OfferPoiType.PARK, name: "Zielony Skwer II", distance: 1884},
        {type: OfferPoiType.PARK, name: "Podgórski Tajemniczy Ogród", distance: 1908},
        {type: OfferPoiType.PARK, name: "Zielony Skwer I", distance: 2086}
    ],
    19886: [
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 309},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 332},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 381},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 424},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 627},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 650},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 671},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 788},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 807},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1283},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1645},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2423}
    ],
    19888: [
        {type: OfferPoiType.BUS, name: "Orzechowa 01", distance: 610},
        {type: OfferPoiType.BUS, name: "Orzechowa 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 651},
        {type: OfferPoiType.BUS, name: "Krakowiaków 02", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Marka Kotańskiego", distance: 2335}
    ],
    19890: [
        {type: OfferPoiType.BUS, name: "Niemcz / Słowackiego", distance: 67},
        {type: OfferPoiType.BUS, name: "Niemcz / Kasprowicza", distance: 261},
        {type: OfferPoiType.BUS, name: "Jeździecka / Ogród Botaniczny", distance: 333},
        {type: OfferPoiType.BUS, name: "Niemcz / Mickiewicza", distance: 518},
        {type: OfferPoiType.BUS, name: "Jeździecka / Hipiczna", distance: 557},
        {type: OfferPoiType.PARK, name: "Drzewa Młodej Bydgoszczy", distance: 2376}
    ],
    19898: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Zapadła", distance: 536},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Zapadła", distance: 536},
        {type: OfferPoiType.LAS, name: "osadnik", distance: 566},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Nurta-Kaszyńskiego", distance: 681},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Nurta-Kaszyńskiego", distance: 681},
        {type: OfferPoiType.PARK, name: "Park nad Jasieniem", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 1515},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2150},
        {type: OfferPoiType.PARK, name: "Park im. Jana Kilińskiego", distance: 2236},
        {type: OfferPoiType.PARK, name: "Park Źródliska I", distance: 2282},
        {type: OfferPoiType.PARK, name: "Skwer im. Świętego Maksymiliana Marii Kolbego", distance: 2375},
        {type: OfferPoiType.PARK, name: "Park Źródliska II", distance: 2453}
    ],
    19902: [
        {type: OfferPoiType.BUS, name: "Halicka", distance: 83},
        {type: OfferPoiType.BUS, name: "Małopolska (Ośrodek dla niewidomych)", distance: 245},
        {type: OfferPoiType.BUS, name: "Częstochowska", distance: 357},
        {type: OfferPoiType.BUS, name: "Złotniki", distance: 675},
        {type: OfferPoiType.BUS, name: "Kosmonautów (Szpital)", distance: 725},
        {type: OfferPoiType.TRAM, name: "Kosmonautów (Szpital)", distance: 746},
        {type: OfferPoiType.PARK, name: "Park Literacki", distance: 1361},
        {type: OfferPoiType.PARK, name: "Park Złotnicki", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park Żernicki", distance: 2066},
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 2349},
        {type: OfferPoiType.PARK, name: "skwer Księdza Justyna Kostka", distance: 2396},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2464},
        {type: OfferPoiType.PARK, name: "Żernicki Park Sportu i Rekreacji", distance: 2485}
    ],
    19904: [
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 355},
        {type: OfferPoiType.BUS, name: "Bogucice Skrzyżowanie", distance: 429},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury", distance: 515},
        {type: OfferPoiType.TRAM, name: "Zawodzie Paderewskiego", distance: 569},
        {type: OfferPoiType.TRAM, name: "Zawodzie Uniwersytet Ekonomiczny", distance: 580},
        {type: OfferPoiType.BUS, name: "Bogucice Markiefki", distance: 598},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Eugeniusza Breitkopfa", distance: 608},
        {type: OfferPoiType.BUS, name: "Zawodzie Waleriana", distance: 727},
        {type: OfferPoiType.BUS, name: "Katowice Strefa Kultury Muzeum Śląskie", distance: 773},
        {type: OfferPoiType.TRAM, name: "Katowice Graniczna", distance: 773},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 793},
        {type: OfferPoiType.PARK, name: "Skwer Andrzeja Fonfary", distance: 814},
        {type: OfferPoiType.BUS, name: "Bogucice Wróblewskiego", distance: 822},
        {type: OfferPoiType.PARK, name: "Plac księdza Emila Szramka", distance: 1180},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 1224},
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 1240},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 1333},
        {type: OfferPoiType.PARK, name: "Park Powstańców Śląskich", distance: 1456},
        {type: OfferPoiType.PARK, name: "Skwer Richarda Holtzego", distance: 1546}
    ],
    19906: [
        {type: OfferPoiType.BUS, name: "Os. Ślichowice", distance: 166},
        {type: OfferPoiType.KOLEJ, name: "Kielce Ślichowice", distance: 406},
        {type: OfferPoiType.BUS, name: "Massalskiego", distance: 461},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skalny Ślichowice im. Jana Czarnockiego", distance: 544},
        {type: OfferPoiType.BUS, name: "Pasaż Świętokrzyski", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Czarnów", distance: 2536}
    ],
    19907: [
        {type: OfferPoiType.BUS, name: "Osielsko / Dzikiej Gęsi", distance: 399},
        {type: OfferPoiType.BUS, name: "Osielsko / Młyn", distance: 509}
    ],
    19908: [
        {type: OfferPoiType.BUS, name: "Trzebinia Osiedle Widokowe Kiosk", distance: 353},
        {type: OfferPoiType.BUS, name: "Trzebinia Osiedle Widokowe Szkoła", distance: 593},
        {type: OfferPoiType.BUS, name: "Trzebinia Osiedle Widokowe Schody", distance: 791},
        {type: OfferPoiType.PARK, name: "Zespół pałacowo – parkowy Florkiewiczów w Młoszowej", distance: 1708}
    ],
    19910: [
        {type: OfferPoiType.BUS, name: "Kredytowa", distance: 528},
        {type: OfferPoiType.BUS, name: "Skarpa", distance: 555},
        {type: OfferPoiType.BUS, name: "Skłodowskiej", distance: 774},
        {type: OfferPoiType.BUS, name: "Słowackiego", distance: 830},
        {type: OfferPoiType.BUS, name: "Gałczyńskiego", distance: 834},
        {type: OfferPoiType.PARK, name: "Park przy Łukasiewicza", distance: 1244},
        {type: OfferPoiType.PARK, name: "Park na Wzgórzu Tumskim", distance: 2035},
        {type: OfferPoiType.PARK, name: "Skwer imienia Romana Lutyńskiego", distance: 2244},
        {type: OfferPoiType.PARK, name: "Plac Obrońców Warszawy", distance: 2252}
    ],
    19919: [
        {type: OfferPoiType.BUS, name: "Edwardowo n/ż", distance: 143},
        {type: OfferPoiType.BUS, name: "Brzechwy n/ż", distance: 320},
        {type: OfferPoiType.BUS, name: "Leśnych Skrzatów", distance: 475},
        {type: OfferPoiType.BUS, name: "Wieczorynki n/ż", distance: 617},
        {type: OfferPoiType.LAS, name: "Lasek Marceliński", distance: 1465}
    ],
    19920: [
        {type: OfferPoiType.TRAM, name: "Pomorska - Matejki", distance: 183},
        {type: OfferPoiType.BUS, name: "Pomorska - Matejki", distance: 192},
        {type: OfferPoiType.BUS, name: "Pomorska - Rondo Solidarności", distance: 322},
        {type: OfferPoiType.TRAM, name: "Pomorska - Rondo Solidarności", distance: 331},
        {type: OfferPoiType.BUS, name: "Pomorska - Tamka NŻ", distance: 415},
        {type: OfferPoiType.BUS, name: "Palki - Źródłowa", distance: 426},
        {type: OfferPoiType.TRAM, name: "Pomorska - Tamka", distance: 433},
        {type: OfferPoiType.BUS, name: "Pomorska - Tamka", distance: 441},
        {type: OfferPoiType.BUS, name: "Kopcińskiego - Rondo Solidarności", distance: 519},
        {type: OfferPoiType.PARK, name: "Skwer Zofii i Zygmunta Hertzów", distance: 694},
        {type: OfferPoiType.PARK, name: "Park Matejki", distance: 756},
        {type: OfferPoiType.TRAM, name: "Pomorska - Wierzbowa", distance: 759},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1219},
        {type: OfferPoiType.PARK, name: "Park Staszica", distance: 1258},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1429},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1583},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1590},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 1725},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1725}
    ],
    19922: [
        {type: OfferPoiType.BUS, name: "Prądnik Biały Zachód 04", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1574},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 1878},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 2054},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 2439}
    ],
    19923: [
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 04", distance: 93},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 02", distance: 199},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 01", distance: 213},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 06", distance: 215},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 03", distance: 244},
        {type: OfferPoiType.BUS, name: "Aleja Zieleniecka 09", distance: 265},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 05", distance: 285},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 07", distance: 298},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 11", distance: 323},
        {type: OfferPoiType.TRAM, name: "Aleja Zieleniecka 71", distance: 347},
        {type: OfferPoiType.TRAM, name: "Lubelska 03", distance: 357},
        {type: OfferPoiType.TRAM, name: "Lubelska 04", distance: 370},
        {type: OfferPoiType.BUS, name: "Kijowska 01", distance: 373},
        {type: OfferPoiType.BUS, name: "Lubelska 06", distance: 385},
        {type: OfferPoiType.BUS, name: "Lubelska 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Lubelska 02", distance: 438},
        {type: OfferPoiType.BUS, name: "Metro Stadion Narodowy 71", distance: 459},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 554},
        {type: OfferPoiType.METRO, name: "Stadion Narodowy", distance: 559},
        {type: OfferPoiType.TRAM, name: "Kijowska 03", distance: 564},
        {type: OfferPoiType.TRAM, name: "Kijowska 06", distance: 638},
        {type: OfferPoiType.TRAM, name: "Kijowska 04", distance: 641},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Stadion", distance: 676},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 829},
        {type: OfferPoiType.PARK, name: "Skwer Kępna-Jagiellońska", distance: 968},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1008},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1259},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1671},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1834},
        {type: OfferPoiType.PARK, name: "Park Odkrywców", distance: 1859},
        {type: OfferPoiType.PARK, name: "Park Praski", distance: 1890}
    ],
    19925: [
        {type: OfferPoiType.BUS, name: "Podbipięty 02", distance: 184},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 16", distance: 187},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 17", distance: 198},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 15", distance: 213},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 14", distance: 228},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 18", distance: 229},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 13", distance: 237},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 10", distance: 245},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 11", distance: 258},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 09", distance: 260},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 05", distance: 339},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 351},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 06", distance: 359},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 72", distance: 416},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 71", distance: 417},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 04", distance: 692},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 03", distance: 738},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 778},
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 986},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1226},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1370},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1521},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1922},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2264}
    ],
    19930: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Mechaniczna (CRO) NŻ", distance: 278},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego NŻ", distance: 474},
        {type: OfferPoiType.TRAM, name: "Lodowa - Przybyszewskiego", distance: 475},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego", distance: 482},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Lodowa", distance: 494},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Lodowa", distance: 498},
        {type: OfferPoiType.BUS, name: "Maciejewskiego - Dw. Łódź Zarzew", distance: 524},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 575},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 575},
        {type: OfferPoiType.KOLEJ, name: "Łódź Zarzew", distance: 665},
        {type: OfferPoiType.TRAM, name: "Cm. Zarzew", distance: 693},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 840},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 1067},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 1144},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 2241},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2366},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2458},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 2492}
    ],
    19933: [
        {type: OfferPoiType.BUS, name: "Mazowieckiego 02", distance: 562},
        {type: OfferPoiType.BUS, name: "Mazowieckiego 01", distance: 665}
    ],
    19934: [{type: OfferPoiType.REZERWAT, name: "Redutowa", distance: 1467}],
    19943: [
        {type: OfferPoiType.BUS, name: "PKP Gocławek 04", distance: 234},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 03", distance: 241},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 02", distance: 356},
        {type: OfferPoiType.BUS, name: "Płowiecka 01", distance: 550},
        {type: OfferPoiType.BUS, name: "Cukrownicza 02", distance: 580},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Gocławek", distance: 612},
        {type: OfferPoiType.BUS, name: "Okularowa 01", distance: 626},
        {type: OfferPoiType.PARK, name: "Zielona Oaza przy Cukrowniczej", distance: 652},
        {type: OfferPoiType.BUS, name: "Cukrownicza 01", distance: 661},
        {type: OfferPoiType.BUS, name: "PKP Gocławek 01", distance: 694},
        {type: OfferPoiType.BUS, name: "Płowiecka 04", distance: 743},
        {type: OfferPoiType.BUS, name: "Okularowa 04", distance: 779},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Olszynka Grochowska", distance: 1419},
        {type: OfferPoiType.PARK, name: 'Park Pułkownika Jana Szypowskiego "Leśnika"', distance: 1536},
        {type: OfferPoiType.REZERWAT, name: "Zakole Wawerskie", distance: 1753},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 1944}
    ],
    19953: [
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 227},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 247},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 320},
        {type: OfferPoiType.BUS, name: "Terespolska 01", distance: 339},
        {type: OfferPoiType.BUS, name: "Terespolska 04", distance: 388},
        {type: OfferPoiType.BUS, name: "Praga Południe-Ratusz 01", distance: 482},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 485},
        {type: OfferPoiType.TRAM, name: "Praga Południe-Ratusz 04", distance: 501},
        {type: OfferPoiType.TRAM, name: "Praga Południe-Ratusz 03", distance: 514},
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 537},
        {type: OfferPoiType.BUS, name: "Praga Południe-Ratusz 02", distance: 544},
        {type: OfferPoiType.BUS, name: "Tor Kolarski 02", distance: 552},
        {type: OfferPoiType.TRAM, name: "Gocławska 03", distance: 718},
        {type: OfferPoiType.TRAM, name: "Gocławska 04", distance: 758},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 781},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 973},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1100},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1136},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1540},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 1595},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 1799},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1807}
    ],
    19963: [
        {type: OfferPoiType.BUS, name: "Janczewice 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Janczewice 02", distance: 515},
        {type: OfferPoiType.BUS, name: "Tolak 02", distance: 784},
        {type: OfferPoiType.BUS, name: "Tolak 01", distance: 817}
    ],
    19964: [
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 03", distance: 519},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 04", distance: 536},
        {type: OfferPoiType.BUS, name: "Papierni Prądnickich 05", distance: 540},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 01", distance: 547},
        {type: OfferPoiType.TRAM, name: "Papierni Prądnickich 02", distance: 561},
        {type: OfferPoiType.PARK, name: "Park Leśny Witkowice", distance: 1502},
        {type: OfferPoiType.REZERWAT, name: "Las w Witkowicach", distance: 1545},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2000}
    ],
    19969: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Teligi", distance: 294},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Czeremchowa", distance: 392},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Bairda", distance: 525},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Królewska / Teligi", distance: 567},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Na Laski", distance: 641},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Świerkowa", distance: 646},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 726},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 846},
        {type: OfferPoiType.REZERWAT, name: "Aleja grabowa", distance: 1042},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1444},
        {type: OfferPoiType.REZERWAT, name: "Łęgi Na Skraju", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 1625},
        {type: OfferPoiType.PARK, name: "Skwer im. Stanisławy i Henryka Witaczków", distance: 1803},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1814},
        {type: OfferPoiType.PARK, name: "Skwer przy ulicy Górnej", distance: 2181}
    ],
    19970: [
        {type: OfferPoiType.PARK, name: "Plac Wincentego Wajdy", distance: 606},
        {type: OfferPoiType.BUS, name: "Bogucice Kościół", distance: 620},
        {type: OfferPoiType.PARK, name: "Skwer Augustyna Halotty", distance: 699},
        {type: OfferPoiType.BUS, name: "Osiedle Kukuczki Sandomierska", distance: 711},
        {type: OfferPoiType.BUS, name: "Bogucice Wróblewskiego", distance: 729},
        {type: OfferPoiType.BUS, name: "Bogucice Cmentarz", distance: 808},
        {type: OfferPoiType.PARK, name: "Park Bogucki", distance: 1229},
        {type: OfferPoiType.PARK, name: "Park przy ul. Leopolda", distance: 1243},
        {type: OfferPoiType.PARK, name: "Plac Gwarków", distance: 1549},
        {type: OfferPoiType.PARK, name: "Park Wełnowiecki", distance: 1584},
        {type: OfferPoiType.PARK, name: "Labirynt – Plan Wielkich Katowic", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park Zielony Zakątek", distance: 1724},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1737}
    ],
    19971: [
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Traugutta", distance: 459},
        {type: OfferPoiType.BUS, name: "Traugutta - Sienkiewicza", distance: 465},
        {type: OfferPoiType.BUS, name: "Łódzka Inf. Turystyczna", distance: 507},
        {type: OfferPoiType.BUS, name: "Jaracza - Piotrkowska", distance: 510},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Narutowicza", distance: 521},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Narutowicza", distance: 528},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 641},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 644},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 662},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 671},
        {type: OfferPoiType.BUS, name: "Jaracza - Kilińskiego", distance: 672},
        {type: OfferPoiType.TRAM, name: "Zachodnia - Więckowskiego", distance: 688},
        {type: OfferPoiType.BUS, name: "Narutowicza - P.O.W. NŻ", distance: 691},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 695},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 706},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 719},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Zachodnia", distance: 723},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 743},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 765},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 841},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 906},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 910},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 930}
    ],
    19972: [
        {type: OfferPoiType.BUS, name: "Mickiewicza 05", distance: 236},
        {type: OfferPoiType.BUS, name: "Ostroroga 01", distance: 325},
        {type: OfferPoiType.TRAM, name: "Mickiewicza 03", distance: 362},
        {type: OfferPoiType.BUS, name: "Kościuszki 04", distance: 408},
        {type: OfferPoiType.BUS, name: "Mickiewicza 04", distance: 408},
        {type: OfferPoiType.BUS, name: "Mickiewicza 06", distance: 414},
        {type: OfferPoiType.TRAM, name: "Mickiewicza 02", distance: 424},
        {type: OfferPoiType.TRAM, name: "Mickiewicza 01", distance: 426},
        {type: OfferPoiType.TRAM, name: "Kościuszki", distance: 435},
        {type: OfferPoiType.BUS, name: "Kościuszki 05", distance: 443},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 479},
        {type: OfferPoiType.BUS, name: "Kościuszki 03", distance: 501},
        {type: OfferPoiType.BUS, name: "Klonowicza 02", distance: 514},
        {type: OfferPoiType.BUS, name: "Klonowicza 01", distance: 542},
        {type: OfferPoiType.BUS, name: "Lwowska 01", distance: 630},
        {type: OfferPoiType.PARK, name: "Park nad Strzyżą", distance: 868},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Wybickiego", distance: 1002}
    ],
    19973: [
        {type: OfferPoiType.BUS, name: "Grabowa", distance: 331},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 340},
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 414},
        {type: OfferPoiType.BUS, name: "Aleja Architektów", distance: 711},
        {type: OfferPoiType.TRAM, name: "Aleja Architektów", distance: 720},
        {type: OfferPoiType.TRAM, name: "Kosmonautów", distance: 811},
        {type: OfferPoiType.BUS, name: "Kosmonautów (pętla)", distance: 830},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 2477}
    ],
    19974: [
        {type: OfferPoiType.BUS, name: "Obornicka (Wołowska)", distance: 306},
        {type: OfferPoiType.BUS, name: "Wołowska", distance: 444},
        {type: OfferPoiType.TRAM, name: "Wołowska", distance: 449},
        {type: OfferPoiType.BUS, name: "Bezpieczna", distance: 490},
        {type: OfferPoiType.TRAM, name: "Poświętne", distance: 702},
        {type: OfferPoiType.BUS, name: "Paprotna", distance: 722},
        {type: OfferPoiType.BUS, name: "Poświętne", distance: 754},
        {type: OfferPoiType.BUS, name: "Kępińska", distance: 797},
        {type: OfferPoiType.TRAM, name: "Kępińska", distance: 798},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 2295}
    ],
    19975: [
        {type: OfferPoiType.PARK, name: "skwer Hansa Scharouna", distance: 537},
        {type: OfferPoiType.BUS, name: "Grabowa", distance: 651},
        {type: OfferPoiType.TRAM, name: "Grabowa", distance: 660}
    ],
    19976: [
        {type: OfferPoiType.BUS, name: "Fabryczna 02", distance: 71},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 02", distance: 203},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 01", distance: 204},
        {type: OfferPoiType.BUS, name: "Wojska Polskiego 03", distance: 228},
        {type: OfferPoiType.BUS, name: "Kościelna 01", distance: 296},
        {type: OfferPoiType.BUS, name: "Szkolna 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 355},
        {type: OfferPoiType.BUS, name: "Szkolna 03", distance: 409},
        {type: OfferPoiType.BUS, name: "Nadarzyńska 02", distance: 428},
        {type: OfferPoiType.BUS, name: "Powstańców Warszawy 02", distance: 504},
        {type: OfferPoiType.PARK, name: "Skwer Hrabianki Ludwiki Małgorzaty Moriconi", distance: 558},
        {type: OfferPoiType.PARK, name: "Park Zachodni", distance: 560},
        {type: OfferPoiType.PARK, name: "Skwer Stefana Kisielewskiego", distance: 735},
        {type: OfferPoiType.PARK, name: "Park Książąt Mazowieckich", distance: 837}
    ],
    19978: [
        {type: OfferPoiType.PARK, name: "Park im. Mariana Jonkajtysa", distance: 2012},
        {type: OfferPoiType.PARK, name: "Skwer im. Żołnierzy Wyklętych", distance: 2380}
    ],
    19981: [
        {type: OfferPoiType.BUS, name: "Błonie PEKAES", distance: 251},
        {type: OfferPoiType.BUS, name: "Błonie Batalionów Chłopskich", distance: 365},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 2079},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 2109},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 2426}
    ],
    19986: [
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Przychodnia", distance: 84},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta", distance: 260},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Traugutta Dw. PKP", distance: 333},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. DSI Malwa", distance: 377},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Dw. PKP", distance: 555},
        {type: OfferPoiType.BUS, name: "Grodzisk Maz. Poniatowskiego", distance: 576},
        {type: OfferPoiType.KOLEJ, name: "Grodzisk Mazowiecki", distance: 615},
        {type: OfferPoiType.PARK, name: "Park im. hrabiów Skarbków", distance: 1048},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Piłsudskiego", distance: 1201},
        {type: OfferPoiType.PARK, name: "Park Marii Michalak", distance: 1290},
        {type: OfferPoiType.PARK, name: 'Skwer "Osiedle Kopernika"', distance: 1600},
        {type: OfferPoiType.PARK, name: "Park nad Rokitnicą", distance: 1797},
        {type: OfferPoiType.PARK, name: "Stawy Goliana", distance: 1820},
        {type: OfferPoiType.PARK, name: "Ogródek Seniora", distance: 2172},
        {type: OfferPoiType.PARK, name: "Park Jaśminowa", distance: 2259}
    ],
    19989: [
        {type: OfferPoiType.BUS, name: "Kolonistów", distance: 513},
        {type: OfferPoiType.BUS, name: "Górna", distance: 543},
        {type: OfferPoiType.BUS, name: "Nehringa", distance: 753},
        {type: OfferPoiType.BUS, name: "Dojazdowa", distance: 804},
        {type: OfferPoiType.LAS, name: "Uroczysko Kupały", distance: 1362},
        {type: OfferPoiType.REZERWAT, name: "Dolina strumienia Grzęziniec", distance: 2130}
    ],
    20000: [
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 176},
        {type: OfferPoiType.BUS, name: "Marycjusza 01", distance: 189},
        {type: OfferPoiType.BUS, name: "Marycjusza 02", distance: 233},
        {type: OfferPoiType.BUS, name: "Popielidów 02", distance: 358},
        {type: OfferPoiType.BUS, name: "Kruszwicka 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Kruszwicka 01", distance: 486},
        {type: OfferPoiType.BUS, name: "Popielidów 01", distance: 514},
        {type: OfferPoiType.BUS, name: "Os. Mistrzejowice Nowe 02", distance: 783},
        {type: OfferPoiType.BUS, name: "Kupały 02", distance: 792},
        {type: OfferPoiType.BUS, name: "Os. Mistrzejowice Nowe 01", distance: 811},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1585},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 1885},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1904},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 1993},
        {type: OfferPoiType.PARK, name: "Park Generała pilota Stanisława Skalskiego", distance: 2460},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2469}
    ],
    20003: [
        {type: OfferPoiType.BUS, name: "Sikorskiego-Wilczyńskiego", distance: 84},
        {type: OfferPoiType.TRAM, name: "Sikorskiego-Wilczyńskiego", distance: 221},
        {type: OfferPoiType.BUS, name: "Andersa", distance: 227},
        {type: OfferPoiType.BUS, name: "Sikorskiego-Wilczyńskiego 02", distance: 233},
        {type: OfferPoiType.TRAM, name: "Andersa", distance: 261},
        {type: OfferPoiType.BUS, name: "Bartąska", distance: 305},
        {type: OfferPoiType.BUS, name: "Jarocka", distance: 361},
        {type: OfferPoiType.BUS, name: "Kutrzeby 01", distance: 571},
        {type: OfferPoiType.BUS, name: "Osiedle Generałów", distance: 576},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 626},
        {type: OfferPoiType.PARK, name: "Skwer generała Augusta Fieldorfa–Nila", distance: 1449},
        {type: OfferPoiType.PARK, name: "Park Nagórki-Jaroty", distance: 1541},
        {type: OfferPoiType.PARK, name: "Park podworski Pozorty", distance: 2402}
    ],
    20004: [{type: OfferPoiType.PARK, name: "Park Miejski im. Lecha Jana Nitkowskiego", distance: 1734}],
    20011: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 724}
    ],
    20012: [
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1144},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1154},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1648}
    ],
    20013: [{type: OfferPoiType.PARK, name: "Zespół pałacowo-parkowy w Gałowie", distance: 1226}],
    20015: [
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 02", distance: 729},
        {type: OfferPoiType.BUS, name: "Muzeum II Wojny Światowej 01", distance: 751},
        {type: OfferPoiType.PARK, name: "Ogród na Ołowiance im. prof. Lecha Wałęsy", distance: 1012},
        {type: OfferPoiType.PARK, name: "Skwer im. Macieja Kosycarza", distance: 1148},
        {type: OfferPoiType.PARK, name: "Skwer Gyddanyzc", distance: 1236},
        {type: OfferPoiType.PARK, name: "Skwer Chrztu Rusi-Ukrainy", distance: 1429},
        {type: OfferPoiType.PARK, name: "Skwer Świętopełka Wielkiego", distance: 1512},
        {type: OfferPoiType.REZERWAT, name: "Fort Nocek", distance: 2241},
        {type: OfferPoiType.REZERWAT, name: "Prochownia pod Kasztanami", distance: 2353}
    ],
    20017: [
        {type: OfferPoiType.BUS, name: "Wiślinka Piaskowa", distance: 363},
        {type: OfferPoiType.BUS, name: "Wiślinka Most", distance: 615}
    ],
    20018: [
        {type: OfferPoiType.BUS, name: "Szczodre-Trzebnicka (na wys. 3a)", distance: 702},
        {type: OfferPoiType.PARK, name: "Park Szczodre", distance: 1936}
    ],
    20026: [
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 221},
        {type: OfferPoiType.BUS, name: "Słona Woda 02", distance: 722},
        {type: OfferPoiType.BUS, name: "Prokocim UJ 02", distance: 746},
        {type: OfferPoiType.BUS, name: "Słona Woda 01", distance: 773},
        {type: OfferPoiType.BUS, name: "Hallera 03", distance: 795},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 1094},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1753},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 1914},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 2211},
        {type: OfferPoiType.REZERWAT, name: "Las Krzyszkowicki", distance: 2287},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 2336}
    ],
    20029: [
        {type: OfferPoiType.BUS, name: "Likusy", distance: 211},
        {type: OfferPoiType.BUS, name: "Wioślarska", distance: 459},
        {type: OfferPoiType.BUS, name: "Żbicza", distance: 563},
        {type: OfferPoiType.KOLEJ, name: "Olsztyn Redykajny", distance: 564},
        {type: OfferPoiType.BUS, name: "Letniskowa", distance: 602},
        {type: OfferPoiType.PARK, name: "Skwer Wolnego Tybetu", distance: 2541}
    ],
    20030: [
        {type: OfferPoiType.BUS, name: "Plac Mickiewicza", distance: 417},
        {type: OfferPoiType.BUS, name: "Plac Żwirki i Wigury", distance: 423},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 603},
        {type: OfferPoiType.BUS, name: "Michałowicza Czarnieckiego", distance: 657},
        {type: OfferPoiType.BUS, name: "PCK PKP Lipnik", distance: 779},
        {type: OfferPoiType.BUS, name: "Sobieskiego Wyspiańskiego", distance: 822},
        {type: OfferPoiType.PARK, name: "Park Włókniarzy", distance: 831}
    ],
    20031: [
        {type: OfferPoiType.BUS, name: "Plac Mickiewicza", distance: 227},
        {type: OfferPoiType.BUS, name: "Michałowicza Czarnieckiego", distance: 372},
        {type: OfferPoiType.BUS, name: "Plac Żwirki i Wigury", distance: 448},
        {type: OfferPoiType.BUS, name: "PCK PKP Lipnik", distance: 513},
        {type: OfferPoiType.PARK, name: "Park Włókniarzy", distance: 538},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 625},
        {type: OfferPoiType.KOLEJ, name: "Bielsko-Biała Lipnik", distance: 762}
    ],
    20032: [
        {type: OfferPoiType.BUS, name: "Wróbla 01", distance: 133},
        {type: OfferPoiType.BUS, name: "Wróbla 02", distance: 144},
        {type: OfferPoiType.BUS, name: "Dobra 02", distance: 215},
        {type: OfferPoiType.BUS, name: "Dobra 01", distance: 227},
        {type: OfferPoiType.BUS, name: "Zagony", distance: 427},
        {type: OfferPoiType.BUS, name: "Chłodna 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Chłodna 01", distance: 588},
        {type: OfferPoiType.BUS, name: "Miedza n/ż 01", distance: 634},
        {type: OfferPoiType.BUS, name: "Miedza n/ż 02", distance: 693},
        {type: OfferPoiType.TRAM, name: "Akademia Muzyczna", distance: 780},
        {type: OfferPoiType.BUS, name: "Brama Nizinna", distance: 792},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 1034},
        {type: OfferPoiType.PARK, name: "Skwer Za Murami", distance: 1188},
        {type: OfferPoiType.PARK, name: "Park im. Św. Barbary", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Profesora Franciszka Duszeńki", distance: 1577}
    ],
    20033: [
        {type: OfferPoiType.BUS, name: "Pogórze-Derdowskiego 02", distance: 615},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 01", distance: 835},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1553},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 2223},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 2384}
    ],
    20036: [
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Mechaniczna (CRO) NŻ", distance: 257},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego NŻ", distance: 453},
        {type: OfferPoiType.TRAM, name: "Lodowa - Przybyszewskiego", distance: 454},
        {type: OfferPoiType.BUS, name: "Lodowa - Przybyszewskiego", distance: 461},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Lodowa", distance: 473},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Lodowa", distance: 477},
        {type: OfferPoiType.BUS, name: "Maciejewskiego - Dw. Łódź Zarzew", distance: 503},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 554},
        {type: OfferPoiType.TRAM, name: "Przybyszewskiego - Dw. Łódź Zarzew", distance: 554},
        {type: OfferPoiType.KOLEJ, name: "Łódź Zarzew", distance: 644},
        {type: OfferPoiType.TRAM, name: "Cm. Zarzew", distance: 672},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 861},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 1088},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 1165},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 2220},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2387},
        {type: OfferPoiType.PARK, name: "Park Podolski", distance: 2471},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2479}
    ],
    20037: [
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 01", distance: 248},
        {type: OfferPoiType.BUS, name: "Ogrody Przyjaciół 02", distance: 289},
        {type: OfferPoiType.BUS, name: "Warmińska 02", distance: 834}
    ],
    20043: [
        {type: OfferPoiType.BUS, name: "Walendów Ogrody", distance: 111},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 01", distance: 618},
        {type: OfferPoiType.BUS, name: "Kajetany Brzozowa", distance: 625},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 02", distance: 675}
    ],
    20044: [
        {type: OfferPoiType.BUS, name: "Walendów Ogrody", distance: 115},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 01", distance: 614},
        {type: OfferPoiType.BUS, name: "Kajetany Brzozowa", distance: 629},
        {type: OfferPoiType.BUS, name: "Walendów Wentana 02", distance: 671}
    ],
    20051: [
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1793},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 2253},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 2273},
        {type: OfferPoiType.PARK, name: "Skwer Bitwy Nad Bzurą", distance: 2401}
    ],
    20054: [
        {type: OfferPoiType.BUS, name: "Plac Bohaterów Getta", distance: 187},
        {type: OfferPoiType.TRAM, name: "Plac Bohaterów Getta 02", distance: 205},
        {type: OfferPoiType.TRAM, name: "Plac Bohaterów Getta 01", distance: 228},
        {type: OfferPoiType.KOLEJ, name: "Kraków Zabłocie", distance: 352},
        {type: OfferPoiType.TRAM, name: "Limanowskiego 02", distance: 367},
        {type: OfferPoiType.TRAM, name: "Limanowskiego 01", distance: 382},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 01", distance: 662},
        {type: OfferPoiType.TRAM, name: "Podgórze SKA 01", distance: 684},
        {type: OfferPoiType.BUS, name: "Dajwór 01", distance: 697},
        {type: OfferPoiType.TRAM, name: "Dajwór 01", distance: 698},
        {type: OfferPoiType.TRAM, name: "św. Wawrzyńca 02", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 748},
        {type: OfferPoiType.TRAM, name: "Podgórze SKA 02", distance: 768},
        {type: OfferPoiType.BUS, name: "Podgórze SKA 03", distance: 792},
        {type: OfferPoiType.BUS, name: "Podgórze SKA 05", distance: 812},
        {type: OfferPoiType.PARK, name: "Ogród Motyli", distance: 921},
        {type: OfferPoiType.PARK, name: "Plac Lasoty", distance: 950},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1008},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1163},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 1724},
        {type: OfferPoiType.REZERWAT, name: "Kamieniołom Libana", distance: 2015}
    ],
    20057: [
        {type: OfferPoiType.BUS, name: "Regulska 01", distance: 778},
        {type: OfferPoiType.BUS, name: "Regulska 02", distance: 786},
        {type: OfferPoiType.PARK, name: "Plac Zgody", distance: 1095},
        {type: OfferPoiType.PARK, name: "Zieleniec przy Zagłoby", distance: 1532},
        {type: OfferPoiType.PARK, name: "Zieleniec Zaczarowanej Dorożki", distance: 1894},
        {type: OfferPoiType.PARK, name: "Park Hassów", distance: 2018},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Królów Polskich", distance: 2040},
        {type: OfferPoiType.PARK, name: "Park Niepodległości", distance: 2124},
        {type: OfferPoiType.PARK, name: "Zieleniec przy ul. Koronacyjnej", distance: 2186},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 2273},
        {type: OfferPoiType.PARK, name: "Park Bogny i Jerzego Sokorskich", distance: 2291},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 2391}
    ],
    20058: [
        {type: OfferPoiType.BUS, name: "Janowska 02", distance: 191},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa 02", distance: 251},
        {type: OfferPoiType.BUS, name: "Janowska 01", distance: 271},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa 03", distance: 292},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa", distance: 318},
        {type: OfferPoiType.BUS, name: "Cisowa Sibeliusa 01", distance: 348},
        {type: OfferPoiType.BUS, name: "Rzepakowa 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Owsiana", distance: 669},
        {type: OfferPoiType.BUS, name: "Rzepakowa 02", distance: 689},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1342}
    ],
    20072: [{type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 781}],
    20073: [
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 01", distance: 134},
        {type: OfferPoiType.BUS, name: "Trzeciakowskich 02", distance: 198},
        {type: OfferPoiType.BUS, name: "Królika 02", distance: 709},
        {type: OfferPoiType.BUS, name: "Starochylicka 01", distance: 747},
        {type: OfferPoiType.BUS, name: "Królika 01", distance: 775}
    ],
    20077: [
        {type: OfferPoiType.BUS, name: "Niwka Tuwima", distance: 95},
        {type: OfferPoiType.BUS, name: "Niwka Szybowa", distance: 439},
        {type: OfferPoiType.BUS, name: "Osiedle Bór Bloki", distance: 536},
        {type: OfferPoiType.BUS, name: "Niwka Fabryka", distance: 555},
        {type: OfferPoiType.TRAM, name: "Niwka Fabryka", distance: 571},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Kłosowskiego", distance: 582},
        {type: OfferPoiType.TRAM, name: "Niwka Kościół", distance: 841},
        {type: OfferPoiType.PARK, name: "Park Wygoda", distance: 1360}
    ],
    20078: [
        {type: OfferPoiType.BUS, name: "Marchewkowa", distance: 299},
        {type: OfferPoiType.BUS, name: "Wałbrzyska", distance: 381},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 501},
        {type: OfferPoiType.LAS, name: "skwer Katyński", distance: 567},
        {type: OfferPoiType.BUS, name: "Zabrodzka", distance: 594},
        {type: OfferPoiType.BUS, name: "Marcepanowa", distance: 602},
        {type: OfferPoiType.TRAM, name: "Klecina", distance: 715},
        {type: OfferPoiType.PARK, name: "Park Kleciński", distance: 1019},
        {type: OfferPoiType.PARK, name: "Park Migdałowy", distance: 1034},
        {type: OfferPoiType.PARK, name: "park Krzycki", distance: 1398},
        {type: OfferPoiType.PARK, name: "skwer Tymoteusza Karpowicza", distance: 1901},
        {type: OfferPoiType.PARK, name: "skwer Simony Kossak", distance: 2043}
    ],
    20080: [
        {type: OfferPoiType.BUS, name: "Bilitewskiego", distance: 679},
        {type: OfferPoiType.BUS, name: "Rubinowa", distance: 807},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 1752}
    ],
    20082: [
        {type: OfferPoiType.BUS, name: "Poświęcka", distance: 282},
        {type: OfferPoiType.BUS, name: "Poświęcka (Ośrodek zdrowia)", distance: 446},
        {type: OfferPoiType.BUS, name: "Żmigrodzka (Obwodnica)", distance: 641},
        {type: OfferPoiType.BUS, name: "Kątowa", distance: 713},
        {type: OfferPoiType.BUS, name: "Milicka", distance: 731},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 1808}
    ],
    20086: [
        {type: OfferPoiType.BUS, name: "Zacharzyce", distance: 165},
        {type: OfferPoiType.PARK, name: "Park Bieńkowicki", distance: 1597},
        {type: OfferPoiType.PARK, name: "Park Na Skraju", distance: 1955}
    ],
    20087: [
        {type: OfferPoiType.BUS, name: "Stocznia", distance: 103},
        {type: OfferPoiType.BUS, name: "Portowa", distance: 407},
        {type: OfferPoiType.PARK, name: "Plac Majora Janusza Mościckiego", distance: 1606}
    ],
    20088: [
        {type: OfferPoiType.BUS, name: "Wysockiego 02", distance: 144},
        {type: OfferPoiType.BUS, name: "Wysockiego 01", distance: 158},
        {type: OfferPoiType.BUS, name: "Broniewskiego 02", distance: 232},
        {type: OfferPoiType.BUS, name: "Broniewskiego 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Kopernika/Kasprowicza 62", distance: 551},
        {type: OfferPoiType.BUS, name: "Osiedle Wschód 02", distance: 567},
        {type: OfferPoiType.BUS, name: "Osiedle Wschód 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Kopernika/Kasprowicza 17", distance: 609},
        {type: OfferPoiType.BUS, name: "Osiedle Kasprowicza 02", distance: 716},
        {type: OfferPoiType.BUS, name: "Kopernika/Azaliowa 58", distance: 725},
        {type: OfferPoiType.PARK, name: "Park Krainy Polodowcowej", distance: 954}
    ],
    20092: [
        {type: OfferPoiType.BUS, name: "Hubalczyków 02", distance: 227},
        {type: OfferPoiType.BUS, name: "Hubalczyków 01", distance: 299},
        {type: OfferPoiType.BUS, name: "Fort Wola 05", distance: 330},
        {type: OfferPoiType.TRAM, name: "Fort Wola 03", distance: 427},
        {type: OfferPoiType.BUS, name: "Fort Wola 01", distance: 438},
        {type: OfferPoiType.TRAM, name: "Fort Wola 04", distance: 475},
        {type: OfferPoiType.BUS, name: "Fort Wola 06", distance: 489},
        {type: OfferPoiType.BUS, name: "Fort Wola 02", distance: 496},
        {type: OfferPoiType.BUS, name: "P+R Połczyńska 01", distance: 568},
        {type: OfferPoiType.BUS, name: "Jana Kazimierza 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Cm. Wolski 07", distance: 607},
        {type: OfferPoiType.BUS, name: "Cm. Wolski 09", distance: 612},
        {type: OfferPoiType.PARK, name: "Skwer Zielone Odolany", distance: 620},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 05", distance: 654},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 04", distance: 660},
        {type: OfferPoiType.TRAM, name: "Cm. Wolski 03", distance: 666},
        {type: OfferPoiType.TRAM, name: "P+R Połczyńska 03", distance: 687},
        {type: OfferPoiType.TRAM, name: "P+R Połczyńska 04", distance: 689},
        {type: OfferPoiType.PARK, name: "Park Powstańców Warszawy", distance: 1095},
        {type: OfferPoiType.PARK, name: "Polanka", distance: 1234},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Klincewicza", distance: 1325},
        {type: OfferPoiType.PARK, name: "Skwer Wiesława Michnikowskiego", distance: 1398},
        {type: OfferPoiType.PARK, name: "Skwer pułkownika Zdzisława Kuźmirskiego-Pacaka", distance: 1793}
    ],
    20093: [
        {type: OfferPoiType.BUS, name: "Góra Kalwaria Marianki III", distance: 703},
        {type: OfferPoiType.BUS, name: "Kalwaryjska 02", distance: 794},
        {type: OfferPoiType.PARK, name: "Skwer Dominikański", distance: 1275},
        {type: OfferPoiType.PARK, name: "Skwer Marszałka Józefa Piłsudskiego", distance: 1519},
        {type: OfferPoiType.PARK, name: "Skwer Adama i Ewy", distance: 1609},
        {type: OfferPoiType.PARK, name: "Ogród Miejski", distance: 1673},
        {type: OfferPoiType.PARK, name: "Park Witolda Pyrkosza", distance: 1951},
        {type: OfferPoiType.PARK, name: "Ogród Klasztorny", distance: 2040}
    ],
    20094: [
        {type: OfferPoiType.BUS, name: "Techników 01", distance: 19},
        {type: OfferPoiType.BUS, name: "Techników 02", distance: 72},
        {type: OfferPoiType.BUS, name: "Stawy 01", distance: 206},
        {type: OfferPoiType.BUS, name: "Stawy 02", distance: 258},
        {type: OfferPoiType.BUS, name: "Mikołajska 03", distance: 264},
        {type: OfferPoiType.BUS, name: "Płużańska 01", distance: 318},
        {type: OfferPoiType.BUS, name: "Mikołajska 02", distance: 439},
        {type: OfferPoiType.BUS, name: "Płużańska 02", distance: 449},
        {type: OfferPoiType.PARK, name: "Park ze Stawami Cietrzewia", distance: 557},
        {type: OfferPoiType.BUS, name: "PKP Włochy 02", distance: 574},
        {type: OfferPoiType.BUS, name: "PKP Włochy 01", distance: 607},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Włochy", distance: 772},
        {type: OfferPoiType.PARK, name: "Ogrody Kosmosu", distance: 824},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 940},
        {type: OfferPoiType.PARK, name: "Park ze Stawem Koziorożca", distance: 1266},
        {type: OfferPoiType.PARK, name: "Skwer 16 Września 1944 r.", distance: 1426},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 2203},
        {type: OfferPoiType.PARK, name: "ROD Fort Szczęśliwice", distance: 2362}
    ],
    20098: [
        {type: OfferPoiType.BUS, name: "Młodej Polski 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 02", distance: 370},
        {type: OfferPoiType.BUS, name: "Młodej Polski 02", distance: 377},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 04", distance: 436},
        {type: OfferPoiType.BUS, name: "Wydział Farmaceutyczny 02", distance: 488},
        {type: OfferPoiType.BUS, name: "Akademia W. Pola 02", distance: 621},
        {type: OfferPoiType.BUS, name: "Orfeusz 03", distance: 681},
        {type: OfferPoiType.BUS, name: "Szpital dziecięcy 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Akademia W. Pola 01", distance: 702},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1974},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 2136}
    ],
    20099: [
        {type: OfferPoiType.BUS, name: "Klasztorna 01", distance: 291},
        {type: OfferPoiType.BUS, name: "Klasztorna 02", distance: 389},
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego 02", distance: 443},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Rembertów", distance: 480},
        {type: OfferPoiType.BUS, name: "Grawerska 01", distance: 481},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 71", distance: 486},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 03", distance: 521},
        {type: OfferPoiType.BUS, name: "Niedziałkowskiego 01", distance: 584},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 04", distance: 590},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 02", distance: 599},
        {type: OfferPoiType.BUS, name: "PKP Rembertów 05", distance: 615},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Kawęczyn", distance: 1474}
    ],
    20100: [
        {type: OfferPoiType.BUS, name: "Twardzickiego / Łochowskiego", distance: 205},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Kleina", distance: 299},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Bołtucia", distance: 633},
        {type: OfferPoiType.BUS, name: "Korfantego / Prejsa", distance: 768},
        {type: OfferPoiType.BUS, name: "Pod Skarpą / Frydrychowicza", distance: 775},
        {type: OfferPoiType.PARK, name: "Dolina Śmierci", distance: 1138},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1885},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 2241}
    ],
    20101: [
        {type: OfferPoiType.BUS, name: "Anielewicza 03", distance: 142},
        {type: OfferPoiType.TRAM, name: "Anielewicza 06", distance: 143},
        {type: OfferPoiType.BUS, name: "Anielewicza 04", distance: 193},
        {type: OfferPoiType.BUS, name: "Anielewicza 01", distance: 196},
        {type: OfferPoiType.TRAM, name: "Anielewicza 05", distance: 199},
        {type: OfferPoiType.BUS, name: "Anielewicza 02", distance: 201},
        {type: OfferPoiType.BUS, name: "Nalewki-Muzeum 01", distance: 312},
        {type: OfferPoiType.BUS, name: "Nalewki-Muzeum 02", distance: 339},
        {type: OfferPoiType.BUS, name: "Smocza 03", distance: 373},
        {type: OfferPoiType.BUS, name: "Smocza 04", distance: 408},
        {type: OfferPoiType.PARK, name: "Skwer gen. Jana Jura-Gorzechowskiego", distance: 417},
        {type: OfferPoiType.BUS, name: "Nowolipki 03", distance: 426},
        {type: OfferPoiType.TRAM, name: "Nowolipki 06", distance: 454},
        {type: OfferPoiType.BUS, name: "Nowolipki 02", distance: 461},
        {type: OfferPoiType.TRAM, name: "Nowolipki 05", distance: 496},
        {type: OfferPoiType.TRAM, name: "Stawki 06", distance: 569},
        {type: OfferPoiType.PARK, name: "Skwer Więźniów Politycznych Stalinizmu", distance: 618},
        {type: OfferPoiType.PARK, name: "Skwer Racheli Auerbach", distance: 625},
        {type: OfferPoiType.TRAM, name: "Muranów 06", distance: 644},
        {type: OfferPoiType.TRAM, name: "Muranów 05", distance: 651},
        {type: OfferPoiType.TRAM, name: "Stawki 05", distance: 652},
        {type: OfferPoiType.TRAM, name: "Kino Femina 06", distance: 764},
        {type: OfferPoiType.TRAM, name: "Dzika 03", distance: 765},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 768},
        {type: OfferPoiType.PARK, name: "Ogród Krasińskich", distance: 946},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Warszawy", distance: 1866}
    ],
    20103: [
        {type: OfferPoiType.BUS, name: "Żywiecka 02", distance: 584},
        {type: OfferPoiType.BUS, name: "Żywiecka 01", distance: 732},
        {type: OfferPoiType.BUS, name: "Kępna 01", distance: 742},
        {type: OfferPoiType.BUS, name: "Rynek Fałęcki 01", distance: 787},
        {type: OfferPoiType.BUS, name: "Rynek Fałęcki 02", distance: 807},
        {type: OfferPoiType.PARK, name: "Park Solvay", distance: 914},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 1271},
        {type: OfferPoiType.PARK, name: "Park rzeczny Wilgi", distance: 1625},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1850}
    ],
    20105: [
        {type: OfferPoiType.BUS, name: "Cystersów 03", distance: 170},
        {type: OfferPoiType.TRAM, name: "Cystersów 02", distance: 261},
        {type: OfferPoiType.TRAM, name: "Cystersów 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 07", distance: 405},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 06", distance: 507},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 04", distance: 521},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 03", distance: 549},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 02", distance: 552},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 01", distance: 554},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 09", distance: 592},
        {type: OfferPoiType.TRAM, name: "Rondo Mogilskie 05", distance: 600},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie 08", distance: 613},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Polaków Poszkodowanych przez III Rzeszę", distance: 622},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 631},
        {type: OfferPoiType.BUS, name: "Rondo Mogilskie Opera 02", distance: 672},
        {type: OfferPoiType.BUS, name: "Brodowicza 01", distance: 717},
        {type: OfferPoiType.BUS, name: "Brodowicza 02", distance: 742},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 780},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 796},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 804},
        {type: OfferPoiType.BUS, name: "Białucha 03", distance: 844},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 945},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 979},
        {type: OfferPoiType.PARK, name: "Ogród Fabryczny", distance: 1029},
        {type: OfferPoiType.PARK, name: "Ogród Kasztanowy", distance: 1318},
        {type: OfferPoiType.PARK, name: "Park Strzelecki", distance: 1332},
        {type: OfferPoiType.PARK, name: "Łąka na Wesołej", distance: 1398},
        {type: OfferPoiType.PARK, name: "Skwer Pilota Pirxa", distance: 1562},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2246},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2475}
    ],
    20115: [
        {type: OfferPoiType.BUS, name: "Kacze Buki Puszczyka 01", distance: 235},
        {type: OfferPoiType.BUS, name: "Bieszczadzka 02 (ŃŻ)", distance: 308},
        {type: OfferPoiType.BUS, name: "Bieszczadzka", distance: 309},
        {type: OfferPoiType.BUS, name: "Bieszczadzka 01 (ŃŻ)", distance: 311}
    ],
    20116: [
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 01", distance: 219},
        {type: OfferPoiType.BUS, name: "Młodej Polski 01", distance: 390},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 02", distance: 407},
        {type: OfferPoiType.BUS, name: "Wydział Farmaceutyczny 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Rondo Kamińskiego 04", distance: 473},
        {type: OfferPoiType.BUS, name: "Młodej Polski 02", distance: 535},
        {type: OfferPoiType.BUS, name: "Chodźki - szpital 01", distance: 713},
        {type: OfferPoiType.BUS, name: "Orfeusz 03", distance: 718},
        {type: OfferPoiType.BUS, name: "Szpital dziecięcy 02", distance: 727},
        {type: OfferPoiType.BUS, name: "Chodźki - szpital 03", distance: 758},
        {type: OfferPoiType.PARK, name: "Skwer Tarasa Szewczenki", distance: 2114},
        {type: OfferPoiType.PARK, name: "50-lecia", distance: 2120},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 2132}
    ],
    20117: [
        {type: OfferPoiType.BUS, name: "Bojano 61", distance: 672},
        {type: OfferPoiType.BUS, name: "Bojano", distance: 673},
        {type: OfferPoiType.BUS, name: "Bojano 18", distance: 674}
    ],
    20118: [{type: OfferPoiType.BUS, name: "Bartąg Fiołkowa P", distance: 819}],
    20119: [
        {type: OfferPoiType.BUS, name: "Tartaczna/Straż Graniczna (122)", distance: 258},
        {type: OfferPoiType.BUS, name: "Tartaczna/Bloki (123)", distance: 339},
        {type: OfferPoiType.BUS, name: "Tartaczna/Pętla (113)", distance: 367},
        {type: OfferPoiType.BUS, name: "Turystyczna/Augustowianka (n/ż) (44)", distance: 370},
        {type: OfferPoiType.BUS, name: "Turystyczna/Rozlewnia Augustowianki (n/ż) (3)", distance: 382},
        {type: OfferPoiType.BUS, name: "Turystyczna/Wypoczynkowa (n/ż) (2)", distance: 440},
        {type: OfferPoiType.BUS, name: "Turystyczna/Jednostka Wojskowa (124) (n/ż)", distance: 490},
        {type: OfferPoiType.BUS, name: "Tartaczna/Os. Lipowiec (73)", distance: 492},
        {type: OfferPoiType.BUS, name: "Tartaczna/Szkoła nr 6 (42)", distance: 614},
        {type: OfferPoiType.PARK, name: "Park Herberta", distance: 807},
        {type: OfferPoiType.LAS, name: "7", distance: 905}
    ],
    20121: [
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 08", distance: 173},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 03", distance: 265},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 04", distance: 304},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 02", distance: 318},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 03", distance: 327},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 04", distance: 333},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 05", distance: 344},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 06", distance: 355},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 01", distance: 364},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 06", distance: 372},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 01", distance: 381},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 07", distance: 432},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 05", distance: 437},
        {type: OfferPoiType.BUS, name: "Arka Pana 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Os. Zgody 04", distance: 473},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 01", distance: 522},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 02", distance: 539},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 660},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 697},
        {type: OfferPoiType.TRAM, name: "Cienista 02", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 956},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1177},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 1194},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 1233},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1555},
        {type: OfferPoiType.PARK, name: "Ogródek Wiewiórek", distance: 1623},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1891}
    ],
    20123: [
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 08", distance: 173},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 03", distance: 265},
        {type: OfferPoiType.PARK, name: "Teatralny Ogród Krakowian", distance: 297},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 04", distance: 304},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 02", distance: 318},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 03", distance: 327},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 04", distance: 333},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 05", distance: 344},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 06", distance: 355},
        {type: OfferPoiType.TRAM, name: "Teatr Ludowy 01", distance: 364},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 06", distance: 372},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 01", distance: 381},
        {type: OfferPoiType.TRAM, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 02", distance: 404},
        {type: OfferPoiType.BUS, name: "Rondo Kocmyrzowskie im. Ks. Gorzelanego 07", distance: 432},
        {type: OfferPoiType.BUS, name: "Teatr Ludowy 05", distance: 437},
        {type: OfferPoiType.BUS, name: "Arka Pana 01", distance: 468},
        {type: OfferPoiType.BUS, name: "Os. Zgody 04", distance: 473},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 01", distance: 522},
        {type: OfferPoiType.TRAM, name: "Os. Zgody 02", distance: 539},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Wojciecha Narębskiego", distance: 660},
        {type: OfferPoiType.PARK, name: "Park Wiśniowy Sad", distance: 697},
        {type: OfferPoiType.TRAM, name: "Cienista 02", distance: 827},
        {type: OfferPoiType.PARK, name: "Park Ratuszowy", distance: 956},
        {type: OfferPoiType.PARK, name: "Planty Bieńczyckie", distance: 1177},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Staw Kaczeńcowy", distance: 1194},
        {type: OfferPoiType.REZERWAT, name: "Staw przy Kaczeńcowej", distance: 1233},
        {type: OfferPoiType.PARK, name: "Park Szwedzki", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Ogród Relaksacyjny", distance: 1555},
        {type: OfferPoiType.PARK, name: "Ogródek Wiewiórek", distance: 1623},
        {type: OfferPoiType.REZERWAT, name: "Łąki Nowohuckie", distance: 1891}
    ],
    20125: [
        {type: OfferPoiType.BUS, name: "Pylna 02", distance: 410},
        {type: OfferPoiType.BUS, name: "Pylna 01", distance: 416},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 1659},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1906},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 2052},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2173}
    ],
    20126: [
        {type: OfferPoiType.BUS, name: "Grabowa 01", distance: 164},
        {type: OfferPoiType.BUS, name: "Grabowa 02", distance: 267},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 02", distance: 484},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 01", distance: 549},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 01", distance: 709},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 02", distance: 719},
        {type: OfferPoiType.BUS, name: "Zielony Dół 01", distance: 739},
        {type: OfferPoiType.BUS, name: "Zielony Dół 02", distance: 782},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1084},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1353},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 1357}
    ],
    20127: [
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1838},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1984},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2105},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 2441}
    ],
    20128: [
        {type: OfferPoiType.BUS, name: "Pylna 02", distance: 161},
        {type: OfferPoiType.BUS, name: "Pylna 01", distance: 167},
        {type: OfferPoiType.BUS, name: "Kraków Zakliki", distance: 685},
        {type: OfferPoiType.KOLEJ, name: "Kraków Zakliki", distance: 755},
        {type: OfferPoiType.BUS, name: "Zakliki SKA 02", distance: 798},
        {type: OfferPoiType.BUS, name: "Zakliki SKA 01", distance: 801},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 1410},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2258},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 2404},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2525}
    ],
    20129: [
        {type: OfferPoiType.BUS, name: "Grabowa 02", distance: 249},
        {type: OfferPoiType.BUS, name: "Grabowa 01", distance: 277},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 01", distance: 525},
        {type: OfferPoiType.BUS, name: "Wilczy Stok 02", distance: 535},
        {type: OfferPoiType.BUS, name: "Zielony Dół 01", distance: 594},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 02", distance: 613},
        {type: OfferPoiType.BUS, name: "Zielony Dół 02", distance: 637},
        {type: OfferPoiType.BUS, name: "Panieńskich Skał 01", distance: 689},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1222},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 1368},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 1489}
    ],
    20130: [
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 1886},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Panieńskie Skały", distance: 2032},
        {type: OfferPoiType.PARK, name: "Park Decjusza", distance: 2153},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy - Malwowy Ogród", distance: 2489}
    ],
    20133: [
        {type: OfferPoiType.BUS, name: "Miłosza Szkoła", distance: 786},
        {type: OfferPoiType.PARK, name: "park Warszewo-Podbórz", distance: 1880},
        {type: OfferPoiType.PARK, name: "Park Złotowska", distance: 2175},
        {type: OfferPoiType.PARK, name: "park Lipy", distance: 2208}
    ],
    20134: [
        {type: OfferPoiType.BUS, name: "Okrągła 01", distance: 222},
        {type: OfferPoiType.BUS, name: "Sieczna 02", distance: 286},
        {type: OfferPoiType.BUS, name: "Okrągła 02", distance: 332},
        {type: OfferPoiType.BUS, name: "Sieczna 01", distance: 359},
        {type: OfferPoiType.BUS, name: "Os. Derby 02", distance: 385},
        {type: OfferPoiType.BUS, name: "Os. Derby 01", distance: 494},
        {type: OfferPoiType.BUS, name: "Os. Derby 04", distance: 515},
        {type: OfferPoiType.BUS, name: "Podwójna 01", distance: 560},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 01", distance: 590},
        {type: OfferPoiType.BUS, name: "Podwójna 02", distance: 607},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 782}
    ],
    20136: [
        {type: OfferPoiType.BUS, name: "Gen. Maczka 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 04", distance: 456},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 03", distance: 489},
        {type: OfferPoiType.BUS, name: "Park Olszyna 06", distance: 496},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 01", distance: 531},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 03", distance: 584},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 04", distance: 640},
        {type: OfferPoiType.BUS, name: "Park Olszyna 02", distance: 643},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 04", distance: 652},
        {type: OfferPoiType.BUS, name: "Kochanowskiego 01", distance: 671},
        {type: OfferPoiType.BUS, name: "Włościańska 01", distance: 685},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 02", distance: 693},
        {type: OfferPoiType.TRAM, name: "Romaszewskiego 03", distance: 824},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 853},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1338},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1339},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1402},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 1686},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1723},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1779},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 1824}
    ],
    20138: [
        {type: OfferPoiType.BUS, name: "Gen. Maczka 02", distance: 148},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 04", distance: 221},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 03", distance: 254},
        {type: OfferPoiType.BUS, name: "Gen. Maczka 01", distance: 296},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 02", distance: 458},
        {type: OfferPoiType.BUS, name: "Park Olszyna 06", distance: 506},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 01", distance: 576},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 03", distance: 594},
        {type: OfferPoiType.TRAM, name: "Park Olszyna 04", distance: 650},
        {type: OfferPoiType.BUS, name: "Park Olszyna 02", distance: 653},
        {type: OfferPoiType.BUS, name: "Włościańska 01", distance: 695},
        {type: OfferPoiType.BUS, name: "Powązki-Cmentarz Wojskowy 04", distance: 743},
        {type: OfferPoiType.TRAM, name: "Romaszewskiego 03", distance: 834},
        {type: OfferPoiType.REZERWAT, name: "Park Olszyna", distance: 863},
        {type: OfferPoiType.PARK, name: "Skwer Aleksandry Piłsudskiej", distance: 1103},
        {type: OfferPoiType.PARK, name: "Park Zbigniewa Herberta", distance: 1349},
        {type: OfferPoiType.PARK, name: "Skwer Kaliny", distance: 1544},
        {type: OfferPoiType.PARK, name: "Skwer Jerzego Jarnuszkiewicza", distance: 1589},
        {type: OfferPoiType.PARK, name: "Park Sady Żoliborskie", distance: 1696},
        {type: OfferPoiType.PARK, name: "Serek Bielański", distance: 1733},
        {type: OfferPoiType.PARK, name: "Skwer Lane'a Kirklanda", distance: 1834}
    ],
    20145: [
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 421},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Powst. Listopad. 06", distance: 499},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 537},
        {type: OfferPoiType.BUS, name: "Krzyżanowskiego / Armii Krajowej 04", distance: 656},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 660},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 694},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Krzyżanowskiego 03", distance: 702},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 740},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 1912},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 2141}
    ],
    20146: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Powst. Listopad. 06", distance: 367},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 03", distance: 412},
        {type: OfferPoiType.BUS, name: "Krzyżanowskiego / Armii Krajowej 04", distance: 524},
        {type: OfferPoiType.BUS, name: "Paderewskiego park 06", distance: 528},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Krzyżanowskiego 03", distance: 570},
        {type: OfferPoiType.BUS, name: "Paderewskiego / Armii Krajowej 04", distance: 639},
        {type: OfferPoiType.BUS, name: "Krzyżanowskiego / Paderewskiego 03", distance: 668},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Szafera", distance: 685},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Paderewskiego 08", distance: 731},
        {type: OfferPoiType.BUS, name: "Armii Krajowej / Mieszka I 05", distance: 762},
        {type: OfferPoiType.PARK, name: "Park Papieski", distance: 1780},
        {type: OfferPoiType.PARK, name: "Ogród kieszonkowy Bielefeld", distance: 2132}
    ],
    20147: [
        {type: OfferPoiType.BUS, name: "Warmińska 02", distance: 332},
        {type: OfferPoiType.BUS, name: "Warmińska 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Bruszewska 01", distance: 746}
    ],
    20151: [
        {type: OfferPoiType.PARK, name: "Park Zdrojowy Mateczny", distance: 564},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 05", distance: 600},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 01", distance: 722},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 02", distance: 731},
        {type: OfferPoiType.TRAM, name: "Rzemieślnicza 02", distance: 733},
        {type: OfferPoiType.TRAM, name: "Rondo Matecznego 01", distance: 746},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 03", distance: 755},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 06", distance: 757},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 04", distance: 759},
        {type: OfferPoiType.BUS, name: "Rzemieślnicza 03", distance: 760},
        {type: OfferPoiType.BUS, name: "Ludwinów 01", distance: 768},
        {type: OfferPoiType.BUS, name: "Ludwinów 02", distance: 812},
        {type: OfferPoiType.BUS, name: "Rondo Matecznego 04", distance: 819},
        {type: OfferPoiType.PARK, name: "Ogród Chwastowy", distance: 1053},
        {type: OfferPoiType.PARK, name: "Park Planty Floriana Nowackiego", distance: 1133},
        {type: OfferPoiType.PARK, name: "skwer Dworski", distance: 1433},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Leśny", distance: 1493},
        {type: OfferPoiType.PARK, name: "Skwer Marii Dulębianki", distance: 1505},
        {type: OfferPoiType.PARK, name: "Park imienia Wojciecha Bednarskiego", distance: 1682},
        {type: OfferPoiType.PARK, name: "skwer Zdrowia", distance: 1772},
        {type: OfferPoiType.PARK, name: "Kieszonkowy Park Sąsiedzki", distance: 1858},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2147},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek - Enklawa Wschodnia", distance: 2326},
        {type: OfferPoiType.REZERWAT, name: 'Rezerwat geologiczny "Bonarka"', distance: 2383}
    ],
    20153: [
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 379},
        {type: OfferPoiType.BUS, name: "Marysińska - Szklana", distance: 434},
        {type: OfferPoiType.BUS, name: "Marysińska - Okopowa", distance: 482},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Park Szarych Szeregów", distance: 547},
        {type: OfferPoiType.BUS, name: "Marysin Stadion", distance: 553},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Okopowa", distance: 589},
        {type: OfferPoiType.BUS, name: "Obr. Westerplatte - Organizacji WiN", distance: 722},
        {type: OfferPoiType.BUS, name: "Boya-Żeleńskiego - Sucharskiego", distance: 726},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 917},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 1283},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1357},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1401},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1502},
        {type: OfferPoiType.PARK, name: "Bulwary nad Łódką", distance: 1570},
        {type: OfferPoiType.PARK, name: "Park Helenów", distance: 1632}
    ],
    20159: [
        {type: OfferPoiType.PARK, name: "Małe Wilczyce", distance: 238},
        {type: OfferPoiType.BUS, name: "Kiełczowska (Cmentarz)", distance: 324}
    ],
    20161: [
        {type: OfferPoiType.BUS, name: "Krynoliny 01", distance: 171},
        {type: OfferPoiType.BUS, name: "Krynoliny 02", distance: 188},
        {type: OfferPoiType.PARK, name: "Park linearny nad Kanałem Zaciszańskim", distance: 488},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 04", distance: 555},
        {type: OfferPoiType.BUS, name: "Bystra 02", distance: 580},
        {type: OfferPoiType.BUS, name: "Bystra 01", distance: 588},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 02", distance: 594},
        {type: OfferPoiType.BUS, name: "Codzienna 02", distance: 682},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 01", distance: 696},
        {type: OfferPoiType.BUS, name: "Młodzieńcza 03", distance: 731},
        {type: OfferPoiType.BUS, name: "Codzienna 01", distance: 782},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Ciechowskiego", distance: 1856},
        {type: OfferPoiType.PARK, name: "Skwer Ekologiczny", distance: 1926},
        {type: OfferPoiType.PARK, name: 'Skwer rekreacyjno-wypoczynkowy "KOTWICA"', distance: 2260}
    ],
    20163: [
        {type: OfferPoiType.BUS, name: "Karolin 02", distance: 589},
        {type: OfferPoiType.BUS, name: "Karolin 01", distance: 649}
    ],
    20164: [
        {type: OfferPoiType.BUS, name: "Sienkiewicza - Traugutta", distance: 457},
        {type: OfferPoiType.BUS, name: "Traugutta - Sienkiewicza", distance: 463},
        {type: OfferPoiType.BUS, name: "Łódzka Inf. Turystyczna", distance: 505},
        {type: OfferPoiType.BUS, name: "Jaracza - Piotrkowska", distance: 508},
        {type: OfferPoiType.BUS, name: "Kilińskiego - Narutowicza", distance: 519},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Narutowicza", distance: 526},
        {type: OfferPoiType.PARK, name: "Pasaż Artura Rubinsteina", distance: 639},
        {type: OfferPoiType.PARK, name: "Skwer Profesora Władysława Raczkowskiego", distance: 642},
        {type: OfferPoiType.TRAM, name: "Kościuszki - 6 Sierpnia", distance: 660},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Przystanek mBank", distance: 669},
        {type: OfferPoiType.BUS, name: "Jaracza - Kilińskiego", distance: 670},
        {type: OfferPoiType.TRAM, name: "Zachodnia - Więckowskiego", distance: 686},
        {type: OfferPoiType.BUS, name: "Narutowicza - P.O.W. NŻ", distance: 689},
        {type: OfferPoiType.PARK, name: "Park Moniuszki", distance: 693},
        {type: OfferPoiType.TRAM, name: "Kilińskiego - Jaracza", distance: 704},
        {type: OfferPoiType.BUS, name: "Kościuszki - 6 Sierpnia", distance: 717},
        {type: OfferPoiType.BUS, name: "Więckowskiego - Zachodnia", distance: 721},
        {type: OfferPoiType.PARK, name: "Skwer Aliny Margolis-Edelman", distance: 741},
        {type: OfferPoiType.TRAM, name: "Rodziny Poznańskich - Dw. Łódź Fabryczna", distance: 763},
        {type: OfferPoiType.PARK, name: "Skwer Kazimierza Balda", distance: 839},
        {type: OfferPoiType.PARK, name: "Skwer Wiedźmina", distance: 904},
        {type: OfferPoiType.PARK, name: "Skwer Barbary Wachowicz-Napiórkowskiej", distance: 908},
        {type: OfferPoiType.PARK, name: "Skwer Powstania Węgierskiego 1956 r.", distance: 928}
    ],
    20165: [
        {type: OfferPoiType.BUS, name: "Widzewska - Wiejska", distance: 195},
        {type: OfferPoiType.BUS, name: "Piłsudskiego - Widzew Stadion", distance: 554},
        {type: OfferPoiType.TRAM, name: "Piłsudskiego - Widzew Stadion", distance: 554},
        {type: OfferPoiType.PARK, name: "Park Widzewski", distance: 879},
        {type: OfferPoiType.PARK, name: "Widzewska Górka I", distance: 880},
        {type: OfferPoiType.PARK, name: "Widzewska Górka II", distance: 1157},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 1907},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 2054},
        {type: OfferPoiType.PARK, name: "Lasek Widzewski", distance: 2497}
    ],
    20168: [
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 08", distance: 171},
        {type: OfferPoiType.BUS, name: "Galeria Copernicus 02", distance: 300},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego II 07", distance: 358},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 05", distance: 370},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 04", distance: 427},
        {type: OfferPoiType.TRAM, name: "Plac Daszyńskiego 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 06", distance: 508},
        {type: OfferPoiType.TRAM, name: "Plac Daszyńskiego 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Plac Daszyńskiego 03", distance: 595},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 02", distance: 639},
        {type: OfferPoiType.BUS, name: "Dworzec Wschodni 01", distance: 703},
        {type: OfferPoiType.TRAM, name: "Dworzec Wschodni 06", distance: 819},
        {type: OfferPoiType.PARK, name: "Greckie Klimaty", distance: 1433},
        {type: OfferPoiType.PARK, name: "Dawny cmentarz żydowski", distance: 1860}
    ],
    20177: [
        {type: OfferPoiType.BUS, name: "Małomiejska", distance: 155},
        {type: OfferPoiType.BUS, name: "Platynowa 01", distance: 534},
        {type: OfferPoiType.BUS, name: "Platynowa 04", distance: 621},
        {type: OfferPoiType.BUS, name: "Ptasia", distance: 648},
        {type: OfferPoiType.BUS, name: "Platynowa 02", distance: 686},
        {type: OfferPoiType.BUS, name: "Platynowa 03", distance: 692},
        {type: OfferPoiType.BUS, name: "Orunia Górna 01", distance: 699},
        {type: OfferPoiType.BUS, name: "Ptasia 02", distance: 738},
        {type: OfferPoiType.BUS, name: "Chełm - Więckowskiego 01", distance: 740},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1154},
        {type: OfferPoiType.REZERWAT, name: 'Zespół przyrodniczo-krajobrazowy "Dolina Potoku Oruńskiego"', distance: 1222},
        {type: OfferPoiType.PARK, name: "Park Oruński im. Emilii Hoene", distance: 1549},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 1661},
        {type: OfferPoiType.PARK, name: 'Skwer im. Danuty Siedzikówny "Inki"', distance: 1703},
        {type: OfferPoiType.PARK, name: "Park Schopenhauera", distance: 1770}
    ],
    20178: [
        {type: OfferPoiType.BUS, name: "Torfowa 02", distance: 181},
        {type: OfferPoiType.BUS, name: "Torfowa 01", distance: 325},
        {type: OfferPoiType.BUS, name: "Zachodnia 01", distance: 376},
        {type: OfferPoiType.BUS, name: "Zachodnia 02", distance: 518},
        {type: OfferPoiType.BUS, name: "Lubostroń 01", distance: 665},
        {type: OfferPoiType.BUS, name: "Lubostroń 03", distance: 672},
        {type: OfferPoiType.BUS, name: "Lubostroń 04", distance: 698},
        {type: OfferPoiType.BUS, name: "Lubostroń 02", distance: 807},
        {type: OfferPoiType.BUS, name: "Kampus UP JP II 03", distance: 814},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 1194},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 2033},
        {type: OfferPoiType.REZERWAT, name: "Zakrzówek", distance: 2285}
    ],
    20179: [
        {type: OfferPoiType.BUS, name: "Wrocław Szczepin", distance: 204},
        {type: OfferPoiType.TRAM, name: "Wrocław Szczepin", distance: 204},
        {type: OfferPoiType.KOLEJ, name: "Wrocław Szczepin", distance: 225},
        {type: OfferPoiType.TRAM, name: "Długa (ogrody działkowe)", distance: 407},
        {type: OfferPoiType.BUS, name: "Długa (ogrody działkowe)", distance: 421},
        {type: OfferPoiType.BUS, name: "Litomska (ZUS)", distance: 534},
        {type: OfferPoiType.BUS, name: "Michalczyka", distance: 582},
        {type: OfferPoiType.TRAM, name: "Michalczyka", distance: 596},
        {type: OfferPoiType.PARK, name: "skwer Świętego Ojca Damiana de Veuster", distance: 897},
        {type: OfferPoiType.REZERWAT, name: "Siedlisko Kozioroga Dębosza", distance: 2401}
    ],
    20180: [
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 08", distance: 219},
        {type: OfferPoiType.BUS, name: "Ustronie / Radomskiego", distance: 303},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Świerkowa 05", distance: 316},
        {type: OfferPoiType.BUS, name: "Biała / Indycza (Tymczasowy)", distance: 418},
        {type: OfferPoiType.BUS, name: "Wyścigowa / Radomskiego", distance: 466},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 06", distance: 526},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Słowackiego 07", distance: 555},
        {type: OfferPoiType.BUS, name: "Grzecznarowskiego / Osiedlowa 03", distance: 674},
        {type: OfferPoiType.PARK, name: "Park Ustronie", distance: 1661},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Ruzika", distance: 1912},
        {type: OfferPoiType.PARK, name: "Sadek", distance: 2139},
        {type: OfferPoiType.PARK, name: "Plac Kazimierza Ołdakowskiego", distance: 2213}
    ],
    20181: [
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 02", distance: 356},
        {type: OfferPoiType.BUS, name: "Nowa Gdańska 01", distance: 511},
        {type: OfferPoiType.PARK, name: "Park księdza kanonika Kazimierza Orkusza", distance: 1206},
        {type: OfferPoiType.PARK, name: "Plac Biskupa Edwarda O’Rourke", distance: 1930},
        {type: OfferPoiType.PARK, name: "Park Millenium", distance: 2005}
    ],
    20183: [
        {type: OfferPoiType.BUS, name: "Reduta 02", distance: 336},
        {type: OfferPoiType.BUS, name: "Reduta 01", distance: 495},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 04", distance: 654},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R", distance: 714},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 01", distance: 721},
        {type: OfferPoiType.BUS, name: "Prądnik Czerwony P+R 02", distance: 791},
        {type: OfferPoiType.LAS, name: "Park Krakowian - Węgrzecka", distance: 838},
        {type: OfferPoiType.PARK, name: "Ogród nad Sudołem", distance: 1594},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 1634},
        {type: OfferPoiType.PARK, name: "Park Zaczarowanej Dorożki", distance: 2071}
    ],
    20185: [{type: OfferPoiType.PARK, name: "Skwer Błogosławionego Kardynała Stefana Wyszyńskiego", distance: 1896}],
    20186: [
        {type: OfferPoiType.BUS, name: "Okrągła 01", distance: 384},
        {type: OfferPoiType.BUS, name: "Okrągła 02", distance: 414},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 01", distance: 600},
        {type: OfferPoiType.BUS, name: "Sieczna 02", distance: 690},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 02", distance: 722},
        {type: OfferPoiType.BUS, name: "Os. Derby III 02", distance: 761},
        {type: OfferPoiType.BUS, name: "Sieczna 01", distance: 763},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1381}
    ],
    20192: [
        {type: OfferPoiType.BUS, name: "Jutrosińska", distance: 112},
        {type: OfferPoiType.BUS, name: "Gąsiorowskiego", distance: 216},
        {type: OfferPoiType.PARK, name: "Park Marii Dąbrowskiej", distance: 325},
        {type: OfferPoiType.BUS, name: "Kamieńskiego (Szpital)", distance: 374},
        {type: OfferPoiType.BUS, name: "Mochnackiego", distance: 595},
        {type: OfferPoiType.BUS, name: "Kamieńskiego (pętla)", distance: 660},
        {type: OfferPoiType.BUS, name: "Kamieńskiego (Pętla)", distance: 662},
        {type: OfferPoiType.PARK, name: "skwer Władysława Bełzy", distance: 1290},
        {type: OfferPoiType.PARK, name: "Park Jana Kasprowicza", distance: 1511}
    ],
    20195: [
        {type: OfferPoiType.BUS, name: "Piastów SKA 02", distance: 126},
        {type: OfferPoiType.BUS, name: "Urząd Skarbowy Nowa Huta 01", distance: 143},
        {type: OfferPoiType.BUS, name: "Piastów SKA 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Piastów SKA", distance: 348},
        {type: OfferPoiType.TRAM, name: "Os. Piastów", distance: 392},
        {type: OfferPoiType.KOLEJ, name: "Kraków Piastów", distance: 394},
        {type: OfferPoiType.BUS, name: "Os. Piastów 04", distance: 405},
        {type: OfferPoiType.TRAM, name: "Os. Piastów 01", distance: 474},
        {type: OfferPoiType.BUS, name: "Os. Piastów", distance: 497},
        {type: OfferPoiType.BUS, name: "Os. Piastów 02", distance: 525},
        {type: OfferPoiType.BUS, name: "Piasta Kołodzieja 03", distance: 808},
        {type: OfferPoiType.TRAM, name: "Piasta Kołodzieja 02", distance: 814},
        {type: OfferPoiType.PARK, name: "Planty Mistrzejowickie", distance: 1312},
        {type: OfferPoiType.PARK, name: "Polny Ogród Krakowian", distance: 1335},
        {type: OfferPoiType.PARK, name: "Park Reduta", distance: 2437},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2443}
    ],
    20199: [
        {type: OfferPoiType.BUS, name: "11 Listopada I", distance: 239},
        {type: OfferPoiType.BUS, name: "Sitarska-Kępy I", distance: 338},
        {type: OfferPoiType.BUS, name: "Sitarska-Kępy II", distance: 353},
        {type: OfferPoiType.BUS, name: "11 Listopada II", distance: 418},
        {type: OfferPoiType.BUS, name: "Ogrody", distance: 571},
        {type: OfferPoiType.BUS, name: "Księdza Popiełuszki", distance: 587},
        {type: OfferPoiType.BUS, name: "Budowlanka", distance: 629},
        {type: OfferPoiType.BUS, name: "Skwer Saski", distance: 839},
        {type: OfferPoiType.BUS, name: "Długa", distance: 842},
        {type: OfferPoiType.PARK, name: "Skwer Niepodległości", distance: 962},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 985},
        {type: OfferPoiType.PARK, name: "Park Solidarności", distance: 1125}
    ],
    20200: [
        {type: OfferPoiType.TRAM, name: "Rycerska [końcowy]", distance: 153},
        {type: OfferPoiType.BUS, name: "Rycerska [końcowy]", distance: 174},
        {type: OfferPoiType.BUS, name: "Rycerska", distance: 174},
        {type: OfferPoiType.TRAM, name: "Rycerska", distance: 210},
        {type: OfferPoiType.BUS, name: "Zaświat / Artyleryjska", distance: 362},
        {type: OfferPoiType.BUS, name: "Artyleryjska / Zaświat", distance: 392},
        {type: OfferPoiType.TRAM, name: "Dworzec Główny", distance: 645},
        {type: OfferPoiType.PARK, name: "Plac Tadeusza Kościuszki", distance: 687},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Komedy", distance: 1466},
        {type: OfferPoiType.PARK, name: "Skwer Franciszka Floriana Czakiego", distance: 1522},
        {type: OfferPoiType.PARK, name: "Park Jana Kochanowskiego", distance: 1602},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Szwalbego", distance: 1649},
        {type: OfferPoiType.PARK, name: "skwer prof. Józefa Kałużnego", distance: 1724},
        {type: OfferPoiType.PARK, name: "Park im. Kazimierza Wielkiego", distance: 1728}
    ],
    20201: [
        {type: OfferPoiType.BUS, name: "Prosta 01", distance: 321},
        {type: OfferPoiType.BUS, name: "Prosta 02", distance: 365},
        {type: OfferPoiType.BUS, name: "Prokocim Rynek 01", distance: 377},
        {type: OfferPoiType.BUS, name: "Prokocim Rynek 02", distance: 472},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 476},
        {type: OfferPoiType.TRAM, name: "Wlotowa 02", distance: 701},
        {type: OfferPoiType.TRAM, name: "Wlotowa 01", distance: 731},
        {type: OfferPoiType.KOLEJ, name: "Kraków Prokocim", distance: 738},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 763},
        {type: OfferPoiType.BUS, name: "Wlotowa 03", distance: 765},
        {type: OfferPoiType.BUS, name: "Wlotowa 04", distance: 766},
        {type: OfferPoiType.BUS, name: "Młodzieży 02", distance: 780},
        {type: OfferPoiType.BUS, name: "Młodzieży 01", distance: 820},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 956},
        {type: OfferPoiType.PARK, name: "Geograficzny Ogród Krakowian", distance: 1359},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1689},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 1900},
        {type: OfferPoiType.PARK, name: "Park Miejski Bagry Wielkie", distance: 2183}
    ],
    20202: [
        {type: OfferPoiType.TRAM, name: "Łódzka - Mały Skręt", distance: 653},
        {type: OfferPoiType.BUS, name: "Łódzka - Mały Skręt", distance: 764},
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 790},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2222},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2423}
    ],
    20204: [
        {type: OfferPoiType.BUS, name: "Jordanowska 02", distance: 136},
        {type: OfferPoiType.BUS, name: "Jordanowska 01", distance: 231},
        {type: OfferPoiType.BUS, name: "Skrajna 01", distance: 429},
        {type: OfferPoiType.BUS, name: "Chabrowa 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Skrajna 02", distance: 521},
        {type: OfferPoiType.BUS, name: "Jordanowska 04", distance: 539},
        {type: OfferPoiType.BUS, name: "Chabrowa 01", distance: 606},
        {type: OfferPoiType.BUS, name: "Pełczyńskiego 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Pełczyńskiego 02", distance: 666},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 942},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 1422},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 1807},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 1975},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 2097},
        {type: OfferPoiType.PARK, name: "Park im. Tadeusza Kościuszki", distance: 2348}
    ],
    20205: [
        {type: OfferPoiType.BUS, name: "Zielonki 02", distance: 797},
        {type: OfferPoiType.BUS, name: "Zielonki 01", distance: 836}
    ],
    20207: [
        {type: OfferPoiType.BUS, name: "Tarczyński Arena (Królewiecka)", distance: 3},
        {type: OfferPoiType.BUS, name: "Królewiecka", distance: 278},
        {type: OfferPoiType.BUS, name: "Maślicka (Osiedle)", distance: 317},
        {type: OfferPoiType.TRAM, name: "Tarczyński Arena (Królewiecka)", distance: 319},
        {type: OfferPoiType.TRAM, name: "Dworska", distance: 491},
        {type: OfferPoiType.PARK, name: "park Maślicki", distance: 1380},
        {type: OfferPoiType.PARK, name: "Park Świetlików", distance: 1437},
        {type: OfferPoiType.REZERWAT, name: "Las Pilczycki", distance: 2097}
    ],
    20209: [
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 285},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 306},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 370},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 374},
        {type: OfferPoiType.BUS, name: "Nadziei 01", distance: 501},
        {type: OfferPoiType.BUS, name: "Nadziei 02", distance: 607}
    ],
    20211: [
        {type: OfferPoiType.BUS, name: "Kolejowa 01", distance: 765},
        {type: OfferPoiType.BUS, name: "Kolejowa 02", distance: 776},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Pawełka", distance: 957},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1416},
        {type: OfferPoiType.PARK, name: "Skwer Wróbelka Elemelka", distance: 1711},
        {type: OfferPoiType.PARK, name: "Park Pięciu Sióstr", distance: 1805},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 2052},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 2072},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 2098},
        {type: OfferPoiType.PARK, name: "Skwer Alfonsa Grotowskiego", distance: 2173},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 2262}
    ],
    20216: [
        {type: OfferPoiType.BUS, name: "Młyn Michla 01", distance: 98},
        {type: OfferPoiType.BUS, name: "Młyn Michla 02", distance: 148},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 02", distance: 300},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 03", distance: 303},
        {type: OfferPoiType.TRAM, name: "Kawęczyńska-Bazylika 01", distance: 310},
        {type: OfferPoiType.PARK, name: "Park Michałowski", distance: 343},
        {type: OfferPoiType.PARK, name: "Skwer Michała i Marii Radziwiłłów", distance: 370},
        {type: OfferPoiType.TRAM, name: "Wojnicka 01", distance: 531},
        {type: OfferPoiType.BUS, name: "Siarczana 03", distance: 620},
        {type: OfferPoiType.TRAM, name: "Wojnicka 02", distance: 632},
        {type: OfferPoiType.BUS, name: "Dw. Wschodni (Kijowska) 16", distance: 642},
        {type: OfferPoiType.TRAM, name: "Dw. Wschodni (Kijowska) 71", distance: 664},
        {type: OfferPoiType.BUS, name: "Siarczana 01", distance: 727},
        {type: OfferPoiType.BUS, name: "Siarczana 02", distance: 764},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Praga 01", distance: 769},
        {type: OfferPoiType.PARK, name: "Skwer Mariana Pozorka", distance: 780},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 1534},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1797},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1899}
    ],
    20217: [{type: OfferPoiType.BUS, name: "Leźnieńska 01", distance: 254}],
    20218: [
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Świętojańska 01", distance: 276},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Świętojańska", distance: 277},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Świętojańska 02", distance: 297},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski 51", distance: 346},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski 01", distance: 390},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski", distance: 398},
        {type: OfferPoiType.BUS, name: "10 Lutego - Skwer Kościuszki 02", distance: 434},
        {type: OfferPoiType.BUS, name: "Skwer Kościuszki - InfoBox 04", distance: 443},
        {type: OfferPoiType.BUS, name: "Plac Kaszubski - Jana z Kolna", distance: 451},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy", distance: 539},
        {type: OfferPoiType.PARK, name: "Park Rady Europy", distance: 554},
        {type: OfferPoiType.PARK, name: "Plac Wolnej Ukrainy", distance: 707},
        {type: OfferPoiType.PARK, name: "Park Marii i Lecha Kaczyńskich", distance: 1043},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1132},
        {type: OfferPoiType.PARK, name: "Gdyński Park Kieszonkowy", distance: 1557},
        {type: OfferPoiType.PARK, name: "Skwer Plymouth", distance: 1652}
    ],
    20220: [
        {type: OfferPoiType.TRAM, name: "Polna", distance: 122},
        {type: OfferPoiType.BUS, name: "Żeromskiego", distance: 509},
        {type: OfferPoiType.TRAM, name: "Żeromskiego", distance: 546},
        {type: OfferPoiType.BUS, name: "Żeromskiego n/ż", distance: 579},
        {type: OfferPoiType.BUS, name: "Kościelna", distance: 679},
        {type: OfferPoiType.TRAM, name: "Rynek Jeżycki", distance: 698},
        {type: OfferPoiType.BUS, name: "Rynek Jeżycki", distance: 703},
        {type: OfferPoiType.PARK, name: "Skwer Antoniny Kaweckiej", distance: 1599},
        {type: OfferPoiType.PARK, name: "Ogród Botaniczny Uniwersytetu im. Adama Mickiewicza", distance: 1636},
        {type: OfferPoiType.PARK, name: "Park Henryka Wieniawskiego", distance: 1695},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 1769},
        {type: OfferPoiType.PARK, name: "Park Stanisława Moniuszki", distance: 1775},
        {type: OfferPoiType.PARK, name: "Park Sołacki", distance: 1845},
        {type: OfferPoiType.PARK, name: "Ogród Zamkowy", distance: 1868},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 2000},
        {type: OfferPoiType.PARK, name: "Park Gustawa Manitiusa", distance: 2016},
        {type: OfferPoiType.PARK, name: "Park Adama Wodziczki", distance: 2039}
    ],
    20222: [
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 01", distance: 239},
        {type: OfferPoiType.BUS, name: "Miejskie Centrum Opieki 02", distance: 257},
        {type: OfferPoiType.PARK, name: "Park Dolina Kurczaba", distance: 371},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 02", distance: 378},
        {type: OfferPoiType.BUS, name: "Szpital Uniwersytecki / Instytut Pediatrii 01", distance: 389},
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 02", distance: 409},
        {type: OfferPoiType.BUS, name: "Jerzmanowskiego 01", distance: 521},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 04", distance: 608},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 01", distance: 662},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 06", distance: 685},
        {type: OfferPoiType.TRAM, name: "Prokocim Szpital 02", distance: 697},
        {type: OfferPoiType.BUS, name: "Prokocim Szpital 05", distance: 698},
        {type: OfferPoiType.PARK, name: "Park Rżąka", distance: 730},
        {type: OfferPoiType.PARK, name: "Park Aleksandry", distance: 989},
        {type: OfferPoiType.REZERWAT, name: "Słona Woda", distance: 1214},
        {type: OfferPoiType.PARK, name: "Park Aleksandry-Północ", distance: 1331},
        {type: OfferPoiType.PARK, name: "Park Lilli Wenedy", distance: 1362},
        {type: OfferPoiType.PARK, name: "Park Anny i Erazma Jerzmanowskich", distance: 1426},
        {type: OfferPoiType.PARK, name: "Skwer Motylem Jestem", distance: 1630}
    ],
    20223: [
        {type: OfferPoiType.BUS, name: "Chopina/Pileckiego (03)", distance: 323},
        {type: OfferPoiType.BUS, name: "Pileckiego / Rondo(03)", distance: 441},
        {type: OfferPoiType.BUS, name: "Chopina / Os. Chopina Park (02) na żądanie", distance: 581},
        {type: OfferPoiType.BUS, name: "Pileckiego / K. O. Faka (02) na żądanie", distance: 592},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego / Pileckiego (01) na żądanie", distance: 742},
        {type: OfferPoiType.PARK, name: "Park Północny", distance: 1436}
    ],
    20224: [
        {type: OfferPoiType.PARK, name: "Skwer Powstańców Warszawy", distance: 1604},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci", distance: 1814},
        {type: OfferPoiType.PARK, name: "Park Glinianki", distance: 2365}
    ],
    20225: [
        {type: OfferPoiType.BUS, name: "Świętego Floriana", distance: 77},
        {type: OfferPoiType.TRAM, name: "Celna", distance: 251},
        {type: OfferPoiType.BUS, name: "Celna", distance: 261},
        {type: OfferPoiType.BUS, name: "SKM Łasztownia", distance: 426},
        {type: OfferPoiType.BUS, name: "Zbożowa", distance: 470},
        {type: OfferPoiType.BUS, name: "Wyszyńskiego", distance: 597},
        {type: OfferPoiType.TRAM, name: "Wyszyńskiego", distance: 620},
        {type: OfferPoiType.KOLEJ, name: "Szczecin Łasztownia", distance: 624},
        {type: OfferPoiType.TRAM, name: "SKM Port Centralny", distance: 813},
        {type: OfferPoiType.PARK, name: "Skwer imienia Guido Recka", distance: 946},
        {type: OfferPoiType.PARK, name: "Plac Tobrucki", distance: 1071},
        {type: OfferPoiType.PARK, name: "Skwer imienia Friedricha Ackermanna", distance: 1577},
        {type: OfferPoiType.PARK, name: "Plac imienia Generała Władysława Andersa", distance: 1720},
        {type: OfferPoiType.LAS, name: "Park imienia Stefana Żeromskiego", distance: 1999},
        {type: OfferPoiType.PARK, name: "Park imienia Stefana Żeromskiego", distance: 1999},
        {type: OfferPoiType.PARK, name: "Plac Dziecka", distance: 2025},
        {type: OfferPoiType.PARK, name: "skwer Filipinek", distance: 2205},
        {type: OfferPoiType.PARK, name: "Plac Janiny Szczerskiej", distance: 2346},
        {type: OfferPoiType.LAS, name: "Park imienia Stanisława Nadratowskiego", distance: 2445},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Nadratowskiego", distance: 2445}
    ],
    20226: [
        {type: OfferPoiType.BUS, name: "Bohaterów Getta/Bank", distance: 230},
        {type: OfferPoiType.BUS, name: "Poleska/Czysta", distance: 314},
        {type: OfferPoiType.BUS, name: "Bohaterów Getta/Poleska", distance: 320},
        {type: OfferPoiType.BUS, name: "Poleska/Sitarska", distance: 373},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego/Waryńskiego", distance: 377},
        {type: OfferPoiType.BUS, name: "Częstochowska/Piłsudskiego", distance: 388},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego/Częstochowska", distance: 402},
        {type: OfferPoiType.PARK, name: "Plac Mordechaja Tenenbauma", distance: 419},
        {type: OfferPoiType.BUS, name: "al. Piłsudskiego / Domus (Komunikacja regionalna)", distance: 447},
        {type: OfferPoiType.BUS, name: "Sitarska/Kozłowa", distance: 508},
        {type: OfferPoiType.BUS, name: "Poleska/Jurowiecka", distance: 530},
        {type: OfferPoiType.PARK, name: "Skwery Tamary Sołoniewicz", distance: 708},
        {type: OfferPoiType.PARK, name: "Park Centralny", distance: 1072},
        {type: OfferPoiType.PARK, name: "Bulwary Ireny Sendlerowej", distance: 1084},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Stanisława Hałko", distance: 1094},
        {type: OfferPoiType.PARK, name: "Park im. Jadwigi Dziekońskiej", distance: 1108},
        {type: OfferPoiType.PARK, name: "Plac Błogosławionego Księdza Michała Sopoćki", distance: 1119},
        {type: OfferPoiType.PARK, name: "Bulwary księdza Aleksandra Chodyki", distance: 1201},
        {type: OfferPoiType.PARK, name: "Skwer Armii Krajowej", distance: 1258},
        {type: OfferPoiType.PARK, name: "Plac Jana Pawła II", distance: 1285}
    ],
    20227: [
        {type: OfferPoiType.BUS, name: "Gutkowo-Przyjazna", distance: 657},
        {type: OfferPoiType.BUS, name: "Żółkiewskiego", distance: 759}
    ],
    20231: [{type: OfferPoiType.PARK, name: "Park Pułkownika Mieczysława Chojnackiego „Młodzika”", distance: 2178}],
    20232: [
        {type: OfferPoiType.TRAM, name: "Teatr Variété 01", distance: 533},
        {type: OfferPoiType.TRAM, name: "Teatr Variété 02", distance: 563},
        {type: OfferPoiType.PARK, name: "Ogród Ptasi", distance: 579},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 07", distance: 618},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 04", distance: 619},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 05", distance: 628},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Grzegórzek", distance: 647},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 01", distance: 647},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 06", distance: 699},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 02", distance: 714},
        {type: OfferPoiType.TRAM, name: "Rondo Grzegórzeckie 03", distance: 733},
        {type: OfferPoiType.BUS, name: "Rondo Grzegórzeckie 08", distance: 738},
        {type: OfferPoiType.TRAM, name: "Nullo 01", distance: 786},
        {type: OfferPoiType.BUS, name: "Most Kotlarski 01", distance: 794},
        {type: OfferPoiType.BUS, name: "Nullo 03", distance: 794},
        {type: OfferPoiType.TRAM, name: "Nullo 02", distance: 804},
        {type: OfferPoiType.BUS, name: "Nullo 04", distance: 812},
        {type: OfferPoiType.PARK, name: "Park Grzegórzecki", distance: 848},
        {type: OfferPoiType.PARK, name: "Skwer imienia Mariana Eilego", distance: 1100},
        {type: OfferPoiType.PARK, name: "Park Stacja Wisła", distance: 1185},
        {type: OfferPoiType.PARK, name: "Łąka na Wesołej", distance: 1432},
        {type: OfferPoiType.REZERWAT, name: "Historyczne centrum Krakowa", distance: 2170},
        {type: OfferPoiType.REZERWAT, name: "Staw Dąbski", distance: 2506}
    ],
    20237: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 493},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 574},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 587},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 790},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 811},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 825},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1079},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1087},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1770},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1889},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1966},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2113},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2223}
    ],
    20245: [
        {type: OfferPoiType.BUS, name: "Złota 02", distance: 210},
        {type: OfferPoiType.BUS, name: "Złota 01", distance: 297},
        {type: OfferPoiType.BUS, name: "Baza na Pogórzu Dolnym 01", distance: 398},
        {type: OfferPoiType.BUS, name: "Kadmowa 02", distance: 485},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne 04", distance: 491},
        {type: OfferPoiType.BUS, name: "Kadmowa", distance: 493},
        {type: OfferPoiType.BUS, name: "Kadmowa 01", distance: 494},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne", distance: 519},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne 03", distance: 520},
        {type: OfferPoiType.BUS, name: "Pogórze Dolne 02", distance: 539},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1364},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 2356}
    ],
    20247: [
        {type: OfferPoiType.PARK, name: "Park Sowińskiego", distance: 269},
        {type: OfferPoiType.BUS, name: "Planetarium", distance: 338},
        {type: OfferPoiType.BUS, name: "Sienkiewicza", distance: 453},
        {type: OfferPoiType.BUS, name: "Stare Miasto (PLAC POCZTOWY)", distance: 479},
        {type: OfferPoiType.BUS, name: "Długa", distance: 525},
        {type: OfferPoiType.BUS, name: "Drzewna (NŻ)", distance: 633},
        {type: OfferPoiType.BUS, name: "Ogrodowa", distance: 662},
        {type: OfferPoiType.PARK, name: "Park Kolei Szprotawskiej", distance: 666},
        {type: OfferPoiType.PARK, name: "Park Winny", distance: 831},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 950}
    ],
    20253: [
        {type: OfferPoiType.PARK, name: "Park Sowińskiego", distance: 268},
        {type: OfferPoiType.BUS, name: "Planetarium", distance: 337},
        {type: OfferPoiType.BUS, name: "Sienkiewicza", distance: 452},
        {type: OfferPoiType.BUS, name: "Stare Miasto (PLAC POCZTOWY)", distance: 478},
        {type: OfferPoiType.BUS, name: "Długa", distance: 526},
        {type: OfferPoiType.BUS, name: "Drzewna (NŻ)", distance: 632},
        {type: OfferPoiType.BUS, name: "Ogrodowa", distance: 663},
        {type: OfferPoiType.PARK, name: "Park Kolei Szprotawskiej", distance: 667},
        {type: OfferPoiType.PARK, name: "Park Winny", distance: 830},
        {type: OfferPoiType.PARK, name: "Plac Teatralny", distance: 949}
    ],
    20255: [
        {type: OfferPoiType.BUS, name: "Nowy Bytom Osiedle Otylia", distance: 269},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Centrum", distance: 605},
        {type: OfferPoiType.BUS, name: "Nowy Bytom Pokoju", distance: 739},
        {type: OfferPoiType.PARK, name: "Park Dworski", distance: 830},
        {type: OfferPoiType.PARK, name: "Zrewitalizowana Hałda Pocynkowa", distance: 1091},
        {type: OfferPoiType.PARK, name: "Ogród Ślaskiego Teatru Impresaryjnego", distance: 1245},
        {type: OfferPoiType.PARK, name: "Park im. Józefa Hallera", distance: 1951},
        {type: OfferPoiType.PARK, name: "Góra Antonia", distance: 1989},
        {type: OfferPoiType.PARK, name: "Park im. Juliana Tuwima", distance: 2365}
    ],
    20256: [
        {type: OfferPoiType.BUS, name: "Gwarna 01", distance: 492},
        {type: OfferPoiType.BUS, name: "Gwarna 02", distance: 638},
        {type: OfferPoiType.BUS, name: "Rataja 02", distance: 837}
    ],
    20258: [
        {type: OfferPoiType.BUS, name: "Przepiórki 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Przepiórki 01", distance: 388},
        {type: OfferPoiType.BUS, name: "Kolibra 01", distance: 715},
        {type: OfferPoiType.BUS, name: "Kolibra 02", distance: 780}
    ],
    20259: [
        {type: OfferPoiType.BUS, name: "Chłodnia 01", distance: 340},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Toruńska", distance: 356},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 03", distance: 422},
        {type: OfferPoiType.BUS, name: "Pelcowizna 01", distance: 438},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 04", distance: 454},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 02", distance: 491},
        {type: OfferPoiType.BUS, name: "Chłodnia 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Pelcowizna 02", distance: 509},
        {type: OfferPoiType.BUS, name: "PKP Toruńska 01", distance: 512},
        {type: OfferPoiType.BUS, name: "Pelcowizna 06", distance: 580},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy Wysockiego 20", distance: 989},
        {type: OfferPoiType.PARK, name: "Park Linearny", distance: 1546},
        {type: OfferPoiType.PARK, name: "VIII Ogród Jordanowski", distance: 1574},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 2150},
        {type: OfferPoiType.PARK, name: "Park Bródnowski", distance: 2401}
    ],
    20260: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 343},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 757},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 1047},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1390},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1819},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2111},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2145},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2404}
    ],
    20261: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 347},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 487},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 681},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 761},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 1038},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1214},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1727},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1908},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2115},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2158},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2394},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2406}
    ],
    20262: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 272},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 562},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 606},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 686},
        {type: OfferPoiType.BUS, name: "Michałkowice Kościół", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 963},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1139},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1652},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1983},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2040},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2083},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2469},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2481}
    ],
    20264: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 308},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 526},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 642},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 722},
        {type: OfferPoiType.BUS, name: "Michałkowice Kościół", distance: 815},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 999},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1175},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1688},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1947},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2076},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2119},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2433},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2445}
    ],
    20265: [
        {type: OfferPoiType.BUS, name: "Michałkowice Park Górnik", distance: 242},
        {type: OfferPoiType.BUS, name: "Bytków Watoły", distance: 576},
        {type: OfferPoiType.BUS, name: "Siemianowice Michałkowicka", distance: 592},
        {type: OfferPoiType.PARK, name: "Park Górnik", distance: 656},
        {type: OfferPoiType.BUS, name: "Michałkowice Kościół", distance: 749},
        {type: OfferPoiType.PARK, name: "Park Ludowy", distance: 933},
        {type: OfferPoiType.PARK, name: "Park Bytkowski", distance: 1109},
        {type: OfferPoiType.REZERWAT, name: "Staw pod Chorzowem", distance: 1622},
        {type: OfferPoiType.REZERWAT, name: "Michałkowicka Kępa", distance: 2010},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 2013},
        {type: OfferPoiType.PARK, name: "Skwer im. Jana Mitręgi", distance: 2053},
        {type: OfferPoiType.PARK, name: "Park Hutniczy", distance: 2499},
        {type: OfferPoiType.PARK, name: "Skwer Laura", distance: 2500}
    ],
    20268: [
        {type: OfferPoiType.BUS, name: "Pomorska - Gryfa Pomorskiego NŻ", distance: 290},
        {type: OfferPoiType.BUS, name: "Pomorska - Śródziemnomorska NŻ", distance: 529},
        {type: OfferPoiType.BUS, name: "Pomorska - Wendy NŻ", distance: 739}
    ],
    20269: [
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola 02", distance: 183},
        {type: OfferPoiType.BUS, name: "Okopowa 02", distance: 258},
        {type: OfferPoiType.PARK, name: "Skwer Gwary Warszawskiej", distance: 268},
        {type: OfferPoiType.BUS, name: "Leszno 01", distance: 270},
        {type: OfferPoiType.BUS, name: "Leszno 02", distance: 272},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Wola 06", distance: 333},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Wola 04", distance: 333},
        {type: OfferPoiType.BUS, name: "Młynarska 01", distance: 370},
        {type: OfferPoiType.TRAM, name: "Zajezdnia Wola 03", distance: 370},
        {type: OfferPoiType.BUS, name: "Okopowa 05", distance: 371},
        {type: OfferPoiType.BUS, name: "Młynarska 02", distance: 372},
        {type: OfferPoiType.BUS, name: "Zajezdnia Wola 01", distance: 391},
        {type: OfferPoiType.BUS, name: "Okopowa 06", distance: 398},
        {type: OfferPoiType.PARK, name: "Skwer Hanki Bielickiej", distance: 399},
        {type: OfferPoiType.TRAM, name: "Okopowa 08", distance: 400},
        {type: OfferPoiType.TRAM, name: "Okopowa 07", distance: 416},
        {type: OfferPoiType.BUS, name: "Młynarska 04", distance: 435},
        {type: OfferPoiType.TRAM, name: "Okopowa 03", distance: 440},
        {type: OfferPoiType.TRAM, name: "Młynarska 04", distance: 449},
        {type: OfferPoiType.TRAM, name: "Żytnia 02", distance: 513},
        {type: OfferPoiType.TRAM, name: "Żytnia 01", distance: 531},
        {type: OfferPoiType.TRAM, name: "Młynarska 03", distance: 534},
        {type: OfferPoiType.PARK, name: "Plac Opolski", distance: 761},
        {type: OfferPoiType.PARK, name: "Różany Skwer Pysznych Pączków", distance: 767},
        {type: OfferPoiType.PARK, name: "Skwer Wandy Lurie", distance: 801},
        {type: OfferPoiType.PARK, name: "Skwer Psa Fafika", distance: 899},
        {type: OfferPoiType.PARK, name: "Skwer „Sierpnia 1944”", distance: 942},
        {type: OfferPoiType.PARK, name: "Park Wolności", distance: 1004},
        {type: OfferPoiType.PARK, name: "Skwer Józefa Rotblata", distance: 1361}
    ],
    20271: [
        {type: OfferPoiType.BUS, name: "Rąbieńska - Traktorowa", distance: 334},
        {type: OfferPoiType.BUS, name: "Rąbieńska - Podjazdowa NŻ", distance: 354},
        {type: OfferPoiType.BUS, name: "Podchorążych - Napoleońska", distance: 415},
        {type: OfferPoiType.BUS, name: "Traktorowa - Rąbieńska", distance: 539},
        {type: OfferPoiType.BUS, name: "Złotno - Podchorążych", distance: 544},
        {type: OfferPoiType.BUS, name: "Fizylierów - Złotno", distance: 577},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 755},
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 1281},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 1417},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1691},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1746},
        {type: OfferPoiType.PARK, name: "Park im. Stefana Żeromskiego", distance: 1827},
        {type: OfferPoiType.PARK, name: "Park im. generała Władysława Andersa", distance: 1832},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 2153},
        {type: OfferPoiType.PARK, name: "Park Grabieński Las", distance: 2220}
    ],
    20278: [
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 454},
        {type: OfferPoiType.BUS, name: "Czermińskiego 01", distance: 509},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1353}
    ],
    20280: [
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 215},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 362},
        {type: OfferPoiType.BUS, name: "Okólna 02", distance: 511},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 539},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 02", distance: 592},
        {type: OfferPoiType.BUS, name: "Okólna 03", distance: 598},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 01", distance: 630},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 673},
        {type: OfferPoiType.BUS, name: "Wspólna 01", distance: 734},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1142},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1401}
    ],
    20287: [{type: OfferPoiType.BUS, name: "Nowosiedlice", distance: 836}],
    20290: [
        {type: OfferPoiType.BUS, name: "Twardzickiego / Łochowskiego", distance: 230},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Kleina", distance: 244},
        {type: OfferPoiType.BUS, name: "Twardzickiego / Bołtucia", distance: 578},
        {type: OfferPoiType.BUS, name: "Korfantego / Prejsa", distance: 793},
        {type: OfferPoiType.BUS, name: "Pod Skarpą / Frydrychowicza", distance: 800},
        {type: OfferPoiType.PARK, name: "Dolina Śmierci", distance: 1046},
        {type: OfferPoiType.PARK, name: "Park Bydgoskich Spółdzielców", distance: 1830},
        {type: OfferPoiType.PARK, name: "Park Akademicki", distance: 2266}
    ],
    20291: [
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 481},
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 485},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 502},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 504},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 513},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 514},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 523},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 558},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 645},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 666},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 806},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 959},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1382},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 2039}
    ],
    20292: [
        {type: OfferPoiType.TRAM, name: "Grasera 03", distance: 418},
        {type: OfferPoiType.BUS, name: "Grasera 02", distance: 437},
        {type: OfferPoiType.TRAM, name: "Grasera 04", distance: 446},
        {type: OfferPoiType.BUS, name: "Strobanda 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Grasera 01", distance: 447},
        {type: OfferPoiType.BUS, name: "Strobanda 02", distance: 505},
        {type: OfferPoiType.BUS, name: "Strobanda", distance: 526},
        {type: OfferPoiType.TRAM, name: "Heweliusza 01", distance: 547},
        {type: OfferPoiType.TRAM, name: "Heweliusza 00", distance: 582},
        {type: OfferPoiType.TRAM, name: "Strobanda 04", distance: 669},
        {type: OfferPoiType.TRAM, name: "Strobanda 03", distance: 690},
        {type: OfferPoiType.TRAM, name: "Hubego 03", distance: 821},
        {type: OfferPoiType.BUS, name: "Rybińskiego 01", distance: 830},
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 892},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 1406},
        {type: OfferPoiType.PARK, name: "Park linearny", distance: 1972}
    ],
    20293: [
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 114},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 119},
        {type: OfferPoiType.BUS, name: "Urbanistów 02", distance: 651},
        {type: OfferPoiType.BUS, name: "Chyliczki 01", distance: 715},
        {type: OfferPoiType.BUS, name: "Urbanistów 01", distance: 736},
        {type: OfferPoiType.BUS, name: "Chyliczki 02", distance: 812}
    ],
    20301: [
        {type: OfferPoiType.BUS, name: "Skrzydlata - Dojazdowa", distance: 191},
        {type: OfferPoiType.BUS, name: "Skrzydlata - Kasztelańska NŻ", distance: 278},
        {type: OfferPoiType.BUS, name: "Warszawska - Słowicza NŻ", distance: 446},
        {type: OfferPoiType.BUS, name: "Warszawska - Dw. Łódź Warszawska NŻ", distance: 452},
        {type: OfferPoiType.KOLEJ, name: "Łódź Warszawska", distance: 575},
        {type: OfferPoiType.BUS, name: "Warszawska - Centralna NŻ", distance: 656},
        {type: OfferPoiType.PARK, name: "Park Świtezianki", distance: 2310},
        {type: OfferPoiType.PARK, name: "Park im. Adama Mickiewicza", distance: 2495}
    ],
    20303: [
        {type: OfferPoiType.BUS, name: "Stadion Olimpijski", distance: 345},
        {type: OfferPoiType.TRAM, name: "Stadion Olimpijski", distance: 395},
        {type: OfferPoiType.TRAM, name: "Karłowicza", distance: 630},
        {type: OfferPoiType.BUS, name: "8 Maja", distance: 766},
        {type: OfferPoiType.BUS, name: "Szymanowskiego", distance: 773},
        {type: OfferPoiType.PARK, name: "skwer Ludwiga Guttmanna", distance: 779},
        {type: OfferPoiType.TRAM, name: "8 Maja", distance: 795},
        {type: OfferPoiType.BUS, name: "Moniuszki", distance: 798},
        {type: OfferPoiType.PARK, name: "Park Wroni", distance: 1107},
        {type: OfferPoiType.PARK, name: "Park Szczytnicki", distance: 1280},
        {type: OfferPoiType.PARK, name: "skwer Magdaleny Abakanowicz", distance: 1958}
    ],
    20304: [
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Bursztynowa Góra", distance: 1483},
        {type: OfferPoiType.LAS, name: "Jankowski las", distance: 1845}
    ],
    20305: [{type: OfferPoiType.KOLEJ, name: "Stegna PKS", distance: 782}],
    20306: [
        {type: OfferPoiType.BUS, name: "Warszawska", distance: 826},
        {type: OfferPoiType.REZERWAT, name: "Śmieszka w Bojanie", distance: 843},
        {type: OfferPoiType.REZERWAT, name: "Trójmiejski Park Krajobrazowy", distance: 1056}
    ],
    20307: [
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 01", distance: 169},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Wąska - Zielone Sady 02", distance: 338},
        {type: OfferPoiType.BUS, name: "Tarczyn Lidl/Biedronka 01", distance: 353},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 01", distance: 507},
        {type: OfferPoiType.BUS, name: "Tarczyn ul. Dębowa 02", distance: 561},
        {type: OfferPoiType.PARK, name: "Park miejski", distance: 1763}
    ],
    20308: [
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 184},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 409},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 688},
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 701},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 718},
        {type: OfferPoiType.BUS, name: "Lutycka Szpital", distance: 747},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 774},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1537},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1641},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1853},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2021},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2132},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2294},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2319}
    ],
    20309: [
        {type: OfferPoiType.KOLEJ, name: "Iwiny", distance: 596},
        {type: OfferPoiType.BUS, name: "Vivaldiego", distance: 811},
        {type: OfferPoiType.PARK, name: "Park Brochowski", distance: 2129},
        {type: OfferPoiType.PARK, name: "skwer Harivansha Rai Bachchana", distance: 2476}
    ],
    20310: [
        {type: OfferPoiType.BUS, name: "Kościelisko Rysulówka 2", distance: 337},
        {type: OfferPoiType.BUS, name: "Kościelisko Rysulówka 1", distance: 367}
    ],
    20311: [
        {type: OfferPoiType.BUS, name: "Leszczynki SKM", distance: 116},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Leszczynki", distance: 247},
        {type: OfferPoiType.BUS, name: "Wiejska", distance: 406},
        {type: OfferPoiType.BUS, name: "Zamenhofa", distance: 484},
        {type: OfferPoiType.PARK, name: "Park Zielone Leszczynki", distance: 1311},
        {type: OfferPoiType.PARK, name: "Kieszonka na fali", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1938}
    ],
    20315: [
        {type: OfferPoiType.BUS, name: "Chodakowska 04", distance: 180},
        {type: OfferPoiType.BUS, name: "Chodakowska 01", distance: 183},
        {type: OfferPoiType.BUS, name: "Chodakowska 02", distance: 198},
        {type: OfferPoiType.BUS, name: "Mińska 01", distance: 328},
        {type: OfferPoiType.BUS, name: "Mińska 02", distance: 421},
        {type: OfferPoiType.BUS, name: "Terespolska 03", distance: 565},
        {type: OfferPoiType.BUS, name: "Kamionek 01", distance: 580},
        {type: OfferPoiType.BUS, name: "Żupnicza 02", distance: 586},
        {type: OfferPoiType.BUS, name: "Żupnicza 01", distance: 648},
        {type: OfferPoiType.BUS, name: "Kamionek 02", distance: 659},
        {type: OfferPoiType.PARK, name: "Centrum Lokalne Kamionek", distance: 1056},
        {type: OfferPoiType.PARK, name: "Park Obwodu Praga AK", distance: 1309},
        {type: OfferPoiType.PARK, name: "Skwer Seniora", distance: 1447},
        {type: OfferPoiType.PARK, name: "Ogrody Polsko-Niemieckie", distance: 1604},
        {type: OfferPoiType.PARK, name: "Kamionkowskie Błonia Elekcyjne", distance: 1664},
        {type: OfferPoiType.PARK, name: "Park Skaryszewski", distance: 1981},
        {type: OfferPoiType.PARK, name: "Skwer 1 Dywizji Grenadierów Francja 1940 Roku", distance: 2123},
        {type: OfferPoiType.PARK, name: "Park Józefa Polińskiego", distance: 2146},
        {type: OfferPoiType.PARK, name: "Skwer Markowska", distance: 2152}
    ],
    20316: [
        {type: OfferPoiType.BUS, name: "Sosnowiec Teatralna", distance: 63},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Wspólna", distance: 228},
        {type: OfferPoiType.BUS, name: "Sosnowiec Wspólna", distance: 259},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dęblińska", distance: 384},
        {type: OfferPoiType.BUS, name: "Sosnowiec Mierosławskiego", distance: 392},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dęblińska", distance: 395},
        {type: OfferPoiType.BUS, name: "Sosnowiec Kościelna", distance: 512},
        {type: OfferPoiType.BUS, name: "Sosnowiec Sienkiewicza", distance: 533},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Południowy", distance: 536},
        {type: OfferPoiType.BUS, name: "Sosnowiec Dworzec PKP", distance: 557},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Dworzec PKP", distance: 612},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Małachowskiego", distance: 720},
        {type: OfferPoiType.KOLEJ, name: "Sosnowiec Główny", distance: 735},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Piłsudskiego/Sobieskiego", distance: 737},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Aleja Zwycięstwa", distance: 765},
        {type: OfferPoiType.TRAM, name: "Sosnowiec Ostrogórska", distance: 823},
        {type: OfferPoiType.PARK, name: "Bulwary Czarnej Przemszy", distance: 1177},
        {type: OfferPoiType.PARK, name: "Park Schöna nad Czarną Przemszą", distance: 1258},
        {type: OfferPoiType.PARK, name: "Park Harcerski", distance: 1436},
        {type: OfferPoiType.PARK, name: "Skwer imienia Jana Antoniego Strzeleckiego", distance: 1726},
        {type: OfferPoiType.PARK, name: "Park Sielecki", distance: 1813},
        {type: OfferPoiType.PARK, name: "Park Dietla", distance: 1990},
        {type: OfferPoiType.REZERWAT, name: 'Zespół Przyrodniczo-Krajobrazowy "Szopienice-Borki"', distance: 1996},
        {type: OfferPoiType.REZERWAT, name: "Kruszczyk Szerokolistny w Lasku Stawiki", distance: 2384}
    ],
    20317: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 447},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 528},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 541},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 744},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 765},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 779},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1033},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1041},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1724},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1843},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1920},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2067},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2177}
    ],
    20318: [
        {type: OfferPoiType.BUS, name: "Edwarda - Pomorska", distance: 483},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda NŻ", distance: 564},
        {type: OfferPoiType.BUS, name: "Pomorska - Edwarda", distance: 577},
        {type: OfferPoiType.BUS, name: "Czechosłowacka - Edwarda NŻ", distance: 780},
        {type: OfferPoiType.BUS, name: "Edwarda - Czechosłowacka", distance: 801},
        {type: OfferPoiType.BUS, name: "Krokusowa - Zrębowa NŻ", distance: 815},
        {type: OfferPoiType.LAS, name: "Park Podgórze", distance: 1069},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Mokradła przy Pomorskiej”", distance: 1077},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 1760},
        {type: OfferPoiType.PARK, name: "Park im. gen. Roberta Baden-Powella – Naczelnego Skauta Świata", distance: 1879},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 1956},
        {type: OfferPoiType.PARK, name: "Zieleniec „Konstytucyjna”", distance: 2103},
        {type: OfferPoiType.PARK, name: "Park Jordanka", distance: 2213}
    ],
    20321: [
        {type: OfferPoiType.BUS, name: "Armii Krajowej 01", distance: 425},
        {type: OfferPoiType.BUS, name: "Armii Krajowej 02", distance: 472},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 02", distance: 535},
        {type: OfferPoiType.BUS, name: "Przybyszewskiego 01", distance: 568},
        {type: OfferPoiType.PARK, name: "Młodzieżowy Ogród Krakowian", distance: 1236},
        {type: OfferPoiType.PARK, name: "park z ławkami", distance: 1245},
        {type: OfferPoiType.PARK, name: "Skwer generała Franciszka Ksawerego Latinika", distance: 1470},
        {type: OfferPoiType.PARK, name: "Skwer Niezależnego Zrzeszenia Studentów", distance: 1582},
        {type: OfferPoiType.PARK, name: "Park Świętego Wincentego á Paulo", distance: 1653},
        {type: OfferPoiType.PARK, name: "Park Bronowicki przy Forcie", distance: 1715},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 1722},
        {type: OfferPoiType.PARK, name: "Park Młynówka Królewska", distance: 1728},
        {type: OfferPoiType.REZERWAT, name: "Łąki nad Rudawą", distance: 2203}
    ],
    20322: [
        {type: OfferPoiType.BUS, name: "Stawowa 01", distance: 486},
        {type: OfferPoiType.BUS, name: "Stawowa 04", distance: 585},
        {type: OfferPoiType.PARK, name: "Plac Omłotowy", distance: 1054},
        {type: OfferPoiType.PARK, name: "Park Radzikowskiego", distance: 1305},
        {type: OfferPoiType.PARK, name: "Park Kieszonkowy – Ogród Trawiasty", distance: 2028},
        {type: OfferPoiType.PARK, name: "Mordor", distance: 2464}
    ],
    20326: [
        {type: OfferPoiType.BUS, name: "Obornicka n/ż", distance: 227},
        {type: OfferPoiType.BUS, name: "Rondo Obornickie", distance: 452},
        {type: OfferPoiType.BUS, name: "Piątkowska", distance: 731},
        {type: OfferPoiType.TRAM, name: "Lutycka Szpital", distance: 744},
        {type: OfferPoiType.TRAM, name: "Piątkowska", distance: 761},
        {type: OfferPoiType.BUS, name: "Lutycka Szpital", distance: 790},
        {type: OfferPoiType.BUS, name: "Suszki", distance: 817},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1580},
        {type: OfferPoiType.PARK, name: "Park na os. Zwycięstwa", distance: 1684},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1896},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 2064},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 2175},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2337},
        {type: OfferPoiType.PARK, name: "Park Władysława Czarneckiego", distance: 2362}
    ],
    20327: [
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 303},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 02", distance: 382},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 01", distance: 444},
        {type: OfferPoiType.BUS, name: "Rumia, Urząd Miasta Rumi", distance: 622},
        {type: OfferPoiType.BUS, name: "Porazińskiej", distance: 794},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1816},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 2461}
    ],
    20328: [
        {type: OfferPoiType.BUS, name: "Łąkowa 01", distance: 483},
        {type: OfferPoiType.BUS, name: "Łąkowa 02", distance: 588},
        {type: OfferPoiType.BUS, name: "Wierzbowa 02", distance: 744}
    ],
    20331: [
        {type: OfferPoiType.BUS, name: "Pilotów 01", distance: 161},
        {type: OfferPoiType.BUS, name: "Dywizjonu 303 01", distance: 163},
        {type: OfferPoiType.BUS, name: "Zaspa SKM 01", distance: 417},
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 01", distance: 422},
        {type: OfferPoiType.TRAM, name: "Jana Pawła II 02", distance: 456},
        {type: OfferPoiType.BUS, name: "Zaspa SKM 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 01", distance: 581},
        {type: OfferPoiType.BUS, name: "Startowa 04", distance: 582},
        {type: OfferPoiType.BUS, name: "Rzeczypospolitej 02", distance: 606},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 01", distance: 610},
        {type: OfferPoiType.BUS, name: "Żwirki i Wigury 03", distance: 622},
        {type: OfferPoiType.KOLEJ, name: "Gdańsk Zaspa", distance: 629},
        {type: OfferPoiType.TRAM, name: "Żwirki i Wigury 02", distance: 638},
        {type: OfferPoiType.TRAM, name: "Startowa 01", distance: 684},
        {type: OfferPoiType.TRAM, name: "Startowa 02", distance: 709},
        {type: OfferPoiType.BUS, name: 'SDO "Złota Jesień" 01', distance: 734},
        {type: OfferPoiType.BUS, name: "Startowa 03", distance: 753},
        {type: OfferPoiType.PARK, name: "Park im. Jana Pawła II", distance: 975},
        {type: OfferPoiType.PARK, name: "Skwer Marszałka Józefa Piłsudskiego", distance: 1035}
    ],
    20332: [
        {type: OfferPoiType.BUS, name: "Mateckiego", distance: 130},
        {type: OfferPoiType.BUS, name: "Wiedeńska", distance: 611},
        {type: OfferPoiType.BUS, name: "Os. Marysieńki", distance: 675},
        {type: OfferPoiType.BUS, name: "Wietrzna n/ż", distance: 718},
        {type: OfferPoiType.BUS, name: "Łęgowskiego n/ż", distance: 724},
        {type: OfferPoiType.BUS, name: "Os. Sobieskiego Szkoła n/ż", distance: 778},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Wisłockiego", distance: 1485},
        {type: OfferPoiType.PARK, name: "Skwer Alojzego Andrzeja Łuczaka", distance: 1530},
        {type: OfferPoiType.PARK, name: "Skwer Teodora Łagody", distance: 1633},
        {type: OfferPoiType.PARK, name: "Park Bergera", distance: 1799},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kasserna", distance: 1965},
        {type: OfferPoiType.PARK, name: "Park Zygmunta Mahlika", distance: 2438}
    ],
    20336: [
        {type: OfferPoiType.BUS, name: "Inflancka - Zagajnikowa", distance: 387},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Inflancka", distance: 437},
        {type: OfferPoiType.BUS, name: "Zagajnikowa - Radlińskiej NŻ", distance: 466},
        {type: OfferPoiType.KOLEJ, name: "Łódź Marysin", distance: 605},
        {type: OfferPoiType.TRAM, name: "Doły", distance: 669},
        {type: OfferPoiType.BUS, name: "Inflancka - Gibalskiego", distance: 673},
        {type: OfferPoiType.BUS, name: "Strykowska - Inflancka", distance: 705},
        {type: OfferPoiType.BUS, name: "Wycieczkowa - Strykowska", distance: 719},
        {type: OfferPoiType.PARK, name: "Skwer Grzegorza Matuszaka", distance: 1243},
        {type: OfferPoiType.PARK, name: "Park im. Szarych Szeregów", distance: 1642},
        {type: OfferPoiType.PARK, name: "Skwer Karola Hillera", distance: 1790},
        {type: OfferPoiType.PARK, name: "Skwer im. Jadwigi Szustrowej", distance: 1832},
        {type: OfferPoiType.PARK, name: "Skwer Gdański", distance: 1846},
        {type: OfferPoiType.PARK, name: "Park Ocalałych", distance: 2345}
    ],
    20337: [{type: OfferPoiType.BUS, name: "Gąski, Nadbrzeżna / Wczasowa", distance: 121}],
    20339: [
        {type: OfferPoiType.BUS, name: "Gowarzewo/Jesionowa n/ż", distance: 385},
        {type: OfferPoiType.BUS, name: "Gowarzewo/Jesienna n/ż", distance: 693},
        {type: OfferPoiType.PARK, name: "Park Dworski w Gowarzewie", distance: 1731}
    ],
    20341: [
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 542},
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 668},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 701},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 714},
        {type: OfferPoiType.BUS, name: "Byszewska - Pomarańczowa", distance: 744},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 770},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2407}
    ],
    20342: [
        {type: OfferPoiType.BUS, name: "Starogardzka 04", distance: 453},
        {type: OfferPoiType.BUS, name: "Starogardzka 01", distance: 464},
        {type: OfferPoiType.BUS, name: "Borkowo Skrzyżowanie 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 01", distance: 794},
        {type: OfferPoiType.BUS, name: "Borkowo Topolowa 02", distance: 801},
        {type: OfferPoiType.BUS, name: "Jagiełły 02", distance: 814},
        {type: OfferPoiType.BUS, name: "Jagiełły 01", distance: 818}
    ],
    20343: [
        {type: OfferPoiType.BUS, name: "Zamienie 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Błędna 01", distance: 630},
        {type: OfferPoiType.BUS, name: "Kakaowa 01", distance: 731},
        {type: OfferPoiType.BUS, name: "Bakaliowa 01", distance: 813},
        {type: OfferPoiType.BUS, name: "Dawidowska 01", distance: 824}
    ],
    20345: [
        {type: OfferPoiType.BUS, name: "Osiedle Limba 02", distance: 232},
        {type: OfferPoiType.BUS, name: "Osiedle Limba 01", distance: 299},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Stawy Raszyńskie", distance: 2485}
    ],
    20346: [
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 12", distance: 1},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 18", distance: 35},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 11", distance: 45},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 10", distance: 59},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 09", distance: 68},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 17", distance: 79},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 16", distance: 90},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 15", distance: 115},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 14", distance: 120},
        {type: OfferPoiType.BUS, name: "Metro Wilanowska 13", distance: 132},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 72", distance: 175},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 71", distance: 176},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 05", distance: 203},
        {type: OfferPoiType.TRAM, name: "Metro Wilanowska 06", distance: 223},
        {type: OfferPoiType.METRO, name: "Wilanowska", distance: 235},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 04", distance: 497},
        {type: OfferPoiType.TRAM, name: "Niedźwiedzia 03", distance: 543},
        {type: OfferPoiType.TRAM, name: "Bukowińska 04", distance: 755},
        {type: OfferPoiType.TRAM, name: "Bukowińska 03", distance: 799},
        {type: OfferPoiType.PARK, name: "Park Enklawa", distance: 1084},
        {type: OfferPoiType.PARK, name: 'Skwer Grupy AK "Granat"', distance: 1203},
        {type: OfferPoiType.PARK, name: "Królikarnia", distance: 1345},
        {type: OfferPoiType.REZERWAT, name: "Zespół przyrodniczo-krajobrazowy Arkadia", distance: 1496},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Czesława Łaszka", distance: 1897},
        {type: OfferPoiType.REZERWAT, name: "Fragment Skarpy Warszawskiej im. Janusza Kusocińskiego", distance: 2239}
    ],
    20347: [
        {type: OfferPoiType.KOLEJ, name: "Warszawa Okęcie", distance: 401},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 04", distance: 473},
        {type: OfferPoiType.BUS, name: "PKP Okęcie 01", distance: 476},
        {type: OfferPoiType.BUS, name: "Taborowa 01", distance: 541},
        {type: OfferPoiType.BUS, name: "Taborowa 02", distance: 587},
        {type: OfferPoiType.BUS, name: "Jurajska 02", distance: 725},
        {type: OfferPoiType.PARK, name: "Park Bartłomieja", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park nad Stawem Służewieckim", distance: 2293},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 2416}
    ],
    20348: [
        {type: OfferPoiType.BUS, name: "Przedpole 02", distance: 555},
        {type: OfferPoiType.BUS, name: "Przedpole 01", distance: 754}
    ],
    20349: [
        {type: OfferPoiType.BUS, name: "Krzesiwa 01", distance: 488},
        {type: OfferPoiType.BUS, name: "Krzesiwa 02", distance: 532},
        {type: OfferPoiType.BUS, name: "Koszalińska 01", distance: 638},
        {type: OfferPoiType.KOLEJ, name: "Warszawa Zacisze-Wilno", distance: 638},
        {type: OfferPoiType.BUS, name: "PKP Zacisze-Wilno 02", distance: 718},
        {type: OfferPoiType.BUS, name: "PKP Zacisze-Wilno 01", distance: 725},
        {type: OfferPoiType.BUS, name: "PKP Zacisze-Wilno 04", distance: 730},
        {type: OfferPoiType.BUS, name: "Diamentowa 01", distance: 738},
        {type: OfferPoiType.PARK, name: "Skwer Ekologiczny", distance: 1841},
        {type: OfferPoiType.PARK, name: "Park linearny nad Kanałem Zaciszańskim", distance: 2247},
        {type: OfferPoiType.PARK, name: "Skwer Bolesława Dubickiego", distance: 2290},
        {type: OfferPoiType.PARK, name: "Plac Tulipanów", distance: 2315}
    ],
    20350: [
        {type: OfferPoiType.BUS, name: "Bartoszowice", distance: 157},
        {type: OfferPoiType.PARK, name: "Park Biskupiński", distance: 625},
        {type: OfferPoiType.BUS, name: "Bacciarellego", distance: 628},
        {type: OfferPoiType.BUS, name: "Biskupin", distance: 800},
        {type: OfferPoiType.TRAM, name: "Biskupin", distance: 819},
        {type: OfferPoiType.PARK, name: "Park Swojczycki", distance: 1924}
    ],
    20351: [
        {type: OfferPoiType.BUS, name: 'C.H. "Port Rumia" - Kosynierów 02', distance: 370},
        {type: OfferPoiType.BUS, name: "Zapolskiej 01", distance: 563},
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 02 n/ż", distance: 566},
        {type: OfferPoiType.BUS, name: "Zapolskiej 02", distance: 588},
        {type: OfferPoiType.BUS, name: 'Rumia C.H. "Port Rumia" 01', distance: 594},
        {type: OfferPoiType.BUS, name: "Rumia Jeziorna 01 n/ż", distance: 725},
        {type: OfferPoiType.PARK, name: "Zielona Wyspa", distance: 1762},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 2467}
    ],
    20352: [
        {type: OfferPoiType.BUS, name: "Ustka, Grunwaldzka", distance: 282},
        {type: OfferPoiType.BUS, name: "Ustka, Wróblewskiego", distance: 404},
        {type: OfferPoiType.BUS, name: "Ustka / Dunina", distance: 534},
        {type: OfferPoiType.BUS, name: "Ustka, Dunina", distance: 535},
        {type: OfferPoiType.BUS, name: "Ustka, Plac Dąbrowskiego", distance: 559},
        {type: OfferPoiType.BUS, name: "Ustka, Słupska - Stadion", distance: 742},
        {type: OfferPoiType.KOLEJ, name: "Ustka", distance: 804},
        {type: OfferPoiType.PARK, name: "Skwer Pożarniaków", distance: 947},
        {type: OfferPoiType.PARK, name: "Park Usteckich Stoczniowców", distance: 1040},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1056},
        {type: OfferPoiType.PARK, name: 'Park linowy "Na Wydmie"', distance: 1246},
        {type: OfferPoiType.PARK, name: "Park Chopina", distance: 1297},
        {type: OfferPoiType.PARK, name: "Park Uzdrowiskowy", distance: 1369}
    ],
    20353: [
        {type: OfferPoiType.BUS, name: "Targówka I", distance: 509},
        {type: OfferPoiType.BUS, name: "Targówka II", distance: 800},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 1981}
    ],
    20354: [
        {type: OfferPoiType.BUS, name: "Karolina", distance: 464},
        {type: OfferPoiType.BUS, name: "Wólka Mińska", distance: 535}
    ],
    20355: [
        {type: OfferPoiType.BUS, name: "Łucznicza 01", distance: 336},
        {type: OfferPoiType.BUS, name: "Łucznicza 02", distance: 359},
        {type: OfferPoiType.BUS, name: "Pastelowa 02", distance: 606},
        {type: OfferPoiType.BUS, name: "Podleckiego 01", distance: 626},
        {type: OfferPoiType.BUS, name: "Pastelowa 01", distance: 635},
        {type: OfferPoiType.BUS, name: "Chychły 01", distance: 707},
        {type: OfferPoiType.BUS, name: "Topazowa 02", distance: 720},
        {type: OfferPoiType.BUS, name: "Topazowa 01", distance: 731},
        {type: OfferPoiType.BUS, name: "Podleckiego 02", distance: 732},
        {type: OfferPoiType.BUS, name: "Przemian 01", distance: 737}
    ],
    20356: [
        {type: OfferPoiType.BUS, name: "Gliwice Michałowskiego", distance: 434},
        {type: OfferPoiType.BUS, name: "Gliwice Grottgera", distance: 484},
        {type: OfferPoiType.BUS, name: "Gliwice Cmentarz Lipowy", distance: 629},
        {type: OfferPoiType.BUS, name: "Gliwice Targowisko", distance: 657},
        {type: OfferPoiType.PARK, name: "Skwer Franza Honioka", distance: 903},
        {type: OfferPoiType.PARK, name: "Skwer Nacka", distance: 1807},
        {type: OfferPoiType.PARK, name: "plac gier", distance: 1842},
        {type: OfferPoiType.PARK, name: "Westerplatte", distance: 1864},
        {type: OfferPoiType.PARK, name: "Skwer Europejski", distance: 1973}
    ],
    20357: [
        {type: OfferPoiType.BUS, name: "Chwałkowska", distance: 405},
        {type: OfferPoiType.BUS, name: "Wełniana", distance: 520},
        {type: OfferPoiType.BUS, name: "Jędrzejowska", distance: 686},
        {type: OfferPoiType.PARK, name: "Park Stabłowicki", distance: 1557},
        {type: OfferPoiType.PARK, name: "Park Pracki", distance: 2257},
        {type: OfferPoiType.PARK, name: "EkoPark Stabłowice", distance: 2259}
    ],
    20358: [{type: OfferPoiType.BUS, name: "Komarowo 01", distance: 378}],
    20359: [{type: OfferPoiType.REZERWAT, name: "Lasy Grędzińskie", distance: 1967}],
    20360: [
        {type: OfferPoiType.PARK, name: "Park Anielin", distance: 298},
        {type: OfferPoiType.BUS, name: "Pałacyk Sokoła 01", distance: 413},
        {type: OfferPoiType.BUS, name: "Kościuszki 01", distance: 414},
        {type: OfferPoiType.BUS, name: "Kościuszki 02", distance: 421},
        {type: OfferPoiType.BUS, name: "USC 01", distance: 485},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Kościuszki", distance: 502},
        {type: OfferPoiType.BUS, name: "USC 05", distance: 548},
        {type: OfferPoiType.BUS, name: "USC 04", distance: 551},
        {type: OfferPoiType.BUS, name: "Kościuszki 03", distance: 589},
        {type: OfferPoiType.BUS, name: "PKP Pruszków", distance: 622},
        {type: OfferPoiType.KOLEJ, name: "Pruszków", distance: 671},
        {type: OfferPoiType.PARK, name: "Park Potulickich", distance: 783},
        {type: OfferPoiType.BUS, name: "Kościelna 02", distance: 830},
        {type: OfferPoiType.PARK, name: "Plac Cedrowy", distance: 898},
        {type: OfferPoiType.PARK, name: "Park Sensoryczny", distance: 1298}
    ],
    20363: [
        {type: OfferPoiType.BUS, name: "Sieczna 02", distance: 134},
        {type: OfferPoiType.BUS, name: "Okrągła 01", distance: 232},
        {type: OfferPoiType.BUS, name: "Sieczna 01", distance: 241},
        {type: OfferPoiType.BUS, name: "Okrągła 02", distance: 319},
        {type: OfferPoiType.BUS, name: "Podwójna 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Podwójna 02", distance: 455},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 01", distance: 598},
        {type: OfferPoiType.BUS, name: "Os. Derby 02", distance: 604},
        {type: OfferPoiType.BUS, name: "Os. Lewandów I 01", distance: 640},
        {type: OfferPoiType.BUS, name: "Grodzisk-Kościół 02", distance: 688},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 995}
    ],
    20365: [
        {type: OfferPoiType.BUS, name: "Wyścigowa [końcowy]", distance: 298},
        {type: OfferPoiType.TRAM, name: "Wyścigowa", distance: 305},
        {type: OfferPoiType.BUS, name: "Wyścigowa", distance: 313},
        {type: OfferPoiType.TRAM, name: "Wyścigowa [końcowy]", distance: 313},
        {type: OfferPoiType.BUS, name: "Fordońska / Wyścigowa", distance: 318},
        {type: OfferPoiType.TRAM, name: "Fordońska / Wyścigowa", distance: 335},
        {type: OfferPoiType.BUS, name: "Fordońska / Fabryczna", distance: 556},
        {type: OfferPoiType.TRAM, name: "Fordońska / Fabryczna", distance: 659},
        {type: OfferPoiType.BUS, name: "Dworzec Wschód", distance: 706},
        {type: OfferPoiType.PARK, name: "Park przyfolwarczny", distance: 1109},
        {type: OfferPoiType.PARK, name: "Skwer przy Gdyńskiej", distance: 1980},
        {type: OfferPoiType.PARK, name: "Ranczo Bartek", distance: 1999}
    ],
    20370: [
        {type: OfferPoiType.PARK, name: "Skwer Prażaby Czatkowickiej", distance: 753},
        {type: OfferPoiType.PARK, name: "Dzikie Planty", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy imienia Adama Bogackiego", distance: 1658},
        {type: OfferPoiType.PARK, name: "Skwer Olgi Drahonowskiej-Małkowskiej", distance: 1686},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Adama Bogackiego (Park Potockich)", distance: 2204}
    ],
    20371: [
        {type: OfferPoiType.BUS, name: "Port", distance: 60},
        {type: OfferPoiType.BUS, name: "Port 05", distance: 108},
        {type: OfferPoiType.BUS, name: "Plac Wolności 01", distance: 194},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 252},
        {type: OfferPoiType.BUS, name: "Plac Kościelny", distance: 333},
        {type: OfferPoiType.BUS, name: "Centrum 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 03", distance: 422},
        {type: OfferPoiType.BUS, name: "Centrum 02", distance: 432},
        {type: OfferPoiType.BUS, name: "Piastowska - kościół 04", distance: 433},
        {type: OfferPoiType.BUS, name: "Prom", distance: 459},
        {type: OfferPoiType.LAS, name: "Parki Miejski im. Fryderyka Chopina", distance: 687},
        {type: OfferPoiType.PARK, name: "Parki Miejski im. Fryderyka Chopina", distance: 687}
    ],
    20373: [
        {type: OfferPoiType.BUS, name: "Czermińskiego 02", distance: 331},
        {type: OfferPoiType.BUS, name: "Rębowo", distance: 447},
        {type: OfferPoiType.BUS, name: "Czermińskiego 01", distance: 502},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1346}
    ],
    20374: [
        {type: OfferPoiType.BUS, name: "Waniliowa", distance: 189},
        {type: OfferPoiType.BUS, name: "Kaparowa", distance: 371},
        {type: OfferPoiType.BUS, name: "Cynamonowa", distance: 474},
        {type: OfferPoiType.BUS, name: "Cynamonowa (Szkoła)", distance: 641},
        {type: OfferPoiType.BUS, name: "Kminkowa", distance: 691},
        {type: OfferPoiType.BUS, name: "Tymiankowa", distance: 802},
        {type: OfferPoiType.PARK, name: "Park Widawski", distance: 1689}
    ],
    20375: [
        {type: OfferPoiType.TRAM, name: "Sielska", distance: 368},
        {type: OfferPoiType.BUS, name: "Sielska", distance: 379},
        {type: OfferPoiType.BUS, name: "Częstochowska n/ż", distance: 386},
        {type: OfferPoiType.BUS, name: "Górczyn PKM", distance: 425},
        {type: OfferPoiType.KOLEJ, name: "Poznań Górczyn", distance: 434},
        {type: OfferPoiType.TRAM, name: "Górczyn PKM", distance: 508},
        {type: OfferPoiType.TRAM, name: "Krauthofera", distance: 792},
        {type: OfferPoiType.PARK, name: "Park Górczyński", distance: 800},
        {type: OfferPoiType.PARK, name: "Park Księdza Józefa Jasińskiego", distance: 1573},
        {type: OfferPoiType.PARK, name: "Skwer Jacka Hałasika", distance: 1762},
        {type: OfferPoiType.PARK, name: "Park Jana Kasprowicza", distance: 2053},
        {type: OfferPoiType.PARK, name: "Park Wojciecha Wróża", distance: 2148},
        {type: OfferPoiType.PARK, name: "Park Astronomiczny Jana Heweliusza", distance: 2179},
        {type: OfferPoiType.PARK, name: "Grunwaldzki Park Społeczny", distance: 2355}
    ],
    20377: [
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 462},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 485},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 519},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 542},
        {type: OfferPoiType.BUS, name: "Pomorska - Nowosolna", distance: 542},
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 595},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2014}
    ],
    20378: [
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 440},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 463},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 497},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Pomorska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 573},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2036}
    ],
    20379: [
        {type: OfferPoiType.BUS, name: "Długa 01", distance: 632},
        {type: OfferPoiType.BUS, name: "Długa 02", distance: 644}
    ],
    20380: [
        {type: OfferPoiType.BUS, name: "Zaborze Pyki", distance: 432},
        {type: OfferPoiType.TRAM, name: "Ruda Klary", distance: 589},
        {type: OfferPoiType.BUS, name: "Ruda Klary", distance: 597},
        {type: OfferPoiType.BUS, name: "Zaborze Struzika", distance: 628},
        {type: OfferPoiType.PARK, name: "Park Gorgol", distance: 969},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1685},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Augusta Kozioła", distance: 1945}
    ],
    20381: [
        {type: OfferPoiType.BUS, name: "Krzeszowice Zielona", distance: 640},
        {type: OfferPoiType.PARK, name: "Skwer Olgi Drahonowskiej-Małkowskiej", distance: 1338},
        {type: OfferPoiType.PARK, name: "Park Zdrojowy imienia Adama Bogackiego", distance: 1339},
        {type: OfferPoiType.REZERWAT, name: "Las Buczyna", distance: 1575},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Adama Bogackiego (Park Potockich)", distance: 1730},
        {type: OfferPoiType.PARK, name: "Dzikie Planty", distance: 2316}
    ],
    20382: [{type: OfferPoiType.BUS, name: "Rabowice Bukowa", distance: 793}],
    20383: [
        {type: OfferPoiType.BUS, name: "Zaborze Pyki", distance: 573},
        {type: OfferPoiType.BUS, name: "Zaborze Struzika", distance: 769},
        {type: OfferPoiType.LAS, name: "Dolina Rowu Rudzkiego II", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Gorgol", distance: 1189},
        {type: OfferPoiType.PARK, name: "Plac Żwirki i Wigury", distance: 1664},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Augusta Kozioła", distance: 1924}
    ],
    20384: [
        {type: OfferPoiType.BUS, name: "Niwka Tuwima", distance: 130},
        {type: OfferPoiType.BUS, name: "Niwka Szybowa", distance: 404},
        {type: OfferPoiType.BUS, name: "Osiedle Bór Bloki", distance: 501},
        {type: OfferPoiType.BUS, name: "Niwka Fabryka", distance: 590},
        {type: OfferPoiType.TRAM, name: "Niwka Fabryka", distance: 606},
        {type: OfferPoiType.PARK, name: "Skwer Stanisława Kłosowskiego", distance: 617},
        {type: OfferPoiType.PARK, name: "Park Wygoda", distance: 1395}
    ],
    20385: [
        {type: OfferPoiType.BUS, name: "Narutowicza - Bandrowskiego", distance: 200},
        {type: OfferPoiType.BUS, name: "Krakowska 01 - Pl. Kościuszki", distance: 211},
        {type: OfferPoiType.BUS, name: "Sikorskiego 01 - Świt", distance: 217},
        {type: OfferPoiType.BUS, name: "Krakowska 03 - Pl. Popiełuszki", distance: 282},
        {type: OfferPoiType.BUS, name: "Krakowska 02 - Planty", distance: 302},
        {type: OfferPoiType.BUS, name: "Tarnów Sikorskiego", distance: 346},
        {type: OfferPoiType.BUS, name: "Bema 04 - Szkoła", distance: 348},
        {type: OfferPoiType.PARK, name: "Planty im. Józefa Jakubowskiego", distance: 384},
        {type: OfferPoiType.BUS, name: "Skwer Petöfiego 01", distance: 399},
        {type: OfferPoiType.BUS, name: "Mościckiego 01 - Szkotnik", distance: 559},
        {type: OfferPoiType.BUS, name: "Narutowicza - Wodna", distance: 563},
        {type: OfferPoiType.PARK, name: "Skwer Obrońców Grodna 1939", distance: 685},
        {type: OfferPoiType.KOLEJ, name: "Tarnów", distance: 757},
        {type: OfferPoiType.PARK, name: "Skwer Alicji i Jana Preiss", distance: 813},
        {type: OfferPoiType.PARK, name: "Skwer Wójta Kiliana Bałkowicza", distance: 886},
        {type: OfferPoiType.PARK, name: "Skwer Ojca Olgierda Kokocińskiego", distance: 1180},
        {type: OfferPoiType.PARK, name: "Skwer Bohaterów Zadwórza 1920", distance: 1239},
        {type: OfferPoiType.PARK, name: "Plac Henryka Sienkiewicza", distance: 1340},
        {type: OfferPoiType.PARK, name: "plac Podpułkownika Stanisława Sowiźrała-Sobolewicza", distance: 1561}
    ],
    20386: [
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 07", distance: 371},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Logos 08", distance: 375},
        {type: OfferPoiType.BUS, name: "Wielkopolska 01", distance: 505},
        {type: OfferPoiType.BUS, name: "Osiedle Zachodnie 03", distance: 519},
        {type: OfferPoiType.BUS, name: "Osiedle Krzywa", distance: 636},
        {type: OfferPoiType.BUS, name: "Wielkopolska / Mazurska 02", distance: 678},
        {type: OfferPoiType.BUS, name: "Markiewicza - Poczta 02", distance: 712},
        {type: OfferPoiType.BUS, name: "Grunwaldzka / Nowokarsiborska 05", distance: 759},
        {type: OfferPoiType.BUS, name: "runwaldzka / Nowokarsiborska 06", distance: 790},
        {type: OfferPoiType.LAS, name: "Świdne Bagna", distance: 850},
        {type: OfferPoiType.PARK, name: "skwer imienia Druhów Olgi i Andrzeja Małkowskich", distance: 2465}
    ],
    20389: [
        {type: OfferPoiType.BUS, name: "Solec - Borowa NŻ", distance: 226},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Praussa", distance: 277},
        {type: OfferPoiType.BUS, name: "Borowa - Siewna NŻ", distance: 375},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Jarzynowa", distance: 627},
        {type: OfferPoiType.BUS, name: "Solec - Cm. Mania", distance: 639},
        {type: OfferPoiType.BUS, name: "Unii Lubelskiej - Srebrzyńska", distance: 675},
        {type: OfferPoiType.BUS, name: "Srebrzyńska - Cm. Mania", distance: 678},
        {type: OfferPoiType.TRAM, name: "Włókniarzy - Długosza", distance: 714},
        {type: OfferPoiType.PARK, name: "Nowoczesna Strefa Rekreacji, Wypoczynku i Animacji", distance: 1262},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Międzyrzecze Łódki i Bałutki”", distance: 1428},
        {type: OfferPoiType.PARK, name: "Park na Zdrowiu", distance: 1450},
        {type: OfferPoiType.PARK, name: "Skwer Praw Dziecka", distance: 1580},
        {type: OfferPoiType.PARK, name: "Skwer Michaliny Wisłockiej", distance: 1850},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 1875}
    ],
    20393: [
        {type: OfferPoiType.BUS, name: "Żeromskiego 01", distance: 281},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy", distance: 289},
        {type: OfferPoiType.BUS, name: "Żeromskiego 02", distance: 310},
        {type: OfferPoiType.PARK, name: "Skwer Kolejarzy", distance: 314},
        {type: OfferPoiType.BUS, name: "Dworzec Kolejowy 01", distance: 385},
        {type: OfferPoiType.KOLEJ, name: "Ostrołęka", distance: 429},
        {type: OfferPoiType.BUS, name: "Starowiejska 02", distance: 473},
        {type: OfferPoiType.BUS, name: "Starowiejska 01", distance: 474},
        {type: OfferPoiType.BUS, name: "Moniuszki 01", distance: 601},
        {type: OfferPoiType.BUS, name: "Kaczyńska 02", distance: 661},
        {type: OfferPoiType.BUS, name: "Wyspiańskiego 01", distance: 767},
        {type: OfferPoiType.BUS, name: "Kaczyńska 01", distance: 790}
    ],
    20394: [
        {type: OfferPoiType.BUS, name: "Nowosolna", distance: 440},
        {type: OfferPoiType.BUS, name: "Grabińska - Nowosolna", distance: 463},
        {type: OfferPoiType.BUS, name: "Brzezińska - Nowosolna", distance: 497},
        {type: OfferPoiType.BUS, name: "Wiączyńska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Pomorska - Nowosolna", distance: 520},
        {type: OfferPoiType.BUS, name: "Byszewska - Nowosolna", distance: 573},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Stawy w Nowosolnej”", distance: 2036}
    ],
    20397: [
        {type: OfferPoiType.BUS, name: "Wólczańska - Skorupki", distance: 131},
        {type: OfferPoiType.PARK, name: "Park im. ks. bp. Michała Klepacza", distance: 198},
        {type: OfferPoiType.BUS, name: "Wólczańska - Radwańska", distance: 355},
        {type: OfferPoiType.BUS, name: "Wólczańska - Czerwona", distance: 378},
        {type: OfferPoiType.BUS, name: "Piotrkowska - Pl. Katedralny", distance: 391},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Pl. Katedralny", distance: 391},
        {type: OfferPoiType.BUS, name: "Politechniki - Park im. Klepacza NŻ", distance: 400},
        {type: OfferPoiType.BUS, name: "Radwańska - Wólczańska", distance: 427},
        {type: OfferPoiType.TRAM, name: "Politechniki - Targi Łódzkie", distance: 505},
        {type: OfferPoiType.PARK, name: "Skwer Ignacego Daszyńskiego", distance: 543},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Brzeźna", distance: 651},
        {type: OfferPoiType.TRAM, name: "Piotrkowska - Czerwona", distance: 681},
        {type: OfferPoiType.TRAM, name: "Politechniki - Radwańska (kampus PŁ)", distance: 723},
        {type: OfferPoiType.TRAM, name: "Żeromskiego - Radwańska (kampus PŁ)", distance: 743},
        {type: OfferPoiType.PARK, name: "Park im. inż. Stefana Skrzywana", distance: 1053},
        {type: OfferPoiType.PARK, name: "Park im. Władysława Reymonta", distance: 1190},
        {type: OfferPoiType.PARK, name: "Park Edwarda Abramowskiego", distance: 1264}
    ],
    20399: [
        {type: OfferPoiType.BUS, name: "Katowice Kopernika Dworzec", distance: 152},
        {type: OfferPoiType.BUS, name: "Katowice Skłodowskiej Dworzec", distance: 183},
        {type: OfferPoiType.BUS, name: "Katowice Plac Miarki", distance: 244},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Miarki", distance: 246},
        {type: OfferPoiType.PARK, name: "Plac Andrzeja", distance: 278},
        {type: OfferPoiType.BUS, name: "Katowice Andrzeja Dworzec", distance: 330},
        {type: OfferPoiType.TRAM, name: "Katowice Jordana", distance: 360},
        {type: OfferPoiType.PARK, name: "Plac Świętego Jana Pawła II", distance: 461},
        {type: OfferPoiType.PARK, name: "Plac doktora Józefa Rostka", distance: 496},
        {type: OfferPoiType.KOLEJ, name: "Katowice", distance: 500},
        {type: OfferPoiType.PARK, name: "plac ks. kard. Augusta Hlonda", distance: 547},
        {type: OfferPoiType.PARK, name: "Skwer Prymasowski", distance: 640},
        {type: OfferPoiType.TRAM, name: "Katowice Stadion AWF", distance: 722},
        {type: OfferPoiType.TRAM, name: "Katowice Plac Wolności", distance: 815},
        {type: OfferPoiType.TRAM, name: "Katowice Św. Jana", distance: 828}
    ],
    20401: [
        {type: OfferPoiType.KOLEJ, name: "Wieliczka Bogucice", distance: 399},
        {type: OfferPoiType.BUS, name: "Wieliczka Winnicka", distance: 584},
        {type: OfferPoiType.PARK, name: "Park Świętej Barbary", distance: 1876},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 2192},
        {type: OfferPoiType.PARK, name: "Planty", distance: 2388}
    ],
    20403: [
        {type: OfferPoiType.BUS, name: "Rondo Bitwy Warszawskiej 1920 r.", distance: 196},
        {type: OfferPoiType.BUS, name: "Okrzei", distance: 358},
        {type: OfferPoiType.BUS, name: "Kazikowskiego", distance: 421},
        {type: OfferPoiType.BUS, name: "Mińsk Mazowiecki Dworzec Autobusowy", distance: 422},
        {type: OfferPoiType.PARK, name: "Skwer przy Muzeum Ziemi Mińskiej", distance: 475},
        {type: OfferPoiType.KOLEJ, name: "Mińsk Mazowiecki", distance: 529},
        {type: OfferPoiType.PARK, name: "Skwer Prezydenta Ryszarda Kaczorowskiego", distance: 751},
        {type: OfferPoiType.PARK, name: "Skwer 600-lecia", distance: 995},
        {type: OfferPoiType.PARK, name: "Plac Lotników", distance: 1084},
        {type: OfferPoiType.PARK, name: "Plac Stary Rynek", distance: 1161},
        {type: OfferPoiType.PARK, name: "Park Dernałowiczów", distance: 1380},
        {type: OfferPoiType.PARK, name: "Skwer Władysława Bartoszewskiego", distance: 2084}
    ],
    20406: [
        {type: OfferPoiType.PARK, name: 'Skwer im. Majora Henryka Dobrzańskiego "Hubala"', distance: 156},
        {type: OfferPoiType.PARK, name: "Park im. Włodzimierza Skarbek-Borowskiego", distance: 372},
        {type: OfferPoiType.BUS, name: "Osiedle Metalowiec", distance: 457},
        {type: OfferPoiType.BUS, name: "Osiedle Chemik", distance: 504},
        {type: OfferPoiType.BUS, name: "T.C. Dębica 1-Maja", distance: 513},
        {type: OfferPoiType.BUS, name: "Staszica Starostwo", distance: 598},
        {type: OfferPoiType.BUS, name: "Osiedle Matejki", distance: 733},
        {type: OfferPoiType.BUS, name: "Krakowska Klasztor", distance: 734},
        {type: OfferPoiType.PARK, name: "Plac Kazimierza Wielkiego", distance: 1212},
        {type: OfferPoiType.PARK, name: "Skwer im. Rodziny Mikołajków", distance: 1226},
        {type: OfferPoiType.PARK, name: "Plac im. Krzysztofa Pendereckiego", distance: 1264},
        {type: OfferPoiType.PARK, name: "Park Jordanowski", distance: 1293},
        {type: OfferPoiType.PARK, name: "Plac Solidarności", distance: 1338},
        {type: OfferPoiType.PARK, name: "Plac Gryfitów", distance: 1364}
    ],
    20407: [
        {type: OfferPoiType.BUS, name: "Wiejska / Chojnicka", distance: 319},
        {type: OfferPoiType.BUS, name: "Nad Torem / Karolewska", distance: 414},
        {type: OfferPoiType.BUS, name: "Wiejska / Krajeńska", distance: 494},
        {type: OfferPoiType.BUS, name: "Krajeńska / Wiejska", distance: 564},
        {type: OfferPoiType.BUS, name: "Wiejska / Deszczowa", distance: 714},
        {type: OfferPoiType.BUS, name: "Deszczowa / Wiejska", distance: 777},
        {type: OfferPoiType.BUS, name: "Nad Torem / Chmurna", distance: 788},
        {type: OfferPoiType.BUS, name: "Czyżkówko", distance: 798},
        {type: OfferPoiType.PARK, name: "Park przy papierni", distance: 1299},
        {type: OfferPoiType.PARK, name: "Park nad Kanałem Bydgoskim", distance: 2213},
        {type: OfferPoiType.PARK, name: "Skwer Poległych i Pomordowanych Mieszkańców Jachcic w latach 1939-1945", distance: 2282},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Prałata Zdzisława Peszkowskiego", distance: 2393}
    ],
    20411: [
        {type: OfferPoiType.BUS, name: "Bilitewskiego", distance: 604},
        {type: OfferPoiType.BUS, name: "Rubinowa", distance: 732},
        {type: OfferPoiType.BUS, name: "Popiełuszki", distance: 795},
        {type: OfferPoiType.PARK, name: "Przestrzeń trawiasta dla: Frisbee, Badmintona itd.", distance: 1656}
    ],
    20413: [
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 241},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 03", distance: 317},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 01", distance: 351},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 441},
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 522},
        {type: OfferPoiType.BUS, name: "Krzemienna 02", distance: 572},
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 668},
        {type: OfferPoiType.BUS, name: "Krzemienna 01", distance: 752},
        {type: OfferPoiType.BUS, name: "Kamykowa 02", distance: 762},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1426}
    ],
    20417: [
        {type: OfferPoiType.BUS, name: "Berensona 02", distance: 116},
        {type: OfferPoiType.BUS, name: "Berensona 01", distance: 272},
        {type: OfferPoiType.BUS, name: "Bohuna 02", distance: 343},
        {type: OfferPoiType.BUS, name: "Berensona-Kanał 01", distance: 367},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 04", distance: 390},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 02", distance: 392},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 03", distance: 409},
        {type: OfferPoiType.BUS, name: "Ostródzka-Szkoła 01", distance: 493},
        {type: OfferPoiType.BUS, name: "Skarbka z Gór 01", distance: 664},
        {type: OfferPoiType.BUS, name: "Juranda ze Spychowa 02", distance: 690},
        {type: OfferPoiType.PARK, name: "Park Magiczna", distance: 1875}
    ],
    20418: [
        {type: OfferPoiType.BUS, name: "Pustecka", distance: 680},
        {type: OfferPoiType.BUS, name: "Trzmielowicka", distance: 727},
        {type: OfferPoiType.BUS, name: "Miodowa (Osiedle)", distance: 824},
        {type: OfferPoiType.PARK, name: "skwer Andrzeja Kobla", distance: 1797},
        {type: OfferPoiType.PARK, name: "Park Leśnicki", distance: 2401}
    ],
    20420: [
        {type: OfferPoiType.BUS, name: "Brzezińska - Kerna NŻ", distance: 365},
        {type: OfferPoiType.BUS, name: "Brzezińska - Janosika", distance: 419},
        {type: OfferPoiType.PARK, name: "Skwer Krzysztofa Surlita", distance: 445},
        {type: OfferPoiType.BUS, name: "Kerna - Brzezińska", distance: 479},
        {type: OfferPoiType.BUS, name: "Janosika - Powstańców Śląskich", distance: 700},
        {type: OfferPoiType.BUS, name: "Brzezińska - CH M1", distance: 727},
        {type: OfferPoiType.PARK, name: "Park na Giewoncie", distance: 2284},
        {type: OfferPoiType.PARK, name: "Park im. gen. Mariusza Zaruskiego", distance: 2383}
    ],
    20421: [
        {type: OfferPoiType.BUS, name: "Wybickiego 02", distance: 109},
        {type: OfferPoiType.BUS, name: "Wybickiego 01", distance: 235},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 01", distance: 252},
        {type: OfferPoiType.BUS, name: "Krowodrza Urzędy Skarbowe 02", distance: 314},
        {type: OfferPoiType.BUS, name: "Bratysławska 06", distance: 330},
        {type: OfferPoiType.BUS, name: "Bratysławska 05", distance: 444},
        {type: OfferPoiType.TRAM, name: "Bratysławska 02", distance: 452},
        {type: OfferPoiType.TRAM, name: "Bratysławska 01", distance: 513},
        {type: OfferPoiType.BUS, name: "Bratysławska 04", distance: 516},
        {type: OfferPoiType.BUS, name: "Władysława Łokietka 01", distance: 537},
        {type: OfferPoiType.BUS, name: "Krowodrza Górka P+R 06", distance: 596},
        {type: OfferPoiType.BUS, name: "Krowodrza Górka P+R 05", distance: 599},
        {type: OfferPoiType.PARK, name: "Park przy Rogatce", distance: 689},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 02", distance: 713},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 03", distance: 716},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R", distance: 754},
        {type: OfferPoiType.TRAM, name: "Krowodrza Górka P+R 01", distance: 766},
        {type: OfferPoiType.PARK, name: "Park Łokietka", distance: 803},
        {type: OfferPoiType.PARK, name: "Park imienia Stanisława Wyspiańskiego", distance: 907},
        {type: OfferPoiType.PARK, name: "Park Krowoderski", distance: 1014},
        {type: OfferPoiType.PARK, name: "Ogród Osiedlowy", distance: 1208}
    ],
    20425: [
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 02", distance: 285},
        {type: OfferPoiType.BUS, name: "Solec-Świetlica 01", distance: 302},
        {type: OfferPoiType.BUS, name: "Szymanów 02", distance: 748},
        {type: OfferPoiType.BUS, name: "Szymanów 01", distance: 795},
        {type: OfferPoiType.BUS, name: "Szymanów 03", distance: 820},
        {type: OfferPoiType.BUS, name: "Szymanów 04", distance: 821},
        {type: OfferPoiType.REZERWAT, name: "Łąki Soleckie", distance: 1370}
    ],
    20427: [{type: OfferPoiType.BUS, name: "Sławoszewo", distance: 486}],
    20430: [
        {type: OfferPoiType.BUS, name: "Popiełuszki/Ubocze", distance: 152},
        {type: OfferPoiType.BUS, name: "Popiełuszki/al. Niepodległości", distance: 230},
        {type: OfferPoiType.BUS, name: "Popiełuszki/Batalionów Chłopskich", distance: 278},
        {type: OfferPoiType.BUS, name: "Popiełuszki/Sikorskiego", distance: 285},
        {type: OfferPoiType.BUS, name: "Wrocławska/Galeria Zielone Wzgórze", distance: 338},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Batalionów Chłopskich", distance: 351},
        {type: OfferPoiType.BUS, name: "al. Niepodległości/Popiełuszki", distance: 418},
        {type: OfferPoiType.BUS, name: "Armii Krajowej/Powstańców", distance: 436},
        {type: OfferPoiType.BUS, name: "Popiełuszki/Boboli", distance: 461},
        {type: OfferPoiType.PARK, name: "Leśny Park Kieszonkowy", distance: 967},
        {type: OfferPoiType.PARK, name: "Park Janiny Kurkowskiej-Spychajowej", distance: 1238},
        {type: OfferPoiType.REZERWAT, name: "Stawy Marczukowskie i Dolina Bażantarki", distance: 1792},
        {type: OfferPoiType.PARK, name: "Park im. Andrzeja Piotra Karolskiego", distance: 1804}
    ],
    20431: [
        {type: OfferPoiType.BUS, name: "Słoneczna 02", distance: 100},
        {type: OfferPoiType.BUS, name: "Słoneczna 03", distance: 269},
        {type: OfferPoiType.BUS, name: "Słoneczna 01", distance: 282},
        {type: OfferPoiType.PARK, name: "Skwer Żołnierzy Wyklętych", distance: 534},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 02", distance: 547},
        {type: OfferPoiType.BUS, name: "Wspólna 01", distance: 561},
        {type: OfferPoiType.BUS, name: "Wspólna 02", distance: 616},
        {type: OfferPoiType.BUS, name: "Marki-Ratusz 01", distance: 625},
        {type: OfferPoiType.PARK, name: "Park Wolontariuszy", distance: 628},
        {type: OfferPoiType.BUS, name: "Okólna 02", distance: 826},
        {type: OfferPoiType.PARK, name: "Park Miejski", distance: 1097},
        {type: OfferPoiType.PARK, name: "Skwer Pamięci Narodowej", distance: 1356}
    ],
    20432: [
        {type: OfferPoiType.BUS, name: "Kórnicka", distance: 127},
        {type: OfferPoiType.TRAM, name: "Kórnicka", distance: 172},
        {type: OfferPoiType.BUS, name: "Rondo Rataje", distance: 343},
        {type: OfferPoiType.TRAM, name: "Rondo Rataje", distance: 405},
        {type: OfferPoiType.TRAM, name: "Politechnika", distance: 489},
        {type: OfferPoiType.BUS, name: "Politechnika", distance: 518},
        {type: OfferPoiType.BUS, name: "Os. Jagiellońskie n/ż", distance: 520},
        {type: OfferPoiType.PARK, name: "Park Karola Kurpińskiego", distance: 661},
        {type: OfferPoiType.PARK, name: "Skwer 4 Czerwca 1989 r.", distance: 975},
        {type: OfferPoiType.PARK, name: "Park Tadeusza Mazowieckiego", distance: 1274},
        {type: OfferPoiType.PARK, name: "Park Rataje", distance: 1478},
        {type: OfferPoiType.PARK, name: "Park Nad Wartą", distance: 1544},
        {type: OfferPoiType.PARK, name: "Park Stare Koryto Warty", distance: 1555},
        {type: OfferPoiType.PARK, name: "Park Fryderyka Chopina", distance: 1673},
        {type: OfferPoiType.REZERWAT, name: "Traszki Ratajskie", distance: 1853},
        {type: OfferPoiType.PARK, name: "Park na os. Tysiąclecia", distance: 1921},
        {type: OfferPoiType.PARK, name: "Park Tysiąclecia", distance: 2036},
        {type: OfferPoiType.REZERWAT, name: "Obszar Natura 2000 Fortyfikacje w Poznaniu", distance: 2104}
    ],
    20434: [
        {type: OfferPoiType.PARK, name: "Plac rekreacyjny", distance: 265},
        {type: OfferPoiType.BUS, name: "Teresin Szkoła", distance: 335},
        {type: OfferPoiType.BUS, name: "Teresin-Niepokalanów PKP", distance: 778},
        {type: OfferPoiType.PARK, name: "Park rekreacyjny", distance: 1669}
    ],
    20435: [
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 02", distance: 383},
        {type: OfferPoiType.BUS, name: "Zielone Wzgórze 01", distance: 383},
        {type: OfferPoiType.BUS, name: "Poligonowa - Osiedle 01", distance: 675},
        {type: OfferPoiType.BUS, name: "Poligonowa - osiedle 02", distance: 685},
        {type: OfferPoiType.PARK, name: "Park Górki Czechowskie", distance: 1120}
    ],
    20436: [{type: OfferPoiType.BUS, name: "Wilczynek 01", distance: 781}],
    20438: [
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Szpital 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Szpital 04", distance: 627},
        {type: OfferPoiType.BUS, name: "Uniwersytecka / Przytycka 02", distance: 674},
        {type: OfferPoiType.BUS, name: "Przytycka / Uniwersytecka 03", distance: 754},
        {type: OfferPoiType.BUS, name: "Przytycka / Uniwersytecka 04", distance: 828},
        {type: OfferPoiType.BUS, name: "Wacyn / Szpital 03", distance: 840}
    ],
    20440: [
        {type: OfferPoiType.BUS, name: "Ćwiklińskiej 01", distance: 387},
        {type: OfferPoiType.BUS, name: "Ćwiklińskiej 02", distance: 445},
        {type: OfferPoiType.PARK, name: "Park Ireny Jarockiej", distance: 466},
        {type: OfferPoiType.BUS, name: "Leśnej Polanki 01", distance: 613},
        {type: OfferPoiType.BUS, name: "Strumykowa 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Chęcińska 01", distance: 648},
        {type: OfferPoiType.PARK, name: "Skwer Teherański", distance: 659},
        {type: OfferPoiType.BUS, name: "Chęcińska 02", distance: 710},
        {type: OfferPoiType.BUS, name: "Leśnej Polanki 02", distance: 719},
        {type: OfferPoiType.BUS, name: "Strumykowa 01", distance: 771},
        {type: OfferPoiType.PARK, name: "Park Ogrody Mehoffera", distance: 1251},
        {type: OfferPoiType.PARK, name: "Park Henrykowski", distance: 1664}
    ],
    20441: [
        {type: OfferPoiType.BUS, name: "Borkowo Szkoła 02", distance: 788},
        {type: OfferPoiType.BUS, name: "Borkowo Szkoła 01", distance: 793},
        {type: OfferPoiType.BUS, name: "Borkowo, Głębokie", distance: 809},
        {type: OfferPoiType.BUS, name: "Borkowo Kasztanowa 02", distance: 819}
    ],
    20442: [
        {type: OfferPoiType.BUS, name: "Wieliczka Solne Miasto II", distance: 120},
        {type: OfferPoiType.BUS, name: "Wieliczka Solne Miasto I", distance: 186},
        {type: OfferPoiType.PARK, name: "Park Adama Mickiewicza", distance: 426},
        {type: OfferPoiType.BUS, name: "Wieliczka Park II", distance: 649},
        {type: OfferPoiType.BUS, name: "Wieliczka Park I", distance: 662},
        {type: OfferPoiType.BUS, name: "Wieliczka Sąd", distance: 666},
        {type: OfferPoiType.PARK, name: "Park Świętej Kingi", distance: 677},
        {type: OfferPoiType.BUS, name: "Wieliczka Jedynaka", distance: 786},
        {type: OfferPoiType.PARK, name: "Planty", distance: 1404}
    ],
    20444: [
        {type: OfferPoiType.BUS, name: "Podchorążych - Łucznicza NŻ", distance: 301},
        {type: OfferPoiType.BUS, name: "Podchorążych - Molla NŻ", distance: 522},
        {type: OfferPoiType.BUS, name: "Złotno - Legnicka NŻ", distance: 728},
        {type: OfferPoiType.PARK, name: "Park Podchorążych", distance: 1550},
        {type: OfferPoiType.PARK, name: "Park nad Jasieńcem", distance: 1605},
        {type: OfferPoiType.PARK, name: "Park im. Rotmistrza Witolda Pileckiego", distance: 1635},
        {type: OfferPoiType.PARK, name: "Park Trzy Wyspy", distance: 1934},
        {type: OfferPoiType.PARK, name: "Park Grabieński Las", distance: 2312},
        {type: OfferPoiType.PARK, name: "Skwer Olszynki Grochowskiej", distance: 2322},
        {type: OfferPoiType.REZERWAT, name: "Użytek ekologiczny „Majerowskie Błota”", distance: 2342},
        {type: OfferPoiType.PARK, name: "Skwer pocmentarny", distance: 2388},
        {type: OfferPoiType.PARK, name: "Park Kielecki", distance: 2397}
    ],
    20446: [
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 02", distance: 400},
        {type: OfferPoiType.BUS, name: "Dzikiej Jabłoni 01", distance: 446},
        {type: OfferPoiType.BUS, name: "Chyliczki 01", distance: 763}
    ],
    20447: [
        {type: OfferPoiType.BUS, name: "Hołubcowa 02", distance: 224},
        {type: OfferPoiType.BUS, name: "Hołubcowa 01", distance: 267},
        {type: OfferPoiType.BUS, name: "Łączyny 02", distance: 307},
        {type: OfferPoiType.BUS, name: "Osmańska 01", distance: 421},
        {type: OfferPoiType.BUS, name: "Wyczółki 01", distance: 435},
        {type: OfferPoiType.BUS, name: "Wyczółki 02", distance: 447},
        {type: OfferPoiType.BUS, name: "Kłobucka 02", distance: 471},
        {type: OfferPoiType.BUS, name: "Kłobucka 04", distance: 497},
        {type: OfferPoiType.PARK, name: "Park Wyczółki", distance: 595},
        {type: OfferPoiType.REZERWAT, name: "Jeziorko Imielińskie - użytek 623", distance: 2512}
    ],
    20448: [
        {type: OfferPoiType.BUS, name: "Dorodna 02", distance: 466},
        {type: OfferPoiType.BUS, name: "Laurowa 02", distance: 605},
        {type: OfferPoiType.BUS, name: "Portowa 01", distance: 642},
        {type: OfferPoiType.BUS, name: "Laurowa 01", distance: 652},
        {type: OfferPoiType.BUS, name: "Portowa 02", distance: 714},
        {type: OfferPoiType.PARK, name: "Park Żerański", distance: 1531}
    ],
    20449: [
        {type: OfferPoiType.BUS, name: "Jeziorna", distance: 357},
        {type: OfferPoiType.LAS, name: "Leśny zakątek", distance: 514},
        {type: OfferPoiType.LAS, name: "Małpia Wyspa", distance: 1023}
    ],
    20451: [
        {type: OfferPoiType.BUS, name: "Pożaryskiego 04", distance: 650},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 03", distance: 653},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 01", distance: 772},
        {type: OfferPoiType.BUS, name: "Czatów 02", distance: 774},
        {type: OfferPoiType.BUS, name: "Czatów 01", distance: 791},
        {type: OfferPoiType.BUS, name: "Pożaryskiego 02", distance: 796}
    ],
    20452: [
        {type: OfferPoiType.BUS, name: "Skośna 02", distance: 215},
        {type: OfferPoiType.BUS, name: "Skośna 01", distance: 254},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 01", distance: 535},
        {type: OfferPoiType.PARK, name: "Ogród Społeczny Macierzanki", distance: 546},
        {type: OfferPoiType.BUS, name: "Konopczyńskiego 02", distance: 584},
        {type: OfferPoiType.BUS, name: "Lubostroń 02", distance: 626},
        {type: OfferPoiType.BUS, name: "Piltza 02", distance: 676},
        {type: OfferPoiType.BUS, name: "Piltza 01", distance: 714},
        {type: OfferPoiType.BUS, name: "Lubostroń 01", distance: 759},
        {type: OfferPoiType.BUS, name: "Lubostroń 04", distance: 784},
        {type: OfferPoiType.BUS, name: "Kobierzyn 02", distance: 798},
        {type: OfferPoiType.PARK, name: "Skwer Generała de Gaulle", distance: 1088},
        {type: OfferPoiType.PARK, name: "Park Maćka i Doroty", distance: 1957},
        {type: OfferPoiType.PARK, name: "Zielony Trójkąt", distance: 2046},
        {type: OfferPoiType.REZERWAT, name: "Rozlewisko Potoku Rzewnego", distance: 2145},
        {type: OfferPoiType.REZERWAT, name: "Łąki na Klinach", distance: 2390}
    ],
    20453: [
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Żurawiej", distance: 118},
        {type: OfferPoiType.KOLEJ, name: "Kołobrzeg Stadion", distance: 259},
        {type: OfferPoiType.BUS, name: "Bałtycka - Zarząd Portu", distance: 333},
        {type: OfferPoiType.BUS, name: "Centum Przesiadkowe Bałtycka", distance: 370},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej - Kościół", distance: 473},
        {type: OfferPoiType.BUS, name: "Jedności Narodowej przy Wolności", distance: 540},
        {type: OfferPoiType.PARK, name: "Skwer Generała Broni Waldemara Skrzypczaka", distance: 1036},
        {type: OfferPoiType.LAS, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Teatralny", distance: 1146},
        {type: OfferPoiType.PARK, name: "Park Kasztanowy", distance: 1187},
        {type: OfferPoiType.PARK, name: "Bulwar imienia księdza prałata Józefa Słomskiego", distance: 1262},
        {type: OfferPoiType.LAS, name: "Park im. Stefana Żeromskiego", distance: 1647}
    ],
    20454: [
        {type: OfferPoiType.BUS, name: "Meksykańska 01", distance: 129},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP - os. Meksyk 03", distance: 134},
        {type: OfferPoiType.BUS, name: "Meksykańska 02", distance: 196},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP - os. Meksyk 01", distance: 201},
        {type: OfferPoiType.BUS, name: "Wiśniowa 90", distance: 246},
        {type: OfferPoiType.KOLEJ, name: "Gdynia Chylonia", distance: 282},
        {type: OfferPoiType.BUS, name: "Pucka - Hutnicza", distance: 312},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 04", distance: 329},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 06", distance: 348},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP 01", distance: 443},
        {type: OfferPoiType.BUS, name: "Chylonia Dworzec PKP", distance: 448},
        {type: OfferPoiType.PARK, name: "Park nad Strugą Cisowską", distance: 1246}
    ],
    20455: [
        {type: OfferPoiType.TRAM, name: "Częstochowska 02", distance: 204},
        {type: OfferPoiType.TRAM, name: "Częstochowska 01", distance: 252},
        {type: OfferPoiType.BUS, name: "Piotrkowska 03", distance: 326},
        {type: OfferPoiType.BUS, name: "Piotrkowska 04", distance: 343},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 02", distance: 402},
        {type: OfferPoiType.TRAM, name: "Piotrkowska 01", distance: 448},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 02", distance: 644},
        {type: OfferPoiType.BUS, name: "Jeleniogórska 01", distance: 650},
        {type: OfferPoiType.BUS, name: "Kielecka 02", distance: 679},
        {type: OfferPoiType.BUS, name: "Ujeścisko 04", distance: 683},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 01", distance: 692},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 03", distance: 710},
        {type: OfferPoiType.BUS, name: "Ujeścisko 05", distance: 718},
        {type: OfferPoiType.TRAM, name: "Ujeścisko 02", distance: 718},
        {type: OfferPoiType.BUS, name: "Ujeścisko 06", distance: 721},
        {type: OfferPoiType.BUS, name: "Kielecka 01", distance: 778},
        {type: OfferPoiType.BUS, name: "Nowosądecka 01", distance: 802},
        {type: OfferPoiType.PARK, name: "Jar Wilanowski", distance: 1819},
        {type: OfferPoiType.PARK, name: "Zielony Staw", distance: 1969},
        {type: OfferPoiType.PARK, name: "Park Dragana", distance: 2382}
    ],
    20456: [
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 02", distance: 161},
        {type: OfferPoiType.BUS, name: "Pogórze - Przedszkole 01", distance: 191},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 02", distance: 414},
        {type: OfferPoiType.BUS, name: "Pogórze - Dąbrowskiego 02", distance: 639},
        {type: OfferPoiType.BUS, name: "Pogórze - Obrońców Wybrzeża 01", distance: 647},
        {type: OfferPoiType.BUS, name: "Pogórze - Pułaskiego", distance: 657},
        {type: OfferPoiType.BUS, name: "Pogórze - Pułaskiego 02", distance: 687},
        {type: OfferPoiType.BUS, name: "Pogórze - Pułaskiego 01", distance: 708},
        {type: OfferPoiType.PARK, name: "Kosmiczna kieszonka", distance: 1370},
        {type: OfferPoiType.PARK, name: "Ogród szkolny", distance: 1619},
        {type: OfferPoiType.PARK, name: "Skwer im. Ireny Kwiatkowskiej", distance: 1995}
    ],
    20457: [
        {type: OfferPoiType.BUS, name: "Os. Ślichowice", distance: 183},
        {type: OfferPoiType.BUS, name: "Massalskiego", distance: 498},
        {type: OfferPoiType.KOLEJ, name: "Kielce Ślichowice", distance: 665},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skalny Ślichowice im. Jana Czarnockiego", distance: 690}
    ],
    20458: [
        {type: OfferPoiType.BUS, name: "Błonie Nowakowskiego", distance: 142},
        {type: OfferPoiType.PARK, name: "Skwer Towarzystwa Przyjaciół Ziemi Błońskiej", distance: 353},
        {type: OfferPoiType.BUS, name: "Błonie Piłsudskiego Przedszkole", distance: 409},
        {type: OfferPoiType.BUS, name: "Błonie Okrzei", distance: 462},
        {type: OfferPoiType.BUS, name: "Błonie Stadion", distance: 528},
        {type: OfferPoiType.BUS, name: "Błonie Wyszyńskiego", distance: 745},
        {type: OfferPoiType.BUS, name: "Błonie Narutowicza", distance: 772},
        {type: OfferPoiType.PARK, name: "Park Bajka", distance: 779},
        {type: OfferPoiType.PARK, name: "Park Włoski", distance: 926}
    ],
    20459: [
        {type: OfferPoiType.BUS, name: "Rumia, Urząd Miasta Rumi", distance: 162},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 01", distance: 407},
        {type: OfferPoiType.BUS, name: "Górnicza 01 (NŻ)", distance: 426},
        {type: OfferPoiType.BUS, name: "Górnicza 03 (NŻ)", distance: 445},
        {type: OfferPoiType.BUS, name: "Sabata - Szkoła 02", distance: 457},
        {type: OfferPoiType.BUS, name: "Młyńska", distance: 613},
        {type: OfferPoiType.BUS, name: "Dąbrowskiego - Most", distance: 646},
        {type: OfferPoiType.KOLEJ, name: "Rumia", distance: 751},
        {type: OfferPoiType.PARK, name: "Park Starowiejski", distance: 1282},
        {type: OfferPoiType.PARK, name: "Park Żelewskiego", distance: 1858},
        {type: OfferPoiType.PARK, name: "Eko Park", distance: 2010}
    ],
    20460: [
        {type: OfferPoiType.PARK, name: "Park na Jarze", distance: 1896},
        {type: OfferPoiType.PARK, name: "Szwajcarski Zakątek", distance: 2270}
    ],
    20463: [
        {type: OfferPoiType.BUS, name: "Malborska (EPBP)", distance: 317},
        {type: OfferPoiType.BUS, name: "Malborska - Fredry", distance: 367},
        {type: OfferPoiType.BUS, name: "Skrzydlata - LOK", distance: 461},
        {type: OfferPoiType.BUS, name: "Lotnicza - Fredry", distance: 648},
        {type: OfferPoiType.BUS, name: "Malborska - Zagonowa", distance: 672},
        {type: OfferPoiType.BUS, name: "Lotnicza - wiadukt", distance: 704},
        {type: OfferPoiType.BUS, name: "Lotnicza - Skrzydlata", distance: 710},
        {type: OfferPoiType.PARK, name: "Park Wojska Polskiego", distance: 1357},
        {type: OfferPoiType.PARK, name: "Skwer Waldemara Rebinina", distance: 1401},
        {type: OfferPoiType.PARK, name: "Park Planty", distance: 1634},
        {type: OfferPoiType.PARK, name: "Park im. Generała Bolesława Nieczuja-Ostrowskiego", distance: 1689}
    ],
    20464: [
        {type: OfferPoiType.BUS, name: "Fabryczna 02", distance: 625},
        {type: OfferPoiType.BUS, name: "Fabryczna 01", distance: 627},
        {type: OfferPoiType.BUS, name: "Nizinna 01", distance: 704},
        {type: OfferPoiType.BUS, name: "Nizinna 02", distance: 756}
    ],
    20465: [
        {type: OfferPoiType.BUS, name: "Chałubińskiego", distance: 471},
        {type: OfferPoiType.BUS, name: "PWSZ", distance: 481},
        {type: OfferPoiType.BUS, name: "Ruszczyca", distance: 597},
        {type: OfferPoiType.BUS, name: "Szpital", distance: 746},
        {type: OfferPoiType.BUS, name: "Zielona", distance: 794},
        {type: OfferPoiType.PARK, name: "Park PCK", distance: 1763},
        {type: OfferPoiType.PARK, name: "Skwer Generała Marka Bezruczki", distance: 2416}
    ],
    20466: [
        {type: OfferPoiType.BUS, name: "Szlachecka 02", distance: 240},
        {type: OfferPoiType.BUS, name: "Szlachecka 01", distance: 256},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 02", distance: 725},
        {type: OfferPoiType.BUS, name: "Zbyszka z Bogdańca 01", distance: 789},
        {type: OfferPoiType.PARK, name: "Park kieszonkowy", distance: 1057}
    ],
    20467: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 122},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 512},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 544},
        {type: OfferPoiType.BUS, name: "6 Dyw. Piechoty - Zieleń Miejska", distance: 680},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 1 Nr 04", distance: 685}
    ],
    20468: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 121},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 429},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 568},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 1 Nr 04", distance: 570},
        {type: OfferPoiType.BUS, name: "6 Dyw. Piechoty - Zieleń Miejska", distance: 696}
    ],
    20469: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 383},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 671},
        {type: OfferPoiType.BUS, name: "Starynowska I - piekarnia", distance: 783},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 813}
    ],
    20470: [
        {type: OfferPoiType.BUS, name: "św. Wojciecha - cmentarz", distance: 390},
        {type: OfferPoiType.BUS, name: "św. Wojciecha - kościół", distance: 678},
        {type: OfferPoiType.BUS, name: "Starynowska I - piekarnia", distance: 790},
        {type: OfferPoiType.BUS, name: "6 Dywizji Piechoty - Cmentarz 2 Nr 03", distance: 820}
    ],
    20471: [
        {type: OfferPoiType.BUS, name: "Watra", distance: 288},
        {type: OfferPoiType.BUS, name: "Krupówki Pomnik hr. Władysława Zamoyskiego", distance: 315},
        {type: OfferPoiType.BUS, name: "Parcele Urzędnicze", distance: 620},
        {type: OfferPoiType.PARK, name: "Górna Rówień Krupowa", distance: 624},
        {type: OfferPoiType.BUS, name: "Piłsudskiego Start", distance: 629},
        {type: OfferPoiType.LAS, name: "Las Chałubińskich", distance: 740},
        {type: OfferPoiType.BUS, name: "Grunwaldzka - Ornak", distance: 751},
        {type: OfferPoiType.BUS, name: "Grunwaldzka Ornak", distance: 767},
        {type: OfferPoiType.PARK, name: "Park Miejski im. Józefa Piłsudskiego", distance: 791},
        {type: OfferPoiType.PARK, name: "Dolna Rówień Krupowa", distance: 1096},
        {type: OfferPoiType.PARK, name: "Park Lecha Kaczyńskiego - Prezydenta Rzeczypospolitej Polskiej", distance: 1229},
        {type: OfferPoiType.PARK, name: "Skwer Josepha Conrada Korzeniowskiego", distance: 1284},
        {type: OfferPoiType.PARK, name: "Skwer księdza Mirosława Drozdka", distance: 1334},
        {type: OfferPoiType.PARK, name: "Skwer Ryszarda Kaczorowskiego Prezydenta Rzeczypospolitej Polskiej", distance: 1494}
    ],
    20472: [
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 01", distance: 178},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 04", distance: 209},
        {type: OfferPoiType.BUS, name: "Poczty Gdańskiej 02", distance: 268},
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 01", distance: 337},
        {type: OfferPoiType.BUS, name: "Walerego Sławka 01", distance: 351},
        {type: OfferPoiType.BUS, name: "Batalionu Włochy 02", distance: 417},
        {type: OfferPoiType.BUS, name: "Walerego Sławka 02", distance: 443},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 05", distance: 555},
        {type: OfferPoiType.BUS, name: "Szancera 02", distance: 597},
        {type: OfferPoiType.PARK, name: "Park Achera", distance: 610},
        {type: OfferPoiType.BUS, name: "Ursus-Ratusz 01", distance: 646},
        {type: OfferPoiType.PARK, name: "Plac Tysiąclecia", distance: 1090},
        {type: OfferPoiType.PARK, name: "Park Planeta Ursus", distance: 1105},
        {type: OfferPoiType.PARK, name: "Plac Wolności", distance: 1355},
        {type: OfferPoiType.PARK, name: "Skwer Księdza Kazimierza Szklarczyka", distance: 1483},
        {type: OfferPoiType.PARK, name: "Park Kombatantów", distance: 1776},
        {type: OfferPoiType.PARK, name: "Park Czechowicki", distance: 1793}
    ],
    20473: [
        {type: OfferPoiType.BUS, name: "Gołuski/Wspólna", distance: 560},
        {type: OfferPoiType.BUS, name: "Palędzie/Żelazka", distance: 648}
    ],
    20474: [{type: OfferPoiType.BUS, name: "Palędzie Leśna n/ż", distance: 509}],
    20476: [
        {type: OfferPoiType.BUS, name: "Metro Imielin 01", distance: 12},
        {type: OfferPoiType.BUS, name: "Polinezyjska 05", distance: 144},
        {type: OfferPoiType.METRO, name: "Imielin", distance: 162},
        {type: OfferPoiType.BUS, name: "Metro Imielin 04", distance: 163},
        {type: OfferPoiType.BUS, name: "Polinezyjska 04", distance: 171},
        {type: OfferPoiType.BUS, name: "Metro Imielin 03", distance: 179},
        {type: OfferPoiType.BUS, name: "Polinezyjska 03", distance: 201},
        {type: OfferPoiType.BUS, name: "Metro Imielin 02", distance: 202},
        {type: OfferPoiType.BUS, name: "Polinezyjska 02", distance: 220},
        {type: OfferPoiType.PARK, name: "Skwer Sportów Miejskich", distance: 273},
        {type: OfferPoiType.BUS, name: "Miklaszewskiego 03", distance: 348},
        {type: OfferPoiType.BUS, name: "Szolc-Rogozińskiego 02", distance: 432},
        {type: OfferPoiType.PARK, name: "Park Polskich Wynalazców", distance: 555},
        {type: OfferPoiType.PARK, name: "Park linearny nad POW", distance: 828},
        {type: OfferPoiType.PARK, name: "Skwer Kapitana Zygmunta Pawlaczyka", distance: 1208},
        {type: OfferPoiType.PARK, name: "Słoneczny Jar", distance: 1292},
        {type: OfferPoiType.PARK, name: "Lasek Brzozowy", distance: 1392},
        {type: OfferPoiType.PARK, name: "Park Jana Pawła II", distance: 1722},
        {type: OfferPoiType.PARK, name: "Plac Wielkiej Przygody", distance: 1764},
        {type: OfferPoiType.PARK, name: "Sadek Natoliński", distance: 1797},
        {type: OfferPoiType.REZERWAT, name: "Aleja drzew", distance: 1989},
        {type: OfferPoiType.REZERWAT, name: "Jeziorko Imielińskie - użytek 623", distance: 2017},
        {type: OfferPoiType.REZERWAT, name: "Rezerwat Skarpa Ursynowska", distance: 2120}
    ],
    20478: [
        {type: OfferPoiType.BUS, name: "Mierzejowa - Długa NŻ", distance: 588},
        {type: OfferPoiType.BUS, name: "Pabianicka - Długa NŻ", distance: 646},
        {type: OfferPoiType.BUS, name: "Chocianowice IKEA", distance: 687},
        {type: OfferPoiType.BUS, name: "Pabianicka - Długa", distance: 731},
        {type: OfferPoiType.TRAM, name: "Chocianowice IKEA", distance: 740},
        {type: OfferPoiType.TRAM, name: "Pabianicka - Długa", distance: 750},
        {type: OfferPoiType.PARK, name: "Park 1 Maja", distance: 2221},
        {type: OfferPoiType.PARK, name: "Park im. mecenasa Zygmunta Kortyńskiego", distance: 2424}
    ],
    20482: [
        {type: OfferPoiType.BUS, name: "Klepacka/Kościół", distance: 278},
        {type: OfferPoiType.BUS, name: "Klepacka", distance: 369},
        {type: OfferPoiType.BUS, name: "Klepacka/Pętla", distance: 389},
        {type: OfferPoiType.BUS, name: "Klepacka/Barszczańska", distance: 399},
        {type: OfferPoiType.BUS, name: "Klepacka/Wenecka", distance: 498},
        {type: OfferPoiType.BUS, name: "Klepacka/Graniczna", distance: 688},
        {type: OfferPoiType.BUS, name: "Niewodnicka/Pętla", distance: 733},
        {type: OfferPoiType.BUS, name: "Meksykańska/Rumuńska", distance: 818},
        {type: OfferPoiType.PARK, name: "Park Janiny Kurkowskiej-Spychajowej", distance: 1811}
    ]
};
